webpackJsonp([2,3],{

/***/ "zga2":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NEWLINE_RE = exports.NEWLINE_RE = /\r?\n/g;
	var LINE_BREAK = exports.LINE_BREAK = '<br />';
	
	var SPACE_RE = exports.SPACE_RE = /^\s*$/;
	var TOKEN_RE = exports.TOKEN_RE = /(\[\/?.+?\])/;
	var START_NEWLINE_RE = exports.START_NEWLINE_RE = /^\r?\n/;
	
	var ESCAPE_RE = exports.ESCAPE_RE = /[&<>"]/g;
	var ESCAPE_DICT = exports.ESCAPE_DICT = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	
	var URL_RE = exports.URL_RE = /\b((?:([\w-]+):(\/{1,3})|www[.])(?:(?:(?:[^\s&()]|&amp;|&quot;)*(?:[^!"#$%&'()*+,.:;<=>?@\[\]^`{|}~\s]))|(?:\((?:[^\s&()]|&amp;|&quot;)*\)))+)/g;
	
	var COSMETIC_DICT = exports.COSMETIC_DICT = {
	  '--': '&ndash;',
	  '---': '&mdash;',
	  '...': '&#8230;',
	  '(c)': '&copy;',
	  '(reg)': '&reg;',
	  '(tm)': '&trade;'
	};
	
	var COSMETIC_RE = exports.COSMETIC_RE = /--|---|\.\.\.|\(c\)|\(reg\)|\(tm\)/;

/***/ },

/***/ "fNuR":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _parser = __webpack_require__("rUVT");
	
	var _parser2 = _interopRequireDefault(_parser);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// export default new Parser();
	
	// export {
	//   Parser,
	//   Tag
	// };
	
	module.exports = new _parser2.default();
	module.exports.Parser = _parser2.default;
	module.exports.Tag = _tag2.default;

/***/ },

/***/ "rUVT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/parser.coffee
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__("zga2");
	
	var _tags = __webpack_require__("WZVX");
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _renderer = __webpack_require__("RMbx");
	
	var _renderer2 = _interopRequireDefault(_renderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	  function Parser() {
	    var _this = this;
	
	    var allowedTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    _classCallCheck(this, Parser);
	
	    this.tags = {};
	
	    if (!allowedTags) {
	      this.tags = _tags2.default;
	    } else {
	      allowedTags.forEach(function (name) {
	        if (_tags2.default[name]) {
	          _this.tags[name] = _tags2.default[name];
	        }
	      });
	    }
	
	    this.renderer = new _renderer2.default();
	  }
	
	  _createClass(Parser, [{
	    key: 'registerTag',
	    value: function registerTag(name, tag) {
	      this.tags[name] = tag;
	    }
	  }, {
	    key: 'parseParams',
	    value: function parseParams(token) {
	      var params = [];
	
	      function addParam(name, value) {
	        if (name) {
	          var n = name.trim();
	          // ignore on* events attribute
	          if (n.length && n.toLowerCase().indexOf('on') !== 0) {
	            params.push([n, value]);
	          }
	        }
	      }
	
	      if (token) {
	        (function () {
	          var key = [];
	          var target = key;
	          var value = [];
	          var terminate = ' ';
	          var skipNext = false;
	
	          Array.from(token).forEach(function (c) {
	            if (skipNext) {
	              skipNext = false;
	            } else if (target === key && c === '=') {
	              target = value;
	            } else if (target === key && c === ':') {
	              target = value;
	            } else if (!value.length && c === '"') {
	              terminate = c;
	            } else if (c !== terminate) {
	              target.push(c);
	            } else {
	              addParam(key.join(''), value.join(''));
	
	              if (!_constants.SPACE_RE.test(terminate)) {
	                skipNext = true;
	              }
	
	              target = key = [];
	              value = [];
	              terminate = ' ';
	            }
	          });
	
	          addParam(key.join(''), value.join(''));
	        })();
	      }
	
	      return params;
	    }
	  }, {
	    key: 'createTextNode',
	    value: function createTextNode(parent, text) {
	      var ref = parent.children.slice(-1)[0];
	      //console.log('ref', ref, text)
	      if (ref != null && ref.STRIP_OUTER) {
	        text = text.replace(_constants.START_NEWLINE_RE, '');
	      }
	
	      return new _tag2.default(this.renderer, { text: text, parent: parent });
	    }
	  }, {
	    key: 'parse',
	    value: function parse(input) {
	      var root = new _tag2.default(this.renderer);
	      var tokens = input.split(_constants.TOKEN_RE);
	      var current = root;
	      var token = null;
	      while (tokens.length) {
	        token = tokens.shift();
	        if (!token.length) {
	          continue;
	        }
	
	        if (token.match(_constants.TOKEN_RE)) {
	          var params = this.parseParams(token.slice(1, -1));
	          var tagName = params[0][0];
	
	          if (current.CLOSED_BY.indexOf(tagName) > -1) {
	            tokens.unshift(token);
	            tagName = '/' + current.name;
	            params = [];
	          }
	
	          if (tagName[0] === '/') {
	            tagName = tagName.slice(1);
	            if (!this.tags[tagName]) {
	              this.createTextNode(current, token);
	              continue;
	            }
	
	            if (current.name === tagName) {
	              current = current.parent;
	            }
	          } else {
	            var cls = this.tags[tagName];
	            if (!cls) {
	              this.createTextNode(current, token);
	              continue;
	            }
	
	            var tag = new cls(this.renderer, {
	              name: tagName,
	              parent: current,
	              params: params
	            });
	
	            if (!tag.SELF_CLOSE && (tag.CLOSED_BY.indexOf(tagName) < 0 || current.name !== tagName)) {
	              current = tag;
	            }
	          }
	        } else {
	          this.createTextNode(current, token);
	        }
	      }
	
	      return root;
	    }
	  }, {
	    key: 'toHTML',
	    value: function toHTML(input) {
	      return this.parse(input).toHTML();
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact(input) {
	      return this.parse(input).toReact();
	    }
	  }]);
	
	  return Parser;
	}();
	
	exports.default = Parser;

/***/ },

/***/ "RMbx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__("zga2");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Renderer = function () {
	  function Renderer(options) {
	    _classCallCheck(this, Renderer);
	
	    this.options = Object.assign({
	      linkify: false
	    }, options);
	    this.contexts = [];
	  }
	
	  _createClass(Renderer, [{
	    key: 'context',
	    value: function context(_context, func) {
	      var newOptions = Object.assign({}, this.options, _context);
	      this.contexts.push(this.options);
	      this.options = newOptions;
	      var v = func();
	      this.options = this.contexts.pop();
	      return v;
	    }
	  }, {
	    key: 'escape',
	    value: function escape(value) {
	      // Escapes a string so it is valid within XML or XHTML
	      return value.replace(_constants.ESCAPE_RE, function (match) {
	        return _constants.ESCAPE_DICT[match];
	      });
	    }
	  }, {
	    key: 'linkify',
	    value: function linkify(value) {
	      return value.replace(_constants.URL_RE, function () {
	        var url = arguments.length <= 1 ? undefined : arguments[1];
	        var proto = arguments.length <= 2 ? undefined : arguments[2];
	
	        if (proto && ['http', 'https'].indexOf(proto) === -1) {
	          return url; // bad protocol, no linkify
	        }
	
	        var href = proto ? url : 'http://' + url;
	
	        return '<a href="' + href + '" target="_blank">' + url + '</a>';
	      });
	    }
	  }, {
	    key: 'strip',
	    value: function strip(text) {
	      return text.replace(/^\s+|\s+$/g, '');
	    }
	  }, {
	    key: 'cosmeticReplace',
	    value: function cosmeticReplace(value) {
	      return value.replace(_constants.COSMETIC_RE, function () {
	        var item = arguments.length <= 0 ? undefined : arguments[0];
	        return _constants.COSMETIC_DICT[item] || item;
	      });
	    }
	  }, {
	    key: 'htmlAttributes',
	    value: function htmlAttributes(attributes) {
	      if (!attributes) {
	        return '';
	      }
	
	      return Object.keys(attributes).map(function (k) {
	        return k + '="' + attributes[k] + '"';
	      }).join(' ');
	    }
	  }]);
	
	  return Renderer;
	}();
	
	exports.default = Renderer;

/***/ },

/***/ "AdJZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__("zga2");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tag = function () {
	  function Tag(renderer) {
	    var _this = this;
	
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Tag);
	
	    this.renderer = renderer;
	    this.CLOSED_BY = [];
	    this.SELF_CLOSE = false;
	    this.STRIP_INNER = false;
	    this.STRIP_OUTER = false;
	    this.DISCARD_TEXT = false;
	
	    this.name = settings.name || null;
	    this.parent = settings.parent || null;
	    this.text = settings.text || '';
	    this.params = {};
	    this.children = [];
	
	    if (this.parent) {
	      this.parent.children.push(this);
	    }
	
	    settings.params = settings.params || [];
	
	    settings.params.forEach(function (item) {
	      if (item.length > 1 && item[1]) {
	        _this.params[item[0]] = item[1];
	      }
	    });
	  }
	
	  _createClass(Tag, [{
	    key: 'getComponents',
	    value: function getComponents() {
	      var _this2 = this;
	
	      var components = [];
	      if (this.text && this.text.length) {
	        // todo linkify and emotion
	        components.push(this.text);
	      }
	
	      this.children.forEach(function (child) {
	        if (!(_this2.DISCARD_TEXT && child.name === null)) {
	          var childComponents = child.toReact();
	          components.push(childComponents);
	        }
	      });
	
	      return _react2.default.Children.toArray(components);
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _this3 = this;
	
	      var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var pieces = [];
	      var text = void 0;
	      var content = void 0;
	
	      if (this.text && this.text.length) {
	        text = this.renderer.escape(this.text);
	
	        if (!raw) {
	          if (this.renderer.options.linkify) {
	            text = this.renderer.linkify(text);
	          }
	          text = this.renderer.cosmeticReplace(text.replace(_constants.NEWLINE_RE, _constants.LINE_BREAK));
	        }
	
	        pieces.push(text);
	      }
	
	      this.children.forEach(function (child) {
	        if (raw) {
	          pieces.push(child.toText());
	        } else {
	          if (!(_this3.DISCARD_TEXT && child.name === null)) {
	            var childPieces = child.toHTML();
	            if (typeof childPieces === 'string') {
	              pieces.push(childPieces);
	            } else {
	              pieces.push.apply(pieces, _toConsumableArray(childPieces));
	            }
	          }
	        }
	      });
	
	      content = pieces.join('');
	
	      if (!raw && this.STRIP_INNER) {
	        content = this.renderer.strip(content);
	
	        while (content.slice(0, _constants.LINE_BREAK.length) === _constants.LINE_BREAK) {
	          content = content.slice(_constants.LINE_BREAK.length);
	        }
	        while (content.slice(-_constants.LINE_BREAK.length) === _constants.LINE_BREAK) {
	          content = content.slice(0, -_constants.LINE_BREAK.length);
	        }
	        content = this.renderer.strip(content);
	      }
	      return content;
	    }
	  }, {
	    key: 'toText',
	    value: function toText() {
	      var _this4 = this;
	
	      var contentAsHTML = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var pieces = [];
	
	      if (this.name !== null) {
	        if (this.params.length) {
	          var params = Object.keys(this.params).map(function (k) {
	            return k + '=' + _this4.params[k];
	          }).join(' ');
	
	          if (this.params[this.name]) {
	            pieces.push('[' + params + ']');
	          } else {
	            pieces.push('[' + this.name + ' ' + params + ']');
	          }
	        } else {
	          pieces.push('[' + this.name + ']');
	        }
	      }
	
	      pieces.push(this.getContent(!contentAsHTML));
	
	      if (this.name !== null && this.CLOSED_BY.indexOf(this.name) === -1) {
	        pieces.push('[/' + this.name + ']');
	      }
	
	      return pieces.join('');
	    }
	  }, {
	    key: 'toHTML',
	    value: function toHTML() {
	      var pieces = this.toText(true);
	
	      return typeof pieces === 'string' ? pieces : pieces.join('');
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      return _react2.default.Children.toArray(this.getComponents());
	    }
	  }]);
	
	  return Tag;
	}();
	
	exports.default = Tag;

/***/ },

/***/ "sGSF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var CenterTag = function (_Tag) {
	  _inherits(CenterTag, _Tag);
	
	  function CenterTag() {
	    _classCallCheck(this, CenterTag);
	
	    return _possibleConstructorReturn(this, (CenterTag.__proto__ || Object.getPrototypeOf(CenterTag)).apply(this, arguments));
	  }
	
	  _createClass(CenterTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      return ['<div style="text-align:center;">', this.getContent(), '</div>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return CenterTag;
	}(_tag2.default);
	
	exports.default = CenterTag;

/***/ },

/***/ "ANuS":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var CodeTag = function (_Tag) {
	  _inherits(CodeTag, _Tag);
	
	  function CodeTag(renderer) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, CodeTag);
	
	    var _this = _possibleConstructorReturn(this, (CodeTag.__proto__ || Object.getPrototypeOf(CodeTag)).call(this, renderer, settings));
	
	    _this.STRIP_INNER = true;
	    _this.inline = _this.params.code === 'inline';
	
	    if (!_this.inline) {
	      _this.STRIP_OUTER = true;
	    }
	    return _this;
	  }
	
	  _createClass(CodeTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      if (this.inline) {
	        return ['<code>', this.getContent(true), '</code>'];
	      }
	      var lang = this.params.lang || this.params[this.name];
	      if (lang) {
	        return ['<pre class="prettyprint lang-' + lang + '">', this.getContent(true), '</pre>'];
	      }
	      return ['<pre>', this.getContent(true), '</pre>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      if (this.inline) {
	        return _react2.default.createElement(
	          'code',
	          null,
	          this.getContent(true)
	        );
	      }
	      var lang = this.params.lang || this.params[this.name];
	
	      var className = 'prettyprint';
	      if (lang) {
	        className += ' lang-' + lang;
	      }
	      return _react2.default.createElement(
	        'pre',
	        { className: className },
	        this.getContent(true)
	      );
	    }
	  }]);
	
	  return CodeTag;
	}(_tag2.default);
	
	exports.default = CodeTag;

/***/ },

/***/ "sO9q":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var ColorTag = function (_Tag) {
	  _inherits(ColorTag, _Tag);
	
	  function ColorTag() {
	    _classCallCheck(this, ColorTag);
	
	    return _possibleConstructorReturn(this, (ColorTag.__proto__ || Object.getPrototypeOf(ColorTag)).apply(this, arguments));
	  }
	
	  _createClass(ColorTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var color = this.params.color;
	
	      if (!color) {
	        return this.getContent();
	      }
	
	      return ['<span style="color:' + color + '">', this.getContent(), '</span>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var color = this.params.color;
	
	      if (!color) {
	        return this.getComponents();
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { style: { color: color } },
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return ColorTag;
	}(_tag2.default);
	
	exports.default = ColorTag;

/***/ },

/***/ "Jtts":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var HorizontalRuleTag = function (_Tag) {
	  _inherits(HorizontalRuleTag, _Tag);
	
	  function HorizontalRuleTag(renderer) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, HorizontalRuleTag);
	
	    var _this = _possibleConstructorReturn(this, (HorizontalRuleTag.__proto__ || Object.getPrototypeOf(HorizontalRuleTag)).call(this, renderer, settings));
	
	    _this.SELF_CLOSE = true;
	    _this.STRIP_OUTER = true;
	    return _this;
	  }
	
	  _createClass(HorizontalRuleTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      return '<hr />';
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      return _react2.default.createElement('hr', null);
	    }
	  }]);
	
	  return HorizontalRuleTag;
	}(_tag2.default);
	
	exports.default = HorizontalRuleTag;

/***/ },

/***/ "Vi+e":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var ImageTag = function (_Tag) {
	  _inherits(ImageTag, _Tag);
	
	  function ImageTag() {
	    _classCallCheck(this, ImageTag);
	
	    return _possibleConstructorReturn(this, (ImageTag.__proto__ || Object.getPrototypeOf(ImageTag)).apply(this, arguments));
	  }
	
	  _createClass(ImageTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var attributes = {
	        src: this.renderer.strip(this.getContent(true))
	      };
	
	      if (this.params.width) {
	        attributes.width = this.params.width;
	      }
	
	      if (this.params.height) {
	        attributes.height = this.params.height;
	      }
	
	      return '<img ' + this.renderer.htmlAttributes(attributes) + ' />';
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var src = this.getContent(true);
	      return _react2.default.createElement('img', {
	        role: 'presentation',
	        src: src,
	        width: this.params.width,
	        height: this.params.height
	      });
	    }
	  }]);
	
	  return ImageTag;
	}(_tag2.default);
	
	exports.default = ImageTag;

/***/ },

/***/ "WZVX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _code = __webpack_require__("ANuS");
	
	var _code2 = _interopRequireDefault(_code);
	
	var _image = __webpack_require__("Vi+e");
	
	var _image2 = _interopRequireDefault(_image);
	
	var _hr = __webpack_require__("Jtts");
	
	var _hr2 = _interopRequireDefault(_hr);
	
	var _size = __webpack_require__("gaAe");
	
	var _size2 = _interopRequireDefault(_size);
	
	var _center = __webpack_require__("sGSF");
	
	var _center2 = _interopRequireDefault(_center);
	
	var _right = __webpack_require__("3BE0");
	
	var _right2 = _interopRequireDefault(_right);
	
	var _color = __webpack_require__("sO9q");
	
	var _color2 = _interopRequireDefault(_color);
	
	var _list = __webpack_require__("Ejzd");
	
	var _list2 = _interopRequireDefault(_list);
	
	var _item = __webpack_require__("LhZG");
	
	var _item2 = _interopRequireDefault(_item);
	
	var _quote = __webpack_require__("6KYk");
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _link = __webpack_require__("Bf9B");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _simple = __webpack_require__("QYy6");
	
	var _simple2 = _interopRequireDefault(_simple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  b: (0, _simple2.default)('strong'),
	  i: (0, _simple2.default)('em'),
	  u: (0, _simple2.default)('u'),
	  s: (0, _simple2.default)('strike'),
	  h1: (0, _simple2.default)('h1', { STRIP_OUTER: true }),
	  h2: (0, _simple2.default)('h2', { STRIP_OUTER: true }),
	  h3: (0, _simple2.default)('h3', { STRIP_OUTER: true }),
	  h4: (0, _simple2.default)('h4', { STRIP_OUTER: true }),
	  h5: (0, _simple2.default)('h5', { STRIP_OUTER: true }),
	  h6: (0, _simple2.default)('h6', { STRIP_OUTER: true }),
	  pre: (0, _simple2.default)('pre'),
	  table: (0, _simple2.default)('table', { DISCARD_TEXT: true }),
	  thead: (0, _simple2.default)('thead', { DISCARD_TEXT: true }),
	  tbody: (0, _simple2.default)('tbody', { DISCARD_TEXT: true }),
	  tr: (0, _simple2.default)('tr', { DISCARD_TEXT: true }),
	  th: (0, _simple2.default)('th'),
	  td: (0, _simple2.default)('td'),
	  code: _code2.default,
	  img: _image2.default,
	  hr: _hr2.default,
	  size: _size2.default,
	  center: _center2.default,
	  right: _right2.default,
	  color: _color2.default,
	  list: _list2.default,
	  '*': _item2.default,
	  quote: _quote2.default,
	  url: _link2.default,
	  link: _link2.default,
	  email: _link2.default
	};

/***/ },

/***/ "LhZG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var ListItemTag = function (_Tag) {
	  _inherits(ListItemTag, _Tag);
	
	  function ListItemTag(renderer) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, ListItemTag);
	
	    var _this = _possibleConstructorReturn(this, (ListItemTag.__proto__ || Object.getPrototypeOf(ListItemTag)).call(this, renderer, settings));
	
	    _this.CLOSED_BY = ['*', '/list'];
	    _this.STRIP_INNER = true;
	    return _this;
	  }
	
	  _createClass(ListItemTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      return ['<li>', this.getContent(), '</li>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return ListItemTag;
	}(_tag2.default);
	
	exports.default = ListItemTag;

/***/ },

/***/ "Bf9B":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var LinkTag = function (_Tag) {
	  _inherits(LinkTag, _Tag);
	
	  function LinkTag() {
	    _classCallCheck(this, LinkTag);
	
	    return _possibleConstructorReturn(this, (LinkTag.__proto__ || Object.getPrototypeOf(LinkTag)).apply(this, arguments));
	  }
	
	  _createClass(LinkTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var _this2 = this;
	
	      var url = this.renderer.strip(this.params[this.name] || this.getContent(true));
	      if (/javascript:/i.test(url)) {
	        url = '';
	      }
	
	      if (!url || !url.length) {
	        return this.getContent();
	      }
	
	      return this.renderer.context({ linkify: false }, function () {
	        return ['<a href="' + url + '" target="_blank">', _this2.getContent(), '</a>'];
	      });
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var url = this.renderer.strip(this.params[this.name] || this.getContent(true));
	      if (/javascript:/i.test(url)) {
	        url = '';
	      }
	
	      if (!url || !url.length) {
	        return this.getComponents();
	      }
	
	      if (this.name === 'email') {
	        url = 'mailto:' + url;
	      }
	
	      return _react2.default.createElement(
	        'a',
	        { href: url, target: '_blank', rel: 'noopener noreferrer' },
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return LinkTag;
	}(_tag2.default);
	
	exports.default = LinkTag;

/***/ },

/***/ "Ejzd":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var ListTag = function (_Tag) {
	  _inherits(ListTag, _Tag);
	
	  function ListTag(renderer) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, ListTag);
	
	    var _this = _possibleConstructorReturn(this, (ListTag.__proto__ || Object.getPrototypeOf(ListTag)).call(this, renderer, settings));
	
	    _this.STRIP_INNER = true;
	    _this.STRIP_OUTER = true;
	    return _this;
	  }
	
	  _createClass(ListTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var listType = this.params.list;
	
	      if (listType === '1') {
	        return ['<ol>', this.getContent(), '</ol>'];
	      }
	
	      if (listType === 'a') {
	        return ['<ol style="list-style-type:lower-alpha;">', this.getContent(), '</ol>'];
	      }
	
	      if (listType === 'A') {
	        return ['<ol style="list-style-type:upper-alpha;">', this.getContent(), '</ol>'];
	      }
	
	      return ['<ul>', this.getContent(), '</ul>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var listType = this.params.list;
	
	      var listTypes = {
	        a: 'lower-alpha',
	        A: 'upper-alpha',
	        i: 'lower-roman',
	        I: 'upper-roman',
	        '1': 'decimal'
	      };
	
	      if (listTypes[listType]) {
	        return _react2.default.createElement(
	          'ol',
	          {
	            style: {
	              listStyleType: listTypes[listType]
	            }
	          },
	          this.getComponents()
	        );
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        null,
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return ListTag;
	}(_tag2.default);
	
	exports.default = ListTag;

/***/ },

/***/ "6KYk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var QuoteTag = function (_Tag) {
	  _inherits(QuoteTag, _Tag);
	
	  function QuoteTag(renderer) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, QuoteTag);
	
	    var _this = _possibleConstructorReturn(this, (QuoteTag.__proto__ || Object.getPrototypeOf(QuoteTag)).call(this, renderer, settings));
	
	    _this.STRIP_INNER = true;
	    _this.STRIP_OUTER = true;
	    return _this;
	  }
	
	  _createClass(QuoteTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var pieces = ['<blockquote>', this.getContent()];
	      var citation = this.params.quote;
	
	      if (citation) {
	        pieces.push('<small>');
	        pieces.push(citation);
	        pieces.push('</small>');
	      }
	
	      pieces.push('</blockquote>');
	
	      return pieces;
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var citation = this.params.quote;
	      return _react2.default.createElement(
	        'blockquote',
	        null,
	        citation && _react2.default.createElement(
	          'small',
	          null,
	          citation,
	          ' wrote:'
	        ),
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return QuoteTag;
	}(_tag2.default);
	
	exports.default = QuoteTag;

/***/ },

/***/ "3BE0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var RightTag = function (_Tag) {
	  _inherits(RightTag, _Tag);
	
	  function RightTag() {
	    _classCallCheck(this, RightTag);
	
	    return _possibleConstructorReturn(this, (RightTag.__proto__ || Object.getPrototypeOf(RightTag)).apply(this, arguments));
	  }
	
	  _createClass(RightTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      return ['<div style="text-align:right;">', this.getContent(), '</div>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return RightTag;
	}(_tag2.default);
	
	exports.default = RightTag;

/***/ },

/***/ "QYy6":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (name, attributes) {
	  var SimpleTag = function (_Tag) {
	    _inherits(SimpleTag, _Tag);
	
	    function SimpleTag(renderer) {
	      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, SimpleTag);
	
	      var _this = _possibleConstructorReturn(this, (SimpleTag.__proto__ || Object.getPrototypeOf(SimpleTag)).call(this, renderer, settings));
	
	      Object.keys(attributes || {}).forEach(function (key) {
	        _this[key] = attributes[key];
	      });
	      return _this;
	    }
	
	    _createClass(SimpleTag, [{
	      key: 'toHTML',
	      value: function toHTML() {
	        var htmlAttributes = this.renderer.htmlAttributes(this.params);
	
	        if (htmlAttributes) {
	          htmlAttributes = ' ' + htmlAttributes;
	        }
	
	        return ['<' + name + htmlAttributes + '>', this.getContent(), '</' + name + '>'];
	      }
	    }, {
	      key: 'toReact',
	      value: function toReact() {
	        var Name = name;
	        return _react2.default.createElement(
	          Name,
	          this.params,
	          this.getComponents()
	        );
	      }
	    }]);
	
	    return SimpleTag;
	  }(_tag2.default);
	
	  return SimpleTag;
	};

/***/ },

/***/ "gaAe":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__("AdJZ");
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // https://github.com/vishnevskiy/bbcodejs/blob/master/src/coffee/tags.coffee
	
	
	var SizeTag = function (_Tag) {
	  _inherits(SizeTag, _Tag);
	
	  function SizeTag() {
	    _classCallCheck(this, SizeTag);
	
	    return _possibleConstructorReturn(this, (SizeTag.__proto__ || Object.getPrototypeOf(SizeTag)).apply(this, arguments));
	  }
	
	  _createClass(SizeTag, [{
	    key: 'toHTML',
	    value: function toHTML() {
	      var size = this.params.size;
	
	      if (isNaN(size)) {
	        return this.getContent();
	      }
	      return ['<span style="font-size:' + size + 'px">', this.getContent(), '</span>'];
	    }
	  }, {
	    key: 'toReact',
	    value: function toReact() {
	      var size = this.params.size;
	
	      if (isNaN(size)) {
	        return this.getComponents();
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { style: { fontSize: size + 'px' } },
	        this.getComponents()
	      );
	    }
	  }]);
	
	  return SizeTag;
	}(_tag2.default);
	
	exports.default = SizeTag;

/***/ },

/***/ "qb6w":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "8g5Q":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("P+fo")(__webpack_require__("pIPB"))

/***/ },

/***/ "pIPB":
/***/ function(module, exports) {

	module.exports = "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under the MIT license\n */\n\nif (typeof jQuery === 'undefined') {\n  throw new Error('Bootstrap\\'s JavaScript requires jQuery')\n}\n\n+function ($) {\n  'use strict';\n  var version = $.fn.jquery.split(' ')[0].split('.')\n  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {\n    throw new Error('Bootstrap\\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')\n  }\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: transition.js v3.3.7\n * http://getbootstrap.com/javascript/#transitions\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)\n  // ============================================================\n\n  function transitionEnd() {\n    var el = document.createElement('bootstrap')\n\n    var transEndEventNames = {\n      WebkitTransition : 'webkitTransitionEnd',\n      MozTransition    : 'transitionend',\n      OTransition      : 'oTransitionEnd otransitionend',\n      transition       : 'transitionend'\n    }\n\n    for (var name in transEndEventNames) {\n      if (el.style[name] !== undefined) {\n        return { end: transEndEventNames[name] }\n      }\n    }\n\n    return false // explicit for ie8 (  ._.)\n  }\n\n  // http://blog.alexmaccaw.com/css-transitions\n  $.fn.emulateTransitionEnd = function (duration) {\n    var called = false\n    var $el = this\n    $(this).one('bsTransitionEnd', function () { called = true })\n    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }\n    setTimeout(callback, duration)\n    return this\n  }\n\n  $(function () {\n    $.support.transition = transitionEnd()\n\n    if (!$.support.transition) return\n\n    $.event.special.bsTransitionEnd = {\n      bindType: $.support.transition.end,\n      delegateType: $.support.transition.end,\n      handle: function (e) {\n        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)\n      }\n    }\n  })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: alert.js v3.3.7\n * http://getbootstrap.com/javascript/#alerts\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // ALERT CLASS DEFINITION\n  // ======================\n\n  var dismiss = '[data-dismiss=\"alert\"]'\n  var Alert   = function (el) {\n    $(el).on('click', dismiss, this.close)\n  }\n\n  Alert.VERSION = '3.3.7'\n\n  Alert.TRANSITION_DURATION = 150\n\n  Alert.prototype.close = function (e) {\n    var $this    = $(this)\n    var selector = $this.attr('data-target')\n\n    if (!selector) {\n      selector = $this.attr('href')\n      selector = selector && selector.replace(/.*(?=#[^\\s]*$)/, '') // strip for ie7\n    }\n\n    var $parent = $(selector === '#' ? [] : selector)\n\n    if (e) e.preventDefault()\n\n    if (!$parent.length) {\n      $parent = $this.closest('.alert')\n    }\n\n    $parent.trigger(e = $.Event('close.bs.alert'))\n\n    if (e.isDefaultPrevented()) return\n\n    $parent.removeClass('in')\n\n    function removeElement() {\n      // detach from parent, fire event then clean up data\n      $parent.detach().trigger('closed.bs.alert').remove()\n    }\n\n    $.support.transition && $parent.hasClass('fade') ?\n      $parent\n        .one('bsTransitionEnd', removeElement)\n        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :\n      removeElement()\n  }\n\n\n  // ALERT PLUGIN DEFINITION\n  // =======================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this = $(this)\n      var data  = $this.data('bs.alert')\n\n      if (!data) $this.data('bs.alert', (data = new Alert(this)))\n      if (typeof option == 'string') data[option].call($this)\n    })\n  }\n\n  var old = $.fn.alert\n\n  $.fn.alert             = Plugin\n  $.fn.alert.Constructor = Alert\n\n\n  // ALERT NO CONFLICT\n  // =================\n\n  $.fn.alert.noConflict = function () {\n    $.fn.alert = old\n    return this\n  }\n\n\n  // ALERT DATA-API\n  // ==============\n\n  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: button.js v3.3.7\n * http://getbootstrap.com/javascript/#buttons\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // BUTTON PUBLIC CLASS DEFINITION\n  // ==============================\n\n  var Button = function (element, options) {\n    this.$element  = $(element)\n    this.options   = $.extend({}, Button.DEFAULTS, options)\n    this.isLoading = false\n  }\n\n  Button.VERSION  = '3.3.7'\n\n  Button.DEFAULTS = {\n    loadingText: 'loading...'\n  }\n\n  Button.prototype.setState = function (state) {\n    var d    = 'disabled'\n    var $el  = this.$element\n    var val  = $el.is('input') ? 'val' : 'html'\n    var data = $el.data()\n\n    state += 'Text'\n\n    if (data.resetText == null) $el.data('resetText', $el[val]())\n\n    // push to event loop to allow forms to submit\n    setTimeout($.proxy(function () {\n      $el[val](data[state] == null ? this.options[state] : data[state])\n\n      if (state == 'loadingText') {\n        this.isLoading = true\n        $el.addClass(d).attr(d, d).prop(d, true)\n      } else if (this.isLoading) {\n        this.isLoading = false\n        $el.removeClass(d).removeAttr(d).prop(d, false)\n      }\n    }, this), 0)\n  }\n\n  Button.prototype.toggle = function () {\n    var changed = true\n    var $parent = this.$element.closest('[data-toggle=\"buttons\"]')\n\n    if ($parent.length) {\n      var $input = this.$element.find('input')\n      if ($input.prop('type') == 'radio') {\n        if ($input.prop('checked')) changed = false\n        $parent.find('.active').removeClass('active')\n        this.$element.addClass('active')\n      } else if ($input.prop('type') == 'checkbox') {\n        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false\n        this.$element.toggleClass('active')\n      }\n      $input.prop('checked', this.$element.hasClass('active'))\n      if (changed) $input.trigger('change')\n    } else {\n      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))\n      this.$element.toggleClass('active')\n    }\n  }\n\n\n  // BUTTON PLUGIN DEFINITION\n  // ========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.button')\n      var options = typeof option == 'object' && option\n\n      if (!data) $this.data('bs.button', (data = new Button(this, options)))\n\n      if (option == 'toggle') data.toggle()\n      else if (option) data.setState(option)\n    })\n  }\n\n  var old = $.fn.button\n\n  $.fn.button             = Plugin\n  $.fn.button.Constructor = Button\n\n\n  // BUTTON NO CONFLICT\n  // ==================\n\n  $.fn.button.noConflict = function () {\n    $.fn.button = old\n    return this\n  }\n\n\n  // BUTTON DATA-API\n  // ===============\n\n  $(document)\n    .on('click.bs.button.data-api', '[data-toggle^=\"button\"]', function (e) {\n      var $btn = $(e.target).closest('.btn')\n      Plugin.call($btn, 'toggle')\n      if (!($(e.target).is('input[type=\"radio\"], input[type=\"checkbox\"]'))) {\n        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes\n        e.preventDefault()\n        // The target component still receive the focus\n        if ($btn.is('input,button')) $btn.trigger('focus')\n        else $btn.find('input:visible,button:visible').first().trigger('focus')\n      }\n    })\n    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^=\"button\"]', function (e) {\n      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))\n    })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: carousel.js v3.3.7\n * http://getbootstrap.com/javascript/#carousel\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // CAROUSEL CLASS DEFINITION\n  // =========================\n\n  var Carousel = function (element, options) {\n    this.$element    = $(element)\n    this.$indicators = this.$element.find('.carousel-indicators')\n    this.options     = options\n    this.paused      = null\n    this.sliding     = null\n    this.interval    = null\n    this.$active     = null\n    this.$items      = null\n\n    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))\n\n    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element\n      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))\n      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))\n  }\n\n  Carousel.VERSION  = '3.3.7'\n\n  Carousel.TRANSITION_DURATION = 600\n\n  Carousel.DEFAULTS = {\n    interval: 5000,\n    pause: 'hover',\n    wrap: true,\n    keyboard: true\n  }\n\n  Carousel.prototype.keydown = function (e) {\n    if (/input|textarea/i.test(e.target.tagName)) return\n    switch (e.which) {\n      case 37: this.prev(); break\n      case 39: this.next(); break\n      default: return\n    }\n\n    e.preventDefault()\n  }\n\n  Carousel.prototype.cycle = function (e) {\n    e || (this.paused = false)\n\n    this.interval && clearInterval(this.interval)\n\n    this.options.interval\n      && !this.paused\n      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))\n\n    return this\n  }\n\n  Carousel.prototype.getItemIndex = function (item) {\n    this.$items = item.parent().children('.item')\n    return this.$items.index(item || this.$active)\n  }\n\n  Carousel.prototype.getItemForDirection = function (direction, active) {\n    var activeIndex = this.getItemIndex(active)\n    var willWrap = (direction == 'prev' && activeIndex === 0)\n                || (direction == 'next' && activeIndex == (this.$items.length - 1))\n    if (willWrap && !this.options.wrap) return active\n    var delta = direction == 'prev' ? -1 : 1\n    var itemIndex = (activeIndex + delta) % this.$items.length\n    return this.$items.eq(itemIndex)\n  }\n\n  Carousel.prototype.to = function (pos) {\n    var that        = this\n    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))\n\n    if (pos > (this.$items.length - 1) || pos < 0) return\n\n    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, \"slid\"\n    if (activeIndex == pos) return this.pause().cycle()\n\n    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))\n  }\n\n  Carousel.prototype.pause = function (e) {\n    e || (this.paused = true)\n\n    if (this.$element.find('.next, .prev').length && $.support.transition) {\n      this.$element.trigger($.support.transition.end)\n      this.cycle(true)\n    }\n\n    this.interval = clearInterval(this.interval)\n\n    return this\n  }\n\n  Carousel.prototype.next = function () {\n    if (this.sliding) return\n    return this.slide('next')\n  }\n\n  Carousel.prototype.prev = function () {\n    if (this.sliding) return\n    return this.slide('prev')\n  }\n\n  Carousel.prototype.slide = function (type, next) {\n    var $active   = this.$element.find('.item.active')\n    var $next     = next || this.getItemForDirection(type, $active)\n    var isCycling = this.interval\n    var direction = type == 'next' ? 'left' : 'right'\n    var that      = this\n\n    if ($next.hasClass('active')) return (this.sliding = false)\n\n    var relatedTarget = $next[0]\n    var slideEvent = $.Event('slide.bs.carousel', {\n      relatedTarget: relatedTarget,\n      direction: direction\n    })\n    this.$element.trigger(slideEvent)\n    if (slideEvent.isDefaultPrevented()) return\n\n    this.sliding = true\n\n    isCycling && this.pause()\n\n    if (this.$indicators.length) {\n      this.$indicators.find('.active').removeClass('active')\n      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])\n      $nextIndicator && $nextIndicator.addClass('active')\n    }\n\n    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, \"slid\"\n    if ($.support.transition && this.$element.hasClass('slide')) {\n      $next.addClass(type)\n      $next[0].offsetWidth // force reflow\n      $active.addClass(direction)\n      $next.addClass(direction)\n      $active\n        .one('bsTransitionEnd', function () {\n          $next.removeClass([type, direction].join(' ')).addClass('active')\n          $active.removeClass(['active', direction].join(' '))\n          that.sliding = false\n          setTimeout(function () {\n            that.$element.trigger(slidEvent)\n          }, 0)\n        })\n        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)\n    } else {\n      $active.removeClass('active')\n      $next.addClass('active')\n      this.sliding = false\n      this.$element.trigger(slidEvent)\n    }\n\n    isCycling && this.cycle()\n\n    return this\n  }\n\n\n  // CAROUSEL PLUGIN DEFINITION\n  // ==========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.carousel')\n      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)\n      var action  = typeof option == 'string' ? option : options.slide\n\n      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))\n      if (typeof option == 'number') data.to(option)\n      else if (action) data[action]()\n      else if (options.interval) data.pause().cycle()\n    })\n  }\n\n  var old = $.fn.carousel\n\n  $.fn.carousel             = Plugin\n  $.fn.carousel.Constructor = Carousel\n\n\n  // CAROUSEL NO CONFLICT\n  // ====================\n\n  $.fn.carousel.noConflict = function () {\n    $.fn.carousel = old\n    return this\n  }\n\n\n  // CAROUSEL DATA-API\n  // =================\n\n  var clickHandler = function (e) {\n    var href\n    var $this   = $(this)\n    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\\s]+$)/, '')) // strip for ie7\n    if (!$target.hasClass('carousel')) return\n    var options = $.extend({}, $target.data(), $this.data())\n    var slideIndex = $this.attr('data-slide-to')\n    if (slideIndex) options.interval = false\n\n    Plugin.call($target, options)\n\n    if (slideIndex) {\n      $target.data('bs.carousel').to(slideIndex)\n    }\n\n    e.preventDefault()\n  }\n\n  $(document)\n    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)\n    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)\n\n  $(window).on('load', function () {\n    $('[data-ride=\"carousel\"]').each(function () {\n      var $carousel = $(this)\n      Plugin.call($carousel, $carousel.data())\n    })\n  })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: collapse.js v3.3.7\n * http://getbootstrap.com/javascript/#collapse\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n/* jshint latedef: false */\n\n+function ($) {\n  'use strict';\n\n  // COLLAPSE PUBLIC CLASS DEFINITION\n  // ================================\n\n  var Collapse = function (element, options) {\n    this.$element      = $(element)\n    this.options       = $.extend({}, Collapse.DEFAULTS, options)\n    this.$trigger      = $('[data-toggle=\"collapse\"][href=\"#' + element.id + '\"],' +\n                           '[data-toggle=\"collapse\"][data-target=\"#' + element.id + '\"]')\n    this.transitioning = null\n\n    if (this.options.parent) {\n      this.$parent = this.getParent()\n    } else {\n      this.addAriaAndCollapsedClass(this.$element, this.$trigger)\n    }\n\n    if (this.options.toggle) this.toggle()\n  }\n\n  Collapse.VERSION  = '3.3.7'\n\n  Collapse.TRANSITION_DURATION = 350\n\n  Collapse.DEFAULTS = {\n    toggle: true\n  }\n\n  Collapse.prototype.dimension = function () {\n    var hasWidth = this.$element.hasClass('width')\n    return hasWidth ? 'width' : 'height'\n  }\n\n  Collapse.prototype.show = function () {\n    if (this.transitioning || this.$element.hasClass('in')) return\n\n    var activesData\n    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')\n\n    if (actives && actives.length) {\n      activesData = actives.data('bs.collapse')\n      if (activesData && activesData.transitioning) return\n    }\n\n    var startEvent = $.Event('show.bs.collapse')\n    this.$element.trigger(startEvent)\n    if (startEvent.isDefaultPrevented()) return\n\n    if (actives && actives.length) {\n      Plugin.call(actives, 'hide')\n      activesData || actives.data('bs.collapse', null)\n    }\n\n    var dimension = this.dimension()\n\n    this.$element\n      .removeClass('collapse')\n      .addClass('collapsing')[dimension](0)\n      .attr('aria-expanded', true)\n\n    this.$trigger\n      .removeClass('collapsed')\n      .attr('aria-expanded', true)\n\n    this.transitioning = 1\n\n    var complete = function () {\n      this.$element\n        .removeClass('collapsing')\n        .addClass('collapse in')[dimension]('')\n      this.transitioning = 0\n      this.$element\n        .trigger('shown.bs.collapse')\n    }\n\n    if (!$.support.transition) return complete.call(this)\n\n    var scrollSize = $.camelCase(['scroll', dimension].join('-'))\n\n    this.$element\n      .one('bsTransitionEnd', $.proxy(complete, this))\n      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])\n  }\n\n  Collapse.prototype.hide = function () {\n    if (this.transitioning || !this.$element.hasClass('in')) return\n\n    var startEvent = $.Event('hide.bs.collapse')\n    this.$element.trigger(startEvent)\n    if (startEvent.isDefaultPrevented()) return\n\n    var dimension = this.dimension()\n\n    this.$element[dimension](this.$element[dimension]())[0].offsetHeight\n\n    this.$element\n      .addClass('collapsing')\n      .removeClass('collapse in')\n      .attr('aria-expanded', false)\n\n    this.$trigger\n      .addClass('collapsed')\n      .attr('aria-expanded', false)\n\n    this.transitioning = 1\n\n    var complete = function () {\n      this.transitioning = 0\n      this.$element\n        .removeClass('collapsing')\n        .addClass('collapse')\n        .trigger('hidden.bs.collapse')\n    }\n\n    if (!$.support.transition) return complete.call(this)\n\n    this.$element\n      [dimension](0)\n      .one('bsTransitionEnd', $.proxy(complete, this))\n      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)\n  }\n\n  Collapse.prototype.toggle = function () {\n    this[this.$element.hasClass('in') ? 'hide' : 'show']()\n  }\n\n  Collapse.prototype.getParent = function () {\n    return $(this.options.parent)\n      .find('[data-toggle=\"collapse\"][data-parent=\"' + this.options.parent + '\"]')\n      .each($.proxy(function (i, element) {\n        var $element = $(element)\n        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)\n      }, this))\n      .end()\n  }\n\n  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {\n    var isOpen = $element.hasClass('in')\n\n    $element.attr('aria-expanded', isOpen)\n    $trigger\n      .toggleClass('collapsed', !isOpen)\n      .attr('aria-expanded', isOpen)\n  }\n\n  function getTargetFromTrigger($trigger) {\n    var href\n    var target = $trigger.attr('data-target')\n      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\\s]+$)/, '') // strip for ie7\n\n    return $(target)\n  }\n\n\n  // COLLAPSE PLUGIN DEFINITION\n  // ==========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.collapse')\n      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)\n\n      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false\n      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.collapse\n\n  $.fn.collapse             = Plugin\n  $.fn.collapse.Constructor = Collapse\n\n\n  // COLLAPSE NO CONFLICT\n  // ====================\n\n  $.fn.collapse.noConflict = function () {\n    $.fn.collapse = old\n    return this\n  }\n\n\n  // COLLAPSE DATA-API\n  // =================\n\n  $(document).on('click.bs.collapse.data-api', '[data-toggle=\"collapse\"]', function (e) {\n    var $this   = $(this)\n\n    if (!$this.attr('data-target')) e.preventDefault()\n\n    var $target = getTargetFromTrigger($this)\n    var data    = $target.data('bs.collapse')\n    var option  = data ? 'toggle' : $this.data()\n\n    Plugin.call($target, option)\n  })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: dropdown.js v3.3.7\n * http://getbootstrap.com/javascript/#dropdowns\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // DROPDOWN CLASS DEFINITION\n  // =========================\n\n  var backdrop = '.dropdown-backdrop'\n  var toggle   = '[data-toggle=\"dropdown\"]'\n  var Dropdown = function (element) {\n    $(element).on('click.bs.dropdown', this.toggle)\n  }\n\n  Dropdown.VERSION = '3.3.7'\n\n  function getParent($this) {\n    var selector = $this.attr('data-target')\n\n    if (!selector) {\n      selector = $this.attr('href')\n      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\\s]*$)/, '') // strip for ie7\n    }\n\n    var $parent = selector && $(selector)\n\n    return $parent && $parent.length ? $parent : $this.parent()\n  }\n\n  function clearMenus(e) {\n    if (e && e.which === 3) return\n    $(backdrop).remove()\n    $(toggle).each(function () {\n      var $this         = $(this)\n      var $parent       = getParent($this)\n      var relatedTarget = { relatedTarget: this }\n\n      if (!$parent.hasClass('open')) return\n\n      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return\n\n      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))\n\n      if (e.isDefaultPrevented()) return\n\n      $this.attr('aria-expanded', 'false')\n      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))\n    })\n  }\n\n  Dropdown.prototype.toggle = function (e) {\n    var $this = $(this)\n\n    if ($this.is('.disabled, :disabled')) return\n\n    var $parent  = getParent($this)\n    var isActive = $parent.hasClass('open')\n\n    clearMenus()\n\n    if (!isActive) {\n      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {\n        // if mobile we use a backdrop because click events don't delegate\n        $(document.createElement('div'))\n          .addClass('dropdown-backdrop')\n          .insertAfter($(this))\n          .on('click', clearMenus)\n      }\n\n      var relatedTarget = { relatedTarget: this }\n      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))\n\n      if (e.isDefaultPrevented()) return\n\n      $this\n        .trigger('focus')\n        .attr('aria-expanded', 'true')\n\n      $parent\n        .toggleClass('open')\n        .trigger($.Event('shown.bs.dropdown', relatedTarget))\n    }\n\n    return false\n  }\n\n  Dropdown.prototype.keydown = function (e) {\n    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return\n\n    var $this = $(this)\n\n    e.preventDefault()\n    e.stopPropagation()\n\n    if ($this.is('.disabled, :disabled')) return\n\n    var $parent  = getParent($this)\n    var isActive = $parent.hasClass('open')\n\n    if (!isActive && e.which != 27 || isActive && e.which == 27) {\n      if (e.which == 27) $parent.find(toggle).trigger('focus')\n      return $this.trigger('click')\n    }\n\n    var desc = ' li:not(.disabled):visible a'\n    var $items = $parent.find('.dropdown-menu' + desc)\n\n    if (!$items.length) return\n\n    var index = $items.index(e.target)\n\n    if (e.which == 38 && index > 0)                 index--         // up\n    if (e.which == 40 && index < $items.length - 1) index++         // down\n    if (!~index)                                    index = 0\n\n    $items.eq(index).trigger('focus')\n  }\n\n\n  // DROPDOWN PLUGIN DEFINITION\n  // ==========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this = $(this)\n      var data  = $this.data('bs.dropdown')\n\n      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))\n      if (typeof option == 'string') data[option].call($this)\n    })\n  }\n\n  var old = $.fn.dropdown\n\n  $.fn.dropdown             = Plugin\n  $.fn.dropdown.Constructor = Dropdown\n\n\n  // DROPDOWN NO CONFLICT\n  // ====================\n\n  $.fn.dropdown.noConflict = function () {\n    $.fn.dropdown = old\n    return this\n  }\n\n\n  // APPLY TO STANDARD DROPDOWN ELEMENTS\n  // ===================================\n\n  $(document)\n    .on('click.bs.dropdown.data-api', clearMenus)\n    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })\n    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)\n    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)\n    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: modal.js v3.3.7\n * http://getbootstrap.com/javascript/#modals\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // MODAL CLASS DEFINITION\n  // ======================\n\n  var Modal = function (element, options) {\n    this.options             = options\n    this.$body               = $(document.body)\n    this.$element            = $(element)\n    this.$dialog             = this.$element.find('.modal-dialog')\n    this.$backdrop           = null\n    this.isShown             = null\n    this.originalBodyPad     = null\n    this.scrollbarWidth      = 0\n    this.ignoreBackdropClick = false\n\n    if (this.options.remote) {\n      this.$element\n        .find('.modal-content')\n        .load(this.options.remote, $.proxy(function () {\n          this.$element.trigger('loaded.bs.modal')\n        }, this))\n    }\n  }\n\n  Modal.VERSION  = '3.3.7'\n\n  Modal.TRANSITION_DURATION = 300\n  Modal.BACKDROP_TRANSITION_DURATION = 150\n\n  Modal.DEFAULTS = {\n    backdrop: true,\n    keyboard: true,\n    show: true\n  }\n\n  Modal.prototype.toggle = function (_relatedTarget) {\n    return this.isShown ? this.hide() : this.show(_relatedTarget)\n  }\n\n  Modal.prototype.show = function (_relatedTarget) {\n    var that = this\n    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })\n\n    this.$element.trigger(e)\n\n    if (this.isShown || e.isDefaultPrevented()) return\n\n    this.isShown = true\n\n    this.checkScrollbar()\n    this.setScrollbar()\n    this.$body.addClass('modal-open')\n\n    this.escape()\n    this.resize()\n\n    this.$element.on('click.dismiss.bs.modal', '[data-dismiss=\"modal\"]', $.proxy(this.hide, this))\n\n    this.$dialog.on('mousedown.dismiss.bs.modal', function () {\n      that.$element.one('mouseup.dismiss.bs.modal', function (e) {\n        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true\n      })\n    })\n\n    this.backdrop(function () {\n      var transition = $.support.transition && that.$element.hasClass('fade')\n\n      if (!that.$element.parent().length) {\n        that.$element.appendTo(that.$body) // don't move modals dom position\n      }\n\n      that.$element\n        .show()\n        .scrollTop(0)\n\n      that.adjustDialog()\n\n      if (transition) {\n        that.$element[0].offsetWidth // force reflow\n      }\n\n      that.$element.addClass('in')\n\n      that.enforceFocus()\n\n      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })\n\n      transition ?\n        that.$dialog // wait for modal to slide in\n          .one('bsTransitionEnd', function () {\n            that.$element.trigger('focus').trigger(e)\n          })\n          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :\n        that.$element.trigger('focus').trigger(e)\n    })\n  }\n\n  Modal.prototype.hide = function (e) {\n    if (e) e.preventDefault()\n\n    e = $.Event('hide.bs.modal')\n\n    this.$element.trigger(e)\n\n    if (!this.isShown || e.isDefaultPrevented()) return\n\n    this.isShown = false\n\n    this.escape()\n    this.resize()\n\n    $(document).off('focusin.bs.modal')\n\n    this.$element\n      .removeClass('in')\n      .off('click.dismiss.bs.modal')\n      .off('mouseup.dismiss.bs.modal')\n\n    this.$dialog.off('mousedown.dismiss.bs.modal')\n\n    $.support.transition && this.$element.hasClass('fade') ?\n      this.$element\n        .one('bsTransitionEnd', $.proxy(this.hideModal, this))\n        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :\n      this.hideModal()\n  }\n\n  Modal.prototype.enforceFocus = function () {\n    $(document)\n      .off('focusin.bs.modal') // guard against infinite focus loop\n      .on('focusin.bs.modal', $.proxy(function (e) {\n        if (document !== e.target &&\n            this.$element[0] !== e.target &&\n            !this.$element.has(e.target).length) {\n          this.$element.trigger('focus')\n        }\n      }, this))\n  }\n\n  Modal.prototype.escape = function () {\n    if (this.isShown && this.options.keyboard) {\n      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {\n        e.which == 27 && this.hide()\n      }, this))\n    } else if (!this.isShown) {\n      this.$element.off('keydown.dismiss.bs.modal')\n    }\n  }\n\n  Modal.prototype.resize = function () {\n    if (this.isShown) {\n      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))\n    } else {\n      $(window).off('resize.bs.modal')\n    }\n  }\n\n  Modal.prototype.hideModal = function () {\n    var that = this\n    this.$element.hide()\n    this.backdrop(function () {\n      that.$body.removeClass('modal-open')\n      that.resetAdjustments()\n      that.resetScrollbar()\n      that.$element.trigger('hidden.bs.modal')\n    })\n  }\n\n  Modal.prototype.removeBackdrop = function () {\n    this.$backdrop && this.$backdrop.remove()\n    this.$backdrop = null\n  }\n\n  Modal.prototype.backdrop = function (callback) {\n    var that = this\n    var animate = this.$element.hasClass('fade') ? 'fade' : ''\n\n    if (this.isShown && this.options.backdrop) {\n      var doAnimate = $.support.transition && animate\n\n      this.$backdrop = $(document.createElement('div'))\n        .addClass('modal-backdrop ' + animate)\n        .appendTo(this.$body)\n\n      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {\n        if (this.ignoreBackdropClick) {\n          this.ignoreBackdropClick = false\n          return\n        }\n        if (e.target !== e.currentTarget) return\n        this.options.backdrop == 'static'\n          ? this.$element[0].focus()\n          : this.hide()\n      }, this))\n\n      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow\n\n      this.$backdrop.addClass('in')\n\n      if (!callback) return\n\n      doAnimate ?\n        this.$backdrop\n          .one('bsTransitionEnd', callback)\n          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :\n        callback()\n\n    } else if (!this.isShown && this.$backdrop) {\n      this.$backdrop.removeClass('in')\n\n      var callbackRemove = function () {\n        that.removeBackdrop()\n        callback && callback()\n      }\n      $.support.transition && this.$element.hasClass('fade') ?\n        this.$backdrop\n          .one('bsTransitionEnd', callbackRemove)\n          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :\n        callbackRemove()\n\n    } else if (callback) {\n      callback()\n    }\n  }\n\n  // these following methods are used to handle overflowing modals\n\n  Modal.prototype.handleUpdate = function () {\n    this.adjustDialog()\n  }\n\n  Modal.prototype.adjustDialog = function () {\n    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight\n\n    this.$element.css({\n      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',\n      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''\n    })\n  }\n\n  Modal.prototype.resetAdjustments = function () {\n    this.$element.css({\n      paddingLeft: '',\n      paddingRight: ''\n    })\n  }\n\n  Modal.prototype.checkScrollbar = function () {\n    var fullWindowWidth = window.innerWidth\n    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8\n      var documentElementRect = document.documentElement.getBoundingClientRect()\n      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)\n    }\n    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth\n    this.scrollbarWidth = this.measureScrollbar()\n  }\n\n  Modal.prototype.setScrollbar = function () {\n    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)\n    this.originalBodyPad = document.body.style.paddingRight || ''\n    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)\n  }\n\n  Modal.prototype.resetScrollbar = function () {\n    this.$body.css('padding-right', this.originalBodyPad)\n  }\n\n  Modal.prototype.measureScrollbar = function () { // thx walsh\n    var scrollDiv = document.createElement('div')\n    scrollDiv.className = 'modal-scrollbar-measure'\n    this.$body.append(scrollDiv)\n    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth\n    this.$body[0].removeChild(scrollDiv)\n    return scrollbarWidth\n  }\n\n\n  // MODAL PLUGIN DEFINITION\n  // =======================\n\n  function Plugin(option, _relatedTarget) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.modal')\n      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)\n\n      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))\n      if (typeof option == 'string') data[option](_relatedTarget)\n      else if (options.show) data.show(_relatedTarget)\n    })\n  }\n\n  var old = $.fn.modal\n\n  $.fn.modal             = Plugin\n  $.fn.modal.Constructor = Modal\n\n\n  // MODAL NO CONFLICT\n  // =================\n\n  $.fn.modal.noConflict = function () {\n    $.fn.modal = old\n    return this\n  }\n\n\n  // MODAL DATA-API\n  // ==============\n\n  $(document).on('click.bs.modal.data-api', '[data-toggle=\"modal\"]', function (e) {\n    var $this   = $(this)\n    var href    = $this.attr('href')\n    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\\s]+$)/, ''))) // strip for ie7\n    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())\n\n    if ($this.is('a')) e.preventDefault()\n\n    $target.one('show.bs.modal', function (showEvent) {\n      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown\n      $target.one('hidden.bs.modal', function () {\n        $this.is(':visible') && $this.trigger('focus')\n      })\n    })\n    Plugin.call($target, option, this)\n  })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: tooltip.js v3.3.7\n * http://getbootstrap.com/javascript/#tooltip\n * Inspired by the original jQuery.tipsy by Jason Frame\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // TOOLTIP PUBLIC CLASS DEFINITION\n  // ===============================\n\n  var Tooltip = function (element, options) {\n    this.type       = null\n    this.options    = null\n    this.enabled    = null\n    this.timeout    = null\n    this.hoverState = null\n    this.$element   = null\n    this.inState    = null\n\n    this.init('tooltip', element, options)\n  }\n\n  Tooltip.VERSION  = '3.3.7'\n\n  Tooltip.TRANSITION_DURATION = 150\n\n  Tooltip.DEFAULTS = {\n    animation: true,\n    placement: 'top',\n    selector: false,\n    template: '<div class=\"tooltip\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>',\n    trigger: 'hover focus',\n    title: '',\n    delay: 0,\n    html: false,\n    container: false,\n    viewport: {\n      selector: 'body',\n      padding: 0\n    }\n  }\n\n  Tooltip.prototype.init = function (type, element, options) {\n    this.enabled   = true\n    this.type      = type\n    this.$element  = $(element)\n    this.options   = this.getOptions(options)\n    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))\n    this.inState   = { click: false, hover: false, focus: false }\n\n    if (this.$element[0] instanceof document.constructor && !this.options.selector) {\n      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')\n    }\n\n    var triggers = this.options.trigger.split(' ')\n\n    for (var i = triggers.length; i--;) {\n      var trigger = triggers[i]\n\n      if (trigger == 'click') {\n        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))\n      } else if (trigger != 'manual') {\n        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'\n        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'\n\n        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))\n        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))\n      }\n    }\n\n    this.options.selector ?\n      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :\n      this.fixTitle()\n  }\n\n  Tooltip.prototype.getDefaults = function () {\n    return Tooltip.DEFAULTS\n  }\n\n  Tooltip.prototype.getOptions = function (options) {\n    options = $.extend({}, this.getDefaults(), this.$element.data(), options)\n\n    if (options.delay && typeof options.delay == 'number') {\n      options.delay = {\n        show: options.delay,\n        hide: options.delay\n      }\n    }\n\n    return options\n  }\n\n  Tooltip.prototype.getDelegateOptions = function () {\n    var options  = {}\n    var defaults = this.getDefaults()\n\n    this._options && $.each(this._options, function (key, value) {\n      if (defaults[key] != value) options[key] = value\n    })\n\n    return options\n  }\n\n  Tooltip.prototype.enter = function (obj) {\n    var self = obj instanceof this.constructor ?\n      obj : $(obj.currentTarget).data('bs.' + this.type)\n\n    if (!self) {\n      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())\n      $(obj.currentTarget).data('bs.' + this.type, self)\n    }\n\n    if (obj instanceof $.Event) {\n      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true\n    }\n\n    if (self.tip().hasClass('in') || self.hoverState == 'in') {\n      self.hoverState = 'in'\n      return\n    }\n\n    clearTimeout(self.timeout)\n\n    self.hoverState = 'in'\n\n    if (!self.options.delay || !self.options.delay.show) return self.show()\n\n    self.timeout = setTimeout(function () {\n      if (self.hoverState == 'in') self.show()\n    }, self.options.delay.show)\n  }\n\n  Tooltip.prototype.isInStateTrue = function () {\n    for (var key in this.inState) {\n      if (this.inState[key]) return true\n    }\n\n    return false\n  }\n\n  Tooltip.prototype.leave = function (obj) {\n    var self = obj instanceof this.constructor ?\n      obj : $(obj.currentTarget).data('bs.' + this.type)\n\n    if (!self) {\n      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())\n      $(obj.currentTarget).data('bs.' + this.type, self)\n    }\n\n    if (obj instanceof $.Event) {\n      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false\n    }\n\n    if (self.isInStateTrue()) return\n\n    clearTimeout(self.timeout)\n\n    self.hoverState = 'out'\n\n    if (!self.options.delay || !self.options.delay.hide) return self.hide()\n\n    self.timeout = setTimeout(function () {\n      if (self.hoverState == 'out') self.hide()\n    }, self.options.delay.hide)\n  }\n\n  Tooltip.prototype.show = function () {\n    var e = $.Event('show.bs.' + this.type)\n\n    if (this.hasContent() && this.enabled) {\n      this.$element.trigger(e)\n\n      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])\n      if (e.isDefaultPrevented() || !inDom) return\n      var that = this\n\n      var $tip = this.tip()\n\n      var tipId = this.getUID(this.type)\n\n      this.setContent()\n      $tip.attr('id', tipId)\n      this.$element.attr('aria-describedby', tipId)\n\n      if (this.options.animation) $tip.addClass('fade')\n\n      var placement = typeof this.options.placement == 'function' ?\n        this.options.placement.call(this, $tip[0], this.$element[0]) :\n        this.options.placement\n\n      var autoToken = /\\s?auto?\\s?/i\n      var autoPlace = autoToken.test(placement)\n      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'\n\n      $tip\n        .detach()\n        .css({ top: 0, left: 0, display: 'block' })\n        .addClass(placement)\n        .data('bs.' + this.type, this)\n\n      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)\n      this.$element.trigger('inserted.bs.' + this.type)\n\n      var pos          = this.getPosition()\n      var actualWidth  = $tip[0].offsetWidth\n      var actualHeight = $tip[0].offsetHeight\n\n      if (autoPlace) {\n        var orgPlacement = placement\n        var viewportDim = this.getPosition(this.$viewport)\n\n        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :\n                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :\n                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :\n                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :\n                    placement\n\n        $tip\n          .removeClass(orgPlacement)\n          .addClass(placement)\n      }\n\n      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)\n\n      this.applyPlacement(calculatedOffset, placement)\n\n      var complete = function () {\n        var prevHoverState = that.hoverState\n        that.$element.trigger('shown.bs.' + that.type)\n        that.hoverState = null\n\n        if (prevHoverState == 'out') that.leave(that)\n      }\n\n      $.support.transition && this.$tip.hasClass('fade') ?\n        $tip\n          .one('bsTransitionEnd', complete)\n          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :\n        complete()\n    }\n  }\n\n  Tooltip.prototype.applyPlacement = function (offset, placement) {\n    var $tip   = this.tip()\n    var width  = $tip[0].offsetWidth\n    var height = $tip[0].offsetHeight\n\n    // manually read margins because getBoundingClientRect includes difference\n    var marginTop = parseInt($tip.css('margin-top'), 10)\n    var marginLeft = parseInt($tip.css('margin-left'), 10)\n\n    // we must check for NaN for ie 8/9\n    if (isNaN(marginTop))  marginTop  = 0\n    if (isNaN(marginLeft)) marginLeft = 0\n\n    offset.top  += marginTop\n    offset.left += marginLeft\n\n    // $.fn.offset doesn't round pixel values\n    // so we use setOffset directly with our own function B-0\n    $.offset.setOffset($tip[0], $.extend({\n      using: function (props) {\n        $tip.css({\n          top: Math.round(props.top),\n          left: Math.round(props.left)\n        })\n      }\n    }, offset), 0)\n\n    $tip.addClass('in')\n\n    // check to see if placing tip in new offset caused the tip to resize itself\n    var actualWidth  = $tip[0].offsetWidth\n    var actualHeight = $tip[0].offsetHeight\n\n    if (placement == 'top' && actualHeight != height) {\n      offset.top = offset.top + height - actualHeight\n    }\n\n    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)\n\n    if (delta.left) offset.left += delta.left\n    else offset.top += delta.top\n\n    var isVertical          = /top|bottom/.test(placement)\n    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight\n    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'\n\n    $tip.offset(offset)\n    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)\n  }\n\n  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {\n    this.arrow()\n      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')\n      .css(isVertical ? 'top' : 'left', '')\n  }\n\n  Tooltip.prototype.setContent = function () {\n    var $tip  = this.tip()\n    var title = this.getTitle()\n\n    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)\n    $tip.removeClass('fade in top bottom left right')\n  }\n\n  Tooltip.prototype.hide = function (callback) {\n    var that = this\n    var $tip = $(this.$tip)\n    var e    = $.Event('hide.bs.' + this.type)\n\n    function complete() {\n      if (that.hoverState != 'in') $tip.detach()\n      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.\n        that.$element\n          .removeAttr('aria-describedby')\n          .trigger('hidden.bs.' + that.type)\n      }\n      callback && callback()\n    }\n\n    this.$element.trigger(e)\n\n    if (e.isDefaultPrevented()) return\n\n    $tip.removeClass('in')\n\n    $.support.transition && $tip.hasClass('fade') ?\n      $tip\n        .one('bsTransitionEnd', complete)\n        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :\n      complete()\n\n    this.hoverState = null\n\n    return this\n  }\n\n  Tooltip.prototype.fixTitle = function () {\n    var $e = this.$element\n    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {\n      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')\n    }\n  }\n\n  Tooltip.prototype.hasContent = function () {\n    return this.getTitle()\n  }\n\n  Tooltip.prototype.getPosition = function ($element) {\n    $element   = $element || this.$element\n\n    var el     = $element[0]\n    var isBody = el.tagName == 'BODY'\n\n    var elRect    = el.getBoundingClientRect()\n    if (elRect.width == null) {\n      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093\n      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })\n    }\n    var isSvg = window.SVGElement && el instanceof window.SVGElement\n    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.\n    // See https://github.com/twbs/bootstrap/issues/20280\n    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())\n    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }\n    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null\n\n    return $.extend({}, elRect, scroll, outerDims, elOffset)\n  }\n\n  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {\n    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :\n           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :\n           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :\n        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }\n\n  }\n\n  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {\n    var delta = { top: 0, left: 0 }\n    if (!this.$viewport) return delta\n\n    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0\n    var viewportDimensions = this.getPosition(this.$viewport)\n\n    if (/right|left/.test(placement)) {\n      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll\n      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight\n      if (topEdgeOffset < viewportDimensions.top) { // top overflow\n        delta.top = viewportDimensions.top - topEdgeOffset\n      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow\n        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset\n      }\n    } else {\n      var leftEdgeOffset  = pos.left - viewportPadding\n      var rightEdgeOffset = pos.left + viewportPadding + actualWidth\n      if (leftEdgeOffset < viewportDimensions.left) { // left overflow\n        delta.left = viewportDimensions.left - leftEdgeOffset\n      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow\n        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset\n      }\n    }\n\n    return delta\n  }\n\n  Tooltip.prototype.getTitle = function () {\n    var title\n    var $e = this.$element\n    var o  = this.options\n\n    title = $e.attr('data-original-title')\n      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)\n\n    return title\n  }\n\n  Tooltip.prototype.getUID = function (prefix) {\n    do prefix += ~~(Math.random() * 1000000)\n    while (document.getElementById(prefix))\n    return prefix\n  }\n\n  Tooltip.prototype.tip = function () {\n    if (!this.$tip) {\n      this.$tip = $(this.options.template)\n      if (this.$tip.length != 1) {\n        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')\n      }\n    }\n    return this.$tip\n  }\n\n  Tooltip.prototype.arrow = function () {\n    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))\n  }\n\n  Tooltip.prototype.enable = function () {\n    this.enabled = true\n  }\n\n  Tooltip.prototype.disable = function () {\n    this.enabled = false\n  }\n\n  Tooltip.prototype.toggleEnabled = function () {\n    this.enabled = !this.enabled\n  }\n\n  Tooltip.prototype.toggle = function (e) {\n    var self = this\n    if (e) {\n      self = $(e.currentTarget).data('bs.' + this.type)\n      if (!self) {\n        self = new this.constructor(e.currentTarget, this.getDelegateOptions())\n        $(e.currentTarget).data('bs.' + this.type, self)\n      }\n    }\n\n    if (e) {\n      self.inState.click = !self.inState.click\n      if (self.isInStateTrue()) self.enter(self)\n      else self.leave(self)\n    } else {\n      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)\n    }\n  }\n\n  Tooltip.prototype.destroy = function () {\n    var that = this\n    clearTimeout(this.timeout)\n    this.hide(function () {\n      that.$element.off('.' + that.type).removeData('bs.' + that.type)\n      if (that.$tip) {\n        that.$tip.detach()\n      }\n      that.$tip = null\n      that.$arrow = null\n      that.$viewport = null\n      that.$element = null\n    })\n  }\n\n\n  // TOOLTIP PLUGIN DEFINITION\n  // =========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.tooltip')\n      var options = typeof option == 'object' && option\n\n      if (!data && /destroy|hide/.test(option)) return\n      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.tooltip\n\n  $.fn.tooltip             = Plugin\n  $.fn.tooltip.Constructor = Tooltip\n\n\n  // TOOLTIP NO CONFLICT\n  // ===================\n\n  $.fn.tooltip.noConflict = function () {\n    $.fn.tooltip = old\n    return this\n  }\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: popover.js v3.3.7\n * http://getbootstrap.com/javascript/#popovers\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // POPOVER PUBLIC CLASS DEFINITION\n  // ===============================\n\n  var Popover = function (element, options) {\n    this.init('popover', element, options)\n  }\n\n  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')\n\n  Popover.VERSION  = '3.3.7'\n\n  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {\n    placement: 'right',\n    trigger: 'click',\n    content: '',\n    template: '<div class=\"popover\" role=\"tooltip\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>'\n  })\n\n\n  // NOTE: POPOVER EXTENDS tooltip.js\n  // ================================\n\n  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)\n\n  Popover.prototype.constructor = Popover\n\n  Popover.prototype.getDefaults = function () {\n    return Popover.DEFAULTS\n  }\n\n  Popover.prototype.setContent = function () {\n    var $tip    = this.tip()\n    var title   = this.getTitle()\n    var content = this.getContent()\n\n    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)\n    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events\n      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'\n    ](content)\n\n    $tip.removeClass('fade top bottom left right in')\n\n    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do\n    // this manually by checking the contents.\n    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()\n  }\n\n  Popover.prototype.hasContent = function () {\n    return this.getTitle() || this.getContent()\n  }\n\n  Popover.prototype.getContent = function () {\n    var $e = this.$element\n    var o  = this.options\n\n    return $e.attr('data-content')\n      || (typeof o.content == 'function' ?\n            o.content.call($e[0]) :\n            o.content)\n  }\n\n  Popover.prototype.arrow = function () {\n    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))\n  }\n\n\n  // POPOVER PLUGIN DEFINITION\n  // =========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.popover')\n      var options = typeof option == 'object' && option\n\n      if (!data && /destroy|hide/.test(option)) return\n      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.popover\n\n  $.fn.popover             = Plugin\n  $.fn.popover.Constructor = Popover\n\n\n  // POPOVER NO CONFLICT\n  // ===================\n\n  $.fn.popover.noConflict = function () {\n    $.fn.popover = old\n    return this\n  }\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: scrollspy.js v3.3.7\n * http://getbootstrap.com/javascript/#scrollspy\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // SCROLLSPY CLASS DEFINITION\n  // ==========================\n\n  function ScrollSpy(element, options) {\n    this.$body          = $(document.body)\n    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)\n    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)\n    this.selector       = (this.options.target || '') + ' .nav li > a'\n    this.offsets        = []\n    this.targets        = []\n    this.activeTarget   = null\n    this.scrollHeight   = 0\n\n    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))\n    this.refresh()\n    this.process()\n  }\n\n  ScrollSpy.VERSION  = '3.3.7'\n\n  ScrollSpy.DEFAULTS = {\n    offset: 10\n  }\n\n  ScrollSpy.prototype.getScrollHeight = function () {\n    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)\n  }\n\n  ScrollSpy.prototype.refresh = function () {\n    var that          = this\n    var offsetMethod  = 'offset'\n    var offsetBase    = 0\n\n    this.offsets      = []\n    this.targets      = []\n    this.scrollHeight = this.getScrollHeight()\n\n    if (!$.isWindow(this.$scrollElement[0])) {\n      offsetMethod = 'position'\n      offsetBase   = this.$scrollElement.scrollTop()\n    }\n\n    this.$body\n      .find(this.selector)\n      .map(function () {\n        var $el   = $(this)\n        var href  = $el.data('target') || $el.attr('href')\n        var $href = /^#./.test(href) && $(href)\n\n        return ($href\n          && $href.length\n          && $href.is(':visible')\n          && [[$href[offsetMethod]().top + offsetBase, href]]) || null\n      })\n      .sort(function (a, b) { return a[0] - b[0] })\n      .each(function () {\n        that.offsets.push(this[0])\n        that.targets.push(this[1])\n      })\n  }\n\n  ScrollSpy.prototype.process = function () {\n    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset\n    var scrollHeight = this.getScrollHeight()\n    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()\n    var offsets      = this.offsets\n    var targets      = this.targets\n    var activeTarget = this.activeTarget\n    var i\n\n    if (this.scrollHeight != scrollHeight) {\n      this.refresh()\n    }\n\n    if (scrollTop >= maxScroll) {\n      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)\n    }\n\n    if (activeTarget && scrollTop < offsets[0]) {\n      this.activeTarget = null\n      return this.clear()\n    }\n\n    for (i = offsets.length; i--;) {\n      activeTarget != targets[i]\n        && scrollTop >= offsets[i]\n        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])\n        && this.activate(targets[i])\n    }\n  }\n\n  ScrollSpy.prototype.activate = function (target) {\n    this.activeTarget = target\n\n    this.clear()\n\n    var selector = this.selector +\n      '[data-target=\"' + target + '\"],' +\n      this.selector + '[href=\"' + target + '\"]'\n\n    var active = $(selector)\n      .parents('li')\n      .addClass('active')\n\n    if (active.parent('.dropdown-menu').length) {\n      active = active\n        .closest('li.dropdown')\n        .addClass('active')\n    }\n\n    active.trigger('activate.bs.scrollspy')\n  }\n\n  ScrollSpy.prototype.clear = function () {\n    $(this.selector)\n      .parentsUntil(this.options.target, '.active')\n      .removeClass('active')\n  }\n\n\n  // SCROLLSPY PLUGIN DEFINITION\n  // ===========================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.scrollspy')\n      var options = typeof option == 'object' && option\n\n      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.scrollspy\n\n  $.fn.scrollspy             = Plugin\n  $.fn.scrollspy.Constructor = ScrollSpy\n\n\n  // SCROLLSPY NO CONFLICT\n  // =====================\n\n  $.fn.scrollspy.noConflict = function () {\n    $.fn.scrollspy = old\n    return this\n  }\n\n\n  // SCROLLSPY DATA-API\n  // ==================\n\n  $(window).on('load.bs.scrollspy.data-api', function () {\n    $('[data-spy=\"scroll\"]').each(function () {\n      var $spy = $(this)\n      Plugin.call($spy, $spy.data())\n    })\n  })\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: tab.js v3.3.7\n * http://getbootstrap.com/javascript/#tabs\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // TAB CLASS DEFINITION\n  // ====================\n\n  var Tab = function (element) {\n    // jscs:disable requireDollarBeforejQueryAssignment\n    this.element = $(element)\n    // jscs:enable requireDollarBeforejQueryAssignment\n  }\n\n  Tab.VERSION = '3.3.7'\n\n  Tab.TRANSITION_DURATION = 150\n\n  Tab.prototype.show = function () {\n    var $this    = this.element\n    var $ul      = $this.closest('ul:not(.dropdown-menu)')\n    var selector = $this.data('target')\n\n    if (!selector) {\n      selector = $this.attr('href')\n      selector = selector && selector.replace(/.*(?=#[^\\s]*$)/, '') // strip for ie7\n    }\n\n    if ($this.parent('li').hasClass('active')) return\n\n    var $previous = $ul.find('.active:last a')\n    var hideEvent = $.Event('hide.bs.tab', {\n      relatedTarget: $this[0]\n    })\n    var showEvent = $.Event('show.bs.tab', {\n      relatedTarget: $previous[0]\n    })\n\n    $previous.trigger(hideEvent)\n    $this.trigger(showEvent)\n\n    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return\n\n    var $target = $(selector)\n\n    this.activate($this.closest('li'), $ul)\n    this.activate($target, $target.parent(), function () {\n      $previous.trigger({\n        type: 'hidden.bs.tab',\n        relatedTarget: $this[0]\n      })\n      $this.trigger({\n        type: 'shown.bs.tab',\n        relatedTarget: $previous[0]\n      })\n    })\n  }\n\n  Tab.prototype.activate = function (element, container, callback) {\n    var $active    = container.find('> .active')\n    var transition = callback\n      && $.support.transition\n      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)\n\n    function next() {\n      $active\n        .removeClass('active')\n        .find('> .dropdown-menu > .active')\n          .removeClass('active')\n        .end()\n        .find('[data-toggle=\"tab\"]')\n          .attr('aria-expanded', false)\n\n      element\n        .addClass('active')\n        .find('[data-toggle=\"tab\"]')\n          .attr('aria-expanded', true)\n\n      if (transition) {\n        element[0].offsetWidth // reflow for transition\n        element.addClass('in')\n      } else {\n        element.removeClass('fade')\n      }\n\n      if (element.parent('.dropdown-menu').length) {\n        element\n          .closest('li.dropdown')\n            .addClass('active')\n          .end()\n          .find('[data-toggle=\"tab\"]')\n            .attr('aria-expanded', true)\n      }\n\n      callback && callback()\n    }\n\n    $active.length && transition ?\n      $active\n        .one('bsTransitionEnd', next)\n        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :\n      next()\n\n    $active.removeClass('in')\n  }\n\n\n  // TAB PLUGIN DEFINITION\n  // =====================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this = $(this)\n      var data  = $this.data('bs.tab')\n\n      if (!data) $this.data('bs.tab', (data = new Tab(this)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.tab\n\n  $.fn.tab             = Plugin\n  $.fn.tab.Constructor = Tab\n\n\n  // TAB NO CONFLICT\n  // ===============\n\n  $.fn.tab.noConflict = function () {\n    $.fn.tab = old\n    return this\n  }\n\n\n  // TAB DATA-API\n  // ============\n\n  var clickHandler = function (e) {\n    e.preventDefault()\n    Plugin.call($(this), 'show')\n  }\n\n  $(document)\n    .on('click.bs.tab.data-api', '[data-toggle=\"tab\"]', clickHandler)\n    .on('click.bs.tab.data-api', '[data-toggle=\"pill\"]', clickHandler)\n\n}(jQuery);\n\n/* ========================================================================\n * Bootstrap: affix.js v3.3.7\n * http://getbootstrap.com/javascript/#affix\n * ========================================================================\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * ======================================================================== */\n\n\n+function ($) {\n  'use strict';\n\n  // AFFIX CLASS DEFINITION\n  // ======================\n\n  var Affix = function (element, options) {\n    this.options = $.extend({}, Affix.DEFAULTS, options)\n\n    this.$target = $(this.options.target)\n      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))\n      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))\n\n    this.$element     = $(element)\n    this.affixed      = null\n    this.unpin        = null\n    this.pinnedOffset = null\n\n    this.checkPosition()\n  }\n\n  Affix.VERSION  = '3.3.7'\n\n  Affix.RESET    = 'affix affix-top affix-bottom'\n\n  Affix.DEFAULTS = {\n    offset: 0,\n    target: window\n  }\n\n  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {\n    var scrollTop    = this.$target.scrollTop()\n    var position     = this.$element.offset()\n    var targetHeight = this.$target.height()\n\n    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false\n\n    if (this.affixed == 'bottom') {\n      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'\n      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'\n    }\n\n    var initializing   = this.affixed == null\n    var colliderTop    = initializing ? scrollTop : position.top\n    var colliderHeight = initializing ? targetHeight : height\n\n    if (offsetTop != null && scrollTop <= offsetTop) return 'top'\n    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'\n\n    return false\n  }\n\n  Affix.prototype.getPinnedOffset = function () {\n    if (this.pinnedOffset) return this.pinnedOffset\n    this.$element.removeClass(Affix.RESET).addClass('affix')\n    var scrollTop = this.$target.scrollTop()\n    var position  = this.$element.offset()\n    return (this.pinnedOffset = position.top - scrollTop)\n  }\n\n  Affix.prototype.checkPositionWithEventLoop = function () {\n    setTimeout($.proxy(this.checkPosition, this), 1)\n  }\n\n  Affix.prototype.checkPosition = function () {\n    if (!this.$element.is(':visible')) return\n\n    var height       = this.$element.height()\n    var offset       = this.options.offset\n    var offsetTop    = offset.top\n    var offsetBottom = offset.bottom\n    var scrollHeight = Math.max($(document).height(), $(document.body).height())\n\n    if (typeof offset != 'object')         offsetBottom = offsetTop = offset\n    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)\n    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)\n\n    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)\n\n    if (this.affixed != affix) {\n      if (this.unpin != null) this.$element.css('top', '')\n\n      var affixType = 'affix' + (affix ? '-' + affix : '')\n      var e         = $.Event(affixType + '.bs.affix')\n\n      this.$element.trigger(e)\n\n      if (e.isDefaultPrevented()) return\n\n      this.affixed = affix\n      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null\n\n      this.$element\n        .removeClass(Affix.RESET)\n        .addClass(affixType)\n        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')\n    }\n\n    if (affix == 'bottom') {\n      this.$element.offset({\n        top: scrollHeight - height - offsetBottom\n      })\n    }\n  }\n\n\n  // AFFIX PLUGIN DEFINITION\n  // =======================\n\n  function Plugin(option) {\n    return this.each(function () {\n      var $this   = $(this)\n      var data    = $this.data('bs.affix')\n      var options = typeof option == 'object' && option\n\n      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))\n      if (typeof option == 'string') data[option]()\n    })\n  }\n\n  var old = $.fn.affix\n\n  $.fn.affix             = Plugin\n  $.fn.affix.Constructor = Affix\n\n\n  // AFFIX NO CONFLICT\n  // =================\n\n  $.fn.affix.noConflict = function () {\n    $.fn.affix = old\n    return this\n  }\n\n\n  // AFFIX DATA-API\n  // ==============\n\n  $(window).on('load', function () {\n    $('[data-spy=\"affix\"]').each(function () {\n      var $spy = $(this)\n      var data = $spy.data()\n\n      data.offset = data.offset || {}\n\n      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom\n      if (data.offsetTop    != null) data.offset.top    = data.offsetTop\n\n      Plugin.call($spy, data)\n    })\n  })\n\n}(jQuery);\n"

/***/ },

/***/ "5W1q":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "sJ7E":
/***/ function(module, exports) {

	module.exports = {
		"GLASS": "M61.164-57.743q0 1.26-1.548 2.808l-22.752 22.752v27.648h11.52q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h11.52v-27.648l-22.752-22.752q-1.548-1.548-1.548-2.808 0-.828.648-1.314t1.368-.63 1.548-.144h50.688q.828 0 1.548.144t1.368.63.648 1.314z",
		"MUSIC": "M55.296-56.375v40.32q0 1.8-1.224 3.204t-3.096 2.178-3.726 1.152-3.474.378-3.474-.378-3.726-1.152-3.096-2.178-1.224-3.204 1.224-3.204 3.096-2.178 3.726-1.152 3.474-.378q3.78 0 6.912 1.404v-19.332l-27.648 8.532v25.524q0 1.8-1.224 3.204t-3.096 2.178-3.726 1.152-3.474.378-3.474-.378-3.726-1.152-3.096-2.178-1.224-3.204 1.224-3.204 3.096-2.178 3.726-1.152 3.474-.378q3.78 0 6.912 1.404v-34.812q0-1.116.684-2.034t1.764-1.278l29.952-9.216q.432-.144 1.008-.144 1.44 0 2.448 1.008t1.008 2.448z",
		"SEARCH": "M41.472-34.487q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.872-1.368 3.24t-3.24 1.368q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z",
		"ENVELOPE_O": "M59.904-10.295v-27.648q-1.152 1.296-2.484 2.376-9.648 7.416-15.336 12.168-1.836 1.548-2.988 2.412t-3.114 1.746-3.69.882h-.072q-1.728 0-3.69-.882t-3.114-1.746-2.988-2.412q-5.688-4.752-15.336-12.168-1.332-1.08-2.484-2.376v27.648q0 .468.342.81t.81.342h52.992q.468 0 .81-.342t.342-.81zm0-37.836v-.882l-.018-.468-.108-.45-.198-.324-.324-.27-.504-.09h-52.992q-.468 0-.81.342t-.342.81q0 6.048 5.292 10.224 6.948 5.472 14.436 11.412.216.18 1.26 1.062t1.656 1.35 1.602 1.134 1.818.99 1.548.324h.072q.72 0 1.548-.324t1.818-.99 1.602-1.134 1.656-1.35 1.26-1.062q7.488-5.94 14.436-11.412 1.944-1.548 3.618-4.158t1.674-4.734zm4.608-1.332v39.168q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h52.992q2.376 0 4.068 1.692t1.692 4.068z",
		"HEART": "M32.256-4.535q-.936 0-1.584-.648l-22.464-21.672q-.36-.288-.99-.936t-1.998-2.358-2.448-3.51-1.926-4.356-.846-4.968q0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384q0 7.956-8.244 16.2l-22.428 21.6q-.648.648-1.584.648z",
		"STAR": "M59.904-41.147q0 .792-.936 1.728l-13.068 12.744 3.096 18q.036.252.036.72 0 .756-.378 1.278t-1.098.522q-.684 0-1.44-.432l-16.164-8.496-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476t1.764 1.476l8.1 16.38 18.072 2.628q2.016.324 2.016 1.656z",
		"STAR_O": "M40.932-28.295l11.016-10.692-15.192-2.232-6.804-13.752-6.804 13.752-15.192 2.232 11.016 10.692-2.628 15.156 13.608-7.164 13.572 7.164zm18.972-12.852q0 .792-.936 1.728l-13.068 12.744 3.096 18q.036.252.036.72 0 1.8-1.476 1.8-.684 0-1.44-.432l-16.164-8.496-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476t1.764 1.476l8.1 16.38 18.072 2.628q2.016.324 2.016 1.656z",
		"USER": "M50.688-13.859q0 4.32-2.628 6.822t-6.984 2.502h-31.464q-4.356 0-6.984-2.502t-2.628-6.822q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.324 0 1.512.774t2.682 1.728 3.888 1.728 4.806.774 4.806-.774 3.888-1.728 2.682-1.728 1.512-.774q2.196 0 4.014.72t3.078 1.926 2.232 2.916 1.548 3.51.954 3.906.504 3.924.126 3.726zm-11.52-32.148q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z",
		"FILM": "M13.824-6.839v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm36.864 27.648v-18.432q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm-36.864-41.472v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm50.688 41.472v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm-13.824-27.648v-18.432q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm13.824 13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm4.608-5.76v48.384q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-48.384q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z",
		"TH_LARGE": "M27.648-27.575v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm0-27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm32.256 27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm0-27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24z",
		"TH": "M18.432-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm-23.04-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm-23.04-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448z",
		"TH_LIST": "M18.432-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm46.08 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448zm-46.08-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm46.08 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448z",
		"CHECK": "M60.156-44.063q0 1.44-1.008 2.448l-26.064 26.064-4.896 4.896q-1.008 1.008-2.448 1.008t-2.448-1.008l-4.896-4.896-13.032-13.032q-1.008-1.008-1.008-2.448t1.008-2.448l4.896-4.896q1.008-1.008 2.448-1.008t2.448 1.008l10.584 10.62 23.616-23.652q1.008-1.008 2.448-1.008t2.448 1.008l4.896 4.896q1.008 1.008 1.008 2.448z",
		"TIMES": "M46.728-16.847q0 1.44-1.008 2.448l-4.896 4.896q-1.008 1.008-2.448 1.008t-2.448-1.008l-10.584-10.584-10.584 10.584q-1.008 1.008-2.448 1.008t-2.448-1.008l-4.896-4.896q-1.008-1.008-1.008-2.448t1.008-2.448l10.584-10.584-10.584-10.584q-1.008-1.008-1.008-2.448t1.008-2.448l4.896-4.896q1.008-1.008 2.448-1.008t2.448 1.008l10.584 10.584 10.584-10.584q1.008-1.008 2.448-1.008t2.448 1.008l4.896 4.896q1.008 1.008 1.008 2.448t-1.008 2.448l-10.584 10.584 10.584 10.584q1.008 1.008 1.008 2.448z",
		"SEARCH_PLUS": "M36.864-35.639v2.304q0 .468-.342.81t-.81.342h-8.064v8.064q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-8.064h-8.064q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h8.064v-8.064q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81v8.064h8.064q.468 0 .81.342t.342.81zm4.608 1.152q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.908-1.35 3.258t-3.258 1.35q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z",
		"SEARCH_MINUS": "M36.864-35.639v2.304q0 .468-.342.81t-.81.342h-20.736q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h20.736q.468 0 .81.342t.342.81zm4.608 1.152q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.908-1.35 3.258t-3.258 1.35q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z",
		"POWER_OFF": "M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196-10.728-2.196-8.82-5.904-5.904-8.82-2.196-10.728q0-6.552 2.898-12.348t8.154-9.72q1.548-1.152 3.438-.9t3.006 1.8q1.152 1.512.882 3.402t-1.782 3.042q-3.528 2.664-5.454 6.516t-1.926 8.208q0 3.744 1.458 7.146t3.942 5.886 5.886 3.942 7.146 1.458 7.146-1.458 5.886-3.942 3.942-5.886 1.458-7.146q0-4.356-1.926-8.208t-5.454-6.516q-1.512-1.152-1.782-3.042t.882-3.402q1.116-1.548 3.024-1.8t3.42.9q5.256 3.924 8.154 9.72t2.898 12.348zm-23.04-27.648v23.04q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24v-23.04q0-1.872 1.368-3.24t3.24-1.368 3.24 1.368 1.368 3.24z",
		"SIGNAL": "M9.216-12.599v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-4.608v11.52q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-11.52q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-9.216v20.736q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-13.824v34.56q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-18.432v52.992q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-52.992q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828z",
		"GEAR": "M36.864-32.183q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm18.432-3.924v7.992q0 .432-.288.828t-.72.468l-6.66 1.008q-.684 1.944-1.404 3.276 1.26 1.8 3.852 4.968.36.432.36.9t-.324.828q-.972 1.332-3.564 3.888t-3.384 2.556q-.432 0-.936-.324l-4.968-3.888q-1.584.828-3.276 1.368-.576 4.896-1.044 6.696-.252 1.008-1.296 1.008h-7.992q-.504 0-.882-.306t-.414-.774l-1.008-6.624q-1.764-.576-3.24-1.332l-5.076 3.852q-.36.324-.9.324-.504 0-.9-.396-4.536-4.104-5.94-6.048-.252-.36-.252-.828 0-.432.288-.828.54-.756 1.836-2.394t1.944-2.538q-.972-1.8-1.476-3.564l-6.588-.972q-.468-.072-.756-.45t-.288-.846v-7.992q0-.432.288-.828t.684-.468l6.696-1.008q.504-1.656 1.404-3.312-1.44-2.052-3.852-4.968-.36-.432-.36-.864 0-.36.324-.828.936-1.296 3.546-3.87t3.402-2.574q.468 0 .936.36l4.968 3.852q1.584-.828 3.276-1.368.576-4.896 1.044-6.696.252-1.008 1.296-1.008h7.992q.504 0 .882.306t.414.774l1.008 6.624q1.764.576 3.24 1.332l5.112-3.852q.324-.324.864-.324.468 0 .9.36 4.644 4.284 5.94 6.12.252.288.252.792 0 .432-.288.828-.54.756-1.836 2.394t-1.944 2.538q.936 1.8 1.476 3.528l6.588 1.008q.468.072.756.45t.288.846z",
		"TRASH_O": "M18.432-37.943v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm9.216 0v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm9.216 0v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm4.608 26.064v-34.128h-32.256v34.128q0 .792.252 1.458t.522.972.378.306h29.952q.108 0 .378-.306t.522-.972.252-1.458zm-24.192-38.736h16.128l-1.728-4.212q-.252-.324-.612-.396h-11.412q-.36.072-.612.396zm33.408 1.152v2.304q0 .504-.324.828t-.828.324h-3.456v34.128q0 2.988-1.692 5.166t-4.068 2.178h-29.952q-2.376 0-4.068-2.106t-1.692-5.094v-34.272h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h11.124l2.52-6.012q.54-1.332 1.944-2.268t2.844-.936h11.52q1.44 0 2.844.936t1.944 2.268l2.52 6.012h11.124q.504 0 .828.324t.324.828z",
		"HOME": "M50.688-28.727v17.28q0 .936-.684 1.62t-1.62.684h-13.824v-13.824h-9.216v13.824h-13.824q-.936 0-1.62-.684t-.684-1.62v-17.28l.018-.108.018-.108 20.7-17.064 20.7 17.064q.036.072.036.216zm8.028-2.484l-2.232 2.664q-.288.324-.756.396h-.108q-.468 0-.756-.252l-24.912-20.772-24.912 20.772q-.432.288-.864.252-.468-.072-.756-.396l-2.232-2.664q-.288-.36-.252-.846t.396-.774l25.884-21.564q1.152-.936 2.736-.936t2.736.936l8.784 7.344v-7.02q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v14.688l7.884 6.552q.36.288.396.774t-.252.846z",
		"FILE_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08z",
		"CLOCK_O": "M32.256-44.855v16.128q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm14.976 12.672q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ROAD": "M39.996-28.583v-.144l-.864-11.52q-.036-.468-.396-.81t-.828-.342h-6.696q-.468 0-.828.342t-.396.81l-.864 11.52v.144q-.036.432.288.72t.756.288h8.784q.432 0 .756-.288t.288-.72zm27.324 16.812q0 2.628-1.656 2.628h-25.344q.468 0 .792-.342t.288-.81l-.72-9.216q-.036-.468-.396-.81t-.828-.342h-9.792q-.468 0-.828.342t-.396.81l-.72 9.216q-.036.468.288.81t.792.342h-25.344q-1.656 0-1.656-2.628 0-1.944.936-4.176l15.012-37.584q.288-.684.936-1.188t1.368-.504h12.204q-.468 0-.828.342t-.396.81l-.54 6.912q-.036.504.288.828t.792.324h5.976q.468 0 .792-.324t.288-.828l-.54-6.912q-.036-.468-.396-.81t-.828-.342h12.204q.72 0 1.368.504t.936 1.188l15.012 37.584q.936 2.232.936 4.176z",
		"DOWNLOAD": "M46.08-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 0q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-8.064v11.52q0 1.44-1.008 2.448t-2.448 1.008h-52.992q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h16.74l4.86 4.896q2.088 2.016 4.896 2.016t4.896-2.016l4.896-4.896h16.704q1.44 0 2.448 1.008t1.008 2.448zm-11.7-20.484q.612 1.476-.504 2.52l-16.128 16.128q-.648.684-1.62.684t-1.62-.684l-16.128-16.128q-1.116-1.044-.504-2.52.612-1.404 2.124-1.404h9.216v-16.128q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62v16.128h9.216q1.512 0 2.124 1.404z",
		"ARROW_CIRCLE_O_DOWN": "M40.32-31.031q0 .432-.36.864l-11.484 11.484q-.396.324-.828.324t-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-12.672q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v12.672h6.912q.504 0 .828.324t.324.828zm-12.672-20.736q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ARROW_CIRCLE_O_UP": "M40.248-32.903q-.288.72-1.08.72h-6.912v12.672q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-12.672h-6.912q-.504 0-.828-.324t-.324-.828q0-.432.36-.864l11.484-11.484q.396-.324.828-.324t.828.324l11.52 11.52q.54.576.252 1.26zm-12.6-18.864q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"INBOX": "M36.828-29.879h11.376l-.09-.288-.09-.288-7.632-17.856h-25.488l-7.632 17.856-.09.288-.09.288h11.376l3.42 6.912h11.52zm18.468 1.08v17.352q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-17.352q0-2.232.9-4.428l8.568-19.872q.36-.9 1.314-1.512t1.89-.612h29.952q.936 0 1.89.612t1.314 1.512l8.568 19.872q.9 2.196.9 4.428z",
		"PLAY_CIRCLE_O": "M42.624-32.183q0 1.332-1.152 1.98l-19.584 11.52q-.54.324-1.152.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-23.04q0-1.332 1.152-2.016 1.188-.648 2.304.036l19.584 11.52q1.152.648 1.152 1.98zm4.608 0q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ROTATE_RIGHT": "M55.296-55.223v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-1.512 0-2.124-1.44-.612-1.404.504-2.484l4.968-4.968q-5.328-4.932-12.564-4.932-3.744 0-7.146 1.458t-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458q4.284 0 8.1-1.872t6.444-5.292q.252-.36.828-.432.504 0 .9.324l4.932 4.968q.324.288.342.738t-.27.81q-3.924 4.752-9.504 7.362t-11.772 2.61q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728 2.196-10.728 5.904-8.82 8.82-5.904 10.728-2.196q5.292 0 10.242 1.998t8.802 5.634l4.68-4.644q1.044-1.116 2.52-.504 1.404.612 1.404 2.124z",
		"REFRESH": "M54.396-26.423q0 .18-.036.252-2.304 9.648-9.648 15.642t-17.208 5.994q-5.256 0-10.17-1.98t-8.766-5.652l-4.644 4.644q-.684.684-1.62.684t-1.62-.684-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684h16.128q.936 0 1.62.684t.684 1.62-.684 1.62l-4.932 4.932q2.556 2.376 5.796 3.672t6.732 1.296q4.824 0 9-2.34t6.696-6.444q.396-.612 1.908-4.212.288-.828 1.08-.828h6.912q.468 0 .81.342t.342.81zm.9-28.8v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62.684-1.62l4.968-4.968q-5.328-4.932-12.564-4.932-4.824 0-9 2.34t-6.696 6.444q-.396.612-1.908 4.212-.288.828-1.08.828h-7.164q-.468 0-.81-.342t-.342-.81v-.252q2.34-9.648 9.72-15.642t17.28-5.994q5.256 0 10.224 1.998t8.82 5.634l4.68-4.644q.684-.684 1.62-.684t1.62.684.684 1.62z",
		"LIST_ALT": "M13.824-21.815v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm41.472 18.432v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm4.608 25.344v-29.952q0-.468-.342-.81t-.81-.342h-52.992q-.468 0-.81.342t-.342.81v29.952q0 .468.342.81t.81.342h52.992q.468 0 .81-.342t.342-.81zm4.608-39.168v39.168q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h52.992q2.376 0 4.068 1.692t1.692 4.068z",
		"LOCK": "M11.52-36.791h18.432v-6.912q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v6.912zm29.952 3.456v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h1.152v-6.912q0-6.624 4.752-11.376t11.376-4.752 11.376 4.752 4.752 11.376v6.912h1.152q1.44 0 2.448 1.008t1.008 2.448z",
		"FLAG": "M11.52-55.223q0 2.592-2.304 3.96v45.576q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-45.576q-2.304-1.368-2.304-3.96 0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 .9-.45 1.386t-1.422.99q-7.74 4.176-13.284 4.176-2.196 0-4.446-.792t-3.906-1.728-4.158-1.728-5.13-.792q-6.912 0-16.704 5.256-.612.324-1.188.324-.936 0-1.62-.684t-.684-1.62v-26.712q0-1.152 1.116-1.98.756-.504 2.844-1.548 8.496-4.32 15.156-4.32 3.852 0 7.2 1.044t7.884 3.168q1.368.684 3.168.684 1.944 0 4.23-.756t3.96-1.692 3.168-1.692 1.962-.756q.936 0 1.62.684t.684 1.62z",
		"HEADPHONES": "M59.904-32.543q0 5.976-2.16 11.304l-.72 1.764-6.66 1.188q-.792 2.988-3.258 4.914t-5.634 1.926v1.152q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v1.152q2.556 0 4.68 1.278t3.348 3.438l2.448-.432q1.044-3.42 1.044-6.948 0-5.328-3.168-10.044t-8.514-7.524-11.358-2.808-11.358 2.808-8.514 7.524-3.168 10.044q0 3.528 1.044 6.948l2.448.432q1.224-2.16 3.348-3.438t4.68-1.278v-1.152q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-1.152q-3.168 0-5.634-1.926t-3.258-4.914l-6.66-1.188-.72-1.764q-2.16-5.328-2.16-11.304 0-5.436 2.412-10.476t6.444-8.73 9.576-5.886 11.52-2.196 11.52 2.196 9.576 5.886 6.444 8.73 2.412 10.476z",
		"VOLUME_OFF": "M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62z",
		"VOLUME_DOWN": "M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62zm13.824 19.584q0 2.736-1.53 5.094t-4.05 3.366q-.36.18-.9.18-.936 0-1.62-.666t-.684-1.638q0-.756.432-1.278t1.044-.9 1.224-.828 1.044-1.278.432-2.052-.432-2.052-1.044-1.278-1.224-.828-1.044-.9-.432-1.278q0-.972.684-1.638t1.62-.666q.54 0 .9.18 2.52.972 4.05 3.348t1.53 5.112z",
		"VOLUME_UP": "M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62zm13.824 19.584q0 2.736-1.53 5.094t-4.05 3.366q-.36.18-.9.18-.936 0-1.62-.666t-.684-1.638q0-.756.432-1.278t1.044-.9 1.224-.828 1.044-1.278.432-2.052-.432-2.052-1.044-1.278-1.224-.828-1.044-.9-.432-1.278q0-.972.684-1.638t1.62-.666q.54 0 .9.18 2.52.972 4.05 3.348t1.53 5.112zm9.216 0q0 5.508-3.06 10.17t-8.1 6.786q-.468.18-.9.18-.972 0-1.656-.684t-.684-1.62q0-1.404 1.404-2.124 2.016-1.044 2.736-1.584 2.664-1.944 4.158-4.878t1.494-6.246-1.494-6.246-4.158-4.878q-.72-.54-2.736-1.584-1.404-.72-1.404-2.124 0-.936.684-1.62t1.62-.684q.468 0 .936.18 5.04 2.124 8.1 6.786t3.06 10.17zm9.216 0q0 8.28-4.572 15.21t-12.168 10.206q-.468.18-.936.18-.936 0-1.62-.684t-.684-1.62q0-1.296 1.404-2.124.252-.144.81-.378t.81-.378q1.656-.9 2.952-1.836 4.428-3.276 6.912-8.172t2.484-10.404-2.484-10.404-6.912-8.172q-1.296-.936-2.952-1.836-.252-.144-.81-.378t-.81-.378q-1.404-.828-1.404-2.124 0-.936.684-1.62t1.62-.684q.468 0 .936.18 7.596 3.276 12.168 10.206t4.572 15.21z",
		"QRCODE": "M13.824-22.967v4.608h-4.608v-4.608h4.608zm0-27.648v4.608h-4.608v-4.608h4.608zm27.648 0v4.608h-4.608v-4.608h4.608zm-36.864 36.828h13.824v-13.788h-13.824v13.788zm0-27.612h13.824v-13.824h-13.824v13.824zm27.648 0h13.824v-13.824h-13.824v13.824zm-9.216 9.216v23.04h-23.04v-23.04h23.04zm18.432 18.432v4.608h-4.608v-4.608h4.608zm9.216 0v4.608h-4.608v-4.608h4.608zm0-18.432v13.824h-13.824v-4.608h-4.608v13.824h-4.608v-23.04h13.824v4.608h4.608v-4.608h4.608zm-27.648-27.648v23.04h-23.04v-23.04h23.04zm27.648 0v23.04h-23.04v-23.04h23.04z",
		"BARCODE": "M2.268-9.143h-2.268v-50.688h2.268v50.688zm2.268-.036h-1.152v-50.652h1.152v50.652zm3.384 0h-1.116v-50.652h1.116v50.652zm5.652 0h-1.116v-50.652h1.116v50.652zm5.652 0h-2.232v-50.652h2.232v50.652zm4.536 0h-1.116v-50.652h1.116v50.652zm2.268 0h-1.116v-50.652h1.116v50.652zm2.268 0h-1.116v-50.652h1.116v50.652zm5.652 0h-2.268v-50.652h2.268v50.652zm5.652 0h-2.268v-50.652h2.268v50.652zm4.536 0h-2.268v-50.652h2.268v50.652zm4.536 0h-2.268v-50.652h2.268v50.652zm3.384 0h-2.268v-50.652h2.268v50.652zm6.804 0h-3.384v-50.652h3.384v50.652zm2.268 0h-1.152v-50.652h1.152v50.652zm3.384.036h-2.268v-50.688h2.268v50.688z",
		"TAG": "M16.128-48.311q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm38.412 20.736q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-25.74-25.776q-1.368-1.332-2.322-3.636t-.954-4.212v-14.976q0-1.872 1.368-3.24t3.24-1.368h14.976q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276z",
		"TAGS": "M16.128-48.311q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm38.412 20.736q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-25.74-25.776q-1.368-1.332-2.322-3.636t-.954-4.212v-14.976q0-1.872 1.368-3.24t3.24-1.368h14.976q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276zm13.824 0q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.296 0-2.124-.504t-1.908-1.62l16.92-16.92q1.332-1.332 1.332-3.24 0-1.872-1.332-3.276l-25.74-25.704q-1.368-1.368-3.672-2.322t-4.212-.954h8.064q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276z",
		"BOOK": "M59.004-47.231q1.44 2.052.648 4.644l-9.9 32.616q-.684 2.304-2.754 3.87t-4.41 1.566h-33.228q-2.772 0-5.346-1.926t-3.582-4.734q-.864-2.412-.072-4.572 0-.144.108-.972t.144-1.332q.036-.288-.108-.774t-.108-.702q.072-.396.288-.756t.594-.846.594-.846q.828-1.368 1.62-3.294t1.08-3.294q.108-.36.018-1.08t-.018-1.008q.108-.396.612-1.008t.612-.828q.756-1.296 1.512-3.312t.9-3.24q.036-.324-.09-1.152t.018-1.008q.144-.468.792-1.098t.792-.81q.684-.936 1.53-3.042t.99-3.474q.036-.288-.108-.918t-.072-.954q.072-.288.324-.648t.648-.828.612-.756q.288-.432.594-1.098t.54-1.26.576-1.296.702-1.152.954-.846 1.296-.414 1.71.198l-.036.108q1.368-.324 1.836-.324h27.396q2.664 0 4.104 2.016t.648 4.68l-9.864 32.616q-1.296 4.284-2.574 5.526t-4.626 1.242h-31.284q-.972 0-1.368.54-.396.576-.036 1.548.864 2.52 5.184 2.52h33.228q1.044 0 2.016-.558t1.26-1.494l10.8-35.532q.252-.792.18-2.052 1.368.54 2.124 1.548zm-38.304.072q-.144.468.072.81t.72.342h21.888q.468 0 .918-.342t.594-.81l.756-2.304q.144-.468-.072-.81t-.72-.342h-21.888q-.468 0-.918.342t-.594.81zm-2.988 9.216q-.144.468.072.81t.72.342h21.888q.468 0 .918-.342t.594-.81l.756-2.304q.144-.468-.072-.81t-.72-.342h-21.888q-.468 0-.918.342t-.594.81z",
		"BOOKMARK": "M41.904-59.831q.828 0 1.584.324 1.188.468 1.89 1.476t.702 2.232v46.404q0 1.224-.702 2.232t-1.89 1.476q-.684.288-1.584.288-1.728 0-2.988-1.152l-15.876-15.264-15.876 15.264q-1.296 1.188-2.988 1.188-.828 0-1.584-.324-1.188-.468-1.89-1.476t-.702-2.232v-46.404q0-1.224.702-2.232t1.89-1.476q.756-.324 1.584-.324h37.728z",
		"PRINT": "M13.824-9.143h32.256v-9.216h-32.256v9.216zm0-23.04h32.256v-13.824h-5.76q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-23.04v23.04zm41.472 2.304q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608 0v14.976q0 .468-.342.81t-.81.342h-8.064v5.76q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-8.064q-.468 0-.81-.342t-.342-.81v-14.976q0-2.844 2.034-4.878t4.878-2.034h2.304v-19.584q0-1.44 1.008-2.448t2.448-1.008h24.192q1.44 0 3.168.72t2.736 1.728l5.472 5.472q1.008 1.008 1.728 2.736t.72 3.168v9.216h2.304q2.844 0 4.878 2.034t2.034 4.878z",
		"CAMERA": "M34.56-40.247q4.284 0 7.326 3.042t3.042 7.326-3.042 7.326-7.326 3.042-7.326-3.042-3.042-7.326 3.042-7.326 7.326-3.042zm25.344-14.976q3.816 0 6.516 2.7t2.7 6.516v32.256q0 3.816-2.7 6.516t-6.516 2.7h-50.688q-3.816 0-6.516-2.7t-2.7-6.516v-32.256q0-3.816 2.7-6.516t6.516-2.7h8.064l1.836-4.896q.684-1.764 2.502-3.042t3.726-1.278h18.432q1.908 0 3.726 1.278t2.502 3.042l1.836 4.896h8.064zm-25.344 41.472q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"FONT": "M26.1-44.315l-6.12 16.2q1.188 0 4.914.072t5.778.072q.684 0 2.052-.072-3.132-9.108-6.624-16.272zm-26.1 39.78l.072-2.844q.828-.252 2.016-.45t2.052-.378 1.782-.522 1.602-1.044 1.116-1.818l8.532-22.176 10.08-26.064h4.6080000000000005q.288.504.396.756l7.38 17.28q1.188 2.808 3.816 9.27t4.104 9.882q.54 1.224 2.088 5.202t2.592 6.066q.72 1.62 1.26 2.052.684.54 3.168 1.062t3.024.738q.216 1.368.216 2.052l-.018.468-.018.468q-2.268 0-6.84-.288t-6.876-.288q-2.736 0-7.74.252t-6.408.288q0-1.548.144-2.808l4.716-1.008q.036 0 .45-.09t.558-.126.522-.162.54-.234.396-.288.324-.396.09-.504q0-.576-1.116-3.474t-2.592-6.39-1.512-3.6l-16.2-.072q-.936 2.088-2.754 7.038t-1.818 5.85q0 .792.504 1.35t1.566.882 1.746.486 2.052.306 1.476.144q.036.684.036 2.088 0 .324-.072.972-2.088 0-6.282-.36t-6.282-.36q-.288 0-.954.144t-.774.144q-2.88.504-6.768.504z",
		"BOLD": "M19.98-9.683q2.664 1.152 5.04 1.152 13.536 0 13.536-12.06 0-4.104-1.476-6.48-.972-1.584-2.214-2.664t-2.43-1.674-2.898-.9-3.024-.378-3.402-.072q-2.628 0-3.636.36 0 1.908-.018 5.724t-.018 5.688q0 .288-.036 2.43t-.018 3.474.162 3.006.432 2.394zm-.504-26.856q1.512.252 3.924.252 2.952 0 5.148-.468t3.96-1.602 2.682-3.222.918-5.112q0-2.52-1.044-4.41t-2.844-2.952-3.888-1.566-4.464-.504q-1.8 0-4.68.468 0 1.8.144 5.436t.144 5.472q0 .972-.018 2.88t-.018 2.844q0 1.656.036 2.484zm-19.476 32.004l.072-3.384q.54-.144 3.06-.576t3.816-.972q.252-.432.45-.972t.306-1.206.198-1.17.108-1.35.018-1.224v-2.358q0-35.352-.792-36.9-.144-.288-.792-.522t-1.602-.396-1.782-.252-1.746-.162-1.098-.108l-.144-2.988q3.528-.072 12.24-.414t13.428-.342q.828 0 2.466.018t2.43.018q2.52 0 4.914.468t4.626 1.512 3.888 2.556 2.664 3.762 1.008 4.95q0 1.872-.594 3.438t-1.404 2.592-2.322 2.07-2.628 1.62-3.024 1.44q5.544 1.26 9.234 4.824t3.69 8.928q0 3.6-1.26 6.462t-3.366 4.698-4.968 3.078-5.886 1.746-6.336.504q-1.584 0-4.752-.108t-4.752-.108q-3.816 0-11.052.396t-8.316.432z",
		"ITALIC": "M0-4.607l.612-3.06q.216-.072 2.934-.774t4.014-1.35q1.008-1.26 1.476-3.636.036-.252 2.232-10.404t4.104-19.566 1.872-10.674v-.9q-.864-.468-1.962-.666t-2.502-.288-2.088-.198l.684-3.708q1.188.072 4.32.234t5.382.252 4.338.09q1.728 0 3.546-.09t4.356-.252 3.546-.234q-.18 1.404-.684 3.204-1.08.36-3.654 1.026t-3.906 1.206q-.288.684-.504 1.53t-.324 1.44-.27 1.638-.234 1.512q-.972 5.328-3.15 15.102t-2.79 12.798q-.072.324-.468 2.088t-.72 3.24-.576 3.006-.216 2.07l.036.648q.612.144 6.66 1.116-.108 1.584-.576 3.564-.396 0-1.17.054t-1.17.054q-1.044 0-3.132-.36t-3.096-.36q-4.968-.072-7.416-.072-1.836 0-5.148.324t-4.356.396z",
		"TEXT_HEIGHT": "M62.784-13.751q1.188 0 1.512.666t-.396 1.602l-4.536 5.832q-.72.936-1.764.936t-1.764-.936l-4.536-5.832q-.72-.936-.396-1.602t1.512-.666h2.88v-36.864h-2.88q-1.188 0-1.512-.666t.396-1.602l4.536-5.832q.72-.936 1.764-.936t1.764.936l4.536 5.832q.72.936.396 1.602t-1.512.666h-2.88v36.864h2.88zm-59.868-46.044l1.944.972q.432.18 7.596.18 1.584 0 4.752-.072t4.752-.072q1.296 0 3.87.018t3.87.018h10.548q.216 0 .756.018t.738 0 .576-.108.63-.324.54-.63l1.512-.036.504.018.504.018q.072 4.032.072 12.096 0 2.88-.18 3.924-1.404.504-2.448.648-.9-1.584-1.944-4.608-.108-.324-.396-1.728t-.522-2.646-.27-1.278q-.216-.288-.432-.45t-.558-.216-.468-.09-.648-.018-.594.018q-.612 0-2.394-.018t-2.682-.018-2.304.072-2.556.216q-.324 2.916-.288 4.896 0 3.384.072 13.968t.072 16.38q0 .576-.09 2.574t0 3.294.45 2.484q1.44.756 4.464 1.53t4.32 1.35q.18 1.44.18 1.8 0 .504-.108 1.044l-1.224.036q-2.736.072-7.848-.288t-7.452-.36q-1.8 0-5.436.324t-5.472.324l-.108-1.872v-.324q.612-.972 2.214-1.548t3.546-1.044 2.808-.972q.684-1.512.684-13.788 0-3.636-.108-10.908t-.108-10.908v-4.212q0-.072.018-.558t.018-.9-.036-.918-.108-.864-.18-.504q-.396-.432-5.832-.432-1.188 0-3.348.432t-2.88.936q-.684.468-1.224 2.61t-1.134 3.996-1.53 1.926q-1.512-.936-2.016-1.584v-13.788z",
		"TEXT_WIDTH": "M2.916-59.795l1.944.972q.432.18 7.596.18 1.584 0 4.752-.072t4.752-.072q2.52 0 8.874-.036t10.962-.018 8.892.162q1.188.036 2.016-1.116l1.512-.036.504.018.504.018q.072 4.032.072 12.096 0 2.88-.18 3.924-1.404.504-2.448.648-.9-1.584-1.944-4.608-.108-.324-.396-1.71t-.54-2.646-.252-1.296q-.36-.468-.972-.684-.18-.072-2.376-.072-1.08 0-3.348-.036t-3.708-.036-3.384.072-3.456.252q-.324 2.916-.288 4.896l.036 5.472v-1.872q0 1.98.036 5.544t.054 6.48.018 5.508q0 .576-.09 2.574t0 3.294.45 2.484q1.44.756 4.464 1.53t4.32 1.35q.18 1.44.18 1.8 0 .504-.108 1.044l-1.224.036q-2.736.072-7.848-.288t-7.452-.36q-1.8 0-5.436.324t-5.472.324l-.108-1.872v-.324q.612-.972 2.214-1.548t3.546-1.044 2.808-.972q.252-.576.414-2.664t.216-5.238.054-5.58-.018-5.526-.018-3.204q0-.252-.09-.774t-.09-.81q0-.252.018-1.584t.036-2.628 0-2.754-.108-2.43-.234-1.152q-.396-.432-5.832-.432-1.476 0-5.868.486t-4.968.882q-.684.432-1.224 2.574t-1.134 4.014-1.53 1.944q-1.512-.936-2.016-1.584v-13.788zm44.244 46.152q.432 0 1.512.702t2.07 1.494 2.142 1.764 1.296 1.08q.936.756.936 1.764t-.936 1.764q-.144.108-1.296 1.08t-2.142 1.764-2.07 1.494-1.512.702q-.468 0-.738-.378t-.36-1.026-.09-1.206.054-1.188.054-.702h-36.864q0 .072.054.702t.054 1.188-.09 1.206-.36 1.026-.738.378q-.432 0-1.512-.702t-2.07-1.494-2.142-1.764-1.296-1.08q-.936-.756-.936-1.764t.936-1.764q.144-.108 1.296-1.08t2.142-1.764 2.07-1.494 1.512-.702q.468 0 .738.378t.36 1.026.09 1.206-.054 1.188-.054.702h36.864q0-.072-.054-.702t-.054-1.188.09-1.206.36-1.026.738-.378z",
		"ALIGN_LEFT": "M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62zm9.216-13.824v4.608q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-41.472q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z",
		"ALIGN_CENTER": "M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h32.256q.936 0 1.62.684t.684 1.62zm9.216-13.824v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h23.04q.936 0 1.62.684t.684 1.62z",
		"ALIGN_RIGHT": "M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-41.472q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z",
		"ALIGN_JUSTIFY": "M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62z",
		"LIST": "M9.216-17.207v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm55.296 27.648v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm-55.296-41.472v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm55.296 27.648v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81z",
		"OUTDENT": "M13.824-44.855v20.736q0 .468-.342.81t-.81.342q-.504 0-.828-.324l-10.368-10.368q-.324-.324-.324-.828t.324-.828l10.368-10.368q.324-.324.828-.324.468 0 .81.342t.342.81zm50.688 27.648v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81z",
		"INDENT": "M12.672-34.487q0 .504-.324.828l-10.368 10.368q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-20.736q0-.468.342-.81t.81-.342q.504 0 .828.324l10.368 10.368q.324.324.324.828zm51.84 17.28v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81z",
		"VIDEO_CAMERA": "M64.512-51.767v39.168q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-14.508-14.508v5.976q0 4.284-3.042 7.326t-7.326 3.042h-25.344q-4.284 0-7.326-3.042t-3.042-7.326v-25.344q0-4.284 3.042-7.326t7.326-3.042h25.344q4.284 0 7.326 3.042t3.042 7.326v5.94l14.508-14.472q.648-.684 1.62-.684.432 0 .9.18 1.404.612 1.404 2.124z",
		"PICTURE_O": "M23.04-43.703q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm36.864 13.824v16.128h-50.688v-6.912l11.52-11.52 5.76 5.76 18.432-18.432zm3.456-25.344h-57.6q-.468 0-.81.342t-.342.81v43.776q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81v-43.776q0-.468-.342-.81t-.81-.342zm5.76 1.152v43.776q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z",
		"PENCIL": "M13.068-9.143l3.276-3.276-8.46-8.46-3.276 3.276v3.852h4.608v4.608h3.852zm18.828-33.408q0-.792-.792-.792-.36 0-.612.252l-19.512 19.512q-.252.252-.252.612 0 .792.792.792.36 0 .612-.252l19.512-19.512q.252-.252.252-.612zm-1.944-6.912l14.976 14.976-29.952 29.952h-14.976v-14.976zm24.588 3.456q0 1.908-1.332 3.24l-5.976 5.976-14.976-14.976 5.976-5.94q1.296-1.368 3.24-1.368 1.908 0 3.276 1.368l8.46 8.424q1.332 1.404 1.332 3.276z",
		"MAP_MARKER": "M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z",
		"ADJUST": "M27.648-12.599v-39.168q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm27.648-19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"TINT": "M18.432-22.967q0-1.296-.72-2.484-.036-.036-.558-.81t-.918-1.368-.9-1.584-.756-1.818q-.144-.576-.756-.576t-.756.576q-.252.828-.756 1.818t-.9 1.584-.918 1.368-.558.81q-.72 1.188-.72 2.484 0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm18.432-4.608q0 7.632-5.4 13.032t-13.032 5.4-13.032-5.4-5.4-13.032q0-5.22 2.916-9.9.216-.324 2.25-3.258t3.636-5.436 3.582-6.408 2.988-7.254q.324-1.08 1.224-1.692t1.836-.612 1.854.612 1.206 1.692q1.008 3.348 2.988 7.254t3.582 6.408 3.636 5.436 2.25 3.258q2.916 4.572 2.916 9.9z",
		"PENCIL_SQUARE_O": "M31.968-21.815l4.176-4.176-5.472-5.472-4.176 4.176v2.016h3.456v3.456h2.016zm15.84-25.92q-.576-.576-1.188.036l-12.6 12.6q-.612.612-.036 1.188t1.188-.036l12.6-12.6q.612-.612.036-1.188zm2.88 21.384v6.84q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q2.268 0 4.212.9.54.252.648.828.108.612-.324 1.044l-1.764 1.764q-.504.504-1.152.288-.828-.216-1.62-.216h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-4.536q0-.468.324-.792l2.304-2.304q.54-.54 1.26-.252t.72 1.044zm-3.456-26.568l10.368 10.368-24.192 24.192h-10.368v-10.368zm15.984 4.752l-3.312 3.312-10.368-10.368 3.312-3.312q1.008-1.008 2.448-1.008t2.448 1.008l5.472 5.472q1.008 1.008 1.008 2.448t-1.008 2.448z",
		"SHARE_SQUARE_O": "M50.688-28.835v9.324q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h9.18q.468 0 .81.342t.342.81q0 .972-.936 1.152-2.772.936-4.788 2.16-.36.144-.576.144h-4.032q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-7.704q0-.684.648-1.044 1.008-.468 1.944-1.332.576-.576 1.26-.288.756.324.756 1.044zm8.532-17.856l-13.824 13.824q-.648.684-1.62.684-.432 0-.9-.18-1.404-.612-1.404-2.124v-6.912h-5.76q-11.628 0-15.768 4.716-4.284 4.932-2.664 17.028.108.828-.72 1.224-.288.072-.432.072-.576 0-.936-.468-.36-.504-.756-1.116t-1.422-2.466-1.782-3.582-1.386-4.104-.63-4.392q0-1.764.126-3.276t.504-3.24 1.008-3.168 1.692-2.934 2.466-2.664 3.402-2.214 4.482-1.746 5.742-1.098 7.074-.396h5.76v-6.912q0-1.512 1.404-2.124.468-.18.9-.18.936 0 1.62.684l13.824 13.824q.684.684.684 1.62t-.684 1.62z",
		"CHECK_SQUARE_O": "M50.688-30.959v11.448q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q2.268 0 4.212.9.54.252.648.828.108.612-.324 1.044l-1.764 1.764q-.36.36-.828.36-.108 0-.324-.072-.828-.216-1.62-.216h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-9.144q0-.468.324-.792l2.304-2.304q.36-.36.828-.36.216 0 .432.108.72.288.72 1.044zm8.316-17.604l-29.304 29.304q-.864.864-2.052.864t-2.052-.864l-15.48-15.48q-.864-.864-.864-2.052t.864-2.052l3.96-3.96q.864-.864 2.052-.864t2.052.864l9.468 9.468 23.292-23.292q.864-.864 2.052-.864t2.052.864l3.96 3.96q.864.864.864 2.052t-.864 2.052z",
		"ARROWS": "M64.512-32.183q0 .936-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684-.684-1.62v-4.608h-13.824v13.824h4.608q.936 0 1.62.684t.684 1.62-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62 1.62-.684h4.608v-13.824h-13.824v4.608q0 .936-.684 1.62t-1.62.684-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684.684 1.62v4.608h13.824v-13.824h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684l9.216 9.216q.684.684.684 1.62t-.684 1.62-1.62.684h-4.608v13.824h13.824v-4.608q0-.936.684-1.62t1.62-.684 1.62.684l9.216 9.216q.684.684.684 1.62z",
		"STEP_BACKWARD": "M35.244-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v24.408q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v24.408q.144-.396.468-.684z",
		"FAST_BACKWARD": "M62.892-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v25.56q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v24.408q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v24.408q.144-.396.468-.684l25.56-25.56q.684-.684 1.152-.468t.468 1.152v25.56q.144-.396.468-.684z",
		"BACKWARD": "M58.284-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.288-.324-.468-.684v25.56q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.684-.684-.684-1.62t.684-1.62l25.56-25.56q.684-.684 1.152-.468t.468 1.152v25.56q.18-.396.468-.684z",
		"PLAY": "M49.824-31.067l-47.808 26.568q-.828.468-1.422.108t-.594-1.296v-52.992q0-.936.594-1.296t1.422.108l47.808 26.568q.828.468.828 1.116t-.828 1.116z",
		"PAUSE": "M55.296-57.527v50.688q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h18.432q.936 0 1.62.684t.684 1.62zm-32.256 0v50.688q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h18.432q.936 0 1.62.684t.684 1.62z",
		"STOP": "M55.296-57.527v50.688q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z",
		"FORWARD": "M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-25.56q0-.936.468-1.152t1.152.468l25.56 25.56q.684.684.684 1.62t-.684 1.62l-25.56 25.56q-.684.684-1.152.468t-.468-1.152v-25.56q-.18.36-.468.684z",
		"FAST_FORWARD": "M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-25.56q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-24.408q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v50.688q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-24.408q-.18.36-.468.684l-25.56 25.56q-.684.684-1.152.468t-.468-1.152v-25.56q-.18.36-.468.684z",
		"STEP_FORWARD": "M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-24.408q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v50.688q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-24.408q-.18.36-.468.684z",
		"EJECT": "M.504-29.195l25.56-25.56q.684-.684 1.62-.684t1.62.684l25.56 25.56q.684.684.468 1.152t-1.152.468h-52.992q-.936 0-1.152-.468t.468-1.152zm52.524 20.052h-50.688q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684z",
		"CHEVRON_LEFT": "M42.156-53.603l-19.116 19.116 19.116 19.116q.684.684.684 1.62t-.684 1.62l-5.976 5.976q-.684.684-1.62.684t-1.62-.684l-26.712-26.712q-.684-.684-.684-1.62t.684-1.62l26.712-26.712q.684-.684 1.62-.684t1.62.684l5.976 5.976q.684.684.684 1.62t-.684 1.62z",
		"CHEVRON_RIGHT": "M39.852-32.867l-26.712 26.712q-.684.684-1.62.684t-1.62-.684l-5.976-5.976q-.684-.684-.684-1.62t.684-1.62l19.116-19.116-19.116-19.116q-.684-.684-.684-1.62t.684-1.62l5.976-5.976q.684-.684 1.62-.684t1.62.684l26.712 26.712q.684.684.684 1.62t-.684 1.62z",
		"PLUS_CIRCLE": "M43.776-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-9.216v-9.216q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v9.216h-9.216q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h9.216v9.216q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-9.216h9.216q.936 0 1.62-.684t.684-1.62zm11.52-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"MINUS_CIRCLE": "M43.776-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm11.52-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"TIMES_CIRCLE": "M41.364-24.047q0-.936-.684-1.62l-6.516-6.516 6.516-6.516q.684-.684.684-1.62 0-.972-.684-1.656l-3.24-3.24q-.684-.684-1.656-.684-.936 0-1.62.684l-6.516 6.516-6.516-6.516q-.684-.684-1.62-.684-.972 0-1.656.684l-3.24 3.24q-.684.684-.684 1.656 0 .936.684 1.62l6.516 6.516-6.516 6.516q-.684.684-.684 1.62 0 .972.684 1.656l3.24 3.24q.684.684 1.656.684.936 0 1.62-.684l6.516-6.516 6.516 6.516q.684.684 1.62.684.972 0 1.656-.684l3.24-3.24q.684-.684.684-1.656zm13.932-8.136q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CHECK_CIRCLE": "M46.224-38.015q0-1.008-.648-1.656l-3.276-3.24q-.684-.684-1.62-.684t-1.62.684l-14.688 14.652-8.136-8.136q-.684-.684-1.62-.684t-1.62.684l-3.276 3.24q-.648.648-.648 1.656 0 .972.648 1.62l13.032 13.032q.684.684 1.62.684.972 0 1.656-.684l19.548-19.548q.648-.648.648-1.62zm9.072 5.832q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"QUESTION_CIRCLE": "M32.256-14.903v-6.912q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828zm9.216-24.192q0-3.168-1.998-5.868t-4.986-4.176-6.12-1.476q-8.748 0-13.356 7.668-.54.864.288 1.512l4.752 3.6q.252.216.684.216.576 0 .9-.432 1.908-2.448 3.096-3.312 1.224-.864 3.096-.864 1.728 0 3.078.936t1.35 2.124q0 1.368-.72 2.196t-2.448 1.62q-2.268 1.008-4.158 3.114t-1.89 4.518v1.296q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828q0-.684.774-1.782t1.962-1.782q1.152-.648 1.764-1.026t1.656-1.26 1.602-1.728 1.008-2.178.45-2.916zm13.824 6.912q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"INFO_CIRCLE": "M36.864-14.903v-5.76q0-.504-.324-.828t-.828-.324h-3.456v-18.432q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h3.456v11.52h-3.456q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h16.128q.504 0 .828-.324t.324-.828zm-4.608-32.256v-5.76q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828zm23.04 14.976q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CROSSHAIRS": "M43.092-27.575h-3.924q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h3.924q-1.152-3.888-4.05-6.786t-6.786-4.05v3.924q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-3.924q-3.888 1.152-6.786 4.05t-4.05 6.786h3.924q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-3.924q1.152 3.888 4.05 6.786t6.786 4.05v-3.924q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v3.924q3.888-1.152 6.786-4.05t4.05-6.786zm12.204-6.912v4.608q0 .936-.684 1.62t-1.62.684h-5.148q-1.332 5.796-5.562 10.026t-10.026 5.562v5.148q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-5.148q-5.796-1.332-10.026-5.562t-5.562-10.026h-5.148q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h5.148q1.332-5.796 5.562-10.026t10.026-5.562v-5.148q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v5.148q5.796 1.332 10.026 5.562t5.562 10.026h5.148q.936 0 1.62.684t.684 1.62z",
		"TIMES_CIRCLE_O": "M39.492-25.595l-5.256 5.256q-.36.36-.828.36t-.828-.36l-4.932-4.932-4.932 4.932q-.36.36-.828.36t-.828-.36l-5.256-5.256q-.36-.36-.36-.828t.36-.828l4.932-4.932-4.932-4.932q-.36-.36-.36-.828t.36-.828l5.256-5.256q.36-.36.828-.36t.828.36l4.932 4.932 4.932-4.932q.36-.36.828-.36t.828.36l5.256 5.256q.36.36.36.828t-.36.828l-4.932 4.932 4.932 4.932q.36.36.36.828t-.36.828zm7.74-6.588q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CHECK_CIRCLE_O": "M42.156-35.171l-15.192 15.192q-.684.684-1.62.684t-1.62-.684l-10.584-10.584q-.684-.684-.684-1.62t.684-1.62l3.672-3.672q.684-.684 1.62-.684t1.62.684l5.292 5.292 9.9-9.9q.684-.684 1.62-.684t1.62.684l3.672 3.672q.684.684.684 1.62t-.684 1.62zm5.076 2.988q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"BAN": "M47.232-32.291q0-5.796-3.132-10.62l-27.144 27.108q4.932 3.204 10.692 3.204 3.996 0 7.614-1.566t6.246-4.194 4.176-6.282 1.548-7.65zm-35.964 10.764l27.18-27.144q-4.86-3.276-10.8-3.276-5.328 0-9.828 2.628t-7.128 7.164-2.628 9.864q0 5.832 3.204 10.764zm44.028-10.764q0 5.652-2.196 10.8t-5.886 8.856-8.82 5.904-10.746 2.196-10.746-2.196-8.82-5.904-5.886-8.856-2.196-10.8 2.196-10.782 5.886-8.838 8.82-5.904 10.746-2.196 10.746 2.196 8.82 5.904 5.886 8.838 2.196 10.782z",
		"ARROW_LEFT": "M55.296-32.183v4.608q0 1.908-1.17 3.258t-3.042 1.35h-25.344l10.548 10.584q1.368 1.296 1.368 3.24t-1.368 3.24l-2.7 2.736q-1.332 1.332-3.24 1.332-1.872 0-3.276-1.332l-23.436-23.472q-1.332-1.332-1.332-3.24 0-1.872 1.332-3.276l23.436-23.4q1.368-1.368 3.276-1.368 1.872 0 3.24 1.368l2.7 2.664q1.368 1.368 1.368 3.276t-1.368 3.276l-10.548 10.548h25.344q1.872 0 3.042 1.35t1.17 3.258z",
		"ARROW_RIGHT": "M52.992-29.879q0 1.944-1.332 3.276l-23.436 23.436q-1.404 1.332-3.276 1.332-1.836 0-3.24-1.332l-2.7-2.7q-1.368-1.368-1.368-3.276t1.368-3.276l10.548-10.548h-25.344q-1.872 0-3.042-1.35t-1.17-3.258v-4.608q0-1.908 1.17-3.258t3.042-1.35h25.344l-10.548-10.584q-1.368-1.296-1.368-3.24t1.368-3.24l2.7-2.7q1.368-1.368 3.24-1.368 1.908 0 3.276 1.368l23.436 23.436q1.332 1.26 1.332 3.24z",
		"ARROW_UP": "M57.996-29.483q0 1.836-1.332 3.24l-2.7 2.7q-1.368 1.368-3.276 1.368-1.944 0-3.24-1.368l-10.584-10.548v25.344q0 1.872-1.35 3.042t-3.258 1.17h-4.608q-1.908 0-3.258-1.17t-1.35-3.042v-25.344l-10.584 10.548q-1.296 1.368-3.24 1.368t-3.24-1.368l-2.7-2.7q-1.368-1.368-1.368-3.24 0-1.908 1.368-3.276l23.436-23.436q1.26-1.332 3.24-1.332 1.944 0 3.276 1.332l23.436 23.436q1.332 1.404 1.332 3.276z",
		"ARROW_DOWN": "M57.996-34.487q0 1.908-1.332 3.24l-23.436 23.472q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-23.436-23.472q-1.368-1.296-1.368-3.24 0-1.908 1.368-3.276l2.664-2.7q1.404-1.332 3.276-1.332 1.908 0 3.24 1.332l10.584 10.584v-25.344q0-1.872 1.368-3.24t3.24-1.368h4.608q1.872 0 3.24 1.368t1.368 3.24v25.344l10.584-10.584q1.332-1.332 3.24-1.332 1.872 0 3.276 1.332l2.7 2.7q1.332 1.404 1.332 3.276z",
		"SHARE": "M64.512-41.399q0 .936-.684 1.62l-18.432 18.432q-.684.684-1.62.684t-1.62-.684-.684-1.62v-9.216h-8.064q-3.528 0-6.318.216t-5.544.774-4.788 1.53-3.798 2.502-2.88 3.636-1.746 4.986-.63 6.516q0 1.98.18 4.428 0 .216.09.846t.09.954q0 .54-.306.9t-.846.36q-.576 0-1.008-.612-.252-.324-.468-.792t-.486-1.08-.378-.864q-4.572-10.26-4.572-16.236 0-7.164 1.908-11.988 5.832-14.508 31.5-14.508h8.064v-9.216q0-.936.684-1.62t1.62-.684 1.62.684l18.432 18.432q.684.684.684 1.62z",
		"EXPAND": "M27.18-26.423q0 .468-.36.828l-11.952 11.952 5.184 5.184q.684.684.684 1.62t-.684 1.62-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684 1.62.684l5.184 5.184 11.952-11.952q.36-.36.828-.36t.828.36l4.104 4.104q.36.36.36.828zm28.116-31.104v16.128q0 .936-.684 1.62t-1.62.684-1.62-.684l-5.184-5.184-11.952 11.952q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l11.952-11.952-5.184-5.184q-.684-.684-.684-1.62t.684-1.62 1.62-.684h16.128q.936 0 1.62.684t.684 1.62z",
		"COMPRESS": "M27.648-29.879v16.128q0 .936-.684 1.62t-1.62.684-1.62-.684l-5.184-5.184-11.952 11.952q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l11.952-11.952-5.184-5.184q-.684-.684-.684-1.62t.684-1.62 1.62-.684h16.128q.936 0 1.62.684t.684 1.62zm27.18-24.192q0 .468-.36.828l-11.952 11.952 5.184 5.184q.684.684.684 1.62t-.684 1.62-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684 1.62.684l5.184 5.184 11.952-11.952q.36-.36.828-.36t.828.36l4.104 4.104q.36.36.36.828z",
		"PLUS": "M50.688-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-14.976v14.976q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h14.976v-14.976q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448v14.976h14.976q1.44 0 2.448 1.008t1.008 2.448z",
		"MINUS": "M50.688-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-43.776q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h43.776q1.44 0 2.448 1.008t1.008 2.448z",
		"ASTERISK": "M53.352-26.639q1.656.936 2.142 2.79t-.45 3.51l-2.304 3.96q-.936 1.656-2.79 2.142t-3.51-.45l-9.576-5.508v11.052q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-11.052l-9.576 5.508q-1.656.936-3.51.45t-2.79-2.142l-2.304-3.96q-.936-1.656-.45-3.51t2.142-2.79l9.576-5.544-9.576-5.544q-1.656-.936-2.142-2.79t.45-3.51l2.304-3.96q.936-1.656 2.79-2.142t3.51.45l9.576 5.508v-11.052q0-1.872 1.368-3.24t3.24-1.368h4.608q1.872 0 3.24 1.368t1.368 3.24v11.052l9.576-5.508q1.656-.936 3.51-.45t2.79 2.142l2.304 3.96q.936 1.656.45 3.51t-2.142 2.79l-9.576 5.544z",
		"EXCLAMATION_CIRCLE": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm4.608 44.892v-6.84q0-.504-.324-.846t-.792-.342h-6.912q-.468 0-.828.36t-.36.828v6.84q0 .468.36.828t.828.36h6.912q.468 0 .792-.342t.324-.846zm-.072-12.384l.648-22.356q0-.432-.36-.648-.36-.288-.864-.288h-7.92q-.504 0-.864.288-.36.216-.36.648l.612 22.356q0 .36.36.63t.864.27h6.66q.504 0 .846-.27t.378-.63z",
		"GIFT": "M33.408-15.623v-25.775999999999996h-11.52v25.775999999999996q0 .9.648 1.386t1.656.486h6.912q1.008 0 1.656-.486t.648-1.386zm-16.416-30.384h7.02l-4.536-5.796q-.936-1.116-2.484-1.116-1.44 0-2.448 1.008t-1.008 2.448 1.008 2.448 2.448 1.008zm24.768-3.456q0-1.44-1.008-2.448t-2.448-1.008q-1.548 0-2.484 1.116l-4.5 5.796h6.984q1.44 0 2.448-1.008t1.008-2.448zm13.536 9.216v11.52q0 .504-.324.828t-.828.324h-3.456v14.976q0 1.44-1.008 2.448t-2.448 1.008h-39.168q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-3.456q-.504 0-.828-.324t-.324-.828v-11.52q0-.504.324-.828t.828-.324h15.84q-3.348 0-5.706-2.358t-2.358-5.706 2.358-5.706 5.706-2.358q3.852 0 6.048 2.772l4.608 5.94 4.608-5.94q2.196-2.772 6.048-2.772 3.348 0 5.706 2.358t2.358 5.706-2.358 5.706-5.706 2.358h15.84q.504 0 .828.324t.324.828z",
		"LEAF": "M46.08-39.095q0-.936-.684-1.62t-1.62-.684q-6.192 0-11.448 1.782t-9.342 4.824-8.478 7.902q-.684.756-.684 1.62 0 .936.684 1.62t1.62.684q.864 0 1.62-.684.972-.864 2.664-2.556t2.412-2.376q4.932-4.464 9.666-6.336t11.286-1.872q.936 0 1.62-.684t.684-1.62zm18.432-7.128q0 3.42-.72 6.948-1.656 8.064-6.642 13.788t-12.87 9.648q-7.704 3.888-15.768 3.888-5.328 0-10.296-1.692-.54-.18-3.168-1.512t-3.456-1.332q-.576 0-1.422 1.152t-1.62 2.52-1.89 2.52-2.16 1.152q-1.08 0-1.836-.396t-1.116-.864-.972-1.512l-.216-.396-.198-.36-.108-.342-.054-.486q0-1.26 1.116-2.646t2.448-2.358 2.448-2.016 1.116-1.728q0-.144-.504-1.368t-.576-1.584q-.324-1.836-.324-3.744 0-4.14 1.566-7.92t4.284-6.642 6.138-5.004 7.344-3.438q1.98-.648 5.22-.918t6.462-.324 6.426-.216 5.886-.864 4.086-2.034l1.062-1.062 1.062-1.008.972-.72 1.314-.576 1.566-.162q1.404 0 2.538 1.656t1.71 4.032.864 4.464.288 3.456z",
		"FIRE": "M50.688-3.383v2.304q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm-9.216-38.016q0 2.808-.882 5.184t-2.304 4.05-3.15 3.168-3.456 2.79-3.15 2.592-2.304 2.934-.882 3.474q0 3.456 2.412 8.064l-.144-.036.036.036q-3.24-1.476-5.76-2.988t-4.986-3.6-4.086-4.41-2.61-5.418-.99-6.624q0-2.808.882-5.184t2.304-4.05 3.15-3.168 3.456-2.79 3.15-2.592 2.304-2.934.882-3.474q0-3.384-2.376-8.064l.108.036-.036-.036q3.24 1.476 5.76 2.988t4.986 3.6 4.086 4.41 2.61 5.418.99 6.624z",
		"EYE": "M59.904-29.879q-5.472-8.496-13.716-12.708 2.196 3.744 2.196 8.1 0 6.66-4.734 11.394t-11.394 4.734-11.394-4.734-4.734-11.394q0-4.356 2.196-8.1-8.244 4.212-13.716 12.708 4.788 7.38 12.006 11.754t15.642 4.374 15.642-4.374 12.006-11.754zm-25.92-13.824q0-.72-.504-1.224t-1.224-.504q-4.5 0-7.722 3.222t-3.222 7.722q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-3.096 2.196-5.292t5.292-2.196q.72 0 1.224-.504t.504-1.224zm30.528 13.824q0 1.224-.72 2.484-5.04 8.28-13.554 13.266t-17.982 4.986-17.982-5.004-13.554-13.248q-.72-1.26-.72-2.484t.72-2.484q5.04-8.244 13.554-13.248t17.982-5.004 17.982 5.004 13.554 13.248q.72 1.26.72 2.484z",
		"EYE_SLASH": "M19.98-16.379l2.808-5.076q-3.132-2.268-4.896-5.724t-1.764-7.308q0-4.356 2.196-8.1-8.244 4.212-13.716 12.708 6.012 9.288 15.372 13.5zm14.004-27.324q0-.72-.504-1.224t-1.224-.504q-4.5 0-7.722 3.222t-3.222 7.722q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-3.096 2.196-5.292t5.292-2.196q.72 0 1.224-.504t.504-1.224zm13.068-6.876q0 .252-.036.324-3.78 6.768-11.34 20.376t-11.376 20.412l-1.764 3.204q-.36.576-1.008.576-.432 0-4.824-2.52-.576-.36-.576-1.008 0-.432 1.584-3.132-5.148-2.34-9.486-6.228t-7.506-8.82q-.72-1.116-.72-2.484t.72-2.484q5.508-8.46 13.68-13.356t17.856-4.896q3.204 0 6.48.612l1.944-3.492q.36-.576 1.008-.576.18 0 .648.216t1.116.558 1.188.666 1.134.666.702.414q.576.36.576.972zm1.332 16.092q0 5.004-2.844 9.126t-7.524 5.922l10.08-18.072q.288 1.62.288 3.024zm16.128 4.608q0 1.26-.72 2.484-1.404 2.304-3.924 5.22-5.4 6.192-12.51 9.612t-15.102 3.42l2.664-4.752q7.632-.648 14.13-4.932t10.854-11.052q-4.14-6.444-10.152-10.584l2.268-4.032q3.42 2.304 6.57 5.508t5.202 6.624q.72 1.224.72 2.484z",
		"WARNING": "M36.864-14.939v-6.84q0-.504-.342-.846t-.81-.342h-6.912q-.468 0-.81.342t-.342.846v6.84q0 .504.342.846t.81.342h6.912q.468 0 .81-.342t.342-.846zm-.072-13.464l.648-16.524q0-.432-.36-.684-.468-.396-.864-.396h-7.92q-.396 0-.864.396-.36.252-.36.756l.612 16.452q0 .36.36.594t.864.234h6.66q.504 0 .846-.234t.378-.594zm-.504-33.624l27.648 50.688q1.26 2.268-.072 4.536-.612 1.044-1.674 1.656t-2.286.612h-55.296q-1.224 0-2.286-.612t-1.674-1.656q-1.332-2.268-.072-4.536l27.648-50.688q.612-1.116 1.692-1.764t2.34-.648 2.34.648 1.692 1.764z",
		"PLANE": "M49.536-58.679q1.584 1.872.432 5.328t-3.888 6.192l-5.796 5.796 5.76 25.056q.18.684-.432 1.188l-4.608 3.456q-.252.216-.684.216-.144 0-.252-.036-.54-.108-.756-.576l-10.044-18.288-9.324 9.324 1.908 6.984q.18.612-.288 1.116l-3.456 3.456q-.324.324-.828.324h-.072q-.54-.072-.864-.468l-6.804-9.072-9.072-6.804q-.396-.252-.468-.828-.036-.468.324-.9l3.456-3.492q.324-.324.828-.324.216 0 .288.036l6.984 1.908 9.324-9.324-18.288-10.044q-.504-.288-.612-.864-.072-.576.324-.972l4.608-4.608q.504-.468 1.08-.288l23.94 5.724 5.76-5.76q2.736-2.736 6.192-3.888t5.328.432z",
		"CALENDAR": "M4.608-4.535h10.368v-10.368h-10.368v10.368zm12.672 0h11.52v-10.368h-11.52v10.368zm-12.672-12.672h10.368v-11.52h-10.368v11.52zm12.672 0h11.52v-11.52h-11.52v11.52zm-12.672-13.824h10.368v-10.368h-10.368v10.368zm26.496 26.496h11.52v-10.368h-11.52v10.368zm-13.824-26.496h11.52v-10.368h-11.52v10.368zm27.648 26.496h10.368v-10.368h-10.368v10.368zm-13.824-12.672h11.52v-11.52h-11.52v11.52zm-12.672-31.104v-10.368q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v10.368q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm26.496 31.104h10.368v-11.52h-10.368v11.52zm-13.824-13.824h11.52v-10.368h-11.52v10.368zm13.824 0h10.368v-10.368h-10.368v10.368zm1.152-17.28v-10.368q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v10.368q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z",
		"RANDOM": "M23.976-47.123q-2.16 3.312-4.932 9.828-.792-1.62-1.332-2.61t-1.458-2.286-1.836-2.034-2.268-1.26-2.934-.522h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064q9 0 14.76 8.1zm40.536 28.764q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912q-1.152 0-3.06.018t-2.916.036-2.628-.036-2.556-.18-2.304-.378-2.268-.666-2.088-1.026-2.124-1.44-1.98-1.926-2.016-2.502q2.124-3.348 4.896-9.828.792 1.62 1.332 2.61t1.458 2.286 1.836 2.034 2.268 1.26 2.934.522h9.216v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828zm0-32.256q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-9.216q-1.728 0-3.132.54t-2.484 1.62-1.836 2.214-1.62 2.79q-1.152 2.232-2.808 6.156-1.044 2.376-1.782 3.996t-1.944 3.78-2.304 3.6-2.664 2.988-3.24 2.466-3.834 1.512-4.608.594h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064q1.728 0 3.132-.54t2.484-1.62 1.836-2.214 1.62-2.79q1.152-2.232 2.808-6.156 1.044-2.376 1.782-3.996t1.944-3.78 2.304-3.6 2.664-2.988 3.24-2.466 3.834-1.512 4.608-.594h9.216v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828z",
		"COMMENT": "M64.512-32.183q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792-.612.072-1.098-.324t-.63-1.044v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-4.68 2.556-8.946t6.876-7.362 10.296-4.914 12.528-1.818q8.784 0 16.2 3.078t11.736 8.388 4.32 11.574z",
		"MAGNET": "M55.296-34.487v4.608q0 7.236-3.546 13.032t-9.864 9.054-14.238 3.258-14.238-3.258-9.864-9.054-3.546-13.032v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62v4.608q0 1.872.846 3.24t1.926 2.052 2.556 1.08 2.304.468 1.584.072 1.584-.072 2.304-.468 2.556-1.08 1.926-2.052.846-3.24v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62zm-36.864-23.04v13.824q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62zm36.864 0v13.824q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62z",
		"CHEVRON_UP": "M60.588-16.523l-5.976 5.94q-.684.684-1.62.684t-1.62-.684l-19.116-19.116-19.116 19.116q-.684.684-1.62.684t-1.62-.684l-5.976-5.94q-.684-.684-.684-1.638t.684-1.638l26.712-26.676q.684-.684 1.62-.684t1.62.684l26.712 26.676q.684.684.684 1.638t-.684 1.638z",
		"CHEVRON_DOWN": "M60.588-35.351l-26.712 26.676q-.684.684-1.62.684t-1.62-.684l-26.712-26.676q-.684-.684-.684-1.638t.684-1.638l5.976-5.94q.684-.684 1.62-.684t1.62.684l19.116 19.116 19.116-19.116q.684-.684 1.62-.684t1.62.684l5.976 5.94q.684.684.684 1.638t-.684 1.638z",
		"RETWEET": "M46.08-10.295q0 .468-.342.81t-.81.342h-34.56q-.288 0-.486-.072t-.324-.252-.198-.288-.108-.414-.036-.414v-21.6h-6.912q-.936 0-1.62-.684t-.684-1.62q0-.864.54-1.476l11.52-13.824q.684-.792 1.764-.792t1.764.792l11.52 13.824q.54.612.54 1.476 0 .936-.684 1.62t-1.62.684h-6.912v13.824h20.736q.576 0 .9.396l5.76 6.912q.252.396.252.756zm23.04-14.976q0 .864-.54 1.476l-11.52 13.824q-.72.828-1.764.828t-1.764-.828l-11.52-13.824q-.54-.612-.54-1.476 0-.936.684-1.62t1.62-.684h6.912v-13.824h-20.736q-.576 0-.9-.432l-5.76-6.912q-.252-.324-.252-.72 0-.468.342-.81t.81-.342h34.56q.288 0 .486.072t.324.252.198.288.108.414.036.414v21.6h6.912q.936 0 1.62.684t.684 1.62z",
		"SHOPPING_CART": "M23.04-9.143q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24 1.368-3.24 3.24-1.368 3.24 1.368 1.368 3.24zm32.256 0q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24 1.368-3.24 3.24-1.368 3.24 1.368 1.368 3.24zm4.608-39.168v18.432q0 .864-.594 1.53t-1.458.774l-37.584 4.392q.468 2.16.468 2.52 0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.396.288-1.134t.576-1.296.774-1.44.558-1.062l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.702.558.468.882.288.936.198 1.062.162.936h43.236q.936 0 1.62.684t.684 1.62z",
		"FOLDER": "M59.904-42.551v25.344q0 3.312-2.376 5.688t-5.688 2.376h-43.776q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h24.192q3.312 0 5.688 2.376t2.376 5.688z",
		"FOLDER_OPEN": "M67.644-30.167q0 1.116-1.116 2.376l-12.096 14.256q-1.548 1.836-4.338 3.114t-5.166 1.278h-39.168q-1.224 0-2.178-.468t-.954-1.548q0-1.116 1.116-2.376l12.096-14.256q1.548-1.836 4.338-3.114t5.166-1.278h39.168q1.224 0 2.178.468t.954 1.548zm-12.348-12.384v5.76h-29.952q-3.384 0-7.092 1.71t-5.904 4.302l-12.132 14.256-.18.216-.018-.45-.018-.45v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h19.584q3.312 0 5.688 2.376t2.376 5.688z",
		"ARROWS_V": "M25.344-52.919q0 .936-.684 1.62t-1.62.684h-4.608v36.864h4.608q.936 0 1.62.684t.684 1.62-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62 1.62-.684h4.608v-36.864h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684l9.216 9.216q.684.684.684 1.62z",
		"ARROWS_H": "M64.512-32.183q0 .936-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684-.684-1.62v-4.608h-36.864v4.608q0 .936-.684 1.62t-1.62.684-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684.684 1.62v4.608h36.864v-4.608q0-.936.684-1.62t1.62-.684 1.62.684l9.216 9.216q.684.684.684 1.62z",
		"BAR_CHART_O": "M23.04-32.183v18.432h-9.216v-18.432h9.216zm13.824-18.432v36.864h-9.216v-36.864h9.216zm36.864 41.472v4.608h-73.728v-55.296h4.608v50.688h69.12zm-23.04-32.256v27.648h-9.216v-27.648h9.216zm13.824-13.824v41.472h-9.216v-41.472h9.216z",
		"TWITTER_SQUARE": "M46.08-42.479q-2.016.9-4.356 1.224 2.448-1.44 3.348-4.212-2.34 1.368-4.824 1.836-2.196-2.376-5.508-2.376-3.132 0-5.346 2.214t-2.214 5.346q0 1.044.18 1.728-4.644-.252-8.712-2.34t-6.912-5.58q-1.044 1.8-1.044 3.816 0 4.104 3.276 6.3-1.692-.036-3.6-.936v.072q0 2.7 1.8 4.806t4.428 2.61q-1.044.288-1.836.288-.468 0-1.404-.144.756 2.268 2.682 3.744t4.374 1.512q-4.176 3.24-9.396 3.24-.936 0-1.8-.108 5.328 3.384 11.592 3.384 4.032 0 7.56-1.278t6.048-3.42 4.338-4.932 2.7-5.832.882-6.066q0-.648-.036-.972 2.268-1.62 3.78-3.924zm9.216-6.984v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"FACEBOOK_SQUARE": "M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-6.768v-21.42h7.164l1.08-8.352h-8.244v-5.328q0-2.016.846-3.024t3.294-1.008l4.392-.036v-7.452q-2.268-.324-6.408-.324-4.896 0-7.83 2.88t-2.934 8.136v6.156h-7.2v8.352h7.2v21.42h-19.152q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56z",
		"CAMERA_RETRO": "M33.408-34.487q0-.504-.324-.828t-.828-.324q-2.376 0-4.068 1.692t-1.692 4.068q0 .504.324.828t.828.324.828-.324.324-.828q0-1.44 1.008-2.448t2.448-1.008q.504 0 .828-.324t.324-.828zm8.064 4.68q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm-36.864 20.664h55.296v-4.608h-55.296v4.608zm41.472-20.664q0-5.724-4.05-9.774t-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05 9.774-4.05 4.05-9.774zm-36.864-23.112h13.824v-4.608h-13.824v4.608zm-4.608 6.912h55.296v-9.216000000000001h-29.808l-2.304 4.608h-23.184v4.608zm59.904-9.216v46.08q0 1.908-1.35 3.258t-3.258 1.35h-55.296q-1.908 0-3.258-1.35t-1.35-3.258v-46.08q0-1.908 1.35-3.258t3.258-1.35h55.296q1.908 0 3.258 1.35t1.35 3.258z",
		"KEY": "M29.952-46.007q0-2.88-2.016-4.896t-4.896-2.016-4.896 2.016-2.016 4.896q0 1.512.684 2.988-1.476-.684-2.988-.684-2.88 0-4.896 2.016t-2.016 4.896 2.016 4.896 4.896 2.016 4.896-2.016 2.016-4.896q0-1.512-.684-2.988 1.476.684 2.988.684 2.88 0 4.896-2.016t2.016-4.896zm30.636 25.344q0 .612-1.764 2.376t-2.376 1.764q-.324 0-1.026-.576t-1.314-1.188-1.386-1.44-.882-.936l-3.456 3.456 7.92 7.92q1.008 1.008 1.008 2.448 0 1.512-1.404 2.916t-2.916 1.404q-1.44 0-2.448-1.008l-24.156-24.156q-6.336 4.716-13.14 4.716-5.868 0-9.558-3.69t-3.69-9.558q0-5.76 3.42-11.268t8.928-8.928 11.268-3.42q5.868 0 9.558 3.69t3.69 9.558q0 6.804-4.716 13.14l12.78 12.78 3.456-3.456q-.108-.108-.936-.882t-1.44-1.386-1.188-1.314-.576-1.026q0-.612 1.764-2.376t2.376-1.764q.468 0 .828.36.216.216 1.656 1.602t2.952 2.862 3.114 3.096 2.628 2.808 1.026 1.476z",
		"GEARS": "M32.256-32.183q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm27.648 18.432q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm0-36.864q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm-13.824 15.156v6.66q0 .36-.252.702t-.576.378l-5.58.864q-.396 1.26-1.152 2.736 1.224 1.728 3.24 4.14.252.36.252.72 0 .432-.252.684-.828 1.08-2.97 3.222t-2.826 2.142q-.396 0-.756-.252l-4.14-3.24q-1.332.684-2.772 1.116-.396 3.888-.828 5.58-.252.864-1.08.864h-6.696q-.396 0-.72-.27t-.36-.63l-.828-5.508q-1.224-.36-2.7-1.116l-4.248 3.204q-.252.252-.72.252-.396 0-.756-.288-5.184-4.788-5.184-5.76 0-.324.252-.684.36-.504 1.476-1.908t1.692-2.196q-.828-1.584-1.26-2.952l-5.472-.864q-.36-.036-.612-.342t-.252-.702v-6.66q0-.36.252-.702t.576-.378l5.58-.864q.396-1.26 1.152-2.736-1.224-1.728-3.24-4.14-.252-.396-.252-.72 0-.432.252-.72.792-1.08 2.952-3.204t2.844-2.124q.396 0 .756.252l4.14 3.24q1.224-.648 2.772-1.152.396-3.888.828-5.544.252-.864 1.08-.864h6.696q.396 0 .72.27t.36.63l.828 5.508q1.224.36 2.7 1.116l4.248-3.204q.288-.252.72-.252.396 0 .756.288 5.184 4.788 5.184 5.76 0 .324-.252.684-.432.576-1.512 1.944t-1.62 2.16q.828 1.728 1.224 2.952l5.472.828q.36.072.612.378t.252.702zm23.04 19.188v5.04q0 .576-5.364 1.116-.432.972-1.08 1.872 1.836 4.068 1.836 4.968 0 .144-.144.252-4.392 2.556-4.464 2.556-.288 0-1.656-1.692t-1.872-2.448q-.72.072-1.08.072t-1.08-.072q-.504.756-1.872 2.448t-1.656 1.692q-.072 0-4.464-2.556-.144-.108-.144-.252 0-.9 1.836-4.968-.648-.9-1.08-1.872-5.364-.54-5.364-1.116v-5.04q0-.576 5.364-1.116.468-1.044 1.08-1.872-1.836-4.068-1.836-4.968 0-.144.144-.252.144-.072 1.26-.72t2.124-1.224 1.08-.576q.288 0 1.656 1.674t1.872 2.43q.72-.072 1.08-.072t1.08.072q1.836-2.556 3.312-4.032l.216-.072q.144 0 4.464 2.52.144.108.144.252 0 .9-1.836 4.968.612.828 1.08 1.872 5.364.54 5.364 1.116zm0-36.864v5.04q0 .576-5.364 1.116-.432.972-1.08 1.872 1.836 4.068 1.836 4.968 0 .144-.144.252-4.392 2.556-4.464 2.556-.288 0-1.656-1.692t-1.872-2.448q-.72.072-1.08.072t-1.08-.072q-.504.756-1.872 2.448t-1.656 1.692q-.072 0-4.464-2.556-.144-.108-.144-.252 0-.9 1.836-4.968-.648-.9-1.08-1.872-5.364-.54-5.364-1.116v-5.04q0-.576 5.364-1.116.468-1.044 1.08-1.872-1.836-4.068-1.836-4.968 0-.144.144-.252.144-.072 1.26-.72t2.124-1.224 1.08-.576q.288 0 1.656 1.674t1.872 2.43q.72-.072 1.08-.072t1.08.072q1.836-2.556 3.312-4.032l.216-.072q.144 0 4.464 2.52.144.108.144.252 0 .9-1.836 4.968.612.828 1.08 1.872 5.364.54 5.364 1.116z",
		"COMMENTS": "M50.688-36.791q0 5.004-3.384 9.252t-9.234 6.714-12.726 2.466q-3.096 0-6.336-.576-4.464 3.168-10.008 4.608-1.296.324-3.096.576h-.108q-.396 0-.738-.288t-.414-.756q-.036-.108-.036-.234t.018-.234.072-.216l.09-.18.126-.198.144-.18.162-.18.144-.162q.18-.216.828-.9t.936-1.062.81-1.044.9-1.386.738-1.584q-4.464-2.592-7.02-6.372t-2.556-8.064q0-5.004 3.384-9.252t9.234-6.714 12.726-2.466 12.726 2.466 9.234 6.714 3.384 9.252zm13.824 9.216q0 4.32-2.556 8.082t-7.02 6.354q.36.864.738 1.584t.9 1.386.81 1.044.936 1.062.828.9l.144.162.162.18.144.18.126.198.09.18.072.216.018.234-.036.234q-.108.504-.468.792t-.792.252q-1.8-.252-3.096-.576-5.544-1.44-10.008-4.608-3.24.576-6.336.576-9.756 0-16.992-4.752 2.088.144 3.168.144 5.796 0 11.124-1.62t9.504-4.644q4.5-3.312 6.912-7.632t2.412-9.144q0-2.772-.828-5.472 4.644 2.556 7.344 6.408t2.7 8.28z",
		"THUMBS_O_UP": "M9.216-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm41.472-20.736q0-1.836-1.404-3.222t-3.204-1.386h-12.672q0-2.088 1.728-5.742t1.728-5.778q0-3.528-1.152-5.22t-4.608-1.692q-.936.936-1.368 3.06t-1.098 4.518-2.142 3.942q-.792.828-2.772 3.276-.144.18-.828 1.08t-1.134 1.476-1.242 1.53-1.44 1.584-1.386 1.278-1.44.972-1.278.324h-1.152v23.04h1.152q.468 0 1.134.108t1.188.234 1.368.396 1.26.414 1.278.45 1.044.378q7.596 2.628 12.312 2.628h4.356q6.912 0 6.912-6.012 0-.936-.18-2.016 1.08-.576 1.71-1.89t.63-2.646-.648-2.484q1.908-1.8 1.908-4.284 0-.9-.36-1.998t-.9-1.71q1.152-.036 1.926-1.692t.774-2.916zm4.608-.036q0 3.204-1.764 5.868.324 1.188.324 2.484 0 2.772-1.368 5.184.108.756.108 1.548 0 3.636-2.16 6.408.036 5.004-3.06 7.902t-8.172 2.898h-4.644q-3.456 0-6.822-.81t-7.794-2.358q-4.176-1.44-4.968-1.44h-10.368q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h9.864q1.296-.864 4.932-5.58 2.088-2.7 3.852-4.608.864-.9 1.278-3.078t1.098-4.554 2.232-3.888q1.404-1.332 3.24-1.332 3.024 0 5.436 1.17t3.672 3.654 1.26 6.696q0 3.348-1.728 6.912h6.336q3.744 0 6.48 2.736t2.736 6.444z",
		"THUMBS_O_DOWN": "M9.216-48.311q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm41.472 20.736q0-1.26-.774-2.916t-1.926-1.692q.54-.612.9-1.71t.36-1.998q0-2.484-1.908-4.284.648-1.152.648-2.484t-.63-2.646-1.71-1.89q.18-1.08.18-2.016 0-3.06-1.764-4.536t-4.896-1.476h-4.608q-4.716 0-12.312 2.628-.18.072-1.044.378t-1.278.45-1.26.414-1.368.396-1.188.234-1.134.108h-1.152v23.04h1.152q.576 0 1.278.324t1.44.972 1.386 1.278 1.44 1.584 1.242 1.53 1.134 1.476.828 1.08q1.98 2.448 2.772 3.276 1.476 1.548 2.142 3.942t1.098 4.518 1.368 3.06q3.456 0 4.608-1.692t1.152-5.22q0-2.124-1.728-5.778t-1.728-5.742h12.672q1.8 0 3.204-1.386t1.404-3.222zm4.608.036q0 3.708-2.736 6.444t-6.48 2.736h-6.336q1.728 3.564 1.728 6.912 0 4.248-1.26 6.696-1.26 2.484-3.672 3.654t-5.436 1.17q-1.836 0-3.24-1.332-1.224-1.188-1.944-2.952t-.918-3.258-.63-3.042-1.116-2.304q-1.728-1.8-3.852-4.572-3.636-4.716-4.932-5.58h-9.864q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h10.368q.792 0 4.968-1.44 4.608-1.584 8.028-2.376t7.2-.792h4.032q5.04 0 8.154 2.844t3.078 7.776v.18q2.16 2.772 2.16 6.408 0 .792-.108 1.548 1.368 2.412 1.368 5.184 0 1.296-.324 2.484 1.764 2.664 1.764 5.868z",
		"STAR_HALF": "M29.952-63.287v48.204l-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476z",
		"HEART_O": "M59.904-42.983q0-2.916-.774-5.148t-1.98-3.546-2.934-2.142-3.384-1.116-3.528-.288-4.032.918-3.978 2.304-3.114 2.592-2.16 2.214q-.648.792-1.764.792t-1.764-.792q-.864-1.008-2.16-2.214t-3.114-2.592-3.978-2.304-4.032-.918-3.528.288-3.384 1.116-2.934 2.142-1.98 3.546-.774 5.148q0 6.048 6.732 12.78l20.916 20.16 20.88-20.124q6.768-6.768 6.768-12.816zm4.608 0q0 7.956-8.244 16.2l-22.428 21.6q-.648.648-1.584.648t-1.584-.648l-22.464-21.672q-.36-.288-.99-.936t-1.998-2.358-2.448-3.51-1.926-4.356-.846-4.968q0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384z",
		"SIGN_OUT": "M23.04-12.599q0 .144.036.72t.018.954-.108.846-.36.702-.738.234h-11.52q-4.284 0-7.326-3.042t-3.042-7.326v-25.344q0-4.284 3.042-7.326t7.326-3.042h11.52q.468 0 .81.342t.342.81q0 .144.036.72t.018.954-.108.846-.36.702-.738.234h-11.52q-2.376 0-4.068 1.692t-1.692 4.068v25.344q0 2.376 1.692 4.068t4.068 1.692h11.232000000000001l.414.036.414.108.288.198.252.324.072.486zm33.408-19.584q0 .936-.684 1.62l-19.584 19.584q-.684.684-1.62.684t-1.62-.684-.684-1.62v-10.368h-16.128q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h16.128v-10.368q0-.936.684-1.62t1.62-.684 1.62.684l19.584 19.584q.684.684.684 1.62z",
		"LINKEDIN_SQUARE": "M8.532-13.535h8.316v-24.984h-8.316v24.984zm8.856-32.688q-.036-1.872-1.296-3.096t-3.348-1.224-3.402 1.224-1.314 3.096q0 1.836 1.278 3.078t3.33 1.242h.036q2.124 0 3.42-1.242t1.296-3.078zm21.06 32.688h8.316v-14.328q0-5.544-2.628-8.388t-6.948-2.844q-4.896 0-7.524 4.212h.072v-3.636h-8.316q.108 2.376 0 24.984h8.316v-13.968q0-1.368.252-2.016.54-1.26 1.62-2.142t2.664-.882q4.176 0 4.176 5.652v13.356zm16.848-35.928v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"THUMB_TACK": "M17.28-33.335v-16.128q0-.504-.324-.828t-.828-.324-.828.324-.324.828v16.128q0 .504.324.828t.828.324.828-.324.324-.828zm24.192 12.672q0 .936-.684 1.62t-1.62.684h-15.444l-1.836 17.388q-.072.432-.378.738t-.738.306h-.036q-.972 0-1.152-.972l-2.736-17.46h-14.544q-.936 0-1.62-.684t-.684-1.62q0-4.428 2.826-7.974t6.39-3.546v-18.432q-1.872 0-3.24-1.368t-1.368-3.24 1.368-3.24 3.24-1.368h23.04q1.872 0 3.24 1.368t1.368 3.24-1.368 3.24-3.24 1.368v18.432q3.564 0 6.39 3.546t2.826 7.974z",
		"EXTERNAL_LINK": "M50.688-31.031v11.52q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h25.344q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-11.52q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm13.824-31.104v18.432q0 .936-.684 1.62t-1.62.684-1.62-.684l-6.336-6.336-23.472 23.472q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l23.472-23.472-6.336-6.336q-.684-.684-.684-1.62t.684-1.62 1.62-.684h18.432q.936 0 1.62.684t.684 1.62z",
		"SIGN_IN": "M42.624-32.183q0 .936-.684 1.62l-19.584 19.584q-.684.684-1.62.684t-1.62-.684-.684-1.62v-10.368h-16.128q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h16.128v-10.368q0-.936.684-1.62t1.62-.684 1.62.684l19.584 19.584q.684.684.684 1.62zm12.672-12.672v25.344q0 4.284-3.042 7.326t-7.326 3.042h-11.52q-.468 0-.81-.342t-.342-.81q0-.144-.036-.72t-.018-.954.108-.846.36-.702.738-.234h11.52q2.376 0 4.068-1.692t1.692-4.068v-25.344q0-2.376-1.692-4.068t-4.068-1.692h-11.232000000000001l-.414-.036-.414-.108-.288-.198-.252-.324-.072-.486q0-.144-.036-.72t-.018-.954.108-.846.36-.702.738-.234h11.52q4.284 0 7.326 3.042t3.042 7.326z",
		"TROPHY": "M16.488-32.651q-2.664-5.832-2.664-13.356h-9.216v3.456q0 2.808 3.402 5.832t8.478 4.068zm38.808-9.9v-3.456h-9.216q0 7.524-2.664 13.356 5.076-1.044 8.478-4.068t3.402-5.832zm4.608-4.608v4.608q0 2.556-1.494 5.148t-4.032 4.68-6.228 3.51-7.758 1.602q-1.512 1.944-3.42 3.42-1.368 1.224-1.89 2.61t-.522 3.222q0 1.944 1.098 3.276t3.51 1.332q2.7 0 4.806 1.638t2.106 4.122v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-2.484 2.106-4.122t4.806-1.638q2.412 0 3.51-1.332t1.098-3.276q0-1.836-.522-3.222t-1.89-2.61q-1.908-1.476-3.42-3.42-4.068-.18-7.758-1.602t-6.228-3.51-4.032-4.68-1.494-5.148v-4.608q0-1.44 1.008-2.448t2.448-1.008h10.368v-3.456q0-2.376 1.692-4.068t4.068-1.692h20.736q2.376 0 4.068 1.692t1.692 4.068v3.456h10.368q1.44 0 2.448 1.008t1.008 2.448z",
		"GITHUB_SQUARE": "M18.684-21.239q.144-.216-.108-.468-.324-.252-.504-.072-.144.216.108.468.324.252.504.072zm-1.008-1.476q-.18-.252-.432-.144-.216.144 0 .432.252.288.432.18.216-.144 0-.468zm-1.476-1.44q.072-.144-.18-.288-.252-.072-.288.072-.108.18.144.288.288.072.324-.072zm.756.828q.072-.036.054-.162t-.126-.198q-.216-.252-.36-.108t.036.396q.216.216.396.072zm3.096 2.7q.072-.252-.324-.396-.324-.108-.468.144-.072.252.324.396.324.108.468-.144zm1.512.108q0-.288-.432-.288-.36 0-.36.288t.396.288.396-.288zm1.404-.252q-.072-.252-.468-.18t-.324.324q.072.288.432.216t.36-.36zm23.112-11.412q0-7.632-5.4-13.032t-13.032-5.4-13.032 5.4-5.4 13.032q0 6.012 3.528 10.818t9.072 6.678q.648.108.954-.18t.306-.72q0-1.872-.036-3.42-.216.036-.558.09t-1.278.072-1.728-.144-1.566-.72-1.062-1.494q-.828-2.124-2.052-2.664l-.162-.126-.288-.288-.252-.342.144-.27.702-.126q.216 0 .54.072t1.08.558 1.188 1.278q.576 1.008 1.35 1.512t1.566.504 1.368-.126 1.08-.342q.252-1.692 1.188-2.484-1.764-.216-3.096-.666t-2.628-1.404-1.998-2.736-.702-4.302q0-2.844 1.908-4.932-.864-2.232.18-4.896.684-.216 1.962.27t2.178 1.062l.936.576q2.088-.612 4.608-.612t4.608.612q.396-.252 1.026-.648t1.998-.936 2.052-.324q1.044 2.664.18 4.896 1.908 2.088 1.908 4.932 0 2.052-.504 3.618t-1.278 2.52-1.926 1.602-2.25.936-2.466.432q1.26 1.116 1.26 3.42 0 1.44-.018 3.204t-.018 1.836q0 .432.306.72t.954.18q5.544-1.872 9.072-6.678t3.528-10.818zm9.216-17.28v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"UPLOAD": "M46.08-11.447q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 0q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-8.064v11.52q0 1.44-1.008 2.448t-2.448 1.008h-52.992q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h15.372q.756 2.016 2.538 3.312t3.978 1.296h9.216q2.196 0 3.978-1.296t2.538-3.312h15.372q1.44 0 2.448 1.008t1.008 2.448zm-11.7-23.328q-.612 1.44-2.124 1.44h-9.216v16.128q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-16.128h-9.216q-1.512 0-2.124-1.44-.612-1.404.504-2.484l16.128-16.128q.648-.684 1.62-.684t1.62.684l16.128 16.128q1.116 1.08.504 2.484z",
		"LEMON_O": "M50.652-34.703q0-1.584-.252-4.086t-.648-3.474q-.432-1.08-.612-1.584t-.324-1.314-.144-1.746q0-.828.18-2.466t.18-2.43q0-1.332-.36-1.98-.144-.036-.468-.036-.684 0-2.088.162t-2.124.162q-2.16 0-6.336-.864t-6.3-.864q-1.548 0-3.402.414t-3.06.846-3.222 1.224q-4.932 1.944-7.272 3.708-3.456 2.628-5.742 6.822t-3.168 8.496-.882 8.946q0 1.44.45 4.32t.45 4.356q0 .828-.396 2.394t-.396 2.358.432 1.314 1.224.522q.864 0 2.61-.396t2.646-.396q2.052 0 6.102.558t6.102.558q6.516 0 10.224-1.296 4.644-1.62 8.478-5.49t5.976-8.838 2.142-9.9zm4.608-.072q0 5.94-2.52 11.79t-7.056 10.368-10.116 6.498q-4.464 1.584-11.736 1.584-2.052 0-6.12-.522t-6.084-.522q-.864 0-2.61.522t-2.646.522q-2.628 0-4.446-1.998t-1.818-4.626q0-.864.396-2.448t.396-2.412q0-1.44-.45-4.338t-.45-4.374q0-3.996.648-7.83t1.962-7.542 3.618-6.984 5.4-5.616q2.808-2.124 8.352-4.32 6.984-2.808 11.376-2.808 2.16 0 6.318.864t6.246.864q.684 0 2.052-.18t2.088-.18q2.916 0 4.248 1.818t1.332 4.842q0 .828-.18 2.448t-.18 2.448q0 .36.036.666t.108.612.144.486.234.576.234.612q.576 1.44.9 4.266t.324 4.914z",
		"PHONE": "M50.688-19.799q0 .972-.36 2.538t-.756 2.466q-.756 1.8-4.392 3.816-3.384 1.836-6.696 1.836-.972 0-1.89-.126t-2.07-.45-1.71-.522-1.998-.738-1.764-.648q-3.528-1.26-6.3-2.988-4.608-2.844-9.522-7.758t-7.758-9.522q-1.728-2.772-2.988-6.3-.108-.324-.648-1.764t-.738-1.998-.522-1.71-.45-2.07-.126-1.89q0-3.312 1.836-6.696 2.016-3.636 3.816-4.392.9-.396 2.466-.756t2.538-.36q.504 0 .756.108.648.216 1.908 2.736.396.684 1.08 1.944t1.26 2.286 1.116 1.926q.108.144.63.9t.774 1.278.252 1.026q0 .72-1.026 1.8t-2.232 1.98-2.232 1.908-1.026 1.656q0 .324.18.81t.306.738.504.864.414.684q2.736 4.932 6.264 8.46t8.46 6.264q.072.036.684.414t.864.504.738.306.81.18q.648 0 1.656-1.026t1.908-2.232 1.98-2.232 1.8-1.026q.504 0 1.026.252t1.278.774.9.63q.9.54 1.926 1.116t2.286 1.26 1.944 1.08q2.52 1.26 2.736 1.908.108.252.108.756z",
		"SQUARE_O": "M40.32-55.223h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-29.952q0-2.376-1.692-4.068t-4.068-1.692zm10.368 5.76v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z",
		"BOOKMARK_O": "M41.472-55.223h-36.864v44.712l15.228-14.616 3.204-3.06 3.204 3.06 15.228 14.616v-44.712zm.432-4.608q.828 0 1.584.324 1.188.468 1.89 1.476t.702 2.232v46.404q0 1.224-.702 2.232t-1.89 1.476q-.684.288-1.584.288-1.728 0-2.988-1.152l-15.876-15.264-15.876 15.264q-1.296 1.188-2.988 1.188-.828 0-1.584-.324-1.188-.468-1.89-1.476t-.702-2.232v-46.404q0-1.224.702-2.232t1.89-1.476q.756-.324 1.584-.324h37.728z",
		"PHONE_SQUARE": "M46.08-21.491q0-.396-.072-.576-.108-.288-1.386-1.062t-3.186-1.782l-1.908-1.044q-.18-.108-.684-.468t-.9-.54-.756-.18q-.648 0-1.692 1.17t-2.052 2.358-1.584 1.188q-.252 0-.594-.126t-.558-.234-.612-.342-.504-.306q-3.564-1.98-6.138-4.554t-4.554-6.138q-.072-.108-.306-.504t-.342-.612-.234-.558-.126-.594q0-.468.738-1.206t1.62-1.386 1.62-1.422.738-1.314q0-.36-.18-.756t-.54-.9-.468-.684q-.108-.216-.54-1.026t-.9-1.638-.954-1.71-.9-1.458-.594-.648-.576-.072q-1.728 0-3.636.792-1.656.756-2.88 3.402t-1.224 4.698q0 .576.09 1.224t.18 1.098.324 1.188.36 1.062.45 1.188.396 1.08q2.16 5.904 7.794 11.538t11.538 7.794q.216.072 1.08.396t1.188.45 1.062.36 1.188.324 1.098.18 1.224.09q2.052 0 4.698-1.224t3.402-2.88q.792-1.908.792-3.636zm9.216-27.972v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TWITTER": "M58.32-49.751q-2.412 3.528-5.832 6.012.036.504.036 1.512 0 4.68-1.368 9.342t-4.158 8.946-6.642 7.578-9.288 5.256-11.628 1.962q-9.756 0-17.856-5.22 1.26.144 2.808.144 8.1 0 14.436-4.968-3.78-.072-6.768-2.322t-4.104-5.742q1.188.18 2.196.18 1.548 0 3.06-.396-4.032-.828-6.678-4.014t-2.646-7.398v-.144q2.448 1.368 5.256 1.476-2.376-1.584-3.78-4.14t-1.404-5.544q0-3.168 1.584-5.868 4.356 5.364 10.602 8.586t13.374 3.582q-.288-1.368-.288-2.664 0-4.824 3.402-8.226t8.226-3.402q5.04 0 8.496 3.672 3.924-.756 7.38-2.808-1.332 4.14-5.112 6.408 3.348-.36 6.696-1.8z",
		"FACEBOOK_F": "M34.524-64.007v9.504h-5.652q-3.096 0-4.176 1.296t-1.08 3.888v6.804h10.548l-1.404 10.656h-9.144v27.324h-11.016v-27.324h-9.18v-10.656h9.18v-7.848q0-6.696 3.744-10.386t9.972-3.69q5.292 0 8.208.432z",
		"GITHUB": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878q0 9.036-5.274 16.254t-13.626 9.99q-.972.18-1.44-.252t-.468-1.08q0-.108.018-2.754t.018-4.842q0-3.492-1.872-5.112 2.052-.216 3.69-.648t3.384-1.404 2.916-2.394 1.908-3.78.738-5.418q0-4.284-2.844-7.416 1.332-3.276-.288-7.344-1.008-.324-2.916.396t-3.312 1.584l-1.368.864q-3.348-.936-6.912-.936t-6.912.936q-.576-.396-1.53-.972t-3.006-1.386-3.06-.486q-1.62 4.068-.288 7.344-2.844 3.132-2.844 7.416 0 3.06.738 5.4t1.89 3.78 2.898 2.412 3.384 1.404 3.69.648q-1.404 1.296-1.764 3.708-.756.36-1.62.54t-2.052.18-2.358-.774-1.998-2.25q-.684-1.152-1.746-1.872t-1.782-.864l-.72-.108q-.756 0-1.044.162t-.18.414.324.504.468.432l.252.18q.792.36 1.566 1.368t1.134 1.836l.36.828q.468 1.368 1.584 2.214t2.412 1.08 2.502.252 1.998-.126l.828-.144q0 1.368.018 3.186t.018 1.962q0 .648-.468 1.08t-1.44.252q-8.352-2.772-13.626-9.99t-5.274-16.254q0-7.524 3.708-13.878t10.062-10.062 13.878-3.708zm-17.172 39.708q.108-.252-.252-.432-.36-.108-.468.072-.108.252.252.432.324.216.468-.072zm1.116 1.224q.252-.18-.072-.576-.36-.324-.576-.108-.252.18.072.576.36.36.576.108zm1.08 1.62q.324-.252 0-.684-.288-.468-.612-.216-.324.18 0 .648t.612.252zm1.512 1.512q.288-.288-.144-.684-.432-.432-.72-.108-.324.288.144.684.432.432.72.108zm2.052.9q.108-.396-.468-.576-.54-.144-.684.252t.468.54q.54.216.684-.216zm2.268.18q0-.468-.612-.396-.576 0-.576.396 0 .468.612.396.576 0 .576-.396zm2.088-.36q-.072-.396-.648-.324-.576.108-.504.54t.648.288.504-.504z",
		"UNLOCK": "M59.904-43.703v9.216q0 .936-.684 1.62t-1.62.684h-2.304q-.936 0-1.62-.684t-.684-1.62v-9.216q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h24.192v-6.912q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394z",
		"CREDIT_CARD": "M63.36-59.831q2.376 0 4.068 1.692t1.692 4.068v43.776q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h57.6zm-57.6 4.608q-.468 0-.81.342t-.342.81v8.064h59.904v-8.064q0-.468-.342-.81t-.81-.342h-57.6zm57.6 46.08q.468 0 .81-.342t.342-.81v-21.888h-59.904v21.888q0 .468.342.81t.81.342h57.6zm-54.144-4.608v-4.608h9.216v4.608h-9.216zm13.824 0v-4.608h13.824v4.608h-13.824z",
		"RSS": "M13.824-16.055q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 4.428q.072 1.008-.612 1.728-.648.756-1.692.756h-4.86q-.9 0-1.548-.594t-.72-1.494q-.792-8.244-6.642-14.094t-14.094-6.642q-.9-.072-1.494-.72t-.594-1.548v-4.86q0-1.044.756-1.692.612-.612 1.548-.612h.18q5.76.468 11.016 2.898t9.324 6.534q4.104 4.068 6.534 9.324t2.898 11.016zm18.432.072q.072.972-.648 1.692-.648.72-1.656.72h-5.148q-.936 0-1.602-.63t-.702-1.53q-.432-7.74-3.636-14.706t-8.334-12.096-12.096-8.334-14.706-3.672q-.9-.036-1.53-.702t-.63-1.566v-5.148q0-1.008.72-1.656.648-.648 1.584-.648h.108q9.432.468 18.054 4.32t15.318 10.584q6.732 6.696 10.584 15.318t4.32 18.054z",
		"HDD_O": "M37.44-20.663q0 1.188-.846 2.034t-2.034.846-2.034-.846-.846-2.034.846-2.034 2.034-.846 2.034.846.846 2.034zm9.216 0q0 1.188-.846 2.034t-2.034.846-2.034-.846-.846-2.034.846-2.034 2.034-.846 2.034.846.846 2.034zm4.032 5.76v-11.52q0-.468-.342-.81t-.81-.342h-43.776q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h43.776q.468 0 .81-.342t.342-.81zm-44.28-17.28h42.48l-5.652-17.352q-.144-.468-.576-.774t-.936-.306h-28.152q-.504 0-.936.306t-.576.774zm48.888 5.76v11.52q0 2.376-1.692 4.068t-4.068 1.692h-43.776q-2.376 0-4.068-1.692t-1.692-4.068v-11.52q0-.9.576-2.7l7.092-21.816q.612-1.908 2.268-3.096t3.636-1.188h28.152q1.98 0 3.636 1.188t2.268 3.096l7.092 21.816q.576 1.8.576 2.7z",
		"BULLHORN": "M59.904-41.399q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35v13.824q0 1.872-1.368 3.24t-3.24 1.368q-15.012-12.492-29.232-13.68-2.088.684-3.276 2.376t-1.116 3.618 1.44 3.33q-.72 1.188-.828 2.358t.216 2.088 1.206 1.98 1.728 1.8 2.214 1.818q-1.044 2.088-4.014 2.988t-6.066.414-4.752-1.998q-.252-.828-1.062-3.15t-1.152-3.402-.828-3.204-.54-3.636.126-3.546.792-3.978h-4.392q-2.376 0-4.068-1.692t-1.692-4.068v-6.912q0-2.376 1.692-4.068t4.068-1.692h17.28q15.66 0 32.256-13.824 1.872 0 3.24 1.368t1.368 3.24v13.824zm-4.608 21.744v-34.344q-14.184 10.872-27.648 12.348v9.72q13.572 1.512 27.648 12.276z",
		"BELL_O": "M32.832-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm-23.976-10.368h46.8q-9.576-10.8-9.576-29.952 0-1.836-.864-3.78t-2.484-3.708-4.374-2.898-6.102-1.134-6.102 1.134-4.374 2.898-2.484 3.708-.864 3.78q0 19.152-9.576 29.952zm53.352 0q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-16.128q-1.872 0-3.24-1.368t-1.368-3.24q1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 6.84 1.008 11.052 5.706t4.212 10.17q0 5.004.702 9.36t1.8 7.416 2.682 5.706 3.06 4.302 3.276 3.168z",
		"CERTIFICATE": "M49.536-32.183l4.968 4.86q1.08 1.008.72 2.52-.432 1.476-1.872 1.836l-6.768 1.728 1.908 6.696q.432 1.476-.684 2.52-1.044 1.116-2.52.684l-6.696-1.908-1.728 6.768q-.36 1.44-1.836 1.872-.432.072-.684.072-1.116 0-1.836-.792l-4.86-4.968-4.86 4.968q-1.008 1.08-2.52.72-1.476-.396-1.836-1.872l-1.728-6.768-6.696 1.908q-1.476.432-2.52-.684-1.116-1.044-.684-2.52l1.908-6.696-6.768-1.728q-1.44-.36-1.872-1.836-.36-1.512.72-2.52l4.968-4.86-4.968-4.86q-1.08-1.008-.72-2.52.432-1.476 1.872-1.836l6.768-1.728-1.908-6.696q-.432-1.476.684-2.52 1.044-1.116 2.52-.684l6.696 1.908 1.728-6.768q.36-1.476 1.836-1.836 1.476-.432 2.52.684l4.86 5.004 4.86-5.004q1.044-1.08 2.52-.684 1.476.36 1.836 1.836l1.728 6.768 6.696-1.908q1.476-.432 2.52.684 1.116 1.044.684 2.52l-1.908 6.696 6.768 1.728q1.44.36 1.872 1.836.36 1.512-.72 2.52z",
		"HAND_O_RIGHT": "M9.216-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm50.688-20.736q0-1.836-1.404-3.222t-3.204-1.386h-20.736q0-.72.54-1.746t1.188-1.98 1.188-2.448.54-3.042q0-2.412-1.602-3.51t-4.158-1.098q-.864 0-3.24 5.004-.864 1.584-1.332 2.34-1.44 2.304-4.032 5.22-2.556 2.916-3.636 3.816-2.484 2.052-5.04 2.052h-1.152v23.04h1.152q2.592 0 6.012 1.152t6.966 2.304 6.462 1.152q6.804 0 6.804-6.012 0-.936-.18-2.016 1.08-.576 1.71-1.89t.63-2.646-.648-2.484q1.908-1.8 1.908-4.284 0-.9-.36-1.998t-.9-1.71h11.916q1.872 0 3.24-1.368t1.368-3.24zm4.608-.036q0 3.78-2.718 6.516t-6.498 2.736h-6.084q-.144 2.232-1.332 4.284.108.756.108 1.548 0 3.636-2.16 6.408.036 5.004-3.06 7.902t-8.172 2.898q-4.788 0-11.592-2.484-5.904-2.124-8.028-2.124h-10.368q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h10.368q.36 0 .774-.162t.846-.504.81-.648.864-.81.738-.774.684-.774.504-.612q2.34-2.664 3.6-4.644.468-.756 1.188-2.232t1.332-2.592 1.458-2.268 1.98-1.782 2.502-.63q4.5 0 7.434 2.412t2.934 6.804q0 2.448-.792 4.608h13.464q3.744 0 6.48 2.736t2.736 6.444z",
		"HAND_O_LEFT": "M49.536-13.751h1.152v-23.04h-1.152q-1.26 0-2.43-.432t-2.25-1.332-1.8-1.656-1.764-1.944l-.126-.162-.144-.162-.162-.18q-2.592-2.916-4.032-5.22-.504-.792-1.368-2.448-.036-.108-.378-.81t-.666-1.296-.72-1.278-.774-1.098-.666-.414q-2.556 0-4.158 1.098t-1.602 3.51q0 1.548.54 3.042t1.188 2.448 1.188 1.98.54 1.746h-20.736q-1.8 0-3.204 1.386t-1.404 3.222q0 1.872 1.368 3.24t3.24 1.368h11.916q-.54.612-.9 1.71t-.36 1.998q0 2.484 1.908 4.284-.648 1.152-.648 2.484t.63 2.646 1.71 1.89q-.144.864-.144 2.016 0 3.06 1.746 4.536t4.878 1.476q3.024 0 6.588-1.152t6.984-2.304 6.012-1.152zm10.368-2.304q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-20.736v23.04q0 1.908-1.35 3.258t-3.258 1.35h-10.368q-2.124 0-8.028 2.124-6.84 2.484-11.412 2.484-5.112 0-8.28-2.79t-3.132-7.83l.036-.18q-2.196-2.736-2.196-6.408 0-.792.108-1.548-1.188-2.052-1.332-4.284h-6.084q-3.78 0-6.498-2.736t-2.718-6.516q0-3.708 2.736-6.444t6.48-2.736h13.464q-.792-2.16-.792-4.608 0-4.392 2.934-6.804t7.434-2.412q1.368 0 2.502.63t1.98 1.782 1.458 2.268 1.332 2.592 1.188 2.232q1.26 1.98 3.6 4.644.072.108.504.612t.684.774.738.774.864.81.81.648.846.504.774.162h10.368q1.908 0 3.258 1.35t1.35 3.258z",
		"HAND_O_UP": "M46.08-6.839q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-27.504q0-6.804-6.012-6.804-.936 0-2.016.18-.576-1.08-1.89-1.71t-2.646-.63-2.484.648q-1.8-1.908-4.284-1.908-.9 0-1.998.36t-1.71.9v-11.916q0-1.872-1.368-3.24t-3.24-1.368q-1.836 0-3.222 1.404t-1.386 3.204v20.736q-.72 0-1.746-.54t-1.98-1.188-2.448-1.188-3.042-.54q-2.412 0-3.51 1.602t-1.098 4.158q0 .864 5.004 3.24 1.584.864 2.34 1.332 2.304 1.44 5.22 4.032 2.916 2.556 3.816 3.636 2.052 2.484 2.052 5.04v1.152h23.04v-1.152q0-2.592 1.152-6.012t2.304-6.966 1.152-6.462zm4.608-.18q0 4.788-2.484 11.592-2.124 5.904-2.124 8.028v10.368q0 1.908-1.35 3.258t-3.258 1.35h-23.04q-1.908 0-3.258-1.35t-1.35-3.258v-10.368q0-.36-.162-.774t-.504-.846-.648-.81-.81-.864-.774-.738-.774-.684-.612-.504q-2.664-2.34-4.644-3.6-.756-.468-2.232-1.188t-2.592-1.332-2.268-1.458-1.782-1.98-.63-2.502q0-4.5 2.412-7.434t6.804-2.934q2.448 0 4.608.792v-13.464q0-3.744 2.736-6.48t6.444-2.736q3.78 0 6.516 2.718t2.736 6.498v6.084q2.232.144 4.284 1.332.756-.108 1.548-.108 3.636 0 6.408 2.16 5.004-.036 7.902 3.06t2.898 8.172z",
		"HAND_O_DOWN": "M50.688-29.879q0-3.024-1.152-6.588t-2.304-6.984-1.152-6.012v-1.152h-23.04v1.152q0 1.26-.432 2.43t-1.332 2.25-1.656 1.8-1.944 1.764q-.324.288-.504.432-2.916 2.592-5.22 4.032-.792.504-2.448 1.368-.108.036-.81.378t-1.296.666-1.278.72-1.098.774-.414.666q0 2.556 1.098 4.158t3.51 1.602q1.548 0 3.042-.54t2.448-1.188 1.98-1.188 1.746-.54v20.736q0 1.8 1.386 3.204t3.222 1.404q1.872 0 3.24-1.368t1.368-3.24v-11.916q1.656 1.26 3.708 1.26 2.484 0 4.284-1.908 1.152.648 2.484.648t2.646-.63 1.89-1.71q.864.144 2.016.144 3.06 0 4.536-1.746t1.476-4.878zm-4.608-27.648q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 27.504q0 5.112-2.79 8.28t-7.83 3.132l-.18-.036q-2.736 2.196-6.408 2.196-.792 0-1.548-.108-1.944 1.08-4.284 1.332v6.084q0 3.78-2.736 6.498t-6.516 2.718q-3.708 0-6.444-2.736t-2.736-6.48v-13.464q-1.944.792-4.608.792-4.356 0-6.786-2.934t-2.43-7.434q0-1.368.63-2.502t1.782-1.98 2.268-1.458 2.592-1.332 2.232-1.188q1.98-1.26 4.644-3.6.108-.072.612-.504t.774-.684.774-.738.81-.864.648-.81.504-.846.162-.774v-10.368q0-1.908 1.35-3.258t3.258-1.35h23.04q1.908 0 3.258 1.35t1.35 3.258v10.368q0 2.124 2.124 8.028 2.484 6.84 2.484 11.412z",
		"ARROW_CIRCLE_LEFT": "M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-18.072l6.804-6.804q.684-.684.684-1.62t-.684-1.62l-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-13.032 13.032-3.276 3.276q-.648.648-.648 1.62t.648 1.62l3.276 3.276 13.032 13.032q.648.648 1.62.648t1.62-.648l3.276-3.276q.648-.648.648-1.62t-.648-1.62l-6.804-6.804h18.072q.936 0 1.62-.684t.684-1.62zm9.216-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ARROW_CIRCLE_RIGHT": "M46.26-32.183q0-.972-.648-1.62l-3.276-3.276-13.032-13.032q-.648-.648-1.62-.648t-1.62.648l-3.276 3.276q-.648.648-.648 1.62t.648 1.62l6.804 6.804h-18.072q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h18.072l-6.804 6.804q-.684.684-.684 1.62t.684 1.62l3.276 3.276q.648.648 1.62.648t1.62-.648l13.032-13.032 3.276-3.276q.648-.648.648-1.62zm9.036 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ARROW_CIRCLE_UP": "M46.224-32.219q0-.972-.648-1.62l-13.032-13.032-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-3.276 3.276-13.032 13.032q-.648.648-.648 1.62t.648 1.62l3.276 3.276q.648.648 1.62.648t1.62-.648l6.804-6.804v18.072q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-18.072l6.804 6.804q.684.684 1.62.684t1.62-.684l3.276-3.276q.648-.648.648-1.62zm9.072.036q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ARROW_CIRCLE_DOWN": "M46.224-32.147q0-.972-.648-1.62l-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-6.804 6.804v-18.072q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v18.072l-6.804-6.804q-.684-.684-1.62-.684t-1.62.684l-3.276 3.276q-.648.648-.648 1.62t.648 1.62l13.032 13.032 3.276 3.276q.648.648 1.62.648t1.62-.648l3.276-3.276 13.032-13.032q.648-.648.648-1.62zm9.072-.036q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"GLOBE": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm9.864 18.756q-.072.036-.342.342t-.486.342q.072 0 .162-.18t.18-.396.126-.252q.216-.252.792-.54.504-.216 1.872-.432 1.224-.288 1.836.396-.072-.072.342-.468t.522-.432q.108-.072.54-.162t.54-.27l.072-.792q-.432.036-.63-.252t-.234-.756q0 .072-.216.288 0-.252-.162-.288t-.414.036-.324.036q-.36-.108-.54-.27t-.288-.594-.144-.54q-.072-.18-.342-.378t-.342-.378l-.09-.198-.108-.234-.144-.198-.198-.09-.252.18-.27.36-.162.18q-.108-.072-.216-.054t-.162.036-.162.108-.18.126q-.108.072-.306.108t-.306.072q.54-.18-.036-.396-.36-.144-.576-.108.324-.144.27-.432t-.306-.504h.18q-.036-.144-.306-.306t-.63-.306-.468-.216q-.288-.18-1.224-.342t-1.188-.018q-.18.216-.162.378t.144.504.126.45q.036.216-.198.468t-.234.432q0 .252.504.558t.36.774q-.108.288-.576.576t-.576.432q-.18.288-.054.666t.378.594q.072.072.054.144t-.126.162-.198.144-.234.126l-.108.072q-.396.18-.738-.216t-.486-.936q-.252-.9-.576-1.08-.828-.288-1.044.036-.18-.468-1.476-.936-.9-.324-2.088-.144.216-.036 0-.54-.252-.54-.684-.432.108-.216.144-.63t.036-.486q.108-.468.432-.828.036-.036.252-.306t.342-.486.018-.216q1.26.144 1.8-.396.18-.18.414-.612t.378-.612q.324-.216.504-.198t.522.198.522.18q.504.036.558-.396t-.27-.72q.432.036.108-.612-.18-.252-.288-.324-.432-.144-.972.18-.288.144.072.288-.036-.036-.342.378t-.594.63-.576-.18q-.036-.036-.198-.486t-.342-.486q-.288 0-.576.54.108-.288-.396-.54t-.864-.288q.684-.432-.288-.972-.252-.144-.738-.18t-.702.144q-.18.252-.198.414t.18.288.378.198.414.144.306.108q.504.36.288.504l-.306.126-.414.162-.216.144q-.108.144 0 .504t-.072.504q-.18-.18-.324-.63t-.252-.594q.252.324-.9.216l-.36-.036q-.144 0-.576.072t-.738.036-.486-.288q-.144-.288 0-.72.036-.144.144-.072-.144-.108-.396-.342t-.36-.306q-1.656.54-3.384 1.476.216.036.432-.036.18-.072.468-.234t.36-.198q1.224-.504 1.512-.252l.18-.18q.504.576.72.9-.252-.144-1.08-.036-.72.216-.792.432.252.432.18.648-.144-.108-.414-.36t-.522-.396-.54-.18q-.576 0-.792.036-5.256 2.88-8.46 7.992.252.252.432.288.144.036.18.324t.09.396.414-.108q.324.288.108.684.036-.036 1.584.972.684.612.756.756.108.396-.36.648-.036-.072-.324-.324t-.324-.144q-.108.18.018.666t.378.45q-.252 0-.342.576t-.09 1.278-.036.846l.072.036q-.108.432.198 1.242t.774.702q-.468.108.72 1.548.216.288.288.324.108.072.432.27t.54.36.36.378q.144.18.36.81t.504.846q-.072.216.342.72t.378.828l-.09.036-.09.036q.108.252.558.504t.558.468q.036.108.072.36t.108.396.288.072q.072-.72-.864-2.232-.54-.9-.612-1.044-.108-.18-.198-.558t-.162-.522q.072 0 .216.054t.306.126.27.144.072.108q-.108.252.072.63t.432.666.612.684.432.468q.216.216.504.702t0 .486q.324 0 .72.36t.612.72q.18.288.288.936t.18.864q.072.252.306.486t.45.342l.576.288.468.252q.18.072.666.378t.774.414q.36.144.576.144t.522-.09.486-.126q.54-.072 1.044.54t.756.756q1.296.684 1.98.396-.072.036.018.27t.288.558.324.522.198.306q.18.216.648.54t.648.54q.216-.144.252-.324-.108.288.252.72t.648.36q.504-.108.504-1.152-1.116.54-1.764-.648l-.09-.198-.144-.306-.09-.306v-.27l.18-.108q.324 0 .36-.126t-.072-.45-.144-.468q-.036-.288-.396-.72t-.432-.54q-.18.324-.576.288t-.576-.324l-.054.198-.054.234q-.468 0-.54-.036.036-.108.09-.63t.126-.81q.036-.144.198-.432t.27-.522.144-.45-.162-.342-.63-.09q-.684.036-.936.72-.036.108-.108.378t-.18.414-.324.252q-.252.108-.864.072t-.864-.18q-.468-.288-.81-1.044t-.342-1.332q0-.36.09-.954t.108-.9-.198-.882q.108-.072.324-.342t.36-.378l.162-.054h.162l.144-.054.108-.216-.144-.108-.144-.108q.252.108 1.026-.054t.99.054q.54.396.792-.072 0-.036-.09-.342t-.018-.486q.18.972 1.044.324.108.108.558.18t.63.18l.252.198.198.162.18-.018.306-.234q.36.504.432.864.396 1.44.684 1.584.252.108.396.072t.162-.342 0-.504-.054-.45l-.036-.288v-.648l-.036-.288q-.54-.108-.666-.432t.054-.666.54-.666q.036-.036.288-.126t.558-.234.45-.288q.756-.684.54-1.26.252 0 .396-.324l-.18-.108-.27-.18-.162-.072q.324-.18.072-.576.18-.108.27-.396t.27-.36q.324.432.756.072.252-.288.036-.576.18-.252.738-.378t.666-.342q.252.072.288-.072t.036-.432.108-.432q.144-.18.54-.324t.468-.18l.612-.396q.108-.144 0-.144.648.072 1.116-.396.36-.396-.216-.72.108-.216-.108-.342t-.54-.198q.108-.036.414-.018t.378-.054q.54-.36-.252-.576-.612-.18-1.548.432zm-5.868 31.572q7.416-1.296 12.636-6.804-.108-.108-.45-.162t-.45-.126q-.648-.252-.864-.288.036-.252-.09-.468t-.288-.324-.45-.288-.396-.252l-.252-.216-.252-.198-.27-.162-.306-.072-.36.036-.108.036-.198.09-.198.108-.144.108v.09q-.756-.612-1.296-.792-.18-.036-.396-.198t-.378-.252-.36-.054-.414.252q-.18.18-.216.54t-.072.468q-.252-.18 0-.63t.072-.666q-.108-.216-.378-.162t-.432.162-.414.306-.324.234-.306.198-.306.27q-.108.144-.216.432t-.18.396q-.072-.144-.414-.234t-.342-.198q.072.36.144 1.26t.18 1.368q.252 1.116-.432 1.728-.972.9-1.044 1.44-.144.792.432.936 0 .252-.288.738t-.252.774q0 .216.072.576z",
		"WRENCH": "M13.824-11.447q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm23.184-15.12l-24.552 24.552q-1.332 1.332-3.24 1.332-1.872 0-3.276-1.332l-3.816-3.888q-1.368-1.296-1.368-3.24 0-1.908 1.368-3.276l24.516-24.516q1.404 3.528 4.122 6.246t6.246 4.122zm22.824-15.66q0 1.404-.828 3.816-1.692 4.824-5.922 7.83t-9.306 3.006q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q2.088 0 4.374.594t3.87 1.674q.576.396.576 1.008t-.576 1.008l-10.548 6.084v8.064l6.948 3.852q.18-.108 2.844-1.746t4.878-2.916 2.538-1.278q.54 0 .846.36t.306.9z",
		"TASKS": "M36.864-13.751h23.04v-4.608h-23.04v4.608zm-13.824-18.432h36.864v-4.608h-36.864v4.608zm23.04-18.432h13.824v-4.608h-13.824v4.608zm18.432 29.952v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-18.432v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-18.432v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62z",
		"FILTER": "M50.508-53.819q.612 1.476-.504 2.52l-17.748 17.748v26.712q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62v-17.496l-17.748-17.748q-1.116-1.044-.504-2.52.612-1.404 2.124-1.404h46.08q1.512 0 2.124 1.404z",
		"BRIEFCASE": "M23.04-55.223h18.432v-4.608h-18.432v4.608zm41.472 23.04v17.28q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-17.28h24.192v5.76q0 .936.684 1.62t1.62.684h11.52q.936 0 1.62-.684t.684-1.62v-5.76h24.192zm-27.648 0v4.608h-9.216v-4.608h9.216zm27.648-17.28v13.824h-64.512v-13.824q0-2.376 1.692-4.068t4.068-1.692h12.672v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h12.672q2.376 0 4.068 1.692t1.692 4.068z",
		"ARROWS_ALT": "M46.188-44.963l-12.78 12.78 12.78 12.78 5.184-5.184q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-1.512 0-2.124-1.44-.612-1.404.504-2.484l5.184-5.184-12.78-12.78-12.78 12.78 5.184 5.184q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l5.184 5.184 12.78-12.78-12.78-12.78-5.184 5.184q-.684.684-1.62.684-.432 0-.864-.18-1.44-.612-1.44-2.124v-16.128q0-.936.684-1.62t1.62-.684h16.128q1.512 0 2.124 1.44.612 1.404-.504 2.484l-5.184 5.184 12.78 12.78 12.78-12.78-5.184-5.184q-1.116-1.08-.504-2.484.612-1.44 2.124-1.44h16.128q.936 0 1.62.684t.684 1.62v16.128q0 1.512-1.404 2.124-.468.18-.9.18-.936 0-1.62-.684z",
		"USERS": "M21.348-32.183q-5.832.18-9.54 4.608h-4.824q-2.952 0-4.968-1.458t-2.016-4.266q0-12.708 4.464-12.708.216 0 1.566.756t3.51 1.53 4.284.774q2.412 0 4.788-.828-.18 1.332-.18 2.376 0 5.004 2.916 9.216zm38.556 22.932q0 4.32-2.628 6.822t-6.984 2.502h-31.464q-4.356 0-6.984-2.502t-2.628-6.822q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.36 0 1.548.774t2.628 1.728 3.852 1.728 4.86.774 4.86-.774 3.852-1.728 2.628-1.728 1.548-.774q2.196 0 4.014.72t3.078 1.926 2.232 2.916 1.548 3.51.954 3.906.504 3.924.126 3.726zm-36.864-45.972q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm25.344 13.824q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774zm20.736 8.1q0 2.808-2.016 4.266t-4.968 1.458h-4.824q-3.708-4.428-9.54-4.608 2.916-4.212 2.916-9.216 0-1.044-.18-2.376 2.376.828 4.788.828 2.124 0 4.284-.774t3.51-1.53 1.566-.756q4.464 0 4.464 12.708zm-4.608-21.924q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516z",
		"LINK": "M52.416-20.663q0-1.44-1.008-2.448l-7.488-7.488q-1.008-1.008-2.448-1.008-1.512 0-2.592 1.152.108.108.684.666t.774.774.54.684.468.918.126.99q0 1.44-1.008 2.448t-2.448 1.008q-.54 0-.99-.126t-.918-.468-.684-.54-.774-.774-.666-.684q-1.188 1.116-1.188 2.628 0 1.44 1.008 2.448l7.416 7.452q.972.972 2.448.972 1.44 0 2.448-.936l5.292-5.256q1.008-1.008 1.008-2.412zm-25.308-25.38q0-1.44-1.008-2.448l-7.416-7.452q-1.008-1.008-2.448-1.008-1.404 0-2.448.972l-5.292 5.256q-1.008 1.008-1.008 2.412 0 1.44 1.008 2.448l7.488 7.488q.972.972 2.448.972 1.512 0 2.592-1.116-.108-.108-.684-.666t-.774-.774-.54-.684-.468-.918-.126-.99q0-1.44 1.008-2.448t2.448-1.008q.54 0 .99.126t.918.468.684.54.774.774.666.684q1.188-1.116 1.188-2.628zm32.22 25.38q0 4.32-3.06 7.308l-5.292 5.256q-2.988 2.988-7.308 2.988-4.356 0-7.344-3.06l-7.416-7.452q-2.988-2.988-2.988-7.308 0-4.428 3.168-7.524l-3.168-3.168q-3.096 3.168-7.488 3.168-4.32 0-7.344-3.024l-7.488-7.488q-3.024-3.024-3.024-7.344t3.06-7.308l5.292-5.256q2.988-2.988 7.308-2.988 4.356 0 7.344 3.06l7.416 7.452q2.988 2.988 2.988 7.308 0 4.428-3.168 7.524l3.168 3.168q3.096-3.168 7.488-3.168 4.32 0 7.344 3.024l7.488 7.488q3.024 3.024 3.024 7.344z",
		"CLOUD": "M69.12-22.967q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.752 2.556-8.694t6.732-5.886q-.072-1.008-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.688 0 10.314 3.168t6.75 8.28q2.52-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.7-1.476 4.968 4.644 1.08 7.668 4.842t3.024 8.622z",
		"FLASK": "M54.972-12.311q2.016 3.204.774 5.49t-5.058 2.286h-41.472q-3.816 0-5.058-2.286t.774-5.49l18.108-28.548v-14.364h-2.304q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h18.432q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-2.304v14.364zm-28.044-26.1l-9.792 15.444h25.632l-9.792-15.444-.72-1.116v-15.696000000000002h-4.608v15.696000000000002z",
		"SCISSORS": "M34.56-32.183q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684zm10.8 2.304l18.252 14.328q1.008.72.9 2.016-.18 1.26-1.26 1.836l-4.608 2.304q-.468.252-1.044.252-.612 0-1.116-.288l-24.84-13.932-3.96 2.376q-.288.144-.432.18.504 1.764.36 3.492-.252 2.772-2.016 5.31t-4.752 4.446q-4.752 3.024-9.972 3.024-4.896 0-7.992-2.808-3.24-3.024-2.844-7.452.252-2.736 2.016-5.292t4.716-4.464q4.752-3.024 10.008-3.024 2.988 0 5.436 1.116.324-.468.792-.792l4.392-2.628-4.392-2.628q-.468-.324-.792-.792-2.448 1.116-5.436 1.116-5.256 0-10.008-3.024-2.952-1.908-4.716-4.464t-2.016-5.292q-.18-2.124.558-4.068t2.286-3.348q3.06-2.844 7.992-2.844 5.22 0 9.972 3.024 2.988 1.872 4.752 4.428t2.016 5.328q.144 1.728-.36 3.492.144.036.432.18l3.96 2.376 24.84-13.932q.504-.288 1.116-.288.576 0 1.044.252l4.608 2.304q1.08.576 1.26 1.836.108 1.296-.9 2.016zm-24.516-9.36q1.656-1.512.756-3.888t-3.816-4.212q-3.312-2.124-6.912-2.124-2.664 0-4.068 1.296-1.656 1.512-.756 3.888t3.816 4.212q3.312 2.124 6.912 2.124 2.664 0 4.068-1.296zm-3.06 26.82q2.916-1.836 3.816-4.212t-.756-3.888q-1.404-1.296-4.068-1.296-3.6 0-6.912 2.124-2.916 1.836-3.816 4.212t.756 3.888q1.404 1.296 4.068 1.296 3.6 0 6.912-2.124zm6.408-22.068l3.456 2.088v-.396q0-1.296 1.188-2.016l.504-.288-2.844-1.692-.936.936q-.108.108-.36.396t-.432.432l-.144.126-.108.09zm8.064 8.064l3.456 1.152 26.496-20.736-4.608-2.304-27.648 15.516v4.068l-5.76 3.456.324.288.252.216q.144.144.396.432t.396.432l.936.936zm25.344 14.976l4.608-2.304-18.72-14.688-6.372 4.968q-.072.108-.468.252z",
		"FILES_O": "M61.056-50.615q1.44 0 2.448 1.008t1.008 2.448v43.776q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-10.368h-19.584q-1.44 0-2.448-1.008t-1.008-2.448v-24.192q0-1.44.72-3.168t1.728-2.736l14.688-14.688q1.008-1.008 2.736-1.728t3.168-.72h14.976q1.44 0 2.448 1.008t1.008 2.448v11.808q2.448-1.44 4.608-1.44h14.976zm-19.584 7.668l-10.764 10.764h10.764v-10.764zm-23.04-13.824l-10.764 10.764h10.764v-10.764zm7.056 23.292l11.376-11.376v-14.976h-13.824v14.976q0 1.44-1.008 2.448t-2.448 1.008h-14.976v23.04h18.432v-9.216q0-1.44.72-3.168t1.728-2.736zm34.416 28.944v-41.472h-13.824v14.976q0 1.44-1.008 2.448t-2.448 1.008h-14.976v23.04h32.256z",
		"PAPERCLIP": "M50.544-14.579q0 4.212-2.844 7.056t-7.056 2.844q-4.86 0-8.46-3.6l-27.972-27.936q-4.068-4.14-4.068-9.756 0-5.724 3.96-9.72t9.684-3.996q5.688 0 9.828 4.068l21.78 21.816q.36.36.36.792 0 .576-1.098 1.674t-1.674 1.098q-.468 0-.828-.36l-21.816-21.852q-2.844-2.772-6.516-2.772-3.816 0-6.444 2.7t-2.628 6.516q0 3.78 2.736 6.516l27.936 27.972q2.268 2.268 5.22 2.268 2.304 0 3.816-1.512t1.512-3.816q0-2.952-2.268-5.22l-20.916-20.916q-.936-.864-2.16-.864-1.044 0-1.728.684t-.684 1.728q0 1.152.9 2.124l14.76 14.76q.36.36.36.792 0 .576-1.116 1.692t-1.692 1.116q-.432 0-.792-.36l-14.76-14.76q-2.268-2.196-2.268-5.364 0-2.952 2.052-5.004t5.004-2.052q3.168 0 5.364 2.268l20.916 20.916q3.6 3.528 3.6 8.46z",
		"SAVE": "M13.824-9.143h27.648v-13.824h-27.648v13.824zm32.256 0h4.608v-32.256q0-.504-.36-1.386t-.72-1.242l-10.116-10.116q-.36-.36-1.224-.72t-1.404-.36v14.976q0 1.44-1.008 2.448t-2.448 1.008h-20.736q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-4.608v46.08h4.608v-14.976q0-1.44 1.008-2.448t2.448-1.008h29.952q1.44 0 2.448 1.008t1.008 2.448v14.976zm-13.824-33.408v-11.52q0-.468-.342-.81t-.81-.342h-6.912q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h6.912q.468 0 .81-.342t.342-.81zm23.04 1.152v33.408q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h33.408q1.44 0 3.168.72t2.736 1.728l10.08 10.08q1.008 1.008 1.728 2.736t.72 3.168z",
		"SQUARE": "M55.296-49.463v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"REORDER": "M55.296-16.055v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm0-18.432v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm0-18.432v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z",
		"LIST_UL": "M13.824-13.751q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm0-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm50.688 14.976v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81zm-50.688-33.408q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm50.688 14.976v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81zm0-18.432v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81z",
		"LIST_OL": "M13.716-6.119q0 2.88-1.962 4.536t-4.878 1.656q-3.816 0-6.192-2.376l2.052-3.168q1.764 1.62 3.816 1.62 1.044 0 1.818-.522t.774-1.53q0-2.304-3.78-2.016l-.936-2.016q.288-.36 1.17-1.566t1.53-1.944 1.332-1.386v-.036q-.576 0-1.746.036t-1.746.036v1.908h-3.816v-5.472h11.988v3.168l-3.42 4.14q1.836.432 2.916 1.764t1.08 3.168zm.072-22.572v5.724h-13.032q-.216-1.296-.216-1.944 0-1.836.846-3.348t2.034-2.448 2.376-1.71 2.034-1.566.846-1.62q0-.9-.522-1.386t-1.422-.486q-1.656 0-2.916 2.088l-3.06-2.124q.864-1.836 2.574-2.862t3.798-1.026q2.628 0 4.428 1.494t1.8 4.05q0 1.8-1.224 3.294t-2.7 2.322-2.718 1.818-1.278 1.89h4.572v-2.16h3.78zm50.724 11.484v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.504.324-.828t.828-.324h43.776q.468 0 .81.342t.342.81zm-50.688-32.364v3.564h-12.06v-3.564h3.852q0-1.476.018-4.392t.018-4.356v-.432h-.072q-.288.612-1.8 1.944l-2.556-2.736 4.896-4.572h3.816v14.544h3.888zm50.688 13.932v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.504.324-.828t.828-.324h43.776q.468 0 .81.342t.342.81zm0-18.432v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81z",
		"STRIKETHROUGH": "M63.36-32.183q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-62.208q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h62.208zm-45.972-2.304q-1.008-1.26-1.836-2.88-1.728-3.492-1.728-6.768 0-6.516 4.824-11.124 4.788-4.572 14.148-4.572 1.8 0 6.012.684 2.376.432 6.372 1.728.36 1.368.756 4.248.504 4.428.504 6.588 0 .648-.18 1.62l-.432.108-3.024-.216-.504-.072q-1.8-5.364-3.708-7.38-3.168-3.276-7.56-3.276-4.104 0-6.552 2.124-2.412 2.088-2.412 5.256 0 2.628 2.376 5.04t10.044 4.644q2.484.72 6.228 2.376 2.088 1.008 3.42 1.872h-26.748zm18.252 9.216h14.796q.252 1.404.252 3.312 0 3.996-1.476 7.632-.828 1.98-2.556 3.744-1.332 1.26-3.924 2.916-2.88 1.728-5.508 2.376-2.88.756-7.308.756-4.104 0-7.02-.828l-5.04-1.44q-2.052-.576-2.592-1.008-.288-.288-.288-.792v-.468q0-3.888-.072-5.616-.036-1.08 0-2.448l.072-1.332v-1.584l3.672-.072q.54 1.224 1.08 2.556t.81 2.016.45.972q1.26 2.052 2.88 3.384 1.548 1.296 3.78 2.052 2.124.792 4.752.792 2.304 0 5.004-.972 2.772-.936 4.392-3.096 1.692-2.196 1.692-4.644 0-3.024-2.916-5.652-1.224-1.044-4.932-2.556z",
		"UNDERLINE": "M1.728-56.411q-1.332-.072-1.62-.144l-.108-3.168q.468-.036 1.44-.036 2.16 0 4.032.144 4.752.252 5.976.252 3.096 0 6.048-.108 4.176-.144 5.256-.18 2.016 0 3.096-.072l-.036.504.072 2.304v.324q-2.16.324-4.464.324-2.16 0-2.844.9-.468.504-.468 4.752 0 .468.018 1.17t.018.918l.036 8.244.504 10.08q.216 4.464 1.836 7.272 1.26 2.124 3.456 3.312 3.168 1.692 6.372 1.692 3.744 0 6.876-1.008 2.016-.648 3.564-1.836 1.728-1.296 2.34-2.304 1.296-2.016 1.908-4.104.756-2.628.756-8.244 0-2.844-.126-4.608t-.396-4.41-.486-5.742l-.144-2.124q-.18-2.412-.864-3.168-1.224-1.26-2.772-1.224l-3.6.072-.504-.108.072-3.096h3.024l7.38.36q2.736.108 7.056-.36l.648.072q.216 1.368.216 1.836 0 .252-.144 1.116-1.62.432-3.024.468-2.628.396-2.844.612-.54.54-.54 1.476 0 .252.054.972t.054 1.116q.288.684.792 14.256.216 7.02-.54 10.944-.54 2.736-1.476 4.392-1.368 2.34-4.032 4.428-2.7 2.052-6.552 3.204-3.924 1.188-9.18 1.188-6.012 0-10.224-1.656-4.284-1.692-6.444-4.392-2.196-2.736-2.988-7.02-.576-2.88-.576-8.532v-11.988q0-6.768-.612-7.668-.9-1.296-5.292-1.404zm53.568 50.724v-2.304q0-.504-.324-.828t-.828-.324h-52.992q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h52.992q.504 0 .828-.324t.324-.828z",
		"TABLE": "M18.432-14.903v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm-18.432-27.648v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm-18.432-27.648v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm4.608-11.52v39.168q0 2.376-1.692 4.068t-4.068 1.692h-48.384q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h48.384q2.376 0 4.068 1.692t1.692 4.068z",
		"MAGIC": "M42.84-43.523l10.548-10.548-3.852-3.852-10.548 10.548zm16.092-10.548q0 .972-.648 1.62l-46.296 46.296q-.648.648-1.62.648t-1.62-.648l-7.128-7.128q-.648-.648-.648-1.62t.648-1.62l46.296-46.296q.648-.648 1.62-.648t1.62.648l7.128 7.128q.648.648.648 1.62zm-48.636-6.84l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528zm12.6 5.832l7.056 2.16-7.056 2.16-2.16 7.056-2.16-7.056-7.056-2.16 7.056-2.16 2.16-7.056zm33.48 17.208l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528zm-23.04-23.04l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528z",
		"TRUCK": "M23.04-13.751q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm-13.824-18.432h13.824v-9.216h-5.688q-.468 0-.792.324l-7.02 7.02q-.324.324-.324.792v1.08zm46.08 18.432q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm9.216-39.168v36.864q0 .54-.144.954t-.486.666-.594.414-.846.216-.81.072-.918 0-.81-.018q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-13.824q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-2.304q-.108 0-.81.018t-.918 0-.81-.072-.846-.216-.594-.414-.486-.666-.144-.954q0-.936.684-1.62t1.62-.684v-11.52q0-.288-.018-1.26t0-1.368.09-1.242.234-1.332.504-1.098.81-1.08l7.128-7.128q.684-.684 1.818-1.152t2.106-.468h5.76v-6.912q0-.936.684-1.62t1.62-.684h36.864q.936 0 1.62.684t.684 1.62z",
		"PINTEREST": "M55.296-32.183q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708q-3.996 0-7.848-1.152 2.124-3.348 2.808-5.904.324-1.224 1.944-7.596.72 1.404 2.628 2.43t4.104 1.026q4.356 0 7.776-2.466t5.292-6.786 1.872-9.72q0-4.104-2.142-7.704t-6.21-5.868-9.18-2.268q-3.78 0-7.056 1.044t-5.562 2.772-3.924 3.978-2.412 4.662-.774 4.824q0 3.744 1.44 6.588t4.212 3.996q1.08.432 1.368-.72.072-.252.288-1.116t.288-1.08q.216-.828-.396-1.548-1.836-2.196-1.836-5.436 0-5.436 3.762-9.342t9.846-3.906q5.436 0 8.478 2.952t3.042 7.668q0 6.12-2.466 10.404t-6.318 4.284q-2.196 0-3.528-1.566t-.828-3.762q.288-1.26.954-3.366t1.08-3.708.414-2.718q0-1.8-.972-2.988t-2.772-1.188q-2.232 0-3.78 2.052t-1.548 5.112q0 2.628.9 4.392l-3.564 15.048q-.612 2.52-.468 6.372-7.416-3.276-11.988-10.116t-4.572-15.228q0-7.524 3.708-13.878t10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"PINTEREST_SQUARE": "M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-26.1q3.06-4.392 3.888-7.56.324-1.224 1.908-7.524.756 1.404 2.646 2.412t4.05 1.008q6.516 0 10.638-5.31t4.122-13.446q0-3.024-1.26-5.85t-3.474-5.004-5.49-3.492-7.092-1.314q-3.744 0-7.002 1.026t-5.508 2.754-3.87 3.942-2.394 4.608-.774 4.77q0 3.672 1.422 6.48t4.194 3.96q.468.18.846 0t.522-.684q.36-1.584.54-2.196.216-.828-.396-1.512-1.8-2.232-1.8-5.4 0-5.4 3.726-9.234t9.738-3.834q5.364 0 8.37 2.916t3.006 7.56q0 6.048-2.43 10.296t-6.246 4.248q-2.16 0-3.492-1.566t-.828-3.726q.288-1.224.954-3.33t1.062-3.672.396-2.682q0-1.764-.954-2.934t-2.718-1.17q-2.196 0-3.726 2.034t-1.53 5.022q0 2.592.864 4.356l-3.528 14.904q-.864 3.6-.252 9.144h-6.588q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56z",
		"GOOGLE_PLUS_SQUARE": "M33.012-31.859q0-.936-.216-2.304h-13.032v4.752h7.812q-.108.864-.594 1.8t-1.35 1.908-2.394 1.602-3.474.63q-3.564 0-6.084-2.556t-2.52-6.156 2.52-6.156 6.084-2.556q3.312 0 5.508 2.124l3.744-3.636q-3.888-3.6-9.252-3.6-5.76 0-9.792 4.05t-4.032 9.774 4.032 9.774 9.792 4.05q5.94 0 9.594-3.78t3.654-9.72zm12.42 1.656h3.924v-3.96h-3.924v-3.96h-3.96v3.96h-3.96v3.96h3.96v3.96h3.96v-3.96zm9.864-19.26v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"GOOGLE_PLUS": "M51.732-31.571q0 7.488-3.132 13.338t-8.928 9.144-13.284 3.294q-5.364 0-10.26-2.088t-8.424-5.616-5.616-8.424-2.088-10.26 2.088-10.26 5.616-8.424 8.424-5.616 10.26-2.088q10.296 0 17.676 6.912l-7.164 6.876q-4.212-4.068-10.512-4.068-4.428 0-8.19 2.232t-5.958 6.066-2.196 8.37 2.196 8.37 5.958 6.066 8.19 2.232q2.988 0 5.49-.828t4.122-2.07 2.826-2.826 1.764-2.988.774-2.664h-14.976v-9.072h24.912q.432 2.268.432 4.392zm31.212-4.392v7.56h-7.524v7.524h-7.56v-7.524h-7.524v-7.56h7.524v-7.524h7.56v7.524h7.524z",
		"MONEY": "M27.648-22.967h13.824v-3.456h-4.608v-16.128h-4.104l-5.328 4.932 2.772 2.88q1.512-1.332 1.98-2.052h.072v10.368h-4.608v3.456zm18.432-9.216q0 2.52-.756 5.112t-2.142 4.824-3.654 3.636-4.968 1.404-4.968-1.404-3.654-3.636-2.142-4.824-.756-5.112.756-5.112 2.142-4.824 3.654-3.636 4.968-1.404 4.968 1.404 3.654 3.636 2.142 4.824.756 5.112zm18.432 9.216v-18.432q-3.816 0-6.516-2.7t-2.7-6.516h-41.472q0 3.816-2.7 6.516t-6.516 2.7v18.432q3.816 0 6.516 2.7t2.7 6.516h41.472q0-3.816 2.7-6.516t6.516-2.7zm4.608-29.952v41.472q0 .936-.684 1.62t-1.62.684h-64.512q-.936 0-1.62-.684t-.684-1.62v-41.472q0-.936.684-1.62t1.62-.684h64.512q.936 0 1.62.684t.684 1.62z",
		"CARET_DOWN": "M36.864-39.095q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62z",
		"CARET_UP": "M36.864-20.663q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z",
		"CARET_LEFT": "M23.04-48.311v32.256q0 .936-.684 1.62t-1.62.684-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684.684 1.62z",
		"CARET_RIGHT": "M20.736-32.183q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684-.684-1.62v-32.256q0-.936.684-1.62t1.62-.684 1.62.684l16.128 16.128q.684.684.684 1.62z",
		"COLUMNS": "M5.76-9.143h21.888v-41.472h-23.04v40.32q0 .468.342.81t.81.342zm49.536-1.152v-40.32h-23.04v41.472h21.888q.468 0 .81-.342t.342-.81zm4.608-43.776v43.776q0 2.376-1.692 4.068t-4.068 1.692h-48.384q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h48.384q2.376 0 4.068 1.692t1.692 4.068z",
		"UNSORTED": "M36.864-25.271q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62zm0-13.824q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z",
		"SORT_DOWN": "M36.864-25.271q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62z",
		"SORT_UP": "M36.864-39.095q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z",
		"ENVELOPE": "M64.512-38.879v28.584q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-28.584q1.584 1.764 3.636 3.132 13.032 8.856 17.892 12.42 2.052 1.512 3.33 2.358t3.402 1.728 3.96.882h.072q1.836 0 3.96-.882t3.402-1.728 3.33-2.358q6.12-4.428 17.928-12.42 2.052-1.404 3.6-3.132zm0-10.584q0 2.844-1.764 5.436t-4.392 4.428q-13.536 9.396-16.848 11.7-.36.252-1.53 1.098t-1.944 1.368-1.872 1.17-2.07.972-1.8.324h-.072q-.828 0-1.8-.324t-2.07-.972-1.872-1.17-1.944-1.368-1.53-1.098q-3.276-2.304-9.432-6.57t-7.38-5.13q-2.232-1.512-4.212-4.158t-1.98-4.914q0-2.808 1.494-4.68t4.266-1.872h52.992q2.34 0 4.05 1.692t1.71 4.068z",
		"LINKEDIN": "M12.564-41.939v35.676h-11.88v-35.676h11.88zm.756-11.016q.036 2.628-1.818 4.392t-4.878 1.764h-.072q-2.952 0-4.752-1.764t-1.8-4.392q0-2.664 1.854-4.41t4.842-1.746 4.788 1.746 1.836 4.41zm41.976 26.244v20.448h-11.844v-19.08q0-3.78-1.458-5.922t-4.554-2.142q-2.268 0-3.798 1.242t-2.286 3.078q-.396 1.08-.396 2.916v19.908h-11.844q.072-14.364.072-23.292t-.036-10.656l-.036-1.728h11.844v5.184h-.072q.72-1.152 1.476-2.016t2.034-1.872 3.132-1.566 4.122-.558q6.156 0 9.9 4.086t3.744 11.97z",
		"UNDO": "M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196q-6.192 0-11.772-2.61t-9.504-7.362q-.252-.36-.234-.81t.306-.738l4.932-4.968q.36-.324.9-.324.576.072.828.432 2.628 3.42 6.444 5.292t8.1 1.872q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458q-3.528 0-6.768 1.278t-5.76 3.654l4.932 4.968q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l4.68 4.644q3.852-3.636 8.802-5.634t10.242-1.998q5.616 0 10.728 2.196t8.82 5.904 5.904 8.82 2.196 10.728z",
		"LEGAL": "M63.756-9.143q0 1.908-1.332 3.24l-3.852 3.888q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-13.068-13.104q-1.368-1.296-1.368-3.24 0-1.908 1.548-3.456l-9.216-9.216-4.536 4.536q-.504.504-1.224.504t-1.224-.504q.072.072.45.432t.45.468.36.414.36.486.216.486.198.594.054.648q0 1.368-1.008 2.448-.108.108-.594.648t-.684.738-.666.594-.792.558-.792.324-.936.162q-1.44 0-2.448-1.008l-14.688-14.688q-1.008-1.008-1.008-2.448 0-.468.162-.936t.324-.792.558-.792.594-.666.738-.684.648-.594q1.08-1.008 2.448-1.008.36 0 .648.054t.594.198.486.216.486.36.414.36.468.45.432.45q-.504-.504-.504-1.224t.504-1.224l12.528-12.528q.504-.504 1.224-.504t1.224.504q-.072-.072-.45-.432t-.45-.468-.36-.414-.36-.486-.216-.486-.198-.594-.054-.648q0-1.368 1.008-2.448.108-.108.594-.648t.684-.738.666-.594.792-.558.792-.324.936-.162q1.44 0 2.448 1.008l14.688 14.688q1.008 1.008 1.008 2.448 0 .468-.162.936t-.324.792-.558.792-.594.666-.738.684-.648.594q-1.08 1.008-2.448 1.008-.36 0-.648-.054t-.594-.198-.486-.216-.486-.36-.414-.36-.468-.45-.432-.45q.504.504.504 1.224t-.504 1.224l-4.536 4.536 9.216 9.216q1.548-1.548 3.456-1.548 1.872 0 3.276 1.332l13.068 13.068q1.332 1.404 1.332 3.276z",
		"TACHOMETER": "M13.824-22.967q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm6.912-16.128q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm15.408 17.316l3.636-13.752q.216-.936-.27-1.746t-1.386-1.062-1.728.234-1.08 1.422l-3.636 13.752q-2.16.18-3.852 1.566t-2.268 3.546q-.72 2.772.72 5.256t4.212 3.204 5.256-.72 3.204-4.212q.576-2.16-.216-4.212t-2.592-3.276zm23.76-1.188q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-23.04-23.04q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm16.128 6.912q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm11.52 16.128q0 9.396-5.076 17.388-.684 1.044-1.944 1.044h-50.472q-1.26 0-1.944-1.044-5.076-7.956-5.076-17.388 0-6.552 2.556-12.528t6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"COMMENT_O": "M32.256-50.615q-7.344 0-13.734 2.502t-10.152 6.75-3.762 9.18q0 4.032 2.574 7.686t7.254 6.318l3.132 1.8-.972 3.456q-.864 3.276-2.52 6.192 5.472-2.268 9.9-6.156l1.548-1.368 2.052.216q2.484.288 4.68.288 7.344 0 13.734-2.502t10.152-6.75 3.762-9.18-3.762-9.18-10.152-6.75-13.734-2.502zm32.256 18.432q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792h-.18q-.54 0-.972-.378t-.576-.99v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-6.264 4.32-11.574t11.736-8.388 16.2-3.078 16.2 3.078 11.736 8.388 4.32 11.574z",
		"COMMENTS_O": "M25.344-50.615q-5.508 0-10.296 1.872t-7.614 5.076-2.826 6.876q0 2.952 1.908 5.688t5.364 4.752l3.492 2.016-1.26 3.024q1.224-.72 2.232-1.404l1.584-1.116 1.908.36q2.808.504 5.508.504 5.508 0 10.296-1.872t7.614-5.076 2.826-6.876-2.826-6.876-7.614-5.076-10.296-1.872zm0-4.608q6.876 0 12.726 2.466t9.234 6.714 3.384 9.252-3.384 9.252-9.234 6.714-12.726 2.466q-3.096 0-6.336-.576-4.464 3.168-10.008 4.608-1.296.324-3.096.576h-.108q-.396 0-.738-.288t-.414-.756q-.036-.108-.036-.234t.018-.234.072-.216l.09-.18.126-.198.144-.18.162-.18.144-.162q.18-.216.828-.9t.936-1.062.81-1.044.9-1.386.738-1.584q-4.464-2.592-7.02-6.372t-2.556-8.064q0-5.004 3.384-9.252t9.234-6.714 12.726-2.466zm29.592 42.084q.36.864.738 1.584t.9 1.386.81 1.044.936 1.062.828.9l.144.162.162.18.144.18.126.198.09.18.072.216.018.234-.036.234q-.108.504-.468.792t-.792.252q-1.8-.252-3.096-.576-5.544-1.44-10.008-4.608-3.24.576-6.336.576-9.756 0-16.992-4.752 2.088.144 3.168.144 5.796 0 11.124-1.62t9.504-4.644q4.5-3.312 6.912-7.632t2.412-9.144q0-2.772-.828-5.472 4.644 2.556 7.344 6.408t2.7 8.28q0 4.32-2.556 8.082t-7.02 6.354z",
		"FLASH": "M31.86-44.063q.648.72.252 1.584l-19.44 41.652q-.468.9-1.512.9-.144 0-.504-.072-.612-.18-.918-.684t-.162-1.08l7.092-29.088-14.616 3.636q-.144.036-.432.036-.648 0-1.116-.396-.648-.54-.468-1.404l7.236-29.7q.144-.504.576-.828t1.008-.324h11.808q.684 0 1.152.45t.468 1.062q0 .288-.18.648l-6.156 16.668 14.256-3.528q.288-.072.432-.072.684 0 1.224.54z",
		"SITEMAP": "M64.512-19.511v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912h-18.432v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912h-18.432v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912q0-1.872 1.368-3.24t3.24-1.368h18.432v-6.912h-3.456q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-3.456v6.912h18.432q1.872 0 3.24 1.368t1.368 3.24v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448z",
		"UMBRELLA": "M32.256-34.631v20.88q0 3.744-2.736 6.48t-6.48 2.736-6.48-2.736-2.736-6.48q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62q0 1.8 1.404 3.204t3.204 1.404 3.204-1.404 1.404-3.204v-20.88q1.188-.396 2.304-.396t2.304.396zm27.648.972q0 .468-.342.81t-.81.342q-.396 0-.828-.36-1.764-1.656-3.348-2.484t-3.672-.828q-2.448 0-4.608 1.332t-3.708 3.492q-.252.36-.63 1.008t-.522.864q-.396.612-1.008.612-.648 0-1.044-.612-.144-.216-.522-.864t-.63-1.008q-1.548-2.16-3.69-3.492t-4.59-1.332-4.59 1.332-3.69 3.492q-.252.36-.63 1.008t-.522.864q-.396.612-1.044.612-.612 0-1.008-.612-.144-.216-.522-.864t-.63-1.008q-1.548-2.16-3.708-3.492t-4.608-1.332q-2.088 0-3.672.828t-3.348 2.484q-.432.36-.828.36-.468 0-.81-.342t-.342-.81q0-.18.036-.252 1.62-6.588 6.21-11.502t10.728-7.362 12.978-2.448q5.04 0 9.882 1.44t8.874 4.086 7.002 6.732 4.158 9.054q.036.072.036.252zm-27.648-26.172v3.528q-1.512-.072-2.304-.072t-2.304.072v-3.528q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62z",
		"PASTE": "M27.648-4.535h32.256v-23.04h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-13.824v41.472zm9.216-51.84v-2.304q0-.468-.342-.81t-.81-.342h-25.344q-.468 0-.81.342t-.342.81v2.304q0 .468.342.81t.81.342h25.344q.468 0 .81-.342t.342-.81zm9.216 24.192h10.764l-10.764-10.764v10.764zm18.432 4.608v24.192q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-19.584q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h39.168q1.44 0 2.448 1.008t1.008 2.448v11.808q.756.468 1.296 1.008l14.688 14.688q1.008 1.008 1.728 2.736t.72 3.168z",
		"LIGHTBULB_O": "M26.496-43.703q0 .468-.342.81t-.81.342-.81-.342-.342-.81q0-1.656-1.944-2.556t-3.816-.9q-.468 0-.81-.342t-.342-.81.342-.81.81-.342q1.8 0 3.582.576t3.132 1.944 1.35 3.24zm5.76 0q0-2.592-1.242-4.824t-3.24-3.654-4.428-2.232-4.914-.81-4.914.81-4.428 2.232-3.24 3.654-1.242 4.824q0 3.636 2.448 6.48.36.396 1.098 1.188t1.098 1.188q4.608 5.508 5.076 10.728h8.208q.468-5.22 5.076-10.728.36-.396 1.098-1.188t1.098-1.188q2.448-2.844 2.448-6.48zm4.608 0q0 5.58-3.708 9.648-1.62 1.764-2.682 3.132t-2.142 3.438-1.224 3.87q1.692 1.008 1.692 2.952 0 1.332-.9 2.304.9.972.9 2.304 0 1.872-1.62 2.916.468.828.468 1.692 0 1.656-1.134 2.556t-2.79.9q-.72 1.584-2.16 2.52t-3.132.936-3.132-.936-2.16-2.52q-1.656 0-2.79-.9t-1.134-2.556q0-.864.468-1.692-1.62-1.044-1.62-2.916 0-1.332.9-2.304-.9-.972-.9-2.304 0-1.944 1.692-2.952-.144-1.8-1.224-3.87t-2.142-3.438-2.682-3.132q-3.708-4.068-3.708-9.648 0-3.564 1.602-6.642t4.212-5.112 5.904-3.204 6.714-1.17 6.714 1.17 5.904 3.204 4.212 5.112 1.602 6.642z",
		"EXCHANGE": "M64.512-21.815v6.912q0 .468-.342.81t-.81.342h-49.536v6.912q0 .468-.342.81t-.81.342q-.432 0-.864-.36l-11.484-11.52q-.324-.324-.324-.792 0-.504.324-.828l11.52-11.52q.324-.324.828-.324.468 0 .81.342t.342.81v6.912h49.536q.468 0 .81.342t.342.81zm0-19.584q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-49.536q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h49.536v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828z",
		"CLOUD_DOWNLOAD": "M46.08-31.031q0-.504-.324-.828t-.828-.324h-8.064v-12.672q0-.468-.342-.81t-.81-.342h-6.912q-.468 0-.81.342t-.342.81v12.672h-8.064q-.468 0-.81.342t-.342.81q0 .504.324.828l12.672 12.672q.324.324.828.324t.828-.324l12.636-12.636q.36-.432.36-.864zm23.04 8.064q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.68 2.52-8.64t6.768-5.94q-.072-1.08-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.616 0 10.278 3.132t6.786 8.316q2.556-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.736-1.476 4.968 4.68 1.116 7.686 4.878t3.006 8.586z",
		"CLOUD_UPLOAD": "M46.08-33.335q0-.504-.324-.828l-12.672-12.672q-.324-.324-.828-.324t-.828.324l-12.636 12.636q-.36.432-.36.864 0 .504.324.828t.828.324h8.064v12.672q0 .468.342.81t.81.342h6.912q.468 0 .81-.342t.342-.81v-12.672h8.064q.468 0 .81-.342t.342-.81zm23.04 10.368q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.68 2.52-8.64t6.768-5.94q-.072-1.08-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.616 0 10.278 3.132t6.786 8.316q2.556-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.736-1.476 4.968 4.68 1.116 7.686 4.878t3.006 8.586z",
		"USER_MD": "M13.824-16.055q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm36.864 2.196q0 4.356-2.628 6.84t-6.984 2.484h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-2.448.198-4.716t.864-4.968 1.71-4.77 2.916-3.708 4.32-2.178q-.792 1.872-.792 4.32v7.308q-2.088.72-3.348 2.52t-1.26 3.996q0 2.88 2.016 4.896t4.896 2.016 4.896-2.016 2.016-4.896q0-2.196-1.278-3.996t-3.33-2.52v-7.308q0-2.232.9-3.348 4.752 3.744 10.62 3.744t10.62-3.744q.9 1.116.9 3.348v2.304q-3.816 0-6.516 2.7t-2.7 6.516v3.204q-1.152 1.044-1.152 2.556 0 1.44 1.008 2.448t2.448 1.008 2.448-1.008 1.008-2.448q0-1.512-1.152-2.556v-3.204q0-1.872 1.368-3.24t3.24-1.368 3.24 1.368 1.368 3.24v3.204q-1.152 1.044-1.152 2.556 0 1.44 1.008 2.448t2.448 1.008 2.448-1.008 1.008-2.448q0-1.512-1.152-2.556v-3.204q0-2.448-1.242-4.59t-3.366-3.366q0-.36.018-1.53t0-1.728-.09-1.494-.252-1.692-.468-1.44q2.448.54 4.32 2.178t2.916 3.708 1.71 4.77.864 4.968.198 4.716zm-11.52-32.148q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z",
		"STETHOSCOPE": "M46.08-39.095q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608 0q0 2.232-1.278 3.996t-3.33 2.52v14.22q0 5.724-4.734 9.774t-11.394 4.05-11.394-4.05-4.734-9.774v-4.752q-5.904-.72-9.864-4.608t-3.96-9.072v-18.432q0-.936.684-1.62t1.62-.684q.216 0 .576.072.612-1.08 1.692-1.728t2.34-.648q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35q-1.188 0-2.304-.648v14.472q0 3.816 3.384 6.516t8.136 2.7 8.136-2.7 3.384-6.516v-14.472q-1.116.648-2.304.648-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35q1.26 0 2.34.648t1.692 1.728q.36-.072.576-.072.936 0 1.62.684t.684 1.62v18.432q0 5.184-3.96 9.072t-9.864 4.608v4.752q0 3.816 3.384 6.516t8.136 2.7 8.136-2.7 3.384-6.516v-14.22q-2.052-.756-3.33-2.52t-1.278-3.996q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896z",
		"SUITCASE": "M23.04-50.615h18.432v-4.608h-18.432v4.608zm-12.672 0v46.08h-2.304q-3.312 0-5.688-2.376t-2.376-5.688v-29.952q0-3.312 2.376-5.688t5.688-2.376h2.304zm40.32 0v46.08h-36.864v-46.08h4.608v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h4.608zm13.824 8.064v29.952q0 3.312-2.376 5.688t-5.688 2.376h-2.304v-46.08h2.304q3.312 0 5.688 2.376t2.376 5.688z",
		"BELL": "M32.832-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm29.376-10.368q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-16.128q-1.872 0-3.24-1.368t-1.368-3.24q1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 6.84 1.008 11.052 5.706t4.212 10.17q0 5.004.702 9.36t1.8 7.416 2.682 5.706 3.06 4.302 3.276 3.168z",
		"COFFEE": "M59.904-41.399q0-2.88-2.016-4.896t-4.896-2.016h-2.304v13.824h2.304q2.88 0 4.896-2.016t2.016-4.896zm-59.904 27.648h64.512q0 3.816-2.7 6.516t-6.516 2.7h-46.08q-3.816 0-6.516-2.7t-2.7-6.516zm66.816-27.648q0 5.724-4.05 9.774t-9.774 4.05h-2.304v1.152q0 3.312-2.376 5.688t-5.688 2.376h-25.344q-3.312 0-5.688-2.376t-2.376-5.688v-26.496q0-.936.684-1.62t1.62-.684h41.472q5.724 0 9.774 4.05t4.05 9.774z",
		"CUTLERY": "M23.04-62.135v23.04q0 2.196-1.278 3.996t-3.33 2.52v28.044q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-28.044q-2.052-.72-3.33-2.52t-1.278-3.996v-23.04q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-14.976q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-14.976q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62zm27.648 0v57.6q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-18.432h-8.064q-.468 0-.81-.342t-.342-.81v-28.8q0-4.752 3.384-8.136t8.136-3.384h9.216q.936 0 1.62.684t.684 1.62z",
		"FILE_TEXT_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-36.864-31.104q0-.504.324-.828t.828-.324h25.344q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304zm26.496 8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h25.344zm0 9.216q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h25.344z",
		"BUILDING_O": "M13.824-17.207v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm18.432 9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216 49.536h13.824v-55.296h-41.472v55.296h13.824v-8.064q0-.468.342-.81t.81-.342h11.52q.468 0 .81.342t.342.81v8.064zm18.432-57.6v59.904q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62z",
		"HOSPITAL_O": "M13.824-17.207v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm18.432 9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216 31.104h13.824v-41.472h-9.216v1.152q0 1.44-1.008 2.448t-2.448 1.008h-16.128q-1.44 0-2.448-1.008t-1.008-2.448v-1.152h-9.216v41.472h13.824v-8.064q0-.468.342-.81t.81-.342h11.52q.468 0 .81.342t.342.81v8.064zm0-42.624v-11.52q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v3.456h-4.608v-3.456q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81v-3.456h4.608v3.456q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm18.432-1.152v46.08q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-46.08q0-.936.684-1.62t1.62-.684h11.52v-10.368q0-1.44 1.008-2.448t2.448-1.008h16.128q1.44 0 2.448 1.008t1.008 2.448v10.368h11.52q.936 0 1.62.684t.684 1.62z",
		"AMBULANCE": "M23.04-13.751q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-18.432h13.824v-9.216h-5.688q-.504.072-.792.324l-7.02 7.02q-.252.432-.324.792v1.08zm46.08 18.432q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm4.608-24.192v-6.912q0-.504-.324-.828t-.828-.324h-8.064v-8.064q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v8.064h-8.064q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h8.064v8.064q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828v-8.064h8.064q.504 0 .828-.324t.324-.828zm9.216-19.584v41.472q0 .936-.684 1.62t-1.62.684h-6.912q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-13.824q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684v-14.976q0-.936.468-2.088t1.152-1.836l7.128-7.128q.684-.684 1.836-1.152t2.088-.468h5.76v-11.52q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z",
		"MEDKIT": "M46.08-24.119v-6.912q0-.504-.324-.828t-.828-.324h-8.064v-8.064q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v8.064h-8.064q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h8.064v8.064q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828v-8.064h8.064q.504 0 .828-.324t.324-.828zm-23.04-26.496h18.432v-4.608h-18.432v4.608zm-13.824 0v46.08h-1.152q-3.312 0-5.688-2.376t-2.376-5.688v-29.952q0-3.312 2.376-5.688t5.688-2.376h1.152zm42.624 0v46.08h-39.168v-46.08h5.76v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h5.76zm12.672 8.064v29.952q0 3.312-2.376 5.688t-5.688 2.376h-1.152v-46.08h1.152q3.312 0 5.688 2.376t2.376 5.688z",
		"FIGHTER_JET": "M69.12-29.879q-.036 1.152-10.368 3.456l-12.672 1.152-8.064 2.304h-2.304l-10.548 12.672h2.484q.936 0 1.62.162t.684.414-.684.414-1.62.162h-11.52v-1.152h2.304v-14.976h-5.76l-6.912 8.064h-3.456l-1.152-1.152v-6.912h1.152v-1.152h4.608v-.288l-6.912-.864v-4.608l6.912-.864v-.288h-4.608v-1.152h-1.152v-6.912l1.152-1.152h3.456l6.912 8.064h5.76v-14.976h-2.304v-1.152h11.52q.936 0 1.62.162t.684.414-.684.414-1.62.162h-2.484l10.548 12.672h2.304l8.064 2.304 12.672 1.152q9.396 2.088 10.332 3.348z",
		"BEER": "M23.04-32.183v-13.824h-9.216v9.216q0 1.908 1.35 3.258t3.258 1.35h4.608zm36.864 16.128v6.912h-41.472v-6.912l4.608-6.912h-4.608q-5.724 0-9.774-4.05t-4.05-9.774v-11.52l-2.304-2.304 1.152-4.608h17.28l1.152-4.608h34.56l1.152 6.912-2.304 1.152v28.8z",
		"H_SQUARE": "M46.08-16.055v-32.256q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v11.52h-18.432v-11.52q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v32.256q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-11.52h18.432v11.52q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm9.216-33.408v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"PLUS_SQUARE": "M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-11.52v-11.52q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v11.52h-11.52q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h11.52v11.52q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-11.52h11.52q.936 0 1.62-.684t.684-1.62zm9.216-19.584v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"ANGLE_DOUBLE_LEFT": "M22.572-14.903q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828zm13.824 0q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828z",
		"ANGLE_DOUBLE_RIGHT": "M21.42-29.879q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828zm13.824 0q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z",
		"ANGLE_DOUBLE_UP": "M38.7-17.207q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828zm0-13.824q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z",
		"ANGLE_DOUBLE_DOWN": "M38.7-33.335q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828zm0-13.824q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z",
		"ANGLE_LEFT": "M22.572-44.855q0 .468-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828t-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z",
		"ANGLE_RIGHT": "M21.42-29.879q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z",
		"ANGLE_UP": "M38.7-21.815q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z",
		"ANGLE_DOWN": "M38.7-37.943q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z",
		"DESKTOP": "M64.512-28.727v-29.952q0-.468-.342-.81t-.81-.342h-57.6q-.468 0-.81.342t-.342.81v29.952q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81zm4.608-29.952v39.168q0 2.376-1.692 4.068t-4.068 1.692h-19.584q0 1.332.576 2.79t1.152 2.556.576 1.566q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62q0-.504.576-1.584t1.152-2.52.576-2.808h-19.584q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z",
		"LAPTOP": "M14.976-18.359q-2.376 0-4.068-1.692t-1.692-4.068v-25.344q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068v25.344q0 2.376-1.692 4.068t-4.068 1.692h-39.168zm-1.152-31.104v25.344q0 .468.342.81t.81.342h39.168q.468 0 .81-.342t.342-.81v-25.344q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81zm49.536 33.408h5.76v3.456q0 1.44-1.692 2.448t-4.068 1.008h-57.6q-2.376 0-4.068-1.008t-1.692-2.448v-3.456h63.36zm-25.92 3.456q.576 0 .576-.576t-.576-.576h-5.76q-.576 0-.576.576t.576.576h5.76z",
		"TABLET": "M23.04-13.751q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm13.824-5.76v-34.56q0-.468-.342-.81t-.81-.342h-29.952q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h29.952q.468 0 .81-.342t.342-.81zm4.608-34.56v39.168q0 2.376-1.692 4.068t-4.068 1.692h-29.952q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h29.952q2.376 0 4.068 1.692t1.692 4.068z",
		"MOBILE_PHONE": "M16.704-13.751q0-1.188-.846-2.034t-2.034-.846-2.034.846-.846 2.034.846 2.034 2.034.846 2.034-.846.846-2.034zm7.488-5.76v-25.344q0-.468-.342-.81t-.81-.342h-18.432q-.468 0-.81.342t-.342.81v25.344q0 .468.342.81t.81.342h18.432q.468 0 .81-.342t.342-.81zm-6.912-30.528q0-.576-.576-.576h-5.76q-.576 0-.576.576t.576.576h5.76q.576 0 .576-.576zm10.368-.576v36.864q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-36.864q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24z",
		"CIRCLE_O": "M27.648-51.767q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"QUOTE_LEFT": "M27.648-29.879v13.824q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-25.344q0-3.744 1.458-7.146t3.942-5.886 5.886-3.942 7.146-1.458h2.304q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-2.304q-3.816 0-6.516 2.7t-2.7 6.516v1.152q0 1.44 1.008 2.448t2.448 1.008h8.064q2.88 0 4.896 2.016t2.016 4.896zm32.256 0v13.824q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-25.344q0-3.744 1.458-7.146t3.942-5.886 5.886-3.942 7.146-1.458h2.304q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-2.304q-3.816 0-6.516 2.7t-2.7 6.516v1.152q0 1.44 1.008 2.448t2.448 1.008h8.064q2.88 0 4.896 2.016t2.016 4.896z",
		"QUOTE_RIGHT": "M27.648-52.919v25.344q0 3.744-1.458 7.146t-3.942 5.886-5.886 3.942-7.146 1.458h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304q3.816 0 6.516-2.7t2.7-6.516v-1.152q0-1.44-1.008-2.448t-2.448-1.008h-8.064q-2.88 0-4.896-2.016t-2.016-4.896v-13.824q0-2.88 2.016-4.896t4.896-2.016h13.824q2.88 0 4.896 2.016t2.016 4.896zm32.256 0v25.344q0 3.744-1.458 7.146t-3.942 5.886-5.886 3.942-7.146 1.458h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304q3.816 0 6.516-2.7t2.7-6.516v-1.152q0-1.44-1.008-2.448t-2.448-1.008h-8.064q-2.88 0-4.896-2.016t-2.016-4.896v-13.824q0-2.88 2.016-4.896t4.896-2.016h13.824q2.88 0 4.896 2.016t2.016 4.896z",
		"SPINNER": "M18.936-14.255q0 1.908-1.35 3.258t-3.258 1.35q-1.872 0-3.24-1.368t-1.368-3.24q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm17.928 7.416q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-25.344-25.344q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm43.272 17.928q0 1.872-1.368 3.24t-3.24 1.368q-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-34.704-35.856q0 2.376-1.692 4.068t-4.068 1.692-4.068-1.692-1.692-4.068 1.692-4.068 4.068-1.692 4.068 1.692 1.692 4.068zm42.12 17.928q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-23.04-25.344q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm19.08 7.416q0 3.348-2.376 5.706t-5.688 2.358q-3.348 0-5.706-2.358t-2.358-5.706q0-3.312 2.358-5.688t5.706-2.376q3.312 0 5.688 2.376t2.376 5.688z",
		"CIRCLE": "M55.296-32.183q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"REPLY": "M64.512-24.119q0 5.976-4.572 16.236-.108.252-.378.864t-.486 1.08-.468.792q-.432.612-1.008.612-.54 0-.846-.36t-.306-.9q0-.324.09-.954t.09-.846q.18-2.448.18-4.428 0-3.636-.63-6.516t-1.746-4.986-2.88-3.636-3.798-2.502-4.788-1.53-5.544-.774-6.318-.216h-8.064v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q.684-.684 1.62-.684t1.62.684.684 1.62v9.216h8.064q25.668 0 31.5 14.508 1.908 4.824 1.908 11.988z",
		"GITHUB_ALT": "M23.04-20.663q0 1.44-.45 2.952t-1.548 2.736-2.61 1.224-2.61-1.224-1.548-2.736-.45-2.952.45-2.952 1.548-2.736 2.61-1.224 2.61 1.224 1.548 2.736.45 2.952zm23.04 0q0 1.44-.45 2.952t-1.548 2.736-2.61 1.224-2.61-1.224-1.548-2.736-.45-2.952.45-2.952 1.548-2.736 2.61-1.224 2.61 1.224 1.548 2.736.45 2.952zm5.76 0q0-4.32-2.484-7.344t-6.732-3.024q-1.476 0-7.02.756-2.556.396-5.652.396t-5.652-.396q-5.472-.756-7.02-.756-4.248 0-6.732 3.024t-2.484 7.344q0 3.168 1.152 5.526t2.916 3.708 4.392 2.16 5.04 1.062 5.364.252h6.048q2.952 0 5.364-.252t5.04-1.062 4.392-2.16 2.916-3.708 1.152-5.526zm8.064-6.336q0 7.452-2.196 11.916-1.368 2.772-3.798 4.788t-5.076 3.096-6.12 1.71-6.174.792-6.012.162q-2.808 0-5.112-.108t-5.31-.45-5.49-1.08-4.932-1.854-4.356-2.916-3.096-4.14q-2.232-4.428-2.232-11.916 0-8.532 4.896-14.256-.972-2.952-.972-6.12 0-4.176 1.836-7.848 3.888 0 6.84 1.422t6.804 4.446q5.292-1.26 11.124-1.26 5.328 0 10.08 1.152 3.78-2.952 6.732-4.356t6.804-1.404q1.836 3.672 1.836 7.848 0 3.132-.972 6.048 4.896 5.76 4.896 14.328z",
		"FOLDER_O": "M55.296-17.207v-25.344q0-1.44-1.008-2.448t-2.448-1.008h-25.344q-1.44 0-2.448-1.008t-1.008-2.448v-2.304q0-1.44-1.008-2.448t-2.448-1.008h-11.52q-1.44 0-2.448 1.008t-1.008 2.448v34.56q0 1.44 1.008 2.448t2.448 1.008h43.776q1.44 0 2.448-1.008t1.008-2.448zm4.608-25.344v25.344q0 3.312-2.376 5.688t-5.688 2.376h-43.776q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h24.192q3.312 0 5.688 2.376t2.376 5.688z",
		"FOLDER_OPEN_O": "M64.116-30.923q0-1.26-1.908-1.26h-39.168q-1.44 0-3.078.774t-2.574 1.89l-10.584 13.068q-.648.864-.648 1.44 0 1.26 1.908 1.26h39.168q1.44 0 3.096-.792t2.556-1.908l10.584-13.068q.648-.792.648-1.404zm-41.076-5.868h27.648v-5.76q0-1.44-1.008-2.448t-2.448-1.008h-20.736q-1.44 0-2.448-1.008t-1.008-2.448v-2.304q0-1.44-1.008-2.448t-2.448-1.008h-11.52q-1.44 0-2.448 1.008t-1.008 2.448v30.708l9.216-11.34q1.584-1.908 4.176-3.15t5.04-1.242zm45.684 5.868q0 2.232-1.656 4.32l-10.62 13.068q-1.548 1.908-4.176 3.15t-5.04 1.242h-39.168q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h19.584q3.312 0 5.688 2.376t2.376 5.688v5.76h6.912q1.944 0 3.564.882t2.412 2.538q.54 1.152.54 2.448z",
		"SMILE_O": "M40.824-25.739q-1.332 4.356-4.968 7.02t-8.208 2.664-8.208-2.664-4.968-7.02q-.288-.9.144-1.746t1.368-1.134q.9-.288 1.746.144t1.134 1.368q.9 2.88 3.33 4.662t5.454 1.782 5.454-1.782 3.33-4.662q.288-.936 1.152-1.368t1.764-.144 1.332 1.134.144 1.746zm-17.784-15.66q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"FROWN_O": "M40.824-20.195q.288.9-.144 1.746t-1.332 1.134-1.764-.144-1.152-1.368q-.9-2.88-3.33-4.662t-5.454-1.782-5.454 1.782-3.33 4.662q-.288.936-1.134 1.368t-1.746.144q-.936-.288-1.368-1.134t-.144-1.746q1.332-4.356 4.968-7.02t8.208-2.664 8.208 2.664 4.968 7.02zm-17.784-21.204q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"MEH_O": "M41.472-25.271q0 .936-.684 1.62t-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h23.04q.936 0 1.62.684t.684 1.62zm-18.432-16.128q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"GAMEPAD": "M29.952-25.271v-4.608q0-.504-.324-.828t-.828-.324h-6.912v-6.912q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v6.912h-6.912q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h6.912v6.912q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828v-6.912h6.912q.504 0 .828-.324t.324-.828zm20.736 2.304q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm9.216-9.216q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm9.216 4.608q0 7.632-5.4 13.032t-13.032 5.4q-6.912 0-12.168-4.608h-7.92q-5.256 4.608-12.168 4.608-7.632 0-13.032-5.4t-5.4-13.032 5.4-13.032 13.032-5.4h32.256q7.632 0 13.032 5.4t5.4 13.032z",
		"KEYBOARD_O": "M13.824-22.391v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm4.608-9.216v3.456q0 .576-.576.576h-8.064q-.576 0-.576-.576v-3.456q0-.576.576-.576h8.064q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm36.864 18.432v3.456q0 .576-.576.576h-31.104q-.576 0-.576-.576v-3.456q0-.576.576-.576h31.104q.576 0 .576.576zm-23.04-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-18.432-18.432v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm9.216 0v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm9.216 0v12.672q0 .576-.576.576h-8.064q-.576 0-.576-.576v-3.456q0-.576.576-.576h4.032v-8.64q0-.576.576-.576h3.456q.576 0 .576.576zm4.608 27.072v-32.256h-59.904v32.256h59.904zm4.608-32.256v32.256q0 1.908-1.35 3.258t-3.258 1.35h-59.904q-1.908 0-3.258-1.35t-1.35-3.258v-32.256q0-1.908 1.35-3.258t3.258-1.35h59.904q1.908 0 3.258 1.35t1.35 3.258z",
		"FLAG_O": "M59.904-26.819v-22.176q-6.084 3.276-11.016 3.276-2.952 0-5.22-1.152-3.6-1.764-6.624-2.754t-6.408-.99q-6.228 0-14.508 4.572v21.564q8.82-4.068 15.588-4.068 1.98 0 3.726.27t3.528.936 2.772 1.116 2.97 1.422l1.008.504q1.584.792 3.636.792 4.32 0 10.548-3.312zm-48.384-28.404q0 1.26-.63 2.304t-1.674 1.656v45.576q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-45.576q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 1.404-1.26 2.052-.36.18-.612.324-7.848 4.176-13.284 4.176-3.168 0-5.688-1.26l-1.008-.504q-2.304-1.188-3.564-1.728t-3.276-1.044-4.104-.504q-3.672 0-8.478 1.584t-8.226 3.672q-.54.324-1.188.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-26.712q0-1.26 1.116-1.98 1.26-.756 2.826-1.53t4.104-1.872 5.49-1.782 5.58-.684q4.032 0 7.524 1.116t7.524 3.096q1.368.684 3.204.684 4.392 0 11.16-4.032l1.116-.612q1.116-.576 2.232.072 1.116.72 1.116 1.98z",
		"FLAG_CHECKERED": "M29.952-28.439v-6.912q-6.516.576-13.824 4.212v6.66q7.38-3.456 13.824-3.96zm0-15.048v-7.092q-6.192.288-13.824 4.536v6.804q7.74-3.996 13.824-4.248zm29.952 16.668v-6.624q-8.46 4.176-13.824 2.556v-8.064q-.72-.216-1.404-.54-.18-.108-1.188-.612t-1.242-.612-1.134-.54-1.242-.558-1.17-.468-1.296-.45-1.26-.306-1.422-.27-1.422-.144-1.584-.072q-.828 0-1.764.108v7.992h.684q3.672 0 6.93 1.044t7.11 2.952q.684.324 1.404.54v6.768q1.512.612 3.276.612 4.32 0 10.548-3.312zm0-15.372v-6.804q-6.084 3.276-11.016 3.276-1.62 0-2.808-.288v7.056q5.328 1.512 13.824-3.24zm-48.384-13.032q0 1.26-.63 2.304t-1.674 1.656v45.576q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-45.576q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 1.404-1.26 2.052-.36.18-.612.324-7.848 4.176-13.284 4.176-3.168 0-5.688-1.26l-1.008-.504q-2.304-1.188-3.564-1.728t-3.276-1.044-4.104-.504q-3.672 0-8.478 1.584t-8.226 3.672q-.54.324-1.188.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-26.712q0-1.26 1.116-1.98 1.26-.756 2.826-1.53t4.104-1.872 5.49-1.782 5.58-.684q4.032 0 7.524 1.116t7.524 3.096q1.368.684 3.204.684 4.392 0 11.16-4.032l1.116-.612q1.116-.576 2.232.072 1.116.72 1.116 1.98z",
		"TERMINAL": "M21.06-29.051l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828t-.36.828zm38.844 16.452v2.304q0 .504-.324.828t-.828.324h-34.56q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h34.56q.504 0 .828.324t.324.828z",
		"CODE": "M22.212-14.075l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828t-.36.828zm21.276-38.412l-13.428 46.476q-.144.468-.558.702t-.846.09l-2.232-.612q-.468-.144-.702-.558t-.09-.882l13.428-46.476q.144-.468.558-.702t.846-.09l2.232.612q.468.144.702.558t.09.882zm23.652 23.436l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828t-.36.828z",
		"REPLY_ALL": "M23.04-25.487v2.52q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v2.484l-14.292 14.328q-.684.684-.684 1.62t.684 1.62zm41.472 1.368q0 2.088-.612 4.806t-1.386 4.968-1.728 4.5-1.458 3.258l-.72 1.44q-.288.612-1.008.612-.216 0-.324-.036-.9-.288-.828-1.224 1.548-14.4-3.816-20.34-2.304-2.556-6.138-3.978t-9.63-1.89v9.036q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v9.432q14.796 1.008 21.564 7.956 6.084 6.228 6.084 18.324z",
		"STAR_HALF_O": "M42.696-29.987l9.252-9-12.816-1.872-2.376-.36-1.08-2.16-5.724-11.592v34.668l2.124 1.116 11.448 6.048-2.16-12.78-.432-2.376zm16.272-9.432l-13.068 12.744 3.096 18q.18 1.188-.216 1.854t-1.224.666q-.612 0-1.44-.432l-16.164-8.496-16.164 8.496q-.828.432-1.44.432-.828 0-1.224-.666t-.216-1.854l3.096-18-13.104-12.744q-1.152-1.152-.828-2.142t1.944-1.242l18.072-2.628 8.1-16.38q.72-1.476 1.764-1.476 1.008 0 1.764 1.476l8.1 16.38 18.072 2.628q1.62.252 1.944 1.242t-.864 2.142z",
		"LOCATION_ARROW": "M50.436-51.875l-23.04 46.08q-.612 1.26-2.052 1.26-.18 0-.54-.072-.792-.18-1.278-.81t-.486-1.422v-20.736h-20.736q-.792 0-1.422-.486t-.81-1.278.144-1.512 1.044-1.08l46.08-23.04q.468-.252 1.044-.252.972 0 1.62.684.54.504.666 1.242t-.234 1.422z",
		"CROP": "M20.052-18.359h21.42v-21.42zm-1.62-1.62l21.42-21.42h-21.42v21.42zm41.472 2.772v6.912q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-8.064h-31.104q-.504 0-.828-.324t-.324-.828v-31.104h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064v-8.064q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v8.064h30.636l8.856-8.892q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828l-8.892 8.856v30.636h8.064q.504 0 .828.324t.324.828z",
		"CODE_FORK": "M10.368-11.447q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm0-41.472q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm23.04 4.608q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm3.456 0q0 1.872-.936 3.474t-2.52 2.502q-.072 10.332-8.136 14.904-2.448 1.368-7.308 2.916-4.608 1.44-6.102 2.556t-1.494 3.6v.936q1.584.9 2.52 2.502t.936 3.474q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896q0-1.872.936-3.474t2.52-2.502v-29.52q-1.584-.9-2.52-2.502t-.936-3.474q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896q0 1.872-.936 3.474t-2.52 2.502v17.892q1.944-.936 5.544-2.052 1.98-.612 3.15-1.062t2.538-1.116 2.124-1.422 1.458-1.836 1.008-2.502.306-3.294q-1.584-.9-2.52-2.502t-.936-3.474q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896z",
		"UNLINK": "M15.804-18.683l-9.216 9.216q-.36.324-.828.324-.432 0-.828-.324-.324-.36-.324-.828t.324-.828l9.216-9.216q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828zm6.084 1.476v11.52q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-11.52q0-.504.324-.828t.828-.324.828.324.324.828zm-8.064-8.064q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h11.52q.504 0 .828.324t.324.828zm45.504 4.608q0 4.32-3.06 7.308l-5.292 5.256q-2.988 2.988-7.308 2.988-4.356 0-7.344-3.06l-12.024-12.06q-.756-.756-1.512-2.016l8.604-.648 9.828 9.864q.972.972 2.448.99t2.448-.954l5.292-5.256q1.008-1.008 1.008-2.412 0-1.44-1.008-2.448l-9.864-9.9.648-8.604q1.26.756 2.016 1.512l12.096 12.096q3.024 3.096 3.024 7.344zm-22.212-26.064l-8.604.648-9.828-9.864q-1.008-1.008-2.448-1.008-1.404 0-2.448.972l-5.292 5.256q-1.008 1.008-1.008 2.412 0 1.44 1.008 2.448l9.864 9.864-.648 8.64q-1.26-.756-2.016-1.512l-12.096-12.096q-3.024-3.096-3.024-7.344 0-4.32 3.06-7.308l5.292-5.256q2.988-2.988 7.308-2.988 4.356 0 7.344 3.06l12.024 12.06q.756.756 1.512 2.016zm22.788 3.024q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h11.52q.504 0 .828.324t.324.828zm-19.584-19.584v11.52q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-11.52q0-.504.324-.828t.828-.324.828.324.324.828zm14.652 5.436l-9.216 9.216q-.396.324-.828.324t-.828-.324q-.324-.36-.324-.828t.324-.828l9.216-9.216q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828z",
		"QUESTION": "M25.344-19.223v8.64q0 .576-.432 1.008t-1.008.432h-8.64q-.576 0-1.008-.432t-.432-1.008v-8.64q0-.576.432-1.008t1.008-.432h8.64q.576 0 1.008.432t.432 1.008zm11.376-21.6q0 1.944-.558 3.636t-1.26 2.754-1.98 2.142-2.07 1.566-2.196 1.278q-1.476.828-2.466 2.34t-.99 2.412q0 .612-.432 1.17t-1.008.558h-8.64q-.54 0-.918-.666t-.378-1.35v-1.62q0-2.988 2.34-5.634t5.148-3.906q2.124-.972 3.024-2.016t.9-2.736q0-1.512-1.674-2.664t-3.87-1.152q-2.34 0-3.888 1.044-1.26.9-3.852 4.14-.468.576-1.116.576-.432 0-.9-.288l-5.904-4.5q-.468-.36-.558-.9t.198-1.008q5.76-9.576 16.704-9.576 2.88 0 5.796 1.116t5.256 2.988 3.816 4.59 1.476 5.706z",
		"INFO": "M23.04-16.055v4.608q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304v-13.824h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62v20.736h2.304q.936 0 1.62.684t.684 1.62zm-4.608-41.472v6.912q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-6.912q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62z",
		"EXCLAMATION": "M18.432-19.511v8.064q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-8.064q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62zm1.08-38.016l-1.008 27.648q-.036.936-.738 1.62t-1.638.684h-9.216q-.936 0-1.638-.684t-.738-1.62l-1.008-27.648q-.036-.936.63-1.62t1.602-.684h11.52q.936 0 1.602.684t.63 1.62z",
		"SUPERSCRIPT": "M32.292-15.155v6.012h-8.928l-5.724-9.072-.864-1.512q-.288-.324-.396-.756h-.108l-.324.756q-.36.72-.9 1.584l-5.58 9h-9.288v-6.012h4.608l7.092-10.476-6.66-9.792h-4.932v-6.048h9.936l5.004 8.208q.072.144.828 1.512.288.324.396.756h.108q.108-.324.396-.756l.9-1.512 5.04-8.208h9.252v6.048h-4.5l-6.624 9.612 7.344 10.656h3.924zm22.932-24.444v7.416h-18.504l-.108-.972q-.144-1.008-.144-1.656 0-2.304.936-4.212t2.34-3.114 3.024-2.34 3.024-1.962 2.34-1.944.936-2.304q0-1.368-1.062-2.25t-2.538-.882q-1.836 0-3.492 1.404-.504.396-1.296 1.368l-3.78-3.312q.936-1.332 2.268-2.376 2.988-2.34 6.768-2.34 3.96 0 6.408 2.142t2.448 5.706q0 2.016-.882 3.708t-2.232 2.754-2.934 2.106-2.952 1.818-2.358 1.854-1.098 2.268h8.352v-2.88h4.536z",
		"SUBSCRIPT": "M32.292-15.155v6.012h-8.928l-5.724-9.072-.864-1.512q-.288-.324-.396-.756h-.108l-.324.756q-.36.72-.9 1.584l-5.58 9h-9.288v-6.012h4.608l7.092-10.476-6.66-9.792h-4.932v-6.048h9.936l5.004 8.208q.072.144.828 1.512.288.324.396.756h.108q.108-.324.396-.756l.9-1.512 5.04-8.208h9.252v6.048h-4.5l-6.624 9.612 7.344 10.656h3.924zm23.004 7.812v7.416h-18.504l-.144-.972-.108-1.656q0-2.304.936-4.212t2.34-3.114 3.024-2.34 3.024-1.962 2.34-1.944.936-2.304q0-1.368-1.062-2.25t-2.538-.882q-1.836 0-3.492 1.404-.504.396-1.296 1.368l-3.78-3.312q.936-1.332 2.268-2.376 2.88-2.34 6.768-2.34 3.96 0 6.408 2.142t2.448 5.706q0 2.376-1.242 4.266t-3.024 3.096-3.582 2.25-3.132 2.268-1.476 2.628h8.352v-2.88h4.536z",
		"ERASER": "M32.256-13.751l12.096-13.824h-27.648l-12.096 13.824h27.648zm36.468-38.772q.54 1.224.342 2.574t-1.098 2.358l-32.256 36.864q-1.368 1.584-3.456 1.584h-27.648q-1.368 0-2.502-.738t-1.71-1.962q-.54-1.224-.342-2.574t1.098-2.358l32.256-36.864q1.368-1.584 3.456-1.584h27.648q1.368 0 2.502.738t1.71 1.962z",
		"PUZZLE_PIECE": "M59.904-24.911q0 2.916-1.602 4.86t-4.446 1.944q-1.476 0-2.79-.63t-2.124-1.368-2.034-1.368-2.556-.63q-3.96 0-3.96 4.464 0 1.404.576 4.14t.54 4.14v.18q-.792 0-1.188.036-1.224.108-3.51.414t-4.158.486-3.528.18q-2.196 0-3.708-.954t-1.512-3.006q0-1.332.63-2.556t1.368-2.034 1.368-2.124.63-2.79q0-2.844-1.944-4.446t-4.86-1.602q-3.024 0-5.148 1.638t-2.124 4.59q0 1.548.54 2.988t1.206 2.322 1.206 1.908.54 1.818q0 1.62-1.656 3.204-1.332 1.26-4.212 1.26-3.42 0-8.82-.864-.324-.072-.99-.144t-.99-.144l-.468-.072-.108-.036-.072-.036v-36.864q.072.036.63.126t1.224.18.774.126q5.4.864 8.82.864 2.88 0 4.212-1.26 1.656-1.584 1.656-3.204 0-.792-.54-1.818t-1.206-1.908-1.206-2.322-.54-2.988q0-2.952 2.124-4.59t5.184-1.638q2.88 0 4.824 1.602t1.944 4.446q0 1.476-.63 2.79t-1.368 2.124-1.368 2.034-.63 2.556q0 2.052 1.512 3.006t3.708.954q2.304 0 6.48-.54t5.868-.612v.072q-.036.072-.126.63t-.18 1.224-.126.774q-.864 5.4-.864 8.82 0 2.88 1.26 4.212 1.584 1.656 3.204 1.656.792 0 1.818-.54t1.908-1.206 2.322-1.206 2.988-.54q2.952 0 4.59 2.124t1.638 5.148z",
		"MICROPHONE": "M41.472-39.095v4.608q0 7.956-5.31 13.842t-13.122 6.75v4.752h9.216q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 6.66 4.734 11.394t11.394 4.734 11.394-4.734 4.734-11.394v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62zm-9.216-13.824v18.432q0 4.752-3.384 8.136t-8.136 3.384-8.136-3.384-3.384-8.136v-18.432q0-4.752 3.384-8.136t8.136-3.384 8.136 3.384 3.384 8.136z",
		"MICROPHONE_SLASH": "M9.756-30.419l-3.636 3.636q-1.512-3.708-1.512-7.704v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 1.908.54 4.068zm40.104-21.672l-12.996 12.996v4.608q0 4.752-3.384 8.136t-8.136 3.384q-1.98 0-3.924-.684l-3.456 3.456q3.492 1.836 7.38 1.836 6.66 0 11.394-4.734t4.734-11.394v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 7.956-5.31 13.842t-13.122 6.75v4.752h9.216q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216v-4.752q-4.5-.468-8.46-2.916l-9.144 9.144q-.36.36-.828.36t-.828-.36l-2.952-2.952q-.36-.36-.36-.828t.36-.828l44.424-44.424q.36-.36.828-.36t.828.36l2.952 2.952q.36.36.36.828t-.36.828zm-13.68-4.752l-22.356 22.356v-18.432q0-4.752 3.384-8.136t8.136-3.384q3.672 0 6.642 2.124t4.194 5.472z",
		"SHIELD": "M39.168-29.879v-23.04h-16.128v40.932q4.284-2.268 7.668-4.932 8.46-6.624 8.46-12.96zm6.912-27.648v27.648q0 3.096-1.206 6.138t-2.988 5.4-4.248 4.59-4.554 3.708-4.356 2.79-3.222 1.782-1.53.72q-.432.216-.936.216t-.936-.216q-.576-.252-1.53-.72t-3.222-1.782-4.356-2.79-4.554-3.708-4.248-4.59-2.988-5.4-1.206-6.138v-27.648q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z",
		"CALENDAR_O": "M4.608-4.535h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z",
		"FIRE_EXTINGUISHER": "M18.432-57.527q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm32.256-1.152v11.52q0 .576-.432.9-.288.252-.72.252-.144 0-.252-.036l-16.128-3.456q-.396-.072-.648-.396t-.252-.72h-9.216v3.672q3.996.828 6.606 3.996t2.61 7.308v28.8q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-28.8q0-3.816 2.25-6.858t5.814-4.122v-3.996h-1.152q-2.124 0-4.14.846t-3.294 1.908-2.376 2.394-1.458 1.926-.504.882q-.612 1.26-2.052 1.26-.576 0-1.044-.252-.828-.432-1.134-1.332t.126-1.764q.18-.36.522-.936t1.35-1.926 2.178-2.52 3.06-2.412 3.906-1.89q-.9-1.512-.9-3.096 0-2.376 1.692-4.068t4.068-1.692 4.068 1.692 1.692 4.068q0 1.188-.504 2.304h10.872q0-.396.252-.72t.648-.396l16.128-3.456q.108-.036.252-.036.432 0 .72.252.432.324.432.9z",
		"ROCKET": "M51.84-48.311q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm8.064-10.368q0 8.964-2.718 15.498t-9.126 12.978q-2.916 2.88-7.02 6.336l-.72 13.644q-.072.576-.576.936l-13.824 8.064q-.252.144-.576.144-.432 0-.828-.324l-2.304-2.304q-.468-.504-.288-1.152l3.06-9.936-10.116-10.116-9.936 3.06q-.108.036-.324.036-.504 0-.828-.324l-2.304-2.304q-.612-.684-.18-1.404l8.064-13.824q.36-.504.936-.576l13.644-.72q3.456-4.104 6.336-7.02 6.768-6.732 12.888-9.288t15.516-2.556q.504 0 .864.342t.36.81z",
		"MAXCDN": "M62.82-36.611l-5.904 27.468h-12.024l6.408-29.952q.468-2.016-.54-3.168-.972-1.188-2.988-1.188h-6.084l-7.344 34.308h-12.024l7.344-34.308h-10.296l-7.344 34.308h-12.024l7.344-34.308-5.508-11.772h45.936q3.636 0 6.822 1.458t5.31 4.086q2.16 2.628 2.916 6.066t0 7.002z",
		"CHEVRON_CIRCLE_LEFT": "M32.724-14.219l3.672-3.672q.684-.684.684-1.62t-.684-1.62l-11.052-11.052 11.052-11.052q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-16.344 16.344q-.684.684-.684 1.62t.684 1.62l16.344 16.344q.684.684 1.62.684t1.62-.684zm22.572-17.964q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CHEVRON_CIRCLE_RIGHT": "M25.812-14.219l16.344-16.344q.684-.684.684-1.62t-.684-1.62l-16.344-16.344q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l11.052 11.052-11.052 11.052q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684zm29.484-17.964q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CHEVRON_CIRCLE_UP": "M41.94-23.435l3.672-3.672q.684-.684.684-1.62t-.684-1.62l-16.344-16.344q-.684-.684-1.62-.684t-1.62.684l-16.344 16.344q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684l11.052-11.052 11.052 11.052q.684.684 1.62.684t1.62-.684zm13.356-8.748q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"CHEVRON_CIRCLE_DOWN": "M29.268-17.675l16.344-16.344q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-11.052 11.052-11.052-11.052q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l16.344 16.344q.684.684 1.62.684t1.62-.684zm26.028-14.508q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"HTML5": "M40.68-42.947l.576-6.3h-31.824l1.692 19.224h22.032l-.792 8.208-7.092 1.908-7.056-1.908-.468-5.04h-6.3l.792 10.008 13.032 3.6h.144v-.036l12.924-3.564 1.8-19.584h-23.184l-.54-6.516h24.264zm-40.68-16.884h50.688l-4.608 51.768-20.808 5.832-20.664-5.832z",
		"CSS3": "M9.9-59.831h54.18l-9.576 47.988-28.944 9.612-25.128-9.612 2.556-12.816h10.692l-1.044 5.292 15.192 5.796 17.496-5.796 2.448-12.204h-43.488l2.088-10.692h43.524l1.368-6.876h-43.488z",
		"ANCHOR": "M34.56-55.223q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm29.952 33.408v12.672q0 .792-.72 1.08-.288.072-.432.072-.468 0-.828-.324l-3.348-3.348q-4.284 5.148-11.466 8.154t-15.462 3.006-15.462-3.006-11.466-8.154l-3.348 3.348q-.324.324-.828.324-.144 0-.432-.072-.72-.288-.72-1.08v-12.672q0-.504.324-.828t.828-.324h12.672q.792 0 1.08.72.288.684-.252 1.26l-3.6 3.6q2.412 3.276 6.822 5.526t9.774 2.97v-23.292h-6.912q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h6.912v-5.868q-2.088-1.224-3.348-3.33t-1.26-4.626q0-3.816 2.7-6.516t6.516-2.7 6.516 2.7 2.7 6.516q0 2.52-1.26 4.626t-3.348 3.33v5.868h6.912q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-6.912v23.292q5.364-.72 9.774-2.97t6.822-5.526l-3.6-3.6q-.54-.576-.252-1.26.288-.72 1.08-.72h12.672q.504 0 .828.324t.324.828z",
		"UNLOCK_ALT": "M38.016-36.791q1.44 0 2.448 1.008t1.008 2.448v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h1.152v-11.52q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394q0 .936-.684 1.62t-1.62.684h-2.304q-.936 0-1.62-.684t-.684-1.62q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v11.52h26.496z",
		"BULLSEYE": "M36.864-32.183q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm4.608 0q0-5.724-4.05-9.774t-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05 9.774-4.05 4.05-9.774zm4.608 0q0 7.632-5.4 13.032t-13.032 5.4-13.032-5.4-5.4-13.032 5.4-13.032 13.032-5.4 13.032 5.4 5.4 13.032zm4.608 0q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ELLIPSIS_H": "M13.824-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm18.432 0v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm18.432 0v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448z",
		"ELLIPSIS_V": "M13.824-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448z",
		"RSS_SQUARE": "M18.432-18.359q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm12.636 3.384q-.468-8.352-6.372-14.256t-14.256-6.372q-.504-.036-.864.324t-.36.828v4.608q0 .468.306.792t.774.36q5.544.396 9.504 4.356t4.356 9.504q.036.468.36.774t.792.306h4.608q.468 0 .828-.36t.324-.864zm13.824.036q-.18-5.544-2.016-10.71t-5.022-9.36-7.38-7.38-9.36-5.022-10.71-2.016q-.504-.036-.828.324-.36.36-.36.828v4.608q0 .468.324.792t.792.36q7.344.252 13.608 4.014t10.026 10.026 4.014 13.608q.036.468.36.792t.792.324h4.608q.468 0 .828-.36.396-.324.324-.828zm10.404-34.524v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"PLAY_CIRCLE": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm13.824 29.628q1.152-.648 1.152-1.98t-1.152-1.98l-19.584-11.52q-1.116-.684-2.304-.036-1.152.684-1.152 2.016v23.04q0 1.332 1.152 2.016.576.288 1.152.288.612 0 1.152-.324z",
		"TICKET": "M36.864-48.167l11.376 11.376-20.592 20.592-11.376-11.376zm-7.596 35.244l22.248-22.248q.684-.684.684-1.62t-.684-1.62l-13.032-13.032q-.648-.648-1.62-.648t-1.62.648l-22.248 22.248q-.684.684-.684 1.62t.684 1.62l13.032 13.032q.648.648 1.62.648t1.62-.648zm32.004-22.932l-32.652 32.688q-1.332 1.332-3.258 1.332t-3.258-1.332l-4.536-4.536q2.016-2.016 2.016-4.896t-2.016-4.896-4.896-2.016-4.896 2.016l-4.5-4.536q-1.332-1.332-1.332-3.258t1.332-3.258l32.652-32.616q1.332-1.332 3.258-1.332t3.258 1.332l4.5 4.5q-2.016 2.016-2.016 4.896t2.016 4.896 4.896 2.016 4.896-2.016l4.536 4.5q1.332 1.332 1.332 3.258t-1.332 3.258z",
		"MINUS_SQUARE": "M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-32.256q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h32.256q.936 0 1.62-.684t.684-1.62zm9.216-19.584v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"MINUS_SQUARE_O": "M41.472-35.639v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828zm4.608 16.128v-29.952q0-2.376-1.692-4.068t-4.068-1.692h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068zm4.608-29.952v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z",
		"LEVEL_UP": "M36.648-42.731q-.648 1.332-2.088 1.332h-6.912v31.104q0 .504-.324.828t-.828.324h-25.344q-.756 0-1.044-.648-.288-.72.144-1.26l5.76-6.912q.324-.396.9-.396h11.52v-23.04h-6.912q-1.44 0-2.088-1.332-.612-1.332.324-2.448l11.52-13.824q.648-.792 1.764-.792t1.764.792l11.52 13.824q.972 1.152.324 2.448z",
		"LEVEL_DOWN": "M1.152-55.223h25.344q.468 0 .81.342t.342.846v31.068h6.912q1.44 0 2.088 1.332t-.324 2.484l-11.52 13.824q-.648.792-1.764.792t-1.764-.792l-11.52-13.824q-.936-1.116-.324-2.484.648-1.332 2.088-1.332h6.912v-23.04h-11.52q-.504 0-.9-.396l-5.76-6.912q-.468-.504-.144-1.224.324-.684 1.044-.684z",
		"CHECK_SQUARE": "M24.66-17.675l22.104-22.104q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-16.812 16.812-7.596-7.596q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l12.888 12.888q.684.684 1.62.684t1.62-.684zm30.636-31.788v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"PENCIL_SQUARE": "M14.544-24.551l5.472 5.472-1.872 1.872h-2.016v-3.456h-3.456v-2.016zm14.904-14.04q.504.468-.108 1.08l-10.476 10.476q-.612.612-1.08.108-.504-.468.108-1.08l10.476-10.476q.612-.612 1.08-.108zm-9.864 24.84l19.584-19.584-10.368-10.368-19.584 19.584v10.368h10.368zm21.888-21.888l3.312-3.312q1.008-1.008 1.008-2.448t-1.008-2.448l-5.472-5.472q-1.008-1.008-2.448-1.008t-2.448 1.008l-3.312 3.312zm13.824-13.824v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"EXTERNAL_LINK_SQUARE": "M46.08-31.031v-17.28q0-.936-.684-1.62t-1.62-.684h-17.28q-1.512 0-2.124 1.404-.612 1.476.504 2.52l5.184 5.184-19.224 19.224q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684l19.224-19.224 5.184 5.184q.648.684 1.62.684.432 0 .9-.18 1.404-.612 1.404-2.124zm9.216-18.432v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"SHARE_SQUARE": "M36.18-24.803l12.672-12.672q.684-.684.684-1.62t-.684-1.62l-12.672-12.672q-1.08-1.116-2.484-.504-1.44.612-1.44 2.124v5.76q-4.284 0-7.776.702t-5.85 1.836-4.104 2.844-2.754 3.438-1.602 3.924-.774 4.014-.18 3.978q0 6.516 6.012 14.544.36.432.9.432.252 0 .468-.108.792-.324.684-1.188-1.584-12.744 2.232-17.028 1.656-1.872 4.68-2.718t8.064-.846v5.76q0 1.512 1.44 2.124.432.18.864.18.936 0 1.62-.684zm19.116-24.66v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"COMPASS": "M23.04-25.271l9.216-4.608-9.216-4.608v9.216zm13.824-21.276v19.512l-18.432 9.216v-19.512zm10.368 14.364q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"TOGGLE_DOWN": "M41.22-40.139q.648 1.26-.18 2.376l-11.52 16.128q-.684.972-1.872.972t-1.872-.972l-11.52-16.128q-.828-1.116-.18-2.376.612-1.26 2.052-1.26h23.04q1.44 0 2.052 1.26zm4.86 25.236v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TOGGLE_UP": "M41.22-24.227q-.612 1.26-2.052 1.26h-23.04q-1.44 0-2.052-1.26-.648-1.26.18-2.376l11.52-16.128q.684-.972 1.872-.972t1.872.972l11.52 16.128q.828 1.116.18 2.376zm4.86 9.324v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TOGGLE_RIGHT": "M39.168-32.183q0 1.188-.972 1.872l-16.128 11.52q-1.116.828-2.376.18-1.26-.612-1.26-2.052v-23.04q0-1.44 1.26-2.052 1.26-.648 2.376.18l16.128 11.52q.972.684.972 1.872zm6.912 17.28v-34.56q0-.504-.324-.828t-.828-.324h-34.56q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h34.56q.504 0 .828-.324t.324-.828zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"EURO": "M35.136-17.387l1.26 5.724q.108.432-.108.81t-.612.522l-.18.036q-.144.072-.378.126t-.576.162-.774.198-.918.18-1.08.18-1.206.162-1.314.108-1.386.036q-8.424 0-14.724-4.698t-8.568-12.654h-3.42q-.468 0-.81-.342t-.342-.81v-4.068q0-.468.342-.81t.81-.342h2.376q-.072-2.052.036-3.78h-2.412q-.504 0-.828-.324t-.324-.828v-4.104q0-.504.324-.828t.828-.324h3.528q2.412-7.56 8.766-12.168t14.418-4.608q3.672 0 6.984.828.396.108.72.54.216.396.108.864l-1.548 5.724q-.108.468-.504.702t-.864.09l-.144-.036-.414-.09-.63-.126-.81-.126-.936-.108-1.044-.09-1.062-.036q-4.536 0-8.136 2.304t-5.4 6.336h16.848q.576 0 .9.432.36.432.252.936l-.864 4.104q-.18.936-1.152.936h-17.568q-.108 1.332 0 3.78h16.524q.54 0 .9.432.324.432.216.972l-.864 4.032q-.072.396-.396.666t-.72.27h-13.932q1.728 4.212 5.382 6.678t8.226 2.466q.648 0 1.296-.054t1.206-.126 1.062-.162.882-.18.666-.162l.432-.108.18-.072q.468-.18.936.072.432.252.54.756z",
		"GBP": "M36.72-23.507v13.212q0 .504-.324.828t-.828.324h-34.416q-.504 0-.828-.324t-.324-.828v-5.4q0-.468.342-.81t.81-.342h3.492v-13.788h-3.42q-.504 0-.828-.342t-.324-.81v-4.716q0-.504.324-.828t.828-.324h3.42v-8.028q0-6.156 4.446-10.152t11.322-3.996q6.66 0 12.06 4.5.324.288.36.738t-.252.81l-3.708 4.572q-.324.396-.792.432-.468.072-.828-.252-.18-.18-.936-.684t-2.484-1.152-3.348-.648q-3.06 0-4.932 1.692t-1.872 4.428v7.74h10.98q.468 0 .81.324t.342.828v4.716q0 .468-.342.81t-.81.342h-10.98v13.644h14.904v-6.516q0-.468.324-.81t.828-.342h5.832q.504 0 .828.342t.324.81z",
		"USD": "M35.208-21.779q0 5.508-3.582 9.486t-9.306 4.914v6.3q0 .504-.324.828t-.828.324h-4.86q-.468 0-.81-.342t-.342-.81v-6.3q-2.376-.324-4.59-1.116t-3.654-1.602-2.664-1.728-1.674-1.35-.63-.648q-.612-.756-.072-1.476l3.708-4.86q.252-.36.828-.432.54-.072.864.324l.072.072q4.068 3.564 8.748 4.5 1.332.288 2.664.288 2.916 0 5.13-1.548t2.214-4.392q0-1.008-.54-1.908t-1.206-1.512-2.106-1.35-2.376-1.152-2.88-1.17q-1.404-.576-2.214-.9t-2.214-.954-2.25-1.116-2.034-1.278-1.926-1.53-1.566-1.764-1.278-2.088-.756-2.394-.306-2.808q0-4.968 3.528-8.712t9.18-4.824v-6.48q0-.468.342-.81t.81-.342h4.86q.504 0 .828.324t.324.828v6.336q2.052.216 3.978.828t3.132 1.206 2.286 1.35 1.404 1.044.54.504q.612.648.18 1.368l-2.916 5.256q-.288.54-.828.576-.504.108-.972-.252-.108-.108-.522-.432t-1.404-.954-2.106-1.152-2.682-.936-3.078-.414q-3.42 0-5.58 1.548t-2.16 3.996q0 .936.306 1.728t1.062 1.494 1.422 1.188 2.016 1.116 2.178.972 2.52.99q1.908.72 2.916 1.134t2.736 1.26 2.718 1.53 2.232 1.8 1.908 2.286 1.134 2.754.468 3.384z",
		"RUPEE": "M32.328-47.519v3.672q0 .504-.324.828t-.828.324h-6.048q-.828 5.184-4.644 8.424t-9.936 3.96q6.012 6.408 16.524 19.296.504.576.144 1.224-.288.648-1.044.648h-7.02q-.576 0-.9-.432-11.016-13.212-17.928-20.556-.324-.324-.324-.792v-4.572q0-.468.342-.81t.81-.342h4.032q4.752 0 7.65-1.548t3.69-4.5h-15.372q-.504 0-.828-.324t-.324-.828v-3.672q0-.504.324-.828t.828-.324h14.868q-2.052-4.068-9.648-4.068h-5.22q-.468 0-.81-.342t-.342-.81v-4.788q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828v3.672q0 .504-.324.828t-.828.324h-8.388q1.692 2.196 2.304 5.184h6.156q.504 0 .828.324t.324.828z",
		"YEN": "M21.708-9.143h-6.192q-.468 0-.81-.324t-.342-.828v-11.88h-10.368q-.468 0-.81-.324t-.342-.828v-3.708q0-.468.342-.81t.81-.342h10.368v-3.06h-10.368q-.468 0-.81-.324t-.342-.828v-3.744q0-.468.342-.81t.81-.342h7.704l-11.556-20.808q-.288-.576 0-1.152.36-.576 1.008-.576h6.984q.684 0 1.044.648l7.74 15.3q.684 1.368 2.016 4.5.36-.864 1.098-2.448t.99-2.196l6.876-15.12q.288-.684 1.044-.684h6.876q.612 0 .972.576.324.504.036 1.116l-11.268 20.844h7.74q.468 0 .81.342t.342.81v3.744q0 .504-.342.828t-.81.324h-10.44v3.06h10.44q.468 0 .81.342t.342.81v3.708q0 .504-.342.828t-.81.324h-10.44v11.88q0 .468-.342.81t-.81.342z",
		"RUBLE": "M37.548-44.099q0-3.6-2.34-5.832t-6.156-2.232h-11.52v16.128h11.52q3.816 0 6.156-2.232t2.34-5.832zm8.532 0q0 6.948-4.554 11.34t-11.754 4.392h-12.24v4.248h18.18q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-18.18v6.912q0 .504-.342.828t-.81.324h-6.012q-.504 0-.828-.324t-.324-.828v-6.912h-8.064q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h8.064v-4.248h-8.064q-.504 0-.828-.324t-.324-.828v-5.364q0-.468.324-.81t.828-.342h8.064v-22.644q0-.504.324-.828t.828-.324h19.404q7.2 0 11.754 4.392t4.554 11.34z",
		"WON": "M18.504-21.419l2.916-10.764h-5.724l2.7 10.8.036.108.036.108.018-.126.018-.126zm4.176-15.372l1.26-4.608h-10.512l1.152 4.608h8.1zm6.912 0h5.004l-1.26-4.608h-2.52zm16.164 15.408l2.808-10.8h-5.832l2.916 10.764.018.126.054.126.018-.108.018-.108zm3.996-15.408l1.188-4.608h-10.692l1.224 4.608h8.28zm14.76 1.152v2.304q0 .504-.324.828t-.828.324h-7.668l-5.904 22.176q-.252.864-1.116.864h-5.724q-.864 0-1.116-.864l-5.976-22.176h-7.524l-6.012 22.176q-.252.864-1.116.864h-5.724q-.396 0-.702-.252t-.378-.612l-5.76-22.176h-7.488q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h6.3l-1.188-4.608h-5.112q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.924l-3.204-12.384q-.18-.54.18-1.008.36-.432.936-.432h4.932q.936 0 1.116.864l3.24 12.96h12.924l3.492-12.96q.252-.864 1.116-.864h4.536q.864 0 1.116.864l3.528 12.96h13.14l3.348-12.96q.18-.864 1.116-.864h4.932q.576 0 .936.432.36.468.18 1.008l-3.276 12.384h3.996q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-5.22l-1.224 4.608h6.444q.504 0 .828.324t.324.828z",
		"BTC": "M42.012-41.399q.648 6.552-4.716 9.288 4.212 1.008 6.3 3.708t1.62 7.704q-.252 2.556-1.17 4.5t-2.322 3.204-3.492 2.106-4.374 1.242-5.238.54v9.18h-5.544v-9.036q-2.88 0-4.392-.036v9.072h-5.544v-9.18q-.648 0-1.944-.018t-1.98-.018h-7.2l1.116-6.588h3.996q1.8 0 2.088-1.836v-14.472h.576q-.216-.036-.576-.036v-10.332q-.468-2.448-3.204-2.448h-3.996v-5.904l7.632.036q2.304 0 3.492-.036v-9.072h5.544v8.892q2.952-.072 4.392-.072v-8.82h5.544v9.072q2.844.252 5.04.81t4.068 1.62 2.97 2.808 1.314 4.122zm-7.74 19.62q0-1.296-.54-2.304t-1.332-1.656-2.07-1.098-2.358-.666-2.664-.324-2.484-.108-2.322.036-1.71.036v12.168q.288 0 1.332.018t1.728.018 1.908-.054 2.106-.144 2.052-.306 1.998-.504 1.71-.756 1.422-1.08.882-1.44.342-1.836zm-2.556-17.136q0-1.188-.45-2.106t-1.098-1.512-1.728-1.008-1.98-.594-2.214-.288-2.088-.09-1.944.036-1.422.018v11.052q.18 0 1.242.018t1.674 0 1.8-.072 1.98-.198 1.854-.396 1.746-.666 1.332-.972.972-1.386.324-1.836z",
		"FILE": "M36.864-46.007v-16.992q.792.504 1.296 1.008l14.688 14.688q.504.504 1.008 1.296h-16.992zm-4.608 1.152q0 1.44 1.008 2.448t2.448 1.008h19.584v38.016q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h28.8v19.584z",
		"FILE_TEXT": "M52.848-47.303q.504.504 1.008 1.296h-16.992v-16.992q.792.504 1.296 1.008zm-17.136 5.904h19.584v38.016q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h28.8v19.584q0 1.44 1.008 2.448t2.448 1.008zm5.76 26.496v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828z",
		"SORT_ALPHA_ASC": "M42.876-49.751h6.372l-2.592-7.848-.432-1.692q-.072-.576-.072-.72h-.144l-.108.72q0 .036-.126.648t-.27 1.044zm-16.38 37.152q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm30.096 4.284v8.388h-21.024v-3.24l13.284-19.044q.432-.648.756-.972l.396-.324v-.108l-.234.018-.27.018q-.432.108-1.08.108h-8.352v4.14h-4.32v-8.244h20.412v3.204l-13.284 19.08q-.216.288-.756.936l-.396.396v.072l.504-.072q.324-.072 1.08-.072h8.928v-4.284h4.356zm3.204-32.292v3.816h-10.368v-3.816h2.7l-1.692-5.184h-8.748l-1.692 5.184h2.7v3.816h-10.332v-3.816h2.52l8.28-23.832h5.832l8.28 23.832h2.52z",
		"SORT_ALPHA_DESC": "M42.876-12.887h6.372l-2.592-7.848-.432-1.692q-.072-.576-.072-.72h-.144l-.108.72q0 .036-.126.648t-.27 1.044zm-16.38.288q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm33.3 8.856v3.816h-10.368v-3.816h2.7l-1.692-5.184h-8.748l-1.692 5.184h2.7v3.816h-10.332v-3.816h2.52l8.28-23.832h5.832l8.28 23.832h2.52zm-3.204-41.436v8.388h-21.024v-3.24l13.284-19.044q.432-.648.756-.972l.396-.324v-.108l-.234.018-.27.018q-.432.108-1.08.108h-8.352v4.14h-4.32v-8.244h20.412v3.204l-13.284 19.08q-.216.288-.756.936l-.396.36v.108l.504-.108q.324-.036 1.08-.036h8.928v-4.284h4.356z",
		"SORT_AMOUNT_ASC": "M26.496-12.599q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm38.016 4.608v6.912q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-23.04q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h23.04q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-16.128q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-9.216q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h9.216q.504 0 .828.324t.324.828z",
		"SORT_AMOUNT_DESC": "M43.776-7.991v6.912q0 .504-.324.828t-.828.324h-9.216q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h9.216q.504 0 .828.324t.324.828zm-17.28-4.608q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm24.192-13.824v6.912q0 .504-.324.828t-.828.324h-16.128q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828zm6.912-18.432v6.912q0 .504-.324.828t-.828.324h-23.04q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h23.04q.504 0 .828.324t.324.828zm6.912-18.432v6.912q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828z",
		"SORT_NUMERIC_ASC": "M48.456-17.171q0-2.268-1.584-4.176t-3.708-1.908q-1.872 0-2.988 1.332t-1.116 3.384 1.314 3.42 3.762 1.368q1.8 0 3.06-.972t1.26-2.448zm-21.96 4.572q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm27-2.484q0 2.232-.468 4.374t-1.476 4.104-2.448 3.438-3.546 2.358-4.59.882q-2.232 0-3.888-.576-.864-.288-1.512-.54l1.404-4.068q.54.252 1.116.396 1.332.468 2.7.468 3.024 0 4.842-2.106t2.394-5.238h-.072q-.756.828-2.214 1.332t-3.042.504q-3.816 0-6.228-2.574t-2.412-6.21q0-3.78 2.592-6.408t6.516-2.628q4.428 0 7.38 3.402t2.952 9.09zm-1.08-25.812v4.104h-16.884v-4.104h6.012v-15.552l.018-.684.018-.612v-.576h-.072l-.252.432q-.288.468-.936 1.116l-2.232 2.088-2.952-3.096 6.912-6.66h4.428v23.544h5.94z",
		"SORT_NUMERIC_DESC": "M48.456-54.035q0-2.268-1.584-4.176t-3.708-1.908q-1.872 0-2.988 1.332t-1.116 3.384 1.314 3.42 3.762 1.368q1.8 0 3.06-.972t1.26-2.448zm-21.96 41.436q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm25.92 8.568v4.104h-16.884v-4.104h6.012v-15.552l.018-.684.018-.612v-.576h-.072l-.252.432q-.288.468-.936 1.116l-2.232 2.088-2.952-3.096 6.912-6.66h4.428v23.544h5.94zm1.08-47.916q0 2.232-.468 4.374t-1.476 4.104-2.448 3.438-3.546 2.358-4.59.882q-2.232 0-3.888-.576-.864-.288-1.512-.54l1.404-4.068q.54.252 1.116.396 1.332.468 2.7.468 3.024 0 4.842-2.106t2.394-5.238h-.072q-.756.828-2.214 1.332t-3.042.504q-3.816 0-6.228-2.574t-2.412-6.21q0-3.78 2.592-6.408t6.516-2.628q4.428 0 7.38 3.402t2.952 9.09z",
		"THUMBS_UP": "M9.216-16.055q0-.936-.684-1.62t-1.62-.684q-.972 0-1.638.684t-.666 1.62q0 .972.666 1.638t1.638.666q.936 0 1.62-.666t.684-1.638zm5.76-18.432v23.04q0 .936-.684 1.62t-1.62.684h-10.368q-.936 0-1.62-.684t-.684-1.62v-23.04q0-.936.684-1.62t1.62-.684h10.368q.936 0 1.62.684t.684 1.62zm42.624 0q0 3.096-1.98 5.364.54 1.584.54 2.736.108 2.736-1.548 4.932.612 2.016 0 4.212-.54 2.052-1.944 3.384.324 4.032-1.764 6.516-2.304 2.736-7.092 2.808h-4.644q-2.376 0-5.184-.558t-4.374-1.044-4.338-1.422q-4.428-1.548-5.688-1.584-.936-.036-1.62-.702t-.684-1.602v-23.076q0-.9.648-1.566t1.548-.738q.864-.072 2.736-2.124t3.636-4.356q2.448-3.132 3.636-4.32.648-.648 1.116-1.728t.63-1.746.486-2.178q.252-1.404.45-2.196t.702-1.872 1.224-1.8q.684-.684 1.62-.684 1.656 0 2.97.378t2.16.936 1.44 1.458.864 1.62.432 1.8.18 1.62.018 1.404q0 1.368-.342 2.736t-.684 2.16-.99 2.016q-.108.216-.36.648t-.396.792-.288.864h9.972q2.808 0 4.86 2.052t2.052 4.86z",
		"THUMBS_DOWN": "M9.216-43.703q0 .936-.684 1.62t-1.62.684q-.972 0-1.638-.684t-.666-1.62q0-.972.666-1.638t1.638-.666q.936 0 1.62.666t.684 1.638zm5.76 18.432v-23.04q0-.936-.684-1.62t-1.62-.684h-10.368q-.936 0-1.62.684t-.684 1.62v23.04q0 .936.684 1.62t1.62.684h10.368q.936 0 1.62-.684t.684-1.62zm40.644-5.364q1.98 2.196 1.98 5.364-.036 2.808-2.07 4.86t-4.842 2.052h-9.972q.144.504.288.864t.396.792.36.648q.648 1.332.972 2.052t.684 2.106.36 2.754q0 .864-.018 1.404t-.18 1.62-.432 1.8-.864 1.62-1.44 1.458-2.16.936-2.97.378q-.936 0-1.62-.684-.72-.72-1.224-1.8t-.702-1.872-.45-2.196q-.324-1.512-.486-2.178t-.63-1.746-1.116-1.728q-1.188-1.188-3.636-4.32-1.764-2.304-3.636-4.356t-2.736-2.124q-.9-.072-1.548-.738t-.648-1.566v-23.076q0-.936.684-1.602t1.62-.702q1.26-.036 5.688-1.584 2.772-.936 4.338-1.422t4.374-1.044 5.184-.558h4.644q4.788.072 7.092 2.808 2.088 2.484 1.764 6.516 1.404 1.332 1.944 3.384.612 2.196 0 4.212 1.656 2.196 1.548 4.932 0 1.152-.54 2.736z",
		"YOUTUBE_SQUARE": "M33.084-17.531v-5.652q0-1.8-1.044-1.8-.612 0-1.188.576v8.064q.576.576 1.188.576 1.044 0 1.044-1.764zm6.624-4.392h2.376v-1.224q0-1.836-1.188-1.836t-1.188 1.836v1.224zm-20.556-9.576v2.52h-2.88v15.228h-2.664v-15.228h-2.808v-2.52h8.352zm7.236 4.536v13.212h-2.412v-1.44q-1.404 1.62-2.736 1.62-1.188 0-1.512-1.008-.216-.576-.216-1.944v-10.44h2.376v9.72q0 .864.036.936.036.54.54.54.72 0 1.512-1.116v-10.08h2.412zm9.072 3.996v5.256q0 1.872-.252 2.628-.432 1.512-1.908 1.512-1.26 0-2.448-1.476v1.296h-2.412v-17.748h2.412v5.796q1.152-1.44 2.448-1.44 1.476 0 1.908 1.512.252.756.252 2.664zm9.036 4.644v.324q0 1.044-.072 1.548-.108.792-.54 1.44-.972 1.44-2.88 1.44-1.872 0-2.916-1.368-.756-.972-.756-3.096v-4.644q0-2.124.72-3.096 1.044-1.368 2.88-1.368t2.808 1.368q.756 1.008.756 3.096v2.736h-4.788v2.34q0 1.836 1.224 1.836.864 0 1.08-.936 0-.036.018-.252t.018-.594v-.774h2.448zm-16.236-29.664v5.616q0 1.836-1.152 1.836t-1.152-1.836v-5.616q0-1.872 1.152-1.872t1.152 1.872zm19.188 25.668q0-6.372-.684-9.36-.36-1.584-1.548-2.646t-2.736-1.242q-4.896-.54-14.832-.54-9.9 0-14.796.54-1.584.18-2.754 1.242t-1.53 2.646q-.72 3.132-.72 9.36 0 6.336.72 9.36.36 1.548 1.53 2.628t2.718 1.26q4.932.54 14.832.54t14.832-.54q1.548-.18 2.718-1.26t1.53-2.628q.72-3.024.72-9.36zm-27.18-23.436l3.24-10.656h-2.7l-1.836 7.02-1.908-7.02h-2.808l.864 2.484.828 2.484q1.26 3.708 1.656 5.688v7.236h2.664v-7.236zm10.404 2.916v-4.68q0-2.088-.756-3.132-1.044-1.368-2.808-1.368-1.836 0-2.808 1.368-.756 1.044-.756 3.132v4.68q0 2.088.756 3.132.972 1.368 2.808 1.368 1.764 0 2.808-1.368.756-.972.756-3.132zm6.516 4.32h2.412v-13.32h-2.412v10.188q-.792 1.116-1.512 1.116-.54 0-.576-.576-.036-.072-.036-.936v-9.792h-2.412v10.548q0 1.332.216 1.98.396.972 1.548.972 1.296 0 2.772-1.62v1.44zm18.108-10.944v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"YOUTUBE": "M34.956-19.655v7.596q0 2.412-1.404 2.412-.828 0-1.62-.792v-10.836q.792-.792 1.62-.792 1.404 0 1.404 2.412zm12.168.036v1.656h-3.24v-1.656q0-2.448 1.62-2.448t1.62 2.448zm-34.776-7.848h3.852v-3.384h-11.232v3.384h3.78v20.484h3.6v-20.484zm10.368 20.484h3.204v-17.784h-3.204v13.608q-1.08 1.512-2.052 1.512-.648 0-.756-.756-.036-.108-.036-1.26v-13.104h-3.204v14.076q0 1.764.288 2.628.432 1.332 2.088 1.332 1.728 0 3.672-2.196v1.944zm15.444-5.328v-7.092q0-2.628-.324-3.564-.612-2.016-2.556-2.016-1.8 0-3.348 1.944v-7.812h-3.204v23.868h3.204v-1.728q1.62 1.98 3.348 1.98 1.944 0 2.556-1.98.324-.972.324-3.6zm12.168-.36v-.468h-3.276q0 1.836-.072 2.196-.252 1.296-1.44 1.296-1.656 0-1.656-2.484v-3.132h6.444v-3.708q0-2.844-.972-4.176-1.404-1.836-3.816-1.836-2.448 0-3.852 1.836-1.008 1.332-1.008 4.176v6.228q0 2.844 1.044 4.176 1.404 1.836 3.888 1.836 2.592 0 3.888-1.908.648-.972.756-1.944.072-.324.072-2.088zm-21.888-32.868v-7.56q0-2.484-1.548-2.484t-1.548 2.484v7.56q0 2.52 1.548 2.52t1.548-2.52zm25.884 27.036q0 8.424-.936 12.6-.504 2.124-2.088 3.564t-3.672 1.656q-6.624.756-19.98.756t-19.98-.756q-2.088-.216-3.69-1.656t-2.07-3.564q-.936-4.032-.936-12.6 0-8.424.936-12.6.504-2.124 2.088-3.564t3.708-1.692q6.588-.72 19.944-.72t19.98.72q2.088.252 3.69 1.692t2.07 3.564q.936 4.032.936 12.6zm-35.928-45.936h3.672l-4.356 14.364v9.756h-3.6v-9.756q-.504-2.664-2.196-7.632-1.332-3.708-2.34-6.732h3.816l2.556 9.468zm13.32 11.988v6.3q0 2.916-1.008 4.248-1.332 1.836-3.816 1.836-2.412 0-3.78-1.836-1.008-1.368-1.008-4.248v-6.3q0-2.88 1.008-4.212 1.368-1.836 3.78-1.836 2.484 0 3.816 1.836 1.008 1.332 1.008 4.212zm12.06-5.832v17.964h-3.276v-1.98q-1.908 2.232-3.708 2.232-1.656 0-2.124-1.332-.288-.864-.288-2.7v-14.184h3.276v13.212q0 1.188.036 1.26.108.792.756.792.972 0 2.052-1.548v-13.716h3.276z",
		"XING": "M21.492-40.427q-.36.648-9.252 16.416-.972 1.656-2.34 1.656h-8.604q-.756 0-1.116-.612t0-1.296l9.108-16.128v-.036l-5.796-10.044q-.432-.792-.036-1.332.324-.54 1.152-.54h8.604q1.44 0 2.376 1.62zm29.016-23.112q.396.576 0 1.332l-19.008 33.624v.036l12.096 22.14q.396.72.036 1.332-.36.54-1.152.54h-8.604q-1.512 0-2.376-1.62l-12.204-22.392q.648-1.152 19.116-33.912.9-1.62 2.304-1.62h8.676q.792 0 1.116.54z",
		"XING_SQUARE": "M24.66-36.899q0-.036-4.536-7.992-.756-1.224-1.872-1.224h-6.624q-.648 0-.936.396-.252.432.036 1.044l4.5 7.776v.036l-7.056 12.456q-.324.504 0 1.008.288.468.864.468h6.66q1.116 0 1.8-1.296zm22.464-17.892q-.252-.432-.864-.432h-6.732q-1.08 0-1.764 1.26l-14.796 26.244q.036.072 9.432 17.316.72 1.26 1.872 1.26h6.624q.648 0 .9-.432.288-.468-.036-1.008l-9.36-17.136v-.036l14.724-26.028q.288-.576 0-1.008zm8.172 5.328v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"YOUTUBE_PLAY": "M46.08-32.183q0-1.332-1.08-1.944l-18.432-11.52q-1.116-.72-2.34-.072-1.188.648-1.188 2.016v23.04q0 1.368 1.188 2.016.576.288 1.116.288.72 0 1.224-.36l18.432-11.52q1.08-.612 1.08-1.944zm18.432 0q0 3.456-.036 5.4t-.306 4.914-.81 5.31q-.576 2.628-2.484 4.428t-4.464 2.088q-7.992.9-24.156.9t-24.156-.9q-2.556-.288-4.482-2.088t-2.502-4.428q-.504-2.34-.774-5.31t-.306-4.914-.036-5.4.036-5.4.306-4.914.81-5.31q.576-2.628 2.484-4.428t4.464-2.088q7.992-.9 24.156-.9t24.156.9q2.556.288 4.482 2.088t2.502 4.428q.504 2.34.774 5.31t.306 4.914.036 5.4z",
		"DROPBOX": "M14.472-38.987l17.784 10.98-12.312 10.26-17.64-11.484zm35.496 19.98v3.888l-17.64 10.548v.036l-.036-.036-.036.036v-.036l-17.604-10.548v-3.888l5.292 3.456 12.312-10.224v-.072l.036.036.036-.036v.072l12.348 10.224zm-30.024-41.184l12.312 10.26-17.784 10.944-12.168-9.72zm30.096 21.204l12.168 9.756-17.604 11.484-12.348-10.26zm-5.436-21.204l17.604 11.484-12.168 9.72-17.784-10.944z",
		"STACK_OVERFLOW": "M46.404-5.687h-40.248v-17.28h-5.76v23.04h51.768v-23.04h-5.76v17.28zm-33.912-18.864l1.188-5.652 28.188 5.94-1.188 5.616zm3.708-13.464l2.412-5.256 26.1 12.204-2.412 5.22zm7.236-12.816l3.672-4.428 22.104 18.468-3.672 4.428zm14.292-13.608l17.172 23.076-4.608 3.456-17.172-23.076zm-25.848 52.956v-5.724h28.8v5.724h-28.8z",
		"INSTAGRAM": "M49.032-13.103v-23.328h-4.86q.72 2.268.72 4.716 0 4.536-2.304 8.37t-6.264 6.066-8.64 2.232q-7.092 0-12.132-4.878t-5.04-11.79q0-2.448.72-4.716h-5.076v23.328q0 .936.63 1.566t1.566.63h38.484q.9 0 1.548-.63t.648-1.566zm-10.224-19.188q0-4.464-3.258-7.614t-7.866-3.15q-4.572 0-7.83 3.15t-3.258 7.614 3.258 7.614 7.83 3.15q4.608 0 7.866-3.15t3.258-7.614zm10.224-12.96v-5.94q0-1.008-.72-1.746t-1.764-.738h-6.264q-1.044 0-1.764.738t-.72 1.746v5.94q0 1.044.72 1.764t1.764.72h6.264q1.044 0 1.764-.72t.72-1.764zm6.264-7.488v41.112q0 2.916-2.088 5.004t-5.004 2.088h-41.112q-2.916 0-5.004-2.088t-2.088-5.004v-41.112q0-2.916 2.088-5.004t5.004-2.088h41.112q2.916 0 5.004 2.088t2.088 5.004z",
		"FLICKR": "M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm-19.8 27.648q0-3.168-2.232-5.4t-5.4-2.232-5.4 2.232-2.232 5.4 2.232 5.4 5.4 2.232 5.4-2.232 2.232-5.4zm20.304 0q0-3.168-2.232-5.4t-5.4-2.232-5.4 2.232-2.232 5.4 2.232 5.4 5.4 2.232 5.4-2.232 2.232-5.4z",
		"ADN": "M27.648-42.047l7.236 11.016h-14.472zm13.14 19.08h3.384l-16.524-24.876-16.524 24.876h3.384l3.744-5.76h18.792zm14.508-9.216q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"BITBUCKET": "M29.34-33.515q.288 2.268-1.818 3.636t-4.014.216q-1.404-.612-1.926-2.088t-.018-2.952 1.872-2.088q1.296-.648 2.61-.432t2.304 1.278.99 2.43zm3.996-.756q-.504-3.852-4.068-5.904t-7.092-.468q-2.268 1.008-3.618 3.186t-1.242 4.662q.144 3.276 2.79 5.58t5.958 2.016q3.276-.288 5.472-3.024t1.8-6.048zm8.604-19.512q-.72-.972-2.016-1.602t-2.088-.792-2.556-.45q-10.476-1.692-20.376.072-1.548.252-2.376.432t-1.98.792-1.8 1.548q1.08 1.008 2.736 1.638t2.646.792 3.15.414q8.208 1.044 16.128.036 2.268-.288 3.222-.432t2.61-.774 2.7-1.674zm2.052 37.26q-.288.936-.558 2.754t-.504 3.024-1.026 2.52-2.088 2.034q-3.096 1.728-6.822 2.574t-7.272.792-7.254-.666q-1.656-.288-2.934-.648t-2.754-.972-2.628-1.566-1.872-2.214q-.9-3.456-2.052-10.512l.216-.576.648-.324q8.028 5.328 18.234 5.328t18.27-5.328q.756.216.864.828t-.18 1.62-.288 1.332zm6.516-34.596q-.936 6.012-3.996 23.58-.18 1.08-.972 2.016t-1.566 1.44-1.962 1.116q-9.072 4.536-21.96 3.168-8.928-.972-14.184-5.004-.54-.432-.918-.954t-.612-1.26-.324-1.224-.216-1.422-.198-1.26q-.324-1.8-.954-5.4t-1.008-5.814-.846-5.31-.792-5.688q.108-.936.63-1.746t1.134-1.35 1.62-1.08 1.656-.81 1.728-.666q4.5-1.656 11.268-2.304 13.644-1.332 24.336 1.8 5.58 1.656 7.74 4.392.576.72.594 1.836t-.198 1.944z",
		"BITBUCKET_SQUARE": "M30.528-33.119q0-1.548-1.476-2.376t-2.772-.036q-1.548.72-1.53 2.61t1.566 2.538q1.404.828 2.916-.144t1.296-2.592zm2.88-.576q.288 2.376-1.296 4.356t-3.96 2.196-4.284-1.44-2.016-4.068q-.072-1.764.918-3.348t2.61-2.304q2.52-1.116 5.094.36t2.934 4.248zm6.192-14.076q-.72.756-1.926 1.224t-1.908.576-2.286.288q-5.58.72-11.664 0-1.584-.216-2.268-.342t-1.89-.576-1.962-1.17q.468-.684 1.296-1.116t1.44-.558 1.692-.306q7.128-1.26 14.688-.036 1.188.18 1.836.306t1.548.576 1.404 1.134zm1.512 26.856q0-.252.198-.954t.108-1.152-.63-.594q-5.796 3.816-13.14 3.816t-13.176-3.816l-.432.216-.18.432q.936 5.544 1.476 7.56 1.692 2.916 7.344 3.888 8.964 1.656 15.408-1.908 1.224-.684 1.764-1.854t.81-3.078.45-2.556zm4.68-24.948q.324-1.908-.288-2.7-1.548-1.98-5.58-3.168-7.776-2.268-17.532-1.296-4.752.432-8.136 1.656-1.368.54-2.142.9t-1.692 1.224-1.062 1.944q.288 2.448.684 4.968t1.044 6.156.864 4.932q.036.18.18 1.116t.252 1.296.432.972.792 1.008q3.78 2.88 10.224 3.6 9.324 1.008 15.84-2.268.864-.468 1.422-.828t1.116-1.044.702-1.44q1.728-9.612 2.88-17.028zm9.504-3.6v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TUMBLR": "M33.984-16.595l2.88 8.532q-.828 1.26-3.996 2.376t-6.372 1.152q-3.744.072-6.858-.936t-5.13-2.664-3.42-3.816-1.998-4.32-.594-4.248v-19.584h-6.048v-7.74q2.592-.936 4.644-2.502t3.276-3.24 2.088-3.672 1.224-3.564.54-3.186q.036-.18.162-.306t.27-.126h8.784v15.264h11.988v9.072h-12.024v18.648q0 1.08.234 2.016t.81 1.89 1.782 1.494 2.934.504q2.808-.072 4.824-1.044z",
		"TUMBLR_SQUARE": "M40.896-11.843l-2.232-6.588q-1.584.792-3.708.792-1.296.036-2.232-.378t-1.386-1.134-.63-1.458-.18-1.566v-14.328h9.252v-6.984h-9.216v-11.736h-6.768q-.288 0-.324.36-.18 1.584-.63 3.132t-1.404 3.42-2.772 3.42-4.266 2.448v5.94h4.68v15.048q0 2.052.774 4.14t2.34 3.996 4.356 3.078 6.354 1.098q2.484-.036 4.914-.9t3.078-1.8zm14.4-37.62v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"LONG_ARROW_DOWN": "M27.54-17.675q.288.684-.18 1.26l-12.6 13.824q-.36.36-.828.36-.504 0-.864-.36l-12.78-13.824q-.468-.576-.18-1.26.324-.684 1.044-.684h8.064v-44.928q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v44.928h8.064q.756 0 1.044.684z",
		"LONG_ARROW_UP": "M27.54-46.691q-.324.684-1.044.684h-8.064v44.928q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-44.928h-8.064q-.756 0-1.044-.684t.18-1.26l12.6-13.824q.36-.36.828-.36.504 0 .864.36l12.78 13.824q.468.576.18 1.26z",
		"LONG_ARROW_LEFT": "M64.512-35.639v6.912q0 .504-.324.828t-.828.324h-44.928v8.064q0 .756-.684 1.044t-1.26-.18l-13.824-12.6q-.36-.36-.36-.828 0-.504.36-.864l13.824-12.744q.576-.504 1.26-.216.684.324.684 1.044v8.064h44.928q.504 0 .828.324t.324.828z",
		"LONG_ARROW_RIGHT": "M62.208-32.291q0 .504-.36.864l-13.824 12.744q-.576.504-1.26.216-.684-.324-.684-1.044v-8.064h-44.928q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h44.928v-8.064q0-.756.684-1.044t1.26.18l13.824 12.6q.36.36.36.828z",
		"APPLE": "M50.148-20.699q-1.404 4.5-4.428 9-4.644 7.056-9.252 7.056-1.764 0-5.04-1.152-3.096-1.152-5.436-1.152-2.196 0-5.112 1.188-2.916 1.224-4.752 1.224-5.472 0-10.836-9.324-5.292-9.396-5.292-18.108 0-8.208 4.068-13.464 4.032-5.184 10.224-5.184 2.592 0 6.372 1.08 3.744 1.08 4.968 1.08 1.62 0 5.148-1.224 3.672-1.224 6.228-1.224 4.284 0 7.668 2.34 1.872 1.296 3.744 3.6-2.844 2.412-4.104 4.248-2.34 3.384-2.34 7.452 0 4.464 2.484 8.028t5.688 4.536zm-13.536-42.228q0 2.196-1.044 4.896-1.08 2.7-3.348 4.968-1.944 1.944-3.888 2.592-1.332.396-3.744.612.108-5.364 2.808-9.252 2.664-3.852 9-5.328l.09.396.09.396.018.36.018.36z",
		"WINDOWS": "M24.552-28.223v23.436l-24.552-3.384v-20.052h24.552zm0-26.748v23.724h-24.552v-20.34zm35.352 26.748v28.296l-32.652-4.5v-23.796h32.652zm0-31.608v28.584h-32.652v-24.084z",
		"ANDROID": "M17.748-47.051q.576 0 .99-.414t.414-.99-.414-.99-.99-.414-.972.414-.396.99.396.99.972.414zm15.192 0q.576 0 .972-.414t.396-.99-.396-.99-.972-.414-.99.414-.414.99.414.99.99.414zm-29.232 6.624q1.512 0 2.592 1.08t1.08 2.592v15.48q0 1.548-1.062 2.628t-2.61 1.08-2.628-1.08-1.08-2.628v-15.48q0-1.512 1.08-2.592t2.628-1.08zm38.16.684v23.976q0 1.656-1.152 2.808t-2.772 1.152h-2.7v8.172q0 1.548-1.08 2.628t-2.628 1.08-2.628-1.08-1.08-2.628v-8.172h-4.968v8.172q0 1.548-1.08 2.628t-2.628 1.08q-1.512 0-2.592-1.08t-1.08-2.628l-.036-8.172h-2.664q-1.656 0-2.808-1.152t-1.152-2.808v-23.976h33.048zm-8.352-14.58q3.852 1.98 6.156 5.526t2.304 7.758h-33.3q0-4.212 2.304-7.758t6.192-5.526l-2.556-4.716q-.252-.468.18-.72.468-.216.72.216l2.592 4.752q3.42-1.512 7.236-1.512t7.236 1.512l2.592-4.752q.252-.432.72-.216.432.252.18.72zm17.172 17.568v15.48q0 1.548-1.08 2.628t-2.628 1.08q-1.512 0-2.592-1.08t-1.08-2.628v-15.48q0-1.548 1.08-2.61t2.592-1.062q1.548 0 2.628 1.062t1.08 2.61z",
		"LINUX": "M23.868-49.643q-.396.036-.558.378t-.306.342q-.18.036-.18-.18 0-.432.684-.54h.36zm3.132.504q-.144.036-.414-.234t-.63-.162q.864-.396 1.152.072.108.216-.108.324zm-12.636 15.372q-.144-.036-.216.108t-.162.45-.198.486-.36.468q-.252.36-.036.432.144.036.45-.252t.45-.648l.072-.252.072-.216.054-.162.018-.144v-.108l-.036-.09-.108-.072zm30.78 12.924q0-.648-1.98-1.512.144-.54.27-.99t.18-.936.108-.774.018-.81-.036-.702-.126-.792-.144-.738-.18-.9-.198-.954q-.36-1.728-1.692-3.708t-2.592-2.7q.864.72 2.052 2.988 3.132 5.832 1.944 10.008-.396 1.44-1.8 1.512-1.116.144-1.386-.666t-.288-3.006-.414-3.852q-.324-1.404-.702-2.484t-.702-1.638-.558-.882-.468-.54-.27-.252q-.504-2.232-1.116-3.708t-1.062-2.016-.846-1.188-.54-1.44q-.144-.756.216-1.926t.162-1.782-1.602-.9q-.54-.108-1.602-.648t-1.278-.576q-.288-.036-.396-.936t.288-1.836 1.296-.972q1.332-.108 1.836 1.08t.144 2.088q-.396.684-.072.954t1.08.018q.468-.144.468-1.296v-1.332q-.18-1.08-.486-1.8t-.756-1.098-.846-.54-.972-.27q-3.852.288-3.204 4.824 0 .54-.036.54-.324-.324-1.062-.378t-1.188.018-.558-.18q.036-2.052-.576-3.24t-1.62-1.224q-.972-.036-1.494.99t-.594 2.142q-.036.54.126 1.332t.468 1.35.558.486q.36-.108.576-.504.144-.324-.252-.288-.252 0-.558-.522t-.342-1.206q-.036-.792.324-1.332t1.224-.504q.612 0 .972.756t.342 1.404-.054.792q-.792.54-1.116 1.044-.288.432-.99.846t-.738.45q-.468.504-.558.972t.27.648q.504.288.9.702t.576.684.666.468 1.278.234q1.692.072 3.672-.54.072-.036.828-.252t1.242-.378 1.062-.468.756-.63q.324-.504.72-.288.18.108.234.306t-.108.432-.594.342q-.72.216-2.034.774t-1.638.702q-1.584.684-2.52.828-.9.18-2.844-.072-.36-.072-.324.072t.612.684q.9.828 2.412.792.612-.036 1.296-.252t1.296-.504 1.206-.63 1.08-.612.882-.432.63-.09.306.396q0 .072-.036.162t-.144.18-.216.162-.306.18-.324.162-.36.18-.342.162q-1.008.504-2.43 1.584t-2.394 1.548-1.764.036q-.756-.396-2.268-2.628-.792-1.116-.9-.792-.036.108-.036.36 0 .9-.54 2.034t-1.062 1.998-.756 2.088.414 2.268q-.828.216-2.25 3.24t-1.71 5.076q-.072.648-.054 2.484t-.198 2.124q-.288.864-1.044.108-1.152-1.116-1.296-3.384-.072-1.008.144-2.016.144-.684-.036-.648l-.144.18q-1.296 2.34.36 5.976.18.432.9 1.008t.864.72q.72.828 3.744 3.258t3.348 2.754q.576.54.63 1.368t-.504 1.548-1.638.828q.288.54 1.044 1.602t1.008 1.944.252 2.538q1.656-.864.252-3.312-.144-.288-.378-.576t-.342-.432-.072-.216q.108-.18.468-.342t.72.09q1.656 1.872 5.976 1.296 4.788-.54 6.372-3.132.828-1.368 1.224-1.08.432.216.36 1.872-.036.9-.828 3.312-.324.828-.216 1.35t.864.558q.108-.684.522-2.772t.486-3.24q.072-.756-.234-2.646t-.27-3.492.828-2.538q.54-.648 1.836-.648.036-1.332 1.242-1.908t2.61-.378 2.16.81zm-22.608-29.772q.108-.612-.09-1.08t-.414-.54q-.324-.072-.324.252.072.18.18.216.36 0 .252.54-.108.72.288.72.108 0 .108-.108zm15.084 7.092q-.072-.288-.234-.414t-.468-.18-.522-.198q-.18-.108-.342-.288t-.252-.288-.198-.234-.144-.144-.144.054q-.504.576.252 1.566t1.404 1.134q.324.036.522-.288t.126-.72zm-6.408-7.668q0-.396-.18-.702t-.396-.45-.324-.108q-.504.036-.252.252l.144.072q.504.144.648 1.116 0 .108.288-.072zm1.944-8.388q0-.072-.09-.18t-.324-.252-.342-.216q-.54-.54-.864-.54-.324.036-.414.27t-.036.468-.018.45q-.036.144-.216.378t-.216.324.108.306q.144.108.288 0t.396-.324.54-.324q.036-.036.324-.036t.54-.072.324-.252zm20.34 48.276q.72.432 1.116.882t.432.864-.09.81-.558.792-.846.702-1.08.666-1.134.594-1.152.558-.972.468q-1.368.684-3.078 2.016t-2.718 2.304q-.612.576-2.448.702t-3.204-.522q-.648-.324-1.062-.846t-.594-.918-.792-.702-1.692-.342q-1.584-.036-4.68-.036-.684 0-2.052.054t-2.088.09q-1.584.036-2.862.54t-1.926 1.08-1.566 1.026-1.926.414q-1.044-.036-3.996-1.116t-5.256-1.548q-.684-.144-1.836-.342t-1.8-.324-1.422-.342-1.206-.522-.612-.702q-.36-.828.252-2.394t.648-1.962q.036-.576-.144-1.44t-.36-1.53-.162-1.314.378-.972q.504-.432 2.052-.504t2.16-.432q1.08-.648 1.512-1.26t.432-1.836q.756 2.628-1.152 3.816-1.152.72-2.988.54-1.224-.108-1.548.36-.468.54.18 2.052.072.216.288.648t.306.648.162.612.036.792q0 .54-.612 1.764t-.504 1.728q.108.612 1.332.936.72.216 3.042.666t3.582.738q.864.216 2.664.792t2.97.828 1.998.144q1.548-.216 2.322-1.008t.828-1.728-.27-2.106-.684-1.872-.72-1.314q-4.356-6.84-6.084-8.712-2.448-2.664-4.068-1.44-.396.324-.54-.54-.108-.576-.072-1.368.036-1.044.36-1.872t.864-1.692.792-1.512q.288-.756.954-2.592t1.062-2.808 1.08-2.196 1.404-1.944q3.96-5.148 4.464-7.02-.432-4.032-.576-11.16-.072-3.24.864-5.454t3.816-3.762q1.404-.756 3.744-.756 1.908-.036 3.816.486t3.204 1.494q2.052 1.512 3.294 4.374t1.062 5.31q-.18 3.42 1.08 7.704 1.224 4.068 4.788 7.848 1.98 2.124 3.582 5.868t2.142 6.876q.288 1.764.18 3.042t-.432 1.998-.72.792q-.36.072-.846.684t-.972 1.278-1.458 1.206-2.196.504q-.648-.036-1.134-.18t-.81-.486-.486-.558-.414-.738-.324-.702q-.792-1.332-1.476-1.08t-1.008 1.764.252 3.492q.72 2.52.036 7.02-.36 2.34.648 3.618t2.628 1.188 3.06-1.278q2.124-1.764 3.222-2.394t3.726-1.53q1.908-.648 2.772-1.314t.666-1.242-.9-1.026-1.854-.846q-1.188-.396-1.782-1.728t-.54-2.61.558-1.71q.036 1.116.288 2.034t.522 1.458.738 1.026.756.684.774.468.594.342z",
		"DRIBBBLE": "M36.864-10.439q-1.512-8.676-5.04-17.928h-.072l-.072.036q-.576.216-1.548.594t-3.636 1.764-4.932 2.952-4.716 4.122-3.708 5.328l-.54-.396q6.624 5.4 15.048 5.4 4.752 0 9.216-1.872zm-6.66-21.852q-.756-1.764-1.908-3.996-11.196 3.348-24.228 3.348-.036.252-.036.756 0 4.464 1.584 8.514t4.464 7.254q1.8-3.204 4.446-5.994t5.13-4.482 4.698-2.916 3.582-1.728l1.332-.468q.144-.036.468-.126t.468-.162zm-3.852-7.632q-4.32-7.668-8.784-13.608-4.968 2.34-8.424 6.696t-4.608 9.792q10.872 0 21.816-2.88zm24.624 11.484q-7.56-2.16-14.724-1.044 3.132 8.604 4.608 16.884 3.996-2.7 6.66-6.822t3.456-9.018zm-28.98-26.676l-.072.036.072-.036zm21.24 5.22q-6.66-5.904-15.588-5.904-2.736 0-5.58.684 4.716 6.12 8.856 13.752 2.484-.936 4.68-2.178t3.474-2.214 2.358-2.052 1.35-1.458zm8.028 17.46q-.108-8.352-5.364-14.76l-.036.036q-.324.432-.684.882t-1.566 1.602-2.556 2.178-3.6 2.34-4.734 2.322q.9 1.908 1.584 3.42.072.216.234.63t.27.594q1.296-.18 2.682-.252t2.646-.072 2.484.054 2.304.144 2.034.198 1.728.234 1.314.216.9.162zm4.032.252q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"SKYPE": "M42.228-26.171q0-1.8-.702-3.294t-1.746-2.466-2.628-1.764-2.97-1.224-3.15-.828l-3.744-.864q-1.08-.252-1.584-.378t-1.26-.414-1.08-.576-.594-.756-.27-1.08q0-2.772 5.184-2.772 1.548 0 2.772.432t1.944 1.026 1.368 1.206 1.44 1.044 1.728.432q1.692 0 2.718-1.152t1.026-2.772q0-1.98-2.016-3.582t-5.112-2.43-6.552-.828q-2.448 0-4.752.558t-4.302 1.692-3.204 3.132-1.206 4.626q0 2.196.684 3.834t2.016 2.718 2.88 1.746 3.708 1.17l5.256 1.296q3.24.792 4.032 1.296 1.152.72 1.152 2.16 0 1.404-1.44 2.322t-3.78.918q-1.836 0-3.294-.576t-2.34-1.386-1.638-1.62-1.656-1.386-1.944-.576q-1.8 0-2.718 1.08t-.918 2.7q0 3.312 4.392 5.67t10.476 2.358q2.628 0 5.04-.666t4.41-1.926 3.186-3.366 1.188-4.734zm13.068 7.812q0 5.724-4.05 9.774t-9.774 4.05q-4.68 0-8.424-2.88-2.772.576-5.4.576-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846q0-2.628.576-5.4-2.88-3.744-2.88-8.424 0-5.724 4.05-9.774t9.774-4.05q4.68 0 8.424 2.88 2.772-.576 5.4-.576 5.148 0 9.846 1.998t8.1 5.4 5.4 8.1 1.998 9.846q0 2.628-.576 5.4 2.88 3.744 2.88 8.424z",
		"FOURSQUARE": "M36-48.815l1.332-6.984q.18-.828-.324-1.44t-1.26-.612h-25.632q-.828 0-1.386.612t-.558 1.332v39.636q0 .252.216.036l10.476-12.672q.828-.936 1.368-1.206t1.728-.27h8.604q.792 0 1.332-.522t.648-1.062q.864-4.68 1.332-6.876.144-.756-.414-1.44t-1.314-.684h-10.584q-1.044 0-1.728-.684t-.684-1.728v-1.512q0-1.044.684-1.71t1.728-.666h12.456q.648 0 1.26-.486t.72-1.062zm8.172-7.992q-.54 2.628-1.926 9.594t-2.502 12.6-1.26 6.246q-.216.792-.324 1.17t-.504 1.17-.882 1.188-1.386.756-2.088.36h-9.756q-.468 0-.792.36-.288.324-15.336 17.784-.792.9-2.106 1.026t-1.746-.198q-1.98-.792-1.98-3.528v-50.76q0-1.98 1.368-3.69t4.32-1.71h31.968q3.42 0 4.572 1.908t.36 5.724zm0 0l-5.688 28.44q.144-.612 1.26-6.246t2.502-12.6 1.926-9.594z",
		"TRELLO": "M25.344-16.055v-36.864q0-.504-.324-.828t-.828-.324h-17.28q-.504 0-.828.324t-.324.828v36.864q0 .504.324.828t.828.324h17.28q.504 0 .828-.324t.324-.828zm24.192-13.824v-23.04q0-.504-.324-.828t-.828-.324h-17.28q-.504 0-.828.324t-.324.828v23.04q0 .504.324.828t.828.324h17.28q.504 0 .828-.324t.324-.828zm5.76-27.648v50.688q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z",
		"FEMALE": "M46.08-26.423q0 1.44-1.008 2.448t-2.448 1.008q-1.836 0-2.88-1.548l-8.172-12.276h-1.62v4.752l8.892 14.796q.324.54.324 1.188 0 .936-.684 1.62t-1.62.684h-6.912v9.792q0 1.656-1.188 2.844t-2.844 1.188h-5.76q-1.656 0-2.844-1.188t-1.188-2.844v-9.792h-6.912q-.936 0-1.62-.684t-.684-1.62q0-.648.324-1.188l8.892-14.796v-4.752h-1.62l-8.172 12.276q-1.044 1.548-2.88 1.548-1.44 0-2.448-1.008t-1.008-2.448q0-1.044.576-1.908l9.216-13.824q2.628-3.852 6.336-3.852h13.824q3.708 0 6.336 3.852l9.216 13.824q.576.864.576 1.908zm-14.976-28.8q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z",
		"MALE": "M36.864-39.095v14.976q0 1.44-1.008 2.448t-2.448 1.008-2.448-1.008-1.008-2.448v-12.672h-2.304v32.832q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-16.704h-2.304v16.704q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-32.832h-2.304v12.672q0 1.44-1.008 2.448t-2.448 1.008-2.448-1.008-1.008-2.448v-14.976q0-2.88 2.016-4.896t4.896-2.016h23.04q2.88 0 4.896 2.016t2.016 4.896zm-10.368-16.128q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z",
		"GRATIPAY": "M27.828-17.567l12.6-17.028q.576-.792.882-2.124t-.216-3.06-2.214-2.844q-1.44-.936-2.988-.918t-2.646.63-1.962 1.62q-1.296 1.44-3.456 1.44-2.124 0-3.42-1.44-.864-1.008-1.962-1.62t-2.646-.63-3.024.918q-1.656 1.116-2.178 2.844t-.216 3.06.882 2.124zm27.468-14.616q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"SUN_O": "M52.992-32.183q0-4.212-1.638-8.046t-4.428-6.624-6.624-4.428-8.046-1.638-8.046 1.638-6.624 4.428-4.428 6.624-1.638 8.046 1.638 8.046 4.428 6.624 6.624 4.428 8.046 1.638 8.046-1.638 6.624-4.428 4.428-6.624 1.638-8.046zm9.936 9.972q-.144.54-.72.72l-10.512 3.456v11.016q0 .576-.468.936-.54.36-1.044.144l-10.512-3.384-6.48 8.928q-.36.468-.936.468t-.936-.468l-6.48-8.928-10.512 3.384q-.504.216-1.044-.144-.468-.36-.468-.936v-11.016l-10.512-3.456q-.576-.18-.72-.72-.18-.612.144-1.044l6.48-8.928-6.48-8.928q-.324-.468-.144-1.044.144-.54.72-.72l10.512-3.456v-11.016q0-.576.468-.936.54-.36 1.044-.144l10.512 3.384 6.48-8.928q.324-.432.936-.432t.936.432l6.48 8.928 10.512-3.384q.504-.216 1.044.144.468.36.468.936v11.016l10.512 3.456q.576.18.72.72.18.576-.144 1.044l-6.48 8.928 6.48 8.928q.324.432.144 1.044z",
		"MOON_O": "M45.432-17.531q-1.944.324-3.96.324-6.552 0-12.132-3.24t-8.82-8.82-3.24-12.132q0-6.912 3.744-12.852-7.236 2.16-11.826 8.244t-4.59 13.824q0 4.68 1.836 8.946t4.914 7.344 7.344 4.914 8.946 1.836q5.184 0 9.846-2.214t7.938-6.174zm7.308-3.06q-3.384 7.308-10.206 11.682t-14.886 4.374q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728q0-5.508 2.07-10.53t5.616-8.694 8.478-5.922 10.44-2.466q1.584-.072 2.196 1.404.648 1.476-.54 2.592-3.096 2.808-4.734 6.534t-1.638 7.866q0 5.328 2.628 9.828t7.128 7.128 9.828 2.628q4.248 0 8.208-1.836 1.476-.648 2.592.468.504.504.63 1.224t-.162 1.368z",
		"ARCHIVE": "M39.168-34.487q0-.936-.684-1.62t-1.62-.684h-9.216q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684h9.216q.936 0 1.62-.684t.684-1.62zm20.736-6.912v34.56q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-34.56q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm2.304-16.128v9.216q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62z",
		"BUG": "M58.752-29.879q0 .936-.684 1.62t-1.62.684h-8.064q0 6.156-2.412 10.44l7.488 7.524q.684.684.684 1.62t-.684 1.62q-.648.684-1.62.684t-1.62-.684l-7.128-7.092q-.18.18-.54.468t-1.512 1.026-2.34 1.314-2.952 1.044-3.492.468v-32.256h-4.608v32.256q-1.836 0-3.654-.486t-3.132-1.188-2.376-1.404-1.566-1.17l-.54-.504-6.588 7.452q-.72.756-1.728.756-.864 0-1.548-.576-.684-.648-.738-1.602t.558-1.674l7.272-8.172q-2.088-4.104-2.088-9.864h-8.064q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h8.064v-10.584l-6.228-6.228q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684l6.228 6.228h30.384l6.228-6.228q.684-.684 1.62-.684t1.62.684.684 1.62-.684 1.62l-6.228 6.228v10.584h8.064q.936 0 1.62.684t.684 1.62zm-17.28-20.736h-23.04q0-4.788 3.366-8.154t8.154-3.366 8.154 3.366 3.366 8.154z",
		"VK": "M69.012-45.719q.828 2.304-5.4 10.584-.864 1.152-2.34 3.06-2.808 3.6-3.24 4.716-.612 1.476.504 2.916.612.756 2.916 2.952h.036l.036.036.036.036.072.072q5.076 4.716 6.876 7.956.108.18.234.45t.252.954-.018 1.224-.9.99-2.124.45l-9.216.144q-.864.18-2.016-.18t-1.872-.792l-.72-.432q-1.08-.756-2.52-2.304t-2.466-2.79-2.196-2.088-2.034-.558q-.108.036-.288.126t-.612.522-.774 1.062-.612 1.872-.234 2.79q0 .54-.126.99t-.27.666l-.144.18q-.648.684-1.908.792h-4.14q-2.556.144-5.256-.594t-4.734-1.908-3.708-2.376-2.538-2.07l-.9-.864q-.36-.36-.99-1.08t-2.574-3.276-3.816-5.436-4.41-7.596-4.698-9.792q-.216-.576-.216-.972t.108-.576l.144-.216q.54-.684 2.052-.684l9.864-.072q.432.072.828.234t.576.306l.18.108q.576.396.864 1.152.72 1.8 1.656 3.726t1.476 2.934l.576 1.044q1.044 2.16 2.016 3.744t1.746 2.466 1.494 1.386 1.224.504.972-.18q.072-.036.18-.18t.432-.792.486-1.692.342-2.916 0-4.5q-.072-1.44-.324-2.628t-.504-1.656l-.216-.432q-.9-1.224-3.06-1.548-.468-.072.18-.864.612-.684 1.368-1.08 1.908-.936 8.604-.864 2.952.036 4.86.468.72.18 1.206.486t.738.864.378 1.152.126 1.638-.036 1.98-.09 2.538-.054 2.97q0 .396-.036 1.512t-.018 1.728.126 1.458.414 1.404.81.882q.288.072.612.144t.936-.396 1.368-1.242 1.872-2.412 2.448-3.87q2.16-3.744 3.852-8.1.144-.36.36-.63t.396-.378l.144-.108.18-.09.468-.108.72-.018 10.368-.072q1.404-.18 2.304.09t1.116.594z",
		"WEIBO": "M24.3-18.215q.756-1.224.396-2.484t-1.62-1.8q-1.224-.504-2.628-.036t-2.16 1.656q-.792 1.224-.468 2.466t1.548 1.818 2.682.09 2.25-1.71zm3.384-4.356q.288-.468.126-.954t-.63-.666q-.504-.18-1.026.018t-.774.666q-.612 1.116.468 1.62.504.18 1.044-.018t.792-.666zm6.264 3.852q-1.62 3.672-5.688 5.4t-8.064.432q-3.852-1.224-5.31-4.554t.234-6.75q1.692-3.348 5.454-5.004t7.578-.684q3.996 1.044 5.706 4.302t.09 6.858zm11.232-5.76q-.324-3.456-3.204-6.12t-7.506-3.924-9.882-.756q-8.028.828-13.302 5.094t-4.77 9.522q.324 3.456 3.204 6.12t7.506 3.924 9.882.756q8.028-.828 13.302-5.094t4.77-9.522zm11.088.144q0 2.448-1.332 5.022t-3.924 4.932-6.066 4.23-8.136 2.988-9.738 1.116-9.9-1.206-8.658-3.348-6.174-5.436-2.34-7.182q0-4.14 2.502-8.82t7.11-9.288q6.084-6.084 12.294-8.496t8.874.252q2.34 2.304.72 7.524-.144.504-.036.72t.36.252.522-.018.486-.126l.216-.072q5.004-2.124 8.856-2.124t5.508 2.196q1.62 2.268 0 6.408-.072.468-.162.72t.162.45.432.27.612.216q2.052.648 3.708 1.692t2.88 2.934 1.224 4.194zm-2.664-22.464q1.512 1.692 1.962 3.906t-.234 4.23q-.288.828-1.062 1.224t-1.602.144q-.828-.288-1.224-1.062t-.144-1.602q.72-2.268-.864-3.996t-3.852-1.26q-.864.18-1.62-.288t-.9-1.332q-.18-.864.288-1.602t1.332-.918q2.16-.468 4.284.198t3.636 2.358zm6.516-5.868q3.132 3.456 4.05 8.01t-.486 8.694q-.324.972-1.224 1.44t-1.872.144-1.44-1.224-.18-1.872q1.008-2.952.36-6.192t-2.88-5.688q-2.232-2.484-5.328-3.438t-6.228-.306q-1.008.216-1.872-.342t-1.08-1.566.342-1.854 1.566-1.062q4.428-.936 8.784.414t7.488 4.842z",
		"RENREN": "M40.788-7.919q-6.156 3.384-13.248 3.384-7.056 0-13.212-3.384 4.968-3.132 8.478-7.596t4.734-9.648q1.26 5.184 4.77 9.648t8.478 7.596zm-17.82-51.408v17.46q0 9.072-4.554 16.542t-11.898 11.034q-6.516-7.74-6.516-17.82 0-6.732 3.006-12.582t8.262-9.702 11.7-4.932zm32.328 27.216q0 10.08-6.516 17.82-7.344-3.564-11.898-11.034t-4.554-16.542v-17.46q6.444 1.08 11.7 4.932t8.262 9.702 3.006 12.582z",
		"PAGELINES": "M50.472-24.731q-1.152 2.88-2.736 4.968t-3.276 3.186-3.564 1.674-3.654.522-3.474-.306-3.114-.792-2.502-.99-1.656-.81l-.612-.36q-4.068 8.208-10.422 12.942t-13.842 4.77q-.684 0-1.152-.468t-.468-1.152.468-1.134 1.152-.45q6.228-.036 11.61-3.87t9.054-10.602q-1.296.504-2.592.828t-2.988.468-3.276-.09-3.348-1.026-3.312-2.124-3.042-3.6-2.682-5.256q4.104-1.692 7.704-2.052t6.03.27 4.482 2.034 3.186 2.772 2.034 2.952q1.908-4.716 2.844-10.476-.252.036-.648.09t-1.674.09-2.502-.018-2.934-.36-3.186-.828-3.024-1.53-2.7-2.34-1.962-3.402-1.026-4.59q2.52-1.008 4.806-1.314t4.05.036 3.312 1.08 2.646 1.8 2.016 2.196 1.512 2.268.99 2.016.576 1.422l.144.576q.432-4.392.432-7.02-.288-.216-.774-.576t-1.764-1.602-2.286-2.574-1.944-3.348-1.188-4.05.432-4.572 2.52-4.986q2.628.9 4.59 2.214t3.042 2.754 1.728 3.06.738 3.204-.018 3.078-.468 2.754-.684 2.232-.612 1.512l-.252.54q.036.18.036 1.818t-.036 2.574q.108-.252.36-.666t1.098-1.548 1.818-2.088 2.556-1.998 3.294-1.602 4.032-.522 4.77.864q-.072 2.808-.774 5.094t-1.8 3.762-2.502 2.574-2.934 1.638-3.042.864-2.88.342-2.43-.036-1.674-.162l-.612-.108q-.828 5.292-2.628 10.188.216-.252.648-.666t1.782-1.476 2.79-1.89 3.582-1.512 4.23-.72 4.644.846 4.932 2.79z",
		"STACK_EXCHANGE": "M45.324-19.331v2.376q0 3.06-2.07 5.202t-4.986 2.142h-2.052l-9.36 9.684v-9.684h-19.044q-2.916 0-4.986-2.142t-2.07-5.202v-2.376h44.568zm0-11.736v9.18h-44.568v-9.18h44.568zm0-11.808v9.18h-44.568v-9.18h44.568zm0-5.04v2.412h-44.568v-2.412q0-3.024 2.07-5.166t4.986-2.142h30.456q2.916 0 4.986 2.142t2.07 5.166z",
		"ARROW_CIRCLE_O_RIGHT": "M41.472-32.183q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-12.672q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h12.672v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828zm5.76 0q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"ARROW_CIRCLE_O_LEFT": "M41.472-35.639v6.912q0 .468-.342.81t-.81.342h-12.672v6.912q0 .504-.324.828t-.828.324q-.432 0-.864-.36l-11.484-11.484q-.324-.324-.324-.828t.324-.828l11.52-11.52q.324-.324.828-.324.468 0 .81.342t.342.81v6.912h12.672q.468 0 .81.342t.342.81zm5.76 3.456q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"TOGGLE_LEFT": "M36.864-43.703v23.04q0 .936-.684 1.62t-1.62.684q-.72 0-1.332-.432l-16.128-11.52q-.972-.684-.972-1.872t.972-1.872l16.128-11.52q.612-.432 1.332-.432.936 0 1.62.684t.684 1.62zm9.216 28.8v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"DOT_CIRCLE_O": "M36.864-32.183q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm-9.216-19.584q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"WHEELCHAIR": "M36.828-21.707l3.672 7.344q-2.088 6.444-7.56 10.44t-12.204 3.996q-5.616 0-10.386-2.79t-7.56-7.56-2.79-10.386q0-6.516 3.762-11.88t9.882-7.596l.612 4.716q-4.392 1.944-7.02 5.958t-2.628 8.802q0 6.66 4.734 11.394t11.394 4.734q4.536 0 8.37-2.34t5.94-6.318 1.782-8.514zm19.728 3.6l2.088 4.104-9.216 4.608q-.468.252-1.044.252-1.44 0-2.052-1.26l-8.604-17.172h-16.992q-.864 0-1.53-.594t-.774-1.458l-3.456-28.044q-.072-.576.216-1.512.504-1.836 2.052-2.97t3.492-1.134q2.376 0 4.068 1.692t1.692 4.068q0 2.484-1.872 4.23t-4.32 1.494l1.332 10.404h15.228v4.608h-14.652l.576 4.608h16.38q1.44 0 2.052 1.26l8.208 16.38z",
		"VIMEO_SQUARE": "M46.512-41.471q.36-7.776-5.796-7.992-8.316-.288-11.232 9.396 1.584-.684 2.952-.684 3.06 0 2.664 3.456-.144 2.052-2.664 6.012t-3.78 3.96q-1.548 0-2.952-6.084-.468-1.944-1.62-9.18-1.08-6.804-5.76-6.372-2.124.252-5.904 3.6l-2.916 2.592-2.916 2.592 1.872 2.412q2.736-1.872 3.132-1.872 2.052 0 3.852 6.444.54 1.98 1.62 5.922t1.62 5.922q2.448 6.444 5.904 6.444 5.652 0 13.788-10.584 7.92-10.188 8.136-15.984zm8.784-7.992v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TURKISH_LIRA": "M41.472-34.487q0 6.876-3.402 12.708t-9.234 9.234-12.708 3.402h-5.76q-.504 0-.828-.324t-.324-.828v-21.996l-7.74 2.376q-.108.036-.324.036-.36 0-.684-.216-.468-.36-.468-.936v-4.608q0-.828.828-1.116l8.388-2.556v-3.348l-7.74 2.376q-.108.036-.324.036-.36 0-.684-.216-.468-.36-.468-.936v-4.608q0-.828.828-1.116l8.388-2.556v-9q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828v6.516l13.5-4.176q.54-.18 1.008.18t.468.936v4.608q0 .828-.828 1.116l-14.148 4.356v3.348l13.5-4.176q.54-.18 1.008.18t.468.936v4.608q0 .828-.828 1.116l-14.148 4.356v17.532q6.768-.468 11.448-5.436t4.68-11.808q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828z",
		"PLUS_SQUARE_O": "M41.472-35.639v2.304q0 .504-.324.828t-.828.324h-12.672v12.672q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-12.672h-12.672q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h12.672v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v12.672h12.672q.504 0 .828.324t.324.828zm4.608 16.128v-29.952q0-2.376-1.692-4.068t-4.068-1.692h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068zm4.608-29.952v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z",
		"SPACE_SHUTTLE": "M22.32-24.119q-3.96 2.304-9.648 2.304h-4.608v-2.304h-2.304q-.468 0-.81-.846t-.342-2.034q0-.864.252-1.764-2.088-.072-3.474-.378t-1.386-.738 1.386-.738 3.474-.378q-.252-.9-.252-1.764 0-1.188.342-2.034t.81-.846h2.304v-2.304h4.608q5.688 0 9.648 2.304h40.068q1.512.252 3.834.648t2.898.504q3.204.54 5.4 1.458t3.006 1.71.81 1.44-.81 1.44-3.006 1.71-5.4 1.458q-.576.108-2.898.504t-3.834.648h-40.068zm40.284-9.072q1.908 1.296 1.908 3.312t-1.908 3.312l2.916 1.08q2.448-1.728 2.448-4.392t-2.448-4.392zm-40.104 9.648h36.54q-7.812 1.368-16.416 2.88-2.052 0-4.068.864t-2.988 1.728l-1.008.864-10.368 10.368q-.936.936-2.538 1.62t-3.222.684h-3.456l-3.348-16.704h1.044q5.652 0 9.828-2.304zm-9.828-14.976h-1.044l3.348-16.704h3.456q1.656 0 3.24.684t2.52 1.62l10.368 10.368q.144.144.396.378t1.098.828 1.746 1.044 2.214.828 2.61.378l16.416 2.88h-36.54q-4.176-2.304-9.828-2.304z",
		"SLACK": "M54.684-36.503q2.232 0 3.726 1.458t1.494 3.654q0 3.492-3.348 4.68l-6.192 2.124 2.016 6.012q.252.756.252 1.692 0 2.124-1.512 3.672t-3.636 1.548q-1.692 0-3.078-.972t-1.926-2.592l-1.98-5.94-11.16 3.816 1.98 5.904q.288.864.288 1.692 0 2.124-1.512 3.672t-3.672 1.548q-1.692 0-3.06-.972t-1.908-2.592l-1.98-5.868-5.508 1.908q-1.044.324-1.8.324-2.196 0-3.654-1.44t-1.458-3.636q0-1.692.99-3.06t2.574-1.908l5.616-1.908-3.78-11.268-5.616 1.944q-.936.288-1.728.288-2.16 0-3.636-1.458t-1.476-3.618q0-1.692.99-3.06t2.574-1.908l5.652-1.908-1.908-5.724q-.288-.864-.288-1.692 0-2.16 1.512-3.69t3.672-1.53q1.692 0 3.06.972t1.908 2.592l1.944 5.76 11.16-3.78-1.944-5.76q-.288-.864-.288-1.692 0-2.124 1.53-3.672t3.654-1.548q1.692 0 3.078.99t1.926 2.574l1.908 5.796 5.832-1.98q.756-.216 1.548-.216 2.16 0 3.69 1.422t1.53 3.546q0 1.62-1.08 2.934t-2.664 1.854l-5.652 1.944 3.78 11.376 5.904-2.016q.864-.288 1.656-.288zm-28.584 9.432l11.16-3.78-3.78-11.34-11.16 3.852z",
		"ENVELOPE_SQUARE": "M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm1.152 38.016v-15.696q-1.116 1.26-2.304 1.98-1.224.792-4.77 3.06t-5.454 3.564q-3.528 2.484-5.904 2.484t-5.904-2.484q-1.656-1.152-5.094-3.33t-5.13-3.33q-.432-.288-1.188-.972t-1.116-.972v15.696q0 1.44 1.008 2.448t2.448 1.008h29.952q1.44 0 2.448-1.008t1.008-2.448zm0-20.628q0-1.476-.99-2.52t-2.466-1.044h-29.952q-1.44 0-2.448 1.008t-1.008 2.448q0 1.332 1.098 2.754t2.43 2.322q1.692 1.152 4.95 3.204t4.662 2.988l.612.414.756.504.756.468.846.468.774.342.81.27.738.09.738-.09.81-.27.774-.342.846-.468.756-.468.756-.504.612-.414 9.612-6.264q1.26-.828 2.394-2.25t1.134-2.646z",
		"WORDPRESS": "M4.572-32.183q0-5.868 2.412-11.268l13.212 36.18q-7.056-3.42-11.34-10.116t-4.284-14.796zm46.368-1.404q0 .684-.09 1.386t-.36 1.782-.414 1.584-.63 2.124-.63 2.088l-2.736 9.216-10.008-29.736q1.656-.108 3.168-.288.684-.072.936-.666t-.09-1.116-1.026-.486l-7.38.36q-2.7-.036-7.272-.36-.432-.036-.738.18t-.414.54-.054.666.324.594.702.288l2.88.288 4.32 11.808-6.048 18.144-10.08-29.952q1.656-.108 3.168-.288.684-.072.936-.666t-.09-1.116-1.026-.486l-7.38.36-.828-.018-.936-.018q3.78-5.76 9.882-9.126t13.23-3.366q5.292 0 10.098 1.908t8.586 5.364h-.36q-1.98 0-3.312 1.458t-1.332 3.438q0 .432.072.864t.144.774.288.828.324.756.432.81.45.756.522.864.504.828q2.268 3.852 2.268 7.632zm-18.216 3.816l8.532 23.292q.036.216.18.396-4.536 1.584-9.18 1.584-4.032 0-7.812-1.152zm23.796-15.696q3.42 6.264 3.42 13.284 0 7.524-3.744 13.878t-10.044 10.026l8.46-24.408q2.124-6.084 2.124-9.936 0-1.512-.216-2.844zm-24.264-18.972q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm0 63.036q6.228 0 11.934-2.448t9.828-6.57 6.57-9.828 2.448-11.934-2.448-11.934-6.57-9.828-9.828-6.57-11.934-2.448-11.934 2.448-9.828 6.57-6.57 9.828-2.448 11.934 2.448 11.934 6.57 9.828 9.828 6.57 11.934 2.448z",
		"OPENID": "M39.096-64.439v55.296l-9.792 4.608q-8.208-.72-14.904-3.672t-10.548-7.506-3.852-9.81q0-5.04 3.618-9.486t9.9-7.398 14.094-3.888v6.192q-7.812 1.368-12.834 5.4t-5.022 9.18q0 5.472 5.562 9.612t13.986 5.22v-48.96zm24.084 20.952l1.332 14.04-18.9-4.104 5.292-2.988q-4.284-2.52-10.08-3.564v-6.192q9.972 1.188 17.316 5.652z",
		"UNIVERSITY": "M34.56-64.439l34.56 13.824v4.608h-4.608q0 .936-.738 1.62t-1.746.684h-54.936q-1.008 0-1.746-.684t-.738-1.62h-4.608v-4.608zm-25.344 23.04h9.216v27.648h4.608v-27.648h9.216v27.648h4.608v-27.648h9.216v27.648h4.608v-27.648h9.216v27.648h2.124q1.008 0 1.746.684t.738 1.62v2.304h-59.904v-2.304q0-.936.738-1.62t1.746-.684h2.124v-27.648zm57.42 34.56q1.008 0 1.746.684t.738 1.62v4.608h-69.12v-4.608q0-.936.738-1.62t1.746-.684h64.152z",
		"MORTAR_BOARD": "M63.864-34.343l.648 11.376q.144 2.484-2.952 4.608t-8.46 3.366-11.628 1.242-11.628-1.242-8.46-3.366-2.952-4.608l.648-11.376 20.664 6.516q.792.252 1.728.252t1.728-.252zm19.08-11.664q0 .828-.792 1.116l-40.32 12.672q-.144.036-.36.036t-.36-.036l-23.472-7.416q-1.548 1.224-2.556 4.014t-1.224 6.426q2.268 1.296 2.268 3.924 0 2.484-2.088 3.852l2.088 15.588q.072.504-.288.9-.324.396-.864.396h-6.912q-.54 0-.864-.396-.36-.396-.288-.9l2.088-15.588q-2.088-1.368-2.088-3.852 0-2.628 2.34-3.996.396-7.452 3.528-11.88l-11.988-3.744q-.792-.288-.792-1.116t.792-1.116l40.32-12.672q.144-.036.36-.036t.36.036l40.32 12.672q.792.288.792 1.116z",
		"YAHOO": "M30.924-29.987l.468 25.452q-2.232-.396-3.78-.396-1.476 0-3.78.396l.468-25.452q-1.44-2.484-6.066-10.638t-7.794-13.482-6.516-10.332q2.088.54 3.888.54 1.548 0 3.996-.54 2.268 3.996 4.806 8.262t6.012 9.954 4.986 8.172q1.332-2.196 3.942-6.39t4.23-6.84 3.78-6.336 3.852-6.822q1.944.504 3.852.504 2.016 0 4.104-.504-1.008 1.404-2.16 3.186t-1.782 2.826-2.034 3.456-1.764 3.024q-5.256 8.928-12.708 21.96z",
		"GOOGLE": "M27.648-36.143h26.1q.432 2.412.432 4.608 0 7.812-3.276 13.95t-9.342 9.594-13.914 3.456q-5.652 0-10.764-2.178t-8.82-5.886-5.886-8.82-2.178-10.764 2.178-10.764 5.886-8.82 8.82-5.886 10.764-2.178q10.8 0 18.54 7.236l-7.524 7.236q-4.428-4.284-11.016-4.284-4.644 0-8.586 2.34t-6.246 6.354-2.304 8.766 2.304 8.766 6.246 6.354 8.586 2.34q3.132 0 5.76-.864t4.32-2.16 2.952-2.952 1.854-3.132.81-2.808h-15.696v-9.504z",
		"REDDIT": "M39.42-22.427q.576.576 0 1.116-2.232 2.232-7.164 2.232t-7.164-2.232q-.576-.54 0-1.116.216-.216.54-.216t.54.216q1.728 1.764 6.084 1.764 4.32 0 6.084-1.764.216-.216.54-.216t.54.216zm-11.052-6.516q0 1.332-.936 2.268t-2.268.936-2.286-.936-.954-2.268q0-1.368.954-2.304t2.286-.936 2.268.954.936 2.286zm14.22 0q0 1.332-.954 2.268t-2.286.936-2.268-.936-.936-2.268.936-2.286 2.268-.954 2.286.936.954 2.304zm9.036-4.32q0-1.764-1.26-3.024t-3.06-1.26-3.096 1.296q-4.68-3.24-11.196-3.456l2.268-10.188 7.2 1.62q0 1.332.936 2.268t2.268.936 2.286-.954.954-2.286-.954-2.286-2.286-.954q-1.944 0-2.88 1.8l-7.956-1.764q-.684-.18-.9.576l-2.484 11.232q-6.48.252-11.124 3.492-1.26-1.332-3.132-1.332-1.8 0-3.06 1.26t-1.26 3.024q0 1.26.666 2.304t1.782 1.584q-.216.972-.216 2.016 0 5.112 5.04 8.748t12.132 3.636q7.128 0 12.168-3.636t5.04-8.748q0-1.152-.252-2.052 1.08-.54 1.728-1.566t.648-2.286zm12.888 1.08q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"REDDIT_SQUARE": "M33.804-23.795q.468.468 0 .936-1.908 1.908-6.156 1.908t-6.156-1.908q-.468-.468 0-.936.18-.216.468-.216t.468.216q1.512 1.512 5.22 1.512t5.22-1.512q.18-.216.468-.216t.468.216zm-9.468-5.616q0 1.116-.828 1.944t-1.944.828-1.944-.828-.828-1.944q0-1.152.81-1.962t1.962-.81 1.962.81.81 1.962zm12.168 0q0 1.116-.828 1.944t-1.944.828-1.944-.828-.828-1.944q0-1.152.81-1.962t1.962-.81 1.962.81.81 1.962zm7.74-3.708q0-1.512-1.08-2.592t-2.628-1.08q-1.512 0-2.628 1.116-4.068-2.808-9.612-2.952l1.944-8.748 6.156 1.404q.036 1.152.846 1.944t1.926.792q1.152 0 1.962-.81t.81-1.962-.81-1.962-1.962-.81q-1.728 0-2.484 1.548l-6.804-1.512q-.612-.18-.756.468l-2.16 9.648q-5.544.216-9.54 2.988-1.08-1.152-2.664-1.152-1.548 0-2.628 1.08t-1.08 2.592q0 1.08.576 1.98t1.512 1.368q-.18.9-.18 1.728 0 4.392 4.32 7.506t10.404 3.114q6.12 0 10.44-3.114t4.32-7.506q0-.9-.216-1.764.9-.468 1.458-1.35t.558-1.962zm11.052-16.344v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"STUMBLEUPON_CIRCLE": "M31.176-34.235l3.24-.972v-2.232q0-2.844-2.088-4.86t-4.968-2.016-4.968 1.998-2.088 4.842v10.188q0 .72-.504 1.206t-1.188.486-1.17-.486-.486-1.206v-4.32h-5.436v4.392q0 2.952 2.07 5.004t5.022 2.052q2.916 0 4.986-2.034t2.07-4.914v-10.08q0-.684.486-1.188t1.206-.504q.684 0 1.17.504t.486 1.188v1.944zm11.988 7.02v-4.392h-5.4v4.536q0 .72-.486 1.206t-1.206.486q-.684 0-1.17-.504t-.486-1.188v-4.428l-3.24.936-2.16-1.008v4.428q0 2.88 2.088 4.932t5.004 2.052 4.986-2.052 2.07-5.004zm12.132-4.968q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"STUMBLEUPON": "M38.232-38.807v-4.248q0-1.512-1.08-2.592t-2.592-1.08-2.592 1.08-1.08 2.592v22.032q0 6.3-4.536 10.764t-10.908 4.464q-6.408 0-10.926-4.518t-4.518-10.926v-9.576h11.808v9.432q0 1.548 1.08 2.61t2.592 1.062 2.592-1.062 1.08-2.61v-22.32q0-6.156 4.554-10.512t10.854-4.356q6.336 0 10.872 4.392t4.536 10.584v4.896l-7.02 2.088zm19.08 7.992h11.808v9.576q0 6.408-4.518 10.926t-10.926 4.518q-6.372 0-10.908-4.482t-4.536-10.818v-9.648l4.716 2.196 7.02-2.088v9.72q0 1.512 1.08 2.574t2.592 1.062 2.592-1.062 1.08-2.574v-9.9z",
		"DELICIOUS": "M52.992-14.903v-17.28h-25.344v-25.344h-17.28q-3.348 0-5.706 2.358t-2.358 5.706v17.28h25.344v25.344h17.28q3.348 0 5.706-2.358t2.358-5.706zm2.304-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"DIGG": "M11.808-54.287h7.344v35.388h-19.152v-25.092h11.808v-10.296zm0 29.484v-13.284h-4.428v13.284h4.428zm10.296-19.188v25.092h7.38v-25.092h-7.38zm0-10.296v7.344h7.38v-7.344h-7.38zm10.332 10.296h19.188v33.912h-19.188v-5.868h11.808v-2.952h-11.808v-25.092zm11.808 19.188v-13.284h-4.428v13.284h4.428zm10.332-19.188h19.152v33.912h-19.152v-5.868h11.772v-2.952h-11.772v-25.092zm11.772 19.188v-13.284h-4.428v13.284h4.428z",
		"PIED_PIPER": "M37.656-27.719q0 2.304-1.368 3.924t-3.276 1.62q-1.548 0-2.52-.54v-9.972q1.008-.612 2.52-.612 1.908 0 3.276 1.638t1.368 3.942zm-12.348-15.408q0 2.304-1.368 3.942t-3.276 1.638q-1.548 0-2.52-.54v-9.972q1.008-.612 2.52-.612 1.908 0 3.276 1.62t1.368 3.924zm20.232 15.516q0-4.824-3.168-8.244t-7.668-3.42q-.72 0-1.404.108-.828 2.808-2.808 4.896-3.132 3.42-7.596 3.636v22.896l7.596-1.476v-7.416q1.836.684 4.212.684 4.5 0 7.668-3.42t3.168-8.244zm-12.348-15.372q0-4.824-3.186-8.244t-7.686-3.42q-2.664 0-5.076 1.296h-6.696v30.24l7.596-1.476v-7.416q1.98.684 4.176.684 4.5 0 7.686-3.42t3.186-8.244zm22.104-6.48v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"PIED_PIPER_ALT": "M43.992-30.995q2.7-.108 5.166.738t4.248 2.106 3.636 3.402 3.024 3.888 2.718 4.338q1.188 2.016 2.826 3.924t2.718 2.898 3.564 3.186q-1.728 1.08-3.906 2.07t-4.986 2.124-4.104 1.71q-1.584-1.332-2.664-4.14t-1.566-5.922-1.188-6.498-1.53-6.066-2.61-4.428-4.41-1.746l-.36.072-.216.144q.144.18.468.504.216.18 1.008.846t.918.792.684.648.648.738.414.756.378.99.162 1.116.144 1.458l.036 1.188q.036.936-.09 2.07t-.27 1.872-.45 2.106-.414 1.908q-1.26-.036-3.636.342t-3.528.378q-1.404 0-2.592-.36-.072-.576-.072-1.692 0-2.664.108-3.456.072-.468 1.134-1.494t2.052-2.124.954-1.854q-.864-.072-1.548.864-1.296 1.908-4.014 3.582t-4.914 1.674q-.9 0-2.718-2.268t-3.834-5.022-3.024-3.474q-.216-.144-.972-1.08-17.352 4.032-18.468 4.032-.576 0-1.008-.396t-.432-.972q0-.54.306-.954t.81-.522l17.496-3.816q-.288-.504-.288-.9t.198-.63.576-.414.72-.252.828-.162.666-.162q.144-.036.558-.27t.63-.234q.54 0 1.008.576t.72 1.188q5.868-1.332 6.192-1.332.612 0 1.062.396t.45 1.008q0 .54-.306.936t-.846.504l-6.552 1.44-.036.576q-.036.936 2.934 4.23t3.762 3.294q1.692 0 4.284-2.88t2.592-4.644q0-1.296-.846-1.908t-1.836-.666-1.836-.414-.846-1.224q0-.576.36-1.224l-2.448-.684q1.548-1.584 1.548-4.212 0-.936-.18-2.088 2.952-.576 5.184-.576 1.584 0 2.574.054t1.746.306 1.116.486.738.882.558 1.206.612 1.71.864 2.16l1.8-.9q-.108 1.44-.828 2.16t-1.53.756-1.44.234-.594.738zm2.16-8.46q-.18-.18-.486-.558t-.432-.522-.378-.414-.36-.378l-.288-.288-.306-.27-.288-.18-.306-.162q-.252-.108-.522-.18t-.738-.09-.792-.018h-2.52q-4.536 0-7.812 1.548.576-1.08 1.296-1.674t1.944-1.062 2.358-1.296 1.656-1.314 1.8-1.98 1.566-1.818q.432.324 1.008 1.134t1.152 1.314 1.368.468l.432-.036v2.736l.792.036q8.892-3.42 13.356-6.84 1.008-.756 1.8-1.404t1.53-1.35 1.188-1.116 1.062-1.224.864-1.116.882-1.332.828-1.368.972-1.71 1.062-1.908l.252-.324q-.072 1.908-1.548 5.004-2.844 5.94-7.38 9.504t-11.016 5.112q-.504.108-1.512.27t-1.8.342-1.404.504q.108.684.882 1.656t.774 1.224q0 .396-.936 1.08zm-7.956 33.156q1.404-.936 4.734-1.71t5.274-.774q.324 0 .81.558t1.008 1.53.936 1.8.864 1.836.522 1.188q-4.356 1.62-8.784 1.62-2.196 0-4.5-.396zm-8.604-23.292l1.728-.432 3.924 6.372-2.628 1.728zm18.036 18.612l.108.576q0 .252-.63.522t-1.656.468-1.944.342-1.926.27-1.152.162l-.252-1.548q.756-.072 2.178-.306t2.592-.36 2.178-.126h.504zm-16.452-22.608l-3.456.72-.216-.612q.36-.036 1.17-.252t1.242-.216q.684 0 1.26.36zm7.02 22.824h1.116l.36 2.988-1.476.432v-3.42zm32.004-53.64v0zm0 0l-.036.18-.072.072.036-.108zm0 0l.036-.036z",
		"DRUPAL": "M42.012-7.343q-.18-.684-.864-.18-1.08.792-3.132 1.404t-4.716.612q-4.644 0-6.948-1.764-.18-.144-.468-.144-.396 0-.936.432-.252.216-.27.576t.27.72q1.224 1.152 3.15 1.656t3.69.45 3.564-.162q1.476-.144 3.042-.738t2.34-1.08 1.026-.738q.432-.432.252-1.044zm-1.404-4.14q-.684-1.692-1.404-2.196-.828-.54-2.736-.54-1.692 0-2.556.36-1.044.432-2.808 2.016-.936.864-.432 1.584.324.288.63.162t1.134-.846q.108-.072.378-.306t.378-.306.36-.252.414-.252.45-.18.54-.162.594-.09.738-.036q.972 0 1.602.27t.828.522.486.792q.36.612.45.72t.45-.036q.828-.432.504-1.224zm12.78-10.116q0-.792-.18-1.602t-.594-1.62-1.224-1.314-1.89-.504q-1.188 0-3.492 1.494t-4.644 3.006-3.636 1.512q-.972.036-2.286-.684t-2.736-1.764-3.006-2.088-3.6-1.764-3.996-.684q-4.14.036-7.092 2.826t-3.024 6.426q-.072 4.032 2.664 5.904 1.044.72 2.25 1.026t3.726.306q2.052 0 4.752-1.17t4.824-2.556 4.32-2.538 3.348-1.116q.936.036 2.34 1.134t2.574 2.412 2.448 2.43 1.998 1.152q1.26.108 2.106-.504t1.998-2.268q1.008-1.476 1.53-3.636t.522-3.816zm1.908-5.76q0 5.904-2.232 10.962t-5.976 8.496-8.73 5.382-10.458 1.944-10.548-2.07-8.91-5.652-6.138-8.694-2.304-10.872q0-3.204.702-6.21t1.764-5.238 2.538-4.266 2.826-3.384 2.826-2.502 2.322-1.674 1.53-.882q.504-.288 1.836-.954t1.962-1.026 1.728-1.08 2.178-1.584q1.296-1.008 2.088-2.61t1.08-4.518q4.644 5.58 6.696 6.948 1.584 1.044 4.68 2.448t4.644 2.376q.756.468 1.404.9t2.178 1.674 2.736 2.538 2.7 3.42 2.484 4.392 1.692 5.346.702 6.39z",
		"JOOMLA": "M38.52-25.811l-5.76 5.76-5.436 5.472-1.08 1.08q-2.34 2.304-5.454 3.132t-6.174.072q-.576 2.52-2.592 4.14t-4.644 1.62q-3.06 0-5.22-2.178t-2.16-5.238q0-2.592 1.602-4.608t4.086-2.592q-.792-3.096.036-6.228t3.168-5.472l.432-.432 5.436 5.472-.396.396q-1.332 1.332-1.332 3.204t1.332 3.24q1.332 1.332 3.204 1.332t3.204-1.332l1.08-1.08 5.436-5.472 5.796-5.76zm-12.276-24.552l.432.432-5.472 5.472-.432-.432q-1.332-1.332-3.204-1.332t-3.204 1.332-1.332 3.222 1.332 3.222l1.044 1.044 5.472 5.472 5.76 5.76-5.436 5.472-5.796-5.76-5.436-5.472-1.08-1.08q-2.448-2.412-3.24-5.742t.18-6.462q-2.52-.54-4.14-2.556t-1.62-4.644q0-3.06 2.16-5.238t5.22-2.178q2.736 0 4.806 1.764t2.502 4.428q3.024-.72 6.102.126t5.382 3.15zm29.052 38.412q0 3.06-2.16 5.238t-5.22 2.178q-2.664 0-4.716-1.692t-2.556-4.248q-3.096 1.008-6.462.216t-5.814-3.24l-.396-.432 5.436-5.472.432.432q1.332 1.332 3.204 1.332t3.204-1.332 1.332-3.204-1.332-3.204l-1.08-1.08-5.472-5.472-5.76-5.76 5.472-5.472 5.76 5.76 5.472 5.472 1.044 1.08q2.304 2.304 3.15 5.418t.09 6.174q2.736.396 4.554 2.466t1.818 4.842zm-.072-40.464q0 2.772-1.836 4.86t-4.572 2.484q.936 3.06.108 6.354t-3.24 5.706l-.432.432-5.436-5.472.432-.432q1.332-1.332 1.332-3.204t-1.332-3.204-3.204-1.332-3.204 1.332l-1.08 1.08-5.472 5.472-5.76 5.76-5.472-5.472 5.796-5.76 5.472-5.472 1.044-1.08q2.412-2.412 5.724-3.222t6.408.126q.396-2.7 2.466-4.536t4.878-1.836q3.06 0 5.22 2.178t2.16 5.238z",
		"LANGUAGE": "M23.544-25.631q-.036.108-.45-.018t-1.134-.414l-.72-.324q-1.584-.72-3.132-1.764-.252-.18-1.476-1.134t-1.368-1.026q-2.412 3.708-4.824 6.516-2.916 3.42-3.78 3.96-.144.072-.702.144t-.666 0q.216-.144 2.952-3.312.756-.864 3.078-4.14t2.826-4.248q.612-1.08 1.836-3.546t1.296-2.79q-.288-.036-3.96 1.188-.288.072-.99.27t-1.242.342-.612.18q-.072.072-.072.378t-.036.342q-.18.36-1.116.54-.828.252-1.692 0-.648-.144-1.008-.756-.144-.216-.18-.828.216-.072.882-.18t1.062-.216q2.088-.576 3.78-1.152 3.6-1.26 3.672-1.26.36-.072 1.548-.702t1.584-.774q.324-.108.774-.288t.522-.198.216.018q.072.432-.036 1.188 0 .072-.45.972t-.954 1.926-.612 1.206q-.9 1.8-2.772 4.716l2.304 1.008q.432.216 2.682 1.152t2.43 1.008q.144.036.378.918t.162 1.098zm-7.38-17.496q.108.54-.144 1.008-.432.828-1.8 1.368-1.08.432-2.16.432-.936-.108-1.764-.936-.504-.54-.648-1.476l.036-.108q.108.108.702.18t.954 0 2.088-.576q1.296-.432 1.98-.504.612 0 .756.612zm25.128 4.644l2.268 8.172-5.004-1.512zm-39.888 28.8l24.984-8.352v-37.152l-24.984 8.388v37.116zm44.676-11.412l3.672 1.116-6.516-23.652-3.6-1.116-7.776 19.296 3.672 1.116 1.62-3.96 7.596 2.34zm-18.108-34.632l20.628 6.624v-13.68zm11.196 47.628l5.688.468-1.944 5.76-1.44-2.376q-4.68 2.988-9.936 3.888-2.088.432-3.276.432h-3.024q-2.844 0-7.182-1.404t-6.606-3.06q-.288-.252-.288-.576 0-.288.18-.486t.468-.198q.144 0 .648.27t1.098.594.738.396q2.628 1.332 5.742 2.214t5.67.882q3.42 0 6.012-.522t5.652-1.818q.54-.252 1.098-.558t1.224-.684 1.026-.594zm16.128-38.844v38.844l-27.864-8.856q-.504.216-13.5 4.59t-13.248 4.374q-.468 0-.648-.468l-.036-.108v-38.808q.108-.324.144-.36.18-.216.72-.396 3.816-1.26 5.364-1.8v-13.824l20.088 7.128q.072 0 5.778-1.98t11.376-3.906 5.814-1.926q.72 0 .72.756v15.048z",
		"FAX": "M10.368-50.615q2.376 0 4.068 1.692t1.692 4.068v39.168q0 2.376-1.692 4.068t-4.068 1.692h-4.608q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h4.608zm49.536 5.868q2.088 1.224 3.348 3.348t1.26 4.608v27.648q0 3.816-2.7 6.516t-6.516 2.7h-31.104q-2.376 0-4.068-1.692t-1.692-4.068v-55.296q0-1.44 1.008-2.448t2.448-1.008h24.192q1.44 0 3.168.72t2.736 1.728l5.472 5.472q1.008 1.008 1.728 2.736t.72 3.168v5.868zm-26.496 35.604v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm9.216 18.432v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm9.216 18.432v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm3.456-13.824v-9.216h-5.76q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-23.04v18.432h32.256z",
		"BUILDING": "M48.384-64.439q.936 0 1.62.684t.684 1.62v59.904q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h46.08zm-29.952 10.368v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm-4.608 11.52v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm18.432 46.08v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-18.432v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 36.864v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828z",
		"CHILD": "M42.768-44.711l-10.512 10.512v29.664q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-13.824h-2.304v13.824q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-29.664l-10.512-10.512q-1.008-1.008-1.008-2.448t1.008-2.448 2.448-1.008 2.448 1.008l8.208 8.208h13.248l8.208-8.208q1.008-1.008 2.448-1.008t2.448 1.008 1.008 2.448-1.008 2.448zm-11.664-5.904q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z",
		"PAW": "M28.08-47.447q0 2.16-.684 4.086t-2.268 3.33-3.78 1.404q-2.736 0-4.968-2.07t-3.312-4.878-1.08-5.436q0-2.16.684-4.086t2.268-3.33 3.78-1.404q2.772 0 4.986 2.07t3.294 4.86 1.08 5.454zm-12.312 17.388q0 2.88-1.512 5.004t-4.284 2.124q-2.736 0-5.094-1.998t-3.618-4.806-1.26-5.472q0-2.88 1.512-5.022t4.284-2.142q2.736 0 5.094 1.998t3.618 4.824 1.26 5.49zm14.184-.972q4.248 0 9.18 3.51t8.244 8.532 3.312 9.162q0 1.656-.612 2.754t-1.746 1.62-2.322.72-2.736.198q-2.448 0-6.75-1.62t-6.57-1.62q-2.376 0-6.93 1.602t-7.218 1.602q-6.588 0-6.588-5.256 0-3.096 2.016-6.894t5.022-6.93 6.75-5.256 6.948-2.124zm8.604-7.596q-2.196 0-3.78-1.404t-2.268-3.33-.684-4.086q0-2.664 1.08-5.454t3.294-4.86 4.986-2.07q2.196 0 3.78 1.404t2.268 3.33.684 4.086q0 2.628-1.08 5.436t-3.312 4.878-4.968 2.07zm15.552-3.744q2.772 0 4.284 2.142t1.512 5.022q0 2.664-1.26 5.472t-3.618 4.806-5.094 1.998q-2.772 0-4.284-2.124t-1.512-5.004q0-2.664 1.26-5.49t3.618-4.824 5.094-1.998z",
		"SPOON": "M25.344-45.431q0 5.22-2.052 8.766t-5.472 4.878l1.62 29.556q.072.936-.576 1.62t-1.584.684h-6.912q-.936 0-1.584-.684t-.576-1.62l1.62-29.556q-3.42-1.332-5.472-4.878t-2.052-8.766q0-4.608 1.53-8.982t4.23-7.2 5.76-2.826 5.76 2.826 4.23 7.2 1.53 8.982z",
		"CUBE": "M32.256-5.795l23.04-12.564v-22.896l-23.04 8.388v27.072zm-2.304-31.14l25.128-9.144-25.128-9.144-25.128 9.144zm29.952-9.072v27.648q0 1.26-.648 2.34t-1.764 1.692l-25.344 13.824q-1.008.576-2.196.576t-2.196-.576l-25.344-13.824q-1.116-.612-1.764-1.692t-.648-2.34v-27.648q0-1.44.828-2.628t2.196-1.692l25.344-9.216q.792-.288 1.584-.288t1.584.288l25.344 9.216q1.368.504 2.196 1.692t.828 2.628z",
		"CUBES": "M23.04-5.687l13.824-6.912v-11.304l-13.824 5.904v12.312zm-2.304-16.344l14.544-6.228-14.544-6.228-14.544 6.228zm39.168 16.344l13.824-6.912v-11.304l-13.824 5.904v12.312zm-2.304-16.344l14.544-6.228-14.544-6.228-14.544 6.228zm-16.128-10.548l13.824-5.94v-9.576l-13.824 5.904v9.612zm-2.304-13.644l15.876-6.804-15.876-6.804-15.876 6.804zm39.168 18.648v14.976q0 1.296-.684 2.412t-1.872 1.692l-16.128 8.064q-.9.504-2.052.504t-2.052-.504l-16.128-8.064q-.18-.072-.252-.144-.072.072-.252.144l-16.128 8.064q-.9.504-2.052.504t-2.052-.504l-16.128-8.064q-1.188-.576-1.872-1.692t-.684-2.412v-14.976q0-1.368.774-2.52t2.034-1.728l15.624-6.696v-14.4q0-1.368.774-2.52t2.034-1.728l16.128-6.912q.828-.36 1.8-.36t1.8.36l16.128 6.912q1.26.576 2.034 1.728t.774 2.52v14.4l15.624 6.696q1.296.576 2.052 1.728t.756 2.52z",
		"BEHANCE": "M66.528-52.235h-18.396v4.464h18.396v-4.464zm-9.072 15.336q-3.24 0-5.256 1.89t-2.232 5.13h14.688q-.648-7.02-7.2-7.02zm.576 21.06q2.268 0 4.392-1.152t2.736-3.132h7.956q-3.6 11.052-15.372 11.052-7.704 0-12.258-4.752t-4.554-12.492q0-7.488 4.698-12.438t12.114-4.95q4.968 0 8.658 2.448t5.508 6.444 1.818 8.928q0 .612-.072 1.692h-23.688q0 3.996 2.07 6.174t5.994 2.178zm-48.06-1.8h10.656q7.38 0 7.38-6.012 0-6.48-7.164-6.48h-10.872v12.492zm0-19.332h10.116q2.808 0 4.446-1.314t1.638-4.086q0-5.184-6.84-5.184h-9.36v10.584zm-9.972-18.324h21.384q3.132 0 5.58.504t4.554 1.71 3.24 3.474 1.134 5.544q0 6.516-6.192 9.468 4.104 1.152 6.192 4.14t2.088 7.344q0 2.7-.882 4.914t-2.376 3.726-3.546 2.556-4.356 1.512-4.824.468h-21.996v-45.36z",
		"BEHANCE_SQUARE": "M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm-26.964 13.212h-13.356v28.332h13.752q4.212 0 7.092-2.07t2.88-6.138q0-5.688-5.148-7.2 3.852-1.872 3.852-5.904 0-2.052-.702-3.474t-2.034-2.178-2.844-1.062-3.492-.306zm-.792 11.448h-6.336v-6.624h5.868q4.284 0 4.284 3.24 0 3.384-3.816 3.384zm.324 12.06h-6.66v-7.812h6.804q4.464 0 4.464 4.068 0 3.744-4.608 3.744zm23.4 1.152q-2.448 0-3.744-1.368t-1.296-3.852h14.796q.036-.36.036-1.08 0-4.752-2.682-7.938t-7.326-3.186q-4.608 0-7.56 3.096t-2.952 7.776q0 4.86 2.844 7.812t7.668 2.952q7.38 0 9.612-6.876h-4.968q-.396 1.224-1.71 1.944t-2.718.72zm-.36-13.176q4.068 0 4.464 4.392h-9.144q.144-2.016 1.404-3.204t3.276-1.188zm-5.832-9.576h11.484v2.772h-11.484v-2.772z",
		"STEAM": "M56.952-43.487q0 3.636-2.574 6.21t-6.21 2.574-6.21-2.574-2.574-6.21 2.574-6.21 6.21-2.574 6.21 2.574 2.574 6.21zm-27.72 26.712q0-3.744-2.628-6.372t-6.372-2.628q-.972 0-1.944.216l3.744 1.512q2.772 1.116 3.942 3.834t.054 5.454q-1.116 2.772-3.852 3.924t-5.472.036q-.756-.288-2.232-.882t-2.196-.882q1.152 2.16 3.276 3.474t4.68 1.314q3.744 0 6.372-2.628t2.628-6.372zm29.88-26.676q0-4.536-3.222-7.758t-7.758-3.222q-4.572 0-7.794 3.222t-3.222 7.758q0 4.572 3.222 7.776t7.794 3.204q4.536 0 7.758-3.204t3.222-7.776zm5.4 0q0 6.804-4.806 11.592t-11.574 4.788l-15.732 11.484q-.432 4.644-3.924 7.848t-8.244 3.204q-4.356 0-7.704-2.736t-4.248-6.912l-8.28-3.312v-15.444l14.004 5.652q2.844-1.728 6.228-1.728.468 0 1.26.072l10.224-14.652q.072-6.732 4.878-11.484t11.538-4.752q6.768 0 11.574 4.806t4.806 11.574z",
		"STEAM_SQUARE": "M44.712-41.147q0-2.88-2.052-4.914t-4.932-2.034-4.914 2.052-2.034 4.896q0 2.88 2.034 4.914t4.914 2.034 4.932-2.034 2.052-4.914zm-21.96 21.168q0 2.988-2.088 5.058t-5.04 2.07q-2.016 0-3.708-1.044t-2.592-2.772q1.872.72 3.528 1.44 2.16.864 4.32-.054t3.06-3.114q.864-2.16-.054-4.32t-3.114-3.024l-2.952-1.188q.792-.18 1.512-.18 2.952 0 5.04 2.07t2.088 5.058zm32.544-29.484v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-5.508l6.192 2.484q.72 3.312 3.366 5.472t6.066 2.16q3.744 0 6.516-2.52t3.132-6.228l12.42-9.072q5.4 0 9.198-3.798t3.798-9.162q0-5.4-3.798-9.198t-9.198-3.798q-5.328 0-9.108 3.762t-3.852 9.09l-8.1 11.592q-.324-.036-1.008-.036-2.7 0-4.932 1.332l-10.692-4.284v-16.848q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326zm-8.892 8.388q0 3.6-2.556 6.138t-6.156 2.538-6.138-2.538-2.538-6.138 2.538-6.156 6.138-2.556q3.636 0 6.174 2.538t2.538 6.174z",
		"RECYCLE": "M30.096-22.355l-.54 13.248-.072.792-15.12-1.044q-1.296-.108-2.412-1.134t-1.692-2.358q-.396-.972-.522-1.98t.144-2.34.432-1.98.774-2.304.684-1.908q2.808.432 18.324 1.008zm-13.932-21.096l6.48 13.644-5.292-3.312q-2.268 2.592-4.014 5.202t-2.61 4.5-1.422 3.402-.666 2.268l-.144.756-6.84-12.852q-.612-.936-.648-2.016t.216-1.692l.288-.648q1.26-2.268 4.104-6.768l-5.04-3.096zm44.316 18.612l-6.768 12.924q-.432 1.044-1.314 1.674t-1.566.738l-.648.144q-2.556.252-7.884.432l.288 5.904-8.28-13.212 7.596-13.032.252 6.228q6.12.576 10.188.18t6.12-1.188zm-28.26-33.264q-1.692 2.268-9.54 15.66l-11.412-6.732-.684-.432 8.1-12.816q.72-1.116 2.16-1.62t2.88-.36q.864.072 1.746.432t1.512.756 1.494 1.188 1.296 1.242 1.296 1.422 1.152 1.26zm23.58 11.052l7.632 13.068q.648 1.332.45 2.736t-.99 2.664q-.468.72-1.188 1.332t-1.368 1.008-1.746.792-1.692.576-1.854.504-1.656.432q-1.224-2.592-9.54-15.696l11.268-7.02zm-5.148-8.136l5.112-2.988-7.92 13.428-15.084-.72 5.436-3.096q-1.224-3.204-2.7-5.976t-2.718-4.446-2.322-2.88-1.692-1.674l-.612-.468 14.58.036q1.116-.108 2.088.378t1.404 1.026l.396.54q1.404 2.196 4.032 6.84z",
		"CAR": "M17.28-25.271q0-2.376-1.692-4.068t-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068zm1.296-11.52h36.576l-3.204-12.852q-.072-.288-.504-.63t-.756-.342h-27.648q-.324 0-.756.342t-.504.63zm49.392 11.52q0-2.376-1.692-4.068t-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068zm5.76-3.456v13.824q0 .504-.324.828t-.828.324h-3.456v4.608q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-4.608h-36.864v4.608q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-4.608h-3.456q-.504 0-.828-.324t-.324-.828v-13.824q0-3.348 2.358-5.706t5.706-2.358h1.008l3.78-15.084q.828-3.384 3.744-5.67t6.444-2.286h27.648q3.528 0 6.444 2.286t3.744 5.67l3.78 15.084h1.008q3.348 0 5.706 2.358t2.358 5.706z",
		"TAXI": "M65.664-32.183q3.348 0 5.706 2.358t2.358 5.706v13.824q0 .504-.324.828t-.828.324h-3.456v2.304q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-2.304h-36.864v2.304q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-2.304h-3.456q-.504 0-.828-.324t-.324-.828v-13.824q0-3.348 2.358-5.706t5.706-2.358h1.008l3.78-15.084q.828-3.384 3.744-5.67t6.444-2.286h4.608v-8.064q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828v8.064h4.608q3.528 0 6.444 2.286t3.744 5.67l3.78 15.084h1.008zm-54.144 17.28q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm7.056-17.28h36.576l-3.204-12.852q-.072-.288-.504-.63t-.756-.342h-27.648q-.324 0-.756.342t-.504.63zm43.632 17.28q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692z",
		"TREE": "M54.144-11.447q0 .936-.684 1.62t-1.62.684h-16.632q.036.612.216 3.15t.18 3.906q0 .9-.648 1.53t-1.548.63h-11.52q-.9 0-1.548-.63t-.648-1.53q0-1.368.18-3.906t.216-3.15h-16.632q-.936 0-1.62-.684t-.684-1.62.684-1.62l14.472-14.508h-8.244q-.936 0-1.62-.684t-.684-1.62.684-1.62l14.472-14.508h-7.092q-.936 0-1.62-.684t-.684-1.62.684-1.62l13.824-13.824q.684-.684 1.62-.684t1.62.684l13.824 13.824q.684.684.684 1.62t-.684 1.62-1.62.684h-7.092l14.472 14.508q.684.684.684 1.62t-.684 1.62-1.62.684h-8.244l14.472 14.508q.684.684.684 1.62z",
		"SPOTIFY": "M40.572-20.879q0-1.152-1.08-1.836-6.948-4.14-16.092-4.14-4.788 0-10.332 1.224-1.512.324-1.512 1.872 0 .72.486 1.242t1.278.522q.18 0 1.332-.288 4.752-.972 8.748-.972 8.136 0 14.292 3.708.684.396 1.188.396.684 0 1.188-.486t.504-1.242zm3.456-7.74q0-1.44-1.26-2.196-8.532-5.076-19.728-5.076-5.508 0-10.908 1.512-1.728.468-1.728 2.304 0 .9.63 1.53t1.53.63q.252 0 1.332-.288 4.392-1.188 9.036-1.188 10.044 0 17.568 4.464.864.468 1.368.468.9 0 1.53-.63t.63-1.53zm3.888-8.928q0-1.692-1.44-2.52-4.536-2.628-10.548-3.978t-12.348-1.35q-7.344 0-13.104 1.692-.828.252-1.386.918t-.558 1.746q0 1.116.738 1.872t1.854.756q.396 0 1.44-.288 4.788-1.332 11.052-1.332 5.724 0 11.142 1.224t9.126 3.42q.756.432 1.44.432 1.044 0 1.818-.738t.774-1.854zm7.38 5.364q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"DEVIANTART": "M36.864-53.531l-10.908 20.952.864 1.116h10.044v14.94h-18.252l-1.584 1.08-5.112 9.828-1.08 1.08h-10.836v-10.908l10.908-20.988-.864-1.08h-10.044v-14.94h18.252l1.584-1.08 5.112-9.828 1.08-1.08h10.836v10.908z",
		"SOUNDCLOUD": "M28.224-15.047l.576-8.676-.576-18.828q-.036-.36-.27-.612t-.594-.252q-.324 0-.576.252t-.252.612l-.504 18.828.504 8.676q.036.36.27.594t.558.234q.792 0 .864-.828zm10.656-1.044l.396-7.596-.432-21.096q0-.576-.468-.864-.288-.18-.576-.18t-.576.18q-.468.288-.468.864l-.036.216-.36 20.844q0 .036.396 8.496v.036q0 .36.216.612.324.396.828.396.396 0 .72-.324.324-.252.324-.72zm-37.62-12.24l.72 4.608-.72 4.536q-.072.324-.324.324t-.324-.324l-.612-4.536.612-4.608q.072-.324.324-.324t.324.324zm3.096-2.844l.936 7.452-.936 7.308q-.072.324-.36.324-.324 0-.324-.36l-.828-7.272.828-7.452q0-.324.324-.324.288 0 .36.324zm10.08 16.308zm-6.768-17.676l.9 8.82-.9 8.532q0 .396-.396.396-.36 0-.432-.396l-.756-8.532.756-8.82q.072-.432.432-.432.396 0 .396.432zm3.384-.252l.828 9.072-.828 8.784q-.072.468-.504.468-.468 0-.468-.468l-.756-8.784.756-9.072q0-.468.468-.468.432 0 .504.468zm3.384.648l.756 8.424-.756 8.856q-.072.576-.576.576-.216 0-.378-.162t-.162-.414l-.72-8.856.72-8.424q0-.216.162-.378t.378-.162q.504 0 .576.54zm13.788 17.1zm-10.404-22.356l.756 13.68-.756 8.856q0 .252-.18.45t-.432.198q-.576 0-.648-.648l-.648-8.856.648-13.68q.072-.648.648-.648.252 0 .432.198t.18.45zm3.384-3.096l.684 16.848-.684 8.784q0 .288-.198.486t-.486.198q-.648 0-.72-.684l-.576-8.784.576-16.848q.072-.684.72-.684.288 0 .486.198t.198.486zm3.528-1.44l.648 18.216-.648 8.712q-.072.756-.792.756-.684 0-.756-.756l-.576-8.712.576-18.216q0-.324.234-.558t.522-.234q.324 0 .54.234t.252.558zm14.112 26.712zm-7.128-26.856l.54 18.36-.54 8.604q0 .36-.27.63t-.63.27-.612-.252-.288-.648l-.504-8.604.504-18.36q0-.396.27-.648t.63-.252.63.252.27.648zm3.564.684l.504 17.712-.504 8.496q0 .396-.288.684t-.684.288-.684-.288-.324-.684l-.432-8.496.432-17.712q.036-.432.324-.72t.684-.288.666.288.306.72zm7.632 17.712l-.504 8.316q0 .468-.324.792t-.792.324-.792-.324-.36-.792l-.216-4.104-.216-4.212.432-22.896v-.108q.072-.54.432-.864.324-.252.72-.252.288 0 .54.18.504.288.576.936zm40.032-.684q0 4.212-2.988 7.182t-7.2 2.97h-28.296q-.468-.072-.792-.396t-.324-.792v-32.364q0-.828 1.008-1.188 3.06-1.224 6.516-1.224 7.02 0 12.168 4.734t5.76 11.646q1.908-.792 3.96-.792 4.212 0 7.2 2.988t2.988 7.236z",
		"DATABASE": "M27.648-36.791q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0 27.648q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0-13.824q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0-41.472q7.488 0 13.86 1.242t10.08 3.366 3.708 4.608v4.608q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-4.608q0-2.484 3.708-4.608t10.08-3.366 13.86-1.242z",
		"FILE_PDF_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-18.504-21.348q1.188.936 3.024 2.016 2.124-.252 4.212-.252 5.292 0 6.372 1.764.576.792.072 1.872l-.036.072-.072.072v.036q-.216 1.368-2.556 1.368-1.728 0-4.14-.72t-4.68-1.908q-7.956.864-14.112 2.988-5.508 9.432-8.712 9.432-.54 0-1.008-.252l-.864-.432-.216-.18q-.36-.36-.216-1.296.324-1.44 2.016-3.294t4.752-3.474q.504-.324.828.216.072.072.072.144 1.872-3.06 3.852-7.092 2.448-4.896 3.744-9.432-.864-2.952-1.098-5.742t.234-4.59q.396-1.44 1.512-1.44h.792q.828 0 1.26.54.648.756.324 2.448-.072.216-.144.288.036.108.036.288v1.08q-.072 4.428-.504 6.912 1.98 5.904 5.256 8.568zm-20.736 14.796q1.872-.864 4.932-5.688-1.836 1.44-3.15 3.024t-1.782 2.664zm14.328-33.12q-.54 1.512-.072 4.752.036-.252.252-1.584 0-.108.252-1.548.036-.144.144-.288l-.036-.072-.018-.054-.018-.054q-.036-.792-.468-1.296l-.036.072v.072zm-4.464 23.796q4.86-1.944 10.224-2.916-.072-.036-.468-.342t-.576-.486q-2.736-2.412-4.572-6.336-.972 3.096-2.988 7.092-1.08 2.016-1.62 2.988zm23.256-.576q-.864-.864-5.04-.864 2.736 1.008 4.464 1.008.504 0 .648-.036l-.072-.108z",
		"FILE_WORD_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-42.3-32.256v3.852h2.52l5.904 23.796h5.724l4.608-17.46q.252-.72.36-1.656.072-.576.072-.864h.144l.108.864q.036.108.126.72t.198.936l4.608 17.46h5.724l5.904-23.796h2.52v-3.852h-10.8v3.852h3.24l-3.564 15.768q-.18.72-.252 1.656l-.072.756h-.144l-.108-.756q-.036-.18-.144-.756t-.18-.9l-5.184-19.62h-4.104l-5.184 19.62q-.072.324-.162.882t-.126.774l-.144.756h-.144l-.072-.756q-.072-.936-.252-1.656l-3.564-15.768h3.24v-3.852h-10.8z",
		"FILE_EXCEL_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-35.244-8.424v3.816h10.116v-3.816h-2.7l3.708-5.796q.18-.252.36-.594t.27-.486.126-.144h.072q.036.144.18.36.072.144.162.27t.216.288.234.306l3.852 5.796h-2.736v3.816h10.476v-3.816h-2.448l-6.912-9.828 7.02-10.152h2.412v-3.852h-10.044v3.852h2.664l-3.708 5.724q-.144.252-.36.594t-.324.486l-.072.108h-.072q-.036-.144-.18-.36-.216-.396-.612-.828l-3.816-5.724h2.736v-3.852h-10.44v3.852h2.448l6.804 9.792-6.984 10.188h-2.448z",
		"FILE_POWERPOINT_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-35.712-8.424v3.816h11.772v-3.816h-3.348v-6.012h4.932q2.736 0 4.248-.54 2.412-.828 3.834-3.132t1.422-5.256q0-2.916-1.332-5.076t-3.6-3.132q-1.728-.684-4.68-.684h-13.248v3.852h3.312v19.98h-3.312zm12.708-10.08h-4.284v-9.648h4.32q1.872 0 2.988.648 2.016 1.188 2.016 4.14 0 3.204-2.232 4.32-1.116.54-2.808.54z",
		"FILE_PICTURE_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-4.608-16.128v11.52h-36.864v-6.912l6.912-6.912 4.608 4.608 13.824-13.824zm-29.952-6.912q-2.88 0-4.896-2.016t-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896-2.016 4.896-4.896 2.016z",
		"FILE_ZIP_O": "M23.04-50.615v-4.608h-4.608v4.608h4.608zm4.608 4.608v-4.608h-4.608v4.608h4.608zm-4.608 4.608v-4.608h-4.608v4.608h4.608zm4.608 4.608v-4.608h-4.608v4.608h4.608zm25.2-13.968q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-4.608v4.608h-4.608v-4.608h-18.432v55.296h46.08zm-22.572-25.956l3.852 12.564q.288.972.288 1.872 0 2.988-2.61 4.95t-6.606 1.962-6.606-1.962-2.61-4.95q0-.9.288-1.872.756-2.268 4.32-14.256v-4.608h4.608v4.608h2.844q.792 0 1.404.468t.828 1.224zm-5.076 16.74q1.908 0 3.258-.684t1.35-1.62-1.35-1.62-3.258-.684-3.258.684-1.35 1.62 1.35 1.62 3.258.684z",
		"FILE_SOUND_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-28.368-29.304q.72.288.72 1.08v19.584q0 .792-.72 1.08-.288.072-.432.072-.432 0-.828-.324l-5.976-6.012h-4.716q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h4.716l5.976-6.012q.576-.54 1.26-.252zm15.012 24.804q1.116 0 1.8-.864 4.644-5.724 4.644-13.068t-4.644-13.068q-.576-.756-1.548-.864t-1.692.504q-.756.612-.846 1.566t.522 1.71q3.6 4.428 3.6 10.152t-3.6 10.152q-.612.756-.522 1.71t.846 1.53q.648.54 1.44.54zm-7.596-5.328q.972 0 1.692-.72 3.132-3.348 3.132-7.884t-3.132-7.884q-.648-.684-1.62-.72t-1.656.612-.72 1.602.648 1.674q1.872 2.052 1.872 4.716t-1.872 4.716q-.684.72-.648 1.674t.72 1.602q.72.612 1.584.612z",
		"FILE_VIDEO_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-23.04-32.256q1.872 0 3.24 1.368t1.368 3.24v13.824q0 1.872-1.368 3.24t-3.24 1.368h-13.824q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h13.824zm17.712.072q.72.288.72 1.08v20.736q0 .792-.72 1.08-.288.072-.432.072-.504 0-.828-.324l-9.54-9.576v-3.24l9.54-9.576q.324-.324.828-.324.144 0 .432.072z",
		"FILE_CODE_O": "M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-33.408-32.256q.288-.396.756-.45t.864.234l1.836 1.368q.396.288.45.756t-.234.864l-6.552 8.748 6.552 8.748q.288.396.234.864t-.45.756l-1.836 1.368q-.396.288-.864.234t-.756-.45l-8.136-10.836q-.504-.684 0-1.368zm28.872 10.836q.504.684 0 1.368l-8.136 10.836q-.288.396-.756.45t-.864-.234l-1.836-1.368q-.396-.288-.45-.756t.234-.864l6.552-8.748-6.552-8.748q-.288-.396-.234-.864t.45-.756l1.836-1.368q.396-.288.864-.234t.756.45zm-22.32 16.596q-.468-.072-.738-.468t-.198-.864l4.968-29.916q.072-.468.468-.738t.864-.198l2.268.36q.468.072.738.468t.198.864l-4.968 29.916q-.072.468-.468.738t-.864.198z",
		"VINE": "M53.892-34.667v7.128q-3.636.828-7.128.828-2.34 4.896-5.958 9.756t-6.534 7.758-4.608 3.834q-2.88 1.62-5.832-.108-1.008-.612-2.178-1.566t-3.06-3.006-3.69-4.626-3.87-6.624-3.798-8.784-3.294-11.322-2.538-14.04h10.188q.936 7.848 2.52 14.346t3.762 11.412 4.374 8.478 5.04 7.02q6.084-6.084 10.332-14.616-5.112-2.592-8.028-7.92t-2.916-11.988q0-6.912 3.744-11.322t10.224-4.41q6.408 0 9.828 3.798t3.42 10.71q0 5.724-2.088 10.296-.252.036-.702.108t-1.656.072-2.268-.216-2.232-.918-1.818-1.854q1.116-3.708 1.116-6.624 0-3.132-1.044-4.752t-2.844-1.62q-1.908 0-3.06 1.782t-1.152 5.058q0 6.696 3.78 10.566t9.612 3.87q2.232 0 4.356-.504z",
		"CODEPEN": "M7.776-22.355l21.708 14.472v-12.924l-12.024-8.028zm-2.232-5.184l6.948-4.644-6.948-4.644v9.288zm29.484 19.656l21.708-14.472-9.684-6.48-12.024 8.028v12.924zm-2.772-17.748l9.792-6.552-9.792-6.552-9.792 6.552zm-14.796-9.9l12.024-8.028v-12.924l-21.708 14.472zm34.56 3.348l6.948 4.644v-9.288zm-4.968-3.348l9.684-6.48-21.708-14.472v12.924zm17.46-6.48v19.656q0 1.476-1.224 2.304l-29.484 19.656q-.756.468-1.548.468t-1.548-.468l-29.484-19.656q-1.224-.828-1.224-2.304v-19.656q0-1.476 1.224-2.304l29.484-19.656q.756-.468 1.548-.468t1.548.468l29.484 19.656q1.224.828 1.224 2.304z",
		"JSFIDDLE": "M64.8-36.647q3.996 1.656 6.462 5.238t2.466 7.974q0 5.904-4.248 10.098t-10.26 4.194l-.414-.018-.378-.018h-43.812000000000005q-6.12-.36-10.368-4.518t-4.248-10.098q0-3.96 1.98-7.308t5.292-5.292q-.432-1.404-.432-2.952 0-4.14 2.952-7.056t7.164-2.916q3.42 0 6.192 2.088 2.7-5.544 8.01-8.928t11.754-3.384q5.976 0 11.016 2.898t7.974 7.866 2.934 10.836l-.018.648-.018.648zm-47.952 9.576q0 4.392 3.024 6.948t7.488 2.556q4.932 0 8.64-3.564-.576-.72-1.71-2.034t-1.566-1.818q-2.412 2.34-5.184 2.34-1.98 0-3.366-1.206t-1.386-3.15q0-1.908 1.386-3.132t3.294-1.224q1.584 0 3.042.756t2.628 1.98 2.34 2.7 2.484 2.952 2.772 2.7 3.492 1.98 4.374.756q4.356 0 7.362-2.574t3.006-6.858q0-4.356-3.024-6.912t-7.452-2.556q-5.148 0-8.676 3.492.504.576 1.062 1.224t1.242 1.44 1.044 1.224q2.376-2.304 5.112-2.304 1.872 0 3.312 1.188t1.44 3.024q0 2.052-1.332 3.294t-3.384 1.242q-1.548 0-2.97-.756t-2.592-1.98-2.358-2.7-2.502-2.952-2.79-2.7-3.474-1.98-4.266-.756q-4.392 0-7.452 2.538t-3.06 6.822z",
		"SUPPORT": "M32.256-64.439q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm0 4.608q-6.84 0-12.996 3.24l6.984 6.984q2.952-1.008 6.012-1.008t6.012 1.008l6.984-6.984q-6.156-3.24-12.996-3.24zm-24.408 40.644l6.984-6.984q-1.008-2.952-1.008-6.012t1.008-6.012l-6.984-6.984q-3.24 6.156-3.24 12.996t3.24 12.996zm24.408 14.652q6.84 0 12.996-3.24l-6.984-6.984q-2.952 1.008-6.012 1.008t-6.012-1.008l-6.984 6.984q6.156 3.24 12.996 3.24zm0-13.824q5.724 0 9.774-4.05t4.05-9.774-4.05-9.774-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05zm17.424-7.812l6.984 6.984q3.24-6.156 3.24-12.996t-3.24-12.996l-6.984 6.984q1.008 2.952 1.008 6.012t-1.008 6.012z",
		"CIRCLE_O_NOTCH": "M63.36-32.183q0 6.336-2.466 12.096t-6.624 9.918-9.918 6.624-12.096 2.466-12.096-2.466-9.918-6.624-6.624-9.918-2.466-12.096q0-7.668 3.492-14.346t9.54-10.998 13.464-5.436v8.208q-7.956 1.62-13.194 7.956t-5.238 14.616q0 4.68 1.836 8.946t4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946q0-8.28-5.238-14.616t-13.194-7.956v-8.208q7.416 1.116 13.464 5.436t9.54 10.998 3.492 14.346z",
		"REBEL": "M.684-32.975q.288-7.812 4.176-14.616t10.98-11.448h.18l-.036.108q-.288.288-1.008 1.206t-1.872 2.754-2.16 3.978-1.602 4.878-.504 5.418 1.404 5.67 3.906 5.544q1.8 1.8 3.672 2.502t3.258.414 2.502-.846 1.692-1.17l.576-.576q1.404-1.836 1.908-4.194t.234-4.41-.756-3.852-.954-2.88l-.504-1.044q-.36-.9-1.098-1.782t-1.548-1.476-1.566-1.062-1.26-.684l-.468-.216 3.744-4.14q1.404.612 2.808 1.872t2.124 2.196l.684.972q.036-1.728-.666-3.726t-1.458-3.15l-.72-1.116 5.796-6.588 5.76 6.516q-1.188 1.656-1.89 3.69t-.81 3.258l-.144 1.188q.792-1.332 2.214-2.61t2.43-1.89l1.008-.612 3.708 4.14q-1.584.504-3.06 1.8t-2.16 2.34l-.684 1.044q-1.116 2.016-1.728 4.806t-.252 6.12 2.052 5.634q1.188 1.62 2.79 2.178t3.06.198 2.736-.954 2.07-1.206l.756-.576q2.16-1.908 3.474-4.14t1.746-4.374.36-4.374-.648-4.248-1.332-3.87-1.638-3.348-1.62-2.592-1.242-1.71l-.468-.612q-.504-.468-.252-.468l.36.108q1.44 1.044 2.25 1.656t2.232 1.8 2.304 2.088 2.106 2.34 1.998 2.772 1.638 3.168 1.368 3.708.846 4.212.378 4.896q.108 9.324-3.888 16.74t-11.232 11.556-16.416 4.14q-6.66 0-12.636-2.664t-10.206-7.128-6.624-10.548-2.178-12.708z",
		"GE": "M31.464-5.471v2.376q-7.488-.216-13.86-3.942t-10.188-9.918l2.088-1.224q1.044 1.764 2.628 3.564l2.34-2.052q5.328 6.048 13.248 7.632l-.612 3.096q2.34.432 4.356.468zm-21.528-19.08l-2.988 1.008q.792 2.16 1.764 4.032l-2.052 1.188q-3.528-6.48-3.528-13.86t3.528-13.86l2.052 1.188q-1.08 2.016-1.764 4.032l2.952 1.008q-1.26 3.6-1.26 7.632 0 3.924 1.296 7.632zm45.072 6.372l2.088 1.224q-3.816 6.192-10.188 9.918t-13.86 3.942v-2.376q2.016-.036 4.356-.468l-.612-3.096q7.92-1.584 13.248-7.632l2.34 2.052q1.584-1.8 2.628-3.564zm-5.436-19.944l-8.388 2.88q.504 1.512.504 3.06t-.504 3.06l8.352 2.88q-1.116 3.312-3.528 6.084l-6.66-5.832q-2.052 2.412-5.292 3.06l1.728 8.676q-1.872.36-3.528.36t-3.528-.36l1.728-8.676q-3.24-.648-5.292-3.06l-6.66 5.832q-2.412-2.772-3.528-6.084l8.352-2.88q-.504-1.512-.504-3.06t.504-3.06l-8.388-2.88q1.188-3.348 3.564-6.084l6.66 5.832q2.124-2.448 5.292-3.096l-1.728-8.64q1.584-.36 3.528-.36t3.528.36l-1.728 8.64q3.168.648 5.292 3.096l6.66-5.832q2.376 2.736 3.564 6.084zm-18.108-23.148v2.376q-2.34.072-4.356.468l.612 3.096q-7.92 1.512-13.248 7.596l-2.34-2.016q-1.368 1.512-2.628 3.528l-2.052-1.188q3.816-6.192 10.152-9.918t13.86-3.942zm29.916 29.088q0 7.38-3.528 13.86l-2.052-1.188q.972-1.872 1.764-4.032l-2.988-1.008q1.296-3.708 1.296-7.632 0-4.032-1.26-7.632l2.952-1.008q-.684-2.016-1.764-4.032l2.052-1.188q3.528 6.48 3.528 13.86zm-4.32-15.228l-2.052 1.188q-1.26-2.016-2.628-3.528l-2.34 2.016q-5.328-6.084-13.248-7.596l.612-3.096q-2.016-.396-4.356-.468v-2.376q7.524.216 13.86 3.942t10.152 9.918zm5.868 15.228q0-6.228-2.43-11.916t-6.534-9.792-9.792-6.534-11.916-2.43-11.916 2.43-9.792 6.534-6.534 9.792-2.43 11.916 2.43 11.916 6.534 9.792 9.792 6.534 11.916 2.43 11.916-2.43 9.792-6.534 6.534-9.792 2.43-11.916zm1.584 0q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"GIT_SQUARE": "M20.952-17.351q0 2.376-3.348 2.376-3.852 0-3.852-2.268 0-2.304 3.528-2.304 3.672 0 3.672 2.196zm-1.296-16.776q0 3.06-2.664 3.06-2.772 0-2.772-3.024 0-3.24 2.772-3.24 1.296 0 1.98.918t.684 2.286zm5.976-2.7v-4.5q-2.808 1.044-4.86 1.044-1.8-1.044-3.96-1.044-3.096 0-5.22 2.052t-2.124 5.148q0 1.8 1.062 3.672t2.646 2.412v.108q-1.368.612-1.368 3.06 0 1.908 1.476 2.772v.108q-4.068 1.332-4.068 5.004 0 1.62.72 2.826t1.944 1.836 2.592.918 2.916.288q8.064 0 8.064-6.768 0-2.412-1.728-3.564t-4.536-1.656q-.972-.18-1.854-.738t-.882-1.422q0-1.584 1.764-1.872 2.772-.54 4.392-2.52t1.62-4.824q0-.864-.36-1.872 1.332-.324 1.764-.468zm2.124 15.084h4.932q-.072-.972-.072-2.952v-13.932q0-1.656.072-2.484h-4.932q.108.828.108 2.556v14.112q0 1.8-.108 2.7zm18.324-.576v-4.356q-1.08.756-2.448.756-1.908 0-1.908-2.952v-8.1h1.872q.324 0 .954.036t.954.036v-4.212h-3.78q0-2.952.108-3.672h-5.04q.144.864.144 1.98v1.692h-2.16v4.212l1.332-.108.396.018.432.018v.072h-.072v7.812q0 1.332.09 2.304t.414 2.034.882 1.746 1.566 1.116 2.376.432q2.304 0 3.888-.864zm-12.816-25.416q0-1.296-.864-2.286t-2.16-.99-2.178.972-.882 2.304q0 1.296.9 2.25t2.16.954 2.142-.972.882-2.232zm22.032-1.728v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"GIT": "M21.42-9.935q0-3.6-5.94-3.6-5.688 0-5.688 3.744 0 3.636 6.192 3.636 5.436 0 5.436-3.78zm-2.124-27.18q0-2.196-1.08-3.672t-3.204-1.476q-4.464 0-4.464 5.22 0 4.86 4.464 4.86 4.284 0 4.284-4.932zm9.684-11.664v7.272q-1.296.432-2.844.792.576 1.548.576 3.024 0 4.572-2.628 7.794t-7.092 4.05q-1.44.288-2.142.972t-.702 2.088q0 1.116.81 1.854t2.088 1.152 2.826.792 3.096.918 2.826 1.35 2.088 2.304.81 3.546q0 10.944-13.068 10.944-2.484 0-4.68-.45t-4.176-1.476-3.15-2.952-1.17-4.59q0-5.94 6.552-8.1v-.144q-2.412-1.476-2.412-4.536 0-3.924 2.268-4.932v-.144q-2.592-.864-4.302-3.906t-1.71-5.958q0-5.004 3.42-8.334t8.46-3.33q3.456 0 6.408 1.692 3.528 0 7.848-1.692zm11.448 31.716h-7.992q.144-1.62.144-4.824v-21.924q0-3.384-.144-4.608h7.992q-.144 1.188-.144 4.464v22.068q0 3.204.144 4.824zm21.636-7.992v7.056q-2.556 1.404-6.264 1.404-2.232 0-3.852-.72t-2.52-1.8-1.422-2.808-.666-3.312-.144-3.708v-12.636h.072v-.144q-.252 0-.684-.036t-.648-.036q-.756 0-2.124.216v-6.84h3.456v-2.736q0-1.944-.216-3.204h8.172q-.216 1.476-.216 5.94h6.156v6.84q-.54 0-1.566-.072t-1.53-.072h-3.06v13.14q0 4.716 3.132 4.716 2.196 0 3.924-1.188zm-20.736-34.092q0 2.088-1.404 3.654t-3.456 1.566q-2.088 0-3.528-1.566t-1.44-3.654q0-2.124 1.422-3.708t3.546-1.584q2.088 0 3.474 1.602t1.386 3.69z",
		"YC_SQUARE": "M29.124-28.295l9.576-17.964h-4.032l-5.652 11.232q-.864 1.728-1.584 3.312l-1.512-3.312-5.58-11.232h-4.32l9.468 17.748v11.664h3.636v-11.448zm26.172-21.168v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TENCENT_WEIBO": "M30.312-43.847q0 2.88-2.052 4.914t-4.896 2.034q-2.16 0-3.996-1.26-2.232 2.412-4.14 5.256-8.892 13.356-7.272 30.924.036.792-.45 1.386t-1.242.666h-.18q-.72 0-1.26-.486t-.612-1.206q-.504-4.536-.126-8.91t1.062-7.812 1.944-6.696 2.484-5.598 2.664-4.5q2.196-3.24 4.752-5.94-.576-1.26-.576-2.772 0-2.88 2.034-4.914t4.914-2.034 4.914 2.034 2.034 4.914zm13.716.396q0 5.688-2.808 10.512t-7.65 7.632-10.53 2.808q-2.304 0-4.716-.504-.756-.18-1.17-.846t-.234-1.422q.18-.72.828-1.134t1.404-.27q1.836.468 3.888.468 3.492 0 6.696-1.368t5.508-3.672 3.672-5.508 1.368-6.696-1.368-6.696-3.672-5.508-5.508-3.672-6.696-1.368-6.696 1.368-5.508 3.672-3.672 5.508-1.368 6.696q0 4.104 1.872 7.848.36.72.126 1.44t-.918 1.08-1.422.108-1.098-.936q-2.304-4.428-2.304-9.54 0-4.284 1.674-8.172t4.482-6.696 6.696-4.464 8.136-1.656q5.688 0 10.53 2.808t7.65 7.65 2.808 10.53z",
		"QQ": "M9.72-35.423q-.288-.684-.288-1.872 0-.72.396-1.764t.864-1.62q-.036-.792.27-1.908t.81-1.548q0-5.004 3.33-10.386t7.83-7.542q5.004-2.376 11.664-2.376 4.788 0 9.576 1.98 1.764.756 3.24 1.728t2.556 2.016 1.98 2.448 1.512 2.664 1.17 3.042.918 3.222.792 3.528l.036.18q1.98 2.988 1.98 5.4 0 .504-.324 1.44t-.324 1.368l.054.126.126.18.072.126q2.772 4.104 4.338 7.722t1.566 7.506q0 1.548-.702 3.6t-1.998 2.052q-.324 0-.702-.27t-.684-.63-.684-.936-.576-.954-.486-.936-.324-.63l-.108-.036-.18.144q-2.124 5.544-4.752 8.028.72.72 2.214 1.386t2.484 1.494 1.278 2.34q-.072.144-.144.576t-.252.648q-2.304 3.492-10.872 3.492-1.908 0-3.978-.324t-3.528-.72-3.762-1.08q-.54-.18-.828-.252-.504-.144-1.656-.162t-1.44-.054q-1.476 1.62-4.59 2.34t-6.066.72q-1.26 0-2.484-.054t-3.348-.324-3.636-.738-2.682-1.44-1.17-2.304q0-1.44.36-2.142t1.476-1.746q.396-.072 1.458-.468t1.782-.432q.144 0 .504-.072.072-.072.072-.144l-.072-.108q-1.728-.396-3.888-3.798t-2.628-5.634l-.18-.108q-.144 0-.432.72-.648 1.476-1.962 2.682t-2.79 1.35h-.036q-.144 0-.216-.162t-.18-.198q-.828-1.944-.828-3.6 0-9.9 9.072-16.776z",
		"WEIXIN": "M20.88-47.843q0-1.476-.9-2.376t-2.376-.9q-1.548 0-2.736.918t-1.188 2.358q0 1.404 1.188 2.322t2.736.918q1.476 0 2.376-.882t.9-2.358zm26.748 18.252q0-1.008-.918-1.8t-2.358-.792q-.972 0-1.782.81t-.81 1.782q0 1.008.81 1.818t1.782.81q1.44 0 2.358-.792t.918-1.836zm-8.496-18.252q0-1.476-.882-2.376t-2.358-.9q-1.548 0-2.736.918t-1.188 2.358q0 1.404 1.188 2.322t2.736.918q1.476 0 2.358-.882t.882-2.358zm22.86 18.252q0-1.008-.936-1.8t-2.34-.792q-.972 0-1.782.81t-.81 1.782q0 1.008.81 1.818t1.782.81q1.404 0 2.34-.792t.936-1.836zm-9.576-14.292q-1.116-.144-2.52-.144-6.084 0-11.196 2.772t-8.046 7.506-2.934 10.35q0 2.808.828 5.472-1.26.108-2.448.108-.936 0-1.8-.054t-1.98-.234-1.602-.252-1.962-.378-1.8-.378l-9.108 4.572 2.592-7.848q-10.44-7.308-10.44-17.64 0-6.084 3.51-11.196t9.504-8.046 13.086-2.934q6.336 0 11.97 2.376t9.432 6.57 4.914 9.378zm21.312 20.196q0 4.212-2.466 8.046t-6.678 6.966l1.98 6.516-7.164-3.924q-5.4 1.332-7.848 1.332-6.084 0-11.196-2.538t-8.046-6.894-2.934-9.504 2.934-9.504 8.046-6.894 11.196-2.538q5.796 0 10.908 2.538t8.19 6.912 3.078 9.486z",
		"SEND": "M63.504-64.043q1.188.864.972 2.304l-9.216 55.296q-.18 1.044-1.152 1.62-.504.288-1.116.288-.396 0-.864-.18l-16.308-6.66-8.712 10.62q-.648.828-1.764.828-.468 0-.792-.144-.684-.252-1.098-.846t-.414-1.314v-12.564l31.104-38.124-38.484 33.3-14.22-5.832q-1.332-.504-1.44-1.98-.072-1.44 1.152-2.124l59.904-34.56q.54-.324 1.152-.324.72 0 1.296.396z",
		"SEND_O": "M63.504-64.043q1.188.864.972 2.304l-9.216 55.296q-.18 1.044-1.152 1.62-.504.288-1.116.288-.396 0-.864-.18l-18.972-7.74-10.728 11.772q-.648.756-1.692.756-.504 0-.828-.144-.684-.252-1.08-.846t-.396-1.314v-16.272l-16.992-6.948q-1.332-.504-1.44-1.98-.108-1.404 1.152-2.124l59.904-34.56q1.26-.756 2.448.072zm-12.312 53.964l7.956-47.628-51.624 29.772 12.096 4.932 31.068-23.004-17.208 28.692z",
		"HISTORY": "M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196q-6.192 0-11.772-2.61t-9.504-7.362q-.252-.36-.234-.81t.306-.738l4.932-4.968q.36-.324.9-.324.576.072.828.432 2.628 3.42 6.444 5.292t8.1 1.872q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458q-3.528 0-6.768 1.278t-5.76 3.654l4.932 4.968q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l4.68 4.644q3.852-3.636 8.802-5.634t10.242-1.998q5.616 0 10.728 2.196t8.82 5.904 5.904 8.82 2.196 10.728zm-23.04-10.368v16.128q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828z",
		"CIRCLE_THIN": "M27.648-55.223q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"HEADER": "M60.552-4.535q-1.584 0-4.77-.126t-4.806-.126q-1.584 0-4.752.126t-4.752.126q-.864 0-1.332-.738t-.468-1.638q0-1.116.612-1.656t1.404-.612 1.836-.252 1.62-.54q1.188-.756 1.188-5.04l-.036-14.076q0-.756-.036-1.116-.468-.144-1.8-.144h-24.3q-1.368 0-1.836.144-.036.36-.036 1.116l-.036 13.356q0 5.112 1.332 5.904.576.36 1.728.468t2.052.126 1.62.54.72 1.638q0 .936-.45 1.728t-1.314.792q-1.692 0-5.022-.126t-4.986-.126q-1.548 0-4.608.126t-4.572.126q-.828 0-1.278-.756t-.45-1.62q0-1.08.558-1.62t1.296-.63 1.71-.27 1.512-.54q1.188-.828 1.188-5.148l-.036-2.052v-29.268q0-.108.018-.936t0-1.314-.054-1.386-.126-1.512-.234-1.314-.396-1.134-.576-.648q-.54-.36-1.62-.432t-1.908-.072-1.476-.504-.648-1.62q0-.936.432-1.728t1.296-.792q1.656 0 4.986.126t4.986.126q1.512 0 4.554-.126t4.554-.126q.9 0 1.35.792t.45 1.728q0 1.08-.612 1.566t-1.386.522-1.782.144-1.548.468q-1.26.756-1.26 5.76l.036 11.52q0 .756.036 1.152.468.108 1.404.108h25.164q.9 0 1.368-.108.036-.396.036-1.152l.036-11.52q0-5.004-1.26-5.76-.648-.396-2.106-.45t-2.376-.468-.918-1.782q0-.936.45-1.728t1.35-.792q1.584 0 4.752.126t4.752.126q1.548 0 4.644-.126t4.644-.126q.9 0 1.35.792t.45 1.728q0 1.08-.63 1.584t-1.44.522-1.854.108-1.584.45q-1.26.828-1.26 5.796l.036 33.948q0 4.284 1.224 5.04.576.36 1.656.486t1.926.162 1.494.558.648 1.602q0 .936-.432 1.728t-1.296.792z",
		"PARAGRAPH": "M46.008-57.635v2.628q0 1.044-.666 2.196t-1.53 1.152q-1.8 0-1.944.036-.936.216-1.152 1.116-.108.396-.108 2.304v41.472q0 .9-.648 1.548t-1.548.648h-3.888q-.9 0-1.548-.648t-.648-1.548v-43.848h-5.148v43.848q0 .9-.63 1.548t-1.566.648h-3.888q-.936 0-1.566-.648t-.63-1.548v-17.856q-5.292-.432-8.82-2.124-4.536-2.088-6.912-6.444-2.304-4.212-2.304-9.324 0-5.976 3.168-10.296 3.168-4.248 7.524-5.724 3.996-1.332 15.012-1.332h17.244q.9 0 1.548.648t.648 1.548z",
		"SLIDERS": "M12.672-13.751v4.608h-12.672v-4.608h12.672zm12.672-4.608q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm5.76-13.824v4.608h-31.104v-4.608h31.104zm-23.04-18.432v4.608h-8.064v-4.608h8.064zm47.232 36.864v4.608h-26.496v-4.608h26.496zm-34.56-41.472q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm23.04 18.432q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm11.52 4.608v4.608h-8.064v-4.608h8.064zm0-18.432v4.608h-31.104v-4.608h31.104z",
		"SHARE_ALT": "M43.776-27.575q4.788 0 8.154 3.366t3.366 8.154-3.366 8.154-8.154 3.366-8.154-3.366-3.366-8.154q0-.432.072-1.224l-12.96-6.48q-3.312 3.096-7.848 3.096-4.788 0-8.154-3.366t-3.366-8.154 3.366-8.154 8.154-3.366q4.536 0 7.848 3.096l12.96-6.48q-.072-.792-.072-1.224 0-4.788 3.366-8.154t8.154-3.366 8.154 3.366 3.366 8.154-3.366 8.154-8.154 3.366q-4.536 0-7.848-3.096l-12.96 6.48q.072.792.072 1.224t-.072 1.224l12.96 6.48q3.312-3.096 7.848-3.096z",
		"SHARE_ALT_SQUARE": "M46.08-21.419q0-3.168-2.25-5.436t-5.418-2.268q-3.024 0-5.22 2.088l-8.676-4.32q.072-.576.072-.828t-.072-.828l8.676-4.32q2.196 2.088 5.22 2.088 3.168 0 5.418-2.268t2.25-5.436-2.25-5.418-5.418-2.25-5.436 2.25-2.268 5.418q0 .252.072.828l-8.676 4.32q-2.232-2.052-5.22-2.052-3.168 0-5.418 2.25t-2.25 5.418 2.25 5.418 5.418 2.25q2.988 0 5.22-2.052l8.676 4.32q-.072.576-.072.828 0 3.168 2.268 5.418t5.436 2.25 5.418-2.25 2.25-5.418zm9.216-28.044v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"BOMB": "M20.556-43.235q-.36-.9-1.224-1.26t-1.764 0q-3.888 1.584-6.876 4.572t-4.572 6.876q-.36.9 0 1.764t1.26 1.224q.468.18.864.18 1.512 0 2.16-1.44 1.224-3.024 3.546-5.346t5.346-3.546q.9-.396 1.26-1.26t0-1.764zm33.912-12.816l1.656 1.656-8.784 8.748 2.448 2.448q.684.684.684 1.638t-.684 1.638l-2.304 2.304q3.204 5.796 3.204 12.348 0 5.148-1.998 9.846t-5.4 8.1-8.1 5.4-9.846 1.998-9.846-1.998-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998q6.552 0 12.348 3.204l2.304-2.304q.684-.684 1.638-.684t1.638.684l2.448 2.448zm.288-2.016q-.36.36-.792.36-.468 0-.828-.36l-3.276-3.24q-.324-.36-.324-.828t.324-.828q.36-.324.828-.324t.828.324l3.24 3.276q.36.324.36.81t-.36.81zm8.28 8.28q-.396.324-.828.324t-.828-.324l-3.24-3.276q-.36-.324-.36-.81t.36-.81q.324-.36.81-.36t.81.36l3.276 3.24q.324.36.324.828t-.324.828zm1.476-6.588q0 .504-.324.828t-.828.324h-3.456q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h3.456q.504 0 .828.324t.324.828zm-6.912-6.912v3.456q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-3.456q0-.504.324-.828t.828-.324.828.324.324.828zm5.436 1.98l-3.276 3.24q-.36.36-.792.36-.468 0-.828-.36-.36-.324-.36-.81t.36-.81l3.24-3.276q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828z",
		"SOCCER_BALL_O": "M21.924-35.063l10.332-7.488 10.332 7.488-3.924 12.096h-12.78zm10.332-29.376q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm22.284 48.6q5.364-7.308 5.364-16.344v-.108l-3.672 3.204-8.64-8.064 2.268-11.628 4.824.432q-5.4-7.416-14.004-10.152l1.908 4.464-10.332 5.724-10.332-5.724 1.908-4.464q-8.604 2.736-14.004 10.152l4.86-.432 2.232 11.628-8.64 8.064-3.672-3.204v.108q0 9.036 5.364 16.344l1.08-4.752 11.736 1.44 5.004 10.728-4.176 2.484q4.212 1.404 8.64 1.404t8.64-1.404l-4.176-2.484 5.004-10.728 11.736-1.44z",
		"TTY": "M16.128-17.207v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm20.736 13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-20.664-5.76q-1.008 0-1.692-.684t-.684-1.656v-4.644h18.504v4.644q0 .972-.684 1.656t-1.656.684h-13.788zm41.4 19.584v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm20.736 13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-14.688v.468h-18.504v-.36q0-3.744-13.752-3.672-13.752.036-13.752 3.672v.36h-18.504v-.468q0-.612.306-1.548t1.224-2.304 2.358-2.718 3.978-2.736 5.76-2.43 8.064-1.71 10.566-.666 10.548.666 8.064 1.71 5.778 2.43 3.978 2.736 2.358 2.718 1.224 2.304.306 1.548zm0 14.688v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm0-12.744v4.644q0 .972-.684 1.656t-1.656.684h-13.824q-.972 0-1.656-.684t-.684-1.656v-4.644h18.504z",
		"BINOCULARS": "M25.344-52.919v27.648q0 .936-.684 1.62t-1.62.684v20.736q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-18.432l8.964-31.428q.252-.828 1.116-.828h15.264zm11.52 0v25.344h-9.216v-25.344h9.216zm27.648 32.256v18.432q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-20.736q-.936 0-1.62-.684t-.684-1.62v-27.648h15.264q.864 0 1.116.828zm-38.016-42.624v8.064h-12.672v-8.064q0-.504.324-.828t.828-.324h10.368q.504 0 .828.324t.324.828zm24.192 0v8.064h-12.672v-8.064q0-.504.324-.828t.828-.324h10.368q.504 0 .828.324t.324.828z",
		"PLUG": "M63.18-48.131q1.332 1.332 1.332 3.24t-1.332 3.276l-14.436 14.4 5.4 5.4-5.76 5.76q-5.868 5.868-14.022 6.714t-14.814-3.618l-13.032 13.032h-6.516v-6.516l13.032-13.032q-4.464-6.66-3.618-14.814t6.714-14.022l5.76-5.76 5.4 5.4 14.4-14.436q1.368-1.332 3.276-1.332t3.24 1.332 1.332 3.258-1.332 3.258l-14.4 14.436 8.424 8.424 14.436-14.4q1.368-1.332 3.276-1.332t3.24 1.332z",
		"SLIDESHARE": "M31.428-37.799q0 2.988-2.286 5.13t-5.49 2.142-5.49-2.142-2.286-5.13q0-3.024 2.286-5.148t5.49-2.124 5.49 2.124 2.286 5.148zm18.072 0q0 2.988-2.268 5.13t-5.508 2.142q-3.204 0-5.49-2.142t-2.286-5.13q0-3.024 2.286-5.148t5.49-2.124q3.24 0 5.508 2.124t2.268 5.148zm8.1 6.48v-24.012q0-3.132-1.152-4.446t-3.996-1.314h-40.032q-2.988 0-4.05 1.224t-1.062 4.536v24.228q1.548.828 3.186 1.44t2.916 1.008 2.916.666 2.556.396 2.52.144 2.106.018 2.034-.072 1.602-.072q2.448-.036 3.42.972.216.216.36.324.936.9 2.196 1.836.252-3.276 4.248-3.132.18 0 1.314.054t1.548.072 1.638.036 1.908-.036 1.962-.162 2.196-.306 2.232-.486 2.412-.702 2.43-.972 2.592-1.242zm5.868-.18q-4.356 5.364-13.392 9.072 3.024 10.26-.828 16.74-2.376 4.068-6.588 5.328-3.744 1.152-6.552-.54-3.096-1.836-2.952-5.904l-.036-11.736v-.036q-.288-.072-.882-.216t-.846-.18l-.036 12.168q.144 4.104-2.988 5.904-2.844 1.692-6.588.54-4.212-1.296-6.552-5.4-3.78-6.48-.792-16.668-9.036-3.708-13.392-9.072-.9-1.332-.144-2.268t2.16.036q.108.072.396.252t.396.288v-24.984q0-2.592 1.692-4.428t4.104-1.836h45.252q2.412 0 4.104 1.836t1.692 4.428v24.984l.756-.54q1.404-.972 2.16-.036t-.144 2.268z",
		"TWITCH": "M32.256-48.815v15.624h-5.22v-15.624h5.22zm14.328 0v15.624h-5.22v-15.624h5.22zm0 27.36l9.108-9.144v-28.62h-42.984v37.764h11.736v7.812l7.812-7.812h14.328zm14.328-42.984v36.468l-15.624 15.624h-11.736l-7.812 7.812h-7.812v-7.812h-14.328v-41.688l3.924-10.404h53.388z",
		"YELP": "M27.828-16.955v4.572q-.036 10.512-.216 10.98-.432 1.152-1.836 1.44-1.944.324-6.534-1.368t-5.85-3.204q-.468-.54-.612-1.296-.036-.432.144-.936.144-.36 1.224-1.692t6.516-7.776q.036 0 2.16-2.52.54-.684 1.422-.882t1.782.126q.864.36 1.35 1.044t.45 1.512zm-5.364-9.036q-.108 1.98-1.872 2.52l-4.32 1.404q-9.9 3.168-10.512 3.168-1.26-.072-1.944-1.296-.432-.9-.612-2.7-.288-2.736.036-5.994t1.08-4.482 2.016-1.152q.468 0 7.272 2.772 2.52 1.044 4.14 1.692l3.024 1.224q.828.324 1.278 1.098t.414 1.746zm29.736 10.692q-.252 1.944-3.294 5.796t-4.878 4.572q-1.332.504-2.268-.252-.504-.36-6.624-10.332l-1.692-2.772q-.504-.756-.414-1.656t.702-1.656q1.26-1.548 2.988-.936.036.036 4.284 1.44 7.308 2.376 8.712 2.862t1.692.738q1.008.792.792 2.196zm-24.192-22.752q.18 3.672-1.944 4.392-2.088.612-4.104-2.556l-13.608-21.528q-.288-1.26.684-2.232 1.476-1.548 7.47-3.222t8.082-1.134q1.44.36 1.764 1.62.108.648.792 10.998t.864 13.662zm23.832 3.888q.108 1.404-.936 2.124-.54.36-11.844 3.096-2.412.54-3.276.828l.036-.072q-.828.216-1.656-.144t-1.332-1.152q-1.08-1.692 0-3.132.036-.036 2.7-3.672 4.5-6.156 5.4-7.344t1.224-1.404q1.008-.684 2.34-.072 1.728.828 4.428 4.806t2.916 6.03v.108z",
		"NEWSPAPER_O": "M36.864-46.007h-13.824v13.824h13.824v-13.824zm4.608 23.04v4.608h-23.04v-4.608h23.04zm0-27.648v23.04h-23.04v-23.04h23.04zm23.04 27.648v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm-55.296 34.56v-34.56h-4.608v34.56q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm59.904 0v-39.168h-55.296v39.168q0 1.188-.396 2.304h53.388q.936 0 1.62-.684t.684-1.62zm4.608-43.776v43.776q0 2.88-2.016 4.896t-4.896 2.016h-59.904q-2.88 0-4.896-2.016t-2.016-4.896v-39.168h9.216v-4.608h64.512z",
		"WIFI": "M36.864-9.611q-.72 0-3.348-2.646t-2.628-3.366q0-1.152 2.25-1.944t3.726-.792 3.726.792 2.25 1.944q0 .72-2.628 3.366t-3.348 2.646zm9.72-9.756q-.072 0-1.44-.9t-3.654-1.8-4.626-.9-4.626.9-3.636 1.8-1.458.9q-.648 0-3.366-2.7t-2.718-3.348q0-.468.36-.828 2.808-2.772 7.056-4.356t8.388-1.584 8.388 1.584 7.056 4.356q.36.36.36.828 0 .648-2.718 3.348t-3.366 2.7zm9.828-9.792q-.396 0-.828-.288-4.896-3.78-9.072-5.562t-9.648-1.782q-3.06 0-6.138.792t-5.364 1.908-4.086 2.232-2.844 1.908-1.116.792q-.612 0-3.312-2.7t-2.7-3.348q0-.432.36-.792 4.752-4.752 11.52-7.38t13.68-2.628 13.68 2.628 11.52 7.38q.36.36.36.792 0 .648-2.7 3.348t-3.312 2.7zm9.756-9.756q-.396 0-.792-.324-6.444-5.652-13.374-8.514t-15.138-2.862-15.138 2.862-13.374 8.514q-.396.324-.792.324-.612 0-3.33-2.7t-2.718-3.348q0-.468.36-.828 6.732-6.696 16.02-10.368t18.972-3.672 18.972 3.672 16.02 10.368q.36.36.36.828 0 .648-2.718 3.348t-3.33 2.7z",
		"CALCULATOR": "M13.824-9.143q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 27.648v-13.824q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24v13.824q0 1.872 1.368 3.24t3.24 1.368 3.24-1.368 1.368-3.24zm-13.824-27.648q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824-11.52v-9.216q0-.936-.684-1.62t-1.62-.684h-46.08q-.936 0-1.62.684t-.684 1.62v9.216q0 .936.684 1.62t1.62.684h46.08q.936 0 1.62-.684t.684-1.62zm0 11.52q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm4.608-23.04v55.296q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-55.296q0-1.872 1.368-3.24t3.24-1.368h50.688q1.872 0 3.24 1.368t1.368 3.24z",
		"PAYPAL": "M54.684-41.183q.648 3.024-.144 7.344-3.132 15.984-20.34 15.984h-1.584q-.9 0-1.584.594t-.864 1.53l-.144.684-1.98 12.456-.072.54q-.18.936-.882 1.53t-1.602.594h-9.036q-.756 0-1.188-.54t-.324-1.296q.324-2.016.954-6.048t.954-6.048.972-6.03.972-6.03q.18-1.332 1.548-1.332h4.716q4.788.072 8.496-.756 6.3-1.404 10.332-5.184 3.672-3.42 5.58-8.856.864-2.52 1.26-4.788.036-.216.09-.27t.126-.036.216.126q2.844 2.124 3.528 5.832zm-6.192-10.152q0 3.852-1.656 8.496-2.88 8.388-10.872 11.34-4.068 1.44-9.072 1.512 0 .036-3.24.036l-3.24-.036q-3.6 0-4.248 3.456-.072.288-3.06 19.08-.036.36-.432.36h-10.62q-.792 0-1.314-.594t-.414-1.386l8.352-52.956q.18-1.044.99-1.728t1.854-.684h21.528q1.224 0 3.51.468t4.014 1.152q3.852 1.476 5.886 4.428t2.034 7.056z",
		"GOOGLE_WALLET": "M15.876-40.247q1.152 0 1.872.936 9.576 13.104 13.032 27.864h-16.056q-4.572-15.876-13.212-26.964-.432-.576-.108-1.206t1.044-.63h13.428zm20.124 12.852q-1.764 7.164-4.5 14.148-2.844-11.16-9.216-21.384 1.44-7.956 1.584-16.164 7.596 12.24 12.132 23.4zm3.564-25.524q8.46 11.664 13.842 25.146t6.642 27.846h-16.236q-1.476-23.94-19.908-52.992h15.66zm24.948 20.736q0 15.264-3.636 29.232-2.412-20.16-12.924-38.988-.9-10.836-3.816-21.024-.144-.576.198-1.026t.918-.45h12.924q.756 0 1.386.468t.81 1.188q4.14 14.724 4.14 30.6z",
		"CC_VISA": "M71.1-28.799h-4.968q.504-1.332 2.376-6.444l.108-.324q.144-.36.36-.936t.324-.936l.432 1.98zm-51.984-2.34l-2.088-10.62q-.396-1.944-2.7-1.944h-9.648l-.072.468q11.196 2.844 14.508 12.096zm6.444-12.564l-5.832 15.768-.612-3.204q-.936-2.52-3.06-4.662t-4.716-3.186l4.86 18.36h6.3l9.396-23.076h-6.336zm5.004 23.112h5.976l3.744-23.112h-5.976zm27.648-22.536q-2.484-.972-5.364-.972-4.428 0-7.236 2.124t-2.844 5.508q-.036 3.672 5.22 6.264 1.728.828 2.412 1.476t.684 1.404q0 1.08-1.08 1.656t-2.484.576q-3.096 0-5.616-1.188l-.792-.396-.828 5.184q2.664 1.224 6.66 1.224 4.68.036 7.506-2.124t2.898-5.76q0-3.816-5.04-6.264-1.764-.9-2.556-1.512t-.792-1.368q0-.792.882-1.386t2.538-.594q2.52-.036 4.464.864l.54.288zm15.3-.576h-4.608q-2.34 0-3.132 1.944l-8.856 21.168h6.264l1.26-3.456h7.632q.18.792.72 3.456h5.544zm9.432-11.52v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"CC_MASTERCARD": "M24.156-30.851h-.468q-1.692 0-1.692 1.152 0 .792.72.792.612 0 1.008-.54t.432-1.404zm14.22-1.296h2.232v-.108q.036-.144.018-.234t-.036-.252-.072-.288-.162-.234-.27-.18-.414-.072q-1.008 0-1.296 1.368zm19.44 1.296h-.432q-1.728 0-1.728 1.152 0 .792.72.792.612 0 1.008-.54t.432-1.404zm11.484-.936q0-1.476-1.08-1.476-.684 0-1.116.72t-.432 1.836q0 1.512 1.008 1.512.72 0 1.17-.72t.45-1.872zm-52.02-5.076h3.132l-1.584 9.432h-2.016l1.152-7.236-2.556 7.236h-1.404l-.144-7.2-1.224 7.2h-1.908l1.584-9.432h2.916l.072 5.868zm9.108 3.852q0 .216-.144 1.512-.576 3.636-.612 4.068h-1.692l.036-.792q-.72.936-2.088.936-.828 0-1.35-.576t-.522-1.512q0-1.404.936-2.178t2.628-.774q.504 0 .828.036l.018-.198.036-.162.018-.108q0-.72-1.296-.72-1.044 0-2.124.36 0-.144.252-1.728 1.368-.396 2.412-.396 2.664 0 2.664 2.232zm5.616-2.088l-.288 1.764q-.792-.108-1.476-.108-.972 0-.972.612 0 .288.162.432t.774.396q1.44.684 1.44 2.16 0 2.592-3.132 2.556-1.224 0-2.088-.216 0-.072.252-1.764 1.044.288 1.836.288 1.152 0 1.152-.684 0-.252-.162-.414t-.774-.45q-1.548-.72-1.548-2.124 0-2.592 3.024-2.592 1.08 0 1.8.144zm3.168 0h1.008l-.252 1.872h-1.044q-.072.612-.234 1.458t-.252 1.386-.09.648q0 .576.684.576.288 0 .576-.072l-.288 1.692q-.756.252-1.44.252-1.548 0-1.62-1.692 0-.432.288-2.016.108-.72.9-5.256h1.98zm7.308 2.628q0 .828-.252 1.872h-3.996q-.108.792.36 1.188t1.368.396q1.08 0 2.088-.504l-.324 1.944q-1.08.288-2.052.288-3.42 0-3.42-3.42 0-1.98.99-3.258t2.502-1.278q1.26 0 1.998.756t.738 2.016zm5.004-2.664q-.468.828-.792 2.232-.792-.072-1.116.864t-.9 4.608h-2.016l.108-.504q.792-4.68 1.044-7.164h1.836l-.108 1.188q.504-.756.918-1.062t1.026-.162zm6.732-1.476l-.324 2.052q-1.008-.504-1.8-.504-1.116 0-1.836.99t-.72 2.538q0 1.08.486 1.692t1.386.612q.756 0 1.728-.468l-.36 2.124q-1.008.288-1.8.288-1.62 0-2.574-1.098t-.954-2.97q0-2.52 1.278-4.122t3.294-1.602q.936 0 2.196.468zm5.832 3.6q0 .648-.144 1.512-.468 2.844-.612 4.068h-1.656l.036-.792q-.72.936-2.124.936-.828 0-1.332-.576t-.504-1.512q0-1.404.918-2.178t2.61-.774q.54 0 .828.036.072-.252.072-.468 0-.72-1.296-.72-1.044 0-2.124.36 0-.144.288-1.728 1.368-.396 2.412-.396 2.628 0 2.628 2.232zm5.076-2.124q-.504.864-.756 2.232-.828-.072-1.134.828t-.918 4.644h-2.016l.108-.504q.684-3.744 1.044-7.164h1.872q0 .396-.144 1.188.54-.756.954-1.062t.99-.162zm5.076-1.728h2.016l-1.548 9.432h-1.908l.108-.684q-.828.828-1.872.828-1.116 0-1.782-.864t-.666-2.304q0-1.908.99-3.312t2.322-1.404q1.116 0 1.908 1.044zm3.996 4.68q0-5.328-2.61-9.828t-7.128-7.128-9.846-2.628q-6.516 0-11.808 3.96 4.572 4.176 6.156 10.224h-1.8q-1.584-5.4-5.688-9.108-4.104 3.708-5.688 9.108h-1.8q1.584-6.048 6.156-10.224-5.292-3.96-11.808-3.96-5.328 0-9.846 2.628t-7.128 7.128-2.61 9.828 2.61 9.828 7.128 7.128 9.846 2.628q6.516 0 11.808-3.96-4.32-3.996-5.94-9.504h1.8q1.656 4.968 5.472 8.388 3.816-3.42 5.472-8.388h1.8q-1.62 5.508-5.94 9.504 5.292 3.96 11.808 3.96 5.328 0 9.846-2.628t7.128-7.128 2.61-9.828zm8.748-23.04v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"CC_DISCOVER": "M11.268-36.467q0 1.836-1.296 3.024-1.044.936-3.204.936h-.612v-7.92h.612q2.196 0 3.204.972 1.296 1.116 1.296 2.988zm63.936-2.34q0 1.872-2.304 1.872h-.684v-3.636h.72q2.268 0 2.268 1.764zm-61.524 2.34q0-2.664-1.8-4.338t-4.644-1.674h-3.42v11.988h3.42q2.664 0 4.284-1.368 2.16-1.836 2.16-4.608zm1.08 5.976h2.34v-11.988h-2.34v11.988zm11.52-3.636q0-1.44-.738-2.232t-2.718-1.512q-1.044-.36-1.422-.684t-.378-.828q0-.576.486-.954t1.242-.378q1.044 0 1.908.972l1.224-1.584q-1.476-1.332-3.528-1.332-1.584 0-2.664.99t-1.08 2.43q0 1.26.648 1.998t2.304 1.314q1.332.468 1.62.684.684.432.684 1.224 0 .72-.504 1.206t-1.296.486q-1.728 0-2.556-1.584l-1.512 1.44q1.584 2.304 4.14 2.304 1.836 0 2.988-1.098t1.152-2.862zm10.008 3.24v-2.772q-1.332 1.332-2.808 1.332-1.764 0-2.898-1.17t-1.134-2.97q0-1.728 1.134-2.934t2.79-1.206q1.548 0 2.916 1.368v-2.772q-1.44-.72-2.88-.72-2.664 0-4.518 1.818t-1.854 4.446 1.836 4.446 4.5 1.818q1.512 0 2.916-.684zm44.352 21.744v-18.972q-2.34 1.44-5.202 3.024t-8.55 4.212-11.862 4.95-15.03 4.842-18.144 4.248h56.484q.936 0 1.62-.684t.684-1.62zm-30.636-27.252q0-2.7-1.908-4.608t-4.608-1.908-4.608 1.908-1.908 4.608 1.908 4.608 4.608 1.908 4.608-1.908 1.908-4.608zm5.472 6.228l5.184-12.312h-2.556l-3.24 8.064-3.204-8.064h-2.556l5.112 12.312h1.26zm6.228-.324h6.624v-2.016h-4.284v-3.24h4.14v-2.016h-4.14v-2.664h4.284v-2.052h-6.624v11.988zm14.076 0h2.88l-3.78-5.04q2.736-.576 2.736-3.384 0-1.692-1.116-2.628t-3.132-.936h-3.492v11.988h2.34v-4.788h.324zm7.164-24.516v45.648q0 2.016-1.386 3.42t-3.366 1.404h-73.44q-1.98 0-3.366-1.404t-1.386-3.42v-45.648q0-2.016 1.386-3.42t3.366-1.404h73.44q1.98 0 3.366 1.404t1.386 3.42z",
		"CC_AMEX": "M4.284-39.887h3.204l-1.62-3.888zm22.356 18.936l2.664-2.844-2.52-2.844h-5.868v1.764h5.112v1.98h-5.112v1.944h5.724zm5.688-2.808l3.564 3.96v-7.812zm10.368-1.692q0-1.188-1.44-1.188h-3.024v2.484h2.988q1.476 0 1.476-1.296zm10.404-.144q0-1.044-1.512-1.044h-2.952v2.196h2.916q1.548 0 1.548-1.152zm-10.008-16.776q0-1.044-1.512-1.044h-2.952v2.16h2.916q1.548 0 1.548-1.116zm16.524 2.484h3.204l-1.584-3.888zm-34.452-5.58v9.756h-2.376v-7.632l-3.384 7.632h-2.052l-3.384-7.632v7.632h-4.752l-.9-2.16h-4.86l-.9 2.16h-2.52l4.176-9.756h3.456l3.96 9.252v-9.252h3.816l3.06 6.624 2.772-6.624h3.888zm20.016 20.016q0 .72-.198 1.26t-.504.9-.81.594-.936.36-1.134.162-1.134.036-1.17-.018-1.062-.018v3.276h-4.536l-2.88-3.24-2.988 3.24h-9.216v-9.756h9.36l2.88 3.204 2.952-3.204h7.452q3.924 0 3.924 3.204zm-10.476-12.276v2.016h-7.812v-9.756h7.812v2.052h-5.472v1.764h5.328v1.98h-5.328v1.944h5.472zm48.24 20.124v8.244q0 1.98-1.386 3.402t-3.366 1.422h-73.44q-1.98 0-3.366-1.422t-1.386-3.402v-24.408h3.996l.9-2.196h1.98l.9 2.196h7.848v-1.656l.684 1.656h4.068l.72-1.692v1.692h19.476v-3.564l.36-.036q.36 0 .36.504v3.096h10.044v-.828q.828.432 1.98.648t1.89.234 2.268-.018 1.854-.036l.9-2.196h2.016l.9 2.196h8.172v-2.088l1.224 2.088h6.552v-13.608h-6.48v1.584l-.9-1.584h-6.66v1.584l-.828-1.584h-8.964q-2.484 0-3.924.792v-.792h-6.192v.792q-.864-.792-2.628-.792h-22.608l-1.548 3.492-1.548-3.492h-7.128v1.584l-.792-1.584h-6.084l-2.808 6.444v-14.076q0-1.98 1.386-3.402t3.366-1.422h73.44q1.98 0 3.366 1.422t1.386 3.402v24.408h-4.32q-1.836 0-2.916.792v-.792h-6.372q-1.98 0-2.808.792v-.792h-11.376v.792q-1.116-.792-3.132-.792h-7.524v.792q-.828-.792-3.276-.792h-8.424l-1.944 2.088-1.8-2.088h-12.564v13.608h12.348l1.98-2.124 1.872 2.124h7.596v-3.204h.756q2.124 0 3.24-.468v3.672h6.264v-3.564h.288q.288 0 .36.072t.072.36v3.132h19.044q2.052 0 3.168-.864v.864h6.048q2.16 0 3.42-.612zm-27.288-8.424q0 .828-.432 1.548t-1.224 1.044q.9.324 1.224.936t.324 1.656v1.944h-2.34v-1.62q0-1.188-.432-1.566t-1.656-.378h-2.484v3.564h-2.34v-9.756h5.544q1.728 0 2.772.54t1.044 2.088zm-9.972-16.812q0 .864-.45 1.584t-1.206 1.044q.936.324 1.242.918t.306 1.674v1.908h-2.34q0-.324.018-.954t0-.9-.108-.666-.306-.576-.63-.306-1.062-.126h-2.52v3.528h-2.304v-9.756l5.508.036q1.764 0 2.808.522t1.044 2.07zm19.044 21.924v2.016h-7.776v-9.756h7.776v2.016h-5.436v1.764h5.328v1.98h-5.328v1.944zm-15.336-24.552v9.756h-2.376v-9.756h2.376zm24.948 23.472q0 3.096-3.672 3.096h-4.536v-2.088h4.536q1.224 0 1.224-.9 0-.576-.612-.756t-1.494-.18-1.782-.126-1.512-.81-.612-1.98q0-1.404.936-2.16t2.376-.756h4.68v2.052h-4.284q-1.296 0-1.296.9 0 .576.63.738t1.512.144 1.764.09 1.512.774.63 1.962zm8.604-1.8v3.636q-.864 1.26-3.168 1.26h-4.5v-2.088h4.5q1.188 0 1.188-.9 0-.468-.45-.684t-1.116-.198-1.44-.072-1.44-.288-1.116-.864-.45-1.746q0-1.404.954-2.16t2.394-.756h4.644v2.052h-4.248q-1.296 0-1.296.9 0 .72 1.044.792t2.466.18 2.034.936zm-5.94-21.636v9.72h-3.312l-4.392-7.308v7.308h-4.752l-.936-2.16h-4.824l-.9 2.16h-2.7q-4.644 0-4.644-4.788 0-4.968 4.788-4.968h2.268v2.124q-.252 0-1.008-.036t-1.026-.018-.828.072-.774.234-.522.486-.414.828-.108 1.206q0 1.368.486 2.088t1.782.72h1.044l3.312-7.668h3.492l3.924 9.216v-9.216h3.564l4.104 6.768v-6.768h2.376z",
		"CC_PAYPAL": "M26.82-31.823q0 1.332-.918 2.214t-2.25.882q-1.044 0-1.674-.576t-.63-1.584q0-1.332.9-2.25t2.232-.918q1.008 0 1.674.594t.666 1.638zm28.26-5.364q0 1.512-.792 2.052t-2.376.54l-1.152.036.612-3.852q.072-.396.468-.396h.648q.792 0 1.26.072t.9.45.432 1.098zm12.636 5.364q0 1.296-.918 2.196t-2.214.9q-1.044 0-1.692-.576t-.648-1.584q0-1.332.9-2.25t2.232-.918q1.008 0 1.674.594t.666 1.638zm-49.248-6.156q0-2.124-1.386-3.078t-3.618-.954h-5.76q-.684 0-.756.684l-2.34 14.688q-.036.216.108.396t.36.18h2.736q.72 0 .792-.684l.648-3.96q.036-.288.252-.468t.54-.234.612-.054.684.036.504.036q3.096 0 4.86-1.746t1.764-4.842zm11.124 11.232l1.476-9.396q.036-.216-.108-.396t-.36-.18h-2.736q-.504 0-.612 1.188-.972-1.44-3.42-1.44-2.592 0-4.41 1.944t-1.818 4.572q0 2.124 1.242 3.384t3.33 1.26q1.008 0 2.088-.432t1.728-1.152q-.144.432-.144.756 0 .576.468.576h2.484q.684 0 .792-.684zm16.092-9.468q0-.18-.144-.342t-.324-.162h-2.772q-.396 0-.648.36l-3.816 5.616-1.584-5.4q-.18-.576-.792-.576h-2.7q-.18 0-.324.162t-.144.342q0 .072.702 2.124t1.512 4.428.846 2.52q-2.952 4.032-2.952 4.32 0 .468.468.468h2.772q.396 0 .648-.36l9.18-13.248q.072-.072.072-.252zm13.68-1.764q0-2.124-1.386-3.078t-3.618-.954h-5.724q-.72 0-.792.684l-2.34 14.688q-.036.216.108.396t.36.18h2.952q.432 0 .576-.468l.648-4.176q.036-.288.252-.468t.54-.234.612-.054.684.036.504.036q3.096 0 4.86-1.746t1.764-4.842zm11.124 11.232l1.476-9.396q.036-.216-.108-.396t-.36-.18h-2.736q-.504 0-.612 1.188-.936-1.44-3.42-1.44-2.592 0-4.41 1.944t-1.818 4.572q0 2.124 1.242 3.384t3.33 1.26q1.044 0 2.124-.432t1.692-1.152q0 .036-.072.324t-.072.432q0 .576.468.576h2.484q.684 0 .792-.684zm7.848-14.724v-.036q0-.504-.468-.504h-2.664q-.396 0-.468.396l-2.34 14.976-.036.072q0 .18.144.342t.36.162h2.376q.684 0 .756-.684zm-64.224 4.824q-.18 1.26-.936 1.656t-2.16.396l-1.188.036.612-3.852q.072-.396.468-.396h.684q1.44 0 2.088.414t.432 1.746zm68.832-18.576v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"CC_STRIPE": "M57.492-31.931q0 2.484-.756 3.816-.684 1.26-1.872 1.26-.828 0-1.476-.324v-8.064q1.044-1.08 2.052-1.08 2.052 0 2.052 4.392zm15.768-1.296h-3.96q.216-3.528 2.016-3.528 1.836 0 1.944 3.528zm-56.124 4.86q0-2.124-1.188-3.294t-3.636-2.07q-1.296-.468-1.872-.864t-.576-.9q0-.936 1.368-.936 2.088 0 4.464 1.188l.648-4.032q-2.412-1.152-5.364-1.152-2.772 0-4.428 1.368-1.728 1.404-1.728 3.924 0 2.088 1.17 3.258t3.582 2.034q1.404.504 1.962.918t.558.99q0 1.116-1.728 1.116-1.044 0-2.52-.45t-2.592-1.098l-.648 4.068q2.592 1.476 6.048 1.476 2.916 0 4.644-1.332 1.836-1.476 1.836-4.212zm10.62-7.74l.684-3.996h-3.456v-4.86l-4.644.756-.648 4.104-1.656.288-.612 3.708h2.232v7.884q0 3.024 1.584 4.32 1.368 1.08 3.996 1.08 1.152 0 2.844-.396v-4.248q-1.152.252-1.584.252-1.512 0-1.512-1.8v-7.092h2.772zm11.376.9v-5.004q-.54-.108-1.008-.108-1.152 0-1.998.576t-1.206 1.656l-.36-2.016h-4.716v16.956h5.4v-11.016q.936-1.116 2.952-1.116.576 0 .936.072zm1.332 12.06h5.4v-16.956h-5.4v16.956zm22.392-8.964q0-4.392-1.62-6.444-1.44-1.872-3.996-1.872-2.304 0-4.212 2.016l-.288-1.692h-4.752v23.22l5.4-.9v-5.436q1.296.396 2.448.396 2.988 0 4.824-2.016 2.196-2.34 2.196-7.272zm-16.848-12.528q0-1.188-.828-2.016t-2.016-.828-2.016.828-.828 2.016.828 2.034 2.016.846 2.016-.846.828-2.034zm32.328 12.852q0-4.068-1.728-6.336-1.8-2.304-5.184-2.304-3.456 0-5.454 2.376t-1.998 6.48q0 4.608 2.268 6.768 1.98 1.98 5.796 1.98 3.636 0 5.76-1.44l-.576-3.708q-2.052 1.116-4.608 1.116-1.548 0-2.268-.684-.828-.684-1.008-2.376h8.928q.072-.504.072-1.872zm4.608-23.436v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"BELL_SLASH": "M56.088-33.767q2.196 12.816 10.728 20.016 0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.498-2.682-2.718-6.498zm-19.224 30.96q.576 0 .576-.576t-.576-.576q-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854zm36.072-57.6q.288.36.27.846t-.378.81l-67.392 58.392q-.36.288-.846.252t-.774-.396l-3.024-3.456q-.288-.36-.27-.846t.378-.774l6.696-5.796q-.684-1.152-.684-2.376 1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 4.464.648 7.884 2.97t5.328 5.67l15.048-13.068q.36-.288.846-.252t.774.396z",
		"BELL_SLASH_O": "M37.44-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm-19.332-17.1l31.572-27.36q-1.512-3.168-4.77-5.274t-8.046-2.106q-3.348 0-6.102 1.134t-4.374 2.898-2.484 3.708-.864 3.78q0 13.824-4.932 23.22zm48.708 6.732q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.498-2.682-2.718-6.498l5.364-4.644h27.252q-5.976-6.732-8.172-16.524l3.996-3.492q2.196 12.816 10.728 20.016zm3.096-50.112l3.024 3.456q.288.36.27.846t-.378.81l-67.392 58.392q-.36.288-.846.252t-.774-.396l-3.024-3.456q-.288-.36-.27-.846t.378-.774l6.696-5.796q-.684-1.152-.684-2.376 1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 4.464.648 7.884 2.97t5.328 5.67l15.048-13.068q.36-.288.846-.252t.774.396z",
		"TRASH": "M18.432-14.903v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 0v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 0v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm-19.584-35.712h16.128l-1.728-4.212q-.252-.324-.612-.396h-11.412q-.36.072-.612.396zm33.408 1.152v2.304q0 .504-.324.828t-.828.324h-3.456v34.128q0 2.988-1.692 5.166t-4.068 2.178h-29.952q-2.376 0-4.068-2.106t-1.692-5.094v-34.272h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h11.124l2.52-6.012q.54-1.332 1.944-2.268t2.844-.936h11.52q1.44 0 2.844.936t1.944 2.268l2.52 6.012h11.124q.504 0 .828.324t.324.828z",
		"COPYRIGHT": "M41.4-25.775v3.924q0 1.8-1.314 3.204t-3.384 2.178-4.248 1.17-4.23.396q-7.38 0-12.33-5.004t-4.95-12.456q0-7.308 4.896-12.204t12.204-4.896q1.224 0 2.718.162t3.348.648 3.33 1.224 2.484 2.034 1.008 2.916v3.924q0 .576-.576.576h-4.248q-.576 0-.576-.576v-2.52q0-1.548-2.358-2.43t-4.95-.882q-5.04 0-8.226 3.294t-3.186 8.55q0 5.436 3.294 8.982t8.406 3.546q2.448 0 4.968-.864t2.52-2.376v-2.52q0-.252.162-.414t.378-.162h4.284q.216 0 .396.162t.18.414zm-13.752-29.448q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"AT": "M34.992-36.539q0-3.888-1.926-6.084t-5.31-2.196q-2.268 0-4.464 1.098t-3.96 3.042-2.862 4.932-1.098 6.48q0 4.032 1.926 6.228t5.418 2.196q3.456 0 6.336-2.394t4.41-5.976 1.53-7.326zm20.304 4.356q0 3.996-1.332 7.092t-3.546 4.86-4.734 2.682-5.22.99l-.558.018-.594.018q-3.42 0-5.112-1.908-1.008-1.188-1.188-2.988-1.872 2.376-4.734 3.96t-6.246 1.584q-5.796 0-8.982-3.438t-3.186-9.702q0-5.652 2.376-10.44t6.444-7.578 8.856-2.79q3.132 0 5.58 1.278t3.816 3.582l.072-.684.396-2.016q.036-.216.198-.432t.342-.216h4.248q.18 0 .468.396.18.18.108.576l-4.32 22.104q-.18.864-.18 1.728 0 1.404.45 1.872t1.602.468q1.008-.036 2.052-.198t2.628-.864 2.772-1.8 2.052-3.222.864-4.932q0-10.512-6.264-16.776t-16.776-6.264q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836q8.208 0 14.58-5.184.396-.324.864-.288t.756.432l1.476 1.764q.288.432.252.864-.072.468-.432.792-3.672 2.988-8.19 4.608t-9.306 1.62q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728 2.196-10.728 5.904-8.82 8.82-5.904 10.728-2.196q12.384 0 20.016 7.632t7.632 20.016z",
		"EYEDROPPER": "M61.128-61.055q3.384 3.384 3.384 8.154t-3.384 8.118l-8.1 8.028 3.744 3.744q.36.36.36.828t-.36.828l-7.56 7.56q-.36.36-.828.36t-.828-.36l-3.78-3.78-21.708 21.708q-1.332 1.332-3.24 1.332h-7.308l-9.216 4.608-2.304-2.304 4.608-9.216v-7.308q0-1.908 1.332-3.24l21.708-21.708-3.78-3.78q-.36-.36-.36-.828t.36-.828l7.56-7.56q.36-.36.828-.36t.828.36l3.744 3.744 8.028-8.1q3.348-3.384 8.118-3.384t8.154 3.384zm-42.696 49.608l20.736-20.736-6.912-6.912-20.736 20.736v6.912h6.912z",
		"PAINT_BRUSH": "M58.14-64.439q2.52 0 4.41 1.674t1.89 4.194q0 2.268-1.62 5.436-11.952 22.644-16.74 27.072-3.492 3.276-7.848 3.276-4.536 0-7.794-3.33t-3.258-7.902q0-4.608 3.312-7.632l22.968-20.844q2.124-1.944 4.68-1.944zm-32.724 37.224q1.404 2.736 3.834 4.68t5.418 2.736l.036 2.556q.144 7.668-4.662 12.492t-12.546 4.824q-4.428 0-7.848-1.674t-5.49-4.59-3.114-6.588-1.044-7.92q.252.18 1.476 1.08t2.232 1.602 2.124 1.314 1.656.612q1.476 0 1.98-1.332.9-2.376 2.07-4.05t2.502-2.736 3.168-1.71 3.708-.918 4.5-.378z",
		"BIRTHDAY_CAKE": "M64.512-13.751v13.824h-64.512v-13.824q1.62 0 3.06-.504t2.124-.99 1.692-1.35q1.08-.972 1.854-1.368t2.034-.396 1.998.396 1.89 1.368q1.044.9 1.692 1.368t2.088.972 3.096.504q1.62 0 3.06-.522t2.088-.972 1.728-1.35q.756-.684 1.17-.972t1.116-.54 1.566-.252q1.26 0 2.034.396t1.854 1.368q1.008.864 1.692 1.35t2.124.99 3.06.504 3.06-.504 2.124-.99 1.692-1.35q1.08-.972 1.854-1.368t2.034-.396q1.224 0 1.998.396t1.854 1.368q1.008.864 1.692 1.35t2.124.99 3.06.504zm0-11.52v6.912q-1.26 0-1.998-.396t-1.89-1.368q-1.044-.9-1.692-1.368t-2.088-.972-3.06-.504q-1.656 0-3.096.504t-2.088.972-1.692 1.368q-.792.684-1.188.972t-1.116.54-1.584.252q-1.26 0-2.034-.396t-1.854-1.368q-1.044-.9-1.692-1.368t-2.088-.972-3.096-.504q-1.62 0-3.06.522t-2.088.972-1.728 1.35q-.756.684-1.17.972t-1.116.54-1.566.252q-1.26 0-2.034-.396t-1.854-1.368q-1.008-.864-1.692-1.35t-2.124-.99-3.06-.504q-1.656 0-3.096.504t-2.088.972-1.692 1.368q-1.08.972-1.854 1.368t-2.034.396v-6.912q0-2.88 2.016-4.896t4.896-2.016h2.304v-16.128h9.216v16.128h9.216v-16.128h9.216v16.128h9.216v-16.128h9.216v16.128h2.304q2.88 0 4.896 2.016t2.016 4.896zm-46.08-31.104q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4zm18.432 0q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4zm18.432 0q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4z",
		"AREA_CHART": "M73.728-9.143v4.608h-73.728v-55.296h4.608v50.688h69.12zm-13.824-36.864l9.216 32.256h-59.904v-20.736l16.128-20.736 20.736 20.736z",
		"PIE_CHART": "M27.648-32.399l19.656 19.656q-3.816 3.888-8.91 6.048t-10.746 2.16q-7.524 0-13.878-3.708t-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708v27.432zm6.732.216h27.828q0 5.652-2.16 10.746t-6.048 8.91zm25.524-4.608h-27.648v-27.648q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878z",
		"LINE_CHART": "M73.728-9.143v4.608h-73.728v-55.296h4.608v50.688h69.12zm-4.608-44.928v15.66q0 .756-.702 1.062t-1.278-.27l-4.356-4.356-22.788 22.788q-.36.36-.828.36t-.828-.36l-8.388-8.388-14.976 14.976-6.912-6.912 21.06-21.06q.36-.36.828-.36t.828.36l8.388 8.388 16.704-16.704-4.356-4.356q-.576-.576-.27-1.278t1.062-.702h15.66q.504 0 .828.324t.324.828z",
		"LASTFM": "M46.512-39.095q0 .216.36 1.476.36 1.044.9 1.782t1.476 1.224 1.584.72 1.98.594q11.7 3.276 11.7 11.952 0 5.256-3.798 8.73t-9.162 3.474q-2.124 0-4.014-.666t-3.294-1.638-2.772-2.682-2.268-3.15-1.926-3.726-1.566-3.708-1.422-3.834-1.278-3.42q-1.152-2.916-2.214-4.806t-2.646-3.474-3.744-2.304-5.112-.72q-3.456 0-6.588 1.998t-4.968 5.202-1.836 6.66q0 5.76 3.834 10.062t9.486 4.302q6.372 0 9.288-3.42 2.016-2.268 2.988-4.176l3.024 5.472q-.54 1.224-1.584 2.52l.036.036q-4.716 5.472-13.968 5.472-5.292 0-9.702-2.844t-6.858-7.47-2.448-9.882q0-3.78 1.566-7.416t4.176-6.354 6.192-4.374 7.362-1.656q3.132 0 5.724.684t4.446 1.8 3.42 2.88 2.61 3.564 2.106 4.212 1.818 4.482 1.8 4.698 1.98 4.572q3.456 7.2 8.388 7.2 2.916 0 4.986-1.746t2.07-4.626q0-1.512-.684-2.592t-1.818-1.656-2.61-1.134-3.042-.972-3.15-1.224-2.916-1.872-2.34-2.952-1.404-4.41q-.108-.576-.108-1.188 0-3.96 3.15-6.912t7.146-2.808q2.808.108 4.338.522t3.258 1.926h-.036q.432.396.828.882t.936 1.296.684.99l-4.644 3.564q-.936-1.764-1.944-2.52v-.036q-.828-.756-3.492-.756-1.764 0-3.024 1.188t-1.26 2.988z",
		"LASTFM_SQUARE": "M51.552-26.567q0-6.228-8.424-8.604-1.26-.36-1.908-.594t-1.368-.9-1.044-1.674q0-.072-.072-.306t-.108-.432-.036-.27q0-1.296.882-2.142t2.178-.846q1.944 0 2.556.54h-.036q.72.54 1.404 1.836l3.348-2.556q-1.404-1.944-1.764-2.304-1.188-1.044-2.43-1.404t-3.078-.36q-2.88 0-5.112 2.07t-2.232 4.95q0 .252.072.828.576 3.456 2.322 5.04t5.346 2.628q1.044.288 1.764.558t1.62.774 1.386 1.242.486 1.674v.18q.036 2.088-1.458 3.348t-3.618 1.26q-3.492 0-6.012-5.184-.828-1.692-1.854-4.374t-1.728-4.518-1.944-3.978-2.664-3.438-3.726-2.178-5.292-.882q-3.636 0-6.912 2.016t-5.184 5.328-1.8 6.912v.036q.144 3.888 1.818 7.164t4.806 5.31 7.056 2.034q6.696 0 10.044-3.96.72-.972 1.116-1.836l-2.16-3.924q-1.512 2.88-3.564 4.176t-5.256 1.296q-4.14 0-6.876-3.132t-2.736-7.344q0-3.78 2.952-6.804t6.696-3.024q4.032 0 6.12 1.926t3.744 6.21q.288.756.918 2.466t1.026 2.754 1.134 2.682 1.386 2.664 1.638 2.25 1.998 1.926 2.376 1.188 2.88.486q3.852 0 6.588-2.502t2.736-6.282zm3.744-22.896v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"TOGGLE_OFF": "M41.472-32.183q0-3.744-1.458-7.146t-3.942-5.886-5.886-3.942-7.146-1.458-7.146 1.458-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458 7.146-1.458 5.886-3.942 3.942-5.886 1.458-7.146zm27.648 0q0-3.744-1.458-7.146t-3.942-5.886-5.886-3.942-7.146-1.458h-13.896q4.284 3.24 6.786 8.064t2.502 10.368-2.502 10.368-6.786 8.064h13.896q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146zm4.608 0q0 4.68-1.836 8.946t-4.914 7.344-7.344 4.914-8.946 1.836h-27.648q-4.68 0-8.946-1.836t-7.344-4.914-4.914-7.344-1.836-8.946 1.836-8.946 4.914-7.344 7.344-4.914 8.946-1.836h27.648q4.68 0 8.946 1.836t7.344 4.914 4.914 7.344 1.836 8.946z",
		"TOGGLE_ON": "M0-32.183q0-4.68 1.836-8.946t4.914-7.344 7.344-4.914 8.946-1.836h27.648q4.68 0 8.946 1.836t7.344 4.914 4.914 7.344 1.836 8.946-1.836 8.946-4.914 7.344-7.344 4.914-8.946 1.836h-27.648q-4.68 0-8.946-1.836t-7.344-4.914-4.914-7.344-1.836-8.946zm50.688 18.432q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458-7.146 1.458-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458z",
		"BICYCLE": "M27.432-22.967h-11.304q-1.44 0-2.07-1.26t.234-2.412l6.768-9.036q-2.34-1.116-4.932-1.116-4.752 0-8.136 3.384t-3.384 8.136 3.384 8.136 8.136 3.384q4.14 0 7.308-2.61t3.996-6.606zm-6.696-4.608h6.696q-.648-3.06-2.7-5.328zm17.28 0l10.368-13.824h-17.28l-3.564 4.752q3.78 3.708 4.536 9.072h5.94zm40.32 2.304q0-4.752-3.384-8.136t-8.136-3.384q-2.16 0-4.356.864l6.264 9.36q.54.828.36 1.764t-.972 1.44q-.54.396-1.296.396-1.26 0-1.908-1.044l-6.264-9.36q-3.348 3.42-3.348 8.1 0 4.752 3.384 8.136t8.136 3.384 8.136-3.384 3.384-8.136zm4.608 0q0 6.66-4.734 11.394t-11.394 4.734-11.394-4.734-4.734-11.394q0-3.492 1.422-6.606t3.942-5.382l-2.34-3.528-12.708 16.884q-.648.936-1.836.936h-7.092q-.828 5.904-5.364 9.864t-10.584 3.96q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q4.104 0 7.74 1.98l4.932-6.588h-8.064q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h13.824v4.608h15.66l-3.06-4.608h-7.992q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q1.188 0 1.908 1.008l9.612 14.4q3.276-1.584 6.912-1.584 6.66 0 11.394 4.734t4.734 11.394z",
		"BUS": "M13.824-20.663q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm36.864 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-1.656-14.256l-2.592-13.824q-.18-.828-.81-1.35t-1.458-.522h-33.048q-.828 0-1.458.522t-.81 1.35l-2.592 13.824q-.18 1.08.504 1.908t1.764.828h38.232q1.08 0 1.764-.828t.504-1.908zm-8.136-22.032q0-.72-.504-1.224t-1.224-.504h-23.04q-.72 0-1.224.504t-.504 1.224.504 1.224 1.224.504h23.04q.72 0 1.224-.504t.504-1.224zm14.4 26.1v21.708h-4.608v4.608q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258v-4.608h-27.648v4.608q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258v-4.608h-4.608v-21.708q0-4.032.9-8.028l3.708-16.344q.324-2.808 3.51-4.932t8.28-3.204 11.25-1.08 11.25 1.08 8.28 3.204 3.51 4.932l3.78 16.344q.828 3.672.828 8.028z",
		"IOXHOST": "M52.668-34.487q0 1.26-.9 2.178t-2.196.918h-25.272q-1.296 0-2.196-.918t-.9-2.178.9-2.178 2.196-.918h25.272q1.296 0 2.196.918t.9 2.178zm7.704 0q0-3.096-.828-6.12h-35.352q-1.296 0-2.196-.9t-.9-2.16q0-1.296.9-2.196t2.196-.9h32.688q-3.168-5.148-8.46-8.172t-11.52-3.024q-6.372 0-11.79 3.15t-8.568 8.55-3.15 11.772q0 3.096.828 6.12h35.352q1.296 0 2.196.9t.9 2.16q0 1.296-.9 2.196t-2.196.9h-32.688q3.168 5.148 8.478 8.172t11.538 3.024q4.752 0 9.108-1.854t7.488-5.004 5.004-7.488 1.872-9.126zm13.356-9.18q0 1.26-.9 2.16t-2.196.9h-4.716q.612 3.06.612 6.12 0 6.012-2.358 11.502t-6.318 9.468-9.45 6.336-11.502 2.358q-8.856 0-16.146-4.788t-10.854-12.6h-6.804q-1.296 0-2.196-.9t-.9-2.196q0-1.26.9-2.16t2.196-.9h4.752q-.612-3.06-.612-6.12 0-6.012 2.358-11.502t6.318-9.468 9.45-6.336 11.538-2.358q8.82 0 16.11 4.788t10.854 12.6h6.768q1.296 0 2.196.9t.9 2.196z",
		"ANGELLIST": "M34.308-50.831l-4.104 11.808 4.212.756q5.94-16.236 5.94-18.648 0-2.016-1.368-2.016-2.052 0-4.68 8.1zm-10.764 24.732l1.188 3.168q1.332-1.512 2.556-2.412l-1.188-.198-1.386-.252-1.17-.306zm-10.512-32.256q0 3.528 5.724 18.756.648-.36 1.764-.36.54 0 2.7.18l-4.356-12.636q-2.7-7.92-4.428-7.92-.684 0-1.044.63t-.36 1.35zm-2.844 27.324q0 1.296 1.854 4.284t4.23 5.508 3.6 2.52q.504 0 .918-.468t.414-.972q0-.864-1.152-3.672-.468-1.152-1.152-2.592t-1.71-3.204-2.214-2.916-2.232-1.152q-.72 0-1.638.972t-.918 1.692zm-5.688 12.06q0 1.476.9 3.744 2.124 5.22 6.606 8.172t10.134 2.952q8.172 0 13.752-6.12 5.472-6.084 5.472-15.372 0-1.548-.036-2.412t-.414-2.232-1.098-2.016q-2.016-1.764-7.614-2.718t-9.738-.954q-1.332 0-1.764.396-.432.18-.432 1.26 0 1.224.774 2.16t1.998 1.44 2.79.846 3.15.414 3.06.144 2.52 0h.828q.864 0 1.44.684.54.684.684 1.98-1.008 1.008-3.456 1.944-2.196.792-3.348 1.656-2.304 1.656-3.906 4.104t-1.602 4.932q0 1.116.666 3.186t.666 3.15l-.108.432q-.144.432-.144.504-4.932-.36-5.256-7.776-.288.072-1.476.072.072.252.072.756 0 1.908-1.458 3.222t-3.402 1.314q-2.952 0-5.994-2.808t-3.042-5.724q0-1.224 1.188-2.412 1.872 2.304 2.16 2.736 2.772 3.744 4.788 3.744.432 0 .954-.306t.522-.738q0-1.224-3.15-5.22t-4.194-3.996q-1.548 0-2.52 1.602t-.972 3.258zm-4.104.324q0-3.636 1.53-5.868t4.914-3.168q-1.008-2.664-1.008-3.744 0-2.232 2.196-4.428t4.392-2.196q1.044 0 2.52.54-5.868-16.632-5.868-20.412 0-2.88 1.476-4.698t4.284-1.818q4.716 0 11.7 20.916l.288.828q.216-.576 1.044-2.862t1.566-4.266 1.944-4.59 2.322-4.428 2.538-3.114 2.754-1.296q2.556 0 4.032 1.764t1.476 4.392q0 3.888-5.724 19.8 2.196.54 3.618 1.656t2.106 2.808.936 3.366.252 3.978q0 5.4-1.692 10.08t-4.752 8.1-7.596 5.4-10.008 1.98q-3.996 0-8.028-1.512-5.364-2.052-9.288-6.894t-3.924-10.314z",
		"CC": "M28.26-28.151h7.452q-.504 5.688-3.546 8.946t-7.722 3.258q-5.832 0-9.162-4.176t-3.33-11.376q0-6.984 3.348-11.214t8.388-4.23q5.328 0 8.352 3.132t3.492 8.892h-7.308q-.18-2.304-1.278-3.564t-2.934-1.26q-2.052 0-3.186 2.178t-1.134 6.39q0 1.728.18 3.024t.648 2.502 1.44 1.854 2.376.648q3.42 0 3.924-5.004zm25.632 0h7.416q-.504 5.688-3.528 8.946t-7.704 3.258q-5.832 0-9.162-4.176t-3.33-11.376q0-6.984 3.348-11.214t8.388-4.23q5.328 0 8.352 3.132t3.492 8.892h-7.344q-.144-2.304-1.26-3.564t-2.916-1.26q-2.052 0-3.186 2.178t-1.134 6.39q0 1.728.18 3.024t.648 2.502 1.422 1.854 2.358.648q1.764 0 2.754-1.368t1.206-3.636zm12.924-4.284q0-7.452-.558-11.052t-2.178-5.796q-.216-.288-.486-.504t-.774-.54-.576-.396q-3.096-2.268-25.092-2.268-22.5 0-25.56 2.268-.18.144-.63.414t-.756.504-.522.522q-1.62 2.16-2.16 5.742t-.54 11.106q0 7.488.54 11.07t2.16 5.778q.216.288.54.54t.738.504.63.432q1.584 1.188 8.622 1.764t16.938.576q21.96 0 25.092-2.34.18-.144.612-.396t.738-.504.486-.576q1.656-2.16 2.196-5.724t.54-11.124zm6.912-27.396v55.296h-73.728v-55.296h73.728z",
		"SHEQEL": "M35.712-41.975v17.856q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-17.856q0-4.032-2.88-6.912t-6.912-2.88h-9.792v41.472q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-48.384q0-.504.324-.828t.828-.324h16.704q4.86 0 8.964 2.394t6.498 6.498 2.394 8.964zm13.824-16.704v31.68q0 4.86-2.394 8.964t-6.498 6.498-8.964 2.394h-16.704q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828v27.648h9.792q4.032 0 6.912-2.88t2.88-6.912v-31.68q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828z",
		"MEANPATH": "M47.196-34.127v4.104q0 .864-.486 1.368t-1.35.504h-7.272q-.864 0-1.368-.504t-.504-1.368v-4.104q0-.864.504-1.368t1.368-.504h7.272q.864 0 1.35.504t.486 1.368zm-17.64 8.28v-9q0-1.908-1.17-3.078t-3.078-1.17h-4.788q-2.448 0-3.456 1.872-1.008-1.872-3.456-1.872h-4.68q-1.908 0-3.078 1.17t-1.17 3.078v9q0 .792.756.792h1.98q.792 0 .792-.792v-8.28q0-.864.486-1.368t1.386-.504h3.384q.864 0 1.368.504t.504 1.368v8.28q0 .792.756.792h1.944q.792 0 .792-.792v-8.28q0-.864.504-1.368t1.368-.504h3.492q.864 0 1.35.504t.486 1.368v8.28q0 .792.792.792h1.98q.756 0 .756-.792zm21.204-3.456v-5.544q0-1.908-1.188-3.078t-3.096-1.17h-9.504q-1.908 0-3.096 1.17t-1.188 3.078v14.76q0 .756.792.756h1.98q.756 0 .756-.756v-6.48q1.116 1.512 3.384 1.512h6.876q1.908 0 3.096-1.17t1.188-3.078zm4.536-22.176v38.592q0 3.456-2.448 5.904t-5.904 2.448h-38.592q-3.456 0-5.904-2.448t-2.448-5.904v-38.592q0-3.456 2.448-5.904t5.904-2.448h38.592q3.456 0 5.904 2.448t2.448 5.904z",
		"BUYSELLADS": "M32.94-25.343h-10.584l5.292-19.836zm3.096 11.592h11.196l-11.664-36.864h-15.84l-11.664 36.864h11.196l13.788-11.304zm19.26-35.712v34.56q0 4.248-3.06 7.308t-7.308 3.06h-34.56q-4.248 0-7.308-3.06t-3.06-7.308v-34.56q0-4.248 3.06-7.308t7.308-3.06h34.56q4.248 0 7.308 3.06t3.06 7.308z",
		"CONNECTDEVELOP": "M73.728-32.219q0 .756-.468 1.314t-1.188.702l-7.38 12.816q.108.324.108.648 0 .72-.45 1.278t-1.17.702l-6.948 12.132q.108.288.108.576 0 .828-.594 1.44t-1.458.612q-.9 0-1.476-.648h-14.4q-.612.72-1.548.72t-1.548-.72h-14.364q-.612.72-1.548.72-.828 0-1.44-.594t-.612-1.458q0-.288.144-.72l-6.948-12.06q-.72-.144-1.17-.702t-.45-1.278q0-.324.108-.648l-7.416-12.816q-.72-.18-1.17-.738t-.45-1.278q0-.756.486-1.314t1.206-.702l7.164-12.384-.018-.108-.018-.108q0-1.296 1.224-1.836l7.524-13.068q-.144-.36-.144-.648 0-.864.612-1.458t1.44-.594q.936 0 1.584.756h14.256q.576-.756 1.548-.756t1.548.756h14.328q.648-.756 1.584-.756.828 0 1.44.594t.612 1.458q0 .216-.144.648l7.452 12.888q.828.036 1.404.63t.576 1.386q0 .468-.252.972l6.732 11.664q.684.144 1.134.702t.45 1.278zm-35.46 28.764h14.004l-12.312-12.744h-5.148l-12.312 12.744h12.96q.648-.576 1.404-.576t1.404.576zm-34.236-29.232q.036.144.036.468 0 .36-.072.54l7.488 12.96.162.036.198.09.18.09 6.768-7.164v-12.492l-6.732-6.984q-.468.288-1.044.36zm31.464-28.224h-13.968l6.84 7.2 19.944-7.2h-10.08q-.576.576-1.368.576t-1.368-.576zm25.308 43.632q.036-.216.18-.396l-2.304-2.448-.612 2.844h2.736zm-3.816 0l.792-3.78-9.072-9.576-10.656 11.052 2.268 2.304h16.668zm-3.168 13.248l.576-1.008 2.34-11.16h-15.372l11.988 12.348q.288-.144.468-.18zm-33.012.576h.18l12.312-12.744h-13.428v12.06l.144.216q.504.18.792.468zm-.936-13.824h14.472l2.304-2.376-11.124-11.556-5.652 5.976v7.956zm-6.948 0h5.868v-6.804l-6.048 6.372q.144.288.18.432zm-.036-29.7l.018.072.018.072q0 .576-.288 1.044l6.156 6.372v-9.684zm6.984-2.52v11.196l5.508 5.652 10.692-11.304-8.028-8.496zm.144-10.944l-.144.288v9.504l7.38-2.664-6.876-7.236-.36.108zm32.076-.468h-.576l-22.356 8.064 7.668 8.1zm-15.264 17.712l-10.692 11.34 11.196 11.484 10.656-11.052zm-12.06 11.232l-4.896-5.076v10.224zm12.6 13.104l-1.512 1.584h3.06zm12.096-12.528l8.568 9.036 4.752-22.464-.108-.18-.036-.036zm12.384-14.4q-.288-.468-.288-1.044v-.072l-7.776-13.536q-.18-.036-.468-.18l-15.732 16.668 11.16 11.772zm-43.056-4.464v-8.028l-5.868 10.152zm0 34.056h-5.868l5.868 10.188v-10.188zm39.06 0l-1.728 8.172 4.68-8.172h-2.952zm4.392-2.52l7.452-12.996q-.072-.36-.072-.504l.108-.576-6.156-10.656-4.644 22.032 2.772 2.952q.18-.108.54-.252z",
		"DASHCUBE": "M0-39.959q0-4.716 3.294-8.154t8.01-3.438h26.712l12.672-12.888v52.92q0 4.752-3.294 8.172t-8.01 3.42h-28.08q-4.716 0-8.01-3.42t-3.294-8.172v-28.44zm44.352 27.144l-6.336-6.48v-15.3q0-1.656-1.152-2.844t-2.808-1.188h-17.424q-1.656 0-2.808 1.188t-1.152 2.844v17.712q0 1.656 1.17 2.862t2.79 1.206h27.72z",
		"FORUMBEE": "M33.624-59.039q-11.412 4.356-20.016 13.05t-12.888 20.178q-.72-3.204-.72-6.336 0-7.488 3.69-13.842t10.026-10.044 13.824-3.69q2.952 0 6.084.684zm9.684 4.284q3.348 2.34 5.904 5.58-14.004 4.068-24.282 14.418t-14.274 24.354q-3.348-2.592-5.58-5.832 4.032-13.896 14.22-24.156t24.012-14.364zm-26.388 48.024q4.14-12.816 13.662-22.392t22.302-13.824q1.44 3.312 1.944 7.02-10.512 4.32-18.576 12.42t-12.348 18.648q-3.708-.504-6.984-1.872zm38.376 2.088q-6.948-1.8-13.212-4.14-4.86 3.024-10.44 3.852 3.924-7.38 9.864-13.338t13.284-9.918q-.756 5.472-3.636 10.224 2.34 6.3 4.14 13.32z",
		"LEANPUB": "M68.148-50.327l5.58 45.792q-4.716 0-9.252-2.052-7.2-3.276-14.148-3.276-8.136 0-13.464 5.328-5.328-5.328-13.464-5.328-6.948 0-14.148 3.276-4.608 2.052-9.072 2.052h-.18l5.58-45.792q8.064-4.572 17.352-4.572 8.388 0 13.932 3.816 5.544-3.816 13.932-3.816 9.288 0 17.352 4.572zm-17.82 35.532q4.644 0 8.352 1.026t9.36 3.366l-4.464-36.756q-6.156-2.808-13.248-2.808-8.064 0-13.464 5.076-5.4-5.076-13.464-5.076-7.092 0-13.248 2.808l-4.464 36.756q3.78-1.548 5.958-2.34t5.346-1.422 6.408-.63q7.272 0 13.464 3.888 6.192-3.888 13.464-3.888zm1.44-1.224l-1.98-32.652q-7.596.144-12.924 5.58-5.472-5.58-13.464-5.58-6.336 0-12.096 2.376l-4.104 33.876q4.464-1.836 8.226-2.736t7.974-.9q7.524 0 13.464 3.672 6.192-3.852 13.464-3.672z",
		"SELLSY": "M54-15.083v-26.388q0-.756-.54-1.296t-1.26-.54h-3.348q-.72 0-1.26.54t-.54 1.296v26.388q0 .72.54 1.26t1.26.54h3.348q.72 0 1.26-.54t.54-1.26zm-10.224 0v-19.116q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v19.116q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm-10.512 0v-15.444q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v15.444q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm-10.512 0v-13.032q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v13.032q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm50.976-5.256q0 5.976-4.248 10.224t-10.224 4.248h-44.784q-5.976 0-10.224-4.248t-4.248-10.224q0-4.176 2.268-7.722t6.048-5.346q-.36-1.224-.36-2.628 0-4.068 2.898-6.966t6.966-2.898q3.672 0 6.48 2.412 1.62-6.588 6.984-10.8t12.168-4.212q5.364 0 9.9 2.646t7.182 7.182 2.646 9.9q0 2.376-.504 4.392 4.86 1.188 7.956 5.13t3.096 8.91z",
		"SHIRTSINBULK": "M0-64.439h55.296v50.112l-27.936 12.168-27.36-12.168v-50.112zm51.696 47.772v-33.336h-48.096v33.336l23.796 10.584zm0-36.936v-7.236h-48.096v7.236h48.096zm-45.18 10.728v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm.936 5.148l.54-1.224 3.78 1.692-.54 1.188zm4.896 2.16l.54-1.224 3.78 1.656-.54 1.224zm4.86 2.16l.54-1.224 3.78 1.656-.54 1.224zm4.896 2.124l.54-1.188 3.744 1.656-.54 1.224zm6.588.468l3.78-1.656.54 1.188-3.78 1.692zm4.86-2.16l3.78-1.656.54 1.224-3.78 1.656zm4.896-2.16l3.78-1.656.54 1.224-3.78 1.656zm4.86-2.124l3.78-1.692.54 1.224-3.78 1.656zm-33.984-43.2v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm-43.56 12.24v2.844h-1.332v-4.14h4.14v1.296h-2.808zm8.64-1.296v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm4.5 4.14v-2.844h-2.808v-1.296h4.14v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm-21.42-1.26q-4.644 0-7.956-3.294t-3.312-7.974q0-4.644 3.312-7.956t7.956-3.312q4.68 0 7.974 3.312t3.294 7.956q0 4.68-3.294 7.974t-7.974 3.294zm-5.94-13.716q0 1.296.702 2.034t1.782.9 2.304.252 2.304.072 1.782.324.702 1.098q0 1.764-4.032 1.764-3.492 0-4.428-1.836h-.108l-1.116 2.268q2.412 1.512 5.832 1.512 1.044 0 2.034-.18t1.998-.576 1.638-1.188.63-1.908q0-1.656-.99-2.502t-2.43-.972-2.862-.108-2.412-.18-.99-.918q0-.756.738-1.188t1.458-.54 1.476-.108q1.224 0 2.538.396t1.854 1.224h.108l1.08-2.088q-.108-.036-.756-.306t-.81-.324-.702-.252-.792-.252-.72-.162-.864-.144-.828-.036q-1.044 0-2.034.18t-1.944.594-1.548 1.224-.594 1.926z",
		"SIMPLYBUILT": "M31.068-27.287q0-4.032-2.862-6.894t-6.894-2.862-6.876 2.862-2.844 6.894 2.844 6.876 6.876 2.844 6.894-2.844 2.862-6.876zm31.068-.036q0-4.032-2.844-6.876t-6.876-2.844-6.894 2.844-2.862 6.876q0 4.068 2.862 6.912t6.894 2.844 6.876-2.862 2.844-6.894zm11.592-29.124v48.528q0 1.584-1.134 2.718t-2.754 1.134h-65.952q-1.62 0-2.754-1.134t-1.134-2.718v-48.528q0-1.584 1.134-2.718t2.754-1.134h15.516q1.584 0 2.736 1.134t1.152 2.718v5.796h27.144v-5.796q0-1.584 1.152-2.718t2.736-1.134h15.516q1.62 0 2.754 1.134t1.134 2.718z",
		"SKYATLAS": "M51.48-43.451zm9.36 7.344q5.328 0 9.108 3.546t3.78 8.802q0 5.652-3.924 9.414t-9.612 3.762q-3.06 0-5.832-.99t-4.968-2.646-4.248-3.816-3.924-4.554-3.726-4.77-3.906-4.536-4.212-3.816-4.896-2.646-5.724-.99q-5.544 0-9.054 3.294t-3.51 8.802q0 5.652 3.744 9t9.468 3.348q3.6 0 7.488-1.35t6.948-3.546q.18-.144.756-.666t1.08-.864.792-.342q.504 0 .882.378t.378.882q0 .864-2.16 2.772-3.636 3.168-8.442 5.112t-9.378 1.944q-4.788 0-8.838-2.088t-6.48-5.94-2.43-8.676q0-7.38 5.094-12.276t12.51-4.896q4.32 0 8.154 1.566t6.678 4.068 5.454 5.508 5.004 6.03 4.806 5.526 5.382 4.068 6.21 1.566q3.672 0 6.066-2.214t2.394-5.85q0-3.42-2.322-5.724t-5.742-2.304q-1.08 0-2.934.666t-2.466.666q-.72 0-1.278-.54t-.558-1.26q0-.648.306-2.052t.306-2.124q0-5.724-3.87-9.468t-9.594-3.744q-2.088 0-4.014.666t-3.024 1.458-1.998 1.458-1.188.666q-.54 0-.918-.378t-.378-.918q0-.684.9-1.656 2.124-2.412 5.292-3.726t6.552-1.314q6.876 0 11.448 4.518t4.572 11.358q0 1.332-.144 2.376 2.052-.54 4.14-.54z",
		"CART_PLUS": "M43.776-39.095q0-.936-.684-1.62t-1.62-.684h-4.608v-4.608q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v4.608h-4.608q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684h4.608v4.608q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-4.608h4.608q.936 0 1.62-.684t.684-1.62zm-20.736 29.952q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm32.256 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm4.608-39.168v18.432q0 .864-.576 1.53t-1.476.774l-37.584 4.392q.036.252.162.774t.216.954.09.792q0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.504.396-1.422t1.062-2.142.738-1.368l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.72.558.468.882.27.954.198 1.062.162.918h43.236q.936 0 1.62.684t.684 1.62z",
		"CART_ARROW_DOWN": "M46.08-39.095q0-.936-.684-1.62t-1.62-.684-1.62.684l-5.292 5.256v-10.548q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v10.548l-5.292-5.256q-.684-.684-1.62-.684t-1.62.684-.684 1.62.684 1.62l9.216 9.216q.684.684 1.62.684t1.62-.684l9.216-9.216q.684-.684.684-1.62zm-23.04 29.952q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm32.256 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm4.608-39.168v18.432q0 .864-.576 1.53t-1.476.774l-37.584 4.392q.036.252.162.774t.216.954.09.792q0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.504.396-1.422t1.062-2.142.738-1.368l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.72.558.468.882.27.954.198 1.062.162.918h43.236q.936 0 1.62.684t.684 1.62z",
		"DIAMOND": "M7.632-36.791l22.428 23.94-10.8-23.94h-11.628zm29.232 27.792l12.564-27.792h-25.128zm-17.496-32.4l7.344-13.824h-9.432l-10.368 13.824h12.456zm24.3 28.548l22.428-23.94h-11.628zm-19.08-28.548h24.552l-7.344-13.824h-9.864zm29.772 0h12.456l-10.368-13.824h-9.432zm5.076-17.496l13.824 18.432q.504.648.468 1.494t-.612 1.458l-34.56 36.864q-.648.72-1.692.72t-1.692-.72l-34.56-36.864q-.576-.612-.612-1.458t.468-1.494l13.824-18.432q.648-.936 1.836-.936h41.472q1.188 0 1.836.936z",
		"SHIP": "M65.196-8.459q.684-.684 1.62-.684t1.62.684l4.608 4.608-3.24 3.24-2.988-2.988-2.988 2.988q-.648.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-4.608-4.608 3.24-3.24 2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988zm-56.664-1.368q-.684.684-1.62.684t-1.62-.684l-4.608-4.608 3.24-3.24 2.988 2.952 2.988-2.952q.684-.684 1.62-.684t1.62.684l2.988 2.952 2.304-2.304v-10.548l-7.56-11.304q-.612-.936-.252-2.034t1.44-1.458l6.372-2.088v-10.764h4.608v-4.608h9.216v-4.608h9.216v4.608h9.216v4.608h4.608v10.764l6.372 2.088q1.08.36 1.44 1.458t-.252 2.034l-7.56 11.304v10.548l.684-.648q.684-.684 1.62-.684t1.62.684l2.988 2.952 2.988-2.952q.684-.684 1.62-.684t1.62.684l4.608 4.608-3.24 3.24-2.988-2.988-2.988 2.988q-.648.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988zm14.508-40.788v4.608l13.824-4.608 13.824 4.608v-4.608h-4.608v-4.608h-18.432v4.608h-4.608z",
		"USER_SECRET": "M20.736-9.143l3.456-16.128-3.456-4.608-4.608-2.304zm9.216 0l4.608-23.04-4.608 2.304-3.456 4.608zm5.76-36.36q-.072-.144-.144-.216-.36-.288-3.456-.288-2.52 0-6.012.684-.252.072-.756.072t-.756-.072q-3.492-.684-6.012-.684-3.096 0-3.456.288-.072.072-.144.216.072.648.144.972.072.108.27.234t.27.378q.072.144.27.738t.252.738.27.612.306.612.324.504.432.486.504.342.63.288.738.144.882.072q1.296 0 2.124-.45t1.17-1.08.522-1.242.414-1.062.63-.45h.432q.396 0 .63.45t.414 1.062.522 1.242 1.17 1.08 2.124.45q.468 0 .882-.072t.738-.144.63-.288.504-.342.432-.486.324-.504.306-.612.27-.612.252-.738.27-.738q.072-.252.27-.378t.27-.234q.072-.324.144-.972zm14.976 31.644q0 4.356-2.628 6.84t-6.984 2.484h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-2.196.162-4.248t.684-4.518 1.35-4.446 2.286-3.726 3.366-2.682l-3.24-7.92h7.704q-.792-2.304-.792-4.608 0-.432.072-1.152-6.984-1.44-6.984-3.456 0-2.052 7.56-3.564.612-2.232 1.854-4.824t2.538-4.104q1.152-1.332 2.736-1.332 1.08 0 3.024 1.116t3.024 1.116 3.024-1.116 3.024-1.116q1.584 0 2.736 1.332 1.296 1.512 2.538 4.104t1.854 4.824q7.56 1.512 7.56 3.564 0 2.016-6.984 3.456.252 2.916-.72 5.76h7.704l-2.952 8.1q2.268 1.188 3.87 3.474t2.358 5.166 1.044 5.454.288 5.346z",
		"MOTORCYCLE": "M82.836-27.143q.432 3.708-.792 7.146t-3.564 5.886-5.706 3.816-7.074 1.116q-5.796-.396-10.062-4.5t-4.842-9.864q-.432-3.996.99-7.578t4.266-6.138l-2.556-3.852q-3.456 2.88-5.436 6.984t-1.98 8.784q0 .972-.666 1.674t-1.638.702h-11.7q-.828 5.904-5.364 9.864t-10.584 3.96q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q2.736 0 5.472.972l.864-1.62q-4.428-3.96-10.944-3.96h-2.304q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h4.608q2.808 0 5.22.486t4.194 1.386 2.574 1.422 1.836 1.314h22.572l-3.06-4.608h-7.992q-1.08 0-1.764-.81t-.504-1.89q.144-.828.828-1.368t1.548-.54h9.108q1.188 0 1.908 1.008l2.52 3.78 4.104-4.104q.684-.684 1.656-.684h3.636q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-6.444l4.14 6.192q4.716-2.268 9.9-1.296 5.148.936 8.784 4.842t4.248 9.126zm-66.708 13.392q4.14 0 7.308-2.61t3.996-6.606h-11.304q-1.26 0-1.98-1.116-.648-1.152-.036-2.268l5.292-9.972q-1.692-.468-3.276-.468-4.752 0-8.136 3.384t-3.384 8.136 3.384 8.136 8.136 3.384zm50.688 0q4.752 0 8.136-3.384t3.384-8.136-3.384-8.136-8.136-3.384q-2.16 0-4.356.864l6.264 9.36q.54.828.36 1.764t-.972 1.44q-.54.396-1.296.396-1.26 0-1.908-1.044l-6.264-9.36q-3.348 3.42-3.348 8.1 0 4.752 3.384 8.136t8.136 3.384z",
		"STREET_VIEW": "M50.688-9.143q0 2.268-2.214 4.086t-5.904 2.916-8.1 1.656-9.126.558-9.126-.558-8.1-1.656-5.904-2.916-2.214-4.086q0-1.764 1.188-3.186t3.276-2.394 4.248-1.602 4.716-1.062q.936-.18 1.728.378t.936 1.494q.18.936-.378 1.728t-1.494.936q-2.088.36-3.816.846t-2.754.918-1.746.846-.99.702-.306.432q.108.396.972.954t2.628 1.188 4.104 1.17 5.778.9 7.254.36 7.254-.36 5.778-.9 4.104-1.188 2.628-1.206.972-.99q-.036-.144-.306-.396t-.99-.684-1.746-.846-2.754-.9-3.816-.846q-.936-.144-1.494-.936t-.378-1.728q.144-.936.936-1.494t1.728-.378q2.556.432 4.716 1.062t4.248 1.602 3.276 2.394 1.188 3.186zm-13.824-32.256v13.824q0 .936-.684 1.62t-1.62.684h-2.304v13.824q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-13.824h-2.304q-.936 0-1.62-.684t-.684-1.62v-13.824q0-1.908 1.35-3.258t3.258-1.35h13.824q1.908 0 3.258 1.35t1.35 3.258zm-3.456-13.824q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z",
		"HEARTBEAT": "M46.08-27.575h10.98q-.18.216-.36.378t-.324.27l-.108.144-22.428 21.6q-.648.648-1.584.648t-1.584-.648l-22.464-21.672q-.18-.072-.756-.72h13.284q.792 0 1.422-.486t.81-1.242l2.52-10.116 6.84 24.012q.216.72.828 1.188t1.404.468q.756 0 1.368-.468t.828-1.188l5.256-17.46 2.016 4.032q.648 1.26 2.052 1.26zm18.432-15.408q0 5.22-3.708 10.8h-13.284l-3.996-7.956q-.288-.612-.918-.972t-1.314-.288q-1.62.18-2.016 1.656l-4.644 15.48-7.056-24.696q-.216-.72-.846-1.188t-1.422-.468-1.404.486-.792 1.242l-4.176 16.704h-15.228q-3.708-5.58-3.708-10.8 0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384z",
		"VENUS": "M41.472-43.703q0 7.956-5.31 13.842t-13.122 6.75v9.36h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-9.36q-5.4-.576-9.774-3.708t-6.696-8.064-1.89-10.512q.396-4.824 2.898-8.964t6.552-6.768 8.838-3.168q6.12-.684 11.484 1.944t8.496 7.632 3.132 11.016zm-36.864 0q0 6.66 4.734 11.394t11.394 4.734 11.394-4.734 4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394z",
		"MARS": "M52.992-59.831q.936 0 1.62.684t.684 1.62v14.976q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-9.432l-13.752 13.788q4.536 5.616 4.536 12.924 0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638q7.308 0 12.924 4.536l13.752-13.752h-9.396q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h14.976zm-32.256 50.688q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"MERCURY": "M29.88-53.063q5.22 2.592 8.406 7.578t3.186 10.998q0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842q0-6.012 3.186-10.998t8.406-7.578q-5.94-3.456-8.208-9.828-.216-.576.126-1.062t.954-.486h2.484q.756 0 1.044.72 1.584 3.816 5.04 6.156t7.704 2.34 7.704-2.34 5.04-6.156q.288-.72 1.332-.72h2.196q.612 0 .954.486t.126 1.062q-2.268 6.372-8.208 9.828zm-9.144 34.704q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"TRANSGENDER": "M36.864-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q4.536 5.688 4.536 12.924 0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-5.364-.576-9.738-3.708t-6.714-8.046-1.908-10.494q.576-7.344 5.76-12.726t12.492-6.21q4.248-.504 8.208.684t7.128 3.708l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-16.128 44.928q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"TRANSGENDER_ALT": "M46.08-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q4.536 5.688 4.536 12.924 0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842q0-7.236 4.536-12.924l-1.872-1.908-3.636 3.996q-.324.36-.792.378t-.828-.27l-1.728-1.584q-.36-.288-.378-.774t.306-.846l3.78-4.14-3.996-4.032v4.824q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-10.368q0-.936.684-1.62t1.62-.684h10.368q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-4.788l3.816 3.852 3.096-3.384q.324-.36.792-.378t.828.27l1.728 1.584q.36.288.378.774t-.306.846l-3.24 3.564 2.052 2.016q5.688-4.536 12.924-4.536t12.924 4.536l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-16.128 44.928q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"VENUS_DOUBLE": "M64.44-45.395q.432 5.58-1.89 10.512t-6.696 8.064-9.774 3.708v9.36h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-18.432v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-9.36q-5.4-.576-9.774-3.708t-6.696-8.064-1.89-10.512q.612-7.416 5.922-12.834t12.69-6.102q7.416-.756 13.572 3.384 6.156-4.14 13.572-3.384 7.38.684 12.69 6.102t5.922 12.834zm-32.184 12.96q4.608-4.716 4.608-11.268t-4.608-11.268q-4.608 4.716-4.608 11.268t4.608 11.268zm-11.52 4.86q4.14 0 7.848-2.052-5.544-5.94-5.544-14.076 0-8.064 5.544-14.076-3.708-2.052-7.848-2.052-6.66 0-11.394 4.734t-4.734 11.394 4.734 11.394 11.394 4.734zm20.736 13.824v-9.36q-4.932-.54-9.216-3.384-4.284 2.844-9.216 3.384v9.36h18.432zm2.304-13.824q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734q-4.14 0-7.848 2.052 5.544 6.012 5.544 14.076 0 8.136-5.544 14.076 3.708 2.052 7.848 2.052z",
		"MARS_DOUBLE": "M55.296-49.463q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.736 3.42 3.87 7.704t.342 8.892q-1.116 6.552-5.976 11.232t-11.448 5.616q-7.56 1.044-13.842-2.88t-8.694-10.8q-4.212-.216-7.956-2.07t-6.39-4.788-4.086-6.93-1.152-8.28q.324-4.86 2.808-9.072t6.552-6.894 8.928-3.222q4.248-.504 8.19.684t7.146 3.708l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.124 2.664 3.348 6.084 6.552.324 11.808 4.464l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-18.432 14.976q0-.72-.144-2.088-5.832.9-9.756 5.4t-3.924 10.512q0 .72.144 2.088 5.832-.9 9.756-5.4t3.924-10.512zm-32.256 0q0 6.048 3.996 10.584t9.936 5.364q-.108-1.044-.108-2.124 0-7.56 4.86-13.302t12.168-7.074q-1.908-4.32-5.886-6.948t-8.838-2.628q-6.66 0-11.394 4.734t-4.734 11.394zm34.56 29.952q6.66 0 11.394-4.734t4.734-11.394q0-6.048-3.996-10.584t-9.936-5.364q.108 1.044.108 2.124 0 7.56-4.86 13.302t-12.168 7.074q1.908 4.32 5.886 6.948t8.838 2.628z",
		"VENUS_MARS": "M59.904-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.736 3.42 3.87 7.704t.342 8.892q-1.152 6.48-5.922 11.16t-11.286 5.652q-8.028 1.224-14.724-3.24-4.212 2.808-9.216 3.348v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-5.58-.612-10.062-3.942t-6.732-8.55-1.422-11.052q.9-6.732 5.742-11.61t11.538-5.922q8.064-1.224 14.76 3.24 5.256-3.492 11.52-3.492 7.236 0 12.924 4.536l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-27.648 40.068q4.608-4.716 4.608-11.268t-4.608-11.268q-4.608 4.716-4.608 11.268t4.608 11.268zm-27.648-11.268q0 6.66 4.734 11.394t11.394 4.734q4.212 0 7.848-2.052-5.544-6.012-5.544-14.076t5.544-14.076q-3.636-2.052-7.848-2.052-6.66 0-11.394 4.734t-4.734 11.394zm39.168 16.128q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734q-4.212 0-7.848 2.052 5.544 6.012 5.544 14.076t-5.544 14.076q3.636 2.052 7.848 2.052z",
		"MARS_STROKE": "M52.992-59.831q.936 0 1.62.684t.684 1.62v14.976q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-9.432l-7.668 7.704 5.04 5.04q.324.36.324.828t-.324.792l-1.656 1.656q-.324.324-.792.324t-.828-.324l-5.04-5.076-2.808 2.844q4.536 5.616 4.536 12.924 0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638q7.308 0 12.924 4.536l2.808-2.808-6.192-6.192q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l6.192 6.192 7.668-7.668h-9.396q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h14.976zm-32.256 50.688q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"MARS_STROKE_V": "M23.04-41.255q7.812.864 13.122 6.75t5.31 13.842q0 6.012-3.132 11.016t-8.496 7.632-11.484 1.944q-4.788-.54-8.838-3.168t-6.552-6.768-2.898-8.964q-.432-5.58 1.89-10.512t6.696-8.064 9.774-3.708v-4.752h-5.76q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h5.76v-5.94l-3.312 3.312q-.36.324-.828.324t-.792-.324l-1.656-1.656q-.324-.324-.324-.792t.324-.828l7.272-7.236q.684-.684 1.62-.684t1.62.684l7.272 7.236q.324.36.324.828t-.324.792l-1.656 1.656q-.324.324-.792.324t-.828-.324l-3.312-3.312v5.94h5.76q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-5.76v4.752zm-2.304 36.72q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"MARS_STROKE_H": "M68.436-31.499q.684.684.684 1.62t-.684 1.62l-10.584 10.584q-.324.36-.81.36t-.81-.36l-1.62-1.62q-.36-.324-.36-.81t.36-.81l6.66-6.66h-10.584v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-4.752q-.864 7.812-6.75 13.122t-13.842 5.31q-6.012 0-11.016-3.132t-7.632-8.496-1.944-11.484q.54-4.788 3.168-8.838t6.768-6.552 8.964-2.898q5.58-.432 10.512 1.89t8.064 6.696 3.708 9.774h4.752v-8.064q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v8.064h10.584l-6.66-6.66q-.36-.324-.36-.81t.36-.81l1.62-1.62q.324-.36.81-.36t.81.36zm-47.7 17.748q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"NEUTER": "M41.472-43.703q0 7.956-5.31 13.842t-13.122 6.75v22.032q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-22.032q-7.812-.864-13.122-6.75t-5.31-13.842q0-4.212 1.638-8.046t4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046zm-20.736 16.128q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z",
		"GENDERLESS": "M36.864-29.879q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm4.608 0q0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046z",
		"FACEBOOK_OFFICIAL": "M52.236-59.831q1.26 0 2.16.9t.9 2.16v49.176q0 1.26-.9 2.16t-2.16.9h-14.076v-21.42h7.164l1.08-8.352h-8.244v-5.328q0-2.016.846-3.024t3.294-1.008l4.392-.036v-7.452q-2.268-.324-6.408-.324-4.896 0-7.83 2.88t-2.934 8.136v6.156h-7.2v8.352h7.2v21.42h-26.46q-1.26 0-2.16-.9t-.9-2.16v-49.176q0-1.26.9-2.16t2.16-.9h49.176z",
		"PINTEREST_P": "M0-42.947q0-3.888 1.35-7.326t3.726-5.994 5.472-4.428 6.66-2.808 7.272-.936q5.688 0 10.584 2.394t7.956 6.966 3.06 10.332q0 3.456-.684 6.768t-2.16 6.372-3.6 5.382-5.22 3.708-6.804 1.386q-2.448 0-4.86-1.152t-3.456-3.168q-.36 1.404-1.008 4.05t-.846 3.42-.738 2.556-.936 2.556-1.152 2.25-1.656 2.79-2.232 3.114l-.504.18-.324-.36q-.54-5.652-.54-6.768 0-3.312.774-7.434t2.394-10.35 1.872-7.308q-1.152-2.34-1.152-6.084 0-2.988 1.872-5.616t4.752-2.628q2.196 0 3.42 1.458t1.224 3.69q0 2.376-1.584 6.876t-1.584 6.732q0 2.268 1.62 3.762t3.924 1.494q1.98 0 3.672-.9t2.826-2.448 2.016-3.42 1.368-3.978.72-3.996.234-3.582q0-6.228-3.942-9.702t-10.278-3.474q-7.2 0-12.024 4.662t-4.824 11.826q0 1.584.45 3.06t.972 2.34.972 1.638.45 1.098q0 1.008-.54 2.628t-1.332 1.62q-.072 0-.612-.108-1.836-.54-3.258-2.016t-2.196-3.402-1.17-3.888-.396-3.834z",
		"WHATSAPP": "M35.46-29.375q.468 0 3.51 1.584t3.222 1.908q.072.18.072.54 0 1.188-.612 2.736-.576 1.404-2.556 2.358t-3.672.954q-2.052 0-6.84-2.232-3.528-1.62-6.12-4.248t-5.328-6.66q-2.592-3.852-2.556-6.984v-.288q.108-3.276 2.664-5.688.864-.792 1.872-.792.216 0 .648.054t.684.054q.684 0 .954.234t.558.99q.288.72 1.188 3.168t.9 2.7q0 .756-1.242 2.07t-1.242 1.674q0 .252.18.54 1.224 2.628 3.672 4.932 2.016 1.908 5.436 3.636.432.252.792.252.54 0 1.944-1.746t1.872-1.746zm-7.308 19.08q4.572 0 8.766-1.8t7.218-4.824 4.824-7.218 1.8-8.766-1.8-8.766-4.824-7.218-7.218-4.824-8.766-1.8-8.766 1.8-7.218 4.824-4.824 7.218-1.8 8.766q0 7.308 4.32 13.248l-2.844 8.388 8.712-2.772q5.688 3.744 12.42 3.744zm0-49.752q5.508 0 10.53 2.16t8.658 5.796 5.796 8.658 2.16 10.53-2.16 10.53-5.796 8.658-8.658 5.796-10.53 2.16q-7.02 0-13.14-3.384l-15.012 4.824 4.896-14.58q-3.888-6.408-3.888-14.004 0-5.508 2.16-10.53t5.796-8.658 8.658-5.796 10.53-2.16z",
		"SERVER": "M4.608-13.751h36.864v-4.608h-36.864v4.608zm0-18.432h36.864v-4.608h-36.864v4.608zm56.448 16.128q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm-56.448-34.56h36.864v-4.608h-36.864v4.608zm56.448 16.128q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm0-18.432q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm3.456 29.952v13.824h-64.512v-13.824h64.512zm0-18.432v13.824h-64.512v-13.824h64.512zm0-18.432v13.824h-64.512v-13.824h64.512z",
		"USER_PLUS": "M25.344-32.183q-5.724 0-9.774-4.05t-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774-4.05 9.774-9.774 4.05zm34.56 4.608h12.672q.468 0 .81.342t.342.81v6.912q0 .468-.342.81t-.81.342h-12.672v12.672q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-12.672h-12.672q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h12.672v-12.672q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81v12.672zm-26.496 8.064q0 1.872 1.368 3.24t3.24 1.368h9.216v8.568q-2.448 1.8-6.156 1.8h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.684 0 1.404.612 2.844 2.196 5.562 3.294t5.922 1.098 5.922-1.098 5.562-3.294q.72-.612 1.404-.612 4.752 0 7.812 3.456h-8.028q-1.872 0-3.24 1.368t-1.368 3.24v6.912z",
		"USER_TIMES": "M25.344-32.183q-5.724 0-9.774-4.05t-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774-4.05 9.774-9.774 4.05zm38.772 11.52l8.964 8.964q.324.324.324.828 0 .468-.324.792l-4.896 4.896q-.324.324-.792.324-.504 0-.828-.324l-8.964-8.964-8.964 8.964q-.324.324-.828.324-.468 0-.792-.324l-4.896-4.896q-.324-.324-.324-.792 0-.504.324-.828l8.964-8.964-8.964-8.964q-.324-.324-.324-.828 0-.468.324-.792l4.896-4.896q.324-.324.792-.324.504 0 .828.324l8.964 8.964 8.964-8.964q.324-.324.828-.324.468 0 .792.324l4.896 4.896q.324.324.324.792 0 .504-.324.828zm-17.928 0l-6.516 6.516q-1.332 1.332-1.332 3.276 0 1.908 1.332 3.24l2.988 2.988q-.756.108-1.584.108h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.684 0 1.404.612 5.544 4.392 11.484 4.392t11.484-4.392q.72-.612 1.404-.612 1.008 0 2.052.216-1.008.972-1.476 1.8t-.468 2.016q0 1.944 1.332 3.276z",
		"HOTEL": "M9.216-27.575h62.208q.936 0 1.62.684t.684 1.62v16.128h-9.216v-9.216h-55.296v9.216h-9.216v-43.776q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v25.344zm20.736-11.52q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm43.776 9.216v-2.304q0-5.724-4.05-9.774t-9.774-4.05h-25.344q-.936 0-1.62.684t-.684 1.62v13.824h41.472z",
		"VIACOIN": "M55.296-64.439l-6.912 16.128h6.912v6.912h-9.864l-1.98 4.608h11.844v6.912h-14.796l-12.852 29.952-12.852-29.952h-14.796v-6.912h11.844l-1.98-4.608h-9.864v-6.912h6.912l-6.912-16.128h9.216l11.628 27.648h13.608l11.628-27.648h9.216zm-27.648 43.776l3.888-9.216h-7.776z",
		"TRAIN": "M39.168-64.439q6.66 0 11.394 3.366t4.734 8.154v32.256q0 4.68-4.518 7.992t-10.998 3.492l7.668 7.272q.576.54.288 1.26t-1.08.72h-38.016q-.792 0-1.08-.72t.288-1.26l7.668-7.272q-6.48-.18-10.998-3.492t-4.518-7.992v-32.256q0-4.788 4.734-8.154t11.394-3.366h23.04zm-11.52 48.384q2.88 0 4.896-2.016t2.016-4.896-2.016-4.896-4.896-2.016-4.896 2.016-2.016 4.896 2.016 4.896 4.896 2.016zm20.736-20.736v-18.432h-41.472v18.432h41.472z",
		"SUBWAY": "M39.168-64.439q6.66 0 11.394 3.366t4.734 8.154v32.256q0 4.68-4.518 7.992t-10.998 3.492l7.668 7.272q.576.54.288 1.26t-1.08.72h-38.016q-.792 0-1.08-.72t.288-1.26l7.668-7.272q-6.48-.18-10.998-3.492t-4.518-7.992v-32.256q0-4.788 4.734-8.154t11.394-3.366h23.04zm-28.8 47.232q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm14.976-19.584v-18.432h-19.584v18.432h19.584zm19.584 19.584q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm5.76-19.584v-18.432h-20.736v18.432h20.736z",
		"MEDIUM": "M21.492-49.283v42.228q0 .9-.45 1.53t-1.314.63q-.612 0-1.188-.288l-16.74-8.388q-.756-.36-1.278-1.206t-.522-1.674v-41.04q0-.72.36-1.224t1.044-.504q.504 0 1.584.54l18.396 9.216q.108.108.108.18zm2.304 3.636l19.224 31.176-19.224-9.576v-21.6zm40.716.648v37.944q0 .9-.504 1.458t-1.368.558-1.692-.468l-15.876-7.92zm-.108-4.32q0 .108-9.234 15.102t-10.818 17.55l-14.04-22.824 11.664-18.972q.612-1.008 1.872-1.008.504 0 .936.216l19.476 9.72q.144.072.144.216z",
		"YC": "M29.124-28.295l9.576-17.964h-4.032l-5.652 11.232q-.864 1.728-1.584 3.312l-1.512-3.312-5.58-11.232h-4.32l9.468 17.748v11.664h3.636v-11.448zm26.172-31.536v55.296h-55.296v-55.296h55.296z",
		"OPTIN_MONSTER": "M17.208-4.139q-.288.576-.972 1.242t-1.332.918q-.9.324-1.854-.126t-1.026-1.134q-.036-.792 1.44-1.98t2.448-1.368q.828-.144 1.224.774t.072 1.674zm48.276 0q.252.576.936 1.242t1.368.918q.9.324 1.854-.126t.99-1.134q.072-.792-1.422-1.98t-2.466-1.368q-.792-.144-1.188.774t-.072 1.674zm1.728-3.924q.468.972 2.034 2.142t2.79 1.494q1.62.468 2.952-.162t1.332-1.818q0-1.656-2.43-3.618t-4.158-2.142q-1.44-.18-2.286 1.35t-.234 2.754zm-51.804 0q-.468.972-2.016 2.142t-2.772 1.494q-1.62.468-2.952-.162t-1.332-1.818q0-1.656 2.43-3.618t4.158-2.142q1.44-.18 2.268 1.35t.216 2.754zm26.28-40.464h.036q-1.476 0-2.736.54.972.288 1.584 1.098t.612 1.782q0 1.26-.972 2.16t-2.34.9q-1.872 0-2.88-1.548-.18.828-.18 1.512 0 2.664 2.016 4.554t4.86 1.89q2.88 0 4.896-1.89t2.016-4.554-2.016-4.554-4.896-1.89zm10.944-7.848q-3.564-3.924-7.938-4.734t-8.838 1.602q.972-2.16 2.97-3.474t4.248-1.422 4.374.612 3.582 2.682 1.602 4.734zm27 44.604q.288.396-.396 1.512.252.828.252 1.44.036 2.016-1.602 4.05t-3.942 3.294-4.248 1.332q-1.728.072-3.312-.774t-2.376-2.358q-24.732.9-45.324 0-.828 1.476-2.394 2.34t-3.33.792q-3.096-.108-6.462-2.898t-3.33-5.778q.072-.792.252-1.44-.684-1.116-.396-1.512.216-.36 1.116-.036.504-.792 1.476-1.836-.252-1.044.072-1.368.396-.36 1.404.144 1.044-.72 2.124-1.224 0-1.044.468-1.332.828-.432 1.836.576 1.26-.18 2.196.072.648.144 1.368.684v-2.628q-.396 0-.648-.072-1.908-.36-3.492-1.602t-1.98-3.15q-.324-1.368 0-2.916.54-2.232 3.348-3.42.072-.612.684-1.278t1.296-.846 1.188.27.684 1.098h.468q1.656.18 2.16.828.108.108.18.252.36-.036 1.098-.126t1.098-.126q-.54-.396-1.08-.612-.828-1.44-3.276-1.548 0-.216.036-.36-2.232-.072-4.266-.666t-3.042-1.71q-1.152-1.296-1.53-3.312t-.09-4.032q.576-4.536 3.24-6.444.828-.576 1.872-.162t1.152 1.458l.054.504.09.756.108.72.198.684.306.36q.972.504 2.736.432 1.728-1.656 3.528-2.664-1.44-.144-5.832.504l1.692-1.656q2.196-2.088 5.868-3.996 5.22-2.628 10.152-3.096-.72-.288-1.476-.558t-1.692-.504-1.53-.378-1.71-.396-1.548-.36q21.42-4.536 32.544 5.004 3.528 3.024 5.688 7.992 3.06.36 4.356-.324h.036q.18-.108.306-.36t.198-.684.108-.702.108-.774l.036-.504q.108-1.008 1.152-1.44t1.872.18q2.628 1.872 3.276 6.408.252 2.052-.126 4.068t-1.53 3.276q-1.008 1.152-3.006 1.746t-4.158.666v.36q-2.556.072-3.42 1.548-.504.18-1.116.612.396.036 1.152.126t1.08.126q.036-.144.18-.288.576-.648 2.16-.828h.468q.18-.648.684-1.08t1.188-.288 1.296.828.684 1.296q2.844 1.152 3.348 3.42.324 1.44.036 2.916-.432 1.908-2.016 3.168t-3.492 1.584q-.36.072-.612.072 0 1.764-.036 2.628.72-.54 1.368-.684.936-.252 2.196-.072 1.008-1.008 1.836-.576.504.324.504 1.332 1.188.576 2.124 1.224.972-.468 1.368-.144.36.36.072 1.368 1.008 1.08 1.476 1.836.828-.288 1.116.036zm-9.9-34.272q0 1.044-.324 1.944 2.952 1.152 4.032 4.752.144-1.332-.342-3.546t-1.494-3.258q-.72-.684-1.296-.612t-.576.72zm-2.808 3.6q1.26 1.512 1.71 3.906t-.018 4.482q2.412-.468 3.492-1.62.468-.504.648-1.008-.108-2.304-1.116-4.122t-2.844-2.394q-.54.54-1.872.756zm-1.332.144q-1.08 0-1.584-.036 1.512 4.14 1.908 8.604.756 0 1.548-.108.576-2.448.036-4.86t-1.908-3.6zm-56.304 2.952q1.08-3.6 4.032-4.752-.324-.9-.324-1.944 0-.648-.594-.72t-1.278.612q-1.008 1.044-1.494 3.258t-.342 3.546zm1.296 3.672q1.044 1.116 3.492 1.62-.468-2.088-.018-4.482t1.71-3.906q-1.332-.216-1.872-.756-1.836.576-2.826 2.376t-1.134 4.14q.324.612.648 1.008zm6.372 1.944q.504-4.464 2.628-8.46-.684.144-1.98.648l-1.62.684v-.036q-1.656 3.204-.72 7.056.9.108 1.692.108zm34.668 1.404q.288 1.368.594 3.906t.414 3.222q.108.648.342.774t.846-.162q1.44-.72 2.232-3.078t.828-4.518q-.864-.072-5.256-.144zm-10.152-23.076q-4.176 0-7.164 2.97t-2.988 7.146q0 4.212 2.988 7.182t7.164 2.97 7.164-2.97 2.988-7.182q0-4.176-2.988-7.146t-7.164-2.97zm8.208 23.004q-3.816-.072-7.596 0v-.036q-.036.972.09 3.096t.486 2.376q1.044.504 3.366.522t3.438-.378q.324-.108.396-1.404t-.018-2.502-.162-1.674zm-9.648 7.164q.288-.144.342-1.728t-.018-3.168-.144-2.268v-.036q-7.632.108-7.704.108-.144.72-.252 2.232t0 2.988.504 1.656q1.224.54 3.636.576t3.636-.36zm-14.184-6.804q-.576 2.124.162 4.266t2.79 3.042q.54.288.864.18t.432-.756q.108-.576.288-3.24t.36-3.708q-2.484.072-4.896.216zm-4.572 4.536q.108.828-1.224 1.296 4.752 5.076 9.774 8.64t10.998 5.544q6.192-1.764 11.178-5.256t10.566-9q-1.188-.468-1.08-1.224l.108-.324v0q-.612-.072-1.8-.198t-1.728-.162q-.936 3.24-2.952 4.752-1.836 1.368-2.952-.036-.18-.216-.324-.504-.252-.468-.612-2.232-.072.18-.18.324t-.27.252-.288.198-.342.144l-.36.09-.432.072-.432.054-.486.036-.486.018q-3.816.324-5.868-.396-.144.612-.36.954t-.756.54-.828.252-1.296.126l-.108.018-.108.018h-.108q-6.444.612-7.308-1.44-.072 2.268-2.016 1.944-1.692-.288-3.276-1.944-.432-.468-.72-.936-.612-1.044-.936-2.34-2.088.216-3.132.36l.144.36zm-3.024 22.608q.108-.504.108-1.08-.612-2.556-1.836-4.68t-2.628-2.52q-1.476-.432-3.654.522t-3.762 2.88-1.404 3.87q1.26 1.908 3.6 3.348t4.284 1.512q1.836.072 3.384-1.008t1.908-2.844zm.108-6.156q.828 2.268.972 4.284 7.02-4.068 14.112-6.264-3.528-1.872-6.498-4.32t-6.462-5.94q-.216.144-1.044.468l-.036.18-.036.144q1.116.648.792 1.332-.432.828-2.016 1.224-.36.468-1.044.864h-.036q-.072 2.988.036 5.4.684 1.224 1.26 2.628zm2.484 5.976q19.152.756 41.22 0-9.144-5.292-15.408-7.056-2.736 1.26-5.616 2.052-.288.108-.576 0-2.34-.756-4.644-1.764-7.488 2.16-14.976 6.768h-.036v.036l.036-.036zm42.624-1.656q.144-1.944 1.008-4.32.504-1.368 1.188-2.556l-.036.036q.108-2.772.108-5.508-.54-.288-1.08-.9-1.512-.324-2.016-1.188-.324-.72.792-1.368-.072-.144-.072-.324-.576-.144-1.008-.432-7.344 6.84-13.788 10.224 7.128 2.124 14.904 6.336zm14.112.828q.18-1.944-1.404-3.87t-3.744-2.88-3.672-.522q-1.368.396-2.61 2.538t-1.854 4.662q0 .576.108 1.08.36 1.764 1.908 2.844t3.384 1.008q1.944-.072 4.284-1.512t3.6-3.348z",
		"OPENCART": "M54.864-8.243q0 2.448-1.728 4.176t-4.176 1.728-4.194-1.728-1.746-4.176 1.746-4.194 4.194-1.746 4.176 1.746 1.728 4.194zm-26.964 0q0 2.448-1.746 4.176t-4.194 1.728-4.176-1.728-1.728-4.176 1.728-4.194 4.176-1.746 4.194 1.746 1.746 4.194zm-27.9-53.784q2.052 2.16 3.978 3.762t4.356 2.952 4.896 2.268 5.976 1.638 7.2 1.134 9 .666 10.944.342 13.41.09q5.004 0 8.802.18t6.516.594 4.464.99 2.556 1.422.864 1.854-.702 2.304-2.034 2.754-3.222 3.276-4.176 3.762-5.004 4.284q-6.66 5.652-10.296 8.892 1.044-1.836 2.754-3.924t3.384-3.798 3.402-3.546 2.988-3.294 1.944-2.898.468-2.52-1.638-1.998-4.194-1.476-7.344-.846-10.944-.18q-6.048.072-11.304-.216t-9.216-.828-7.362-1.476-5.742-1.854-4.41-2.25-3.294-2.394-2.448-2.574-1.818-2.502-1.44-2.448-1.314-2.142z",
		"EXPEDITEDSSL": "M32.256-62.135q-6.084 0-11.628 2.376t-9.558 6.39-6.39 9.558-2.376 11.628 2.376 11.628 6.39 9.558 9.558 6.39 11.628 2.376 11.628-2.376 9.558-6.39 6.39-9.558 2.376-11.628-2.376-11.628-6.39-9.558-9.558-6.39-11.628-2.376zm0-2.304q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm-14.4 29.952q.576 0 .576.576v17.28q0 .576-.576.576h-1.152q-.576 0-.576-.576v-17.28q0-.576.576-.576h1.152zm14.4 2.304q1.908 0 3.258 1.35t1.35 3.258q0 1.26-.63 2.304t-1.674 1.656v4.104q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.104q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35zm0-27.648q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm-12.672 17.28v3.456q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-3.456q0-3.348 2.358-5.706t5.706-2.358 5.706 2.358 2.358 5.706v3.456q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-3.456q0-5.256-3.708-8.964t-8.964-3.708-8.964 3.708-3.708 8.964zm31.104 26.496v-18.432q0-.936-.684-1.62t-1.62-.684h-32.256q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h32.256q.936 0 1.62-.684t.684-1.62z",
		"BATTERY_FULL": "M69.12-46.007v27.648h-59.904v-27.648h59.904zm4.608 20.736h4.608v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368zm9.216-13.824v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76q1.908 0 3.258 1.35t1.35 3.258z",
		"BATTERY_THREE_QUARTERS": "M9.216-18.359v-27.648h46.08v27.648h-46.08zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z",
		"BATTERY_HALF": "M9.216-18.359v-27.648h32.256v27.648h-32.256zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z",
		"BATTERY_QUARTER": "M9.216-18.359v-27.648h18.432v27.648h-18.432zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z",
		"BATTERY_EMPTY": "M78.336-43.703q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z",
		"MOUSE_POINTER": "M40.788-26.891q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-13.752l7.236 17.136q.36.9 0 1.764t-1.224 1.26l-6.372 2.7q-.9.36-1.764 0t-1.26-1.224l-6.876-16.272-11.232 11.232q-.684.684-1.62.684-.432 0-.864-.18-1.44-.612-1.44-2.124v-54.144q0-1.512 1.44-2.124.432-.18.864-.18.972 0 1.62.684z",
		"I_CURSOR": "M29.952-59.831q-11.52 0-11.52 8.064v14.976h4.608v4.608h-4.608v19.584q0 8.064 11.52 8.064h2.304v4.608h-2.304q-9.792 0-13.824-5.256-4.032 5.256-13.824 5.256h-2.304v-4.608h2.304q11.52 0 11.52-8.064v-19.584h-4.608v-4.608h4.608v-14.976q0-8.064-11.52-8.064h-2.304v-4.608h2.304q9.792 0 13.824 5.256 4.032-5.256 13.824-5.256h2.304v4.608h-2.304z",
		"OBJECT_GROUP": "M73.728-50.615h-4.608v36.864h4.608v13.824h-13.824v-4.608h-46.08v4.608h-13.824v-13.824h4.608v-36.864h-4.608v-13.824h13.824v4.608h46.08v-4.608h13.824v13.824zm-9.216-9.216v4.608h4.608v-4.608h-4.608zm-59.904 0v4.608h4.608v-4.608h-4.608zm4.608 55.296v-4.608h-4.608v4.608h4.608zm50.688-4.608v-4.608h4.608v-36.864h-4.608v-4.608h-46.08v4.608h-4.608v36.864h4.608v4.608h46.08zm9.216 4.608v-4.608h-4.608v4.608h4.608zm-23.04-36.864h13.824v27.648h-32.256v-9.216h-13.824v-27.648h32.256v9.216zm-27.648 13.824h23.04v-18.432h-23.04v18.432zm36.864 9.216v-18.432h-9.216v13.824h-13.824v4.608h23.04z",
		"OBJECT_UNGROUP": "M82.944-36.791h-4.608v23.04h4.608v13.824h-13.824v-4.608h-32.256v4.608h-13.824v-13.824h4.608v-4.608h-13.824v4.608h-13.824v-13.824h4.608v-23.04h-4.608v-13.824h13.824v4.608h32.256v-4.608h13.824v13.824h-4.608v4.608h13.824v-4.608h13.824v13.824zm-9.216-9.216v4.608h4.608v-4.608h-4.608zm-23.04-13.824v4.608h4.608v-4.608h-4.608zm-46.08 0v4.608h4.608v-4.608h-4.608zm4.608 41.472v-4.608h-4.608v4.608h4.608zm46.08-4.608h-4.608v4.608h4.608v-4.608zm-41.472 0h32.256v-4.608h4.608v-23.04h-4.608v-4.608h-32.256v4.608h-4.608v23.04h4.608v4.608zm18.432 18.432v-4.608h-4.608v4.608h4.608zm46.08 0v-4.608h-4.608v4.608h4.608zm-4.608-9.216v-23.04h-4.608v-4.608h-13.824v13.824h4.608v13.824h-13.824v-4.608h-13.824v4.608h4.608v4.608h32.256v-4.608h4.608z",
		"STICKY_NOTE": "M36.864-19.511v14.976h-33.408q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h48.384q1.44 0 2.448 1.008t1.008 2.448v33.408h-14.976q-1.44 0-2.448 1.008t-1.008 2.448zm4.608 1.152h13.716q-.54 2.952-2.34 4.752l-6.624 6.624q-1.8 1.8-4.752 2.34v-13.716z",
		"STICKY_NOTE_O": "M50.4-18.359h-8.928v8.928q1.044-.36 1.476-.792l6.66-6.66q.432-.432.792-1.476zm-10.08-4.608h10.368v-32.256h-46.08v46.08h32.256v-10.368q0-1.44 1.008-2.448t2.448-1.008zm14.976-33.408v36.864q0 1.44-.72 3.168t-1.728 2.736l-6.624 6.624q-1.008 1.008-2.736 1.728t-3.168.72h-36.864q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h48.384q1.44 0 2.448 1.008t1.008 2.448z",
		"CC_JCB": "M70.236-28.511q0 .936-.558 1.602t-1.386.846q-.288.072-.648.072h-5.508v-5.04h5.508q.36 0 .648.072.828.18 1.386.846t.558 1.602zm-.648-7.668q0 .9-.54 1.512t-1.368.756q-.108.036-.54.036h-5.004v-4.644h5.004l.306.018.234.018q.828.144 1.368.774t.54 1.53zm-43.38 5.904v-11.088h-8.208v11.088q0 2.088-1.368 3.402t-3.78 1.314q-3.888 0-8.244-2.124v4.032q1.908.54 4.356.828t3.924.324l1.512.036q11.808 0 11.808-7.812zm25.704 6.624v-4.068q-3.564 1.872-7.2 2.124-3.888.288-6.084-1.476t-2.196-5.112 2.196-5.112 6.084-1.476q3.636.252 7.2 2.088v-4.032q-1.728-.432-3.6-.702t-2.88-.342l-1.008-.072q-4.572-.216-7.866.504t-5.058 2.16-2.556 3.168-.792 3.816.792 3.816 2.556 3.168 5.058 2.16 7.866.504q3.636-.144 7.488-1.116zm26.424-4.14q0-1.944-1.548-3.186t-3.924-1.422v-.108q2.052-.288 3.204-1.494t1.152-2.862q0-1.98-1.476-3.168t-3.852-1.296l-.432-.018-.504-.018h-16.38v18.36h17.676q2.664 0 4.374-1.314t1.71-3.474zm4.608-27.432v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"CC_DINERS_CLUB": "M30.888-19.763v-24.948q-3.816 1.476-6.192 4.878t-2.376 7.614 2.376 7.614 6.192 4.842zm18.144-12.456q0-4.212-2.376-7.614t-6.192-4.878v24.984q3.816-1.476 6.192-4.878t2.376-7.614zm7.74 0q0 5.724-2.826 10.584t-7.686 7.686-10.584 2.826q-4.284 0-8.19-1.674t-6.732-4.5-4.5-6.732-1.674-8.19q0-5.724 2.826-10.584t7.686-7.686 10.584-2.826 10.584 2.826 7.686 7.686 2.826 10.584zm13.788.252q0-5.004-1.998-9.414t-5.31-7.398-7.686-4.716-9.09-1.728h-10.836q-6.336 0-11.646 2.916t-8.46 8.28-3.15 12.06q0 6.156 3.132 11.43t8.496 8.334 11.628 3.06h10.836q4.644 0 9.054-1.818t7.722-4.86 5.31-7.29 1.998-8.856zm12.384-23.256v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z",
		"CLONE": "M59.904-5.687v-39.168q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81v39.168q0 .468.342.81t.81.342h39.168q.468 0 .81-.342t.342-.81zm4.608-39.168v39.168q0 2.376-1.692 4.068t-4.068 1.692h-39.168q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068zm-13.824-13.824v5.76h-4.608v-5.76q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81v39.168q0 .468.342.81t.81.342h5.76v4.608h-5.76q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068z",
		"BALANCE_SCALE": "M62.208-48.311l-13.824 25.344h27.648zm-46.08 0l-13.824 25.344h27.648zm29.556-6.912q-.504 1.44-1.638 2.574t-2.574 1.638v46.476h21.888q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-48.384q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h21.888v-46.476q-1.44-.504-2.574-1.638t-1.638-2.574h-17.676q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h17.676q.756-2.052 2.52-3.33t3.996-1.278 3.996 1.278 2.52 3.33h17.676q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-17.676zm-6.516.576q1.188 0 2.034-.846t.846-2.034-.846-2.034-2.034-.846-2.034.846-.846 2.034.846 2.034 2.034.846zm39.168 31.68q0 2.628-1.674 4.716t-4.23 3.276-5.202 1.782-5.022.594-5.022-.594-5.202-1.782-4.23-3.276-1.674-4.716q0-.396 1.26-2.916t3.312-6.282 3.852-7.038 3.672-6.624 2.016-3.6q.648-1.188 2.016-1.188t2.016 1.188q.144.252 2.016 3.6t3.672 6.624 3.852 7.038 3.312 6.282 1.26 2.916zm-46.08 0q0 2.628-1.674 4.716t-4.23 3.276-5.202 1.782-5.022.594-5.022-.594-5.202-1.782-4.23-3.276-1.674-4.716q0-.396 1.26-2.916t3.312-6.282 3.852-7.038 3.672-6.624 2.016-3.6q.648-1.188 2.016-1.188t2.016 1.188q.144.252 2.016 3.6t3.672 6.624 3.852 7.038 3.312 6.282 1.26 2.916z",
		"HOURGLASS_O": "M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-19.224 25.488q2.772-1.044 5.364-3.33t4.662-5.49 3.33-7.56 1.26-9.108h-36.864q0 4.752 1.26 9.108t3.33 7.56 4.662 5.49 5.364 3.33q.684.252 1.098.846t.414 1.314-.414 1.314-1.098.846q-2.772 1.044-5.364 3.33t-4.662 5.49-3.33 7.56-1.26 9.108h36.864q0-4.752-1.26-9.108t-3.33-7.56-4.662-5.49-5.364-3.33q-.684-.252-1.098-.846t-.414-1.314.414-1.314 1.098-.846z",
		"HOURGLASS_START": "M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-4.608 0h-36.864q0 2.376.324 4.608h36.216q.324-2.196.324-4.608zm0 55.296q0-4.68-1.224-8.982t-3.258-7.488-4.554-5.472-5.256-3.402h-8.28q-2.736 1.116-5.256 3.402t-4.554 5.472-3.258 7.488-1.224 8.982h36.864z",
		"HOURGLASS_HALF": "M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-4.608 0h-36.864q0 7.416 3.06 13.824h30.744q3.06-6.408 3.06-13.824zm-2.052 43.776q-1.944-5.076-5.238-8.694t-7.002-5.13h-8.28q-3.708 1.512-7.002 5.13t-5.238 8.694h32.76z",
		"HOURGLASS_END": "M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-19.224 25.488q2.772-1.044 5.364-3.33t4.662-5.49 3.33-7.56 1.26-9.108h-36.864q0 4.752 1.26 9.108t3.33 7.56 4.662 5.49 5.364 3.33q.684.252 1.098.846t.414 1.314-.414 1.314-1.098.846q-4.932 1.836-8.784 7.056h25.2q-3.852-5.22-8.784-7.056-.684-.252-1.098-.846t-.414-1.314.414-1.314 1.098-.846z",
		"HOURGLASS": "M54.144-6.839q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h52.992zm-49.464-2.304q.108-1.98.576-3.852t1.08-3.42 1.656-3.132 1.926-2.736 2.322-2.502 2.376-2.16 2.538-1.98 2.394-1.71 2.34-1.548q-1.548-1.008-2.34-1.548t-2.394-1.71-2.538-1.98-2.376-2.16-2.322-2.502-1.926-2.736-1.656-3.132-1.08-3.42-.576-3.852h45.936q-.108 1.98-.576 3.852t-1.08 3.42-1.656 3.132-1.926 2.736-2.322 2.502-2.376 2.16-2.538 1.98-2.394 1.71-2.34 1.548q1.548 1.008 2.34 1.548t2.394 1.71 2.538 1.98 2.376 2.16 2.322 2.502 1.926 2.736 1.656 3.132 1.08 3.42.576 3.852h-45.936zm49.464-55.296q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h52.992z",
		"HAND_ROCK_O": "M27.648-50.615q-1.908 0-3.258 1.35t-1.35 3.258v4.608h-1.152v-3.348q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v15.444l-1.152-1.08v-6.192q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v8.064q0 1.692 1.26 2.952l11.16 10.656q1.404 1.404 1.404 3.672 0 .936.684 1.62t1.62.684h23.04q.936 0 1.62-.684t.684-1.62v-.9q0-1.476.36-2.772l3.888-15.696q.36-1.296.36-2.772v-8.856q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v1.152h-1.152v-4.5q0-1.44-.9-2.61t-2.304-1.458q-.504-.072-.828-.072-1.656 0-2.844 1.188t-1.188 2.844v4.608h-1.152v-4.392q0-1.836-1.17-3.222t-2.97-1.566q-.18-.036-.468-.036zm0-4.608q3.024 0 5.364 1.8 2.052-1.224 4.428-1.224 2.124 0 3.996.972t3.096 2.736q.972-.252 2.124-.252 3.6 0 6.12 2.574t2.52 6.174v8.856q0 1.836-.468 3.888l-3.924 15.696q-.216.864-.216 2.556 0 2.88-2.016 4.896t-4.896 2.016h-23.04q-3.024 0-4.968-2.106t-1.944-5.13l-11.088-10.656q-2.736-2.628-2.736-6.3v-8.064q0-3.564 2.538-6.102t6.102-2.538q.396 0 .576.036.216-3.42 2.718-5.76t5.922-2.34q1.872 0 3.528.756 2.592-2.484 6.264-2.484z",
		"HAND_STOP_O": "M31.68-59.831q-1.656 0-2.844 1.188t-1.188 2.844v23.616h-1.152v-19.008q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v28.223999999999997l-5.544-7.38q-1.368-1.836-3.672-1.836-1.908 0-3.258 1.35t-1.35 3.258q0 1.548.936 2.772l13.824 18.432q1.368 1.836 3.672 1.836h24.768q1.224 0 2.196-.792t1.224-2.016l2.736-14.58q.18-1.152.18-2.124v-17.928q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v9.792h-1.152v-19.008q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v19.008h-1.152v-23.616q0-1.656-1.188-2.844t-2.844-1.188zm0-4.608q2.448 0 4.518 1.278t3.186 3.474q.684-.144 1.512-.144 3.564 0 6.102 2.538t2.538 6.102v.612q3.78-.216 6.498 2.304t2.718 6.3v17.928q0 1.44-.288 2.988l-2.736 14.544q-.504 2.844-2.754 4.716t-5.166 1.872h-24.768q-2.16 0-4.122-.99t-3.258-2.682l-13.824-18.432q-1.836-2.448-1.836-5.544 0-3.816 2.7-6.516t6.516-2.7q2.808 0 4.608 1.224v-15.624q0-3.564 2.538-6.102t6.102-2.538q.828 0 1.512.144 1.116-2.196 3.186-3.474t4.518-1.278z",
		"HAND_SCISSORS_O": "M38.628-4.535h-6.372q-5.868 0-8.136-5.076-.828-1.764-.828-3.672v-.18q-2.232-1.08-3.546-3.186t-1.314-4.59q0-1.368.18-1.728h-9.396q-3.816 0-6.516-2.7t-2.7-6.516 2.7-6.516 6.516-2.7h4.068l-1.584-.612q-2.664-1.008-4.302-3.366t-1.638-5.238q0-3.816 2.7-6.516t6.516-2.7q1.656 0 3.276.612l22.608 8.604h14.436q3.816 0 6.516 2.7t2.7 6.516v24.048q0 3.168-1.944 5.67t-5.04 3.258l-12.204 3.06q-3.312.828-6.696.828zm-1.764-25.596l-5.58 2.556-5.868 2.664q-1.08.504-1.728 1.494t-.648 2.178q0 1.656 1.188 2.844t2.844 1.188q.936 0 1.656-.36l12.168-5.544q-1.764-.36-2.898-1.8t-1.134-3.24v-1.98zm11.52 11.196q0-1.656-1.188-2.844t-2.844-1.188q-.936 0-1.656.36l-10.44 4.752q-1.008.468-1.332.612t-1.098.612-1.062.846-.576 1.044-.288 1.458q0 1.8 1.134 2.952t2.934 1.152q.72 0 1.368-.324l12.672-5.76q1.08-.504 1.728-1.494t.648-2.178zm-8.352-27.072l-23.4-8.928q-.864-.288-1.656-.288-1.908 0-3.258 1.35t-1.35 3.258q0 1.44.81 2.628t2.142 1.692l18.936 7.2v2.304h-23.04q-1.908 0-3.258 1.35t-1.35 3.258 1.35 3.258 3.258 1.35h19.26l8.388-3.816v-7.128q0-2.268 1.656-3.816l3.996-3.672h-2.484zm-1.404 36.864q2.952 0 5.58-.684l12.204-3.06q1.548-.396 2.52-1.638t.972-2.826v-24.048q0-1.908-1.35-3.258t-3.258-1.35h-11.088l-4.896 4.536q-1.296 1.188-1.296 2.952v10.656q0 1.656 1.188 2.772t2.844 1.116 2.844-1.26 1.188-2.916v-7.488h1.152v7.488q0 2.52-2.052 4.104 1.872.288 3.114 1.746t1.242 3.366q0 1.512-.828 2.808t-2.196 1.908l-11.16 5.076h3.276z",
		"HAND_LIZARD_O": "M41.436-64.439q2.196 0 4.176 1.008t3.276 2.772l20.592 28.116q4.248 5.724 4.248 12.924v12.78q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-6.372l-10.296-5.148h-19.656q-2.88 0-4.896-2.016t-2.016-4.896v-1.152q0-4.284 3.042-7.326t7.326-3.042h15.12l1.512-4.608h-24.696q-3.6 0-6.246-2.43t-2.934-5.994q-2.34-2.844-2.34-6.552v-1.152q0-2.88 2.016-4.896t4.896-2.016h34.524zm27.684 57.6v-12.78q0-5.652-3.348-10.224l-20.628-28.116q-1.404-1.872-3.708-1.872h-34.524q-.936 0-1.62.684t-.684 1.62q0 1.152.054 1.782t.342 1.458.9 1.548q.36-1.116 1.278-1.8t2.034-.684h29.952v1.152h-29.952q-.936 0-1.62.684t-.684 1.62q0 1.584.108 2.088.288 1.584 1.584 2.628t2.916 1.044h26.316q1.44 0 2.448 1.008t1.008 2.448q0 .54-.18 1.08l-2.304 6.912q-.36 1.044-1.26 1.71t-2.016.666h-15.948q-2.376 0-4.068 1.692t-1.692 4.068v1.152q0 .936.684 1.62t1.62.684h20.196q.576 0 1.044.252l11.412 5.688q.864.468 1.386 1.296t.522 1.8v7.092q0 .936.684 1.62t1.62.684h13.824q.936 0 1.62-.684t.684-1.62z",
		"HAND_SPOCK_O": "M29.376-59.831q-1.728 0-2.862 1.224t-1.134 2.952q0 .504.108 1.008l5.4 22.464h-.936l-4.176-17.352q-.324-1.368-1.422-2.232t-2.502-.864q-1.692 0-2.844 1.224t-1.152 2.916q0 .396.144 1.044.108.468 1.404 5.796t2.448 10.152 1.152 4.968v8.172l-11.052-8.28q-1.224-.936-2.772-.936-1.872 0-3.222 1.314t-1.35 3.186q0 2.412 2.016 3.96l18.252 13.644q1.224.936 2.736.936h24.984q1.188 0 2.124-.738t1.224-1.89l3.6-14.436q.288-1.08.36-3.168t.324-3.096l4.176-17.208q.108-.432.108-.936 0-1.656-1.188-2.844t-2.88-1.188q-1.368 0-2.484.918t-1.44 2.25l-3.564 14.688h-.936l4.752-19.692q.108-.504.108-1.008 0-1.692-1.152-2.88t-2.88-1.188q-1.368 0-2.466.864t-1.422 2.232l-5.22 21.672h-4.572l-5.904-24.552q-.324-1.368-1.422-2.232t-2.466-.864zm23.22 59.904h-24.984q-3.06 0-5.508-1.836l-18.252-13.68q-1.8-1.368-2.826-3.384t-1.026-4.248q0-3.78 2.7-6.444t6.48-2.664q.9 0 1.782.198t1.494.396 1.476.738 1.26.828 1.386 1.062 1.35 1.026l-4.428-18.432q-.252-1.26-.252-2.124 0-3.348 2.16-5.832t5.472-2.844q.504-3.132 2.898-5.202t5.598-2.07q2.988 0 5.328 1.854t3.06 4.77l3.708 15.408 2.988-12.528q.72-2.916 3.06-4.77t5.328-1.854q3.132 0 5.49 1.944t2.97 5.004q3.348.36 5.58 2.808t2.232 5.796q0 1.08-.252 2.052l-4.176 17.172q-.18.792-.18 2.412 0 1.836-.468 3.888l-3.636 14.436q-.684 2.7-2.862 4.41t-4.95 1.71z",
		"HAND_POINTER_O": "M23.04-59.831q-1.908 0-3.258 1.35t-1.35 3.258v32.256l-5.436-7.272q-1.476-1.944-3.852-1.944-1.872 0-3.204 1.368t-1.332 3.24q0 1.548.936 2.772l13.824 18.432q1.368 1.836 3.672 1.836h25.848q.792 0 1.422-.486t.81-1.242l3.312-13.248q.864-3.456.864-6.984v-7.812q0-1.476-1.008-2.556t-2.448-1.08-2.448 1.008-1.008 2.448h-1.152v-2.196q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v2.304h-1.152v-3.24q0-1.98-1.332-3.402t-3.276-1.422q-1.908 0-3.258 1.35t-1.35 3.258v3.456h-1.152v-20.52q0-1.98-1.332-3.402t-3.276-1.422zm0-4.608q3.852 0 6.534 2.79t2.682 6.642v7.92q.792-.072 1.152-.072 3.564 0 6.228 2.484 1.692-.756 3.564-.756 4.068 0 6.624 3.132.972-.252 2.016-.252 3.384 0 5.724 2.43t2.34 5.814v7.812q0 4.176-1.008 8.1l-3.312 13.248q-.576 2.304-2.448 3.762t-4.248 1.458h-25.848q-2.16 0-4.122-.99t-3.258-2.682l-13.824-18.432q-1.836-2.448-1.836-5.544 0-3.78 2.682-6.498t6.462-2.718q2.556 0 4.68 1.26v-19.692q0-3.816 2.7-6.516t6.516-2.7zm4.608 50.688v-13.824h-1.152v13.824h1.152zm9.216 0v-13.824h-1.152v13.824h1.152zm9.216 0v-13.824h-1.152v13.824h1.152z",
		"HAND_PEACE_O": "M46.368-41.147q2.16 0 3.852.828 5.076 2.268 5.076 8.136v6.372q0 3.384-.828 6.696l-3.06 12.204q-.756 3.096-3.258 5.04t-5.67 1.944h-24.048q-3.816 0-6.516-2.7t-2.7-6.516v-14.436l-8.604-22.608q-.612-1.62-.612-3.276 0-3.816 2.7-6.516t6.516-2.7q2.88 0 5.238 1.638t3.366 4.302l.612 1.584v-4.068q0-3.816 2.7-6.516t6.516-2.7 6.516 2.7 2.7 6.516v9.396q.972-.18 1.728-.18 2.484 0 4.59 1.314t3.186 3.546zm-7.776-.252q-1.188 0-2.178.648t-1.494 1.728l-2.664 5.868-2.556 5.58h1.98q1.8 0 3.24 1.134t1.8 2.898l5.544-12.168q.36-.72.36-1.656 0-1.656-1.188-2.844t-2.844-1.188zm7.956 4.86q-.792 0-1.458.288t-1.044.576-.846 1.062-.612 1.098-.612 1.332l-4.752 10.44q-.36.72-.36 1.656 0 1.656 1.188 2.844t2.844 1.188q1.188 0 2.178-.648t1.494-1.728l5.76-12.672q.324-.648.324-1.368 0-1.8-1.152-2.934t-2.952-1.134zm-41.94-12.924q0 .792.288 1.656l8.928 23.4v2.484l3.672-3.996q1.548-1.656 3.816-1.656h7.128l3.816-8.388v-19.26q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258v23.04h-2.304l-7.2-18.936q-.504-1.332-1.692-2.142t-2.628-.81q-1.908 0-3.258 1.35t-1.35 3.258zm37.872 44.928q1.584 0 2.826-.972t1.638-2.52l3.06-12.204q.684-2.628.684-5.58v-3.276l-5.076 11.16q-.612 1.368-1.908 2.196t-2.808.828q-1.908 0-3.366-1.242t-1.746-3.114q-1.584 2.052-4.104 2.052h-7.488v-1.152h7.488q1.656 0 2.916-1.188t1.26-2.844-1.116-2.844-2.772-1.188h-10.656q-1.764 0-2.952 1.296l-4.536 4.896v11.088q0 1.908 1.35 3.258t3.258 1.35h24.048z",
		"TRADEMARK": "M30.852-44.855v4.212q0 .468-.342.792t-.81.324h-10.728v29.232q0 .468-.324.81t-.792.342h-4.86q-.468 0-.81-.324t-.342-.828v-29.232h-10.692q-.468 0-.81-.324t-.342-.792v-4.212q0-.504.324-.828t.828-.324h28.548q.468 0 .81.342t.342.81zm37.368-.108l2.772 34.596q.036.468-.288.864-.36.36-.828.36h-4.824q-.432 0-.756-.306t-.36-.738l-1.656-21.168-6.804 15.3q-.288.684-1.044.684h-4.32q-.72 0-1.044-.684l-6.768-15.372-1.62 21.24q-.036.432-.36.738t-.756.306h-4.86q-.468 0-.828-.36-.324-.36-.324-.864l2.808-34.596q.036-.432.36-.738t.756-.306h5.112q.72 0 1.044.684l7.92 18.72q.36.864.72 1.836.108-.252.342-.882t.378-.954l7.956-18.72q.324-.684 1.044-.684h5.076q.468 0 .792.306t.36.738z",
		"REGISTERED": "M37.512-39.131q0-3.168-2.16-4.356-1.188-.648-4.212-.648h-4.428v10.116h5.832q2.376 0 3.672-1.332t1.296-3.78zm1.872 10.26l7.38 13.428q.288.612-.036 1.116-.288.576-.972.576h-5.472q-.72 0-1.008-.612l-6.984-13.14h-5.58v12.6q0 .504-.324.828t-.828.324h-4.824q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h10.584q4.608 0 6.84.864 3.06 1.116 4.824 3.924t1.764 6.48q0 3.312-1.53 5.958t-4.158 3.942q.216.36.324.576zm-7.128-29.808q-5.4 0-10.296 2.106t-8.442 5.652-5.652 8.442-2.106 10.296 2.106 10.296 5.652 8.442 8.442 5.652 10.296 2.106 10.296-2.106 8.442-5.652 5.652-8.442 2.106-10.296-2.106-10.296-5.652-8.442-8.442-5.652-10.296-2.106zm32.256 26.496q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"CREATIVE_COMMONS": "M21.78-20.051q5.508 0 9.252-3.744.504-.648.108-1.296l-1.62-2.952q-.216-.468-.864-.612-.576-.072-.972.396l-.144.108q-.144.144-.414.36t-.63.468-.846.522-1.026.486-1.206.342-1.35.126q-2.736 0-4.5-1.8t-1.764-4.572q0-2.736 1.728-4.518t4.392-1.782q1.332 0 2.574.504t1.818 1.008l.576.504q.396.396.936.36.576-.072.864-.504l1.908-2.808q.468-.72-.072-1.404-.108-.144-.396-.432t-1.08-.846-1.746-1.008-2.43-.81-3.096-.36q-5.328 0-8.856 3.474t-3.528 8.658q0 5.256 3.492 8.694t8.892 3.438zm22.68 0q5.508 0 9.252-3.744.504-.648.144-1.296l-1.62-2.952q-.288-.504-.9-.612-.576-.072-.972.396l-.144.108q-.144.144-.414.36t-.63.468-.846.522-1.026.486-1.206.342-1.35.126q-2.736 0-4.5-1.8t-1.764-4.572q0-2.736 1.728-4.518t4.392-1.782q1.332 0 2.574.504t1.818 1.008l.576.504q.396.396.936.36.576-.072.864-.504l1.908-2.808q.468-.72-.072-1.404-.108-.144-.396-.432t-1.08-.846-1.746-1.008-2.43-.81-3.096-.36q-5.292 0-8.838 3.474t-3.546 8.658q0 5.256 3.492 8.694t8.892 3.438zm-12.204-38.628q-5.4 0-10.296 2.106t-8.442 5.652-5.652 8.442-2.106 10.296 2.106 10.296 5.652 8.442 8.442 5.652 10.296 2.106 10.296-2.106 8.442-5.652 5.652-8.442 2.106-10.296-2.106-10.296-5.652-8.442-8.442-5.652-10.296-2.106zm0-5.76q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556z",
		"GG": "M26.496-35.639l13.824 13.824-13.824 13.824-24.192-24.192 24.192-24.192 6.048 6.048-3.456 3.456-2.592-2.592-17.28 17.28 17.28 17.28 6.948-6.948-10.404-10.332zm20.736-20.736l24.192 24.192-24.192 24.192-6.048-6.048 3.456-3.456 2.592 2.592 17.28-17.28-17.28-17.28-6.948 6.948 10.404 10.332-3.456 3.456-13.824-13.824z",
		"GG_CIRCLE": "M25.812-15.695l9.756-9.756-10.044-10.044-3.168 3.168 6.912 6.876-3.456 3.456-10.044-10.044 10.044-10.044 1.44 1.44 3.132-3.132-4.572-4.608-16.344 16.344zm12.888-.288l16.344-16.344-16.344-16.344-9.756 9.756 10.044 10.044 3.168-3.168-6.912-6.876 3.456-3.456 10.044 10.044-10.044 10.044-1.44-1.44-3.132 3.168zm25.812-16.2q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"TRIPADVISOR": "M23.436-28.547q0 1.404-.99 2.394t-2.358.99q-1.404 0-2.394-.99t-.99-2.394q0-1.368.99-2.358t2.394-.99q1.368 0 2.358.99t.99 2.358zm41.544-.036q0 1.404-.99 2.394t-2.394.99-2.394-.99-.99-2.394.99-2.376 2.394-.972 2.394.972.99 2.376zm-37.44.036q0-2.844-2.034-4.896t-4.914-2.052-4.914 2.034-2.034 4.914 2.034 4.914 4.914 2.034 4.914-2.034 2.034-4.914zm41.508-.036q0-2.88-2.034-4.914t-4.914-2.034q-2.844 0-4.896 2.034t-2.052 4.914 2.034 4.914 4.914 2.034 4.914-2.034 2.034-4.914zm-38.448.036q0 4.176-2.934 7.11t-7.074 2.934q-4.176 0-7.11-2.952t-2.934-7.092 2.952-7.074 7.092-2.934 7.074 2.934 2.934 7.074zm41.544-.036q0 4.14-2.934 7.074t-7.11 2.934q-4.14 0-7.074-2.934t-2.934-7.074 2.934-7.074 7.074-2.934q4.176 0 7.11 2.934t2.934 7.074zm-34.704.108q0-6.876-4.878-11.754t-11.754-4.878q-4.5 0-8.316 2.232t-6.048 6.066-2.232 8.334 2.232 8.334 6.048 6.066 8.316 2.232q6.876 0 11.754-4.878t4.878-11.754zm24.048-20.628q-9.144-3.996-20.016-3.996-11.484 0-20.628 3.96 4.212 0 8.028 1.638t6.57 4.41 4.392 6.588 1.638 8.028q0-4.14 1.566-7.902t4.248-6.498 6.39-4.428 7.812-1.8zm17.244 20.628q0-6.876-4.86-11.754t-11.736-4.878-11.754 4.878-4.878 11.754 4.878 11.754 11.754 4.878 11.736-4.878 4.86-11.754zm-9.576-20.376h13.788q-1.584 1.836-2.7 4.122t-1.44 4.122q3.96 5.436 3.96 12.132 0 5.616-2.772 10.368t-7.524 7.506-10.332 2.754q-4.788 0-8.964-2.016t-7.056-5.58q-1.692 2.016-4.644 6.444-.396-.792-1.926-2.97t-2.682-3.51q-2.88 3.564-7.074 5.598t-8.982 2.034q-5.58 0-10.332-2.754t-7.524-7.506-2.772-10.368q0-6.696 3.96-12.132-.324-1.836-1.44-4.122t-2.7-4.122h13.14q5.364-3.6 12.78-5.634t15.552-2.034q8.064 0 15.156 2.016t12.528 5.652z",
		"ODNOKLASSNIKI": "M23.04-31.787q-6.768 0-11.556-4.788t-4.788-11.52q0-6.768 4.788-11.556t11.556-4.788 11.556 4.788 4.788 11.556q0 6.732-4.788 11.52t-11.556 4.788zm0-24.372q-3.312 0-5.67 2.358t-2.358 5.706q0 3.312 2.358 5.67t5.67 2.358 5.67-2.358 2.358-5.67q0-3.348-2.358-5.706t-5.67-2.358zm18.828 26.352q.468.972.54 1.782t-.162 1.458-.954 1.386-1.53 1.332-2.214 1.494q-4.14 2.628-11.34 3.384l2.628 2.592 9.612 9.612q1.08 1.116 1.08 2.664t-1.08 2.628l-.432.468q-1.116 1.08-2.664 1.08t-2.664-1.08q-2.412-2.448-9.612-9.648l-9.612 9.648q-1.116 1.08-2.664 1.08t-2.628-1.08l-.432-.468q-1.116-1.08-1.116-2.628t1.116-2.664l9.612-9.612 2.592-2.592q-7.308-.756-11.412-3.384-1.404-.9-2.214-1.494t-1.53-1.332-.954-1.386-.162-1.458.54-1.782q.36-.72 1.008-1.26t1.512-.792 2.016.072 2.34 1.26q.18.144.54.396t1.548.882 2.484 1.098 3.312.864 4.068.396q3.276 0 6.264-.918t4.32-1.818l1.368-.9q1.188-.936 2.34-1.26t2.016-.072 1.512.792 1.008 1.26z",
		"ODNOKLASSNIKI_SQUARE": "M33.372-43.559q0 2.376-1.674 4.05t-4.05 1.674-4.05-1.674-1.674-4.05 1.674-4.05 4.05-1.674 4.05 1.674 1.674 4.05zm7.704 13.068q-.36-.72-1.008-1.152t-1.71-.342-2.178.99q-.36.288-1.044.72t-2.916 1.152-4.572.72-4.464-.648-3.096-1.296l-.972-.648q-1.116-.9-2.178-.99t-1.71.342-1.008 1.152q-.792 1.62-.072 2.682t3.132 2.646q2.988 1.908 8.136 2.412l-1.836 1.872q-5.112 5.112-6.876 6.84-.792.792-.792 1.89t.792 1.89l.324.324q.792.792 1.89.792t1.89-.792l6.876-6.876q4.104 4.14 6.876 6.876.792.792 1.89.792t1.89-.792l.324-.324q.792-.792.792-1.89t-.792-1.89l-6.876-6.84-1.872-1.872q5.076-.504 8.1-2.412 2.412-1.584 3.132-2.646t-.072-2.682zm-1.764-13.068q0-4.824-3.42-8.244t-8.244-3.42-8.244 3.42-3.42 8.244 3.42 8.244 8.244 3.42 8.244-3.42 3.42-8.244zm15.984-5.904v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"GET_POCKET": "M56.34-59.831q2.34 0 3.96 1.638t1.62 3.978v18.684q0 6.336-2.448 12.096t-6.57 9.9-9.864 6.57-12.042 2.43q-6.336 0-12.078-2.43t-9.882-6.57-6.588-9.9-2.448-12.096v-18.684q0-2.304 1.656-3.96t3.96-1.656h50.724zm-25.344 38.304q1.692 0 2.952-1.188l14.544-13.968q1.332-1.26 1.332-3.06 0-1.764-1.242-3.006t-3.006-1.242q-1.692 0-2.952 1.188l-11.628 11.16-11.628-11.16q-1.26-1.188-2.916-1.188-1.764 0-3.006 1.242t-1.242 3.006q0 1.836 1.296 3.06l14.58 13.968q1.188 1.188 2.916 1.188z",
		"WIKIPEDIA_W": "M53.784-5.435l-10.62-25.02q-.9 1.764-5.706 10.998t-7.146 14.022q-.036.036-.99.018t-.954-.054q-2.952-6.948-9.198-21.132t-9.342-21.456q-.756-1.8-2.394-3.87t-3.726-3.618-3.672-1.548l-.018-.864-.018-.972h20.988v1.8q-1.404.072-2.862.576t-2.394 1.548-.36 2.304q.936 2.124 7.794 17.964t8.478 19.44q1.116-2.196 5.04-9.594t4.716-8.91q-.684-1.404-4.536-10.116t-4.896-10.62q-1.368-2.484-7.236-2.556v-1.8l18.468.036v1.692q-2.16.072-3.366.9t-.45 2.484q1.188 2.52 3.132 6.822t3.096 6.75q3.96-7.704 6.228-13.068.864-1.98-.36-2.862t-4.644-.954q.036-.252.036-.9v-.864q2.304 0 6.138-.018t6.48-.036 3.33-.018v1.764q-2.232.072-4.284 1.188t-3.24 2.916l-7.668 15.912q.468 1.188 4.59 10.44t4.374 9.864l15.876-36.612q-.504-1.368-1.782-2.25t-2.34-1.134-1.998-.288v-1.8l16.56.144.036.072-.036 1.584q-5.004.144-7.236 5.22-18.936 43.776-20.124 46.476h-1.764z",
		"SAFARI": "M34.164-32.291q0 .936-.594 1.62t-1.494.684q-.936 0-1.62-.594t-.684-1.494q0-.936.612-1.62t1.512-.684 1.584.594.684 1.494zm.54 2.088l12.6-20.916q-.324.288-2.43 2.25t-4.518 4.194-4.914 4.572-4.212 3.978-1.818 1.854l-12.564 20.88q.252-.252 2.412-2.232t4.536-4.194 4.896-4.572 4.212-3.996 1.8-1.818zm23.292-1.98q0 7.236-3.744 13.356-.108-.072-.612-.396t-.954-.594-.594-.27q-.468 0-.468.468 0 .36 2.124 1.584-2.664 4.032-6.642 6.858t-8.694 3.978l-.576-2.412q-.036-.36-.54-.36-.18 0-.288.198t-.072.342l.576 2.448q-2.592.54-5.256.54-7.164 0-13.392-3.78.036-.072.468-.738t.774-1.206.342-.684q0-.468-.468-.468-.216 0-.612.522t-.81 1.242-.486.828q-4.068-2.7-6.912-6.75t-3.96-8.802l2.484-.54q.36-.108.36-.54 0-.18-.198-.288t-.378-.072l-2.448.54q-.504-2.592-.504-5.004 0-7.416 3.924-13.644.072.036.666.432t1.08.684.63.288q.468 0 .468-.432 0-.216-.45-.558t-1.17-.774l-.72-.432q2.772-4.032 6.804-6.804t8.784-3.852l.54 2.412q.072.36.54.36.18 0 .288-.198t.072-.378l-.54-2.376q2.556-.468 4.824-.468 7.344 0 13.644 3.924-1.404 2.016-1.404 2.34 0 .468.432.468.396 0 1.728-2.304 3.996 2.7 6.75 6.696t3.87 8.676l-2.016.432q-.36.072-.36.576 0 .18.198.288t.342.072l2.052-.468q.504 2.592.504 5.04zm3.06 0q0-5.868-2.286-11.196t-6.138-9.18-9.18-6.138-11.196-2.286-11.196 2.286-9.18 6.138-6.138 9.18-2.286 11.196 2.286 11.196 6.138 9.18 9.18 6.138 11.196 2.286 11.196-2.286 9.18-6.138 6.138-9.18 2.286-11.196zm3.456 0q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"CHROME": "M32.148-64.439q8.64-.072 16.236 4.32 8.352 4.824 12.672 13.392l-26.712-1.404q-5.76-.324-10.584 2.682t-6.66 8.262l-9.936-15.264q4.608-5.724 11.196-8.838t13.788-3.15zm-26.892 14.58l12.132 23.868q2.592 5.148 7.596 7.812t10.548 1.62l-8.28 16.236q-7.632-1.188-13.86-5.67t-9.81-11.376-3.582-14.814q0-9.612 5.256-17.676zm57.096 6.084q2.088 5.4 2.142 11.178t-1.746 11.016-5.508 9.792-8.856 7.542q-8.28 4.788-17.928 4.284l14.58-22.428q3.168-4.716 2.97-10.458t-3.834-9.99zm-30.096.72q4.5 0 7.686 3.186t3.186 7.686-3.186 7.686-7.686 3.186-7.686-3.186-3.186-7.686 3.186-7.686 7.686-3.186z",
		"FIREFOX": "M32.508.073q-10.188 0-18.162-5.418t-11.862-14.346q-2.088-4.716-2.412-10.836t.936-11.97 3.996-11.232 6.444-8.73l-.396 10.116q.396-.504 2.448-.558t2.52.558q1.512-2.916 5.778-4.968t8.442-2.124q-1.944 1.62-4.302 5.346t-2.106 5.886q.9.288 2.25.486t2.268.27 2.448.144 1.818.108q.54.18.342 1.638t-1.098 2.718q-.18.252-.594.666t-2.034 1.278-3.636 1.224l.54 6.804-5.004-2.412q-.648 1.548-.27 2.934t1.296 2.394 2.358 1.494 2.916.234q1.836-.324 3.528-1.242t3.006-1.62 2.646-.63q2.196.144 3.222 1.188t.702 2.34q-.036.072-.09.198t-.306.45-.648.558-1.134.378-1.674.036q-2.16 3.42-5.202 4.878t-7.542 1.062q2.664 2.196 5.85 2.97t6.066.216 5.562-1.872 4.608-3.15 2.898-3.744q1.548-3.276 1.404-6.93t-1.35-6.786-2.826-4.5q3.132 1.368 4.932 2.862t2.772 4.05q.54-6.12-2.07-12.348t-7.542-10.224q9.54 2.772 14.832 10.062t5.436 18.63q.072 4.572-1.458 9.18t-4.446 8.568-6.804 7.056-8.91 4.878-10.386 1.782z",
		"OPERA": "M53.748-56.231q-5.94-3.96-12.924-3.96-5.58 0-10.548 2.628t-8.64 7.2q-2.7 3.348-4.302 7.848t-1.746 9.576v1.512q.144 5.076 1.746 9.576t4.302 7.848q3.672 4.572 8.64 7.2t10.548 2.628q6.984 0 12.924-3.96-4.356 3.888-9.882 6.048t-11.61 2.16q-1.044 0-1.548-.036-6.3-.288-11.988-2.952t-9.792-6.948-6.516-10.116-2.412-12.204q0-6.552 2.556-12.528t6.876-10.296 10.296-6.876 12.528-2.556h.108q6.048.036 11.538 2.178t9.846 6.03zm10.764 24.048q0 6.912-2.772 13.05t-7.668 10.674q-3.744 2.268-7.992 2.268-4.932 0-9.18-3.024 5.544-2.016 9.126-8.388t3.582-14.58q0-8.172-3.564-14.544t-9.108-8.424q4.284-2.988 9.144-2.988 4.284 0 8.136 2.34 4.86 4.5 7.578 10.62t2.718 12.996z",
		"INTERNET_EXPLORER": "M64.512-30.707q0 2.016-.252 3.744h-41.436q0 5.256 3.942 8.802t9.27 3.546q3.564 0 6.678-1.674t4.914-4.698h15.228q-2.016 5.724-6.138 10.116t-9.63 6.786-11.556 2.394q-6.732 0-12.816-2.988-8.208 4.176-14.184 4.176-8.532 0-8.532-9.468 0-4.14 1.62-9.9.612-2.16 3.924-8.244 7.164-12.96 17.1-21.816-6.624 2.844-15.372 12.744 2.268-9.864 10.206-16.182t18.054-6.318q1.08 0 1.62.036 9.18-4.212 15.588-4.212 2.304 0 4.176.468t3.402 1.458 2.394 2.754.864 4.14q0 4.176-2.7 10.296 3.636 6.552 3.636 14.04zm-2.52-23.04q0-2.988-1.908-4.752t-4.932-1.764q-3.888 0-9.144 2.52 4.356 1.692 8.01 4.734t6.138 7.038q1.836-4.86 1.836-7.776zm-57.384 44.532q0 3.096 1.746 4.77t4.842 1.674q4.14 0 9.576-2.988-4.392-2.592-7.686-6.588t-4.95-8.82q-3.528 7.38-3.528 11.952zm18.144-25.668h26.208q-.18-5.112-4.068-8.532t-9.036-3.42q-5.184 0-9.054 3.42t-4.05 8.532z",
		"TV": "M64.512-19.511v-34.56q0-.468-.342-.81t-.81-.342h-57.6q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81zm4.608-34.56v34.56q0 2.376-1.692 4.068t-4.068 1.692h-26.496v4.608h12.672q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h12.672v-4.608h-26.496q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z",
		"CONTAO": "M4.968-59.831h7.092q-2.52 2.304-4.536 5.364-1.296 2.016-2.124 4.14t-1.08 4.518-.306 4.32.378 4.752.756 4.536 1.008 4.914l.216 1.008q1.836 8.568 2.916 11.844 2.052 6.156 5.472 9.9h-9.792q-1.728 0-2.952-1.224t-1.224-2.952v-46.944q0-1.728 1.224-2.952t2.952-1.224zm43.488 0h11.088q1.728 0 2.952 1.224t1.224 2.952v46.944q0 1.728-1.224 2.952t-2.952 1.224h-6.408q7.632-7.56 7.056-20.34l-16.884 3.636q-.072 1.62-.432 2.952t-1.116 2.592-2.142 2.142-3.366 1.314q-4.428.936-7.164-1.44-1.152-.972-1.908-2.196t-1.854-4.644-2.322-9.288q-1.26-5.868-1.638-9.468t-.198-5.004.828-2.772q.72-1.476 2.25-2.628t3.69-1.62q1.62-.432 3.006-.234t2.412.612 1.944 1.26 1.548 1.728 1.242 2.034l16.848-3.6q-2.448-6.3-6.48-10.332z",
		"500PX": "M50.436-8.747l-.216.216q-4.068 4.104-9.324 6.3-5.544 2.304-11.412 2.304-5.94 0-11.412-2.304-5.328-2.268-9.324-6.3-4.068-4.032-6.3-9.288-1.512-3.708-1.944-6.804-.144-1.008 1.728-1.296 1.836-.288 2.016.72l.036.144q.648 3.24 1.656 5.724 1.8 4.464 5.472 8.136 3.528 3.528 8.136 5.472 4.752 2.016 9.936 2.016 5.148 0 9.936-2.016 4.608-1.98 8.1-5.472l.216-.216q.36-.36.9-.216.432.108 1.188.792 1.296 1.332.612 2.088zm-16.992-22.14l-2.376 2.376 2.268 2.268q.756.756-.252 1.764-.612.612-1.152.612-.36 0-.684-.36l-2.232-2.196-2.376 2.376q-.18.18-.54.18-.54 0-1.116-.576l-.072-.072q-.648-.54-.648-1.044 0-.252.288-.612l2.376-2.34-2.376-2.376q-.576-.576.504-1.62.648-.648 1.116-.648.216 0 .468.18l2.34 2.376 2.34-2.34q.648-.612 1.728.468.972.972.396 1.584zm16.956 2.052q0 4.248-1.656 8.208-1.62 3.78-4.536 6.696-2.88 2.88-6.732 4.536t-8.208 1.656-8.208-1.656-6.732-4.536q-2.952-2.952-4.5-6.696-.54-1.152-.54-1.44h-.036q-.324-.972 1.548-1.584 1.8-.576 2.16.432 1.332 3.564 3.492 6.012h.036v-12.276q.108-4.896 3.672-8.352 3.78-3.708 9.108-3.708 5.292 0 9.036 3.708t3.744 8.964q0 5.292-3.762 9.036t-9.018 3.744q-2.088 0-4.032-.576-1.008-.396-.468-2.196.576-1.836 1.584-1.548l.504.108q.504.108 1.17.216t1.098.108q3.744 0 6.336-2.574t2.592-6.282q0-3.636-2.592-6.156-2.556-2.556-6.3-2.556-3.852 0-6.408 2.88-2.304 2.592-2.304 5.76v14.868q3.96 2.412 8.712 2.412 3.456 0 6.66-1.314t5.616-3.726 3.726-5.58 1.314-6.588q0-7.128-5.076-12.204-5.04-5.04-12.204-5.04-7.2 0-12.24 5.04-1.908 1.908-2.772 3.132l-.072.072q-.288.396-.468.558t-.774.342-1.386-.108q-.756-.18-1.314-.594t-.558-.954v-24.48q0-.54.378-.954t.99-.414h31.572q1.08 0 1.08 1.98t-1.08 1.98h-29.196v17.388h.036q1.44-1.512 3.672-3.024t3.888-2.196q3.924-1.656 8.316-1.656 4.356 0 8.208 1.656t6.732 4.536q2.916 2.916 4.536 6.696 1.656 4.032 1.656 8.244zm-1.116-20.916q.324.288.324.648t-.198.648-.594.756q-.936.936-1.404.936-.324 0-.576-.252-3.816-3.276-7.452-4.788-4.608-2.016-9.936-2.016-4.788 0-9.432 1.764-.972.36-1.62-1.332-.324-.9-.288-1.368.108-.576.576-.72 4.68-2.052 10.764-2.052 5.904 0 11.376 2.304 4.932 2.088 8.46 5.472z",
		"AMAZON": "M55.836-11.303q.54-.216.936-.108t.396.63-.54 1.206q-.468.576-1.584 1.566t-3.438 2.448-5.076 2.664-6.768 2.088-8.262.882q-4.284 0-8.568-1.116t-7.524-2.754-6.21-3.744-4.77-3.78-3.024-3.15q-.288-.324-.36-.594t.036-.432.288-.252.414-.072.414.162q6.912 4.212 10.8 5.976 14.004 6.336 28.764 3.24 6.84-1.44 14.076-4.86zm7.452-4.14q.396.576.09 2.502t-1.026 3.69q-1.224 2.988-3.06 4.464-.612.504-.936.324t0-.864q.756-1.62 1.602-4.374t.234-3.546q-.18-.252-.558-.414t-.972-.216-1.062-.09-1.26 0-1.134.072-1.116.108-.81.072q-.216.036-.468.054t-.396.036-.306.036-.252.018h-.36l-.108-.018-.072-.054-.054-.108q-.216-.576 1.692-1.44t3.708-1.08q1.656-.252 3.888-.036t2.736.864zm-14.184-15.948q0 1.116.486 2.304t1.152 2.088 1.35 1.656 1.188 1.152l.468.396-8.172 8.064q-1.44-1.332-2.844-2.718t-2.088-2.106l-.684-.72q-.396-.396-.9-1.188-1.368 2.124-3.51 3.69t-4.59 2.286-5.04.828-4.95-.756-4.23-2.358-2.988-4.068-1.116-5.85q0-3.024 1.008-5.544t2.592-4.194 3.834-2.988 4.41-2.052 4.68-1.242 4.302-.666 3.582-.234v-4.572q0-2.34-.756-3.492-1.224-1.908-4.356-1.908-.216 0-.594.036t-1.458.432-2.016 1.062-2.016 2.142-1.728 3.456l-10.584-.972q0-2.16.792-4.284t2.412-4.068 3.888-3.42 5.454-2.358 6.858-.882q3.6 0 6.516.9t4.662 2.214 2.916 2.988 1.62 3.096.45 2.646v21.204zm-24.192.756q0 3.096 2.52 4.788 2.376 1.584 5.004.792 3.024-.9 4.104-4.428.504-1.62.504-3.636v-5.832q-2.124.072-3.996.432t-3.834 1.206-3.132 2.556-1.17 4.122z",
		"CALENDAR_PLUS_O": "M55.296-55.223q1.872 0 3.24 1.368t1.368 3.24v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608zm-13.824-3.456v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm-27.648 0v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm41.472 54.144v-36.864h-50.688v36.864h50.688zm-23.04-20.736h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-8.064q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v8.064z",
		"CALENDAR_MINUS_O": "M41.472-24.119v2.304q0 .504-.324.828t-.828.324h-20.736q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h20.736q.504 0 .828.324t.324.828zm-36.864 19.584h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z",
		"CALENDAR_TIMES_O": "M39.996-14.579l-1.656 1.656q-.324.324-.792.324t-.828-.324l-6.768-6.804-6.768 6.804q-.36.324-.828.324t-.792-.324l-1.656-1.656q-.324-.324-.324-.792t.324-.828l6.804-6.768-6.804-6.768q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l6.768 6.768 6.768-6.768q.36-.324.828-.324t.792.324l1.656 1.656q.324.324.324.792t-.324.828l-6.768 6.768 6.768 6.768q.324.36.324.828t-.324.792zm-35.388 10.044h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z",
		"CALENDAR_CHECK_O": "M46.908-29.735l-18.432 18.432q-.36.324-.828.324t-.828-.324l-10.368-10.368q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l7.92 7.92 15.984-15.984q.36-.324.828-.324t.792.324l1.656 1.656q.324.324.324.792t-.324.828zm-42.3 25.2h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z",
		"INDUSTRY": "M16.128-64.439q.936 0 1.62.684t.684 1.62v32.076l19.296-15.444q.612-.504 1.44-.504.936 0 1.62.684t.684 1.62v13.644l19.296-15.444q.612-.504 1.44-.504.936 0 1.62.684t.684 1.62v41.472q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h13.824z",
		"MAP_PIN": "M18.432-25.271q2.376 0 4.608-.54v23.58q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-23.58q2.196.54 4.608.54zm0-39.168q7.632 0 13.032 5.4t5.4 13.032-5.4 13.032-13.032 5.4-13.032-5.4-5.4-13.032 5.4-13.032 13.032-5.4zm0 8.064q.504 0 .828-.324t.324-.828-.324-.828-.828-.324q-5.256 0-8.964 3.708t-3.708 8.964q0 .504.324.828t.828.324.828-.324.324-.828q0-4.284 3.042-7.326t7.326-3.042z",
		"MAP_SIGNS": "M62.82-53.747q.36.36.36.828t-.36.828l-5.076 5.076q-1.008 1.008-2.448 1.008h-48.384q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h20.736v-2.304q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v2.304h18.432q1.44 0 2.448 1.008zm-35.172 33.084h9.216v18.432q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-18.432zm29.952-16.128q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-48.384q-1.44 0-2.448-1.008l-5.076-5.076q-.36-.36-.36-.828t.36-.828l5.076-5.076q1.008-1.008 2.448-1.008h18.432v-6.912h9.216v6.912h20.736z",
		"MAP_O": "M72.72-64.043q1.008.72 1.008 1.908v50.688q0 .72-.396 1.296t-1.044.828l-23.04 9.216q-.864.396-1.728 0l-22.176-8.856-22.176 8.856q-.36.18-.864.18-.684 0-1.296-.396-1.008-.72-1.008-1.908v-50.688q0-.72.396-1.296t1.044-.828l23.04-9.216q.864-.396 1.728 0l22.176 8.856 22.176-8.856q1.152-.468 2.16.216zm-46.224 4.86v45.72l20.736 8.28v-45.72zm-21.888 7.812v45.72l19.584-7.812v-45.72zm64.512 38.376v-45.72l-19.584 7.812v45.72z",
		"MAP": "M18.432-64.439q.468 0 .81.342t.342.81v52.992q0 .72-.612 1.008l-17.28 9.216q-.252.144-.54.144-.468 0-.81-.342t-.342-.81v-52.992q0-.72.612-1.008l17.28-9.216q.252-.144.54-.144zm44.928 0q.468 0 .81.342t.342.81v52.992q0 .72-.612 1.008l-17.28 9.216q-.252.144-.54.144-.468 0-.81-.342t-.342-.81v-52.992q0-.72.612-1.008l17.28-9.216q.252-.144.54-.144zm-40.32 0q.288 0 .504.108l18.432 9.216q.648.36.648 1.044v52.992q0 .468-.342.81t-.81.342q-.288 0-.504-.108l-18.432-9.216q-.648-.36-.648-1.044v-52.992q0-.468.342-.81t.81-.342z",
		"COMMENTING": "M23.04-32.183q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-3.96 0-7.596-.648-6.228 6.228-15.66 8.244-1.872.36-3.096.468-.432.036-.792-.216t-.468-.648q-.144-.54.72-1.332.18-.18.846-.774t.918-.846.846-.918.864-1.134.738-1.332.72-1.728.522-2.07.45-2.61q-5.256-3.24-8.262-7.794t-3.006-9.702q0-6.264 4.32-11.574t11.736-8.388 16.2-3.078 16.2 3.078 11.736 8.388 4.32 11.574z",
		"COMMENTING_O": "M23.04-32.183q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm13.824 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm13.824 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-18.432-18.432q-7.344 0-13.734 2.502t-10.152 6.75-3.762 9.18q0 4.032 2.574 7.686t7.254 6.318l3.132 1.8-.972 3.456q-.864 3.276-2.52 6.192 5.472-2.268 9.9-6.156l1.548-1.368 2.052.216q2.484.288 4.68.288 7.344 0 13.734-2.502t10.152-6.75 3.762-9.18-3.762-9.18-10.152-6.75-13.734-2.502zm32.256 18.432q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792h-.18q-.54 0-.972-.378t-.576-.99v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-4.68 2.556-8.946t6.876-7.362 10.296-4.914 12.528-1.818 12.528 1.818 10.296 4.914 6.876 7.362 2.556 8.946z",
		"HOUZZ": "M18.432-21.563l18.432-10.62v21.276l-18.432 10.656v-21.312zm-18.432-10.62v21.276l18.432-10.656zm18.432-31.932v21.276l-18.432 10.656v-21.276zm0 21.276l18.432-10.62v21.276z",
		"VIMEO": "M61.524-45.791q-.36 8.496-11.952 23.436-11.988 15.516-20.232 15.516-5.112 0-8.64-9.468-1.584-5.76-4.752-17.352-2.592-9.432-5.652-9.432-.648 0-4.572 2.736l-2.772-3.528q.864-.756 3.888-3.474t4.68-4.158q5.616-4.968 8.676-5.256 3.42-.324 5.508 1.998t2.916 7.326q1.584 10.332 2.376 13.428 1.98 8.964 4.32 8.964 1.836 0 5.544-5.796 3.636-5.796 3.924-8.856.468-5.004-3.924-5.004-2.052 0-4.356.936 4.32-14.148 16.524-13.752 9.036.288 8.496 11.736z",
		"BLACK_TIE": "M0-59.831h55.296v55.296h-55.296v-55.296zm39.06 40.14l-7.956-22.716 7.956-10.692h-22.824l7.956 10.692-7.956 22.716 11.412 10.944z",
		"FONTICONS": "M0-59.831h55.296v55.296h-55.296v-55.296zm32.688 11.52l-.432 1.188 2.7 2.988-1.116 4.104.9.9 3.852-2.052 3.852 2.052.9-.9-1.116-4.104 2.7-2.988-.432-1.188h-3.42l-1.908-3.456h-1.152l-1.908 3.456h-3.42zm-9.612 5.868q1.152 0 1.602.576t.414 2.268l6.264-.756q0-1.98-.63-3.33t-1.818-2.016-2.484-.918-3.06-.252q-4.788 0-7.164 2.07t-2.376 6.57v2.592h-3.456v4.608h2.736q.72 0 .72.288v13.752q0 .504-.18.72t-.648.252l-2.628.252v3.168h16.128v-3.096l-5.364-.504q-.216-.036-.306-.054t-.126-.09-.018-.144.036-.252.018-.36v-13.932h6.876l1.368-4.608h-8.316q-.216 0-.072-.216t.144-.324v-2.88q0-.972.054-1.458t.27-1.008.702-.72 1.314-.198zm21.852 29.844v-3.096l-1.944-.324q-.252-.036-.342-.09t-.09-.108.036-.27.036-.432v-18.72h-9.9l-.828 3.636 2.988.792q.828.252.828.972v13.32q0 .504-.216.666t-.72.234l-2.52.324v3.096h12.672z",
		"REDDIT_ALIEN": "M64.512-33.983q0 2.088-1.062 3.798t-2.862 2.61q.432 1.656.432 3.456 0 5.58-3.834 10.332t-10.458 7.506-14.4 2.754-14.382-2.754-10.44-7.506-3.834-10.332q0-1.692.396-3.384-1.836-.9-2.952-2.646t-1.116-3.834q0-2.952 2.088-5.058t5.076-2.106q3.06 0 5.22 2.268 7.848-5.472 18.54-5.832l4.176-18.756q.108-.468.54-.756t.936-.18l13.284 2.916q.648-1.332 1.944-2.142t2.844-.81q2.232 0 3.816 1.566t1.584 3.798-1.584 3.816-3.816 1.584-3.798-1.566-1.566-3.798l-12.024-2.664-3.744 16.992q10.8.324 18.684 5.76 2.088-2.196 5.148-2.196 2.988 0 5.076 2.106t2.088 5.058zm-49.464 7.164q0 2.232 1.566 3.816t3.798 1.584 3.816-1.584 1.584-3.816-1.584-3.798-3.816-1.566q-2.196 0-3.78 1.584t-1.584 3.78zm29.16 12.78q.396-.396.396-.936t-.396-.936q-.36-.36-.9-.36t-.936.36q-1.476 1.512-4.356 2.232t-5.76.72-5.76-.72-4.356-2.232q-.396-.36-.936-.36t-.9.36q-.396.36-.396.918t.396.954q1.548 1.548 4.266 2.448t4.41 1.062 3.276.162 3.276-.162 4.41-1.062 4.266-2.448zm-.108-7.38q2.232 0 3.798-1.584t1.566-3.816q0-2.196-1.584-3.78t-3.78-1.584q-2.232 0-3.816 1.566t-1.584 3.798 1.584 3.816 3.816 1.584z",
		"EDGE": "M2.484-35.819h.036q.576-4.536 2.106-8.694t4.14-7.812 6.03-6.336 8.046-4.23 9.954-1.548q8.316 0 14.904 3.798t10.584 10.926q3.744 6.732 3.744 15.912v6.768h-40.5q.036 3.996 1.926 6.93t4.914 4.41 6.822 2.052 7.668.108 7.488-1.674 6.246-3.042v13.572q-3.312 1.98-8.262 3.312t-11.25 1.368-11.376-1.908q-6.804-2.628-11.214-8.964t-4.482-13.392q-.108-8.712 3.996-14.832t11.7-9.648q-1.728 2.16-2.808 4.518t-1.656 5.742h22.86q.288-2.772-.288-5.04t-1.692-3.654-2.538-2.394-2.898-1.476-2.7-.738-2.016-.306l-.792-.036q-4.86.18-9.342 1.602t-8.046 3.762-6.336 5.058-4.968 5.886z",
		"CREDIT_CARD_ALT": "M0-10.295v-21.888h82.944v21.888q0 2.376-1.692 4.068t-4.068 1.692h-71.424q-2.376 0-4.068-1.692t-1.692-4.068zm23.04-8.064v4.608h13.824v-4.608h-13.824zm-13.824 0v4.608h9.216v-4.608h-9.216zm67.968-41.472q2.376 0 4.068 1.692t1.692 4.068v8.064h-82.944v-8.064q0-2.376 1.692-4.068t4.068-1.692h71.424z",
		"CODIEPIE": "M55.764-39.995q1.98 0 3.078 1.026t1.098 3.006-1.224 2.952-3.276.972h-4.896v6.372h-.9v-14.328h6.12zm5.796 21.24l-.144.396-.18.36q-4.068 8.28-11.898 13.176t-17.082 4.896q-6.552 0-12.528-2.556t-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556q8.784 0 16.362 4.464t11.862 12.168l.072.144.288.576q-1.08.54-4.914 2.466t-5.886 3.042q-.216.108-17.244 9.648 13.824 6.588 28.764 13.176zm-29.304 18.036q9 0 16.65-4.77t11.61-12.87l-10.332-4.644q-2.592 5.04-7.416 7.992t-10.512 2.952q-5.436 0-10.08-2.7t-7.344-7.344-2.7-10.08 2.7-10.08 7.344-7.344 10.08-2.7 10.08 2.646 7.344 7.362l10.08-5.148q-4.176-7.488-11.556-11.844t-15.948-4.356q-4.284 0-8.37 1.134t-7.524 3.15-6.354 4.932-4.932 6.354-3.15 7.524-1.134 8.37 1.134 8.37 3.15 7.524 4.932 6.354 6.354 4.932 7.524 3.15 8.37 1.134z",
		"MODX": "M51.372-38.915l-22.104-13.896 3.312-5.436h30.78zm-36.792 9.54l-6.624-4.176v-30.888l42.588 26.748zm36.684-4.86l5.292 3.42v30.888l-19.152-12.06zm-1.332-.756l-18 28.872h-30.78l12.816-20.556z",
		"FORT_AWESOME": "M23.04-28.151v-8.064q0-.576-.576-.576h-3.456q-.576 0-.576.576v8.064q0 .576.576.576h3.456q.576 0 .576-.576zm18.432 0v-8.064q0-.576-.576-.576h-3.456q-.576 0-.576.576v8.064q0 .576.576.576h3.456q.576 0 .576-.576zm18.432 1.152v27.072h-23.04v-11.52q0-2.88-2.016-4.896t-4.896-2.016-4.896 2.016-2.016 4.896v11.52h-23.04v-27.072q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-22.464q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h.576v-14.148q-1.152-.684-1.152-1.98 0-.936.684-1.62t1.62-.684 1.62.684.684 1.62q0 1.296-1.152 1.98v.324h9.792q.576 0 .576.576v8.064q0 .576-.576.576h-9.792v4.608h.576q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v22.464h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576z",
		"USB": "M82.368-35.459q.576.288.576.972t-.576.972l-11.52 6.912q-.288.18-.576.18-.324 0-.576-.144-.576-.36-.576-1.008v-4.608h-30.888q1.332 2.088 2.988 5.94.576 1.332.882 1.98t.864 1.764.972 1.692.972 1.224 1.134.936 1.188.288h3.456v-3.456q0-.504.324-.828t.828-.324h11.52q.504 0 .828.324t.324.828v11.52q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-1.152 0-2.196-.36t-1.836-.846-1.62-1.458-1.332-1.656-1.206-2.052-1.026-2.07-1.008-2.178q-.828-1.908-1.332-2.934t-1.296-2.34-1.602-1.926-1.674-.612h-12.96q-.792 3.024-3.276 4.968t-5.652 1.944q-3.816 0-6.516-2.7t-2.7-6.516 2.7-6.516 6.516-2.7q3.168 0 5.652 1.944t3.276 4.968h3.744q.864 0 1.674-.612t1.602-1.926 1.296-2.34 1.332-2.934q.684-1.476 1.008-2.178t1.026-2.07 1.206-2.052 1.332-1.656 1.62-1.458 1.836-.846 2.196-.36h3.852q.756-2.052 2.52-3.33t3.996-1.278q2.88 0 4.896 2.016t2.016 4.896-2.016 4.896-4.896 2.016q-2.232 0-3.996-1.278t-2.52-3.33h-3.852q-.612 0-1.188.288t-1.134.936-.972 1.224-.972 1.692-.864 1.764-.882 1.98q-1.656 3.852-2.988 5.94h40.104v-4.608q0-.648.576-1.008t1.152.036z",
		"PRODUCT_HUNT": "M41.4-37.007q0 2.016-1.422 3.42t-3.438 1.404h-9.108v-9.684h9.108q2.016 0 3.438 1.422t1.422 3.438zm6.444 0q0-4.68-3.294-7.992t-8.01-3.312h-15.588v32.256h6.48v-9.684h9.108q4.68 0 7.992-3.294t3.312-7.974zm16.668 4.824q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"MIXCLOUD": "M59.22-24.911q0-2.124-1.224-3.834t-3.132-2.466q-.252 1.62-.828 3.312-.252.864-.99 1.368t-1.602.504q-.432 0-.864-.108-1.116-.36-1.62-1.386t-.144-2.106q.828-2.556.828-5.148 0-4.428-2.196-8.19t-5.976-5.958-8.208-2.196q-4.824 0-8.892 2.628t-6.012 6.984q3.888 1.008 6.768 3.816.792.828.792 1.98t-.792 1.944-1.944.792-1.98-.792q-2.7-2.7-6.48-2.7-3.816 0-6.516 2.682t-2.7 6.498 2.7 6.498 6.516 2.682h37.656q2.844 0 4.842-1.998t1.998-4.806zm5.508 0q0 5.112-3.618 8.712t-8.73 3.6h-37.656q-6.084 0-10.404-4.302t-4.32-10.386q0-5.508 3.6-9.612t8.964-4.896q2.232-6.624 7.956-10.728t12.744-4.104q8.46 0 14.706 5.706t7.074 14.022q4.176.9 6.93 4.266t2.754 7.722zm9 0q0 6.3-3.492 11.484-.828 1.188-2.304 1.188-.864 0-1.548-.468-.936-.612-1.152-1.746t.432-2.07q2.556-3.744 2.556-8.388t-2.556-8.388q-.648-.936-.432-2.052t1.152-1.764 2.07-.414 1.782 1.17q3.492 5.112 3.492 11.448zm9.216 0q0 8.784-4.824 15.948-.828 1.224-2.304 1.224-.828 0-1.512-.468-.936-.648-1.17-1.764t.414-2.052q3.888-5.904 3.888-12.888 0-7.02-3.888-12.852-.648-.936-.414-2.07t1.17-1.746q.936-.648 2.052-.432t1.764 1.188q4.824 7.128 4.824 15.912z",
		"SCRIBD": "M54-8.675q0 3.204-2.268 5.49t-5.508 2.286-5.526-2.286-2.286-5.49q0-3.24 2.286-5.526t5.526-2.286 5.508 2.286 2.268 5.526zm-8.388-10.116q-4.14.54-6.93 3.69t-2.79 7.398q0 2.664 1.188 4.968-5.256 2.808-13.644 2.808-3.924 0-7.236-.756t-5.526-1.962-3.978-2.754-2.736-3.06-1.602-2.988-.846-2.394-.216-1.422q0-.684.162-1.53t.666-2.016 1.314-2.088 2.304-1.566 3.402-.648 3.384.63 2.268 1.476 1.278 1.908.63 1.764.144 1.206q0 1.224-.828 2.916 1.008.972 2.952 1.512t3.348.612l1.44.036q4.14 0 6.84-1.836t2.7-4.788q0-.936-.324-1.746t-1.134-1.602-1.782-1.476-2.664-1.584-3.366-1.71-4.302-2.034l-1.548-.72q-4.176-1.98-6.732-3.6t-4.41-3.672-2.592-4.518-.738-5.85q0-2.808.738-5.4t2.376-4.95 4.05-4.104 5.994-2.772 7.974-1.026q4.32 0 7.92.936t5.922 2.412 3.942 3.384 2.304 3.798.684 3.726q0 1.656-.54 2.97t-1.314 2.088-1.746 1.296-1.764.702-1.404.18h-1.44l-1.404-.18-1.584-.504-1.476-1.008-1.332-1.656-.864-2.538-.36-3.51q-.54-.576-2.124-.918t-2.916-.378l-1.332-.036q-2.448 0-4.23 1.116t-2.538 2.52-.756 2.736q0 .864.18 1.548t.864 1.656 1.908 1.836 3.492 1.926 5.4 2.106q2.736.9 4.986 1.926t3.924 1.998 2.988 2.124 2.178 2.142 1.476 2.25.954 2.232.522 2.286.216 2.232.036 2.25z",
		"PAUSE_CIRCLE": "M25.344-21.815v-20.736q0-.504-.324-.828t-.828-.324h-9.216q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h9.216q.504 0 .828-.324t.324-.828zm16.128 0v-20.736q0-.504-.324-.828t-.828-.324h-9.216q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h9.216q.504 0 .828-.324t.324-.828zm13.824-10.368q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"PAUSE_CIRCLE_O": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm0 47.232q5.328 0 9.828-2.628t7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm3.456-8.064q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-6.912zm-13.824 0q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-6.912z",
		"STOP_CIRCLE": "M39.168-21.815v-20.736q0-.504-.324-.828t-.828-.324h-20.736q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h20.736q.504 0 .828-.324t.324-.828zm16.128-10.368q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"STOP_CIRCLE_O": "M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm0 47.232q5.328 0 9.828-2.628t7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm-10.368-8.064q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h20.736q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-20.736z",
		"SHOPPING_BAG": "M63.252-13.751l1.26 11.268q.108 1.008-.576 1.8-.684.756-1.728.756h-59.904q-1.044 0-1.728-.756-.684-.792-.576-1.8l1.26-11.268h61.992zm-3.348-30.204l3.096 27.9h-61.488l3.096-27.9q.108-.864.756-1.458t1.548-.594h9.216v4.608q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258v-4.608h13.824v4.608q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258v-4.608h9.216q.9 0 1.548.594t.756 1.458zm-13.824-6.66v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62v-9.216q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62v-9.216q0-5.724 4.05-9.774t9.774-4.05 9.774 4.05 4.05 9.774z",
		"SHOPPING_BASKET": "M69.12-36.791q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35h-.54l-4.14 23.832q-.288 1.656-1.584 2.736t-2.952 1.08h-46.08q-1.656 0-2.952-1.08t-1.584-2.736l-4.14-23.832h-.54q-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35h64.512zm-51.66 28.8q.936-.072 1.566-.81t.558-1.674l-1.152-14.976q-.072-.936-.81-1.566t-1.674-.558-1.566.81-.558 1.674l1.152 14.976q.072.9.738 1.512t1.566.612h.18zm14.796-2.304v-14.976q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm13.824 0v-14.976q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm12.672.18l1.152-14.976q.072-.936-.558-1.674t-1.566-.81-1.674.558-.81 1.566l-1.152 14.976q-.072.936.558 1.674t1.566.81h.18q.9 0 1.566-.612t.738-1.512zm-41.616-43.812l-3.348 14.832h-4.752l3.636-15.876q.684-3.168 3.204-5.166t5.76-1.998h6.012q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62h6.012q3.24 0 5.76 1.998t3.204 5.166l3.636 15.876h-4.752l-3.348-14.832q-.396-1.584-1.638-2.592t-2.862-1.008h-6.012q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62h-6.012q-1.62 0-2.862 1.008t-1.638 2.592z",
		"HASHTAG": "M35.676-27.575l2.304-9.216h-9.144l-2.304 9.216h9.144zm27.648-18.144l-2.016 8.064q-.252.864-1.116.864h-11.772l-2.304 9.216h11.196q.54 0 .9.432.36.504.216 1.008l-2.016 8.064q-.18.864-1.116.864h-11.772l-2.916 11.808q-.252.864-1.116.864h-8.064q-.576 0-.936-.432-.324-.432-.216-1.008l2.808-11.232h-9.144l-2.916 11.808q-.252.864-1.116.864h-8.1q-.54 0-.9-.432-.324-.432-.216-1.008l2.808-11.232h-11.196q-.54 0-.9-.432-.324-.432-.216-1.008l2.016-8.064q.252-.864 1.116-.864h11.772l2.304-9.216h-11.196q-.54 0-.9-.432-.36-.504-.216-1.008l2.016-8.064q.18-.864 1.116-.864h11.772l2.916-11.808q.252-.864 1.152-.864h8.064q.54 0 .9.432.324.432.216 1.008l-2.808 11.232h9.144l2.916-11.808q.252-.864 1.152-.864h8.064q.54 0 .9.432.324.432.216 1.008l-2.808 11.232h11.196q.54 0 .9.432.324.432.216 1.008z",
		"BLUETOOTH": "M30.276-26.531l5.328 5.328-5.364 5.364zm-.036-21.996l5.364 5.364-5.328 5.328zm-4.68 44.064l16.704-16.704-11.016-11.016 11.016-11.016-16.704-16.704v21.996l-9.18-9.18-3.348 3.348 11.52 11.556-11.52 11.556 3.348 3.348 9.18-9.18v21.996zm25.884-27.72q0 7.524-1.152 13.158t-3.15 9.252-5.058 5.85-6.534 3.114-7.902.882-7.902-.882-6.534-3.114-5.058-5.85-3.15-9.252-1.152-13.158 1.152-13.158 3.15-9.252 5.058-5.85 6.534-3.114 7.902-.882 7.902.882 6.534 3.114 5.058 5.85 3.15 9.252 1.152 13.158z",
		"BLUETOOTH_B": "M21.456-13.211l6.228-6.192-6.228-6.192v12.384zm0-25.56l6.228-6.192-6.228-6.192v12.384zm1.152 6.588l12.816 12.816-19.404 19.44v-25.596l-10.692 10.656-3.888-3.888 13.392-13.428-13.392-13.428 3.888-3.888 10.692 10.656v-25.596l19.404 19.44z",
		"PERCENT": "M46.08-18.359q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm-27.648-27.648q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm36.864 27.648q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774zm-3.456-39.168q0 .72-.468 1.368l-38.016 50.688q-.684.936-1.836.936h-5.76q-.936 0-1.62-.684t-.684-1.62q0-.72.468-1.368l38.016-50.688q.684-.936 1.836-.936h5.76q.936 0 1.62.684t.684 1.62zm-24.192 11.52q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z",
		"GITLAB": "M3.744-39.023l28.512 36.54-31.248-22.68q-.648-.468-.9-1.242t0-1.53l3.636-11.088zm16.632 0h23.76l-11.88 36.54zm-7.128-22.032l7.128 22.032h-16.632l7.128-22.032q.288-.828 1.188-.828t1.188.828zm47.52 22.032l3.636 11.088q.252.756 0 1.53t-.9 1.242l-31.248 22.68 28.512-36.54zm0 0h-16.632l7.128-22.032q.288-.828 1.188-.828t1.188.828z",
		"WPBEGINNER": "M13.824-34.487h5.76v-8.064h-5.76v8.064zm30.132 11.952v-3.312q-3.744 1.296-8.748 1.368-4.86.036-9.342-1.674t-7.938-4.41l.036 3.456q3.168 2.88 7.632 4.626t9.792 1.71q4.644 0 8.568-1.764zm-20.916-11.952h23.04v-8.064h-23.04v8.064zm41.472-1.152q0 6.732-3.564 12.672 3.204 3.672 3.204 8.244 0 5.652-4.662 9.648t-11.286 3.996q-4.392 0-8.1-1.89t-5.796-5.058q-.684.036-2.052.036t-2.052-.036q-2.088 3.168-5.796 5.058t-8.1 1.89q-6.624 0-11.286-3.996t-4.662-9.648q0-4.572 3.204-8.244-3.564-5.94-3.564-12.672 0-7.524 4.32-13.878t11.754-10.062 16.182-3.708 16.182 3.708 11.754 10.062 4.32 13.878z",
		"WPFORMS": "M18.54-31.643v4.608h-9.072v-4.608h9.072zm0-9.18v4.572h-9.072v-4.572h9.072zm27.288 18.396v4.608h-12.276v-4.608h12.276zm0-9.216v4.608h-24.192v-4.608h24.192zm0-9.18v4.572h-24.192v-4.572h24.192zm4.86 30.96v-44.64q0-.288-.216-.504t-.504-.216h-1.152l-13.608 9.216-7.56-6.156-7.56 6.156-13.608-9.216h-1.152q-.288 0-.504.216t-.216.504v44.64q0 .288.216.504t.504.216h44.64q.288 0 .504-.216t.216-.504zm-30.78-39.96l6.66-5.4h-14.616zm15.48 0l7.956-5.4h-14.616zm19.908-4.68v44.64q0 2.232-1.548 3.78t-3.78 1.548h-44.64q-2.232 0-3.78-1.548t-1.548-3.78v-44.64q0-2.232 1.548-3.78t3.78-1.548h44.64q2.232 0 3.78 1.548t1.548 3.78z",
		"ENVIRA": "M32.256-35.063q-3.744-7.056-5.76-10.008-5.004-7.272-12.492-11.448-1.224-.684-2.52-1.296-3.204-1.44-3.384-1.152t1.224 1.368l1.404 1.116q2.232 1.548 4.05 3.366t3.402 4.194 2.538 4.068 2.538 4.716q.324.612.468.9 1.584 3.024 3.024 5.508t3.528 5.544 4.158 5.4 4.716 4.446 5.346 3.258q5.508 2.376 5.544 2.16.036-.108-1.764-1.332-1.908-1.296-2.916-2.052-2.772-2.088-6.444-7.596t-6.66-11.16zm-12.492 19.548q-2.736-2.16-4.77-4.5t-3.528-5.166-2.556-5.562-2.106-6.696-1.872-7.524-2.178-9.072-2.754-10.404q9.828 0 17.91 1.296t13.644 3.312 9.756 5.202 6.678 6.21 3.96 7.146 2.016 7.182.45 7.146-.342 6.228-.72 5.166-.468 3.852l11.628 11.772h-3.744l-10.116-10.26q-.792.072-3.294.504t-4.374.684-4.968.216-5.778-.612-6.03-2.124-6.444-3.996z",
		"UNIVERSAL_ACCESS": "M49.464-40.787q-.216-.936-1.026-1.422t-1.746-.27q-9.396 2.232-14.436 2.232t-14.436-2.232q-.936-.216-1.746.27t-1.026 1.422.27 1.746 1.422 1.026q6.984 1.656 10.908 2.088-.072 5.688-.558 9.684t-.954 5.598-1.476 4.158l-.324.756q-.36.9.036 1.764t1.296 1.224q.324.144.828.144 1.584 0 2.16-1.476l.288-.72q1.944-5.004 2.556-9.324h1.512q.612 4.32 2.556 9.324l.288.72q.576 1.476 2.16 1.476.504 0 .828-.144.9-.36 1.296-1.224t.036-1.764l-.324-.756q-1.008-2.556-1.476-4.158t-.954-5.598-.558-9.684q3.924-.432 10.908-2.088.936-.216 1.422-1.026t.27-1.746zm-12.6-5.22q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm20.736 13.824q0 5.148-1.998 9.846t-5.4 8.1-8.1 5.4-9.846 1.998-9.846-1.998-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846zm-25.344-27.648q-5.616 0-10.728 2.196t-8.82 5.904-5.904 8.82-2.196 10.728 2.196 10.728 5.904 8.82 8.82 5.904 10.728 2.196 10.728-2.196 8.82-5.904 5.904-8.82 2.196-10.728-2.196-10.728-5.904-8.82-8.82-5.904-10.728-2.196zm32.256 27.648q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z",
		"WHEELCHAIR_ALT": "M51.768-35.171q1.224 1.26 1.044 2.952l-1.584 19.836q-.144 1.512-1.242 2.52t-2.574 1.008q-.216 0-.324-.036-1.584-.108-2.61-1.314t-.918-2.79l1.26-15.444-5.148.288q1.98 4.068 1.98 8.64 0 7.776-5.328 13.392l-4.932-4.932q3.276-3.636 3.276-8.46 0-5.22-3.69-8.928t-8.91-3.708q-4.824 0-8.496 3.312l-4.932-4.968q4.32-4.104 10.224-5.076l9.504-10.8-5.364-3.132-6.516 5.796q-1.188 1.08-2.772.99t-2.628-1.278-.954-2.772 1.242-2.628l8.604-7.668q.936-.828 2.16-.954t2.304.522l17.568 10.188q1.296.756 1.728 2.448.612 2.412-.936 4.212l-7.38 8.352 13.356-.72q1.764-.108 2.988 1.152zm-7.128-16.452q-2.664 0-4.536-1.872t-1.872-4.536 1.872-4.536 4.536-1.872 4.554 1.872 1.89 4.536-1.89 4.536-4.554 1.872zm-22.572 44.712q3.816 0 7.056-2.196l5.004 5.004q-5.256 4.176-12.06 4.176-5.328 0-9.846-2.628t-7.146-7.128-2.628-9.828q0-6.768 4.176-12.096l5.004 5.004q-2.16 3.168-2.16 7.092 0 5.22 3.69 8.91t8.91 3.69z",
		"QUESTION_CIRCLE_O": "M31.68-21.239v5.76q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-5.76q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828zm9.216-17.856q0 1.8-.54 3.24t-1.638 2.484-1.872 1.584-2.142 1.296q-1.152.648-1.674 1.008t-.936.864-.414 1.044v1.152q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-2.448q0-1.26.378-2.322t.864-1.71 1.404-1.278 1.476-.918 1.602-.756q1.908-.9 2.7-1.548t.792-1.764q0-1.512-1.566-2.574t-3.438-1.062q-2.016 0-3.42.972-1.044.72-2.88 2.988-.324.432-.9.432-.396 0-.684-.216l-3.888-2.952q-.36-.252-.432-.72t.18-.828q4.392-6.912 12.564-6.912 4.644 0 8.586 3.222t3.942 7.722zm-13.248-16.128q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"BLIND": "M13.176-53.243q-2.304 0-3.96-1.638t-1.656-3.978q0-2.304 1.656-3.942t3.96-1.638 3.942 1.638 1.638 3.942q0 2.34-1.638 3.978t-3.942 1.638zm19.836 23.112q0 1.8-1.08 2.43t-2.286.234-1.71-1.224l-13.212-15.768q-.252-.432-.504-.558t-.396-.054l-.108.108q-.252.288.144.756l4.392 5.004.036 12.744-5.796 16.452q-2.412 6.912-3.312 8.424-.576.936-1.008 1.152-1.8.936-3.708.036-1.044-.468-1.494-1.548t-.342-2.052q.072-.612 7.092-22.248l.18-14.976-3.06 5.904 1.26 7.992q.144.864-.036 1.512t-.504.99-.684.576-.612.27l-.252.072q-.684.108-1.242-.108t-.864-.576-.504-.792-.27-.702-.072-.342l-1.656-10.764 7.596-13.716q.828-1.224 4.068-1.224 2.7 0 3.852 1.44l15.264 18.756q.252.18.504.612l.108.108-.036.036q.252.468.252 1.044zm-14.508 5.4q1.548 4.068 3.186 8.1t2.502 6.048l.864 1.98q1.296 3.348 1.512 4.5.396 2.52-1.296 3.492-1.26.792-2.376.576t-1.836-.792-1.044-1.26h-.036q-.216-.576-.288-.9l-4.464-12.636zm29.664 21.312q1.116 1.764 1.116 2.052 0 .18-.108.252-.324.18-.522-.018t-.558-.936-.576-1.098q-4.104-6.192-15.228-23.796.108.036.252-.036t.252-.144l.108-.072q.396-.324.396-.612z",
		"AUDIO_DESCRIPTION": "M18.144-28.655h6.156l-.036-9.54zm36.936-3.564q0-3.132-1.818-5.04t-5.274-1.908h-1.944v13.968h1.872q3.276 0 5.22-2.052t1.944-4.968zm-20.664-13.572l.036 27.216q0 .504-.342.864t-.846.36h-7.776q-.504 0-.846-.36t-.342-.864v-2.232h-10.476l-1.98 2.916q-.36.54-1.008.54h-9.612q-.756 0-1.098-.648t.126-1.26l20.016-27.252q.324-.504.972-.504h11.952q.504 0 .864.36t.36.864zm29.772 13.572q0 6.948-4.518 10.908t-11.682 3.96h-9.72q-.504 0-.864-.36t-.36-.864v-27.216q0-.504.36-.864t.864-.36h9.648q7.2 0 11.736 3.924t4.536 10.872zm5.616.036q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.602 3.888-2.646 3.69h-1.836q1.368-1.62 2.394-3.762t1.494-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.72-3.294-1.476-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.378 2.538zm6.624 0q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.62 3.888-2.664 3.69h-1.836q1.368-1.62 2.394-3.762t1.494-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.702-3.294-1.458-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.378 2.538zm6.516 0q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.602 3.888-2.646 3.69h-1.836q1.368-1.62 2.376-3.762t1.476-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.702-3.294-1.458-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.342 2.538z",
		"VOLUME_CONTROL_PHONE": "M22.212-3.635q0-.396-.468-2.088t-1.116-3.852-.72-2.484q-.036-.144-.18-.954t-.306-1.296-.486-.774q-.54-.504-1.836-.504-.828 0-2.52.198t-2.556.198q-1.224 0-1.692-.396-.216-.18-.396-.558t-.27-.72-.234-.864-.18-.666q-1.332-4.608-1.332-9.18t1.332-9.18l.18-.666.234-.864.27-.72.396-.558q.468-.396 1.692-.396.864 0 2.556.198t2.52.198q1.296 0 1.836-.504.324-.288.486-.774t.306-1.296.18-.954q.072-.324.72-2.484t1.116-3.852.468-2.088q0-.792-1.566-1.89t-2.718-1.53q-.72-.288-1.62-.288-1.224 0-3.528.648-2.052.612-3.474 1.458t-2.556 2.376-1.656 2.52-1.638 3.402q-.216.432-.324.684-1.764 3.852-2.448 7.776t-.684 8.784.684 8.784 2.448 7.776q2.016 4.392 2.988 5.796 2.268 3.276 6.444 4.572l.216.072q2.304.648 3.528.648.9 0 1.62-.288 1.152-.432 2.718-1.53t1.566-1.89zm5.724-32.868q-.936 0-1.62-.684t-.684-1.638.684-1.638q1.332-1.332 1.332-3.24 0-1.872-1.332-3.276-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q2.7 2.7 2.7 6.516t-2.7 6.516q-.756.684-1.62.684zm6.516 6.516q-.972 0-1.62-.684-.684-.684-.684-1.62t.684-1.62q4.032-4.104 4.032-9.792t-4.032-9.792q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q5.4 5.4 5.4 13.032t-5.4 13.032q-.648.684-1.62.684zm6.516 6.516q-.972 0-1.62-.684-.684-.684-.684-1.62t.684-1.62q3.24-3.276 4.986-7.488t1.746-8.82-1.746-8.82-4.986-7.488q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q3.924 3.924 6.012 8.964t2.088 10.584-2.088 10.584-6.012 8.964q-.648.684-1.62.684z",
		"BRAILLE": "M6.912-21.815q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm0-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm27.648 18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm-18.432-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm0-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm-57.6 42.624q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm46.08 36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-27.648-36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm46.08 36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896z",
		"ASSISTIVE_LISTENING_SYSTEMS": "M4.608-2.231q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm6.912-6.912q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm1.62-13.14l9.216 9.216-3.24 3.24-9.216-9.216zm12.204-.684q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm25.452-11.52q0 2.124-.414 3.906t-1.35 3.366-1.584 2.43-1.908 2.322q-1.116 1.26-1.638 1.944t-1.206 1.8-.954 2.304-.27 2.664q0 5.724-4.05 9.774t-9.774 4.05q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684q3.816 0 6.516-2.7t2.7-6.516q0-2.052.414-3.798t1.332-3.276 1.566-2.394 1.872-2.268q1.44-1.656 2.142-2.592t1.35-2.682.648-3.726q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-4.212 1.638-8.046t4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046zm-18.54 4.608q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm10.368-4.608q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-3.348-2.358-5.706t-5.706-2.358q-3.312 0-5.688 2.358t-2.376 5.706q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-5.256 3.708-8.964t8.964-3.708 8.964 3.708 3.708 8.964zm14.184-10.404q.36.9-.036 1.764t-1.296 1.224q-.324.144-.828.144-.684 0-1.278-.396t-.846-1.08q-2.448-6.408-8.064-10.62-.756-.576-.9-1.512t.432-1.692q.612-.756 1.548-.9t1.692.432q6.588 4.932 9.576 12.636zm7.56-2.916q.324.9-.054 1.764t-1.278 1.224q-.396.144-.828.144-1.584 0-2.16-1.476-3.312-8.568-10.692-14.148-.792-.576-.918-1.512t.45-1.692q.576-.792 1.512-.918t1.692.45q8.46 6.3 12.276 16.164z",
		"ASL_INTERPRETING": "M37.152-29.879q-2.124-.072-3.024-1.98-.612-1.224-1.728-1.926t-2.448-.702q-1.908 0-3.258 1.35t-1.35 3.258q0 2.016 1.296 3.204l.36.288q1.224 1.116 2.952 1.116 1.332 0 2.448-.702t1.728-1.926q.9-1.908 3.024-1.98zm20.448-4.608q0-2.016-1.296-3.204l-.36-.288q-1.224-1.116-2.952-1.116-1.332 0-2.448.702t-1.728 1.926q-.9 1.908-3.024 1.98 2.124.072 3.024 1.98.612 1.224 1.728 1.926t2.448.702q1.908 0 3.258-1.35t1.35-3.258zm-15.336-7.956q-.612 1.26-1.98 1.728t-2.628-.144q-2.232-1.116-4.824-1.116-1.836 0-3.564.612l.342-.018.342-.018q3.312 0 6.138 1.8t4.266 4.788q.612 1.296.126 2.646t-1.782 1.962q-.648.324-1.404.324.756 0 1.404.324 1.296.612 1.782 1.962t-.126 2.646q-1.44 2.988-4.266 4.788t-6.138 1.8h-.216q-.576-.072-1.584-.144l-10.44-.972-8.604 4.32q-.504.252-1.044.252-1.44 0-2.052-1.26l-5.76-11.52q-.396-.828-.144-1.71t1.044-1.35l7.524-4.284 5.328-9.612q.612-5.58 3.294-10.494t7.038-8.514q1.116-.9 2.538-.774t2.322 1.242.774 2.52-1.242 2.34q-2.52 2.124-4.212 4.608 4.428-3.024 9.612-3.636 1.44-.18 2.574.684t1.278 2.304q.18 1.44-.684 2.574t-2.304 1.278q-3.024.36-5.724 1.98 1.656-.36 3.564-.36 4.14 0 7.848 1.8 1.296.648 1.764 1.998t-.18 2.646zm34.668-5.76l5.76 11.52q.396.828.144 1.71t-1.044 1.35l-7.524 4.284-5.328 9.612q-.612 5.58-3.294 10.494t-7.038 8.514q-.936.792-2.196.792-1.62 0-2.664-1.26-.9-1.116-.774-2.52t1.242-2.34q2.52-2.124 4.212-4.608-4.428 3.024-9.612 3.636-.144.036-.432.036-1.296 0-2.286-.864t-1.134-2.16q-.18-1.44.684-2.574t2.304-1.278q3.024-.36 5.724-1.98-1.656.36-3.564.36-4.14 0-7.848-1.8-1.296-.648-1.764-1.998t.18-2.646q.612-1.26 1.98-1.728t2.628.144q2.232 1.116 4.824 1.116 1.836 0 3.564-.612l-.342.018-.342.018q-3.312 0-6.138-1.8t-4.266-4.788q-.612-1.296-.126-2.646t1.782-1.962q.648-.324 1.404-.324-.756 0-1.404-.324-1.296-.612-1.782-1.962t.126-2.646q1.44-2.988 4.266-4.788t6.138-1.8h.252q.504.072 1.512.144l10.476.972 8.604-4.32q.504-.252 1.044-.252 1.44 0 2.052 1.26z",
		"HARD_OF_HEARING": "M38.016-34.487q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-5.256-3.708-8.964t-8.964-3.708-8.964 3.708-3.708 8.964q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-3.348 2.376-5.706t5.688-2.358 5.688 2.358 2.376 5.706zm-7.956-20.736q-4.212 0-8.046 1.638t-6.624 4.428-4.428 6.624-1.638 8.046q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394q0 1.98-.648 3.726t-1.35 2.682-2.142 2.592q-1.224 1.404-1.872 2.268t-1.566 2.394-1.332 3.276-.414 3.798q0 3.816-2.7 6.516t-6.516 2.7q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684q5.724 0 9.774-4.05t4.05-9.774q0-1.476.27-2.664t.954-2.304 1.206-1.8 1.638-1.944q1.26-1.476 1.908-2.322t1.584-2.43 1.35-3.366.414-3.906q0-4.212-1.638-8.046t-4.428-6.624-6.624-4.428-8.046-1.638zm-8.784 25.884l8.136 8.136-20.844 20.844q-.432.432-1.044.432t-1.044-.432l-6.048-6.048q-.432-.432-.432-1.044t.432-1.044zm36.756-34.668l6.048 6.048q.432.432.432 1.044t-.432 1.08l-8.388 8.388-.936.9-2.556 2.556q-2.376-5.508-7.02-9.288l3.276-3.276 7.452-7.452q.468-.432 1.08-.432t1.044.432z",
		"GLIDE": "M31.176-45.899q0 .972-.468 3.384-.396 1.8-1.134 5.4t-1.098 5.4q-.072.396-.162.45t-.486.09q-.72.072-1.116.072-2.088 0-3.024-1.782t-.936-4.086q0-3.168 1.26-6.264t3.708-4.464q1.008-.504 1.836-.504 1.008 0 1.314.594t.306 1.71zm17.496 15.264q0-.504-1.404-2.718t-1.872-2.394q-.756-.288-1.224-.288-3.276 0-8.136 2.772l-.072-.072q.108-.792.99-4.86t.882-6.408q0-8.388-8.712-8.388-.864 0-2.448.216-3.384.612-6.066 3.222t-4.014 5.994-1.332 6.804q0 5.256 2.898 8.1t8.19 2.844q.9 0 .9.108t-.036.18q-.144 1.224-.936 4.212-.504 1.872-1.854 3.636t-2.97 1.764q-1.512 0-1.512-1.692 0-.864.378-1.71t.9-1.422 1.062-1.026.936-.72.396-.306q0-.108-.252-.36-.864-.792-2.106-1.314t-2.358-.522q-1.26 0-2.286 1.224t-1.476 2.7-.45 2.7q0 3.168 1.854 5.112t4.986 1.944q2.952 0 5.58-1.908t4.23-4.536 2.358-5.508q.216-.792.558-2.394t.522-2.394q.108-.432.504-.648 4.248-2.16 8.172-2.16 1.728 0 4.572.648l.144.036q.18 0 .342-.162t.162-.306zm6.624-18.828v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"GLIDE_G": "M26.784-53.459q0-.864-.072-1.386t-.306-1.08-.756-.828-1.35-.27q-1.404 0-2.808.828-3.78 2.088-5.724 6.858t-1.944 9.702q0 1.584.306 3.078t.954 2.898 1.89 2.25 2.934.846q.144 0 .648.018t.72 0 .576-.108.54-.306.252-.576q.576-2.772 1.728-8.334t1.728-8.334q.684-3.276.684-5.256zm27.144 23.616q0 .252-.27.486t-.558.234l-.216-.036q-.792-.108-2.232-.396t-2.592-.45-2.268-.162q-6.012 0-12.636 3.348-.54.288-.756.972-.36 1.296-.882 3.798t-.81 3.618q-.828 3.276-2.52 6.462t-4.05 5.922-5.562 4.428-6.66 1.692q-4.86 0-7.722-3.006t-2.862-7.902q0-1.908.702-4.212t2.268-4.194 3.51-1.89q1.368 0 4.32 1.206t2.988 2.214q0 .036-.594.45t-1.422 1.116-1.656 1.602-1.404 2.196-.576 2.664q0 1.188.594 1.908t1.746.72q1.62 0 3.06-1.134t2.394-2.808 1.728-3.798 1.17-3.852.576-3.24v-.324q0-.072-.126-.126t-.306-.054h-.36l-.36.018-.216.018q-8.172 0-12.672-4.41t-4.5-12.546q0-3.888 1.242-7.956t3.456-7.56 5.616-6.03 7.362-3.222q1.872-.324 3.816-.324 13.464 0 13.464 12.96 0 3.528-1.368 9.828t-1.548 7.596l.108.108q3.636-2.052 6.57-3.168t6.03-1.116q.792 0 1.908.468.684.252 2.88 3.69t2.196 4.194z",
		"SIGNING": "M29.916-40.211q1.152 0 2.124.648l7.992 5.328q2.196 1.44 3.96 3.492l5.256 6.12q1.44 1.656 1.044 3.816l-2.592 14.868q-.216 1.152-1.062 1.926t-1.998.918l-18.972 2.016-12.672 1.152h-.324q-1.404 0-2.43-1.008t-1.026-2.448q0-1.332.972-2.304t2.34-1.152l9.36-1.152h-16.128q-1.476 0-2.502-1.08t-.954-2.556q.072-1.404 1.152-2.34t2.484-.936l15.912-.036-18.756-2.304q-1.476-.18-2.376-1.332t-.684-2.628q.216-1.26 1.242-2.07t2.358-.81h.36l17.316 2.16-12.636-3.384q-1.368-.36-2.232-1.494t-.648-2.466q.216-1.296 1.188-2.106t2.232-.81q.216 0 .72.072l16.128 3.456 7.812 1.332.108.018.108.018q.828 0 1.098-.828t-.45-1.296l-6.696-4.5q-1.26-.828-1.512-2.286t.648-2.646q.972-1.368 2.736-1.368zm-2.52 7.272l6.696 4.5-7.848-1.332-.18-.072-1.296-1.368-8.568-9.432-.09-.126-.09-.126q-.864-1.116-.666-2.52t1.35-2.304q1.116-.828 2.448-.63t2.304 1.206l5.112 5.292-.144.144-.18.144q-1.152 1.62-.828 3.564t1.98 3.06zm31.932-16.344l.54 9.576q.144 2.628-.396 5.292l-1.728 7.884q-.432 2.124-2.412 3.132l-3.816 1.944q.072-2.232-1.404-3.924l-5.256-6.12q-1.908-2.196-4.212-3.708l-7.992-5.328q-1.224-.828-2.736-.828-1.836 0-3.168 1.332l-8.46-11.232q-.9-1.188-.648-2.646t1.476-2.286q1.188-.792 2.574-.504t2.25 1.44l9.576 12.672-9.432-16.38q-.756-1.26-.378-2.7t1.71-2.124q1.26-.648 2.61-.216t2.07 1.656l8.676 15.12-4.896-12.132q-.54-1.26-.162-2.664t1.602-2.016q1.332-.684 2.736-.216t2.016 1.836l6.948 14.94 3.636 7.056q.288.54.828.63t.972-.27.396-.936l-.432-8.064q-.072-1.476.936-2.556t2.484-1.116q1.404 0 2.412 1.026t1.08 2.43z",
		"LOW_VISION": "M12.06-15.623q-.072 0-.216-.072-3.096-2.052-6.066-5.22t-5.022-6.48q-.756-1.08-.756-2.484 0-.324.072-.684t.144-.648.252-.648.306-.576.378-.612.36-.54.432-.558.396-.522q6.624-9.036 16.272-13.14-3.96-7.128-3.96-7.596 0-.684.612-1.044 4.176-2.304 4.608-2.304.648 0 1.008.576l4.464 8.244q3.312-.684 6.912-.684 9.576 0 17.91 4.95t13.626 13.302q.72 1.116.72 2.484t-.72 2.484q-3.276 5.112-7.866 9.126t-10.026 6.318q3.96 7.128 3.96 7.596 0 .72-.612 1.044-4.176 2.304-4.572 2.304-.684 0-1.044-.576l-4.464-8.244-2.304-4.284-15.984-29.52.252-.252q-2.088.864-3.564 1.692.108.18 4.572 8.424t8.748 16.164 4.284 8.028q0 .252-.324.324-.468.108-2.592.108-2.052 0-2.16-.252l-16.416-30.276q-1.404 1.008-2.952 2.448.864 1.548 7.704 14.166t6.84 12.762q0 .36-.396.36-.504 0-2.97-.792t-2.61-1.008l-3.816-7.092-8.064-14.868q-1.584 1.908-2.808 3.816.072.108.648.9t.828 1.224l6.336 11.772q0 .36-.36.36zm29.88-3.672l1.764 3.276q9.828-3.996 16.2-13.86-6.48-9.972-16.524-14.004 2.412 2.304 3.708 5.346t1.296 6.354q0 3.816-1.692 7.218t-4.752 5.67zm-11.412-22.104q0 .72.504 1.224t1.224.504q3.096 0 5.292 2.196t2.196 5.292q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-4.536-3.204-7.74t-7.74-3.204q-.72 0-1.224.504t-.504 1.224zm13.176-2.34l-.324-.144.252.252z",
		"VIADEO": "M37.8-24.623q0 7.74-5.292 13.464-5.328 5.796-13.608 5.796-8.352 0-13.608-5.796-5.292-5.724-5.292-13.464 0-5.292 2.448-9.738t6.804-7.074 9.648-2.628q3.456 0 6.552 1.116-1.152 2.232-1.404 4.536-2.376-1.008-5.148-1.008-6.012 0-10.098 4.428t-4.086 10.476q0 6.12 4.05 10.386t10.134 4.266 10.116-4.266 4.032-10.386q0-3.204-1.152-5.976 2.376-.468 4.428-1.764 1.476 3.528 1.476 7.632zm-7.344-6.804q0 6.912-2.862 12.42t-8.586 9.108l-.504.036q-1.044 0-2.232-.18 2.988-1.152 5.274-3.69t3.582-5.562 2.106-6.804 1.08-6.93.27-6.426q0-2.484-.108-3.708 1.98 5.76 1.98 11.736zm-1.98-11.808v.072q-2.628-7.704-7.416-15.84 3.168 2.124 5.13 6.714t2.286 9.054zm8.784 7.308q-2.988 0-5.76-2.7 7.848-4.32 10.44-8.892.684-1.332.756-2.016-1.512 3.384-5.022 5.994t-7.362 3.51q-1.26-1.944-1.26-4.068 0-1.332.612-2.844t1.548-2.448q1.656-1.584 5.652-2.664 2.124-.576 3.816-2.106t2.664-3.618q2.664 3.78 2.664 9.108 0 3.924-.864 6.12-1.152 2.772-3.186 4.698t-4.698 1.926z",
		"VIADEO_SQUARE": "M37.8-26.963q0-2.808-1.008-5.292-1.476.9-3.06 1.224.792 1.8.792 4.104 0 4.212-2.772 7.146t-6.948 2.934-6.966-2.934-2.79-7.146q0-4.14 2.808-7.182t6.948-3.042q1.908 0 3.528.684.144-1.548.972-3.132-2.16-.756-4.5-.756-5.544 0-9.27 3.906t-3.726 9.486 3.726 9.396 9.27 3.816 9.27-3.834 3.726-9.378zm-6.408-12.78q.072.864.072 2.556 0 2.268-.18 4.428t-.738 4.77-1.458 4.68-2.466 3.816-3.618 2.538q.756.108 1.512.108h.36q7.884-5.004 7.884-14.796 0-4.176-1.368-8.1zm0 0q-.144-2.88-1.584-6.174t-3.528-4.698q3.312 5.616 5.112 10.872zm12.06-3.78q0-3.672-1.836-6.264-1.476 3.096-4.464 3.924-2.484.684-3.924 1.926t-1.44 3.582q0 1.44.864 2.772 2.664-.612 5.058-2.412t3.438-4.14q-.144 1.872-2.682 4.014t-4.986 3.51q1.872 1.872 3.96 1.872 1.836 0 3.24-1.332t2.16-3.24q.612-1.548.612-4.212zm11.844-5.94v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z",
		"SNAPCHAT": "M46.044-23.111q0-.792-.792-.972-2.412-.54-4.248-2.124t-2.88-3.888q-.252-.684-.252-.9 0-.54.702-.936t1.548-.612 1.548-.738.702-1.314q0-.684-.666-1.134t-1.386-.45q-.432 0-1.152.288t-1.116.288q-.144 0-.432-.072.18-3.42.18-4.104 0-2.844-.612-4.104-1.296-2.808-3.708-4.374t-5.472-1.566q-7.164 0-9.9 5.94-.612 1.26-.612 4.104 0 .684.18 4.104-.144.072-.504.072-.432 0-1.152-.27t-1.08-.27q-.756 0-1.386.432t-.63 1.152q0 .756.702 1.278t1.548.738 1.548.612.702.936q0 .216-.252.9-2.304 4.968-7.128 6.012-.792.18-.792.972 0 1.656 4.932 2.448.072.18.216.936t.414 1.098.846.342q.432 0 1.35-.162t1.422-.162q1.26 0 2.412.54t1.944 1.17 2.07 1.17 2.754.54q1.548 0 2.844-.54t2.07-1.17 1.926-1.17 2.412-.54q.504 0 1.422.144t1.386.144q.576 0 .828-.36t.396-1.08.216-.9q4.932-.792 4.932-2.448zm9.252-9.072q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z",
		"SNAPCHAT_GHOST": "M30.528-59.831q4.824-.036 8.658 2.466t5.886 6.93q.972 2.088.972 6.444 0 1.692-.324 6.876.504.252 1.008.252.648 0 1.836-.486t1.836-.486q1.044 0 2.016.648t.972 1.656q0 1.152-1.134 1.944t-2.484 1.134-2.484 1.044-1.134 1.71q0 .54.432 1.548 1.332 2.952 3.69 5.4t5.202 3.636q1.008.432 2.88.828 1.008.216 1.008 1.26 0 2.52-7.884 3.708-.252.396-.396 1.404t-.504 1.674-1.188.666q-.72 0-2.232-.234t-2.304-.234q-1.332 0-2.232.18-1.152.18-2.268.81t-2.088 1.368-2.088 1.458-2.736 1.206-3.564.486q-1.872 0-3.474-.486t-2.7-1.206-2.07-1.458-2.088-1.368-2.232-.81q-.936-.18-2.268-.18-.864 0-2.358.27t-2.106.27q-.9 0-1.26-.666t-.504-1.71-.396-1.44q-7.884-1.188-7.884-3.708 0-1.044 1.008-1.26 1.872-.396 2.88-.828 2.808-1.152 5.202-3.636t3.69-5.4q.432-1.008.432-1.548 0-1.008-1.134-1.71t-2.502-1.062-2.502-1.134-1.134-1.89q0-.972.936-1.638t1.98-.666q.54 0 1.728.468t1.908.468q.648 0 1.152-.252-.324-5.112-.324-6.84 0-4.392.972-6.48 2.304-4.932 6.192-7.128t9.504-2.268z",
		"SNAPCHAT_SQUARE": "M46.08-23.111q0-.792-.792-.972-2.412-.504-4.248-2.088t-2.88-3.924q-.252-.504-.252-.9 0-.54.702-.936t1.53-.612 1.53-.738.702-1.314q0-.684-.666-1.134t-1.386-.45q-.396 0-1.116.288t-1.152.288q-.144 0-.432-.072.18-2.268.18-4.14 0-2.808-.612-4.104-1.296-2.808-3.69-4.374t-5.49-1.566q-7.128 0-9.9 5.94-.648 1.368-.648 4.14 0 1.368.216 4.104-.36.072-.54.072-.396 0-1.134-.288t-1.098-.288q-.72 0-1.35.45t-.63 1.17q0 .756.702 1.278t1.53.738 1.53.612.702.936q0 .396-.252.9-2.304 4.968-7.128 6.012-.792.18-.792.972 0 1.692 4.968 2.484.072.18.216.936t.396 1.098.828.342q.468 0 1.386-.18t1.386-.18q1.26 0 2.43.54t1.962 1.17 2.07 1.17 2.754.54q1.548 0 2.844-.54t2.07-1.17 1.944-1.17 2.43-.54q.468 0 1.404.162t1.404.162q.54 0 .81-.342t.414-1.116.18-.882q4.968-.792 4.968-2.484zm9.216-26.352v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z"
	};

/***/ },

/***/ "abtG":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("P+fo")(__webpack_require__("vZNL"))

/***/ },

/***/ "vZNL":
/***/ function(module, exports) {

	module.exports = "var fontawesome={};fontawesome.markers={\"GLASS\":\"M61.164-57.743q0 1.26-1.548 2.808l-22.752 22.752v27.648h11.52q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h11.52v-27.648l-22.752-22.752q-1.548-1.548-1.548-2.808 0-.828.648-1.314t1.368-.63 1.548-.144h50.688q.828 0 1.548.144t1.368.63.648 1.314z\",\"MUSIC\":\"M55.296-56.375v40.32q0 1.8-1.224 3.204t-3.096 2.178-3.726 1.152-3.474.378-3.474-.378-3.726-1.152-3.096-2.178-1.224-3.204 1.224-3.204 3.096-2.178 3.726-1.152 3.474-.378q3.78 0 6.912 1.404v-19.332l-27.648 8.532v25.524q0 1.8-1.224 3.204t-3.096 2.178-3.726 1.152-3.474.378-3.474-.378-3.726-1.152-3.096-2.178-1.224-3.204 1.224-3.204 3.096-2.178 3.726-1.152 3.474-.378q3.78 0 6.912 1.404v-34.812q0-1.116.684-2.034t1.764-1.278l29.952-9.216q.432-.144 1.008-.144 1.44 0 2.448 1.008t1.008 2.448z\",\"SEARCH\":\"M41.472-34.487q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.872-1.368 3.24t-3.24 1.368q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z\",\"ENVELOPE_O\":\"M59.904-10.295v-27.648q-1.152 1.296-2.484 2.376-9.648 7.416-15.336 12.168-1.836 1.548-2.988 2.412t-3.114 1.746-3.69.882h-.072q-1.728 0-3.69-.882t-3.114-1.746-2.988-2.412q-5.688-4.752-15.336-12.168-1.332-1.08-2.484-2.376v27.648q0 .468.342.81t.81.342h52.992q.468 0 .81-.342t.342-.81zm0-37.836v-.882l-.018-.468-.108-.45-.198-.324-.324-.27-.504-.09h-52.992q-.468 0-.81.342t-.342.81q0 6.048 5.292 10.224 6.948 5.472 14.436 11.412.216.18 1.26 1.062t1.656 1.35 1.602 1.134 1.818.99 1.548.324h.072q.72 0 1.548-.324t1.818-.99 1.602-1.134 1.656-1.35 1.26-1.062q7.488-5.94 14.436-11.412 1.944-1.548 3.618-4.158t1.674-4.734zm4.608-1.332v39.168q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h52.992q2.376 0 4.068 1.692t1.692 4.068z\",\"HEART\":\"M32.256-4.535q-.936 0-1.584-.648l-22.464-21.672q-.36-.288-.99-.936t-1.998-2.358-2.448-3.51-1.926-4.356-.846-4.968q0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384q0 7.956-8.244 16.2l-22.428 21.6q-.648.648-1.584.648z\",\"STAR\":\"M59.904-41.147q0 .792-.936 1.728l-13.068 12.744 3.096 18q.036.252.036.72 0 .756-.378 1.278t-1.098.522q-.684 0-1.44-.432l-16.164-8.496-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476t1.764 1.476l8.1 16.38 18.072 2.628q2.016.324 2.016 1.656z\",\"STAR_O\":\"M40.932-28.295l11.016-10.692-15.192-2.232-6.804-13.752-6.804 13.752-15.192 2.232 11.016 10.692-2.628 15.156 13.608-7.164 13.572 7.164zm18.972-12.852q0 .792-.936 1.728l-13.068 12.744 3.096 18q.036.252.036.72 0 1.8-1.476 1.8-.684 0-1.44-.432l-16.164-8.496-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476t1.764 1.476l8.1 16.38 18.072 2.628q2.016.324 2.016 1.656z\",\"USER\":\"M50.688-13.859q0 4.32-2.628 6.822t-6.984 2.502h-31.464q-4.356 0-6.984-2.502t-2.628-6.822q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.324 0 1.512.774t2.682 1.728 3.888 1.728 4.806.774 4.806-.774 3.888-1.728 2.682-1.728 1.512-.774q2.196 0 4.014.72t3.078 1.926 2.232 2.916 1.548 3.51.954 3.906.504 3.924.126 3.726zm-11.52-32.148q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z\",\"FILM\":\"M13.824-6.839v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm36.864 27.648v-18.432q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm-36.864-41.472v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm50.688 41.472v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm-13.824-27.648v-18.432q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm13.824 13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm0-13.824v-4.608q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm4.608-5.76v48.384q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-48.384q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z\",\"TH_LARGE\":\"M27.648-27.575v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm0-27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm32.256 27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24zm0-27.648v13.824q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24z\",\"TH\":\"M18.432-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm-23.04-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm-23.04-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm23.04 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448z\",\"TH_LIST\":\"M18.432-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm46.08 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448zm-46.08-36.864v6.912q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448zm46.08 18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h34.56q1.44 0 2.448 1.008t1.008 2.448z\",\"CHECK\":\"M60.156-44.063q0 1.44-1.008 2.448l-26.064 26.064-4.896 4.896q-1.008 1.008-2.448 1.008t-2.448-1.008l-4.896-4.896-13.032-13.032q-1.008-1.008-1.008-2.448t1.008-2.448l4.896-4.896q1.008-1.008 2.448-1.008t2.448 1.008l10.584 10.62 23.616-23.652q1.008-1.008 2.448-1.008t2.448 1.008l4.896 4.896q1.008 1.008 1.008 2.448z\",\"TIMES\":\"M46.728-16.847q0 1.44-1.008 2.448l-4.896 4.896q-1.008 1.008-2.448 1.008t-2.448-1.008l-10.584-10.584-10.584 10.584q-1.008 1.008-2.448 1.008t-2.448-1.008l-4.896-4.896q-1.008-1.008-1.008-2.448t1.008-2.448l10.584-10.584-10.584-10.584q-1.008-1.008-1.008-2.448t1.008-2.448l4.896-4.896q1.008-1.008 2.448-1.008t2.448 1.008l10.584 10.584 10.584-10.584q1.008-1.008 2.448-1.008t2.448 1.008l4.896 4.896q1.008 1.008 1.008 2.448t-1.008 2.448l-10.584 10.584 10.584 10.584q1.008 1.008 1.008 2.448z\",\"SEARCH_PLUS\":\"M36.864-35.639v2.304q0 .468-.342.81t-.81.342h-8.064v8.064q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-8.064h-8.064q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h8.064v-8.064q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81v8.064h8.064q.468 0 .81.342t.342.81zm4.608 1.152q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.908-1.35 3.258t-3.258 1.35q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z\",\"SEARCH_MINUS\":\"M36.864-35.639v2.304q0 .468-.342.81t-.81.342h-20.736q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h20.736q.468 0 .81.342t.342.81zm4.608 1.152q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm18.432 29.952q0 1.908-1.35 3.258t-3.258 1.35q-1.944 0-3.24-1.368l-12.348-12.312q-6.444 4.464-14.364 4.464-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846q0 7.92-4.464 14.364l12.348 12.348q1.332 1.332 1.332 3.24z\",\"POWER_OFF\":\"M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196-10.728-2.196-8.82-5.904-5.904-8.82-2.196-10.728q0-6.552 2.898-12.348t8.154-9.72q1.548-1.152 3.438-.9t3.006 1.8q1.152 1.512.882 3.402t-1.782 3.042q-3.528 2.664-5.454 6.516t-1.926 8.208q0 3.744 1.458 7.146t3.942 5.886 5.886 3.942 7.146 1.458 7.146-1.458 5.886-3.942 3.942-5.886 1.458-7.146q0-4.356-1.926-8.208t-5.454-6.516q-1.512-1.152-1.782-3.042t.882-3.402q1.116-1.548 3.024-1.8t3.42.9q5.256 3.924 8.154 9.72t2.898 12.348zm-23.04-27.648v23.04q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24v-23.04q0-1.872 1.368-3.24t3.24-1.368 3.24 1.368 1.368 3.24z\",\"SIGNAL\":\"M9.216-12.599v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-4.608v11.52q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-11.52q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-9.216v20.736q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-13.824v34.56q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-18.432v52.992q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-52.992q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828z\",\"GEAR\":\"M36.864-32.183q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm18.432-3.924v7.992q0 .432-.288.828t-.72.468l-6.66 1.008q-.684 1.944-1.404 3.276 1.26 1.8 3.852 4.968.36.432.36.9t-.324.828q-.972 1.332-3.564 3.888t-3.384 2.556q-.432 0-.936-.324l-4.968-3.888q-1.584.828-3.276 1.368-.576 4.896-1.044 6.696-.252 1.008-1.296 1.008h-7.992q-.504 0-.882-.306t-.414-.774l-1.008-6.624q-1.764-.576-3.24-1.332l-5.076 3.852q-.36.324-.9.324-.504 0-.9-.396-4.536-4.104-5.94-6.048-.252-.36-.252-.828 0-.432.288-.828.54-.756 1.836-2.394t1.944-2.538q-.972-1.8-1.476-3.564l-6.588-.972q-.468-.072-.756-.45t-.288-.846v-7.992q0-.432.288-.828t.684-.468l6.696-1.008q.504-1.656 1.404-3.312-1.44-2.052-3.852-4.968-.36-.432-.36-.864 0-.36.324-.828.936-1.296 3.546-3.87t3.402-2.574q.468 0 .936.36l4.968 3.852q1.584-.828 3.276-1.368.576-4.896 1.044-6.696.252-1.008 1.296-1.008h7.992q.504 0 .882.306t.414.774l1.008 6.624q1.764.576 3.24 1.332l5.112-3.852q.324-.324.864-.324.468 0 .9.36 4.644 4.284 5.94 6.12.252.288.252.792 0 .432-.288.828-.54.756-1.836 2.394t-1.944 2.538q.936 1.8 1.476 3.528l6.588 1.008q.468.072.756.45t.288.846z\",\"TRASH_O\":\"M18.432-37.943v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm9.216 0v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm9.216 0v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm4.608 26.064v-34.128h-32.256v34.128q0 .792.252 1.458t.522.972.378.306h29.952q.108 0 .378-.306t.522-.972.252-1.458zm-24.192-38.736h16.128l-1.728-4.212q-.252-.324-.612-.396h-11.412q-.36.072-.612.396zm33.408 1.152v2.304q0 .504-.324.828t-.828.324h-3.456v34.128q0 2.988-1.692 5.166t-4.068 2.178h-29.952q-2.376 0-4.068-2.106t-1.692-5.094v-34.272h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h11.124l2.52-6.012q.54-1.332 1.944-2.268t2.844-.936h11.52q1.44 0 2.844.936t1.944 2.268l2.52 6.012h11.124q.504 0 .828.324t.324.828z\",\"HOME\":\"M50.688-28.727v17.28q0 .936-.684 1.62t-1.62.684h-13.824v-13.824h-9.216v13.824h-13.824q-.936 0-1.62-.684t-.684-1.62v-17.28l.018-.108.018-.108 20.7-17.064 20.7 17.064q.036.072.036.216zm8.028-2.484l-2.232 2.664q-.288.324-.756.396h-.108q-.468 0-.756-.252l-24.912-20.772-24.912 20.772q-.432.288-.864.252-.468-.072-.756-.396l-2.232-2.664q-.288-.36-.252-.846t.396-.774l25.884-21.564q1.152-.936 2.736-.936t2.736.936l8.784 7.344v-7.02q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v14.688l7.884 6.552q.36.288.396.774t-.252.846z\",\"FILE_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08z\",\"CLOCK_O\":\"M32.256-44.855v16.128q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm14.976 12.672q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ROAD\":\"M39.996-28.583v-.144l-.864-11.52q-.036-.468-.396-.81t-.828-.342h-6.696q-.468 0-.828.342t-.396.81l-.864 11.52v.144q-.036.432.288.72t.756.288h8.784q.432 0 .756-.288t.288-.72zm27.324 16.812q0 2.628-1.656 2.628h-25.344q.468 0 .792-.342t.288-.81l-.72-9.216q-.036-.468-.396-.81t-.828-.342h-9.792q-.468 0-.828.342t-.396.81l-.72 9.216q-.036.468.288.81t.792.342h-25.344q-1.656 0-1.656-2.628 0-1.944.936-4.176l15.012-37.584q.288-.684.936-1.188t1.368-.504h12.204q-.468 0-.828.342t-.396.81l-.54 6.912q-.036.504.288.828t.792.324h5.976q.468 0 .792-.324t.288-.828l-.54-6.912q-.036-.468-.396-.81t-.828-.342h12.204q.72 0 1.368.504t.936 1.188l15.012 37.584q.936 2.232.936 4.176z\",\"DOWNLOAD\":\"M46.08-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 0q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-8.064v11.52q0 1.44-1.008 2.448t-2.448 1.008h-52.992q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h16.74l4.86 4.896q2.088 2.016 4.896 2.016t4.896-2.016l4.896-4.896h16.704q1.44 0 2.448 1.008t1.008 2.448zm-11.7-20.484q.612 1.476-.504 2.52l-16.128 16.128q-.648.684-1.62.684t-1.62-.684l-16.128-16.128q-1.116-1.044-.504-2.52.612-1.404 2.124-1.404h9.216v-16.128q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62v16.128h9.216q1.512 0 2.124 1.404z\",\"ARROW_CIRCLE_O_DOWN\":\"M40.32-31.031q0 .432-.36.864l-11.484 11.484q-.396.324-.828.324t-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-12.672q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v12.672h6.912q.504 0 .828.324t.324.828zm-12.672-20.736q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ARROW_CIRCLE_O_UP\":\"M40.248-32.903q-.288.72-1.08.72h-6.912v12.672q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-12.672h-6.912q-.504 0-.828-.324t-.324-.828q0-.432.36-.864l11.484-11.484q.396-.324.828-.324t.828.324l11.52 11.52q.54.576.252 1.26zm-12.6-18.864q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"INBOX\":\"M36.828-29.879h11.376l-.09-.288-.09-.288-7.632-17.856h-25.488l-7.632 17.856-.09.288-.09.288h11.376l3.42 6.912h11.52zm18.468 1.08v17.352q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-17.352q0-2.232.9-4.428l8.568-19.872q.36-.9 1.314-1.512t1.89-.612h29.952q.936 0 1.89.612t1.314 1.512l8.568 19.872q.9 2.196.9 4.428z\",\"PLAY_CIRCLE_O\":\"M42.624-32.183q0 1.332-1.152 1.98l-19.584 11.52q-.54.324-1.152.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-23.04q0-1.332 1.152-2.016 1.188-.648 2.304.036l19.584 11.52q1.152.648 1.152 1.98zm4.608 0q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ROTATE_RIGHT\":\"M55.296-55.223v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-1.512 0-2.124-1.44-.612-1.404.504-2.484l4.968-4.968q-5.328-4.932-12.564-4.932-3.744 0-7.146 1.458t-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458q4.284 0 8.1-1.872t6.444-5.292q.252-.36.828-.432.504 0 .9.324l4.932 4.968q.324.288.342.738t-.27.81q-3.924 4.752-9.504 7.362t-11.772 2.61q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728 2.196-10.728 5.904-8.82 8.82-5.904 10.728-2.196q5.292 0 10.242 1.998t8.802 5.634l4.68-4.644q1.044-1.116 2.52-.504 1.404.612 1.404 2.124z\",\"REFRESH\":\"M54.396-26.423q0 .18-.036.252-2.304 9.648-9.648 15.642t-17.208 5.994q-5.256 0-10.17-1.98t-8.766-5.652l-4.644 4.644q-.684.684-1.62.684t-1.62-.684-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684h16.128q.936 0 1.62.684t.684 1.62-.684 1.62l-4.932 4.932q2.556 2.376 5.796 3.672t6.732 1.296q4.824 0 9-2.34t6.696-6.444q.396-.612 1.908-4.212.288-.828 1.08-.828h6.912q.468 0 .81.342t.342.81zm.9-28.8v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62.684-1.62l4.968-4.968q-5.328-4.932-12.564-4.932-4.824 0-9 2.34t-6.696 6.444q-.396.612-1.908 4.212-.288.828-1.08.828h-7.164q-.468 0-.81-.342t-.342-.81v-.252q2.34-9.648 9.72-15.642t17.28-5.994q5.256 0 10.224 1.998t8.82 5.634l4.68-4.644q.684-.684 1.62-.684t1.62.684.684 1.62z\",\"LIST_ALT\":\"M13.824-21.815v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm41.472 18.432v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-34.56q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h34.56q.468 0 .81.342t.342.81zm4.608 25.344v-29.952q0-.468-.342-.81t-.81-.342h-52.992q-.468 0-.81.342t-.342.81v29.952q0 .468.342.81t.81.342h52.992q.468 0 .81-.342t.342-.81zm4.608-39.168v39.168q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h52.992q2.376 0 4.068 1.692t1.692 4.068z\",\"LOCK\":\"M11.52-36.791h18.432v-6.912q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v6.912zm29.952 3.456v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h1.152v-6.912q0-6.624 4.752-11.376t11.376-4.752 11.376 4.752 4.752 11.376v6.912h1.152q1.44 0 2.448 1.008t1.008 2.448z\",\"FLAG\":\"M11.52-55.223q0 2.592-2.304 3.96v45.576q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-45.576q-2.304-1.368-2.304-3.96 0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 .9-.45 1.386t-1.422.99q-7.74 4.176-13.284 4.176-2.196 0-4.446-.792t-3.906-1.728-4.158-1.728-5.13-.792q-6.912 0-16.704 5.256-.612.324-1.188.324-.936 0-1.62-.684t-.684-1.62v-26.712q0-1.152 1.116-1.98.756-.504 2.844-1.548 8.496-4.32 15.156-4.32 3.852 0 7.2 1.044t7.884 3.168q1.368.684 3.168.684 1.944 0 4.23-.756t3.96-1.692 3.168-1.692 1.962-.756q.936 0 1.62.684t.684 1.62z\",\"HEADPHONES\":\"M59.904-32.543q0 5.976-2.16 11.304l-.72 1.764-6.66 1.188q-.792 2.988-3.258 4.914t-5.634 1.926v1.152q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v1.152q2.556 0 4.68 1.278t3.348 3.438l2.448-.432q1.044-3.42 1.044-6.948 0-5.328-3.168-10.044t-8.514-7.524-11.358-2.808-11.358 2.808-8.514 7.524-3.168 10.044q0 3.528 1.044 6.948l2.448.432q1.224-2.16 3.348-3.438t4.68-1.278v-1.152q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-1.152q-3.168 0-5.634-1.926t-3.258-4.914l-6.66-1.188-.72-1.764q-2.16-5.328-2.16-11.304 0-5.436 2.412-10.476t6.444-8.73 9.576-5.886 11.52-2.196 11.52 2.196 9.576 5.886 6.444 8.73 2.412 10.476z\",\"VOLUME_OFF\":\"M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62z\",\"VOLUME_DOWN\":\"M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62zm13.824 19.584q0 2.736-1.53 5.094t-4.05 3.366q-.36.18-.9.18-.936 0-1.62-.666t-.684-1.638q0-.756.432-1.278t1.044-.9 1.224-.828 1.044-1.278.432-2.052-.432-2.052-1.044-1.278-1.224-.828-1.044-.9-.432-1.278q0-.972.684-1.638t1.62-.666q.54 0 .9.18 2.52.972 4.05 3.348t1.53 5.112z\",\"VOLUME_UP\":\"M27.648-51.767v39.168q0 .936-.684 1.62t-1.62.684-1.62-.684l-11.988-11.988h-9.432q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h9.432l11.988-11.988q.684-.684 1.62-.684t1.62.684.684 1.62zm13.824 19.584q0 2.736-1.53 5.094t-4.05 3.366q-.36.18-.9.18-.936 0-1.62-.666t-.684-1.638q0-.756.432-1.278t1.044-.9 1.224-.828 1.044-1.278.432-2.052-.432-2.052-1.044-1.278-1.224-.828-1.044-.9-.432-1.278q0-.972.684-1.638t1.62-.666q.54 0 .9.18 2.52.972 4.05 3.348t1.53 5.112zm9.216 0q0 5.508-3.06 10.17t-8.1 6.786q-.468.18-.9.18-.972 0-1.656-.684t-.684-1.62q0-1.404 1.404-2.124 2.016-1.044 2.736-1.584 2.664-1.944 4.158-4.878t1.494-6.246-1.494-6.246-4.158-4.878q-.72-.54-2.736-1.584-1.404-.72-1.404-2.124 0-.936.684-1.62t1.62-.684q.468 0 .936.18 5.04 2.124 8.1 6.786t3.06 10.17zm9.216 0q0 8.28-4.572 15.21t-12.168 10.206q-.468.18-.936.18-.936 0-1.62-.684t-.684-1.62q0-1.296 1.404-2.124.252-.144.81-.378t.81-.378q1.656-.9 2.952-1.836 4.428-3.276 6.912-8.172t2.484-10.404-2.484-10.404-6.912-8.172q-1.296-.936-2.952-1.836-.252-.144-.81-.378t-.81-.378q-1.404-.828-1.404-2.124 0-.936.684-1.62t1.62-.684q.468 0 .936.18 7.596 3.276 12.168 10.206t4.572 15.21z\",\"QRCODE\":\"M13.824-22.967v4.608h-4.608v-4.608h4.608zm0-27.648v4.608h-4.608v-4.608h4.608zm27.648 0v4.608h-4.608v-4.608h4.608zm-36.864 36.828h13.824v-13.788h-13.824v13.788zm0-27.612h13.824v-13.824h-13.824v13.824zm27.648 0h13.824v-13.824h-13.824v13.824zm-9.216 9.216v23.04h-23.04v-23.04h23.04zm18.432 18.432v4.608h-4.608v-4.608h4.608zm9.216 0v4.608h-4.608v-4.608h4.608zm0-18.432v13.824h-13.824v-4.608h-4.608v13.824h-4.608v-23.04h13.824v4.608h4.608v-4.608h4.608zm-27.648-27.648v23.04h-23.04v-23.04h23.04zm27.648 0v23.04h-23.04v-23.04h23.04z\",\"BARCODE\":\"M2.268-9.143h-2.268v-50.688h2.268v50.688zm2.268-.036h-1.152v-50.652h1.152v50.652zm3.384 0h-1.116v-50.652h1.116v50.652zm5.652 0h-1.116v-50.652h1.116v50.652zm5.652 0h-2.232v-50.652h2.232v50.652zm4.536 0h-1.116v-50.652h1.116v50.652zm2.268 0h-1.116v-50.652h1.116v50.652zm2.268 0h-1.116v-50.652h1.116v50.652zm5.652 0h-2.268v-50.652h2.268v50.652zm5.652 0h-2.268v-50.652h2.268v50.652zm4.536 0h-2.268v-50.652h2.268v50.652zm4.536 0h-2.268v-50.652h2.268v50.652zm3.384 0h-2.268v-50.652h2.268v50.652zm6.804 0h-3.384v-50.652h3.384v50.652zm2.268 0h-1.152v-50.652h1.152v50.652zm3.384.036h-2.268v-50.688h2.268v50.688z\",\"TAG\":\"M16.128-48.311q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm38.412 20.736q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-25.74-25.776q-1.368-1.332-2.322-3.636t-.954-4.212v-14.976q0-1.872 1.368-3.24t3.24-1.368h14.976q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276z\",\"TAGS\":\"M16.128-48.311q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm38.412 20.736q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-25.74-25.776q-1.368-1.332-2.322-3.636t-.954-4.212v-14.976q0-1.872 1.368-3.24t3.24-1.368h14.976q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276zm13.824 0q0 1.908-1.332 3.24l-17.676 17.712q-1.404 1.332-3.276 1.332-1.296 0-2.124-.504t-1.908-1.62l16.92-16.92q1.332-1.332 1.332-3.24 0-1.872-1.332-3.276l-25.74-25.704q-1.368-1.368-3.672-2.322t-4.212-.954h8.064q1.908 0 4.212.954t3.672 2.322l25.74 25.704q1.332 1.404 1.332 3.276z\",\"BOOK\":\"M59.004-47.231q1.44 2.052.648 4.644l-9.9 32.616q-.684 2.304-2.754 3.87t-4.41 1.566h-33.228q-2.772 0-5.346-1.926t-3.582-4.734q-.864-2.412-.072-4.572 0-.144.108-.972t.144-1.332q.036-.288-.108-.774t-.108-.702q.072-.396.288-.756t.594-.846.594-.846q.828-1.368 1.62-3.294t1.08-3.294q.108-.36.018-1.08t-.018-1.008q.108-.396.612-1.008t.612-.828q.756-1.296 1.512-3.312t.9-3.24q.036-.324-.09-1.152t.018-1.008q.144-.468.792-1.098t.792-.81q.684-.936 1.53-3.042t.99-3.474q.036-.288-.108-.918t-.072-.954q.072-.288.324-.648t.648-.828.612-.756q.288-.432.594-1.098t.54-1.26.576-1.296.702-1.152.954-.846 1.296-.414 1.71.198l-.036.108q1.368-.324 1.836-.324h27.396q2.664 0 4.104 2.016t.648 4.68l-9.864 32.616q-1.296 4.284-2.574 5.526t-4.626 1.242h-31.284q-.972 0-1.368.54-.396.576-.036 1.548.864 2.52 5.184 2.52h33.228q1.044 0 2.016-.558t1.26-1.494l10.8-35.532q.252-.792.18-2.052 1.368.54 2.124 1.548zm-38.304.072q-.144.468.072.81t.72.342h21.888q.468 0 .918-.342t.594-.81l.756-2.304q.144-.468-.072-.81t-.72-.342h-21.888q-.468 0-.918.342t-.594.81zm-2.988 9.216q-.144.468.072.81t.72.342h21.888q.468 0 .918-.342t.594-.81l.756-2.304q.144-.468-.072-.81t-.72-.342h-21.888q-.468 0-.918.342t-.594.81z\",\"BOOKMARK\":\"M41.904-59.831q.828 0 1.584.324 1.188.468 1.89 1.476t.702 2.232v46.404q0 1.224-.702 2.232t-1.89 1.476q-.684.288-1.584.288-1.728 0-2.988-1.152l-15.876-15.264-15.876 15.264q-1.296 1.188-2.988 1.188-.828 0-1.584-.324-1.188-.468-1.89-1.476t-.702-2.232v-46.404q0-1.224.702-2.232t1.89-1.476q.756-.324 1.584-.324h37.728z\",\"PRINT\":\"M13.824-9.143h32.256v-9.216h-32.256v9.216zm0-23.04h32.256v-13.824h-5.76q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-23.04v23.04zm41.472 2.304q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608 0v14.976q0 .468-.342.81t-.81.342h-8.064v5.76q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-8.064q-.468 0-.81-.342t-.342-.81v-14.976q0-2.844 2.034-4.878t4.878-2.034h2.304v-19.584q0-1.44 1.008-2.448t2.448-1.008h24.192q1.44 0 3.168.72t2.736 1.728l5.472 5.472q1.008 1.008 1.728 2.736t.72 3.168v9.216h2.304q2.844 0 4.878 2.034t2.034 4.878z\",\"CAMERA\":\"M34.56-40.247q4.284 0 7.326 3.042t3.042 7.326-3.042 7.326-7.326 3.042-7.326-3.042-3.042-7.326 3.042-7.326 7.326-3.042zm25.344-14.976q3.816 0 6.516 2.7t2.7 6.516v32.256q0 3.816-2.7 6.516t-6.516 2.7h-50.688q-3.816 0-6.516-2.7t-2.7-6.516v-32.256q0-3.816 2.7-6.516t6.516-2.7h8.064l1.836-4.896q.684-1.764 2.502-3.042t3.726-1.278h18.432q1.908 0 3.726 1.278t2.502 3.042l1.836 4.896h8.064zm-25.344 41.472q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"FONT\":\"M26.1-44.315l-6.12 16.2q1.188 0 4.914.072t5.778.072q.684 0 2.052-.072-3.132-9.108-6.624-16.272zm-26.1 39.78l.072-2.844q.828-.252 2.016-.45t2.052-.378 1.782-.522 1.602-1.044 1.116-1.818l8.532-22.176 10.08-26.064h4.6080000000000005q.288.504.396.756l7.38 17.28q1.188 2.808 3.816 9.27t4.104 9.882q.54 1.224 2.088 5.202t2.592 6.066q.72 1.62 1.26 2.052.684.54 3.168 1.062t3.024.738q.216 1.368.216 2.052l-.018.468-.018.468q-2.268 0-6.84-.288t-6.876-.288q-2.736 0-7.74.252t-6.408.288q0-1.548.144-2.808l4.716-1.008q.036 0 .45-.09t.558-.126.522-.162.54-.234.396-.288.324-.396.09-.504q0-.576-1.116-3.474t-2.592-6.39-1.512-3.6l-16.2-.072q-.936 2.088-2.754 7.038t-1.818 5.85q0 .792.504 1.35t1.566.882 1.746.486 2.052.306 1.476.144q.036.684.036 2.088 0 .324-.072.972-2.088 0-6.282-.36t-6.282-.36q-.288 0-.954.144t-.774.144q-2.88.504-6.768.504z\",\"BOLD\":\"M19.98-9.683q2.664 1.152 5.04 1.152 13.536 0 13.536-12.06 0-4.104-1.476-6.48-.972-1.584-2.214-2.664t-2.43-1.674-2.898-.9-3.024-.378-3.402-.072q-2.628 0-3.636.36 0 1.908-.018 5.724t-.018 5.688q0 .288-.036 2.43t-.018 3.474.162 3.006.432 2.394zm-.504-26.856q1.512.252 3.924.252 2.952 0 5.148-.468t3.96-1.602 2.682-3.222.918-5.112q0-2.52-1.044-4.41t-2.844-2.952-3.888-1.566-4.464-.504q-1.8 0-4.68.468 0 1.8.144 5.436t.144 5.472q0 .972-.018 2.88t-.018 2.844q0 1.656.036 2.484zm-19.476 32.004l.072-3.384q.54-.144 3.06-.576t3.816-.972q.252-.432.45-.972t.306-1.206.198-1.17.108-1.35.018-1.224v-2.358q0-35.352-.792-36.9-.144-.288-.792-.522t-1.602-.396-1.782-.252-1.746-.162-1.098-.108l-.144-2.988q3.528-.072 12.24-.414t13.428-.342q.828 0 2.466.018t2.43.018q2.52 0 4.914.468t4.626 1.512 3.888 2.556 2.664 3.762 1.008 4.95q0 1.872-.594 3.438t-1.404 2.592-2.322 2.07-2.628 1.62-3.024 1.44q5.544 1.26 9.234 4.824t3.69 8.928q0 3.6-1.26 6.462t-3.366 4.698-4.968 3.078-5.886 1.746-6.336.504q-1.584 0-4.752-.108t-4.752-.108q-3.816 0-11.052.396t-8.316.432z\",\"ITALIC\":\"M0-4.607l.612-3.06q.216-.072 2.934-.774t4.014-1.35q1.008-1.26 1.476-3.636.036-.252 2.232-10.404t4.104-19.566 1.872-10.674v-.9q-.864-.468-1.962-.666t-2.502-.288-2.088-.198l.684-3.708q1.188.072 4.32.234t5.382.252 4.338.09q1.728 0 3.546-.09t4.356-.252 3.546-.234q-.18 1.404-.684 3.204-1.08.36-3.654 1.026t-3.906 1.206q-.288.684-.504 1.53t-.324 1.44-.27 1.638-.234 1.512q-.972 5.328-3.15 15.102t-2.79 12.798q-.072.324-.468 2.088t-.72 3.24-.576 3.006-.216 2.07l.036.648q.612.144 6.66 1.116-.108 1.584-.576 3.564-.396 0-1.17.054t-1.17.054q-1.044 0-3.132-.36t-3.096-.36q-4.968-.072-7.416-.072-1.836 0-5.148.324t-4.356.396z\",\"TEXT_HEIGHT\":\"M62.784-13.751q1.188 0 1.512.666t-.396 1.602l-4.536 5.832q-.72.936-1.764.936t-1.764-.936l-4.536-5.832q-.72-.936-.396-1.602t1.512-.666h2.88v-36.864h-2.88q-1.188 0-1.512-.666t.396-1.602l4.536-5.832q.72-.936 1.764-.936t1.764.936l4.536 5.832q.72.936.396 1.602t-1.512.666h-2.88v36.864h2.88zm-59.868-46.044l1.944.972q.432.18 7.596.18 1.584 0 4.752-.072t4.752-.072q1.296 0 3.87.018t3.87.018h10.548q.216 0 .756.018t.738 0 .576-.108.63-.324.54-.63l1.512-.036.504.018.504.018q.072 4.032.072 12.096 0 2.88-.18 3.924-1.404.504-2.448.648-.9-1.584-1.944-4.608-.108-.324-.396-1.728t-.522-2.646-.27-1.278q-.216-.288-.432-.45t-.558-.216-.468-.09-.648-.018-.594.018q-.612 0-2.394-.018t-2.682-.018-2.304.072-2.556.216q-.324 2.916-.288 4.896 0 3.384.072 13.968t.072 16.38q0 .576-.09 2.574t0 3.294.45 2.484q1.44.756 4.464 1.53t4.32 1.35q.18 1.44.18 1.8 0 .504-.108 1.044l-1.224.036q-2.736.072-7.848-.288t-7.452-.36q-1.8 0-5.436.324t-5.472.324l-.108-1.872v-.324q.612-.972 2.214-1.548t3.546-1.044 2.808-.972q.684-1.512.684-13.788 0-3.636-.108-10.908t-.108-10.908v-4.212q0-.072.018-.558t.018-.9-.036-.918-.108-.864-.18-.504q-.396-.432-5.832-.432-1.188 0-3.348.432t-2.88.936q-.684.468-1.224 2.61t-1.134 3.996-1.53 1.926q-1.512-.936-2.016-1.584v-13.788z\",\"TEXT_WIDTH\":\"M2.916-59.795l1.944.972q.432.18 7.596.18 1.584 0 4.752-.072t4.752-.072q2.52 0 8.874-.036t10.962-.018 8.892.162q1.188.036 2.016-1.116l1.512-.036.504.018.504.018q.072 4.032.072 12.096 0 2.88-.18 3.924-1.404.504-2.448.648-.9-1.584-1.944-4.608-.108-.324-.396-1.71t-.54-2.646-.252-1.296q-.36-.468-.972-.684-.18-.072-2.376-.072-1.08 0-3.348-.036t-3.708-.036-3.384.072-3.456.252q-.324 2.916-.288 4.896l.036 5.472v-1.872q0 1.98.036 5.544t.054 6.48.018 5.508q0 .576-.09 2.574t0 3.294.45 2.484q1.44.756 4.464 1.53t4.32 1.35q.18 1.44.18 1.8 0 .504-.108 1.044l-1.224.036q-2.736.072-7.848-.288t-7.452-.36q-1.8 0-5.436.324t-5.472.324l-.108-1.872v-.324q.612-.972 2.214-1.548t3.546-1.044 2.808-.972q.252-.576.414-2.664t.216-5.238.054-5.58-.018-5.526-.018-3.204q0-.252-.09-.774t-.09-.81q0-.252.018-1.584t.036-2.628 0-2.754-.108-2.43-.234-1.152q-.396-.432-5.832-.432-1.476 0-5.868.486t-4.968.882q-.684.432-1.224 2.574t-1.134 4.014-1.53 1.944q-1.512-.936-2.016-1.584v-13.788zm44.244 46.152q.432 0 1.512.702t2.07 1.494 2.142 1.764 1.296 1.08q.936.756.936 1.764t-.936 1.764q-.144.108-1.296 1.08t-2.142 1.764-2.07 1.494-1.512.702q-.468 0-.738-.378t-.36-1.026-.09-1.206.054-1.188.054-.702h-36.864q0 .072.054.702t.054 1.188-.09 1.206-.36 1.026-.738.378q-.432 0-1.512-.702t-2.07-1.494-2.142-1.764-1.296-1.08q-.936-.756-.936-1.764t.936-1.764q.144-.108 1.296-1.08t2.142-1.764 2.07-1.494 1.512-.702q.468 0 .738.378t.36 1.026.09 1.206-.054 1.188-.054.702h36.864q0-.072-.054-.702t-.054-1.188.09-1.206.36-1.026.738-.378z\",\"ALIGN_LEFT\":\"M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62zm9.216-13.824v4.608q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-41.472q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z\",\"ALIGN_CENTER\":\"M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h32.256q.936 0 1.62.684t.684 1.62zm9.216-13.824v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm-13.824-13.824v4.608q0 .936-.684 1.62t-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h23.04q.936 0 1.62.684t.684 1.62z\",\"ALIGN_RIGHT\":\"M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-41.472q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z\",\"ALIGN_JUSTIFY\":\"M64.512-16.055v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-13.824v4.608q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62z\",\"LIST\":\"M9.216-17.207v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm55.296 27.648v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm-55.296-41.472v6.912q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81zm55.296 27.648v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81z\",\"OUTDENT\":\"M13.824-44.855v20.736q0 .468-.342.81t-.81.342q-.504 0-.828-.324l-10.368-10.368q-.324-.324-.324-.828t.324-.828l10.368-10.368q.324-.324.828-.324.468 0 .81.342t.342.81zm50.688 27.648v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81z\",\"INDENT\":\"M12.672-34.487q0 .504-.324.828l-10.368 10.368q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-20.736q0-.468.342-.81t.81-.342q.504 0 .828.324l10.368 10.368q.324.324.324.828zm51.84 17.28v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-39.168q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h39.168q.468 0 .81.342t.342.81zm0-13.824v6.912q0 .468-.342.81t-.81.342h-62.208q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h62.208q.468 0 .81.342t.342.81z\",\"VIDEO_CAMERA\":\"M64.512-51.767v39.168q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-14.508-14.508v5.976q0 4.284-3.042 7.326t-7.326 3.042h-25.344q-4.284 0-7.326-3.042t-3.042-7.326v-25.344q0-4.284 3.042-7.326t7.326-3.042h25.344q4.284 0 7.326 3.042t3.042 7.326v5.94l14.508-14.472q.648-.684 1.62-.684.432 0 .9.18 1.404.612 1.404 2.124z\",\"PICTURE_O\":\"M23.04-43.703q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm36.864 13.824v16.128h-50.688v-6.912l11.52-11.52 5.76 5.76 18.432-18.432zm3.456-25.344h-57.6q-.468 0-.81.342t-.342.81v43.776q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81v-43.776q0-.468-.342-.81t-.81-.342zm5.76 1.152v43.776q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z\",\"PENCIL\":\"M13.068-9.143l3.276-3.276-8.46-8.46-3.276 3.276v3.852h4.608v4.608h3.852zm18.828-33.408q0-.792-.792-.792-.36 0-.612.252l-19.512 19.512q-.252.252-.252.612 0 .792.792.792.36 0 .612-.252l19.512-19.512q.252-.252.252-.612zm-1.944-6.912l14.976 14.976-29.952 29.952h-14.976v-14.976zm24.588 3.456q0 1.908-1.332 3.24l-5.976 5.976-14.976-14.976 5.976-5.94q1.296-1.368 3.24-1.368 1.908 0 3.276 1.368l8.46 8.424q1.332 1.404 1.332 3.276z\",\"MAP_MARKER\":\"M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z\",\"ADJUST\":\"M27.648-12.599v-39.168q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm27.648-19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"TINT\":\"M18.432-22.967q0-1.296-.72-2.484-.036-.036-.558-.81t-.918-1.368-.9-1.584-.756-1.818q-.144-.576-.756-.576t-.756.576q-.252.828-.756 1.818t-.9 1.584-.918 1.368-.558.81q-.72 1.188-.72 2.484 0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm18.432-4.608q0 7.632-5.4 13.032t-13.032 5.4-13.032-5.4-5.4-13.032q0-5.22 2.916-9.9.216-.324 2.25-3.258t3.636-5.436 3.582-6.408 2.988-7.254q.324-1.08 1.224-1.692t1.836-.612 1.854.612 1.206 1.692q1.008 3.348 2.988 7.254t3.582 6.408 3.636 5.436 2.25 3.258q2.916 4.572 2.916 9.9z\",\"PENCIL_SQUARE_O\":\"M31.968-21.815l4.176-4.176-5.472-5.472-4.176 4.176v2.016h3.456v3.456h2.016zm15.84-25.92q-.576-.576-1.188.036l-12.6 12.6q-.612.612-.036 1.188t1.188-.036l12.6-12.6q.612-.612.036-1.188zm2.88 21.384v6.84q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q2.268 0 4.212.9.54.252.648.828.108.612-.324 1.044l-1.764 1.764q-.504.504-1.152.288-.828-.216-1.62-.216h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-4.536q0-.468.324-.792l2.304-2.304q.54-.54 1.26-.252t.72 1.044zm-3.456-26.568l10.368 10.368-24.192 24.192h-10.368v-10.368zm15.984 4.752l-3.312 3.312-10.368-10.368 3.312-3.312q1.008-1.008 2.448-1.008t2.448 1.008l5.472 5.472q1.008 1.008 1.008 2.448t-1.008 2.448z\",\"SHARE_SQUARE_O\":\"M50.688-28.835v9.324q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h9.18q.468 0 .81.342t.342.81q0 .972-.936 1.152-2.772.936-4.788 2.16-.36.144-.576.144h-4.032q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-7.704q0-.684.648-1.044 1.008-.468 1.944-1.332.576-.576 1.26-.288.756.324.756 1.044zm8.532-17.856l-13.824 13.824q-.648.684-1.62.684-.432 0-.9-.18-1.404-.612-1.404-2.124v-6.912h-5.76q-11.628 0-15.768 4.716-4.284 4.932-2.664 17.028.108.828-.72 1.224-.288.072-.432.072-.576 0-.936-.468-.36-.504-.756-1.116t-1.422-2.466-1.782-3.582-1.386-4.104-.63-4.392q0-1.764.126-3.276t.504-3.24 1.008-3.168 1.692-2.934 2.466-2.664 3.402-2.214 4.482-1.746 5.742-1.098 7.074-.396h5.76v-6.912q0-1.512 1.404-2.124.468-.18.9-.18.936 0 1.62.684l13.824 13.824q.684.684.684 1.62t-.684 1.62z\",\"CHECK_SQUARE_O\":\"M50.688-30.959v11.448q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q2.268 0 4.212.9.54.252.648.828.108.612-.324 1.044l-1.764 1.764q-.36.36-.828.36-.108 0-.324-.072-.828-.216-1.62-.216h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-9.144q0-.468.324-.792l2.304-2.304q.36-.36.828-.36.216 0 .432.108.72.288.72 1.044zm8.316-17.604l-29.304 29.304q-.864.864-2.052.864t-2.052-.864l-15.48-15.48q-.864-.864-.864-2.052t.864-2.052l3.96-3.96q.864-.864 2.052-.864t2.052.864l9.468 9.468 23.292-23.292q.864-.864 2.052-.864t2.052.864l3.96 3.96q.864.864.864 2.052t-.864 2.052z\",\"ARROWS\":\"M64.512-32.183q0 .936-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684-.684-1.62v-4.608h-13.824v13.824h4.608q.936 0 1.62.684t.684 1.62-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62 1.62-.684h4.608v-13.824h-13.824v4.608q0 .936-.684 1.62t-1.62.684-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684.684 1.62v4.608h13.824v-13.824h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684l9.216 9.216q.684.684.684 1.62t-.684 1.62-1.62.684h-4.608v13.824h13.824v-4.608q0-.936.684-1.62t1.62-.684 1.62.684l9.216 9.216q.684.684.684 1.62z\",\"STEP_BACKWARD\":\"M35.244-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v24.408q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v24.408q.144-.396.468-.684z\",\"FAST_BACKWARD\":\"M62.892-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v25.56q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.324-.324-.468-.684v24.408q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v24.408q.144-.396.468-.684l25.56-25.56q.684-.684 1.152-.468t.468 1.152v25.56q.144-.396.468-.684z\",\"BACKWARD\":\"M58.284-59.363q.684-.684 1.152-.468t.468 1.152v52.992q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.288-.324-.468-.684v25.56q0 .936-.468 1.152t-1.152-.468l-25.56-25.56q-.684-.684-.684-1.62t.684-1.62l25.56-25.56q.684-.684 1.152-.468t.468 1.152v25.56q.18-.396.468-.684z\",\"PLAY\":\"M49.824-31.067l-47.808 26.568q-.828.468-1.422.108t-.594-1.296v-52.992q0-.936.594-1.296t1.422.108l47.808 26.568q.828.468.828 1.116t-.828 1.116z\",\"PAUSE\":\"M55.296-57.527v50.688q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h18.432q.936 0 1.62.684t.684 1.62zm-32.256 0v50.688q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h18.432q.936 0 1.62.684t.684 1.62z\",\"STOP\":\"M55.296-57.527v50.688q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z\",\"FORWARD\":\"M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-25.56q0-.936.468-1.152t1.152.468l25.56 25.56q.684.684.684 1.62t-.684 1.62l-25.56 25.56q-.684.684-1.152.468t-.468-1.152v-25.56q-.18.36-.468.684z\",\"FAST_FORWARD\":\"M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-25.56q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-24.408q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v50.688q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-24.408q-.18.36-.468.684l-25.56 25.56q-.684.684-1.152.468t-.468-1.152v-25.56q-.18.36-.468.684z\",\"STEP_FORWARD\":\"M1.62-5.003q-.684.684-1.152.468t-.468-1.152v-52.992q0-.936.468-1.152t1.152.468l25.56 25.56q.288.288.468.684v-24.408q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v50.688q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-24.408q-.18.36-.468.684z\",\"EJECT\":\"M.504-29.195l25.56-25.56q.684-.684 1.62-.684t1.62.684l25.56 25.56q.684.684.468 1.152t-1.152.468h-52.992q-.936 0-1.152-.468t.468-1.152zm52.524 20.052h-50.688q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684z\",\"CHEVRON_LEFT\":\"M42.156-53.603l-19.116 19.116 19.116 19.116q.684.684.684 1.62t-.684 1.62l-5.976 5.976q-.684.684-1.62.684t-1.62-.684l-26.712-26.712q-.684-.684-.684-1.62t.684-1.62l26.712-26.712q.684-.684 1.62-.684t1.62.684l5.976 5.976q.684.684.684 1.62t-.684 1.62z\",\"CHEVRON_RIGHT\":\"M39.852-32.867l-26.712 26.712q-.684.684-1.62.684t-1.62-.684l-5.976-5.976q-.684-.684-.684-1.62t.684-1.62l19.116-19.116-19.116-19.116q-.684-.684-.684-1.62t.684-1.62l5.976-5.976q.684-.684 1.62-.684t1.62.684l26.712 26.712q.684.684.684 1.62t-.684 1.62z\",\"PLUS_CIRCLE\":\"M43.776-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-9.216v-9.216q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v9.216h-9.216q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h9.216v9.216q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-9.216h9.216q.936 0 1.62-.684t.684-1.62zm11.52-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"MINUS_CIRCLE\":\"M43.776-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-27.648q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h27.648q.936 0 1.62-.684t.684-1.62zm11.52-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"TIMES_CIRCLE\":\"M41.364-24.047q0-.936-.684-1.62l-6.516-6.516 6.516-6.516q.684-.684.684-1.62 0-.972-.684-1.656l-3.24-3.24q-.684-.684-1.656-.684-.936 0-1.62.684l-6.516 6.516-6.516-6.516q-.684-.684-1.62-.684-.972 0-1.656.684l-3.24 3.24q-.684.684-.684 1.656 0 .936.684 1.62l6.516 6.516-6.516 6.516q-.684.684-.684 1.62 0 .972.684 1.656l3.24 3.24q.684.684 1.656.684.936 0 1.62-.684l6.516-6.516 6.516 6.516q.684.684 1.62.684.972 0 1.656-.684l3.24-3.24q.684-.684.684-1.656zm13.932-8.136q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CHECK_CIRCLE\":\"M46.224-38.015q0-1.008-.648-1.656l-3.276-3.24q-.684-.684-1.62-.684t-1.62.684l-14.688 14.652-8.136-8.136q-.684-.684-1.62-.684t-1.62.684l-3.276 3.24q-.648.648-.648 1.656 0 .972.648 1.62l13.032 13.032q.684.684 1.62.684.972 0 1.656-.684l19.548-19.548q.648-.648.648-1.62zm9.072 5.832q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"QUESTION_CIRCLE\":\"M32.256-14.903v-6.912q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828zm9.216-24.192q0-3.168-1.998-5.868t-4.986-4.176-6.12-1.476q-8.748 0-13.356 7.668-.54.864.288 1.512l4.752 3.6q.252.216.684.216.576 0 .9-.432 1.908-2.448 3.096-3.312 1.224-.864 3.096-.864 1.728 0 3.078.936t1.35 2.124q0 1.368-.72 2.196t-2.448 1.62q-2.268 1.008-4.158 3.114t-1.89 4.518v1.296q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828q0-.684.774-1.782t1.962-1.782q1.152-.648 1.764-1.026t1.656-1.26 1.602-1.728 1.008-2.178.45-2.916zm13.824 6.912q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"INFO_CIRCLE\":\"M36.864-14.903v-5.76q0-.504-.324-.828t-.828-.324h-3.456v-18.432q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h3.456v11.52h-3.456q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h16.128q.504 0 .828-.324t.324-.828zm-4.608-32.256v-5.76q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v5.76q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828zm23.04 14.976q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CROSSHAIRS\":\"M43.092-27.575h-3.924q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h3.924q-1.152-3.888-4.05-6.786t-6.786-4.05v3.924q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-3.924q-3.888 1.152-6.786 4.05t-4.05 6.786h3.924q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-3.924q1.152 3.888 4.05 6.786t6.786 4.05v-3.924q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v3.924q3.888-1.152 6.786-4.05t4.05-6.786zm12.204-6.912v4.608q0 .936-.684 1.62t-1.62.684h-5.148q-1.332 5.796-5.562 10.026t-10.026 5.562v5.148q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-5.148q-5.796-1.332-10.026-5.562t-5.562-10.026h-5.148q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h5.148q1.332-5.796 5.562-10.026t10.026-5.562v-5.148q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v5.148q5.796 1.332 10.026 5.562t5.562 10.026h5.148q.936 0 1.62.684t.684 1.62z\",\"TIMES_CIRCLE_O\":\"M39.492-25.595l-5.256 5.256q-.36.36-.828.36t-.828-.36l-4.932-4.932-4.932 4.932q-.36.36-.828.36t-.828-.36l-5.256-5.256q-.36-.36-.36-.828t.36-.828l4.932-4.932-4.932-4.932q-.36-.36-.36-.828t.36-.828l5.256-5.256q.36-.36.828-.36t.828.36l4.932 4.932 4.932-4.932q.36-.36.828-.36t.828.36l5.256 5.256q.36.36.36.828t-.36.828l-4.932 4.932 4.932 4.932q.36.36.36.828t-.36.828zm7.74-6.588q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CHECK_CIRCLE_O\":\"M42.156-35.171l-15.192 15.192q-.684.684-1.62.684t-1.62-.684l-10.584-10.584q-.684-.684-.684-1.62t.684-1.62l3.672-3.672q.684-.684 1.62-.684t1.62.684l5.292 5.292 9.9-9.9q.684-.684 1.62-.684t1.62.684l3.672 3.672q.684.684.684 1.62t-.684 1.62zm5.076 2.988q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"BAN\":\"M47.232-32.291q0-5.796-3.132-10.62l-27.144 27.108q4.932 3.204 10.692 3.204 3.996 0 7.614-1.566t6.246-4.194 4.176-6.282 1.548-7.65zm-35.964 10.764l27.18-27.144q-4.86-3.276-10.8-3.276-5.328 0-9.828 2.628t-7.128 7.164-2.628 9.864q0 5.832 3.204 10.764zm44.028-10.764q0 5.652-2.196 10.8t-5.886 8.856-8.82 5.904-10.746 2.196-10.746-2.196-8.82-5.904-5.886-8.856-2.196-10.8 2.196-10.782 5.886-8.838 8.82-5.904 10.746-2.196 10.746 2.196 8.82 5.904 5.886 8.838 2.196 10.782z\",\"ARROW_LEFT\":\"M55.296-32.183v4.608q0 1.908-1.17 3.258t-3.042 1.35h-25.344l10.548 10.584q1.368 1.296 1.368 3.24t-1.368 3.24l-2.7 2.736q-1.332 1.332-3.24 1.332-1.872 0-3.276-1.332l-23.436-23.472q-1.332-1.332-1.332-3.24 0-1.872 1.332-3.276l23.436-23.4q1.368-1.368 3.276-1.368 1.872 0 3.24 1.368l2.7 2.664q1.368 1.368 1.368 3.276t-1.368 3.276l-10.548 10.548h25.344q1.872 0 3.042 1.35t1.17 3.258z\",\"ARROW_RIGHT\":\"M52.992-29.879q0 1.944-1.332 3.276l-23.436 23.436q-1.404 1.332-3.276 1.332-1.836 0-3.24-1.332l-2.7-2.7q-1.368-1.368-1.368-3.276t1.368-3.276l10.548-10.548h-25.344q-1.872 0-3.042-1.35t-1.17-3.258v-4.608q0-1.908 1.17-3.258t3.042-1.35h25.344l-10.548-10.584q-1.368-1.296-1.368-3.24t1.368-3.24l2.7-2.7q1.368-1.368 3.24-1.368 1.908 0 3.276 1.368l23.436 23.436q1.332 1.26 1.332 3.24z\",\"ARROW_UP\":\"M57.996-29.483q0 1.836-1.332 3.24l-2.7 2.7q-1.368 1.368-3.276 1.368-1.944 0-3.24-1.368l-10.584-10.548v25.344q0 1.872-1.35 3.042t-3.258 1.17h-4.608q-1.908 0-3.258-1.17t-1.35-3.042v-25.344l-10.584 10.548q-1.296 1.368-3.24 1.368t-3.24-1.368l-2.7-2.7q-1.368-1.368-1.368-3.24 0-1.908 1.368-3.276l23.436-23.436q1.26-1.332 3.24-1.332 1.944 0 3.276 1.332l23.436 23.436q1.332 1.404 1.332 3.276z\",\"ARROW_DOWN\":\"M57.996-34.487q0 1.908-1.332 3.24l-23.436 23.472q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-23.436-23.472q-1.368-1.296-1.368-3.24 0-1.908 1.368-3.276l2.664-2.7q1.404-1.332 3.276-1.332 1.908 0 3.24 1.332l10.584 10.584v-25.344q0-1.872 1.368-3.24t3.24-1.368h4.608q1.872 0 3.24 1.368t1.368 3.24v25.344l10.584-10.584q1.332-1.332 3.24-1.332 1.872 0 3.276 1.332l2.7 2.7q1.332 1.404 1.332 3.276z\",\"SHARE\":\"M64.512-41.399q0 .936-.684 1.62l-18.432 18.432q-.684.684-1.62.684t-1.62-.684-.684-1.62v-9.216h-8.064q-3.528 0-6.318.216t-5.544.774-4.788 1.53-3.798 2.502-2.88 3.636-1.746 4.986-.63 6.516q0 1.98.18 4.428 0 .216.09.846t.09.954q0 .54-.306.9t-.846.36q-.576 0-1.008-.612-.252-.324-.468-.792t-.486-1.08-.378-.864q-4.572-10.26-4.572-16.236 0-7.164 1.908-11.988 5.832-14.508 31.5-14.508h8.064v-9.216q0-.936.684-1.62t1.62-.684 1.62.684l18.432 18.432q.684.684.684 1.62z\",\"EXPAND\":\"M27.18-26.423q0 .468-.36.828l-11.952 11.952 5.184 5.184q.684.684.684 1.62t-.684 1.62-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684 1.62.684l5.184 5.184 11.952-11.952q.36-.36.828-.36t.828.36l4.104 4.104q.36.36.36.828zm28.116-31.104v16.128q0 .936-.684 1.62t-1.62.684-1.62-.684l-5.184-5.184-11.952 11.952q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l11.952-11.952-5.184-5.184q-.684-.684-.684-1.62t.684-1.62 1.62-.684h16.128q.936 0 1.62.684t.684 1.62z\",\"COMPRESS\":\"M27.648-29.879v16.128q0 .936-.684 1.62t-1.62.684-1.62-.684l-5.184-5.184-11.952 11.952q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l11.952-11.952-5.184-5.184q-.684-.684-.684-1.62t.684-1.62 1.62-.684h16.128q.936 0 1.62.684t.684 1.62zm27.18-24.192q0 .468-.36.828l-11.952 11.952 5.184 5.184q.684.684.684 1.62t-.684 1.62-1.62.684h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-.936.684-1.62t1.62-.684 1.62.684l5.184 5.184 11.952-11.952q.36-.36.828-.36t.828.36l4.104 4.104q.36.36.36.828z\",\"PLUS\":\"M50.688-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-14.976v14.976q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h14.976v-14.976q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448v14.976h14.976q1.44 0 2.448 1.008t1.008 2.448z\",\"MINUS\":\"M50.688-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-43.776q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h43.776q1.44 0 2.448 1.008t1.008 2.448z\",\"ASTERISK\":\"M53.352-26.639q1.656.936 2.142 2.79t-.45 3.51l-2.304 3.96q-.936 1.656-2.79 2.142t-3.51-.45l-9.576-5.508v11.052q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-11.052l-9.576 5.508q-1.656.936-3.51.45t-2.79-2.142l-2.304-3.96q-.936-1.656-.45-3.51t2.142-2.79l9.576-5.544-9.576-5.544q-1.656-.936-2.142-2.79t.45-3.51l2.304-3.96q.936-1.656 2.79-2.142t3.51.45l9.576 5.508v-11.052q0-1.872 1.368-3.24t3.24-1.368h4.608q1.872 0 3.24 1.368t1.368 3.24v11.052l9.576-5.508q1.656-.936 3.51-.45t2.79 2.142l2.304 3.96q.936 1.656.45 3.51t-2.142 2.79l-9.576 5.544z\",\"EXCLAMATION_CIRCLE\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm4.608 44.892v-6.84q0-.504-.324-.846t-.792-.342h-6.912q-.468 0-.828.36t-.36.828v6.84q0 .468.36.828t.828.36h6.912q.468 0 .792-.342t.324-.846zm-.072-12.384l.648-22.356q0-.432-.36-.648-.36-.288-.864-.288h-7.92q-.504 0-.864.288-.36.216-.36.648l.612 22.356q0 .36.36.63t.864.27h6.66q.504 0 .846-.27t.378-.63z\",\"GIFT\":\"M33.408-15.623v-25.775999999999996h-11.52v25.775999999999996q0 .9.648 1.386t1.656.486h6.912q1.008 0 1.656-.486t.648-1.386zm-16.416-30.384h7.02l-4.536-5.796q-.936-1.116-2.484-1.116-1.44 0-2.448 1.008t-1.008 2.448 1.008 2.448 2.448 1.008zm24.768-3.456q0-1.44-1.008-2.448t-2.448-1.008q-1.548 0-2.484 1.116l-4.5 5.796h6.984q1.44 0 2.448-1.008t1.008-2.448zm13.536 9.216v11.52q0 .504-.324.828t-.828.324h-3.456v14.976q0 1.44-1.008 2.448t-2.448 1.008h-39.168q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-3.456q-.504 0-.828-.324t-.324-.828v-11.52q0-.504.324-.828t.828-.324h15.84q-3.348 0-5.706-2.358t-2.358-5.706 2.358-5.706 5.706-2.358q3.852 0 6.048 2.772l4.608 5.94 4.608-5.94q2.196-2.772 6.048-2.772 3.348 0 5.706 2.358t2.358 5.706-2.358 5.706-5.706 2.358h15.84q.504 0 .828.324t.324.828z\",\"LEAF\":\"M46.08-39.095q0-.936-.684-1.62t-1.62-.684q-6.192 0-11.448 1.782t-9.342 4.824-8.478 7.902q-.684.756-.684 1.62 0 .936.684 1.62t1.62.684q.864 0 1.62-.684.972-.864 2.664-2.556t2.412-2.376q4.932-4.464 9.666-6.336t11.286-1.872q.936 0 1.62-.684t.684-1.62zm18.432-7.128q0 3.42-.72 6.948-1.656 8.064-6.642 13.788t-12.87 9.648q-7.704 3.888-15.768 3.888-5.328 0-10.296-1.692-.54-.18-3.168-1.512t-3.456-1.332q-.576 0-1.422 1.152t-1.62 2.52-1.89 2.52-2.16 1.152q-1.08 0-1.836-.396t-1.116-.864-.972-1.512l-.216-.396-.198-.36-.108-.342-.054-.486q0-1.26 1.116-2.646t2.448-2.358 2.448-2.016 1.116-1.728q0-.144-.504-1.368t-.576-1.584q-.324-1.836-.324-3.744 0-4.14 1.566-7.92t4.284-6.642 6.138-5.004 7.344-3.438q1.98-.648 5.22-.918t6.462-.324 6.426-.216 5.886-.864 4.086-2.034l1.062-1.062 1.062-1.008.972-.72 1.314-.576 1.566-.162q1.404 0 2.538 1.656t1.71 4.032.864 4.464.288 3.456z\",\"FIRE\":\"M50.688-3.383v2.304q0 .468-.342.81t-.81.342h-48.384q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h48.384q.468 0 .81.342t.342.81zm-9.216-38.016q0 2.808-.882 5.184t-2.304 4.05-3.15 3.168-3.456 2.79-3.15 2.592-2.304 2.934-.882 3.474q0 3.456 2.412 8.064l-.144-.036.036.036q-3.24-1.476-5.76-2.988t-4.986-3.6-4.086-4.41-2.61-5.418-.99-6.624q0-2.808.882-5.184t2.304-4.05 3.15-3.168 3.456-2.79 3.15-2.592 2.304-2.934.882-3.474q0-3.384-2.376-8.064l.108.036-.036-.036q3.24 1.476 5.76 2.988t4.986 3.6 4.086 4.41 2.61 5.418.99 6.624z\",\"EYE\":\"M59.904-29.879q-5.472-8.496-13.716-12.708 2.196 3.744 2.196 8.1 0 6.66-4.734 11.394t-11.394 4.734-11.394-4.734-4.734-11.394q0-4.356 2.196-8.1-8.244 4.212-13.716 12.708 4.788 7.38 12.006 11.754t15.642 4.374 15.642-4.374 12.006-11.754zm-25.92-13.824q0-.72-.504-1.224t-1.224-.504q-4.5 0-7.722 3.222t-3.222 7.722q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-3.096 2.196-5.292t5.292-2.196q.72 0 1.224-.504t.504-1.224zm30.528 13.824q0 1.224-.72 2.484-5.04 8.28-13.554 13.266t-17.982 4.986-17.982-5.004-13.554-13.248q-.72-1.26-.72-2.484t.72-2.484q5.04-8.244 13.554-13.248t17.982-5.004 17.982 5.004 13.554 13.248q.72 1.26.72 2.484z\",\"EYE_SLASH\":\"M19.98-16.379l2.808-5.076q-3.132-2.268-4.896-5.724t-1.764-7.308q0-4.356 2.196-8.1-8.244 4.212-13.716 12.708 6.012 9.288 15.372 13.5zm14.004-27.324q0-.72-.504-1.224t-1.224-.504q-4.5 0-7.722 3.222t-3.222 7.722q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-3.096 2.196-5.292t5.292-2.196q.72 0 1.224-.504t.504-1.224zm13.068-6.876q0 .252-.036.324-3.78 6.768-11.34 20.376t-11.376 20.412l-1.764 3.204q-.36.576-1.008.576-.432 0-4.824-2.52-.576-.36-.576-1.008 0-.432 1.584-3.132-5.148-2.34-9.486-6.228t-7.506-8.82q-.72-1.116-.72-2.484t.72-2.484q5.508-8.46 13.68-13.356t17.856-4.896q3.204 0 6.48.612l1.944-3.492q.36-.576 1.008-.576.18 0 .648.216t1.116.558 1.188.666 1.134.666.702.414q.576.36.576.972zm1.332 16.092q0 5.004-2.844 9.126t-7.524 5.922l10.08-18.072q.288 1.62.288 3.024zm16.128 4.608q0 1.26-.72 2.484-1.404 2.304-3.924 5.22-5.4 6.192-12.51 9.612t-15.102 3.42l2.664-4.752q7.632-.648 14.13-4.932t10.854-11.052q-4.14-6.444-10.152-10.584l2.268-4.032q3.42 2.304 6.57 5.508t5.202 6.624q.72 1.224.72 2.484z\",\"WARNING\":\"M36.864-14.939v-6.84q0-.504-.342-.846t-.81-.342h-6.912q-.468 0-.81.342t-.342.846v6.84q0 .504.342.846t.81.342h6.912q.468 0 .81-.342t.342-.846zm-.072-13.464l.648-16.524q0-.432-.36-.684-.468-.396-.864-.396h-7.92q-.396 0-.864.396-.36.252-.36.756l.612 16.452q0 .36.36.594t.864.234h6.66q.504 0 .846-.234t.378-.594zm-.504-33.624l27.648 50.688q1.26 2.268-.072 4.536-.612 1.044-1.674 1.656t-2.286.612h-55.296q-1.224 0-2.286-.612t-1.674-1.656q-1.332-2.268-.072-4.536l27.648-50.688q.612-1.116 1.692-1.764t2.34-.648 2.34.648 1.692 1.764z\",\"PLANE\":\"M49.536-58.679q1.584 1.872.432 5.328t-3.888 6.192l-5.796 5.796 5.76 25.056q.18.684-.432 1.188l-4.608 3.456q-.252.216-.684.216-.144 0-.252-.036-.54-.108-.756-.576l-10.044-18.288-9.324 9.324 1.908 6.984q.18.612-.288 1.116l-3.456 3.456q-.324.324-.828.324h-.072q-.54-.072-.864-.468l-6.804-9.072-9.072-6.804q-.396-.252-.468-.828-.036-.468.324-.9l3.456-3.492q.324-.324.828-.324.216 0 .288.036l6.984 1.908 9.324-9.324-18.288-10.044q-.504-.288-.612-.864-.072-.576.324-.972l4.608-4.608q.504-.468 1.08-.288l23.94 5.724 5.76-5.76q2.736-2.736 6.192-3.888t5.328.432z\",\"CALENDAR\":\"M4.608-4.535h10.368v-10.368h-10.368v10.368zm12.672 0h11.52v-10.368h-11.52v10.368zm-12.672-12.672h10.368v-11.52h-10.368v11.52zm12.672 0h11.52v-11.52h-11.52v11.52zm-12.672-13.824h10.368v-10.368h-10.368v10.368zm26.496 26.496h11.52v-10.368h-11.52v10.368zm-13.824-26.496h11.52v-10.368h-11.52v10.368zm27.648 26.496h10.368v-10.368h-10.368v10.368zm-13.824-12.672h11.52v-11.52h-11.52v11.52zm-12.672-31.104v-10.368q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v10.368q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm26.496 31.104h10.368v-11.52h-10.368v11.52zm-13.824-13.824h11.52v-10.368h-11.52v10.368zm13.824 0h10.368v-10.368h-10.368v10.368zm1.152-17.28v-10.368q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v10.368q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z\",\"RANDOM\":\"M23.976-47.123q-2.16 3.312-4.932 9.828-.792-1.62-1.332-2.61t-1.458-2.286-1.836-2.034-2.268-1.26-2.934-.522h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064q9 0 14.76 8.1zm40.536 28.764q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912q-1.152 0-3.06.018t-2.916.036-2.628-.036-2.556-.18-2.304-.378-2.268-.666-2.088-1.026-2.124-1.44-1.98-1.926-2.016-2.502q2.124-3.348 4.896-9.828.792 1.62 1.332 2.61t1.458 2.286 1.836 2.034 2.268 1.26 2.934.522h9.216v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828zm0-32.256q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-9.216q-1.728 0-3.132.54t-2.484 1.62-1.836 2.214-1.62 2.79q-1.152 2.232-2.808 6.156-1.044 2.376-1.782 3.996t-1.944 3.78-2.304 3.6-2.664 2.988-3.24 2.466-3.834 1.512-4.608.594h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064q1.728 0 3.132-.54t2.484-1.62 1.836-2.214 1.62-2.79q1.152-2.232 2.808-6.156 1.044-2.376 1.782-3.996t1.944-3.78 2.304-3.6 2.664-2.988 3.24-2.466 3.834-1.512 4.608-.594h9.216v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828z\",\"COMMENT\":\"M64.512-32.183q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792-.612.072-1.098-.324t-.63-1.044v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-4.68 2.556-8.946t6.876-7.362 10.296-4.914 12.528-1.818q8.784 0 16.2 3.078t11.736 8.388 4.32 11.574z\",\"MAGNET\":\"M55.296-34.487v4.608q0 7.236-3.546 13.032t-9.864 9.054-14.238 3.258-14.238-3.258-9.864-9.054-3.546-13.032v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62v4.608q0 1.872.846 3.24t1.926 2.052 2.556 1.08 2.304.468 1.584.072 1.584-.072 2.304-.468 2.556-1.08 1.926-2.052.846-3.24v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62zm-36.864-23.04v13.824q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62zm36.864 0v13.824q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62z\",\"CHEVRON_UP\":\"M60.588-16.523l-5.976 5.94q-.684.684-1.62.684t-1.62-.684l-19.116-19.116-19.116 19.116q-.684.684-1.62.684t-1.62-.684l-5.976-5.94q-.684-.684-.684-1.638t.684-1.638l26.712-26.676q.684-.684 1.62-.684t1.62.684l26.712 26.676q.684.684.684 1.638t-.684 1.638z\",\"CHEVRON_DOWN\":\"M60.588-35.351l-26.712 26.676q-.684.684-1.62.684t-1.62-.684l-26.712-26.676q-.684-.684-.684-1.638t.684-1.638l5.976-5.94q.684-.684 1.62-.684t1.62.684l19.116 19.116 19.116-19.116q.684-.684 1.62-.684t1.62.684l5.976 5.94q.684.684.684 1.638t-.684 1.638z\",\"RETWEET\":\"M46.08-10.295q0 .468-.342.81t-.81.342h-34.56q-.288 0-.486-.072t-.324-.252-.198-.288-.108-.414-.036-.414v-21.6h-6.912q-.936 0-1.62-.684t-.684-1.62q0-.864.54-1.476l11.52-13.824q.684-.792 1.764-.792t1.764.792l11.52 13.824q.54.612.54 1.476 0 .936-.684 1.62t-1.62.684h-6.912v13.824h20.736q.576 0 .9.396l5.76 6.912q.252.396.252.756zm23.04-14.976q0 .864-.54 1.476l-11.52 13.824q-.72.828-1.764.828t-1.764-.828l-11.52-13.824q-.54-.612-.54-1.476 0-.936.684-1.62t1.62-.684h6.912v-13.824h-20.736q-.576 0-.9-.432l-5.76-6.912q-.252-.324-.252-.72 0-.468.342-.81t.81-.342h34.56q.288 0 .486.072t.324.252.198.288.108.414.036.414v21.6h6.912q.936 0 1.62.684t.684 1.62z\",\"SHOPPING_CART\":\"M23.04-9.143q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24 1.368-3.24 3.24-1.368 3.24 1.368 1.368 3.24zm32.256 0q0 1.872-1.368 3.24t-3.24 1.368-3.24-1.368-1.368-3.24 1.368-3.24 3.24-1.368 3.24 1.368 1.368 3.24zm4.608-39.168v18.432q0 .864-.594 1.53t-1.458.774l-37.584 4.392q.468 2.16.468 2.52 0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.396.288-1.134t.576-1.296.774-1.44.558-1.062l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.702.558.468.882.288.936.198 1.062.162.936h43.236q.936 0 1.62.684t.684 1.62z\",\"FOLDER\":\"M59.904-42.551v25.344q0 3.312-2.376 5.688t-5.688 2.376h-43.776q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h24.192q3.312 0 5.688 2.376t2.376 5.688z\",\"FOLDER_OPEN\":\"M67.644-30.167q0 1.116-1.116 2.376l-12.096 14.256q-1.548 1.836-4.338 3.114t-5.166 1.278h-39.168q-1.224 0-2.178-.468t-.954-1.548q0-1.116 1.116-2.376l12.096-14.256q1.548-1.836 4.338-3.114t5.166-1.278h39.168q1.224 0 2.178.468t.954 1.548zm-12.348-12.384v5.76h-29.952q-3.384 0-7.092 1.71t-5.904 4.302l-12.132 14.256-.18.216-.018-.45-.018-.45v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h19.584q3.312 0 5.688 2.376t2.376 5.688z\",\"ARROWS_V\":\"M25.344-52.919q0 .936-.684 1.62t-1.62.684h-4.608v36.864h4.608q.936 0 1.62.684t.684 1.62-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62 1.62-.684h4.608v-36.864h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684l9.216 9.216q.684.684.684 1.62z\",\"ARROWS_H\":\"M64.512-32.183q0 .936-.684 1.62l-9.216 9.216q-.684.684-1.62.684t-1.62-.684-.684-1.62v-4.608h-36.864v4.608q0 .936-.684 1.62t-1.62.684-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62t.684-1.62l9.216-9.216q.684-.684 1.62-.684t1.62.684.684 1.62v4.608h36.864v-4.608q0-.936.684-1.62t1.62-.684 1.62.684l9.216 9.216q.684.684.684 1.62z\",\"BAR_CHART_O\":\"M23.04-32.183v18.432h-9.216v-18.432h9.216zm13.824-18.432v36.864h-9.216v-36.864h9.216zm36.864 41.472v4.608h-73.728v-55.296h4.608v50.688h69.12zm-23.04-32.256v27.648h-9.216v-27.648h9.216zm13.824-13.824v41.472h-9.216v-41.472h9.216z\",\"TWITTER_SQUARE\":\"M46.08-42.479q-2.016.9-4.356 1.224 2.448-1.44 3.348-4.212-2.34 1.368-4.824 1.836-2.196-2.376-5.508-2.376-3.132 0-5.346 2.214t-2.214 5.346q0 1.044.18 1.728-4.644-.252-8.712-2.34t-6.912-5.58q-1.044 1.8-1.044 3.816 0 4.104 3.276 6.3-1.692-.036-3.6-.936v.072q0 2.7 1.8 4.806t4.428 2.61q-1.044.288-1.836.288-.468 0-1.404-.144.756 2.268 2.682 3.744t4.374 1.512q-4.176 3.24-9.396 3.24-.936 0-1.8-.108 5.328 3.384 11.592 3.384 4.032 0 7.56-1.278t6.048-3.42 4.338-4.932 2.7-5.832.882-6.066q0-.648-.036-.972 2.268-1.62 3.78-3.924zm9.216-6.984v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"FACEBOOK_SQUARE\":\"M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-6.768v-21.42h7.164l1.08-8.352h-8.244v-5.328q0-2.016.846-3.024t3.294-1.008l4.392-.036v-7.452q-2.268-.324-6.408-.324-4.896 0-7.83 2.88t-2.934 8.136v6.156h-7.2v8.352h7.2v21.42h-19.152q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56z\",\"CAMERA_RETRO\":\"M33.408-34.487q0-.504-.324-.828t-.828-.324q-2.376 0-4.068 1.692t-1.692 4.068q0 .504.324.828t.828.324.828-.324.324-.828q0-1.44 1.008-2.448t2.448-1.008q.504 0 .828-.324t.324-.828zm8.064 4.68q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm-36.864 20.664h55.296v-4.608h-55.296v4.608zm41.472-20.664q0-5.724-4.05-9.774t-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05 9.774-4.05 4.05-9.774zm-36.864-23.112h13.824v-4.608h-13.824v4.608zm-4.608 6.912h55.296v-9.216000000000001h-29.808l-2.304 4.608h-23.184v4.608zm59.904-9.216v46.08q0 1.908-1.35 3.258t-3.258 1.35h-55.296q-1.908 0-3.258-1.35t-1.35-3.258v-46.08q0-1.908 1.35-3.258t3.258-1.35h55.296q1.908 0 3.258 1.35t1.35 3.258z\",\"KEY\":\"M29.952-46.007q0-2.88-2.016-4.896t-4.896-2.016-4.896 2.016-2.016 4.896q0 1.512.684 2.988-1.476-.684-2.988-.684-2.88 0-4.896 2.016t-2.016 4.896 2.016 4.896 4.896 2.016 4.896-2.016 2.016-4.896q0-1.512-.684-2.988 1.476.684 2.988.684 2.88 0 4.896-2.016t2.016-4.896zm30.636 25.344q0 .612-1.764 2.376t-2.376 1.764q-.324 0-1.026-.576t-1.314-1.188-1.386-1.44-.882-.936l-3.456 3.456 7.92 7.92q1.008 1.008 1.008 2.448 0 1.512-1.404 2.916t-2.916 1.404q-1.44 0-2.448-1.008l-24.156-24.156q-6.336 4.716-13.14 4.716-5.868 0-9.558-3.69t-3.69-9.558q0-5.76 3.42-11.268t8.928-8.928 11.268-3.42q5.868 0 9.558 3.69t3.69 9.558q0 6.804-4.716 13.14l12.78 12.78 3.456-3.456q-.108-.108-.936-.882t-1.44-1.386-1.188-1.314-.576-1.026q0-.612 1.764-2.376t2.376-1.764q.468 0 .828.36.216.216 1.656 1.602t2.952 2.862 3.114 3.096 2.628 2.808 1.026 1.476z\",\"GEARS\":\"M32.256-32.183q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm27.648 18.432q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm0-36.864q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258zm-13.824 15.156v6.66q0 .36-.252.702t-.576.378l-5.58.864q-.396 1.26-1.152 2.736 1.224 1.728 3.24 4.14.252.36.252.72 0 .432-.252.684-.828 1.08-2.97 3.222t-2.826 2.142q-.396 0-.756-.252l-4.14-3.24q-1.332.684-2.772 1.116-.396 3.888-.828 5.58-.252.864-1.08.864h-6.696q-.396 0-.72-.27t-.36-.63l-.828-5.508q-1.224-.36-2.7-1.116l-4.248 3.204q-.252.252-.72.252-.396 0-.756-.288-5.184-4.788-5.184-5.76 0-.324.252-.684.36-.504 1.476-1.908t1.692-2.196q-.828-1.584-1.26-2.952l-5.472-.864q-.36-.036-.612-.342t-.252-.702v-6.66q0-.36.252-.702t.576-.378l5.58-.864q.396-1.26 1.152-2.736-1.224-1.728-3.24-4.14-.252-.396-.252-.72 0-.432.252-.72.792-1.08 2.952-3.204t2.844-2.124q.396 0 .756.252l4.14 3.24q1.224-.648 2.772-1.152.396-3.888.828-5.544.252-.864 1.08-.864h6.696q.396 0 .72.27t.36.63l.828 5.508q1.224.36 2.7 1.116l4.248-3.204q.288-.252.72-.252.396 0 .756.288 5.184 4.788 5.184 5.76 0 .324-.252.684-.432.576-1.512 1.944t-1.62 2.16q.828 1.728 1.224 2.952l5.472.828q.36.072.612.378t.252.702zm23.04 19.188v5.04q0 .576-5.364 1.116-.432.972-1.08 1.872 1.836 4.068 1.836 4.968 0 .144-.144.252-4.392 2.556-4.464 2.556-.288 0-1.656-1.692t-1.872-2.448q-.72.072-1.08.072t-1.08-.072q-.504.756-1.872 2.448t-1.656 1.692q-.072 0-4.464-2.556-.144-.108-.144-.252 0-.9 1.836-4.968-.648-.9-1.08-1.872-5.364-.54-5.364-1.116v-5.04q0-.576 5.364-1.116.468-1.044 1.08-1.872-1.836-4.068-1.836-4.968 0-.144.144-.252.144-.072 1.26-.72t2.124-1.224 1.08-.576q.288 0 1.656 1.674t1.872 2.43q.72-.072 1.08-.072t1.08.072q1.836-2.556 3.312-4.032l.216-.072q.144 0 4.464 2.52.144.108.144.252 0 .9-1.836 4.968.612.828 1.08 1.872 5.364.54 5.364 1.116zm0-36.864v5.04q0 .576-5.364 1.116-.432.972-1.08 1.872 1.836 4.068 1.836 4.968 0 .144-.144.252-4.392 2.556-4.464 2.556-.288 0-1.656-1.692t-1.872-2.448q-.72.072-1.08.072t-1.08-.072q-.504.756-1.872 2.448t-1.656 1.692q-.072 0-4.464-2.556-.144-.108-.144-.252 0-.9 1.836-4.968-.648-.9-1.08-1.872-5.364-.54-5.364-1.116v-5.04q0-.576 5.364-1.116.468-1.044 1.08-1.872-1.836-4.068-1.836-4.968 0-.144.144-.252.144-.072 1.26-.72t2.124-1.224 1.08-.576q.288 0 1.656 1.674t1.872 2.43q.72-.072 1.08-.072t1.08.072q1.836-2.556 3.312-4.032l.216-.072q.144 0 4.464 2.52.144.108.144.252 0 .9-1.836 4.968.612.828 1.08 1.872 5.364.54 5.364 1.116z\",\"COMMENTS\":\"M50.688-36.791q0 5.004-3.384 9.252t-9.234 6.714-12.726 2.466q-3.096 0-6.336-.576-4.464 3.168-10.008 4.608-1.296.324-3.096.576h-.108q-.396 0-.738-.288t-.414-.756q-.036-.108-.036-.234t.018-.234.072-.216l.09-.18.126-.198.144-.18.162-.18.144-.162q.18-.216.828-.9t.936-1.062.81-1.044.9-1.386.738-1.584q-4.464-2.592-7.02-6.372t-2.556-8.064q0-5.004 3.384-9.252t9.234-6.714 12.726-2.466 12.726 2.466 9.234 6.714 3.384 9.252zm13.824 9.216q0 4.32-2.556 8.082t-7.02 6.354q.36.864.738 1.584t.9 1.386.81 1.044.936 1.062.828.9l.144.162.162.18.144.18.126.198.09.18.072.216.018.234-.036.234q-.108.504-.468.792t-.792.252q-1.8-.252-3.096-.576-5.544-1.44-10.008-4.608-3.24.576-6.336.576-9.756 0-16.992-4.752 2.088.144 3.168.144 5.796 0 11.124-1.62t9.504-4.644q4.5-3.312 6.912-7.632t2.412-9.144q0-2.772-.828-5.472 4.644 2.556 7.344 6.408t2.7 8.28z\",\"THUMBS_O_UP\":\"M9.216-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm41.472-20.736q0-1.836-1.404-3.222t-3.204-1.386h-12.672q0-2.088 1.728-5.742t1.728-5.778q0-3.528-1.152-5.22t-4.608-1.692q-.936.936-1.368 3.06t-1.098 4.518-2.142 3.942q-.792.828-2.772 3.276-.144.18-.828 1.08t-1.134 1.476-1.242 1.53-1.44 1.584-1.386 1.278-1.44.972-1.278.324h-1.152v23.04h1.152q.468 0 1.134.108t1.188.234 1.368.396 1.26.414 1.278.45 1.044.378q7.596 2.628 12.312 2.628h4.356q6.912 0 6.912-6.012 0-.936-.18-2.016 1.08-.576 1.71-1.89t.63-2.646-.648-2.484q1.908-1.8 1.908-4.284 0-.9-.36-1.998t-.9-1.71q1.152-.036 1.926-1.692t.774-2.916zm4.608-.036q0 3.204-1.764 5.868.324 1.188.324 2.484 0 2.772-1.368 5.184.108.756.108 1.548 0 3.636-2.16 6.408.036 5.004-3.06 7.902t-8.172 2.898h-4.644q-3.456 0-6.822-.81t-7.794-2.358q-4.176-1.44-4.968-1.44h-10.368q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h9.864q1.296-.864 4.932-5.58 2.088-2.7 3.852-4.608.864-.9 1.278-3.078t1.098-4.554 2.232-3.888q1.404-1.332 3.24-1.332 3.024 0 5.436 1.17t3.672 3.654 1.26 6.696q0 3.348-1.728 6.912h6.336q3.744 0 6.48 2.736t2.736 6.444z\",\"THUMBS_O_DOWN\":\"M9.216-48.311q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm41.472 20.736q0-1.26-.774-2.916t-1.926-1.692q.54-.612.9-1.71t.36-1.998q0-2.484-1.908-4.284.648-1.152.648-2.484t-.63-2.646-1.71-1.89q.18-1.08.18-2.016 0-3.06-1.764-4.536t-4.896-1.476h-4.608q-4.716 0-12.312 2.628-.18.072-1.044.378t-1.278.45-1.26.414-1.368.396-1.188.234-1.134.108h-1.152v23.04h1.152q.576 0 1.278.324t1.44.972 1.386 1.278 1.44 1.584 1.242 1.53 1.134 1.476.828 1.08q1.98 2.448 2.772 3.276 1.476 1.548 2.142 3.942t1.098 4.518 1.368 3.06q3.456 0 4.608-1.692t1.152-5.22q0-2.124-1.728-5.778t-1.728-5.742h12.672q1.8 0 3.204-1.386t1.404-3.222zm4.608.036q0 3.708-2.736 6.444t-6.48 2.736h-6.336q1.728 3.564 1.728 6.912 0 4.248-1.26 6.696-1.26 2.484-3.672 3.654t-5.436 1.17q-1.836 0-3.24-1.332-1.224-1.188-1.944-2.952t-.918-3.258-.63-3.042-1.116-2.304q-1.728-1.8-3.852-4.572-3.636-4.716-4.932-5.58h-9.864q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h10.368q.792 0 4.968-1.44 4.608-1.584 8.028-2.376t7.2-.792h4.032q5.04 0 8.154 2.844t3.078 7.776v.18q2.16 2.772 2.16 6.408 0 .792-.108 1.548 1.368 2.412 1.368 5.184 0 1.296-.324 2.484 1.764 2.664 1.764 5.868z\",\"STAR_HALF\":\"M29.952-63.287v48.204l-16.164 8.496q-.792.432-1.44.432-.756 0-1.134-.522t-.378-1.278q0-.216.072-.72l3.096-18-13.104-12.744q-.9-.972-.9-1.728 0-1.332 2.016-1.656l18.072-2.628 8.1-16.38q.684-1.476 1.764-1.476z\",\"HEART_O\":\"M59.904-42.983q0-2.916-.774-5.148t-1.98-3.546-2.934-2.142-3.384-1.116-3.528-.288-4.032.918-3.978 2.304-3.114 2.592-2.16 2.214q-.648.792-1.764.792t-1.764-.792q-.864-1.008-2.16-2.214t-3.114-2.592-3.978-2.304-4.032-.918-3.528.288-3.384 1.116-2.934 2.142-1.98 3.546-.774 5.148q0 6.048 6.732 12.78l20.916 20.16 20.88-20.124q6.768-6.768 6.768-12.816zm4.608 0q0 7.956-8.244 16.2l-22.428 21.6q-.648.648-1.584.648t-1.584-.648l-22.464-21.672q-.36-.288-.99-.936t-1.998-2.358-2.448-3.51-1.926-4.356-.846-4.968q0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384z\",\"SIGN_OUT\":\"M23.04-12.599q0 .144.036.72t.018.954-.108.846-.36.702-.738.234h-11.52q-4.284 0-7.326-3.042t-3.042-7.326v-25.344q0-4.284 3.042-7.326t7.326-3.042h11.52q.468 0 .81.342t.342.81q0 .144.036.72t.018.954-.108.846-.36.702-.738.234h-11.52q-2.376 0-4.068 1.692t-1.692 4.068v25.344q0 2.376 1.692 4.068t4.068 1.692h11.232000000000001l.414.036.414.108.288.198.252.324.072.486zm33.408-19.584q0 .936-.684 1.62l-19.584 19.584q-.684.684-1.62.684t-1.62-.684-.684-1.62v-10.368h-16.128q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h16.128v-10.368q0-.936.684-1.62t1.62-.684 1.62.684l19.584 19.584q.684.684.684 1.62z\",\"LINKEDIN_SQUARE\":\"M8.532-13.535h8.316v-24.984h-8.316v24.984zm8.856-32.688q-.036-1.872-1.296-3.096t-3.348-1.224-3.402 1.224-1.314 3.096q0 1.836 1.278 3.078t3.33 1.242h.036q2.124 0 3.42-1.242t1.296-3.078zm21.06 32.688h8.316v-14.328q0-5.544-2.628-8.388t-6.948-2.844q-4.896 0-7.524 4.212h.072v-3.636h-8.316q.108 2.376 0 24.984h8.316v-13.968q0-1.368.252-2.016.54-1.26 1.62-2.142t2.664-.882q4.176 0 4.176 5.652v13.356zm16.848-35.928v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"THUMB_TACK\":\"M17.28-33.335v-16.128q0-.504-.324-.828t-.828-.324-.828.324-.324.828v16.128q0 .504.324.828t.828.324.828-.324.324-.828zm24.192 12.672q0 .936-.684 1.62t-1.62.684h-15.444l-1.836 17.388q-.072.432-.378.738t-.738.306h-.036q-.972 0-1.152-.972l-2.736-17.46h-14.544q-.936 0-1.62-.684t-.684-1.62q0-4.428 2.826-7.974t6.39-3.546v-18.432q-1.872 0-3.24-1.368t-1.368-3.24 1.368-3.24 3.24-1.368h23.04q1.872 0 3.24 1.368t1.368 3.24-1.368 3.24-3.24 1.368v18.432q3.564 0 6.39 3.546t2.826 7.974z\",\"EXTERNAL_LINK\":\"M50.688-31.031v11.52q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h25.344q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-11.52q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828zm13.824-31.104v18.432q0 .936-.684 1.62t-1.62.684-1.62-.684l-6.336-6.336-23.472 23.472q-.36.36-.828.36t-.828-.36l-4.104-4.104q-.36-.36-.36-.828t.36-.828l23.472-23.472-6.336-6.336q-.684-.684-.684-1.62t.684-1.62 1.62-.684h18.432q.936 0 1.62.684t.684 1.62z\",\"SIGN_IN\":\"M42.624-32.183q0 .936-.684 1.62l-19.584 19.584q-.684.684-1.62.684t-1.62-.684-.684-1.62v-10.368h-16.128q-.936 0-1.62-.684t-.684-1.62v-13.824q0-.936.684-1.62t1.62-.684h16.128v-10.368q0-.936.684-1.62t1.62-.684 1.62.684l19.584 19.584q.684.684.684 1.62zm12.672-12.672v25.344q0 4.284-3.042 7.326t-7.326 3.042h-11.52q-.468 0-.81-.342t-.342-.81q0-.144-.036-.72t-.018-.954.108-.846.36-.702.738-.234h11.52q2.376 0 4.068-1.692t1.692-4.068v-25.344q0-2.376-1.692-4.068t-4.068-1.692h-11.232000000000001l-.414-.036-.414-.108-.288-.198-.252-.324-.072-.486q0-.144-.036-.72t-.018-.954.108-.846.36-.702.738-.234h11.52q4.284 0 7.326 3.042t3.042 7.326z\",\"TROPHY\":\"M16.488-32.651q-2.664-5.832-2.664-13.356h-9.216v3.456q0 2.808 3.402 5.832t8.478 4.068zm38.808-9.9v-3.456h-9.216q0 7.524-2.664 13.356 5.076-1.044 8.478-4.068t3.402-5.832zm4.608-4.608v4.608q0 2.556-1.494 5.148t-4.032 4.68-6.228 3.51-7.758 1.602q-1.512 1.944-3.42 3.42-1.368 1.224-1.89 2.61t-.522 3.222q0 1.944 1.098 3.276t3.51 1.332q2.7 0 4.806 1.638t2.106 4.122v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-2.484 2.106-4.122t4.806-1.638q2.412 0 3.51-1.332t1.098-3.276q0-1.836-.522-3.222t-1.89-2.61q-1.908-1.476-3.42-3.42-4.068-.18-7.758-1.602t-6.228-3.51-4.032-4.68-1.494-5.148v-4.608q0-1.44 1.008-2.448t2.448-1.008h10.368v-3.456q0-2.376 1.692-4.068t4.068-1.692h20.736q2.376 0 4.068 1.692t1.692 4.068v3.456h10.368q1.44 0 2.448 1.008t1.008 2.448z\",\"GITHUB_SQUARE\":\"M18.684-21.239q.144-.216-.108-.468-.324-.252-.504-.072-.144.216.108.468.324.252.504.072zm-1.008-1.476q-.18-.252-.432-.144-.216.144 0 .432.252.288.432.18.216-.144 0-.468zm-1.476-1.44q.072-.144-.18-.288-.252-.072-.288.072-.108.18.144.288.288.072.324-.072zm.756.828q.072-.036.054-.162t-.126-.198q-.216-.252-.36-.108t.036.396q.216.216.396.072zm3.096 2.7q.072-.252-.324-.396-.324-.108-.468.144-.072.252.324.396.324.108.468-.144zm1.512.108q0-.288-.432-.288-.36 0-.36.288t.396.288.396-.288zm1.404-.252q-.072-.252-.468-.18t-.324.324q.072.288.432.216t.36-.36zm23.112-11.412q0-7.632-5.4-13.032t-13.032-5.4-13.032 5.4-5.4 13.032q0 6.012 3.528 10.818t9.072 6.678q.648.108.954-.18t.306-.72q0-1.872-.036-3.42-.216.036-.558.09t-1.278.072-1.728-.144-1.566-.72-1.062-1.494q-.828-2.124-2.052-2.664l-.162-.126-.288-.288-.252-.342.144-.27.702-.126q.216 0 .54.072t1.08.558 1.188 1.278q.576 1.008 1.35 1.512t1.566.504 1.368-.126 1.08-.342q.252-1.692 1.188-2.484-1.764-.216-3.096-.666t-2.628-1.404-1.998-2.736-.702-4.302q0-2.844 1.908-4.932-.864-2.232.18-4.896.684-.216 1.962.27t2.178 1.062l.936.576q2.088-.612 4.608-.612t4.608.612q.396-.252 1.026-.648t1.998-.936 2.052-.324q1.044 2.664.18 4.896 1.908 2.088 1.908 4.932 0 2.052-.504 3.618t-1.278 2.52-1.926 1.602-2.25.936-2.466.432q1.26 1.116 1.26 3.42 0 1.44-.018 3.204t-.018 1.836q0 .432.306.72t.954.18q5.544-1.872 9.072-6.678t3.528-10.818zm9.216-17.28v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"UPLOAD\":\"M46.08-11.447q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 0q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-8.064v11.52q0 1.44-1.008 2.448t-2.448 1.008h-52.992q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h15.372q.756 2.016 2.538 3.312t3.978 1.296h9.216q2.196 0 3.978-1.296t2.538-3.312h15.372q1.44 0 2.448 1.008t1.008 2.448zm-11.7-23.328q-.612 1.44-2.124 1.44h-9.216v16.128q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-16.128h-9.216q-1.512 0-2.124-1.44-.612-1.404.504-2.484l16.128-16.128q.648-.684 1.62-.684t1.62.684l16.128 16.128q1.116 1.08.504 2.484z\",\"LEMON_O\":\"M50.652-34.703q0-1.584-.252-4.086t-.648-3.474q-.432-1.08-.612-1.584t-.324-1.314-.144-1.746q0-.828.18-2.466t.18-2.43q0-1.332-.36-1.98-.144-.036-.468-.036-.684 0-2.088.162t-2.124.162q-2.16 0-6.336-.864t-6.3-.864q-1.548 0-3.402.414t-3.06.846-3.222 1.224q-4.932 1.944-7.272 3.708-3.456 2.628-5.742 6.822t-3.168 8.496-.882 8.946q0 1.44.45 4.32t.45 4.356q0 .828-.396 2.394t-.396 2.358.432 1.314 1.224.522q.864 0 2.61-.396t2.646-.396q2.052 0 6.102.558t6.102.558q6.516 0 10.224-1.296 4.644-1.62 8.478-5.49t5.976-8.838 2.142-9.9zm4.608-.072q0 5.94-2.52 11.79t-7.056 10.368-10.116 6.498q-4.464 1.584-11.736 1.584-2.052 0-6.12-.522t-6.084-.522q-.864 0-2.61.522t-2.646.522q-2.628 0-4.446-1.998t-1.818-4.626q0-.864.396-2.448t.396-2.412q0-1.44-.45-4.338t-.45-4.374q0-3.996.648-7.83t1.962-7.542 3.618-6.984 5.4-5.616q2.808-2.124 8.352-4.32 6.984-2.808 11.376-2.808 2.16 0 6.318.864t6.246.864q.684 0 2.052-.18t2.088-.18q2.916 0 4.248 1.818t1.332 4.842q0 .828-.18 2.448t-.18 2.448q0 .36.036.666t.108.612.144.486.234.576.234.612q.576 1.44.9 4.266t.324 4.914z\",\"PHONE\":\"M50.688-19.799q0 .972-.36 2.538t-.756 2.466q-.756 1.8-4.392 3.816-3.384 1.836-6.696 1.836-.972 0-1.89-.126t-2.07-.45-1.71-.522-1.998-.738-1.764-.648q-3.528-1.26-6.3-2.988-4.608-2.844-9.522-7.758t-7.758-9.522q-1.728-2.772-2.988-6.3-.108-.324-.648-1.764t-.738-1.998-.522-1.71-.45-2.07-.126-1.89q0-3.312 1.836-6.696 2.016-3.636 3.816-4.392.9-.396 2.466-.756t2.538-.36q.504 0 .756.108.648.216 1.908 2.736.396.684 1.08 1.944t1.26 2.286 1.116 1.926q.108.144.63.9t.774 1.278.252 1.026q0 .72-1.026 1.8t-2.232 1.98-2.232 1.908-1.026 1.656q0 .324.18.81t.306.738.504.864.414.684q2.736 4.932 6.264 8.46t8.46 6.264q.072.036.684.414t.864.504.738.306.81.18q.648 0 1.656-1.026t1.908-2.232 1.98-2.232 1.8-1.026q.504 0 1.026.252t1.278.774.9.63q.9.54 1.926 1.116t2.286 1.26 1.944 1.08q2.52 1.26 2.736 1.908.108.252.108.756z\",\"SQUARE_O\":\"M40.32-55.223h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068v-29.952q0-2.376-1.692-4.068t-4.068-1.692zm10.368 5.76v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z\",\"BOOKMARK_O\":\"M41.472-55.223h-36.864v44.712l15.228-14.616 3.204-3.06 3.204 3.06 15.228 14.616v-44.712zm.432-4.608q.828 0 1.584.324 1.188.468 1.89 1.476t.702 2.232v46.404q0 1.224-.702 2.232t-1.89 1.476q-.684.288-1.584.288-1.728 0-2.988-1.152l-15.876-15.264-15.876 15.264q-1.296 1.188-2.988 1.188-.828 0-1.584-.324-1.188-.468-1.89-1.476t-.702-2.232v-46.404q0-1.224.702-2.232t1.89-1.476q.756-.324 1.584-.324h37.728z\",\"PHONE_SQUARE\":\"M46.08-21.491q0-.396-.072-.576-.108-.288-1.386-1.062t-3.186-1.782l-1.908-1.044q-.18-.108-.684-.468t-.9-.54-.756-.18q-.648 0-1.692 1.17t-2.052 2.358-1.584 1.188q-.252 0-.594-.126t-.558-.234-.612-.342-.504-.306q-3.564-1.98-6.138-4.554t-4.554-6.138q-.072-.108-.306-.504t-.342-.612-.234-.558-.126-.594q0-.468.738-1.206t1.62-1.386 1.62-1.422.738-1.314q0-.36-.18-.756t-.54-.9-.468-.684q-.108-.216-.54-1.026t-.9-1.638-.954-1.71-.9-1.458-.594-.648-.576-.072q-1.728 0-3.636.792-1.656.756-2.88 3.402t-1.224 4.698q0 .576.09 1.224t.18 1.098.324 1.188.36 1.062.45 1.188.396 1.08q2.16 5.904 7.794 11.538t11.538 7.794q.216.072 1.08.396t1.188.45 1.062.36 1.188.324 1.098.18 1.224.09q2.052 0 4.698-1.224t3.402-2.88q.792-1.908.792-3.636zm9.216-27.972v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TWITTER\":\"M58.32-49.751q-2.412 3.528-5.832 6.012.036.504.036 1.512 0 4.68-1.368 9.342t-4.158 8.946-6.642 7.578-9.288 5.256-11.628 1.962q-9.756 0-17.856-5.22 1.26.144 2.808.144 8.1 0 14.436-4.968-3.78-.072-6.768-2.322t-4.104-5.742q1.188.18 2.196.18 1.548 0 3.06-.396-4.032-.828-6.678-4.014t-2.646-7.398v-.144q2.448 1.368 5.256 1.476-2.376-1.584-3.78-4.14t-1.404-5.544q0-3.168 1.584-5.868 4.356 5.364 10.602 8.586t13.374 3.582q-.288-1.368-.288-2.664 0-4.824 3.402-8.226t8.226-3.402q5.04 0 8.496 3.672 3.924-.756 7.38-2.808-1.332 4.14-5.112 6.408 3.348-.36 6.696-1.8z\",\"FACEBOOK_F\":\"M34.524-64.007v9.504h-5.652q-3.096 0-4.176 1.296t-1.08 3.888v6.804h10.548l-1.404 10.656h-9.144v27.324h-11.016v-27.324h-9.18v-10.656h9.18v-7.848q0-6.696 3.744-10.386t9.972-3.69q5.292 0 8.208.432z\",\"GITHUB\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878q0 9.036-5.274 16.254t-13.626 9.99q-.972.18-1.44-.252t-.468-1.08q0-.108.018-2.754t.018-4.842q0-3.492-1.872-5.112 2.052-.216 3.69-.648t3.384-1.404 2.916-2.394 1.908-3.78.738-5.418q0-4.284-2.844-7.416 1.332-3.276-.288-7.344-1.008-.324-2.916.396t-3.312 1.584l-1.368.864q-3.348-.936-6.912-.936t-6.912.936q-.576-.396-1.53-.972t-3.006-1.386-3.06-.486q-1.62 4.068-.288 7.344-2.844 3.132-2.844 7.416 0 3.06.738 5.4t1.89 3.78 2.898 2.412 3.384 1.404 3.69.648q-1.404 1.296-1.764 3.708-.756.36-1.62.54t-2.052.18-2.358-.774-1.998-2.25q-.684-1.152-1.746-1.872t-1.782-.864l-.72-.108q-.756 0-1.044.162t-.18.414.324.504.468.432l.252.18q.792.36 1.566 1.368t1.134 1.836l.36.828q.468 1.368 1.584 2.214t2.412 1.08 2.502.252 1.998-.126l.828-.144q0 1.368.018 3.186t.018 1.962q0 .648-.468 1.08t-1.44.252q-8.352-2.772-13.626-9.99t-5.274-16.254q0-7.524 3.708-13.878t10.062-10.062 13.878-3.708zm-17.172 39.708q.108-.252-.252-.432-.36-.108-.468.072-.108.252.252.432.324.216.468-.072zm1.116 1.224q.252-.18-.072-.576-.36-.324-.576-.108-.252.18.072.576.36.36.576.108zm1.08 1.62q.324-.252 0-.684-.288-.468-.612-.216-.324.18 0 .648t.612.252zm1.512 1.512q.288-.288-.144-.684-.432-.432-.72-.108-.324.288.144.684.432.432.72.108zm2.052.9q.108-.396-.468-.576-.54-.144-.684.252t.468.54q.54.216.684-.216zm2.268.18q0-.468-.612-.396-.576 0-.576.396 0 .468.612.396.576 0 .576-.396zm2.088-.36q-.072-.396-.648-.324-.576.108-.504.54t.648.288.504-.504z\",\"UNLOCK\":\"M59.904-43.703v9.216q0 .936-.684 1.62t-1.62.684h-2.304q-.936 0-1.62-.684t-.684-1.62v-9.216q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h24.192v-6.912q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394z\",\"CREDIT_CARD\":\"M63.36-59.831q2.376 0 4.068 1.692t1.692 4.068v43.776q0 2.376-1.692 4.068t-4.068 1.692h-57.6q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h57.6zm-57.6 4.608q-.468 0-.81.342t-.342.81v8.064h59.904v-8.064q0-.468-.342-.81t-.81-.342h-57.6zm57.6 46.08q.468 0 .81-.342t.342-.81v-21.888h-59.904v21.888q0 .468.342.81t.81.342h57.6zm-54.144-4.608v-4.608h9.216v4.608h-9.216zm13.824 0v-4.608h13.824v4.608h-13.824z\",\"RSS\":\"M13.824-16.055q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 4.428q.072 1.008-.612 1.728-.648.756-1.692.756h-4.86q-.9 0-1.548-.594t-.72-1.494q-.792-8.244-6.642-14.094t-14.094-6.642q-.9-.072-1.494-.72t-.594-1.548v-4.86q0-1.044.756-1.692.612-.612 1.548-.612h.18q5.76.468 11.016 2.898t9.324 6.534q4.104 4.068 6.534 9.324t2.898 11.016zm18.432.072q.072.972-.648 1.692-.648.72-1.656.72h-5.148q-.936 0-1.602-.63t-.702-1.53q-.432-7.74-3.636-14.706t-8.334-12.096-12.096-8.334-14.706-3.672q-.9-.036-1.53-.702t-.63-1.566v-5.148q0-1.008.72-1.656.648-.648 1.584-.648h.108q9.432.468 18.054 4.32t15.318 10.584q6.732 6.696 10.584 15.318t4.32 18.054z\",\"HDD_O\":\"M37.44-20.663q0 1.188-.846 2.034t-2.034.846-2.034-.846-.846-2.034.846-2.034 2.034-.846 2.034.846.846 2.034zm9.216 0q0 1.188-.846 2.034t-2.034.846-2.034-.846-.846-2.034.846-2.034 2.034-.846 2.034.846.846 2.034zm4.032 5.76v-11.52q0-.468-.342-.81t-.81-.342h-43.776q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h43.776q.468 0 .81-.342t.342-.81zm-44.28-17.28h42.48l-5.652-17.352q-.144-.468-.576-.774t-.936-.306h-28.152q-.504 0-.936.306t-.576.774zm48.888 5.76v11.52q0 2.376-1.692 4.068t-4.068 1.692h-43.776q-2.376 0-4.068-1.692t-1.692-4.068v-11.52q0-.9.576-2.7l7.092-21.816q.612-1.908 2.268-3.096t3.636-1.188h28.152q1.98 0 3.636 1.188t2.268 3.096l7.092 21.816q.576 1.8.576 2.7z\",\"BULLHORN\":\"M59.904-41.399q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35v13.824q0 1.872-1.368 3.24t-3.24 1.368q-15.012-12.492-29.232-13.68-2.088.684-3.276 2.376t-1.116 3.618 1.44 3.33q-.72 1.188-.828 2.358t.216 2.088 1.206 1.98 1.728 1.8 2.214 1.818q-1.044 2.088-4.014 2.988t-6.066.414-4.752-1.998q-.252-.828-1.062-3.15t-1.152-3.402-.828-3.204-.54-3.636.126-3.546.792-3.978h-4.392q-2.376 0-4.068-1.692t-1.692-4.068v-6.912q0-2.376 1.692-4.068t4.068-1.692h17.28q15.66 0 32.256-13.824 1.872 0 3.24 1.368t1.368 3.24v13.824zm-4.608 21.744v-34.344q-14.184 10.872-27.648 12.348v9.72q13.572 1.512 27.648 12.276z\",\"BELL_O\":\"M32.832-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm-23.976-10.368h46.8q-9.576-10.8-9.576-29.952 0-1.836-.864-3.78t-2.484-3.708-4.374-2.898-6.102-1.134-6.102 1.134-4.374 2.898-2.484 3.708-.864 3.78q0 19.152-9.576 29.952zm53.352 0q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-16.128q-1.872 0-3.24-1.368t-1.368-3.24q1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 6.84 1.008 11.052 5.706t4.212 10.17q0 5.004.702 9.36t1.8 7.416 2.682 5.706 3.06 4.302 3.276 3.168z\",\"CERTIFICATE\":\"M49.536-32.183l4.968 4.86q1.08 1.008.72 2.52-.432 1.476-1.872 1.836l-6.768 1.728 1.908 6.696q.432 1.476-.684 2.52-1.044 1.116-2.52.684l-6.696-1.908-1.728 6.768q-.36 1.44-1.836 1.872-.432.072-.684.072-1.116 0-1.836-.792l-4.86-4.968-4.86 4.968q-1.008 1.08-2.52.72-1.476-.396-1.836-1.872l-1.728-6.768-6.696 1.908q-1.476.432-2.52-.684-1.116-1.044-.684-2.52l1.908-6.696-6.768-1.728q-1.44-.36-1.872-1.836-.36-1.512.72-2.52l4.968-4.86-4.968-4.86q-1.08-1.008-.72-2.52.432-1.476 1.872-1.836l6.768-1.728-1.908-6.696q-.432-1.476.684-2.52 1.044-1.116 2.52-.684l6.696 1.908 1.728-6.768q.36-1.476 1.836-1.836 1.476-.432 2.52.684l4.86 5.004 4.86-5.004q1.044-1.08 2.52-.684 1.476.36 1.836 1.836l1.728 6.768 6.696-1.908q1.476-.432 2.52.684 1.116 1.044.684 2.52l-1.908 6.696 6.768 1.728q1.44.36 1.872 1.836.36 1.512-.72 2.52z\",\"HAND_O_RIGHT\":\"M9.216-16.055q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm50.688-20.736q0-1.836-1.404-3.222t-3.204-1.386h-20.736q0-.72.54-1.746t1.188-1.98 1.188-2.448.54-3.042q0-2.412-1.602-3.51t-4.158-1.098q-.864 0-3.24 5.004-.864 1.584-1.332 2.34-1.44 2.304-4.032 5.22-2.556 2.916-3.636 3.816-2.484 2.052-5.04 2.052h-1.152v23.04h1.152q2.592 0 6.012 1.152t6.966 2.304 6.462 1.152q6.804 0 6.804-6.012 0-.936-.18-2.016 1.08-.576 1.71-1.89t.63-2.646-.648-2.484q1.908-1.8 1.908-4.284 0-.9-.36-1.998t-.9-1.71h11.916q1.872 0 3.24-1.368t1.368-3.24zm4.608-.036q0 3.78-2.718 6.516t-6.498 2.736h-6.084q-.144 2.232-1.332 4.284.108.756.108 1.548 0 3.636-2.16 6.408.036 5.004-3.06 7.902t-8.172 2.898q-4.788 0-11.592-2.484-5.904-2.124-8.028-2.124h-10.368q-1.908 0-3.258-1.35t-1.35-3.258v-23.04q0-1.908 1.35-3.258t3.258-1.35h10.368q.36 0 .774-.162t.846-.504.81-.648.864-.81.738-.774.684-.774.504-.612q2.34-2.664 3.6-4.644.468-.756 1.188-2.232t1.332-2.592 1.458-2.268 1.98-1.782 2.502-.63q4.5 0 7.434 2.412t2.934 6.804q0 2.448-.792 4.608h13.464q3.744 0 6.48 2.736t2.736 6.444z\",\"HAND_O_LEFT\":\"M49.536-13.751h1.152v-23.04h-1.152q-1.26 0-2.43-.432t-2.25-1.332-1.8-1.656-1.764-1.944l-.126-.162-.144-.162-.162-.18q-2.592-2.916-4.032-5.22-.504-.792-1.368-2.448-.036-.108-.378-.81t-.666-1.296-.72-1.278-.774-1.098-.666-.414q-2.556 0-4.158 1.098t-1.602 3.51q0 1.548.54 3.042t1.188 2.448 1.188 1.98.54 1.746h-20.736q-1.8 0-3.204 1.386t-1.404 3.222q0 1.872 1.368 3.24t3.24 1.368h11.916q-.54.612-.9 1.71t-.36 1.998q0 2.484 1.908 4.284-.648 1.152-.648 2.484t.63 2.646 1.71 1.89q-.144.864-.144 2.016 0 3.06 1.746 4.536t4.878 1.476q3.024 0 6.588-1.152t6.984-2.304 6.012-1.152zm10.368-2.304q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-20.736v23.04q0 1.908-1.35 3.258t-3.258 1.35h-10.368q-2.124 0-8.028 2.124-6.84 2.484-11.412 2.484-5.112 0-8.28-2.79t-3.132-7.83l.036-.18q-2.196-2.736-2.196-6.408 0-.792.108-1.548-1.188-2.052-1.332-4.284h-6.084q-3.78 0-6.498-2.736t-2.718-6.516q0-3.708 2.736-6.444t6.48-2.736h13.464q-.792-2.16-.792-4.608 0-4.392 2.934-6.804t7.434-2.412q1.368 0 2.502.63t1.98 1.782 1.458 2.268 1.332 2.592 1.188 2.232q1.26 1.98 3.6 4.644.072.108.504.612t.684.774.738.774.864.81.81.648.846.504.774.162h10.368q1.908 0 3.258 1.35t1.35 3.258z\",\"HAND_O_UP\":\"M46.08-6.839q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608-27.504q0-6.804-6.012-6.804-.936 0-2.016.18-.576-1.08-1.89-1.71t-2.646-.63-2.484.648q-1.8-1.908-4.284-1.908-.9 0-1.998.36t-1.71.9v-11.916q0-1.872-1.368-3.24t-3.24-1.368q-1.836 0-3.222 1.404t-1.386 3.204v20.736q-.72 0-1.746-.54t-1.98-1.188-2.448-1.188-3.042-.54q-2.412 0-3.51 1.602t-1.098 4.158q0 .864 5.004 3.24 1.584.864 2.34 1.332 2.304 1.44 5.22 4.032 2.916 2.556 3.816 3.636 2.052 2.484 2.052 5.04v1.152h23.04v-1.152q0-2.592 1.152-6.012t2.304-6.966 1.152-6.462zm4.608-.18q0 4.788-2.484 11.592-2.124 5.904-2.124 8.028v10.368q0 1.908-1.35 3.258t-3.258 1.35h-23.04q-1.908 0-3.258-1.35t-1.35-3.258v-10.368q0-.36-.162-.774t-.504-.846-.648-.81-.81-.864-.774-.738-.774-.684-.612-.504q-2.664-2.34-4.644-3.6-.756-.468-2.232-1.188t-2.592-1.332-2.268-1.458-1.782-1.98-.63-2.502q0-4.5 2.412-7.434t6.804-2.934q2.448 0 4.608.792v-13.464q0-3.744 2.736-6.48t6.444-2.736q3.78 0 6.516 2.718t2.736 6.498v6.084q2.232.144 4.284 1.332.756-.108 1.548-.108 3.636 0 6.408 2.16 5.004-.036 7.902 3.06t2.898 8.172z\",\"HAND_O_DOWN\":\"M50.688-29.879q0-3.024-1.152-6.588t-2.304-6.984-1.152-6.012v-1.152h-23.04v1.152q0 1.26-.432 2.43t-1.332 2.25-1.656 1.8-1.944 1.764q-.324.288-.504.432-2.916 2.592-5.22 4.032-.792.504-2.448 1.368-.108.036-.81.378t-1.296.666-1.278.72-1.098.774-.414.666q0 2.556 1.098 4.158t3.51 1.602q1.548 0 3.042-.54t2.448-1.188 1.98-1.188 1.746-.54v20.736q0 1.8 1.386 3.204t3.222 1.404q1.872 0 3.24-1.368t1.368-3.24v-11.916q1.656 1.26 3.708 1.26 2.484 0 4.284-1.908 1.152.648 2.484.648t2.646-.63 1.89-1.71q.864.144 2.016.144 3.06 0 4.536-1.746t1.476-4.878zm-4.608-27.648q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm9.216 27.504q0 5.112-2.79 8.28t-7.83 3.132l-.18-.036q-2.736 2.196-6.408 2.196-.792 0-1.548-.108-1.944 1.08-4.284 1.332v6.084q0 3.78-2.736 6.498t-6.516 2.718q-3.708 0-6.444-2.736t-2.736-6.48v-13.464q-1.944.792-4.608.792-4.356 0-6.786-2.934t-2.43-7.434q0-1.368.63-2.502t1.782-1.98 2.268-1.458 2.592-1.332 2.232-1.188q1.98-1.26 4.644-3.6.108-.072.612-.504t.774-.684.774-.738.81-.864.648-.81.504-.846.162-.774v-10.368q0-1.908 1.35-3.258t3.258-1.35h23.04q1.908 0 3.258 1.35t1.35 3.258v10.368q0 2.124 2.124 8.028 2.484 6.84 2.484 11.412z\",\"ARROW_CIRCLE_LEFT\":\"M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-18.072l6.804-6.804q.684-.684.684-1.62t-.684-1.62l-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-13.032 13.032-3.276 3.276q-.648.648-.648 1.62t.648 1.62l3.276 3.276 13.032 13.032q.648.648 1.62.648t1.62-.648l3.276-3.276q.648-.648.648-1.62t-.648-1.62l-6.804-6.804h18.072q.936 0 1.62-.684t.684-1.62zm9.216-2.304q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ARROW_CIRCLE_RIGHT\":\"M46.26-32.183q0-.972-.648-1.62l-3.276-3.276-13.032-13.032q-.648-.648-1.62-.648t-1.62.648l-3.276 3.276q-.648.648-.648 1.62t.648 1.62l6.804 6.804h-18.072q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h18.072l-6.804 6.804q-.684.684-.684 1.62t.684 1.62l3.276 3.276q.648.648 1.62.648t1.62-.648l13.032-13.032 3.276-3.276q.648-.648.648-1.62zm9.036 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ARROW_CIRCLE_UP\":\"M46.224-32.219q0-.972-.648-1.62l-13.032-13.032-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-3.276 3.276-13.032 13.032q-.648.648-.648 1.62t.648 1.62l3.276 3.276q.648.648 1.62.648t1.62-.648l6.804-6.804v18.072q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-18.072l6.804 6.804q.684.684 1.62.684t1.62-.684l3.276-3.276q.648-.648.648-1.62zm9.072.036q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ARROW_CIRCLE_DOWN\":\"M46.224-32.147q0-.972-.648-1.62l-3.276-3.276q-.648-.648-1.62-.648t-1.62.648l-6.804 6.804v-18.072q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v18.072l-6.804-6.804q-.684-.684-1.62-.684t-1.62.684l-3.276 3.276q-.648.648-.648 1.62t.648 1.62l13.032 13.032 3.276 3.276q.648.648 1.62.648t1.62-.648l3.276-3.276 13.032-13.032q.648-.648.648-1.62zm9.072-.036q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"GLOBE\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm9.864 18.756q-.072.036-.342.342t-.486.342q.072 0 .162-.18t.18-.396.126-.252q.216-.252.792-.54.504-.216 1.872-.432 1.224-.288 1.836.396-.072-.072.342-.468t.522-.432q.108-.072.54-.162t.54-.27l.072-.792q-.432.036-.63-.252t-.234-.756q0 .072-.216.288 0-.252-.162-.288t-.414.036-.324.036q-.36-.108-.54-.27t-.288-.594-.144-.54q-.072-.18-.342-.378t-.342-.378l-.09-.198-.108-.234-.144-.198-.198-.09-.252.18-.27.36-.162.18q-.108-.072-.216-.054t-.162.036-.162.108-.18.126q-.108.072-.306.108t-.306.072q.54-.18-.036-.396-.36-.144-.576-.108.324-.144.27-.432t-.306-.504h.18q-.036-.144-.306-.306t-.63-.306-.468-.216q-.288-.18-1.224-.342t-1.188-.018q-.18.216-.162.378t.144.504.126.45q.036.216-.198.468t-.234.432q0 .252.504.558t.36.774q-.108.288-.576.576t-.576.432q-.18.288-.054.666t.378.594q.072.072.054.144t-.126.162-.198.144-.234.126l-.108.072q-.396.18-.738-.216t-.486-.936q-.252-.9-.576-1.08-.828-.288-1.044.036-.18-.468-1.476-.936-.9-.324-2.088-.144.216-.036 0-.54-.252-.54-.684-.432.108-.216.144-.63t.036-.486q.108-.468.432-.828.036-.036.252-.306t.342-.486.018-.216q1.26.144 1.8-.396.18-.18.414-.612t.378-.612q.324-.216.504-.198t.522.198.522.18q.504.036.558-.396t-.27-.72q.432.036.108-.612-.18-.252-.288-.324-.432-.144-.972.18-.288.144.072.288-.036-.036-.342.378t-.594.63-.576-.18q-.036-.036-.198-.486t-.342-.486q-.288 0-.576.54.108-.288-.396-.54t-.864-.288q.684-.432-.288-.972-.252-.144-.738-.18t-.702.144q-.18.252-.198.414t.18.288.378.198.414.144.306.108q.504.36.288.504l-.306.126-.414.162-.216.144q-.108.144 0 .504t-.072.504q-.18-.18-.324-.63t-.252-.594q.252.324-.9.216l-.36-.036q-.144 0-.576.072t-.738.036-.486-.288q-.144-.288 0-.72.036-.144.144-.072-.144-.108-.396-.342t-.36-.306q-1.656.54-3.384 1.476.216.036.432-.036.18-.072.468-.234t.36-.198q1.224-.504 1.512-.252l.18-.18q.504.576.72.9-.252-.144-1.08-.036-.72.216-.792.432.252.432.18.648-.144-.108-.414-.36t-.522-.396-.54-.18q-.576 0-.792.036-5.256 2.88-8.46 7.992.252.252.432.288.144.036.18.324t.09.396.414-.108q.324.288.108.684.036-.036 1.584.972.684.612.756.756.108.396-.36.648-.036-.072-.324-.324t-.324-.144q-.108.18.018.666t.378.45q-.252 0-.342.576t-.09 1.278-.036.846l.072.036q-.108.432.198 1.242t.774.702q-.468.108.72 1.548.216.288.288.324.108.072.432.27t.54.36.36.378q.144.18.36.81t.504.846q-.072.216.342.72t.378.828l-.09.036-.09.036q.108.252.558.504t.558.468q.036.108.072.36t.108.396.288.072q.072-.72-.864-2.232-.54-.9-.612-1.044-.108-.18-.198-.558t-.162-.522q.072 0 .216.054t.306.126.27.144.072.108q-.108.252.072.63t.432.666.612.684.432.468q.216.216.504.702t0 .486q.324 0 .72.36t.612.72q.18.288.288.936t.18.864q.072.252.306.486t.45.342l.576.288.468.252q.18.072.666.378t.774.414q.36.144.576.144t.522-.09.486-.126q.54-.072 1.044.54t.756.756q1.296.684 1.98.396-.072.036.018.27t.288.558.324.522.198.306q.18.216.648.54t.648.54q.216-.144.252-.324-.108.288.252.72t.648.36q.504-.108.504-1.152-1.116.54-1.764-.648l-.09-.198-.144-.306-.09-.306v-.27l.18-.108q.324 0 .36-.126t-.072-.45-.144-.468q-.036-.288-.396-.72t-.432-.54q-.18.324-.576.288t-.576-.324l-.054.198-.054.234q-.468 0-.54-.036.036-.108.09-.63t.126-.81q.036-.144.198-.432t.27-.522.144-.45-.162-.342-.63-.09q-.684.036-.936.72-.036.108-.108.378t-.18.414-.324.252q-.252.108-.864.072t-.864-.18q-.468-.288-.81-1.044t-.342-1.332q0-.36.09-.954t.108-.9-.198-.882q.108-.072.324-.342t.36-.378l.162-.054h.162l.144-.054.108-.216-.144-.108-.144-.108q.252.108 1.026-.054t.99.054q.54.396.792-.072 0-.036-.09-.342t-.018-.486q.18.972 1.044.324.108.108.558.18t.63.18l.252.198.198.162.18-.018.306-.234q.36.504.432.864.396 1.44.684 1.584.252.108.396.072t.162-.342 0-.504-.054-.45l-.036-.288v-.648l-.036-.288q-.54-.108-.666-.432t.054-.666.54-.666q.036-.036.288-.126t.558-.234.45-.288q.756-.684.54-1.26.252 0 .396-.324l-.18-.108-.27-.18-.162-.072q.324-.18.072-.576.18-.108.27-.396t.27-.36q.324.432.756.072.252-.288.036-.576.18-.252.738-.378t.666-.342q.252.072.288-.072t.036-.432.108-.432q.144-.18.54-.324t.468-.18l.612-.396q.108-.144 0-.144.648.072 1.116-.396.36-.396-.216-.72.108-.216-.108-.342t-.54-.198q.108-.036.414-.018t.378-.054q.54-.36-.252-.576-.612-.18-1.548.432zm-5.868 31.572q7.416-1.296 12.636-6.804-.108-.108-.45-.162t-.45-.126q-.648-.252-.864-.288.036-.252-.09-.468t-.288-.324-.45-.288-.396-.252l-.252-.216-.252-.198-.27-.162-.306-.072-.36.036-.108.036-.198.09-.198.108-.144.108v.09q-.756-.612-1.296-.792-.18-.036-.396-.198t-.378-.252-.36-.054-.414.252q-.18.18-.216.54t-.072.468q-.252-.18 0-.63t.072-.666q-.108-.216-.378-.162t-.432.162-.414.306-.324.234-.306.198-.306.27q-.108.144-.216.432t-.18.396q-.072-.144-.414-.234t-.342-.198q.072.36.144 1.26t.18 1.368q.252 1.116-.432 1.728-.972.9-1.044 1.44-.144.792.432.936 0 .252-.288.738t-.252.774q0 .216.072.576z\",\"WRENCH\":\"M13.824-11.447q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm23.184-15.12l-24.552 24.552q-1.332 1.332-3.24 1.332-1.872 0-3.276-1.332l-3.816-3.888q-1.368-1.296-1.368-3.24 0-1.908 1.368-3.276l24.516-24.516q1.404 3.528 4.122 6.246t6.246 4.122zm22.824-15.66q0 1.404-.828 3.816-1.692 4.824-5.922 7.83t-9.306 3.006q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q2.088 0 4.374.594t3.87 1.674q.576.396.576 1.008t-.576 1.008l-10.548 6.084v8.064l6.948 3.852q.18-.108 2.844-1.746t4.878-2.916 2.538-1.278q.54 0 .846.36t.306.9z\",\"TASKS\":\"M36.864-13.751h23.04v-4.608h-23.04v4.608zm-13.824-18.432h36.864v-4.608h-36.864v4.608zm23.04-18.432h13.824v-4.608h-13.824v4.608zm18.432 29.952v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-18.432v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62zm0-18.432v9.216q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h59.904q.936 0 1.62.684t.684 1.62z\",\"FILTER\":\"M50.508-53.819q.612 1.476-.504 2.52l-17.748 17.748v26.712q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-9.216-9.216q-.684-.684-.684-1.62v-17.496l-17.748-17.748q-1.116-1.044-.504-2.52.612-1.404 2.124-1.404h46.08q1.512 0 2.124 1.404z\",\"BRIEFCASE\":\"M23.04-55.223h18.432v-4.608h-18.432v4.608zm41.472 23.04v17.28q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-17.28h24.192v5.76q0 .936.684 1.62t1.62.684h11.52q.936 0 1.62-.684t.684-1.62v-5.76h24.192zm-27.648 0v4.608h-9.216v-4.608h9.216zm27.648-17.28v13.824h-64.512v-13.824q0-2.376 1.692-4.068t4.068-1.692h12.672v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h12.672q2.376 0 4.068 1.692t1.692 4.068z\",\"ARROWS_ALT\":\"M46.188-44.963l-12.78 12.78 12.78 12.78 5.184-5.184q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v16.128q0 .936-.684 1.62t-1.62.684h-16.128q-1.512 0-2.124-1.44-.612-1.404.504-2.484l5.184-5.184-12.78-12.78-12.78 12.78 5.184 5.184q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l5.184 5.184 12.78-12.78-12.78-12.78-5.184 5.184q-.684.684-1.62.684-.432 0-.864-.18-1.44-.612-1.44-2.124v-16.128q0-.936.684-1.62t1.62-.684h16.128q1.512 0 2.124 1.44.612 1.404-.504 2.484l-5.184 5.184 12.78 12.78 12.78-12.78-5.184-5.184q-1.116-1.08-.504-2.484.612-1.44 2.124-1.44h16.128q.936 0 1.62.684t.684 1.62v16.128q0 1.512-1.404 2.124-.468.18-.9.18-.936 0-1.62-.684z\",\"USERS\":\"M21.348-32.183q-5.832.18-9.54 4.608h-4.824q-2.952 0-4.968-1.458t-2.016-4.266q0-12.708 4.464-12.708.216 0 1.566.756t3.51 1.53 4.284.774q2.412 0 4.788-.828-.18 1.332-.18 2.376 0 5.004 2.916 9.216zm38.556 22.932q0 4.32-2.628 6.822t-6.984 2.502h-31.464q-4.356 0-6.984-2.502t-2.628-6.822q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.36 0 1.548.774t2.628 1.728 3.852 1.728 4.86.774 4.86-.774 3.852-1.728 2.628-1.728 1.548-.774q2.196 0 4.014.72t3.078 1.926 2.232 2.916 1.548 3.51.954 3.906.504 3.924.126 3.726zm-36.864-45.972q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm25.344 13.824q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774zm20.736 8.1q0 2.808-2.016 4.266t-4.968 1.458h-4.824q-3.708-4.428-9.54-4.608 2.916-4.212 2.916-9.216 0-1.044-.18-2.376 2.376.828 4.788.828 2.124 0 4.284-.774t3.51-1.53 1.566-.756q4.464 0 4.464 12.708zm-4.608-21.924q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516z\",\"LINK\":\"M52.416-20.663q0-1.44-1.008-2.448l-7.488-7.488q-1.008-1.008-2.448-1.008-1.512 0-2.592 1.152.108.108.684.666t.774.774.54.684.468.918.126.99q0 1.44-1.008 2.448t-2.448 1.008q-.54 0-.99-.126t-.918-.468-.684-.54-.774-.774-.666-.684q-1.188 1.116-1.188 2.628 0 1.44 1.008 2.448l7.416 7.452q.972.972 2.448.972 1.44 0 2.448-.936l5.292-5.256q1.008-1.008 1.008-2.412zm-25.308-25.38q0-1.44-1.008-2.448l-7.416-7.452q-1.008-1.008-2.448-1.008-1.404 0-2.448.972l-5.292 5.256q-1.008 1.008-1.008 2.412 0 1.44 1.008 2.448l7.488 7.488q.972.972 2.448.972 1.512 0 2.592-1.116-.108-.108-.684-.666t-.774-.774-.54-.684-.468-.918-.126-.99q0-1.44 1.008-2.448t2.448-1.008q.54 0 .99.126t.918.468.684.54.774.774.666.684q1.188-1.116 1.188-2.628zm32.22 25.38q0 4.32-3.06 7.308l-5.292 5.256q-2.988 2.988-7.308 2.988-4.356 0-7.344-3.06l-7.416-7.452q-2.988-2.988-2.988-7.308 0-4.428 3.168-7.524l-3.168-3.168q-3.096 3.168-7.488 3.168-4.32 0-7.344-3.024l-7.488-7.488q-3.024-3.024-3.024-7.344t3.06-7.308l5.292-5.256q2.988-2.988 7.308-2.988 4.356 0 7.344 3.06l7.416 7.452q2.988 2.988 2.988 7.308 0 4.428-3.168 7.524l3.168 3.168q3.096-3.168 7.488-3.168 4.32 0 7.344 3.024l7.488 7.488q3.024 3.024 3.024 7.344z\",\"CLOUD\":\"M69.12-22.967q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.752 2.556-8.694t6.732-5.886q-.072-1.008-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.688 0 10.314 3.168t6.75 8.28q2.52-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.7-1.476 4.968 4.644 1.08 7.668 4.842t3.024 8.622z\",\"FLASK\":\"M54.972-12.311q2.016 3.204.774 5.49t-5.058 2.286h-41.472q-3.816 0-5.058-2.286t.774-5.49l18.108-28.548v-14.364h-2.304q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h18.432q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-2.304v14.364zm-28.044-26.1l-9.792 15.444h25.632l-9.792-15.444-.72-1.116v-15.696000000000002h-4.608v15.696000000000002z\",\"SCISSORS\":\"M34.56-32.183q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684zm10.8 2.304l18.252 14.328q1.008.72.9 2.016-.18 1.26-1.26 1.836l-4.608 2.304q-.468.252-1.044.252-.612 0-1.116-.288l-24.84-13.932-3.96 2.376q-.288.144-.432.18.504 1.764.36 3.492-.252 2.772-2.016 5.31t-4.752 4.446q-4.752 3.024-9.972 3.024-4.896 0-7.992-2.808-3.24-3.024-2.844-7.452.252-2.736 2.016-5.292t4.716-4.464q4.752-3.024 10.008-3.024 2.988 0 5.436 1.116.324-.468.792-.792l4.392-2.628-4.392-2.628q-.468-.324-.792-.792-2.448 1.116-5.436 1.116-5.256 0-10.008-3.024-2.952-1.908-4.716-4.464t-2.016-5.292q-.18-2.124.558-4.068t2.286-3.348q3.06-2.844 7.992-2.844 5.22 0 9.972 3.024 2.988 1.872 4.752 4.428t2.016 5.328q.144 1.728-.36 3.492.144.036.432.18l3.96 2.376 24.84-13.932q.504-.288 1.116-.288.576 0 1.044.252l4.608 2.304q1.08.576 1.26 1.836.108 1.296-.9 2.016zm-24.516-9.36q1.656-1.512.756-3.888t-3.816-4.212q-3.312-2.124-6.912-2.124-2.664 0-4.068 1.296-1.656 1.512-.756 3.888t3.816 4.212q3.312 2.124 6.912 2.124 2.664 0 4.068-1.296zm-3.06 26.82q2.916-1.836 3.816-4.212t-.756-3.888q-1.404-1.296-4.068-1.296-3.6 0-6.912 2.124-2.916 1.836-3.816 4.212t.756 3.888q1.404 1.296 4.068 1.296 3.6 0 6.912-2.124zm6.408-22.068l3.456 2.088v-.396q0-1.296 1.188-2.016l.504-.288-2.844-1.692-.936.936q-.108.108-.36.396t-.432.432l-.144.126-.108.09zm8.064 8.064l3.456 1.152 26.496-20.736-4.608-2.304-27.648 15.516v4.068l-5.76 3.456.324.288.252.216q.144.144.396.432t.396.432l.936.936zm25.344 14.976l4.608-2.304-18.72-14.688-6.372 4.968q-.072.108-.468.252z\",\"FILES_O\":\"M61.056-50.615q1.44 0 2.448 1.008t1.008 2.448v43.776q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-10.368h-19.584q-1.44 0-2.448-1.008t-1.008-2.448v-24.192q0-1.44.72-3.168t1.728-2.736l14.688-14.688q1.008-1.008 2.736-1.728t3.168-.72h14.976q1.44 0 2.448 1.008t1.008 2.448v11.808q2.448-1.44 4.608-1.44h14.976zm-19.584 7.668l-10.764 10.764h10.764v-10.764zm-23.04-13.824l-10.764 10.764h10.764v-10.764zm7.056 23.292l11.376-11.376v-14.976h-13.824v14.976q0 1.44-1.008 2.448t-2.448 1.008h-14.976v23.04h18.432v-9.216q0-1.44.72-3.168t1.728-2.736zm34.416 28.944v-41.472h-13.824v14.976q0 1.44-1.008 2.448t-2.448 1.008h-14.976v23.04h32.256z\",\"PAPERCLIP\":\"M50.544-14.579q0 4.212-2.844 7.056t-7.056 2.844q-4.86 0-8.46-3.6l-27.972-27.936q-4.068-4.14-4.068-9.756 0-5.724 3.96-9.72t9.684-3.996q5.688 0 9.828 4.068l21.78 21.816q.36.36.36.792 0 .576-1.098 1.674t-1.674 1.098q-.468 0-.828-.36l-21.816-21.852q-2.844-2.772-6.516-2.772-3.816 0-6.444 2.7t-2.628 6.516q0 3.78 2.736 6.516l27.936 27.972q2.268 2.268 5.22 2.268 2.304 0 3.816-1.512t1.512-3.816q0-2.952-2.268-5.22l-20.916-20.916q-.936-.864-2.16-.864-1.044 0-1.728.684t-.684 1.728q0 1.152.9 2.124l14.76 14.76q.36.36.36.792 0 .576-1.116 1.692t-1.692 1.116q-.432 0-.792-.36l-14.76-14.76q-2.268-2.196-2.268-5.364 0-2.952 2.052-5.004t5.004-2.052q3.168 0 5.364 2.268l20.916 20.916q3.6 3.528 3.6 8.46z\",\"SAVE\":\"M13.824-9.143h27.648v-13.824h-27.648v13.824zm32.256 0h4.608v-32.256q0-.504-.36-1.386t-.72-1.242l-10.116-10.116q-.36-.36-1.224-.72t-1.404-.36v14.976q0 1.44-1.008 2.448t-2.448 1.008h-20.736q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-4.608v46.08h4.608v-14.976q0-1.44 1.008-2.448t2.448-1.008h29.952q1.44 0 2.448 1.008t1.008 2.448v14.976zm-13.824-33.408v-11.52q0-.468-.342-.81t-.81-.342h-6.912q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h6.912q.468 0 .81-.342t.342-.81zm23.04 1.152v33.408q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h33.408q1.44 0 3.168.72t2.736 1.728l10.08 10.08q1.008 1.008 1.728 2.736t.72 3.168z\",\"SQUARE\":\"M55.296-49.463v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"REORDER\":\"M55.296-16.055v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm0-18.432v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm0-18.432v4.608q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z\",\"LIST_UL\":\"M13.824-13.751q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm0-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm50.688 14.976v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81zm-50.688-33.408q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm50.688 14.976v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81zm0-18.432v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81z\",\"LIST_OL\":\"M13.716-6.119q0 2.88-1.962 4.536t-4.878 1.656q-3.816 0-6.192-2.376l2.052-3.168q1.764 1.62 3.816 1.62 1.044 0 1.818-.522t.774-1.53q0-2.304-3.78-2.016l-.936-2.016q.288-.36 1.17-1.566t1.53-1.944 1.332-1.386v-.036q-.576 0-1.746.036t-1.746.036v1.908h-3.816v-5.472h11.988v3.168l-3.42 4.14q1.836.432 2.916 1.764t1.08 3.168zm.072-22.572v5.724h-13.032q-.216-1.296-.216-1.944 0-1.836.846-3.348t2.034-2.448 2.376-1.71 2.034-1.566.846-1.62q0-.9-.522-1.386t-1.422-.486q-1.656 0-2.916 2.088l-3.06-2.124q.864-1.836 2.574-2.862t3.798-1.026q2.628 0 4.428 1.494t1.8 4.05q0 1.8-1.224 3.294t-2.7 2.322-2.718 1.818-1.278 1.89h4.572v-2.16h3.78zm50.724 11.484v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.504.324-.828t.828-.324h43.776q.468 0 .81.342t.342.81zm-50.688-32.364v3.564h-12.06v-3.564h3.852q0-1.476.018-4.392t.018-4.356v-.432h-.072q-.288.612-1.8 1.944l-2.556-2.736 4.896-4.572h3.816v14.544h3.888zm50.688 13.932v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.504.324-.828t.828-.324h43.776q.468 0 .81.342t.342.81zm0-18.432v6.912q0 .468-.342.81t-.81.342h-43.776q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h43.776q.468 0 .81.342t.342.81z\",\"STRIKETHROUGH\":\"M63.36-32.183q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-62.208q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h62.208zm-45.972-2.304q-1.008-1.26-1.836-2.88-1.728-3.492-1.728-6.768 0-6.516 4.824-11.124 4.788-4.572 14.148-4.572 1.8 0 6.012.684 2.376.432 6.372 1.728.36 1.368.756 4.248.504 4.428.504 6.588 0 .648-.18 1.62l-.432.108-3.024-.216-.504-.072q-1.8-5.364-3.708-7.38-3.168-3.276-7.56-3.276-4.104 0-6.552 2.124-2.412 2.088-2.412 5.256 0 2.628 2.376 5.04t10.044 4.644q2.484.72 6.228 2.376 2.088 1.008 3.42 1.872h-26.748zm18.252 9.216h14.796q.252 1.404.252 3.312 0 3.996-1.476 7.632-.828 1.98-2.556 3.744-1.332 1.26-3.924 2.916-2.88 1.728-5.508 2.376-2.88.756-7.308.756-4.104 0-7.02-.828l-5.04-1.44q-2.052-.576-2.592-1.008-.288-.288-.288-.792v-.468q0-3.888-.072-5.616-.036-1.08 0-2.448l.072-1.332v-1.584l3.672-.072q.54 1.224 1.08 2.556t.81 2.016.45.972q1.26 2.052 2.88 3.384 1.548 1.296 3.78 2.052 2.124.792 4.752.792 2.304 0 5.004-.972 2.772-.936 4.392-3.096 1.692-2.196 1.692-4.644 0-3.024-2.916-5.652-1.224-1.044-4.932-2.556z\",\"UNDERLINE\":\"M1.728-56.411q-1.332-.072-1.62-.144l-.108-3.168q.468-.036 1.44-.036 2.16 0 4.032.144 4.752.252 5.976.252 3.096 0 6.048-.108 4.176-.144 5.256-.18 2.016 0 3.096-.072l-.036.504.072 2.304v.324q-2.16.324-4.464.324-2.16 0-2.844.9-.468.504-.468 4.752 0 .468.018 1.17t.018.918l.036 8.244.504 10.08q.216 4.464 1.836 7.272 1.26 2.124 3.456 3.312 3.168 1.692 6.372 1.692 3.744 0 6.876-1.008 2.016-.648 3.564-1.836 1.728-1.296 2.34-2.304 1.296-2.016 1.908-4.104.756-2.628.756-8.244 0-2.844-.126-4.608t-.396-4.41-.486-5.742l-.144-2.124q-.18-2.412-.864-3.168-1.224-1.26-2.772-1.224l-3.6.072-.504-.108.072-3.096h3.024l7.38.36q2.736.108 7.056-.36l.648.072q.216 1.368.216 1.836 0 .252-.144 1.116-1.62.432-3.024.468-2.628.396-2.844.612-.54.54-.54 1.476 0 .252.054.972t.054 1.116q.288.684.792 14.256.216 7.02-.54 10.944-.54 2.736-1.476 4.392-1.368 2.34-4.032 4.428-2.7 2.052-6.552 3.204-3.924 1.188-9.18 1.188-6.012 0-10.224-1.656-4.284-1.692-6.444-4.392-2.196-2.736-2.988-7.02-.576-2.88-.576-8.532v-11.988q0-6.768-.612-7.668-.9-1.296-5.292-1.404zm53.568 50.724v-2.304q0-.504-.324-.828t-.828-.324h-52.992q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h52.992q.504 0 .828-.324t.324-.828z\",\"TABLE\":\"M18.432-14.903v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm-18.432-27.648v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm-18.432-27.648v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm18.432 13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-13.824v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm4.608-11.52v39.168q0 2.376-1.692 4.068t-4.068 1.692h-48.384q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h48.384q2.376 0 4.068 1.692t1.692 4.068z\",\"MAGIC\":\"M42.84-43.523l10.548-10.548-3.852-3.852-10.548 10.548zm16.092-10.548q0 .972-.648 1.62l-46.296 46.296q-.648.648-1.62.648t-1.62-.648l-7.128-7.128q-.648-.648-.648-1.62t.648-1.62l46.296-46.296q.648-.648 1.62-.648t1.62.648l7.128 7.128q.648.648.648 1.62zm-48.636-6.84l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528zm12.6 5.832l7.056 2.16-7.056 2.16-2.16 7.056-2.16-7.056-7.056-2.16 7.056-2.16 2.16-7.056zm33.48 17.208l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528zm-23.04-23.04l3.528 1.08-3.528 1.08-1.08 3.528-1.08-3.528-3.528-1.08 3.528-1.08 1.08-3.528z\",\"TRUCK\":\"M23.04-13.751q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm-13.824-18.432h13.824v-9.216h-5.688q-.468 0-.792.324l-7.02 7.02q-.324.324-.324.792v1.08zm46.08 18.432q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm9.216-39.168v36.864q0 .54-.144.954t-.486.666-.594.414-.846.216-.81.072-.918 0-.81-.018q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-13.824q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-2.304q-.108 0-.81.018t-.918 0-.81-.072-.846-.216-.594-.414-.486-.666-.144-.954q0-.936.684-1.62t1.62-.684v-11.52q0-.288-.018-1.26t0-1.368.09-1.242.234-1.332.504-1.098.81-1.08l7.128-7.128q.684-.684 1.818-1.152t2.106-.468h5.76v-6.912q0-.936.684-1.62t1.62-.684h36.864q.936 0 1.62.684t.684 1.62z\",\"PINTEREST\":\"M55.296-32.183q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708q-3.996 0-7.848-1.152 2.124-3.348 2.808-5.904.324-1.224 1.944-7.596.72 1.404 2.628 2.43t4.104 1.026q4.356 0 7.776-2.466t5.292-6.786 1.872-9.72q0-4.104-2.142-7.704t-6.21-5.868-9.18-2.268q-3.78 0-7.056 1.044t-5.562 2.772-3.924 3.978-2.412 4.662-.774 4.824q0 3.744 1.44 6.588t4.212 3.996q1.08.432 1.368-.72.072-.252.288-1.116t.288-1.08q.216-.828-.396-1.548-1.836-2.196-1.836-5.436 0-5.436 3.762-9.342t9.846-3.906q5.436 0 8.478 2.952t3.042 7.668q0 6.12-2.466 10.404t-6.318 4.284q-2.196 0-3.528-1.566t-.828-3.762q.288-1.26.954-3.366t1.08-3.708.414-2.718q0-1.8-.972-2.988t-2.772-1.188q-2.232 0-3.78 2.052t-1.548 5.112q0 2.628.9 4.392l-3.564 15.048q-.612 2.52-.468 6.372-7.416-3.276-11.988-10.116t-4.572-15.228q0-7.524 3.708-13.878t10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"PINTEREST_SQUARE\":\"M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-26.1q3.06-4.392 3.888-7.56.324-1.224 1.908-7.524.756 1.404 2.646 2.412t4.05 1.008q6.516 0 10.638-5.31t4.122-13.446q0-3.024-1.26-5.85t-3.474-5.004-5.49-3.492-7.092-1.314q-3.744 0-7.002 1.026t-5.508 2.754-3.87 3.942-2.394 4.608-.774 4.77q0 3.672 1.422 6.48t4.194 3.96q.468.18.846 0t.522-.684q.36-1.584.54-2.196.216-.828-.396-1.512-1.8-2.232-1.8-5.4 0-5.4 3.726-9.234t9.738-3.834q5.364 0 8.37 2.916t3.006 7.56q0 6.048-2.43 10.296t-6.246 4.248q-2.16 0-3.492-1.566t-.828-3.726q.288-1.224.954-3.33t1.062-3.672.396-2.682q0-1.764-.954-2.934t-2.718-1.17q-2.196 0-3.726 2.034t-1.53 5.022q0 2.592.864 4.356l-3.528 14.904q-.864 3.6-.252 9.144h-6.588q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56z\",\"GOOGLE_PLUS_SQUARE\":\"M33.012-31.859q0-.936-.216-2.304h-13.032v4.752h7.812q-.108.864-.594 1.8t-1.35 1.908-2.394 1.602-3.474.63q-3.564 0-6.084-2.556t-2.52-6.156 2.52-6.156 6.084-2.556q3.312 0 5.508 2.124l3.744-3.636q-3.888-3.6-9.252-3.6-5.76 0-9.792 4.05t-4.032 9.774 4.032 9.774 9.792 4.05q5.94 0 9.594-3.78t3.654-9.72zm12.42 1.656h3.924v-3.96h-3.924v-3.96h-3.96v3.96h-3.96v3.96h3.96v3.96h3.96v-3.96zm9.864-19.26v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"GOOGLE_PLUS\":\"M51.732-31.571q0 7.488-3.132 13.338t-8.928 9.144-13.284 3.294q-5.364 0-10.26-2.088t-8.424-5.616-5.616-8.424-2.088-10.26 2.088-10.26 5.616-8.424 8.424-5.616 10.26-2.088q10.296 0 17.676 6.912l-7.164 6.876q-4.212-4.068-10.512-4.068-4.428 0-8.19 2.232t-5.958 6.066-2.196 8.37 2.196 8.37 5.958 6.066 8.19 2.232q2.988 0 5.49-.828t4.122-2.07 2.826-2.826 1.764-2.988.774-2.664h-14.976v-9.072h24.912q.432 2.268.432 4.392zm31.212-4.392v7.56h-7.524v7.524h-7.56v-7.524h-7.524v-7.56h7.524v-7.524h7.56v7.524h7.524z\",\"MONEY\":\"M27.648-22.967h13.824v-3.456h-4.608v-16.128h-4.104l-5.328 4.932 2.772 2.88q1.512-1.332 1.98-2.052h.072v10.368h-4.608v3.456zm18.432-9.216q0 2.52-.756 5.112t-2.142 4.824-3.654 3.636-4.968 1.404-4.968-1.404-3.654-3.636-2.142-4.824-.756-5.112.756-5.112 2.142-4.824 3.654-3.636 4.968-1.404 4.968 1.404 3.654 3.636 2.142 4.824.756 5.112zm18.432 9.216v-18.432q-3.816 0-6.516-2.7t-2.7-6.516h-41.472q0 3.816-2.7 6.516t-6.516 2.7v18.432q3.816 0 6.516 2.7t2.7 6.516h41.472q0-3.816 2.7-6.516t6.516-2.7zm4.608-29.952v41.472q0 .936-.684 1.62t-1.62.684h-64.512q-.936 0-1.62-.684t-.684-1.62v-41.472q0-.936.684-1.62t1.62-.684h64.512q.936 0 1.62.684t.684 1.62z\",\"CARET_DOWN\":\"M36.864-39.095q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62z\",\"CARET_UP\":\"M36.864-20.663q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z\",\"CARET_LEFT\":\"M23.04-48.311v32.256q0 .936-.684 1.62t-1.62.684-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684.684 1.62z\",\"CARET_RIGHT\":\"M20.736-32.183q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684-.684-1.62v-32.256q0-.936.684-1.62t1.62-.684 1.62.684l16.128 16.128q.684.684.684 1.62z\",\"COLUMNS\":\"M5.76-9.143h21.888v-41.472h-23.04v40.32q0 .468.342.81t.81.342zm49.536-1.152v-40.32h-23.04v41.472h21.888q.468 0 .81-.342t.342-.81zm4.608-43.776v43.776q0 2.376-1.692 4.068t-4.068 1.692h-48.384q-2.376 0-4.068-1.692t-1.692-4.068v-43.776q0-2.376 1.692-4.068t4.068-1.692h48.384q2.376 0 4.068 1.692t1.692 4.068z\",\"UNSORTED\":\"M36.864-25.271q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62zm0-13.824q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z\",\"SORT_DOWN\":\"M36.864-25.271q0 .936-.684 1.62l-16.128 16.128q-.684.684-1.62.684t-1.62-.684l-16.128-16.128q-.684-.684-.684-1.62t.684-1.62 1.62-.684h32.256q.936 0 1.62.684t.684 1.62z\",\"SORT_UP\":\"M36.864-39.095q0 .936-.684 1.62t-1.62.684h-32.256q-.936 0-1.62-.684t-.684-1.62.684-1.62l16.128-16.128q.684-.684 1.62-.684t1.62.684l16.128 16.128q.684.684.684 1.62z\",\"ENVELOPE\":\"M64.512-38.879v28.584q0 2.376-1.692 4.068t-4.068 1.692h-52.992q-2.376 0-4.068-1.692t-1.692-4.068v-28.584q1.584 1.764 3.636 3.132 13.032 8.856 17.892 12.42 2.052 1.512 3.33 2.358t3.402 1.728 3.96.882h.072q1.836 0 3.96-.882t3.402-1.728 3.33-2.358q6.12-4.428 17.928-12.42 2.052-1.404 3.6-3.132zm0-10.584q0 2.844-1.764 5.436t-4.392 4.428q-13.536 9.396-16.848 11.7-.36.252-1.53 1.098t-1.944 1.368-1.872 1.17-2.07.972-1.8.324h-.072q-.828 0-1.8-.324t-2.07-.972-1.872-1.17-1.944-1.368-1.53-1.098q-3.276-2.304-9.432-6.57t-7.38-5.13q-2.232-1.512-4.212-4.158t-1.98-4.914q0-2.808 1.494-4.68t4.266-1.872h52.992q2.34 0 4.05 1.692t1.71 4.068z\",\"LINKEDIN\":\"M12.564-41.939v35.676h-11.88v-35.676h11.88zm.756-11.016q.036 2.628-1.818 4.392t-4.878 1.764h-.072q-2.952 0-4.752-1.764t-1.8-4.392q0-2.664 1.854-4.41t4.842-1.746 4.788 1.746 1.836 4.41zm41.976 26.244v20.448h-11.844v-19.08q0-3.78-1.458-5.922t-4.554-2.142q-2.268 0-3.798 1.242t-2.286 3.078q-.396 1.08-.396 2.916v19.908h-11.844q.072-14.364.072-23.292t-.036-10.656l-.036-1.728h11.844v5.184h-.072q.72-1.152 1.476-2.016t2.034-1.872 3.132-1.566 4.122-.558q6.156 0 9.9 4.086t3.744 11.97z\",\"UNDO\":\"M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196q-6.192 0-11.772-2.61t-9.504-7.362q-.252-.36-.234-.81t.306-.738l4.932-4.968q.36-.324.9-.324.576.072.828.432 2.628 3.42 6.444 5.292t8.1 1.872q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458q-3.528 0-6.768 1.278t-5.76 3.654l4.932 4.968q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l4.68 4.644q3.852-3.636 8.802-5.634t10.242-1.998q5.616 0 10.728 2.196t8.82 5.904 5.904 8.82 2.196 10.728z\",\"LEGAL\":\"M63.756-9.143q0 1.908-1.332 3.24l-3.852 3.888q-1.404 1.332-3.276 1.332-1.908 0-3.24-1.332l-13.068-13.104q-1.368-1.296-1.368-3.24 0-1.908 1.548-3.456l-9.216-9.216-4.536 4.536q-.504.504-1.224.504t-1.224-.504q.072.072.45.432t.45.468.36.414.36.486.216.486.198.594.054.648q0 1.368-1.008 2.448-.108.108-.594.648t-.684.738-.666.594-.792.558-.792.324-.936.162q-1.44 0-2.448-1.008l-14.688-14.688q-1.008-1.008-1.008-2.448 0-.468.162-.936t.324-.792.558-.792.594-.666.738-.684.648-.594q1.08-1.008 2.448-1.008.36 0 .648.054t.594.198.486.216.486.36.414.36.468.45.432.45q-.504-.504-.504-1.224t.504-1.224l12.528-12.528q.504-.504 1.224-.504t1.224.504q-.072-.072-.45-.432t-.45-.468-.36-.414-.36-.486-.216-.486-.198-.594-.054-.648q0-1.368 1.008-2.448.108-.108.594-.648t.684-.738.666-.594.792-.558.792-.324.936-.162q1.44 0 2.448 1.008l14.688 14.688q1.008 1.008 1.008 2.448 0 .468-.162.936t-.324.792-.558.792-.594.666-.738.684-.648.594q-1.08 1.008-2.448 1.008-.36 0-.648-.054t-.594-.198-.486-.216-.486-.36-.414-.36-.468-.45-.432-.45q.504.504.504 1.224t-.504 1.224l-4.536 4.536 9.216 9.216q1.548-1.548 3.456-1.548 1.872 0 3.276 1.332l13.068 13.068q1.332 1.404 1.332 3.276z\",\"TACHOMETER\":\"M13.824-22.967q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm6.912-16.128q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm15.408 17.316l3.636-13.752q.216-.936-.27-1.746t-1.386-1.062-1.728.234-1.08 1.422l-3.636 13.752q-2.16.18-3.852 1.566t-2.268 3.546q-.72 2.772.72 5.256t4.212 3.204 5.256-.72 3.204-4.212q.576-2.16-.216-4.212t-2.592-3.276zm23.76-1.188q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-23.04-23.04q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm16.128 6.912q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm11.52 16.128q0 9.396-5.076 17.388-.684 1.044-1.944 1.044h-50.472q-1.26 0-1.944-1.044-5.076-7.956-5.076-17.388 0-6.552 2.556-12.528t6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"COMMENT_O\":\"M32.256-50.615q-7.344 0-13.734 2.502t-10.152 6.75-3.762 9.18q0 4.032 2.574 7.686t7.254 6.318l3.132 1.8-.972 3.456q-.864 3.276-2.52 6.192 5.472-2.268 9.9-6.156l1.548-1.368 2.052.216q2.484.288 4.68.288 7.344 0 13.734-2.502t10.152-6.75 3.762-9.18-3.762-9.18-10.152-6.75-13.734-2.502zm32.256 18.432q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792h-.18q-.54 0-.972-.378t-.576-.99v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-6.264 4.32-11.574t11.736-8.388 16.2-3.078 16.2 3.078 11.736 8.388 4.32 11.574z\",\"COMMENTS_O\":\"M25.344-50.615q-5.508 0-10.296 1.872t-7.614 5.076-2.826 6.876q0 2.952 1.908 5.688t5.364 4.752l3.492 2.016-1.26 3.024q1.224-.72 2.232-1.404l1.584-1.116 1.908.36q2.808.504 5.508.504 5.508 0 10.296-1.872t7.614-5.076 2.826-6.876-2.826-6.876-7.614-5.076-10.296-1.872zm0-4.608q6.876 0 12.726 2.466t9.234 6.714 3.384 9.252-3.384 9.252-9.234 6.714-12.726 2.466q-3.096 0-6.336-.576-4.464 3.168-10.008 4.608-1.296.324-3.096.576h-.108q-.396 0-.738-.288t-.414-.756q-.036-.108-.036-.234t.018-.234.072-.216l.09-.18.126-.198.144-.18.162-.18.144-.162q.18-.216.828-.9t.936-1.062.81-1.044.9-1.386.738-1.584q-4.464-2.592-7.02-6.372t-2.556-8.064q0-5.004 3.384-9.252t9.234-6.714 12.726-2.466zm29.592 42.084q.36.864.738 1.584t.9 1.386.81 1.044.936 1.062.828.9l.144.162.162.18.144.18.126.198.09.18.072.216.018.234-.036.234q-.108.504-.468.792t-.792.252q-1.8-.252-3.096-.576-5.544-1.44-10.008-4.608-3.24.576-6.336.576-9.756 0-16.992-4.752 2.088.144 3.168.144 5.796 0 11.124-1.62t9.504-4.644q4.5-3.312 6.912-7.632t2.412-9.144q0-2.772-.828-5.472 4.644 2.556 7.344 6.408t2.7 8.28q0 4.32-2.556 8.082t-7.02 6.354z\",\"FLASH\":\"M31.86-44.063q.648.72.252 1.584l-19.44 41.652q-.468.9-1.512.9-.144 0-.504-.072-.612-.18-.918-.684t-.162-1.08l7.092-29.088-14.616 3.636q-.144.036-.432.036-.648 0-1.116-.396-.648-.54-.468-1.404l7.236-29.7q.144-.504.576-.828t1.008-.324h11.808q.684 0 1.152.45t.468 1.062q0 .288-.18.648l-6.156 16.668 14.256-3.528q.288-.072.432-.072.684 0 1.224.54z\",\"SITEMAP\":\"M64.512-19.511v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912h-18.432v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912h-18.432v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-11.52q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h3.456v-6.912q0-1.872 1.368-3.24t3.24-1.368h18.432v-6.912h-3.456q-1.44 0-2.448-1.008t-1.008-2.448v-11.52q0-1.44 1.008-2.448t2.448-1.008h11.52q1.44 0 2.448 1.008t1.008 2.448v11.52q0 1.44-1.008 2.448t-2.448 1.008h-3.456v6.912h18.432q1.872 0 3.24 1.368t1.368 3.24v6.912h3.456q1.44 0 2.448 1.008t1.008 2.448z\",\"UMBRELLA\":\"M32.256-34.631v20.88q0 3.744-2.736 6.48t-6.48 2.736-6.48-2.736-2.736-6.48q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62q0 1.8 1.404 3.204t3.204 1.404 3.204-1.404 1.404-3.204v-20.88q1.188-.396 2.304-.396t2.304.396zm27.648.972q0 .468-.342.81t-.81.342q-.396 0-.828-.36-1.764-1.656-3.348-2.484t-3.672-.828q-2.448 0-4.608 1.332t-3.708 3.492q-.252.36-.63 1.008t-.522.864q-.396.612-1.008.612-.648 0-1.044-.612-.144-.216-.522-.864t-.63-1.008q-1.548-2.16-3.69-3.492t-4.59-1.332-4.59 1.332-3.69 3.492q-.252.36-.63 1.008t-.522.864q-.396.612-1.044.612-.612 0-1.008-.612-.144-.216-.522-.864t-.63-1.008q-1.548-2.16-3.708-3.492t-4.608-1.332q-2.088 0-3.672.828t-3.348 2.484q-.432.36-.828.36-.468 0-.81-.342t-.342-.81q0-.18.036-.252 1.62-6.588 6.21-11.502t10.728-7.362 12.978-2.448q5.04 0 9.882 1.44t8.874 4.086 7.002 6.732 4.158 9.054q.036.072.036.252zm-27.648-26.172v3.528q-1.512-.072-2.304-.072t-2.304.072v-3.528q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62z\",\"PASTE\":\"M27.648-4.535h32.256v-23.04h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-13.824v41.472zm9.216-51.84v-2.304q0-.468-.342-.81t-.81-.342h-25.344q-.468 0-.81.342t-.342.81v2.304q0 .468.342.81t.81.342h25.344q.468 0 .81-.342t.342-.81zm9.216 24.192h10.764l-10.764-10.764v10.764zm18.432 4.608v24.192q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-19.584q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h39.168q1.44 0 2.448 1.008t1.008 2.448v11.808q.756.468 1.296 1.008l14.688 14.688q1.008 1.008 1.728 2.736t.72 3.168z\",\"LIGHTBULB_O\":\"M26.496-43.703q0 .468-.342.81t-.81.342-.81-.342-.342-.81q0-1.656-1.944-2.556t-3.816-.9q-.468 0-.81-.342t-.342-.81.342-.81.81-.342q1.8 0 3.582.576t3.132 1.944 1.35 3.24zm5.76 0q0-2.592-1.242-4.824t-3.24-3.654-4.428-2.232-4.914-.81-4.914.81-4.428 2.232-3.24 3.654-1.242 4.824q0 3.636 2.448 6.48.36.396 1.098 1.188t1.098 1.188q4.608 5.508 5.076 10.728h8.208q.468-5.22 5.076-10.728.36-.396 1.098-1.188t1.098-1.188q2.448-2.844 2.448-6.48zm4.608 0q0 5.58-3.708 9.648-1.62 1.764-2.682 3.132t-2.142 3.438-1.224 3.87q1.692 1.008 1.692 2.952 0 1.332-.9 2.304.9.972.9 2.304 0 1.872-1.62 2.916.468.828.468 1.692 0 1.656-1.134 2.556t-2.79.9q-.72 1.584-2.16 2.52t-3.132.936-3.132-.936-2.16-2.52q-1.656 0-2.79-.9t-1.134-2.556q0-.864.468-1.692-1.62-1.044-1.62-2.916 0-1.332.9-2.304-.9-.972-.9-2.304 0-1.944 1.692-2.952-.144-1.8-1.224-3.87t-2.142-3.438-2.682-3.132q-3.708-4.068-3.708-9.648 0-3.564 1.602-6.642t4.212-5.112 5.904-3.204 6.714-1.17 6.714 1.17 5.904 3.204 4.212 5.112 1.602 6.642z\",\"EXCHANGE\":\"M64.512-21.815v6.912q0 .468-.342.81t-.81.342h-49.536v6.912q0 .468-.342.81t-.81.342q-.432 0-.864-.36l-11.484-11.52q-.324-.324-.324-.792 0-.504.324-.828l11.52-11.52q.324-.324.828-.324.468 0 .81.342t.342.81v6.912h49.536q.468 0 .81.342t.342.81zm0-19.584q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-49.536q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h49.536v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828z\",\"CLOUD_DOWNLOAD\":\"M46.08-31.031q0-.504-.324-.828t-.828-.324h-8.064v-12.672q0-.468-.342-.81t-.81-.342h-6.912q-.468 0-.81.342t-.342.81v12.672h-8.064q-.468 0-.81.342t-.342.81q0 .504.324.828l12.672 12.672q.324.324.828.324t.828-.324l12.636-12.636q.36-.432.36-.864zm23.04 8.064q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.68 2.52-8.64t6.768-5.94q-.072-1.08-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.616 0 10.278 3.132t6.786 8.316q2.556-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.736-1.476 4.968 4.68 1.116 7.686 4.878t3.006 8.586z\",\"CLOUD_UPLOAD\":\"M46.08-33.335q0-.504-.324-.828l-12.672-12.672q-.324-.324-.828-.324t-.828.324l-12.636 12.636q-.36.432-.36.864 0 .504.324.828t.828.324h8.064v12.672q0 .468.342.81t.81.342h6.912q.468 0 .81-.342t.342-.81v-12.672h8.064q.468 0 .81-.342t.342-.81zm23.04 10.368q0 5.724-4.05 9.774t-9.774 4.05h-39.168q-6.66 0-11.394-4.734t-4.734-11.394q0-4.68 2.52-8.64t6.768-5.94q-.072-1.08-.072-1.548 0-7.632 5.4-13.032t13.032-5.4q5.616 0 10.278 3.132t6.786 8.316q2.556-2.232 5.976-2.232 3.816 0 6.516 2.7t2.7 6.516q0 2.736-1.476 4.968 4.68 1.116 7.686 4.878t3.006 8.586z\",\"USER_MD\":\"M13.824-16.055q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm36.864 2.196q0 4.356-2.628 6.84t-6.984 2.484h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-2.448.198-4.716t.864-4.968 1.71-4.77 2.916-3.708 4.32-2.178q-.792 1.872-.792 4.32v7.308q-2.088.72-3.348 2.52t-1.26 3.996q0 2.88 2.016 4.896t4.896 2.016 4.896-2.016 2.016-4.896q0-2.196-1.278-3.996t-3.33-2.52v-7.308q0-2.232.9-3.348 4.752 3.744 10.62 3.744t10.62-3.744q.9 1.116.9 3.348v2.304q-3.816 0-6.516 2.7t-2.7 6.516v3.204q-1.152 1.044-1.152 2.556 0 1.44 1.008 2.448t2.448 1.008 2.448-1.008 1.008-2.448q0-1.512-1.152-2.556v-3.204q0-1.872 1.368-3.24t3.24-1.368 3.24 1.368 1.368 3.24v3.204q-1.152 1.044-1.152 2.556 0 1.44 1.008 2.448t2.448 1.008 2.448-1.008 1.008-2.448q0-1.512-1.152-2.556v-3.204q0-2.448-1.242-4.59t-3.366-3.366q0-.36.018-1.53t0-1.728-.09-1.494-.252-1.692-.468-1.44q2.448.54 4.32 2.178t2.916 3.708 1.71 4.77.864 4.968.198 4.716zm-11.52-32.148q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z\",\"STETHOSCOPE\":\"M46.08-39.095q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm4.608 0q0 2.232-1.278 3.996t-3.33 2.52v14.22q0 5.724-4.734 9.774t-11.394 4.05-11.394-4.05-4.734-9.774v-4.752q-5.904-.72-9.864-4.608t-3.96-9.072v-18.432q0-.936.684-1.62t1.62-.684q.216 0 .576.072.612-1.08 1.692-1.728t2.34-.648q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35q-1.188 0-2.304-.648v14.472q0 3.816 3.384 6.516t8.136 2.7 8.136-2.7 3.384-6.516v-14.472q-1.116.648-2.304.648-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35q1.26 0 2.34.648t1.692 1.728q.36-.072.576-.072.936 0 1.62.684t.684 1.62v18.432q0 5.184-3.96 9.072t-9.864 4.608v4.752q0 3.816 3.384 6.516t8.136 2.7 8.136-2.7 3.384-6.516v-14.22q-2.052-.756-3.33-2.52t-1.278-3.996q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896z\",\"SUITCASE\":\"M23.04-50.615h18.432v-4.608h-18.432v4.608zm-12.672 0v46.08h-2.304q-3.312 0-5.688-2.376t-2.376-5.688v-29.952q0-3.312 2.376-5.688t5.688-2.376h2.304zm40.32 0v46.08h-36.864v-46.08h4.608v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h4.608zm13.824 8.064v29.952q0 3.312-2.376 5.688t-5.688 2.376h-2.304v-46.08h2.304q3.312 0 5.688 2.376t2.376 5.688z\",\"BELL\":\"M32.832-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm29.376-10.368q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-16.128q-1.872 0-3.24-1.368t-1.368-3.24q1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 6.84 1.008 11.052 5.706t4.212 10.17q0 5.004.702 9.36t1.8 7.416 2.682 5.706 3.06 4.302 3.276 3.168z\",\"COFFEE\":\"M59.904-41.399q0-2.88-2.016-4.896t-4.896-2.016h-2.304v13.824h2.304q2.88 0 4.896-2.016t2.016-4.896zm-59.904 27.648h64.512q0 3.816-2.7 6.516t-6.516 2.7h-46.08q-3.816 0-6.516-2.7t-2.7-6.516zm66.816-27.648q0 5.724-4.05 9.774t-9.774 4.05h-2.304v1.152q0 3.312-2.376 5.688t-5.688 2.376h-25.344q-3.312 0-5.688-2.376t-2.376-5.688v-26.496q0-.936.684-1.62t1.62-.684h41.472q5.724 0 9.774 4.05t4.05 9.774z\",\"CUTLERY\":\"M23.04-62.135v23.04q0 2.196-1.278 3.996t-3.33 2.52v28.044q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-28.044q-2.052-.72-3.33-2.52t-1.278-3.996v-23.04q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-14.976q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-14.976q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62zm27.648 0v57.6q0 1.872-1.368 3.24t-3.24 1.368h-4.608q-1.872 0-3.24-1.368t-1.368-3.24v-18.432h-8.064q-.468 0-.81-.342t-.342-.81v-28.8q0-4.752 3.384-8.136t8.136-3.384h9.216q.936 0 1.62.684t.684 1.62z\",\"FILE_TEXT_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-36.864-31.104q0-.504.324-.828t.828-.324h25.344q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304zm26.496 8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h25.344zm0 9.216q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-25.344q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h25.344z\",\"BUILDING_O\":\"M13.824-17.207v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm18.432 9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216 49.536h13.824v-55.296h-41.472v55.296h13.824v-8.064q0-.468.342-.81t.81-.342h11.52q.468 0 .81.342t.342.81v8.064zm18.432-57.6v59.904q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h46.08q.936 0 1.62.684t.684 1.62z\",\"HOSPITAL_O\":\"M13.824-17.207v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm0-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm27.648 18.432v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm18.432 9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216-9.216v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm9.216 0v2.304q0 .468-.342.81t-.81.342h-2.304q-.468 0-.81-.342t-.342-.81v-2.304q0-.468.342-.81t.81-.342h2.304q.468 0 .81.342t.342.81zm-9.216 31.104h13.824v-41.472h-9.216v1.152q0 1.44-1.008 2.448t-2.448 1.008h-16.128q-1.44 0-2.448-1.008t-1.008-2.448v-1.152h-9.216v41.472h13.824v-8.064q0-.468.342-.81t.81-.342h11.52q.468 0 .81.342t.342.81v8.064zm0-42.624v-11.52q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v3.456h-4.608v-3.456q0-.468-.342-.81t-.81-.342h-2.304q-.468 0-.81.342t-.342.81v11.52q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81v-3.456h4.608v3.456q0 .468.342.81t.81.342h2.304q.468 0 .81-.342t.342-.81zm18.432-1.152v46.08q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-46.08q0-.936.684-1.62t1.62-.684h11.52v-10.368q0-1.44 1.008-2.448t2.448-1.008h16.128q1.44 0 2.448 1.008t1.008 2.448v10.368h11.52q.936 0 1.62.684t.684 1.62z\",\"AMBULANCE\":\"M23.04-13.751q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-18.432h13.824v-9.216h-5.688q-.504.072-.792.324l-7.02 7.02q-.252.432-.324.792v1.08zm46.08 18.432q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm4.608-24.192v-6.912q0-.504-.324-.828t-.828-.324h-8.064v-8.064q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v8.064h-8.064q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h8.064v8.064q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828v-8.064h8.064q.504 0 .828-.324t.324-.828zm9.216-19.584v41.472q0 .936-.684 1.62t-1.62.684h-6.912q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-13.824q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516h-4.608q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684v-14.976q0-.936.468-2.088t1.152-1.836l7.128-7.128q.684-.684 1.836-1.152t2.088-.468h5.76v-11.52q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z\",\"MEDKIT\":\"M46.08-24.119v-6.912q0-.504-.324-.828t-.828-.324h-8.064v-8.064q0-.504-.324-.828t-.828-.324h-6.912q-.504 0-.828.324t-.324.828v8.064h-8.064q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h8.064v8.064q0 .504.324.828t.828.324h6.912q.504 0 .828-.324t.324-.828v-8.064h8.064q.504 0 .828-.324t.324-.828zm-23.04-26.496h18.432v-4.608h-18.432v4.608zm-13.824 0v46.08h-1.152q-3.312 0-5.688-2.376t-2.376-5.688v-29.952q0-3.312 2.376-5.688t5.688-2.376h1.152zm42.624 0v46.08h-39.168v-46.08h5.76v-5.76q0-1.44 1.008-2.448t2.448-1.008h20.736q1.44 0 2.448 1.008t1.008 2.448v5.76h5.76zm12.672 8.064v29.952q0 3.312-2.376 5.688t-5.688 2.376h-1.152v-46.08h1.152q3.312 0 5.688 2.376t2.376 5.688z\",\"FIGHTER_JET\":\"M69.12-29.879q-.036 1.152-10.368 3.456l-12.672 1.152-8.064 2.304h-2.304l-10.548 12.672h2.484q.936 0 1.62.162t.684.414-.684.414-1.62.162h-11.52v-1.152h2.304v-14.976h-5.76l-6.912 8.064h-3.456l-1.152-1.152v-6.912h1.152v-1.152h4.608v-.288l-6.912-.864v-4.608l6.912-.864v-.288h-4.608v-1.152h-1.152v-6.912l1.152-1.152h3.456l6.912 8.064h5.76v-14.976h-2.304v-1.152h11.52q.936 0 1.62.162t.684.414-.684.414-1.62.162h-2.484l10.548 12.672h2.304l8.064 2.304 12.672 1.152q9.396 2.088 10.332 3.348z\",\"BEER\":\"M23.04-32.183v-13.824h-9.216v9.216q0 1.908 1.35 3.258t3.258 1.35h4.608zm36.864 16.128v6.912h-41.472v-6.912l4.608-6.912h-4.608q-5.724 0-9.774-4.05t-4.05-9.774v-11.52l-2.304-2.304 1.152-4.608h17.28l1.152-4.608h34.56l1.152 6.912-2.304 1.152v28.8z\",\"H_SQUARE\":\"M46.08-16.055v-32.256q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v11.52h-18.432v-11.52q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v32.256q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-11.52h18.432v11.52q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62zm9.216-33.408v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"PLUS_SQUARE\":\"M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-11.52v-11.52q0-.936-.684-1.62t-1.62-.684h-4.608q-.936 0-1.62.684t-.684 1.62v11.52h-11.52q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h11.52v11.52q0 .936.684 1.62t1.62.684h4.608q.936 0 1.62-.684t.684-1.62v-11.52h11.52q.936 0 1.62-.684t.684-1.62zm9.216-19.584v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"ANGLE_DOUBLE_LEFT\":\"M22.572-14.903q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828zm13.824 0q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828z\",\"ANGLE_DOUBLE_RIGHT\":\"M21.42-29.879q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828zm13.824 0q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z\",\"ANGLE_DOUBLE_UP\":\"M38.7-17.207q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828zm0-13.824q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z\",\"ANGLE_DOUBLE_DOWN\":\"M38.7-33.335q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828zm0-13.824q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z\",\"ANGLE_LEFT\":\"M22.572-44.855q0 .468-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828t-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z\",\"ANGLE_RIGHT\":\"M21.42-29.879q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z\",\"ANGLE_UP\":\"M38.7-21.815q0 .468-.36.828l-1.8 1.8q-.36.36-.828.36t-.828-.36l-14.148-14.148-14.148 14.148q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828z\",\"ANGLE_DOWN\":\"M38.7-37.943q0 .468-.36.828l-16.776 16.776q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l14.148 14.148 14.148-14.148q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828z\",\"DESKTOP\":\"M64.512-28.727v-29.952q0-.468-.342-.81t-.81-.342h-57.6q-.468 0-.81.342t-.342.81v29.952q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81zm4.608-29.952v39.168q0 2.376-1.692 4.068t-4.068 1.692h-19.584q0 1.332.576 2.79t1.152 2.556.576 1.566q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62q0-.504.576-1.584t1.152-2.52.576-2.808h-19.584q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z\",\"LAPTOP\":\"M14.976-18.359q-2.376 0-4.068-1.692t-1.692-4.068v-25.344q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068v25.344q0 2.376-1.692 4.068t-4.068 1.692h-39.168zm-1.152-31.104v25.344q0 .468.342.81t.81.342h39.168q.468 0 .81-.342t.342-.81v-25.344q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81zm49.536 33.408h5.76v3.456q0 1.44-1.692 2.448t-4.068 1.008h-57.6q-2.376 0-4.068-1.008t-1.692-2.448v-3.456h63.36zm-25.92 3.456q.576 0 .576-.576t-.576-.576h-5.76q-.576 0-.576.576t.576.576h5.76z\",\"TABLET\":\"M23.04-13.751q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm13.824-5.76v-34.56q0-.468-.342-.81t-.81-.342h-29.952q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h29.952q.468 0 .81-.342t.342-.81zm4.608-34.56v39.168q0 2.376-1.692 4.068t-4.068 1.692h-29.952q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h29.952q2.376 0 4.068 1.692t1.692 4.068z\",\"MOBILE_PHONE\":\"M16.704-13.751q0-1.188-.846-2.034t-2.034-.846-2.034.846-.846 2.034.846 2.034 2.034.846 2.034-.846.846-2.034zm7.488-5.76v-25.344q0-.468-.342-.81t-.81-.342h-18.432q-.468 0-.81.342t-.342.81v25.344q0 .468.342.81t.81.342h18.432q.468 0 .81-.342t.342-.81zm-6.912-30.528q0-.576-.576-.576h-5.76q-.576 0-.576.576t.576.576h5.76q.576 0 .576-.576zm10.368-.576v36.864q0 1.872-1.368 3.24t-3.24 1.368h-18.432q-1.872 0-3.24-1.368t-1.368-3.24v-36.864q0-1.872 1.368-3.24t3.24-1.368h18.432q1.872 0 3.24 1.368t1.368 3.24z\",\"CIRCLE_O\":\"M27.648-51.767q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"QUOTE_LEFT\":\"M27.648-29.879v13.824q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-25.344q0-3.744 1.458-7.146t3.942-5.886 5.886-3.942 7.146-1.458h2.304q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-2.304q-3.816 0-6.516 2.7t-2.7 6.516v1.152q0 1.44 1.008 2.448t2.448 1.008h8.064q2.88 0 4.896 2.016t2.016 4.896zm32.256 0v13.824q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-25.344q0-3.744 1.458-7.146t3.942-5.886 5.886-3.942 7.146-1.458h2.304q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-2.304q-3.816 0-6.516 2.7t-2.7 6.516v1.152q0 1.44 1.008 2.448t2.448 1.008h8.064q2.88 0 4.896 2.016t2.016 4.896z\",\"QUOTE_RIGHT\":\"M27.648-52.919v25.344q0 3.744-1.458 7.146t-3.942 5.886-5.886 3.942-7.146 1.458h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304q3.816 0 6.516-2.7t2.7-6.516v-1.152q0-1.44-1.008-2.448t-2.448-1.008h-8.064q-2.88 0-4.896-2.016t-2.016-4.896v-13.824q0-2.88 2.016-4.896t4.896-2.016h13.824q2.88 0 4.896 2.016t2.016 4.896zm32.256 0v25.344q0 3.744-1.458 7.146t-3.942 5.886-5.886 3.942-7.146 1.458h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304q3.816 0 6.516-2.7t2.7-6.516v-1.152q0-1.44-1.008-2.448t-2.448-1.008h-8.064q-2.88 0-4.896-2.016t-2.016-4.896v-13.824q0-2.88 2.016-4.896t4.896-2.016h13.824q2.88 0 4.896 2.016t2.016 4.896z\",\"SPINNER\":\"M18.936-14.255q0 1.908-1.35 3.258t-3.258 1.35q-1.872 0-3.24-1.368t-1.368-3.24q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm17.928 7.416q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-25.344-25.344q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm43.272 17.928q0 1.872-1.368 3.24t-3.24 1.368q-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-34.704-35.856q0 2.376-1.692 4.068t-4.068 1.692-4.068-1.692-1.692-4.068 1.692-4.068 4.068-1.692 4.068 1.692 1.692 4.068zm42.12 17.928q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-23.04-25.344q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm19.08 7.416q0 3.348-2.376 5.706t-5.688 2.358q-3.348 0-5.706-2.358t-2.358-5.706q0-3.312 2.358-5.688t5.706-2.376q3.312 0 5.688 2.376t2.376 5.688z\",\"CIRCLE\":\"M55.296-32.183q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"REPLY\":\"M64.512-24.119q0 5.976-4.572 16.236-.108.252-.378.864t-.486 1.08-.468.792q-.432.612-1.008.612-.54 0-.846-.36t-.306-.9q0-.324.09-.954t.09-.846q.18-2.448.18-4.428 0-3.636-.63-6.516t-1.746-4.986-2.88-3.636-3.798-2.502-4.788-1.53-5.544-.774-6.318-.216h-8.064v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q.684-.684 1.62-.684t1.62.684.684 1.62v9.216h8.064q25.668 0 31.5 14.508 1.908 4.824 1.908 11.988z\",\"GITHUB_ALT\":\"M23.04-20.663q0 1.44-.45 2.952t-1.548 2.736-2.61 1.224-2.61-1.224-1.548-2.736-.45-2.952.45-2.952 1.548-2.736 2.61-1.224 2.61 1.224 1.548 2.736.45 2.952zm23.04 0q0 1.44-.45 2.952t-1.548 2.736-2.61 1.224-2.61-1.224-1.548-2.736-.45-2.952.45-2.952 1.548-2.736 2.61-1.224 2.61 1.224 1.548 2.736.45 2.952zm5.76 0q0-4.32-2.484-7.344t-6.732-3.024q-1.476 0-7.02.756-2.556.396-5.652.396t-5.652-.396q-5.472-.756-7.02-.756-4.248 0-6.732 3.024t-2.484 7.344q0 3.168 1.152 5.526t2.916 3.708 4.392 2.16 5.04 1.062 5.364.252h6.048q2.952 0 5.364-.252t5.04-1.062 4.392-2.16 2.916-3.708 1.152-5.526zm8.064-6.336q0 7.452-2.196 11.916-1.368 2.772-3.798 4.788t-5.076 3.096-6.12 1.71-6.174.792-6.012.162q-2.808 0-5.112-.108t-5.31-.45-5.49-1.08-4.932-1.854-4.356-2.916-3.096-4.14q-2.232-4.428-2.232-11.916 0-8.532 4.896-14.256-.972-2.952-.972-6.12 0-4.176 1.836-7.848 3.888 0 6.84 1.422t6.804 4.446q5.292-1.26 11.124-1.26 5.328 0 10.08 1.152 3.78-2.952 6.732-4.356t6.804-1.404q1.836 3.672 1.836 7.848 0 3.132-.972 6.048 4.896 5.76 4.896 14.328z\",\"FOLDER_O\":\"M55.296-17.207v-25.344q0-1.44-1.008-2.448t-2.448-1.008h-25.344q-1.44 0-2.448-1.008t-1.008-2.448v-2.304q0-1.44-1.008-2.448t-2.448-1.008h-11.52q-1.44 0-2.448 1.008t-1.008 2.448v34.56q0 1.44 1.008 2.448t2.448 1.008h43.776q1.44 0 2.448-1.008t1.008-2.448zm4.608-25.344v25.344q0 3.312-2.376 5.688t-5.688 2.376h-43.776q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h24.192q3.312 0 5.688 2.376t2.376 5.688z\",\"FOLDER_OPEN_O\":\"M64.116-30.923q0-1.26-1.908-1.26h-39.168q-1.44 0-3.078.774t-2.574 1.89l-10.584 13.068q-.648.864-.648 1.44 0 1.26 1.908 1.26h39.168q1.44 0 3.096-.792t2.556-1.908l10.584-13.068q.648-.792.648-1.404zm-41.076-5.868h27.648v-5.76q0-1.44-1.008-2.448t-2.448-1.008h-20.736q-1.44 0-2.448-1.008t-1.008-2.448v-2.304q0-1.44-1.008-2.448t-2.448-1.008h-11.52q-1.44 0-2.448 1.008t-1.008 2.448v30.708l9.216-11.34q1.584-1.908 4.176-3.15t5.04-1.242zm45.684 5.868q0 2.232-1.656 4.32l-10.62 13.068q-1.548 1.908-4.176 3.15t-5.04 1.242h-39.168q-3.312 0-5.688-2.376t-2.376-5.688v-34.56q0-3.312 2.376-5.688t5.688-2.376h11.52q3.312 0 5.688 2.376t2.376 5.688v1.152h19.584q3.312 0 5.688 2.376t2.376 5.688v5.76h6.912q1.944 0 3.564.882t2.412 2.538q.54 1.152.54 2.448z\",\"SMILE_O\":\"M40.824-25.739q-1.332 4.356-4.968 7.02t-8.208 2.664-8.208-2.664-4.968-7.02q-.288-.9.144-1.746t1.368-1.134q.9-.288 1.746.144t1.134 1.368q.9 2.88 3.33 4.662t5.454 1.782 5.454-1.782 3.33-4.662q.288-.936 1.152-1.368t1.764-.144 1.332 1.134.144 1.746zm-17.784-15.66q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"FROWN_O\":\"M40.824-20.195q.288.9-.144 1.746t-1.332 1.134-1.764-.144-1.152-1.368q-.9-2.88-3.33-4.662t-5.454-1.782-5.454 1.782-3.33 4.662q-.288.936-1.134 1.368t-1.746.144q-.936-.288-1.368-1.134t-.144-1.746q1.332-4.356 4.968-7.02t8.208-2.664 8.208 2.664 4.968 7.02zm-17.784-21.204q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"MEH_O\":\"M41.472-25.271q0 .936-.684 1.62t-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h23.04q.936 0 1.62.684t.684 1.62zm-18.432-16.128q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm18.432 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm9.216 9.216q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"GAMEPAD\":\"M29.952-25.271v-4.608q0-.504-.324-.828t-.828-.324h-6.912v-6.912q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v6.912h-6.912q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h6.912v6.912q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828v-6.912h6.912q.504 0 .828-.324t.324-.828zm20.736 2.304q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm9.216-9.216q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm9.216 4.608q0 7.632-5.4 13.032t-13.032 5.4q-6.912 0-12.168-4.608h-7.92q-5.256 4.608-12.168 4.608-7.632 0-13.032-5.4t-5.4-13.032 5.4-13.032 13.032-5.4h32.256q7.632 0 13.032 5.4t5.4 13.032z\",\"KEYBOARD_O\":\"M13.824-22.391v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm4.608-9.216v3.456q0 .576-.576.576h-8.064q-.576 0-.576-.576v-3.456q0-.576.576-.576h8.064q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm36.864 18.432v3.456q0 .576-.576.576h-31.104q-.576 0-.576-.576v-3.456q0-.576.576-.576h31.104q.576 0 .576.576zm-23.04-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-4.608-9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm13.824 9.216v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm-18.432-18.432v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm9.216 0v3.456q0 .576-.576.576h-3.456q-.576 0-.576-.576v-3.456q0-.576.576-.576h3.456q.576 0 .576.576zm9.216 0v12.672q0 .576-.576.576h-8.064q-.576 0-.576-.576v-3.456q0-.576.576-.576h4.032v-8.64q0-.576.576-.576h3.456q.576 0 .576.576zm4.608 27.072v-32.256h-59.904v32.256h59.904zm4.608-32.256v32.256q0 1.908-1.35 3.258t-3.258 1.35h-59.904q-1.908 0-3.258-1.35t-1.35-3.258v-32.256q0-1.908 1.35-3.258t3.258-1.35h59.904q1.908 0 3.258 1.35t1.35 3.258z\",\"FLAG_O\":\"M59.904-26.819v-22.176q-6.084 3.276-11.016 3.276-2.952 0-5.22-1.152-3.6-1.764-6.624-2.754t-6.408-.99q-6.228 0-14.508 4.572v21.564q8.82-4.068 15.588-4.068 1.98 0 3.726.27t3.528.936 2.772 1.116 2.97 1.422l1.008.504q1.584.792 3.636.792 4.32 0 10.548-3.312zm-48.384-28.404q0 1.26-.63 2.304t-1.674 1.656v45.576q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-45.576q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 1.404-1.26 2.052-.36.18-.612.324-7.848 4.176-13.284 4.176-3.168 0-5.688-1.26l-1.008-.504q-2.304-1.188-3.564-1.728t-3.276-1.044-4.104-.504q-3.672 0-8.478 1.584t-8.226 3.672q-.54.324-1.188.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-26.712q0-1.26 1.116-1.98 1.26-.756 2.826-1.53t4.104-1.872 5.49-1.782 5.58-.684q4.032 0 7.524 1.116t7.524 3.096q1.368.684 3.204.684 4.392 0 11.16-4.032l1.116-.612q1.116-.576 2.232.072 1.116.72 1.116 1.98z\",\"FLAG_CHECKERED\":\"M29.952-28.439v-6.912q-6.516.576-13.824 4.212v6.66q7.38-3.456 13.824-3.96zm0-15.048v-7.092q-6.192.288-13.824 4.536v6.804q7.74-3.996 13.824-4.248zm29.952 16.668v-6.624q-8.46 4.176-13.824 2.556v-8.064q-.72-.216-1.404-.54-.18-.108-1.188-.612t-1.242-.612-1.134-.54-1.242-.558-1.17-.468-1.296-.45-1.26-.306-1.422-.27-1.422-.144-1.584-.072q-.828 0-1.764.108v7.992h.684q3.672 0 6.93 1.044t7.11 2.952q.684.324 1.404.54v6.768q1.512.612 3.276.612 4.32 0 10.548-3.312zm0-15.372v-6.804q-6.084 3.276-11.016 3.276-1.62 0-2.808-.288v7.056q5.328 1.512 13.824-3.24zm-48.384-13.032q0 1.26-.63 2.304t-1.674 1.656v45.576q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-45.576q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35 3.258 1.35 1.35 3.258zm52.992 2.304v27.468q0 1.404-1.26 2.052-.36.18-.612.324-7.848 4.176-13.284 4.176-3.168 0-5.688-1.26l-1.008-.504q-2.304-1.188-3.564-1.728t-3.276-1.044-4.104-.504q-3.672 0-8.478 1.584t-8.226 3.672q-.54.324-1.188.324-.576 0-1.152-.288-1.152-.684-1.152-2.016v-26.712q0-1.26 1.116-1.98 1.26-.756 2.826-1.53t4.104-1.872 5.49-1.782 5.58-.684q4.032 0 7.524 1.116t7.524 3.096q1.368.684 3.204.684 4.392 0 11.16-4.032l1.116-.612q1.116-.576 2.232.072 1.116.72 1.116 1.98z\",\"TERMINAL\":\"M21.06-29.051l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828t-.36.828zm38.844 16.452v2.304q0 .504-.324.828t-.828.324h-34.56q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h34.56q.504 0 .828.324t.324.828z\",\"CODE\":\"M22.212-14.075l-1.8 1.8q-.36.36-.828.36t-.828-.36l-16.776-16.776q-.36-.36-.36-.828t.36-.828l16.776-16.776q.36-.36.828-.36t.828.36l1.8 1.8q.36.36.36.828t-.36.828l-14.148 14.148 14.148 14.148q.36.36.36.828t-.36.828zm21.276-38.412l-13.428 46.476q-.144.468-.558.702t-.846.09l-2.232-.612q-.468-.144-.702-.558t-.09-.882l13.428-46.476q.144-.468.558-.702t.846-.09l2.232.612q.468.144.702.558t.09.882zm23.652 23.436l-16.776 16.776q-.36.36-.828.36t-.828-.36l-1.8-1.8q-.36-.36-.36-.828t.36-.828l14.148-14.148-14.148-14.148q-.36-.36-.36-.828t.36-.828l1.8-1.8q.36-.36.828-.36t.828.36l16.776 16.776q.36.36.36.828t-.36.828z\",\"REPLY_ALL\":\"M23.04-25.487v2.52q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v2.484l-14.292 14.328q-.684.684-.684 1.62t.684 1.62zm41.472 1.368q0 2.088-.612 4.806t-1.386 4.968-1.728 4.5-1.458 3.258l-.72 1.44q-.288.612-1.008.612-.216 0-.324-.036-.9-.288-.828-1.224 1.548-14.4-3.816-20.34-2.304-2.556-6.138-3.978t-9.63-1.89v9.036q0 1.512-1.404 2.124-.468.18-.9.18-.972 0-1.62-.684l-18.432-18.432q-.684-.684-.684-1.62t.684-1.62l18.432-18.432q1.044-1.116 2.52-.504 1.404.612 1.404 2.124v9.432q14.796 1.008 21.564 7.956 6.084 6.228 6.084 18.324z\",\"STAR_HALF_O\":\"M42.696-29.987l9.252-9-12.816-1.872-2.376-.36-1.08-2.16-5.724-11.592v34.668l2.124 1.116 11.448 6.048-2.16-12.78-.432-2.376zm16.272-9.432l-13.068 12.744 3.096 18q.18 1.188-.216 1.854t-1.224.666q-.612 0-1.44-.432l-16.164-8.496-16.164 8.496q-.828.432-1.44.432-.828 0-1.224-.666t-.216-1.854l3.096-18-13.104-12.744q-1.152-1.152-.828-2.142t1.944-1.242l18.072-2.628 8.1-16.38q.72-1.476 1.764-1.476 1.008 0 1.764 1.476l8.1 16.38 18.072 2.628q1.62.252 1.944 1.242t-.864 2.142z\",\"LOCATION_ARROW\":\"M50.436-51.875l-23.04 46.08q-.612 1.26-2.052 1.26-.18 0-.54-.072-.792-.18-1.278-.81t-.486-1.422v-20.736h-20.736q-.792 0-1.422-.486t-.81-1.278.144-1.512 1.044-1.08l46.08-23.04q.468-.252 1.044-.252.972 0 1.62.684.54.504.666 1.242t-.234 1.422z\",\"CROP\":\"M20.052-18.359h21.42v-21.42zm-1.62-1.62l21.42-21.42h-21.42v21.42zm41.472 2.772v6.912q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-8.064h-31.104q-.504 0-.828-.324t-.324-.828v-31.104h-8.064q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h8.064v-8.064q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v8.064h30.636l8.856-8.892q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828l-8.892 8.856v30.636h8.064q.504 0 .828.324t.324.828z\",\"CODE_FORK\":\"M10.368-11.447q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm0-41.472q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm23.04 4.608q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm3.456 0q0 1.872-.936 3.474t-2.52 2.502q-.072 10.332-8.136 14.904-2.448 1.368-7.308 2.916-4.608 1.44-6.102 2.556t-1.494 3.6v.936q1.584.9 2.52 2.502t.936 3.474q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896q0-1.872.936-3.474t2.52-2.502v-29.52q-1.584-.9-2.52-2.502t-.936-3.474q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896q0 1.872-.936 3.474t-2.52 2.502v17.892q1.944-.936 5.544-2.052 1.98-.612 3.15-1.062t2.538-1.116 2.124-1.422 1.458-1.836 1.008-2.502.306-3.294q-1.584-.9-2.52-2.502t-.936-3.474q0-2.88 2.016-4.896t4.896-2.016 4.896 2.016 2.016 4.896z\",\"UNLINK\":\"M15.804-18.683l-9.216 9.216q-.36.324-.828.324-.432 0-.828-.324-.324-.36-.324-.828t.324-.828l9.216-9.216q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828zm6.084 1.476v11.52q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-11.52q0-.504.324-.828t.828-.324.828.324.324.828zm-8.064-8.064q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h11.52q.504 0 .828.324t.324.828zm45.504 4.608q0 4.32-3.06 7.308l-5.292 5.256q-2.988 2.988-7.308 2.988-4.356 0-7.344-3.06l-12.024-12.06q-.756-.756-1.512-2.016l8.604-.648 9.828 9.864q.972.972 2.448.99t2.448-.954l5.292-5.256q1.008-1.008 1.008-2.412 0-1.44-1.008-2.448l-9.864-9.9.648-8.604q1.26.756 2.016 1.512l12.096 12.096q3.024 3.096 3.024 7.344zm-22.212-26.064l-8.604.648-9.828-9.864q-1.008-1.008-2.448-1.008-1.404 0-2.448.972l-5.292 5.256q-1.008 1.008-1.008 2.412 0 1.44 1.008 2.448l9.864 9.864-.648 8.64q-1.26-.756-2.016-1.512l-12.096-12.096q-3.024-3.096-3.024-7.344 0-4.32 3.06-7.308l5.292-5.256q2.988-2.988 7.308-2.988 4.356 0 7.344 3.06l12.024 12.06q.756.756 1.512 2.016zm22.788 3.024q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h11.52q.504 0 .828.324t.324.828zm-19.584-19.584v11.52q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-11.52q0-.504.324-.828t.828-.324.828.324.324.828zm14.652 5.436l-9.216 9.216q-.396.324-.828.324t-.828-.324q-.324-.36-.324-.828t.324-.828l9.216-9.216q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828z\",\"QUESTION\":\"M25.344-19.223v8.64q0 .576-.432 1.008t-1.008.432h-8.64q-.576 0-1.008-.432t-.432-1.008v-8.64q0-.576.432-1.008t1.008-.432h8.64q.576 0 1.008.432t.432 1.008zm11.376-21.6q0 1.944-.558 3.636t-1.26 2.754-1.98 2.142-2.07 1.566-2.196 1.278q-1.476.828-2.466 2.34t-.99 2.412q0 .612-.432 1.17t-1.008.558h-8.64q-.54 0-.918-.666t-.378-1.35v-1.62q0-2.988 2.34-5.634t5.148-3.906q2.124-.972 3.024-2.016t.9-2.736q0-1.512-1.674-2.664t-3.87-1.152q-2.34 0-3.888 1.044-1.26.9-3.852 4.14-.468.576-1.116.576-.432 0-.9-.288l-5.904-4.5q-.468-.36-.558-.9t.198-1.008q5.76-9.576 16.704-9.576 2.88 0 5.796 1.116t5.256 2.988 3.816 4.59 1.476 5.706z\",\"INFO\":\"M23.04-16.055v4.608q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h2.304v-13.824h-2.304q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62v20.736h2.304q.936 0 1.62.684t.684 1.62zm-4.608-41.472v6.912q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-6.912q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62z\",\"EXCLAMATION\":\"M18.432-19.511v8.064q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-8.064q0-.936.684-1.62t1.62-.684h9.216q.936 0 1.62.684t.684 1.62zm1.08-38.016l-1.008 27.648q-.036.936-.738 1.62t-1.638.684h-9.216q-.936 0-1.638-.684t-.738-1.62l-1.008-27.648q-.036-.936.63-1.62t1.602-.684h11.52q.936 0 1.602.684t.63 1.62z\",\"SUPERSCRIPT\":\"M32.292-15.155v6.012h-8.928l-5.724-9.072-.864-1.512q-.288-.324-.396-.756h-.108l-.324.756q-.36.72-.9 1.584l-5.58 9h-9.288v-6.012h4.608l7.092-10.476-6.66-9.792h-4.932v-6.048h9.936l5.004 8.208q.072.144.828 1.512.288.324.396.756h.108q.108-.324.396-.756l.9-1.512 5.04-8.208h9.252v6.048h-4.5l-6.624 9.612 7.344 10.656h3.924zm22.932-24.444v7.416h-18.504l-.108-.972q-.144-1.008-.144-1.656 0-2.304.936-4.212t2.34-3.114 3.024-2.34 3.024-1.962 2.34-1.944.936-2.304q0-1.368-1.062-2.25t-2.538-.882q-1.836 0-3.492 1.404-.504.396-1.296 1.368l-3.78-3.312q.936-1.332 2.268-2.376 2.988-2.34 6.768-2.34 3.96 0 6.408 2.142t2.448 5.706q0 2.016-.882 3.708t-2.232 2.754-2.934 2.106-2.952 1.818-2.358 1.854-1.098 2.268h8.352v-2.88h4.536z\",\"SUBSCRIPT\":\"M32.292-15.155v6.012h-8.928l-5.724-9.072-.864-1.512q-.288-.324-.396-.756h-.108l-.324.756q-.36.72-.9 1.584l-5.58 9h-9.288v-6.012h4.608l7.092-10.476-6.66-9.792h-4.932v-6.048h9.936l5.004 8.208q.072.144.828 1.512.288.324.396.756h.108q.108-.324.396-.756l.9-1.512 5.04-8.208h9.252v6.048h-4.5l-6.624 9.612 7.344 10.656h3.924zm23.004 7.812v7.416h-18.504l-.144-.972-.108-1.656q0-2.304.936-4.212t2.34-3.114 3.024-2.34 3.024-1.962 2.34-1.944.936-2.304q0-1.368-1.062-2.25t-2.538-.882q-1.836 0-3.492 1.404-.504.396-1.296 1.368l-3.78-3.312q.936-1.332 2.268-2.376 2.88-2.34 6.768-2.34 3.96 0 6.408 2.142t2.448 5.706q0 2.376-1.242 4.266t-3.024 3.096-3.582 2.25-3.132 2.268-1.476 2.628h8.352v-2.88h4.536z\",\"ERASER\":\"M32.256-13.751l12.096-13.824h-27.648l-12.096 13.824h27.648zm36.468-38.772q.54 1.224.342 2.574t-1.098 2.358l-32.256 36.864q-1.368 1.584-3.456 1.584h-27.648q-1.368 0-2.502-.738t-1.71-1.962q-.54-1.224-.342-2.574t1.098-2.358l32.256-36.864q1.368-1.584 3.456-1.584h27.648q1.368 0 2.502.738t1.71 1.962z\",\"PUZZLE_PIECE\":\"M59.904-24.911q0 2.916-1.602 4.86t-4.446 1.944q-1.476 0-2.79-.63t-2.124-1.368-2.034-1.368-2.556-.63q-3.96 0-3.96 4.464 0 1.404.576 4.14t.54 4.14v.18q-.792 0-1.188.036-1.224.108-3.51.414t-4.158.486-3.528.18q-2.196 0-3.708-.954t-1.512-3.006q0-1.332.63-2.556t1.368-2.034 1.368-2.124.63-2.79q0-2.844-1.944-4.446t-4.86-1.602q-3.024 0-5.148 1.638t-2.124 4.59q0 1.548.54 2.988t1.206 2.322 1.206 1.908.54 1.818q0 1.62-1.656 3.204-1.332 1.26-4.212 1.26-3.42 0-8.82-.864-.324-.072-.99-.144t-.99-.144l-.468-.072-.108-.036-.072-.036v-36.864q.072.036.63.126t1.224.18.774.126q5.4.864 8.82.864 2.88 0 4.212-1.26 1.656-1.584 1.656-3.204 0-.792-.54-1.818t-1.206-1.908-1.206-2.322-.54-2.988q0-2.952 2.124-4.59t5.184-1.638q2.88 0 4.824 1.602t1.944 4.446q0 1.476-.63 2.79t-1.368 2.124-1.368 2.034-.63 2.556q0 2.052 1.512 3.006t3.708.954q2.304 0 6.48-.54t5.868-.612v.072q-.036.072-.126.63t-.18 1.224-.126.774q-.864 5.4-.864 8.82 0 2.88 1.26 4.212 1.584 1.656 3.204 1.656.792 0 1.818-.54t1.908-1.206 2.322-1.206 2.988-.54q2.952 0 4.59 2.124t1.638 5.148z\",\"MICROPHONE\":\"M41.472-39.095v4.608q0 7.956-5.31 13.842t-13.122 6.75v4.752h9.216q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 6.66 4.734 11.394t11.394 4.734 11.394-4.734 4.734-11.394v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62zm-9.216-13.824v18.432q0 4.752-3.384 8.136t-8.136 3.384-8.136-3.384-3.384-8.136v-18.432q0-4.752 3.384-8.136t8.136-3.384 8.136 3.384 3.384 8.136z\",\"MICROPHONE_SLASH\":\"M9.756-30.419l-3.636 3.636q-1.512-3.708-1.512-7.704v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 1.908.54 4.068zm40.104-21.672l-12.996 12.996v4.608q0 4.752-3.384 8.136t-8.136 3.384q-1.98 0-3.924-.684l-3.456 3.456q3.492 1.836 7.38 1.836 6.66 0 11.394-4.734t4.734-11.394v-4.608q0-.936.684-1.62t1.62-.684 1.62.684.684 1.62v4.608q0 7.956-5.31 13.842t-13.122 6.75v4.752h9.216q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-23.04q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216v-4.752q-4.5-.468-8.46-2.916l-9.144 9.144q-.36.36-.828.36t-.828-.36l-2.952-2.952q-.36-.36-.36-.828t.36-.828l44.424-44.424q.36-.36.828-.36t.828.36l2.952 2.952q.36.36.36.828t-.36.828zm-13.68-4.752l-22.356 22.356v-18.432q0-4.752 3.384-8.136t8.136-3.384q3.672 0 6.642 2.124t4.194 5.472z\",\"SHIELD\":\"M39.168-29.879v-23.04h-16.128v40.932q4.284-2.268 7.668-4.932 8.46-6.624 8.46-12.96zm6.912-27.648v27.648q0 3.096-1.206 6.138t-2.988 5.4-4.248 4.59-4.554 3.708-4.356 2.79-3.222 1.782-1.53.72q-.432.216-.936.216t-.936-.216q-.576-.252-1.53-.72t-3.222-1.782-4.356-2.79-4.554-3.708-4.248-4.59-2.988-5.4-1.206-6.138v-27.648q0-.936.684-1.62t1.62-.684h41.472q.936 0 1.62.684t.684 1.62z\",\"CALENDAR_O\":\"M4.608-4.535h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z\",\"FIRE_EXTINGUISHER\":\"M18.432-57.527q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm32.256-1.152v11.52q0 .576-.432.9-.288.252-.72.252-.144 0-.252-.036l-16.128-3.456q-.396-.072-.648-.396t-.252-.72h-9.216v3.672q3.996.828 6.606 3.996t2.61 7.308v28.8q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-28.8q0-3.816 2.25-6.858t5.814-4.122v-3.996h-1.152q-2.124 0-4.14.846t-3.294 1.908-2.376 2.394-1.458 1.926-.504.882q-.612 1.26-2.052 1.26-.576 0-1.044-.252-.828-.432-1.134-1.332t.126-1.764q.18-.36.522-.936t1.35-1.926 2.178-2.52 3.06-2.412 3.906-1.89q-.9-1.512-.9-3.096 0-2.376 1.692-4.068t4.068-1.692 4.068 1.692 1.692 4.068q0 1.188-.504 2.304h10.872q0-.396.252-.72t.648-.396l16.128-3.456q.108-.036.252-.036.432 0 .72.252.432.324.432.9z\",\"ROCKET\":\"M51.84-48.311q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm8.064-10.368q0 8.964-2.718 15.498t-9.126 12.978q-2.916 2.88-7.02 6.336l-.72 13.644q-.072.576-.576.936l-13.824 8.064q-.252.144-.576.144-.432 0-.828-.324l-2.304-2.304q-.468-.504-.288-1.152l3.06-9.936-10.116-10.116-9.936 3.06q-.108.036-.324.036-.504 0-.828-.324l-2.304-2.304q-.612-.684-.18-1.404l8.064-13.824q.36-.504.936-.576l13.644-.72q3.456-4.104 6.336-7.02 6.768-6.732 12.888-9.288t15.516-2.556q.504 0 .864.342t.36.81z\",\"MAXCDN\":\"M62.82-36.611l-5.904 27.468h-12.024l6.408-29.952q.468-2.016-.54-3.168-.972-1.188-2.988-1.188h-6.084l-7.344 34.308h-12.024l7.344-34.308h-10.296l-7.344 34.308h-12.024l7.344-34.308-5.508-11.772h45.936q3.636 0 6.822 1.458t5.31 4.086q2.16 2.628 2.916 6.066t0 7.002z\",\"CHEVRON_CIRCLE_LEFT\":\"M32.724-14.219l3.672-3.672q.684-.684.684-1.62t-.684-1.62l-11.052-11.052 11.052-11.052q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-16.344 16.344q-.684.684-.684 1.62t.684 1.62l16.344 16.344q.684.684 1.62.684t1.62-.684zm22.572-17.964q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CHEVRON_CIRCLE_RIGHT\":\"M25.812-14.219l16.344-16.344q.684-.684.684-1.62t-.684-1.62l-16.344-16.344q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l11.052 11.052-11.052 11.052q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684zm29.484-17.964q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CHEVRON_CIRCLE_UP\":\"M41.94-23.435l3.672-3.672q.684-.684.684-1.62t-.684-1.62l-16.344-16.344q-.684-.684-1.62-.684t-1.62.684l-16.344 16.344q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684l11.052-11.052 11.052 11.052q.684.684 1.62.684t1.62-.684zm13.356-8.748q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"CHEVRON_CIRCLE_DOWN\":\"M29.268-17.675l16.344-16.344q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-11.052 11.052-11.052-11.052q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l16.344 16.344q.684.684 1.62.684t1.62-.684zm26.028-14.508q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"HTML5\":\"M40.68-42.947l.576-6.3h-31.824l1.692 19.224h22.032l-.792 8.208-7.092 1.908-7.056-1.908-.468-5.04h-6.3l.792 10.008 13.032 3.6h.144v-.036l12.924-3.564 1.8-19.584h-23.184l-.54-6.516h24.264zm-40.68-16.884h50.688l-4.608 51.768-20.808 5.832-20.664-5.832z\",\"CSS3\":\"M9.9-59.831h54.18l-9.576 47.988-28.944 9.612-25.128-9.612 2.556-12.816h10.692l-1.044 5.292 15.192 5.796 17.496-5.796 2.448-12.204h-43.488l2.088-10.692h43.524l1.368-6.876h-43.488z\",\"ANCHOR\":\"M34.56-55.223q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62.684 1.62 1.62.684 1.62-.684.684-1.62zm29.952 33.408v12.672q0 .792-.72 1.08-.288.072-.432.072-.468 0-.828-.324l-3.348-3.348q-4.284 5.148-11.466 8.154t-15.462 3.006-15.462-3.006-11.466-8.154l-3.348 3.348q-.324.324-.828.324-.144 0-.432-.072-.72-.288-.72-1.08v-12.672q0-.504.324-.828t.828-.324h12.672q.792 0 1.08.72.288.684-.252 1.26l-3.6 3.6q2.412 3.276 6.822 5.526t9.774 2.97v-23.292h-6.912q-.936 0-1.62-.684t-.684-1.62v-4.608q0-.936.684-1.62t1.62-.684h6.912v-5.868q-2.088-1.224-3.348-3.33t-1.26-4.626q0-3.816 2.7-6.516t6.516-2.7 6.516 2.7 2.7 6.516q0 2.52-1.26 4.626t-3.348 3.33v5.868h6.912q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-6.912v23.292q5.364-.72 9.774-2.97t6.822-5.526l-3.6-3.6q-.54-.576-.252-1.26.288-.72 1.08-.72h12.672q.504 0 .828.324t.324.828z\",\"UNLOCK_ALT\":\"M38.016-36.791q1.44 0 2.448 1.008t1.008 2.448v20.736q0 1.44-1.008 2.448t-2.448 1.008h-34.56q-1.44 0-2.448-1.008t-1.008-2.448v-20.736q0-1.44 1.008-2.448t2.448-1.008h1.152v-11.52q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394q0 .936-.684 1.62t-1.62.684h-2.304q-.936 0-1.62-.684t-.684-1.62q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v11.52h26.496z\",\"BULLSEYE\":\"M36.864-32.183q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm4.608 0q0-5.724-4.05-9.774t-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05 9.774-4.05 4.05-9.774zm4.608 0q0 7.632-5.4 13.032t-13.032 5.4-13.032-5.4-5.4-13.032 5.4-13.032 13.032-5.4 13.032 5.4 5.4 13.032zm4.608 0q0-4.68-1.836-8.946t-4.914-7.344-7.344-4.914-8.946-1.836-8.946 1.836-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946zm4.608 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ELLIPSIS_H\":\"M13.824-37.943v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm18.432 0v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm18.432 0v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448z\",\"ELLIPSIS_V\":\"M13.824-19.511v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448zm0-18.432v6.912q0 1.44-1.008 2.448t-2.448 1.008h-6.912q-1.44 0-2.448-1.008t-1.008-2.448v-6.912q0-1.44 1.008-2.448t2.448-1.008h6.912q1.44 0 2.448 1.008t1.008 2.448z\",\"RSS_SQUARE\":\"M18.432-18.359q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm12.636 3.384q-.468-8.352-6.372-14.256t-14.256-6.372q-.504-.036-.864.324t-.36.828v4.608q0 .468.306.792t.774.36q5.544.396 9.504 4.356t4.356 9.504q.036.468.36.774t.792.306h4.608q.468 0 .828-.36t.324-.864zm13.824.036q-.18-5.544-2.016-10.71t-5.022-9.36-7.38-7.38-9.36-5.022-10.71-2.016q-.504-.036-.828.324-.36.36-.36.828v4.608q0 .468.324.792t.792.36q7.344.252 13.608 4.014t10.026 10.026 4.014 13.608q.036.468.36.792t.792.324h4.608q.468 0 .828-.36.396-.324.324-.828zm10.404-34.524v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"PLAY_CIRCLE\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm13.824 29.628q1.152-.648 1.152-1.98t-1.152-1.98l-19.584-11.52q-1.116-.684-2.304-.036-1.152.684-1.152 2.016v23.04q0 1.332 1.152 2.016.576.288 1.152.288.612 0 1.152-.324z\",\"TICKET\":\"M36.864-48.167l11.376 11.376-20.592 20.592-11.376-11.376zm-7.596 35.244l22.248-22.248q.684-.684.684-1.62t-.684-1.62l-13.032-13.032q-.648-.648-1.62-.648t-1.62.648l-22.248 22.248q-.684.684-.684 1.62t.684 1.62l13.032 13.032q.648.648 1.62.648t1.62-.648zm32.004-22.932l-32.652 32.688q-1.332 1.332-3.258 1.332t-3.258-1.332l-4.536-4.536q2.016-2.016 2.016-4.896t-2.016-4.896-4.896-2.016-4.896 2.016l-4.5-4.536q-1.332-1.332-1.332-3.258t1.332-3.258l32.652-32.616q1.332-1.332 3.258-1.332t3.258 1.332l4.5 4.5q-2.016 2.016-2.016 4.896t2.016 4.896 4.896 2.016 4.896-2.016l4.536 4.5q1.332 1.332 1.332 3.258t-1.332 3.258z\",\"MINUS_SQUARE\":\"M46.08-29.879v-4.608q0-.936-.684-1.62t-1.62-.684h-32.256q-.936 0-1.62.684t-.684 1.62v4.608q0 .936.684 1.62t1.62.684h32.256q.936 0 1.62-.684t.684-1.62zm9.216-19.584v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"MINUS_SQUARE_O\":\"M41.472-35.639v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828zm4.608 16.128v-29.952q0-2.376-1.692-4.068t-4.068-1.692h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068zm4.608-29.952v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z\",\"LEVEL_UP\":\"M36.648-42.731q-.648 1.332-2.088 1.332h-6.912v31.104q0 .504-.324.828t-.828.324h-25.344q-.756 0-1.044-.648-.288-.72.144-1.26l5.76-6.912q.324-.396.9-.396h11.52v-23.04h-6.912q-1.44 0-2.088-1.332-.612-1.332.324-2.448l11.52-13.824q.648-.792 1.764-.792t1.764.792l11.52 13.824q.972 1.152.324 2.448z\",\"LEVEL_DOWN\":\"M1.152-55.223h25.344q.468 0 .81.342t.342.846v31.068h6.912q1.44 0 2.088 1.332t-.324 2.484l-11.52 13.824q-.648.792-1.764.792t-1.764-.792l-11.52-13.824q-.936-1.116-.324-2.484.648-1.332 2.088-1.332h6.912v-23.04h-11.52q-.504 0-.9-.396l-5.76-6.912q-.468-.504-.144-1.224.324-.684 1.044-.684z\",\"CHECK_SQUARE\":\"M24.66-17.675l22.104-22.104q.684-.684.684-1.62t-.684-1.62l-3.672-3.672q-.684-.684-1.62-.684t-1.62.684l-16.812 16.812-7.596-7.596q-.684-.684-1.62-.684t-1.62.684l-3.672 3.672q-.684.684-.684 1.62t.684 1.62l12.888 12.888q.684.684 1.62.684t1.62-.684zm30.636-31.788v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"PENCIL_SQUARE\":\"M14.544-24.551l5.472 5.472-1.872 1.872h-2.016v-3.456h-3.456v-2.016zm14.904-14.04q.504.468-.108 1.08l-10.476 10.476q-.612.612-1.08.108-.504-.468.108-1.08l10.476-10.476q.612-.612 1.08-.108zm-9.864 24.84l19.584-19.584-10.368-10.368-19.584 19.584v10.368h10.368zm21.888-21.888l3.312-3.312q1.008-1.008 1.008-2.448t-1.008-2.448l-5.472-5.472q-1.008-1.008-2.448-1.008t-2.448 1.008l-3.312 3.312zm13.824-13.824v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"EXTERNAL_LINK_SQUARE\":\"M46.08-31.031v-17.28q0-.936-.684-1.62t-1.62-.684h-17.28q-1.512 0-2.124 1.404-.612 1.476.504 2.52l5.184 5.184-19.224 19.224q-.684.684-.684 1.62t.684 1.62l3.672 3.672q.684.684 1.62.684t1.62-.684l19.224-19.224 5.184 5.184q.648.684 1.62.684.432 0 .9-.18 1.404-.612 1.404-2.124zm9.216-18.432v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"SHARE_SQUARE\":\"M36.18-24.803l12.672-12.672q.684-.684.684-1.62t-.684-1.62l-12.672-12.672q-1.08-1.116-2.484-.504-1.44.612-1.44 2.124v5.76q-4.284 0-7.776.702t-5.85 1.836-4.104 2.844-2.754 3.438-1.602 3.924-.774 4.014-.18 3.978q0 6.516 6.012 14.544.36.432.9.432.252 0 .468-.108.792-.324.684-1.188-1.584-12.744 2.232-17.028 1.656-1.872 4.68-2.718t8.064-.846v5.76q0 1.512 1.44 2.124.432.18.864.18.936 0 1.62-.684zm19.116-24.66v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"COMPASS\":\"M23.04-25.271l9.216-4.608-9.216-4.608v9.216zm13.824-21.276v19.512l-18.432 9.216v-19.512zm10.368 14.364q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"TOGGLE_DOWN\":\"M41.22-40.139q.648 1.26-.18 2.376l-11.52 16.128q-.684.972-1.872.972t-1.872-.972l-11.52-16.128q-.828-1.116-.18-2.376.612-1.26 2.052-1.26h23.04q1.44 0 2.052 1.26zm4.86 25.236v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TOGGLE_UP\":\"M41.22-24.227q-.612 1.26-2.052 1.26h-23.04q-1.44 0-2.052-1.26-.648-1.26.18-2.376l11.52-16.128q.684-.972 1.872-.972t1.872.972l11.52 16.128q.828 1.116.18 2.376zm4.86 9.324v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TOGGLE_RIGHT\":\"M39.168-32.183q0 1.188-.972 1.872l-16.128 11.52q-1.116.828-2.376.18-1.26-.612-1.26-2.052v-23.04q0-1.44 1.26-2.052 1.26-.648 2.376.18l16.128 11.52q.972.684.972 1.872zm6.912 17.28v-34.56q0-.504-.324-.828t-.828-.324h-34.56q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h34.56q.504 0 .828-.324t.324-.828zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"EURO\":\"M35.136-17.387l1.26 5.724q.108.432-.108.81t-.612.522l-.18.036q-.144.072-.378.126t-.576.162-.774.198-.918.18-1.08.18-1.206.162-1.314.108-1.386.036q-8.424 0-14.724-4.698t-8.568-12.654h-3.42q-.468 0-.81-.342t-.342-.81v-4.068q0-.468.342-.81t.81-.342h2.376q-.072-2.052.036-3.78h-2.412q-.504 0-.828-.324t-.324-.828v-4.104q0-.504.324-.828t.828-.324h3.528q2.412-7.56 8.766-12.168t14.418-4.608q3.672 0 6.984.828.396.108.72.54.216.396.108.864l-1.548 5.724q-.108.468-.504.702t-.864.09l-.144-.036-.414-.09-.63-.126-.81-.126-.936-.108-1.044-.09-1.062-.036q-4.536 0-8.136 2.304t-5.4 6.336h16.848q.576 0 .9.432.36.432.252.936l-.864 4.104q-.18.936-1.152.936h-17.568q-.108 1.332 0 3.78h16.524q.54 0 .9.432.324.432.216.972l-.864 4.032q-.072.396-.396.666t-.72.27h-13.932q1.728 4.212 5.382 6.678t8.226 2.466q.648 0 1.296-.054t1.206-.126 1.062-.162.882-.18.666-.162l.432-.108.18-.072q.468-.18.936.072.432.252.54.756z\",\"GBP\":\"M36.72-23.507v13.212q0 .504-.324.828t-.828.324h-34.416q-.504 0-.828-.324t-.324-.828v-5.4q0-.468.342-.81t.81-.342h3.492v-13.788h-3.42q-.504 0-.828-.342t-.324-.81v-4.716q0-.504.324-.828t.828-.324h3.42v-8.028q0-6.156 4.446-10.152t11.322-3.996q6.66 0 12.06 4.5.324.288.36.738t-.252.81l-3.708 4.572q-.324.396-.792.432-.468.072-.828-.252-.18-.18-.936-.684t-2.484-1.152-3.348-.648q-3.06 0-4.932 1.692t-1.872 4.428v7.74h10.98q.468 0 .81.324t.342.828v4.716q0 .468-.342.81t-.81.342h-10.98v13.644h14.904v-6.516q0-.468.324-.81t.828-.342h5.832q.504 0 .828.342t.324.81z\",\"USD\":\"M35.208-21.779q0 5.508-3.582 9.486t-9.306 4.914v6.3q0 .504-.324.828t-.828.324h-4.86q-.468 0-.81-.342t-.342-.81v-6.3q-2.376-.324-4.59-1.116t-3.654-1.602-2.664-1.728-1.674-1.35-.63-.648q-.612-.756-.072-1.476l3.708-4.86q.252-.36.828-.432.54-.072.864.324l.072.072q4.068 3.564 8.748 4.5 1.332.288 2.664.288 2.916 0 5.13-1.548t2.214-4.392q0-1.008-.54-1.908t-1.206-1.512-2.106-1.35-2.376-1.152-2.88-1.17q-1.404-.576-2.214-.9t-2.214-.954-2.25-1.116-2.034-1.278-1.926-1.53-1.566-1.764-1.278-2.088-.756-2.394-.306-2.808q0-4.968 3.528-8.712t9.18-4.824v-6.48q0-.468.342-.81t.81-.342h4.86q.504 0 .828.324t.324.828v6.336q2.052.216 3.978.828t3.132 1.206 2.286 1.35 1.404 1.044.54.504q.612.648.18 1.368l-2.916 5.256q-.288.54-.828.576-.504.108-.972-.252-.108-.108-.522-.432t-1.404-.954-2.106-1.152-2.682-.936-3.078-.414q-3.42 0-5.58 1.548t-2.16 3.996q0 .936.306 1.728t1.062 1.494 1.422 1.188 2.016 1.116 2.178.972 2.52.99q1.908.72 2.916 1.134t2.736 1.26 2.718 1.53 2.232 1.8 1.908 2.286 1.134 2.754.468 3.384z\",\"RUPEE\":\"M32.328-47.519v3.672q0 .504-.324.828t-.828.324h-6.048q-.828 5.184-4.644 8.424t-9.936 3.96q6.012 6.408 16.524 19.296.504.576.144 1.224-.288.648-1.044.648h-7.02q-.576 0-.9-.432-11.016-13.212-17.928-20.556-.324-.324-.324-.792v-4.572q0-.468.342-.81t.81-.342h4.032q4.752 0 7.65-1.548t3.69-4.5h-15.372q-.504 0-.828-.324t-.324-.828v-3.672q0-.504.324-.828t.828-.324h14.868q-2.052-4.068-9.648-4.068h-5.22q-.468 0-.81-.342t-.342-.81v-4.788q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828v3.672q0 .504-.324.828t-.828.324h-8.388q1.692 2.196 2.304 5.184h6.156q.504 0 .828.324t.324.828z\",\"YEN\":\"M21.708-9.143h-6.192q-.468 0-.81-.324t-.342-.828v-11.88h-10.368q-.468 0-.81-.324t-.342-.828v-3.708q0-.468.342-.81t.81-.342h10.368v-3.06h-10.368q-.468 0-.81-.324t-.342-.828v-3.744q0-.468.342-.81t.81-.342h7.704l-11.556-20.808q-.288-.576 0-1.152.36-.576 1.008-.576h6.984q.684 0 1.044.648l7.74 15.3q.684 1.368 2.016 4.5.36-.864 1.098-2.448t.99-2.196l6.876-15.12q.288-.684 1.044-.684h6.876q.612 0 .972.576.324.504.036 1.116l-11.268 20.844h7.74q.468 0 .81.342t.342.81v3.744q0 .504-.342.828t-.81.324h-10.44v3.06h10.44q.468 0 .81.342t.342.81v3.708q0 .504-.342.828t-.81.324h-10.44v11.88q0 .468-.342.81t-.81.342z\",\"RUBLE\":\"M37.548-44.099q0-3.6-2.34-5.832t-6.156-2.232h-11.52v16.128h11.52q3.816 0 6.156-2.232t2.34-5.832zm8.532 0q0 6.948-4.554 11.34t-11.754 4.392h-12.24v4.248h18.18q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-18.18v6.912q0 .504-.342.828t-.81.324h-6.012q-.504 0-.828-.324t-.324-.828v-6.912h-8.064q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h8.064v-4.248h-8.064q-.504 0-.828-.324t-.324-.828v-5.364q0-.468.324-.81t.828-.342h8.064v-22.644q0-.504.324-.828t.828-.324h19.404q7.2 0 11.754 4.392t4.554 11.34z\",\"WON\":\"M18.504-21.419l2.916-10.764h-5.724l2.7 10.8.036.108.036.108.018-.126.018-.126zm4.176-15.372l1.26-4.608h-10.512l1.152 4.608h8.1zm6.912 0h5.004l-1.26-4.608h-2.52zm16.164 15.408l2.808-10.8h-5.832l2.916 10.764.018.126.054.126.018-.108.018-.108zm3.996-15.408l1.188-4.608h-10.692l1.224 4.608h8.28zm14.76 1.152v2.304q0 .504-.324.828t-.828.324h-7.668l-5.904 22.176q-.252.864-1.116.864h-5.724q-.864 0-1.116-.864l-5.976-22.176h-7.524l-6.012 22.176q-.252.864-1.116.864h-5.724q-.396 0-.702-.252t-.378-.612l-5.76-22.176h-7.488q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h6.3l-1.188-4.608h-5.112q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.924l-3.204-12.384q-.18-.54.18-1.008.36-.432.936-.432h4.932q.936 0 1.116.864l3.24 12.96h12.924l3.492-12.96q.252-.864 1.116-.864h4.536q.864 0 1.116.864l3.528 12.96h13.14l3.348-12.96q.18-.864 1.116-.864h4.932q.576 0 .936.432.36.468.18 1.008l-3.276 12.384h3.996q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-5.22l-1.224 4.608h6.444q.504 0 .828.324t.324.828z\",\"BTC\":\"M42.012-41.399q.648 6.552-4.716 9.288 4.212 1.008 6.3 3.708t1.62 7.704q-.252 2.556-1.17 4.5t-2.322 3.204-3.492 2.106-4.374 1.242-5.238.54v9.18h-5.544v-9.036q-2.88 0-4.392-.036v9.072h-5.544v-9.18q-.648 0-1.944-.018t-1.98-.018h-7.2l1.116-6.588h3.996q1.8 0 2.088-1.836v-14.472h.576q-.216-.036-.576-.036v-10.332q-.468-2.448-3.204-2.448h-3.996v-5.904l7.632.036q2.304 0 3.492-.036v-9.072h5.544v8.892q2.952-.072 4.392-.072v-8.82h5.544v9.072q2.844.252 5.04.81t4.068 1.62 2.97 2.808 1.314 4.122zm-7.74 19.62q0-1.296-.54-2.304t-1.332-1.656-2.07-1.098-2.358-.666-2.664-.324-2.484-.108-2.322.036-1.71.036v12.168q.288 0 1.332.018t1.728.018 1.908-.054 2.106-.144 2.052-.306 1.998-.504 1.71-.756 1.422-1.08.882-1.44.342-1.836zm-2.556-17.136q0-1.188-.45-2.106t-1.098-1.512-1.728-1.008-1.98-.594-2.214-.288-2.088-.09-1.944.036-1.422.018v11.052q.18 0 1.242.018t1.674 0 1.8-.072 1.98-.198 1.854-.396 1.746-.666 1.332-.972.972-1.386.324-1.836z\",\"FILE\":\"M36.864-46.007v-16.992q.792.504 1.296 1.008l14.688 14.688q.504.504 1.008 1.296h-16.992zm-4.608 1.152q0 1.44 1.008 2.448t2.448 1.008h19.584v38.016q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h28.8v19.584z\",\"FILE_TEXT\":\"M52.848-47.303q.504.504 1.008 1.296h-16.992v-16.992q.792.504 1.296 1.008zm-17.136 5.904h19.584v38.016q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h28.8v19.584q0 1.44 1.008 2.448t2.448 1.008zm5.76 26.496v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-25.344q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h25.344q.504 0 .828-.324t.324-.828z\",\"SORT_ALPHA_ASC\":\"M42.876-49.751h6.372l-2.592-7.848-.432-1.692q-.072-.576-.072-.72h-.144l-.108.72q0 .036-.126.648t-.27 1.044zm-16.38 37.152q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm30.096 4.284v8.388h-21.024v-3.24l13.284-19.044q.432-.648.756-.972l.396-.324v-.108l-.234.018-.27.018q-.432.108-1.08.108h-8.352v4.14h-4.32v-8.244h20.412v3.204l-13.284 19.08q-.216.288-.756.936l-.396.396v.072l.504-.072q.324-.072 1.08-.072h8.928v-4.284h4.356zm3.204-32.292v3.816h-10.368v-3.816h2.7l-1.692-5.184h-8.748l-1.692 5.184h2.7v3.816h-10.332v-3.816h2.52l8.28-23.832h5.832l8.28 23.832h2.52z\",\"SORT_ALPHA_DESC\":\"M42.876-12.887h6.372l-2.592-7.848-.432-1.692q-.072-.576-.072-.72h-.144l-.108.72q0 .036-.126.648t-.27 1.044zm-16.38.288q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm33.3 8.856v3.816h-10.368v-3.816h2.7l-1.692-5.184h-8.748l-1.692 5.184h2.7v3.816h-10.332v-3.816h2.52l8.28-23.832h5.832l8.28 23.832h2.52zm-3.204-41.436v8.388h-21.024v-3.24l13.284-19.044q.432-.648.756-.972l.396-.324v-.108l-.234.018-.27.018q-.432.108-1.08.108h-8.352v4.14h-4.32v-8.244h20.412v3.204l-13.284 19.08q-.216.288-.756.936l-.396.36v.108l.504-.108q.324-.036 1.08-.036h8.928v-4.284h4.356z\",\"SORT_AMOUNT_ASC\":\"M26.496-12.599q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm38.016 4.608v6.912q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-23.04q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h23.04q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-16.128q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828zm-6.912-18.432v6.912q0 .504-.324.828t-.828.324h-9.216q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h9.216q.504 0 .828.324t.324.828z\",\"SORT_AMOUNT_DESC\":\"M43.776-7.991v6.912q0 .504-.324.828t-.828.324h-9.216q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h9.216q.504 0 .828.324t.324.828zm-17.28-4.608q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm24.192-13.824v6.912q0 .504-.324.828t-.828.324h-16.128q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828zm6.912-18.432v6.912q0 .504-.324.828t-.828.324h-23.04q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h23.04q.504 0 .828.324t.324.828zm6.912-18.432v6.912q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h29.952q.504 0 .828.324t.324.828z\",\"SORT_NUMERIC_ASC\":\"M48.456-17.171q0-2.268-1.584-4.176t-3.708-1.908q-1.872 0-2.988 1.332t-1.116 3.384 1.314 3.42 3.762 1.368q1.8 0 3.06-.972t1.26-2.448zm-21.96 4.572q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm27-2.484q0 2.232-.468 4.374t-1.476 4.104-2.448 3.438-3.546 2.358-4.59.882q-2.232 0-3.888-.576-.864-.288-1.512-.54l1.404-4.068q.54.252 1.116.396 1.332.468 2.7.468 3.024 0 4.842-2.106t2.394-5.238h-.072q-.756.828-2.214 1.332t-3.042.504q-3.816 0-6.228-2.574t-2.412-6.21q0-3.78 2.592-6.408t6.516-2.628q4.428 0 7.38 3.402t2.952 9.09zm-1.08-25.812v4.104h-16.884v-4.104h6.012v-15.552l.018-.684.018-.612v-.576h-.072l-.252.432q-.288.468-.936 1.116l-2.232 2.088-2.952-3.096 6.912-6.66h4.428v23.544h5.94z\",\"SORT_NUMERIC_DESC\":\"M48.456-54.035q0-2.268-1.584-4.176t-3.708-1.908q-1.872 0-2.988 1.332t-1.116 3.384 1.314 3.42 3.762 1.368q1.8 0 3.06-.972t1.26-2.448zm-21.96 41.436q0 .432-.36.864l-11.484 11.484q-.36.324-.828.324-.432 0-.828-.324l-11.52-11.52q-.54-.576-.252-1.26.288-.72 1.08-.72h6.912v-49.536q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v49.536h6.912q.504 0 .828.324t.324.828zm25.92 8.568v4.104h-16.884v-4.104h6.012v-15.552l.018-.684.018-.612v-.576h-.072l-.252.432q-.288.468-.936 1.116l-2.232 2.088-2.952-3.096 6.912-6.66h4.428v23.544h5.94zm1.08-47.916q0 2.232-.468 4.374t-1.476 4.104-2.448 3.438-3.546 2.358-4.59.882q-2.232 0-3.888-.576-.864-.288-1.512-.54l1.404-4.068q.54.252 1.116.396 1.332.468 2.7.468 3.024 0 4.842-2.106t2.394-5.238h-.072q-.756.828-2.214 1.332t-3.042.504q-3.816 0-6.228-2.574t-2.412-6.21q0-3.78 2.592-6.408t6.516-2.628q4.428 0 7.38 3.402t2.952 9.09z\",\"THUMBS_UP\":\"M9.216-16.055q0-.936-.684-1.62t-1.62-.684q-.972 0-1.638.684t-.666 1.62q0 .972.666 1.638t1.638.666q.936 0 1.62-.666t.684-1.638zm5.76-18.432v23.04q0 .936-.684 1.62t-1.62.684h-10.368q-.936 0-1.62-.684t-.684-1.62v-23.04q0-.936.684-1.62t1.62-.684h10.368q.936 0 1.62.684t.684 1.62zm42.624 0q0 3.096-1.98 5.364.54 1.584.54 2.736.108 2.736-1.548 4.932.612 2.016 0 4.212-.54 2.052-1.944 3.384.324 4.032-1.764 6.516-2.304 2.736-7.092 2.808h-4.644q-2.376 0-5.184-.558t-4.374-1.044-4.338-1.422q-4.428-1.548-5.688-1.584-.936-.036-1.62-.702t-.684-1.602v-23.076q0-.9.648-1.566t1.548-.738q.864-.072 2.736-2.124t3.636-4.356q2.448-3.132 3.636-4.32.648-.648 1.116-1.728t.63-1.746.486-2.178q.252-1.404.45-2.196t.702-1.872 1.224-1.8q.684-.684 1.62-.684 1.656 0 2.97.378t2.16.936 1.44 1.458.864 1.62.432 1.8.18 1.62.018 1.404q0 1.368-.342 2.736t-.684 2.16-.99 2.016q-.108.216-.36.648t-.396.792-.288.864h9.972q2.808 0 4.86 2.052t2.052 4.86z\",\"THUMBS_DOWN\":\"M9.216-43.703q0 .936-.684 1.62t-1.62.684q-.972 0-1.638-.684t-.666-1.62q0-.972.666-1.638t1.638-.666q.936 0 1.62.666t.684 1.638zm5.76 18.432v-23.04q0-.936-.684-1.62t-1.62-.684h-10.368q-.936 0-1.62.684t-.684 1.62v23.04q0 .936.684 1.62t1.62.684h10.368q.936 0 1.62-.684t.684-1.62zm40.644-5.364q1.98 2.196 1.98 5.364-.036 2.808-2.07 4.86t-4.842 2.052h-9.972q.144.504.288.864t.396.792.36.648q.648 1.332.972 2.052t.684 2.106.36 2.754q0 .864-.018 1.404t-.18 1.62-.432 1.8-.864 1.62-1.44 1.458-2.16.936-2.97.378q-.936 0-1.62-.684-.72-.72-1.224-1.8t-.702-1.872-.45-2.196q-.324-1.512-.486-2.178t-.63-1.746-1.116-1.728q-1.188-1.188-3.636-4.32-1.764-2.304-3.636-4.356t-2.736-2.124q-.9-.072-1.548-.738t-.648-1.566v-23.076q0-.936.684-1.602t1.62-.702q1.26-.036 5.688-1.584 2.772-.936 4.338-1.422t4.374-1.044 5.184-.558h4.644q4.788.072 7.092 2.808 2.088 2.484 1.764 6.516 1.404 1.332 1.944 3.384.612 2.196 0 4.212 1.656 2.196 1.548 4.932 0 1.152-.54 2.736z\",\"YOUTUBE_SQUARE\":\"M33.084-17.531v-5.652q0-1.8-1.044-1.8-.612 0-1.188.576v8.064q.576.576 1.188.576 1.044 0 1.044-1.764zm6.624-4.392h2.376v-1.224q0-1.836-1.188-1.836t-1.188 1.836v1.224zm-20.556-9.576v2.52h-2.88v15.228h-2.664v-15.228h-2.808v-2.52h8.352zm7.236 4.536v13.212h-2.412v-1.44q-1.404 1.62-2.736 1.62-1.188 0-1.512-1.008-.216-.576-.216-1.944v-10.44h2.376v9.72q0 .864.036.936.036.54.54.54.72 0 1.512-1.116v-10.08h2.412zm9.072 3.996v5.256q0 1.872-.252 2.628-.432 1.512-1.908 1.512-1.26 0-2.448-1.476v1.296h-2.412v-17.748h2.412v5.796q1.152-1.44 2.448-1.44 1.476 0 1.908 1.512.252.756.252 2.664zm9.036 4.644v.324q0 1.044-.072 1.548-.108.792-.54 1.44-.972 1.44-2.88 1.44-1.872 0-2.916-1.368-.756-.972-.756-3.096v-4.644q0-2.124.72-3.096 1.044-1.368 2.88-1.368t2.808 1.368q.756 1.008.756 3.096v2.736h-4.788v2.34q0 1.836 1.224 1.836.864 0 1.08-.936 0-.036.018-.252t.018-.594v-.774h2.448zm-16.236-29.664v5.616q0 1.836-1.152 1.836t-1.152-1.836v-5.616q0-1.872 1.152-1.872t1.152 1.872zm19.188 25.668q0-6.372-.684-9.36-.36-1.584-1.548-2.646t-2.736-1.242q-4.896-.54-14.832-.54-9.9 0-14.796.54-1.584.18-2.754 1.242t-1.53 2.646q-.72 3.132-.72 9.36 0 6.336.72 9.36.36 1.548 1.53 2.628t2.718 1.26q4.932.54 14.832.54t14.832-.54q1.548-.18 2.718-1.26t1.53-2.628q.72-3.024.72-9.36zm-27.18-23.436l3.24-10.656h-2.7l-1.836 7.02-1.908-7.02h-2.808l.864 2.484.828 2.484q1.26 3.708 1.656 5.688v7.236h2.664v-7.236zm10.404 2.916v-4.68q0-2.088-.756-3.132-1.044-1.368-2.808-1.368-1.836 0-2.808 1.368-.756 1.044-.756 3.132v4.68q0 2.088.756 3.132.972 1.368 2.808 1.368 1.764 0 2.808-1.368.756-.972.756-3.132zm6.516 4.32h2.412v-13.32h-2.412v10.188q-.792 1.116-1.512 1.116-.54 0-.576-.576-.036-.072-.036-.936v-9.792h-2.412v10.548q0 1.332.216 1.98.396.972 1.548.972 1.296 0 2.772-1.62v1.44zm18.108-10.944v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"YOUTUBE\":\"M34.956-19.655v7.596q0 2.412-1.404 2.412-.828 0-1.62-.792v-10.836q.792-.792 1.62-.792 1.404 0 1.404 2.412zm12.168.036v1.656h-3.24v-1.656q0-2.448 1.62-2.448t1.62 2.448zm-34.776-7.848h3.852v-3.384h-11.232v3.384h3.78v20.484h3.6v-20.484zm10.368 20.484h3.204v-17.784h-3.204v13.608q-1.08 1.512-2.052 1.512-.648 0-.756-.756-.036-.108-.036-1.26v-13.104h-3.204v14.076q0 1.764.288 2.628.432 1.332 2.088 1.332 1.728 0 3.672-2.196v1.944zm15.444-5.328v-7.092q0-2.628-.324-3.564-.612-2.016-2.556-2.016-1.8 0-3.348 1.944v-7.812h-3.204v23.868h3.204v-1.728q1.62 1.98 3.348 1.98 1.944 0 2.556-1.98.324-.972.324-3.6zm12.168-.36v-.468h-3.276q0 1.836-.072 2.196-.252 1.296-1.44 1.296-1.656 0-1.656-2.484v-3.132h6.444v-3.708q0-2.844-.972-4.176-1.404-1.836-3.816-1.836-2.448 0-3.852 1.836-1.008 1.332-1.008 4.176v6.228q0 2.844 1.044 4.176 1.404 1.836 3.888 1.836 2.592 0 3.888-1.908.648-.972.756-1.944.072-.324.072-2.088zm-21.888-32.868v-7.56q0-2.484-1.548-2.484t-1.548 2.484v7.56q0 2.52 1.548 2.52t1.548-2.52zm25.884 27.036q0 8.424-.936 12.6-.504 2.124-2.088 3.564t-3.672 1.656q-6.624.756-19.98.756t-19.98-.756q-2.088-.216-3.69-1.656t-2.07-3.564q-.936-4.032-.936-12.6 0-8.424.936-12.6.504-2.124 2.088-3.564t3.708-1.692q6.588-.72 19.944-.72t19.98.72q2.088.252 3.69 1.692t2.07 3.564q.936 4.032.936 12.6zm-35.928-45.936h3.672l-4.356 14.364v9.756h-3.6v-9.756q-.504-2.664-2.196-7.632-1.332-3.708-2.34-6.732h3.816l2.556 9.468zm13.32 11.988v6.3q0 2.916-1.008 4.248-1.332 1.836-3.816 1.836-2.412 0-3.78-1.836-1.008-1.368-1.008-4.248v-6.3q0-2.88 1.008-4.212 1.368-1.836 3.78-1.836 2.484 0 3.816 1.836 1.008 1.332 1.008 4.212zm12.06-5.832v17.964h-3.276v-1.98q-1.908 2.232-3.708 2.232-1.656 0-2.124-1.332-.288-.864-.288-2.7v-14.184h3.276v13.212q0 1.188.036 1.26.108.792.756.792.972 0 2.052-1.548v-13.716h3.276z\",\"XING\":\"M21.492-40.427q-.36.648-9.252 16.416-.972 1.656-2.34 1.656h-8.604q-.756 0-1.116-.612t0-1.296l9.108-16.128v-.036l-5.796-10.044q-.432-.792-.036-1.332.324-.54 1.152-.54h8.604q1.44 0 2.376 1.62zm29.016-23.112q.396.576 0 1.332l-19.008 33.624v.036l12.096 22.14q.396.72.036 1.332-.36.54-1.152.54h-8.604q-1.512 0-2.376-1.62l-12.204-22.392q.648-1.152 19.116-33.912.9-1.62 2.304-1.62h8.676q.792 0 1.116.54z\",\"XING_SQUARE\":\"M24.66-36.899q0-.036-4.536-7.992-.756-1.224-1.872-1.224h-6.624q-.648 0-.936.396-.252.432.036 1.044l4.5 7.776v.036l-7.056 12.456q-.324.504 0 1.008.288.468.864.468h6.66q1.116 0 1.8-1.296zm22.464-17.892q-.252-.432-.864-.432h-6.732q-1.08 0-1.764 1.26l-14.796 26.244q.036.072 9.432 17.316.72 1.26 1.872 1.26h6.624q.648 0 .9-.432.288-.468-.036-1.008l-9.36-17.136v-.036l14.724-26.028q.288-.576 0-1.008zm8.172 5.328v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"YOUTUBE_PLAY\":\"M46.08-32.183q0-1.332-1.08-1.944l-18.432-11.52q-1.116-.72-2.34-.072-1.188.648-1.188 2.016v23.04q0 1.368 1.188 2.016.576.288 1.116.288.72 0 1.224-.36l18.432-11.52q1.08-.612 1.08-1.944zm18.432 0q0 3.456-.036 5.4t-.306 4.914-.81 5.31q-.576 2.628-2.484 4.428t-4.464 2.088q-7.992.9-24.156.9t-24.156-.9q-2.556-.288-4.482-2.088t-2.502-4.428q-.504-2.34-.774-5.31t-.306-4.914-.036-5.4.036-5.4.306-4.914.81-5.31q.576-2.628 2.484-4.428t4.464-2.088q7.992-.9 24.156-.9t24.156.9q2.556.288 4.482 2.088t2.502 4.428q.504 2.34.774 5.31t.306 4.914.036 5.4z\",\"DROPBOX\":\"M14.472-38.987l17.784 10.98-12.312 10.26-17.64-11.484zm35.496 19.98v3.888l-17.64 10.548v.036l-.036-.036-.036.036v-.036l-17.604-10.548v-3.888l5.292 3.456 12.312-10.224v-.072l.036.036.036-.036v.072l12.348 10.224zm-30.024-41.184l12.312 10.26-17.784 10.944-12.168-9.72zm30.096 21.204l12.168 9.756-17.604 11.484-12.348-10.26zm-5.436-21.204l17.604 11.484-12.168 9.72-17.784-10.944z\",\"STACK_OVERFLOW\":\"M46.404-5.687h-40.248v-17.28h-5.76v23.04h51.768v-23.04h-5.76v17.28zm-33.912-18.864l1.188-5.652 28.188 5.94-1.188 5.616zm3.708-13.464l2.412-5.256 26.1 12.204-2.412 5.22zm7.236-12.816l3.672-4.428 22.104 18.468-3.672 4.428zm14.292-13.608l17.172 23.076-4.608 3.456-17.172-23.076zm-25.848 52.956v-5.724h28.8v5.724h-28.8z\",\"INSTAGRAM\":\"M49.032-13.103v-23.328h-4.86q.72 2.268.72 4.716 0 4.536-2.304 8.37t-6.264 6.066-8.64 2.232q-7.092 0-12.132-4.878t-5.04-11.79q0-2.448.72-4.716h-5.076v23.328q0 .936.63 1.566t1.566.63h38.484q.9 0 1.548-.63t.648-1.566zm-10.224-19.188q0-4.464-3.258-7.614t-7.866-3.15q-4.572 0-7.83 3.15t-3.258 7.614 3.258 7.614 7.83 3.15q4.608 0 7.866-3.15t3.258-7.614zm10.224-12.96v-5.94q0-1.008-.72-1.746t-1.764-.738h-6.264q-1.044 0-1.764.738t-.72 1.746v5.94q0 1.044.72 1.764t1.764.72h6.264q1.044 0 1.764-.72t.72-1.764zm6.264-7.488v41.112q0 2.916-2.088 5.004t-5.004 2.088h-41.112q-2.916 0-5.004-2.088t-2.088-5.004v-41.112q0-2.916 2.088-5.004t5.004-2.088h41.112q2.916 0 5.004 2.088t2.088 5.004z\",\"FLICKR\":\"M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm-19.8 27.648q0-3.168-2.232-5.4t-5.4-2.232-5.4 2.232-2.232 5.4 2.232 5.4 5.4 2.232 5.4-2.232 2.232-5.4zm20.304 0q0-3.168-2.232-5.4t-5.4-2.232-5.4 2.232-2.232 5.4 2.232 5.4 5.4 2.232 5.4-2.232 2.232-5.4z\",\"ADN\":\"M27.648-42.047l7.236 11.016h-14.472zm13.14 19.08h3.384l-16.524-24.876-16.524 24.876h3.384l3.744-5.76h18.792zm14.508-9.216q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"BITBUCKET\":\"M29.34-33.515q.288 2.268-1.818 3.636t-4.014.216q-1.404-.612-1.926-2.088t-.018-2.952 1.872-2.088q1.296-.648 2.61-.432t2.304 1.278.99 2.43zm3.996-.756q-.504-3.852-4.068-5.904t-7.092-.468q-2.268 1.008-3.618 3.186t-1.242 4.662q.144 3.276 2.79 5.58t5.958 2.016q3.276-.288 5.472-3.024t1.8-6.048zm8.604-19.512q-.72-.972-2.016-1.602t-2.088-.792-2.556-.45q-10.476-1.692-20.376.072-1.548.252-2.376.432t-1.98.792-1.8 1.548q1.08 1.008 2.736 1.638t2.646.792 3.15.414q8.208 1.044 16.128.036 2.268-.288 3.222-.432t2.61-.774 2.7-1.674zm2.052 37.26q-.288.936-.558 2.754t-.504 3.024-1.026 2.52-2.088 2.034q-3.096 1.728-6.822 2.574t-7.272.792-7.254-.666q-1.656-.288-2.934-.648t-2.754-.972-2.628-1.566-1.872-2.214q-.9-3.456-2.052-10.512l.216-.576.648-.324q8.028 5.328 18.234 5.328t18.27-5.328q.756.216.864.828t-.18 1.62-.288 1.332zm6.516-34.596q-.936 6.012-3.996 23.58-.18 1.08-.972 2.016t-1.566 1.44-1.962 1.116q-9.072 4.536-21.96 3.168-8.928-.972-14.184-5.004-.54-.432-.918-.954t-.612-1.26-.324-1.224-.216-1.422-.198-1.26q-.324-1.8-.954-5.4t-1.008-5.814-.846-5.31-.792-5.688q.108-.936.63-1.746t1.134-1.35 1.62-1.08 1.656-.81 1.728-.666q4.5-1.656 11.268-2.304 13.644-1.332 24.336 1.8 5.58 1.656 7.74 4.392.576.72.594 1.836t-.198 1.944z\",\"BITBUCKET_SQUARE\":\"M30.528-33.119q0-1.548-1.476-2.376t-2.772-.036q-1.548.72-1.53 2.61t1.566 2.538q1.404.828 2.916-.144t1.296-2.592zm2.88-.576q.288 2.376-1.296 4.356t-3.96 2.196-4.284-1.44-2.016-4.068q-.072-1.764.918-3.348t2.61-2.304q2.52-1.116 5.094.36t2.934 4.248zm6.192-14.076q-.72.756-1.926 1.224t-1.908.576-2.286.288q-5.58.72-11.664 0-1.584-.216-2.268-.342t-1.89-.576-1.962-1.17q.468-.684 1.296-1.116t1.44-.558 1.692-.306q7.128-1.26 14.688-.036 1.188.18 1.836.306t1.548.576 1.404 1.134zm1.512 26.856q0-.252.198-.954t.108-1.152-.63-.594q-5.796 3.816-13.14 3.816t-13.176-3.816l-.432.216-.18.432q.936 5.544 1.476 7.56 1.692 2.916 7.344 3.888 8.964 1.656 15.408-1.908 1.224-.684 1.764-1.854t.81-3.078.45-2.556zm4.68-24.948q.324-1.908-.288-2.7-1.548-1.98-5.58-3.168-7.776-2.268-17.532-1.296-4.752.432-8.136 1.656-1.368.54-2.142.9t-1.692 1.224-1.062 1.944q.288 2.448.684 4.968t1.044 6.156.864 4.932q.036.18.18 1.116t.252 1.296.432.972.792 1.008q3.78 2.88 10.224 3.6 9.324 1.008 15.84-2.268.864-.468 1.422-.828t1.116-1.044.702-1.44q1.728-9.612 2.88-17.028zm9.504-3.6v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TUMBLR\":\"M33.984-16.595l2.88 8.532q-.828 1.26-3.996 2.376t-6.372 1.152q-3.744.072-6.858-.936t-5.13-2.664-3.42-3.816-1.998-4.32-.594-4.248v-19.584h-6.048v-7.74q2.592-.936 4.644-2.502t3.276-3.24 2.088-3.672 1.224-3.564.54-3.186q.036-.18.162-.306t.27-.126h8.784v15.264h11.988v9.072h-12.024v18.648q0 1.08.234 2.016t.81 1.89 1.782 1.494 2.934.504q2.808-.072 4.824-1.044z\",\"TUMBLR_SQUARE\":\"M40.896-11.843l-2.232-6.588q-1.584.792-3.708.792-1.296.036-2.232-.378t-1.386-1.134-.63-1.458-.18-1.566v-14.328h9.252v-6.984h-9.216v-11.736h-6.768q-.288 0-.324.36-.18 1.584-.63 3.132t-1.404 3.42-2.772 3.42-4.266 2.448v5.94h4.68v15.048q0 2.052.774 4.14t2.34 3.996 4.356 3.078 6.354 1.098q2.484-.036 4.914-.9t3.078-1.8zm14.4-37.62v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"LONG_ARROW_DOWN\":\"M27.54-17.675q.288.684-.18 1.26l-12.6 13.824q-.36.36-.828.36-.504 0-.864-.36l-12.78-13.824q-.468-.576-.18-1.26.324-.684 1.044-.684h8.064v-44.928q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v44.928h8.064q.756 0 1.044.684z\",\"LONG_ARROW_UP\":\"M27.54-46.691q-.324.684-1.044.684h-8.064v44.928q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-44.928h-8.064q-.756 0-1.044-.684t.18-1.26l12.6-13.824q.36-.36.828-.36.504 0 .864.36l12.78 13.824q.468.576.18 1.26z\",\"LONG_ARROW_LEFT\":\"M64.512-35.639v6.912q0 .504-.324.828t-.828.324h-44.928v8.064q0 .756-.684 1.044t-1.26-.18l-13.824-12.6q-.36-.36-.36-.828 0-.504.36-.864l13.824-12.744q.576-.504 1.26-.216.684.324.684 1.044v8.064h44.928q.504 0 .828.324t.324.828z\",\"LONG_ARROW_RIGHT\":\"M62.208-32.291q0 .504-.36.864l-13.824 12.744q-.576.504-1.26.216-.684-.324-.684-1.044v-8.064h-44.928q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h44.928v-8.064q0-.756.684-1.044t1.26.18l13.824 12.6q.36.36.36.828z\",\"APPLE\":\"M50.148-20.699q-1.404 4.5-4.428 9-4.644 7.056-9.252 7.056-1.764 0-5.04-1.152-3.096-1.152-5.436-1.152-2.196 0-5.112 1.188-2.916 1.224-4.752 1.224-5.472 0-10.836-9.324-5.292-9.396-5.292-18.108 0-8.208 4.068-13.464 4.032-5.184 10.224-5.184 2.592 0 6.372 1.08 3.744 1.08 4.968 1.08 1.62 0 5.148-1.224 3.672-1.224 6.228-1.224 4.284 0 7.668 2.34 1.872 1.296 3.744 3.6-2.844 2.412-4.104 4.248-2.34 3.384-2.34 7.452 0 4.464 2.484 8.028t5.688 4.536zm-13.536-42.228q0 2.196-1.044 4.896-1.08 2.7-3.348 4.968-1.944 1.944-3.888 2.592-1.332.396-3.744.612.108-5.364 2.808-9.252 2.664-3.852 9-5.328l.09.396.09.396.018.36.018.36z\",\"WINDOWS\":\"M24.552-28.223v23.436l-24.552-3.384v-20.052h24.552zm0-26.748v23.724h-24.552v-20.34zm35.352 26.748v28.296l-32.652-4.5v-23.796h32.652zm0-31.608v28.584h-32.652v-24.084z\",\"ANDROID\":\"M17.748-47.051q.576 0 .99-.414t.414-.99-.414-.99-.99-.414-.972.414-.396.99.396.99.972.414zm15.192 0q.576 0 .972-.414t.396-.99-.396-.99-.972-.414-.99.414-.414.99.414.99.99.414zm-29.232 6.624q1.512 0 2.592 1.08t1.08 2.592v15.48q0 1.548-1.062 2.628t-2.61 1.08-2.628-1.08-1.08-2.628v-15.48q0-1.512 1.08-2.592t2.628-1.08zm38.16.684v23.976q0 1.656-1.152 2.808t-2.772 1.152h-2.7v8.172q0 1.548-1.08 2.628t-2.628 1.08-2.628-1.08-1.08-2.628v-8.172h-4.968v8.172q0 1.548-1.08 2.628t-2.628 1.08q-1.512 0-2.592-1.08t-1.08-2.628l-.036-8.172h-2.664q-1.656 0-2.808-1.152t-1.152-2.808v-23.976h33.048zm-8.352-14.58q3.852 1.98 6.156 5.526t2.304 7.758h-33.3q0-4.212 2.304-7.758t6.192-5.526l-2.556-4.716q-.252-.468.18-.72.468-.216.72.216l2.592 4.752q3.42-1.512 7.236-1.512t7.236 1.512l2.592-4.752q.252-.432.72-.216.432.252.18.72zm17.172 17.568v15.48q0 1.548-1.08 2.628t-2.628 1.08q-1.512 0-2.592-1.08t-1.08-2.628v-15.48q0-1.548 1.08-2.61t2.592-1.062q1.548 0 2.628 1.062t1.08 2.61z\",\"LINUX\":\"M23.868-49.643q-.396.036-.558.378t-.306.342q-.18.036-.18-.18 0-.432.684-.54h.36zm3.132.504q-.144.036-.414-.234t-.63-.162q.864-.396 1.152.072.108.216-.108.324zm-12.636 15.372q-.144-.036-.216.108t-.162.45-.198.486-.36.468q-.252.36-.036.432.144.036.45-.252t.45-.648l.072-.252.072-.216.054-.162.018-.144v-.108l-.036-.09-.108-.072zm30.78 12.924q0-.648-1.98-1.512.144-.54.27-.99t.18-.936.108-.774.018-.81-.036-.702-.126-.792-.144-.738-.18-.9-.198-.954q-.36-1.728-1.692-3.708t-2.592-2.7q.864.72 2.052 2.988 3.132 5.832 1.944 10.008-.396 1.44-1.8 1.512-1.116.144-1.386-.666t-.288-3.006-.414-3.852q-.324-1.404-.702-2.484t-.702-1.638-.558-.882-.468-.54-.27-.252q-.504-2.232-1.116-3.708t-1.062-2.016-.846-1.188-.54-1.44q-.144-.756.216-1.926t.162-1.782-1.602-.9q-.54-.108-1.602-.648t-1.278-.576q-.288-.036-.396-.936t.288-1.836 1.296-.972q1.332-.108 1.836 1.08t.144 2.088q-.396.684-.072.954t1.08.018q.468-.144.468-1.296v-1.332q-.18-1.08-.486-1.8t-.756-1.098-.846-.54-.972-.27q-3.852.288-3.204 4.824 0 .54-.036.54-.324-.324-1.062-.378t-1.188.018-.558-.18q.036-2.052-.576-3.24t-1.62-1.224q-.972-.036-1.494.99t-.594 2.142q-.036.54.126 1.332t.468 1.35.558.486q.36-.108.576-.504.144-.324-.252-.288-.252 0-.558-.522t-.342-1.206q-.036-.792.324-1.332t1.224-.504q.612 0 .972.756t.342 1.404-.054.792q-.792.54-1.116 1.044-.288.432-.99.846t-.738.45q-.468.504-.558.972t.27.648q.504.288.9.702t.576.684.666.468 1.278.234q1.692.072 3.672-.54.072-.036.828-.252t1.242-.378 1.062-.468.756-.63q.324-.504.72-.288.18.108.234.306t-.108.432-.594.342q-.72.216-2.034.774t-1.638.702q-1.584.684-2.52.828-.9.18-2.844-.072-.36-.072-.324.072t.612.684q.9.828 2.412.792.612-.036 1.296-.252t1.296-.504 1.206-.63 1.08-.612.882-.432.63-.09.306.396q0 .072-.036.162t-.144.18-.216.162-.306.18-.324.162-.36.18-.342.162q-1.008.504-2.43 1.584t-2.394 1.548-1.764.036q-.756-.396-2.268-2.628-.792-1.116-.9-.792-.036.108-.036.36 0 .9-.54 2.034t-1.062 1.998-.756 2.088.414 2.268q-.828.216-2.25 3.24t-1.71 5.076q-.072.648-.054 2.484t-.198 2.124q-.288.864-1.044.108-1.152-1.116-1.296-3.384-.072-1.008.144-2.016.144-.684-.036-.648l-.144.18q-1.296 2.34.36 5.976.18.432.9 1.008t.864.72q.72.828 3.744 3.258t3.348 2.754q.576.54.63 1.368t-.504 1.548-1.638.828q.288.54 1.044 1.602t1.008 1.944.252 2.538q1.656-.864.252-3.312-.144-.288-.378-.576t-.342-.432-.072-.216q.108-.18.468-.342t.72.09q1.656 1.872 5.976 1.296 4.788-.54 6.372-3.132.828-1.368 1.224-1.08.432.216.36 1.872-.036.9-.828 3.312-.324.828-.216 1.35t.864.558q.108-.684.522-2.772t.486-3.24q.072-.756-.234-2.646t-.27-3.492.828-2.538q.54-.648 1.836-.648.036-1.332 1.242-1.908t2.61-.378 2.16.81zm-22.608-29.772q.108-.612-.09-1.08t-.414-.54q-.324-.072-.324.252.072.18.18.216.36 0 .252.54-.108.72.288.72.108 0 .108-.108zm15.084 7.092q-.072-.288-.234-.414t-.468-.18-.522-.198q-.18-.108-.342-.288t-.252-.288-.198-.234-.144-.144-.144.054q-.504.576.252 1.566t1.404 1.134q.324.036.522-.288t.126-.72zm-6.408-7.668q0-.396-.18-.702t-.396-.45-.324-.108q-.504.036-.252.252l.144.072q.504.144.648 1.116 0 .108.288-.072zm1.944-8.388q0-.072-.09-.18t-.324-.252-.342-.216q-.54-.54-.864-.54-.324.036-.414.27t-.036.468-.018.45q-.036.144-.216.378t-.216.324.108.306q.144.108.288 0t.396-.324.54-.324q.036-.036.324-.036t.54-.072.324-.252zm20.34 48.276q.72.432 1.116.882t.432.864-.09.81-.558.792-.846.702-1.08.666-1.134.594-1.152.558-.972.468q-1.368.684-3.078 2.016t-2.718 2.304q-.612.576-2.448.702t-3.204-.522q-.648-.324-1.062-.846t-.594-.918-.792-.702-1.692-.342q-1.584-.036-4.68-.036-.684 0-2.052.054t-2.088.09q-1.584.036-2.862.54t-1.926 1.08-1.566 1.026-1.926.414q-1.044-.036-3.996-1.116t-5.256-1.548q-.684-.144-1.836-.342t-1.8-.324-1.422-.342-1.206-.522-.612-.702q-.36-.828.252-2.394t.648-1.962q.036-.576-.144-1.44t-.36-1.53-.162-1.314.378-.972q.504-.432 2.052-.504t2.16-.432q1.08-.648 1.512-1.26t.432-1.836q.756 2.628-1.152 3.816-1.152.72-2.988.54-1.224-.108-1.548.36-.468.54.18 2.052.072.216.288.648t.306.648.162.612.036.792q0 .54-.612 1.764t-.504 1.728q.108.612 1.332.936.72.216 3.042.666t3.582.738q.864.216 2.664.792t2.97.828 1.998.144q1.548-.216 2.322-1.008t.828-1.728-.27-2.106-.684-1.872-.72-1.314q-4.356-6.84-6.084-8.712-2.448-2.664-4.068-1.44-.396.324-.54-.54-.108-.576-.072-1.368.036-1.044.36-1.872t.864-1.692.792-1.512q.288-.756.954-2.592t1.062-2.808 1.08-2.196 1.404-1.944q3.96-5.148 4.464-7.02-.432-4.032-.576-11.16-.072-3.24.864-5.454t3.816-3.762q1.404-.756 3.744-.756 1.908-.036 3.816.486t3.204 1.494q2.052 1.512 3.294 4.374t1.062 5.31q-.18 3.42 1.08 7.704 1.224 4.068 4.788 7.848 1.98 2.124 3.582 5.868t2.142 6.876q.288 1.764.18 3.042t-.432 1.998-.72.792q-.36.072-.846.684t-.972 1.278-1.458 1.206-2.196.504q-.648-.036-1.134-.18t-.81-.486-.486-.558-.414-.738-.324-.702q-.792-1.332-1.476-1.08t-1.008 1.764.252 3.492q.72 2.52.036 7.02-.36 2.34.648 3.618t2.628 1.188 3.06-1.278q2.124-1.764 3.222-2.394t3.726-1.53q1.908-.648 2.772-1.314t.666-1.242-.9-1.026-1.854-.846q-1.188-.396-1.782-1.728t-.54-2.61.558-1.71q.036 1.116.288 2.034t.522 1.458.738 1.026.756.684.774.468.594.342z\",\"DRIBBBLE\":\"M36.864-10.439q-1.512-8.676-5.04-17.928h-.072l-.072.036q-.576.216-1.548.594t-3.636 1.764-4.932 2.952-4.716 4.122-3.708 5.328l-.54-.396q6.624 5.4 15.048 5.4 4.752 0 9.216-1.872zm-6.66-21.852q-.756-1.764-1.908-3.996-11.196 3.348-24.228 3.348-.036.252-.036.756 0 4.464 1.584 8.514t4.464 7.254q1.8-3.204 4.446-5.994t5.13-4.482 4.698-2.916 3.582-1.728l1.332-.468q.144-.036.468-.126t.468-.162zm-3.852-7.632q-4.32-7.668-8.784-13.608-4.968 2.34-8.424 6.696t-4.608 9.792q10.872 0 21.816-2.88zm24.624 11.484q-7.56-2.16-14.724-1.044 3.132 8.604 4.608 16.884 3.996-2.7 6.66-6.822t3.456-9.018zm-28.98-26.676l-.072.036.072-.036zm21.24 5.22q-6.66-5.904-15.588-5.904-2.736 0-5.58.684 4.716 6.12 8.856 13.752 2.484-.936 4.68-2.178t3.474-2.214 2.358-2.052 1.35-1.458zm8.028 17.46q-.108-8.352-5.364-14.76l-.036.036q-.324.432-.684.882t-1.566 1.602-2.556 2.178-3.6 2.34-4.734 2.322q.9 1.908 1.584 3.42.072.216.234.63t.27.594q1.296-.18 2.682-.252t2.646-.072 2.484.054 2.304.144 2.034.198 1.728.234 1.314.216.9.162zm4.032.252q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"SKYPE\":\"M42.228-26.171q0-1.8-.702-3.294t-1.746-2.466-2.628-1.764-2.97-1.224-3.15-.828l-3.744-.864q-1.08-.252-1.584-.378t-1.26-.414-1.08-.576-.594-.756-.27-1.08q0-2.772 5.184-2.772 1.548 0 2.772.432t1.944 1.026 1.368 1.206 1.44 1.044 1.728.432q1.692 0 2.718-1.152t1.026-2.772q0-1.98-2.016-3.582t-5.112-2.43-6.552-.828q-2.448 0-4.752.558t-4.302 1.692-3.204 3.132-1.206 4.626q0 2.196.684 3.834t2.016 2.718 2.88 1.746 3.708 1.17l5.256 1.296q3.24.792 4.032 1.296 1.152.72 1.152 2.16 0 1.404-1.44 2.322t-3.78.918q-1.836 0-3.294-.576t-2.34-1.386-1.638-1.62-1.656-1.386-1.944-.576q-1.8 0-2.718 1.08t-.918 2.7q0 3.312 4.392 5.67t10.476 2.358q2.628 0 5.04-.666t4.41-1.926 3.186-3.366 1.188-4.734zm13.068 7.812q0 5.724-4.05 9.774t-9.774 4.05q-4.68 0-8.424-2.88-2.772.576-5.4.576-5.148 0-9.846-1.998t-8.1-5.4-5.4-8.1-1.998-9.846q0-2.628.576-5.4-2.88-3.744-2.88-8.424 0-5.724 4.05-9.774t9.774-4.05q4.68 0 8.424 2.88 2.772-.576 5.4-.576 5.148 0 9.846 1.998t8.1 5.4 5.4 8.1 1.998 9.846q0 2.628-.576 5.4 2.88 3.744 2.88 8.424z\",\"FOURSQUARE\":\"M36-48.815l1.332-6.984q.18-.828-.324-1.44t-1.26-.612h-25.632q-.828 0-1.386.612t-.558 1.332v39.636q0 .252.216.036l10.476-12.672q.828-.936 1.368-1.206t1.728-.27h8.604q.792 0 1.332-.522t.648-1.062q.864-4.68 1.332-6.876.144-.756-.414-1.44t-1.314-.684h-10.584q-1.044 0-1.728-.684t-.684-1.728v-1.512q0-1.044.684-1.71t1.728-.666h12.456q.648 0 1.26-.486t.72-1.062zm8.172-7.992q-.54 2.628-1.926 9.594t-2.502 12.6-1.26 6.246q-.216.792-.324 1.17t-.504 1.17-.882 1.188-1.386.756-2.088.36h-9.756q-.468 0-.792.36-.288.324-15.336 17.784-.792.9-2.106 1.026t-1.746-.198q-1.98-.792-1.98-3.528v-50.76q0-1.98 1.368-3.69t4.32-1.71h31.968q3.42 0 4.572 1.908t.36 5.724zm0 0l-5.688 28.44q.144-.612 1.26-6.246t2.502-12.6 1.926-9.594z\",\"TRELLO\":\"M25.344-16.055v-36.864q0-.504-.324-.828t-.828-.324h-17.28q-.504 0-.828.324t-.324.828v36.864q0 .504.324.828t.828.324h17.28q.504 0 .828-.324t.324-.828zm24.192-13.824v-23.04q0-.504-.324-.828t-.828-.324h-17.28q-.504 0-.828.324t-.324.828v23.04q0 .504.324.828t.828.324h17.28q.504 0 .828-.324t.324-.828zm5.76-27.648v50.688q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-50.688q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62z\",\"FEMALE\":\"M46.08-26.423q0 1.44-1.008 2.448t-2.448 1.008q-1.836 0-2.88-1.548l-8.172-12.276h-1.62v4.752l8.892 14.796q.324.54.324 1.188 0 .936-.684 1.62t-1.62.684h-6.912v9.792q0 1.656-1.188 2.844t-2.844 1.188h-5.76q-1.656 0-2.844-1.188t-1.188-2.844v-9.792h-6.912q-.936 0-1.62-.684t-.684-1.62q0-.648.324-1.188l8.892-14.796v-4.752h-1.62l-8.172 12.276q-1.044 1.548-2.88 1.548-1.44 0-2.448-1.008t-1.008-2.448q0-1.044.576-1.908l9.216-13.824q2.628-3.852 6.336-3.852h13.824q3.708 0 6.336 3.852l9.216 13.824q.576.864.576 1.908zm-14.976-28.8q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z\",\"MALE\":\"M36.864-39.095v14.976q0 1.44-1.008 2.448t-2.448 1.008-2.448-1.008-1.008-2.448v-12.672h-2.304v32.832q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-16.704h-2.304v16.704q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-32.832h-2.304v12.672q0 1.44-1.008 2.448t-2.448 1.008-2.448-1.008-1.008-2.448v-14.976q0-2.88 2.016-4.896t4.896-2.016h23.04q2.88 0 4.896 2.016t2.016 4.896zm-10.368-16.128q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z\",\"GRATIPAY\":\"M27.828-17.567l12.6-17.028q.576-.792.882-2.124t-.216-3.06-2.214-2.844q-1.44-.936-2.988-.918t-2.646.63-1.962 1.62q-1.296 1.44-3.456 1.44-2.124 0-3.42-1.44-.864-1.008-1.962-1.62t-2.646-.63-3.024.918q-1.656 1.116-2.178 2.844t-.216 3.06.882 2.124zm27.468-14.616q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"SUN_O\":\"M52.992-32.183q0-4.212-1.638-8.046t-4.428-6.624-6.624-4.428-8.046-1.638-8.046 1.638-6.624 4.428-4.428 6.624-1.638 8.046 1.638 8.046 4.428 6.624 6.624 4.428 8.046 1.638 8.046-1.638 6.624-4.428 4.428-6.624 1.638-8.046zm9.936 9.972q-.144.54-.72.72l-10.512 3.456v11.016q0 .576-.468.936-.54.36-1.044.144l-10.512-3.384-6.48 8.928q-.36.468-.936.468t-.936-.468l-6.48-8.928-10.512 3.384q-.504.216-1.044-.144-.468-.36-.468-.936v-11.016l-10.512-3.456q-.576-.18-.72-.72-.18-.612.144-1.044l6.48-8.928-6.48-8.928q-.324-.468-.144-1.044.144-.54.72-.72l10.512-3.456v-11.016q0-.576.468-.936.54-.36 1.044-.144l10.512 3.384 6.48-8.928q.324-.432.936-.432t.936.432l6.48 8.928 10.512-3.384q.504-.216 1.044.144.468.36.468.936v11.016l10.512 3.456q.576.18.72.72.18.576-.144 1.044l-6.48 8.928 6.48 8.928q.324.432.144 1.044z\",\"MOON_O\":\"M45.432-17.531q-1.944.324-3.96.324-6.552 0-12.132-3.24t-8.82-8.82-3.24-12.132q0-6.912 3.744-12.852-7.236 2.16-11.826 8.244t-4.59 13.824q0 4.68 1.836 8.946t4.914 7.344 7.344 4.914 8.946 1.836q5.184 0 9.846-2.214t7.938-6.174zm7.308-3.06q-3.384 7.308-10.206 11.682t-14.886 4.374q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728q0-5.508 2.07-10.53t5.616-8.694 8.478-5.922 10.44-2.466q1.584-.072 2.196 1.404.648 1.476-.54 2.592-3.096 2.808-4.734 6.534t-1.638 7.866q0 5.328 2.628 9.828t7.128 7.128 9.828 2.628q4.248 0 8.208-1.836 1.476-.648 2.592.468.504.504.63 1.224t-.162 1.368z\",\"ARCHIVE\":\"M39.168-34.487q0-.936-.684-1.62t-1.62-.684h-9.216q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684h9.216q.936 0 1.62-.684t.684-1.62zm20.736-6.912v34.56q0 .936-.684 1.62t-1.62.684h-50.688q-.936 0-1.62-.684t-.684-1.62v-34.56q0-.936.684-1.62t1.62-.684h50.688q.936 0 1.62.684t.684 1.62zm2.304-16.128v9.216q0 .936-.684 1.62t-1.62.684h-55.296q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h55.296q.936 0 1.62.684t.684 1.62z\",\"BUG\":\"M58.752-29.879q0 .936-.684 1.62t-1.62.684h-8.064q0 6.156-2.412 10.44l7.488 7.524q.684.684.684 1.62t-.684 1.62q-.648.684-1.62.684t-1.62-.684l-7.128-7.092q-.18.18-.54.468t-1.512 1.026-2.34 1.314-2.952 1.044-3.492.468v-32.256h-4.608v32.256q-1.836 0-3.654-.486t-3.132-1.188-2.376-1.404-1.566-1.17l-.54-.504-6.588 7.452q-.72.756-1.728.756-.864 0-1.548-.576-.684-.648-.738-1.602t.558-1.674l7.272-8.172q-2.088-4.104-2.088-9.864h-8.064q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h8.064v-10.584l-6.228-6.228q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684l6.228 6.228h30.384l6.228-6.228q.684-.684 1.62-.684t1.62.684.684 1.62-.684 1.62l-6.228 6.228v10.584h8.064q.936 0 1.62.684t.684 1.62zm-17.28-20.736h-23.04q0-4.788 3.366-8.154t8.154-3.366 8.154 3.366 3.366 8.154z\",\"VK\":\"M69.012-45.719q.828 2.304-5.4 10.584-.864 1.152-2.34 3.06-2.808 3.6-3.24 4.716-.612 1.476.504 2.916.612.756 2.916 2.952h.036l.036.036.036.036.072.072q5.076 4.716 6.876 7.956.108.18.234.45t.252.954-.018 1.224-.9.99-2.124.45l-9.216.144q-.864.18-2.016-.18t-1.872-.792l-.72-.432q-1.08-.756-2.52-2.304t-2.466-2.79-2.196-2.088-2.034-.558q-.108.036-.288.126t-.612.522-.774 1.062-.612 1.872-.234 2.79q0 .54-.126.99t-.27.666l-.144.18q-.648.684-1.908.792h-4.14q-2.556.144-5.256-.594t-4.734-1.908-3.708-2.376-2.538-2.07l-.9-.864q-.36-.36-.99-1.08t-2.574-3.276-3.816-5.436-4.41-7.596-4.698-9.792q-.216-.576-.216-.972t.108-.576l.144-.216q.54-.684 2.052-.684l9.864-.072q.432.072.828.234t.576.306l.18.108q.576.396.864 1.152.72 1.8 1.656 3.726t1.476 2.934l.576 1.044q1.044 2.16 2.016 3.744t1.746 2.466 1.494 1.386 1.224.504.972-.18q.072-.036.18-.18t.432-.792.486-1.692.342-2.916 0-4.5q-.072-1.44-.324-2.628t-.504-1.656l-.216-.432q-.9-1.224-3.06-1.548-.468-.072.18-.864.612-.684 1.368-1.08 1.908-.936 8.604-.864 2.952.036 4.86.468.72.18 1.206.486t.738.864.378 1.152.126 1.638-.036 1.98-.09 2.538-.054 2.97q0 .396-.036 1.512t-.018 1.728.126 1.458.414 1.404.81.882q.288.072.612.144t.936-.396 1.368-1.242 1.872-2.412 2.448-3.87q2.16-3.744 3.852-8.1.144-.36.36-.63t.396-.378l.144-.108.18-.09.468-.108.72-.018 10.368-.072q1.404-.18 2.304.09t1.116.594z\",\"WEIBO\":\"M24.3-18.215q.756-1.224.396-2.484t-1.62-1.8q-1.224-.504-2.628-.036t-2.16 1.656q-.792 1.224-.468 2.466t1.548 1.818 2.682.09 2.25-1.71zm3.384-4.356q.288-.468.126-.954t-.63-.666q-.504-.18-1.026.018t-.774.666q-.612 1.116.468 1.62.504.18 1.044-.018t.792-.666zm6.264 3.852q-1.62 3.672-5.688 5.4t-8.064.432q-3.852-1.224-5.31-4.554t.234-6.75q1.692-3.348 5.454-5.004t7.578-.684q3.996 1.044 5.706 4.302t.09 6.858zm11.232-5.76q-.324-3.456-3.204-6.12t-7.506-3.924-9.882-.756q-8.028.828-13.302 5.094t-4.77 9.522q.324 3.456 3.204 6.12t7.506 3.924 9.882.756q8.028-.828 13.302-5.094t4.77-9.522zm11.088.144q0 2.448-1.332 5.022t-3.924 4.932-6.066 4.23-8.136 2.988-9.738 1.116-9.9-1.206-8.658-3.348-6.174-5.436-2.34-7.182q0-4.14 2.502-8.82t7.11-9.288q6.084-6.084 12.294-8.496t8.874.252q2.34 2.304.72 7.524-.144.504-.036.72t.36.252.522-.018.486-.126l.216-.072q5.004-2.124 8.856-2.124t5.508 2.196q1.62 2.268 0 6.408-.072.468-.162.72t.162.45.432.27.612.216q2.052.648 3.708 1.692t2.88 2.934 1.224 4.194zm-2.664-22.464q1.512 1.692 1.962 3.906t-.234 4.23q-.288.828-1.062 1.224t-1.602.144q-.828-.288-1.224-1.062t-.144-1.602q.72-2.268-.864-3.996t-3.852-1.26q-.864.18-1.62-.288t-.9-1.332q-.18-.864.288-1.602t1.332-.918q2.16-.468 4.284.198t3.636 2.358zm6.516-5.868q3.132 3.456 4.05 8.01t-.486 8.694q-.324.972-1.224 1.44t-1.872.144-1.44-1.224-.18-1.872q1.008-2.952.36-6.192t-2.88-5.688q-2.232-2.484-5.328-3.438t-6.228-.306q-1.008.216-1.872-.342t-1.08-1.566.342-1.854 1.566-1.062q4.428-.936 8.784.414t7.488 4.842z\",\"RENREN\":\"M40.788-7.919q-6.156 3.384-13.248 3.384-7.056 0-13.212-3.384 4.968-3.132 8.478-7.596t4.734-9.648q1.26 5.184 4.77 9.648t8.478 7.596zm-17.82-51.408v17.46q0 9.072-4.554 16.542t-11.898 11.034q-6.516-7.74-6.516-17.82 0-6.732 3.006-12.582t8.262-9.702 11.7-4.932zm32.328 27.216q0 10.08-6.516 17.82-7.344-3.564-11.898-11.034t-4.554-16.542v-17.46q6.444 1.08 11.7 4.932t8.262 9.702 3.006 12.582z\",\"PAGELINES\":\"M50.472-24.731q-1.152 2.88-2.736 4.968t-3.276 3.186-3.564 1.674-3.654.522-3.474-.306-3.114-.792-2.502-.99-1.656-.81l-.612-.36q-4.068 8.208-10.422 12.942t-13.842 4.77q-.684 0-1.152-.468t-.468-1.152.468-1.134 1.152-.45q6.228-.036 11.61-3.87t9.054-10.602q-1.296.504-2.592.828t-2.988.468-3.276-.09-3.348-1.026-3.312-2.124-3.042-3.6-2.682-5.256q4.104-1.692 7.704-2.052t6.03.27 4.482 2.034 3.186 2.772 2.034 2.952q1.908-4.716 2.844-10.476-.252.036-.648.09t-1.674.09-2.502-.018-2.934-.36-3.186-.828-3.024-1.53-2.7-2.34-1.962-3.402-1.026-4.59q2.52-1.008 4.806-1.314t4.05.036 3.312 1.08 2.646 1.8 2.016 2.196 1.512 2.268.99 2.016.576 1.422l.144.576q.432-4.392.432-7.02-.288-.216-.774-.576t-1.764-1.602-2.286-2.574-1.944-3.348-1.188-4.05.432-4.572 2.52-4.986q2.628.9 4.59 2.214t3.042 2.754 1.728 3.06.738 3.204-.018 3.078-.468 2.754-.684 2.232-.612 1.512l-.252.54q.036.18.036 1.818t-.036 2.574q.108-.252.36-.666t1.098-1.548 1.818-2.088 2.556-1.998 3.294-1.602 4.032-.522 4.77.864q-.072 2.808-.774 5.094t-1.8 3.762-2.502 2.574-2.934 1.638-3.042.864-2.88.342-2.43-.036-1.674-.162l-.612-.108q-.828 5.292-2.628 10.188.216-.252.648-.666t1.782-1.476 2.79-1.89 3.582-1.512 4.23-.72 4.644.846 4.932 2.79z\",\"STACK_EXCHANGE\":\"M45.324-19.331v2.376q0 3.06-2.07 5.202t-4.986 2.142h-2.052l-9.36 9.684v-9.684h-19.044q-2.916 0-4.986-2.142t-2.07-5.202v-2.376h44.568zm0-11.736v9.18h-44.568v-9.18h44.568zm0-11.808v9.18h-44.568v-9.18h44.568zm0-5.04v2.412h-44.568v-2.412q0-3.024 2.07-5.166t4.986-2.142h30.456q2.916 0 4.986 2.142t2.07 5.166z\",\"ARROW_CIRCLE_O_RIGHT\":\"M41.472-32.183q0 .504-.324.828l-11.52 11.52q-.324.324-.828.324-.468 0-.81-.342t-.342-.81v-6.912h-12.672q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h12.672v-6.912q0-.504.324-.828t.828-.324q.432 0 .864.36l11.484 11.484q.324.324.324.828zm5.76 0q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"ARROW_CIRCLE_O_LEFT\":\"M41.472-35.639v6.912q0 .468-.342.81t-.81.342h-12.672v6.912q0 .504-.324.828t-.828.324q-.432 0-.864-.36l-11.484-11.484q-.324-.324-.324-.828t.324-.828l11.52-11.52q.324-.324.828-.324.468 0 .81.342t.342.81v6.912h12.672q.468 0 .81.342t.342.81zm5.76 3.456q0-5.328-2.628-9.828t-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828zm8.064 0q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"TOGGLE_LEFT\":\"M36.864-43.703v23.04q0 .936-.684 1.62t-1.62.684q-.72 0-1.332-.432l-16.128-11.52q-.972-.684-.972-1.872t.972-1.872l16.128-11.52q.612-.432 1.332-.432.936 0 1.62.684t.684 1.62zm9.216 28.8v-34.56q0-.468-.342-.81t-.81-.342h-34.56q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h34.56q.468 0 .81-.342t.342-.81zm9.216-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"DOT_CIRCLE_O\":\"M36.864-32.183q0 3.816-2.7 6.516t-6.516 2.7-6.516-2.7-2.7-6.516 2.7-6.516 6.516-2.7 6.516 2.7 2.7 6.516zm-9.216-19.584q-5.328 0-9.828 2.628t-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628 9.828-2.628 7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628zm27.648 19.584q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"WHEELCHAIR\":\"M36.828-21.707l3.672 7.344q-2.088 6.444-7.56 10.44t-12.204 3.996q-5.616 0-10.386-2.79t-7.56-7.56-2.79-10.386q0-6.516 3.762-11.88t9.882-7.596l.612 4.716q-4.392 1.944-7.02 5.958t-2.628 8.802q0 6.66 4.734 11.394t11.394 4.734q4.536 0 8.37-2.34t5.94-6.318 1.782-8.514zm19.728 3.6l2.088 4.104-9.216 4.608q-.468.252-1.044.252-1.44 0-2.052-1.26l-8.604-17.172h-16.992q-.864 0-1.53-.594t-.774-1.458l-3.456-28.044q-.072-.576.216-1.512.504-1.836 2.052-2.97t3.492-1.134q2.376 0 4.068 1.692t1.692 4.068q0 2.484-1.872 4.23t-4.32 1.494l1.332 10.404h15.228v4.608h-14.652l.576 4.608h16.38q1.44 0 2.052 1.26l8.208 16.38z\",\"VIMEO_SQUARE\":\"M46.512-41.471q.36-7.776-5.796-7.992-8.316-.288-11.232 9.396 1.584-.684 2.952-.684 3.06 0 2.664 3.456-.144 2.052-2.664 6.012t-3.78 3.96q-1.548 0-2.952-6.084-.468-1.944-1.62-9.18-1.08-6.804-5.76-6.372-2.124.252-5.904 3.6l-2.916 2.592-2.916 2.592 1.872 2.412q2.736-1.872 3.132-1.872 2.052 0 3.852 6.444.54 1.98 1.62 5.922t1.62 5.922q2.448 6.444 5.904 6.444 5.652 0 13.788-10.584 7.92-10.188 8.136-15.984zm8.784-7.992v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TURKISH_LIRA\":\"M41.472-34.487q0 6.876-3.402 12.708t-9.234 9.234-12.708 3.402h-5.76q-.504 0-.828-.324t-.324-.828v-21.996l-7.74 2.376q-.108.036-.324.036-.36 0-.684-.216-.468-.36-.468-.936v-4.608q0-.828.828-1.116l8.388-2.556v-3.348l-7.74 2.376q-.108.036-.324.036-.36 0-.684-.216-.468-.36-.468-.936v-4.608q0-.828.828-1.116l8.388-2.556v-9q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828v6.516l13.5-4.176q.54-.18 1.008.18t.468.936v4.608q0 .828-.828 1.116l-14.148 4.356v3.348l13.5-4.176q.54-.18 1.008.18t.468.936v4.608q0 .828-.828 1.116l-14.148 4.356v17.532q6.768-.468 11.448-5.436t4.68-11.808q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828z\",\"PLUS_SQUARE_O\":\"M41.472-35.639v2.304q0 .504-.324.828t-.828.324h-12.672v12.672q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-12.672h-12.672q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h12.672v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v12.672h12.672q.504 0 .828.324t.324.828zm4.608 16.128v-29.952q0-2.376-1.692-4.068t-4.068-1.692h-29.952q-2.376 0-4.068 1.692t-1.692 4.068v29.952q0 2.376 1.692 4.068t4.068 1.692h29.952q2.376 0 4.068-1.692t1.692-4.068zm4.608-29.952v29.952q0 4.284-3.042 7.326t-7.326 3.042h-29.952q-4.284 0-7.326-3.042t-3.042-7.326v-29.952q0-4.284 3.042-7.326t7.326-3.042h29.952q4.284 0 7.326 3.042t3.042 7.326z\",\"SPACE_SHUTTLE\":\"M22.32-24.119q-3.96 2.304-9.648 2.304h-4.608v-2.304h-2.304q-.468 0-.81-.846t-.342-2.034q0-.864.252-1.764-2.088-.072-3.474-.378t-1.386-.738 1.386-.738 3.474-.378q-.252-.9-.252-1.764 0-1.188.342-2.034t.81-.846h2.304v-2.304h4.608q5.688 0 9.648 2.304h40.068q1.512.252 3.834.648t2.898.504q3.204.54 5.4 1.458t3.006 1.71.81 1.44-.81 1.44-3.006 1.71-5.4 1.458q-.576.108-2.898.504t-3.834.648h-40.068zm40.284-9.072q1.908 1.296 1.908 3.312t-1.908 3.312l2.916 1.08q2.448-1.728 2.448-4.392t-2.448-4.392zm-40.104 9.648h36.54q-7.812 1.368-16.416 2.88-2.052 0-4.068.864t-2.988 1.728l-1.008.864-10.368 10.368q-.936.936-2.538 1.62t-3.222.684h-3.456l-3.348-16.704h1.044q5.652 0 9.828-2.304zm-9.828-14.976h-1.044l3.348-16.704h3.456q1.656 0 3.24.684t2.52 1.62l10.368 10.368q.144.144.396.378t1.098.828 1.746 1.044 2.214.828 2.61.378l16.416 2.88h-36.54q-4.176-2.304-9.828-2.304z\",\"SLACK\":\"M54.684-36.503q2.232 0 3.726 1.458t1.494 3.654q0 3.492-3.348 4.68l-6.192 2.124 2.016 6.012q.252.756.252 1.692 0 2.124-1.512 3.672t-3.636 1.548q-1.692 0-3.078-.972t-1.926-2.592l-1.98-5.94-11.16 3.816 1.98 5.904q.288.864.288 1.692 0 2.124-1.512 3.672t-3.672 1.548q-1.692 0-3.06-.972t-1.908-2.592l-1.98-5.868-5.508 1.908q-1.044.324-1.8.324-2.196 0-3.654-1.44t-1.458-3.636q0-1.692.99-3.06t2.574-1.908l5.616-1.908-3.78-11.268-5.616 1.944q-.936.288-1.728.288-2.16 0-3.636-1.458t-1.476-3.618q0-1.692.99-3.06t2.574-1.908l5.652-1.908-1.908-5.724q-.288-.864-.288-1.692 0-2.16 1.512-3.69t3.672-1.53q1.692 0 3.06.972t1.908 2.592l1.944 5.76 11.16-3.78-1.944-5.76q-.288-.864-.288-1.692 0-2.124 1.53-3.672t3.654-1.548q1.692 0 3.078.99t1.926 2.574l1.908 5.796 5.832-1.98q.756-.216 1.548-.216 2.16 0 3.69 1.422t1.53 3.546q0 1.62-1.08 2.934t-2.664 1.854l-5.652 1.944 3.78 11.376 5.904-2.016q.864-.288 1.656-.288zm-28.584 9.432l11.16-3.78-3.78-11.34-11.16 3.852z\",\"ENVELOPE_SQUARE\":\"M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm1.152 38.016v-15.696q-1.116 1.26-2.304 1.98-1.224.792-4.77 3.06t-5.454 3.564q-3.528 2.484-5.904 2.484t-5.904-2.484q-1.656-1.152-5.094-3.33t-5.13-3.33q-.432-.288-1.188-.972t-1.116-.972v15.696q0 1.44 1.008 2.448t2.448 1.008h29.952q1.44 0 2.448-1.008t1.008-2.448zm0-20.628q0-1.476-.99-2.52t-2.466-1.044h-29.952q-1.44 0-2.448 1.008t-1.008 2.448q0 1.332 1.098 2.754t2.43 2.322q1.692 1.152 4.95 3.204t4.662 2.988l.612.414.756.504.756.468.846.468.774.342.81.27.738.09.738-.09.81-.27.774-.342.846-.468.756-.468.756-.504.612-.414 9.612-6.264q1.26-.828 2.394-2.25t1.134-2.646z\",\"WORDPRESS\":\"M4.572-32.183q0-5.868 2.412-11.268l13.212 36.18q-7.056-3.42-11.34-10.116t-4.284-14.796zm46.368-1.404q0 .684-.09 1.386t-.36 1.782-.414 1.584-.63 2.124-.63 2.088l-2.736 9.216-10.008-29.736q1.656-.108 3.168-.288.684-.072.936-.666t-.09-1.116-1.026-.486l-7.38.36q-2.7-.036-7.272-.36-.432-.036-.738.18t-.414.54-.054.666.324.594.702.288l2.88.288 4.32 11.808-6.048 18.144-10.08-29.952q1.656-.108 3.168-.288.684-.072.936-.666t-.09-1.116-1.026-.486l-7.38.36-.828-.018-.936-.018q3.78-5.76 9.882-9.126t13.23-3.366q5.292 0 10.098 1.908t8.586 5.364h-.36q-1.98 0-3.312 1.458t-1.332 3.438q0 .432.072.864t.144.774.288.828.324.756.432.81.45.756.522.864.504.828q2.268 3.852 2.268 7.632zm-18.216 3.816l8.532 23.292q.036.216.18.396-4.536 1.584-9.18 1.584-4.032 0-7.812-1.152zm23.796-15.696q3.42 6.264 3.42 13.284 0 7.524-3.744 13.878t-10.044 10.026l8.46-24.408q2.124-6.084 2.124-9.936 0-1.512-.216-2.844zm-24.264-18.972q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm0 63.036q6.228 0 11.934-2.448t9.828-6.57 6.57-9.828 2.448-11.934-2.448-11.934-6.57-9.828-9.828-6.57-11.934-2.448-11.934 2.448-9.828 6.57-6.57 9.828-2.448 11.934 2.448 11.934 6.57 9.828 9.828 6.57 11.934 2.448z\",\"OPENID\":\"M39.096-64.439v55.296l-9.792 4.608q-8.208-.72-14.904-3.672t-10.548-7.506-3.852-9.81q0-5.04 3.618-9.486t9.9-7.398 14.094-3.888v6.192q-7.812 1.368-12.834 5.4t-5.022 9.18q0 5.472 5.562 9.612t13.986 5.22v-48.96zm24.084 20.952l1.332 14.04-18.9-4.104 5.292-2.988q-4.284-2.52-10.08-3.564v-6.192q9.972 1.188 17.316 5.652z\",\"UNIVERSITY\":\"M34.56-64.439l34.56 13.824v4.608h-4.608q0 .936-.738 1.62t-1.746.684h-54.936q-1.008 0-1.746-.684t-.738-1.62h-4.608v-4.608zm-25.344 23.04h9.216v27.648h4.608v-27.648h9.216v27.648h4.608v-27.648h9.216v27.648h4.608v-27.648h9.216v27.648h2.124q1.008 0 1.746.684t.738 1.62v2.304h-59.904v-2.304q0-.936.738-1.62t1.746-.684h2.124v-27.648zm57.42 34.56q1.008 0 1.746.684t.738 1.62v4.608h-69.12v-4.608q0-.936.738-1.62t1.746-.684h64.152z\",\"MORTAR_BOARD\":\"M63.864-34.343l.648 11.376q.144 2.484-2.952 4.608t-8.46 3.366-11.628 1.242-11.628-1.242-8.46-3.366-2.952-4.608l.648-11.376 20.664 6.516q.792.252 1.728.252t1.728-.252zm19.08-11.664q0 .828-.792 1.116l-40.32 12.672q-.144.036-.36.036t-.36-.036l-23.472-7.416q-1.548 1.224-2.556 4.014t-1.224 6.426q2.268 1.296 2.268 3.924 0 2.484-2.088 3.852l2.088 15.588q.072.504-.288.9-.324.396-.864.396h-6.912q-.54 0-.864-.396-.36-.396-.288-.9l2.088-15.588q-2.088-1.368-2.088-3.852 0-2.628 2.34-3.996.396-7.452 3.528-11.88l-11.988-3.744q-.792-.288-.792-1.116t.792-1.116l40.32-12.672q.144-.036.36-.036t.36.036l40.32 12.672q.792.288.792 1.116z\",\"YAHOO\":\"M30.924-29.987l.468 25.452q-2.232-.396-3.78-.396-1.476 0-3.78.396l.468-25.452q-1.44-2.484-6.066-10.638t-7.794-13.482-6.516-10.332q2.088.54 3.888.54 1.548 0 3.996-.54 2.268 3.996 4.806 8.262t6.012 9.954 4.986 8.172q1.332-2.196 3.942-6.39t4.23-6.84 3.78-6.336 3.852-6.822q1.944.504 3.852.504 2.016 0 4.104-.504-1.008 1.404-2.16 3.186t-1.782 2.826-2.034 3.456-1.764 3.024q-5.256 8.928-12.708 21.96z\",\"GOOGLE\":\"M27.648-36.143h26.1q.432 2.412.432 4.608 0 7.812-3.276 13.95t-9.342 9.594-13.914 3.456q-5.652 0-10.764-2.178t-8.82-5.886-5.886-8.82-2.178-10.764 2.178-10.764 5.886-8.82 8.82-5.886 10.764-2.178q10.8 0 18.54 7.236l-7.524 7.236q-4.428-4.284-11.016-4.284-4.644 0-8.586 2.34t-6.246 6.354-2.304 8.766 2.304 8.766 6.246 6.354 8.586 2.34q3.132 0 5.76-.864t4.32-2.16 2.952-2.952 1.854-3.132.81-2.808h-15.696v-9.504z\",\"REDDIT\":\"M39.42-22.427q.576.576 0 1.116-2.232 2.232-7.164 2.232t-7.164-2.232q-.576-.54 0-1.116.216-.216.54-.216t.54.216q1.728 1.764 6.084 1.764 4.32 0 6.084-1.764.216-.216.54-.216t.54.216zm-11.052-6.516q0 1.332-.936 2.268t-2.268.936-2.286-.936-.954-2.268q0-1.368.954-2.304t2.286-.936 2.268.954.936 2.286zm14.22 0q0 1.332-.954 2.268t-2.286.936-2.268-.936-.936-2.268.936-2.286 2.268-.954 2.286.936.954 2.304zm9.036-4.32q0-1.764-1.26-3.024t-3.06-1.26-3.096 1.296q-4.68-3.24-11.196-3.456l2.268-10.188 7.2 1.62q0 1.332.936 2.268t2.268.936 2.286-.954.954-2.286-.954-2.286-2.286-.954q-1.944 0-2.88 1.8l-7.956-1.764q-.684-.18-.9.576l-2.484 11.232q-6.48.252-11.124 3.492-1.26-1.332-3.132-1.332-1.8 0-3.06 1.26t-1.26 3.024q0 1.26.666 2.304t1.782 1.584q-.216.972-.216 2.016 0 5.112 5.04 8.748t12.132 3.636q7.128 0 12.168-3.636t5.04-8.748q0-1.152-.252-2.052 1.08-.54 1.728-1.566t.648-2.286zm12.888 1.08q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"REDDIT_SQUARE\":\"M33.804-23.795q.468.468 0 .936-1.908 1.908-6.156 1.908t-6.156-1.908q-.468-.468 0-.936.18-.216.468-.216t.468.216q1.512 1.512 5.22 1.512t5.22-1.512q.18-.216.468-.216t.468.216zm-9.468-5.616q0 1.116-.828 1.944t-1.944.828-1.944-.828-.828-1.944q0-1.152.81-1.962t1.962-.81 1.962.81.81 1.962zm12.168 0q0 1.116-.828 1.944t-1.944.828-1.944-.828-.828-1.944q0-1.152.81-1.962t1.962-.81 1.962.81.81 1.962zm7.74-3.708q0-1.512-1.08-2.592t-2.628-1.08q-1.512 0-2.628 1.116-4.068-2.808-9.612-2.952l1.944-8.748 6.156 1.404q.036 1.152.846 1.944t1.926.792q1.152 0 1.962-.81t.81-1.962-.81-1.962-1.962-.81q-1.728 0-2.484 1.548l-6.804-1.512q-.612-.18-.756.468l-2.16 9.648q-5.544.216-9.54 2.988-1.08-1.152-2.664-1.152-1.548 0-2.628 1.08t-1.08 2.592q0 1.08.576 1.98t1.512 1.368q-.18.9-.18 1.728 0 4.392 4.32 7.506t10.404 3.114q6.12 0 10.44-3.114t4.32-7.506q0-.9-.216-1.764.9-.468 1.458-1.35t.558-1.962zm11.052-16.344v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"STUMBLEUPON_CIRCLE\":\"M31.176-34.235l3.24-.972v-2.232q0-2.844-2.088-4.86t-4.968-2.016-4.968 1.998-2.088 4.842v10.188q0 .72-.504 1.206t-1.188.486-1.17-.486-.486-1.206v-4.32h-5.436v4.392q0 2.952 2.07 5.004t5.022 2.052q2.916 0 4.986-2.034t2.07-4.914v-10.08q0-.684.486-1.188t1.206-.504q.684 0 1.17.504t.486 1.188v1.944zm11.988 7.02v-4.392h-5.4v4.536q0 .72-.486 1.206t-1.206.486q-.684 0-1.17-.504t-.486-1.188v-4.428l-3.24.936-2.16-1.008v4.428q0 2.88 2.088 4.932t5.004 2.052 4.986-2.052 2.07-5.004zm12.132-4.968q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"STUMBLEUPON\":\"M38.232-38.807v-4.248q0-1.512-1.08-2.592t-2.592-1.08-2.592 1.08-1.08 2.592v22.032q0 6.3-4.536 10.764t-10.908 4.464q-6.408 0-10.926-4.518t-4.518-10.926v-9.576h11.808v9.432q0 1.548 1.08 2.61t2.592 1.062 2.592-1.062 1.08-2.61v-22.32q0-6.156 4.554-10.512t10.854-4.356q6.336 0 10.872 4.392t4.536 10.584v4.896l-7.02 2.088zm19.08 7.992h11.808v9.576q0 6.408-4.518 10.926t-10.926 4.518q-6.372 0-10.908-4.482t-4.536-10.818v-9.648l4.716 2.196 7.02-2.088v9.72q0 1.512 1.08 2.574t2.592 1.062 2.592-1.062 1.08-2.574v-9.9z\",\"DELICIOUS\":\"M52.992-14.903v-17.28h-25.344v-25.344h-17.28q-3.348 0-5.706 2.358t-2.358 5.706v17.28h25.344v25.344h17.28q3.348 0 5.706-2.358t2.358-5.706zm2.304-34.56v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"DIGG\":\"M11.808-54.287h7.344v35.388h-19.152v-25.092h11.808v-10.296zm0 29.484v-13.284h-4.428v13.284h4.428zm10.296-19.188v25.092h7.38v-25.092h-7.38zm0-10.296v7.344h7.38v-7.344h-7.38zm10.332 10.296h19.188v33.912h-19.188v-5.868h11.808v-2.952h-11.808v-25.092zm11.808 19.188v-13.284h-4.428v13.284h4.428zm10.332-19.188h19.152v33.912h-19.152v-5.868h11.772v-2.952h-11.772v-25.092zm11.772 19.188v-13.284h-4.428v13.284h4.428z\",\"PIED_PIPER\":\"M37.656-27.719q0 2.304-1.368 3.924t-3.276 1.62q-1.548 0-2.52-.54v-9.972q1.008-.612 2.52-.612 1.908 0 3.276 1.638t1.368 3.942zm-12.348-15.408q0 2.304-1.368 3.942t-3.276 1.638q-1.548 0-2.52-.54v-9.972q1.008-.612 2.52-.612 1.908 0 3.276 1.62t1.368 3.924zm20.232 15.516q0-4.824-3.168-8.244t-7.668-3.42q-.72 0-1.404.108-.828 2.808-2.808 4.896-3.132 3.42-7.596 3.636v22.896l7.596-1.476v-7.416q1.836.684 4.212.684 4.5 0 7.668-3.42t3.168-8.244zm-12.348-15.372q0-4.824-3.186-8.244t-7.686-3.42q-2.664 0-5.076 1.296h-6.696v30.24l7.596-1.476v-7.416q1.98.684 4.176.684 4.5 0 7.686-3.42t3.186-8.244zm22.104-6.48v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"PIED_PIPER_ALT\":\"M43.992-30.995q2.7-.108 5.166.738t4.248 2.106 3.636 3.402 3.024 3.888 2.718 4.338q1.188 2.016 2.826 3.924t2.718 2.898 3.564 3.186q-1.728 1.08-3.906 2.07t-4.986 2.124-4.104 1.71q-1.584-1.332-2.664-4.14t-1.566-5.922-1.188-6.498-1.53-6.066-2.61-4.428-4.41-1.746l-.36.072-.216.144q.144.18.468.504.216.18 1.008.846t.918.792.684.648.648.738.414.756.378.99.162 1.116.144 1.458l.036 1.188q.036.936-.09 2.07t-.27 1.872-.45 2.106-.414 1.908q-1.26-.036-3.636.342t-3.528.378q-1.404 0-2.592-.36-.072-.576-.072-1.692 0-2.664.108-3.456.072-.468 1.134-1.494t2.052-2.124.954-1.854q-.864-.072-1.548.864-1.296 1.908-4.014 3.582t-4.914 1.674q-.9 0-2.718-2.268t-3.834-5.022-3.024-3.474q-.216-.144-.972-1.08-17.352 4.032-18.468 4.032-.576 0-1.008-.396t-.432-.972q0-.54.306-.954t.81-.522l17.496-3.816q-.288-.504-.288-.9t.198-.63.576-.414.72-.252.828-.162.666-.162q.144-.036.558-.27t.63-.234q.54 0 1.008.576t.72 1.188q5.868-1.332 6.192-1.332.612 0 1.062.396t.45 1.008q0 .54-.306.936t-.846.504l-6.552 1.44-.036.576q-.036.936 2.934 4.23t3.762 3.294q1.692 0 4.284-2.88t2.592-4.644q0-1.296-.846-1.908t-1.836-.666-1.836-.414-.846-1.224q0-.576.36-1.224l-2.448-.684q1.548-1.584 1.548-4.212 0-.936-.18-2.088 2.952-.576 5.184-.576 1.584 0 2.574.054t1.746.306 1.116.486.738.882.558 1.206.612 1.71.864 2.16l1.8-.9q-.108 1.44-.828 2.16t-1.53.756-1.44.234-.594.738zm2.16-8.46q-.18-.18-.486-.558t-.432-.522-.378-.414-.36-.378l-.288-.288-.306-.27-.288-.18-.306-.162q-.252-.108-.522-.18t-.738-.09-.792-.018h-2.52q-4.536 0-7.812 1.548.576-1.08 1.296-1.674t1.944-1.062 2.358-1.296 1.656-1.314 1.8-1.98 1.566-1.818q.432.324 1.008 1.134t1.152 1.314 1.368.468l.432-.036v2.736l.792.036q8.892-3.42 13.356-6.84 1.008-.756 1.8-1.404t1.53-1.35 1.188-1.116 1.062-1.224.864-1.116.882-1.332.828-1.368.972-1.71 1.062-1.908l.252-.324q-.072 1.908-1.548 5.004-2.844 5.94-7.38 9.504t-11.016 5.112q-.504.108-1.512.27t-1.8.342-1.404.504q.108.684.882 1.656t.774 1.224q0 .396-.936 1.08zm-7.956 33.156q1.404-.936 4.734-1.71t5.274-.774q.324 0 .81.558t1.008 1.53.936 1.8.864 1.836.522 1.188q-4.356 1.62-8.784 1.62-2.196 0-4.5-.396zm-8.604-23.292l1.728-.432 3.924 6.372-2.628 1.728zm18.036 18.612l.108.576q0 .252-.63.522t-1.656.468-1.944.342-1.926.27-1.152.162l-.252-1.548q.756-.072 2.178-.306t2.592-.36 2.178-.126h.504zm-16.452-22.608l-3.456.72-.216-.612q.36-.036 1.17-.252t1.242-.216q.684 0 1.26.36zm7.02 22.824h1.116l.36 2.988-1.476.432v-3.42zm32.004-53.64v0zm0 0l-.036.18-.072.072.036-.108zm0 0l.036-.036z\",\"DRUPAL\":\"M42.012-7.343q-.18-.684-.864-.18-1.08.792-3.132 1.404t-4.716.612q-4.644 0-6.948-1.764-.18-.144-.468-.144-.396 0-.936.432-.252.216-.27.576t.27.72q1.224 1.152 3.15 1.656t3.69.45 3.564-.162q1.476-.144 3.042-.738t2.34-1.08 1.026-.738q.432-.432.252-1.044zm-1.404-4.14q-.684-1.692-1.404-2.196-.828-.54-2.736-.54-1.692 0-2.556.36-1.044.432-2.808 2.016-.936.864-.432 1.584.324.288.63.162t1.134-.846q.108-.072.378-.306t.378-.306.36-.252.414-.252.45-.18.54-.162.594-.09.738-.036q.972 0 1.602.27t.828.522.486.792q.36.612.45.72t.45-.036q.828-.432.504-1.224zm12.78-10.116q0-.792-.18-1.602t-.594-1.62-1.224-1.314-1.89-.504q-1.188 0-3.492 1.494t-4.644 3.006-3.636 1.512q-.972.036-2.286-.684t-2.736-1.764-3.006-2.088-3.6-1.764-3.996-.684q-4.14.036-7.092 2.826t-3.024 6.426q-.072 4.032 2.664 5.904 1.044.72 2.25 1.026t3.726.306q2.052 0 4.752-1.17t4.824-2.556 4.32-2.538 3.348-1.116q.936.036 2.34 1.134t2.574 2.412 2.448 2.43 1.998 1.152q1.26.108 2.106-.504t1.998-2.268q1.008-1.476 1.53-3.636t.522-3.816zm1.908-5.76q0 5.904-2.232 10.962t-5.976 8.496-8.73 5.382-10.458 1.944-10.548-2.07-8.91-5.652-6.138-8.694-2.304-10.872q0-3.204.702-6.21t1.764-5.238 2.538-4.266 2.826-3.384 2.826-2.502 2.322-1.674 1.53-.882q.504-.288 1.836-.954t1.962-1.026 1.728-1.08 2.178-1.584q1.296-1.008 2.088-2.61t1.08-4.518q4.644 5.58 6.696 6.948 1.584 1.044 4.68 2.448t4.644 2.376q.756.468 1.404.9t2.178 1.674 2.736 2.538 2.7 3.42 2.484 4.392 1.692 5.346.702 6.39z\",\"JOOMLA\":\"M38.52-25.811l-5.76 5.76-5.436 5.472-1.08 1.08q-2.34 2.304-5.454 3.132t-6.174.072q-.576 2.52-2.592 4.14t-4.644 1.62q-3.06 0-5.22-2.178t-2.16-5.238q0-2.592 1.602-4.608t4.086-2.592q-.792-3.096.036-6.228t3.168-5.472l.432-.432 5.436 5.472-.396.396q-1.332 1.332-1.332 3.204t1.332 3.24q1.332 1.332 3.204 1.332t3.204-1.332l1.08-1.08 5.436-5.472 5.796-5.76zm-12.276-24.552l.432.432-5.472 5.472-.432-.432q-1.332-1.332-3.204-1.332t-3.204 1.332-1.332 3.222 1.332 3.222l1.044 1.044 5.472 5.472 5.76 5.76-5.436 5.472-5.796-5.76-5.436-5.472-1.08-1.08q-2.448-2.412-3.24-5.742t.18-6.462q-2.52-.54-4.14-2.556t-1.62-4.644q0-3.06 2.16-5.238t5.22-2.178q2.736 0 4.806 1.764t2.502 4.428q3.024-.72 6.102.126t5.382 3.15zm29.052 38.412q0 3.06-2.16 5.238t-5.22 2.178q-2.664 0-4.716-1.692t-2.556-4.248q-3.096 1.008-6.462.216t-5.814-3.24l-.396-.432 5.436-5.472.432.432q1.332 1.332 3.204 1.332t3.204-1.332 1.332-3.204-1.332-3.204l-1.08-1.08-5.472-5.472-5.76-5.76 5.472-5.472 5.76 5.76 5.472 5.472 1.044 1.08q2.304 2.304 3.15 5.418t.09 6.174q2.736.396 4.554 2.466t1.818 4.842zm-.072-40.464q0 2.772-1.836 4.86t-4.572 2.484q.936 3.06.108 6.354t-3.24 5.706l-.432.432-5.436-5.472.432-.432q1.332-1.332 1.332-3.204t-1.332-3.204-3.204-1.332-3.204 1.332l-1.08 1.08-5.472 5.472-5.76 5.76-5.472-5.472 5.796-5.76 5.472-5.472 1.044-1.08q2.412-2.412 5.724-3.222t6.408.126q.396-2.7 2.466-4.536t4.878-1.836q3.06 0 5.22 2.178t2.16 5.238z\",\"LANGUAGE\":\"M23.544-25.631q-.036.108-.45-.018t-1.134-.414l-.72-.324q-1.584-.72-3.132-1.764-.252-.18-1.476-1.134t-1.368-1.026q-2.412 3.708-4.824 6.516-2.916 3.42-3.78 3.96-.144.072-.702.144t-.666 0q.216-.144 2.952-3.312.756-.864 3.078-4.14t2.826-4.248q.612-1.08 1.836-3.546t1.296-2.79q-.288-.036-3.96 1.188-.288.072-.99.27t-1.242.342-.612.18q-.072.072-.072.378t-.036.342q-.18.36-1.116.54-.828.252-1.692 0-.648-.144-1.008-.756-.144-.216-.18-.828.216-.072.882-.18t1.062-.216q2.088-.576 3.78-1.152 3.6-1.26 3.672-1.26.36-.072 1.548-.702t1.584-.774q.324-.108.774-.288t.522-.198.216.018q.072.432-.036 1.188 0 .072-.45.972t-.954 1.926-.612 1.206q-.9 1.8-2.772 4.716l2.304 1.008q.432.216 2.682 1.152t2.43 1.008q.144.036.378.918t.162 1.098zm-7.38-17.496q.108.54-.144 1.008-.432.828-1.8 1.368-1.08.432-2.16.432-.936-.108-1.764-.936-.504-.54-.648-1.476l.036-.108q.108.108.702.18t.954 0 2.088-.576q1.296-.432 1.98-.504.612 0 .756.612zm25.128 4.644l2.268 8.172-5.004-1.512zm-39.888 28.8l24.984-8.352v-37.152l-24.984 8.388v37.116zm44.676-11.412l3.672 1.116-6.516-23.652-3.6-1.116-7.776 19.296 3.672 1.116 1.62-3.96 7.596 2.34zm-18.108-34.632l20.628 6.624v-13.68zm11.196 47.628l5.688.468-1.944 5.76-1.44-2.376q-4.68 2.988-9.936 3.888-2.088.432-3.276.432h-3.024q-2.844 0-7.182-1.404t-6.606-3.06q-.288-.252-.288-.576 0-.288.18-.486t.468-.198q.144 0 .648.27t1.098.594.738.396q2.628 1.332 5.742 2.214t5.67.882q3.42 0 6.012-.522t5.652-1.818q.54-.252 1.098-.558t1.224-.684 1.026-.594zm16.128-38.844v38.844l-27.864-8.856q-.504.216-13.5 4.59t-13.248 4.374q-.468 0-.648-.468l-.036-.108v-38.808q.108-.324.144-.36.18-.216.72-.396 3.816-1.26 5.364-1.8v-13.824l20.088 7.128q.072 0 5.778-1.98t11.376-3.906 5.814-1.926q.72 0 .72.756v15.048z\",\"FAX\":\"M10.368-50.615q2.376 0 4.068 1.692t1.692 4.068v39.168q0 2.376-1.692 4.068t-4.068 1.692h-4.608q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h4.608zm49.536 5.868q2.088 1.224 3.348 3.348t1.26 4.608v27.648q0 3.816-2.7 6.516t-6.516 2.7h-31.104q-2.376 0-4.068-1.692t-1.692-4.068v-55.296q0-1.44 1.008-2.448t2.448-1.008h24.192q1.44 0 3.168.72t2.736 1.728l5.472 5.472q1.008 1.008 1.728 2.736t.72 3.168v5.868zm-26.496 35.604v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm9.216 18.432v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm9.216 18.432v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm0-9.216v-4.608q0-.504-.324-.828t-.828-.324h-4.608q-.504 0-.828.324t-.324.828v4.608q0 .504.324.828t.828.324h4.608q.504 0 .828-.324t.324-.828zm3.456-13.824v-9.216h-5.76q-1.44 0-2.448-1.008t-1.008-2.448v-5.76h-23.04v18.432h32.256z\",\"BUILDING\":\"M48.384-64.439q.936 0 1.62.684t.684 1.62v59.904q0 .936-.684 1.62t-1.62.684h-46.08q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h46.08zm-29.952 10.368v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm0 9.216v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm-4.608 11.52v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm18.432 46.08v-6.912q0-.504-.324-.828t-.828-.324h-11.52q-.504 0-.828.324t-.324.828v6.912q0 .504.324.828t.828.324h11.52q.504 0 .828-.324t.324-.828zm0-18.432v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 36.864v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm0-9.216v-2.304q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v2.304q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828z\",\"CHILD\":\"M42.768-44.711l-10.512 10.512v29.664q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-13.824h-2.304v13.824q0 1.656-1.188 2.844t-2.844 1.188-2.844-1.188-1.188-2.844v-29.664l-10.512-10.512q-1.008-1.008-1.008-2.448t1.008-2.448 2.448-1.008 2.448 1.008l8.208 8.208h13.248l8.208-8.208q1.008-1.008 2.448-1.008t2.448 1.008 1.008 2.448-1.008 2.448zm-11.664-5.904q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z\",\"PAW\":\"M28.08-47.447q0 2.16-.684 4.086t-2.268 3.33-3.78 1.404q-2.736 0-4.968-2.07t-3.312-4.878-1.08-5.436q0-2.16.684-4.086t2.268-3.33 3.78-1.404q2.772 0 4.986 2.07t3.294 4.86 1.08 5.454zm-12.312 17.388q0 2.88-1.512 5.004t-4.284 2.124q-2.736 0-5.094-1.998t-3.618-4.806-1.26-5.472q0-2.88 1.512-5.022t4.284-2.142q2.736 0 5.094 1.998t3.618 4.824 1.26 5.49zm14.184-.972q4.248 0 9.18 3.51t8.244 8.532 3.312 9.162q0 1.656-.612 2.754t-1.746 1.62-2.322.72-2.736.198q-2.448 0-6.75-1.62t-6.57-1.62q-2.376 0-6.93 1.602t-7.218 1.602q-6.588 0-6.588-5.256 0-3.096 2.016-6.894t5.022-6.93 6.75-5.256 6.948-2.124zm8.604-7.596q-2.196 0-3.78-1.404t-2.268-3.33-.684-4.086q0-2.664 1.08-5.454t3.294-4.86 4.986-2.07q2.196 0 3.78 1.404t2.268 3.33.684 4.086q0 2.628-1.08 5.436t-3.312 4.878-4.968 2.07zm15.552-3.744q2.772 0 4.284 2.142t1.512 5.022q0 2.664-1.26 5.472t-3.618 4.806-5.094 1.998q-2.772 0-4.284-2.124t-1.512-5.004q0-2.664 1.26-5.49t3.618-4.824 5.094-1.998z\",\"SPOON\":\"M25.344-45.431q0 5.22-2.052 8.766t-5.472 4.878l1.62 29.556q.072.936-.576 1.62t-1.584.684h-6.912q-.936 0-1.584-.684t-.576-1.62l1.62-29.556q-3.42-1.332-5.472-4.878t-2.052-8.766q0-4.608 1.53-8.982t4.23-7.2 5.76-2.826 5.76 2.826 4.23 7.2 1.53 8.982z\",\"CUBE\":\"M32.256-5.795l23.04-12.564v-22.896l-23.04 8.388v27.072zm-2.304-31.14l25.128-9.144-25.128-9.144-25.128 9.144zm29.952-9.072v27.648q0 1.26-.648 2.34t-1.764 1.692l-25.344 13.824q-1.008.576-2.196.576t-2.196-.576l-25.344-13.824q-1.116-.612-1.764-1.692t-.648-2.34v-27.648q0-1.44.828-2.628t2.196-1.692l25.344-9.216q.792-.288 1.584-.288t1.584.288l25.344 9.216q1.368.504 2.196 1.692t.828 2.628z\",\"CUBES\":\"M23.04-5.687l13.824-6.912v-11.304l-13.824 5.904v12.312zm-2.304-16.344l14.544-6.228-14.544-6.228-14.544 6.228zm39.168 16.344l13.824-6.912v-11.304l-13.824 5.904v12.312zm-2.304-16.344l14.544-6.228-14.544-6.228-14.544 6.228zm-16.128-10.548l13.824-5.94v-9.576l-13.824 5.904v9.612zm-2.304-13.644l15.876-6.804-15.876-6.804-15.876 6.804zm39.168 18.648v14.976q0 1.296-.684 2.412t-1.872 1.692l-16.128 8.064q-.9.504-2.052.504t-2.052-.504l-16.128-8.064q-.18-.072-.252-.144-.072.072-.252.144l-16.128 8.064q-.9.504-2.052.504t-2.052-.504l-16.128-8.064q-1.188-.576-1.872-1.692t-.684-2.412v-14.976q0-1.368.774-2.52t2.034-1.728l15.624-6.696v-14.4q0-1.368.774-2.52t2.034-1.728l16.128-6.912q.828-.36 1.8-.36t1.8.36l16.128 6.912q1.26.576 2.034 1.728t.774 2.52v14.4l15.624 6.696q1.296.576 2.052 1.728t.756 2.52z\",\"BEHANCE\":\"M66.528-52.235h-18.396v4.464h18.396v-4.464zm-9.072 15.336q-3.24 0-5.256 1.89t-2.232 5.13h14.688q-.648-7.02-7.2-7.02zm.576 21.06q2.268 0 4.392-1.152t2.736-3.132h7.956q-3.6 11.052-15.372 11.052-7.704 0-12.258-4.752t-4.554-12.492q0-7.488 4.698-12.438t12.114-4.95q4.968 0 8.658 2.448t5.508 6.444 1.818 8.928q0 .612-.072 1.692h-23.688q0 3.996 2.07 6.174t5.994 2.178zm-48.06-1.8h10.656q7.38 0 7.38-6.012 0-6.48-7.164-6.48h-10.872v12.492zm0-19.332h10.116q2.808 0 4.446-1.314t1.638-4.086q0-5.184-6.84-5.184h-9.36v10.584zm-9.972-18.324h21.384q3.132 0 5.58.504t4.554 1.71 3.24 3.474 1.134 5.544q0 6.516-6.192 9.468 4.104 1.152 6.192 4.14t2.088 7.344q0 2.7-.882 4.914t-2.376 3.726-3.546 2.556-4.356 1.512-4.824.468h-21.996v-45.36z\",\"BEHANCE_SQUARE\":\"M44.928-59.831q4.284 0 7.326 3.042t3.042 7.326v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56zm-26.964 13.212h-13.356v28.332h13.752q4.212 0 7.092-2.07t2.88-6.138q0-5.688-5.148-7.2 3.852-1.872 3.852-5.904 0-2.052-.702-3.474t-2.034-2.178-2.844-1.062-3.492-.306zm-.792 11.448h-6.336v-6.624h5.868q4.284 0 4.284 3.24 0 3.384-3.816 3.384zm.324 12.06h-6.66v-7.812h6.804q4.464 0 4.464 4.068 0 3.744-4.608 3.744zm23.4 1.152q-2.448 0-3.744-1.368t-1.296-3.852h14.796q.036-.36.036-1.08 0-4.752-2.682-7.938t-7.326-3.186q-4.608 0-7.56 3.096t-2.952 7.776q0 4.86 2.844 7.812t7.668 2.952q7.38 0 9.612-6.876h-4.968q-.396 1.224-1.71 1.944t-2.718.72zm-.36-13.176q4.068 0 4.464 4.392h-9.144q.144-2.016 1.404-3.204t3.276-1.188zm-5.832-9.576h11.484v2.772h-11.484v-2.772z\",\"STEAM\":\"M56.952-43.487q0 3.636-2.574 6.21t-6.21 2.574-6.21-2.574-2.574-6.21 2.574-6.21 6.21-2.574 6.21 2.574 2.574 6.21zm-27.72 26.712q0-3.744-2.628-6.372t-6.372-2.628q-.972 0-1.944.216l3.744 1.512q2.772 1.116 3.942 3.834t.054 5.454q-1.116 2.772-3.852 3.924t-5.472.036q-.756-.288-2.232-.882t-2.196-.882q1.152 2.16 3.276 3.474t4.68 1.314q3.744 0 6.372-2.628t2.628-6.372zm29.88-26.676q0-4.536-3.222-7.758t-7.758-3.222q-4.572 0-7.794 3.222t-3.222 7.758q0 4.572 3.222 7.776t7.794 3.204q4.536 0 7.758-3.204t3.222-7.776zm5.4 0q0 6.804-4.806 11.592t-11.574 4.788l-15.732 11.484q-.432 4.644-3.924 7.848t-8.244 3.204q-4.356 0-7.704-2.736t-4.248-6.912l-8.28-3.312v-15.444l14.004 5.652q2.844-1.728 6.228-1.728.468 0 1.26.072l10.224-14.652q.072-6.732 4.878-11.484t11.538-4.752q6.768 0 11.574 4.806t4.806 11.574z\",\"STEAM_SQUARE\":\"M44.712-41.147q0-2.88-2.052-4.914t-4.932-2.034-4.914 2.052-2.034 4.896q0 2.88 2.034 4.914t4.914 2.034 4.932-2.034 2.052-4.914zm-21.96 21.168q0 2.988-2.088 5.058t-5.04 2.07q-2.016 0-3.708-1.044t-2.592-2.772q1.872.72 3.528 1.44 2.16.864 4.32-.054t3.06-3.114q.864-2.16-.054-4.32t-3.114-3.024l-2.952-1.188q.792-.18 1.512-.18 2.952 0 5.04 2.07t2.088 5.058zm32.544-29.484v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-5.508l6.192 2.484q.72 3.312 3.366 5.472t6.066 2.16q3.744 0 6.516-2.52t3.132-6.228l12.42-9.072q5.4 0 9.198-3.798t3.798-9.162q0-5.4-3.798-9.198t-9.198-3.798q-5.328 0-9.108 3.762t-3.852 9.09l-8.1 11.592q-.324-.036-1.008-.036-2.7 0-4.932 1.332l-10.692-4.284v-16.848q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326zm-8.892 8.388q0 3.6-2.556 6.138t-6.156 2.538-6.138-2.538-2.538-6.138 2.538-6.156 6.138-2.556q3.636 0 6.174 2.538t2.538 6.174z\",\"RECYCLE\":\"M30.096-22.355l-.54 13.248-.072.792-15.12-1.044q-1.296-.108-2.412-1.134t-1.692-2.358q-.396-.972-.522-1.98t.144-2.34.432-1.98.774-2.304.684-1.908q2.808.432 18.324 1.008zm-13.932-21.096l6.48 13.644-5.292-3.312q-2.268 2.592-4.014 5.202t-2.61 4.5-1.422 3.402-.666 2.268l-.144.756-6.84-12.852q-.612-.936-.648-2.016t.216-1.692l.288-.648q1.26-2.268 4.104-6.768l-5.04-3.096zm44.316 18.612l-6.768 12.924q-.432 1.044-1.314 1.674t-1.566.738l-.648.144q-2.556.252-7.884.432l.288 5.904-8.28-13.212 7.596-13.032.252 6.228q6.12.576 10.188.18t6.12-1.188zm-28.26-33.264q-1.692 2.268-9.54 15.66l-11.412-6.732-.684-.432 8.1-12.816q.72-1.116 2.16-1.62t2.88-.36q.864.072 1.746.432t1.512.756 1.494 1.188 1.296 1.242 1.296 1.422 1.152 1.26zm23.58 11.052l7.632 13.068q.648 1.332.45 2.736t-.99 2.664q-.468.72-1.188 1.332t-1.368 1.008-1.746.792-1.692.576-1.854.504-1.656.432q-1.224-2.592-9.54-15.696l11.268-7.02zm-5.148-8.136l5.112-2.988-7.92 13.428-15.084-.72 5.436-3.096q-1.224-3.204-2.7-5.976t-2.718-4.446-2.322-2.88-1.692-1.674l-.612-.468 14.58.036q1.116-.108 2.088.378t1.404 1.026l.396.54q1.404 2.196 4.032 6.84z\",\"CAR\":\"M17.28-25.271q0-2.376-1.692-4.068t-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068zm1.296-11.52h36.576l-3.204-12.852q-.072-.288-.504-.63t-.756-.342h-27.648q-.324 0-.756.342t-.504.63zm49.392 11.52q0-2.376-1.692-4.068t-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068zm5.76-3.456v13.824q0 .504-.324.828t-.828.324h-3.456v4.608q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-4.608h-36.864v4.608q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-4.608h-3.456q-.504 0-.828-.324t-.324-.828v-13.824q0-3.348 2.358-5.706t5.706-2.358h1.008l3.78-15.084q.828-3.384 3.744-5.67t6.444-2.286h27.648q3.528 0 6.444 2.286t3.744 5.67l3.78 15.084h1.008q3.348 0 5.706 2.358t2.358 5.706z\",\"TAXI\":\"M65.664-32.183q3.348 0 5.706 2.358t2.358 5.706v13.824q0 .504-.324.828t-.828.324h-3.456v2.304q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-2.304h-36.864v2.304q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896v-2.304h-3.456q-.504 0-.828-.324t-.324-.828v-13.824q0-3.348 2.358-5.706t5.706-2.358h1.008l3.78-15.084q.828-3.384 3.744-5.67t6.444-2.286h4.608v-8.064q0-.504.324-.828t.828-.324h16.128q.504 0 .828.324t.324.828v8.064h4.608q3.528 0 6.444 2.286t3.744 5.67l3.78 15.084h1.008zm-54.144 17.28q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm7.056-17.28h36.576l-3.204-12.852q-.072-.288-.504-.63t-.756-.342h-27.648q-.324 0-.756.342t-.504.63zm43.632 17.28q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692z\",\"TREE\":\"M54.144-11.447q0 .936-.684 1.62t-1.62.684h-16.632q.036.612.216 3.15t.18 3.906q0 .9-.648 1.53t-1.548.63h-11.52q-.9 0-1.548-.63t-.648-1.53q0-1.368.18-3.906t.216-3.15h-16.632q-.936 0-1.62-.684t-.684-1.62.684-1.62l14.472-14.508h-8.244q-.936 0-1.62-.684t-.684-1.62.684-1.62l14.472-14.508h-7.092q-.936 0-1.62-.684t-.684-1.62.684-1.62l13.824-13.824q.684-.684 1.62-.684t1.62.684l13.824 13.824q.684.684.684 1.62t-.684 1.62-1.62.684h-7.092l14.472 14.508q.684.684.684 1.62t-.684 1.62-1.62.684h-8.244l14.472 14.508q.684.684.684 1.62z\",\"SPOTIFY\":\"M40.572-20.879q0-1.152-1.08-1.836-6.948-4.14-16.092-4.14-4.788 0-10.332 1.224-1.512.324-1.512 1.872 0 .72.486 1.242t1.278.522q.18 0 1.332-.288 4.752-.972 8.748-.972 8.136 0 14.292 3.708.684.396 1.188.396.684 0 1.188-.486t.504-1.242zm3.456-7.74q0-1.44-1.26-2.196-8.532-5.076-19.728-5.076-5.508 0-10.908 1.512-1.728.468-1.728 2.304 0 .9.63 1.53t1.53.63q.252 0 1.332-.288 4.392-1.188 9.036-1.188 10.044 0 17.568 4.464.864.468 1.368.468.9 0 1.53-.63t.63-1.53zm3.888-8.928q0-1.692-1.44-2.52-4.536-2.628-10.548-3.978t-12.348-1.35q-7.344 0-13.104 1.692-.828.252-1.386.918t-.558 1.746q0 1.116.738 1.872t1.854.756q.396 0 1.44-.288 4.788-1.332 11.052-1.332 5.724 0 11.142 1.224t9.126 3.42q.756.432 1.44.432 1.044 0 1.818-.738t.774-1.854zm7.38 5.364q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"DEVIANTART\":\"M36.864-53.531l-10.908 20.952.864 1.116h10.044v14.94h-18.252l-1.584 1.08-5.112 9.828-1.08 1.08h-10.836v-10.908l10.908-20.988-.864-1.08h-10.044v-14.94h18.252l1.584-1.08 5.112-9.828 1.08-1.08h10.836v10.908z\",\"SOUNDCLOUD\":\"M28.224-15.047l.576-8.676-.576-18.828q-.036-.36-.27-.612t-.594-.252q-.324 0-.576.252t-.252.612l-.504 18.828.504 8.676q.036.36.27.594t.558.234q.792 0 .864-.828zm10.656-1.044l.396-7.596-.432-21.096q0-.576-.468-.864-.288-.18-.576-.18t-.576.18q-.468.288-.468.864l-.036.216-.36 20.844q0 .036.396 8.496v.036q0 .36.216.612.324.396.828.396.396 0 .72-.324.324-.252.324-.72zm-37.62-12.24l.72 4.608-.72 4.536q-.072.324-.324.324t-.324-.324l-.612-4.536.612-4.608q.072-.324.324-.324t.324.324zm3.096-2.844l.936 7.452-.936 7.308q-.072.324-.36.324-.324 0-.324-.36l-.828-7.272.828-7.452q0-.324.324-.324.288 0 .36.324zm10.08 16.308zm-6.768-17.676l.9 8.82-.9 8.532q0 .396-.396.396-.36 0-.432-.396l-.756-8.532.756-8.82q.072-.432.432-.432.396 0 .396.432zm3.384-.252l.828 9.072-.828 8.784q-.072.468-.504.468-.468 0-.468-.468l-.756-8.784.756-9.072q0-.468.468-.468.432 0 .504.468zm3.384.648l.756 8.424-.756 8.856q-.072.576-.576.576-.216 0-.378-.162t-.162-.414l-.72-8.856.72-8.424q0-.216.162-.378t.378-.162q.504 0 .576.54zm13.788 17.1zm-10.404-22.356l.756 13.68-.756 8.856q0 .252-.18.45t-.432.198q-.576 0-.648-.648l-.648-8.856.648-13.68q.072-.648.648-.648.252 0 .432.198t.18.45zm3.384-3.096l.684 16.848-.684 8.784q0 .288-.198.486t-.486.198q-.648 0-.72-.684l-.576-8.784.576-16.848q.072-.684.72-.684.288 0 .486.198t.198.486zm3.528-1.44l.648 18.216-.648 8.712q-.072.756-.792.756-.684 0-.756-.756l-.576-8.712.576-18.216q0-.324.234-.558t.522-.234q.324 0 .54.234t.252.558zm14.112 26.712zm-7.128-26.856l.54 18.36-.54 8.604q0 .36-.27.63t-.63.27-.612-.252-.288-.648l-.504-8.604.504-18.36q0-.396.27-.648t.63-.252.63.252.27.648zm3.564.684l.504 17.712-.504 8.496q0 .396-.288.684t-.684.288-.684-.288-.324-.684l-.432-8.496.432-17.712q.036-.432.324-.72t.684-.288.666.288.306.72zm7.632 17.712l-.504 8.316q0 .468-.324.792t-.792.324-.792-.324-.36-.792l-.216-4.104-.216-4.212.432-22.896v-.108q.072-.54.432-.864.324-.252.72-.252.288 0 .54.18.504.288.576.936zm40.032-.684q0 4.212-2.988 7.182t-7.2 2.97h-28.296q-.468-.072-.792-.396t-.324-.792v-32.364q0-.828 1.008-1.188 3.06-1.224 6.516-1.224 7.02 0 12.168 4.734t5.76 11.646q1.908-.792 3.96-.792 4.212 0 7.2 2.988t2.988 7.236z\",\"DATABASE\":\"M27.648-36.791q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0 27.648q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0-13.824q8.532 0 15.948-1.548t11.7-4.572v6.12q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-6.12q4.284 3.024 11.7 4.572t15.948 1.548zm0-41.472q7.488 0 13.86 1.242t10.08 3.366 3.708 4.608v4.608q0 2.484-3.708 4.608t-10.08 3.366-13.86 1.242-13.86-1.242-10.08-3.366-3.708-4.608v-4.608q0-2.484 3.708-4.608t10.08-3.366 13.86-1.242z\",\"FILE_PDF_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-18.504-21.348q1.188.936 3.024 2.016 2.124-.252 4.212-.252 5.292 0 6.372 1.764.576.792.072 1.872l-.036.072-.072.072v.036q-.216 1.368-2.556 1.368-1.728 0-4.14-.72t-4.68-1.908q-7.956.864-14.112 2.988-5.508 9.432-8.712 9.432-.54 0-1.008-.252l-.864-.432-.216-.18q-.36-.36-.216-1.296.324-1.44 2.016-3.294t4.752-3.474q.504-.324.828.216.072.072.072.144 1.872-3.06 3.852-7.092 2.448-4.896 3.744-9.432-.864-2.952-1.098-5.742t.234-4.59q.396-1.44 1.512-1.44h.792q.828 0 1.26.54.648.756.324 2.448-.072.216-.144.288.036.108.036.288v1.08q-.072 4.428-.504 6.912 1.98 5.904 5.256 8.568zm-20.736 14.796q1.872-.864 4.932-5.688-1.836 1.44-3.15 3.024t-1.782 2.664zm14.328-33.12q-.54 1.512-.072 4.752.036-.252.252-1.584 0-.108.252-1.548.036-.144.144-.288l-.036-.072-.018-.054-.018-.054q-.036-.792-.468-1.296l-.036.072v.072zm-4.464 23.796q4.86-1.944 10.224-2.916-.072-.036-.468-.342t-.576-.486q-2.736-2.412-4.572-6.336-.972 3.096-2.988 7.092-1.08 2.016-1.62 2.988zm23.256-.576q-.864-.864-5.04-.864 2.736 1.008 4.464 1.008.504 0 .648-.036l-.072-.108z\",\"FILE_WORD_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-42.3-32.256v3.852h2.52l5.904 23.796h5.724l4.608-17.46q.252-.72.36-1.656.072-.576.072-.864h.144l.108.864q.036.108.126.72t.198.936l4.608 17.46h5.724l5.904-23.796h2.52v-3.852h-10.8v3.852h3.24l-3.564 15.768q-.18.72-.252 1.656l-.072.756h-.144l-.108-.756q-.036-.18-.144-.756t-.18-.9l-5.184-19.62h-4.104l-5.184 19.62q-.072.324-.162.882t-.126.774l-.144.756h-.144l-.072-.756q-.072-.936-.252-1.656l-3.564-15.768h3.24v-3.852h-10.8z\",\"FILE_EXCEL_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-35.244-8.424v3.816h10.116v-3.816h-2.7l3.708-5.796q.18-.252.36-.594t.27-.486.126-.144h.072q.036.144.18.36.072.144.162.27t.216.288.234.306l3.852 5.796h-2.736v3.816h10.476v-3.816h-2.448l-6.912-9.828 7.02-10.152h2.412v-3.852h-10.044v3.852h2.664l-3.708 5.724q-.144.252-.36.594t-.324.486l-.072.108h-.072q-.036-.144-.18-.36-.216-.396-.612-.828l-3.816-5.724h2.736v-3.852h-10.44v3.852h2.448l6.804 9.792-6.984 10.188h-2.448z\",\"FILE_POWERPOINT_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-35.712-8.424v3.816h11.772v-3.816h-3.348v-6.012h4.932q2.736 0 4.248-.54 2.412-.828 3.834-3.132t1.422-5.256q0-2.916-1.332-5.076t-3.6-3.132q-1.728-.684-4.68-.684h-13.248v3.852h3.312v19.98h-3.312zm12.708-10.08h-4.284v-9.648h4.32q1.872 0 2.988.648 2.016 1.188 2.016 4.14 0 3.204-2.232 4.32-1.116.54-2.808.54z\",\"FILE_PICTURE_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-4.608-16.128v11.52h-36.864v-6.912l6.912-6.912 4.608 4.608 13.824-13.824zm-29.952-6.912q-2.88 0-4.896-2.016t-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896-2.016 4.896-4.896 2.016z\",\"FILE_ZIP_O\":\"M23.04-50.615v-4.608h-4.608v4.608h4.608zm4.608 4.608v-4.608h-4.608v4.608h4.608zm-4.608 4.608v-4.608h-4.608v4.608h4.608zm4.608 4.608v-4.608h-4.608v4.608h4.608zm25.2-13.968q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-4.608v4.608h-4.608v-4.608h-18.432v55.296h46.08zm-22.572-25.956l3.852 12.564q.288.972.288 1.872 0 2.988-2.61 4.95t-6.606 1.962-6.606-1.962-2.61-4.95q0-.9.288-1.872.756-2.268 4.32-14.256v-4.608h4.608v4.608h2.844q.792 0 1.404.468t.828 1.224zm-5.076 16.74q1.908 0 3.258-.684t1.35-1.62-1.35-1.62-3.258-.684-3.258.684-1.35 1.62 1.35 1.62 3.258.684z\",\"FILE_SOUND_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-28.368-29.304q.72.288.72 1.08v19.584q0 .792-.72 1.08-.288.072-.432.072-.432 0-.828-.324l-5.976-6.012h-4.716q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h4.716l5.976-6.012q.576-.54 1.26-.252zm15.012 24.804q1.116 0 1.8-.864 4.644-5.724 4.644-13.068t-4.644-13.068q-.576-.756-1.548-.864t-1.692.504q-.756.612-.846 1.566t.522 1.71q3.6 4.428 3.6 10.152t-3.6 10.152q-.612.756-.522 1.71t.846 1.53q.648.54 1.44.54zm-7.596-5.328q.972 0 1.692-.72 3.132-3.348 3.132-7.884t-3.132-7.884q-.648-.684-1.62-.72t-1.656.612-.72 1.602.648 1.674q1.872 2.052 1.872 4.716t-1.872 4.716q-.684.72-.648 1.674t.72 1.602q.72.612 1.584.612z\",\"FILE_VIDEO_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-23.04-32.256q1.872 0 3.24 1.368t1.368 3.24v13.824q0 1.872-1.368 3.24t-3.24 1.368h-13.824q-1.872 0-3.24-1.368t-1.368-3.24v-13.824q0-1.872 1.368-3.24t3.24-1.368h13.824zm17.712.072q.72.288.72 1.08v20.736q0 .792-.72 1.08-.288.072-.432.072-.504 0-.828-.324l-9.54-9.576v-3.24l9.54-9.576q.324-.324.828-.324.144 0 .432.072z\",\"FILE_CODE_O\":\"M52.848-50.759q1.008 1.008 1.728 2.736t.72 3.168v41.472q0 1.44-1.008 2.448t-2.448 1.008h-48.384q-1.44 0-2.448-1.008t-1.008-2.448v-57.6q0-1.44 1.008-2.448t2.448-1.008h32.256q1.44 0 3.168.72t2.736 1.728zm-15.984-8.784v13.536h13.536q-.36-1.044-.792-1.476l-11.268-11.268q-.432-.432-1.476-.792zm13.824 55.008v-36.864h-14.976q-1.44 0-2.448-1.008t-1.008-2.448v-14.976h-27.648v55.296h46.08zm-33.408-32.256q.288-.396.756-.45t.864.234l1.836 1.368q.396.288.45.756t-.234.864l-6.552 8.748 6.552 8.748q.288.396.234.864t-.45.756l-1.836 1.368q-.396.288-.864.234t-.756-.45l-8.136-10.836q-.504-.684 0-1.368zm28.872 10.836q.504.684 0 1.368l-8.136 10.836q-.288.396-.756.45t-.864-.234l-1.836-1.368q-.396-.288-.45-.756t.234-.864l6.552-8.748-6.552-8.748q-.288-.396-.234-.864t.45-.756l1.836-1.368q.396-.288.864-.234t.756.45zm-22.32 16.596q-.468-.072-.738-.468t-.198-.864l4.968-29.916q.072-.468.468-.738t.864-.198l2.268.36q.468.072.738.468t.198.864l-4.968 29.916q-.072.468-.468.738t-.864.198z\",\"VINE\":\"M53.892-34.667v7.128q-3.636.828-7.128.828-2.34 4.896-5.958 9.756t-6.534 7.758-4.608 3.834q-2.88 1.62-5.832-.108-1.008-.612-2.178-1.566t-3.06-3.006-3.69-4.626-3.87-6.624-3.798-8.784-3.294-11.322-2.538-14.04h10.188q.936 7.848 2.52 14.346t3.762 11.412 4.374 8.478 5.04 7.02q6.084-6.084 10.332-14.616-5.112-2.592-8.028-7.92t-2.916-11.988q0-6.912 3.744-11.322t10.224-4.41q6.408 0 9.828 3.798t3.42 10.71q0 5.724-2.088 10.296-.252.036-.702.108t-1.656.072-2.268-.216-2.232-.918-1.818-1.854q1.116-3.708 1.116-6.624 0-3.132-1.044-4.752t-2.844-1.62q-1.908 0-3.06 1.782t-1.152 5.058q0 6.696 3.78 10.566t9.612 3.87q2.232 0 4.356-.504z\",\"CODEPEN\":\"M7.776-22.355l21.708 14.472v-12.924l-12.024-8.028zm-2.232-5.184l6.948-4.644-6.948-4.644v9.288zm29.484 19.656l21.708-14.472-9.684-6.48-12.024 8.028v12.924zm-2.772-17.748l9.792-6.552-9.792-6.552-9.792 6.552zm-14.796-9.9l12.024-8.028v-12.924l-21.708 14.472zm34.56 3.348l6.948 4.644v-9.288zm-4.968-3.348l9.684-6.48-21.708-14.472v12.924zm17.46-6.48v19.656q0 1.476-1.224 2.304l-29.484 19.656q-.756.468-1.548.468t-1.548-.468l-29.484-19.656q-1.224-.828-1.224-2.304v-19.656q0-1.476 1.224-2.304l29.484-19.656q.756-.468 1.548-.468t1.548.468l29.484 19.656q1.224.828 1.224 2.304z\",\"JSFIDDLE\":\"M64.8-36.647q3.996 1.656 6.462 5.238t2.466 7.974q0 5.904-4.248 10.098t-10.26 4.194l-.414-.018-.378-.018h-43.812000000000005q-6.12-.36-10.368-4.518t-4.248-10.098q0-3.96 1.98-7.308t5.292-5.292q-.432-1.404-.432-2.952 0-4.14 2.952-7.056t7.164-2.916q3.42 0 6.192 2.088 2.7-5.544 8.01-8.928t11.754-3.384q5.976 0 11.016 2.898t7.974 7.866 2.934 10.836l-.018.648-.018.648zm-47.952 9.576q0 4.392 3.024 6.948t7.488 2.556q4.932 0 8.64-3.564-.576-.72-1.71-2.034t-1.566-1.818q-2.412 2.34-5.184 2.34-1.98 0-3.366-1.206t-1.386-3.15q0-1.908 1.386-3.132t3.294-1.224q1.584 0 3.042.756t2.628 1.98 2.34 2.7 2.484 2.952 2.772 2.7 3.492 1.98 4.374.756q4.356 0 7.362-2.574t3.006-6.858q0-4.356-3.024-6.912t-7.452-2.556q-5.148 0-8.676 3.492.504.576 1.062 1.224t1.242 1.44 1.044 1.224q2.376-2.304 5.112-2.304 1.872 0 3.312 1.188t1.44 3.024q0 2.052-1.332 3.294t-3.384 1.242q-1.548 0-2.97-.756t-2.592-1.98-2.358-2.7-2.502-2.952-2.79-2.7-3.474-1.98-4.266-.756q-4.392 0-7.452 2.538t-3.06 6.822z\",\"SUPPORT\":\"M32.256-64.439q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm0 4.608q-6.84 0-12.996 3.24l6.984 6.984q2.952-1.008 6.012-1.008t6.012 1.008l6.984-6.984q-6.156-3.24-12.996-3.24zm-24.408 40.644l6.984-6.984q-1.008-2.952-1.008-6.012t1.008-6.012l-6.984-6.984q-3.24 6.156-3.24 12.996t3.24 12.996zm24.408 14.652q6.84 0 12.996-3.24l-6.984-6.984q-2.952 1.008-6.012 1.008t-6.012-1.008l-6.984 6.984q6.156 3.24 12.996 3.24zm0-13.824q5.724 0 9.774-4.05t4.05-9.774-4.05-9.774-9.774-4.05-9.774 4.05-4.05 9.774 4.05 9.774 9.774 4.05zm17.424-7.812l6.984 6.984q3.24-6.156 3.24-12.996t-3.24-12.996l-6.984 6.984q1.008 2.952 1.008 6.012t-1.008 6.012z\",\"CIRCLE_O_NOTCH\":\"M63.36-32.183q0 6.336-2.466 12.096t-6.624 9.918-9.918 6.624-12.096 2.466-12.096-2.466-9.918-6.624-6.624-9.918-2.466-12.096q0-7.668 3.492-14.346t9.54-10.998 13.464-5.436v8.208q-7.956 1.62-13.194 7.956t-5.238 14.616q0 4.68 1.836 8.946t4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946q0-8.28-5.238-14.616t-13.194-7.956v-8.208q7.416 1.116 13.464 5.436t9.54 10.998 3.492 14.346z\",\"REBEL\":\"M.684-32.975q.288-7.812 4.176-14.616t10.98-11.448h.18l-.036.108q-.288.288-1.008 1.206t-1.872 2.754-2.16 3.978-1.602 4.878-.504 5.418 1.404 5.67 3.906 5.544q1.8 1.8 3.672 2.502t3.258.414 2.502-.846 1.692-1.17l.576-.576q1.404-1.836 1.908-4.194t.234-4.41-.756-3.852-.954-2.88l-.504-1.044q-.36-.9-1.098-1.782t-1.548-1.476-1.566-1.062-1.26-.684l-.468-.216 3.744-4.14q1.404.612 2.808 1.872t2.124 2.196l.684.972q.036-1.728-.666-3.726t-1.458-3.15l-.72-1.116 5.796-6.588 5.76 6.516q-1.188 1.656-1.89 3.69t-.81 3.258l-.144 1.188q.792-1.332 2.214-2.61t2.43-1.89l1.008-.612 3.708 4.14q-1.584.504-3.06 1.8t-2.16 2.34l-.684 1.044q-1.116 2.016-1.728 4.806t-.252 6.12 2.052 5.634q1.188 1.62 2.79 2.178t3.06.198 2.736-.954 2.07-1.206l.756-.576q2.16-1.908 3.474-4.14t1.746-4.374.36-4.374-.648-4.248-1.332-3.87-1.638-3.348-1.62-2.592-1.242-1.71l-.468-.612q-.504-.468-.252-.468l.36.108q1.44 1.044 2.25 1.656t2.232 1.8 2.304 2.088 2.106 2.34 1.998 2.772 1.638 3.168 1.368 3.708.846 4.212.378 4.896q.108 9.324-3.888 16.74t-11.232 11.556-16.416 4.14q-6.66 0-12.636-2.664t-10.206-7.128-6.624-10.548-2.178-12.708z\",\"GE\":\"M31.464-5.471v2.376q-7.488-.216-13.86-3.942t-10.188-9.918l2.088-1.224q1.044 1.764 2.628 3.564l2.34-2.052q5.328 6.048 13.248 7.632l-.612 3.096q2.34.432 4.356.468zm-21.528-19.08l-2.988 1.008q.792 2.16 1.764 4.032l-2.052 1.188q-3.528-6.48-3.528-13.86t3.528-13.86l2.052 1.188q-1.08 2.016-1.764 4.032l2.952 1.008q-1.26 3.6-1.26 7.632 0 3.924 1.296 7.632zm45.072 6.372l2.088 1.224q-3.816 6.192-10.188 9.918t-13.86 3.942v-2.376q2.016-.036 4.356-.468l-.612-3.096q7.92-1.584 13.248-7.632l2.34 2.052q1.584-1.8 2.628-3.564zm-5.436-19.944l-8.388 2.88q.504 1.512.504 3.06t-.504 3.06l8.352 2.88q-1.116 3.312-3.528 6.084l-6.66-5.832q-2.052 2.412-5.292 3.06l1.728 8.676q-1.872.36-3.528.36t-3.528-.36l1.728-8.676q-3.24-.648-5.292-3.06l-6.66 5.832q-2.412-2.772-3.528-6.084l8.352-2.88q-.504-1.512-.504-3.06t.504-3.06l-8.388-2.88q1.188-3.348 3.564-6.084l6.66 5.832q2.124-2.448 5.292-3.096l-1.728-8.64q1.584-.36 3.528-.36t3.528.36l-1.728 8.64q3.168.648 5.292 3.096l6.66-5.832q2.376 2.736 3.564 6.084zm-18.108-23.148v2.376q-2.34.072-4.356.468l.612 3.096q-7.92 1.512-13.248 7.596l-2.34-2.016q-1.368 1.512-2.628 3.528l-2.052-1.188q3.816-6.192 10.152-9.918t13.86-3.942zm29.916 29.088q0 7.38-3.528 13.86l-2.052-1.188q.972-1.872 1.764-4.032l-2.988-1.008q1.296-3.708 1.296-7.632 0-4.032-1.26-7.632l2.952-1.008q-.684-2.016-1.764-4.032l2.052-1.188q3.528 6.48 3.528 13.86zm-4.32-15.228l-2.052 1.188q-1.26-2.016-2.628-3.528l-2.34 2.016q-5.328-6.084-13.248-7.596l.612-3.096q-2.016-.396-4.356-.468v-2.376q7.524.216 13.86 3.942t10.152 9.918zm5.868 15.228q0-6.228-2.43-11.916t-6.534-9.792-9.792-6.534-11.916-2.43-11.916 2.43-9.792 6.534-6.534 9.792-2.43 11.916 2.43 11.916 6.534 9.792 9.792 6.534 11.916 2.43 11.916-2.43 9.792-6.534 6.534-9.792 2.43-11.916zm1.584 0q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"GIT_SQUARE\":\"M20.952-17.351q0 2.376-3.348 2.376-3.852 0-3.852-2.268 0-2.304 3.528-2.304 3.672 0 3.672 2.196zm-1.296-16.776q0 3.06-2.664 3.06-2.772 0-2.772-3.024 0-3.24 2.772-3.24 1.296 0 1.98.918t.684 2.286zm5.976-2.7v-4.5q-2.808 1.044-4.86 1.044-1.8-1.044-3.96-1.044-3.096 0-5.22 2.052t-2.124 5.148q0 1.8 1.062 3.672t2.646 2.412v.108q-1.368.612-1.368 3.06 0 1.908 1.476 2.772v.108q-4.068 1.332-4.068 5.004 0 1.62.72 2.826t1.944 1.836 2.592.918 2.916.288q8.064 0 8.064-6.768 0-2.412-1.728-3.564t-4.536-1.656q-.972-.18-1.854-.738t-.882-1.422q0-1.584 1.764-1.872 2.772-.54 4.392-2.52t1.62-4.824q0-.864-.36-1.872 1.332-.324 1.764-.468zm2.124 15.084h4.932q-.072-.972-.072-2.952v-13.932q0-1.656.072-2.484h-4.932q.108.828.108 2.556v14.112q0 1.8-.108 2.7zm18.324-.576v-4.356q-1.08.756-2.448.756-1.908 0-1.908-2.952v-8.1h1.872q.324 0 .954.036t.954.036v-4.212h-3.78q0-2.952.108-3.672h-5.04q.144.864.144 1.98v1.692h-2.16v4.212l1.332-.108.396.018.432.018v.072h-.072v7.812q0 1.332.09 2.304t.414 2.034.882 1.746 1.566 1.116 2.376.432q2.304 0 3.888-.864zm-12.816-25.416q0-1.296-.864-2.286t-2.16-.99-2.178.972-.882 2.304q0 1.296.9 2.25t2.16.954 2.142-.972.882-2.232zm22.032-1.728v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"GIT\":\"M21.42-9.935q0-3.6-5.94-3.6-5.688 0-5.688 3.744 0 3.636 6.192 3.636 5.436 0 5.436-3.78zm-2.124-27.18q0-2.196-1.08-3.672t-3.204-1.476q-4.464 0-4.464 5.22 0 4.86 4.464 4.86 4.284 0 4.284-4.932zm9.684-11.664v7.272q-1.296.432-2.844.792.576 1.548.576 3.024 0 4.572-2.628 7.794t-7.092 4.05q-1.44.288-2.142.972t-.702 2.088q0 1.116.81 1.854t2.088 1.152 2.826.792 3.096.918 2.826 1.35 2.088 2.304.81 3.546q0 10.944-13.068 10.944-2.484 0-4.68-.45t-4.176-1.476-3.15-2.952-1.17-4.59q0-5.94 6.552-8.1v-.144q-2.412-1.476-2.412-4.536 0-3.924 2.268-4.932v-.144q-2.592-.864-4.302-3.906t-1.71-5.958q0-5.004 3.42-8.334t8.46-3.33q3.456 0 6.408 1.692 3.528 0 7.848-1.692zm11.448 31.716h-7.992q.144-1.62.144-4.824v-21.924q0-3.384-.144-4.608h7.992q-.144 1.188-.144 4.464v22.068q0 3.204.144 4.824zm21.636-7.992v7.056q-2.556 1.404-6.264 1.404-2.232 0-3.852-.72t-2.52-1.8-1.422-2.808-.666-3.312-.144-3.708v-12.636h.072v-.144q-.252 0-.684-.036t-.648-.036q-.756 0-2.124.216v-6.84h3.456v-2.736q0-1.944-.216-3.204h8.172q-.216 1.476-.216 5.94h6.156v6.84q-.54 0-1.566-.072t-1.53-.072h-3.06v13.14q0 4.716 3.132 4.716 2.196 0 3.924-1.188zm-20.736-34.092q0 2.088-1.404 3.654t-3.456 1.566q-2.088 0-3.528-1.566t-1.44-3.654q0-2.124 1.422-3.708t3.546-1.584q2.088 0 3.474 1.602t1.386 3.69z\",\"YC_SQUARE\":\"M29.124-28.295l9.576-17.964h-4.032l-5.652 11.232q-.864 1.728-1.584 3.312l-1.512-3.312-5.58-11.232h-4.32l9.468 17.748v11.664h3.636v-11.448zm26.172-21.168v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TENCENT_WEIBO\":\"M30.312-43.847q0 2.88-2.052 4.914t-4.896 2.034q-2.16 0-3.996-1.26-2.232 2.412-4.14 5.256-8.892 13.356-7.272 30.924.036.792-.45 1.386t-1.242.666h-.18q-.72 0-1.26-.486t-.612-1.206q-.504-4.536-.126-8.91t1.062-7.812 1.944-6.696 2.484-5.598 2.664-4.5q2.196-3.24 4.752-5.94-.576-1.26-.576-2.772 0-2.88 2.034-4.914t4.914-2.034 4.914 2.034 2.034 4.914zm13.716.396q0 5.688-2.808 10.512t-7.65 7.632-10.53 2.808q-2.304 0-4.716-.504-.756-.18-1.17-.846t-.234-1.422q.18-.72.828-1.134t1.404-.27q1.836.468 3.888.468 3.492 0 6.696-1.368t5.508-3.672 3.672-5.508 1.368-6.696-1.368-6.696-3.672-5.508-5.508-3.672-6.696-1.368-6.696 1.368-5.508 3.672-3.672 5.508-1.368 6.696q0 4.104 1.872 7.848.36.72.126 1.44t-.918 1.08-1.422.108-1.098-.936q-2.304-4.428-2.304-9.54 0-4.284 1.674-8.172t4.482-6.696 6.696-4.464 8.136-1.656q5.688 0 10.53 2.808t7.65 7.65 2.808 10.53z\",\"QQ\":\"M9.72-35.423q-.288-.684-.288-1.872 0-.72.396-1.764t.864-1.62q-.036-.792.27-1.908t.81-1.548q0-5.004 3.33-10.386t7.83-7.542q5.004-2.376 11.664-2.376 4.788 0 9.576 1.98 1.764.756 3.24 1.728t2.556 2.016 1.98 2.448 1.512 2.664 1.17 3.042.918 3.222.792 3.528l.036.18q1.98 2.988 1.98 5.4 0 .504-.324 1.44t-.324 1.368l.054.126.126.18.072.126q2.772 4.104 4.338 7.722t1.566 7.506q0 1.548-.702 3.6t-1.998 2.052q-.324 0-.702-.27t-.684-.63-.684-.936-.576-.954-.486-.936-.324-.63l-.108-.036-.18.144q-2.124 5.544-4.752 8.028.72.72 2.214 1.386t2.484 1.494 1.278 2.34q-.072.144-.144.576t-.252.648q-2.304 3.492-10.872 3.492-1.908 0-3.978-.324t-3.528-.72-3.762-1.08q-.54-.18-.828-.252-.504-.144-1.656-.162t-1.44-.054q-1.476 1.62-4.59 2.34t-6.066.72q-1.26 0-2.484-.054t-3.348-.324-3.636-.738-2.682-1.44-1.17-2.304q0-1.44.36-2.142t1.476-1.746q.396-.072 1.458-.468t1.782-.432q.144 0 .504-.072.072-.072.072-.144l-.072-.108q-1.728-.396-3.888-3.798t-2.628-5.634l-.18-.108q-.144 0-.432.72-.648 1.476-1.962 2.682t-2.79 1.35h-.036q-.144 0-.216-.162t-.18-.198q-.828-1.944-.828-3.6 0-9.9 9.072-16.776z\",\"WEIXIN\":\"M20.88-47.843q0-1.476-.9-2.376t-2.376-.9q-1.548 0-2.736.918t-1.188 2.358q0 1.404 1.188 2.322t2.736.918q1.476 0 2.376-.882t.9-2.358zm26.748 18.252q0-1.008-.918-1.8t-2.358-.792q-.972 0-1.782.81t-.81 1.782q0 1.008.81 1.818t1.782.81q1.44 0 2.358-.792t.918-1.836zm-8.496-18.252q0-1.476-.882-2.376t-2.358-.9q-1.548 0-2.736.918t-1.188 2.358q0 1.404 1.188 2.322t2.736.918q1.476 0 2.358-.882t.882-2.358zm22.86 18.252q0-1.008-.936-1.8t-2.34-.792q-.972 0-1.782.81t-.81 1.782q0 1.008.81 1.818t1.782.81q1.404 0 2.34-.792t.936-1.836zm-9.576-14.292q-1.116-.144-2.52-.144-6.084 0-11.196 2.772t-8.046 7.506-2.934 10.35q0 2.808.828 5.472-1.26.108-2.448.108-.936 0-1.8-.054t-1.98-.234-1.602-.252-1.962-.378-1.8-.378l-9.108 4.572 2.592-7.848q-10.44-7.308-10.44-17.64 0-6.084 3.51-11.196t9.504-8.046 13.086-2.934q6.336 0 11.97 2.376t9.432 6.57 4.914 9.378zm21.312 20.196q0 4.212-2.466 8.046t-6.678 6.966l1.98 6.516-7.164-3.924q-5.4 1.332-7.848 1.332-6.084 0-11.196-2.538t-8.046-6.894-2.934-9.504 2.934-9.504 8.046-6.894 11.196-2.538q5.796 0 10.908 2.538t8.19 6.912 3.078 9.486z\",\"SEND\":\"M63.504-64.043q1.188.864.972 2.304l-9.216 55.296q-.18 1.044-1.152 1.62-.504.288-1.116.288-.396 0-.864-.18l-16.308-6.66-8.712 10.62q-.648.828-1.764.828-.468 0-.792-.144-.684-.252-1.098-.846t-.414-1.314v-12.564l31.104-38.124-38.484 33.3-14.22-5.832q-1.332-.504-1.44-1.98-.072-1.44 1.152-2.124l59.904-34.56q.54-.324 1.152-.324.72 0 1.296.396z\",\"SEND_O\":\"M63.504-64.043q1.188.864.972 2.304l-9.216 55.296q-.18 1.044-1.152 1.62-.504.288-1.116.288-.396 0-.864-.18l-18.972-7.74-10.728 11.772q-.648.756-1.692.756-.504 0-.828-.144-.684-.252-1.08-.846t-.396-1.314v-16.272l-16.992-6.948q-1.332-.504-1.44-1.98-.108-1.404 1.152-2.124l59.904-34.56q1.26-.756 2.448.072zm-12.312 53.964l7.956-47.628-51.624 29.772 12.096 4.932 31.068-23.004-17.208 28.692z\",\"HISTORY\":\"M55.296-32.183q0 5.616-2.196 10.728t-5.904 8.82-8.82 5.904-10.728 2.196q-6.192 0-11.772-2.61t-9.504-7.362q-.252-.36-.234-.81t.306-.738l4.932-4.968q.36-.324.9-.324.576.072.828.432 2.628 3.42 6.444 5.292t8.1 1.872q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458q-3.528 0-6.768 1.278t-5.76 3.654l4.932 4.968q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-16.128q-.936 0-1.62-.684t-.684-1.62v-16.128q0-1.512 1.44-2.124 1.404-.612 2.484.504l4.68 4.644q3.852-3.636 8.802-5.634t10.242-1.998q5.616 0 10.728 2.196t8.82 5.904 5.904 8.82 2.196 10.728zm-23.04-10.368v16.128q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-12.672q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828z\",\"CIRCLE_THIN\":\"M27.648-55.223q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"HEADER\":\"M60.552-4.535q-1.584 0-4.77-.126t-4.806-.126q-1.584 0-4.752.126t-4.752.126q-.864 0-1.332-.738t-.468-1.638q0-1.116.612-1.656t1.404-.612 1.836-.252 1.62-.54q1.188-.756 1.188-5.04l-.036-14.076q0-.756-.036-1.116-.468-.144-1.8-.144h-24.3q-1.368 0-1.836.144-.036.36-.036 1.116l-.036 13.356q0 5.112 1.332 5.904.576.36 1.728.468t2.052.126 1.62.54.72 1.638q0 .936-.45 1.728t-1.314.792q-1.692 0-5.022-.126t-4.986-.126q-1.548 0-4.608.126t-4.572.126q-.828 0-1.278-.756t-.45-1.62q0-1.08.558-1.62t1.296-.63 1.71-.27 1.512-.54q1.188-.828 1.188-5.148l-.036-2.052v-29.268q0-.108.018-.936t0-1.314-.054-1.386-.126-1.512-.234-1.314-.396-1.134-.576-.648q-.54-.36-1.62-.432t-1.908-.072-1.476-.504-.648-1.62q0-.936.432-1.728t1.296-.792q1.656 0 4.986.126t4.986.126q1.512 0 4.554-.126t4.554-.126q.9 0 1.35.792t.45 1.728q0 1.08-.612 1.566t-1.386.522-1.782.144-1.548.468q-1.26.756-1.26 5.76l.036 11.52q0 .756.036 1.152.468.108 1.404.108h25.164q.9 0 1.368-.108.036-.396.036-1.152l.036-11.52q0-5.004-1.26-5.76-.648-.396-2.106-.45t-2.376-.468-.918-1.782q0-.936.45-1.728t1.35-.792q1.584 0 4.752.126t4.752.126q1.548 0 4.644-.126t4.644-.126q.9 0 1.35.792t.45 1.728q0 1.08-.63 1.584t-1.44.522-1.854.108-1.584.45q-1.26.828-1.26 5.796l.036 33.948q0 4.284 1.224 5.04.576.36 1.656.486t1.926.162 1.494.558.648 1.602q0 .936-.432 1.728t-1.296.792z\",\"PARAGRAPH\":\"M46.008-57.635v2.628q0 1.044-.666 2.196t-1.53 1.152q-1.8 0-1.944.036-.936.216-1.152 1.116-.108.396-.108 2.304v41.472q0 .9-.648 1.548t-1.548.648h-3.888q-.9 0-1.548-.648t-.648-1.548v-43.848h-5.148v43.848q0 .9-.63 1.548t-1.566.648h-3.888q-.936 0-1.566-.648t-.63-1.548v-17.856q-5.292-.432-8.82-2.124-4.536-2.088-6.912-6.444-2.304-4.212-2.304-9.324 0-5.976 3.168-10.296 3.168-4.248 7.524-5.724 3.996-1.332 15.012-1.332h17.244q.9 0 1.548.648t.648 1.548z\",\"SLIDERS\":\"M12.672-13.751v4.608h-12.672v-4.608h12.672zm12.672-4.608q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm5.76-13.824v4.608h-31.104v-4.608h31.104zm-23.04-18.432v4.608h-8.064v-4.608h8.064zm47.232 36.864v4.608h-26.496v-4.608h26.496zm-34.56-41.472q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm23.04 18.432q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h9.216zm11.52 4.608v4.608h-8.064v-4.608h8.064zm0-18.432v4.608h-31.104v-4.608h31.104z\",\"SHARE_ALT\":\"M43.776-27.575q4.788 0 8.154 3.366t3.366 8.154-3.366 8.154-8.154 3.366-8.154-3.366-3.366-8.154q0-.432.072-1.224l-12.96-6.48q-3.312 3.096-7.848 3.096-4.788 0-8.154-3.366t-3.366-8.154 3.366-8.154 8.154-3.366q4.536 0 7.848 3.096l12.96-6.48q-.072-.792-.072-1.224 0-4.788 3.366-8.154t8.154-3.366 8.154 3.366 3.366 8.154-3.366 8.154-8.154 3.366q-4.536 0-7.848-3.096l-12.96 6.48q.072.792.072 1.224t-.072 1.224l12.96 6.48q3.312-3.096 7.848-3.096z\",\"SHARE_ALT_SQUARE\":\"M46.08-21.419q0-3.168-2.25-5.436t-5.418-2.268q-3.024 0-5.22 2.088l-8.676-4.32q.072-.576.072-.828t-.072-.828l8.676-4.32q2.196 2.088 5.22 2.088 3.168 0 5.418-2.268t2.25-5.436-2.25-5.418-5.418-2.25-5.436 2.25-2.268 5.418q0 .252.072.828l-8.676 4.32q-2.232-2.052-5.22-2.052-3.168 0-5.418 2.25t-2.25 5.418 2.25 5.418 5.418 2.25q2.988 0 5.22-2.052l8.676 4.32q-.072.576-.072.828 0 3.168 2.268 5.418t5.436 2.25 5.418-2.25 2.25-5.418zm9.216-28.044v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"BOMB\":\"M20.556-43.235q-.36-.9-1.224-1.26t-1.764 0q-3.888 1.584-6.876 4.572t-4.572 6.876q-.36.9 0 1.764t1.26 1.224q.468.18.864.18 1.512 0 2.16-1.44 1.224-3.024 3.546-5.346t5.346-3.546q.9-.396 1.26-1.26t0-1.764zm33.912-12.816l1.656 1.656-8.784 8.748 2.448 2.448q.684.684.684 1.638t-.684 1.638l-2.304 2.304q3.204 5.796 3.204 12.348 0 5.148-1.998 9.846t-5.4 8.1-8.1 5.4-9.846 1.998-9.846-1.998-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998q6.552 0 12.348 3.204l2.304-2.304q.684-.684 1.638-.684t1.638.684l2.448 2.448zm.288-2.016q-.36.36-.792.36-.468 0-.828-.36l-3.276-3.24q-.324-.36-.324-.828t.324-.828q.36-.324.828-.324t.828.324l3.24 3.276q.36.324.36.81t-.36.81zm8.28 8.28q-.396.324-.828.324t-.828-.324l-3.24-3.276q-.36-.324-.36-.81t.36-.81q.324-.36.81-.36t.81.36l3.276 3.24q.324.36.324.828t-.324.828zm1.476-6.588q0 .504-.324.828t-.828.324h-3.456q-.504 0-.828-.324t-.324-.828.324-.828.828-.324h3.456q.504 0 .828.324t.324.828zm-6.912-6.912v3.456q0 .504-.324.828t-.828.324-.828-.324-.324-.828v-3.456q0-.504.324-.828t.828-.324.828.324.324.828zm5.436 1.98l-3.276 3.24q-.36.36-.792.36-.468 0-.828-.36-.36-.324-.36-.81t.36-.81l3.24-3.276q.36-.324.828-.324t.828.324q.324.36.324.828t-.324.828z\",\"SOCCER_BALL_O\":\"M21.924-35.063l10.332-7.488 10.332 7.488-3.924 12.096h-12.78zm10.332-29.376q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm22.284 48.6q5.364-7.308 5.364-16.344v-.108l-3.672 3.204-8.64-8.064 2.268-11.628 4.824.432q-5.4-7.416-14.004-10.152l1.908 4.464-10.332 5.724-10.332-5.724 1.908-4.464q-8.604 2.736-14.004 10.152l4.86-.432 2.232 11.628-8.64 8.064-3.672-3.204v.108q0 9.036 5.364 16.344l1.08-4.752 11.736 1.44 5.004 10.728-4.176 2.484q4.212 1.404 8.64 1.404t8.64-1.404l-4.176-2.484 5.004-10.728 11.736-1.44z\",\"TTY\":\"M16.128-17.207v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm20.736 13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-20.664-5.76q-1.008 0-1.692-.684t-.684-1.656v-4.644h18.504v4.644q0 .972-.684 1.656t-1.656.684h-13.788zm41.4 19.584v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm20.736 13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm-6.912-13.824v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm13.824-14.688v.468h-18.504v-.36q0-3.744-13.752-3.672-13.752.036-13.752 3.672v.36h-18.504v-.468q0-.612.306-1.548t1.224-2.304 2.358-2.718 3.978-2.736 5.76-2.43 8.064-1.71 10.566-.666 10.548.666 8.064 1.71 5.778 2.43 3.978 2.736 2.358 2.718 1.224 2.304.306 1.548zm0 14.688v6.912q0 .504-.324.828t-.828.324h-6.912q-.504 0-.828-.324t-.324-.828v-6.912q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828zm0-12.744v4.644q0 .972-.684 1.656t-1.656.684h-13.824q-.972 0-1.656-.684t-.684-1.656v-4.644h18.504z\",\"BINOCULARS\":\"M25.344-52.919v27.648q0 .936-.684 1.62t-1.62.684v20.736q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-18.432l8.964-31.428q.252-.828 1.116-.828h15.264zm11.52 0v25.344h-9.216v-25.344h9.216zm27.648 32.256v18.432q0 .936-.684 1.62t-1.62.684h-18.432q-.936 0-1.62-.684t-.684-1.62v-20.736q-.936 0-1.62-.684t-.684-1.62v-27.648h15.264q.864 0 1.116.828zm-38.016-42.624v8.064h-12.672v-8.064q0-.504.324-.828t.828-.324h10.368q.504 0 .828.324t.324.828zm24.192 0v8.064h-12.672v-8.064q0-.504.324-.828t.828-.324h10.368q.504 0 .828.324t.324.828z\",\"PLUG\":\"M63.18-48.131q1.332 1.332 1.332 3.24t-1.332 3.276l-14.436 14.4 5.4 5.4-5.76 5.76q-5.868 5.868-14.022 6.714t-14.814-3.618l-13.032 13.032h-6.516v-6.516l13.032-13.032q-4.464-6.66-3.618-14.814t6.714-14.022l5.76-5.76 5.4 5.4 14.4-14.436q1.368-1.332 3.276-1.332t3.24 1.332 1.332 3.258-1.332 3.258l-14.4 14.436 8.424 8.424 14.436-14.4q1.368-1.332 3.276-1.332t3.24 1.332z\",\"SLIDESHARE\":\"M31.428-37.799q0 2.988-2.286 5.13t-5.49 2.142-5.49-2.142-2.286-5.13q0-3.024 2.286-5.148t5.49-2.124 5.49 2.124 2.286 5.148zm18.072 0q0 2.988-2.268 5.13t-5.508 2.142q-3.204 0-5.49-2.142t-2.286-5.13q0-3.024 2.286-5.148t5.49-2.124q3.24 0 5.508 2.124t2.268 5.148zm8.1 6.48v-24.012q0-3.132-1.152-4.446t-3.996-1.314h-40.032q-2.988 0-4.05 1.224t-1.062 4.536v24.228q1.548.828 3.186 1.44t2.916 1.008 2.916.666 2.556.396 2.52.144 2.106.018 2.034-.072 1.602-.072q2.448-.036 3.42.972.216.216.36.324.936.9 2.196 1.836.252-3.276 4.248-3.132.18 0 1.314.054t1.548.072 1.638.036 1.908-.036 1.962-.162 2.196-.306 2.232-.486 2.412-.702 2.43-.972 2.592-1.242zm5.868-.18q-4.356 5.364-13.392 9.072 3.024 10.26-.828 16.74-2.376 4.068-6.588 5.328-3.744 1.152-6.552-.54-3.096-1.836-2.952-5.904l-.036-11.736v-.036q-.288-.072-.882-.216t-.846-.18l-.036 12.168q.144 4.104-2.988 5.904-2.844 1.692-6.588.54-4.212-1.296-6.552-5.4-3.78-6.48-.792-16.668-9.036-3.708-13.392-9.072-.9-1.332-.144-2.268t2.16.036q.108.072.396.252t.396.288v-24.984q0-2.592 1.692-4.428t4.104-1.836h45.252q2.412 0 4.104 1.836t1.692 4.428v24.984l.756-.54q1.404-.972 2.16-.036t-.144 2.268z\",\"TWITCH\":\"M32.256-48.815v15.624h-5.22v-15.624h5.22zm14.328 0v15.624h-5.22v-15.624h5.22zm0 27.36l9.108-9.144v-28.62h-42.984v37.764h11.736v7.812l7.812-7.812h14.328zm14.328-42.984v36.468l-15.624 15.624h-11.736l-7.812 7.812h-7.812v-7.812h-14.328v-41.688l3.924-10.404h53.388z\",\"YELP\":\"M27.828-16.955v4.572q-.036 10.512-.216 10.98-.432 1.152-1.836 1.44-1.944.324-6.534-1.368t-5.85-3.204q-.468-.54-.612-1.296-.036-.432.144-.936.144-.36 1.224-1.692t6.516-7.776q.036 0 2.16-2.52.54-.684 1.422-.882t1.782.126q.864.36 1.35 1.044t.45 1.512zm-5.364-9.036q-.108 1.98-1.872 2.52l-4.32 1.404q-9.9 3.168-10.512 3.168-1.26-.072-1.944-1.296-.432-.9-.612-2.7-.288-2.736.036-5.994t1.08-4.482 2.016-1.152q.468 0 7.272 2.772 2.52 1.044 4.14 1.692l3.024 1.224q.828.324 1.278 1.098t.414 1.746zm29.736 10.692q-.252 1.944-3.294 5.796t-4.878 4.572q-1.332.504-2.268-.252-.504-.36-6.624-10.332l-1.692-2.772q-.504-.756-.414-1.656t.702-1.656q1.26-1.548 2.988-.936.036.036 4.284 1.44 7.308 2.376 8.712 2.862t1.692.738q1.008.792.792 2.196zm-24.192-22.752q.18 3.672-1.944 4.392-2.088.612-4.104-2.556l-13.608-21.528q-.288-1.26.684-2.232 1.476-1.548 7.47-3.222t8.082-1.134q1.44.36 1.764 1.62.108.648.792 10.998t.864 13.662zm23.832 3.888q.108 1.404-.936 2.124-.54.36-11.844 3.096-2.412.54-3.276.828l.036-.072q-.828.216-1.656-.144t-1.332-1.152q-1.08-1.692 0-3.132.036-.036 2.7-3.672 4.5-6.156 5.4-7.344t1.224-1.404q1.008-.684 2.34-.072 1.728.828 4.428 4.806t2.916 6.03v.108z\",\"NEWSPAPER_O\":\"M36.864-46.007h-13.824v13.824h13.824v-13.824zm4.608 23.04v4.608h-23.04v-4.608h23.04zm0-27.648v23.04h-23.04v-23.04h23.04zm23.04 27.648v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm0-9.216v4.608h-18.432v-4.608h18.432zm-55.296 34.56v-34.56h-4.608v34.56q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm59.904 0v-39.168h-55.296v39.168q0 1.188-.396 2.304h53.388q.936 0 1.62-.684t.684-1.62zm4.608-43.776v43.776q0 2.88-2.016 4.896t-4.896 2.016h-59.904q-2.88 0-4.896-2.016t-2.016-4.896v-39.168h9.216v-4.608h64.512z\",\"WIFI\":\"M36.864-9.611q-.72 0-3.348-2.646t-2.628-3.366q0-1.152 2.25-1.944t3.726-.792 3.726.792 2.25 1.944q0 .72-2.628 3.366t-3.348 2.646zm9.72-9.756q-.072 0-1.44-.9t-3.654-1.8-4.626-.9-4.626.9-3.636 1.8-1.458.9q-.648 0-3.366-2.7t-2.718-3.348q0-.468.36-.828 2.808-2.772 7.056-4.356t8.388-1.584 8.388 1.584 7.056 4.356q.36.36.36.828 0 .648-2.718 3.348t-3.366 2.7zm9.828-9.792q-.396 0-.828-.288-4.896-3.78-9.072-5.562t-9.648-1.782q-3.06 0-6.138.792t-5.364 1.908-4.086 2.232-2.844 1.908-1.116.792q-.612 0-3.312-2.7t-2.7-3.348q0-.432.36-.792 4.752-4.752 11.52-7.38t13.68-2.628 13.68 2.628 11.52 7.38q.36.36.36.792 0 .648-2.7 3.348t-3.312 2.7zm9.756-9.756q-.396 0-.792-.324-6.444-5.652-13.374-8.514t-15.138-2.862-15.138 2.862-13.374 8.514q-.396.324-.792.324-.612 0-3.33-2.7t-2.718-3.348q0-.468.36-.828 6.732-6.696 16.02-10.368t18.972-3.672 18.972 3.672 16.02 10.368q.36.36.36.828 0 .648-2.718 3.348t-3.33 2.7z\",\"CALCULATOR\":\"M13.824-9.143q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-13.824-13.824q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm27.648 27.648v-13.824q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24v13.824q0 1.872 1.368 3.24t3.24 1.368 3.24-1.368 1.368-3.24zm-13.824-27.648q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824-11.52v-9.216q0-.936-.684-1.62t-1.62-.684h-46.08q-.936 0-1.62.684t-.684 1.62v9.216q0 .936.684 1.62t1.62.684h46.08q.936 0 1.62-.684t.684-1.62zm0 11.52q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm4.608-23.04v55.296q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-55.296q0-1.872 1.368-3.24t3.24-1.368h50.688q1.872 0 3.24 1.368t1.368 3.24z\",\"PAYPAL\":\"M54.684-41.183q.648 3.024-.144 7.344-3.132 15.984-20.34 15.984h-1.584q-.9 0-1.584.594t-.864 1.53l-.144.684-1.98 12.456-.072.54q-.18.936-.882 1.53t-1.602.594h-9.036q-.756 0-1.188-.54t-.324-1.296q.324-2.016.954-6.048t.954-6.048.972-6.03.972-6.03q.18-1.332 1.548-1.332h4.716q4.788.072 8.496-.756 6.3-1.404 10.332-5.184 3.672-3.42 5.58-8.856.864-2.52 1.26-4.788.036-.216.09-.27t.126-.036.216.126q2.844 2.124 3.528 5.832zm-6.192-10.152q0 3.852-1.656 8.496-2.88 8.388-10.872 11.34-4.068 1.44-9.072 1.512 0 .036-3.24.036l-3.24-.036q-3.6 0-4.248 3.456-.072.288-3.06 19.08-.036.36-.432.36h-10.62q-.792 0-1.314-.594t-.414-1.386l8.352-52.956q.18-1.044.99-1.728t1.854-.684h21.528q1.224 0 3.51.468t4.014 1.152q3.852 1.476 5.886 4.428t2.034 7.056z\",\"GOOGLE_WALLET\":\"M15.876-40.247q1.152 0 1.872.936 9.576 13.104 13.032 27.864h-16.056q-4.572-15.876-13.212-26.964-.432-.576-.108-1.206t1.044-.63h13.428zm20.124 12.852q-1.764 7.164-4.5 14.148-2.844-11.16-9.216-21.384 1.44-7.956 1.584-16.164 7.596 12.24 12.132 23.4zm3.564-25.524q8.46 11.664 13.842 25.146t6.642 27.846h-16.236q-1.476-23.94-19.908-52.992h15.66zm24.948 20.736q0 15.264-3.636 29.232-2.412-20.16-12.924-38.988-.9-10.836-3.816-21.024-.144-.576.198-1.026t.918-.45h12.924q.756 0 1.386.468t.81 1.188q4.14 14.724 4.14 30.6z\",\"CC_VISA\":\"M71.1-28.799h-4.968q.504-1.332 2.376-6.444l.108-.324q.144-.36.36-.936t.324-.936l.432 1.98zm-51.984-2.34l-2.088-10.62q-.396-1.944-2.7-1.944h-9.648l-.072.468q11.196 2.844 14.508 12.096zm6.444-12.564l-5.832 15.768-.612-3.204q-.936-2.52-3.06-4.662t-4.716-3.186l4.86 18.36h6.3l9.396-23.076h-6.336zm5.004 23.112h5.976l3.744-23.112h-5.976zm27.648-22.536q-2.484-.972-5.364-.972-4.428 0-7.236 2.124t-2.844 5.508q-.036 3.672 5.22 6.264 1.728.828 2.412 1.476t.684 1.404q0 1.08-1.08 1.656t-2.484.576q-3.096 0-5.616-1.188l-.792-.396-.828 5.184q2.664 1.224 6.66 1.224 4.68.036 7.506-2.124t2.898-5.76q0-3.816-5.04-6.264-1.764-.9-2.556-1.512t-.792-1.368q0-.792.882-1.386t2.538-.594q2.52-.036 4.464.864l.54.288zm15.3-.576h-4.608q-2.34 0-3.132 1.944l-8.856 21.168h6.264l1.26-3.456h7.632q.18.792.72 3.456h5.544zm9.432-11.52v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"CC_MASTERCARD\":\"M24.156-30.851h-.468q-1.692 0-1.692 1.152 0 .792.72.792.612 0 1.008-.54t.432-1.404zm14.22-1.296h2.232v-.108q.036-.144.018-.234t-.036-.252-.072-.288-.162-.234-.27-.18-.414-.072q-1.008 0-1.296 1.368zm19.44 1.296h-.432q-1.728 0-1.728 1.152 0 .792.72.792.612 0 1.008-.54t.432-1.404zm11.484-.936q0-1.476-1.08-1.476-.684 0-1.116.72t-.432 1.836q0 1.512 1.008 1.512.72 0 1.17-.72t.45-1.872zm-52.02-5.076h3.132l-1.584 9.432h-2.016l1.152-7.236-2.556 7.236h-1.404l-.144-7.2-1.224 7.2h-1.908l1.584-9.432h2.916l.072 5.868zm9.108 3.852q0 .216-.144 1.512-.576 3.636-.612 4.068h-1.692l.036-.792q-.72.936-2.088.936-.828 0-1.35-.576t-.522-1.512q0-1.404.936-2.178t2.628-.774q.504 0 .828.036l.018-.198.036-.162.018-.108q0-.72-1.296-.72-1.044 0-2.124.36 0-.144.252-1.728 1.368-.396 2.412-.396 2.664 0 2.664 2.232zm5.616-2.088l-.288 1.764q-.792-.108-1.476-.108-.972 0-.972.612 0 .288.162.432t.774.396q1.44.684 1.44 2.16 0 2.592-3.132 2.556-1.224 0-2.088-.216 0-.072.252-1.764 1.044.288 1.836.288 1.152 0 1.152-.684 0-.252-.162-.414t-.774-.45q-1.548-.72-1.548-2.124 0-2.592 3.024-2.592 1.08 0 1.8.144zm3.168 0h1.008l-.252 1.872h-1.044q-.072.612-.234 1.458t-.252 1.386-.09.648q0 .576.684.576.288 0 .576-.072l-.288 1.692q-.756.252-1.44.252-1.548 0-1.62-1.692 0-.432.288-2.016.108-.72.9-5.256h1.98zm7.308 2.628q0 .828-.252 1.872h-3.996q-.108.792.36 1.188t1.368.396q1.08 0 2.088-.504l-.324 1.944q-1.08.288-2.052.288-3.42 0-3.42-3.42 0-1.98.99-3.258t2.502-1.278q1.26 0 1.998.756t.738 2.016zm5.004-2.664q-.468.828-.792 2.232-.792-.072-1.116.864t-.9 4.608h-2.016l.108-.504q.792-4.68 1.044-7.164h1.836l-.108 1.188q.504-.756.918-1.062t1.026-.162zm6.732-1.476l-.324 2.052q-1.008-.504-1.8-.504-1.116 0-1.836.99t-.72 2.538q0 1.08.486 1.692t1.386.612q.756 0 1.728-.468l-.36 2.124q-1.008.288-1.8.288-1.62 0-2.574-1.098t-.954-2.97q0-2.52 1.278-4.122t3.294-1.602q.936 0 2.196.468zm5.832 3.6q0 .648-.144 1.512-.468 2.844-.612 4.068h-1.656l.036-.792q-.72.936-2.124.936-.828 0-1.332-.576t-.504-1.512q0-1.404.918-2.178t2.61-.774q.54 0 .828.036.072-.252.072-.468 0-.72-1.296-.72-1.044 0-2.124.36 0-.144.288-1.728 1.368-.396 2.412-.396 2.628 0 2.628 2.232zm5.076-2.124q-.504.864-.756 2.232-.828-.072-1.134.828t-.918 4.644h-2.016l.108-.504q.684-3.744 1.044-7.164h1.872q0 .396-.144 1.188.54-.756.954-1.062t.99-.162zm5.076-1.728h2.016l-1.548 9.432h-1.908l.108-.684q-.828.828-1.872.828-1.116 0-1.782-.864t-.666-2.304q0-1.908.99-3.312t2.322-1.404q1.116 0 1.908 1.044zm3.996 4.68q0-5.328-2.61-9.828t-7.128-7.128-9.846-2.628q-6.516 0-11.808 3.96 4.572 4.176 6.156 10.224h-1.8q-1.584-5.4-5.688-9.108-4.104 3.708-5.688 9.108h-1.8q1.584-6.048 6.156-10.224-5.292-3.96-11.808-3.96-5.328 0-9.846 2.628t-7.128 7.128-2.61 9.828 2.61 9.828 7.128 7.128 9.846 2.628q6.516 0 11.808-3.96-4.32-3.996-5.94-9.504h1.8q1.656 4.968 5.472 8.388 3.816-3.42 5.472-8.388h1.8q-1.62 5.508-5.94 9.504 5.292 3.96 11.808 3.96 5.328 0 9.846-2.628t7.128-7.128 2.61-9.828zm8.748-23.04v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"CC_DISCOVER\":\"M11.268-36.467q0 1.836-1.296 3.024-1.044.936-3.204.936h-.612v-7.92h.612q2.196 0 3.204.972 1.296 1.116 1.296 2.988zm63.936-2.34q0 1.872-2.304 1.872h-.684v-3.636h.72q2.268 0 2.268 1.764zm-61.524 2.34q0-2.664-1.8-4.338t-4.644-1.674h-3.42v11.988h3.42q2.664 0 4.284-1.368 2.16-1.836 2.16-4.608zm1.08 5.976h2.34v-11.988h-2.34v11.988zm11.52-3.636q0-1.44-.738-2.232t-2.718-1.512q-1.044-.36-1.422-.684t-.378-.828q0-.576.486-.954t1.242-.378q1.044 0 1.908.972l1.224-1.584q-1.476-1.332-3.528-1.332-1.584 0-2.664.99t-1.08 2.43q0 1.26.648 1.998t2.304 1.314q1.332.468 1.62.684.684.432.684 1.224 0 .72-.504 1.206t-1.296.486q-1.728 0-2.556-1.584l-1.512 1.44q1.584 2.304 4.14 2.304 1.836 0 2.988-1.098t1.152-2.862zm10.008 3.24v-2.772q-1.332 1.332-2.808 1.332-1.764 0-2.898-1.17t-1.134-2.97q0-1.728 1.134-2.934t2.79-1.206q1.548 0 2.916 1.368v-2.772q-1.44-.72-2.88-.72-2.664 0-4.518 1.818t-1.854 4.446 1.836 4.446 4.5 1.818q1.512 0 2.916-.684zm44.352 21.744v-18.972q-2.34 1.44-5.202 3.024t-8.55 4.212-11.862 4.95-15.03 4.842-18.144 4.248h56.484q.936 0 1.62-.684t.684-1.62zm-30.636-27.252q0-2.7-1.908-4.608t-4.608-1.908-4.608 1.908-1.908 4.608 1.908 4.608 4.608 1.908 4.608-1.908 1.908-4.608zm5.472 6.228l5.184-12.312h-2.556l-3.24 8.064-3.204-8.064h-2.556l5.112 12.312h1.26zm6.228-.324h6.624v-2.016h-4.284v-3.24h4.14v-2.016h-4.14v-2.664h4.284v-2.052h-6.624v11.988zm14.076 0h2.88l-3.78-5.04q2.736-.576 2.736-3.384 0-1.692-1.116-2.628t-3.132-.936h-3.492v11.988h2.34v-4.788h.324zm7.164-24.516v45.648q0 2.016-1.386 3.42t-3.366 1.404h-73.44q-1.98 0-3.366-1.404t-1.386-3.42v-45.648q0-2.016 1.386-3.42t3.366-1.404h73.44q1.98 0 3.366 1.404t1.386 3.42z\",\"CC_AMEX\":\"M4.284-39.887h3.204l-1.62-3.888zm22.356 18.936l2.664-2.844-2.52-2.844h-5.868v1.764h5.112v1.98h-5.112v1.944h5.724zm5.688-2.808l3.564 3.96v-7.812zm10.368-1.692q0-1.188-1.44-1.188h-3.024v2.484h2.988q1.476 0 1.476-1.296zm10.404-.144q0-1.044-1.512-1.044h-2.952v2.196h2.916q1.548 0 1.548-1.152zm-10.008-16.776q0-1.044-1.512-1.044h-2.952v2.16h2.916q1.548 0 1.548-1.116zm16.524 2.484h3.204l-1.584-3.888zm-34.452-5.58v9.756h-2.376v-7.632l-3.384 7.632h-2.052l-3.384-7.632v7.632h-4.752l-.9-2.16h-4.86l-.9 2.16h-2.52l4.176-9.756h3.456l3.96 9.252v-9.252h3.816l3.06 6.624 2.772-6.624h3.888zm20.016 20.016q0 .72-.198 1.26t-.504.9-.81.594-.936.36-1.134.162-1.134.036-1.17-.018-1.062-.018v3.276h-4.536l-2.88-3.24-2.988 3.24h-9.216v-9.756h9.36l2.88 3.204 2.952-3.204h7.452q3.924 0 3.924 3.204zm-10.476-12.276v2.016h-7.812v-9.756h7.812v2.052h-5.472v1.764h5.328v1.98h-5.328v1.944h5.472zm48.24 20.124v8.244q0 1.98-1.386 3.402t-3.366 1.422h-73.44q-1.98 0-3.366-1.422t-1.386-3.402v-24.408h3.996l.9-2.196h1.98l.9 2.196h7.848v-1.656l.684 1.656h4.068l.72-1.692v1.692h19.476v-3.564l.36-.036q.36 0 .36.504v3.096h10.044v-.828q.828.432 1.98.648t1.89.234 2.268-.018 1.854-.036l.9-2.196h2.016l.9 2.196h8.172v-2.088l1.224 2.088h6.552v-13.608h-6.48v1.584l-.9-1.584h-6.66v1.584l-.828-1.584h-8.964q-2.484 0-3.924.792v-.792h-6.192v.792q-.864-.792-2.628-.792h-22.608l-1.548 3.492-1.548-3.492h-7.128v1.584l-.792-1.584h-6.084l-2.808 6.444v-14.076q0-1.98 1.386-3.402t3.366-1.422h73.44q1.98 0 3.366 1.422t1.386 3.402v24.408h-4.32q-1.836 0-2.916.792v-.792h-6.372q-1.98 0-2.808.792v-.792h-11.376v.792q-1.116-.792-3.132-.792h-7.524v.792q-.828-.792-3.276-.792h-8.424l-1.944 2.088-1.8-2.088h-12.564v13.608h12.348l1.98-2.124 1.872 2.124h7.596v-3.204h.756q2.124 0 3.24-.468v3.672h6.264v-3.564h.288q.288 0 .36.072t.072.36v3.132h19.044q2.052 0 3.168-.864v.864h6.048q2.16 0 3.42-.612zm-27.288-8.424q0 .828-.432 1.548t-1.224 1.044q.9.324 1.224.936t.324 1.656v1.944h-2.34v-1.62q0-1.188-.432-1.566t-1.656-.378h-2.484v3.564h-2.34v-9.756h5.544q1.728 0 2.772.54t1.044 2.088zm-9.972-16.812q0 .864-.45 1.584t-1.206 1.044q.936.324 1.242.918t.306 1.674v1.908h-2.34q0-.324.018-.954t0-.9-.108-.666-.306-.576-.63-.306-1.062-.126h-2.52v3.528h-2.304v-9.756l5.508.036q1.764 0 2.808.522t1.044 2.07zm19.044 21.924v2.016h-7.776v-9.756h7.776v2.016h-5.436v1.764h5.328v1.98h-5.328v1.944zm-15.336-24.552v9.756h-2.376v-9.756h2.376zm24.948 23.472q0 3.096-3.672 3.096h-4.536v-2.088h4.536q1.224 0 1.224-.9 0-.576-.612-.756t-1.494-.18-1.782-.126-1.512-.81-.612-1.98q0-1.404.936-2.16t2.376-.756h4.68v2.052h-4.284q-1.296 0-1.296.9 0 .576.63.738t1.512.144 1.764.09 1.512.774.63 1.962zm8.604-1.8v3.636q-.864 1.26-3.168 1.26h-4.5v-2.088h4.5q1.188 0 1.188-.9 0-.468-.45-.684t-1.116-.198-1.44-.072-1.44-.288-1.116-.864-.45-1.746q0-1.404.954-2.16t2.394-.756h4.644v2.052h-4.248q-1.296 0-1.296.9 0 .72 1.044.792t2.466.18 2.034.936zm-5.94-21.636v9.72h-3.312l-4.392-7.308v7.308h-4.752l-.936-2.16h-4.824l-.9 2.16h-2.7q-4.644 0-4.644-4.788 0-4.968 4.788-4.968h2.268v2.124q-.252 0-1.008-.036t-1.026-.018-.828.072-.774.234-.522.486-.414.828-.108 1.206q0 1.368.486 2.088t1.782.72h1.044l3.312-7.668h3.492l3.924 9.216v-9.216h3.564l4.104 6.768v-6.768h2.376z\",\"CC_PAYPAL\":\"M26.82-31.823q0 1.332-.918 2.214t-2.25.882q-1.044 0-1.674-.576t-.63-1.584q0-1.332.9-2.25t2.232-.918q1.008 0 1.674.594t.666 1.638zm28.26-5.364q0 1.512-.792 2.052t-2.376.54l-1.152.036.612-3.852q.072-.396.468-.396h.648q.792 0 1.26.072t.9.45.432 1.098zm12.636 5.364q0 1.296-.918 2.196t-2.214.9q-1.044 0-1.692-.576t-.648-1.584q0-1.332.9-2.25t2.232-.918q1.008 0 1.674.594t.666 1.638zm-49.248-6.156q0-2.124-1.386-3.078t-3.618-.954h-5.76q-.684 0-.756.684l-2.34 14.688q-.036.216.108.396t.36.18h2.736q.72 0 .792-.684l.648-3.96q.036-.288.252-.468t.54-.234.612-.054.684.036.504.036q3.096 0 4.86-1.746t1.764-4.842zm11.124 11.232l1.476-9.396q.036-.216-.108-.396t-.36-.18h-2.736q-.504 0-.612 1.188-.972-1.44-3.42-1.44-2.592 0-4.41 1.944t-1.818 4.572q0 2.124 1.242 3.384t3.33 1.26q1.008 0 2.088-.432t1.728-1.152q-.144.432-.144.756 0 .576.468.576h2.484q.684 0 .792-.684zm16.092-9.468q0-.18-.144-.342t-.324-.162h-2.772q-.396 0-.648.36l-3.816 5.616-1.584-5.4q-.18-.576-.792-.576h-2.7q-.18 0-.324.162t-.144.342q0 .072.702 2.124t1.512 4.428.846 2.52q-2.952 4.032-2.952 4.32 0 .468.468.468h2.772q.396 0 .648-.36l9.18-13.248q.072-.072.072-.252zm13.68-1.764q0-2.124-1.386-3.078t-3.618-.954h-5.724q-.72 0-.792.684l-2.34 14.688q-.036.216.108.396t.36.18h2.952q.432 0 .576-.468l.648-4.176q.036-.288.252-.468t.54-.234.612-.054.684.036.504.036q3.096 0 4.86-1.746t1.764-4.842zm11.124 11.232l1.476-9.396q.036-.216-.108-.396t-.36-.18h-2.736q-.504 0-.612 1.188-.936-1.44-3.42-1.44-2.592 0-4.41 1.944t-1.818 4.572q0 2.124 1.242 3.384t3.33 1.26q1.044 0 2.124-.432t1.692-1.152q0 .036-.072.324t-.072.432q0 .576.468.576h2.484q.684 0 .792-.684zm7.848-14.724v-.036q0-.504-.468-.504h-2.664q-.396 0-.468.396l-2.34 14.976-.036.072q0 .18.144.342t.36.162h2.376q.684 0 .756-.684zm-64.224 4.824q-.18 1.26-.936 1.656t-2.16.396l-1.188.036.612-3.852q.072-.396.468-.396h.684q1.44 0 2.088.414t.432 1.746zm68.832-18.576v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"CC_STRIPE\":\"M57.492-31.931q0 2.484-.756 3.816-.684 1.26-1.872 1.26-.828 0-1.476-.324v-8.064q1.044-1.08 2.052-1.08 2.052 0 2.052 4.392zm15.768-1.296h-3.96q.216-3.528 2.016-3.528 1.836 0 1.944 3.528zm-56.124 4.86q0-2.124-1.188-3.294t-3.636-2.07q-1.296-.468-1.872-.864t-.576-.9q0-.936 1.368-.936 2.088 0 4.464 1.188l.648-4.032q-2.412-1.152-5.364-1.152-2.772 0-4.428 1.368-1.728 1.404-1.728 3.924 0 2.088 1.17 3.258t3.582 2.034q1.404.504 1.962.918t.558.99q0 1.116-1.728 1.116-1.044 0-2.52-.45t-2.592-1.098l-.648 4.068q2.592 1.476 6.048 1.476 2.916 0 4.644-1.332 1.836-1.476 1.836-4.212zm10.62-7.74l.684-3.996h-3.456v-4.86l-4.644.756-.648 4.104-1.656.288-.612 3.708h2.232v7.884q0 3.024 1.584 4.32 1.368 1.08 3.996 1.08 1.152 0 2.844-.396v-4.248q-1.152.252-1.584.252-1.512 0-1.512-1.8v-7.092h2.772zm11.376.9v-5.004q-.54-.108-1.008-.108-1.152 0-1.998.576t-1.206 1.656l-.36-2.016h-4.716v16.956h5.4v-11.016q.936-1.116 2.952-1.116.576 0 .936.072zm1.332 12.06h5.4v-16.956h-5.4v16.956zm22.392-8.964q0-4.392-1.62-6.444-1.44-1.872-3.996-1.872-2.304 0-4.212 2.016l-.288-1.692h-4.752v23.22l5.4-.9v-5.436q1.296.396 2.448.396 2.988 0 4.824-2.016 2.196-2.34 2.196-7.272zm-16.848-12.528q0-1.188-.828-2.016t-2.016-.828-2.016.828-.828 2.016.828 2.034 2.016.846 2.016-.846.828-2.034zm32.328 12.852q0-4.068-1.728-6.336-1.8-2.304-5.184-2.304-3.456 0-5.454 2.376t-1.998 6.48q0 4.608 2.268 6.768 1.98 1.98 5.796 1.98 3.636 0 5.76-1.44l-.576-3.708q-2.052 1.116-4.608 1.116-1.548 0-2.268-.684-.828-.684-1.008-2.376h8.928q.072-.504.072-1.872zm4.608-23.436v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"BELL_SLASH\":\"M56.088-33.767q2.196 12.816 10.728 20.016 0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.498-2.682-2.718-6.498zm-19.224 30.96q.576 0 .576-.576t-.576-.576q-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854zm36.072-57.6q.288.36.27.846t-.378.81l-67.392 58.392q-.36.288-.846.252t-.774-.396l-3.024-3.456q-.288-.36-.27-.846t.378-.774l6.696-5.796q-.684-1.152-.684-2.376 1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 4.464.648 7.884 2.97t5.328 5.67l15.048-13.068q.36-.288.846-.252t.774.396z\",\"BELL_SLASH_O\":\"M37.44-3.383q0-.576-.576-.576-2.124 0-3.654-1.53t-1.53-3.654q0-.576-.576-.576t-.576.576q0 2.628 1.854 4.482t4.482 1.854q.576 0 .576-.576zm-19.332-17.1l31.572-27.36q-1.512-3.168-4.77-5.274t-8.046-2.106q-3.348 0-6.102 1.134t-4.374 2.898-2.484 3.708-.864 3.78q0 13.824-4.932 23.22zm48.708 6.732q0 1.872-1.368 3.24t-3.24 1.368h-16.128q0 3.816-2.7 6.516t-6.516 2.7-6.498-2.682-2.718-6.498l5.364-4.644h27.252q-5.976-6.732-8.172-16.524l3.996-3.492q2.196 12.816 10.728 20.016zm3.096-50.112l3.024 3.456q.288.36.27.846t-.378.81l-67.392 58.392q-.36.288-.846.252t-.774-.396l-3.024-3.456q-.288-.36-.27-.846t.378-.774l6.696-5.796q-.684-1.152-.684-2.376 1.8-1.512 3.276-3.168t3.06-4.302 2.682-5.706 1.8-7.416.702-9.36q0-5.472 4.212-10.17t11.052-5.706q-.288-.684-.288-1.404 0-1.44 1.008-2.448t2.448-1.008 2.448 1.008 1.008 2.448q0 .72-.288 1.404 4.464.648 7.884 2.97t5.328 5.67l15.048-13.068q.36-.288.846-.252t.774.396z\",\"TRASH\":\"M18.432-14.903v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 0v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm9.216 0v-25.344q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v25.344q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm-19.584-35.712h16.128l-1.728-4.212q-.252-.324-.612-.396h-11.412q-.36.072-.612.396zm33.408 1.152v2.304q0 .504-.324.828t-.828.324h-3.456v34.128q0 2.988-1.692 5.166t-4.068 2.178h-29.952q-2.376 0-4.068-2.106t-1.692-5.094v-34.272h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h11.124l2.52-6.012q.54-1.332 1.944-2.268t2.844-.936h11.52q1.44 0 2.844.936t1.944 2.268l2.52 6.012h11.124q.504 0 .828.324t.324.828z\",\"COPYRIGHT\":\"M41.4-25.775v3.924q0 1.8-1.314 3.204t-3.384 2.178-4.248 1.17-4.23.396q-7.38 0-12.33-5.004t-4.95-12.456q0-7.308 4.896-12.204t12.204-4.896q1.224 0 2.718.162t3.348.648 3.33 1.224 2.484 2.034 1.008 2.916v3.924q0 .576-.576.576h-4.248q-.576 0-.576-.576v-2.52q0-1.548-2.358-2.43t-4.95-.882q-5.04 0-8.226 3.294t-3.186 8.55q0 5.436 3.294 8.982t8.406 3.546q2.448 0 4.968-.864t2.52-2.376v-2.52q0-.252.162-.414t.378-.162h4.284q.216 0 .396.162t.18.414zm-13.752-29.448q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"AT\":\"M34.992-36.539q0-3.888-1.926-6.084t-5.31-2.196q-2.268 0-4.464 1.098t-3.96 3.042-2.862 4.932-1.098 6.48q0 4.032 1.926 6.228t5.418 2.196q3.456 0 6.336-2.394t4.41-5.976 1.53-7.326zm20.304 4.356q0 3.996-1.332 7.092t-3.546 4.86-4.734 2.682-5.22.99l-.558.018-.594.018q-3.42 0-5.112-1.908-1.008-1.188-1.188-2.988-1.872 2.376-4.734 3.96t-6.246 1.584q-5.796 0-8.982-3.438t-3.186-9.702q0-5.652 2.376-10.44t6.444-7.578 8.856-2.79q3.132 0 5.58 1.278t3.816 3.582l.072-.684.396-2.016q.036-.216.198-.432t.342-.216h4.248q.18 0 .468.396.18.18.108.576l-4.32 22.104q-.18.864-.18 1.728 0 1.404.45 1.872t1.602.468q1.008-.036 2.052-.198t2.628-.864 2.772-1.8 2.052-3.222.864-4.932q0-10.512-6.264-16.776t-16.776-6.264q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836q8.208 0 14.58-5.184.396-.324.864-.288t.756.432l1.476 1.764q.288.432.252.864-.072.468-.432.792-3.672 2.988-8.19 4.608t-9.306 1.62q-5.616 0-10.728-2.196t-8.82-5.904-5.904-8.82-2.196-10.728 2.196-10.728 5.904-8.82 8.82-5.904 10.728-2.196q12.384 0 20.016 7.632t7.632 20.016z\",\"EYEDROPPER\":\"M61.128-61.055q3.384 3.384 3.384 8.154t-3.384 8.118l-8.1 8.028 3.744 3.744q.36.36.36.828t-.36.828l-7.56 7.56q-.36.36-.828.36t-.828-.36l-3.78-3.78-21.708 21.708q-1.332 1.332-3.24 1.332h-7.308l-9.216 4.608-2.304-2.304 4.608-9.216v-7.308q0-1.908 1.332-3.24l21.708-21.708-3.78-3.78q-.36-.36-.36-.828t.36-.828l7.56-7.56q.36-.36.828-.36t.828.36l3.744 3.744 8.028-8.1q3.348-3.384 8.118-3.384t8.154 3.384zm-42.696 49.608l20.736-20.736-6.912-6.912-20.736 20.736v6.912h6.912z\",\"PAINT_BRUSH\":\"M58.14-64.439q2.52 0 4.41 1.674t1.89 4.194q0 2.268-1.62 5.436-11.952 22.644-16.74 27.072-3.492 3.276-7.848 3.276-4.536 0-7.794-3.33t-3.258-7.902q0-4.608 3.312-7.632l22.968-20.844q2.124-1.944 4.68-1.944zm-32.724 37.224q1.404 2.736 3.834 4.68t5.418 2.736l.036 2.556q.144 7.668-4.662 12.492t-12.546 4.824q-4.428 0-7.848-1.674t-5.49-4.59-3.114-6.588-1.044-7.92q.252.18 1.476 1.08t2.232 1.602 2.124 1.314 1.656.612q1.476 0 1.98-1.332.9-2.376 2.07-4.05t2.502-2.736 3.168-1.71 3.708-.918 4.5-.378z\",\"BIRTHDAY_CAKE\":\"M64.512-13.751v13.824h-64.512v-13.824q1.62 0 3.06-.504t2.124-.99 1.692-1.35q1.08-.972 1.854-1.368t2.034-.396 1.998.396 1.89 1.368q1.044.9 1.692 1.368t2.088.972 3.096.504q1.62 0 3.06-.522t2.088-.972 1.728-1.35q.756-.684 1.17-.972t1.116-.54 1.566-.252q1.26 0 2.034.396t1.854 1.368q1.008.864 1.692 1.35t2.124.99 3.06.504 3.06-.504 2.124-.99 1.692-1.35q1.08-.972 1.854-1.368t2.034-.396q1.224 0 1.998.396t1.854 1.368q1.008.864 1.692 1.35t2.124.99 3.06.504zm0-11.52v6.912q-1.26 0-1.998-.396t-1.89-1.368q-1.044-.9-1.692-1.368t-2.088-.972-3.06-.504q-1.656 0-3.096.504t-2.088.972-1.692 1.368q-.792.684-1.188.972t-1.116.54-1.584.252q-1.26 0-2.034-.396t-1.854-1.368q-1.044-.9-1.692-1.368t-2.088-.972-3.096-.504q-1.62 0-3.06.522t-2.088.972-1.728 1.35q-.756.684-1.17.972t-1.116.54-1.566.252q-1.26 0-2.034-.396t-1.854-1.368q-1.008-.864-1.692-1.35t-2.124-.99-3.06-.504q-1.656 0-3.096.504t-2.088.972-1.692 1.368q-1.08.972-1.854 1.368t-2.034.396v-6.912q0-2.88 2.016-4.896t4.896-2.016h2.304v-16.128h9.216v16.128h9.216v-16.128h9.216v16.128h9.216v-16.128h9.216v16.128h2.304q2.88 0 4.896 2.016t2.016 4.896zm-46.08-31.104q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4zm18.432 0q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4zm18.432 0q0 2.772-1.296 4.266t-3.312 1.494q-1.908 0-3.258-1.35t-1.35-3.258q0-1.044.342-1.836t.846-1.224 1.116-1.008 1.116-1.134.846-1.602.342-2.412q1.368 0 2.988 2.664t1.62 5.4z\",\"AREA_CHART\":\"M73.728-9.143v4.608h-73.728v-55.296h4.608v50.688h69.12zm-13.824-36.864l9.216 32.256h-59.904v-20.736l16.128-20.736 20.736 20.736z\",\"PIE_CHART\":\"M27.648-32.399l19.656 19.656q-3.816 3.888-8.91 6.048t-10.746 2.16q-7.524 0-13.878-3.708t-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708v27.432zm6.732.216h27.828q0 5.652-2.16 10.746t-6.048 8.91zm25.524-4.608h-27.648v-27.648q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878z\",\"LINE_CHART\":\"M73.728-9.143v4.608h-73.728v-55.296h4.608v50.688h69.12zm-4.608-44.928v15.66q0 .756-.702 1.062t-1.278-.27l-4.356-4.356-22.788 22.788q-.36.36-.828.36t-.828-.36l-8.388-8.388-14.976 14.976-6.912-6.912 21.06-21.06q.36-.36.828-.36t.828.36l8.388 8.388 16.704-16.704-4.356-4.356q-.576-.576-.27-1.278t1.062-.702h15.66q.504 0 .828.324t.324.828z\",\"LASTFM\":\"M46.512-39.095q0 .216.36 1.476.36 1.044.9 1.782t1.476 1.224 1.584.72 1.98.594q11.7 3.276 11.7 11.952 0 5.256-3.798 8.73t-9.162 3.474q-2.124 0-4.014-.666t-3.294-1.638-2.772-2.682-2.268-3.15-1.926-3.726-1.566-3.708-1.422-3.834-1.278-3.42q-1.152-2.916-2.214-4.806t-2.646-3.474-3.744-2.304-5.112-.72q-3.456 0-6.588 1.998t-4.968 5.202-1.836 6.66q0 5.76 3.834 10.062t9.486 4.302q6.372 0 9.288-3.42 2.016-2.268 2.988-4.176l3.024 5.472q-.54 1.224-1.584 2.52l.036.036q-4.716 5.472-13.968 5.472-5.292 0-9.702-2.844t-6.858-7.47-2.448-9.882q0-3.78 1.566-7.416t4.176-6.354 6.192-4.374 7.362-1.656q3.132 0 5.724.684t4.446 1.8 3.42 2.88 2.61 3.564 2.106 4.212 1.818 4.482 1.8 4.698 1.98 4.572q3.456 7.2 8.388 7.2 2.916 0 4.986-1.746t2.07-4.626q0-1.512-.684-2.592t-1.818-1.656-2.61-1.134-3.042-.972-3.15-1.224-2.916-1.872-2.34-2.952-1.404-4.41q-.108-.576-.108-1.188 0-3.96 3.15-6.912t7.146-2.808q2.808.108 4.338.522t3.258 1.926h-.036q.432.396.828.882t.936 1.296.684.99l-4.644 3.564q-.936-1.764-1.944-2.52v-.036q-.828-.756-3.492-.756-1.764 0-3.024 1.188t-1.26 2.988z\",\"LASTFM_SQUARE\":\"M51.552-26.567q0-6.228-8.424-8.604-1.26-.36-1.908-.594t-1.368-.9-1.044-1.674q0-.072-.072-.306t-.108-.432-.036-.27q0-1.296.882-2.142t2.178-.846q1.944 0 2.556.54h-.036q.72.54 1.404 1.836l3.348-2.556q-1.404-1.944-1.764-2.304-1.188-1.044-2.43-1.404t-3.078-.36q-2.88 0-5.112 2.07t-2.232 4.95q0 .252.072.828.576 3.456 2.322 5.04t5.346 2.628q1.044.288 1.764.558t1.62.774 1.386 1.242.486 1.674v.18q.036 2.088-1.458 3.348t-3.618 1.26q-3.492 0-6.012-5.184-.828-1.692-1.854-4.374t-1.728-4.518-1.944-3.978-2.664-3.438-3.726-2.178-5.292-.882q-3.636 0-6.912 2.016t-5.184 5.328-1.8 6.912v.036q.144 3.888 1.818 7.164t4.806 5.31 7.056 2.034q6.696 0 10.044-3.96.72-.972 1.116-1.836l-2.16-3.924q-1.512 2.88-3.564 4.176t-5.256 1.296q-4.14 0-6.876-3.132t-2.736-7.344q0-3.78 2.952-6.804t6.696-3.024q4.032 0 6.12 1.926t3.744 6.21q.288.756.918 2.466t1.026 2.754 1.134 2.682 1.386 2.664 1.638 2.25 1.998 1.926 2.376 1.188 2.88.486q3.852 0 6.588-2.502t2.736-6.282zm3.744-22.896v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"TOGGLE_OFF\":\"M41.472-32.183q0-3.744-1.458-7.146t-3.942-5.886-5.886-3.942-7.146-1.458-7.146 1.458-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458 7.146-1.458 5.886-3.942 3.942-5.886 1.458-7.146zm27.648 0q0-3.744-1.458-7.146t-3.942-5.886-5.886-3.942-7.146-1.458h-13.896q4.284 3.24 6.786 8.064t2.502 10.368-2.502 10.368-6.786 8.064h13.896q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146zm4.608 0q0 4.68-1.836 8.946t-4.914 7.344-7.344 4.914-8.946 1.836h-27.648q-4.68 0-8.946-1.836t-7.344-4.914-4.914-7.344-1.836-8.946 1.836-8.946 4.914-7.344 7.344-4.914 8.946-1.836h27.648q4.68 0 8.946 1.836t7.344 4.914 4.914 7.344 1.836 8.946z\",\"TOGGLE_ON\":\"M0-32.183q0-4.68 1.836-8.946t4.914-7.344 7.344-4.914 8.946-1.836h27.648q4.68 0 8.946 1.836t7.344 4.914 4.914 7.344 1.836 8.946-1.836 8.946-4.914 7.344-7.344 4.914-8.946 1.836h-27.648q-4.68 0-8.946-1.836t-7.344-4.914-4.914-7.344-1.836-8.946zm50.688 18.432q3.744 0 7.146-1.458t5.886-3.942 3.942-5.886 1.458-7.146-1.458-7.146-3.942-5.886-5.886-3.942-7.146-1.458-7.146 1.458-5.886 3.942-3.942 5.886-1.458 7.146 1.458 7.146 3.942 5.886 5.886 3.942 7.146 1.458z\",\"BICYCLE\":\"M27.432-22.967h-11.304q-1.44 0-2.07-1.26t.234-2.412l6.768-9.036q-2.34-1.116-4.932-1.116-4.752 0-8.136 3.384t-3.384 8.136 3.384 8.136 8.136 3.384q4.14 0 7.308-2.61t3.996-6.606zm-6.696-4.608h6.696q-.648-3.06-2.7-5.328zm17.28 0l10.368-13.824h-17.28l-3.564 4.752q3.78 3.708 4.536 9.072h5.94zm40.32 2.304q0-4.752-3.384-8.136t-8.136-3.384q-2.16 0-4.356.864l6.264 9.36q.54.828.36 1.764t-.972 1.44q-.54.396-1.296.396-1.26 0-1.908-1.044l-6.264-9.36q-3.348 3.42-3.348 8.1 0 4.752 3.384 8.136t8.136 3.384 8.136-3.384 3.384-8.136zm4.608 0q0 6.66-4.734 11.394t-11.394 4.734-11.394-4.734-4.734-11.394q0-3.492 1.422-6.606t3.942-5.382l-2.34-3.528-12.708 16.884q-.648.936-1.836.936h-7.092q-.828 5.904-5.364 9.864t-10.584 3.96q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q4.104 0 7.74 1.98l4.932-6.588h-8.064q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h13.824v4.608h15.66l-3.06-4.608h-7.992q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q1.188 0 1.908 1.008l9.612 14.4q3.276-1.584 6.912-1.584 6.66 0 11.394 4.734t4.734 11.394z\",\"BUS\":\"M13.824-20.663q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm36.864 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm-1.656-14.256l-2.592-13.824q-.18-.828-.81-1.35t-1.458-.522h-33.048q-.828 0-1.458.522t-.81 1.35l-2.592 13.824q-.18 1.08.504 1.908t1.764.828h38.232q1.08 0 1.764-.828t.504-1.908zm-8.136-22.032q0-.72-.504-1.224t-1.224-.504h-23.04q-.72 0-1.224.504t-.504 1.224.504 1.224 1.224.504h23.04q.72 0 1.224-.504t.504-1.224zm14.4 26.1v21.708h-4.608v4.608q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258v-4.608h-27.648v4.608q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258v-4.608h-4.608v-21.708q0-4.032.9-8.028l3.708-16.344q.324-2.808 3.51-4.932t8.28-3.204 11.25-1.08 11.25 1.08 8.28 3.204 3.51 4.932l3.78 16.344q.828 3.672.828 8.028z\",\"IOXHOST\":\"M52.668-34.487q0 1.26-.9 2.178t-2.196.918h-25.272q-1.296 0-2.196-.918t-.9-2.178.9-2.178 2.196-.918h25.272q1.296 0 2.196.918t.9 2.178zm7.704 0q0-3.096-.828-6.12h-35.352q-1.296 0-2.196-.9t-.9-2.16q0-1.296.9-2.196t2.196-.9h32.688q-3.168-5.148-8.46-8.172t-11.52-3.024q-6.372 0-11.79 3.15t-8.568 8.55-3.15 11.772q0 3.096.828 6.12h35.352q1.296 0 2.196.9t.9 2.16q0 1.296-.9 2.196t-2.196.9h-32.688q3.168 5.148 8.478 8.172t11.538 3.024q4.752 0 9.108-1.854t7.488-5.004 5.004-7.488 1.872-9.126zm13.356-9.18q0 1.26-.9 2.16t-2.196.9h-4.716q.612 3.06.612 6.12 0 6.012-2.358 11.502t-6.318 9.468-9.45 6.336-11.502 2.358q-8.856 0-16.146-4.788t-10.854-12.6h-6.804q-1.296 0-2.196-.9t-.9-2.196q0-1.26.9-2.16t2.196-.9h4.752q-.612-3.06-.612-6.12 0-6.012 2.358-11.502t6.318-9.468 9.45-6.336 11.538-2.358q8.82 0 16.11 4.788t10.854 12.6h6.768q1.296 0 2.196.9t.9 2.196z\",\"ANGELLIST\":\"M34.308-50.831l-4.104 11.808 4.212.756q5.94-16.236 5.94-18.648 0-2.016-1.368-2.016-2.052 0-4.68 8.1zm-10.764 24.732l1.188 3.168q1.332-1.512 2.556-2.412l-1.188-.198-1.386-.252-1.17-.306zm-10.512-32.256q0 3.528 5.724 18.756.648-.36 1.764-.36.54 0 2.7.18l-4.356-12.636q-2.7-7.92-4.428-7.92-.684 0-1.044.63t-.36 1.35zm-2.844 27.324q0 1.296 1.854 4.284t4.23 5.508 3.6 2.52q.504 0 .918-.468t.414-.972q0-.864-1.152-3.672-.468-1.152-1.152-2.592t-1.71-3.204-2.214-2.916-2.232-1.152q-.72 0-1.638.972t-.918 1.692zm-5.688 12.06q0 1.476.9 3.744 2.124 5.22 6.606 8.172t10.134 2.952q8.172 0 13.752-6.12 5.472-6.084 5.472-15.372 0-1.548-.036-2.412t-.414-2.232-1.098-2.016q-2.016-1.764-7.614-2.718t-9.738-.954q-1.332 0-1.764.396-.432.18-.432 1.26 0 1.224.774 2.16t1.998 1.44 2.79.846 3.15.414 3.06.144 2.52 0h.828q.864 0 1.44.684.54.684.684 1.98-1.008 1.008-3.456 1.944-2.196.792-3.348 1.656-2.304 1.656-3.906 4.104t-1.602 4.932q0 1.116.666 3.186t.666 3.15l-.108.432q-.144.432-.144.504-4.932-.36-5.256-7.776-.288.072-1.476.072.072.252.072.756 0 1.908-1.458 3.222t-3.402 1.314q-2.952 0-5.994-2.808t-3.042-5.724q0-1.224 1.188-2.412 1.872 2.304 2.16 2.736 2.772 3.744 4.788 3.744.432 0 .954-.306t.522-.738q0-1.224-3.15-5.22t-4.194-3.996q-1.548 0-2.52 1.602t-.972 3.258zm-4.104.324q0-3.636 1.53-5.868t4.914-3.168q-1.008-2.664-1.008-3.744 0-2.232 2.196-4.428t4.392-2.196q1.044 0 2.52.54-5.868-16.632-5.868-20.412 0-2.88 1.476-4.698t4.284-1.818q4.716 0 11.7 20.916l.288.828q.216-.576 1.044-2.862t1.566-4.266 1.944-4.59 2.322-4.428 2.538-3.114 2.754-1.296q2.556 0 4.032 1.764t1.476 4.392q0 3.888-5.724 19.8 2.196.54 3.618 1.656t2.106 2.808.936 3.366.252 3.978q0 5.4-1.692 10.08t-4.752 8.1-7.596 5.4-10.008 1.98q-3.996 0-8.028-1.512-5.364-2.052-9.288-6.894t-3.924-10.314z\",\"CC\":\"M28.26-28.151h7.452q-.504 5.688-3.546 8.946t-7.722 3.258q-5.832 0-9.162-4.176t-3.33-11.376q0-6.984 3.348-11.214t8.388-4.23q5.328 0 8.352 3.132t3.492 8.892h-7.308q-.18-2.304-1.278-3.564t-2.934-1.26q-2.052 0-3.186 2.178t-1.134 6.39q0 1.728.18 3.024t.648 2.502 1.44 1.854 2.376.648q3.42 0 3.924-5.004zm25.632 0h7.416q-.504 5.688-3.528 8.946t-7.704 3.258q-5.832 0-9.162-4.176t-3.33-11.376q0-6.984 3.348-11.214t8.388-4.23q5.328 0 8.352 3.132t3.492 8.892h-7.344q-.144-2.304-1.26-3.564t-2.916-1.26q-2.052 0-3.186 2.178t-1.134 6.39q0 1.728.18 3.024t.648 2.502 1.422 1.854 2.358.648q1.764 0 2.754-1.368t1.206-3.636zm12.924-4.284q0-7.452-.558-11.052t-2.178-5.796q-.216-.288-.486-.504t-.774-.54-.576-.396q-3.096-2.268-25.092-2.268-22.5 0-25.56 2.268-.18.144-.63.414t-.756.504-.522.522q-1.62 2.16-2.16 5.742t-.54 11.106q0 7.488.54 11.07t2.16 5.778q.216.288.54.54t.738.504.63.432q1.584 1.188 8.622 1.764t16.938.576q21.96 0 25.092-2.34.18-.144.612-.396t.738-.504.486-.576q1.656-2.16 2.196-5.724t.54-11.124zm6.912-27.396v55.296h-73.728v-55.296h73.728z\",\"SHEQEL\":\"M35.712-41.975v17.856q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-17.856q0-4.032-2.88-6.912t-6.912-2.88h-9.792v41.472q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-48.384q0-.504.324-.828t.828-.324h16.704q4.86 0 8.964 2.394t6.498 6.498 2.394 8.964zm13.824-16.704v31.68q0 4.86-2.394 8.964t-6.498 6.498-8.964 2.394h-16.704q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828v27.648h9.792q4.032 0 6.912-2.88t2.88-6.912v-31.68q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828z\",\"MEANPATH\":\"M47.196-34.127v4.104q0 .864-.486 1.368t-1.35.504h-7.272q-.864 0-1.368-.504t-.504-1.368v-4.104q0-.864.504-1.368t1.368-.504h7.272q.864 0 1.35.504t.486 1.368zm-17.64 8.28v-9q0-1.908-1.17-3.078t-3.078-1.17h-4.788q-2.448 0-3.456 1.872-1.008-1.872-3.456-1.872h-4.68q-1.908 0-3.078 1.17t-1.17 3.078v9q0 .792.756.792h1.98q.792 0 .792-.792v-8.28q0-.864.486-1.368t1.386-.504h3.384q.864 0 1.368.504t.504 1.368v8.28q0 .792.756.792h1.944q.792 0 .792-.792v-8.28q0-.864.504-1.368t1.368-.504h3.492q.864 0 1.35.504t.486 1.368v8.28q0 .792.792.792h1.98q.756 0 .756-.792zm21.204-3.456v-5.544q0-1.908-1.188-3.078t-3.096-1.17h-9.504q-1.908 0-3.096 1.17t-1.188 3.078v14.76q0 .756.792.756h1.98q.756 0 .756-.756v-6.48q1.116 1.512 3.384 1.512h6.876q1.908 0 3.096-1.17t1.188-3.078zm4.536-22.176v38.592q0 3.456-2.448 5.904t-5.904 2.448h-38.592q-3.456 0-5.904-2.448t-2.448-5.904v-38.592q0-3.456 2.448-5.904t5.904-2.448h38.592q3.456 0 5.904 2.448t2.448 5.904z\",\"BUYSELLADS\":\"M32.94-25.343h-10.584l5.292-19.836zm3.096 11.592h11.196l-11.664-36.864h-15.84l-11.664 36.864h11.196l13.788-11.304zm19.26-35.712v34.56q0 4.248-3.06 7.308t-7.308 3.06h-34.56q-4.248 0-7.308-3.06t-3.06-7.308v-34.56q0-4.248 3.06-7.308t7.308-3.06h34.56q4.248 0 7.308 3.06t3.06 7.308z\",\"CONNECTDEVELOP\":\"M73.728-32.219q0 .756-.468 1.314t-1.188.702l-7.38 12.816q.108.324.108.648 0 .72-.45 1.278t-1.17.702l-6.948 12.132q.108.288.108.576 0 .828-.594 1.44t-1.458.612q-.9 0-1.476-.648h-14.4q-.612.72-1.548.72t-1.548-.72h-14.364q-.612.72-1.548.72-.828 0-1.44-.594t-.612-1.458q0-.288.144-.72l-6.948-12.06q-.72-.144-1.17-.702t-.45-1.278q0-.324.108-.648l-7.416-12.816q-.72-.18-1.17-.738t-.45-1.278q0-.756.486-1.314t1.206-.702l7.164-12.384-.018-.108-.018-.108q0-1.296 1.224-1.836l7.524-13.068q-.144-.36-.144-.648 0-.864.612-1.458t1.44-.594q.936 0 1.584.756h14.256q.576-.756 1.548-.756t1.548.756h14.328q.648-.756 1.584-.756.828 0 1.44.594t.612 1.458q0 .216-.144.648l7.452 12.888q.828.036 1.404.63t.576 1.386q0 .468-.252.972l6.732 11.664q.684.144 1.134.702t.45 1.278zm-35.46 28.764h14.004l-12.312-12.744h-5.148l-12.312 12.744h12.96q.648-.576 1.404-.576t1.404.576zm-34.236-29.232q.036.144.036.468 0 .36-.072.54l7.488 12.96.162.036.198.09.18.09 6.768-7.164v-12.492l-6.732-6.984q-.468.288-1.044.36zm31.464-28.224h-13.968l6.84 7.2 19.944-7.2h-10.08q-.576.576-1.368.576t-1.368-.576zm25.308 43.632q.036-.216.18-.396l-2.304-2.448-.612 2.844h2.736zm-3.816 0l.792-3.78-9.072-9.576-10.656 11.052 2.268 2.304h16.668zm-3.168 13.248l.576-1.008 2.34-11.16h-15.372l11.988 12.348q.288-.144.468-.18zm-33.012.576h.18l12.312-12.744h-13.428v12.06l.144.216q.504.18.792.468zm-.936-13.824h14.472l2.304-2.376-11.124-11.556-5.652 5.976v7.956zm-6.948 0h5.868v-6.804l-6.048 6.372q.144.288.18.432zm-.036-29.7l.018.072.018.072q0 .576-.288 1.044l6.156 6.372v-9.684zm6.984-2.52v11.196l5.508 5.652 10.692-11.304-8.028-8.496zm.144-10.944l-.144.288v9.504l7.38-2.664-6.876-7.236-.36.108zm32.076-.468h-.576l-22.356 8.064 7.668 8.1zm-15.264 17.712l-10.692 11.34 11.196 11.484 10.656-11.052zm-12.06 11.232l-4.896-5.076v10.224zm12.6 13.104l-1.512 1.584h3.06zm12.096-12.528l8.568 9.036 4.752-22.464-.108-.18-.036-.036zm12.384-14.4q-.288-.468-.288-1.044v-.072l-7.776-13.536q-.18-.036-.468-.18l-15.732 16.668 11.16 11.772zm-43.056-4.464v-8.028l-5.868 10.152zm0 34.056h-5.868l5.868 10.188v-10.188zm39.06 0l-1.728 8.172 4.68-8.172h-2.952zm4.392-2.52l7.452-12.996q-.072-.36-.072-.504l.108-.576-6.156-10.656-4.644 22.032 2.772 2.952q.18-.108.54-.252z\",\"DASHCUBE\":\"M0-39.959q0-4.716 3.294-8.154t8.01-3.438h26.712l12.672-12.888v52.92q0 4.752-3.294 8.172t-8.01 3.42h-28.08q-4.716 0-8.01-3.42t-3.294-8.172v-28.44zm44.352 27.144l-6.336-6.48v-15.3q0-1.656-1.152-2.844t-2.808-1.188h-17.424q-1.656 0-2.808 1.188t-1.152 2.844v17.712q0 1.656 1.17 2.862t2.79 1.206h27.72z\",\"FORUMBEE\":\"M33.624-59.039q-11.412 4.356-20.016 13.05t-12.888 20.178q-.72-3.204-.72-6.336 0-7.488 3.69-13.842t10.026-10.044 13.824-3.69q2.952 0 6.084.684zm9.684 4.284q3.348 2.34 5.904 5.58-14.004 4.068-24.282 14.418t-14.274 24.354q-3.348-2.592-5.58-5.832 4.032-13.896 14.22-24.156t24.012-14.364zm-26.388 48.024q4.14-12.816 13.662-22.392t22.302-13.824q1.44 3.312 1.944 7.02-10.512 4.32-18.576 12.42t-12.348 18.648q-3.708-.504-6.984-1.872zm38.376 2.088q-6.948-1.8-13.212-4.14-4.86 3.024-10.44 3.852 3.924-7.38 9.864-13.338t13.284-9.918q-.756 5.472-3.636 10.224 2.34 6.3 4.14 13.32z\",\"LEANPUB\":\"M68.148-50.327l5.58 45.792q-4.716 0-9.252-2.052-7.2-3.276-14.148-3.276-8.136 0-13.464 5.328-5.328-5.328-13.464-5.328-6.948 0-14.148 3.276-4.608 2.052-9.072 2.052h-.18l5.58-45.792q8.064-4.572 17.352-4.572 8.388 0 13.932 3.816 5.544-3.816 13.932-3.816 9.288 0 17.352 4.572zm-17.82 35.532q4.644 0 8.352 1.026t9.36 3.366l-4.464-36.756q-6.156-2.808-13.248-2.808-8.064 0-13.464 5.076-5.4-5.076-13.464-5.076-7.092 0-13.248 2.808l-4.464 36.756q3.78-1.548 5.958-2.34t5.346-1.422 6.408-.63q7.272 0 13.464 3.888 6.192-3.888 13.464-3.888zm1.44-1.224l-1.98-32.652q-7.596.144-12.924 5.58-5.472-5.58-13.464-5.58-6.336 0-12.096 2.376l-4.104 33.876q4.464-1.836 8.226-2.736t7.974-.9q7.524 0 13.464 3.672 6.192-3.852 13.464-3.672z\",\"SELLSY\":\"M54-15.083v-26.388q0-.756-.54-1.296t-1.26-.54h-3.348q-.72 0-1.26.54t-.54 1.296v26.388q0 .72.54 1.26t1.26.54h3.348q.72 0 1.26-.54t.54-1.26zm-10.224 0v-19.116q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v19.116q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm-10.512 0v-15.444q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v15.444q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm-10.512 0v-13.032q0-.72-.54-1.26t-1.26-.54h-3.636q-.72 0-1.26.54t-.54 1.26v13.032q0 .72.54 1.26t1.26.54h3.636q.72 0 1.26-.54t.54-1.26zm50.976-5.256q0 5.976-4.248 10.224t-10.224 4.248h-44.784q-5.976 0-10.224-4.248t-4.248-10.224q0-4.176 2.268-7.722t6.048-5.346q-.36-1.224-.36-2.628 0-4.068 2.898-6.966t6.966-2.898q3.672 0 6.48 2.412 1.62-6.588 6.984-10.8t12.168-4.212q5.364 0 9.9 2.646t7.182 7.182 2.646 9.9q0 2.376-.504 4.392 4.86 1.188 7.956 5.13t3.096 8.91z\",\"SHIRTSINBULK\":\"M0-64.439h55.296v50.112l-27.936 12.168-27.36-12.168v-50.112zm51.696 47.772v-33.336h-48.096v33.336l23.796 10.584zm0-36.936v-7.236h-48.096v7.236h48.096zm-45.18 10.728v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm0 5.328v4.14h-1.332v-4.14h1.332zm.936 5.148l.54-1.224 3.78 1.692-.54 1.188zm4.896 2.16l.54-1.224 3.78 1.656-.54 1.224zm4.86 2.16l.54-1.224 3.78 1.656-.54 1.224zm4.896 2.124l.54-1.188 3.744 1.656-.54 1.224zm6.588.468l3.78-1.656.54 1.188-3.78 1.692zm4.86-2.16l3.78-1.656.54 1.224-3.78 1.656zm4.896-2.16l3.78-1.656.54 1.224-3.78 1.656zm4.86-2.124l3.78-1.692.54 1.224-3.78 1.656zm-33.984-43.2v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm-43.56 12.24v2.844h-1.332v-4.14h4.14v1.296h-2.808zm8.64-1.296v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm5.796 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.104v-1.296h4.104zm5.832 0v1.296h-4.14v-1.296h4.14zm5.832 0v1.296h-4.14v-1.296h4.14zm4.5 4.14v-2.844h-2.808v-1.296h4.14v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm0 5.328v-4.14h1.332v4.14h-1.332zm-21.42-1.26q-4.644 0-7.956-3.294t-3.312-7.974q0-4.644 3.312-7.956t7.956-3.312q4.68 0 7.974 3.312t3.294 7.956q0 4.68-3.294 7.974t-7.974 3.294zm-5.94-13.716q0 1.296.702 2.034t1.782.9 2.304.252 2.304.072 1.782.324.702 1.098q0 1.764-4.032 1.764-3.492 0-4.428-1.836h-.108l-1.116 2.268q2.412 1.512 5.832 1.512 1.044 0 2.034-.18t1.998-.576 1.638-1.188.63-1.908q0-1.656-.99-2.502t-2.43-.972-2.862-.108-2.412-.18-.99-.918q0-.756.738-1.188t1.458-.54 1.476-.108q1.224 0 2.538.396t1.854 1.224h.108l1.08-2.088q-.108-.036-.756-.306t-.81-.324-.702-.252-.792-.252-.72-.162-.864-.144-.828-.036q-1.044 0-2.034.18t-1.944.594-1.548 1.224-.594 1.926z\",\"SIMPLYBUILT\":\"M31.068-27.287q0-4.032-2.862-6.894t-6.894-2.862-6.876 2.862-2.844 6.894 2.844 6.876 6.876 2.844 6.894-2.844 2.862-6.876zm31.068-.036q0-4.032-2.844-6.876t-6.876-2.844-6.894 2.844-2.862 6.876q0 4.068 2.862 6.912t6.894 2.844 6.876-2.862 2.844-6.894zm11.592-29.124v48.528q0 1.584-1.134 2.718t-2.754 1.134h-65.952q-1.62 0-2.754-1.134t-1.134-2.718v-48.528q0-1.584 1.134-2.718t2.754-1.134h15.516q1.584 0 2.736 1.134t1.152 2.718v5.796h27.144v-5.796q0-1.584 1.152-2.718t2.736-1.134h15.516q1.62 0 2.754 1.134t1.134 2.718z\",\"SKYATLAS\":\"M51.48-43.451zm9.36 7.344q5.328 0 9.108 3.546t3.78 8.802q0 5.652-3.924 9.414t-9.612 3.762q-3.06 0-5.832-.99t-4.968-2.646-4.248-3.816-3.924-4.554-3.726-4.77-3.906-4.536-4.212-3.816-4.896-2.646-5.724-.99q-5.544 0-9.054 3.294t-3.51 8.802q0 5.652 3.744 9t9.468 3.348q3.6 0 7.488-1.35t6.948-3.546q.18-.144.756-.666t1.08-.864.792-.342q.504 0 .882.378t.378.882q0 .864-2.16 2.772-3.636 3.168-8.442 5.112t-9.378 1.944q-4.788 0-8.838-2.088t-6.48-5.94-2.43-8.676q0-7.38 5.094-12.276t12.51-4.896q4.32 0 8.154 1.566t6.678 4.068 5.454 5.508 5.004 6.03 4.806 5.526 5.382 4.068 6.21 1.566q3.672 0 6.066-2.214t2.394-5.85q0-3.42-2.322-5.724t-5.742-2.304q-1.08 0-2.934.666t-2.466.666q-.72 0-1.278-.54t-.558-1.26q0-.648.306-2.052t.306-2.124q0-5.724-3.87-9.468t-9.594-3.744q-2.088 0-4.014.666t-3.024 1.458-1.998 1.458-1.188.666q-.54 0-.918-.378t-.378-.918q0-.684.9-1.656 2.124-2.412 5.292-3.726t6.552-1.314q6.876 0 11.448 4.518t4.572 11.358q0 1.332-.144 2.376 2.052-.54 4.14-.54z\",\"CART_PLUS\":\"M43.776-39.095q0-.936-.684-1.62t-1.62-.684h-4.608v-4.608q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v4.608h-4.608q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684h4.608v4.608q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62v-4.608h4.608q.936 0 1.62-.684t.684-1.62zm-20.736 29.952q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm32.256 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm4.608-39.168v18.432q0 .864-.576 1.53t-1.476.774l-37.584 4.392q.036.252.162.774t.216.954.09.792q0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.504.396-1.422t1.062-2.142.738-1.368l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.72.558.468.882.27.954.198 1.062.162.918h43.236q.936 0 1.62.684t.684 1.62z\",\"CART_ARROW_DOWN\":\"M46.08-39.095q0-.936-.684-1.62t-1.62-.684-1.62.684l-5.292 5.256v-10.548q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v10.548l-5.292-5.256q-.684-.684-1.62-.684t-1.62.684-.684 1.62.684 1.62l9.216 9.216q.684.684 1.62.684t1.62-.684l9.216-9.216q.684-.684.684-1.62zm-23.04 29.952q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm32.256 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm4.608-39.168v18.432q0 .864-.576 1.53t-1.476.774l-37.584 4.392q.036.252.162.774t.216.954.09.792q0 .576-.864 2.304h33.12q.936 0 1.62.684t.684 1.62-.684 1.62-1.62.684h-36.864q-.936 0-1.62-.684t-.684-1.62q0-.504.396-1.422t1.062-2.142.738-1.368l-6.372-29.628h-7.344q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h9.216q.576 0 1.026.234t.72.558.468.882.27.954.198 1.062.162.918h43.236q.936 0 1.62.684t.684 1.62z\",\"DIAMOND\":\"M7.632-36.791l22.428 23.94-10.8-23.94h-11.628zm29.232 27.792l12.564-27.792h-25.128zm-17.496-32.4l7.344-13.824h-9.432l-10.368 13.824h12.456zm24.3 28.548l22.428-23.94h-11.628zm-19.08-28.548h24.552l-7.344-13.824h-9.864zm29.772 0h12.456l-10.368-13.824h-9.432zm5.076-17.496l13.824 18.432q.504.648.468 1.494t-.612 1.458l-34.56 36.864q-.648.72-1.692.72t-1.692-.72l-34.56-36.864q-.576-.612-.612-1.458t.468-1.494l13.824-18.432q.648-.936 1.836-.936h41.472q1.188 0 1.836.936z\",\"SHIP\":\"M65.196-8.459q.684-.684 1.62-.684t1.62.684l4.608 4.608-3.24 3.24-2.988-2.988-2.988 2.988q-.648.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-4.608-4.608 3.24-3.24 2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988 2.988-2.988q.684-.684 1.62-.684t1.62.684l2.988 2.988zm-56.664-1.368q-.684.684-1.62.684t-1.62-.684l-4.608-4.608 3.24-3.24 2.988 2.952 2.988-2.952q.684-.684 1.62-.684t1.62.684l2.988 2.952 2.304-2.304v-10.548l-7.56-11.304q-.612-.936-.252-2.034t1.44-1.458l6.372-2.088v-10.764h4.608v-4.608h9.216v-4.608h9.216v4.608h9.216v4.608h4.608v10.764l6.372 2.088q1.08.36 1.44 1.458t-.252 2.034l-7.56 11.304v10.548l.684-.648q.684-.684 1.62-.684t1.62.684l2.988 2.952 2.988-2.952q.684-.684 1.62-.684t1.62.684l4.608 4.608-3.24 3.24-2.988-2.988-2.988 2.988q-.648.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988-2.988 2.988q-.684.684-1.62.684t-1.62-.684l-2.988-2.988zm14.508-40.788v4.608l13.824-4.608 13.824 4.608v-4.608h-4.608v-4.608h-18.432v4.608h-4.608z\",\"USER_SECRET\":\"M20.736-9.143l3.456-16.128-3.456-4.608-4.608-2.304zm9.216 0l4.608-23.04-4.608 2.304-3.456 4.608zm5.76-36.36q-.072-.144-.144-.216-.36-.288-3.456-.288-2.52 0-6.012.684-.252.072-.756.072t-.756-.072q-3.492-.684-6.012-.684-3.096 0-3.456.288-.072.072-.144.216.072.648.144.972.072.108.27.234t.27.378q.072.144.27.738t.252.738.27.612.306.612.324.504.432.486.504.342.63.288.738.144.882.072q1.296 0 2.124-.45t1.17-1.08.522-1.242.414-1.062.63-.45h.432q.396 0 .63.45t.414 1.062.522 1.242 1.17 1.08 2.124.45q.468 0 .882-.072t.738-.144.63-.288.504-.342.432-.486.324-.504.306-.612.27-.612.252-.738.27-.738q.072-.252.27-.378t.27-.234q.072-.324.144-.972zm14.976 31.644q0 4.356-2.628 6.84t-6.984 2.484h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-2.196.162-4.248t.684-4.518 1.35-4.446 2.286-3.726 3.366-2.682l-3.24-7.92h7.704q-.792-2.304-.792-4.608 0-.432.072-1.152-6.984-1.44-6.984-3.456 0-2.052 7.56-3.564.612-2.232 1.854-4.824t2.538-4.104q1.152-1.332 2.736-1.332 1.08 0 3.024 1.116t3.024 1.116 3.024-1.116 3.024-1.116q1.584 0 2.736 1.332 1.296 1.512 2.538 4.104t1.854 4.824q7.56 1.512 7.56 3.564 0 2.016-6.984 3.456.252 2.916-.72 5.76h7.704l-2.952 8.1q2.268 1.188 3.87 3.474t2.358 5.166 1.044 5.454.288 5.346z\",\"MOTORCYCLE\":\"M82.836-27.143q.432 3.708-.792 7.146t-3.564 5.886-5.706 3.816-7.074 1.116q-5.796-.396-10.062-4.5t-4.842-9.864q-.432-3.996.99-7.578t4.266-6.138l-2.556-3.852q-3.456 2.88-5.436 6.984t-1.98 8.784q0 .972-.666 1.674t-1.638.702h-11.7q-.828 5.904-5.364 9.864t-10.584 3.96q-6.66 0-11.394-4.734t-4.734-11.394 4.734-11.394 11.394-4.734q2.736 0 5.472.972l.864-1.62q-4.428-3.96-10.944-3.96h-2.304q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684h4.608q2.808 0 5.22.486t4.194 1.386 2.574 1.422 1.836 1.314h22.572l-3.06-4.608h-7.992q-1.08 0-1.764-.81t-.504-1.89q.144-.828.828-1.368t1.548-.54h9.108q1.188 0 1.908 1.008l2.52 3.78 4.104-4.104q.684-.684 1.656-.684h3.636q.936 0 1.62.684t.684 1.62v4.608q0 .936-.684 1.62t-1.62.684h-6.444l4.14 6.192q4.716-2.268 9.9-1.296 5.148.936 8.784 4.842t4.248 9.126zm-66.708 13.392q4.14 0 7.308-2.61t3.996-6.606h-11.304q-1.26 0-1.98-1.116-.648-1.152-.036-2.268l5.292-9.972q-1.692-.468-3.276-.468-4.752 0-8.136 3.384t-3.384 8.136 3.384 8.136 8.136 3.384zm50.688 0q4.752 0 8.136-3.384t3.384-8.136-3.384-8.136-8.136-3.384q-2.16 0-4.356.864l6.264 9.36q.54.828.36 1.764t-.972 1.44q-.54.396-1.296.396-1.26 0-1.908-1.044l-6.264-9.36q-3.348 3.42-3.348 8.1 0 4.752 3.384 8.136t8.136 3.384z\",\"STREET_VIEW\":\"M50.688-9.143q0 2.268-2.214 4.086t-5.904 2.916-8.1 1.656-9.126.558-9.126-.558-8.1-1.656-5.904-2.916-2.214-4.086q0-1.764 1.188-3.186t3.276-2.394 4.248-1.602 4.716-1.062q.936-.18 1.728.378t.936 1.494q.18.936-.378 1.728t-1.494.936q-2.088.36-3.816.846t-2.754.918-1.746.846-.99.702-.306.432q.108.396.972.954t2.628 1.188 4.104 1.17 5.778.9 7.254.36 7.254-.36 5.778-.9 4.104-1.188 2.628-1.206.972-.99q-.036-.144-.306-.396t-.99-.684-1.746-.846-2.754-.9-3.816-.846q-.936-.144-1.494-.936t-.378-1.728q.144-.936.936-1.494t1.728-.378q2.556.432 4.716 1.062t4.248 1.602 3.276 2.394 1.188 3.186zm-13.824-32.256v13.824q0 .936-.684 1.62t-1.62.684h-2.304v13.824q0 .936-.684 1.62t-1.62.684h-9.216q-.936 0-1.62-.684t-.684-1.62v-13.824h-2.304q-.936 0-1.62-.684t-.684-1.62v-13.824q0-1.908 1.35-3.258t3.258-1.35h13.824q1.908 0 3.258 1.35t1.35 3.258zm-3.456-13.824q0 3.348-2.358 5.706t-5.706 2.358-5.706-2.358-2.358-5.706 2.358-5.706 5.706-2.358 5.706 2.358 2.358 5.706z\",\"HEARTBEAT\":\"M46.08-27.575h10.98q-.18.216-.36.378t-.324.27l-.108.144-22.428 21.6q-.648.648-1.584.648t-1.584-.648l-22.464-21.672q-.18-.072-.756-.72h13.284q.792 0 1.422-.486t.81-1.242l2.52-10.116 6.84 24.012q.216.72.828 1.188t1.404.468q.756 0 1.368-.468t.828-1.188l5.256-17.46 2.016 4.032q.648 1.26 2.052 1.26zm18.432-15.408q0 5.22-3.708 10.8h-13.284l-3.996-7.956q-.288-.612-.918-.972t-1.314-.288q-1.62.18-2.016 1.656l-4.644 15.48-7.056-24.696q-.216-.72-.846-1.188t-1.422-.468-1.404.486-.792 1.242l-4.176 16.704h-15.228q-3.708-5.58-3.708-10.8 0-7.92 4.572-12.384t12.636-4.464q2.232 0 4.554.774t4.32 2.088 3.438 2.466 2.736 2.448q1.296-1.296 2.736-2.448t3.438-2.466 4.32-2.088 4.554-.774q8.064 0 12.636 4.464t4.572 12.384z\",\"VENUS\":\"M41.472-43.703q0 7.956-5.31 13.842t-13.122 6.75v9.36h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-9.36q-5.4-.576-9.774-3.708t-6.696-8.064-1.89-10.512q.396-4.824 2.898-8.964t6.552-6.768 8.838-3.168q6.12-.684 11.484 1.944t8.496 7.632 3.132 11.016zm-36.864 0q0 6.66 4.734 11.394t11.394 4.734 11.394-4.734 4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394z\",\"MARS\":\"M52.992-59.831q.936 0 1.62.684t.684 1.62v14.976q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-9.432l-13.752 13.788q4.536 5.616 4.536 12.924 0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638q7.308 0 12.924 4.536l13.752-13.752h-9.396q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h14.976zm-32.256 50.688q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"MERCURY\":\"M29.88-53.063q5.22 2.592 8.406 7.578t3.186 10.998q0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842q0-6.012 3.186-10.998t8.406-7.578q-5.94-3.456-8.208-9.828-.216-.576.126-1.062t.954-.486h2.484q.756 0 1.044.72 1.584 3.816 5.04 6.156t7.704 2.34 7.704-2.34 5.04-6.156q.288-.72 1.332-.72h2.196q.612 0 .954.486t.126 1.062q-2.268 6.372-8.208 9.828zm-9.144 34.704q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"TRANSGENDER\":\"M36.864-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q4.536 5.688 4.536 12.924 0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-5.364-.576-9.738-3.708t-6.714-8.046-1.908-10.494q.576-7.344 5.76-12.726t12.492-6.21q4.248-.504 8.208.684t7.128 3.708l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-16.128 44.928q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"TRANSGENDER_ALT\":\"M46.08-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q4.536 5.688 4.536 12.924 0 7.956-5.31 13.842t-13.122 6.75v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-7.812-.864-13.122-6.75t-5.31-13.842q0-7.236 4.536-12.924l-1.872-1.908-3.636 3.996q-.324.36-.792.378t-.828-.27l-1.728-1.584q-.36-.288-.378-.774t.306-.846l3.78-4.14-3.996-4.032v4.824q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-10.368q0-.936.684-1.62t1.62-.684h10.368q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-4.788l3.816 3.852 3.096-3.384q.324-.36.792-.378t.828.27l1.728 1.584q.36.288.378.774t-.306.846l-3.24 3.564 2.052 2.016q5.688-4.536 12.924-4.536t12.924 4.536l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-16.128 44.928q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"VENUS_DOUBLE\":\"M64.44-45.395q.432 5.58-1.89 10.512t-6.696 8.064-9.774 3.708v9.36h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-18.432v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-9.36q-5.4-.576-9.774-3.708t-6.696-8.064-1.89-10.512q.612-7.416 5.922-12.834t12.69-6.102q7.416-.756 13.572 3.384 6.156-4.14 13.572-3.384 7.38.684 12.69 6.102t5.922 12.834zm-32.184 12.96q4.608-4.716 4.608-11.268t-4.608-11.268q-4.608 4.716-4.608 11.268t4.608 11.268zm-11.52 4.86q4.14 0 7.848-2.052-5.544-5.94-5.544-14.076 0-8.064 5.544-14.076-3.708-2.052-7.848-2.052-6.66 0-11.394 4.734t-4.734 11.394 4.734 11.394 11.394 4.734zm20.736 13.824v-9.36q-4.932-.54-9.216-3.384-4.284 2.844-9.216 3.384v9.36h18.432zm2.304-13.824q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734q-4.14 0-7.848 2.052 5.544 6.012 5.544 14.076 0 8.136-5.544 14.076 3.708 2.052 7.848 2.052z\",\"MARS_DOUBLE\":\"M55.296-49.463q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.736 3.42 3.87 7.704t.342 8.892q-1.116 6.552-5.976 11.232t-11.448 5.616q-7.56 1.044-13.842-2.88t-8.694-10.8q-4.212-.216-7.956-2.07t-6.39-4.788-4.086-6.93-1.152-8.28q.324-4.86 2.808-9.072t6.552-6.894 8.928-3.222q4.248-.504 8.19.684t7.146 3.708l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.124 2.664 3.348 6.084 6.552.324 11.808 4.464l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-18.432 14.976q0-.72-.144-2.088-5.832.9-9.756 5.4t-3.924 10.512q0 .72.144 2.088 5.832-.9 9.756-5.4t3.924-10.512zm-32.256 0q0 6.048 3.996 10.584t9.936 5.364q-.108-1.044-.108-2.124 0-7.56 4.86-13.302t12.168-7.074q-1.908-4.32-5.886-6.948t-8.838-2.628q-6.66 0-11.394 4.734t-4.734 11.394zm34.56 29.952q6.66 0 11.394-4.734t4.734-11.394q0-6.048-3.996-10.584t-9.936-5.364q.108 1.044.108 2.124 0 7.56-4.86 13.302t-12.168 7.074q1.908 4.32 5.886 6.948t8.838 2.628z\",\"VENUS_MARS\":\"M59.904-63.287q0-.504.324-.828t.828-.324h10.368q.936 0 1.62.684t.684 1.62v10.368q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.824l-9.144 9.18q2.736 3.42 3.87 7.704t.342 8.892q-1.152 6.48-5.922 11.16t-11.286 5.652q-8.028 1.224-14.724-3.24-4.212 2.808-9.216 3.348v4.752h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456v3.456q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456v-4.752q-5.58-.612-10.062-3.942t-6.732-8.55-1.422-11.052q.9-6.732 5.742-11.61t11.538-5.922q8.064-1.224 14.76 3.24 5.256-3.492 11.52-3.492 7.236 0 12.924 4.536l9.18-9.144h-4.824q-.504 0-.828-.324t-.324-.828v-2.304zm-27.648 40.068q4.608-4.716 4.608-11.268t-4.608-11.268q-4.608 4.716-4.608 11.268t4.608 11.268zm-27.648-11.268q0 6.66 4.734 11.394t11.394 4.734q4.212 0 7.848-2.052-5.544-6.012-5.544-14.076t5.544-14.076q-3.636-2.052-7.848-2.052-6.66 0-11.394 4.734t-4.734 11.394zm39.168 16.128q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734q-4.212 0-7.848 2.052 5.544 6.012 5.544 14.076t-5.544 14.076q3.636 2.052 7.848 2.052z\",\"MARS_STROKE\":\"M52.992-59.831q.936 0 1.62.684t.684 1.62v14.976q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-9.432l-7.668 7.704 5.04 5.04q.324.36.324.828t-.324.792l-1.656 1.656q-.324.324-.792.324t-.828-.324l-5.04-5.076-2.808 2.844q4.536 5.616 4.536 12.924 0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638q7.308 0 12.924 4.536l2.808-2.808-6.192-6.192q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l6.192 6.192 7.668-7.668h-9.396q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h14.976zm-32.256 50.688q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"MARS_STROKE_V\":\"M23.04-41.255q7.812.864 13.122 6.75t5.31 13.842q0 6.012-3.132 11.016t-8.496 7.632-11.484 1.944q-4.788-.54-8.838-3.168t-6.552-6.768-2.898-8.964q-.432-5.58 1.89-10.512t6.696-8.064 9.774-3.708v-4.752h-5.76q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h5.76v-5.94l-3.312 3.312q-.36.324-.828.324t-.792-.324l-1.656-1.656q-.324-.324-.324-.792t.324-.828l7.272-7.236q.684-.684 1.62-.684t1.62.684l7.272 7.236q.324.36.324.828t-.324.792l-1.656 1.656q-.324.324-.792.324t-.828-.324l-3.312-3.312v5.94h5.76q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-5.76v4.752zm-2.304 36.72q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"MARS_STROKE_H\":\"M68.436-31.499q.684.684.684 1.62t-.684 1.62l-10.584 10.584q-.324.36-.81.36t-.81-.36l-1.62-1.62q-.36-.324-.36-.81t.36-.81l6.66-6.66h-10.584v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-4.752q-.864 7.812-6.75 13.122t-13.842 5.31q-6.012 0-11.016-3.132t-7.632-8.496-1.944-11.484q.54-4.788 3.168-8.838t6.768-6.552 8.964-2.898q5.58-.432 10.512 1.89t8.064 6.696 3.708 9.774h4.752v-8.064q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v8.064h10.584l-6.66-6.66q-.36-.324-.36-.81t.36-.81l1.62-1.62q.324-.36.81-.36t.81.36zm-47.7 17.748q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"NEUTER\":\"M41.472-43.703q0 7.956-5.31 13.842t-13.122 6.75v22.032q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-22.032q-7.812-.864-13.122-6.75t-5.31-13.842q0-4.212 1.638-8.046t4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046zm-20.736 16.128q6.66 0 11.394-4.734t4.734-11.394-4.734-11.394-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734z\",\"GENDERLESS\":\"M36.864-29.879q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394 4.734 11.394 11.394 4.734 11.394-4.734 4.734-11.394zm4.608 0q0 4.212-1.638 8.046t-4.428 6.624-6.624 4.428-8.046 1.638-8.046-1.638-6.624-4.428-4.428-6.624-1.638-8.046 1.638-8.046 4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046z\",\"FACEBOOK_OFFICIAL\":\"M52.236-59.831q1.26 0 2.16.9t.9 2.16v49.176q0 1.26-.9 2.16t-2.16.9h-14.076v-21.42h7.164l1.08-8.352h-8.244v-5.328q0-2.016.846-3.024t3.294-1.008l4.392-.036v-7.452q-2.268-.324-6.408-.324-4.896 0-7.83 2.88t-2.934 8.136v6.156h-7.2v8.352h7.2v21.42h-26.46q-1.26 0-2.16-.9t-.9-2.16v-49.176q0-1.26.9-2.16t2.16-.9h49.176z\",\"PINTEREST_P\":\"M0-42.947q0-3.888 1.35-7.326t3.726-5.994 5.472-4.428 6.66-2.808 7.272-.936q5.688 0 10.584 2.394t7.956 6.966 3.06 10.332q0 3.456-.684 6.768t-2.16 6.372-3.6 5.382-5.22 3.708-6.804 1.386q-2.448 0-4.86-1.152t-3.456-3.168q-.36 1.404-1.008 4.05t-.846 3.42-.738 2.556-.936 2.556-1.152 2.25-1.656 2.79-2.232 3.114l-.504.18-.324-.36q-.54-5.652-.54-6.768 0-3.312.774-7.434t2.394-10.35 1.872-7.308q-1.152-2.34-1.152-6.084 0-2.988 1.872-5.616t4.752-2.628q2.196 0 3.42 1.458t1.224 3.69q0 2.376-1.584 6.876t-1.584 6.732q0 2.268 1.62 3.762t3.924 1.494q1.98 0 3.672-.9t2.826-2.448 2.016-3.42 1.368-3.978.72-3.996.234-3.582q0-6.228-3.942-9.702t-10.278-3.474q-7.2 0-12.024 4.662t-4.824 11.826q0 1.584.45 3.06t.972 2.34.972 1.638.45 1.098q0 1.008-.54 2.628t-1.332 1.62q-.072 0-.612-.108-1.836-.54-3.258-2.016t-2.196-3.402-1.17-3.888-.396-3.834z\",\"WHATSAPP\":\"M35.46-29.375q.468 0 3.51 1.584t3.222 1.908q.072.18.072.54 0 1.188-.612 2.736-.576 1.404-2.556 2.358t-3.672.954q-2.052 0-6.84-2.232-3.528-1.62-6.12-4.248t-5.328-6.66q-2.592-3.852-2.556-6.984v-.288q.108-3.276 2.664-5.688.864-.792 1.872-.792.216 0 .648.054t.684.054q.684 0 .954.234t.558.99q.288.72 1.188 3.168t.9 2.7q0 .756-1.242 2.07t-1.242 1.674q0 .252.18.54 1.224 2.628 3.672 4.932 2.016 1.908 5.436 3.636.432.252.792.252.54 0 1.944-1.746t1.872-1.746zm-7.308 19.08q4.572 0 8.766-1.8t7.218-4.824 4.824-7.218 1.8-8.766-1.8-8.766-4.824-7.218-7.218-4.824-8.766-1.8-8.766 1.8-7.218 4.824-4.824 7.218-1.8 8.766q0 7.308 4.32 13.248l-2.844 8.388 8.712-2.772q5.688 3.744 12.42 3.744zm0-49.752q5.508 0 10.53 2.16t8.658 5.796 5.796 8.658 2.16 10.53-2.16 10.53-5.796 8.658-8.658 5.796-10.53 2.16q-7.02 0-13.14-3.384l-15.012 4.824 4.896-14.58q-3.888-6.408-3.888-14.004 0-5.508 2.16-10.53t5.796-8.658 8.658-5.796 10.53-2.16z\",\"SERVER\":\"M4.608-13.751h36.864v-4.608h-36.864v4.608zm0-18.432h36.864v-4.608h-36.864v4.608zm56.448 16.128q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm-56.448-34.56h36.864v-4.608h-36.864v4.608zm56.448 16.128q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm0-18.432q0-1.44-1.008-2.448t-2.448-1.008-2.448 1.008-1.008 2.448 1.008 2.448 2.448 1.008 2.448-1.008 1.008-2.448zm3.456 29.952v13.824h-64.512v-13.824h64.512zm0-18.432v13.824h-64.512v-13.824h64.512zm0-18.432v13.824h-64.512v-13.824h64.512z\",\"USER_PLUS\":\"M25.344-32.183q-5.724 0-9.774-4.05t-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774-4.05 9.774-9.774 4.05zm34.56 4.608h12.672q.468 0 .81.342t.342.81v6.912q0 .468-.342.81t-.81.342h-12.672v12.672q0 .468-.342.81t-.81.342h-6.912q-.468 0-.81-.342t-.342-.81v-12.672h-12.672q-.468 0-.81-.342t-.342-.81v-6.912q0-.468.342-.81t.81-.342h12.672v-12.672q0-.468.342-.81t.81-.342h6.912q.468 0 .81.342t.342.81v12.672zm-26.496 8.064q0 1.872 1.368 3.24t3.24 1.368h9.216v8.568q-2.448 1.8-6.156 1.8h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.684 0 1.404.612 2.844 2.196 5.562 3.294t5.922 1.098 5.922-1.098 5.562-3.294q.72-.612 1.404-.612 4.752 0 7.812 3.456h-8.028q-1.872 0-3.24 1.368t-1.368 3.24v6.912z\",\"USER_TIMES\":\"M25.344-32.183q-5.724 0-9.774-4.05t-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774-4.05 9.774-9.774 4.05zm38.772 11.52l8.964 8.964q.324.324.324.828 0 .468-.324.792l-4.896 4.896q-.324.324-.792.324-.504 0-.828-.324l-8.964-8.964-8.964 8.964q-.324.324-.828.324-.468 0-.792-.324l-4.896-4.896q-.324-.324-.324-.792 0-.504.324-.828l8.964-8.964-8.964-8.964q-.324-.324-.324-.828 0-.468.324-.792l4.896-4.896q.324-.324.792-.324.504 0 .828.324l8.964 8.964 8.964-8.964q.324-.324.828-.324.468 0 .792.324l4.896 4.896q.324.324.324.792 0 .504-.324.828zm-17.928 0l-6.516 6.516q-1.332 1.332-1.332 3.276 0 1.908 1.332 3.24l2.988 2.988q-.756.108-1.584.108h-31.464q-4.356 0-6.984-2.484t-2.628-6.84q0-1.908.126-3.726t.504-3.924.954-3.906 1.548-3.51 2.232-2.916 3.078-1.926 4.014-.72q.684 0 1.404.612 5.544 4.392 11.484 4.392t11.484-4.392q.72-.612 1.404-.612 1.008 0 2.052.216-1.008.972-1.476 1.8t-.468 2.016q0 1.944 1.332 3.276z\",\"HOTEL\":\"M9.216-27.575h62.208q.936 0 1.62.684t.684 1.62v16.128h-9.216v-9.216h-55.296v9.216h-9.216v-43.776q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v25.344zm20.736-11.52q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm43.776 9.216v-2.304q0-5.724-4.05-9.774t-9.774-4.05h-25.344q-.936 0-1.62.684t-.684 1.62v13.824h41.472z\",\"VIACOIN\":\"M55.296-64.439l-6.912 16.128h6.912v6.912h-9.864l-1.98 4.608h11.844v6.912h-14.796l-12.852 29.952-12.852-29.952h-14.796v-6.912h11.844l-1.98-4.608h-9.864v-6.912h6.912l-6.912-16.128h9.216l11.628 27.648h13.608l11.628-27.648h9.216zm-27.648 43.776l3.888-9.216h-7.776z\",\"TRAIN\":\"M39.168-64.439q6.66 0 11.394 3.366t4.734 8.154v32.256q0 4.68-4.518 7.992t-10.998 3.492l7.668 7.272q.576.54.288 1.26t-1.08.72h-38.016q-.792 0-1.08-.72t.288-1.26l7.668-7.272q-6.48-.18-10.998-3.492t-4.518-7.992v-32.256q0-4.788 4.734-8.154t11.394-3.366h23.04zm-11.52 48.384q2.88 0 4.896-2.016t2.016-4.896-2.016-4.896-4.896-2.016-4.896 2.016-2.016 4.896 2.016 4.896 4.896 2.016zm20.736-20.736v-18.432h-41.472v18.432h41.472z\",\"SUBWAY\":\"M39.168-64.439q6.66 0 11.394 3.366t4.734 8.154v32.256q0 4.68-4.518 7.992t-10.998 3.492l7.668 7.272q.576.54.288 1.26t-1.08.72h-38.016q-.792 0-1.08-.72t.288-1.26l7.668-7.272q-6.48-.18-10.998-3.492t-4.518-7.992v-32.256q0-4.788 4.734-8.154t11.394-3.366h23.04zm-28.8 47.232q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm14.976-19.584v-18.432h-19.584v18.432h19.584zm19.584 19.584q2.376 0 4.068-1.692t1.692-4.068-1.692-4.068-4.068-1.692-4.068 1.692-1.692 4.068 1.692 4.068 4.068 1.692zm5.76-19.584v-18.432h-20.736v18.432h20.736z\",\"MEDIUM\":\"M21.492-49.283v42.228q0 .9-.45 1.53t-1.314.63q-.612 0-1.188-.288l-16.74-8.388q-.756-.36-1.278-1.206t-.522-1.674v-41.04q0-.72.36-1.224t1.044-.504q.504 0 1.584.54l18.396 9.216q.108.108.108.18zm2.304 3.636l19.224 31.176-19.224-9.576v-21.6zm40.716.648v37.944q0 .9-.504 1.458t-1.368.558-1.692-.468l-15.876-7.92zm-.108-4.32q0 .108-9.234 15.102t-10.818 17.55l-14.04-22.824 11.664-18.972q.612-1.008 1.872-1.008.504 0 .936.216l19.476 9.72q.144.072.144.216z\",\"YC\":\"M29.124-28.295l9.576-17.964h-4.032l-5.652 11.232q-.864 1.728-1.584 3.312l-1.512-3.312-5.58-11.232h-4.32l9.468 17.748v11.664h3.636v-11.448zm26.172-31.536v55.296h-55.296v-55.296h55.296z\",\"OPTIN_MONSTER\":\"M17.208-4.139q-.288.576-.972 1.242t-1.332.918q-.9.324-1.854-.126t-1.026-1.134q-.036-.792 1.44-1.98t2.448-1.368q.828-.144 1.224.774t.072 1.674zm48.276 0q.252.576.936 1.242t1.368.918q.9.324 1.854-.126t.99-1.134q.072-.792-1.422-1.98t-2.466-1.368q-.792-.144-1.188.774t-.072 1.674zm1.728-3.924q.468.972 2.034 2.142t2.79 1.494q1.62.468 2.952-.162t1.332-1.818q0-1.656-2.43-3.618t-4.158-2.142q-1.44-.18-2.286 1.35t-.234 2.754zm-51.804 0q-.468.972-2.016 2.142t-2.772 1.494q-1.62.468-2.952-.162t-1.332-1.818q0-1.656 2.43-3.618t4.158-2.142q1.44-.18 2.268 1.35t.216 2.754zm26.28-40.464h.036q-1.476 0-2.736.54.972.288 1.584 1.098t.612 1.782q0 1.26-.972 2.16t-2.34.9q-1.872 0-2.88-1.548-.18.828-.18 1.512 0 2.664 2.016 4.554t4.86 1.89q2.88 0 4.896-1.89t2.016-4.554-2.016-4.554-4.896-1.89zm10.944-7.848q-3.564-3.924-7.938-4.734t-8.838 1.602q.972-2.16 2.97-3.474t4.248-1.422 4.374.612 3.582 2.682 1.602 4.734zm27 44.604q.288.396-.396 1.512.252.828.252 1.44.036 2.016-1.602 4.05t-3.942 3.294-4.248 1.332q-1.728.072-3.312-.774t-2.376-2.358q-24.732.9-45.324 0-.828 1.476-2.394 2.34t-3.33.792q-3.096-.108-6.462-2.898t-3.33-5.778q.072-.792.252-1.44-.684-1.116-.396-1.512.216-.36 1.116-.036.504-.792 1.476-1.836-.252-1.044.072-1.368.396-.36 1.404.144 1.044-.72 2.124-1.224 0-1.044.468-1.332.828-.432 1.836.576 1.26-.18 2.196.072.648.144 1.368.684v-2.628q-.396 0-.648-.072-1.908-.36-3.492-1.602t-1.98-3.15q-.324-1.368 0-2.916.54-2.232 3.348-3.42.072-.612.684-1.278t1.296-.846 1.188.27.684 1.098h.468q1.656.18 2.16.828.108.108.18.252.36-.036 1.098-.126t1.098-.126q-.54-.396-1.08-.612-.828-1.44-3.276-1.548 0-.216.036-.36-2.232-.072-4.266-.666t-3.042-1.71q-1.152-1.296-1.53-3.312t-.09-4.032q.576-4.536 3.24-6.444.828-.576 1.872-.162t1.152 1.458l.054.504.09.756.108.72.198.684.306.36q.972.504 2.736.432 1.728-1.656 3.528-2.664-1.44-.144-5.832.504l1.692-1.656q2.196-2.088 5.868-3.996 5.22-2.628 10.152-3.096-.72-.288-1.476-.558t-1.692-.504-1.53-.378-1.71-.396-1.548-.36q21.42-4.536 32.544 5.004 3.528 3.024 5.688 7.992 3.06.36 4.356-.324h.036q.18-.108.306-.36t.198-.684.108-.702.108-.774l.036-.504q.108-1.008 1.152-1.44t1.872.18q2.628 1.872 3.276 6.408.252 2.052-.126 4.068t-1.53 3.276q-1.008 1.152-3.006 1.746t-4.158.666v.36q-2.556.072-3.42 1.548-.504.18-1.116.612.396.036 1.152.126t1.08.126q.036-.144.18-.288.576-.648 2.16-.828h.468q.18-.648.684-1.08t1.188-.288 1.296.828.684 1.296q2.844 1.152 3.348 3.42.324 1.44.036 2.916-.432 1.908-2.016 3.168t-3.492 1.584q-.36.072-.612.072 0 1.764-.036 2.628.72-.54 1.368-.684.936-.252 2.196-.072 1.008-1.008 1.836-.576.504.324.504 1.332 1.188.576 2.124 1.224.972-.468 1.368-.144.36.36.072 1.368 1.008 1.08 1.476 1.836.828-.288 1.116.036zm-9.9-34.272q0 1.044-.324 1.944 2.952 1.152 4.032 4.752.144-1.332-.342-3.546t-1.494-3.258q-.72-.684-1.296-.612t-.576.72zm-2.808 3.6q1.26 1.512 1.71 3.906t-.018 4.482q2.412-.468 3.492-1.62.468-.504.648-1.008-.108-2.304-1.116-4.122t-2.844-2.394q-.54.54-1.872.756zm-1.332.144q-1.08 0-1.584-.036 1.512 4.14 1.908 8.604.756 0 1.548-.108.576-2.448.036-4.86t-1.908-3.6zm-56.304 2.952q1.08-3.6 4.032-4.752-.324-.9-.324-1.944 0-.648-.594-.72t-1.278.612q-1.008 1.044-1.494 3.258t-.342 3.546zm1.296 3.672q1.044 1.116 3.492 1.62-.468-2.088-.018-4.482t1.71-3.906q-1.332-.216-1.872-.756-1.836.576-2.826 2.376t-1.134 4.14q.324.612.648 1.008zm6.372 1.944q.504-4.464 2.628-8.46-.684.144-1.98.648l-1.62.684v-.036q-1.656 3.204-.72 7.056.9.108 1.692.108zm34.668 1.404q.288 1.368.594 3.906t.414 3.222q.108.648.342.774t.846-.162q1.44-.72 2.232-3.078t.828-4.518q-.864-.072-5.256-.144zm-10.152-23.076q-4.176 0-7.164 2.97t-2.988 7.146q0 4.212 2.988 7.182t7.164 2.97 7.164-2.97 2.988-7.182q0-4.176-2.988-7.146t-7.164-2.97zm8.208 23.004q-3.816-.072-7.596 0v-.036q-.036.972.09 3.096t.486 2.376q1.044.504 3.366.522t3.438-.378q.324-.108.396-1.404t-.018-2.502-.162-1.674zm-9.648 7.164q.288-.144.342-1.728t-.018-3.168-.144-2.268v-.036q-7.632.108-7.704.108-.144.72-.252 2.232t0 2.988.504 1.656q1.224.54 3.636.576t3.636-.36zm-14.184-6.804q-.576 2.124.162 4.266t2.79 3.042q.54.288.864.18t.432-.756q.108-.576.288-3.24t.36-3.708q-2.484.072-4.896.216zm-4.572 4.536q.108.828-1.224 1.296 4.752 5.076 9.774 8.64t10.998 5.544q6.192-1.764 11.178-5.256t10.566-9q-1.188-.468-1.08-1.224l.108-.324v0q-.612-.072-1.8-.198t-1.728-.162q-.936 3.24-2.952 4.752-1.836 1.368-2.952-.036-.18-.216-.324-.504-.252-.468-.612-2.232-.072.18-.18.324t-.27.252-.288.198-.342.144l-.36.09-.432.072-.432.054-.486.036-.486.018q-3.816.324-5.868-.396-.144.612-.36.954t-.756.54-.828.252-1.296.126l-.108.018-.108.018h-.108q-6.444.612-7.308-1.44-.072 2.268-2.016 1.944-1.692-.288-3.276-1.944-.432-.468-.72-.936-.612-1.044-.936-2.34-2.088.216-3.132.36l.144.36zm-3.024 22.608q.108-.504.108-1.08-.612-2.556-1.836-4.68t-2.628-2.52q-1.476-.432-3.654.522t-3.762 2.88-1.404 3.87q1.26 1.908 3.6 3.348t4.284 1.512q1.836.072 3.384-1.008t1.908-2.844zm.108-6.156q.828 2.268.972 4.284 7.02-4.068 14.112-6.264-3.528-1.872-6.498-4.32t-6.462-5.94q-.216.144-1.044.468l-.036.18-.036.144q1.116.648.792 1.332-.432.828-2.016 1.224-.36.468-1.044.864h-.036q-.072 2.988.036 5.4.684 1.224 1.26 2.628zm2.484 5.976q19.152.756 41.22 0-9.144-5.292-15.408-7.056-2.736 1.26-5.616 2.052-.288.108-.576 0-2.34-.756-4.644-1.764-7.488 2.16-14.976 6.768h-.036v.036l.036-.036zm42.624-1.656q.144-1.944 1.008-4.32.504-1.368 1.188-2.556l-.036.036q.108-2.772.108-5.508-.54-.288-1.08-.9-1.512-.324-2.016-1.188-.324-.72.792-1.368-.072-.144-.072-.324-.576-.144-1.008-.432-7.344 6.84-13.788 10.224 7.128 2.124 14.904 6.336zm14.112.828q.18-1.944-1.404-3.87t-3.744-2.88-3.672-.522q-1.368.396-2.61 2.538t-1.854 4.662q0 .576.108 1.08.36 1.764 1.908 2.844t3.384 1.008q1.944-.072 4.284-1.512t3.6-3.348z\",\"OPENCART\":\"M54.864-8.243q0 2.448-1.728 4.176t-4.176 1.728-4.194-1.728-1.746-4.176 1.746-4.194 4.194-1.746 4.176 1.746 1.728 4.194zm-26.964 0q0 2.448-1.746 4.176t-4.194 1.728-4.176-1.728-1.728-4.176 1.728-4.194 4.176-1.746 4.194 1.746 1.746 4.194zm-27.9-53.784q2.052 2.16 3.978 3.762t4.356 2.952 4.896 2.268 5.976 1.638 7.2 1.134 9 .666 10.944.342 13.41.09q5.004 0 8.802.18t6.516.594 4.464.99 2.556 1.422.864 1.854-.702 2.304-2.034 2.754-3.222 3.276-4.176 3.762-5.004 4.284q-6.66 5.652-10.296 8.892 1.044-1.836 2.754-3.924t3.384-3.798 3.402-3.546 2.988-3.294 1.944-2.898.468-2.52-1.638-1.998-4.194-1.476-7.344-.846-10.944-.18q-6.048.072-11.304-.216t-9.216-.828-7.362-1.476-5.742-1.854-4.41-2.25-3.294-2.394-2.448-2.574-1.818-2.502-1.44-2.448-1.314-2.142z\",\"EXPEDITEDSSL\":\"M32.256-62.135q-6.084 0-11.628 2.376t-9.558 6.39-6.39 9.558-2.376 11.628 2.376 11.628 6.39 9.558 9.558 6.39 11.628 2.376 11.628-2.376 9.558-6.39 6.39-9.558 2.376-11.628-2.376-11.628-6.39-9.558-9.558-6.39-11.628-2.376zm0-2.304q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556zm-14.4 29.952q.576 0 .576.576v17.28q0 .576-.576.576h-1.152q-.576 0-.576-.576v-17.28q0-.576.576-.576h1.152zm14.4 2.304q1.908 0 3.258 1.35t1.35 3.258q0 1.26-.63 2.304t-1.674 1.656v4.104q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-4.104q-1.044-.612-1.674-1.656t-.63-2.304q0-1.908 1.35-3.258t3.258-1.35zm0-27.648q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm-12.672 17.28v3.456q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-3.456q0-3.348 2.358-5.706t5.706-2.358 5.706 2.358 2.358 5.706v3.456q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-3.456q0-5.256-3.708-8.964t-8.964-3.708-8.964 3.708-3.708 8.964zm31.104 26.496v-18.432q0-.936-.684-1.62t-1.62-.684h-32.256q-.936 0-1.62.684t-.684 1.62v18.432q0 .936.684 1.62t1.62.684h32.256q.936 0 1.62-.684t.684-1.62z\",\"BATTERY_FULL\":\"M69.12-46.007v27.648h-59.904v-27.648h59.904zm4.608 20.736h4.608v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368zm9.216-13.824v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76q1.908 0 3.258 1.35t1.35 3.258z\",\"BATTERY_THREE_QUARTERS\":\"M9.216-18.359v-27.648h46.08v27.648h-46.08zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z\",\"BATTERY_HALF\":\"M9.216-18.359v-27.648h32.256v27.648h-32.256zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z\",\"BATTERY_QUARTER\":\"M9.216-18.359v-27.648h18.432v27.648h-18.432zm69.12-25.344q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z\",\"BATTERY_EMPTY\":\"M78.336-43.703q1.908 0 3.258 1.35t1.35 3.258v13.824q0 1.908-1.35 3.258t-3.258 1.35v5.76q0 2.376-1.692 4.068t-4.068 1.692h-66.816q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h66.816q2.376 0 4.068 1.692t1.692 4.068v5.76zm0 18.432v-13.824h-4.608v-10.368q0-.504-.324-.828t-.828-.324h-66.816q-.504 0-.828.324t-.324.828v34.56q0 .504.324.828t.828.324h66.816q.504 0 .828-.324t.324-.828v-10.368h4.608z\",\"MOUSE_POINTER\":\"M40.788-26.891q1.116 1.08.504 2.484-.612 1.44-2.124 1.44h-13.752l7.236 17.136q.36.9 0 1.764t-1.224 1.26l-6.372 2.7q-.9.36-1.764 0t-1.26-1.224l-6.876-16.272-11.232 11.232q-.684.684-1.62.684-.432 0-.864-.18-1.44-.612-1.44-2.124v-54.144q0-1.512 1.44-2.124.432-.18.864-.18.972 0 1.62.684z\",\"I_CURSOR\":\"M29.952-59.831q-11.52 0-11.52 8.064v14.976h4.608v4.608h-4.608v19.584q0 8.064 11.52 8.064h2.304v4.608h-2.304q-9.792 0-13.824-5.256-4.032 5.256-13.824 5.256h-2.304v-4.608h2.304q11.52 0 11.52-8.064v-19.584h-4.608v-4.608h4.608v-14.976q0-8.064-11.52-8.064h-2.304v-4.608h2.304q9.792 0 13.824 5.256 4.032-5.256 13.824-5.256h2.304v4.608h-2.304z\",\"OBJECT_GROUP\":\"M73.728-50.615h-4.608v36.864h4.608v13.824h-13.824v-4.608h-46.08v4.608h-13.824v-13.824h4.608v-36.864h-4.608v-13.824h13.824v4.608h46.08v-4.608h13.824v13.824zm-9.216-9.216v4.608h4.608v-4.608h-4.608zm-59.904 0v4.608h4.608v-4.608h-4.608zm4.608 55.296v-4.608h-4.608v4.608h4.608zm50.688-4.608v-4.608h4.608v-36.864h-4.608v-4.608h-46.08v4.608h-4.608v36.864h4.608v4.608h46.08zm9.216 4.608v-4.608h-4.608v4.608h4.608zm-23.04-36.864h13.824v27.648h-32.256v-9.216h-13.824v-27.648h32.256v9.216zm-27.648 13.824h23.04v-18.432h-23.04v18.432zm36.864 9.216v-18.432h-9.216v13.824h-13.824v4.608h23.04z\",\"OBJECT_UNGROUP\":\"M82.944-36.791h-4.608v23.04h4.608v13.824h-13.824v-4.608h-32.256v4.608h-13.824v-13.824h4.608v-4.608h-13.824v4.608h-13.824v-13.824h4.608v-23.04h-4.608v-13.824h13.824v4.608h32.256v-4.608h13.824v13.824h-4.608v4.608h13.824v-4.608h13.824v13.824zm-9.216-9.216v4.608h4.608v-4.608h-4.608zm-23.04-13.824v4.608h4.608v-4.608h-4.608zm-46.08 0v4.608h4.608v-4.608h-4.608zm4.608 41.472v-4.608h-4.608v4.608h4.608zm46.08-4.608h-4.608v4.608h4.608v-4.608zm-41.472 0h32.256v-4.608h4.608v-23.04h-4.608v-4.608h-32.256v4.608h-4.608v23.04h4.608v4.608zm18.432 18.432v-4.608h-4.608v4.608h4.608zm46.08 0v-4.608h-4.608v4.608h4.608zm-4.608-9.216v-23.04h-4.608v-4.608h-13.824v13.824h4.608v13.824h-13.824v-4.608h-13.824v4.608h4.608v4.608h32.256v-4.608h4.608z\",\"STICKY_NOTE\":\"M36.864-19.511v14.976h-33.408q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h48.384q1.44 0 2.448 1.008t1.008 2.448v33.408h-14.976q-1.44 0-2.448 1.008t-1.008 2.448zm4.608 1.152h13.716q-.54 2.952-2.34 4.752l-6.624 6.624q-1.8 1.8-4.752 2.34v-13.716z\",\"STICKY_NOTE_O\":\"M50.4-18.359h-8.928v8.928q1.044-.36 1.476-.792l6.66-6.66q.432-.432.792-1.476zm-10.08-4.608h10.368v-32.256h-46.08v46.08h32.256v-10.368q0-1.44 1.008-2.448t2.448-1.008zm14.976-33.408v36.864q0 1.44-.72 3.168t-1.728 2.736l-6.624 6.624q-1.008 1.008-2.736 1.728t-3.168.72h-36.864q-1.44 0-2.448-1.008t-1.008-2.448v-48.384q0-1.44 1.008-2.448t2.448-1.008h48.384q1.44 0 2.448 1.008t1.008 2.448z\",\"CC_JCB\":\"M70.236-28.511q0 .936-.558 1.602t-1.386.846q-.288.072-.648.072h-5.508v-5.04h5.508q.36 0 .648.072.828.18 1.386.846t.558 1.602zm-.648-7.668q0 .9-.54 1.512t-1.368.756q-.108.036-.54.036h-5.004v-4.644h5.004l.306.018.234.018q.828.144 1.368.774t.54 1.53zm-43.38 5.904v-11.088h-8.208v11.088q0 2.088-1.368 3.402t-3.78 1.314q-3.888 0-8.244-2.124v4.032q1.908.54 4.356.828t3.924.324l1.512.036q11.808 0 11.808-7.812zm25.704 6.624v-4.068q-3.564 1.872-7.2 2.124-3.888.288-6.084-1.476t-2.196-5.112 2.196-5.112 6.084-1.476q3.636.252 7.2 2.088v-4.032q-1.728-.432-3.6-.702t-2.88-.342l-1.008-.072q-4.572-.216-7.866.504t-5.058 2.16-2.556 3.168-.792 3.816.792 3.816 2.556 3.168 5.058 2.16 7.866.504q3.636-.144 7.488-1.116zm26.424-4.14q0-1.944-1.548-3.186t-3.924-1.422v-.108q2.052-.288 3.204-1.494t1.152-2.862q0-1.98-1.476-3.168t-3.852-1.296l-.432-.018-.504-.018h-16.38v18.36h17.676q2.664 0 4.374-1.314t1.71-3.474zm4.608-27.432v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"CC_DINERS_CLUB\":\"M30.888-19.763v-24.948q-3.816 1.476-6.192 4.878t-2.376 7.614 2.376 7.614 6.192 4.842zm18.144-12.456q0-4.212-2.376-7.614t-6.192-4.878v24.984q3.816-1.476 6.192-4.878t2.376-7.614zm7.74 0q0 5.724-2.826 10.584t-7.686 7.686-10.584 2.826q-4.284 0-8.19-1.674t-6.732-4.5-4.5-6.732-1.674-8.19q0-5.724 2.826-10.584t7.686-7.686 10.584-2.826 10.584 2.826 7.686 7.686 2.826 10.584zm13.788.252q0-5.004-1.998-9.414t-5.31-7.398-7.686-4.716-9.09-1.728h-10.836q-6.336 0-11.646 2.916t-8.46 8.28-3.15 12.06q0 6.156 3.132 11.43t8.496 8.334 11.628 3.06h10.836q4.644 0 9.054-1.818t7.722-4.86 5.31-7.29 1.998-8.856zm12.384-23.256v46.08q0 1.872-1.368 3.24t-3.24 1.368h-73.728q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h73.728q1.872 0 3.24 1.368t1.368 3.24z\",\"CLONE\":\"M59.904-5.687v-39.168q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81v39.168q0 .468.342.81t.81.342h39.168q.468 0 .81-.342t.342-.81zm4.608-39.168v39.168q0 2.376-1.692 4.068t-4.068 1.692h-39.168q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068zm-13.824-13.824v5.76h-4.608v-5.76q0-.468-.342-.81t-.81-.342h-39.168q-.468 0-.81.342t-.342.81v39.168q0 .468.342.81t.81.342h5.76v4.608h-5.76q-2.376 0-4.068-1.692t-1.692-4.068v-39.168q0-2.376 1.692-4.068t4.068-1.692h39.168q2.376 0 4.068 1.692t1.692 4.068z\",\"BALANCE_SCALE\":\"M62.208-48.311l-13.824 25.344h27.648zm-46.08 0l-13.824 25.344h27.648zm29.556-6.912q-.504 1.44-1.638 2.574t-2.574 1.638v46.476h21.888q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-48.384q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h21.888v-46.476q-1.44-.504-2.574-1.638t-1.638-2.574h-17.676q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h17.676q.756-2.052 2.52-3.33t3.996-1.278 3.996 1.278 2.52 3.33h17.676q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-17.676zm-6.516.576q1.188 0 2.034-.846t.846-2.034-.846-2.034-2.034-.846-2.034.846-.846 2.034.846 2.034 2.034.846zm39.168 31.68q0 2.628-1.674 4.716t-4.23 3.276-5.202 1.782-5.022.594-5.022-.594-5.202-1.782-4.23-3.276-1.674-4.716q0-.396 1.26-2.916t3.312-6.282 3.852-7.038 3.672-6.624 2.016-3.6q.648-1.188 2.016-1.188t2.016 1.188q.144.252 2.016 3.6t3.672 6.624 3.852 7.038 3.312 6.282 1.26 2.916zm-46.08 0q0 2.628-1.674 4.716t-4.23 3.276-5.202 1.782-5.022.594-5.022-.594-5.202-1.782-4.23-3.276-1.674-4.716q0-.396 1.26-2.916t3.312-6.282 3.852-7.038 3.672-6.624 2.016-3.6q.648-1.188 2.016-1.188t2.016 1.188q.144.252 2.016 3.6t3.672 6.624 3.852 7.038 3.312 6.282 1.26 2.916z\",\"HOURGLASS_O\":\"M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-19.224 25.488q2.772-1.044 5.364-3.33t4.662-5.49 3.33-7.56 1.26-9.108h-36.864q0 4.752 1.26 9.108t3.33 7.56 4.662 5.49 5.364 3.33q.684.252 1.098.846t.414 1.314-.414 1.314-1.098.846q-2.772 1.044-5.364 3.33t-4.662 5.49-3.33 7.56-1.26 9.108h36.864q0-4.752-1.26-9.108t-3.33-7.56-4.662-5.49-5.364-3.33q-.684-.252-1.098-.846t-.414-1.314.414-1.314 1.098-.846z\",\"HOURGLASS_START\":\"M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-4.608 0h-36.864q0 2.376.324 4.608h36.216q.324-2.196.324-4.608zm0 55.296q0-4.68-1.224-8.982t-3.258-7.488-4.554-5.472-5.256-3.402h-8.28q-2.736 1.116-5.256 3.402t-4.554 5.472-3.258 7.488-1.224 8.982h36.864z\",\"HOURGLASS_HALF\":\"M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-4.608 0h-36.864q0 7.416 3.06 13.824h30.744q3.06-6.408 3.06-13.824zm-2.052 43.776q-1.944-5.076-5.238-8.694t-7.002-5.13h-8.28q-3.708 1.512-7.002 5.13t-5.238 8.694h32.76z\",\"HOURGLASS_END\":\"M50.688-59.831q0 9.396-3.834 16.614t-9.594 11.034q5.76 3.816 9.594 11.034t3.834 16.614h3.456q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h3.456q0-9.396 3.834-16.614t9.594-11.034q-5.76-3.816-9.594-11.034t-3.834-16.614h-3.456q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h52.992q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-3.456zm-19.224 25.488q2.772-1.044 5.364-3.33t4.662-5.49 3.33-7.56 1.26-9.108h-36.864q0 4.752 1.26 9.108t3.33 7.56 4.662 5.49 5.364 3.33q.684.252 1.098.846t.414 1.314-.414 1.314-1.098.846q-4.932 1.836-8.784 7.056h25.2q-3.852-5.22-8.784-7.056-.684-.252-1.098-.846t-.414-1.314.414-1.314 1.098-.846z\",\"HOURGLASS\":\"M54.144-6.839q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h52.992zm-49.464-2.304q.108-1.98.576-3.852t1.08-3.42 1.656-3.132 1.926-2.736 2.322-2.502 2.376-2.16 2.538-1.98 2.394-1.71 2.34-1.548q-1.548-1.008-2.34-1.548t-2.394-1.71-2.538-1.98-2.376-2.16-2.322-2.502-1.926-2.736-1.656-3.132-1.08-3.42-.576-3.852h45.936q-.108 1.98-.576 3.852t-1.08 3.42-1.656 3.132-1.926 2.736-2.322 2.502-2.376 2.16-2.538 1.98-2.394 1.71-2.34 1.548q1.548 1.008 2.34 1.548t2.394 1.71 2.538 1.98 2.376 2.16 2.322 2.502 1.926 2.736 1.656 3.132 1.08 3.42.576 3.852h-45.936zm49.464-55.296q.504 0 .828.324t.324.828v4.608q0 .504-.324.828t-.828.324h-52.992q-.504 0-.828-.324t-.324-.828v-4.608q0-.504.324-.828t.828-.324h52.992z\",\"HAND_ROCK_O\":\"M27.648-50.615q-1.908 0-3.258 1.35t-1.35 3.258v4.608h-1.152v-3.348q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v15.444l-1.152-1.08v-6.192q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v8.064q0 1.692 1.26 2.952l11.16 10.656q1.404 1.404 1.404 3.672 0 .936.684 1.62t1.62.684h23.04q.936 0 1.62-.684t.684-1.62v-.9q0-1.476.36-2.772l3.888-15.696q.36-1.296.36-2.772v-8.856q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v1.152h-1.152v-4.5q0-1.44-.9-2.61t-2.304-1.458q-.504-.072-.828-.072-1.656 0-2.844 1.188t-1.188 2.844v4.608h-1.152v-4.392q0-1.836-1.17-3.222t-2.97-1.566q-.18-.036-.468-.036zm0-4.608q3.024 0 5.364 1.8 2.052-1.224 4.428-1.224 2.124 0 3.996.972t3.096 2.736q.972-.252 2.124-.252 3.6 0 6.12 2.574t2.52 6.174v8.856q0 1.836-.468 3.888l-3.924 15.696q-.216.864-.216 2.556 0 2.88-2.016 4.896t-4.896 2.016h-23.04q-3.024 0-4.968-2.106t-1.944-5.13l-11.088-10.656q-2.736-2.628-2.736-6.3v-8.064q0-3.564 2.538-6.102t6.102-2.538q.396 0 .576.036.216-3.42 2.718-5.76t5.922-2.34q1.872 0 3.528.756 2.592-2.484 6.264-2.484z\",\"HAND_STOP_O\":\"M31.68-59.831q-1.656 0-2.844 1.188t-1.188 2.844v23.616h-1.152v-19.008q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v28.223999999999997l-5.544-7.38q-1.368-1.836-3.672-1.836-1.908 0-3.258 1.35t-1.35 3.258q0 1.548.936 2.772l13.824 18.432q1.368 1.836 3.672 1.836h24.768q1.224 0 2.196-.792t1.224-2.016l2.736-14.58q.18-1.152.18-2.124v-17.928q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v9.792h-1.152v-19.008q0-1.656-1.188-2.844t-2.844-1.188-2.844 1.188-1.188 2.844v19.008h-1.152v-23.616q0-1.656-1.188-2.844t-2.844-1.188zm0-4.608q2.448 0 4.518 1.278t3.186 3.474q.684-.144 1.512-.144 3.564 0 6.102 2.538t2.538 6.102v.612q3.78-.216 6.498 2.304t2.718 6.3v17.928q0 1.44-.288 2.988l-2.736 14.544q-.504 2.844-2.754 4.716t-5.166 1.872h-24.768q-2.16 0-4.122-.99t-3.258-2.682l-13.824-18.432q-1.836-2.448-1.836-5.544 0-3.816 2.7-6.516t6.516-2.7q2.808 0 4.608 1.224v-15.624q0-3.564 2.538-6.102t6.102-2.538q.828 0 1.512.144 1.116-2.196 3.186-3.474t4.518-1.278z\",\"HAND_SCISSORS_O\":\"M38.628-4.535h-6.372q-5.868 0-8.136-5.076-.828-1.764-.828-3.672v-.18q-2.232-1.08-3.546-3.186t-1.314-4.59q0-1.368.18-1.728h-9.396q-3.816 0-6.516-2.7t-2.7-6.516 2.7-6.516 6.516-2.7h4.068l-1.584-.612q-2.664-1.008-4.302-3.366t-1.638-5.238q0-3.816 2.7-6.516t6.516-2.7q1.656 0 3.276.612l22.608 8.604h14.436q3.816 0 6.516 2.7t2.7 6.516v24.048q0 3.168-1.944 5.67t-5.04 3.258l-12.204 3.06q-3.312.828-6.696.828zm-1.764-25.596l-5.58 2.556-5.868 2.664q-1.08.504-1.728 1.494t-.648 2.178q0 1.656 1.188 2.844t2.844 1.188q.936 0 1.656-.36l12.168-5.544q-1.764-.36-2.898-1.8t-1.134-3.24v-1.98zm11.52 11.196q0-1.656-1.188-2.844t-2.844-1.188q-.936 0-1.656.36l-10.44 4.752q-1.008.468-1.332.612t-1.098.612-1.062.846-.576 1.044-.288 1.458q0 1.8 1.134 2.952t2.934 1.152q.72 0 1.368-.324l12.672-5.76q1.08-.504 1.728-1.494t.648-2.178zm-8.352-27.072l-23.4-8.928q-.864-.288-1.656-.288-1.908 0-3.258 1.35t-1.35 3.258q0 1.44.81 2.628t2.142 1.692l18.936 7.2v2.304h-23.04q-1.908 0-3.258 1.35t-1.35 3.258 1.35 3.258 3.258 1.35h19.26l8.388-3.816v-7.128q0-2.268 1.656-3.816l3.996-3.672h-2.484zm-1.404 36.864q2.952 0 5.58-.684l12.204-3.06q1.548-.396 2.52-1.638t.972-2.826v-24.048q0-1.908-1.35-3.258t-3.258-1.35h-11.088l-4.896 4.536q-1.296 1.188-1.296 2.952v10.656q0 1.656 1.188 2.772t2.844 1.116 2.844-1.26 1.188-2.916v-7.488h1.152v7.488q0 2.52-2.052 4.104 1.872.288 3.114 1.746t1.242 3.366q0 1.512-.828 2.808t-2.196 1.908l-11.16 5.076h3.276z\",\"HAND_LIZARD_O\":\"M41.436-64.439q2.196 0 4.176 1.008t3.276 2.772l20.592 28.116q4.248 5.724 4.248 12.924v12.78q0 2.88-2.016 4.896t-4.896 2.016h-13.824q-2.88 0-4.896-2.016t-2.016-4.896v-6.372l-10.296-5.148h-19.656q-2.88 0-4.896-2.016t-2.016-4.896v-1.152q0-4.284 3.042-7.326t7.326-3.042h15.12l1.512-4.608h-24.696q-3.6 0-6.246-2.43t-2.934-5.994q-2.34-2.844-2.34-6.552v-1.152q0-2.88 2.016-4.896t4.896-2.016h34.524zm27.684 57.6v-12.78q0-5.652-3.348-10.224l-20.628-28.116q-1.404-1.872-3.708-1.872h-34.524q-.936 0-1.62.684t-.684 1.62q0 1.152.054 1.782t.342 1.458.9 1.548q.36-1.116 1.278-1.8t2.034-.684h29.952v1.152h-29.952q-.936 0-1.62.684t-.684 1.62q0 1.584.108 2.088.288 1.584 1.584 2.628t2.916 1.044h26.316q1.44 0 2.448 1.008t1.008 2.448q0 .54-.18 1.08l-2.304 6.912q-.36 1.044-1.26 1.71t-2.016.666h-15.948q-2.376 0-4.068 1.692t-1.692 4.068v1.152q0 .936.684 1.62t1.62.684h20.196q.576 0 1.044.252l11.412 5.688q.864.468 1.386 1.296t.522 1.8v7.092q0 .936.684 1.62t1.62.684h13.824q.936 0 1.62-.684t.684-1.62z\",\"HAND_SPOCK_O\":\"M29.376-59.831q-1.728 0-2.862 1.224t-1.134 2.952q0 .504.108 1.008l5.4 22.464h-.936l-4.176-17.352q-.324-1.368-1.422-2.232t-2.502-.864q-1.692 0-2.844 1.224t-1.152 2.916q0 .396.144 1.044.108.468 1.404 5.796t2.448 10.152 1.152 4.968v8.172l-11.052-8.28q-1.224-.936-2.772-.936-1.872 0-3.222 1.314t-1.35 3.186q0 2.412 2.016 3.96l18.252 13.644q1.224.936 2.736.936h24.984q1.188 0 2.124-.738t1.224-1.89l3.6-14.436q.288-1.08.36-3.168t.324-3.096l4.176-17.208q.108-.432.108-.936 0-1.656-1.188-2.844t-2.88-1.188q-1.368 0-2.484.918t-1.44 2.25l-3.564 14.688h-.936l4.752-19.692q.108-.504.108-1.008 0-1.692-1.152-2.88t-2.88-1.188q-1.368 0-2.466.864t-1.422 2.232l-5.22 21.672h-4.572l-5.904-24.552q-.324-1.368-1.422-2.232t-2.466-.864zm23.22 59.904h-24.984q-3.06 0-5.508-1.836l-18.252-13.68q-1.8-1.368-2.826-3.384t-1.026-4.248q0-3.78 2.7-6.444t6.48-2.664q.9 0 1.782.198t1.494.396 1.476.738 1.26.828 1.386 1.062 1.35 1.026l-4.428-18.432q-.252-1.26-.252-2.124 0-3.348 2.16-5.832t5.472-2.844q.504-3.132 2.898-5.202t5.598-2.07q2.988 0 5.328 1.854t3.06 4.77l3.708 15.408 2.988-12.528q.72-2.916 3.06-4.77t5.328-1.854q3.132 0 5.49 1.944t2.97 5.004q3.348.36 5.58 2.808t2.232 5.796q0 1.08-.252 2.052l-4.176 17.172q-.18.792-.18 2.412 0 1.836-.468 3.888l-3.636 14.436q-.684 2.7-2.862 4.41t-4.95 1.71z\",\"HAND_POINTER_O\":\"M23.04-59.831q-1.908 0-3.258 1.35t-1.35 3.258v32.256l-5.436-7.272q-1.476-1.944-3.852-1.944-1.872 0-3.204 1.368t-1.332 3.24q0 1.548.936 2.772l13.824 18.432q1.368 1.836 3.672 1.836h25.848q.792 0 1.422-.486t.81-1.242l3.312-13.248q.864-3.456.864-6.984v-7.812q0-1.476-1.008-2.556t-2.448-1.08-2.448 1.008-1.008 2.448h-1.152v-2.196q0-1.728-1.152-2.934t-2.88-1.206q-1.656 0-2.844 1.188t-1.188 2.844v2.304h-1.152v-3.24q0-1.98-1.332-3.402t-3.276-1.422q-1.908 0-3.258 1.35t-1.35 3.258v3.456h-1.152v-20.52q0-1.98-1.332-3.402t-3.276-1.422zm0-4.608q3.852 0 6.534 2.79t2.682 6.642v7.92q.792-.072 1.152-.072 3.564 0 6.228 2.484 1.692-.756 3.564-.756 4.068 0 6.624 3.132.972-.252 2.016-.252 3.384 0 5.724 2.43t2.34 5.814v7.812q0 4.176-1.008 8.1l-3.312 13.248q-.576 2.304-2.448 3.762t-4.248 1.458h-25.848q-2.16 0-4.122-.99t-3.258-2.682l-13.824-18.432q-1.836-2.448-1.836-5.544 0-3.78 2.682-6.498t6.462-2.718q2.556 0 4.68 1.26v-19.692q0-3.816 2.7-6.516t6.516-2.7zm4.608 50.688v-13.824h-1.152v13.824h1.152zm9.216 0v-13.824h-1.152v13.824h1.152zm9.216 0v-13.824h-1.152v13.824h1.152z\",\"HAND_PEACE_O\":\"M46.368-41.147q2.16 0 3.852.828 5.076 2.268 5.076 8.136v6.372q0 3.384-.828 6.696l-3.06 12.204q-.756 3.096-3.258 5.04t-5.67 1.944h-24.048q-3.816 0-6.516-2.7t-2.7-6.516v-14.436l-8.604-22.608q-.612-1.62-.612-3.276 0-3.816 2.7-6.516t6.516-2.7q2.88 0 5.238 1.638t3.366 4.302l.612 1.584v-4.068q0-3.816 2.7-6.516t6.516-2.7 6.516 2.7 2.7 6.516v9.396q.972-.18 1.728-.18 2.484 0 4.59 1.314t3.186 3.546zm-7.776-.252q-1.188 0-2.178.648t-1.494 1.728l-2.664 5.868-2.556 5.58h1.98q1.8 0 3.24 1.134t1.8 2.898l5.544-12.168q.36-.72.36-1.656 0-1.656-1.188-2.844t-2.844-1.188zm7.956 4.86q-.792 0-1.458.288t-1.044.576-.846 1.062-.612 1.098-.612 1.332l-4.752 10.44q-.36.72-.36 1.656 0 1.656 1.188 2.844t2.844 1.188q1.188 0 2.178-.648t1.494-1.728l5.76-12.672q.324-.648.324-1.368 0-1.8-1.152-2.934t-2.952-1.134zm-41.94-12.924q0 .792.288 1.656l8.928 23.4v2.484l3.672-3.996q1.548-1.656 3.816-1.656h7.128l3.816-8.388v-19.26q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258v23.04h-2.304l-7.2-18.936q-.504-1.332-1.692-2.142t-2.628-.81q-1.908 0-3.258 1.35t-1.35 3.258zm37.872 44.928q1.584 0 2.826-.972t1.638-2.52l3.06-12.204q.684-2.628.684-5.58v-3.276l-5.076 11.16q-.612 1.368-1.908 2.196t-2.808.828q-1.908 0-3.366-1.242t-1.746-3.114q-1.584 2.052-4.104 2.052h-7.488v-1.152h7.488q1.656 0 2.916-1.188t1.26-2.844-1.116-2.844-2.772-1.188h-10.656q-1.764 0-2.952 1.296l-4.536 4.896v11.088q0 1.908 1.35 3.258t3.258 1.35h24.048z\",\"TRADEMARK\":\"M30.852-44.855v4.212q0 .468-.342.792t-.81.324h-10.728v29.232q0 .468-.324.81t-.792.342h-4.86q-.468 0-.81-.324t-.342-.828v-29.232h-10.692q-.468 0-.81-.324t-.342-.792v-4.212q0-.504.324-.828t.828-.324h28.548q.468 0 .81.342t.342.81zm37.368-.108l2.772 34.596q.036.468-.288.864-.36.36-.828.36h-4.824q-.432 0-.756-.306t-.36-.738l-1.656-21.168-6.804 15.3q-.288.684-1.044.684h-4.32q-.72 0-1.044-.684l-6.768-15.372-1.62 21.24q-.036.432-.36.738t-.756.306h-4.86q-.468 0-.828-.36-.324-.36-.324-.864l2.808-34.596q.036-.432.36-.738t.756-.306h5.112q.72 0 1.044.684l7.92 18.72q.36.864.72 1.836.108-.252.342-.882t.378-.954l7.956-18.72q.324-.684 1.044-.684h5.076q.468 0 .792.306t.36.738z\",\"REGISTERED\":\"M37.512-39.131q0-3.168-2.16-4.356-1.188-.648-4.212-.648h-4.428v10.116h5.832q2.376 0 3.672-1.332t1.296-3.78zm1.872 10.26l7.38 13.428q.288.612-.036 1.116-.288.576-.972.576h-5.472q-.72 0-1.008-.612l-6.984-13.14h-5.58v12.6q0 .504-.324.828t-.828.324h-4.824q-.504 0-.828-.324t-.324-.828v-34.56q0-.504.324-.828t.828-.324h10.584q4.608 0 6.84.864 3.06 1.116 4.824 3.924t1.764 6.48q0 3.312-1.53 5.958t-4.158 3.942q.216.36.324.576zm-7.128-29.808q-5.4 0-10.296 2.106t-8.442 5.652-5.652 8.442-2.106 10.296 2.106 10.296 5.652 8.442 8.442 5.652 10.296 2.106 10.296-2.106 8.442-5.652 5.652-8.442 2.106-10.296-2.106-10.296-5.652-8.442-8.442-5.652-10.296-2.106zm32.256 26.496q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"CREATIVE_COMMONS\":\"M21.78-20.051q5.508 0 9.252-3.744.504-.648.108-1.296l-1.62-2.952q-.216-.468-.864-.612-.576-.072-.972.396l-.144.108q-.144.144-.414.36t-.63.468-.846.522-1.026.486-1.206.342-1.35.126q-2.736 0-4.5-1.8t-1.764-4.572q0-2.736 1.728-4.518t4.392-1.782q1.332 0 2.574.504t1.818 1.008l.576.504q.396.396.936.36.576-.072.864-.504l1.908-2.808q.468-.72-.072-1.404-.108-.144-.396-.432t-1.08-.846-1.746-1.008-2.43-.81-3.096-.36q-5.328 0-8.856 3.474t-3.528 8.658q0 5.256 3.492 8.694t8.892 3.438zm22.68 0q5.508 0 9.252-3.744.504-.648.144-1.296l-1.62-2.952q-.288-.504-.9-.612-.576-.072-.972.396l-.144.108q-.144.144-.414.36t-.63.468-.846.522-1.026.486-1.206.342-1.35.126q-2.736 0-4.5-1.8t-1.764-4.572q0-2.736 1.728-4.518t4.392-1.782q1.332 0 2.574.504t1.818 1.008l.576.504q.396.396.936.36.576-.072.864-.504l1.908-2.808q.468-.72-.072-1.404-.108-.144-.396-.432t-1.08-.846-1.746-1.008-2.43-.81-3.096-.36q-5.292 0-8.838 3.474t-3.546 8.658q0 5.256 3.492 8.694t8.892 3.438zm-12.204-38.628q-5.4 0-10.296 2.106t-8.442 5.652-5.652 8.442-2.106 10.296 2.106 10.296 5.652 8.442 8.442 5.652 10.296 2.106 10.296-2.106 8.442-5.652 5.652-8.442 2.106-10.296-2.106-10.296-5.652-8.442-8.442-5.652-10.296-2.106zm0-5.76q6.552 0 12.528 2.556t10.296 6.876 6.876 10.296 2.556 12.528-2.556 12.528-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556z\",\"GG\":\"M26.496-35.639l13.824 13.824-13.824 13.824-24.192-24.192 24.192-24.192 6.048 6.048-3.456 3.456-2.592-2.592-17.28 17.28 17.28 17.28 6.948-6.948-10.404-10.332zm20.736-20.736l24.192 24.192-24.192 24.192-6.048-6.048 3.456-3.456 2.592 2.592 17.28-17.28-17.28-17.28-6.948 6.948 10.404 10.332-3.456 3.456-13.824-13.824z\",\"GG_CIRCLE\":\"M25.812-15.695l9.756-9.756-10.044-10.044-3.168 3.168 6.912 6.876-3.456 3.456-10.044-10.044 10.044-10.044 1.44 1.44 3.132-3.132-4.572-4.608-16.344 16.344zm12.888-.288l16.344-16.344-16.344-16.344-9.756 9.756 10.044 10.044 3.168-3.168-6.912-6.876 3.456-3.456 10.044 10.044-10.044 10.044-1.44-1.44-3.132 3.168zm25.812-16.2q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"TRIPADVISOR\":\"M23.436-28.547q0 1.404-.99 2.394t-2.358.99q-1.404 0-2.394-.99t-.99-2.394q0-1.368.99-2.358t2.394-.99q1.368 0 2.358.99t.99 2.358zm41.544-.036q0 1.404-.99 2.394t-2.394.99-2.394-.99-.99-2.394.99-2.376 2.394-.972 2.394.972.99 2.376zm-37.44.036q0-2.844-2.034-4.896t-4.914-2.052-4.914 2.034-2.034 4.914 2.034 4.914 4.914 2.034 4.914-2.034 2.034-4.914zm41.508-.036q0-2.88-2.034-4.914t-4.914-2.034q-2.844 0-4.896 2.034t-2.052 4.914 2.034 4.914 4.914 2.034 4.914-2.034 2.034-4.914zm-38.448.036q0 4.176-2.934 7.11t-7.074 2.934q-4.176 0-7.11-2.952t-2.934-7.092 2.952-7.074 7.092-2.934 7.074 2.934 2.934 7.074zm41.544-.036q0 4.14-2.934 7.074t-7.11 2.934q-4.14 0-7.074-2.934t-2.934-7.074 2.934-7.074 7.074-2.934q4.176 0 7.11 2.934t2.934 7.074zm-34.704.108q0-6.876-4.878-11.754t-11.754-4.878q-4.5 0-8.316 2.232t-6.048 6.066-2.232 8.334 2.232 8.334 6.048 6.066 8.316 2.232q6.876 0 11.754-4.878t4.878-11.754zm24.048-20.628q-9.144-3.996-20.016-3.996-11.484 0-20.628 3.96 4.212 0 8.028 1.638t6.57 4.41 4.392 6.588 1.638 8.028q0-4.14 1.566-7.902t4.248-6.498 6.39-4.428 7.812-1.8zm17.244 20.628q0-6.876-4.86-11.754t-11.736-4.878-11.754 4.878-4.878 11.754 4.878 11.754 11.754 4.878 11.736-4.878 4.86-11.754zm-9.576-20.376h13.788q-1.584 1.836-2.7 4.122t-1.44 4.122q3.96 5.436 3.96 12.132 0 5.616-2.772 10.368t-7.524 7.506-10.332 2.754q-4.788 0-8.964-2.016t-7.056-5.58q-1.692 2.016-4.644 6.444-.396-.792-1.926-2.97t-2.682-3.51q-2.88 3.564-7.074 5.598t-8.982 2.034q-5.58 0-10.332-2.754t-7.524-7.506-2.772-10.368q0-6.696 3.96-12.132-.324-1.836-1.44-4.122t-2.7-4.122h13.14q5.364-3.6 12.78-5.634t15.552-2.034q8.064 0 15.156 2.016t12.528 5.652z\",\"ODNOKLASSNIKI\":\"M23.04-31.787q-6.768 0-11.556-4.788t-4.788-11.52q0-6.768 4.788-11.556t11.556-4.788 11.556 4.788 4.788 11.556q0 6.732-4.788 11.52t-11.556 4.788zm0-24.372q-3.312 0-5.67 2.358t-2.358 5.706q0 3.312 2.358 5.67t5.67 2.358 5.67-2.358 2.358-5.67q0-3.348-2.358-5.706t-5.67-2.358zm18.828 26.352q.468.972.54 1.782t-.162 1.458-.954 1.386-1.53 1.332-2.214 1.494q-4.14 2.628-11.34 3.384l2.628 2.592 9.612 9.612q1.08 1.116 1.08 2.664t-1.08 2.628l-.432.468q-1.116 1.08-2.664 1.08t-2.664-1.08q-2.412-2.448-9.612-9.648l-9.612 9.648q-1.116 1.08-2.664 1.08t-2.628-1.08l-.432-.468q-1.116-1.08-1.116-2.628t1.116-2.664l9.612-9.612 2.592-2.592q-7.308-.756-11.412-3.384-1.404-.9-2.214-1.494t-1.53-1.332-.954-1.386-.162-1.458.54-1.782q.36-.72 1.008-1.26t1.512-.792 2.016.072 2.34 1.26q.18.144.54.396t1.548.882 2.484 1.098 3.312.864 4.068.396q3.276 0 6.264-.918t4.32-1.818l1.368-.9q1.188-.936 2.34-1.26t2.016-.072 1.512.792 1.008 1.26z\",\"ODNOKLASSNIKI_SQUARE\":\"M33.372-43.559q0 2.376-1.674 4.05t-4.05 1.674-4.05-1.674-1.674-4.05 1.674-4.05 4.05-1.674 4.05 1.674 1.674 4.05zm7.704 13.068q-.36-.72-1.008-1.152t-1.71-.342-2.178.99q-.36.288-1.044.72t-2.916 1.152-4.572.72-4.464-.648-3.096-1.296l-.972-.648q-1.116-.9-2.178-.99t-1.71.342-1.008 1.152q-.792 1.62-.072 2.682t3.132 2.646q2.988 1.908 8.136 2.412l-1.836 1.872q-5.112 5.112-6.876 6.84-.792.792-.792 1.89t.792 1.89l.324.324q.792.792 1.89.792t1.89-.792l6.876-6.876q4.104 4.14 6.876 6.876.792.792 1.89.792t1.89-.792l.324-.324q.792-.792.792-1.89t-.792-1.89l-6.876-6.84-1.872-1.872q5.076-.504 8.1-2.412 2.412-1.584 3.132-2.646t-.072-2.682zm-1.764-13.068q0-4.824-3.42-8.244t-8.244-3.42-8.244 3.42-3.42 8.244 3.42 8.244 8.244 3.42 8.244-3.42 3.42-8.244zm15.984-5.904v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"GET_POCKET\":\"M56.34-59.831q2.34 0 3.96 1.638t1.62 3.978v18.684q0 6.336-2.448 12.096t-6.57 9.9-9.864 6.57-12.042 2.43q-6.336 0-12.078-2.43t-9.882-6.57-6.588-9.9-2.448-12.096v-18.684q0-2.304 1.656-3.96t3.96-1.656h50.724zm-25.344 38.304q1.692 0 2.952-1.188l14.544-13.968q1.332-1.26 1.332-3.06 0-1.764-1.242-3.006t-3.006-1.242q-1.692 0-2.952 1.188l-11.628 11.16-11.628-11.16q-1.26-1.188-2.916-1.188-1.764 0-3.006 1.242t-1.242 3.006q0 1.836 1.296 3.06l14.58 13.968q1.188 1.188 2.916 1.188z\",\"WIKIPEDIA_W\":\"M53.784-5.435l-10.62-25.02q-.9 1.764-5.706 10.998t-7.146 14.022q-.036.036-.99.018t-.954-.054q-2.952-6.948-9.198-21.132t-9.342-21.456q-.756-1.8-2.394-3.87t-3.726-3.618-3.672-1.548l-.018-.864-.018-.972h20.988v1.8q-1.404.072-2.862.576t-2.394 1.548-.36 2.304q.936 2.124 7.794 17.964t8.478 19.44q1.116-2.196 5.04-9.594t4.716-8.91q-.684-1.404-4.536-10.116t-4.896-10.62q-1.368-2.484-7.236-2.556v-1.8l18.468.036v1.692q-2.16.072-3.366.9t-.45 2.484q1.188 2.52 3.132 6.822t3.096 6.75q3.96-7.704 6.228-13.068.864-1.98-.36-2.862t-4.644-.954q.036-.252.036-.9v-.864q2.304 0 6.138-.018t6.48-.036 3.33-.018v1.764q-2.232.072-4.284 1.188t-3.24 2.916l-7.668 15.912q.468 1.188 4.59 10.44t4.374 9.864l15.876-36.612q-.504-1.368-1.782-2.25t-2.34-1.134-1.998-.288v-1.8l16.56.144.036.072-.036 1.584q-5.004.144-7.236 5.22-18.936 43.776-20.124 46.476h-1.764z\",\"SAFARI\":\"M34.164-32.291q0 .936-.594 1.62t-1.494.684q-.936 0-1.62-.594t-.684-1.494q0-.936.612-1.62t1.512-.684 1.584.594.684 1.494zm.54 2.088l12.6-20.916q-.324.288-2.43 2.25t-4.518 4.194-4.914 4.572-4.212 3.978-1.818 1.854l-12.564 20.88q.252-.252 2.412-2.232t4.536-4.194 4.896-4.572 4.212-3.996 1.8-1.818zm23.292-1.98q0 7.236-3.744 13.356-.108-.072-.612-.396t-.954-.594-.594-.27q-.468 0-.468.468 0 .36 2.124 1.584-2.664 4.032-6.642 6.858t-8.694 3.978l-.576-2.412q-.036-.36-.54-.36-.18 0-.288.198t-.072.342l.576 2.448q-2.592.54-5.256.54-7.164 0-13.392-3.78.036-.072.468-.738t.774-1.206.342-.684q0-.468-.468-.468-.216 0-.612.522t-.81 1.242-.486.828q-4.068-2.7-6.912-6.75t-3.96-8.802l2.484-.54q.36-.108.36-.54 0-.18-.198-.288t-.378-.072l-2.448.54q-.504-2.592-.504-5.004 0-7.416 3.924-13.644.072.036.666.432t1.08.684.63.288q.468 0 .468-.432 0-.216-.45-.558t-1.17-.774l-.72-.432q2.772-4.032 6.804-6.804t8.784-3.852l.54 2.412q.072.36.54.36.18 0 .288-.198t.072-.378l-.54-2.376q2.556-.468 4.824-.468 7.344 0 13.644 3.924-1.404 2.016-1.404 2.34 0 .468.432.468.396 0 1.728-2.304 3.996 2.7 6.75 6.696t3.87 8.676l-2.016.432q-.36.072-.36.576 0 .18.198.288t.342.072l2.052-.468q.504 2.592.504 5.04zm3.06 0q0-5.868-2.286-11.196t-6.138-9.18-9.18-6.138-11.196-2.286-11.196 2.286-9.18 6.138-6.138 9.18-2.286 11.196 2.286 11.196 6.138 9.18 9.18 6.138 11.196 2.286 11.196-2.286 9.18-6.138 6.138-9.18 2.286-11.196zm3.456 0q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"CHROME\":\"M32.148-64.439q8.64-.072 16.236 4.32 8.352 4.824 12.672 13.392l-26.712-1.404q-5.76-.324-10.584 2.682t-6.66 8.262l-9.936-15.264q4.608-5.724 11.196-8.838t13.788-3.15zm-26.892 14.58l12.132 23.868q2.592 5.148 7.596 7.812t10.548 1.62l-8.28 16.236q-7.632-1.188-13.86-5.67t-9.81-11.376-3.582-14.814q0-9.612 5.256-17.676zm57.096 6.084q2.088 5.4 2.142 11.178t-1.746 11.016-5.508 9.792-8.856 7.542q-8.28 4.788-17.928 4.284l14.58-22.428q3.168-4.716 2.97-10.458t-3.834-9.99zm-30.096.72q4.5 0 7.686 3.186t3.186 7.686-3.186 7.686-7.686 3.186-7.686-3.186-3.186-7.686 3.186-7.686 7.686-3.186z\",\"FIREFOX\":\"M32.508.073q-10.188 0-18.162-5.418t-11.862-14.346q-2.088-4.716-2.412-10.836t.936-11.97 3.996-11.232 6.444-8.73l-.396 10.116q.396-.504 2.448-.558t2.52.558q1.512-2.916 5.778-4.968t8.442-2.124q-1.944 1.62-4.302 5.346t-2.106 5.886q.9.288 2.25.486t2.268.27 2.448.144 1.818.108q.54.18.342 1.638t-1.098 2.718q-.18.252-.594.666t-2.034 1.278-3.636 1.224l.54 6.804-5.004-2.412q-.648 1.548-.27 2.934t1.296 2.394 2.358 1.494 2.916.234q1.836-.324 3.528-1.242t3.006-1.62 2.646-.63q2.196.144 3.222 1.188t.702 2.34q-.036.072-.09.198t-.306.45-.648.558-1.134.378-1.674.036q-2.16 3.42-5.202 4.878t-7.542 1.062q2.664 2.196 5.85 2.97t6.066.216 5.562-1.872 4.608-3.15 2.898-3.744q1.548-3.276 1.404-6.93t-1.35-6.786-2.826-4.5q3.132 1.368 4.932 2.862t2.772 4.05q.54-6.12-2.07-12.348t-7.542-10.224q9.54 2.772 14.832 10.062t5.436 18.63q.072 4.572-1.458 9.18t-4.446 8.568-6.804 7.056-8.91 4.878-10.386 1.782z\",\"OPERA\":\"M53.748-56.231q-5.94-3.96-12.924-3.96-5.58 0-10.548 2.628t-8.64 7.2q-2.7 3.348-4.302 7.848t-1.746 9.576v1.512q.144 5.076 1.746 9.576t4.302 7.848q3.672 4.572 8.64 7.2t10.548 2.628q6.984 0 12.924-3.96-4.356 3.888-9.882 6.048t-11.61 2.16q-1.044 0-1.548-.036-6.3-.288-11.988-2.952t-9.792-6.948-6.516-10.116-2.412-12.204q0-6.552 2.556-12.528t6.876-10.296 10.296-6.876 12.528-2.556h.108q6.048.036 11.538 2.178t9.846 6.03zm10.764 24.048q0 6.912-2.772 13.05t-7.668 10.674q-3.744 2.268-7.992 2.268-4.932 0-9.18-3.024 5.544-2.016 9.126-8.388t3.582-14.58q0-8.172-3.564-14.544t-9.108-8.424q4.284-2.988 9.144-2.988 4.284 0 8.136 2.34 4.86 4.5 7.578 10.62t2.718 12.996z\",\"INTERNET_EXPLORER\":\"M64.512-30.707q0 2.016-.252 3.744h-41.436q0 5.256 3.942 8.802t9.27 3.546q3.564 0 6.678-1.674t4.914-4.698h15.228q-2.016 5.724-6.138 10.116t-9.63 6.786-11.556 2.394q-6.732 0-12.816-2.988-8.208 4.176-14.184 4.176-8.532 0-8.532-9.468 0-4.14 1.62-9.9.612-2.16 3.924-8.244 7.164-12.96 17.1-21.816-6.624 2.844-15.372 12.744 2.268-9.864 10.206-16.182t18.054-6.318q1.08 0 1.62.036 9.18-4.212 15.588-4.212 2.304 0 4.176.468t3.402 1.458 2.394 2.754.864 4.14q0 4.176-2.7 10.296 3.636 6.552 3.636 14.04zm-2.52-23.04q0-2.988-1.908-4.752t-4.932-1.764q-3.888 0-9.144 2.52 4.356 1.692 8.01 4.734t6.138 7.038q1.836-4.86 1.836-7.776zm-57.384 44.532q0 3.096 1.746 4.77t4.842 1.674q4.14 0 9.576-2.988-4.392-2.592-7.686-6.588t-4.95-8.82q-3.528 7.38-3.528 11.952zm18.144-25.668h26.208q-.18-5.112-4.068-8.532t-9.036-3.42q-5.184 0-9.054 3.42t-4.05 8.532z\",\"TV\":\"M64.512-19.511v-34.56q0-.468-.342-.81t-.81-.342h-57.6q-.468 0-.81.342t-.342.81v34.56q0 .468.342.81t.81.342h57.6q.468 0 .81-.342t.342-.81zm4.608-34.56v34.56q0 2.376-1.692 4.068t-4.068 1.692h-26.496v4.608h12.672q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-29.952q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h12.672v-4.608h-26.496q-2.376 0-4.068-1.692t-1.692-4.068v-34.56q0-2.376 1.692-4.068t4.068-1.692h57.6q2.376 0 4.068 1.692t1.692 4.068z\",\"CONTAO\":\"M4.968-59.831h7.092q-2.52 2.304-4.536 5.364-1.296 2.016-2.124 4.14t-1.08 4.518-.306 4.32.378 4.752.756 4.536 1.008 4.914l.216 1.008q1.836 8.568 2.916 11.844 2.052 6.156 5.472 9.9h-9.792q-1.728 0-2.952-1.224t-1.224-2.952v-46.944q0-1.728 1.224-2.952t2.952-1.224zm43.488 0h11.088q1.728 0 2.952 1.224t1.224 2.952v46.944q0 1.728-1.224 2.952t-2.952 1.224h-6.408q7.632-7.56 7.056-20.34l-16.884 3.636q-.072 1.62-.432 2.952t-1.116 2.592-2.142 2.142-3.366 1.314q-4.428.936-7.164-1.44-1.152-.972-1.908-2.196t-1.854-4.644-2.322-9.288q-1.26-5.868-1.638-9.468t-.198-5.004.828-2.772q.72-1.476 2.25-2.628t3.69-1.62q1.62-.432 3.006-.234t2.412.612 1.944 1.26 1.548 1.728 1.242 2.034l16.848-3.6q-2.448-6.3-6.48-10.332z\",\"500PX\":\"M50.436-8.747l-.216.216q-4.068 4.104-9.324 6.3-5.544 2.304-11.412 2.304-5.94 0-11.412-2.304-5.328-2.268-9.324-6.3-4.068-4.032-6.3-9.288-1.512-3.708-1.944-6.804-.144-1.008 1.728-1.296 1.836-.288 2.016.72l.036.144q.648 3.24 1.656 5.724 1.8 4.464 5.472 8.136 3.528 3.528 8.136 5.472 4.752 2.016 9.936 2.016 5.148 0 9.936-2.016 4.608-1.98 8.1-5.472l.216-.216q.36-.36.9-.216.432.108 1.188.792 1.296 1.332.612 2.088zm-16.992-22.14l-2.376 2.376 2.268 2.268q.756.756-.252 1.764-.612.612-1.152.612-.36 0-.684-.36l-2.232-2.196-2.376 2.376q-.18.18-.54.18-.54 0-1.116-.576l-.072-.072q-.648-.54-.648-1.044 0-.252.288-.612l2.376-2.34-2.376-2.376q-.576-.576.504-1.62.648-.648 1.116-.648.216 0 .468.18l2.34 2.376 2.34-2.34q.648-.612 1.728.468.972.972.396 1.584zm16.956 2.052q0 4.248-1.656 8.208-1.62 3.78-4.536 6.696-2.88 2.88-6.732 4.536t-8.208 1.656-8.208-1.656-6.732-4.536q-2.952-2.952-4.5-6.696-.54-1.152-.54-1.44h-.036q-.324-.972 1.548-1.584 1.8-.576 2.16.432 1.332 3.564 3.492 6.012h.036v-12.276q.108-4.896 3.672-8.352 3.78-3.708 9.108-3.708 5.292 0 9.036 3.708t3.744 8.964q0 5.292-3.762 9.036t-9.018 3.744q-2.088 0-4.032-.576-1.008-.396-.468-2.196.576-1.836 1.584-1.548l.504.108q.504.108 1.17.216t1.098.108q3.744 0 6.336-2.574t2.592-6.282q0-3.636-2.592-6.156-2.556-2.556-6.3-2.556-3.852 0-6.408 2.88-2.304 2.592-2.304 5.76v14.868q3.96 2.412 8.712 2.412 3.456 0 6.66-1.314t5.616-3.726 3.726-5.58 1.314-6.588q0-7.128-5.076-12.204-5.04-5.04-12.204-5.04-7.2 0-12.24 5.04-1.908 1.908-2.772 3.132l-.072.072q-.288.396-.468.558t-.774.342-1.386-.108q-.756-.18-1.314-.594t-.558-.954v-24.48q0-.54.378-.954t.99-.414h31.572q1.08 0 1.08 1.98t-1.08 1.98h-29.196v17.388h.036q1.44-1.512 3.672-3.024t3.888-2.196q3.924-1.656 8.316-1.656 4.356 0 8.208 1.656t6.732 4.536q2.916 2.916 4.536 6.696 1.656 4.032 1.656 8.244zm-1.116-20.916q.324.288.324.648t-.198.648-.594.756q-.936.936-1.404.936-.324 0-.576-.252-3.816-3.276-7.452-4.788-4.608-2.016-9.936-2.016-4.788 0-9.432 1.764-.972.36-1.62-1.332-.324-.9-.288-1.368.108-.576.576-.72 4.68-2.052 10.764-2.052 5.904 0 11.376 2.304 4.932 2.088 8.46 5.472z\",\"AMAZON\":\"M55.836-11.303q.54-.216.936-.108t.396.63-.54 1.206q-.468.576-1.584 1.566t-3.438 2.448-5.076 2.664-6.768 2.088-8.262.882q-4.284 0-8.568-1.116t-7.524-2.754-6.21-3.744-4.77-3.78-3.024-3.15q-.288-.324-.36-.594t.036-.432.288-.252.414-.072.414.162q6.912 4.212 10.8 5.976 14.004 6.336 28.764 3.24 6.84-1.44 14.076-4.86zm7.452-4.14q.396.576.09 2.502t-1.026 3.69q-1.224 2.988-3.06 4.464-.612.504-.936.324t0-.864q.756-1.62 1.602-4.374t.234-3.546q-.18-.252-.558-.414t-.972-.216-1.062-.09-1.26 0-1.134.072-1.116.108-.81.072q-.216.036-.468.054t-.396.036-.306.036-.252.018h-.36l-.108-.018-.072-.054-.054-.108q-.216-.576 1.692-1.44t3.708-1.08q1.656-.252 3.888-.036t2.736.864zm-14.184-15.948q0 1.116.486 2.304t1.152 2.088 1.35 1.656 1.188 1.152l.468.396-8.172 8.064q-1.44-1.332-2.844-2.718t-2.088-2.106l-.684-.72q-.396-.396-.9-1.188-1.368 2.124-3.51 3.69t-4.59 2.286-5.04.828-4.95-.756-4.23-2.358-2.988-4.068-1.116-5.85q0-3.024 1.008-5.544t2.592-4.194 3.834-2.988 4.41-2.052 4.68-1.242 4.302-.666 3.582-.234v-4.572q0-2.34-.756-3.492-1.224-1.908-4.356-1.908-.216 0-.594.036t-1.458.432-2.016 1.062-2.016 2.142-1.728 3.456l-10.584-.972q0-2.16.792-4.284t2.412-4.068 3.888-3.42 5.454-2.358 6.858-.882q3.6 0 6.516.9t4.662 2.214 2.916 2.988 1.62 3.096.45 2.646v21.204zm-24.192.756q0 3.096 2.52 4.788 2.376 1.584 5.004.792 3.024-.9 4.104-4.428.504-1.62.504-3.636v-5.832q-2.124.072-3.996.432t-3.834 1.206-3.132 2.556-1.17 4.122z\",\"CALENDAR_PLUS_O\":\"M55.296-55.223q1.872 0 3.24 1.368t1.368 3.24v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608zm-13.824-3.456v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm-27.648 0v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828zm41.472 54.144v-36.864h-50.688v36.864h50.688zm-23.04-20.736h8.064q.504 0 .828.324t.324.828v2.304q0 .504-.324.828t-.828.324h-8.064v8.064q0 .504-.324.828t-.828.324h-2.304q-.504 0-.828-.324t-.324-.828v-8.064h-8.064q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h8.064v-8.064q0-.504.324-.828t.828-.324h2.304q.504 0 .828.324t.324.828v8.064z\",\"CALENDAR_MINUS_O\":\"M41.472-24.119v2.304q0 .504-.324.828t-.828.324h-20.736q-.504 0-.828-.324t-.324-.828v-2.304q0-.504.324-.828t.828-.324h20.736q.504 0 .828.324t.324.828zm-36.864 19.584h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z\",\"CALENDAR_TIMES_O\":\"M39.996-14.579l-1.656 1.656q-.324.324-.792.324t-.828-.324l-6.768-6.804-6.768 6.804q-.36.324-.828.324t-.792-.324l-1.656-1.656q-.324-.324-.324-.792t.324-.828l6.804-6.768-6.804-6.768q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l6.768 6.768 6.768-6.768q.36-.324.828-.324t.792.324l1.656 1.656q.324.324.324.792t-.324.828l-6.768 6.768 6.768 6.768q.324.36.324.828t-.324.792zm-35.388 10.044h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z\",\"CALENDAR_CHECK_O\":\"M46.908-29.735l-18.432 18.432q-.36.324-.828.324t-.828-.324l-10.368-10.368q-.324-.36-.324-.828t.324-.792l1.656-1.656q.324-.324.792-.324t.828.324l7.92 7.92 15.984-15.984q.36-.324.828-.324t.792.324l1.656 1.656q.324.324.324.792t-.324.828zm-42.3 25.2h50.688v-36.864h-50.688v36.864zm13.824-43.776v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm27.648 0v-10.368q0-.504-.324-.828t-.828-.324h-2.304q-.504 0-.828.324t-.324.828v10.368q0 .504.324.828t.828.324h2.304q.504 0 .828-.324t.324-.828zm13.824-2.304v46.08q0 1.872-1.368 3.24t-3.24 1.368h-50.688q-1.872 0-3.24-1.368t-1.368-3.24v-46.08q0-1.872 1.368-3.24t3.24-1.368h4.608v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h13.824v-3.456q0-2.376 1.692-4.068t4.068-1.692h2.304q2.376 0 4.068 1.692t1.692 4.068v3.456h4.608q1.872 0 3.24 1.368t1.368 3.24z\",\"INDUSTRY\":\"M16.128-64.439q.936 0 1.62.684t.684 1.62v32.076l19.296-15.444q.612-.504 1.44-.504.936 0 1.62.684t.684 1.62v13.644l19.296-15.444q.612-.504 1.44-.504.936 0 1.62.684t.684 1.62v41.472q0 .936-.684 1.62t-1.62.684h-59.904q-.936 0-1.62-.684t-.684-1.62v-59.904q0-.936.684-1.62t1.62-.684h13.824z\",\"MAP_PIN\":\"M18.432-25.271q2.376 0 4.608-.54v23.58q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-23.58q2.196.54 4.608.54zm0-39.168q7.632 0 13.032 5.4t5.4 13.032-5.4 13.032-13.032 5.4-13.032-5.4-5.4-13.032 5.4-13.032 13.032-5.4zm0 8.064q.504 0 .828-.324t.324-.828-.324-.828-.828-.324q-5.256 0-8.964 3.708t-3.708 8.964q0 .504.324.828t.828.324.828-.324.324-.828q0-4.284 3.042-7.326t7.326-3.042z\",\"MAP_SIGNS\":\"M62.82-53.747q.36.36.36.828t-.36.828l-5.076 5.076q-1.008 1.008-2.448 1.008h-48.384q-.936 0-1.62-.684t-.684-1.62v-9.216q0-.936.684-1.62t1.62-.684h20.736v-2.304q0-.936.684-1.62t1.62-.684h4.608q.936 0 1.62.684t.684 1.62v2.304h18.432q1.44 0 2.448 1.008zm-35.172 33.084h9.216v18.432q0 .936-.684 1.62t-1.62.684h-4.608q-.936 0-1.62-.684t-.684-1.62v-18.432zm29.952-16.128q.936 0 1.62.684t.684 1.62v9.216q0 .936-.684 1.62t-1.62.684h-48.384q-1.44 0-2.448-1.008l-5.076-5.076q-.36-.36-.36-.828t.36-.828l5.076-5.076q1.008-1.008 2.448-1.008h18.432v-6.912h9.216v6.912h20.736z\",\"MAP_O\":\"M72.72-64.043q1.008.72 1.008 1.908v50.688q0 .72-.396 1.296t-1.044.828l-23.04 9.216q-.864.396-1.728 0l-22.176-8.856-22.176 8.856q-.36.18-.864.18-.684 0-1.296-.396-1.008-.72-1.008-1.908v-50.688q0-.72.396-1.296t1.044-.828l23.04-9.216q.864-.396 1.728 0l22.176 8.856 22.176-8.856q1.152-.468 2.16.216zm-46.224 4.86v45.72l20.736 8.28v-45.72zm-21.888 7.812v45.72l19.584-7.812v-45.72zm64.512 38.376v-45.72l-19.584 7.812v45.72z\",\"MAP\":\"M18.432-64.439q.468 0 .81.342t.342.81v52.992q0 .72-.612 1.008l-17.28 9.216q-.252.144-.54.144-.468 0-.81-.342t-.342-.81v-52.992q0-.72.612-1.008l17.28-9.216q.252-.144.54-.144zm44.928 0q.468 0 .81.342t.342.81v52.992q0 .72-.612 1.008l-17.28 9.216q-.252.144-.54.144-.468 0-.81-.342t-.342-.81v-52.992q0-.72.612-1.008l17.28-9.216q.252-.144.54-.144zm-40.32 0q.288 0 .504.108l18.432 9.216q.648.36.648 1.044v52.992q0 .468-.342.81t-.81.342q-.288 0-.504-.108l-18.432-9.216q-.648-.36-.648-1.044v-52.992q0-.468.342-.81t.81-.342z\",\"COMMENTING\":\"M23.04-32.183q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm13.824 0q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-3.96 0-7.596-.648-6.228 6.228-15.66 8.244-1.872.36-3.096.468-.432.036-.792-.216t-.468-.648q-.144-.54.72-1.332.18-.18.846-.774t.918-.846.846-.918.864-1.134.738-1.332.72-1.728.522-2.07.45-2.61q-5.256-3.24-8.262-7.794t-3.006-9.702q0-6.264 4.32-11.574t11.736-8.388 16.2-3.078 16.2 3.078 11.736 8.388 4.32 11.574z\",\"COMMENTING_O\":\"M23.04-32.183q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm13.824 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm13.824 0q0 1.908-1.35 3.258t-3.258 1.35-3.258-1.35-1.35-3.258 1.35-3.258 3.258-1.35 3.258 1.35 1.35 3.258zm-18.432-18.432q-7.344 0-13.734 2.502t-10.152 6.75-3.762 9.18q0 4.032 2.574 7.686t7.254 6.318l3.132 1.8-.972 3.456q-.864 3.276-2.52 6.192 5.472-2.268 9.9-6.156l1.548-1.368 2.052.216q2.484.288 4.68.288 7.344 0 13.734-2.502t10.152-6.75 3.762-9.18-3.762-9.18-10.152-6.75-13.734-2.502zm32.256 18.432q0 6.264-4.32 11.574t-11.736 8.388-16.2 3.078q-2.52 0-5.22-.288-7.128 6.3-16.56 8.712-1.764.504-4.104.792h-.18q-.54 0-.972-.378t-.576-.99v-.036q-.108-.144-.018-.432t.072-.36.162-.342l.216-.324.252-.306.288-.324q.252-.288 1.116-1.242t1.242-1.368 1.116-1.422 1.17-1.836.972-2.124.936-2.736q-5.652-3.204-8.91-7.92t-3.258-10.116q0-4.68 2.556-8.946t6.876-7.362 10.296-4.914 12.528-1.818 12.528 1.818 10.296 4.914 6.876 7.362 2.556 8.946z\",\"HOUZZ\":\"M18.432-21.563l18.432-10.62v21.276l-18.432 10.656v-21.312zm-18.432-10.62v21.276l18.432-10.656zm18.432-31.932v21.276l-18.432 10.656v-21.276zm0 21.276l18.432-10.62v21.276z\",\"VIMEO\":\"M61.524-45.791q-.36 8.496-11.952 23.436-11.988 15.516-20.232 15.516-5.112 0-8.64-9.468-1.584-5.76-4.752-17.352-2.592-9.432-5.652-9.432-.648 0-4.572 2.736l-2.772-3.528q.864-.756 3.888-3.474t4.68-4.158q5.616-4.968 8.676-5.256 3.42-.324 5.508 1.998t2.916 7.326q1.584 10.332 2.376 13.428 1.98 8.964 4.32 8.964 1.836 0 5.544-5.796 3.636-5.796 3.924-8.856.468-5.004-3.924-5.004-2.052 0-4.356.936 4.32-14.148 16.524-13.752 9.036.288 8.496 11.736z\",\"BLACK_TIE\":\"M0-59.831h55.296v55.296h-55.296v-55.296zm39.06 40.14l-7.956-22.716 7.956-10.692h-22.824l7.956 10.692-7.956 22.716 11.412 10.944z\",\"FONTICONS\":\"M0-59.831h55.296v55.296h-55.296v-55.296zm32.688 11.52l-.432 1.188 2.7 2.988-1.116 4.104.9.9 3.852-2.052 3.852 2.052.9-.9-1.116-4.104 2.7-2.988-.432-1.188h-3.42l-1.908-3.456h-1.152l-1.908 3.456h-3.42zm-9.612 5.868q1.152 0 1.602.576t.414 2.268l6.264-.756q0-1.98-.63-3.33t-1.818-2.016-2.484-.918-3.06-.252q-4.788 0-7.164 2.07t-2.376 6.57v2.592h-3.456v4.608h2.736q.72 0 .72.288v13.752q0 .504-.18.72t-.648.252l-2.628.252v3.168h16.128v-3.096l-5.364-.504q-.216-.036-.306-.054t-.126-.09-.018-.144.036-.252.018-.36v-13.932h6.876l1.368-4.608h-8.316q-.216 0-.072-.216t.144-.324v-2.88q0-.972.054-1.458t.27-1.008.702-.72 1.314-.198zm21.852 29.844v-3.096l-1.944-.324q-.252-.036-.342-.09t-.09-.108.036-.27.036-.432v-18.72h-9.9l-.828 3.636 2.988.792q.828.252.828.972v13.32q0 .504-.216.666t-.72.234l-2.52.324v3.096h12.672z\",\"REDDIT_ALIEN\":\"M64.512-33.983q0 2.088-1.062 3.798t-2.862 2.61q.432 1.656.432 3.456 0 5.58-3.834 10.332t-10.458 7.506-14.4 2.754-14.382-2.754-10.44-7.506-3.834-10.332q0-1.692.396-3.384-1.836-.9-2.952-2.646t-1.116-3.834q0-2.952 2.088-5.058t5.076-2.106q3.06 0 5.22 2.268 7.848-5.472 18.54-5.832l4.176-18.756q.108-.468.54-.756t.936-.18l13.284 2.916q.648-1.332 1.944-2.142t2.844-.81q2.232 0 3.816 1.566t1.584 3.798-1.584 3.816-3.816 1.584-3.798-1.566-1.566-3.798l-12.024-2.664-3.744 16.992q10.8.324 18.684 5.76 2.088-2.196 5.148-2.196 2.988 0 5.076 2.106t2.088 5.058zm-49.464 7.164q0 2.232 1.566 3.816t3.798 1.584 3.816-1.584 1.584-3.816-1.584-3.798-3.816-1.566q-2.196 0-3.78 1.584t-1.584 3.78zm29.16 12.78q.396-.396.396-.936t-.396-.936q-.36-.36-.9-.36t-.936.36q-1.476 1.512-4.356 2.232t-5.76.72-5.76-.72-4.356-2.232q-.396-.36-.936-.36t-.9.36q-.396.36-.396.918t.396.954q1.548 1.548 4.266 2.448t4.41 1.062 3.276.162 3.276-.162 4.41-1.062 4.266-2.448zm-.108-7.38q2.232 0 3.798-1.584t1.566-3.816q0-2.196-1.584-3.78t-3.78-1.584q-2.232 0-3.816 1.566t-1.584 3.798 1.584 3.816 3.816 1.584z\",\"EDGE\":\"M2.484-35.819h.036q.576-4.536 2.106-8.694t4.14-7.812 6.03-6.336 8.046-4.23 9.954-1.548q8.316 0 14.904 3.798t10.584 10.926q3.744 6.732 3.744 15.912v6.768h-40.5q.036 3.996 1.926 6.93t4.914 4.41 6.822 2.052 7.668.108 7.488-1.674 6.246-3.042v13.572q-3.312 1.98-8.262 3.312t-11.25 1.368-11.376-1.908q-6.804-2.628-11.214-8.964t-4.482-13.392q-.108-8.712 3.996-14.832t11.7-9.648q-1.728 2.16-2.808 4.518t-1.656 5.742h22.86q.288-2.772-.288-5.04t-1.692-3.654-2.538-2.394-2.898-1.476-2.7-.738-2.016-.306l-.792-.036q-4.86.18-9.342 1.602t-8.046 3.762-6.336 5.058-4.968 5.886z\",\"CREDIT_CARD_ALT\":\"M0-10.295v-21.888h82.944v21.888q0 2.376-1.692 4.068t-4.068 1.692h-71.424q-2.376 0-4.068-1.692t-1.692-4.068zm23.04-8.064v4.608h13.824v-4.608h-13.824zm-13.824 0v4.608h9.216v-4.608h-9.216zm67.968-41.472q2.376 0 4.068 1.692t1.692 4.068v8.064h-82.944v-8.064q0-2.376 1.692-4.068t4.068-1.692h71.424z\",\"CODIEPIE\":\"M55.764-39.995q1.98 0 3.078 1.026t1.098 3.006-1.224 2.952-3.276.972h-4.896v6.372h-.9v-14.328h6.12zm5.796 21.24l-.144.396-.18.36q-4.068 8.28-11.898 13.176t-17.082 4.896q-6.552 0-12.528-2.556t-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556q8.784 0 16.362 4.464t11.862 12.168l.072.144.288.576q-1.08.54-4.914 2.466t-5.886 3.042q-.216.108-17.244 9.648 13.824 6.588 28.764 13.176zm-29.304 18.036q9 0 16.65-4.77t11.61-12.87l-10.332-4.644q-2.592 5.04-7.416 7.992t-10.512 2.952q-5.436 0-10.08-2.7t-7.344-7.344-2.7-10.08 2.7-10.08 7.344-7.344 10.08-2.7 10.08 2.646 7.344 7.362l10.08-5.148q-4.176-7.488-11.556-11.844t-15.948-4.356q-4.284 0-8.37 1.134t-7.524 3.15-6.354 4.932-4.932 6.354-3.15 7.524-1.134 8.37 1.134 8.37 3.15 7.524 4.932 6.354 6.354 4.932 7.524 3.15 8.37 1.134z\",\"MODX\":\"M51.372-38.915l-22.104-13.896 3.312-5.436h30.78zm-36.792 9.54l-6.624-4.176v-30.888l42.588 26.748zm36.684-4.86l5.292 3.42v30.888l-19.152-12.06zm-1.332-.756l-18 28.872h-30.78l12.816-20.556z\",\"FORT_AWESOME\":\"M23.04-28.151v-8.064q0-.576-.576-.576h-3.456q-.576 0-.576.576v8.064q0 .576.576.576h3.456q.576 0 .576-.576zm18.432 0v-8.064q0-.576-.576-.576h-3.456q-.576 0-.576.576v8.064q0 .576.576.576h3.456q.576 0 .576-.576zm18.432 1.152v27.072h-23.04v-11.52q0-2.88-2.016-4.896t-4.896-2.016-4.896 2.016-2.016 4.896v11.52h-23.04v-27.072q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-22.464q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h.576v-14.148q-1.152-.684-1.152-1.98 0-.936.684-1.62t1.62-.684 1.62.684.684 1.62q0 1.296-1.152 1.98v.324h9.792q.576 0 .576.576v8.064q0 .576-.576.576h-9.792v4.608h.576q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v4.032h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576v22.464h4.608v-4.032q0-.576.576-.576h3.456q.576 0 .576.576z\",\"USB\":\"M82.368-35.459q.576.288.576.972t-.576.972l-11.52 6.912q-.288.18-.576.18-.324 0-.576-.144-.576-.36-.576-1.008v-4.608h-30.888q1.332 2.088 2.988 5.94.576 1.332.882 1.98t.864 1.764.972 1.692.972 1.224 1.134.936 1.188.288h3.456v-3.456q0-.504.324-.828t.828-.324h11.52q.504 0 .828.324t.324.828v11.52q0 .504-.324.828t-.828.324h-11.52q-.504 0-.828-.324t-.324-.828v-3.456h-3.456q-1.152 0-2.196-.36t-1.836-.846-1.62-1.458-1.332-1.656-1.206-2.052-1.026-2.07-1.008-2.178q-.828-1.908-1.332-2.934t-1.296-2.34-1.602-1.926-1.674-.612h-12.96q-.792 3.024-3.276 4.968t-5.652 1.944q-3.816 0-6.516-2.7t-2.7-6.516 2.7-6.516 6.516-2.7q3.168 0 5.652 1.944t3.276 4.968h3.744q.864 0 1.674-.612t1.602-1.926 1.296-2.34 1.332-2.934q.684-1.476 1.008-2.178t1.026-2.07 1.206-2.052 1.332-1.656 1.62-1.458 1.836-.846 2.196-.36h3.852q.756-2.052 2.52-3.33t3.996-1.278q2.88 0 4.896 2.016t2.016 4.896-2.016 4.896-4.896 2.016q-2.232 0-3.996-1.278t-2.52-3.33h-3.852q-.612 0-1.188.288t-1.134.936-.972 1.224-.972 1.692-.864 1.764-.882 1.98q-1.656 3.852-2.988 5.94h40.104v-4.608q0-.648.576-1.008t1.152.036z\",\"PRODUCT_HUNT\":\"M41.4-37.007q0 2.016-1.422 3.42t-3.438 1.404h-9.108v-9.684h9.108q2.016 0 3.438 1.422t1.422 3.438zm6.444 0q0-4.68-3.294-7.992t-8.01-3.312h-15.588v32.256h6.48v-9.684h9.108q4.68 0 7.992-3.294t3.312-7.974zm16.668 4.824q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"MIXCLOUD\":\"M59.22-24.911q0-2.124-1.224-3.834t-3.132-2.466q-.252 1.62-.828 3.312-.252.864-.99 1.368t-1.602.504q-.432 0-.864-.108-1.116-.36-1.62-1.386t-.144-2.106q.828-2.556.828-5.148 0-4.428-2.196-8.19t-5.976-5.958-8.208-2.196q-4.824 0-8.892 2.628t-6.012 6.984q3.888 1.008 6.768 3.816.792.828.792 1.98t-.792 1.944-1.944.792-1.98-.792q-2.7-2.7-6.48-2.7-3.816 0-6.516 2.682t-2.7 6.498 2.7 6.498 6.516 2.682h37.656q2.844 0 4.842-1.998t1.998-4.806zm5.508 0q0 5.112-3.618 8.712t-8.73 3.6h-37.656q-6.084 0-10.404-4.302t-4.32-10.386q0-5.508 3.6-9.612t8.964-4.896q2.232-6.624 7.956-10.728t12.744-4.104q8.46 0 14.706 5.706t7.074 14.022q4.176.9 6.93 4.266t2.754 7.722zm9 0q0 6.3-3.492 11.484-.828 1.188-2.304 1.188-.864 0-1.548-.468-.936-.612-1.152-1.746t.432-2.07q2.556-3.744 2.556-8.388t-2.556-8.388q-.648-.936-.432-2.052t1.152-1.764 2.07-.414 1.782 1.17q3.492 5.112 3.492 11.448zm9.216 0q0 8.784-4.824 15.948-.828 1.224-2.304 1.224-.828 0-1.512-.468-.936-.648-1.17-1.764t.414-2.052q3.888-5.904 3.888-12.888 0-7.02-3.888-12.852-.648-.936-.414-2.07t1.17-1.746q.936-.648 2.052-.432t1.764 1.188q4.824 7.128 4.824 15.912z\",\"SCRIBD\":\"M54-8.675q0 3.204-2.268 5.49t-5.508 2.286-5.526-2.286-2.286-5.49q0-3.24 2.286-5.526t5.526-2.286 5.508 2.286 2.268 5.526zm-8.388-10.116q-4.14.54-6.93 3.69t-2.79 7.398q0 2.664 1.188 4.968-5.256 2.808-13.644 2.808-3.924 0-7.236-.756t-5.526-1.962-3.978-2.754-2.736-3.06-1.602-2.988-.846-2.394-.216-1.422q0-.684.162-1.53t.666-2.016 1.314-2.088 2.304-1.566 3.402-.648 3.384.63 2.268 1.476 1.278 1.908.63 1.764.144 1.206q0 1.224-.828 2.916 1.008.972 2.952 1.512t3.348.612l1.44.036q4.14 0 6.84-1.836t2.7-4.788q0-.936-.324-1.746t-1.134-1.602-1.782-1.476-2.664-1.584-3.366-1.71-4.302-2.034l-1.548-.72q-4.176-1.98-6.732-3.6t-4.41-3.672-2.592-4.518-.738-5.85q0-2.808.738-5.4t2.376-4.95 4.05-4.104 5.994-2.772 7.974-1.026q4.32 0 7.92.936t5.922 2.412 3.942 3.384 2.304 3.798.684 3.726q0 1.656-.54 2.97t-1.314 2.088-1.746 1.296-1.764.702-1.404.18h-1.44l-1.404-.18-1.584-.504-1.476-1.008-1.332-1.656-.864-2.538-.36-3.51q-.54-.576-2.124-.918t-2.916-.378l-1.332-.036q-2.448 0-4.23 1.116t-2.538 2.52-.756 2.736q0 .864.18 1.548t.864 1.656 1.908 1.836 3.492 1.926 5.4 2.106q2.736.9 4.986 1.926t3.924 1.998 2.988 2.124 2.178 2.142 1.476 2.25.954 2.232.522 2.286.216 2.232.036 2.25z\",\"PAUSE_CIRCLE\":\"M25.344-21.815v-20.736q0-.504-.324-.828t-.828-.324h-9.216q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h9.216q.504 0 .828-.324t.324-.828zm16.128 0v-20.736q0-.504-.324-.828t-.828-.324h-9.216q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h9.216q.504 0 .828-.324t.324-.828zm13.824-10.368q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"PAUSE_CIRCLE_O\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm0 47.232q5.328 0 9.828-2.628t7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm3.456-8.064q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-6.912zm-13.824 0q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h6.912q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-6.912z\",\"STOP_CIRCLE\":\"M39.168-21.815v-20.736q0-.504-.324-.828t-.828-.324h-20.736q-.504 0-.828.324t-.324.828v20.736q0 .504.324.828t.828.324h20.736q.504 0 .828-.324t.324-.828zm16.128-10.368q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"STOP_CIRCLE_O\":\"M27.648-59.831q7.524 0 13.878 3.708t10.062 10.062 3.708 13.878-3.708 13.878-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708zm0 47.232q5.328 0 9.828-2.628t7.128-7.128 2.628-9.828-2.628-9.828-7.128-7.128-9.828-2.628-9.828 2.628-7.128 7.128-2.628 9.828 2.628 9.828 7.128 7.128 9.828 2.628zm-10.368-8.064q-.504 0-.828-.324t-.324-.828v-20.736q0-.504.324-.828t.828-.324h20.736q.504 0 .828.324t.324.828v20.736q0 .504-.324.828t-.828.324h-20.736z\",\"SHOPPING_BAG\":\"M63.252-13.751l1.26 11.268q.108 1.008-.576 1.8-.684.756-1.728.756h-59.904q-1.044 0-1.728-.756-.684-.792-.576-1.8l1.26-11.268h61.992zm-3.348-30.204l3.096 27.9h-61.488l3.096-27.9q.108-.864.756-1.458t1.548-.594h9.216v4.608q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258v-4.608h13.824v4.608q0 1.908 1.35 3.258t3.258 1.35 3.258-1.35 1.35-3.258v-4.608h9.216q.9 0 1.548.594t.756 1.458zm-13.824-6.66v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62v-9.216q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516v9.216q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62v-9.216q0-5.724 4.05-9.774t9.774-4.05 9.774 4.05 4.05 9.774z\",\"SHOPPING_BASKET\":\"M69.12-36.791q1.908 0 3.258 1.35t1.35 3.258-1.35 3.258-3.258 1.35h-.54l-4.14 23.832q-.288 1.656-1.584 2.736t-2.952 1.08h-46.08q-1.656 0-2.952-1.08t-1.584-2.736l-4.14-23.832h-.54q-1.908 0-3.258-1.35t-1.35-3.258 1.35-3.258 3.258-1.35h64.512zm-51.66 28.8q.936-.072 1.566-.81t.558-1.674l-1.152-14.976q-.072-.936-.81-1.566t-1.674-.558-1.566.81-.558 1.674l1.152 14.976q.072.9.738 1.512t1.566.612h.18zm14.796-2.304v-14.976q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm13.824 0v-14.976q0-.936-.684-1.62t-1.62-.684-1.62.684-.684 1.62v14.976q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62zm12.672.18l1.152-14.976q.072-.936-.558-1.674t-1.566-.81-1.674.558-.81 1.566l-1.152 14.976q-.072.936.558 1.674t1.566.81h.18q.9 0 1.566-.612t.738-1.512zm-41.616-43.812l-3.348 14.832h-4.752l3.636-15.876q.684-3.168 3.204-5.166t5.76-1.998h6.012q0-.936.684-1.62t1.62-.684h13.824q.936 0 1.62.684t.684 1.62h6.012q3.24 0 5.76 1.998t3.204 5.166l3.636 15.876h-4.752l-3.348-14.832q-.396-1.584-1.638-2.592t-2.862-1.008h-6.012q0 .936-.684 1.62t-1.62.684h-13.824q-.936 0-1.62-.684t-.684-1.62h-6.012q-1.62 0-2.862 1.008t-1.638 2.592z\",\"HASHTAG\":\"M35.676-27.575l2.304-9.216h-9.144l-2.304 9.216h9.144zm27.648-18.144l-2.016 8.064q-.252.864-1.116.864h-11.772l-2.304 9.216h11.196q.54 0 .9.432.36.504.216 1.008l-2.016 8.064q-.18.864-1.116.864h-11.772l-2.916 11.808q-.252.864-1.116.864h-8.064q-.576 0-.936-.432-.324-.432-.216-1.008l2.808-11.232h-9.144l-2.916 11.808q-.252.864-1.116.864h-8.1q-.54 0-.9-.432-.324-.432-.216-1.008l2.808-11.232h-11.196q-.54 0-.9-.432-.324-.432-.216-1.008l2.016-8.064q.252-.864 1.116-.864h11.772l2.304-9.216h-11.196q-.54 0-.9-.432-.36-.504-.216-1.008l2.016-8.064q.18-.864 1.116-.864h11.772l2.916-11.808q.252-.864 1.152-.864h8.064q.54 0 .9.432.324.432.216 1.008l-2.808 11.232h9.144l2.916-11.808q.252-.864 1.152-.864h8.064q.54 0 .9.432.324.432.216 1.008l-2.808 11.232h11.196q.54 0 .9.432.324.432.216 1.008z\",\"BLUETOOTH\":\"M30.276-26.531l5.328 5.328-5.364 5.364zm-.036-21.996l5.364 5.364-5.328 5.328zm-4.68 44.064l16.704-16.704-11.016-11.016 11.016-11.016-16.704-16.704v21.996l-9.18-9.18-3.348 3.348 11.52 11.556-11.52 11.556 3.348 3.348 9.18-9.18v21.996zm25.884-27.72q0 7.524-1.152 13.158t-3.15 9.252-5.058 5.85-6.534 3.114-7.902.882-7.902-.882-6.534-3.114-5.058-5.85-3.15-9.252-1.152-13.158 1.152-13.158 3.15-9.252 5.058-5.85 6.534-3.114 7.902-.882 7.902.882 6.534 3.114 5.058 5.85 3.15 9.252 1.152 13.158z\",\"BLUETOOTH_B\":\"M21.456-13.211l6.228-6.192-6.228-6.192v12.384zm0-25.56l6.228-6.192-6.228-6.192v12.384zm1.152 6.588l12.816 12.816-19.404 19.44v-25.596l-10.692 10.656-3.888-3.888 13.392-13.428-13.392-13.428 3.888-3.888 10.692 10.656v-25.596l19.404 19.44z\",\"PERCENT\":\"M46.08-18.359q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm-27.648-27.648q0-1.872-1.368-3.24t-3.24-1.368-3.24 1.368-1.368 3.24 1.368 3.24 3.24 1.368 3.24-1.368 1.368-3.24zm36.864 27.648q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774zm-3.456-39.168q0 .72-.468 1.368l-38.016 50.688q-.684.936-1.836.936h-5.76q-.936 0-1.62-.684t-.684-1.62q0-.72.468-1.368l38.016-50.688q.684-.936 1.836-.936h5.76q.936 0 1.62.684t.684 1.62zm-24.192 11.52q0 5.724-4.05 9.774t-9.774 4.05-9.774-4.05-4.05-9.774 4.05-9.774 9.774-4.05 9.774 4.05 4.05 9.774z\",\"GITLAB\":\"M3.744-39.023l28.512 36.54-31.248-22.68q-.648-.468-.9-1.242t0-1.53l3.636-11.088zm16.632 0h23.76l-11.88 36.54zm-7.128-22.032l7.128 22.032h-16.632l7.128-22.032q.288-.828 1.188-.828t1.188.828zm47.52 22.032l3.636 11.088q.252.756 0 1.53t-.9 1.242l-31.248 22.68 28.512-36.54zm0 0h-16.632l7.128-22.032q.288-.828 1.188-.828t1.188.828z\",\"WPBEGINNER\":\"M13.824-34.487h5.76v-8.064h-5.76v8.064zm30.132 11.952v-3.312q-3.744 1.296-8.748 1.368-4.86.036-9.342-1.674t-7.938-4.41l.036 3.456q3.168 2.88 7.632 4.626t9.792 1.71q4.644 0 8.568-1.764zm-20.916-11.952h23.04v-8.064h-23.04v8.064zm41.472-1.152q0 6.732-3.564 12.672 3.204 3.672 3.204 8.244 0 5.652-4.662 9.648t-11.286 3.996q-4.392 0-8.1-1.89t-5.796-5.058q-.684.036-2.052.036t-2.052-.036q-2.088 3.168-5.796 5.058t-8.1 1.89q-6.624 0-11.286-3.996t-4.662-9.648q0-4.572 3.204-8.244-3.564-5.94-3.564-12.672 0-7.524 4.32-13.878t11.754-10.062 16.182-3.708 16.182 3.708 11.754 10.062 4.32 13.878z\",\"WPFORMS\":\"M18.54-31.643v4.608h-9.072v-4.608h9.072zm0-9.18v4.572h-9.072v-4.572h9.072zm27.288 18.396v4.608h-12.276v-4.608h12.276zm0-9.216v4.608h-24.192v-4.608h24.192zm0-9.18v4.572h-24.192v-4.572h24.192zm4.86 30.96v-44.64q0-.288-.216-.504t-.504-.216h-1.152l-13.608 9.216-7.56-6.156-7.56 6.156-13.608-9.216h-1.152q-.288 0-.504.216t-.216.504v44.64q0 .288.216.504t.504.216h44.64q.288 0 .504-.216t.216-.504zm-30.78-39.96l6.66-5.4h-14.616zm15.48 0l7.956-5.4h-14.616zm19.908-4.68v44.64q0 2.232-1.548 3.78t-3.78 1.548h-44.64q-2.232 0-3.78-1.548t-1.548-3.78v-44.64q0-2.232 1.548-3.78t3.78-1.548h44.64q2.232 0 3.78 1.548t1.548 3.78z\",\"ENVIRA\":\"M32.256-35.063q-3.744-7.056-5.76-10.008-5.004-7.272-12.492-11.448-1.224-.684-2.52-1.296-3.204-1.44-3.384-1.152t1.224 1.368l1.404 1.116q2.232 1.548 4.05 3.366t3.402 4.194 2.538 4.068 2.538 4.716q.324.612.468.9 1.584 3.024 3.024 5.508t3.528 5.544 4.158 5.4 4.716 4.446 5.346 3.258q5.508 2.376 5.544 2.16.036-.108-1.764-1.332-1.908-1.296-2.916-2.052-2.772-2.088-6.444-7.596t-6.66-11.16zm-12.492 19.548q-2.736-2.16-4.77-4.5t-3.528-5.166-2.556-5.562-2.106-6.696-1.872-7.524-2.178-9.072-2.754-10.404q9.828 0 17.91 1.296t13.644 3.312 9.756 5.202 6.678 6.21 3.96 7.146 2.016 7.182.45 7.146-.342 6.228-.72 5.166-.468 3.852l11.628 11.772h-3.744l-10.116-10.26q-.792.072-3.294.504t-4.374.684-4.968.216-5.778-.612-6.03-2.124-6.444-3.996z\",\"UNIVERSAL_ACCESS\":\"M49.464-40.787q-.216-.936-1.026-1.422t-1.746-.27q-9.396 2.232-14.436 2.232t-14.436-2.232q-.936-.216-1.746.27t-1.026 1.422.27 1.746 1.422 1.026q6.984 1.656 10.908 2.088-.072 5.688-.558 9.684t-.954 5.598-1.476 4.158l-.324.756q-.36.9.036 1.764t1.296 1.224q.324.144.828.144 1.584 0 2.16-1.476l.288-.72q1.944-5.004 2.556-9.324h1.512q.612 4.32 2.556 9.324l.288.72q.576 1.476 2.16 1.476.504 0 .828-.144.9-.36 1.296-1.224t.036-1.764l-.324-.756q-1.008-2.556-1.476-4.158t-.954-5.598-.558-9.684q3.924-.432 10.908-2.088.936-.216 1.422-1.026t.27-1.746zm-12.6-5.22q0-1.908-1.35-3.258t-3.258-1.35-3.258 1.35-1.35 3.258 1.35 3.258 3.258 1.35 3.258-1.35 1.35-3.258zm20.736 13.824q0 5.148-1.998 9.846t-5.4 8.1-8.1 5.4-9.846 1.998-9.846-1.998-8.1-5.4-5.4-8.1-1.998-9.846 1.998-9.846 5.4-8.1 8.1-5.4 9.846-1.998 9.846 1.998 8.1 5.4 5.4 8.1 1.998 9.846zm-25.344-27.648q-5.616 0-10.728 2.196t-8.82 5.904-5.904 8.82-2.196 10.728 2.196 10.728 5.904 8.82 8.82 5.904 10.728 2.196 10.728-2.196 8.82-5.904 5.904-8.82 2.196-10.728-2.196-10.728-5.904-8.82-8.82-5.904-10.728-2.196zm32.256 27.648q0 6.552-2.556 12.528t-6.876 10.296-10.296 6.876-12.528 2.556-12.528-2.556-10.296-6.876-6.876-10.296-2.556-12.528 2.556-12.528 6.876-10.296 10.296-6.876 12.528-2.556 12.528 2.556 10.296 6.876 6.876 10.296 2.556 12.528z\",\"WHEELCHAIR_ALT\":\"M51.768-35.171q1.224 1.26 1.044 2.952l-1.584 19.836q-.144 1.512-1.242 2.52t-2.574 1.008q-.216 0-.324-.036-1.584-.108-2.61-1.314t-.918-2.79l1.26-15.444-5.148.288q1.98 4.068 1.98 8.64 0 7.776-5.328 13.392l-4.932-4.932q3.276-3.636 3.276-8.46 0-5.22-3.69-8.928t-8.91-3.708q-4.824 0-8.496 3.312l-4.932-4.968q4.32-4.104 10.224-5.076l9.504-10.8-5.364-3.132-6.516 5.796q-1.188 1.08-2.772.99t-2.628-1.278-.954-2.772 1.242-2.628l8.604-7.668q.936-.828 2.16-.954t2.304.522l17.568 10.188q1.296.756 1.728 2.448.612 2.412-.936 4.212l-7.38 8.352 13.356-.72q1.764-.108 2.988 1.152zm-7.128-16.452q-2.664 0-4.536-1.872t-1.872-4.536 1.872-4.536 4.536-1.872 4.554 1.872 1.89 4.536-1.89 4.536-4.554 1.872zm-22.572 44.712q3.816 0 7.056-2.196l5.004 5.004q-5.256 4.176-12.06 4.176-5.328 0-9.846-2.628t-7.146-7.128-2.628-9.828q0-6.768 4.176-12.096l5.004 5.004q-2.16 3.168-2.16 7.092 0 5.22 3.69 8.91t8.91 3.69z\",\"QUESTION_CIRCLE_O\":\"M31.68-21.239v5.76q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-5.76q0-.504.324-.828t.828-.324h5.76q.504 0 .828.324t.324.828zm9.216-17.856q0 1.8-.54 3.24t-1.638 2.484-1.872 1.584-2.142 1.296q-1.152.648-1.674 1.008t-.936.864-.414 1.044v1.152q0 .504-.324.828t-.828.324h-5.76q-.504 0-.828-.324t-.324-.828v-2.448q0-1.26.378-2.322t.864-1.71 1.404-1.278 1.476-.918 1.602-.756q1.908-.9 2.7-1.548t.792-1.764q0-1.512-1.566-2.574t-3.438-1.062q-2.016 0-3.42.972-1.044.72-2.88 2.988-.324.432-.9.432-.396 0-.684-.216l-3.888-2.952q-.36-.252-.432-.72t.18-.828q4.392-6.912 12.564-6.912 4.644 0 8.586 3.222t3.942 7.722zm-13.248-16.128q-4.68 0-8.946 1.836t-7.344 4.914-4.914 7.344-1.836 8.946 1.836 8.946 4.914 7.344 7.344 4.914 8.946 1.836 8.946-1.836 7.344-4.914 4.914-7.344 1.836-8.946-1.836-8.946-4.914-7.344-7.344-4.914-8.946-1.836zm27.648 23.04q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"BLIND\":\"M13.176-53.243q-2.304 0-3.96-1.638t-1.656-3.978q0-2.304 1.656-3.942t3.96-1.638 3.942 1.638 1.638 3.942q0 2.34-1.638 3.978t-3.942 1.638zm19.836 23.112q0 1.8-1.08 2.43t-2.286.234-1.71-1.224l-13.212-15.768q-.252-.432-.504-.558t-.396-.054l-.108.108q-.252.288.144.756l4.392 5.004.036 12.744-5.796 16.452q-2.412 6.912-3.312 8.424-.576.936-1.008 1.152-1.8.936-3.708.036-1.044-.468-1.494-1.548t-.342-2.052q.072-.612 7.092-22.248l.18-14.976-3.06 5.904 1.26 7.992q.144.864-.036 1.512t-.504.99-.684.576-.612.27l-.252.072q-.684.108-1.242-.108t-.864-.576-.504-.792-.27-.702-.072-.342l-1.656-10.764 7.596-13.716q.828-1.224 4.068-1.224 2.7 0 3.852 1.44l15.264 18.756q.252.18.504.612l.108.108-.036.036q.252.468.252 1.044zm-14.508 5.4q1.548 4.068 3.186 8.1t2.502 6.048l.864 1.98q1.296 3.348 1.512 4.5.396 2.52-1.296 3.492-1.26.792-2.376.576t-1.836-.792-1.044-1.26h-.036q-.216-.576-.288-.9l-4.464-12.636zm29.664 21.312q1.116 1.764 1.116 2.052 0 .18-.108.252-.324.18-.522-.018t-.558-.936-.576-1.098q-4.104-6.192-15.228-23.796.108.036.252-.036t.252-.144l.108-.072q.396-.324.396-.612z\",\"AUDIO_DESCRIPTION\":\"M18.144-28.655h6.156l-.036-9.54zm36.936-3.564q0-3.132-1.818-5.04t-5.274-1.908h-1.944v13.968h1.872q3.276 0 5.22-2.052t1.944-4.968zm-20.664-13.572l.036 27.216q0 .504-.342.864t-.846.36h-7.776q-.504 0-.846-.36t-.342-.864v-2.232h-10.476l-1.98 2.916q-.36.54-1.008.54h-9.612q-.756 0-1.098-.648t.126-1.26l20.016-27.252q.324-.504.972-.504h11.952q.504 0 .864.36t.36.864zm29.772 13.572q0 6.948-4.518 10.908t-11.682 3.96h-9.72q-.504 0-.864-.36t-.36-.864v-27.216q0-.504.36-.864t.864-.36h9.648q7.2 0 11.736 3.924t4.536 10.872zm5.616.036q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.602 3.888-2.646 3.69h-1.836q1.368-1.62 2.394-3.762t1.494-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.72-3.294-1.476-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.378 2.538zm6.624 0q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.62 3.888-2.664 3.69h-1.836q1.368-1.62 2.394-3.762t1.494-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.702-3.294-1.458-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.378 2.538zm6.516 0q0 .396-.018 1.044t-.288 2.574-.774 3.672-1.602 3.888-2.646 3.69h-1.836q1.368-1.62 2.376-3.762t1.476-4.032.756-3.528.324-2.61l.036-.972q0-.288-.018-.81t-.27-2.16-.702-3.294-1.458-4.014-2.376-4.482h1.548q1.476 1.692 2.592 3.852t1.638 4.014.828 3.456.342 2.538z\",\"VOLUME_CONTROL_PHONE\":\"M22.212-3.635q0-.396-.468-2.088t-1.116-3.852-.72-2.484q-.036-.144-.18-.954t-.306-1.296-.486-.774q-.54-.504-1.836-.504-.828 0-2.52.198t-2.556.198q-1.224 0-1.692-.396-.216-.18-.396-.558t-.27-.72-.234-.864-.18-.666q-1.332-4.608-1.332-9.18t1.332-9.18l.18-.666.234-.864.27-.72.396-.558q.468-.396 1.692-.396.864 0 2.556.198t2.52.198q1.296 0 1.836-.504.324-.288.486-.774t.306-1.296.18-.954q.072-.324.72-2.484t1.116-3.852.468-2.088q0-.792-1.566-1.89t-2.718-1.53q-.72-.288-1.62-.288-1.224 0-3.528.648-2.052.612-3.474 1.458t-2.556 2.376-1.656 2.52-1.638 3.402q-.216.432-.324.684-1.764 3.852-2.448 7.776t-.684 8.784.684 8.784 2.448 7.776q2.016 4.392 2.988 5.796 2.268 3.276 6.444 4.572l.216.072q2.304.648 3.528.648.9 0 1.62-.288 1.152-.432 2.718-1.53t1.566-1.89zm5.724-32.868q-.936 0-1.62-.684t-.684-1.638.684-1.638q1.332-1.332 1.332-3.24 0-1.872-1.332-3.276-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q2.7 2.7 2.7 6.516t-2.7 6.516q-.756.684-1.62.684zm6.516 6.516q-.972 0-1.62-.684-.684-.684-.684-1.62t.684-1.62q4.032-4.104 4.032-9.792t-4.032-9.792q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q5.4 5.4 5.4 13.032t-5.4 13.032q-.648.684-1.62.684zm6.516 6.516q-.972 0-1.62-.684-.684-.684-.684-1.62t.684-1.62q3.24-3.276 4.986-7.488t1.746-8.82-1.746-8.82-4.986-7.488q-.684-.684-.684-1.62t.684-1.62 1.62-.684 1.62.684q3.924 3.924 6.012 8.964t2.088 10.584-2.088 10.584-6.012 8.964q-.648.684-1.62.684z\",\"BRAILLE\":\"M6.912-21.815q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm0-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm27.648 18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm-18.432-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm18.432 0q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm0-18.432q-2.376 0-4.068 1.692t-1.692 4.068 1.692 4.068 4.068 1.692 4.068-1.692 1.692-4.068-1.692-4.068-4.068-1.692zm-57.6 42.624q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm46.08 36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-27.648-36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm46.08 36.864q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm-18.432-18.432q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896zm18.432 0q0 2.88-2.016 4.896t-4.896 2.016-4.896-2.016-2.016-4.896 2.016-4.896 4.896-2.016 4.896 2.016 2.016 4.896z\",\"ASSISTIVE_LISTENING_SYSTEMS\":\"M4.608-2.231q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm6.912-6.912q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm1.62-13.14l9.216 9.216-3.24 3.24-9.216-9.216zm12.204-.684q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm25.452-11.52q0 2.124-.414 3.906t-1.35 3.366-1.584 2.43-1.908 2.322q-1.116 1.26-1.638 1.944t-1.206 1.8-.954 2.304-.27 2.664q0 5.724-4.05 9.774t-9.774 4.05q-.936 0-1.62-.684t-.684-1.62.684-1.62 1.62-.684q3.816 0 6.516-2.7t2.7-6.516q0-2.052.414-3.798t1.332-3.276 1.566-2.394 1.872-2.268q1.44-1.656 2.142-2.592t1.35-2.682.648-3.726q0-6.66-4.734-11.394t-11.394-4.734-11.394 4.734-4.734 11.394q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-4.212 1.638-8.046t4.428-6.624 6.624-4.428 8.046-1.638 8.046 1.638 6.624 4.428 4.428 6.624 1.638 8.046zm-18.54 4.608q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62.684-1.62 1.62-.684 1.62.684.684 1.62zm10.368-4.608q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-3.348-2.358-5.706t-5.706-2.358q-3.312 0-5.688 2.358t-2.376 5.706q0 .936-.684 1.62t-1.62.684-1.62-.684-.684-1.62q0-5.256 3.708-8.964t8.964-3.708 8.964 3.708 3.708 8.964zm14.184-10.404q.36.9-.036 1.764t-1.296 1.224q-.324.144-.828.144-.684 0-1.278-.396t-.846-1.08q-2.448-6.408-8.064-10.62-.756-.576-.9-1.512t.432-1.692q.612-.756 1.548-.9t1.692.432q6.588 4.932 9.576 12.636zm7.56-2.916q.324.9-.054 1.764t-1.278 1.224q-.396.144-.828.144-1.584 0-2.16-1.476-3.312-8.568-10.692-14.148-.792-.576-.918-1.512t.45-1.692q.576-.792 1.512-.918t1.692.45q8.46 6.3 12.276 16.164z\",\"ASL_INTERPRETING\":\"M37.152-29.879q-2.124-.072-3.024-1.98-.612-1.224-1.728-1.926t-2.448-.702q-1.908 0-3.258 1.35t-1.35 3.258q0 2.016 1.296 3.204l.36.288q1.224 1.116 2.952 1.116 1.332 0 2.448-.702t1.728-1.926q.9-1.908 3.024-1.98zm20.448-4.608q0-2.016-1.296-3.204l-.36-.288q-1.224-1.116-2.952-1.116-1.332 0-2.448.702t-1.728 1.926q-.9 1.908-3.024 1.98 2.124.072 3.024 1.98.612 1.224 1.728 1.926t2.448.702q1.908 0 3.258-1.35t1.35-3.258zm-15.336-7.956q-.612 1.26-1.98 1.728t-2.628-.144q-2.232-1.116-4.824-1.116-1.836 0-3.564.612l.342-.018.342-.018q3.312 0 6.138 1.8t4.266 4.788q.612 1.296.126 2.646t-1.782 1.962q-.648.324-1.404.324.756 0 1.404.324 1.296.612 1.782 1.962t-.126 2.646q-1.44 2.988-4.266 4.788t-6.138 1.8h-.216q-.576-.072-1.584-.144l-10.44-.972-8.604 4.32q-.504.252-1.044.252-1.44 0-2.052-1.26l-5.76-11.52q-.396-.828-.144-1.71t1.044-1.35l7.524-4.284 5.328-9.612q.612-5.58 3.294-10.494t7.038-8.514q1.116-.9 2.538-.774t2.322 1.242.774 2.52-1.242 2.34q-2.52 2.124-4.212 4.608 4.428-3.024 9.612-3.636 1.44-.18 2.574.684t1.278 2.304q.18 1.44-.684 2.574t-2.304 1.278q-3.024.36-5.724 1.98 1.656-.36 3.564-.36 4.14 0 7.848 1.8 1.296.648 1.764 1.998t-.18 2.646zm34.668-5.76l5.76 11.52q.396.828.144 1.71t-1.044 1.35l-7.524 4.284-5.328 9.612q-.612 5.58-3.294 10.494t-7.038 8.514q-.936.792-2.196.792-1.62 0-2.664-1.26-.9-1.116-.774-2.52t1.242-2.34q2.52-2.124 4.212-4.608-4.428 3.024-9.612 3.636-.144.036-.432.036-1.296 0-2.286-.864t-1.134-2.16q-.18-1.44.684-2.574t2.304-1.278q3.024-.36 5.724-1.98-1.656.36-3.564.36-4.14 0-7.848-1.8-1.296-.648-1.764-1.998t.18-2.646q.612-1.26 1.98-1.728t2.628.144q2.232 1.116 4.824 1.116 1.836 0 3.564-.612l-.342.018-.342.018q-3.312 0-6.138-1.8t-4.266-4.788q-.612-1.296-.126-2.646t1.782-1.962q.648-.324 1.404-.324-.756 0-1.404-.324-1.296-.612-1.782-1.962t.126-2.646q1.44-2.988 4.266-4.788t6.138-1.8h.252q.504.072 1.512.144l10.476.972 8.604-4.32q.504-.252 1.044-.252 1.44 0 2.052 1.26z\",\"HARD_OF_HEARING\":\"M38.016-34.487q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-5.256-3.708-8.964t-8.964-3.708-8.964 3.708-3.708 8.964q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-3.348 2.376-5.706t5.688-2.358 5.688 2.358 2.376 5.706zm-7.956-20.736q-4.212 0-8.046 1.638t-6.624 4.428-4.428 6.624-1.638 8.046q0 .936.684 1.62t1.62.684 1.62-.684.684-1.62q0-6.66 4.734-11.394t11.394-4.734 11.394 4.734 4.734 11.394q0 1.98-.648 3.726t-1.35 2.682-2.142 2.592q-1.224 1.404-1.872 2.268t-1.566 2.394-1.332 3.276-.414 3.798q0 3.816-2.7 6.516t-6.516 2.7q-.936 0-1.62.684t-.684 1.62.684 1.62 1.62.684q5.724 0 9.774-4.05t4.05-9.774q0-1.476.27-2.664t.954-2.304 1.206-1.8 1.638-1.944q1.26-1.476 1.908-2.322t1.584-2.43 1.35-3.366.414-3.906q0-4.212-1.638-8.046t-4.428-6.624-6.624-4.428-8.046-1.638zm-8.784 25.884l8.136 8.136-20.844 20.844q-.432.432-1.044.432t-1.044-.432l-6.048-6.048q-.432-.432-.432-1.044t.432-1.044zm36.756-34.668l6.048 6.048q.432.432.432 1.044t-.432 1.08l-8.388 8.388-.936.9-2.556 2.556q-2.376-5.508-7.02-9.288l3.276-3.276 7.452-7.452q.468-.432 1.08-.432t1.044.432z\",\"GLIDE\":\"M31.176-45.899q0 .972-.468 3.384-.396 1.8-1.134 5.4t-1.098 5.4q-.072.396-.162.45t-.486.09q-.72.072-1.116.072-2.088 0-3.024-1.782t-.936-4.086q0-3.168 1.26-6.264t3.708-4.464q1.008-.504 1.836-.504 1.008 0 1.314.594t.306 1.71zm17.496 15.264q0-.504-1.404-2.718t-1.872-2.394q-.756-.288-1.224-.288-3.276 0-8.136 2.772l-.072-.072q.108-.792.99-4.86t.882-6.408q0-8.388-8.712-8.388-.864 0-2.448.216-3.384.612-6.066 3.222t-4.014 5.994-1.332 6.804q0 5.256 2.898 8.1t8.19 2.844q.9 0 .9.108t-.036.18q-.144 1.224-.936 4.212-.504 1.872-1.854 3.636t-2.97 1.764q-1.512 0-1.512-1.692 0-.864.378-1.71t.9-1.422 1.062-1.026.936-.72.396-.306q0-.108-.252-.36-.864-.792-2.106-1.314t-2.358-.522q-1.26 0-2.286 1.224t-1.476 2.7-.45 2.7q0 3.168 1.854 5.112t4.986 1.944q2.952 0 5.58-1.908t4.23-4.536 2.358-5.508q.216-.792.558-2.394t.522-2.394q.108-.432.504-.648 4.248-2.16 8.172-2.16 1.728 0 4.572.648l.144.036q.18 0 .342-.162t.162-.306zm6.624-18.828v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"GLIDE_G\":\"M26.784-53.459q0-.864-.072-1.386t-.306-1.08-.756-.828-1.35-.27q-1.404 0-2.808.828-3.78 2.088-5.724 6.858t-1.944 9.702q0 1.584.306 3.078t.954 2.898 1.89 2.25 2.934.846q.144 0 .648.018t.72 0 .576-.108.54-.306.252-.576q.576-2.772 1.728-8.334t1.728-8.334q.684-3.276.684-5.256zm27.144 23.616q0 .252-.27.486t-.558.234l-.216-.036q-.792-.108-2.232-.396t-2.592-.45-2.268-.162q-6.012 0-12.636 3.348-.54.288-.756.972-.36 1.296-.882 3.798t-.81 3.618q-.828 3.276-2.52 6.462t-4.05 5.922-5.562 4.428-6.66 1.692q-4.86 0-7.722-3.006t-2.862-7.902q0-1.908.702-4.212t2.268-4.194 3.51-1.89q1.368 0 4.32 1.206t2.988 2.214q0 .036-.594.45t-1.422 1.116-1.656 1.602-1.404 2.196-.576 2.664q0 1.188.594 1.908t1.746.72q1.62 0 3.06-1.134t2.394-2.808 1.728-3.798 1.17-3.852.576-3.24v-.324q0-.072-.126-.126t-.306-.054h-.36l-.36.018-.216.018q-8.172 0-12.672-4.41t-4.5-12.546q0-3.888 1.242-7.956t3.456-7.56 5.616-6.03 7.362-3.222q1.872-.324 3.816-.324 13.464 0 13.464 12.96 0 3.528-1.368 9.828t-1.548 7.596l.108.108q3.636-2.052 6.57-3.168t6.03-1.116q.792 0 1.908.468.684.252 2.88 3.69t2.196 4.194z\",\"SIGNING\":\"M29.916-40.211q1.152 0 2.124.648l7.992 5.328q2.196 1.44 3.96 3.492l5.256 6.12q1.44 1.656 1.044 3.816l-2.592 14.868q-.216 1.152-1.062 1.926t-1.998.918l-18.972 2.016-12.672 1.152h-.324q-1.404 0-2.43-1.008t-1.026-2.448q0-1.332.972-2.304t2.34-1.152l9.36-1.152h-16.128q-1.476 0-2.502-1.08t-.954-2.556q.072-1.404 1.152-2.34t2.484-.936l15.912-.036-18.756-2.304q-1.476-.18-2.376-1.332t-.684-2.628q.216-1.26 1.242-2.07t2.358-.81h.36l17.316 2.16-12.636-3.384q-1.368-.36-2.232-1.494t-.648-2.466q.216-1.296 1.188-2.106t2.232-.81q.216 0 .72.072l16.128 3.456 7.812 1.332.108.018.108.018q.828 0 1.098-.828t-.45-1.296l-6.696-4.5q-1.26-.828-1.512-2.286t.648-2.646q.972-1.368 2.736-1.368zm-2.52 7.272l6.696 4.5-7.848-1.332-.18-.072-1.296-1.368-8.568-9.432-.09-.126-.09-.126q-.864-1.116-.666-2.52t1.35-2.304q1.116-.828 2.448-.63t2.304 1.206l5.112 5.292-.144.144-.18.144q-1.152 1.62-.828 3.564t1.98 3.06zm31.932-16.344l.54 9.576q.144 2.628-.396 5.292l-1.728 7.884q-.432 2.124-2.412 3.132l-3.816 1.944q.072-2.232-1.404-3.924l-5.256-6.12q-1.908-2.196-4.212-3.708l-7.992-5.328q-1.224-.828-2.736-.828-1.836 0-3.168 1.332l-8.46-11.232q-.9-1.188-.648-2.646t1.476-2.286q1.188-.792 2.574-.504t2.25 1.44l9.576 12.672-9.432-16.38q-.756-1.26-.378-2.7t1.71-2.124q1.26-.648 2.61-.216t2.07 1.656l8.676 15.12-4.896-12.132q-.54-1.26-.162-2.664t1.602-2.016q1.332-.684 2.736-.216t2.016 1.836l6.948 14.94 3.636 7.056q.288.54.828.63t.972-.27.396-.936l-.432-8.064q-.072-1.476.936-2.556t2.484-1.116q1.404 0 2.412 1.026t1.08 2.43z\",\"LOW_VISION\":\"M12.06-15.623q-.072 0-.216-.072-3.096-2.052-6.066-5.22t-5.022-6.48q-.756-1.08-.756-2.484 0-.324.072-.684t.144-.648.252-.648.306-.576.378-.612.36-.54.432-.558.396-.522q6.624-9.036 16.272-13.14-3.96-7.128-3.96-7.596 0-.684.612-1.044 4.176-2.304 4.608-2.304.648 0 1.008.576l4.464 8.244q3.312-.684 6.912-.684 9.576 0 17.91 4.95t13.626 13.302q.72 1.116.72 2.484t-.72 2.484q-3.276 5.112-7.866 9.126t-10.026 6.318q3.96 7.128 3.96 7.596 0 .72-.612 1.044-4.176 2.304-4.572 2.304-.684 0-1.044-.576l-4.464-8.244-2.304-4.284-15.984-29.52.252-.252q-2.088.864-3.564 1.692.108.18 4.572 8.424t8.748 16.164 4.284 8.028q0 .252-.324.324-.468.108-2.592.108-2.052 0-2.16-.252l-16.416-30.276q-1.404 1.008-2.952 2.448.864 1.548 7.704 14.166t6.84 12.762q0 .36-.396.36-.504 0-2.97-.792t-2.61-1.008l-3.816-7.092-8.064-14.868q-1.584 1.908-2.808 3.816.072.108.648.9t.828 1.224l6.336 11.772q0 .36-.36.36zm29.88-3.672l1.764 3.276q9.828-3.996 16.2-13.86-6.48-9.972-16.524-14.004 2.412 2.304 3.708 5.346t1.296 6.354q0 3.816-1.692 7.218t-4.752 5.67zm-11.412-22.104q0 .72.504 1.224t1.224.504q3.096 0 5.292 2.196t2.196 5.292q0 .72.504 1.224t1.224.504 1.224-.504.504-1.224q0-4.536-3.204-7.74t-7.74-3.204q-.72 0-1.224.504t-.504 1.224zm13.176-2.34l-.324-.144.252.252z\",\"VIADEO\":\"M37.8-24.623q0 7.74-5.292 13.464-5.328 5.796-13.608 5.796-8.352 0-13.608-5.796-5.292-5.724-5.292-13.464 0-5.292 2.448-9.738t6.804-7.074 9.648-2.628q3.456 0 6.552 1.116-1.152 2.232-1.404 4.536-2.376-1.008-5.148-1.008-6.012 0-10.098 4.428t-4.086 10.476q0 6.12 4.05 10.386t10.134 4.266 10.116-4.266 4.032-10.386q0-3.204-1.152-5.976 2.376-.468 4.428-1.764 1.476 3.528 1.476 7.632zm-7.344-6.804q0 6.912-2.862 12.42t-8.586 9.108l-.504.036q-1.044 0-2.232-.18 2.988-1.152 5.274-3.69t3.582-5.562 2.106-6.804 1.08-6.93.27-6.426q0-2.484-.108-3.708 1.98 5.76 1.98 11.736zm-1.98-11.808v.072q-2.628-7.704-7.416-15.84 3.168 2.124 5.13 6.714t2.286 9.054zm8.784 7.308q-2.988 0-5.76-2.7 7.848-4.32 10.44-8.892.684-1.332.756-2.016-1.512 3.384-5.022 5.994t-7.362 3.51q-1.26-1.944-1.26-4.068 0-1.332.612-2.844t1.548-2.448q1.656-1.584 5.652-2.664 2.124-.576 3.816-2.106t2.664-3.618q2.664 3.78 2.664 9.108 0 3.924-.864 6.12-1.152 2.772-3.186 4.698t-4.698 1.926z\",\"VIADEO_SQUARE\":\"M37.8-26.963q0-2.808-1.008-5.292-1.476.9-3.06 1.224.792 1.8.792 4.104 0 4.212-2.772 7.146t-6.948 2.934-6.966-2.934-2.79-7.146q0-4.14 2.808-7.182t6.948-3.042q1.908 0 3.528.684.144-1.548.972-3.132-2.16-.756-4.5-.756-5.544 0-9.27 3.906t-3.726 9.486 3.726 9.396 9.27 3.816 9.27-3.834 3.726-9.378zm-6.408-12.78q.072.864.072 2.556 0 2.268-.18 4.428t-.738 4.77-1.458 4.68-2.466 3.816-3.618 2.538q.756.108 1.512.108h.36q7.884-5.004 7.884-14.796 0-4.176-1.368-8.1zm0 0q-.144-2.88-1.584-6.174t-3.528-4.698q3.312 5.616 5.112 10.872zm12.06-3.78q0-3.672-1.836-6.264-1.476 3.096-4.464 3.924-2.484.684-3.924 1.926t-1.44 3.582q0 1.44.864 2.772 2.664-.612 5.058-2.412t3.438-4.14q-.144 1.872-2.682 4.014t-4.986 3.51q1.872 1.872 3.96 1.872 1.836 0 3.24-1.332t2.16-3.24q.612-1.548.612-4.212zm11.844-5.94v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\",\"SNAPCHAT\":\"M46.044-23.111q0-.792-.792-.972-2.412-.54-4.248-2.124t-2.88-3.888q-.252-.684-.252-.9 0-.54.702-.936t1.548-.612 1.548-.738.702-1.314q0-.684-.666-1.134t-1.386-.45q-.432 0-1.152.288t-1.116.288q-.144 0-.432-.072.18-3.42.18-4.104 0-2.844-.612-4.104-1.296-2.808-3.708-4.374t-5.472-1.566q-7.164 0-9.9 5.94-.612 1.26-.612 4.104 0 .684.18 4.104-.144.072-.504.072-.432 0-1.152-.27t-1.08-.27q-.756 0-1.386.432t-.63 1.152q0 .756.702 1.278t1.548.738 1.548.612.702.936q0 .216-.252.9-2.304 4.968-7.128 6.012-.792.18-.792.972 0 1.656 4.932 2.448.072.18.216.936t.414 1.098.846.342q.432 0 1.35-.162t1.422-.162q1.26 0 2.412.54t1.944 1.17 2.07 1.17 2.754.54q1.548 0 2.844-.54t2.07-1.17 1.926-1.17 2.412-.54q.504 0 1.422.144t1.386.144q.576 0 .828-.36t.396-1.08.216-.9q4.932-.792 4.932-2.448zm9.252-9.072q0 7.524-3.708 13.878t-10.062 10.062-13.878 3.708-13.878-3.708-10.062-10.062-3.708-13.878 3.708-13.878 10.062-10.062 13.878-3.708 13.878 3.708 10.062 10.062 3.708 13.878z\",\"SNAPCHAT_GHOST\":\"M30.528-59.831q4.824-.036 8.658 2.466t5.886 6.93q.972 2.088.972 6.444 0 1.692-.324 6.876.504.252 1.008.252.648 0 1.836-.486t1.836-.486q1.044 0 2.016.648t.972 1.656q0 1.152-1.134 1.944t-2.484 1.134-2.484 1.044-1.134 1.71q0 .54.432 1.548 1.332 2.952 3.69 5.4t5.202 3.636q1.008.432 2.88.828 1.008.216 1.008 1.26 0 2.52-7.884 3.708-.252.396-.396 1.404t-.504 1.674-1.188.666q-.72 0-2.232-.234t-2.304-.234q-1.332 0-2.232.18-1.152.18-2.268.81t-2.088 1.368-2.088 1.458-2.736 1.206-3.564.486q-1.872 0-3.474-.486t-2.7-1.206-2.07-1.458-2.088-1.368-2.232-.81q-.936-.18-2.268-.18-.864 0-2.358.27t-2.106.27q-.9 0-1.26-.666t-.504-1.71-.396-1.44q-7.884-1.188-7.884-3.708 0-1.044 1.008-1.26 1.872-.396 2.88-.828 2.808-1.152 5.202-3.636t3.69-5.4q.432-1.008.432-1.548 0-1.008-1.134-1.71t-2.502-1.062-2.502-1.134-1.134-1.89q0-.972.936-1.638t1.98-.666q.54 0 1.728.468t1.908.468q.648 0 1.152-.252-.324-5.112-.324-6.84 0-4.392.972-6.48 2.304-4.932 6.192-7.128t9.504-2.268z\",\"SNAPCHAT_SQUARE\":\"M46.08-23.111q0-.792-.792-.972-2.412-.504-4.248-2.088t-2.88-3.924q-.252-.504-.252-.9 0-.54.702-.936t1.53-.612 1.53-.738.702-1.314q0-.684-.666-1.134t-1.386-.45q-.396 0-1.116.288t-1.152.288q-.144 0-.432-.072.18-2.268.18-4.14 0-2.808-.612-4.104-1.296-2.808-3.69-4.374t-5.49-1.566q-7.128 0-9.9 5.94-.648 1.368-.648 4.14 0 1.368.216 4.104-.36.072-.54.072-.396 0-1.134-.288t-1.098-.288q-.72 0-1.35.45t-.63 1.17q0 .756.702 1.278t1.53.738 1.53.612.702.936q0 .396-.252.9-2.304 4.968-7.128 6.012-.792.18-.792.972 0 1.692 4.968 2.484.072.18.216.936t.396 1.098.828.342q.468 0 1.386-.18t1.386-.18q1.26 0 2.43.54t1.962 1.17 2.07 1.17 2.754.54q1.548 0 2.844-.54t2.07-1.17 1.944-1.17 2.43-.54q.468 0 1.404.162t1.404.162q.54 0 .81-.342t.414-1.116.18-.882q4.968-.792 4.968-2.484zm9.216-26.352v34.56q0 4.284-3.042 7.326t-7.326 3.042h-34.56q-4.284 0-7.326-3.042t-3.042-7.326v-34.56q0-4.284 3.042-7.326t7.326-3.042h34.56q4.284 0 7.326 3.042t3.042 7.326z\"};"

/***/ },

/***/ "nF1+":
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.14 (2017-07-28)
	
	 3D features for Highcharts JS
	
	 @license: www.highcharts.com/license
	*/
	(function(y){"object"===typeof module&&module.exports?module.exports=y:y(Highcharts)})(function(y){(function(b){var v=b.deg2rad,t=b.pick;b.perspective=function(u,w,x){var k=w.options.chart.options3d,n=x?w.inverted:!1,f=w.plotWidth/2,p=w.plotHeight/2,l=k.depth/2,d=t(k.depth,1)*t(k.viewDistance,0),a=w.scale3d||1,c=v*k.beta*(n?-1:1),k=v*k.alpha*(n?-1:1),e=Math.cos(k),g=Math.cos(-c),h=Math.sin(k),A=Math.sin(-c);x||(f+=w.plotLeft,p+=w.plotTop);return b.map(u,function(c){var b,r;r=(n?c.y:c.x)-f;var m=(n?
	c.x:c.y)-p,G=(c.z||0)-l;b=g*r-A*G;c=-h*A*r+e*m-g*h*G;r=e*A*r+h*m+e*g*G;m=0<d&&d<Number.POSITIVE_INFINITY?d/(r+l+d):1;b=b*m*a+f;c=c*m*a+p;return{x:n?c:b,y:n?b:c,z:r*a+l}})};b.pointCameraDistance=function(b,w){var u=w.options.chart.options3d,k=w.plotWidth/2;w=w.plotHeight/2;u=t(u.depth,1)*t(u.viewDistance,0)+u.depth;return Math.sqrt(Math.pow(k-b.plotX,2)+Math.pow(w-b.plotY,2)+Math.pow(u-b.plotZ,2))};b.shapeArea=function(b){var u=0,t,k;for(t=0;t<b.length;t++)k=(t+1)%b.length,u+=b[t].x*b[k].y-b[k].x*
	b[t].y;return u/2};b.shapeArea3d=function(t,w,v){return b.shapeArea(b.perspective(t,w,v))}})(y);(function(b){function v(a,e,c,g,d,b,h,l){var B=[],m=b-d;return b>d&&b-d>Math.PI/2+.0001?(B=B.concat(v(a,e,c,g,d,d+Math.PI/2,h,l)),B=B.concat(v(a,e,c,g,d+Math.PI/2,b,h,l))):b<d&&d-b>Math.PI/2+.0001?(B=B.concat(v(a,e,c,g,d,d-Math.PI/2,h,l)),B=B.concat(v(a,e,c,g,d-Math.PI/2,b,h,l))):["C",a+c*Math.cos(d)-c*r*m*Math.sin(d)+h,e+g*Math.sin(d)+g*r*m*Math.cos(d)+l,a+c*Math.cos(b)+c*r*m*Math.sin(b)+h,e+g*Math.sin(b)-
	g*r*m*Math.cos(b)+l,a+c*Math.cos(b)+h,e+g*Math.sin(b)+l]}var t=Math.cos,u=Math.PI,w=Math.sin,x=b.animObject,k=b.charts,n=b.color,f=b.defined,p=b.deg2rad,l=b.each,d=b.extend,a=b.inArray,c=b.map,e=b.merge,g=b.perspective,h=b.pick,A=b.SVGElement,q=b.SVGRenderer,z=b.wrap,r=4*(Math.sqrt(2)-1)/3/(u/2);q.prototype.toLinePath=function(a,e){var c=[];l(a,function(a){c.push("L",a.x,a.y)});a.length&&(c[0]="M",e&&c.push("Z"));return c};q.prototype.toLineSegments=function(a){var e=[],c=!0;l(a,function(a){e.push(c?
	"M":"L",a.x,a.y);c=!c});return e};q.prototype.face3d=function(a){var e=this,c=this.createElement("path");c.vertexes=[];c.insidePlotArea=!1;c.enabled=!0;z(c,"attr",function(a,c){if("object"===typeof c&&(f(c.enabled)||f(c.vertexes)||f(c.insidePlotArea))){this.enabled=h(c.enabled,this.enabled);this.vertexes=h(c.vertexes,this.vertexes);this.insidePlotArea=h(c.insidePlotArea,this.insidePlotArea);delete c.enabled;delete c.vertexes;delete c.insidePlotArea;var d=g(this.vertexes,k[e.chartIndex],this.insidePlotArea),
	B=e.toLinePath(d,!0),d=b.shapeArea(d),d=this.enabled&&0<d?"visible":"hidden";c.d=B;c.visibility=d}return a.apply(this,[].slice.call(arguments,1))});z(c,"animate",function(a,c){if("object"===typeof c&&(f(c.enabled)||f(c.vertexes)||f(c.insidePlotArea))){this.enabled=h(c.enabled,this.enabled);this.vertexes=h(c.vertexes,this.vertexes);this.insidePlotArea=h(c.insidePlotArea,this.insidePlotArea);delete c.enabled;delete c.vertexes;delete c.insidePlotArea;var d=g(this.vertexes,k[e.chartIndex],this.insidePlotArea),
	B=e.toLinePath(d,!0),d=b.shapeArea(d),d=this.enabled&&0<d?"visible":"hidden";c.d=B;this.attr("visibility",d)}return a.apply(this,[].slice.call(arguments,1))});return c.attr(a)};q.prototype.polyhedron=function(a){var c=this,e=this.g(),d=e.destroy;e.attr({"stroke-linejoin":"round"});e.faces=[];e.destroy=function(){for(var a=0;a<e.faces.length;a++)e.faces[a].destroy();return d.call(this)};z(e,"attr",function(a,d,g,b,h){if("object"===typeof d&&f(d.faces)){for(;e.faces.length>d.faces.length;)e.faces.pop().destroy();
	for(;e.faces.length<d.faces.length;)e.faces.push(c.face3d().add(e));for(var m=0;m<d.faces.length;m++)e.faces[m].attr(d.faces[m],null,b,h);delete d.faces}return a.apply(this,[].slice.call(arguments,1))});z(e,"animate",function(a,d,g,b){if(d&&d.faces){for(;e.faces.length>d.faces.length;)e.faces.pop().destroy();for(;e.faces.length<d.faces.length;)e.faces.push(c.face3d().add(e));for(var h=0;h<d.faces.length;h++)e.faces[h].animate(d.faces[h],g,b);delete d.faces}return a.apply(this,[].slice.call(arguments,
	1))});return e.attr(a)};q.prototype.cuboid=function(a){var c=this.g(),e=c.destroy;a=this.cuboidPath(a);c.attr({"stroke-linejoin":"round"});c.front=this.path(a[0]).attr({"class":"highcharts-3d-front"}).add(c);c.top=this.path(a[1]).attr({"class":"highcharts-3d-top"}).add(c);c.side=this.path(a[2]).attr({"class":"highcharts-3d-side"}).add(c);c.fillSetter=function(a){this.front.attr({fill:a});this.top.attr({fill:n(a).brighten(.1).get()});this.side.attr({fill:n(a).brighten(-.1).get()});this.color=a;c.fill=
	a;return this};c.opacitySetter=function(a){this.front.attr({opacity:a});this.top.attr({opacity:a});this.side.attr({opacity:a});return this};c.attr=function(a,c,e,d){if("string"===typeof a&&"undefined"!==typeof c){var g=a;a={};a[g]=c}if(a.shapeArgs||f(a.x))a=this.renderer.cuboidPath(a.shapeArgs||a),this.front.attr({d:a[0]}),this.top.attr({d:a[1]}),this.side.attr({d:a[2]});else return A.prototype.attr.call(this,a,void 0,e,d);return this};c.animate=function(a,c,e){f(a.x)&&f(a.y)?(a=this.renderer.cuboidPath(a),
	this.front.animate({d:a[0]},c,e),this.top.animate({d:a[1]},c,e),this.side.animate({d:a[2]},c,e),this.attr({zIndex:-a[3]})):a.opacity?(this.front.animate(a,c,e),this.top.animate(a,c,e),this.side.animate(a,c,e)):A.prototype.animate.call(this,a,c,e);return this};c.destroy=function(){this.front.destroy();this.top.destroy();this.side.destroy();return e.call(this)};c.attr({zIndex:-a[3]});return c};b.SVGRenderer.prototype.cuboidPath=function(a){function e(a){return t[a]}var d=a.x,h=a.y,m=a.z,l=a.height,
	p=a.width,r=a.depth,A=k[this.chartIndex],q,z,n=A.options.chart.options3d.alpha,f=0,t=[{x:d,y:h,z:m},{x:d+p,y:h,z:m},{x:d+p,y:h+l,z:m},{x:d,y:h+l,z:m},{x:d,y:h+l,z:m+r},{x:d+p,y:h+l,z:m+r},{x:d+p,y:h,z:m+r},{x:d,y:h,z:m+r}],t=g(t,A,a.insidePlotArea);z=function(a,d){var g=[[],-1];a=c(a,e);d=c(d,e);0>b.shapeArea(a)?g=[a,0]:0>b.shapeArea(d)&&(g=[d,1]);return g};q=z([3,2,1,0],[7,6,5,4]);a=q[0];p=q[1];q=z([1,6,7,0],[4,5,2,3]);l=q[0];r=q[1];q=z([1,2,5,6],[0,7,4,3]);z=q[0];q=q[1];1===q?f+=1E4*(1E3-d):q||
	(f+=1E4*d);f+=10*(!r||0<=n&&180>=n||360>n&&357.5<n?A.plotHeight-h:10+h);1===p?f+=100*m:p||(f+=100*(1E3-m));f=-Math.round(f);return[this.toLinePath(a,!0),this.toLinePath(l,!0),this.toLinePath(z,!0),f]};b.SVGRenderer.prototype.arc3d=function(c){function g(c){var d=!1,b={};c=e(c);for(var g in c)-1!==a(g,q)&&(b[g]=c[g],delete c[g],d=!0);return d?b:!1}var b=this.g(),m=b.renderer,q="x y r innerR start end".split(" ");c=e(c);c.alpha*=p;c.beta*=p;b.top=m.path();b.side1=m.path();b.side2=m.path();b.inn=m.path();
	b.out=m.path();b.onAdd=function(){var a=b.parentGroup,c=b.attr("class");b.top.add(b);l(["out","inn","side1","side2"],function(e){b[e].attr({"class":c+" highcharts-3d-side"}).add(a)})};l(["addClass","removeClass"],function(a){b[a]=function(){var c=arguments;l(["top","out","inn","side1","side2"],function(e){b[e][a].apply(b[e],c)})}});b.setPaths=function(a){var c=b.renderer.arc3dPath(a),e=100*c.zTop;b.attribs=a;b.top.attr({d:c.top,zIndex:c.zTop});b.inn.attr({d:c.inn,zIndex:c.zInn});b.out.attr({d:c.out,
	zIndex:c.zOut});b.side1.attr({d:c.side1,zIndex:c.zSide1});b.side2.attr({d:c.side2,zIndex:c.zSide2});b.zIndex=e;b.attr({zIndex:e});a.center&&(b.top.setRadialReference(a.center),delete a.center)};b.setPaths(c);b.fillSetter=function(a){var c=n(a).brighten(-.1).get();this.fill=a;this.side1.attr({fill:c});this.side2.attr({fill:c});this.inn.attr({fill:c});this.out.attr({fill:c});this.top.attr({fill:a});return this};l(["opacity","translateX","translateY","visibility"],function(a){b[a+"Setter"]=function(a,
	c){b[c]=a;l(["out","inn","side1","side2","top"],function(e){b[e].attr(c,a)})}});z(b,"attr",function(a,c){var e;"object"===typeof c&&(e=g(c))&&(d(b.attribs,e),b.setPaths(b.attribs));return a.apply(this,[].slice.call(arguments,1))});z(b,"animate",function(a,c,d,b){var m,l=this.attribs,p;delete c.center;delete c.z;delete c.depth;delete c.alpha;delete c.beta;p=x(h(d,this.renderer.globalAnimation));p.duration&&(m=g(c),c.dummy=1,m&&(p.step=function(a,c){function d(a){return l[a]+(h(m[a],l[a])-l[a])*c.pos}
	"dummy"===c.prop&&c.elem.setPaths(e(l,{x:d("x"),y:d("y"),r:d("r"),innerR:d("innerR"),start:d("start"),end:d("end")}))}),d=p);return a.call(this,c,d,b)});b.destroy=function(){this.top.destroy();this.out.destroy();this.inn.destroy();this.side1.destroy();this.side2.destroy();A.prototype.destroy.call(this)};b.hide=function(){this.top.hide();this.out.hide();this.inn.hide();this.side1.hide();this.side2.hide()};b.show=function(){this.top.show();this.out.show();this.inn.show();this.side1.show();this.side2.show()};
	return b};q.prototype.arc3dPath=function(a){function c(a){a%=2*Math.PI;a>Math.PI&&(a=2*Math.PI-a);return a}var e=a.x,d=a.y,b=a.start,g=a.end-.00001,h=a.r,l=a.innerR,m=a.depth,p=a.alpha,q=a.beta,r=Math.cos(b),A=Math.sin(b);a=Math.cos(g);var z=Math.sin(g),f=h*Math.cos(q),h=h*Math.cos(p),k=l*Math.cos(q),n=l*Math.cos(p),l=m*Math.sin(q),x=m*Math.sin(p),m=["M",e+f*r,d+h*A],m=m.concat(v(e,d,f,h,b,g,0,0)),m=m.concat(["L",e+k*a,d+n*z]),m=m.concat(v(e,d,k,n,g,b,0,0)),m=m.concat(["Z"]),y=0<q?Math.PI/2:0,q=0<
	p?0:Math.PI/2,y=b>-y?b:g>-y?-y:b,C=g<u-q?g:b<u-q?u-q:g,D=2*u-q,p=["M",e+f*t(y),d+h*w(y)],p=p.concat(v(e,d,f,h,y,C,0,0));g>D&&b<D?(p=p.concat(["L",e+f*t(C)+l,d+h*w(C)+x]),p=p.concat(v(e,d,f,h,C,D,l,x)),p=p.concat(["L",e+f*t(D),d+h*w(D)]),p=p.concat(v(e,d,f,h,D,g,0,0)),p=p.concat(["L",e+f*t(g)+l,d+h*w(g)+x]),p=p.concat(v(e,d,f,h,g,D,l,x)),p=p.concat(["L",e+f*t(D),d+h*w(D)]),p=p.concat(v(e,d,f,h,D,C,0,0))):g>u-q&&b<u-q&&(p=p.concat(["L",e+f*Math.cos(C)+l,d+h*Math.sin(C)+x]),p=p.concat(v(e,d,f,h,C,g,
	l,x)),p=p.concat(["L",e+f*Math.cos(g),d+h*Math.sin(g)]),p=p.concat(v(e,d,f,h,g,C,0,0)));p=p.concat(["L",e+f*Math.cos(C)+l,d+h*Math.sin(C)+x]);p=p.concat(v(e,d,f,h,C,y,l,x));p=p.concat(["Z"]);q=["M",e+k*r,d+n*A];q=q.concat(v(e,d,k,n,b,g,0,0));q=q.concat(["L",e+k*Math.cos(g)+l,d+n*Math.sin(g)+x]);q=q.concat(v(e,d,k,n,g,b,l,x));q=q.concat(["Z"]);r=["M",e+f*r,d+h*A,"L",e+f*r+l,d+h*A+x,"L",e+k*r+l,d+n*A+x,"L",e+k*r,d+n*A,"Z"];e=["M",e+f*a,d+h*z,"L",e+f*a+l,d+h*z+x,"L",e+k*a+l,d+n*z+x,"L",e+k*a,d+n*z,"Z"];
	z=Math.atan2(x,-l);d=Math.abs(g+z);a=Math.abs(b+z);b=Math.abs((b+g)/2+z);d=c(d);a=c(a);b=c(b);b*=1E5;g=1E5*a;d*=1E5;return{top:m,zTop:1E5*Math.PI+1,out:p,zOut:Math.max(b,g,d),inn:q,zInn:Math.max(b,g,d),side1:r,zSide1:.99*d,side2:e,zSide2:.99*g}}})(y);(function(b){function v(b,l){var d=b.plotLeft,a=b.plotWidth+d,c=b.plotTop,e=b.plotHeight+c,g=d+b.plotWidth/2,h=c+b.plotHeight/2,p=Number.MAX_VALUE,q=-Number.MAX_VALUE,f=Number.MAX_VALUE,r=-Number.MAX_VALUE,m,k=1;m=[{x:d,y:c,z:0},{x:d,y:c,z:l}];u([0,1],
	function(c){m.push({x:a,y:m[c].y,z:m[c].z})});u([0,1,2,3],function(a){m.push({x:m[a].x,y:e,z:m[a].z})});m=x(m,b,!1);u(m,function(a){p=Math.min(p,a.x);q=Math.max(q,a.x);f=Math.min(f,a.y);r=Math.max(r,a.y)});d>p&&(k=Math.min(k,1-Math.abs((d+g)/(p+g))%1));a<q&&(k=Math.min(k,(a-g)/(q-g)));c>f&&(k=0>f?Math.min(k,(c+h)/(-f+c+h)):Math.min(k,1-(c+h)/(f+h)%1));e<r&&(k=Math.min(k,Math.abs((e-h)/(r-h))));return k}var t=b.Chart,u=b.each,w=b.merge,x=b.perspective,k=b.pick,n=b.wrap;t.prototype.is3d=function(){return this.options.chart.options3d&&
	this.options.chart.options3d.enabled};t.prototype.propsRequireDirtyBox.push("chart.options3d");t.prototype.propsRequireUpdateSeries.push("chart.options3d");b.wrap(b.Chart.prototype,"isInsidePlot",function(b){return this.is3d()||b.apply(this,[].slice.call(arguments,1))});var f=b.getOptions();w(!0,f,{chart:{options3d:{enabled:!1,alpha:0,beta:0,depth:100,fitToPlot:!0,viewDistance:25,axisLabelPosition:"default",frame:{visible:"default",size:1,bottom:{},top:{},left:{},right:{},back:{},front:{}}}}});n(t.prototype,
	"setClassName",function(b){b.apply(this,[].slice.call(arguments,1));this.is3d()&&(this.container.className+=" highcharts-3d-chart")});b.wrap(b.Chart.prototype,"setChartSize",function(b){var l=this.options.chart.options3d;b.apply(this,[].slice.call(arguments,1));if(this.is3d()){var d=this.inverted,a=this.clipBox,c=this.margin;a[d?"y":"x"]=-(c[3]||0);a[d?"x":"y"]=-(c[0]||0);a[d?"height":"width"]=this.chartWidth+(c[3]||0)+(c[1]||0);a[d?"width":"height"]=this.chartHeight+(c[0]||0)+(c[2]||0);this.scale3d=
	1;!0===l.fitToPlot&&(this.scale3d=v(this,l.depth))}});n(t.prototype,"redraw",function(b){this.is3d()&&(this.isDirtyBox=!0,this.frame3d=this.get3dFrame());b.apply(this,[].slice.call(arguments,1))});n(t.prototype,"render",function(b){this.is3d()&&(this.frame3d=this.get3dFrame());b.apply(this,[].slice.call(arguments,1))});n(t.prototype,"renderSeries",function(b){var l=this.series.length;if(this.is3d())for(;l--;)b=this.series[l],b.translate(),b.render();else b.call(this)});n(t.prototype,"drawChartBox",
	function(p){if(this.is3d()){var l=this.renderer,d=this.options.chart.options3d,a=this.get3dFrame(),c=this.plotLeft,e=this.plotLeft+this.plotWidth,g=this.plotTop,h=this.plotTop+this.plotHeight,d=d.depth,f=c-(a.left.visible?a.left.size:0),q=e+(a.right.visible?a.right.size:0),k=g-(a.top.visible?a.top.size:0),r=h+(a.bottom.visible?a.bottom.size:0),m=0-(a.front.visible?a.front.size:0),n=d+(a.back.visible?a.back.size:0),t=this.hasRendered?"animate":"attr";this.frame3d=a;this.frameShapes||(this.frameShapes=
	{bottom:l.polyhedron().add(),top:l.polyhedron().add(),left:l.polyhedron().add(),right:l.polyhedron().add(),back:l.polyhedron().add(),front:l.polyhedron().add()});this.frameShapes.bottom[t]({"class":"highcharts-3d-frame highcharts-3d-frame-bottom",zIndex:a.bottom.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.bottom.color).brighten(.1).get(),vertexes:[{x:f,y:r,z:m},{x:q,y:r,z:m},{x:q,y:r,z:n},{x:f,y:r,z:n}],enabled:a.bottom.visible},{fill:b.color(a.bottom.color).brighten(.1).get(),vertexes:[{x:c,y:h,
	z:d},{x:e,y:h,z:d},{x:e,y:h,z:0},{x:c,y:h,z:0}],enabled:a.bottom.visible},{fill:b.color(a.bottom.color).brighten(-.1).get(),vertexes:[{x:f,y:r,z:m},{x:f,y:r,z:n},{x:c,y:h,z:d},{x:c,y:h,z:0}],enabled:a.bottom.visible&&!a.left.visible},{fill:b.color(a.bottom.color).brighten(-.1).get(),vertexes:[{x:q,y:r,z:n},{x:q,y:r,z:m},{x:e,y:h,z:0},{x:e,y:h,z:d}],enabled:a.bottom.visible&&!a.right.visible},{fill:b.color(a.bottom.color).get(),vertexes:[{x:q,y:r,z:m},{x:f,y:r,z:m},{x:c,y:h,z:0},{x:e,y:h,z:0}],enabled:a.bottom.visible&&
	!a.front.visible},{fill:b.color(a.bottom.color).get(),vertexes:[{x:f,y:r,z:n},{x:q,y:r,z:n},{x:e,y:h,z:d},{x:c,y:h,z:d}],enabled:a.bottom.visible&&!a.back.visible}]});this.frameShapes.top[t]({"class":"highcharts-3d-frame highcharts-3d-frame-top",zIndex:a.top.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.top.color).brighten(.1).get(),vertexes:[{x:f,y:k,z:n},{x:q,y:k,z:n},{x:q,y:k,z:m},{x:f,y:k,z:m}],enabled:a.top.visible},{fill:b.color(a.top.color).brighten(.1).get(),vertexes:[{x:c,y:g,z:0},{x:e,y:g,
	z:0},{x:e,y:g,z:d},{x:c,y:g,z:d}],enabled:a.top.visible},{fill:b.color(a.top.color).brighten(-.1).get(),vertexes:[{x:f,y:k,z:n},{x:f,y:k,z:m},{x:c,y:g,z:0},{x:c,y:g,z:d}],enabled:a.top.visible&&!a.left.visible},{fill:b.color(a.top.color).brighten(-.1).get(),vertexes:[{x:q,y:k,z:m},{x:q,y:k,z:n},{x:e,y:g,z:d},{x:e,y:g,z:0}],enabled:a.top.visible&&!a.right.visible},{fill:b.color(a.top.color).get(),vertexes:[{x:f,y:k,z:m},{x:q,y:k,z:m},{x:e,y:g,z:0},{x:c,y:g,z:0}],enabled:a.top.visible&&!a.front.visible},
	{fill:b.color(a.top.color).get(),vertexes:[{x:q,y:k,z:n},{x:f,y:k,z:n},{x:c,y:g,z:d},{x:e,y:g,z:d}],enabled:a.top.visible&&!a.back.visible}]});this.frameShapes.left[t]({"class":"highcharts-3d-frame highcharts-3d-frame-left",zIndex:a.left.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.left.color).brighten(.1).get(),vertexes:[{x:f,y:r,z:m},{x:c,y:h,z:0},{x:c,y:h,z:d},{x:f,y:r,z:n}],enabled:a.left.visible&&!a.bottom.visible},{fill:b.color(a.left.color).brighten(.1).get(),vertexes:[{x:f,y:k,z:n},{x:c,y:g,
	z:d},{x:c,y:g,z:0},{x:f,y:k,z:m}],enabled:a.left.visible&&!a.top.visible},{fill:b.color(a.left.color).brighten(-.1).get(),vertexes:[{x:f,y:r,z:n},{x:f,y:k,z:n},{x:f,y:k,z:m},{x:f,y:r,z:m}],enabled:a.left.visible},{fill:b.color(a.left.color).brighten(-.1).get(),vertexes:[{x:c,y:g,z:d},{x:c,y:h,z:d},{x:c,y:h,z:0},{x:c,y:g,z:0}],enabled:a.left.visible},{fill:b.color(a.left.color).get(),vertexes:[{x:f,y:r,z:m},{x:f,y:k,z:m},{x:c,y:g,z:0},{x:c,y:h,z:0}],enabled:a.left.visible&&!a.front.visible},{fill:b.color(a.left.color).get(),
	vertexes:[{x:f,y:k,z:n},{x:f,y:r,z:n},{x:c,y:h,z:d},{x:c,y:g,z:d}],enabled:a.left.visible&&!a.back.visible}]});this.frameShapes.right[t]({"class":"highcharts-3d-frame highcharts-3d-frame-right",zIndex:a.right.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.right.color).brighten(.1).get(),vertexes:[{x:q,y:r,z:n},{x:e,y:h,z:d},{x:e,y:h,z:0},{x:q,y:r,z:m}],enabled:a.right.visible&&!a.bottom.visible},{fill:b.color(a.right.color).brighten(.1).get(),vertexes:[{x:q,y:k,z:m},{x:e,y:g,z:0},{x:e,y:g,z:d},{x:q,
	y:k,z:n}],enabled:a.right.visible&&!a.top.visible},{fill:b.color(a.right.color).brighten(-.1).get(),vertexes:[{x:e,y:g,z:0},{x:e,y:h,z:0},{x:e,y:h,z:d},{x:e,y:g,z:d}],enabled:a.right.visible},{fill:b.color(a.right.color).brighten(-.1).get(),vertexes:[{x:q,y:r,z:m},{x:q,y:k,z:m},{x:q,y:k,z:n},{x:q,y:r,z:n}],enabled:a.right.visible},{fill:b.color(a.right.color).get(),vertexes:[{x:q,y:k,z:m},{x:q,y:r,z:m},{x:e,y:h,z:0},{x:e,y:g,z:0}],enabled:a.right.visible&&!a.front.visible},{fill:b.color(a.right.color).get(),
	vertexes:[{x:q,y:r,z:n},{x:q,y:k,z:n},{x:e,y:g,z:d},{x:e,y:h,z:d}],enabled:a.right.visible&&!a.back.visible}]});this.frameShapes.back[t]({"class":"highcharts-3d-frame highcharts-3d-frame-back",zIndex:a.back.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.back.color).brighten(.1).get(),vertexes:[{x:q,y:r,z:n},{x:f,y:r,z:n},{x:c,y:h,z:d},{x:e,y:h,z:d}],enabled:a.back.visible&&!a.bottom.visible},{fill:b.color(a.back.color).brighten(.1).get(),vertexes:[{x:f,y:k,z:n},{x:q,y:k,z:n},{x:e,y:g,z:d},{x:c,y:g,z:d}],
	enabled:a.back.visible&&!a.top.visible},{fill:b.color(a.back.color).brighten(-.1).get(),vertexes:[{x:f,y:r,z:n},{x:f,y:k,z:n},{x:c,y:g,z:d},{x:c,y:h,z:d}],enabled:a.back.visible&&!a.left.visible},{fill:b.color(a.back.color).brighten(-.1).get(),vertexes:[{x:q,y:k,z:n},{x:q,y:r,z:n},{x:e,y:h,z:d},{x:e,y:g,z:d}],enabled:a.back.visible&&!a.right.visible},{fill:b.color(a.back.color).get(),vertexes:[{x:c,y:g,z:d},{x:e,y:g,z:d},{x:e,y:h,z:d},{x:c,y:h,z:d}],enabled:a.back.visible},{fill:b.color(a.back.color).get(),
	vertexes:[{x:f,y:r,z:n},{x:q,y:r,z:n},{x:q,y:k,z:n},{x:f,y:k,z:n}],enabled:a.back.visible}]});this.frameShapes.front[t]({"class":"highcharts-3d-frame highcharts-3d-frame-front",zIndex:a.front.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.front.color).brighten(.1).get(),vertexes:[{x:f,y:r,z:m},{x:q,y:r,z:m},{x:e,y:h,z:0},{x:c,y:h,z:0}],enabled:a.front.visible&&!a.bottom.visible},{fill:b.color(a.front.color).brighten(.1).get(),vertexes:[{x:q,y:k,z:m},{x:f,y:k,z:m},{x:c,y:g,z:0},{x:e,y:g,z:0}],enabled:a.front.visible&&
	!a.top.visible},{fill:b.color(a.front.color).brighten(-.1).get(),vertexes:[{x:f,y:k,z:m},{x:f,y:r,z:m},{x:c,y:h,z:0},{x:c,y:g,z:0}],enabled:a.front.visible&&!a.left.visible},{fill:b.color(a.front.color).brighten(-.1).get(),vertexes:[{x:q,y:r,z:m},{x:q,y:k,z:m},{x:e,y:g,z:0},{x:e,y:h,z:0}],enabled:a.front.visible&&!a.right.visible},{fill:b.color(a.front.color).get(),vertexes:[{x:e,y:g,z:0},{x:c,y:g,z:0},{x:c,y:h,z:0},{x:e,y:h,z:0}],enabled:a.front.visible},{fill:b.color(a.front.color).get(),vertexes:[{x:q,
	y:r,z:m},{x:f,y:r,z:m},{x:f,y:k,z:m},{x:q,y:k,z:m}],enabled:a.front.visible}]})}return p.apply(this,[].slice.call(arguments,1))});t.prototype.retrieveStacks=function(b){var f=this.series,d={},a,c=1;u(this.series,function(e){a=k(e.options.stack,b?0:f.length-1-e.index);d[a]?d[a].series.push(e):(d[a]={series:[e],position:c},c++)});d.totalStacks=c+1;return d};t.prototype.get3dFrame=function(){var f=this,l=f.options.chart.options3d,d=l.frame,a=f.plotLeft,c=f.plotLeft+f.plotWidth,e=f.plotTop,g=f.plotTop+
	f.plotHeight,h=l.depth,n=b.shapeArea3d([{x:a,y:g,z:h},{x:c,y:g,z:h},{x:c,y:g,z:0},{x:a,y:g,z:0}],f),q=b.shapeArea3d([{x:a,y:e,z:0},{x:c,y:e,z:0},{x:c,y:e,z:h},{x:a,y:e,z:h}],f),t=b.shapeArea3d([{x:a,y:e,z:0},{x:a,y:e,z:h},{x:a,y:g,z:h},{x:a,y:g,z:0}],f),r=b.shapeArea3d([{x:c,y:e,z:h},{x:c,y:e,z:0},{x:c,y:g,z:0},{x:c,y:g,z:h}],f),m=b.shapeArea3d([{x:a,y:g,z:0},{x:c,y:g,z:0},{x:c,y:e,z:0},{x:a,y:e,z:0}],f),w=b.shapeArea3d([{x:a,y:e,z:h},{x:c,y:e,z:h},{x:c,y:g,z:h},{x:a,y:g,z:h}],f),v=!1,y=!1,F=!1,H=
	!1;u([].concat(f.xAxis,f.yAxis,f.zAxis),function(a){a&&(a.horiz?a.opposite?y=!0:v=!0:a.opposite?H=!0:F=!0)});var E=function(a,c,e){for(var d=["size","color","visible"],b={},g=0;g<d.length;g++)for(var h=d[g],f=0;f<a.length;f++)if("object"===typeof a[f]){var l=a[f][h];if(void 0!==l&&null!==l){b[h]=l;break}}a=e;!0===b.visible||!1===b.visible?a=b.visible:"auto"===b.visible&&(a=0<=c);return{size:k(b.size,1),color:k(b.color,"none"),frontFacing:0<c,visible:a}},d={bottom:E([d.bottom,d.top,d],n,v),top:E([d.top,
	d.bottom,d],q,y),left:E([d.left,d.right,d.side,d],t,F),right:E([d.right,d.left,d.side,d],r,H),back:E([d.back,d.front,d],w,!0),front:E([d.front,d.back,d],m,!1)};"auto"===l.axisLabelPosition?(r=function(a,c){return a.visible!==c.visible||a.visible&&c.visible&&a.frontFacing!==c.frontFacing},l=[],r(d.left,d.front)&&l.push({y:(e+g)/2,x:a,z:0}),r(d.left,d.back)&&l.push({y:(e+g)/2,x:a,z:h}),r(d.right,d.front)&&l.push({y:(e+g)/2,x:c,z:0}),r(d.right,d.back)&&l.push({y:(e+g)/2,x:c,z:h}),n=[],r(d.bottom,d.front)&&
	n.push({x:(a+c)/2,y:g,z:0}),r(d.bottom,d.back)&&n.push({x:(a+c)/2,y:g,z:h}),q=[],r(d.top,d.front)&&q.push({x:(a+c)/2,y:e,z:0}),r(d.top,d.back)&&q.push({x:(a+c)/2,y:e,z:h}),t=[],r(d.bottom,d.left)&&t.push({z:(0+h)/2,y:g,x:a}),r(d.bottom,d.right)&&t.push({z:(0+h)/2,y:g,x:c}),g=[],r(d.top,d.left)&&g.push({z:(0+h)/2,y:e,x:a}),r(d.top,d.right)&&g.push({z:(0+h)/2,y:e,x:c}),a=function(a,c,e){if(0===a.length)return null;if(1===a.length)return a[0];for(var d=0,b=x(a,f,!1),g=1;g<b.length;g++)e*b[g][c]>e*b[d][c]?
	d=g:e*b[g][c]===e*b[d][c]&&b[g].z<b[d].z&&(d=g);return a[d]},d.axes={y:{left:a(l,"x",-1),right:a(l,"x",1)},x:{top:a(q,"y",-1),bottom:a(n,"y",1)},z:{top:a(g,"y",-1),bottom:a(t,"y",1)}}):d.axes={y:{left:{x:a,z:0},right:{x:c,z:0}},x:{top:{y:e,z:0},bottom:{y:g,z:0}},z:{top:{x:F?c:a,y:e},bottom:{x:F?c:a,y:g}}};return d}})(y);(function(b){function v(a,e){if(a.chart.is3d()&&"colorAxis"!==a.coll){var c=a.chart,d=c.frame3d,b=c.plotLeft,l=c.plotWidth+b,k=c.plotTop,c=c.plotHeight+k,n=0,m=0;e=a.swapZ({x:e.x,
	y:e.y,z:0});if(a.isZAxis)if(a.opposite){if(null===d.axes.z.top)return{};m=e.y-k;e.x=d.axes.z.top.x;e.y=d.axes.z.top.y}else{if(null===d.axes.z.bottom)return{};m=e.y-c;e.x=d.axes.z.bottom.x;e.y=d.axes.z.bottom.y}else if(a.horiz)if(a.opposite){if(null===d.axes.x.top)return{};m=e.y-k;e.y=d.axes.x.top.y;e.z=d.axes.x.top.z}else{if(null===d.axes.x.bottom)return{};m=e.y-c;e.y=d.axes.x.bottom.y;e.z=d.axes.x.bottom.z}else if(a.opposite){if(null===d.axes.y.right)return{};n=e.x-l;e.x=d.axes.y.right.x;e.z=d.axes.y.right.z}else{if(null===
	d.axes.y.left)return{};n=e.x-b;e.x=d.axes.y.left.x;e.z=d.axes.y.left.z}e=f([e],a.chart)[0];e.x+=n;e.y+=m}return e}var t,u=b.Axis,w=b.Chart,x=b.each,k=b.extend,n=b.merge,f=b.perspective,p=b.pick,l=b.splat,d=b.Tick,a=b.wrap;a(u.prototype,"setOptions",function(a,d){a.call(this,d);this.chart.is3d()&&"colorAxis"!==this.coll&&(a=this.options,a.tickWidth=p(a.tickWidth,0),a.gridLineWidth=p(a.gridLineWidth,1))});a(u.prototype,"getPlotLinePath",function(a){var c=a.apply(this,[].slice.call(arguments,1));if(!this.chart.is3d()||
	"colorAxis"===this.coll||null===c)return c;var d=this.chart,b=d.options.chart.options3d,b=this.isZAxis?d.plotWidth:b.depth,d=d.frame3d,c=[this.swapZ({x:c[1],y:c[2],z:0}),this.swapZ({x:c[1],y:c[2],z:b}),this.swapZ({x:c[4],y:c[5],z:0}),this.swapZ({x:c[4],y:c[5],z:b})],b=[];this.horiz?(this.isZAxis?(d.left.visible&&b.push(c[0],c[2]),d.right.visible&&b.push(c[1],c[3])):(d.front.visible&&b.push(c[0],c[2]),d.back.visible&&b.push(c[1],c[3])),d.top.visible&&b.push(c[0],c[1]),d.bottom.visible&&b.push(c[2],
	c[3])):(d.front.visible&&b.push(c[0],c[2]),d.back.visible&&b.push(c[1],c[3]),d.left.visible&&b.push(c[0],c[1]),d.right.visible&&b.push(c[2],c[3]));b=f(b,this.chart,!1);return this.chart.renderer.toLineSegments(b)});a(u.prototype,"getLinePath",function(a){return this.chart.is3d()?[]:a.apply(this,[].slice.call(arguments,1))});a(u.prototype,"getPlotBandPath",function(a){if(!this.chart.is3d()||"colorAxis"===this.coll)return a.apply(this,[].slice.call(arguments,1));var c=arguments,d=c[2],b=[],c=this.getPlotLinePath(c[1]),
	d=this.getPlotLinePath(d);if(c&&d)for(var f=0;f<c.length;f+=6)b.push("M",c[f+1],c[f+2],"L",c[f+4],c[f+5],"L",d[f+4],d[f+5],"L",d[f+1],d[f+2],"Z");return b});a(d.prototype,"getMarkPath",function(a){var c=a.apply(this,[].slice.call(arguments,1)),c=[v(this.axis,{x:c[1],y:c[2],z:0}),v(this.axis,{x:c[4],y:c[5],z:0})];return this.axis.chart.renderer.toLineSegments(c)});a(d.prototype,"getLabelPosition",function(a){var c=a.apply(this,[].slice.call(arguments,1));return v(this.axis,c)});b.wrap(u.prototype,
	"getTitlePosition",function(a){var c=a.apply(this,[].slice.call(arguments,1));return v(this,c)});a(u.prototype,"drawCrosshair",function(a){var c=arguments;this.chart.is3d()&&c[2]&&(c[2]={plotX:c[2].plotXold||c[2].plotX,plotY:c[2].plotYold||c[2].plotY});a.apply(this,[].slice.call(c,1))});a(u.prototype,"destroy",function(a){x(["backFrame","bottomFrame","sideFrame"],function(a){this[a]&&(this[a]=this[a].destroy())},this);a.apply(this,[].slice.call(arguments,1))});u.prototype.swapZ=function(a,d){return this.isZAxis?
	(d=d?0:this.chart.plotLeft,{x:d+a.z,y:a.y,z:a.x-d}):a};t=b.ZAxis=function(){this.init.apply(this,arguments)};k(t.prototype,u.prototype);k(t.prototype,{isZAxis:!0,setOptions:function(a){a=n({offset:0,lineWidth:0},a);u.prototype.setOptions.call(this,a);this.coll="zAxis"},setAxisSize:function(){u.prototype.setAxisSize.call(this);this.width=this.len=this.chart.options.chart.options3d.depth;this.right=this.chart.chartWidth-this.width-this.left},getSeriesExtremes:function(){var a=this,d=a.chart;a.hasVisibleSeries=
	!1;a.dataMin=a.dataMax=a.ignoreMinPadding=a.ignoreMaxPadding=null;a.buildStacks&&a.buildStacks();x(a.series,function(c){if(c.visible||!d.options.chart.ignoreHiddenSeries)a.hasVisibleSeries=!0,c=c.zData,c.length&&(a.dataMin=Math.min(p(a.dataMin,c[0]),Math.min.apply(null,c)),a.dataMax=Math.max(p(a.dataMax,c[0]),Math.max.apply(null,c)))})}});a(w.prototype,"getAxes",function(a){var c=this,d=this.options,d=d.zAxis=l(d.zAxis||{});a.call(this);c.is3d()&&(this.zAxis=[],x(d,function(a,d){a.index=d;a.isX=!0;
	(new t(c,a)).setScale()}))})})(y);(function(b){function v(b){var d=b.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&(d.stroke=this.options.edgeColor||d.fill,d["stroke-width"]=w(this.options.edgeWidth,1));return d}var t=b.each,u=b.perspective,w=b.pick,x=b.Series,k=b.seriesTypes,n=b.inArray,f=b.svg,p=b.wrap;p(k.column.prototype,"translate",function(b){b.apply(this,[].slice.call(arguments,1));if(this.chart.is3d()){var d=this,a=d.chart,c=d.options,e=c.depth||25,g=(c.stacking?c.stack||0:d.index)*
	(e+(c.groupZPadding||1)),f=d.borderWidth%2?.5:0;a.inverted&&!d.yAxis.reversed&&(f*=-1);!1!==c.grouping&&(g=0);g+=c.groupZPadding||1;t(d.data,function(c){if(null!==c.y){var b=c.shapeArgs,h=c.tooltipPos,l;t([["x","width"],["y","height"]],function(a){l=b[a[0]]-f;0>l&&(b[a[1]]+=b[a[0]]+f,b[a[0]]=-f,l=0);l+b[a[1]]>d[a[0]+"Axis"].len&&0!==b[a[1]]&&(b[a[1]]=d[a[0]+"Axis"].len-b[a[0]]);if(0!==b[a[1]]&&(b[a[0]]>=d[a[0]+"Axis"].len||b[a[0]]+b[a[1]]<=f))for(var c in b)b[c]=0});c.shapeType="cuboid";b.z=g;b.depth=
	e;b.insidePlotArea=!0;h=u([{x:h[0],y:h[1],z:g}],a,!0)[0];c.tooltipPos=[h.x,h.y]}});d.z=g}});p(k.column.prototype,"animate",function(b){if(this.chart.is3d()){var d=arguments[1],a=this.yAxis,c=this,e=this.yAxis.reversed;f&&(d?t(c.data,function(c){null!==c.y&&(c.height=c.shapeArgs.height,c.shapey=c.shapeArgs.y,c.shapeArgs.height=1,e||(c.shapeArgs.y=c.stackY?c.plotY+a.translate(c.stackY):c.plotY+(c.negative?-c.height:c.height)))}):(t(c.data,function(a){null!==a.y&&(a.shapeArgs.height=a.height,a.shapeArgs.y=
	a.shapey,a.graphic&&a.graphic.animate(a.shapeArgs,c.options.animation))}),this.drawDataLabels(),c.animate=null))}else b.apply(this,[].slice.call(arguments,1))});p(k.column.prototype,"plotGroup",function(b,d,a,c,e,g){this.chart.is3d()&&g&&!this[d]&&(this[d]=g,g.attr(this.getPlotBox()),this[d].survive=!0);return b.apply(this,Array.prototype.slice.call(arguments,1))});p(k.column.prototype,"setVisible",function(b,d){var a=this,c;a.chart.is3d()&&t(a.data,function(b){c=(b.visible=b.options.visible=d=void 0===
	d?!b.visible:d)?"visible":"hidden";a.options.data[n(b,a.data)]=b.options;b.graphic&&b.graphic.attr({visibility:c})});b.apply(this,Array.prototype.slice.call(arguments,1))});p(k.column.prototype,"init",function(b){b.apply(this,[].slice.call(arguments,1));if(this.chart.is3d()){var d=this.options,a=d.grouping,c=d.stacking,e=w(this.yAxis.options.reversedStacks,!0),g=0;if(void 0===a||a){a=this.chart.retrieveStacks(c);g=d.stack||0;for(c=0;c<a[g].series.length&&a[g].series[c]!==this;c++);g=10*(a.totalStacks-
	a[g].position)+(e?c:-c);this.xAxis.reversed||(g=10*a.totalStacks-g)}d.zIndex=g}});p(k.column.prototype,"pointAttribs",v);k.columnrange&&(p(k.columnrange.prototype,"pointAttribs",v),k.columnrange.prototype.plotGroup=k.column.prototype.plotGroup,k.columnrange.prototype.setVisible=k.column.prototype.setVisible);p(x.prototype,"alignDataLabel",function(b){if(this.chart.is3d()&&("column"===this.type||"columnrange"===this.type)){var d=arguments[4],a={x:d.x,y:d.y,z:this.z},a=u([a],this.chart,!0)[0];d.x=a.x;
	d.y=a.y}b.apply(this,[].slice.call(arguments,1))});p(b.StackItem.prototype,"getStackBox",function(f,d){var a=f.apply(this,[].slice.call(arguments,1));if(d.is3d()){var c={x:a.x,y:a.y,z:0},c=b.perspective([c],d,!0)[0];a.x=c.x;a.y=c.y}return a})})(y);(function(b){var v=b.deg2rad,t=b.each,u=b.pick,w=b.seriesTypes,x=b.svg;b=b.wrap;b(w.pie.prototype,"translate",function(b){b.apply(this,[].slice.call(arguments,1));if(this.chart.is3d()){var k=this,f=k.options,p=f.depth||0,l=k.chart.options.chart.options3d,
	d=l.alpha,a=l.beta,c=f.stacking?(f.stack||0)*p:k._i*p,c=c+p/2;!1!==f.grouping&&(c=0);t(k.data,function(b){var e=b.shapeArgs;b.shapeType="arc3d";e.z=c;e.depth=.75*p;e.alpha=d;e.beta=a;e.center=k.center;e=(e.end+e.start)/2;b.slicedTranslation={translateX:Math.round(Math.cos(e)*f.slicedOffset*Math.cos(d*v)),translateY:Math.round(Math.sin(e)*f.slicedOffset*Math.cos(d*v))}})}});b(w.pie.prototype.pointClass.prototype,"haloPath",function(b){var k=arguments;return this.series.chart.is3d()?[]:b.call(this,
	k[1])});b(w.pie.prototype,"pointAttribs",function(b,n,f){b=b.call(this,n,f);f=this.options;this.chart.is3d()&&(b.stroke=f.edgeColor||n.color||this.color,b["stroke-width"]=u(f.edgeWidth,1));return b});b(w.pie.prototype,"drawPoints",function(b){b.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&t(this.points,function(b){var f=b.graphic;if(f)f[b.y&&b.visible?"show":"hide"]()})});b(w.pie.prototype,"drawDataLabels",function(b){if(this.chart.is3d()){var k=this.chart.options.chart.options3d;t(this.data,
	function(b){var f=b.shapeArgs,l=f.r,d=(f.start+f.end)/2,a=b.labelPos,c=-l*(1-Math.cos((f.alpha||k.alpha)*v))*Math.sin(d),e=l*(Math.cos((f.beta||k.beta)*v)-1)*Math.cos(d);t([0,2,4],function(b){a[b]+=e;a[b+1]+=c})})}b.apply(this,[].slice.call(arguments,1))});b(w.pie.prototype,"addPoint",function(b){b.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&this.update(this.userOptions,!0)});b(w.pie.prototype,"animate",function(b){if(this.chart.is3d()){var k=arguments[1],f=this.options.animation,p=
	this.center,l=this.group,d=this.markerGroup;x&&(!0===f&&(f={}),k?(l.oldtranslateX=l.translateX,l.oldtranslateY=l.translateY,k={translateX:p[0],translateY:p[1],scaleX:.001,scaleY:.001},l.attr(k),d&&(d.attrSetters=l.attrSetters,d.attr(k))):(k={translateX:l.oldtranslateX,translateY:l.oldtranslateY,scaleX:1,scaleY:1},l.animate(k,f),d&&d.animate(k,f),this.animate=null))}else b.apply(this,[].slice.call(arguments,1))})})(y);(function(b){var v=b.perspective,t=b.pick,u=b.Point,w=b.seriesTypes,x=b.wrap;x(w.scatter.prototype,
	"translate",function(b){b.apply(this,[].slice.call(arguments,1));if(this.chart.is3d()){var k=this.chart,f=t(this.zAxis,k.options.zAxis[0]),p=[],l,d,a;for(a=0;a<this.data.length;a++)l=this.data[a],d=f.isLog&&f.val2lin?f.val2lin(l.z):l.z,l.plotZ=f.translate(d),l.isInside=l.isInside?d>=f.min&&d<=f.max:!1,p.push({x:l.plotX,y:l.plotY,z:l.plotZ});k=v(p,k,!0);for(a=0;a<this.data.length;a++)l=this.data[a],f=k[a],l.plotXold=l.plotX,l.plotYold=l.plotY,l.plotZold=l.plotZ,l.plotX=f.x,l.plotY=f.y,l.plotZ=f.z}});
	x(w.scatter.prototype,"init",function(b,n,f){n.is3d()&&(this.axisTypes=["xAxis","yAxis","zAxis"],this.pointArrayMap=["x","y","z"],this.parallelArrays=["x","y","z"],this.directTouch=!0);b=b.apply(this,[n,f]);this.chart.is3d()&&(this.tooltipOptions.pointFormat=this.userOptions.tooltip?this.userOptions.tooltip.pointFormat||"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3ez: \x3cb\x3e{point.z}\x3c/b\x3e\x3cbr/\x3e":"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3ez: \x3cb\x3e{point.z}\x3c/b\x3e\x3cbr/\x3e");
	return b});x(w.scatter.prototype,"pointAttribs",function(k,n){var f=k.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&n&&(f.zIndex=b.pointCameraDistance(n,this.chart));return f});x(u.prototype,"applyOptions",function(b){var k=b.apply(this,[].slice.call(arguments,1));this.series.chart.is3d()&&void 0===k.z&&(k.z=0);return k})})(y);(function(b){var v=b.Axis,t=b.SVGRenderer,u=b.VMLRenderer;u&&(b.setOptions({animate:!1}),u.prototype.face3d=t.prototype.face3d,u.prototype.polyhedron=t.prototype.polyhedron,
	u.prototype.cuboid=t.prototype.cuboid,u.prototype.cuboidPath=t.prototype.cuboidPath,u.prototype.toLinePath=t.prototype.toLinePath,u.prototype.toLineSegments=t.prototype.toLineSegments,u.prototype.createElement3D=t.prototype.createElement3D,u.prototype.arc3d=function(b){b=t.prototype.arc3d.call(this,b);b.css({zIndex:b.zIndex});return b},b.VMLRenderer.prototype.arc3dPath=b.SVGRenderer.prototype.arc3dPath,b.wrap(v.prototype,"render",function(b){b.apply(this,[].slice.call(arguments,1));this.sideFrame&&
	(this.sideFrame.css({zIndex:0}),this.sideFrame.front.attr({fill:this.sideFrame.color}));this.bottomFrame&&(this.bottomFrame.css({zIndex:1}),this.bottomFrame.front.attr({fill:this.bottomFrame.color}));this.backFrame&&(this.backFrame.css({zIndex:0}),this.backFrame.front.attr({fill:this.backFrame.color}))}))})(y)});


/***/ },

/***/ "504h":
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.14 (2017-07-28)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(M,S){"object"===typeof module&&module.exports?module.exports=M.document?S(M):S:M.Highcharts=S(M)})("undefined"!==typeof window?window:this,function(M){M=function(){var a=window,C=a.document,A=a.navigator&&a.navigator.userAgent||"",F=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,E=/(edge|msie|trident)/i.test(A)&&!window.opera,m=!F,f=/Firefox/.test(A),l=f&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
	version:"5.0.14",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:l,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:E,isWebKit:/AppleWebKit/.test(A),isFirefox:f,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:F,vml:m,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){var C=[],A=a.charts,F=a.doc,E=a.win;a.error=function(m,f){m=a.isNumber(m)?"Highcharts error #"+
	m+": www.highcharts.com/errors/"+m:m;if(f)throw Error(m);E.console&&console.log(m)};a.Fx=function(a,f,l){this.options=f;this.elem=a;this.prop=l};a.Fx.prototype={dSetter:function(){var a=this.paths[0],f=this.paths[1],l=[],r=this.now,u=a.length,t;if(1===r)l=this.toD;else if(u===f.length&&1>r)for(;u--;)t=parseFloat(a[u]),l[u]=isNaN(t)?a[u]:r*parseFloat(f[u]-t)+t;else l=f;this.elem.attr("d",l,null,!0)},update:function(){var a=this.elem,f=this.prop,l=this.now,r=this.options.step;if(this[f+"Setter"])this[f+
	"Setter"]();else a.attr?a.element&&a.attr(f,l,null,!0):a.style[f]=l+this.unit;r&&r.call(a,l,this)},run:function(a,f,l){var r=this,m=function(a){return m.stopped?!1:r.step(a)},t;this.startTime=+new Date;this.start=a;this.end=f;this.unit=l;this.now=this.start;this.pos=0;m.elem=this.elem;m.prop=this.prop;m()&&1===C.push(m)&&(m.timerId=setInterval(function(){for(t=0;t<C.length;t++)C[t]()||C.splice(t--,1);C.length||clearInterval(m.timerId)},13))},step:function(m){var f=+new Date,l,r=this.options,u=this.elem,
	t=r.complete,g=r.duration,d=r.curAnim;u.attr&&!u.element?m=!1:m||f>=g+this.startTime?(this.now=this.end,this.pos=1,this.update(),l=d[this.prop]=!0,a.objectEach(d,function(a){!0!==a&&(l=!1)}),l&&t&&t.call(u),m=!1):(this.pos=r.easing((f-this.startTime)/g),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0);return m},initPath:function(m,f,l){function r(a){var c,e;for(n=a.length;n--;)c="M"===a[n]||"L"===a[n],e=/[a-zA-Z]/.test(a[n+3]),c&&e&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+2])}
	function u(a,c){for(;a.length<v;){a[0]=c[v-a.length];var b=a.slice(0,e);[].splice.apply(a,[0,0].concat(b));D&&(b=a.slice(a.length-e),[].splice.apply(a,[a.length,0].concat(b)),n--)}a[0]="M"}function t(a,c){for(var q=(v-a.length)/e;0<q&&q--;)y=a.slice().splice(a.length/J-e,e*J),y[0]=c[v-e-q*e],b&&(y[e-6]=y[e-2],y[e-5]=y[e-1]),[].splice.apply(a,[a.length/J,0].concat(y)),D&&q--}f=f||"";var g,d=m.startX,k=m.endX,b=-1<f.indexOf("C"),e=b?7:3,v,y,n;f=f.split(" ");l=l.slice();var D=m.isArea,J=D?2:1,c;b&&(r(f),
	r(l));if(d&&k){for(n=0;n<d.length;n++)if(d[n]===k[0]){g=n;break}else if(d[0]===k[k.length-d.length+n]){g=n;c=!0;break}void 0===g&&(f=[])}f.length&&a.isNumber(g)&&(v=l.length+g*J*e,c?(u(f,l),t(l,f)):(u(l,f),t(f,l)));return[f,l]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,f){var m;a||(a={});for(m in f)a[m]=f[m];return a};a.merge=function(){var m,f=arguments,l,r={},u=
	function(f,g){"object"!==typeof f&&(f={});a.objectEach(g,function(d,k){!a.isObject(d,!0)||a.isClass(d)||a.isDOMElement(d)?f[k]=g[k]:f[k]=u(f[k]||{},d)});return f};!0===f[0]&&(r=f[1],f=Array.prototype.slice.call(f,2));l=f.length;for(m=0;m<l;m++)r=u(r,f[m]);return r};a.pInt=function(a,f){return parseInt(a,f||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(m,
	f){return!!m&&"object"===typeof m&&(!f||!a.isArray(m))};a.isDOMElement=function(m){return a.isObject(m)&&"number"===typeof m.nodeType};a.isClass=function(m){var f=m&&m.constructor;return!(!a.isObject(m,!0)||a.isDOMElement(m)||!f||!f.name||"Object"===f.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=function(a,f){for(var m=a.length;m--;)if(a[m]===f){a.splice(m,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(m,f,l){var r;a.isString(f)?a.defined(l)?
	m.setAttribute(f,l):m&&m.getAttribute&&(r=m.getAttribute(f)):a.defined(f)&&a.isObject(f)&&a.objectEach(f,function(a,f){m.setAttribute(f,a)});return r};a.splat=function(m){return a.isArray(m)?m:[m]};a.syncTimeout=function(a,f,l){if(f)return setTimeout(a,f,l);a.call(0,l)};a.pick=function(){var a=arguments,f,l,r=a.length;for(f=0;f<r;f++)if(l=a[f],void 0!==l&&null!==l)return l};a.css=function(m,f){a.isMS&&!a.svg&&f&&void 0!==f.opacity&&(f.filter="alpha(opacity\x3d"+100*f.opacity+")");a.extend(m.style,
	f)};a.createElement=function(m,f,l,r,u){m=F.createElement(m);var t=a.css;f&&a.extend(m,f);u&&t(m,{padding:0,border:"none",margin:0});l&&t(m,l);r&&r.appendChild(m);return m};a.extendClass=function(m,f){var l=function(){};l.prototype=new m;a.extend(l.prototype,f);return l};a.pad=function(a,f,l){return Array((f||2)+1-String(a).length).join(l||0)+a};a.relativeLength=function(a,f,l){return/%$/.test(a)?f*parseFloat(a)/100+(l||0):parseFloat(a)};a.wrap=function(a,f,l){var r=a[f];a[f]=function(){var a=Array.prototype.slice.call(arguments),
	f=arguments,g=this;g.proceed=function(){r.apply(g,arguments.length?arguments:f)};a.unshift(r);a=l.apply(this,a);g.proceed=null;return a}};a.getTZOffset=function(m){var f=a.Date;return 6E4*(f.hcGetTimezoneOffset&&f.hcGetTimezoneOffset(m)||f.hcTimezoneOffset||0)};a.dateFormat=function(m,f,l){if(!a.defined(f)||isNaN(f))return a.defaultOptions.lang.invalidDate||"";m=a.pick(m,"%Y-%m-%d %H:%M:%S");var r=a.Date,u=new r(f-a.getTZOffset(f)),t=u[r.hcGetHours](),g=u[r.hcGetDay](),d=u[r.hcGetDate](),k=u[r.hcGetMonth](),
	b=u[r.hcGetFullYear](),e=a.defaultOptions.lang,v=e.weekdays,y=e.shortWeekdays,n=a.pad,r=a.extend({a:y?y[g]:v[g].substr(0,3),A:v[g],d:n(d),e:n(d,2," "),w:g,b:e.shortMonths[k],B:e.months[k],m:n(k+1),y:b.toString().substr(2,2),Y:b,H:n(t),k:t,I:n(t%12||12),l:t%12||12,M:n(u[r.hcGetMinutes]()),p:12>t?"AM":"PM",P:12>t?"am":"pm",S:n(u.getSeconds()),L:n(Math.round(f%1E3),3)},a.dateFormats);a.objectEach(r,function(a,e){for(;-1!==m.indexOf("%"+e);)m=m.replace("%"+e,"function"===typeof a?a(f):a)});return l?m.substr(0,
	1).toUpperCase()+m.substr(1):m};a.formatSingle=function(m,f){var l=/\.([0-9])/,r=a.defaultOptions.lang;/f$/.test(m)?(l=(l=m.match(l))?l[1]:-1,null!==f&&(f=a.numberFormat(f,l,r.decimalPoint,-1<m.indexOf(",")?r.thousandsSep:""))):f=a.dateFormat(m,f);return f};a.format=function(m,f){for(var l="{",r=!1,u,t,g,d,k=[],b;m;){l=m.indexOf(l);if(-1===l)break;u=m.slice(0,l);if(r){u=u.split(":");t=u.shift().split(".");d=t.length;b=f;for(g=0;g<d;g++)b=b[t[g]];u.length&&(b=a.formatSingle(u.join(":"),b));k.push(b)}else k.push(u);
	m=m.slice(l+1);l=(r=!r)?"}":"{"}k.push(m);return k.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(m,f,l,r,u){var t,g=m;l=a.pick(l,1);t=m/l;f||(f=u?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===r&&(1===l?f=a.grep(f,function(a){return 0===a%1}):.1>=l&&(f=[1/l])));for(r=0;r<f.length&&!(g=f[r],u&&g*l>=m||!u&&t<=(f[r]+(f[r+1]||f[r]))/2);r++);return g=a.correctFloat(g*l,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=
	function(a,f){var l=a.length,r,m;for(m=0;m<l;m++)a[m].safeI=m;a.sort(function(a,g){r=f(a,g);return 0===r?a.safeI-g.safeI:r});for(m=0;m<l;m++)delete a[m].safeI};a.arrayMin=function(a){for(var f=a.length,l=a[0];f--;)a[f]<l&&(l=a[f]);return l};a.arrayMax=function(a){for(var f=a.length,l=a[0];f--;)a[f]>l&&(l=a[f]);return l};a.destroyObjectProperties=function(m,f){a.objectEach(m,function(a,r){a&&a!==f&&a.destroy&&a.destroy();delete m[r]})};a.discardElement=function(m){var f=a.garbageBin;f||(f=a.createElement("div"));
	m&&f.appendChild(m);f.innerHTML=""};a.correctFloat=function(a,f){return parseFloat(a.toPrecision(f||14))};a.setAnimation=function(m,f){f.renderer.globalAnimation=a.pick(m,f.options.chart.animation,!0)};a.animObject=function(m){return a.isObject(m)?a.merge(m):{duration:m?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(m,f,l,r){m=+m||0;f=+f;var u=a.defaultOptions.lang,t=(m.toString().split(".")[1]||"").split("e")[0].length,
	g,d,k=m.toString().split("e");-1===f?f=Math.min(t,20):a.isNumber(f)||(f=2);d=(Math.abs(k[1]?k[0]:m)+Math.pow(10,-Math.max(f,t)-1)).toFixed(f);t=String(a.pInt(d));g=3<t.length?t.length%3:0;l=a.pick(l,u.decimalPoint);r=a.pick(r,u.thousandsSep);m=(0>m?"-":"")+(g?t.substr(0,g)+r:"");m+=t.substr(g).replace(/(\d{3})(?=\d)/g,"$1"+r);f&&(m+=l+d.slice(-f));k[1]&&(m+="e"+k[1]);return m};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(m,f,l){if("width"===f)return Math.min(m.offsetWidth,
	m.scrollWidth)-a.getStyle(m,"padding-left")-a.getStyle(m,"padding-right");if("height"===f)return Math.min(m.offsetHeight,m.scrollHeight)-a.getStyle(m,"padding-top")-a.getStyle(m,"padding-bottom");if(m=E.getComputedStyle(m,void 0))m=m.getPropertyValue(f),a.pick(l,!0)&&(m=a.pInt(m));return m};a.inArray=function(a,f){return f.indexOf?f.indexOf(a):[].indexOf.call(f,a)};a.grep=function(a,f){return[].filter.call(a,f)};a.find=function(a,f){return[].find.call(a,f)};a.map=function(a,f){for(var l=[],r=0,m=
	a.length;r<m;r++)l[r]=f.call(a[r],a[r],r,a);return l};a.offset=function(a){var f=F.documentElement;a=a.getBoundingClientRect();return{top:a.top+(E.pageYOffset||f.scrollTop)-(f.clientTop||0),left:a.left+(E.pageXOffset||f.scrollLeft)-(f.clientLeft||0)}};a.stop=function(a,f){for(var l=C.length;l--;)C[l].elem!==a||f&&f!==C[l].prop||(C[l].stopped=!0)};a.each=function(a,f,l){return Array.prototype.forEach.call(a,f,l)};a.objectEach=function(a,f,l){for(var r in a)a.hasOwnProperty(r)&&f.call(l,a[r],r,a)};
	a.addEvent=function(m,f,l){function r(a){a.target=a.srcElement||E;l.call(m,a)}var u=m.hcEvents=m.hcEvents||{};m.addEventListener?m.addEventListener(f,l,!1):m.attachEvent&&(m.hcEventsIE||(m.hcEventsIE={}),l.hcGetKey||(l.hcGetKey=a.uniqueKey()),m.hcEventsIE[l.hcGetKey]=r,m.attachEvent("on"+f,r));u[f]||(u[f]=[]);u[f].push(l);return function(){a.removeEvent(m,f,l)}};a.removeEvent=function(m,f,l){function r(a,b){m.removeEventListener?m.removeEventListener(a,b,!1):m.attachEvent&&(b=m.hcEventsIE[b.hcGetKey],
	m.detachEvent("on"+a,b))}function u(){var d,b;m.nodeName&&(f?(d={},d[f]=!0):d=g,a.objectEach(d,function(a,d){if(g[d])for(b=g[d].length;b--;)r(d,g[d][b])}))}var t,g=m.hcEvents,d;g&&(f?(t=g[f]||[],l?(d=a.inArray(l,t),-1<d&&(t.splice(d,1),g[f]=t),r(f,l)):(u(),g[f]=[])):(u(),m.hcEvents={}))};a.fireEvent=function(m,f,l,r){var u;u=m.hcEvents;var t,g;l=l||{};if(F.createEvent&&(m.dispatchEvent||m.fireEvent))u=F.createEvent("Events"),u.initEvent(f,!0,!0),a.extend(u,l),m.dispatchEvent?m.dispatchEvent(u):m.fireEvent(f,
	u);else if(u)for(u=u[f]||[],t=u.length,l.target||a.extend(l,{preventDefault:function(){l.defaultPrevented=!0},target:m,type:f}),f=0;f<t;f++)(g=u[f])&&!1===g.call(m,l)&&l.preventDefault();r&&!l.defaultPrevented&&r(l)};a.animate=function(m,f,l){var r,u="",t,g,d;a.isObject(l)||(d=arguments,l={duration:d[2],easing:d[3],complete:d[4]});a.isNumber(l.duration)||(l.duration=400);l.easing="function"===typeof l.easing?l.easing:Math[l.easing]||Math.easeInOutSine;l.curAnim=a.merge(f);a.objectEach(f,function(d,
	b){a.stop(m,b);g=new a.Fx(m,l,b);t=null;"d"===b?(g.paths=g.initPath(m,m.d,f.d),g.toD=f.d,r=0,t=1):m.attr?r=m.attr(b):(r=parseFloat(a.getStyle(m,b))||0,"opacity"!==b&&(u="px"));t||(t=d);t&&t.match&&t.match("px")&&(t=t.replace(/px/g,""));g.run(r,t,u)})};a.seriesType=function(m,f,l,r,u){var t=a.getOptions(),g=a.seriesTypes;t.plotOptions[m]=a.merge(t.plotOptions[f],l);g[m]=a.extendClass(g[f]||function(){},r);g[m].prototype.type=m;u&&(g[m].prototype.pointClass=a.extendClass(a.Point,u));return g[m]};a.uniqueKey=
	function(){var a=Math.random().toString(36).substring(2,9),f=0;return function(){return"highcharts-"+a+"-"+f++}}();E.jQuery&&(E.jQuery.fn.highcharts=function(){var m=[].slice.call(arguments);if(this[0])return m[0]?(new (a[a.isString(m[0])?m.shift():"Chart"])(this[0],m[0],m[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});F&&!F.defaultView&&(a.getStyle=function(m,f){var l={width:"clientWidth",height:"clientHeight"}[f];if(m.style[f])return a.pInt(m.style[f]);"opacity"===f&&(f="filter");if(l)return m.style.zoom=
	1,Math.max(m[l]-2*a.getStyle(m,"padding"),0);m=m.currentStyle[f.replace(/\-(\w)/g,function(a,f){return f.toUpperCase()})];"filter"===f&&(m=m.replace(/alpha\(opacity=([0-9]+)\)/,function(a,f){return f/100}));return""===m?1:a.pInt(m)});Array.prototype.forEach||(a.each=function(a,f,l){for(var r=0,m=a.length;r<m;r++)if(!1===f.call(l,a[r],r,a))return r});Array.prototype.indexOf||(a.inArray=function(a,f){var l,r=0;if(f)for(l=f.length;r<l;r++)if(f[r]===a)return r;return-1});Array.prototype.filter||(a.grep=
	function(a,f){for(var l=[],r=0,m=a.length;r<m;r++)f(a[r],r)&&l.push(a[r]);return l});Array.prototype.find||(a.find=function(a,f){var l,r=a.length;for(l=0;l<r;l++)if(f(a[l],l))return a[l]})})(M);(function(a){var C=a.each,A=a.isNumber,F=a.map,E=a.merge,m=a.pInt;a.Color=function(f){if(!(this instanceof a.Color))return new a.Color(f);this.init(f)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[m(a[1]),
	m(a[2]),m(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[m(a[1]),m(a[2]),m(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(f){var l,r,m,t;if((this.input=f=this.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=F(f.stops,function(g){return new a.Color(g[1])});else if(f&&"#"===f.charAt()&&(l=f.length,f=parseInt(f.substr(1),16),7===l?r=[(f&16711680)>>16,(f&65280)>>
	8,f&255,1]:4===l&&(r=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])),!r)for(m=this.parsers.length;m--&&!r;)t=this.parsers[m],(l=t.regex.exec(f))&&(r=t.parse(l));this.rgba=r||[]},get:function(a){var f=this.input,r=this.rgba,m;this.stops?(m=E(f),m.stops=[].concat(m.stops),C(this.stops,function(f,g){m.stops[g]=[m.stops[g][0],f.get(a)]})):m=r&&A(r[0])?"rgb"===a||!a&&1===r[3]?"rgb("+r[0]+","+r[1]+","+r[2]+")":"a"===a?r[3]:"rgba("+r.join(",")+")":f;return m},brighten:function(a){var f,r=this.rgba;
	if(this.stops)C(this.stops,function(f){f.brighten(a)});else if(A(a)&&0!==a)for(f=0;3>f;f++)r[f]+=m(255*a),0>r[f]&&(r[f]=0),255<r[f]&&(r[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,l){var f,m;a.rgba.length?(f=this.rgba,a=a.rgba,m=1!==a[3]||1!==f[3],a=(m?"rgba(":"rgb(")+Math.round(a[0]+(f[0]-a[0])*(1-l))+","+Math.round(a[1]+(f[1]-a[1])*(1-l))+","+Math.round(a[2]+(f[2]-a[2])*(1-l))+(m?","+(a[3]+(f[3]-a[3])*(1-l)):"")+")"):a=a.input||"none";return a}};a.color=
	function(f){return new a.Color(f)}})(M);(function(a){var C,A,F=a.addEvent,E=a.animate,m=a.attr,f=a.charts,l=a.color,r=a.css,u=a.createElement,t=a.defined,g=a.deg2rad,d=a.destroyObjectProperties,k=a.doc,b=a.each,e=a.extend,v=a.erase,y=a.grep,n=a.hasTouch,D=a.inArray,J=a.isArray,c=a.isFirefox,G=a.isMS,q=a.isObject,B=a.isString,K=a.isWebKit,p=a.merge,z=a.noop,I=a.objectEach,L=a.pick,h=a.pInt,w=a.removeEvent,P=a.stop,H=a.svg,O=a.SVG_NS,Q=a.symbolSizes,R=a.win;C=a.SVGElement=function(){return this};e(C.prototype,
	{opacity:1,SVG_NS:O,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,h){this.element="span"===h?u(h):k.createElementNS(this.SVG_NS,h);this.renderer=a},animate:function(x,h,c){h=a.animObject(L(h,this.renderer.globalAnimation,!0));0!==h.duration?(c&&(h.complete=c),E(this,x,h)):(this.attr(x,null,c),h.step&&h.step.call(this));return this},colorGradient:function(x,h,c){var w=this.renderer,
	e,q,N,d,n,g,k,H,G,v,z=[],f;x.radialGradient?q="radialGradient":x.linearGradient&&(q="linearGradient");q&&(N=x[q],n=w.gradients,k=x.stops,v=c.radialReference,J(N)&&(x[q]=N={x1:N[0],y1:N[1],x2:N[2],y2:N[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===q&&v&&!t(N.gradientUnits)&&(d=N,N=p(N,w.getRadialAttr(v,d),{gradientUnits:"userSpaceOnUse"})),I(N,function(a,x){"id"!==x&&z.push(x,a)}),I(k,function(a){z.push(a)}),z=z.join(","),n[z]?v=n[z].attr("id"):(N.id=v=a.uniqueKey(),n[z]=g=w.createElement(q).attr(N).add(w.defs),
	g.radAttr=d,g.stops=[],b(k,function(x){0===x[1].indexOf("rgba")?(e=a.color(x[1]),H=e.get("rgb"),G=e.get("a")):(H=x[1],G=1);x=w.createElement("stop").attr({offset:x[0],"stop-color":H,"stop-opacity":G}).add(g);g.stops.push(x)})),f="url("+w.url+"#"+v+")",c.setAttribute(h,f),c.gradient=z,x.toString=function(){return f})},applyTextOutline:function(x){var h=this.element,c,w,p,e,q;-1!==x.indexOf("contrast")&&(x=x.replace(/contrast/g,this.renderer.getContrast(h.style.fill)));x=x.split(" ");w=x[x.length-1];
	if((p=x[0])&&"none"!==p&&a.svg){this.fakeTS=!0;x=[].slice.call(h.getElementsByTagName("tspan"));this.ySetter=this.xSetter;p=p.replace(/(^[\d\.]+)(.*?)$/g,function(a,x,h){return 2*x+h});for(q=x.length;q--;)c=x[q],"highcharts-text-outline"===c.getAttribute("class")&&v(x,h.removeChild(c));e=h.firstChild;b(x,function(a,x){0===x&&(a.setAttribute("x",h.getAttribute("x")),x=h.getAttribute("y"),a.setAttribute("y",x||0),null===x&&h.setAttribute("y",0));a=a.cloneNode(1);m(a,{"class":"highcharts-text-outline",
	fill:w,stroke:w,"stroke-width":p,"stroke-linejoin":"round"});h.insertBefore(a,e)})}},attr:function(a,h,c,w){var x,p=this.element,e,q=this,b,N;"string"===typeof a&&void 0!==h&&(x=a,a={},a[x]=h);"string"===typeof a?q=(this[a+"Getter"]||this._defaultGetter).call(this,a,p):(I(a,function(x,h){b=!1;w||P(this,h);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(h)&&(e||(this.symbolAttr(a),e=!0),b=!0);!this.rotation||"x"!==h&&"y"!==h||(this.doTransform=!0);b||(N=this[h+"Setter"]||
	this._defaultSetter,N.call(this,x,h,p),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(h)&&this.updateShadows(h,x,N))},this),this.afterSetters());c&&c();return q},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,h,c){for(var x=this.shadows,w=x.length;w--;)c.call(x[w],"height"===a?Math.max(h-(x[w].cutHeight||0),0):"d"===a?this.d:h,a,x[w])},addClass:function(a,h){var x=this.attr("class")||"";-1===x.indexOf(a)&&
	(h||(a=(x+(x?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==D(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var x=this;b("x y r start end width height innerR anchorX anchorY".split(" "),function(h){x[h]=L(a[h],x[h])});x.attr({d:x.renderer.symbols[x.symbolName](x.x,x.y,x.width,x.height,x)})},clip:function(a){return this.attr("clip-path",a?"url("+
	this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,h){var x=this,c={},w;h=h||a.strokeWidth||0;w=Math.round(h)%2/2;a.x=Math.floor(a.x||x.x||0)+w;a.y=Math.floor(a.y||x.y||0)+w;a.width=Math.floor((a.width||x.width||0)-2*w);a.height=Math.floor((a.height||x.height||0)-2*w);t(a.strokeWidth)&&(a.strokeWidth=h);I(a,function(a,h){x[h]!==a&&(x[h]=c[h]=a)});return c},css:function(a){var x=this.styles,c={},w=this.element,p,q="",b,d=!x,n=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);
	x&&I(a,function(a,h){a!==x[h]&&(c[h]=a,d=!0)});d&&(x&&(a=e(x,c)),p=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===w.nodeName.toLowerCase()&&h(a.width),this.styles=a,p&&!H&&this.renderer.forExport&&delete a.width,G&&!H?r(this.element,a):(b=function(a,x){return"-"+x.toLowerCase()},I(a,function(a,x){-1===D(x,n)&&(q+=x.replace(/([A-Z])/g,b)+":"+a+";")}),q&&m(w,"style",q)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));
	return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,h){var x=this,c=x.element;n&&"click"===a?(c.ontouchstart=function(a){x.touchEventFired=Date.now();a.preventDefault();h.call(c,a)},c.onclick=function(a){(-1===R.navigator.userAgent.indexOf("Android")||1100<Date.now()-(x.touchEventFired||0))&&h.call(c,a)}):c["on"+a]=h;return this},setRadialReference:function(a){var x=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;x&&x.radAttr&&x.animate(this.renderer.getRadialAttr(a,
	x.radAttr));return this},translate:function(a,h){return this.attr({translateX:a,translateY:h})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,h=this.translateY||0,c=this.scaleX,w=this.scaleY,p=this.inverted,e=this.rotation,q=this.element;p&&(a+=this.width,h+=this.height);a=["translate("+a+","+h+")"];p?a.push("rotate(90) scale(-1,1)"):e&&a.push("rotate("+e+" "+(q.getAttribute("x")||0)+" "+(q.getAttribute("y")||0)+")");(t(c)||
	t(w))&&a.push("scale("+L(c,1)+" "+L(w,1)+")");a.length&&q.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,h,c){var x,w,p,e,q={};w=this.renderer;p=w.alignedObjects;var b,d;if(a){if(this.alignOptions=a,this.alignByTranslate=h,!c||B(c))this.alignTo=x=c||"renderer",v(p,this),p.push(this),c=null}else a=this.alignOptions,h=this.alignByTranslate,x=this.alignTo;c=L(c,w[x],w);x=a.align;w=a.verticalAlign;p=(c.x||0)+(a.x||
	0);e=(c.y||0)+(a.y||0);"right"===x?b=1:"center"===x&&(b=2);b&&(p+=(c.width-(a.width||0))/b);q[h?"translateX":"x"]=Math.round(p);"bottom"===w?d=1:"middle"===w&&(d=2);d&&(e+=(c.height-(a.height||0))/d);q[h?"translateY":"y"]=Math.round(e);this[this.placed?"animate":"attr"](q);this.placed=!0;this.alignAttr=q;return this},getBBox:function(a,h){var x,c=this.renderer,w,p=this.element,q=this.styles,d,n=this.textStr,k,N=c.cache,H=c.cacheKeys,G;h=L(h,this.rotation);w=h*g;d=q&&q.fontSize;void 0!==n&&(G=n.toString(),
	-1===G.indexOf("\x3c")&&(G=G.replace(/[0-9]/g,"0")),G+=["",h||0,d,q&&q.width,q&&q.textOverflow].join());G&&!a&&(x=N[G]);if(!x){if(p.namespaceURI===this.SVG_NS||c.forExport){try{(k=this.fakeTS&&function(a){b(p.querySelectorAll(".highcharts-text-outline"),function(x){x.style.display=a})})&&k("none"),x=p.getBBox?e({},p.getBBox()):{width:p.offsetWidth,height:p.offsetHeight},k&&k("")}catch(W){}if(!x||0>x.width)x={width:0,height:0}}else x=this.htmlGetBBox();c.isSVG&&(a=x.width,c=x.height,q&&"11px"===q.fontSize&&
	17===Math.round(c)&&(x.height=c=14),h&&(x.width=Math.abs(c*Math.sin(w))+Math.abs(a*Math.cos(w)),x.height=Math.abs(c*Math.cos(w))+Math.abs(a*Math.sin(w))));if(G&&0<x.height){for(;250<H.length;)delete N[H.shift()];N[G]||H.push(G);N[G]=x}}return x},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var x=this;x.animate({opacity:0},{duration:a||150,complete:function(){x.attr({y:-9999})}})},add:function(a){var x=
	this.renderer,h=this.element,c;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&x.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)c=this.zIndexSetter();c||(a?a.element:x.box).appendChild(h);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var x=a.parentNode;x&&x.removeChild(a)},destroy:function(){var a=this,h=a.element||{},c=a.renderer.isSVG&&"SPAN"===h.nodeName&&a.parentGroup,w=h.ownerSVGElement;h.onclick=h.onmouseout=h.onmouseover=h.onmousemove=
	h.point=null;P(a);a.clipPath&&w&&(b(w.querySelectorAll("[clip-path]"),function(x){-1<x.getAttribute("clip-path").indexOf(a.clipPath.element.id+")")&&x.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(w=0;w<a.stops.length;w++)a.stops[w]=a.stops[w].destroy();a.stops=null}a.safeRemoveChild(h);for(a.destroyShadows();c&&c.div&&0===c.div.childNodes.length;)h=c.parentGroup,a.safeRemoveChild(c.div),delete c.div,c=h;a.alignTo&&v(a.renderer.alignedObjects,a);I(a,function(x,h){delete a[h]});
	return null},shadow:function(a,h,c){var x=[],w,p,q=this.element,e,b,d,n;if(!a)this.destroyShadows();else if(!this.shadows){b=L(a.width,3);d=(a.opacity||.15)/b;n=this.parentInverted?"(-1,-1)":"("+L(a.offsetX,1)+", "+L(a.offsetY,1)+")";for(w=1;w<=b;w++)p=q.cloneNode(0),e=2*b+1-2*w,m(p,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":d*w,"stroke-width":e,transform:"translate"+n,fill:"none"}),c&&(m(p,"height",Math.max(m(p,"height")-e,0)),p.cutHeight=e),h?h.element.appendChild(p):q.parentNode.insertBefore(p,
	q),x.push(p);this.shadows=x}return this},destroyShadows:function(){b(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=L(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,h,c){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[h]!==
	a&&(c.setAttribute(h,a),this[h]=a)},dashstyleSetter:function(a){var x,c=this["stroke-width"];"inherit"===c&&(c=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(x=a.length;x--;)a[x]=h(a[x])*c;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",
	{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,h,c){this[h]=a;c.setAttribute(h,a)},titleSetter:function(a){var h=this.element.getElementsByTagName("title")[0];h||(h=k.createElementNS(this.SVG_NS,"title"),this.element.appendChild(h));h.firstChild&&h.removeChild(h.firstChild);h.appendChild(k.createTextNode(String(L(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,
	h,c){"string"===typeof a?c.setAttribute(h,a):a&&this.colorGradient(a,h,c)},visibilitySetter:function(a,h,c){"inherit"===a?c.removeAttribute(h):this[h]!==a&&c.setAttribute(h,a);this[h]=a},zIndexSetter:function(a,c){var x=this.renderer,w=this.parentGroup,p=(w||x).element||x.box,q,e=this.element,b;q=this.added;var d;t(a)&&(e.zIndex=a,a=+a,this[c]===a&&(q=!1),this[c]=a);if(q){(a=this.zIndex)&&w&&(w.handleZ=!0);c=p.childNodes;for(d=0;d<c.length&&!b;d++)w=c[d],q=w.zIndex,w!==e&&(h(q)>a||!t(a)&&t(q)||0>
	a&&!t(q)&&p!==x.box)&&(p.insertBefore(e,w),b=!0);b||p.appendChild(e)}return b},_defaultSetter:function(a,h,c){c.setAttribute(h,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=function(a,h){this[h]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,h,c){this[h]=a;this.stroke&&this["stroke-width"]?
	(C.prototype.fillSetter.call(this,this.stroke,"stroke",c),c.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===h&&0===a&&this.hasStroke&&(c.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};e(A.prototype,{Element:C,SVG_NS:O,init:function(a,h,w,p,q,e){var x;p=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(p));x=p.element;a.appendChild(x);-1===a.innerHTML.indexOf("xmlns")&&
	m(x,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=x;this.boxWrapper=p;this.alignedObjects=[];this.url=(c||K)&&k.getElementsByTagName("base").length?R.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(k.createTextNode("Created with Highcharts 5.0.14"));this.defs=this.createElement("defs").add();this.allowHTML=e;this.forExport=q;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
	0;this.setSize(h,w,!1);var b;c&&a.getBoundingClientRect&&(h=function(){r(a,{left:0,top:0});b=a.getBoundingClientRect();r(a,{left:Math.ceil(b.left)-b.left+"px",top:Math.ceil(b.top)-b.top+"px"})},h(),this.unSubPixelFix=F(R,"resize",h))},getStyle:function(a){return this.style=e({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
	this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();d(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var h=new this.Element;h.init(this,a);return h},draw:z,getRadialAttr:function(a,h){return{cx:a[0]-a[2]/2+h.cx*a[2],cy:a[1]-a[2]/2+h.cy*a[2],r:h.r*a[2]}},getSpanWidth:function(a,h){var c=a.getBBox(!0).width;!H&&this.forExport&&(c=this.measureSpanWidth(h.firstChild.data,
	a.styles));return c},applyEllipsis:function(a,h,c,w){var x=a.rotation,p=c,q,e=0,b=c.length,d=function(a){h.removeChild(h.firstChild);a&&h.appendChild(k.createTextNode(a))},n;a.rotation=0;p=this.getSpanWidth(a,h);if(n=p>w){for(;e<=b;)q=Math.ceil((e+b)/2),p=c.substring(0,q)+"\u2026",d(p),p=this.getSpanWidth(a,h),e===b?e=b+1:p>w?b=q-1:e=q;0===b&&d("")}a.rotation=x;return n},buildText:function(a){var c=a.element,w=this,x=w.forExport,p=L(a.textStr,"").toString(),q=-1!==p.indexOf("\x3c"),e=c.childNodes,
	d,n,g,G,v=m(c,"x"),z=a.styles,f=a.textWidth,I=z&&z.lineHeight,B=z&&z.textOutline,D=z&&"ellipsis"===z.textOverflow,l=z&&"nowrap"===z.whiteSpace,P=z&&z.fontSize,t,J,u=e.length,z=f&&!a.added&&this.box,K=function(a){var x;x=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:P||w.style.fontSize||12;return I?h(I):w.fontMetrics(x,a.getAttribute("style")?a:c).h};t=[p,D,l,I,B,P,f].join();if(t!==a.textCache){for(a.textCache=t;u--;)c.removeChild(e[u]);q||B||D||f||-1!==p.indexOf(" ")?(d=/<.*class="([^"]+)".*>/,
	n=/<.*style="([^"]+)".*>/,g=/<.*href="([^"]+)".*>/,z&&z.appendChild(c),p=q?p.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[p],p=y(p,function(a){return""!==a}),b(p,function(h,p){var q,e=0;h=h.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");q=h.split("|||");b(q,function(h){if(""!==
	h||1===q.length){var b={},z=k.createElementNS(w.SVG_NS,"tspan"),y,I;d.test(h)&&(y=h.match(d)[1],m(z,"class",y));n.test(h)&&(I=h.match(n)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),m(z,"style",I));g.test(h)&&!x&&(m(z,"onclick",'location.href\x3d"'+h.match(g)[1]+'"'),r(z,{cursor:"pointer"}));h=(h.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==h){z.appendChild(k.createTextNode(h));e?b.dx=0:p&&null!==v&&(b.x=v);m(z,b);c.appendChild(z);!e&&J&&(!H&&x&&r(z,{display:"block"}),
	m(z,"dy",K(z)));if(f){b=h.replace(/([^\^])-/g,"$1- ").split(" ");y=1<q.length||p||1<b.length&&!l;var B=[],N,P=K(z),t=a.rotation;for(D&&(G=w.applyEllipsis(a,z,h,f));!D&&y&&(b.length||B.length);)a.rotation=0,N=w.getSpanWidth(a,z),h=N>f,void 0===G&&(G=h),h&&1!==b.length?(z.removeChild(z.firstChild),B.unshift(b.pop())):(b=B,B=[],b.length&&!l&&(z=k.createElementNS(O,"tspan"),m(z,{dy:P,x:v}),I&&m(z,"style",I),c.appendChild(z)),N>f&&(f=N)),b.length&&z.appendChild(k.createTextNode(b.join(" ").replace(/- /g,
	"-")));a.rotation=t}e++}}});J=J||c.childNodes.length}),G&&a.attr("title",a.textStr),z&&z.removeChild(c),B&&a.applyTextOutline&&a.applyTextOutline(B)):c.appendChild(k.createTextNode(p.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=l(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,h,c,w,q,b,d,n,g){var x=this.label(a,h,c,g,null,null,null,null,"button"),k=0;x.attr(p({padding:8,r:2},q));var z,H,v,f;q=p({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,
	style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},q);z=q.style;delete q.style;b=p(q,{fill:"#e6e6e6"},b);H=b.style;delete b.style;d=p(q,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},d);v=d.style;delete d.style;n=p(q,{style:{color:"#cccccc"}},n);f=n.style;delete n.style;F(x.element,G?"mouseover":"mouseenter",function(){3!==k&&x.setState(1)});F(x.element,G?"mouseout":"mouseleave",function(){3!==k&&x.setState(k)});x.setState=function(a){1!==a&&(x.state=k=a);x.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+
	["normal","hover","pressed","disabled"][a||0]);x.attr([q,b,d,n][a||0]).css([z,H,v,f][a||0])};x.attr(q).css(e({cursor:"default"},z));return x.on("click",function(a){3!==k&&w.call(x,a)})},crispLine:function(a,h){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-h%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+h%2/2);return a},path:function(a){var h={fill:"none"};J(a)?h.d=a:q(a)&&e(h,a);return this.createElement("path").attr(h)},circle:function(a,h,c){a=q(a)?a:{x:a,y:h,r:c};h=this.createElement("circle");h.xSetter=
	h.ySetter=function(a,h,c){c.setAttribute("c"+h,a)};return h.attr(a)},arc:function(a,h,c,w,p,b){q(a)?(w=a,h=w.y,c=w.r,a=w.x):w={innerR:w,start:p,end:b};a=this.symbol("arc",a,h,c,c,w);a.r=c;return a},rect:function(a,h,c,w,p,b){p=q(a)?a.r:p;var x=this.createElement("rect");a=q(a)?a:void 0===a?{}:{x:a,y:h,width:Math.max(c,0),height:Math.max(w,0)};void 0!==b&&(a.strokeWidth=b,a=x.crisp(a));a.fill="none";p&&(a.r=p);x.rSetter=function(a,h,c){m(c,{rx:a,ry:a})};return x.attr(a)},setSize:function(a,h,c){var w=
	this.alignedObjects,p=w.length;this.width=a;this.height=h;for(this.boxWrapper.animate({width:a,height:h},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:L(c,!0)?void 0:0});p--;)w[p].align()},g:function(a){var h=this.createElement("g");return a?h.attr({"class":"highcharts-"+a}):h},image:function(a,h,c,w,p){var x={preserveAspectRatio:"none"};1<arguments.length&&e(x,{x:h,y:c,width:w,height:p});x=this.createElement("image").attr(x);x.element.setAttributeNS?
	x.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):x.element.setAttribute("hc-svg-href",a);return x},symbol:function(a,h,c,w,p,q){var x=this,d,n=/^url\((.*?)\)$/,g=n.test(a),z=!g&&(this.symbols[a]?a:"circle"),G=z&&this.symbols[z],H=t(h)&&G&&G.call(this.symbols,Math.round(h),Math.round(c),w,p,q),v,y;G?(d=this.path(H),d.attr("fill","none"),e(d,{symbolName:z,x:h,y:c,width:w,height:p}),q&&e(d,q)):g&&(v=a.match(n)[1],d=this.image(v),d.imgwidth=L(Q[v]&&Q[v].width,q&&q.width),d.imgheight=
	L(Q[v]&&Q[v].height,q&&q.height),y=function(){d.attr({width:d.width,height:d.height})},b(["width","height"],function(a){d[a+"Setter"]=function(a,h){var c={},w=this["img"+h],p="width"===h?"translateX":"translateY";this[h]=a;t(w)&&(this.element&&this.element.setAttribute(h,w),this.alignByTranslate||(c[p]=((this[h]||0)-w)/2,this.attr(c)))}}),t(h)&&d.attr({x:h,y:c}),d.isImg=!0,t(d.imgwidth)&&t(d.imgheight)?y():(d.attr({width:0,height:0}),u("img",{onload:function(){var a=f[x.chartIndex];0===this.width&&
	(r(this,{position:"absolute",top:"-999em"}),k.body.appendChild(this));Q[v]={width:this.width,height:this.height};d.imgwidth=this.width;d.imgheight=this.height;d.element&&y();this.parentNode&&this.parentNode.removeChild(this);x.imgCount--;if(!x.imgCount&&a&&a.onload)a.onload()},src:v}),this.imgCount++));return d},symbols:{circle:function(a,h,c,w){return this.arc(a+c/2,h+w/2,c/2,w/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,h,c,w){return["M",a,h,"L",a+c,h,a+c,h+w,a,h+w,"Z"]},triangle:function(a,
	h,c,w){return["M",a+c/2,h,"L",a+c,h+w,a,h+w,"Z"]},"triangle-down":function(a,h,c,w){return["M",a,h,"L",a+c,h,a+c/2,h+w,"Z"]},diamond:function(a,h,c,w){return["M",a+c/2,h,"L",a+c,h+w/2,a+c/2,h+w,a,h+w/2,"Z"]},arc:function(a,h,c,w,p){var q=p.start,b=p.r||c,x=p.r||w||c,e=p.end-.001;c=p.innerR;w=L(p.open,.001>Math.abs(p.end-p.start-2*Math.PI));var d=Math.cos(q),n=Math.sin(q),g=Math.cos(e),e=Math.sin(e);p=.001>p.end-q-Math.PI?0:1;b=["M",a+b*d,h+x*n,"A",b,x,0,p,1,a+b*g,h+x*e];t(c)&&b.push(w?"M":"L",a+c*
	g,h+c*e,"A",c,c,0,p,0,a+c*d,h+c*n);b.push(w?"":"Z");return b},callout:function(a,h,c,w,p){var q=Math.min(p&&p.r||0,c,w),b=q+6,e=p&&p.anchorX;p=p&&p.anchorY;var d;d=["M",a+q,h,"L",a+c-q,h,"C",a+c,h,a+c,h,a+c,h+q,"L",a+c,h+w-q,"C",a+c,h+w,a+c,h+w,a+c-q,h+w,"L",a+q,h+w,"C",a,h+w,a,h+w,a,h+w-q,"L",a,h+q,"C",a,h,a,h,a+q,h];e&&e>c?p>h+b&&p<h+w-b?d.splice(13,3,"L",a+c,p-6,a+c+6,p,a+c,p+6,a+c,h+w-q):d.splice(13,3,"L",a+c,w/2,e,p,a+c,w/2,a+c,h+w-q):e&&0>e?p>h+b&&p<h+w-b?d.splice(33,3,"L",a,p+6,a-6,p,a,p-6,
	a,h+q):d.splice(33,3,"L",a,w/2,e,p,a,w/2,a,h+q):p&&p>w&&e>a+b&&e<a+c-b?d.splice(23,3,"L",e+6,h+w,e,h+w+6,e-6,h+w,a+q,h+w):p&&0>p&&e>a+b&&e<a+c-b&&d.splice(3,3,"L",e-6,h,e,h-6,e+6,h,c-q,h);return d}},clipRect:function(h,c,w,p){var q=a.uniqueKey(),b=this.createElement("clipPath").attr({id:q}).add(this.defs);h=this.rect(h,c,w,p,0).add(b);h.id=q;h.clipPath=b;h.count=0;return h},text:function(a,h,c,w){var p=!H&&this.forExport,q={};if(w&&(this.allowHTML||!this.forExport))return this.html(a,h,c);q.x=Math.round(h||
	0);c&&(q.y=Math.round(c));if(a||0===a)q.text=a;a=this.createElement("text").attr(q);p&&a.css({position:"absolute"});w||(a.xSetter=function(a,h,c){var w=c.getElementsByTagName("tspan"),p,q=c.getAttribute(h),b;for(b=0;b<w.length;b++)p=w[b],p.getAttribute(h)===q&&p.setAttribute(h,a);c.setAttribute(h,a)});return a},fontMetrics:function(a,c){a=a||c&&c.style&&c.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?h(a):/em/.test(a)?parseFloat(a)*(c?this.fontMetrics(null,c.parentNode).f:16):12;
	c=24>a?a+3:Math.round(1.2*a);return{h:c,b:Math.round(.8*c),f:a}},rotCorr:function(a,h,c){var w=a;h&&c&&(w=Math.max(w*Math.cos(h*g),4));return{x:-a/3*Math.sin(h*g),y:w}},label:function(h,c,q,d,n,g,k,z,G){var x=this,H=x.g("button"!==G&&"label"),v=H.text=x.text("",0,0,k).attr({zIndex:1}),f,y,I=0,B=3,D=0,r,l,P,m,J,O={},L,u,N=/^url\((.*?)\)$/.test(d),K=N,U,T,Q,R;G&&H.addClass("highcharts-"+G);K=N;U=function(){return(L||0)%2/2};T=function(){var a=v.element.style,h={};y=(void 0===r||void 0===l||J)&&t(v.textStr)&&
	v.getBBox();H.width=(r||y.width||0)+2*B+D;H.height=(l||y.height||0)+2*B;u=B+x.fontMetrics(a&&a.fontSize,v).b;K&&(f||(H.box=f=x.symbols[d]||N?x.symbol(d):x.rect(),f.addClass(("button"===G?"":"highcharts-label-box")+(G?" highcharts-"+G+"-box":"")),f.add(H),a=U(),h.x=a,h.y=(z?-u:0)+a),h.width=Math.round(H.width),h.height=Math.round(H.height),f.attr(e(h,O)),O={})};Q=function(){var a=D+B,h;h=z?0:u;t(r)&&y&&("center"===J||"right"===J)&&(a+={center:.5,right:1}[J]*(r-y.width));if(a!==v.x||h!==v.y)v.attr("x",
	a),void 0!==h&&v.attr("y",h);v.x=a;v.y=h};R=function(a,h){f?f.attr(a,h):O[a]=h};H.onAdd=function(){v.add(H);H.attr({text:h||0===h?h:"",x:c,y:q});f&&t(n)&&H.attr({anchorX:n,anchorY:g})};H.widthSetter=function(h){r=a.isNumber(h)?h:null};H.heightSetter=function(a){l=a};H["text-alignSetter"]=function(a){J=a};H.paddingSetter=function(a){t(a)&&a!==B&&(B=H.padding=a,Q())};H.paddingLeftSetter=function(a){t(a)&&a!==D&&(D=a,Q())};H.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==I&&(I=a,y&&H.attr({x:P}))};
	H.textSetter=function(a){void 0!==a&&v.textSetter(a);T();Q()};H["stroke-widthSetter"]=function(a,h){a&&(K=!0);L=this["stroke-width"]=a;R(h,a)};H.strokeSetter=H.fillSetter=H.rSetter=function(a,h){"r"!==h&&("fill"===h&&a&&(K=!0),H[h]=a);R(h,a)};H.anchorXSetter=function(a,h){n=H.anchorX=a;R(h,Math.round(a)-U()-P)};H.anchorYSetter=function(a,h){g=H.anchorY=a;R(h,a-m)};H.xSetter=function(a){H.x=a;I&&(a-=I*((r||y.width)+2*B));P=Math.round(a);H.attr("translateX",P)};H.ySetter=function(a){m=H.y=Math.round(a);
	H.attr("translateY",m)};var V=H.css;return e(H,{css:function(a){if(a){var h={};a=p(a);b(H.textProps,function(c){void 0!==a[c]&&(h[c]=a[c],delete a[c])});v.css(h)}return V.call(H,a)},getBBox:function(){return{width:y.width+2*B,height:y.height+2*B,x:y.x-B,y:y.y-B}},shadow:function(a){a&&(T(),f&&f.shadow(a));return H},destroy:function(){w(H.element,"mouseenter");w(H.element,"mouseleave");v&&(v=v.destroy());f&&(f=f.destroy());C.prototype.destroy.call(H);H=x=T=Q=R=null}})}});a.Renderer=A})(M);(function(a){var C=
	a.attr,A=a.createElement,F=a.css,E=a.defined,m=a.each,f=a.extend,l=a.isFirefox,r=a.isMS,u=a.isWebKit,t=a.pInt,g=a.SVGRenderer,d=a.win,k=a.wrap;f(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=f(this.styles,a);F(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position=
	"absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,e=this.element,d=this.translateX||0,g=this.translateY||0,n=this.x||0,k=this.y||0,f=this.textAlign||"left",c={left:0,center:.5,right:1}[f],G=this.styles;F(e,{marginLeft:d,marginTop:g});this.shadows&&m(this.shadows,function(a){F(a,{marginLeft:d+1,marginTop:g+1})});this.inverted&&m(e.childNodes,function(c){a.invertChild(c,e)});if("SPAN"===e.tagName){var q=
	this.rotation,B=t(this.textWidth),r=G&&G.whiteSpace,p=[q,f,e.innerHTML,this.textWidth,this.textAlign].join();p!==this.cTT&&(G=a.fontMetrics(e.style.fontSize).b,E(q)&&this.setSpanRotation(q,c,G),F(e,{width:"",whiteSpace:r||"nowrap"}),e.offsetWidth>B&&/[ \-]/.test(e.textContent||e.innerText)&&F(e,{width:B+"px",display:"block",whiteSpace:r||"normal"}),this.getSpanCorrection(e.offsetWidth,G,c,q,f));F(e,{left:n+(this.xCorr||0)+"px",top:k+(this.yCorr||0)+"px"});u&&(G=e.offsetHeight);this.cTT=p}}else this.alignOnAdd=
	!0},setSpanRotation:function(a,e,g){var b={},n=r?"-ms-transform":u?"-webkit-transform":l?"MozTransform":d.opera?"-o-transform":"";b[n]=b.transform="rotate("+a+"deg)";b[n+(l?"Origin":"-origin")]=b.transformOrigin=100*e+"% "+g+"px";F(this.element,b)},getSpanCorrection:function(a,e,d){this.xCorr=-a*d;this.yCorr=-e}});f(g.prototype,{html:function(a,e,d){var b=this.createElement("span"),n=b.element,g=b.renderer,v=g.isSVG,c=function(a,c){m(["opacity","visibility"],function(q){k(a,q+"Setter",function(a,
	p,q,b){a.call(this,p,q,b);c[q]=p})})};b.textSetter=function(a){a!==n.innerHTML&&delete this.bBox;n.innerHTML=this.textStr=a;b.htmlUpdateTransform()};v&&c(b,b.element.style);b.xSetter=b.ySetter=b.alignSetter=b.rotationSetter=function(a,c){"align"===c&&(c="textAlign");b[c]=a;b.htmlUpdateTransform()};b.attr({text:a,x:Math.round(e),y:Math.round(d)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});n.style.whiteSpace="nowrap";b.css=b.htmlCss;v&&(b.add=function(a){var q,
	e=g.box.parentNode,d=[];if(this.parentGroup=a){if(q=a.div,!q){for(;a;)d.push(a),a=a.parentGroup;m(d.reverse(),function(a){var p,n=C(a.element,"class");n&&(n={className:n});q=a.div=a.div||A("div",n,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},q||e);p=q.style;f(a,{classSetter:function(a){this.element.setAttribute("class",a);q.className=a},on:function(){d[0].div&&b.on.apply({element:d[0].div},
	arguments);return a},translateXSetter:function(c,h){p.left=c+"px";a[h]=c;a.doTransform=!0},translateYSetter:function(c,h){p.top=c+"px";a[h]=c;a.doTransform=!0}});c(a,p)})}}else q=e;q.appendChild(n);b.added=!0;b.alignOnAdd&&b.htmlUpdateTransform();return b});return b}})})(M);(function(a){var C,A,F=a.createElement,E=a.css,m=a.defined,f=a.deg2rad,l=a.discardElement,r=a.doc,u=a.each,t=a.erase,g=a.extend;C=a.extendClass;var d=a.isArray,k=a.isNumber,b=a.isObject,e=a.merge;A=a.noop;var v=a.pick,y=a.pInt,
	n=a.SVGElement,D=a.SVGRenderer,J=a.win;a.svg||(A={docMode8:r&&8===r.documentMode,init:function(a,b){var c=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],e=["position: ","absolute",";"],d="div"===b;("shape"===b||d)&&e.push("left:0;top:0;width:1px;height:1px;");e.push("visibility: ",d?"hidden":"visible");c.push(' style\x3d"',e.join(""),'"/\x3e');b&&(c=d||"span"===b||"img"===b?c.join(""):a.prepVML(c),this.element=F(c));this.renderer=a},add:function(a){var c=this.renderer,b=this.element,e=c.box,d=a&&a.inverted,
	e=a?a.element||a:e;a&&(this.parentGroup=a);d&&c.invertChild(b,e);e.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:n.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*f),q=Math.sin(a*f);E(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",b,", M12\x3d",-q,", M21\x3d",q,", M22\x3d",
	b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,q,e,d){var c=e?Math.cos(e*f):1,n=e?Math.sin(e*f):0,g=v(this.elemHeight,this.element.offsetHeight),k;this.xCorr=0>c&&-a;this.yCorr=0>n&&-g;k=0>c*n;this.xCorr+=n*b*(k?1-q:q);this.yCorr-=c*b*(e?k?q:1-q:1);d&&"left"!==d&&(this.xCorr-=a*q*(0>c?-1:1),e&&(this.yCorr-=g*q*(0>n?-1:1)),E(this.element,{textAlign:d}))},pathToVML:function(a){for(var c=a.length,b=[];c--;)k(a[c])?b[c]=Math.round(10*a[c])-5:"Z"===a[c]?b[c]="x":
	(b[c]=a[c],!a.isArc||"wa"!==a[c]&&"at"!==a[c]||(b[c+5]===b[c+7]&&(b[c+7]+=a[c+7]>a[c+5]?1:-1),b[c+6]===b[c+8]&&(b[c+8]+=a[c+8]>a[c+6]?1:-1)));return b.join(" ")||"x"},clip:function(a){var c=this,b;a?(b=a.members,t(b,c),b.push(c),c.destroyClip=function(){t(b,c)},a=a.getCSS(c)):(c.destroyClip&&c.destroyClip(),a={clip:c.docMode8?"inherit":"rect(auto)"});return c.css(a)},css:n.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&l(a)},destroy:function(){this.destroyClip&&this.destroyClip();return n.prototype.destroy.apply(this)},
	on:function(a,b){this.element["on"+a]=function(){var a=J.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var c;a=a.split(/[ ,]/);c=a.length;if(9===c||11===c)a[c-4]=a[c-2]=y(a[c-2])-10*b;return a.join(" ")},shadow:function(a,b,e){var c=[],q,p=this.element,d=this.renderer,n,g=p.style,h,w=p.path,k,H,f,D;w&&"string"!==typeof w.value&&(w="x");H=w;if(a){f=v(a.width,3);D=(a.opacity||.15)/f;for(q=1;3>=q;q++)k=2*f+1-2*q,e&&(H=this.cutOffPath(w.value,k+.5)),h=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',
	k,'" filled\x3d"false" path\x3d"',H,'" coordsize\x3d"10 10" style\x3d"',p.style.cssText,'" /\x3e'],n=F(d.prepVML(h),null,{left:y(g.left)+v(a.offsetX,1),top:y(g.top)+v(a.offsetY,1)}),e&&(n.cutOff=k+1),h=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',D*q,'"/\x3e'],F(d.prepVML(h),null,null,n),b?b.element.appendChild(n):p.parentNode.insertBefore(n,p),c.push(n);this.shadows=c}return this},updateShadows:A,setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},
	classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,e){(e.getElementsByTagName("stroke")[0]||F(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,e))[b]=a||"solid";this[b]=a},dSetter:function(a,b,e){var c=this.shadows;a=a||[];this.d=a.join&&a.join(" ");e.path=a=this.pathToVML(a);if(c)for(e=c.length;e--;)c[e].path=c[e].cutOff?this.cutOffPath(a,c[e].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,e){var c=e.nodeName;"SPAN"===c?e.style.color=a:"IMG"!==
	c&&(e.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,e,b,this)))},"fill-opacitySetter":function(a,b,e){F(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,e)},opacitySetter:A,rotationSetter:function(a,b,e){e=e.style;this[b]=e[b]=a;e.left=-Math.round(Math.sin(a*f)+1)+"px";e.top=Math.round(Math.cos(a*f))+"px"},strokeSetter:function(a,b,e){this.setAttr("strokecolor",this.renderer.color(a,e,b,this))},"stroke-widthSetter":function(a,b,e){e.stroked=!!a;
	this[b]=a;k(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,e){"inherit"===a&&(a="visible");this.shadows&&u(this.shadows,function(c){c.style[b]=a});"DIV"===e.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(e.style[b]=a?"visible":"hidden"),b="top");e.style[b]=a},xSetter:function(a,b,e){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):e.style[b]=a},zIndexSetter:function(a,
	b,e){e.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=C(n,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<J.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,e){var c,d;this.alignedObjects=[];c=this.createElement("div").css({position:"relative"});d=c.element;a.appendChild(c.element);this.isVML=!0;this.box=d;this.boxWrapper=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,
	e,!1);if(!r.namespaces.hcv){r.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{r.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(p){r.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,e,d,n){var c=this.createElement(),p=b(a);return g(c,{members:[],
	count:0,left:(p?a.x:a)+1,top:(p?a.y:e)+1,width:(p?a.width:d)-1,height:(p?a.height:n)-1,getCSS:function(a){var c=a.element,b=c.nodeName,h=a.inverted,w=this.top-("shape"===b?c.offsetTop:0),p=this.left,c=p+this.width,e=w+this.height,w={clip:"rect("+Math.round(h?p:w)+"px,"+Math.round(h?e:c)+"px,"+Math.round(h?c:e)+"px,"+Math.round(h?w:p)+"px)"};!h&&a.docMode8&&"DIV"===b&&g(w,{width:c+"px",height:e+"px"});return w},updateClipping:function(){u(c.members,function(a){a.element&&a.css(c.getCSS(a))})}})},color:function(c,
	b,e,d){var q=this,p,n=/^rgba/,g,k,h="none";c&&c.linearGradient?k="gradient":c&&c.radialGradient&&(k="pattern");if(k){var w,v,H=c.linearGradient||c.radialGradient,f,D,y,x,r,B="";c=c.stops;var l,G=[],m=function(){g=['\x3cfill colors\x3d"'+G.join(",")+'" opacity\x3d"',y,'" o:opacity2\x3d"',D,'" type\x3d"',k,'" ',B,'focus\x3d"100%" method\x3d"any" /\x3e'];F(q.prepVML(g),null,null,b)};f=c[0];l=c[c.length-1];0<f[0]&&c.unshift([0,f[1]]);1>l[0]&&c.push([1,l[1]]);u(c,function(h,c){n.test(h[1])?(p=a.color(h[1]),
	w=p.get("rgb"),v=p.get("a")):(w=h[1],v=1);G.push(100*h[0]+"% "+w);c?(y=v,x=w):(D=v,r=w)});if("fill"===e)if("gradient"===k)e=H.x1||H[0]||0,c=H.y1||H[1]||0,f=H.x2||H[2]||0,H=H.y2||H[3]||0,B='angle\x3d"'+(90-180*Math.atan((H-c)/(f-e))/Math.PI)+'"',m();else{var h=H.r,t=2*h,J=2*h,A=H.cx,C=H.cy,E=b.radialReference,M,h=function(){E&&(M=d.getBBox(),A+=(E[0]-M.x)/M.width-.5,C+=(E[1]-M.y)/M.height-.5,t*=E[2]/M.width,J*=E[2]/M.height);B='src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+t+","+
	J+'" origin\x3d"0.5,0.5" position\x3d"'+A+","+C+'" color2\x3d"'+r+'" ';m()};d.added?h():d.onAdd=h;h=x}else h=w}else n.test(c)&&"IMG"!==b.tagName?(p=a.color(c),d[e+"-opacitySetter"](p.get("a"),e,b),h=p.get("rgb")):(h=b.getElementsByTagName(e),h.length&&(h[0].opacity=1,h[0].type="solid"),h=c);return h},prepVML:function(a){var c=this.isIE8;a=a.join("");c?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):
	a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:D.prototype.html,path:function(a){var c={coordsize:"10 10"};d(a)?c.d=a:b(a)&&g(c,a);return this.createElement("shape").attr(c)},circle:function(a,e,d){var c=this.symbol("circle");b(a)&&(d=a.r,e=a.y,a=a.x);c.isCircle=!0;c.r=d;return c.attr({x:a,y:e})},g:function(a){var c;a&&(c={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(c)},
	image:function(a,b,e,d,n){var c=this.createElement("img").attr({src:a});1<arguments.length&&c.attr({x:b,y:e,width:d,height:n});return c},createElement:function(a){return"rect"===a?this.symbol(a):D.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this;b=b.style;var e="IMG"===a.tagName&&a.style;E(a,{flip:"x",left:y(b.width)-(e?y(e.top):1),top:y(b.height)-(e?y(e.left):1),rotation:-90});u(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,e,d,n){var c=n.start,
	q=n.end,g=n.r||e||d;e=n.innerR;d=Math.cos(c);var k=Math.sin(c),h=Math.cos(q),w=Math.sin(q);if(0===q-c)return["x"];c=["wa",a-g,b-g,a+g,b+g,a+g*d,b+g*k,a+g*h,b+g*w];n.open&&!e&&c.push("e","M",a,b);c.push("at",a-e,b-e,a+e,b+e,a+e*h,b+e*w,a+e*d,b+e*k,"x","e");c.isArc=!0;return c},circle:function(a,b,e,d,n){n&&m(n.r)&&(e=d=2*n.r);n&&n.isCircle&&(a-=e/2,b-=d/2);return["wa",a,b,a+e,b+d,a+e,b+d/2,a+e,b+d/2,"e"]},rect:function(a,b,e,d,n){return D.prototype.symbols[m(n)&&n.r?"callout":"square"].call(0,a,b,
	e,d,n)}}},a.VMLRenderer=C=function(){this.init.apply(this,arguments)},C.prototype=e(D.prototype,A),a.Renderer=C);D.prototype.measureSpanWidth=function(a,b){var c=r.createElement("span");a=r.createTextNode(a);c.appendChild(a);E(c,b);this.box.appendChild(c);b=c.offsetWidth;l(c);return b}})(M);(function(a){function C(){var f=a.defaultOptions.global,l=r.moment;if(f.timezone){if(l)return function(a){return-l.tz(a,f.timezone).utcOffset()};a.error(25)}return f.useUTC&&f.getTimezoneOffset}function A(){var f=
	a.defaultOptions.global,t,g=f.useUTC,d=g?"getUTC":"get",k=g?"setUTC":"set";a.Date=t=f.Date||r.Date;t.hcTimezoneOffset=g&&f.timezoneOffset;t.hcGetTimezoneOffset=C();t.hcMakeTime=function(a,e,d,k,n,f){var b;g?(b=t.UTC.apply(0,arguments),b+=m(b)):b=(new t(a,e,l(d,1),l(k,0),l(n,0),l(f,0))).getTime();return b};E("Minutes Hours Day Date Month FullYear".split(" "),function(a){t["hcGet"+a]=d+a});E("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),function(a){t["hcSet"+a]=k+a})}var F=a.color,
	E=a.each,m=a.getTZOffset,f=a.merge,l=a.pick,r=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
	decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.14/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
	align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},
	shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",
	day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:F("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",
	whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(r){a.defaultOptions=f(!0,a.defaultOptions,r);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(M);(function(a){var C=a.correctFloat,A=a.defined,F=a.destroyObjectProperties,E=a.isNumber,
	m=a.merge,f=a.pick,l=a.deg2rad;a.Tick=function(a,f,l,g){this.axis=a;this.pos=f;this.type=l||"";this.isNewLabel=this.isNew=!0;l||g||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,l=a.options,t=a.chart,g=a.categories,d=a.names,k=this.pos,b=l.labels,e=a.tickPositions,v=k===e[0],y=k===e[e.length-1],d=g?f(g[k],d[k],k):k,g=this.label,e=e.info,n;a.isDatetimeAxis&&e&&(n=l.dateTimeLabelFormats[e.higherRanks[k]||e.unitName]);this.isFirst=v;this.isLast=y;l=a.labelFormatter.call({axis:a,
	chart:t,isFirst:v,isLast:y,dateTimeLabelFormat:n,value:a.isLog?C(a.lin2log(d)):d,pos:k});A(g)?g&&g.attr({text:l}):(this.labelLength=(this.label=g=A(l)&&b.enabled?t.renderer.text(l,0,0,b.useHTML).css(m(b.style)).add(a.labelGroup):null)&&g.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var r=this.axis,m=a.x,g=r.chart.chartWidth,d=r.chart.spacing,k=f(r.labelLeft,Math.min(r.pos,d[3])),d=f(r.labelRight,
	Math.max(r.pos+r.len,g-d[1])),b=this.label,e=this.rotation,v={left:0,center:.5,right:1}[r.labelAlign],y=b.getBBox().width,n=r.getSlotWidth(),D=n,J=1,c,G={};if(e)0>e&&m-v*y<k?c=Math.round(m/Math.cos(e*l)-k):0<e&&m+v*y>d&&(c=Math.round((g-m)/Math.cos(e*l)));else if(g=m+(1-v)*y,m-v*y<k?D=a.x+D*(1-v)-k:g>d&&(D=d-a.x+D*v,J=-1),D=Math.min(n,D),D<n&&"center"===r.labelAlign&&(a.x+=J*(n-D-v*(n-Math.min(y,D)))),y>D||r.autoRotation&&(b.styles||{}).width)c=D;c&&(G.width=c,(r.options.labels.style||{}).textOverflow||
	(G.textOverflow="ellipsis"),b.css(G))},getPosition:function(a,f,l,g){var d=this.axis,k=d.chart,b=g&&k.oldChartHeight||k.chartHeight;return{x:a?d.translate(f+l,null,null,g)+d.transB:d.left+d.offset+(d.opposite?(g&&k.oldChartWidth||k.chartWidth)-d.right-d.left:0),y:a?b-d.bottom+d.offset-(d.opposite?d.height:0):b-d.translate(f+l,null,null,g)-d.transB}},getLabelPosition:function(a,f,m,g,d,k,b,e){var v=this.axis,y=v.transA,n=v.reversed,D=v.staggerLines,r=v.tickRotCorr||{x:0,y:0},c=d.y;A(c)||(c=0===v.side?
	m.rotation?-8:-m.getBBox().height:2===v.side?r.y+8:Math.cos(m.rotation*l)*(r.y-m.getBBox(!1,0).height/2));a=a+d.x+r.x-(k&&g?k*y*(n?-1:1):0);f=f+c-(k&&!g?k*y*(n?1:-1):0);D&&(m=b/(e||1)%D,v.opposite&&(m=D-m-1),f+=v.labelOffset/D*m);return{x:a,y:Math.round(f)}},getMarkPath:function(a,f,l,g,d,k){return k.crispLine(["M",a,f,"L",a+(d?0:-l),f+(d?l:0)],g)},renderGridLine:function(a,f,l){var g=this.axis,d=g.options,k=this.gridLine,b={},e=this.pos,v=this.type,y=g.tickmarkOffset,n=g.chart.renderer,D=v?v+"Grid":
	"grid",r=d[D+"LineWidth"],c=d[D+"LineColor"],d=d[D+"LineDashStyle"];k||(b.stroke=c,b["stroke-width"]=r,d&&(b.dashstyle=d),v||(b.zIndex=1),a&&(b.opacity=0),this.gridLine=k=n.path().attr(b).addClass("highcharts-"+(v?v+"-":"")+"grid-line").add(g.gridGroup));if(!a&&k&&(a=g.getPlotLinePath(e+y,k.strokeWidth()*l,a,!0)))k[this.isNew?"attr":"animate"]({d:a,opacity:f})},renderMark:function(a,l,m){var g=this.axis,d=g.options,k=g.chart.renderer,b=this.type,e=b?b+"Tick":"tick",v=g.tickSize(e),y=this.mark,n=!y,
	D=a.x;a=a.y;var r=f(d[e+"Width"],!b&&g.isXAxis?1:0),d=d[e+"Color"];v&&(g.opposite&&(v[0]=-v[0]),n&&(this.mark=y=k.path().addClass("highcharts-"+(b?b+"-":"")+"tick").add(g.axisGroup),y.attr({stroke:d,"stroke-width":r})),y[n?"attr":"animate"]({d:this.getMarkPath(D,a,v[0],y.strokeWidth()*m,g.horiz,k),opacity:l}))},renderLabel:function(a,l,m,g){var d=this.axis,k=d.horiz,b=d.options,e=this.label,v=b.labels,y=v.step,n=d.tickmarkOffset,D=!0,r=a.x;a=a.y;e&&E(r)&&(e.xy=a=this.getLabelPosition(r,a,e,k,v,n,
	g,y),this.isFirst&&!this.isLast&&!f(b.showFirstLabel,1)||this.isLast&&!this.isFirst&&!f(b.showLastLabel,1)?D=!1:!k||d.isRadial||v.step||v.rotation||l||0===m||this.handleOverflow(a),y&&g%y&&(D=!1),D&&E(a.y)?(a.opacity=m,e[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(e.attr("y",-9999),this.isNewLabel=!0),this.isNew=!1)},render:function(a,l,m){var g=this.axis,d=g.horiz,k=this.getPosition(d,this.pos,g.tickmarkOffset,l),b=k.x,e=k.y,g=d&&b===g.pos+g.len||!d&&e===g.pos?-1:1;m=f(m,1);this.isActive=
	!0;this.renderGridLine(l,m,g);this.renderMark(k,m,g);this.renderLabel(k,l,m,a)},destroy:function(){F(this,this.axis)}}})(M);var S=function(a){var C=a.addEvent,A=a.animObject,F=a.arrayMax,E=a.arrayMin,m=a.color,f=a.correctFloat,l=a.defaultOptions,r=a.defined,u=a.deg2rad,t=a.destroyObjectProperties,g=a.each,d=a.extend,k=a.fireEvent,b=a.format,e=a.getMagnitude,v=a.grep,y=a.inArray,n=a.isArray,D=a.isNumber,J=a.isString,c=a.merge,G=a.normalizeTickInterval,q=a.objectEach,B=a.pick,K=a.removeEvent,p=a.splat,
	z=a.syncTimeout,I=a.Tick,L=function(){this.init.apply(this,arguments)};a.extend(L.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,
	tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},
	style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,c){var h=c.isX,b=this;b.chart=a;b.horiz=a.inverted&&!b.isZAxis?!h:h;b.isXAxis=h;b.coll=b.coll||(h?
	"xAxis":"yAxis");b.opposite=c.opposite;b.side=c.side||(b.horiz?b.opposite?0:2:b.opposite?1:3);b.setOptions(c);var w=this.options,e=w.type;b.labelFormatter=w.labels.formatter||b.defaultLabelFormatter;b.userOptions=c;b.minPixelPadding=0;b.reversed=w.reversed;b.visible=!1!==w.visible;b.zoomEnabled=!1!==w.zoomEnabled;b.hasNames="category"===e||!0===w.categories;b.categories=w.categories||b.hasNames;b.names=b.names||[];b.plotLinesAndBandsGroups={};b.isLog="logarithmic"===e;b.isDatetimeAxis="datetime"===
	e;b.positiveValuesOnly=b.isLog&&!b.allowNegativeLog;b.isLinked=r(w.linkedTo);b.ticks={};b.labelEdge=[];b.minorTicks={};b.plotLinesAndBands=[];b.alternateBands={};b.len=0;b.minRange=b.userMinRange=w.minRange||w.maxZoom;b.range=w.range;b.offset=w.offset||0;b.stacks={};b.oldStacks={};b.stacksTouched=0;b.max=null;b.min=null;b.crosshair=B(w.crosshair,p(a.options.tooltip.crosshairs)[h?0:1],!1);c=b.options.events;-1===y(b,a.axes)&&(h?a.axes.splice(a.xAxis.length,0,b):a.axes.push(b),a[b.coll].push(b));b.series=
	b.series||[];a.inverted&&!b.isZAxis&&h&&void 0===b.reversed&&(b.reversed=!0);q(c,function(a,h){C(b,h,a)});b.lin2log=w.linearToLogConverter||b.lin2log;b.isLog&&(b.val2lin=b.log2lin,b.lin2val=b.lin2log)},setOptions:function(a){this.options=c(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],c(l[this.coll],a))},defaultLabelFormatter:function(){var h=this.axis,
	c=this.value,e=h.categories,p=this.dateTimeLabelFormat,d=l.lang,n=d.numericSymbols,d=d.numericSymbolMagnitude||1E3,q=n&&n.length,x,g=h.options.labels.format,h=h.isLog?Math.abs(c):h.tickInterval;if(g)x=b(g,this);else if(e)x=c;else if(p)x=a.dateFormat(p,c);else if(q&&1E3<=h)for(;q--&&void 0===x;)e=Math.pow(d,q+1),h>=e&&0===10*c%e&&null!==n[q]&&0!==c&&(x=a.numberFormat(c/e,-1)+n[q]);void 0===x&&(x=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return x},getSeriesExtremes:function(){var a=
	this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();g(a.series,function(h){if(h.visible||!b.options.chart.ignoreHiddenSeries){var c=h.options,w=c.threshold,e;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=w&&(w=null);if(a.isXAxis)c=h.xData,c.length&&(h=E(c),D(h)||h instanceof Date||(c=v(c,function(a){return D(a)}),h=E(c)),a.dataMin=Math.min(B(a.dataMin,c[0]),h),a.dataMax=Math.max(B(a.dataMax,c[0]),F(c)));else if(h.getExtremes(),
	e=h.dataMax,h=h.dataMin,r(h)&&r(e)&&(a.dataMin=Math.min(B(a.dataMin,h),h),a.dataMax=Math.max(B(a.dataMax,e),e)),r(w)&&(a.threshold=w),!c.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,c,e,p,d){var h=this.linkedParent||this,w=1,n=0,q=e?h.oldTransA:h.transA;e=e?h.oldMin:h.min;var g=h.minPixelPadding;p=(h.isOrdinal||h.isBroken||h.isLog&&p)&&h.lin2val;q||(q=h.transA);c&&(w*=-1,n=h.len);h.reversed&&(w*=-1,n-=w*(h.sector||h.len));b?(a=(a*w+n-g)/q+e,p&&(a=h.lin2val(a))):
	(p&&(a=h.val2lin(a)),a=w*(a-e)*q+n+w*g+(D(d)?q*d:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,e,p){var h=this.chart,w=this.left,d=this.top,n,q,g=c&&h.oldChartHeight||h.chartHeight,k=c&&h.oldChartWidth||h.chartWidth,f;n=this.transB;var v=function(a,h,b){if(a<h||a>b)e?a=Math.min(Math.max(h,a),b):f=!0;return a};p=B(p,this.translate(a,
	null,null,c));a=c=Math.round(p+n);n=q=Math.round(g-p-n);D(p)?this.horiz?(n=d,q=g-this.bottom,a=c=v(a,w,w+this.width)):(a=w,c=k-this.right,n=q=v(n,d,d+this.height)):f=!0;return f&&!e?null:h.renderer.crispLine(["M",a,n,"L",c,q],b||1)},getLinearTickPositions:function(a,b,c){var h,w=f(Math.floor(b/a)*a);c=f(Math.ceil(c/a)*a);var e=[];if(this.single)return[b];for(b=w;b<=c;){e.push(b);b=f(b+a);if(b===h)break;h=b}return e},getMinorTickPositions:function(){var a=this,b=a.options,c=a.tickPositions,e=a.minorTickInterval,
	p=[],d=a.pointRangePadding||0,n=a.min-d,d=a.max+d,q=d-n;if(q&&q/e<a.len/3)if(a.isLog)g(this.paddedTicks,function(h,b,c){b&&p.push.apply(p,a.getLogTickPositions(e,c[b-1],c[b],!0))});else if(a.isDatetimeAxis&&"auto"===b.minorTickInterval)p=p.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),n,d,b.startOfWeek));else for(b=n+(c[0]-n)%e;b<=d&&b!==p[0];b+=e)p.push(b);0!==p.length&&a.trimTicks(p);return p},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,e,p,d,n,q,k,f,v;this.isXAxis&&
	void 0===this.minRange&&!this.isLog&&(r(a.min)||r(a.max)?this.minRange=null:(g(this.series,function(a){k=a.xData;for(n=f=a.xIncrement?1:k.length-1;0<n;n--)if(q=k[n]-k[n-1],void 0===d||q<d)d=q}),this.minRange=Math.min(5*d,this.dataMax-this.dataMin)));c-b<this.minRange&&(p=this.dataMax-this.dataMin>=this.minRange,v=this.minRange,e=(v-c+b)/2,e=[b-e,B(a.min,b-e)],p&&(e[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=F(e),c=[b+v,B(a.max,b+v)],p&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),
	c=E(c),c-b<v&&(e[0]=c-v,e[1]=B(a.min,c-v),b=F(e)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:g(this.series,function(h){var b=h.closestPointRange,c=h.visible||!h.chart.options.chart.ignoreHiddenSeries;!h.noSharedTooltip&&r(b)&&c&&(a=r(a)?Math.min(a,b):b)});return a},nameToX:function(a){var h=n(this.categories),b=h?this.categories:this.names,c=a.options.x,e;a.series.requireSorting=!1;r(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():y(a.name,b));-1===c?h||
	(e=b.length):e=c;void 0!==e&&(this.names[e]=a.name);return e},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=this.userMinRange,g(this.series||[],function(h){h.xIncrement=null;if(!h.points||h.isDirtyData)h.processData(),h.generatePoints();g(h.points,function(b,c){var e;b.options&&(e=a.nameToX(b),void 0!==e&&e!==b.x&&(b.x=e,h.xData[c]=e))})}))},setAxisTranslation:function(a){var h=this,b=h.max-h.min,c=h.axisPointRange||0,e,p=0,d=0,n=h.linkedParent,q=!!h.categories,
	k=h.transA,f=h.isXAxis;if(f||q||c)e=h.getClosest(),n?(p=n.minPointOffset,d=n.pointRangePadding):g(h.series,function(a){var b=q?1:f?B(a.options.pointRange,e,0):h.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,b);h.single||(p=Math.max(p,J(a)?0:b/2),d=Math.max(d,"on"===a?0:b))}),n=h.ordinalSlope&&e?h.ordinalSlope/e:1,h.minPointOffset=p*=n,h.pointRangePadding=d*=n,h.pointRange=Math.min(c,b),f&&(h.closestPointRange=e);a&&(h.oldTransA=k);h.translationSlope=h.transA=k=h.options.staticScale||h.len/
	(b+d||1);h.transB=h.horiz?h.left:h.bottom;h.minPixelPadding=k*p},minFromRange:function(){return this.max-this.range},setTickInterval:function(h){var b=this,c=b.chart,p=b.options,d=b.isLog,n=b.log2lin,q=b.isDatetimeAxis,x=b.isXAxis,v=b.isLinked,z=p.maxPadding,y=p.minPadding,l=p.tickInterval,I=p.tickPixelInterval,m=b.categories,J=b.threshold,t=b.softThreshold,L,u,K,A;q||m||v||this.getTickAmount();K=B(b.userMin,p.min);A=B(b.userMax,p.max);v?(b.linkedParent=c[b.coll][p.linkedTo],c=b.linkedParent.getExtremes(),
	b.min=B(c.min,c.dataMin),b.max=B(c.max,c.dataMax),p.type!==b.linkedParent.options.type&&a.error(11,1)):(!t&&r(J)&&(b.dataMin>=J?(L=J,y=0):b.dataMax<=J&&(u=J,z=0)),b.min=B(K,L,b.dataMin),b.max=B(A,u,b.dataMax));d&&(b.positiveValuesOnly&&!h&&0>=Math.min(b.min,B(b.dataMin,b.min))&&a.error(10,1),b.min=f(n(b.min),15),b.max=f(n(b.max),15));b.range&&r(b.max)&&(b.userMin=b.min=K=Math.max(b.dataMin,b.minFromRange()),b.userMax=A=b.max,b.range=null);k(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();
	!(m||b.axisPointRange||b.usePercentage||v)&&r(b.min)&&r(b.max)&&(n=b.max-b.min)&&(!r(K)&&y&&(b.min-=n*y),!r(A)&&z&&(b.max+=n*z));D(p.softMin)&&(b.min=Math.min(b.min,p.softMin));D(p.softMax)&&(b.max=Math.max(b.max,p.softMax));D(p.floor)&&(b.min=Math.max(b.min,p.floor));D(p.ceiling)&&(b.max=Math.min(b.max,p.ceiling));t&&r(b.dataMin)&&(J=J||0,!r(K)&&b.min<J&&b.dataMin>=J?b.min=J:!r(A)&&b.max>J&&b.dataMax<=J&&(b.max=J));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:v&&!l&&I===b.linkedParent.options.tickPixelInterval?
	l=b.linkedParent.tickInterval:B(l,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,m?1:(b.max-b.min)*I/Math.max(b.len,I));x&&!h&&g(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!l&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));h=B(p.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);
	!l&&b.tickInterval<h&&(b.tickInterval=h);q||d||l||(b.tickInterval=G(b.tickInterval,null,e(b.tickInterval),B(p.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,e=a.tickPositioner,p=a.startOnTick,d=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval=
	"auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.single=this.min===this.max&&r(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,
	this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=b=e);this.paddedTicks=b.slice(0);this.trimTicks(b,p,d);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),c||e||this.adjustTickAmount())},trimTicks:function(a,b,c){var h=a[0],e=a[a.length-1],p=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==h)this.min=h;else for(;this.min-p>a[0];)a.shift();if(c)this.max=e;else for(;this.max+p<a[a.length-
	1];)a.pop();0===a.length&&r(h)&&a.push((e+h)/2)}},alignToOthers:function(){var a={},b,c=this.options;!1===this.chart.options.chart.alignTicks||!1===c.alignTicks||this.isLog||g(this.chart[this.coll],function(h){var c=h.options,c=[h.horiz?c.left:c.top,c.width,c.height,c.pane].join();h.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!r(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=
	2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,p=b&&b.length;if(p<c){for(;b.length<c;)b.push(f(b[b.length-1]+a));this.transA*=(p-1)/(c-1);this.max=b[b.length-1]}else p>c&&(this.tickInterval*=2,this.setTickPositions());if(r(e)){for(a=c=b.length;a--;)(3===e&&1===a%2||2>=e&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,
	b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;g(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||
	(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,e,p){var h=this,n=h.chart;c=B(c,!0);g(h.series,function(a){delete a.kdTree});p=d(p,{min:a,max:b});k(h,"setExtremes",p,function(){h.userMin=a;h.userMax=b;h.eventArgs=p;c&&n.redraw(e)})},zoom:function(a,b){var h=this.dataMin,c=this.dataMax,e=this.options,p=Math.min(h,B(e.min,h)),e=Math.max(c,B(e.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(r(h)&&(a<p&&(a=
	p),a>e&&(a=e)),r(c)&&(b<p&&(b=p),b>e&&(b=e))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,c=this.options,e=c.offsets||[0,0,0,0],p=this.horiz,d=this.width=Math.round(a.relativeLength(B(c.width,b.plotWidth-e[3]+e[1]),b.plotWidth)),n=this.height=Math.round(a.relativeLength(B(c.height,b.plotHeight-e[0]+e[2]),b.plotHeight)),q=this.top=Math.round(a.relativeLength(B(c.top,b.plotTop+e[0]),b.plotHeight,b.plotTop)),
	c=this.left=Math.round(a.relativeLength(B(c.left,b.plotLeft+e[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-n-q;this.right=b.chartWidth-d-c;this.len=Math.max(p?d:n,0);this.pos=p?c:q},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?f(b(this.min)):this.min,max:a?f(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,h=this.lin2log,c=b?h(this.min):this.min,b=b?h(this.max):this.max;
	null===a?a=c:c>a?a=c:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(B(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,h=b[a+"Length"],c=B(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&h)return"inside"===b[a+"Position"]&&(h=-h),[h,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,
	this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,e=c,p=this.len/(((this.categories?1:0)+this.max-this.min)/c),d,n=a.rotation,q=this.labelMetrics(),k,f=Number.MAX_VALUE,v,z=function(a){a/=p||1;a=1<a?Math.ceil(a):1;return a*c};b?(v=!a.staggerLines&&!a.step&&(r(n)?[n]:p<B(a.autoRotationLimit,80)&&a.autoRotation))&&g(v,function(a){var b;if(a===n||a&&-90<=a&&90>=a)k=z(Math.abs(q.h/Math.sin(u*a))),b=k+Math.abs(a/360),b<f&&(f=b,d=a,e=k)}):
	a.step||(e=z(q.h));this.autoRotation=v;this.labelRotation=B(d,n);return e},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,e=Math.max(this.tickPositions.length-(this.categories?0:1),1),p=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/e||!b&&(p&&p-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,e=this.tickPositions,p=this.ticks,d=this.options.labels,n=this.horiz,q=this.getSlotWidth(),k=Math.max(1,
	Math.round(q-2*(d.padding||5))),f={},v=this.labelMetrics(),z=d.style&&d.style.textOverflow,D,y=0,l,I;J(d.rotation)||(f.rotation=d.rotation||0);g(e,function(a){(a=p[a])&&a.labelLength>y&&(y=a.labelLength)});this.maxLabelLength=y;if(this.autoRotation)y>k&&y>v.h?f.rotation=this.labelRotation:this.labelRotation=0;else if(q&&(D={width:k+"px"},!z))for(D.textOverflow="clip",l=e.length;!n&&l--;)if(I=e[l],k=p[I].label)k.styles&&"ellipsis"===k.styles.textOverflow?k.css({textOverflow:"clip"}):p[I].labelLength>
	q&&k.css({width:q+"px"}),k.getBBox().height>this.len/e.length-(v.h-v.f)&&(k.specCss={textOverflow:"ellipsis"});f.rotation&&(D={width:(y>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},z||(D.textOverflow="ellipsis"));if(this.labelAlign=d.align||this.autoLabelAlign(this.labelRotation))f.align=this.labelAlign;g(e,function(a){var b=(a=p[a])&&a.label;b&&(b.attr(f),D&&b.css(c(D,b.specCss)),delete b.specCss,a.rotation=f.rotation)});this.tickRotCorr=b.rotCorr(v.b,this.labelRotation||0,0!==this.side)},
	hasData:function(){return this.hasVisibleSeries||r(this.min)&&r(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,c=this.horiz,h=this.opposite,e=this.options.title,p;this.axisTitle||((p=e.textAlign)||(p=(c?{low:"left",middle:"center",high:"right"}:{low:h?"right":"left",middle:"center",high:h?"left":"right"})[e.align]),this.axisTitle=b.text(e.text,0,0,e.useHTML).attr({zIndex:7,rotation:e.rotation||0,align:p}).addClass("highcharts-axis-title").css(e.style).add(this.axisGroup),
	this.axisTitle.isNew=!0);e.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new I(this,a)},getOffset:function(){var a=this,b=a.chart,c=b.renderer,e=a.options,p=a.tickPositions,d=a.ticks,n=a.horiz,k=a.side,f=b.inverted&&!a.isZAxis?[1,0,3,2][k]:k,v,z,D=0,y,l=0,I=e.title,m=e.labels,G=0,J=b.axisOffset,b=b.clipOffset,t=[-1,1,1,-1][k],L=e.className,u=a.axisParent,K=this.tickSize("tick");
	v=a.hasData();a.showAxis=z=v||B(e.showEmpty,!0);a.staggerLines=a.horiz&&m.staggerLines;a.axisGroup||(a.gridGroup=c.g("grid").attr({zIndex:e.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(L||"")).add(u),a.axisGroup=c.g("axis").attr({zIndex:e.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(L||"")).add(u),a.labelGroup=c.g("axis-labels").attr({zIndex:m.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(L||"")).add(u));v||a.isLinked?(g(p,function(b,
	c){a.generateTick(b,c)}),a.renderUnsquish(),!1===m.reserveSpace||0!==k&&2!==k&&{1:"left",3:"right"}[k]!==a.labelAlign&&"center"!==a.labelAlign||g(p,function(a){G=Math.max(d[a].getLabelSize(),G)}),a.staggerLines&&(G*=a.staggerLines,a.labelOffset=G*(a.opposite?-1:1))):q(d,function(a,b){a.destroy();delete d[b]});I&&I.text&&!1!==I.enabled&&(a.addTitle(z),z&&!1!==I.reserveSpace&&(a.titleOffset=D=a.axisTitle.getBBox()[n?"height":"width"],y=I.offset,l=r(y)?0:B(I.margin,n?5:10)));a.renderLine();a.offset=
	t*B(e.offset,J[k]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=0===k?-a.labelMetrics().h:2===k?a.tickRotCorr.y:0;l=Math.abs(G)+l;G&&(l=l-c+t*(n?B(m.y,a.tickRotCorr.y+8*t):m.x));a.axisTitleMargin=B(y,l);J[k]=Math.max(J[k],a.axisTitleMargin+D+t*a.offset,l,v&&p.length&&K?K[0]+t*a.offset:0);p=2*Math.floor(a.axisLine.strokeWidth()/2);0<e.offset&&(p-=2*e.offset);b[f]=Math.max(b[f]||p,p)},getLinePath:function(a){var b=this.chart,c=this.opposite,h=this.offset,e=this.horiz,p=this.left+(c?this.width:0)+h,h=b.chartHeight-
	this.bottom-(c?this.height:0)+h;c&&(a*=-1);return b.renderer.crispLine(["M",e?this.left:p,e?h:this.top,"L",e?b.chartWidth-this.right:p,e?h:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,e=this.len,p=this.options.title,
	d=a?b:c,n=this.opposite,q=this.offset,k=p.x||0,g=p.y||0,f=this.axisTitle,v=this.chart.renderer.fontMetrics(p.style&&p.style.fontSize,f),f=Math.max(f.getBBox(null,0).height-v.h-1,0),e={low:d+(a?0:e),middle:d+e/2,high:d+(a?e:0)}[p.align],b=(a?c+this.height:b)+(a?1:-1)*(n?-1:1)*this.axisTitleMargin+[-f,f,v.f,-f][this.side];return{x:a?e+k:b+(n?this.width:0)+q+k,y:a?b+g-(n?this.height:0)+q:e+g}},renderMinorTick:function(a){var b=this.chart.hasRendered&&D(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new I(this,
	a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,e=this.ticks,h=this.chart.hasRendered&&D(this.oldMin);if(!c||a>=this.min&&a<=this.max)e[a]||(e[a]=new I(this,a)),h&&e[a].isNew&&e[a].render(b,!0,.1),e[a].render(b)},render:function(){var b=this,c=b.chart,e=b.options,p=b.isLog,d=b.lin2log,n=b.isLinked,k=b.tickPositions,f=b.axisTitle,v=b.ticks,y=b.minorTicks,l=b.alternateBands,m=e.stackLabels,r=e.alternateGridColor,B=b.tickmarkOffset,
	G=b.axisLine,J=b.showAxis,t=A(c.renderer.globalAnimation),L,u;b.labelEdge.length=0;b.overlap=!1;g([v,y,l],function(a){q(a,function(a){a.isActive=!1})});if(b.hasData()||n)b.minorTickInterval&&!b.categories&&g(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),k.length&&(g(k,function(a,c){b.renderTick(a,c)}),B&&(0===b.min||b.single)&&(v[-1]||(v[-1]=new I(b,-1,null,!0)),v[-1].render(-1))),r&&g(k,function(e,h){u=void 0!==k[h+1]?k[h+1]+B:b.max-B;0===h%2&&e<b.max&&u<=b.max+(c.polar?-B:B)&&(l[e]||
	(l[e]=new a.PlotLineOrBand(b)),L=e+B,l[e].options={from:p?d(L):L,to:p?d(u):u,color:r},l[e].render(),l[e].isActive=!0)}),b._addedPlotLB||(g((e.plotLines||[]).concat(e.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);g([v,y,l],function(a){var b,e=[],h=t.duration;q(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,e.push(b))});z(function(){for(b=e.length;b--;)a[e[b]]&&!a[e[b]].isActive&&(a[e[b]].destroy(),delete a[e[b]])},a!==l&&c.hasRendered&&h?h:0)});G&&(G[G.isPlaced?
	"animate":"attr"]({d:this.getLinePath(G.strokeWidth())}),G.isPlaced=!0,G[J?"show":"hide"](!0));f&&J&&(e=b.getTitlePosition(),D(e.y)?(f[f.isNew?"attr":"animate"](e),f.isNew=!1):(f.attr("y",-9999),f.isNew=!0));m&&m.enabled&&b.renderStackTotals();b.isDirty=!1},redraw:function(){this.visible&&(this.render(),g(this.plotLinesAndBands,function(a){a.render()}));g(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,c=b.stacks,
	e=b.plotLinesAndBands,h;a||K(b);q(c,function(a,b){t(a);c[b]=null});g([b.ticks,b.minorTicks,b.alternateBands],function(a){t(a)});if(e)for(a=e.length;a--;)e[a].destroy();g("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(h in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[h]=b.plotLinesAndBandsGroups[h].destroy();q(b,function(a,c){-1===y(c,b.keepProps)&&delete b[c]})},drawCrosshair:function(a,b){var c,e=this.crosshair,
	h=B(e.snap,!0),p,d=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(r(b)||!h)?(h?r(b)&&(p=this.isXAxis?b.plotX:this.len-b.plotY):p=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),r(p)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:B(b.stackY,b.y)),null,null,null,p)||null),r(c)?(b=this.categories&&!this.isRadial,d||(this.cross=d=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+e.className).attr({zIndex:B(e.zIndex,2)}).add(),
	d.attr({stroke:e.color||(b?m("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":B(e.width,1)}),e.dashStyle&&d.attr({dashstyle:e.dashStyle})),d.show().attr({d:c}),b&&!e.width&&d.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=L}(M);(function(a){var C=a.Axis,A=a.Date,F=a.dateFormat,E=a.defaultOptions,m=a.defined,f=a.each,l=a.extend,r=a.getMagnitude,u=a.getTZOffset,t=a.normalizeTickInterval,
	g=a.pick,d=a.timeUnits;C.prototype.getTimeTicks=function(a,b,e,v){var k=[],n={},D=E.global.useUTC,r,c=new A(b-Math.max(u(b),u(e))),G=A.hcMakeTime,q=a.unitRange,B=a.count,t,p;if(m(b)){c[A.hcSetMilliseconds](q>=d.second?0:B*Math.floor(c.getMilliseconds()/B));if(q>=d.second)c[A.hcSetSeconds](q>=d.minute?0:B*Math.floor(c.getSeconds()/B));if(q>=d.minute)c[A.hcSetMinutes](q>=d.hour?0:B*Math.floor(c[A.hcGetMinutes]()/B));if(q>=d.hour)c[A.hcSetHours](q>=d.day?0:B*Math.floor(c[A.hcGetHours]()/B));if(q>=d.day)c[A.hcSetDate](q>=
	d.month?1:B*Math.floor(c[A.hcGetDate]()/B));q>=d.month&&(c[A.hcSetMonth](q>=d.year?0:B*Math.floor(c[A.hcGetMonth]()/B)),r=c[A.hcGetFullYear]());if(q>=d.year)c[A.hcSetFullYear](r-r%B);if(q===d.week)c[A.hcSetDate](c[A.hcGetDate]()-c[A.hcGetDay]()+g(v,1));r=c[A.hcGetFullYear]();v=c[A.hcGetMonth]();var z=c[A.hcGetDate](),I=c[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)p=(!D||!!A.hcGetTimezoneOffset)&&(e-b>4*d.month||u(b)!==u(e)),c=c.getTime(),t=u(c),c=new A(c+t);D=c.getTime();for(b=1;D<
	e;)k.push(D),D=q===d.year?G(r+b*B,0):q===d.month?G(r,v+b*B):!p||q!==d.day&&q!==d.week?p&&q===d.hour?G(r,v,z,I+b*B,0,0,t)-t:D+q*B:G(r,v,z+b*B*(q===d.day?1:7)),b++;k.push(D);q<=d.hour&&1E4>k.length&&f(k,function(a){0===a%18E5&&"000000000"===F("%H%M%S%L",a)&&(n[a]="day")})}k.info=l(a,{higherRanks:n,totalRange:q*B});return k};C.prototype.normalizeTimeTickInterval=function(a,b){var e=b||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,
	2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];b=e[e.length-1];var k=d[b[0]],g=b[1],n;for(n=0;n<e.length&&!(b=e[n],k=d[b[0]],g=b[1],e[n+1]&&a<=(k*g[g.length-1]+d[e[n+1][0]])/2);n++);k===d.year&&a<5*k&&(g=[1,2,5]);a=t(a/k,g,"year"===b[0]?Math.max(r(a/k),1):1);return{unitRange:k,count:a,unitName:b[0]}}})(M);(function(a){var C=a.Axis,A=a.getMagnitude,F=a.map,E=a.normalizeTickInterval,m=a.pick;C.prototype.getLogTickPositions=function(a,l,r,u){var f=this.options,g=this.len,
	d=this.lin2log,k=this.log2lin,b=[];u||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),b=this.getLinearTickPositions(a,l,r);else if(.08<=a)for(var g=Math.floor(l),e,v,y,n,D,f=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];g<r+1&&!D;g++)for(v=f.length,e=0;e<v&&!D;e++)y=k(d(g)*f[e]),y>l&&(!u||n<=r)&&void 0!==n&&b.push(n),n>r&&(D=!0),n=y;else l=d(l),r=d(r),a=f[u?"minorTickInterval":"tickInterval"],a=m("auto"===a?null:a,this._minorAutoInterval,f.tickPixelInterval/(u?5:1)*(r-l)/((u?g/this.tickPositions.length:
	g)||1)),a=E(a,null,A(a)),b=F(this.getLinearTickPositions(a,l,r),k),u||(this._minorAutoInterval=a/5);u||(this.tickInterval=a);return b};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(M);(function(a,C){var A=a.arrayMax,F=a.arrayMin,E=a.defined,m=a.destroyObjectProperties,f=a.each,l=a.erase,r=a.merge,u=a.pick;a.PlotLineOrBand=function(a,g){this.axis=a;g&&(this.options=g,this.id=g.id)};a.PlotLineOrBand.prototype={render:function(){var f=
	this,g=f.axis,d=g.horiz,k=f.options,b=k.label,e=f.label,v=k.to,l=k.from,n=k.value,D=E(l)&&E(v),m=E(n),c=f.svgElem,G=!c,q=[],B=k.color,K=u(k.zIndex,0),p=k.events,q={"class":"highcharts-plot-"+(D?"band ":"line ")+(k.className||"")},z={},I=g.chart.renderer,L=D?"bands":"lines",h=g.log2lin;g.isLog&&(l=h(l),v=h(v),n=h(n));m?(q={stroke:B,"stroke-width":k.width},k.dashStyle&&(q.dashstyle=k.dashStyle)):D&&(B&&(q.fill=B),k.borderWidth&&(q.stroke=k.borderColor,q["stroke-width"]=k.borderWidth));z.zIndex=K;L+=
	"-"+K;(B=g.plotLinesAndBandsGroups[L])||(g.plotLinesAndBandsGroups[L]=B=I.g("plot-"+L).attr(z).add());G&&(f.svgElem=c=I.path().attr(q).add(B));if(m)q=g.getPlotLinePath(n,c.strokeWidth());else if(D)q=g.getPlotBandPath(l,v,k);else return;G&&q&&q.length?(c.attr({d:q}),p&&a.objectEach(p,function(a,b){c.on(b,function(a){p[b].apply(f,[a])})})):c&&(q?(c.show(),c.animate({d:q})):(c.hide(),e&&(f.label=e=e.destroy())));b&&E(b.text)&&q&&q.length&&0<g.width&&0<g.height&&!q.flat?(b=r({align:d&&D&&"center",x:d?
	!D&&4:10,verticalAlign:!d&&D&&"middle",y:d?D?16:10:D?6:-4,rotation:d&&!D&&90},b),this.renderLabel(b,q,D,K)):e&&e.hide();return f},renderLabel:function(a,g,d,k){var b=this.label,e=this.axis.chart.renderer;b||(b={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(d?"band":"line")+"-label "+(a.className||"")},b.zIndex=k,this.label=b=e.text(a.text,0,0,a.useHTML).attr(b).add(),b.css(a.style));k=[g[1],g[4],d?g[6]:g[1]];g=[g[2],g[5],d?g[7]:g[2]];d=F(k);e=F(g);b.align(a,!1,{x:d,y:e,
	width:A(k)-d,height:A(g)-e});b.show()},destroy:function(){l(this.axis.plotLinesAndBands,this);delete this.axis;m(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,g){var d=this.getPlotLinePath(g,null,null,!0),k=this.getPlotLinePath(a,null,null,!0),b=this.horiz,e=1;a=a<this.min&&g<this.min||a>this.max&&g>this.max;k&&d?(a&&(k.flat=k.toString()===d.toString(),e=0),k.push(b&&d[4]===k[4]?d[4]+e:d[4],b||d[5]!==k[5]?d[5]:d[5]+e,b&&d[1]===k[1]?d[1]+e:d[1],b||d[2]!==k[2]?d[2]:d[2]+e)):k=null;return k},
	addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(f,g){var d=(new a.PlotLineOrBand(this,f)).render(),k=this.userOptions;d&&(g&&(k[g]=k[g]||[],k[g].push(f)),this.plotLinesAndBands.push(d));return d},removePlotBandOrLine:function(a){for(var g=this.plotLinesAndBands,d=this.options,k=this.userOptions,b=g.length;b--;)g[b].id===a&&g[b].destroy();f([d.plotLines||[],k.plotLines||[],d.plotBands||
	[],k.plotBands||[]],function(e){for(b=e.length;b--;)e[b].id===a&&l(e,e[b])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(M,S);(function(a){var C=a.dateFormat,A=a.each,F=a.extend,E=a.format,m=a.isNumber,f=a.map,l=a.merge,r=a.pick,u=a.splat,t=a.syncTimeout,g=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,k){this.chart=a;this.options=k;this.crosshairs=[];this.now={x:0,y:0};
	this.isHidden=!0;this.split=k.split&&!a.inverted;this.shared=k.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(d){var b=d&&d.tt;b&&(!b.isActive||a?d.tt=b.destroy():b.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,k=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,k.shape||"callout",null,null,k.useHTML,null,"tooltip").attr({padding:k.padding,r:k.borderRadius}),this.label.attr({fill:k.backgroundColor,"stroke-width":k.borderWidth}).css(k.style).shadow(k.shadow)),
	this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();l(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,l(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,k,b,e){var d=this,g=d.now,n=!1!==d.options.animation&&!d.isHidden&&(1<Math.abs(a-g.x)||1<Math.abs(k-
	g.y)),f=d.followPointer||1<d.len;F(g,{x:n?(2*g.x+a)/3:a,y:n?(g.y+k)/2:k,anchorX:f?void 0:n?(2*g.anchorX+b)/3:b,anchorY:f?void 0:n?(g.anchorY+e)/2:e});d.getLabel().attr(g);n&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){d&&d.move(a,k,b,e)},32))},hide:function(a){var d=this;clearTimeout(this.hideTimer);a=r(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=t(function(){d.getLabel()[a?"fadeOut":"hide"]();d.isHidden=!0},a))},getAnchor:function(a,k){var b,e=this.chart,
	d=e.inverted,g=e.plotTop,n=e.plotLeft,l=0,m=0,c,r;a=u(a);b=a[0].tooltipPos;this.followPointer&&k&&(void 0===k.chartX&&(k=e.pointer.normalize(k)),b=[k.chartX-e.plotLeft,k.chartY-g]);b||(A(a,function(a){c=a.series.yAxis;r=a.series.xAxis;l+=a.plotX+(!d&&r?r.left-n:0);m+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!d&&c?c.top-g:0)}),l/=a.length,m/=a.length,b=[d?e.plotWidth-m:l,this.shared&&!d&&1<a.length&&k?k.chartY-g:d?e.plotHeight-l:m]);return f(b,Math.round)},getPosition:function(a,g,b){var e=this.chart,
	d=this.distance,k={},n=b.h||0,f,l=["y",e.chartHeight,g,b.plotY+e.plotTop,e.plotTop,e.plotTop+e.plotHeight],c=["x",e.chartWidth,a,b.plotX+e.plotLeft,e.plotLeft,e.plotLeft+e.plotWidth],m=!this.followPointer&&r(b.ttBelow,!e.inverted===!!b.negative),q=function(a,b,c,e,p,q){var h=c<e-d,g=e+d+c<b,f=e-d-c;e+=d;if(m&&g)k[a]=e;else if(!m&&h)k[a]=f;else if(h)k[a]=Math.min(q-c,0>f-n?f:f-n);else if(g)k[a]=Math.max(p,e+n+c>b?e:e+n);else return!1},B=function(a,b,c,e){var h;e<d||e>b-d?h=!1:k[a]=e<c/2?1:e>b-c/2?
	b-c-2:e-c/2;return h},t=function(a){var b=l;l=c;c=b;f=a},p=function(){!1!==q.apply(0,l)?!1!==B.apply(0,c)||f||(t(!0),p()):f?k.x=k.y=0:(t(!0),p())};(e.inverted||1<this.len)&&t();p();return k},defaultFormatter:function(a){var d=this.points||u(this),b;b=[a.tooltipFooterHeaderFormatter(d[0])];b=b.concat(a.bodyFormatter(d));b.push(a.tooltipFooterHeaderFormatter(d[0],!0));return b},refresh:function(a,g){var b,e=this.options,d,k=a,n,f={},l=[];b=e.formatter||this.defaultFormatter;var f=this.shared,c;e.enabled&&
	(clearTimeout(this.hideTimer),this.followPointer=u(k)[0].series.tooltipOptions.followPointer,n=this.getAnchor(k,g),g=n[0],d=n[1],!f||k.series&&k.series.noSharedTooltip?f=k.getLabelConfig():(A(k,function(a){a.setState("hover");l.push(a.getLabelConfig())}),f={x:k[0].category,y:k[0].y},f.points=l,k=k[0]),this.len=l.length,f=b.call(f,this),c=k.series,this.distance=r(c.tooltipOptions.distance,16),!1===f?this.hide():(b=this.getLabel(),this.isHidden&&b.attr({opacity:1}).show(),this.split?this.renderSplit(f,
	a):(e.style.width||b.css({width:this.chart.spacingBox.width}),b.attr({text:f&&f.join?f.join(""):f}),b.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+r(k.colorIndex,c.colorIndex)),b.attr({stroke:e.borderColor||k.color||c.color||"#666666"}),this.updatePosition({plotX:g,plotY:d,negative:k.negative,ttBelow:k.ttBelow,h:n[2]||0})),this.isHidden=!1))},renderSplit:function(d,k){var b=this,e=[],g=this.chart,f=g.renderer,n=!0,l=this.options,m=0,c=this.getLabel();A(d.slice(0,k.length+1),
	function(a,d){if(!1!==a){d=k[d-1]||{isHeader:!0,plotX:k[0].plotX};var q=d.series||b,v=q.tt,p=d.series||{},z="highcharts-color-"+r(d.colorIndex,p.colorIndex,"none");v||(q.tt=v=f.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+z).attr({padding:l.padding,r:l.borderRadius,fill:l.backgroundColor,stroke:l.borderColor||d.color||p.color||"#333333","stroke-width":l.borderWidth}).add(c));v.isActive=!0;v.attr({text:a});v.css(l.style).shadow(l.shadow);a=v.getBBox();p=a.width+v.strokeWidth();
	d.isHeader?(m=a.height,p=Math.max(0,Math.min(d.plotX+g.plotLeft-p/2,g.chartWidth-p))):p=d.plotX+g.plotLeft-r(l.distance,16)-p;0>p&&(n=!1);a=(d.series&&d.series.yAxis&&d.series.yAxis.pos)+(d.plotY||0);a-=g.plotTop;e.push({target:d.isHeader?g.plotHeight+m:a,rank:d.isHeader?1:0,size:q.tt.getBBox().height+1,point:d,x:p,tt:v})}});this.cleanSplit();a.distribute(e,g.plotHeight+m);A(e,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:n||b.isHeader?a.x:b.plotX+
	g.plotLeft+r(l.distance,16),y:a.pos+g.plotTop,anchorX:b.isHeader?b.plotX+g.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+g.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var d=this.chart,b=this.getLabel(),b=(this.options.positioner||this.getPosition).call(this,b.width,b.height,a);this.move(Math.round(b.x),Math.round(b.y||0),a.plotX+d.plotLeft,a.plotY+d.plotTop)},getDateFormat:function(a,k,b,e){var d=C("%m-%d %H:%M:%S.%L",k),f,n,l={millisecond:15,second:12,minute:9,hour:6,day:3},
	m="millisecond";for(n in g){if(a===g.week&&+C("%w",k)===b&&"00:00:00.000"===d.substr(6)){n="week";break}if(g[n]>a){n=m;break}if(l[n]&&d.substr(l[n])!=="01-01 00:00:00.000".substr(l[n]))break;"week"!==n&&(m=n)}n&&(f=e[n]);return f},getXDateFormat:function(a,g,b){g=g.dateTimeLabelFormats;var e=b&&b.closestPointRange;return(e?this.getDateFormat(e,a.x,b.options.startOfWeek,g):g.day)||g.year},tooltipFooterHeaderFormatter:function(a,g){var b=g?"footer":"header";g=a.series;var e=g.tooltipOptions,d=e.xDateFormat,
	k=g.xAxis,n=k&&"datetime"===k.options.type&&m(a.key),b=e[b+"Format"];n&&!d&&(d=this.getXDateFormat(a,e,k));n&&d&&(b=b.replace("{point.key}","{point.key:"+d+"}"));return E(b,{point:a,series:g})},bodyFormatter:function(a){return f(a,function(a){var b=a.series.tooltipOptions;return(b.pointFormatter||a.point.tooltipFormatter).call(a.point,b.pointFormat)})}}})(M);(function(a){var C=a.addEvent,A=a.attr,F=a.charts,E=a.color,m=a.css,f=a.defined,l=a.each,r=a.extend,u=a.find,t=a.fireEvent,g=a.isObject,d=a.offset,
	k=a.pick,b=a.removeEvent,e=a.splat,v=a.Tooltip,y=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};v&&(a.tooltip=new v(a,b.tooltip),this.followTouchMove=k(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,e=b.options.chart,c=e.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=k(e.pinchType,c));
	this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,b){var e,c;a=a||y.event;a.target||(a.target=a.srcElement);c=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));void 0===c.pageX?(e=Math.max(a.x,a.clientX-b.left),b=a.y):(e=c.pageX-b.left,b=c.pageY-b.top);return r(a,{chartX:Math.round(e),chartY:Math.round(b)})},getCoordinates:function(a){var b=
	{xAxis:[],yAxis:[]};l(this.chart.axes,function(e){b[e.isXAxis?"xAxis":"yAxis"].push({axis:e,value:e.toValue(a[e.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,e){var c;l(a,function(a){var d=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(e,d);if((d=g(a,!0))&&!(d=!g(c,!0)))var d=c.distX-a.distX,n=c.dist-a.dist,k=(a.series.group&&a.series.group.zIndex)-(c.series.group&&c.series.group.zIndex),d=0<(0!==d&&b?d:0!==n?n:0!==k?k:c.series.index>
	a.series.index?-1:1);d&&(c=a)});return c},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var e=a.series,c=e.xAxis,e=e.yAxis;if(c&&e)return b?{chartX:c.len+c.pos-a.clientX,chartY:e.len+e.pos-a.plotY}:{chartX:a.clientX+c.pos,chartY:a.plotY+e.pos}},getHoverData:function(b,e,d,c,f,q){var n,v=[];c=!(!c||!b);var p=e&&!e.stickyTracking?[e]:a.grep(d,function(a){return a.visible&&!(!f&&a.directTouch)&&k(a.options.enableMouseTracking,
	!0)&&a.stickyTracking});e=(n=c?b:this.findNearestKDPoint(p,f,q))&&n.series;n&&(f&&!e.noSharedTooltip?(p=a.grep(d,function(a){return a.visible&&!(!f&&a.directTouch)&&k(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),l(p,function(a){a=u(a.points,function(a){return a.x===n.x});g(a)&&!a.isNull&&v.push(a)})):v.push(n));return{hoverPoint:n,hoverSeries:e,hoverPoints:v}},runPointActions:function(b,e){var d=this.chart,c=d.tooltip,g=c?c.shared:!1,n=e||d.hoverPoint,f=n&&n.series||d.hoverSeries,f=this.getHoverData(n,
	f,d.series,!!e||f&&f.directTouch&&this.isDirectTouch,g,b),v,n=f.hoverPoint;v=f.hoverPoints;e=(f=f.hoverSeries)&&f.tooltipOptions.followPointer;g=g&&f&&!f.noSharedTooltip;if(n&&(n!==d.hoverPoint||c&&c.isHidden)){l(d.hoverPoints||[],function(b){-1===a.inArray(b,v)&&b.setState()});l(v||[],function(a){a.setState("hover")});if(d.hoverSeries!==f)f.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");n.firePointEvent("mouseOver");d.hoverPoints=v;d.hoverPoint=n;c&&c.refresh(g?v:n,b)}else e&&
	c&&!c.isHidden&&(n=c.getAnchor([{}],b),c.updatePosition({plotX:n[0],plotY:n[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(d.container.ownerDocument,"mousemove",function(b){var c=F[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));l(d.axes,function(c){var e=k(c.crosshair.snap,!0),p=e?a.find(v,function(a){return a.series[c.coll]===c}):void 0;p||!e?c.drawCrosshair(b,p):c.hideCrosshair()})},reset:function(a,b){var d=this.chart,c=d.hoverSeries,g=d.hoverPoint,n=d.hoverPoints,f=d.tooltip,k=
	f&&f.shared?n:g;a&&k&&l(e(k),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)f&&k&&(f.refresh(k),g&&(g.setState(g.state,!0),l(d.axes,function(a){a.crosshair&&a.drawCrosshair(null,g)})));else{if(g)g.onMouseOut();n&&l(n,function(a){a.setState()});if(c)c.onMouseOut();f&&f.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());l(d.axes,function(a){a.hideCrosshair()});this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var e=this.chart,c;l(e.series,
	function(d){c=a||d.getPlotBox();d.xAxis&&d.xAxis.zoomEnabled&&d.group&&(d.group.attr(c),d.markerGroup&&(d.markerGroup.attr(c),d.markerGroup.clip(b?e.clipRect:null)),d.dataLabelsGroup&&d.dataLabelsGroup.attr(c))});e.clipRect.attr(b||e.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,e=b.options.chart,c=a.chartX,d=a.chartY,g=this.zoomHor,n=this.zoomVert,
	f=b.plotLeft,p=b.plotTop,k=b.plotWidth,v=b.plotHeight,l,h=this.selectionMarker,w=this.mouseDownX,m=this.mouseDownY,r=e.panKey&&a[e.panKey+"Key"];h&&h.touch||(c<f?c=f:c>f+k&&(c=f+k),d<p?d=p:d>p+v&&(d=p+v),this.hasDragged=Math.sqrt(Math.pow(w-c,2)+Math.pow(m-d,2)),10<this.hasDragged&&(l=b.isInsidePlot(w-f,m-p),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!r&&!h&&(this.selectionMarker=h=b.renderer.rect(f,p,g?1:k,n?1:v,0).attr({fill:e.selectionMarkerFill||E("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",
	zIndex:7}).add()),h&&g&&(c-=w,h.attr({width:Math.abs(c),x:(0<c?0:c)+w})),h&&n&&(c=d-m,h.attr({height:Math.abs(c),y:(0<c?0:c)+m})),l&&!h&&e.panning&&b.pan(a,e.panning)))},drop:function(a){var b=this,e=this.chart,c=this.hasPinched;if(this.selectionMarker){var d={originalEvent:a,xAxis:[],yAxis:[]},g=this.selectionMarker,n=g.attr?g.attr("x"):g.x,k=g.attr?g.attr("y"):g.y,p=g.attr?g.attr("width"):g.width,v=g.attr?g.attr("height"):g.height,I;if(this.hasDragged||c)l(e.axes,function(e){if(e.zoomEnabled&&f(e.min)&&
	(c||b[{xAxis:"zoomX",yAxis:"zoomY"}[e.coll]])){var h=e.horiz,g="touchend"===a.type?e.minPixelPadding:0,q=e.toValue((h?n:k)+g),h=e.toValue((h?n+p:k+v)-g);d[e.coll].push({axis:e,min:Math.min(q,h),max:Math.max(q,h)});I=!0}}),I&&t(e,"selection",d,function(a){e.zoom(r(a,c?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();c&&this.scaleGroups()}e&&(m(e.container,{cursor:e._cursor}),e.cancelClick=10<this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=
	[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){F[a.hoverChartIndex]&&F[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,e=this.chartPosition;a=this.normalize(a,e);!e||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var e=F[a.hoverChartIndex];e&&(b.relatedTarget||
	b.toElement)&&(e.pointer.reset(),e.pointer.chartPosition=null)},onContainerMouseMove:function(b){var e=this.chart;f(a.hoverChartIndex)&&F[a.hoverChartIndex]&&F[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=e.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===e.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!e.isInsidePlot(b.chartX-e.plotLeft,b.chartY-e.plotTop)||e.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var e;a;){if(e=A(a,"class")){if(-1!==
	e.indexOf(b))return!0;if(-1!==e.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,e=b.hoverPoint,c=b.plotLeft,d=b.plotTop;a=this.normalize(a);b.cancelClick||(e&&this.inClass(a.target,
	"highcharts-tracker")?(t(e.series,"click",r(a,{point:e})),b.hoverPoint&&e.firePointEvent("click",a)):(r(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-c,a.chartY-d)&&t(b,"click",a)))},setDOMEvents:function(){var b=this,e=b.chart.container,d=e.ownerDocument;e.onmousedown=function(a){b.onContainerMouseDown(a)};e.onmousemove=function(a){b.onContainerMouseMove(a)};e.onclick=function(a){b.onContainerClick(a)};C(e,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&C(d,"mouseup",b.onDocumentMouseUp);
	a.hasTouch&&(e.ontouchstart=function(a){b.onContainerTouchStart(a)},e.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&C(d,"touchend",b.onDocumentTouchEnd))},destroy:function(){var e=this,d=this.chart.container.ownerDocument;e.unDocMouseMove&&e.unDocMouseMove();b(e.chart.container,"mouseleave",e.onContainerMouseLeave);a.chartCount||(b(d,"mouseup",e.onDocumentMouseUp),a.hasTouch&&b(d,"touchend",e.onDocumentTouchEnd));clearInterval(e.tooltipTimeout);a.objectEach(e,function(a,b){e[b]=
	null})}}})(M);(function(a){var C=a.charts,A=a.each,F=a.extend,E=a.map,m=a.noop,f=a.pick;F(a.Pointer.prototype,{pinchTranslate:function(a,f,m,t,g,d){this.zoomHor&&this.pinchTranslateDirection(!0,a,f,m,t,g,d);this.zoomVert&&this.pinchTranslateDirection(!1,a,f,m,t,g,d)},pinchTranslateDirection:function(a,f,m,t,g,d,k,b){var e=this.chart,v=a?"x":"y",l=a?"X":"Y",n="chart"+l,r=a?"width":"height",u=e["plot"+(a?"Left":"Top")],c,G,q=b||1,B=e.inverted,K=e.bounds[a?"h":"v"],p=1===f.length,z=f[0][n],I=m[0][n],
	L=!p&&f[1][n],h=!p&&m[1][n],w;m=function(){!p&&20<Math.abs(z-L)&&(q=b||Math.abs(I-h)/Math.abs(z-L));G=(u-I)/q+z;c=e["plot"+(a?"Width":"Height")]/q};m();f=G;f<K.min?(f=K.min,w=!0):f+c>K.max&&(f=K.max-c,w=!0);w?(I-=.8*(I-k[v][0]),p||(h-=.8*(h-k[v][1])),m()):k[v]=[I,h];B||(d[v]=G-u,d[r]=c);d=B?1/q:q;g[r]=c;g[v]=f;t[B?a?"scaleY":"scaleX":"scale"+l]=q;t["translate"+l]=d*u+(I-d*z)},pinch:function(a){var l=this,u=l.chart,t=l.pinchDown,g=a.touches,d=g.length,k=l.lastValidTouch,b=l.hasZoom,e=l.selectionMarker,
	v={},y=1===d&&(l.inClass(a.target,"highcharts-tracker")&&u.runTrackerClick||l.runChartClick),n={};1<d&&(l.initiated=!0);b&&l.initiated&&!y&&a.preventDefault();E(g,function(a){return l.normalize(a)});"touchstart"===a.type?(A(g,function(a,b){t[b]={chartX:a.chartX,chartY:a.chartY}}),k.x=[t[0].chartX,t[1]&&t[1].chartX],k.y=[t[0].chartY,t[1]&&t[1].chartY],A(u.axes,function(a){if(a.zoomEnabled){var b=u.bounds[a.horiz?"h":"v"],e=a.minPixelPadding,d=a.toPixels(f(a.options.min,a.dataMin)),g=a.toPixels(f(a.options.max,
	a.dataMax)),k=Math.max(d,g);b.min=Math.min(a.pos,Math.min(d,g)-e);b.max=Math.max(a.pos+a.len,k+e)}}),l.res=!0):l.followTouchMove&&1===d?this.runPointActions(l.normalize(a)):t.length&&(e||(l.selectionMarker=e=F({destroy:m,touch:!0},u.plotBox)),l.pinchTranslate(t,g,v,e,n,k),l.hasPinched=b,l.scaleGroups(v,n),l.res&&(l.res=!1,this.reset(!1,0)))},touch:function(l,m){var r=this.chart,t,g;if(r.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=r.index;1===l.touches.length?
	(l=this.normalize(l),(g=r.isInsidePlot(l.chartX-r.plotLeft,l.chartY-r.plotTop))&&!r.openMenu?(m&&this.runPointActions(l),"touchmove"===l.type&&(m=this.pinchDown,t=m[0]?4<=Math.sqrt(Math.pow(m[0].chartX-l.chartX,2)+Math.pow(m[0].chartY-l.chartY,2)):!1),f(t,!0)&&this.pinch(l)):m&&this.reset()):2===l.touches.length&&this.pinch(l)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){C[a.hoverChartIndex]&&
	C[a.hoverChartIndex].pointer.drop(f)}})})(M);(function(a){var C=a.addEvent,A=a.charts,F=a.css,E=a.doc,m=a.extend,f=a.noop,l=a.Pointer,r=a.removeEvent,u=a.win,t=a.wrap;if(!a.hasTouch&&(u.PointerEvent||u.MSPointerEvent)){var g={},d=!!u.PointerEvent,k=function(){var b=[];b.item=function(a){return this[a]};a.objectEach(g,function(a){b.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return b},b=function(b,d,g,n){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||
	(n(b),n=A[a.hoverChartIndex].pointer,n[d]({type:g,target:b.currentTarget,preventDefault:f,touches:k()}))};m(l.prototype,{onContainerPointerDown:function(a){b(a,"onContainerTouchStart","touchstart",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){b(a,"onContainerTouchMove","touchmove",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY};g[a.pointerId].target||(g[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){b(a,
	"onDocumentTouchEnd","touchend",function(a){delete g[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,d?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,d?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(E,d?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});t(l.prototype,"init",function(a,b,d){a.call(this,b,d);this.hasZoom&&F(b.container,{"-ms-touch-action":"none","touch-action":"none"})});t(l.prototype,"setDOMEvents",function(a){a.apply(this);
	(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});t(l.prototype,"destroy",function(a){this.batchMSEvents(r);a.call(this)})}})(M);(function(a){var C=a.addEvent,A=a.css,F=a.discardElement,E=a.defined,m=a.each,f=a.isFirefox,l=a.marginNames,r=a.merge,u=a.pick,t=a.setAnimation,g=a.stableSort,d=a.win,k=a.wrap;a.Legend=function(a,e){this.init(a,e)};a.Legend.prototype={init:function(a,e){this.chart=a;this.setOptions(e);e.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},
	setOptions:function(a){var b=u(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=r(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=u(a.symbolWidth,16);this.pages=[]},update:function(a,e){var b=this.chart;this.setOptions(r(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;u(e,!0)&&b.redraw()},colorizeItem:function(a,e){a.legendGroup[e?"removeClass":
	"addClass"]("highcharts-legend-item-hidden");var b=this.options,d=a.legendItem,g=a.legendLine,f=a.legendSymbol,k=this.itemHiddenStyle.color,b=e?b.itemStyle.color:k,c=e?a.color||k:k,l=a.options&&a.options.marker,q={fill:c};d&&d.css({fill:b,color:b});g&&g.attr({stroke:c});f&&(l&&f.isMarker&&(q=a.pointAttribs(),e||(q.stroke=q.fill=k)),f.attr(q))},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,g=a._legendItemPos,f=g[0],g=g[1],k=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?
	f:this.legendWidth-f-2*d-4,g);k&&(k.x=f,k.y=g)},destroyItem:function(a){var b=a.checkbox;m(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&F(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}m(this.getAllItems(),function(b){m(["legendItem","legendGroup"],a,b)});m("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,
	d,g=this.clipHeight||this.legendHeight,f=this.titleHeight;b&&(d=b.translateY,m(this.allItems,function(e){var k=e.checkbox,c;k&&(c=d+f+k.y+(a||0)+3,A(k,{left:b.translateX+e.checkboxOffset+k.x-20+"px",top:c+"px",display:c>d-6&&c<d+g-6?"":"none"}))}))},renderTitle:function(){var a=this.options,e=this.padding,d=a.title,g=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,e-3,e-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(d.style).add(this.group)),a=this.title.getBBox(),
	g=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:g}));this.titleHeight=g},setText:function(b){var e=this.options;b.legendItem.attr({text:e.labelFormat?a.format(e.labelFormat,b):e.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,d=b.renderer,g=this.options,f="horizontal"===g.layout,k=this.symbolWidth,l=g.symbolPadding,c=this.itemStyle,m=this.itemHiddenStyle,q=this.padding,B=f?u(g.itemDistance,20):0,t=!g.rtl,p=g.width,z=g.itemMarginBottom||0,I=this.itemMarginTop,
	L=a.legendItem,h=!a.series,w=!h&&a.series.drawLegendSymbol?a.series:a,P=w.options,H=this.createCheckboxForItem&&P&&P.showCheckbox,P=k+l+B+(H?20:0),O=g.useHTML,A=a.options.className;L||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+w.type+"-series highcharts-color-"+a.colorIndex+(A?" "+A:"")+(h?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=L=d.text("",t?k+l:-l,this.baseline||0,O).css(r(a.visible?c:m)).attr({align:t?"left":"right",zIndex:2}).add(a.legendGroup),
	this.baseline||(k=c.fontSize,this.fontMetrics=d.fontMetrics(k,L),this.baseline=this.fontMetrics.f+3+I,L.attr("y",this.baseline)),this.symbolHeight=g.symbolHeight||this.fontMetrics.f,w.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,L,O),H&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);c.width||L.css({width:(g.itemWidth||g.width||b.spacingBox.width)-P});this.setText(a);d=L.getBBox();c=a.checkboxOffset=g.itemWidth||a.legendItemWidth||d.width+P;this.itemHeight=d=Math.round(a.legendItemHeight||
	d.height||this.symbolHeight);f&&this.itemX-q+c>(p||b.spacingBox.width-2*q-g.x)&&(this.itemX=q,this.itemY+=I+this.lastLineHeight+z,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,c);this.lastItemY=I+this.itemY+z;this.lastLineHeight=Math.max(d,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];f?this.itemX+=c:(this.itemY+=I+d+z,this.lastLineHeight=d);this.offsetWidth=p||Math.max((f?this.itemX-q-(a.checkbox?0:B):c)+q,this.offsetWidth)},getAllItems:function(){var a=[];m(this.chart.series,
	function(b){var e=b&&b.options;b&&u(e.showInLegend,E(e.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===e.legendType?b.data:b)))});return a},adjustMargins:function(a,e){var b=this.chart,d=this.options,g=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||m([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(f,k){f.test(g)&&!E(a[k])&&(b[l[k]]=Math.max(b[l[k]],b.legend[(k+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][k]*d[k%2?"x":"y"]+u(d.margin,
	12)+e[k]))})},render:function(){var a=this,e=a.chart,d=e.renderer,f=a.group,k,l,t,c,u=a.box,q=a.options,B=a.padding;a.itemX=B;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;f||(a.group=f=d.g("legend").attr({zIndex:7}).add(),a.contentGroup=d.g().attr({zIndex:1}).add(f),a.scrollGroup=d.g().add(a.contentGroup));a.renderTitle();k=a.getAllItems();g(k,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});q.reversed&&k.reverse();a.allItems=k;a.display=l=
	!!k.length;a.lastLineHeight=0;m(k,function(b){a.renderItem(b)});t=(q.width||a.offsetWidth)+B;c=a.lastItemY+a.lastLineHeight+a.titleHeight;c=a.handleOverflow(c);c+=B;u||(a.box=u=d.rect().addClass("highcharts-legend-box").attr({r:q.borderRadius}).add(f),u.isNew=!0);u.attr({stroke:q.borderColor,"stroke-width":q.borderWidth||0,fill:q.backgroundColor||"none"}).shadow(q.shadow);0<t&&0<c&&(u[u.isNew?"attr":"animate"](u.crisp({x:0,y:0,width:t,height:c},u.strokeWidth())),u.isNew=!1);u[l?"show":"hide"]();a.legendWidth=
	t;a.legendHeight=c;m(k,function(b){a.positionItem(b)});l&&f.align(r(q,{width:t,height:c}),!0,"spacingBox");e.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,d=this.chart,g=d.renderer,f=this.options,k=f.y,l=this.padding,d=d.spacingBox.height+("top"===f.verticalAlign?-k:k)-l,k=f.maxHeight,c,r=this.clipRect,q=f.navigation,B=u(q.animation,!0),t=q.arrowSize||12,p=this.nav,z=this.pages,I,L=this.allItems,h=function(a){"number"===typeof a?r.attr({height:a}):r&&(b.clipRect=r.destroy(),
	b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};"horizontal"!==f.layout||"middle"===f.verticalAlign||f.floating||(d/=2);k&&(d=Math.min(d,k));z.length=0;a>d&&!1!==q.enabled?(this.clipHeight=c=Math.max(d-20-this.titleHeight-l,0),this.currentPage=u(this.currentPage,1),this.fullHeight=a,m(L,function(a,b){var e=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=z.length;if(!d||e-z[d-1]>c&&(I||e)!==z[d-1])z.push(I||
	e),d++;b===L.length-1&&e+a-z[d-1]>c&&z.push(e);e!==I&&(I=e)}),r||(r=b.clipRect=g.clipRect(0,l,9999,0),b.contentGroup.clip(r)),h(c),p||(this.nav=p=g.g().attr({zIndex:1}).add(this.group),this.up=g.symbol("triangle",0,0,t,t).on("click",function(){b.scroll(-1,B)}).add(p),this.pager=g.text("",15,10).addClass("highcharts-legend-navigation").css(q.style).add(p),this.down=g.symbol("triangle-down",0,0,t,t).on("click",function(){b.scroll(1,B)}).add(p)),b.scroll(0),a=d):p&&(h(),this.nav=p.destroy(),this.scrollGroup.attr({translateY:1}),
	this.clipHeight=0);return a},scroll:function(a,e){var b=this.pages,d=b.length;a=this.currentPage+a;var g=this.clipHeight,f=this.options.navigation,k=this.pager,c=this.padding;a>d&&(a=d);0<a&&(void 0!==e&&t(e,this.chart),this.nav.attr({translateX:c,translateY:g+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),k.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":
	"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?f.inactiveColor:f.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?f.inactiveColor:f.activeColor}).css({cursor:a===d?"default":"pointer"}),e=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:e}),this.currentPage=a,this.positionCheckboxes(e))}};a.LegendSymbolMixin={drawRectangle:function(a,e){var b=a.symbolHeight,d=a.options.squareSymbol;e.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/
	2:0,a.baseline-b+1,d?b:a.symbolWidth,b,u(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(e.legendGroup)},drawLineMarker:function(a){var b=this.options,d=b.marker,g=a.symbolWidth,f=a.symbolHeight,k=f/2,l=this.chart.renderer,c=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var m;m={"stroke-width":b.lineWidth||0};b.dashStyle&&(m.dashstyle=b.dashStyle);this.legendLine=l.path(["M",0,a,"L",g,a]).addClass("highcharts-graph").attr(m).add(c);d&&!1!==d.enabled&&
	(b=Math.min(u(d.radius,k),k),0===this.symbol.indexOf("url")&&(d=r(d,{width:f,height:f}),b=0),this.legendSymbol=d=l.symbol(this.symbol,g/2-b,a-b,2*b,2*b,d).addClass("highcharts-point").add(c),d.isMarker=!0)}};(/Trident\/7\.0/.test(d.navigator.userAgent)||f)&&k(a.Legend.prototype,"positionItem",function(a,e){var b=this,d=function(){e._legendItemPos&&a.call(b,e)};d();setTimeout(d)})})(M);(function(a){var C=a.addEvent,A=a.animate,F=a.animObject,E=a.attr,m=a.doc,f=a.Axis,l=a.createElement,r=a.defaultOptions,
	u=a.discardElement,t=a.charts,g=a.css,d=a.defined,k=a.each,b=a.extend,e=a.find,v=a.fireEvent,y=a.getStyle,n=a.grep,D=a.isNumber,J=a.isObject,c=a.isString,G=a.Legend,q=a.marginNames,B=a.merge,K=a.objectEach,p=a.Pointer,z=a.pick,I=a.pInt,L=a.removeEvent,h=a.seriesTypes,w=a.splat,P=a.svg,H=a.syncTimeout,O=a.win,Q=a.Renderer,R=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new R(a,b,c)};b(R.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);
	if(c(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var e,d,h=b.series,p=b.plotOptions||{};b.series=null;e=B(r,b);for(d in e.plotOptions)e.plotOptions[d].tooltip=p[d]&&B(p[d].tooltip)||void 0;e.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;e.series=b.series=h;this.userOptions=b;b=e.chart;d=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=
	[];this.hasCartesianSeries=b.showAxes;var g=this;g.index=t.length;t.push(g);a.chartCount++;d&&K(d,function(a,b){C(g,b,a)});g.xAxis=[];g.yAxis=[];g.pointCount=g.colorCounter=g.symbolCounter=0;g.firstRender()},initSeries:function(b){var c=this.options.chart;(c=h[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,
	b,c){var e=c?b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(c){var e=this.axes,d=this.series,h=this.pointer,p=this.legend,g=this.isDirtyLegend,f,q,l=this.hasCartesianSeries,n=this.isDirtyBox,z,m=this.renderer,x=m.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(c,this);x&&this.temporaryDisplay();this.layOutTitles();for(c=d.length;c--;)if(z=d[c],z.options.stacking&&(f=!0,z.isDirty)){q=!0;break}if(q)for(c=d.length;c--;)z=d[c],z.options.stacking&&
	(z.isDirty=!0);k(d,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),g=!0);a.isDirtyData&&v(a,"updatedData")});g&&p.options.enabled&&(p.render(),this.isDirtyLegend=!1);f&&this.getStacks();l&&k(e,function(a){a.updateNames();a.setScale()});this.getMargins();l&&(k(e,function(a){a.isDirty&&(n=!0)}),k(e,function(a){var c=a.min+","+a.max;a.extKey!==c&&(a.extKey=c,w.push(function(){v(a,"afterSetExtremes",b(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(n||f)&&
	a.redraw()}));n&&this.drawChartBox();v(this,"predraw");k(d,function(a){(n||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);m.draw();v(this,"redraw");v(this,"render");x&&this.temporaryDisplay(!0);k(w,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,h;c=e(this.axes,b)||e(this.series,b);for(h=0;!c&&h<d.length;h++)c=e(d[h].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=w(b.xAxis||
	{}),b=b.yAxis=w(b.yAxis||{});k(c,function(a,b){a.index=b;a.isX=!0});k(b,function(a,b){a.index=b});c=c.concat(b);k(c,function(b){new f(a,b)})},getSelectedPoints:function(){var a=[];k(this.series,function(b){a=a.concat(n(b.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return n(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var e=this,d=e.options,h;h=d.title=B({style:{color:"#333333",fontSize:d.isStock?"16px":"18px"}},d.title,a);d=d.subtitle=
	B({style:{color:"#666666"}},d.subtitle,b);k([["title",a,h],["subtitle",b,d]],function(a,b){var c=a[0],d=e[c],h=a[1];a=a[2];d&&h&&(e[c]=d=d.destroy());a&&a.text&&!d&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var c=0,e,d=this.renderer,h=this.spacingBox;k(["title","subtitle"],function(a){var e=this[a],p=this.options[a];
	a="title"===a?-3:p.verticalAlign?0:c+2;var g;e&&(g=p.style.fontSize,g=d.fontMetrics(g,e).b,e.css({width:(p.width||h.width+p.widthAdjust)+"px"}).align(b({y:a+g},p),!1,"spacingBox"),p.floating||p.verticalAlign||(c=Math.ceil(c+e.getBBox(p.useHTML).height)))},this);e=this.titleOffset!==c;this.titleOffset=c;!this.isDirtyBox&&e&&(this.isDirtyBox=e,this.hasRendered&&z(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,e=this.renderTo;d(c)||(this.containerWidth=
	y(e,"width"));d(b)||(this.containerHeight=y(e,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||this.containerHeight||400)},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(m.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){m.body.contains(c)||(c.hcOrigDetached=!0,m.body.appendChild(c));
	if("none"===y(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===m.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var e,d=this.options,h=d.chart,p,g;e=this.renderTo;var f=a.uniqueKey(),k;e||
	(this.renderTo=e=h.renderTo);c(e)&&(this.renderTo=e=m.getElementById(e));e||a.error(13,!0);p=I(E(e,"data-highcharts-chart"));D(p)&&t[p]&&t[p].hasRendered&&t[p].destroy();E(e,"data-highcharts-chart",this.index);e.innerHTML="";h.skipClone||e.offsetWidth||this.temporaryDisplay();this.getChartSize();p=this.chartWidth;g=this.chartHeight;k=b({position:"relative",overflow:"hidden",width:p+"px",height:g+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},h.style);
	this.container=e=l("div",{id:f},k,e);this._cursor=e.style.cursor;this.renderer=new (a[h.renderer]||Q)(e,p,g,null,h.forExport,d.exporting&&d.exporting.allowHTML);this.setClassName(h.className);this.renderer.setStyle(h.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,e=this.titleOffset;this.resetMargins();e&&!d(c[0])&&(this.plotTop=Math.max(this.plotTop,e+this.options.title.margin+b[0]));this.legend.display&&this.legend.adjustMargins(c,b);this.extraMargin&&
	(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&k(a.axes,function(a){a.visible&&a.getOffset()});k(q,function(e,h){d(c[h])||(a[e]+=b[h])});a.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,e=b.renderTo,h=d(c.width)&&d(c.height),p=c.width||y(e,"width"),c=c.height||y(e,"height"),
	e=a?a.target:O;if(!h&&!b.isPrinting&&p&&c&&(e===O||e===m)){if(p!==b.containerWidth||c!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=H(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=p;b.containerHeight=c}},initReflow:function(){var a=this,b;b=C(O,"resize",function(b){a.reflow(b)});C(a,"destroy",b)},setSize:function(b,c,e){var d=this,h=d.renderer;d.isResizing+=1;a.setAnimation(e,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;void 0!==
	b&&(d.options.chart.width=b);void 0!==c&&(d.options.chart.height=c);d.getChartSize();b=h.globalAnimation;(b?A:g)(d.container,{width:d.chartWidth+"px",height:d.chartHeight+"px"},b);d.setChartSize(!0);h.setSize(d.chartWidth,d.chartHeight,e);k(d.axes,function(a){a.isDirty=!0;a.setScale()});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(e);d.oldChartHeight=null;v(d,"resize");H(function(){d&&v(d,"endResize",null,function(){--d.isResizing})},F(b).duration)},setChartSize:function(a){function b(a){a=
	f[a]||0;return Math.max(m||a,a)/2}var c=this.inverted,e=this.renderer,d=this.chartWidth,h=this.chartHeight,p=this.options.chart,g=this.spacing,f=this.clipOffset,q,n,l,z,m;this.plotLeft=q=Math.round(this.plotLeft);this.plotTop=n=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(d-q-this.marginRight));this.plotHeight=z=Math.max(0,Math.round(h-n-this.marginBottom));this.plotSizeX=c?z:l;this.plotSizeY=c?l:z;this.plotBorderWidth=p.plotBorderWidth||0;this.spacingBox=e.spacingBox={x:g[3],y:g[0],
	width:d-g[3]-g[1],height:h-g[0]-g[2]};this.plotBox=e.plotBox={x:q,y:n,width:l,height:z};m=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(b(3));e=Math.ceil(b(0));this.clipBox={x:c,y:e,width:Math.floor(this.plotSizeX-b(1)-c),height:Math.max(0,Math.floor(this.plotSizeY-b(2)-e))};a||k(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;k(["margin","spacing"],function(c){var e=b[c],d=J(e)?e:[e,e,e,e];k(["Top","Right","Bottom","Left"],function(e,
	h){a[c][h]=z(b[c+e],d[h])})});k(q,function(b,c){a[b]=z(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,e=this.chartHeight,d=this.chartBackground,h=this.plotBackground,p=this.plotBorder,g,f=this.plotBGImage,k=a.backgroundColor,q=a.plotBackgroundColor,l=a.plotBackgroundImage,n,z=this.plotLeft,m=this.plotTop,w=this.plotWidth,I=this.plotHeight,v=this.plotBox,r=this.clipRect,B=this.clipBox,y="animate";
	d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),y="attr");g=a.borderWidth||0;n=g+(a.shadow?8:0);k={fill:k||"none"};if(g||d["stroke-width"])k.stroke=a.borderColor,k["stroke-width"]=g;d.attr(k).shadow(a.shadow);d[y]({x:n/2,y:n/2,width:c-n-g%2,height:e-n-g%2,r:a.borderRadius});y="animate";h||(y="attr",this.plotBackground=h=b.rect().addClass("highcharts-plot-background").add());h[y](v);h.attr({fill:q||"none"}).shadow(a.plotShadow);l&&(f?f.animate(v):this.plotBGImage=b.image(l,
	z,m,w,I).add());r?r.animate({width:B.width,height:B.height}):this.clipRect=b.clipRect(B);y="animate";p||(y="attr",this.plotBorder=p=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());p.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});p[y](p.crisp({x:z,y:m,width:w,height:I},-p.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,d,p;k(["inverted","angular","polar"],function(g){c=h[b.type||b.defaultSeriesType];
	p=b[g]||c&&c.prototype[g];for(d=e&&e.length;!p&&d--;)(c=h[e[d].type])&&c.prototype[g]&&(p=!0);a[g]=p})},linkSeries:function(){var a=this,b=a.series;k(b,function(a){a.linkedSeries.length=0});k(b,function(b){var e=b.options.linkedTo;c(e)&&(e=":previous"===e?a.series[b.index-1]:a.get(e))&&e.linkedParent!==b&&(e.linkedSeries.push(b),b.linkedParent=e,b.visible=z(b.options.visible,e.options.visible,b.visible))})},renderSeries:function(){k(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=
	this,c=a.options.labels;c.items&&k(c.items,function(e){var d=b(c.style,e.style),h=I(d.left)+a.plotLeft,p=I(d.top)+a.plotTop+12;delete d.left;delete d.top;a.renderer.text(e.html,h,p).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,d,h;this.setTitle();this.legend=new G(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight-=21;k(a,function(a){a.setScale()});this.getAxisMargins();d=
	1.1<c/this.plotWidth;h=1.05<e/this.plotHeight;if(d||h)k(a,function(a){(a.horiz&&d||!a.horiz&&h)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&k(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=B(!0,this.options.credits,a);a.enabled&&!this.credits&&
	(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(O.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,e=b.series,d=b.container,h,p=d&&d.parentNode;v(b,"destroy");b.renderer.forExport?a.erase(t,b):t[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");
	L(b);for(h=c.length;h--;)c[h]=c[h].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(h=e.length;h--;)e[h]=e[h].destroy();k("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});d&&(d.innerHTML="",L(d),p&&u(d));K(b,function(a,c){delete b[c]})},isReadyToRender:function(){var a=this;return P||O!=O.top||
	"complete"===m.readyState?!0:(m.attachEvent("onreadystatechange",function(){m.detachEvent("onreadystatechange",a.firstRender);"complete"===m.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();v(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();k(b.series||[],function(b){a.initSeries(b)});a.linkSeries();v(a,"beforeRender");p&&(a.pointer=new p(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();
	a.temporaryDisplay(!0)}},onload:function(){k([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);v(this,"load");v(this,"render");d(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(M);(function(a){var C,A=a.each,F=a.extend,E=a.erase,m=a.fireEvent,f=a.format,l=a.isArray,r=a.isNumber,u=a.pick,t=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,d,f){this.series=a;this.color=a.color;this.applyOptions(d,
	f);a.options.colorByPoint?(d=a.options.colors||a.chart.options.colors,this.color=this.color||d[a.colorCounter],d=d.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===d&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=u(this.colorIndex,f);a.chart.pointCount++;return this},applyOptions:function(a,d){var g=this.series,b=g.options.pointValKey||g.pointValKey;a=C.prototype.optionsToObject.call(this,a);F(this,a);this.options=this.options?F(this.options,a):a;a.group&&delete this.group;b&&(this.y=
	this[b]);this.isNull=u(this.isValid&&!this.isValid(),null===this.x||!r(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===d&&g.xAxis&&g.xAxis.hasNames&&(this.x=g.xAxis.nameToX(this));void 0===this.x&&g&&(this.x=void 0===d?g.autoIncrement(this):d);return this},optionsToObject:function(a){var d={},g=this.series,b=g.options.keys,e=b||g.pointArrayMap||["y"],f=e.length,m=0,n=0;if(r(a)||null===a)d[e[0]]=a;else if(l(a))for(!b&&a.length>f&&(g=typeof a[0],"string"===g?d.name=a[0]:"number"===
	g&&(d.x=a[0]),m++);n<f;)b&&void 0===a[m]||(d[e[n]]=a[m]),m++,n++;else"object"===typeof a&&(d=a,a.dataLabels&&(g._hasPointLabels=!0),a.marker&&(g._hasPointMarkers=!0));return d},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
	" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,d=a.zones,a=a.zoneAxis||"y",f=0,b;for(b=d[f];this[a]>=b.value;)b=d[++f];b&&b.color&&!this.options.color&&(this.color=b.color);return b},destroy:function(){var a=this.series.chart,d=a.hoverPoints,f;a.pointCount--;d&&(this.setState(),E(d,this),d.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)t(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);
	for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],d,f=6;f--;)d=a[f],this[d]&&(this[d]=this[d].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var d=this.series,g=d.tooltipOptions,b=u(g.valueDecimals,""),
	e=g.valuePrefix||"",l=g.valueSuffix||"";A(d.pointArrayMap||["y"],function(d){d="{point."+d;if(e||l)a=a.replace(d+"}",e+d+"}"+l);a=a.replace(d+"}",d+":,."+b+"f}")});return f(a,{point:this,series:this.series})},firePointEvent:function(a,d,f){var b=this,e=this.series.options;(e.point.events[a]||b.options&&b.options.events&&b.options.events[a])&&this.importEvents();"click"===a&&e.allowPointSelect&&(f=function(a){b.select&&b.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});m(this,a,d,f)},visible:!0}})(M);
	(function(a){var C=a.addEvent,A=a.animObject,F=a.arrayMax,E=a.arrayMin,m=a.correctFloat,f=a.Date,l=a.defaultOptions,r=a.defaultPlotOptions,u=a.defined,t=a.each,g=a.erase,d=a.extend,k=a.fireEvent,b=a.grep,e=a.isArray,v=a.isNumber,y=a.isString,n=a.merge,D=a.objectEach,J=a.pick,c=a.removeEvent,G=a.splat,q=a.SVGElement,B=a.syncTimeout,K=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,
	states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},
	halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,e,h=a.series,p;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();d(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});e=b.events;D(e,function(a,b){C(c,b,a)});if(e&&
	e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();t(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);h.length&&(p=h[h.length-1]);c._i=J(p&&p._i,-1)+1;a.orderSeries(this.insert(h))},insert:function(a){var b=this.options.index,c;if(v(b)){for(c=a.length;c--;)if(b>=J(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return J(c,
	a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,d;t(b.axisTypes||[],function(h){t(e[h],function(a){d=a.options;if(c[h]===d.index||void 0!==c[h]&&c[h]===d.id||void 0===c[h]&&0===d.index)b.insert(a.series),b[h]=a,a.isDirty=!0});b[h]||b.optionalAxis===h||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,e=arguments,d=v(b)?function(e){var d="y"===e&&c.toYData?c.toYData(a):a[e];c[e+"Data"][b]=d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(e,
	2))};t(c.parallelArrays,d)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,b=J(b,a.pointStart,0);this.pointInterval=c=J(this.pointInterval,a.pointInterval,1);e&&(a=new f(b),"day"===e?a=+a[f.hcSetDate](a[f.hcGetDate]()+c):"month"===e?a=+a[f.hcSetMonth](a[f.hcGetMonth]()+c):"year"===e&&(a=+a[f.hcSetFullYear](a[f.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,e=c.plotOptions,d=(b.userOptions||{}).plotOptions||
	{},p=e[this.type];this.userOptions=a;b=n(p,e.series,a);this.tooltipOptions=n(l.tooltip,l.plotOptions.series&&l.plotOptions.series.tooltip,l.plotOptions[this.type].tooltip,c.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,a.tooltip);this.stickyTracking=J(a.stickyTracking,d[this.type]&&d[this.type].stickyTracking,d.series&&d.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===p.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=
	(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&u(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return b},getCyclic:function(a,b,c){var e,d=this.chart,p=this.userOptions,f=a+"Index",g=a+"Counter",k=c?c.length:J(d.options.chart[a+"Count"],d[a+"Count"]);b||(e=J(p[f],p["_"+f]),u(e)||(d.series.length||
	(d[g]=0),p["_"+f]=e=d[g]%k,d[g]+=1),c&&(b=c[e]));void 0!==e&&(this[f]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||r[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,c,d,f){var h=this,p=h.points,g=p&&p.length||0,k,q=h.options,l=h.chart,n=null,m=h.xAxis,
	z=q.turboThreshold,r=this.xData,B=this.yData,I=(k=h.pointArrayMap)&&k.length;b=b||[];k=b.length;c=J(c,!0);if(!1!==f&&k&&g===k&&!h.cropped&&!h.hasGroupedData&&h.visible)t(b,function(a,b){p[b].update&&a!==q.data[b]&&p[b].update(a,!1,null,!1)});else{h.xIncrement=null;h.colorCounter=0;t(this.parallelArrays,function(a){h[a+"Data"].length=0});if(z&&k>z){for(d=0;null===n&&d<k;)n=b[d],d++;if(v(n))for(d=0;d<k;d++)r[d]=this.autoIncrement(),B[d]=b[d];else if(e(n))if(I)for(d=0;d<k;d++)n=b[d],r[d]=n[0],B[d]=n.slice(1,
	I+1);else for(d=0;d<k;d++)n=b[d],r[d]=n[0],B[d]=n[1];else a.error(12)}else for(d=0;d<k;d++)void 0!==b[d]&&(n={series:h},h.pointClass.prototype.applyOptions.apply(n,[b[d]]),h.updateParallelArrays(n,d));y(B[0])&&a.error(14,!0);h.data=[];h.options.data=h.userOptions.data=b;for(d=g;d--;)p[d]&&p[d].destroy&&p[d].destroy();m&&(m.minRange=m.userMinRange);h.isDirty=l.isDirtyBox=!0;h.isDirtyData=!!p;d=!1}"point"===q.legendType&&(this.processData(),this.generatePoints());c&&l.redraw(d)},processData:function(b){var c=
	this.xData,e=this.yData,d=c.length,h;h=0;var p,f,g=this.xAxis,k,q=this.options;k=q.cropThreshold;var n=this.getExtremesFromAll||q.getExtremesFromAll,l=this.isCartesian,q=g&&g.val2lin,m=g&&g.isLog,v,r;if(l&&!this.isDirty&&!g.isDirty&&!this.yAxis.isDirty&&!b)return!1;g&&(b=g.getExtremes(),v=b.min,r=b.max);if(l&&this.sorted&&!n&&(!k||d>k||this.forceCrop))if(c[d-1]<v||c[0]>r)c=[],e=[];else if(c[0]<v||c[d-1]>r)h=this.cropData(this.xData,this.yData,v,r),c=h.xData,e=h.yData,h=h.start,p=!0;for(k=c.length||
	1;--k;)d=m?q(c[k])-q(c[k-1]):c[k]-c[k-1],0<d&&(void 0===f||d<f)?f=d:0>d&&this.requireSorting&&a.error(15);this.cropped=p;this.cropStart=h;this.processedXData=c;this.processedYData=e;this.closestPointRange=f},cropData:function(a,b,c,e){var d=a.length,p=0,g=d,f=J(this.cropShoulder,1),k;for(k=0;k<d;k++)if(a[k]>=c){p=Math.max(0,k-f);break}for(c=k;c<d;c++)if(a[c]>e){g=c+f;break}return{xData:a.slice(p,g),yData:b.slice(p,g),start:p,end:g}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,
	e,d=this.processedXData,g=this.processedYData,f=this.pointClass,k=d.length,q=this.cropStart||0,n,l=this.hasGroupedData,a=a.keys,m,v=[],r;c||l||(c=[],c.length=b.length,c=this.data=c);a&&l&&(this.options.keys=!1);for(r=0;r<k;r++)n=q+r,l?(m=(new f).init(this,[d[r]].concat(G(g[r]))),m.dataGroup=this.groupMap[r]):(m=c[n])||void 0===b[n]||(c[n]=m=(new f).init(this,b[n],d[r])),m&&(m.index=n,v[r]=m);this.options.keys=a;if(c&&(k!==(e=c.length)||l))for(r=0;r<e;r++)r!==q||l||(r+=k),c[r]&&(c[r].destroyElements(),
	c[r].plotX=void 0);this.data=c;this.points=v},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,h=[],p=0;d=this.xAxis.getExtremes();var g=d.min,f=d.max,k,q,n,l;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(l=0;l<d;l++)if(q=c[l],n=a[l],k=(v(n,!0)||e(n))&&(!b.positiveValuesOnly||n.length||0<n),q=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[l]||q)>=g&&(c[l]||q)<=f,k&&q)if(k=n.length)for(;k--;)null!==n[k]&&(h[p++]=n[k]);else h[p++]=n;this.dataMin=
	E(h);this.dataMax=F(h)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,e=c.categories,d=this.yAxis,g=this.points,f=g.length,k=!!this.modifyValue,q=a.pointPlacement,n="between"===q||v(q),l=a.threshold,r=a.startFromThreshold?l:0,B,y,t,G,D=Number.MAX_VALUE;"between"===q&&(q=.5);v(q)&&(q*=J(a.pointRange||c.pointRange));for(a=0;a<f;a++){var K=g[a],A=K.x,C=K.y;y=K.low;var E=b&&d.stacks[(this.negStacks&&C<(r?0:l)?"-":"")+this.stackKey],
	F;d.positiveValuesOnly&&null!==C&&0>=C&&(K.isNull=!0);K.plotX=B=m(Math.min(Math.max(-1E5,c.translate(A,0,0,0,1,q,"flags"===this.type)),1E5));b&&this.visible&&!K.isNull&&E&&E[A]&&(G=this.getStackIndicator(G,A,this.index),F=E[A],C=F.points[G.key],y=C[0],C=C[1],y===r&&G.key===E[A].base&&(y=J(l,d.min)),d.positiveValuesOnly&&0>=y&&(y=null),K.total=K.stackTotal=F.total,K.percentage=F.total&&K.y/F.total*100,K.stackY=C,F.setOffset(this.pointXOffset||0,this.barW||0));K.yBottom=u(y)?d.translate(y,0,1,0,1):
	null;k&&(C=this.modifyValue(C,K));K.plotY=y="number"===typeof C&&Infinity!==C?Math.min(Math.max(-1E5,d.translate(C,0,1,0,1)),1E5):void 0;K.isInside=void 0!==y&&0<=y&&y<=d.len&&0<=B&&B<=c.len;K.clientX=n?m(c.translate(A,0,0,0,1,q)):B;K.negative=K.y<(l||0);K.category=e&&void 0!==e[K.x]?e[K.x]:K.x;K.isNull||(void 0!==t&&(D=Math.min(D,Math.abs(B-t))),t=B);K.zone=this.zones.length&&K.getZone()}this.closestPointRangePx=D},getValidPoints:function(a,c){var e=this.chart;return b(a||this.points||[],function(a){return c&&
	!e.isInsidePlot(a.plotX,a.plotY,e.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,e=b.renderer,d=b.inverted,p=this.clipBox,g=p||b.clipBox,f=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,c.xAxis,c.yAxis].join(),k=b[f],q=b[f+"m"];k||(a&&(g.width=0,b[f+"m"]=q=e.clipRect(-99,d?-b.plotLeft:-b.plotTop,99,d?b.chartWidth:b.chartHeight)),b[f]=k=e.clipRect(g),k.count={length:0});a&&!k.count[this.index]&&(k.count[this.index]=!0,k.count.length+=1);!1!==c.clip&&
	(this.group.clip(a||p?k:b.clipRect),this.markerGroup.clip(q),this.sharedClipKey=f);a||(k.count[this.index]&&(delete k.count[this.index],--k.count.length),0===k.count.length&&f&&b[f]&&(p||(b[f]=b[f].destroy()),b[f+"m"]&&(b[f+"m"]=b[f+"m"].destroy())))},animate:function(a){var b=this.chart,c=A(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();
	k(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,e,d,f,g=this.options.marker,k,q,n,l,m=this[this.specialGroup]||this.markerGroup,r=J(g.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*g.radius);if(!1!==g.enabled||this._hasPointMarkers)for(e=0;e<a.length;e++)d=a[e],c=d.plotY,f=d.graphic,k=d.marker||{},q=!!d.marker,n=r&&void 0===k.enabled||k.enabled,l=d.isInside,n&&v(c)&&null!==d.y?(c=J(k.symbol,this.symbol),d.hasImage=0===c.indexOf("url"),
	n=this.markerAttribs(d,d.selected&&"select"),f?f[l?"show":"hide"](!0).animate(n):l&&(0<n.width||d.hasImage)&&(d.graphic=f=b.renderer.symbol(c,n.x,n.y,n.width,n.height,q?k:g).add(m)),f&&f.attr(this.pointAttribs(d,d.selected&&"select")),f&&f.addClass(d.getClassName(),!0)):f&&(d.graphic=f.destroy())},markerAttribs:function(a,b){var c=this.options.marker,e=a.marker||{},d=J(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=J(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage&&(d=
	0);a={x:Math.floor(a.plotX)-d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,d=e&&e.marker||{},f=this.color,g=e&&e.color,p=a&&a.color,e=J(d.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;f=g||a||p||f;a=d.fillColor||c.fillColor||f;f=d.lineColor||c.lineColor||f;b&&(c=c.states[b],b=d.states&&d.states[b]||{},e=J(b.lineWidth,c.lineWidth,e+J(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,f=b.lineColor||c.lineColor||
	f);return{stroke:f,"stroke-width":e,fill:a}},destroy:function(){var a=this,b=a.chart,e=/AppleWebKit\/533/.test(K.navigator.userAgent),d,h,f=a.data||[],n,l;k(a,"destroy");c(a);t(a.axisTypes||[],function(b){(l=a[b])&&l.series&&(g(l.series,a),l.isDirty=l.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(h=f.length;h--;)(n=f[h])&&n.destroy&&n.destroy();a.points=null;clearTimeout(a.animationTimeout);D(a,function(a,b){a instanceof q&&!a.survive&&(d=e&&"group"===b?"hide":"destroy",a[d]())});
	b.hoverSeries===a&&(b.hoverSeries=null);g(b.series,a);b.orderSeries();D(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var e=this,d=e.options,f=d.step,g,p=[],k=[],q;a=a||e.points;(g=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&g&&(f=4-f);!d.connectNulls||b||c||(a=this.getValidPoints(a));t(a,function(h,g){var n=h.plotX,l=h.plotY,m=a[g-1];(h.leftCliff||m&&m.rightCliff)&&!c&&(q=!0);h.isNull&&!u(b)&&0<g?q=!d.connectNulls:h.isNull&&!b?q=!0:(0===g||q?g=["M",h.plotX,h.plotY]:e.getPointSpline?
	g=e.getPointSpline(a,h,g):f?(g=1===f?["L",m.plotX,l]:2===f?["L",(m.plotX+n)/2,m.plotY,"L",(m.plotX+n)/2,l]:["L",n,m.plotY],g.push("L",n,l)):g=["L",n,l],k.push(h.x),f&&k.push(h.x),p.push.apply(p,g),q=!1)});p.xMap=k;return e.graphPath=p},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];t(this.zones,function(c,d){e.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+
	(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});t(e,function(e,d){var h=e[0],f=a[h];f?(f.endX=c.xMap,f.animate({d:c})):c.length&&(a[h]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),f={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?f.dashstyle=e[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[h].attr(f).shadow(2>d&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},applyZones:function(){var a=
	this,b=this.chart,c=b.renderer,e=this.zones,d,f,g=this.clips||[],k,q=this.graph,n=this.area,l=Math.max(b.chartWidth,b.chartHeight),m=this[(this.zoneAxis||"y")+"Axis"],r,v,B=b.inverted,y,u,G,D,K=!1;e.length&&(q||n)&&m&&void 0!==m.min&&(v=m.reversed,y=m.horiz,q&&q.hide(),n&&n.hide(),r=m.getExtremes(),t(e,function(e,h){d=v?y?b.plotWidth:0:y?0:m.toPixels(r.min);d=Math.min(Math.max(J(f,d),0),l);f=Math.min(Math.max(Math.round(m.toPixels(J(e.value,r.max),!0)),0),l);K&&(d=f=m.toPixels(r.max));u=Math.abs(d-
	f);G=Math.min(d,f);D=Math.max(d,f);m.isXAxis?(k={x:B?D:G,y:0,width:u,height:l},y||(k.x=b.plotHeight-k.x)):(k={x:0,y:B?D:G,width:l,height:u},y&&(k.y=b.plotWidth-k.y));B&&c.isVML&&(k=m.isXAxis?{x:0,y:v?G:D,height:k.width,width:b.chartWidth}:{x:k.y-b.plotLeft-b.spacingBox.x,y:0,width:k.height,height:b.chartHeight});g[h]?g[h].animate(k):(g[h]=c.clipRect(k),q&&a["zone-graph-"+h].clip(g[h]),n&&a["zone-area-"+h].clip(g[h]));K=e.value>r.max}),this.clips=g)},invertGroups:function(a){function b(){t(["group",
	"markerGroup"],function(b){c[b]&&(e.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e=c.chart,d;c.xAxis&&(d=C(e,"resize",b),C(c,"destroy",d),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,d){var h=this[a],f=!h;f&&(this[a]=h=this.chart.renderer.g().attr({zIndex:e||.1}).add(d));h.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+
	" "+(this.options.className||""),!0);h.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return h},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&A(e.animation).duration,f=a.visible?"inherit":"hidden",g=e.zIndex,k=a.hasRendered,q=b.seriesGroup,n=b.inverted;c=a.plotGroup("group",
	"series",f,g,q);a.markerGroup=a.plotGroup("markerGroup","markers",f,g,q);d&&a.animate(!0);c.inverted=a.isCartesian?n:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(n);!1===e.clip||a.sharedClipKey||k||c.clip(b.clipRect);d&&a.animate();k||(a.animationTimeout=B(function(){a.afterAnimate()},d));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,
	b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,d=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:J(e&&e.left,a.plotLeft),translateY:J(d&&d.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},
	buildKDTree:function(){function a(c,e,d){var h,f;if(f=c&&c.length)return h=b.kdAxisArray[e%d],c.sort(function(a,b){return a[h]-b[h]}),f=Math.floor(f/2),{point:c[f],left:a(c.slice(0,f),e+1,d),right:a(c.slice(f+1),e+1,d)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;B(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,h,k){var p=b.point,q=e.kdAxisArray[h%
	k],n,l,m=p;l=u(a[d])&&u(p[d])?Math.pow(a[d]-p[d],2):null;n=u(a[f])&&u(p[f])?Math.pow(a[f]-p[f],2):null;n=(l||0)+(n||0);p.dist=u(n)?Math.sqrt(n):Number.MAX_VALUE;p.distX=u(l)?Math.sqrt(l):Number.MAX_VALUE;q=a[q]-p[q];n=0>q?"left":"right";l=0>q?"right":"left";b[n]&&(n=c(a,b[n],h+1,k),m=n[g]<m[g]?n:p);b[l]&&Math.sqrt(q*q)<m[g]&&(a=c(a,b[l],h+1,k),m=a[g]<m[g]?a:m);return m}var e=this,d=this.kdAxisArray[0],f=this.kdAxisArray[1],g=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||
	this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(M);(function(a){var C=a.Axis,A=a.Chart,F=a.correctFloat,E=a.defined,m=a.destroyObjectProperties,f=a.each,l=a.format,r=a.objectEach,u=a.pick,t=a.Series;a.StackItem=function(a,d,f,b,e){var g=a.chart.inverted;this.axis=a;this.isNegative=f;this.options=d;this.x=b;this.total=null;this.points={};this.stack=e;this.rightCliff=this.leftCliff=0;this.alignOptions={align:d.align||(g?f?"left":"right":"center"),verticalAlign:d.verticalAlign||
	(g?"middle":f?"bottom":"top"),y:u(d.y,g?4:f?14:-6),x:u(d.x,g?f?-6:6:0)};this.textAlign=d.textAlign||(g?f?"right":"left":"center")};a.StackItem.prototype={destroy:function(){m(this,this.axis)},render:function(a){var d=this.options,f=d.format,f=f?l(f,this):d.formatter.call(this);this.label?this.label.attr({text:f,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(f,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,
	d){var f=this.axis,b=f.chart,e=f.translate(f.usePercentage?100:this.total,0,0,0,1),f=f.translate(0),f=Math.abs(e-f);a=b.xAxis[0].translate(this.x)+a;e=this.getStackBox(b,this,a,e,d,f);if(d=this.label)d.align(this.alignOptions,null,e),e=d.alignAttr,d[!1===this.options.crop||b.isInsidePlot(e.x,e.y)?"show":"hide"](!0)},getStackBox:function(a,d,f,b,e,l){var g=d.axis.reversed,k=a.inverted;a=a.plotHeight;d=d.isNegative&&!g||!d.isNegative&&g;return{x:k?d?b:b-l:f,y:k?a-f-e:d?a-b-l:a-b,width:k?l:e,height:k?
	e:l}}};A.prototype.getStacks=function(){var a=this;f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(d){!d.options.stacking||!0!==d.visible&&!1!==a.options.chart.ignoreHiddenSeries||(d.stackKey=d.type+u(d.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,d=u(this.options.reversedStacks,!0),f=a.length,b;if(!this.isXAxis){this.usePercentage=!1;for(b=f;b--;)a[d?b:f-b-1].setStackedPoints();if(this.usePercentage)for(b=0;b<f;b++)a[b].setPercentStacks()}};
	C.prototype.renderStackTotals=function(){var a=this.chart,d=a.renderer,f=this.stacks,b=this.stackTotalGroup;b||(this.stackTotalGroup=b=d.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());b.translate(a.plotLeft,a.plotTop);r(f,function(a){r(a,function(a){a.render(b)})})};C.prototype.resetStacks=function(){var a=this,d=a.stacks;a.isXAxis||r(d,function(d){r(d,function(b,e){b.touched<a.stacksTouched?(b.destroy(),delete d[e]):(b.total=null,b.cum=null)})})};C.prototype.cleanStacks=function(){var a;
	this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),r(a,function(a){r(a,function(a){a.cum=a.total})}))};t.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var f=this.processedXData,d=this.processedYData,k=[],b=d.length,e=this.options,l=e.threshold,m=e.startFromThreshold?l:0,n=e.stack,e=e.stacking,r=this.stackKey,t="-"+r,c=this.negStacks,G=this.yAxis,q=G.stacks,B=G.oldStacks,K,p,z,I,A,h,w;G.stacksTouched+=
	1;for(A=0;A<b;A++)h=f[A],w=d[A],K=this.getStackIndicator(K,h,this.index),I=K.key,z=(p=c&&w<(m?0:l))?t:r,q[z]||(q[z]={}),q[z][h]||(B[z]&&B[z][h]?(q[z][h]=B[z][h],q[z][h].total=null):q[z][h]=new a.StackItem(G,G.options.stackLabels,p,h,n)),z=q[z][h],null!==w&&(z.points[I]=z.points[this.index]=[u(z.cum,m)],E(z.cum)||(z.base=I),z.touched=G.stacksTouched,0<K.index&&!1===this.singleStacks&&(z.points[I][0]=z.points[this.index+","+h+",0"][0])),"percent"===e?(p=p?r:t,c&&q[p]&&q[p][h]?(p=q[p][h],z.total=p.total=
	Math.max(p.total,z.total)+Math.abs(w)||0):z.total=F(z.total+(Math.abs(w)||0))):z.total=F(z.total+(w||0)),z.cum=u(z.cum,m)+(w||0),null!==w&&(z.points[I].push(z.cum),k[A]=z.cum);"percent"===e&&(G.usePercentage=!0);this.stackedYData=k;G.oldStacks={}}};t.prototype.setPercentStacks=function(){var a=this,d=a.stackKey,k=a.yAxis.stacks,b=a.processedXData,e;f([d,"-"+d],function(d){for(var f=b.length,g,l;f--;)if(g=b[f],e=a.getStackIndicator(e,g,a.index,d),g=(l=k[d]&&k[d][g])&&l.points[e.key])l=l.total?100/
	l.total:0,g[0]=F(g[0]*l),g[1]=F(g[1]*l),a.stackedYData[f]=g[1]})};t.prototype.getStackIndicator=function(a,d,f,b){!E(a)||a.x!==d||b&&a.key!==b?a={x:d,index:0,key:b}:a.index++;a.key=[f,d,a.index].join();return a}})(M);(function(a){var C=a.addEvent,A=a.animate,F=a.Axis,E=a.createElement,m=a.css,f=a.defined,l=a.each,r=a.erase,u=a.extend,t=a.fireEvent,g=a.inArray,d=a.isNumber,k=a.isObject,b=a.isArray,e=a.merge,v=a.objectEach,y=a.pick,n=a.Point,D=a.Series,J=a.seriesTypes,c=a.setAnimation,G=a.splat;u(a.Chart.prototype,
	{addSeries:function(a,b,c){var e,d=this;a&&(b=y(b,!0),t(d,"addSeries",{options:a},function(){e=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();b&&d.redraw(c)}));return e},addAxis:function(a,b,c,d){var f=b?"xAxis":"yAxis",g=this.options;a=e(a,{index:this[f].length,isX:b});b=new F(this,a);g[f]=G(g[f]||{});g[f].push(a);y(c,!0)&&this.redraw(d);return b},showLoading:function(a){var b=this,c=b.options,e=b.loadingDiv,d=c.loading,f=function(){e&&m(e,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+
	"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=E("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=E("span",{className:"highcharts-loading-inner"},null,e),C(b,"redraw",f));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;m(e,u(d.style,{zIndex:10}));m(b.loadingSpan,d.labelStyle);b.loadingShown||(m(e,{opacity:0,display:""}),A(e,{opacity:d.style.opacity||.5},{duration:d.showDuration||0}));b.loadingShown=!0;f()},hideLoading:function(){var a=
	this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){m(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),update:function(a,b,c){var k=this,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},q=a.chart,m,h,r=[];if(q){e(!0,k.options.chart,q);"className"in q&&k.setClassName(q.className);if("inverted"in q||"polar"in q)k.propFromSeries(),m=!0;"alignTicks"in q&&(m=!0);v(q,function(a,b){-1!==g("chart."+b,k.propsRequireUpdateSeries)&&(h=!0);-1!==g(b,k.propsRequireDirtyBox)&&
	(k.isDirtyBox=!0)});"style"in q&&k.renderer.setStyle(q.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&e(!0,this.options.plotOptions,a.plotOptions);v(a,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,!1);else if("function"===typeof k[n[b]])k[n[b]](a);"chart"!==b&&-1!==g(b,k.propsRequireUpdateSeries)&&(h=!0)});l("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){a[b]&&(l(G(a[b]),function(a,e){(e=f(a.id)&&k.get(a.id)||k[b][e])&&e.coll===b&&(e.update(a,
	!1),c&&(e.touched=!0));if(!e&&c)if("series"===b)k.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)k.addAxis(a,"xAxis"===b,!1).touched=!0}),c&&l(k[b],function(a){a.touched?delete a.touched:r.push(a)}))});l(r,function(a){a.remove(!1)});m&&l(k.axes,function(a){a.update({},!1)});h&&l(k.series,function(a){a.update({},!1)});a.loading&&e(!0,k.options.loading,a.loading);m=q&&q.width;q=q&&q.height;d(m)&&m!==k.chartWidth||d(q)&&q!==k.chartHeight?k.setSize(m,q):y(b,!0)&&k.redraw()},setSubtitle:function(a){this.setTitle(void 0,
	a)}});u(n.prototype,{update:function(a,b,c,e){function d(){f.applyOptions(a);null===f.y&&h&&(f.graphic=h.destroy());k(a,!0)&&(h&&h.element&&a&&a.marker&&void 0!==a.marker.symbol&&(f.graphic=h.destroy()),a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));p=f.index;g.updateParallelArrays(f,p);q.data[p]=k(q.data[p],!0)||k(a,!0)?f.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===q.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(c)}var f=
	this,g=f.series,h=f.graphic,p,l=g.chart,q=g.options;b=y(b,!0);!1===e?d():f.firePointEvent("update",{options:a},d)},remove:function(a,b){this.series.removePoint(g(this,this.series.data),a,b)}});u(D.prototype,{addPoint:function(a,b,c,e){var d=this.options,f=this.data,g=this.chart,h=this.xAxis,h=h&&h.hasNames&&h.names,k=d.data,p,l,q=this.xData,n,m;b=y(b,!0);p={series:this};this.pointClass.prototype.applyOptions.apply(p,[a]);m=p.x;n=q.length;if(this.requireSorting&&m<q[n-1])for(l=!0;n&&q[n-1]>m;)n--;
	this.updateParallelArrays(p,"splice",n,0,0);this.updateParallelArrays(p,n);h&&p.name&&(h[m]=p.name);k.splice(n,0,a);l&&(this.data.splice(n,0,null),this.processData());"point"===d.legendType&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(p,"shift"),k.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(e)},removePoint:function(a,b,e){var d=this,f=d.data,g=f[a],k=d.points,h=d.chart,l=function(){k&&k.length===f.length&&k.splice(a,1);f.splice(a,1);
	d.options.data.splice(a,1);d.updateParallelArrays(g||{series:d},"splice",a,1);g&&g.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&h.redraw()};c(e,h);b=y(b,!0);g?g.firePointEvent("remove",null,l):l()},remove:function(a,b,c){function e(){d.destroy();f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();y(a,!0)&&f.redraw(b)}var d=this,f=d.chart;!1!==c?t(d,"remove",null,e):e()},update:function(a,b){var c=this,d=c.chart,f=c.userOptions,g=c.oldType||c.type,k=a.type||f.type||d.options.chart.type,h=J[g].prototype,n,
	q=["group","markerGroup","dataLabelsGroup","navigatorSeries","baseSeries"],m=c.finishedAnimating&&{animation:!1};if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,b);if(k&&k!==g||void 0!==a.zIndex)q.length=0;l(q,function(a){q[a]=c[a];delete c[a]});a=e(f,m,{index:c.index,pointStart:c.xData[0]},{data:c.options.data},a);c.remove(!1,null,!1);for(n in h)c[n]=void 0;u(c,J[k||g].prototype);l(q,function(a){c[a]=q[a]});c.init(d,a);c.oldType=g;d.linkSeries();y(b,!0)&&d.redraw(!1)}});
	u(F.prototype,{update:function(a,b){var c=this.chart;a=c.options[this.coll][this.options.index]=e(this.userOptions,a);this.destroy(!0);this.init(c,u(a,{events:void 0}));c.isDirtyBox=!0;y(b,!0)&&c.redraw()},remove:function(a){for(var c=this.chart,e=this.coll,d=this.series,f=d.length;f--;)d[f]&&d[f].remove(!1);r(c.axes,this);r(c[e],this);b(c.options[e])?c.options[e].splice(this.options.index,1):delete c.options[e];l(c[e],function(a,b){a.options.index=b});this.destroy();c.isDirtyBox=!0;y(a,!0)&&c.redraw()},
	setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(M);(function(a){var C=a.color,A=a.each,F=a.map,E=a.pick,m=a.Series,f=a.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(f){var l=[],m=[],t=this.xAxis,g=this.yAxis,d=g.stacks[this.stackKey],k={},b=this.index,e=g.series,v=e.length,y,n=E(g.options.reversedStacks,!0)?1:-1,D;f=f||this.points;if(this.options.stacking){for(D=0;D<f.length;D++)k[f[D].x]=
	f[D];a.objectEach(d,function(a,b){null!==a.total&&m.push(b)});m.sort(function(a,b){return a-b});y=F(e,function(){return this.visible});A(m,function(a,c){var e=0,f,r;if(k[a]&&!k[a].isNull)l.push(k[a]),A([-1,1],function(e){var g=1===e?"rightNull":"leftNull",l=0,q=d[m[c+e]];if(q)for(D=b;0<=D&&D<v;)f=q.points[D],f||(D===b?k[a][g]=!0:y[D]&&(r=d[a].points[D])&&(l-=r[1]-r[0])),D+=n;k[a][1===e?"rightCliff":"leftCliff"]=l});else{for(D=b;0<=D&&D<v;){if(f=d[a].points[D]){e=f[1];break}D+=n}e=g.translate(e,0,
	1,0,1);l.push({isNull:!0,plotX:t.translate(a,0,0,0,1),x:a,plotY:e,yBottom:e})}})}return l},getGraphPath:function(a){var f=m.prototype.getGraphPath,l=this.options,t=l.stacking,g=this.yAxis,d,k,b=[],e=[],v=this.index,y,n=g.stacks[this.stackKey],D=l.threshold,A=g.getThreshold(l.threshold),c,l=l.connectNulls||"percent"===t,G=function(c,d,f){var k=a[c];c=t&&n[k.x].points[v];var l=k[f+"Null"]||0;f=k[f+"Cliff"]||0;var q,m,k=!0;f||l?(q=(l?c[0]:c[1])+f,m=c[0]+f,k=!!l):!t&&a[d]&&a[d].isNull&&(q=m=D);void 0!==
	q&&(e.push({plotX:y,plotY:null===q?A:g.getThreshold(q),isNull:k,isCliff:!0}),b.push({plotX:y,plotY:null===m?A:g.getThreshold(m),doCurve:!1}))};a=a||this.points;t&&(a=this.getStackPoints(a));for(d=0;d<a.length;d++)if(k=a[d].isNull,y=E(a[d].rectPlotX,a[d].plotX),c=E(a[d].yBottom,A),!k||l)l||G(d,d-1,"left"),k&&!t&&l||(e.push(a[d]),b.push({x:d,plotX:y,plotY:c})),l||G(d,d+1,"right");d=f.call(this,e,!0,!0);b.reversed=!0;k=f.call(this,b,!0,!0);k.length&&(k[0]="L");k=d.concat(k);f=f.call(this,e,!1,l);k.xMap=
	d.xMap;this.areaPath=k;return f},drawGraph:function(){this.areaPath=[];m.prototype.drawGraph.apply(this);var a=this,f=this.areaPath,u=this.options,t=[["area","highcharts-area",this.color,u.fillColor]];A(this.zones,function(f,d){t.push(["zone-area-"+d,"highcharts-area highcharts-zone-area-"+d+" "+f.className,f.color||a.color,f.fillColor||u.fillColor])});A(t,function(g){var d=g[0],k=a[d];k?(k.endX=f.xMap,k.animate({d:f})):(k=a[d]=a.chart.renderer.path(f).addClass(g[1]).attr({fill:E(g[3],C(g[2]).setOpacity(E(u.fillOpacity,
	.75)).get()),zIndex:0}).add(a.group),k.isArea=!0);k.startX=f.xMap;k.shiftUnit=u.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,F,E){var m=F.plotX,f=F.plotY,l=a[E-1];E=a[E+1];var r,u,t,g;if(l&&!l.isNull&&!1!==l.doCurve&&!F.isCliff&&E&&!E.isNull&&!1!==E.doCurve&&!F.isCliff){a=l.plotY;t=E.plotX;E=E.plotY;var d=0;r=(1.5*m+l.plotX)/2.5;u=(1.5*f+a)/2.5;t=(1.5*m+t)/2.5;g=(1.5*f+E)/2.5;t!==r&&(d=
	(g-u)*(t-m)/(t-r)+f-g);u+=d;g+=d;u>a&&u>f?(u=Math.max(a,f),g=2*f-u):u<a&&u<f&&(u=Math.min(a,f),g=2*f-u);g>E&&g>f?(g=Math.max(E,f),u=2*f-g):g<E&&g<f&&(g=Math.min(E,f),u=2*f-g);F.rightContX=t;F.rightContY=g}F=["C",C(l.rightContX,l.plotX),C(l.rightContY,l.plotY),C(r,m),C(u,f),m,f];l.rightContX=l.rightContY=null;return F}})})(M);(function(a){var C=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,
	drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var C=a.animObject,A=a.color,F=a.each,E=a.extend,m=a.isNumber,f=a.merge,l=a.pick,r=a.Series,u=a.seriesType,t=a.svg;u("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},
	softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){r.prototype.init.apply(this,arguments);var a=this,d=a.chart;d.hasRendered&&F(d.series,function(d){d.type===a.type&&(d.isDirty=!0)})},getColumnMetrics:function(){var a=this,d=a.options,f=a.xAxis,b=a.yAxis,e=f.reversed,m,r={},n=0;!1===d.grouping?n=1:F(a.chart.series,function(c){var e=c.options,
	d=c.yAxis,f;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||b.len!==d.len||b.pos!==d.pos||(e.stacking?(m=c.stackKey,void 0===r[m]&&(r[m]=n++),f=r[m]):!1!==e.grouping&&(f=n++),c.columnIndex=f)});var t=Math.min(Math.abs(f.transA)*(f.ordinalSlope||d.pointRange||f.closestPointRange||f.tickInterval||1),f.len),u=t*d.groupPadding,c=(t-2*u)/(n||1),d=Math.min(d.maxPointWidth||f.len,l(d.pointWidth,c*(1-2*d.pointPadding)));a.columnMetrics={width:d,offset:(c-d)/2+(u+((a.columnIndex||0)+
	(e?1:0))*c-t/2)*(e?-1:1)};return a.columnMetrics},crispCol:function(a,d,f,b){var e=this.chart,g=this.borderWidth,k=-(g%2?.5:0),g=g%2?.5:1;e.inverted&&e.renderer.isVML&&(g+=1);this.options.crisp&&(f=Math.round(a+f)+k,a=Math.round(a)+k,f-=a);b=Math.round(d+b)+g;k=.5>=Math.abs(d)&&.5<b;d=Math.round(d)+g;b-=d;k&&b&&(--d,b+=1);return{x:a,y:d,width:f,height:b}},translate:function(){var a=this,d=a.chart,f=a.options,b=a.dense=2>a.closestPointRange*a.xAxis.transA,b=a.borderWidth=l(f.borderWidth,b?0:1),e=a.yAxis,
	m=a.translatedThreshold=e.getThreshold(f.threshold),t=l(f.minPointLength,5),n=a.getColumnMetrics(),u=n.width,A=a.barW=Math.max(u,1+2*b),c=a.pointXOffset=n.offset;d.inverted&&(m-=.5);f.pointPadding&&(A=Math.ceil(A));r.prototype.translate.apply(a);F(a.points,function(b){var f=l(b.yBottom,m),g=999+Math.abs(f),g=Math.min(Math.max(-g,b.plotY),e.len+g),k=b.plotX+c,n=A,r=Math.min(g,f),v,y=Math.max(g,f)-r;Math.abs(y)<t&&t&&(y=t,v=!e.reversed&&!b.negative||e.reversed&&b.negative,r=Math.abs(r-m)>t?f-t:m-(v?
	t:0));b.barX=k;b.pointWidth=u;b.tooltipPos=d.inverted?[e.len+e.pos-d.plotLeft-g,a.xAxis.len-k-n/2,y]:[k+n/2,g+e.pos-d.plotTop,y];b.shapeType="rect";b.shapeArgs=a.crispCol.apply(a,b.isNull?[k,m,n,0]:[k,r,n,y])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,d){var g=this.options,b,e=this.pointAttrToOptions||{};b=e.stroke||"borderColor";var l=e["stroke-width"]||
	"borderWidth",m=a&&a.color||this.color,n=a[b]||g[b]||this.color||m,r=a[l]||g[l]||this[l]||0,e=g.dashStyle;a&&this.zones.length&&(m=a.getZone(),m=a.options.color||m&&m.color||this.color);d&&(a=f(g.states[d],a.options.states&&a.options.states[d]||{}),d=a.brightness,m=a.color||void 0!==d&&A(m).brighten(a.brightness).get()||m,n=a[b]||n,r=a[l]||r,e=a.dashStyle||e);b={fill:m,stroke:n,"stroke-width":r};e&&(b.dashstyle=e);return b},drawPoints:function(){var a=this,d=this.chart,k=a.options,b=d.renderer,e=
	k.animationLimit||250,l;F(a.points,function(g){var n=g.graphic;if(m(g.plotY)&&null!==g.y){l=g.shapeArgs;if(n)n[d.pointCount<e?"animate":"attr"](f(l));else g.graphic=n=b[g.shapeType](l).add(g.group||a.group);k.borderRadius&&n.attr({r:k.borderRadius});n.attr(a.pointAttribs(g,g.selected&&"select")).shadow(k.shadow,null,k.stacking&&!k.borderRadius);n.addClass(g.getClassName(),!0)}else n&&(g.graphic=n.destroy())})},animate:function(a){var d=this,f=this.yAxis,b=d.options,e=this.chart.inverted,g={};t&&(a?
	(g.scaleY=.001,a=Math.min(f.pos+f.len,Math.max(f.pos,f.toPixels(b.threshold))),e?g.translateX=a-f.len:g.translateY=a,d.group.attr(g)):(g[e?"translateX":"translateY"]=f.pos,d.group.animate(g,E(C(d.options.animation),{step:function(a,b){d.group.attr({scaleY:Math.max(.001,b.pos)})}})),d.animate=null))},remove:function(){var a=this,d=a.chart;d.hasRendered&&F(d.series,function(d){d.type===a.type&&(d.isDirty=!0)});r.prototype.remove.apply(a,arguments)}})})(M);(function(a){a=a.seriesType;a("bar","column",
	null,{inverted:!0})})(M);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],
	takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(M);(function(a){var C=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,E=this.chart,m=2*(a.slicedOffset||0),f=E.plotWidth-2*m,E=E.plotHeight-2*m,l=a.center,l=[C(l[0],"50%"),C(l[1],"50%"),a.size||"100%",a.innerSize||0],r=Math.min(f,E),u,t;for(u=0;4>u;++u)t=l[u],a=2>u||2===u&&/%$/.test(t),l[u]=A(t,[f,E,r,l[2]][u])+(a?m:0);l[3]>l[2]&&(l[3]=l[2]);return l}}})(M);
	(function(a){var C=a.addEvent,A=a.defined,F=a.each,E=a.extend,m=a.inArray,f=a.noop,l=a.pick,r=a.Point,u=a.Series,t=a.seriesType,g=a.setAnimation;t("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,
	shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var d=this,b=d.points,e=d.startAngleRad;a||(F(b,function(a){var b=a.graphic,f=a.shapeArgs;b&&(b.attr({r:a.startR||d.center[3]/2,start:e,end:e}),b.animate({r:f.r,start:f.start,end:f.end},d.options.animation))}),d.animate=null)},updateTotals:function(){var a,f=0,b=this.points,e=b.length,g,
	l=this.options.ignoreHiddenPoint;for(a=0;a<e;a++)g=b[a],f+=l&&!g.visible?0:g.isNull?0:g.y;this.total=f;for(a=0;a<e;a++)g=b[a],g.percentage=0<f&&(g.visible||!l)?g.y/f*100:0,g.total=f},generatePoints:function(){u.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var d=0,b=this.options,e=b.slicedOffset,f=e+(b.borderWidth||0),g,n,m,r=b.startAngle||0,c=this.startAngleRad=Math.PI/180*(r-90),r=(this.endAngleRad=Math.PI/180*(l(b.endAngle,r+360)-90))-c,t=
	this.points,q,B=b.dataLabels.distance,b=b.ignoreHiddenPoint,u,p=t.length,z;a||(this.center=a=this.getCenter());this.getX=function(b,c,e){m=Math.asin(Math.min((b-a[1])/(a[2]/2+e.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(m)*(a[2]/2+e.labelDistance)};for(u=0;u<p;u++){z=t[u];z.labelDistance=l(z.options.dataLabels&&z.options.dataLabels.distance,B);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,z.labelDistance);g=c+d*r;if(!b||z.visible)d+=z.percentage/100;n=c+d*r;z.shapeType="arc";z.shapeArgs=
	{x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*g)/1E3,end:Math.round(1E3*n)/1E3};m=(n+g)/2;m>1.5*Math.PI?m-=2*Math.PI:m<-Math.PI/2&&(m+=2*Math.PI);z.slicedTranslation={translateX:Math.round(Math.cos(m)*e),translateY:Math.round(Math.sin(m)*e)};n=Math.cos(m)*a[2]/2;q=Math.sin(m)*a[2]/2;z.tooltipPos=[a[0]+.7*n,a[1]+.7*q];z.half=m<-Math.PI/2||m>Math.PI/2?1:0;z.angle=m;g=Math.min(f,z.labelDistance/5);z.labelPos=[a[0]+n+Math.cos(m)*z.labelDistance,a[1]+q+Math.sin(m)*z.labelDistance,a[0]+n+Math.cos(m)*
	g,a[1]+q+Math.sin(m)*g,a[0]+n,a[1]+q,0>z.labelDistance?"center":z.half?"right":"left",m]}},drawGraph:null,drawPoints:function(){var a=this,f=a.chart.renderer,b,e,g,l,n=a.options.shadow;n&&!a.shadowGroup&&(a.shadowGroup=f.g("shadow").add(a.group));F(a.points,function(d){if(!d.isNull){e=d.graphic;l=d.shapeArgs;b=d.getTranslate();var k=d.shadowGroup;n&&!k&&(k=d.shadowGroup=f.g("shadow").add(a.shadowGroup));k&&k.attr(b);g=a.pointAttribs(d,d.selected&&"select");e?e.setRadialReference(a.center).attr(g).animate(E(l,
	b)):(d.graphic=e=f[d.shapeType](l).setRadialReference(a.center).attr(b).add(a.group),d.visible||e.attr({visibility:"hidden"}),e.attr(g).attr({"stroke-linejoin":"round"}).shadow(n,k));e.addClass(d.getClassName())}})},searchPoint:f,sortByAngle:function(a,f){a.sort(function(a,e){return void 0!==a.angle&&(e.angle-a.angle)*f})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:f},{init:function(){r.prototype.init.apply(this,arguments);var a=this,f;a.name=
	l(a.name,"Slice");f=function(b){a.slice("select"===b.type)};C(a,"select",f);C(a,"unselect",f);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,f){var b=this,e=b.series,d=e.chart,g=e.options.ignoreHiddenPoint;f=l(f,g);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,e.options.data[m(b,e.data)]=b.options,F(["graphic","dataLabel","connector","shadowGroup"],function(e){if(b[e])b[e][a?"show":"hide"](!0)}),b.legendItem&&d.legend.colorizeItem(b,
	a),a||"hover"!==b.state||b.setState(""),g&&(e.isDirty=!0),f&&d.redraw())},slice:function(a,f,b){var e=this.series;g(b,e.chart);l(f,!0);this.sliced=this.options.sliced=A(a)?a:!this.sliced;e.options.data[m(this,e.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var d=this.shapeArgs;return this.sliced||!this.visible?
	[]:this.series.chart.renderer.symbols.arc(d.x,d.y,d.r+a,d.r+a,{innerR:this.shapeArgs.r,start:d.start,end:d.end})}})})(M);(function(a){var C=a.addEvent,A=a.arrayMax,F=a.defined,E=a.each,m=a.extend,f=a.format,l=a.map,r=a.merge,u=a.noop,t=a.pick,g=a.relativeLength,d=a.Series,k=a.seriesTypes,b=a.stableSort;a.distribute=function(a,d){function e(a,b){return a.target-b.target}var f,g=!0,k=a,c=[],m;m=0;for(f=a.length;f--;)m+=a[f].size;if(m>d){b(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(m=f=0;m<=
	d;)m+=a[f].size,f++;c=a.splice(f-1,a.length)}b(a,e);for(a=l(a,function(a){return{size:a.size,targets:[a.target]}});g;){for(f=a.length;f--;)g=a[f],m=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=Math.min(Math.max(0,m-g.size/2),d-g.size);f=a.length;for(g=!1;f--;)0<f&&a[f-1].pos+a[f-1].size>a[f].pos&&(a[f-1].size+=a[f].size,a[f-1].targets=a[f-1].targets.concat(a[f].targets),a[f-1].pos+a[f-1].size>d&&(a[f-1].pos=d-a[f-1].size),a.splice(f,1),g=!0)}f=0;E(a,function(a){var b=0;E(a.targets,
	function(){k[f].pos=a.pos+b;b+=k[f].size;f++})});k.push.apply(k,c);b(k,e)};d.prototype.drawDataLabels=function(){var b=this,d=b.options,g=d.dataLabels,k=b.points,l,m,c=b.hasRendered||0,u,q,B=t(g.defer,!!d.animation),A=b.chart.renderer;if(g.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(g),q=b.plotGroup("dataLabelsGroup","data-labels",B&&!c?"hidden":"visible",g.zIndex||6),B&&(q.attr({opacity:+c}),c||C(b,"afterAnimate",function(){b.visible&&q.show(!0);q[d.animation?"animate":"attr"]({opacity:1},
	{duration:200})})),m=g,E(k,function(c){var e,k=c.dataLabel,n,h,p=c.connector,v=!k,B;l=c.dlOptions||c.options&&c.options.dataLabels;if(e=t(l&&l.enabled,m.enabled)&&null!==c.y)g=r(m,l),n=c.getLabelConfig(),u=g.format?f(g.format,n):g.formatter.call(n,g),B=g.style,n=g.rotation,B.color=t(g.color,B.color,b.color,"#000000"),"contrast"===B.color&&(c.contrastColor=A.getContrast(c.color||b.color),B.color=g.inside||0>t(c.labelDistance,g.distance)||d.stacking?c.contrastColor:"#000000"),d.cursor&&(B.cursor=d.cursor),
	h={fill:g.backgroundColor,stroke:g.borderColor,"stroke-width":g.borderWidth,r:g.borderRadius||0,rotation:n,padding:g.padding,zIndex:1},a.objectEach(h,function(a,b){void 0===a&&delete h[b]});!k||e&&F(u)?e&&F(u)&&(k?h.text=u:(k=c.dataLabel=A[n?"text":"label"](u,0,-9999,g.shape,null,null,g.useHTML,null,"data-label"),k.addClass("highcharts-data-label-color-"+c.colorIndex+" "+(g.className||"")+(g.useHTML?"highcharts-tracker":""))),k.attr(h),k.css(B).shadow(g.shadow),k.added||k.add(q),b.alignDataLabel(c,
	k,g,null,v)):(c.dataLabel=k=k.destroy(),p&&(c.connector=p.destroy()))})};d.prototype.alignDataLabel=function(a,b,d,f,g){var e=this.chart,c=e.inverted,k=t(a.plotX,-9999),l=t(a.plotY,-9999),n=b.getBBox(),r,p=d.rotation,v=d.align,u=this.visible&&(a.series.forceDL||e.isInsidePlot(k,Math.round(l),c)||f&&e.isInsidePlot(k,c?f.x+1:f.y+f.height-1,c)),y="justify"===t(d.overflow,"justify");if(u&&(r=d.style.fontSize,r=e.renderer.fontMetrics(r,b).b,f=m({x:c?this.yAxis.len-l:k,y:Math.round(c?this.xAxis.len-k:l),
	width:0,height:0},f),m(d,{width:n.width,height:n.height}),p?(y=!1,k=e.renderer.rotCorr(r,p),k={x:f.x+d.x+f.width/2+k.x,y:f.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*f.height},b[g?"attr":"animate"](k).attr({align:v}),l=(p+720)%360,l=180<l&&360>l,"left"===v?k.y-=l?n.height:0:"center"===v?(k.x-=n.width/2,k.y-=n.height/2):"right"===v&&(k.x-=n.width,k.y-=l?0:n.height)):(b.align(d,null,f),k=b.alignAttr),y?a.isLabelJustified=this.justifyDataLabel(b,d,k,n,f,g):t(d.crop,!0)&&(u=e.isInsidePlot(k.x,
	k.y)&&e.isInsidePlot(k.x+n.width,k.y+n.height)),d.shape&&!p))b[g?"attr":"animate"]({anchorX:c?e.plotWidth-a.plotY:a.plotX,anchorY:c?e.plotHeight-a.plotX:a.plotY});u||(b.attr({y:-9999}),b.placed=!1)};d.prototype.justifyDataLabel=function(a,b,d,f,g,k){var c=this.chart,e=b.align,l=b.verticalAlign,m,n,p=a.box?0:a.padding||0;m=d.x+p;0>m&&("right"===e?b.align="left":b.x=-m,n=!0);m=d.x+f.width-p;m>c.plotWidth&&("left"===e?b.align="right":b.x=c.plotWidth-m,n=!0);m=d.y+p;0>m&&("bottom"===l?b.verticalAlign=
	"top":b.y=-m,n=!0);m=d.y+f.height-p;m>c.plotHeight&&("top"===l?b.verticalAlign="bottom":b.y=c.plotHeight-m,n=!0);n&&(a.placed=!k,a.align(b,null,g));return n};k.pie&&(k.pie.prototype.drawDataLabels=function(){var b=this,f=b.data,g,k=b.chart,l=b.options.dataLabels,m=t(l.connectorPadding,10),c=t(l.connectorWidth,1),r=k.plotWidth,q=k.plotHeight,u,C=b.center,p=C[2]/2,z=C[1],I,L,h,w,M=[[],[]],H,O,Q,R,x=[0,0,0,0];b.visible&&(l.enabled||b._hasPointLabels)&&(E(f,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&
	(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),d.prototype.drawDataLabels.apply(b),E(f,function(a){a.dataLabel&&a.visible&&(M[a.half].push(a),a.dataLabel._pos=null)}),E(M,function(c,d){var e,f,n=c.length,v=[],u;if(n)for(b.sortByAngle(c,d-.5),0<b.maxLabelDistance&&(e=Math.max(0,z-p-b.maxLabelDistance),f=Math.min(z+p+b.maxLabelDistance,k.plotHeight),E(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,z-p-a.labelDistance),a.bottom=
	Math.min(z+p+a.labelDistance,k.plotHeight),u=a.dataLabel.getBBox().height||21,a.positionsIndex=v.push({target:a.labelPos[1]-a.top+u/2,size:u,rank:a.y})-1)}),a.distribute(v,f+u-e)),R=0;R<n;R++)g=c[R],f=g.positionsIndex,h=g.labelPos,I=g.dataLabel,Q=!1===g.visible?"hidden":"inherit",e=h[1],v&&F(v[f])?void 0===v[f].pos?Q="hidden":(w=v[f].size,O=g.top+v[f].pos):O=e,delete g.positionIndex,H=l.justify?C[0]+(d?-1:1)*(p+g.labelDistance):b.getX(O<g.top+2||O>g.bottom-2?e:O,d,g),I._attr={visibility:Q,align:h[6]},
	I._pos={x:H+l.x+({left:m,right:-m}[h[6]]||0),y:O+l.y-10},h.x=H,h.y=O,t(l.crop,!0)&&(L=I.getBBox().width,e=null,H-L<m?(e=Math.round(L-H+m),x[3]=Math.max(e,x[3])):H+L>r-m&&(e=Math.round(H+L-r+m),x[1]=Math.max(e,x[1])),0>O-w/2?x[0]=Math.max(Math.round(-O+w/2),x[0]):O+w/2>q&&(x[2]=Math.max(Math.round(O+w/2-q),x[2])),I.sideOverflow=e)}),0===A(x)||this.verifyDataLabelOverflow(x))&&(this.placeDataLabels(),c&&E(this.points,function(a){var e;u=a.connector;if((I=a.dataLabel)&&I._pos&&a.visible&&0<a.labelDistance){Q=
	I._attr.visibility;if(e=!u)a.connector=u=k.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(b.dataLabelsGroup),u.attr({"stroke-width":c,stroke:l.connectorColor||a.color||"#666666"});u[e?"attr":"animate"]({d:b.connectorPath(a.labelPos)});u.attr("visibility",Q)}else u&&(a.connector=u.destroy())}))},k.pie.prototype.connectorPath=function(a){var b=a.x,d=a.y;return t(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),d,"C",b,d,2*a[2]-a[4],
	2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),d,"L",a[2],a[3],"L",a[4],a[5]]},k.pie.prototype.placeDataLabels=function(){E(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},k.pie.prototype.alignDataLabel=u,k.pie.prototype.verifyDataLabelOverflow=
	function(a){var b=this.center,d=this.options,e=d.center,f=d.minSize||80,k,c=null!==d.size;c||(null!==e[0]?k=Math.max(b[2]-Math.max(a[1],a[3]),f):(k=Math.max(b[2]-a[1]-a[3],f),b[0]+=(a[3]-a[1])/2),null!==e[1]?k=Math.max(Math.min(k,b[2]-Math.max(a[0],a[2])),f):(k=Math.max(Math.min(k,b[2]-a[0]-a[2]),f),b[1]+=(a[0]-a[2])/2),k<b[2]?(b[2]=k,b[3]=Math.min(g(d.innerSize||0,k),k),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):c=!0);return c});k.column&&(k.column.prototype.alignDataLabel=function(a,
	b,f,g,k){var e=this.chart.inverted,c=a.series,l=a.dlBox||a.shapeArgs,m=t(a.below,a.plotY>t(this.translatedThreshold,c.yAxis.len)),n=t(f.inside,!!this.options.stacking);l&&(g=r(l),0>g.y&&(g.height+=g.y,g.y=0),l=g.y+g.height-c.yAxis.len,0<l&&(g.height-=l),e&&(g={x:c.yAxis.len-g.y-g.height,y:c.xAxis.len-g.x-g.width,width:g.height,height:g.width}),n||(e?(g.x+=m?0:g.width,g.width=0):(g.y+=m?g.height:0,g.height=0)));f.align=t(f.align,!e||n?"center":m?"right":"left");f.verticalAlign=t(f.verticalAlign,e||
	n?"middle":m?"top":"bottom");d.prototype.alignDataLabel.call(this,a,b,f,g,k);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(M);(function(a){var C=a.Chart,A=a.each,F=a.objectEach,E=a.pick,m=a.addEvent;C.prototype.callbacks.push(function(a){function f(){var f=[];A(a.yAxis||[],function(a){a.options.stackLabels&&!a.options.stackLabels.allowOverlap&&F(a.stacks,function(a){F(a,function(a){f.push(a.label)})})});A(a.series||[],function(a){var l=a.options.dataLabels,g=a.dataLabelCollections||
	["dataLabel"];(l.enabled||a._hasPointLabels)&&!l.allowOverlap&&a.visible&&A(g,function(d){A(a.points,function(a){a[d]&&(a[d].labelrank=E(a.labelrank,a.shapeArgs&&a.shapeArgs.height),f.push(a[d]))})})});a.hideOverlappingLabels(f)}f();m(a,"redraw",f)});C.prototype.hideOverlappingLabels=function(a){var f=a.length,m,u,t,g,d,k,b,e,v,y=function(a,b,d,c,e,f,g,k){return!(e>a+d||e+g<a||f>b+c||f+k<b)};for(u=0;u<f;u++)if(m=a[u])m.oldOpacity=m.opacity,m.newOpacity=1,m.width||(t=m.getBBox(),m.width=t.width,m.height=
	t.height);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(u=0;u<f;u++)for(t=a[u],m=u+1;m<f;++m)if(g=a[m],t&&g&&t!==g&&t.placed&&g.placed&&0!==t.newOpacity&&0!==g.newOpacity&&(d=t.alignAttr,k=g.alignAttr,b=t.parentGroup,e=g.parentGroup,v=2*(t.box?0:t.padding||0),d=y(d.x+b.translateX,d.y+b.translateY,t.width-v,t.height-v,k.x+e.translateX,k.y+e.translateY,g.width-v,g.height-v)))(t.labelrank<g.labelrank?t:g).newOpacity=0;A(a,function(a){var b,d;a&&(d=a.newOpacity,a.oldOpacity!==d&&
	a.placed&&(d?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=d,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(M);(function(a){var C=a.addEvent,A=a.Chart,F=a.createElement,E=a.css,m=a.defaultOptions,f=a.defaultPlotOptions,l=a.each,r=a.extend,u=a.fireEvent,t=a.hasTouch,g=a.inArray,d=a.isObject,k=a.Legend,b=a.merge,e=a.pick,v=a.Point,y=a.Series,n=a.seriesTypes,D=a.svg,J;J=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,d=function(a){var c=b.getPointFromEvent(a);
	void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};l(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(l(a.trackerGroups,function(c){if(a[c]){a[c].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(t)a[c].on("touchstart",d);a.options.cursor&&a[c].css(E).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=
	this,b=a.options,d=b.trackByArea,e=[].concat(d?a.areaPath:a.graphPath),f=e.length,g=a.chart,k=g.pointer,m=g.renderer,n=g.options.tooltip.snap,h=a.tracker,r,u=function(){if(g.hoverSeries!==a)a.onMouseOver()},v="rgba(192,192,192,"+(D?.0001:.002)+")";if(f&&!d)for(r=f+1;r--;)"M"===e[r]&&e.splice(r+1,0,e[r+1]-n,e[r+2],"L"),(r&&"M"===e[r]||r===f)&&e.splice(r,0,"L",e[r-2]+n,e[r-1]);h?h.attr({d:e}):a.graph&&(a.tracker=m.path(e).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:v,
	fill:d?v:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n),zIndex:2}).add(a.group),l([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",u).on("mouseout",function(a){k.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(t)a.on("touchstart",u)}))}};n.column&&(n.column.prototype.drawTracker=J.drawTrackerPoint);n.pie&&(n.pie.prototype.drawTracker=J.drawTrackerPoint);n.scatter&&(n.scatter.prototype.drawTracker=J.drawTrackerPoint);r(k.prototype,{setItemEvents:function(a,
	d,e){var c=this,f=c.chart.renderer.boxWrapper,g="highcharts-legend-"+(a.series?"point":"series")+"-active";(e?d:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(g);d.css(c.options.itemHoverStyle)}).on("mouseout",function(){d.css(b(a.visible?c.itemStyle:c.itemHiddenStyle));f.removeClass(g);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):u(a,"legendItemClick",b,c)})},
	createCheckboxForItem:function(a){a.checkbox=F("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){u(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});m.legend.itemStyle.cursor="pointer";r(A.prototype,{showResetZoom:function(){var a=this,b=m.lang,d=a.options.chart.resetZoomButton,e=d.theme,f=e.states,g="chart"===d.relativeTo?null:"plotBox";this.resetZoomButton=
	a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},e,f&&f.hover).attr({align:d.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,g)},zoomOut:function(){var a=this;u(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,f=!1,g;!a||a.resetSelection?(l(this.axes,function(a){b=a.zoom()}),c.initiated=!1):l(a.xAxis.concat(a.yAxis),function(a){var d=a.axis;c[d.isXAxis?"zoomX":"zoomY"]&&(b=d.zoom(a.min,
	a.max),d.displayBtn&&(f=!0))});g=this.resetZoomButton;f&&!g?this.showResetZoom():!f&&d(g)&&(this.resetZoomButton=g.destroy());b&&this.redraw(e(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&l(d,function(a){a.setState()});l("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],h=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(g-f,!0)+h,h=b.toValue(g+
	b.len-f,!0)-h,m=h<l,g=m?h:l,l=m?l:h,h=Math.min(k.dataMin,b.toValue(b.toPixels(k.min)-b.minPixelPadding)),m=Math.max(k.dataMax,b.toValue(b.toPixels(k.max)+b.minPixelPadding)),n;n=h-g;0<n&&(l+=n,g=h);n=l-m;0<n&&(l=m,g-=n);b.series.length&&g!==k.min&&l!==k.max&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);E(c.container,{cursor:"move"})}});r(v.prototype,{select:function(a,b){var c=this,d=c.series,f=d.chart;a=e(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},
	function(){c.selected=c.options.selected=a;d.options.data[g(c,d.data)]=c.options;c.setState(a&&"select");b||l(f.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[g(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");
	l(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var c=this,d=b(c.series.options.point,c.options).events;c.events=d;a.objectEach(d,function(a,b){C(c,b,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,g=this.series,k=g.options.states[a]||{},l=f[g.type].marker&&g.options.marker,m=l&&!1===l.enabled,n=l&&l.states&&l.states[a]||{},h=!1===n.enabled,t=g.stateMarkerGraphic,u=
	this.marker||{},v=g.chart,y=g.halo,A,C=l&&g.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===k.enabled||a&&(h||m&&!1===n.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){C&&(A=g.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(g.pointAttribs(this,a),e(v.options.chart.animation,k.animation)),A&&this.graphic.animate(A,e(v.options.chart.animation,
	n.animation,l.animation)),t&&t.hide();else{if(a&&n){l=u.symbol||g.symbol;t&&t.currentSymbol!==l&&(t=t.destroy());if(t)t[b?"animate":"attr"]({x:A.x,y:A.y});else l&&(g.stateMarkerGraphic=t=v.renderer.symbol(l,A.x,A.y,A.width,A.height).add(g.markerGroup),t.currentSymbol=l);t&&t.attr(g.pointAttribs(this,a))}t&&(t[a&&v.isInsidePlot(c,d,v.inverted)?"show":"hide"](),t.element.point=this)}(c=k.halo)&&c.size?(y||(g.halo=y=v.renderer.path().add((this.graphic||t).parentGroup)),y[b?"animate":"attr"]({d:this.haloPath(c.size)}),
	y.attr({"class":"highcharts-halo highcharts-color-"+e(this.colorIndex,g.colorIndex)}),y.point=this,y.attr(r({fill:this.color||g.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))):y&&y.point&&y.point.haloPath&&y.animate({d:y.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});r(y.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
	u(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,d=b.tooltip,e=b.hoverPoint;b.hoverSeries=null;if(e)e.onMouseOut();this&&a.events.mouseOut&&u(this,"mouseOut");!d||this.stickyTracking||d.shared&&!this.noSharedTooltip||d.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,f=c.states,g=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(l([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+
	b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!f[a]||!1!==f[a].enabled)&&(a&&(g=f[a].lineWidth||g+(f[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":g},d.animate(g,e(b.chart.options.chart.animation,f[a]&&f[a].animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(g),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,g=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:a)?"show":"hide";l(["group",
	"dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&l(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});l(c.linkedSeries,function(b){b.setVisible(a,!1)});g&&(d.isDirtyBox=!0);!1!==b&&d.redraw();u(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===
	a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);u(this,a?"select":"unselect")},drawTracker:J.drawTrackerGraph})})(M);(function(a){var C=a.Chart,A=a.each,F=a.inArray,E=a.isArray,m=a.isObject,f=a.pick,l=a.splat;C.prototype.setResponsive=function(f){var l=this.options.responsive,m=[],g=this.currentResponsive;l&&l.rules&&A(l.rules,function(d){void 0===d._id&&(d._id=a.uniqueKey());this.matchResponsiveRule(d,m,f)},this);var d=a.merge.apply(0,a.map(m,function(d){return a.find(l.rules,function(a){return a._id===
	d}).chartOptions})),m=m.toString()||void 0;m!==(g&&g.ruleIds)&&(g&&this.update(g.undoOptions,f),m?(this.currentResponsive={ruleIds:m,mergedOptions:d,undoOptions:this.currentOptions(d)},this.update(d,f)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,l){var m=a.condition;(m.callback||function(){return this.chartWidth<=f(m.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=f(m.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=f(m.minWidth,0)&&this.chartHeight>=f(m.minHeight,0)}).call(this)&&
	l.push(a._id)};C.prototype.currentOptions=function(f){function r(f,d,k,b){var e;a.objectEach(f,function(a,g){if(!b&&-1<F(g,["series","xAxis","yAxis"]))for(f[g]=l(f[g]),k[g]=[],e=0;e<f[g].length;e++)d[g][e]&&(k[g][e]={},r(a[e],d[g][e],k[g][e],b+1));else m(a)?(k[g]=E(a)?[]:{},r(a,d[g]||{},k[g],b+1)):k[g]=d[g]||null})}var t={};r(f,this.options,t,0);return t}})(M);return M});


/***/ },

/***/ "7t+N":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },

/***/ "MR0U":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("P+fo")(__webpack_require__("lzUo"))

/***/ },

/***/ "lzUo":
/***/ function(module, exports) {

	module.exports = "/*! jQuery v3.2.1 | (c) JS Foundation and other contributors | jquery.org/license */\n!function(a,b){\"use strict\";\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error(\"jQuery requires a window with a document\");return b(a)}:b(a)}(\"undefined\"!=typeof window?window:this,function(a,b){\"use strict\";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement(\"script\");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q=\"3.2.1\",r=function(a,b){return new r.fn.init(a,b)},s=/^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null==a?f.call(this):a<0?this[a+this.length]:this[a]},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for(\"boolean\"==typeof g&&(j=g,g=arguments[h]||{},h++),\"object\"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=Array.isArray(d)))?(e?(e=!1,f=c&&Array.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:\"jQuery\"+(q+Math.random()).replace(/\\D/g,\"\"),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return\"function\"===r.type(a)},isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return(\"number\"===b||\"string\"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||\"[object Object]\"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,\"constructor\")&&b.constructor,\"function\"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+\"\":\"object\"==typeof a||\"function\"==typeof a?j[k.call(a)]||\"object\":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,\"ms-\").replace(u,v)},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?\"\":(a+\"\").replace(s,\"\")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,\"string\"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if(\"string\"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),\"function\"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each(\"Boolean Number String Function Array Date RegExp Object Error Symbol\".split(\" \"),function(a,b){j[\"[object \"+b+\"]\"]=b.toLowerCase()});function w(a){var b=!!a&&\"length\"in a&&a.length,c=r.type(a);return\"function\"!==c&&!r.isWindow(a)&&(\"array\"===c||0===b||\"number\"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u=\"sizzle\"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J=\"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",K=\"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",L=\"(?:\\\\\\\\.|[\\\\w-]|[^\\0-\\\\xa0])+\",M=\"\\\\[\"+K+\"*(\"+L+\")(?:\"+K+\"*([*^$|!~]?=)\"+K+\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\"+L+\"))|)\"+K+\"*\\\\]\",N=\":(\"+L+\")(?:\\\\((('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\"+M+\")*)|.*)\\\\)|)\",O=new RegExp(K+\"+\",\"g\"),P=new RegExp(\"^\"+K+\"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\"+K+\"+$\",\"g\"),Q=new RegExp(\"^\"+K+\"*,\"+K+\"*\"),R=new RegExp(\"^\"+K+\"*([>+~]|\"+K+\")\"+K+\"*\"),S=new RegExp(\"=\"+K+\"*([^\\\\]'\\\"]*?)\"+K+\"*\\\\]\",\"g\"),T=new RegExp(N),U=new RegExp(\"^\"+L+\"$\"),V={ID:new RegExp(\"^#(\"+L+\")\"),CLASS:new RegExp(\"^\\\\.(\"+L+\")\"),TAG:new RegExp(\"^(\"+L+\"|[*])\"),ATTR:new RegExp(\"^\"+M),PSEUDO:new RegExp(\"^\"+N),CHILD:new RegExp(\"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\"+K+\"*(even|odd|(([+-]|)(\\\\d*)n|)\"+K+\"*(?:([+-]|)\"+K+\"*(\\\\d+)|))\"+K+\"*\\\\)|)\",\"i\"),bool:new RegExp(\"^(?:\"+J+\")$\",\"i\"),needsContext:new RegExp(\"^\"+K+\"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\"+K+\"*((?:-\\\\d)?\\\\d*)\"+K+\"*\\\\)|)(?=[^-]|$)\",\"i\")},W=/^(?:input|select|textarea|button)$/i,X=/^h\\d$/i,Y=/^[^{]+\\{\\s*\\[native \\w/,Z=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,$=/[+~]/,_=new RegExp(\"\\\\\\\\([\\\\da-f]{1,6}\"+K+\"?|(\"+K+\")|.)\",\"ig\"),aa=function(a,b,c){var d=\"0x\"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\\0-\\x1f\\x7f]|^-?\\d)|^-$|[^\\0-\\x1f\\x7f-\\uFFFF\\w-]/g,ca=function(a,b){return b?\"\\0\"===a?\"\\ufffd\":a.slice(0,-1)+\"\\\\\"+a.charCodeAt(a.length-1).toString(16)+\" \":\"\\\\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0&&(\"form\"in a||\"label\"in a)},{dir:\"parentNode\",next:\"legend\"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],\"string\"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+\" \"]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if(\"object\"!==b.nodeName.toLowerCase()){(k=b.getAttribute(\"id\"))?k=k.replace(ba,ca):b.setAttribute(\"id\",k=u),o=g(a),h=o.length;while(h--)o[h]=\"#\"+k+\" \"+sa(o[h]);r=o.join(\",\"),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute(\"id\")}}}return i(a.replace(P,\"$1\"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+\" \")>d.cacheLength&&delete b[a.shift()],b[c+\" \"]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement(\"fieldset\");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split(\"|\"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return\"input\"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return(\"input\"===c||\"button\"===c)&&b.type===a}}function oa(a){return function(b){return\"form\"in b?b.parentNode&&b.disabled===!1?\"label\"in b?\"label\"in b.parentNode?b.parentNode.disabled===a:b.disabled===a:b.isDisabled===a||b.isDisabled!==!a&&ea(b)===a:b.disabled===a:\"label\"in b&&b.disabled===a}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&\"undefined\"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&\"HTML\"!==b.nodeName},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener(\"unload\",da,!1):e.attachEvent&&e.attachEvent(\"onunload\",da)),c.attributes=ja(function(a){return a.className=\"i\",!a.getAttribute(\"className\")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment(\"\")),!a.getElementsByTagName(\"*\").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute(\"id\")===b}},d.find.ID=function(a,b){if(\"undefined\"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}}):(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c=\"undefined\"!=typeof a.getAttributeNode&&a.getAttributeNode(\"id\");return c&&c.value===b}},d.find.ID=function(a,b){if(\"undefined\"!=typeof b.getElementById&&p){var c,d,e,f=b.getElementById(a);if(f){if(c=f.getAttributeNode(\"id\"),c&&c.value===a)return[f];e=b.getElementsByName(a),d=0;while(f=e[d++])if(c=f.getAttributeNode(\"id\"),c&&c.value===a)return[f]}return[]}}),d.find.TAG=c.getElementsByTagName?function(a,b){return\"undefined\"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if(\"*\"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if(\"undefined\"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML=\"<a id='\"+u+\"'></a><select id='\"+u+\"-\\r\\\\' msallowcapture=''><option selected=''></option></select>\",a.querySelectorAll(\"[msallowcapture^='']\").length&&q.push(\"[*^$]=\"+K+\"*(?:''|\\\"\\\")\"),a.querySelectorAll(\"[selected]\").length||q.push(\"\\\\[\"+K+\"*(?:value|\"+J+\")\"),a.querySelectorAll(\"[id~=\"+u+\"-]\").length||q.push(\"~=\"),a.querySelectorAll(\":checked\").length||q.push(\":checked\"),a.querySelectorAll(\"a#\"+u+\"+*\").length||q.push(\".#.+[+~]\")}),ja(function(a){a.innerHTML=\"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>\";var b=n.createElement(\"input\");b.setAttribute(\"type\",\"hidden\"),a.appendChild(b).setAttribute(\"name\",\"D\"),a.querySelectorAll(\"[name=d]\").length&&q.push(\"name\"+K+\"*[*^$|!~]?=\"),2!==a.querySelectorAll(\":enabled\").length&&q.push(\":enabled\",\":disabled\"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(\":disabled\").length&&q.push(\":enabled\",\":disabled\"),a.querySelectorAll(\"*,:x\"),q.push(\",.*:\")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,\"*\"),s.call(a,\"[s!='']:x\"),r.push(\"!=\",N)}),q=q.length&&new RegExp(q.join(\"|\")),r=r.length&&new RegExp(r.join(\"|\")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,\"='$1']\"),c.matchesSelector&&p&&!A[b+\" \"]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+\"\").replace(ba,ca)},ga.error=function(a){throw new Error(\"Syntax error, unrecognized expression: \"+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c=\"\",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if(\"string\"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{\">\":{dir:\"parentNode\",first:!0},\" \":{dir:\"parentNode\"},\"+\":{dir:\"previousSibling\",first:!0},\"~\":{dir:\"previousSibling\"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||\"\").replace(_,aa),\"~=\"===a[2]&&(a[3]=\" \"+a[3]+\" \"),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),\"nth\"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*(\"even\"===a[3]||\"odd\"===a[3])),a[5]=+(a[7]+a[8]||\"odd\"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||\"\":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(\")\",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return\"*\"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+\" \"];return b||(b=new RegExp(\"(^|\"+K+\")\"+a+\"(\"+K+\"|$)\"))&&y(a,function(a){return b.test(\"string\"==typeof a.className&&a.className||\"undefined\"!=typeof a.getAttribute&&a.getAttribute(\"class\")||\"\")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?\"!=\"===b:!b||(e+=\"\",\"=\"===b?e===c:\"!=\"===b?e!==c:\"^=\"===b?c&&0===e.indexOf(c):\"*=\"===b?c&&e.indexOf(c)>-1:\"$=\"===b?c&&e.slice(-c.length)===c:\"~=\"===b?(\" \"+e.replace(O,\" \")+\" \").indexOf(c)>-1:\"|=\"===b&&(e===c||e.slice(0,c.length+1)===c+\"-\"))}},CHILD:function(a,b,c,d,e){var f=\"nth\"!==a.slice(0,3),g=\"last\"!==a.slice(-4),h=\"of-type\"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?\"nextSibling\":\"previousSibling\",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p=\"only\"===a&&!o&&\"nextSibling\"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error(\"unsupported pseudo: \"+a);return e[u]?e(b):e.length>1?(c=[a,a,\"\",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,\"$1\"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||\"\")||ga.error(\"unsupported lang: \"+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute(\"xml:lang\")||b.getAttribute(\"lang\"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+\"-\");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&!!a.checked||\"option\"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&\"button\"===a.type||\"button\"===b},text:function(a){var b;return\"input\"===a.nodeName.toLowerCase()&&\"text\"===a.type&&(null==(b=a.getAttribute(\"type\"))||\"text\"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[c<0?c+b:c]}),even:pa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+\" \"];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P,\" \")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d=\"\";b<c;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&\"parentNode\"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e);return!1}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}return!1}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;d<e;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||\"*\",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[\" \"],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:\" \"===a[i-2].type?\"*\":\"\"})).replace(P,\"$1\"),c,i<e&&ya(a.slice(i,e)),e<f&&ya(a=a.slice(e)),e<f&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s=\"0\",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG(\"*\",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+\" \"];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,c,e){var f,i,j,k,l,m=\"function\"==typeof a&&a,n=!e&&g(a=m.selector||a);if(c=c||[],1===n.length){if(i=n[0]=n[0].slice(0),i.length>2&&\"ID\"===(j=i[0]).type&&9===b.nodeType&&p&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(_,aa),b)||[])[0],!b)return c;m&&(b=b.parentNode),a=a.slice(i.shift().value.length)}f=V.needsContext.test(a)?0:i.length;while(f--){if(j=i[f],d.relative[k=j.type])break;if((l=d.find[k])&&(e=l(j.matches[0].replace(_,aa),$.test(i[0].type)&&qa(b.parentNode)||b))){if(i.splice(f,1),a=e.length&&sa(i),!a)return G.apply(c,e),c;break}}}return(m||h(a,n))(e,b,!p,c,!b||$.test(a)&&qa(b.parentNode)||b),c},c.sortStable=u.split(\"\").sort(B).join(\"\")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement(\"fieldset\"))}),ja(function(a){return a.innerHTML=\"<a href='#'></a>\",\"#\"===a.firstChild.getAttribute(\"href\")})||ka(\"type|href|height|width\",function(a,b,c){if(!c)return a.getAttribute(b,\"type\"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML=\"<input/>\",a.firstChild.setAttribute(\"value\",\"\"),\"\"===a.firstChild.getAttribute(\"value\")})||ka(\"value\",function(a,b,c){if(!c&&\"input\"===a.nodeName.toLowerCase())return a.defaultValue}),ja(function(a){return null==a.getAttribute(\"disabled\")})||ka(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[\":\"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext;function B(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()}var C=/^<([a-z][^\\/\\0>:\\x20\\t\\r\\n\\f]*)[\\x20\\t\\r\\n\\f]*\\/?>(?:<\\/\\1>|)$/i,D=/^.[^:#\\[\\.,]*$/;function E(a,b,c){return r.isFunction(b)?r.grep(a,function(a,d){return!!b.call(a,d,a)!==c}):b.nodeType?r.grep(a,function(a){return a===b!==c}):\"string\"!=typeof b?r.grep(a,function(a){return i.call(b,a)>-1!==c}):D.test(b)?r.filter(b,a,c):(b=r.filter(b,a),r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType}))}r.filter=function(a,b,c){var d=b[0];return c&&(a=\":not(\"+a+\")\"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if(\"string\"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(E(this,a||[],!1))},not:function(a){return this.pushStack(E(this,a||[],!0))},is:function(a){return!!E(this,\"string\"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var F,G=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]+))$/,H=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||F,\"string\"==typeof a){if(e=\"<\"===a[0]&&\">\"===a[a.length-1]&&a.length>=3?[null,a,null]:G.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),C.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};H.prototype=r.fn,F=r(d);var I=/^(?:parents|prev(?:Until|All))/,J={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g=\"string\"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?\"string\"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function K(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,\"parentNode\")},parentsUntil:function(a,b,c){return y(a,\"parentNode\",c)},next:function(a){return K(a,\"nextSibling\")},prev:function(a){return K(a,\"previousSibling\")},nextAll:function(a){return y(a,\"nextSibling\")},prevAll:function(a){return y(a,\"previousSibling\")},nextUntil:function(a,b,c){return y(a,\"nextSibling\",c)},prevUntil:function(a,b,c){return y(a,\"previousSibling\",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return B(a,\"iframe\")?a.contentDocument:(B(a,\"template\")&&(a=a.content||a),r.merge([],a.childNodes))}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return\"Until\"!==a.slice(-5)&&(d=c),d&&\"string\"==typeof d&&(e=r.filter(d,e)),this.length>1&&(J[a]||r.uniqueSort(e),I.test(a)&&e.reverse()),this.pushStack(e)}});var L=/[^\\x20\\t\\r\\n\\f]+/g;function M(a){var b={};return r.each(a.match(L)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a=\"string\"==typeof a?M(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=e||a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:\"\")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&\"string\"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c=\"\",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=\"\"),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function N(a){return a}function O(a){throw a}function P(a,b,c,d){var e;try{a&&r.isFunction(e=a.promise)?e.call(a).done(b).fail(c):a&&r.isFunction(e=a.then)?e.call(a,b,c):b.apply(void 0,[a].slice(d))}catch(a){c.apply(void 0,[a])}}r.extend({Deferred:function(b){var c=[[\"notify\",\"progress\",r.Callbacks(\"memory\"),r.Callbacks(\"memory\"),2],[\"resolve\",\"done\",r.Callbacks(\"once memory\"),r.Callbacks(\"once memory\"),0,\"resolved\"],[\"reject\",\"fail\",r.Callbacks(\"once memory\"),r.Callbacks(\"once memory\"),1,\"rejected\"]],d=\"pending\",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},\"catch\":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+\"With\"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError(\"Thenable self-resolution\");j=a&&(\"object\"==typeof a||\"function\"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,N,e),g(f,c,O,e)):(f++,j.call(a,g(f,c,N,e),g(f,c,O,e),g(f,c,N,c.notifyWith))):(d!==N&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==O&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:N,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:N)),c[2][3].add(g(0,a,r.isFunction(d)?d:O))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+\"With\"](this===f?void 0:this,arguments),this},f[b[0]+\"With\"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(P(a,g.done(h(c)).resolve,g.reject,!b),\"pending\"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)P(e[c],h(c),g.reject);return g.promise()}});var Q=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&Q.test(b.name)&&a.console.warn(\"jQuery.Deferred exception: \"+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var R=r.Deferred();r.fn.ready=function(a){return R.then(a)[\"catch\"](function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||R.resolveWith(d,[r]))}}),r.ready.then=R.then;function S(){d.removeEventListener(\"DOMContentLoaded\",S),\na.removeEventListener(\"load\",S),r.ready()}\"complete\"===d.readyState||\"loading\"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener(\"DOMContentLoaded\",S),a.addEventListener(\"load\",S));var T=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if(\"object\"===r.type(c)){e=!0;for(h in c)T(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},U=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function V(){this.expando=r.expando+V.uid++}V.uid=1,V.prototype={cache:function(a){var b=a[this.expando];return b||(b={},U(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if(\"string\"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&\"string\"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){Array.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(L)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var W=new V,X=new V,Y=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,Z=/[A-Z]/g;function $(a){return\"true\"===a||\"false\"!==a&&(\"null\"===a?null:a===+a+\"\"?+a:Y.test(a)?JSON.parse(a):a)}function _(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d=\"data-\"+b.replace(Z,\"-$&\").toLowerCase(),c=a.getAttribute(d),\"string\"==typeof c){try{c=$(c)}catch(e){}X.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return X.hasData(a)||W.hasData(a)},data:function(a,b,c){return X.access(a,b,c)},removeData:function(a,b){X.remove(a,b)},_data:function(a,b,c){return W.access(a,b,c)},_removeData:function(a,b){W.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=X.get(f),1===f.nodeType&&!W.get(f,\"hasDataAttrs\"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf(\"data-\")&&(d=r.camelCase(d.slice(5)),_(f,d,e[d])));W.set(f,\"hasDataAttrs\",!0)}return e}return\"object\"==typeof a?this.each(function(){X.set(this,a)}):T(this,function(b){var c;if(f&&void 0===b){if(c=X.get(f,a),void 0!==c)return c;if(c=_(f,a),void 0!==c)return c}else this.each(function(){X.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){X.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||\"fx\")+\"queue\",d=W.get(a,b),c&&(!d||Array.isArray(c)?d=W.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||\"fx\";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};\"inprogress\"===e&&(e=c.shift(),d--),e&&(\"fx\"===b&&c.unshift(\"inprogress\"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+\"queueHooks\";return W.get(a,c)||W.access(a,c,{empty:r.Callbacks(\"once memory\").add(function(){W.remove(a,[b+\"queue\",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return\"string\"!=typeof a&&(b=a,a=\"fx\",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),\"fx\"===a&&\"inprogress\"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||\"fx\",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};\"string\"!=typeof a&&(b=a,a=void 0),a=a||\"fx\";while(g--)c=W.get(f[g],a+\"queueHooks\"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var aa=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,ba=new RegExp(\"^(?:([+-])=|)(\"+aa+\")([a-z%]*)$\",\"i\"),ca=[\"Top\",\"Right\",\"Bottom\",\"Left\"],da=function(a,b){return a=b||a,\"none\"===a.style.display||\"\"===a.style.display&&r.contains(a.ownerDocument,a)&&\"none\"===r.css(a,\"display\")},ea=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function fa(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,\"\")},i=h(),j=c&&c[3]||(r.cssNumber[b]?\"\":\"px\"),k=(r.cssNumber[b]||\"px\"!==j&&+i)&&ba.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||\".5\",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ga={};function ha(a){var b,c=a.ownerDocument,d=a.nodeName,e=ga[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,\"display\"),b.parentNode.removeChild(b),\"none\"===e&&(e=\"block\"),ga[d]=e,e)}function ia(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?(\"none\"===c&&(e[f]=W.get(d,\"display\")||null,e[f]||(d.style.display=\"\")),\"\"===d.style.display&&da(d)&&(e[f]=ha(d))):\"none\"!==c&&(e[f]=\"none\",W.set(d,\"display\",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ia(this,!0)},hide:function(){return ia(this)},toggle:function(a){return\"boolean\"==typeof a?a?this.show():this.hide():this.each(function(){da(this)?r(this).show():r(this).hide()})}});var ja=/^(?:checkbox|radio)$/i,ka=/<([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]+)/i,la=/^$|\\/(?:java|ecma)script/i,ma={option:[1,\"<select multiple='multiple'>\",\"</select>\"],thead:[1,\"<table>\",\"</table>\"],col:[2,\"<table><colgroup>\",\"</colgroup></table>\"],tr:[2,\"<table><tbody>\",\"</tbody></table>\"],td:[3,\"<table><tbody><tr>\",\"</tr></tbody></table>\"],_default:[0,\"\",\"\"]};ma.optgroup=ma.option,ma.tbody=ma.tfoot=ma.colgroup=ma.caption=ma.thead,ma.th=ma.td;function na(a,b){var c;return c=\"undefined\"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||\"*\"):\"undefined\"!=typeof a.querySelectorAll?a.querySelectorAll(b||\"*\"):[],void 0===b||b&&B(a,b)?r.merge([a],c):c}function oa(a,b){for(var c=0,d=a.length;c<d;c++)W.set(a[c],\"globalEval\",!b||W.get(b[c],\"globalEval\"))}var pa=/<|&#?\\w+;/;function qa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if(\"object\"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(pa.test(f)){g=g||l.appendChild(b.createElement(\"div\")),h=(ka.exec(f)||[\"\",\"\"])[1].toLowerCase(),i=ma[h]||ma._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=\"\"}else m.push(b.createTextNode(f));l.textContent=\"\",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=na(l.appendChild(f),\"script\"),j&&oa(g),c){k=0;while(f=g[k++])la.test(f.type||\"\")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement(\"div\")),c=d.createElement(\"input\");c.setAttribute(\"type\",\"radio\"),c.setAttribute(\"checked\",\"checked\"),c.setAttribute(\"name\",\"t\"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML=\"<textarea>x</textarea>\",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var ra=d.documentElement,sa=/^key/,ta=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,ua=/^([^.]*)(?:\\.(.+)|)/;function va(){return!0}function wa(){return!1}function xa(){try{return d.activeElement}catch(a){}}function ya(a,b,c,d,e,f){var g,h;if(\"object\"==typeof b){\"string\"!=typeof c&&(d=d||c,c=void 0);for(h in b)ya(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&(\"string\"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=wa;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(ra,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return\"undefined\"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||\"\").match(L)||[\"\"],j=b.length;while(j--)h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||\"\").split(\".\").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(\".\")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.hasData(a)&&W.get(a);if(q&&(i=q.events)){b=(b||\"\").match(L)||[\"\"],j=b.length;while(j--)if(h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||\"\").split(\".\").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp(\"(^|\\\\.)\"+o.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&(\"**\"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&W.remove(a,\"handle events\")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(W.get(this,\"events\")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&!(\"click\"===a.type&&a.button>=1))for(;j!==this;j=j.parentNode||this)if(1===j.nodeType&&(\"click\"!==a.type||j.disabled!==!0)){for(f=[],g={},c=0;c<i;c++)d=b[c],e=d.selector+\" \",void 0===g[e]&&(g[e]=d.needsContext?r(e,this).index(j)>-1:r.find(e,this,null,[j]).length),g[e]&&f.push(d);f.length&&h.push({elem:j,handlers:f})}return j=this,i<b.length&&h.push({elem:j,handlers:b.slice(i)}),h},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==xa()&&this.focus)return this.focus(),!1},delegateType:\"focusin\"},blur:{trigger:function(){if(this===xa()&&this.blur)return this.blur(),!1},delegateType:\"focusout\"},click:{trigger:function(){if(\"checkbox\"===this.type&&this.click&&B(this,\"input\"))return this.click(),!1},_default:function(a){return B(a.target,\"a\")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?va:wa,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:wa,isPropagationStopped:wa,isImmediatePropagationStopped:wa,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=va,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=va,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=va,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,\"char\":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&sa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ta.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:\"mouseover\",mouseleave:\"mouseout\",pointerenter:\"pointerover\",pointerleave:\"pointerout\"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return ya(this,a,b,c,d)},one:function(a,b,c,d){return ya(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+\".\"+d.namespace:d.origType,d.selector,d.handler),this;if(\"object\"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&\"function\"!=typeof b||(c=b,b=void 0),c===!1&&(c=wa),this.each(function(){r.event.remove(this,a,c,b)})}});var za=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]*)[^>]*)\\/>/gi,Aa=/<script|<style|<link/i,Ba=/checked\\s*(?:[^=]|=\\s*.checked.)/i,Ca=/^true\\/(.*)/,Da=/^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g;function Ea(a,b){return B(a,\"table\")&&B(11!==b.nodeType?b:b.firstChild,\"tr\")?r(\">tbody\",a)[0]||a:a}function Fa(a){return a.type=(null!==a.getAttribute(\"type\"))+\"/\"+a.type,a}function Ga(a){var b=Ca.exec(a.type);return b?a.type=b[1]:a.removeAttribute(\"type\"),a}function Ha(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(W.hasData(a)&&(f=W.access(a),g=W.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}X.hasData(a)&&(h=X.access(a),i=r.extend({},h),X.set(b,i))}}function Ia(a,b){var c=b.nodeName.toLowerCase();\"input\"===c&&ja.test(a.type)?b.checked=a.checked:\"input\"!==c&&\"textarea\"!==c||(b.defaultValue=a.defaultValue)}function Ja(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&\"string\"==typeof q&&!o.checkClone&&Ba.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ja(f,b,c,d)});if(m&&(e=qa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(na(e,\"script\"),Fa),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,na(j,\"script\"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ga),l=0;l<i;l++)j=h[l],la.test(j.type||\"\")&&!W.access(j,\"globalEval\")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Da,\"\"),k))}return a}function Ka(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(na(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&oa(na(d,\"script\")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(za,\"<$1></$2>\")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=na(h),f=na(a),d=0,e=f.length;d<e;d++)Ia(f[d],g[d]);if(b)if(c)for(f=f||na(a),g=g||na(h),d=0,e=f.length;d<e;d++)Ha(f[d],g[d]);else Ha(a,h);return g=na(h,\"script\"),g.length>0&&oa(g,!i&&na(a,\"script\")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(U(c)){if(b=c[W.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[W.expando]=void 0}c[X.expando]&&(c[X.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ka(this,a,!0)},remove:function(a){return Ka(this,a)},text:function(a){return T(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.appendChild(a)}})},prepend:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(na(a,!1)),a.textContent=\"\");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return T(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if(\"string\"==typeof a&&!Aa.test(a)&&!ma[(ka.exec(a)||[\"\",\"\"])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(na(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ja(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(na(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:\"append\",prependTo:\"prepend\",insertBefore:\"before\",insertAfter:\"after\",replaceAll:\"replaceWith\"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var La=/^margin/,Ma=new RegExp(\"^(\"+aa+\")(?!px)[a-z%]+$\",\"i\"),Na=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText=\"box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%\",i.innerHTML=\"\",ra.appendChild(h);var b=a.getComputedStyle(i);c=\"1%\"!==b.top,g=\"2px\"===b.marginLeft,e=\"4px\"===b.width,i.style.marginRight=\"50%\",f=\"4px\"===b.marginRight,ra.removeChild(h),i=null}}var c,e,f,g,h=d.createElement(\"div\"),i=d.createElement(\"div\");i.style&&(i.style.backgroundClip=\"content-box\",i.cloneNode(!0).style.backgroundClip=\"\",o.clearCloneStyle=\"content-box\"===i.style.backgroundClip,h.style.cssText=\"border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute\",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Oa(a,b,c){var d,e,f,g,h=a.style;return c=c||Na(a),c&&(g=c.getPropertyValue(b)||c[b],\"\"!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ma.test(g)&&La.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+\"\":g}function Pa(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Qa=/^(none|table(?!-c[ea]).+)/,Ra=/^--/,Sa={position:\"absolute\",visibility:\"hidden\",display:\"block\"},Ta={letterSpacing:\"0\",fontWeight:\"400\"},Ua=[\"Webkit\",\"Moz\",\"ms\"],Va=d.createElement(\"div\").style;function Wa(a){if(a in Va)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ua.length;while(c--)if(a=Ua[c]+b,a in Va)return a}function Xa(a){var b=r.cssProps[a];return b||(b=r.cssProps[a]=Wa(a)||a),b}function Ya(a,b,c){var d=ba.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||\"px\"):b}function Za(a,b,c,d,e){var f,g=0;for(f=c===(d?\"border\":\"content\")?4:\"width\"===b?1:0;f<4;f+=2)\"margin\"===c&&(g+=r.css(a,c+ca[f],!0,e)),d?(\"content\"===c&&(g-=r.css(a,\"padding\"+ca[f],!0,e)),\"margin\"!==c&&(g-=r.css(a,\"border\"+ca[f]+\"Width\",!0,e))):(g+=r.css(a,\"padding\"+ca[f],!0,e),\"padding\"!==c&&(g+=r.css(a,\"border\"+ca[f]+\"Width\",!0,e)));return g}function $a(a,b,c){var d,e=Na(a),f=Oa(a,b,e),g=\"border-box\"===r.css(a,\"boxSizing\",!1,e);return Ma.test(f)?f:(d=g&&(o.boxSizingReliable()||f===a.style[b]),\"auto\"===f&&(f=a[\"offset\"+b[0].toUpperCase()+b.slice(1)]),f=parseFloat(f)||0,f+Za(a,b,c||(g?\"border\":\"content\"),d,e)+\"px\")}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Oa(a,\"opacity\");return\"\"===c?\"1\":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{\"float\":\"cssFloat\"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=Ra.test(b),j=a.style;return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&\"get\"in g&&void 0!==(e=g.get(a,!1,d))?e:j[b]:(f=typeof c,\"string\"===f&&(e=ba.exec(c))&&e[1]&&(c=fa(a,b,e),f=\"number\"),null!=c&&c===c&&(\"number\"===f&&(c+=e&&e[3]||(r.cssNumber[h]?\"\":\"px\")),o.clearCloneStyle||\"\"!==c||0!==b.indexOf(\"background\")||(j[b]=\"inherit\"),g&&\"set\"in g&&void 0===(c=g.set(a,c,d))||(i?j.setProperty(b,c):j[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b),i=Ra.test(b);return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],g&&\"get\"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Oa(a,b,d)),\"normal\"===e&&b in Ta&&(e=Ta[b]),\"\"===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each([\"height\",\"width\"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Qa.test(r.css(a,\"display\"))||a.getClientRects().length&&a.getBoundingClientRect().width?$a(a,b,d):ea(a,Sa,function(){return $a(a,b,d)})},set:function(a,c,d){var e,f=d&&Na(a),g=d&&Za(a,b,d,\"border-box\"===r.css(a,\"boxSizing\",!1,f),f);return g&&(e=ba.exec(c))&&\"px\"!==(e[3]||\"px\")&&(a.style[b]=c,c=r.css(a,b)),Ya(a,c,g)}}}),r.cssHooks.marginLeft=Pa(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Oa(a,\"marginLeft\"))||a.getBoundingClientRect().left-ea(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+\"px\"}),r.each({margin:\"\",padding:\"\",border:\"Width\"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f=\"string\"==typeof c?c.split(\" \"):[c];d<4;d++)e[a+ca[d]+b]=f[d]||f[d-2]||f[0];return e}},La.test(a)||(r.cssHooks[a+b].set=Ya)}),r.fn.extend({css:function(a,b){return T(this,function(a,b,c){var d,e,f={},g=0;if(Array.isArray(b)){for(d=Na(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function _a(a,b,c,d,e){return new _a.prototype.init(a,b,c,d,e)}r.Tween=_a,_a.prototype={constructor:_a,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?\"\":\"px\")},cur:function(){var a=_a.propHooks[this.prop];return a&&a.get?a.get(this):_a.propHooks._default.get(this)},run:function(a){var b,c=_a.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):_a.propHooks._default.set(this),this}},_a.prototype.init.prototype=_a.prototype,_a.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,\"\"),b&&\"auto\"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},_a.propHooks.scrollTop=_a.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:\"swing\"},r.fx=_a.prototype.init,r.fx.step={};var ab,bb,cb=/^(?:toggle|show|hide)$/,db=/queueHooks$/;function eb(){bb&&(d.hidden===!1&&a.requestAnimationFrame?a.requestAnimationFrame(eb):a.setTimeout(eb,r.fx.interval),r.fx.tick())}function fb(){return a.setTimeout(function(){ab=void 0}),ab=r.now()}function gb(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=ca[d],e[\"margin\"+c]=e[\"padding\"+c]=a;return b&&(e.opacity=e.width=a),e}function hb(a,b,c){for(var d,e=(kb.tweeners[b]||[]).concat(kb.tweeners[\"*\"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,k,l=\"width\"in b||\"height\"in b,m=this,n={},o=a.style,p=a.nodeType&&da(a),q=W.get(a,\"fxshow\");c.queue||(g=r._queueHooks(a,\"fx\"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,\"fx\").length||g.empty.fire()})}));for(d in b)if(e=b[d],cb.test(e)){if(delete b[d],f=f||\"toggle\"===e,e===(p?\"hide\":\"show\")){if(\"show\"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=W.get(a,\"display\")),k=r.css(a,\"display\"),\"none\"===k&&(j?k=j:(ia([a],!0),j=a.style.display||j,k=r.css(a,\"display\"),ia([a]))),(\"inline\"===k||\"inline-block\"===k&&null!=j)&&\"none\"===r.css(a,\"float\")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j=\"none\"===k?\"\":k)),o.display=\"inline-block\")),c.overflow&&(o.overflow=\"hidden\",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?\"hidden\"in q&&(p=q.hidden):q=W.access(a,\"fxshow\",{display:j}),f&&(q.hidden=!p),p&&ia([a],!0),m.done(function(){p||ia([a]),W.remove(a,\"fxshow\");for(d in n)r.style(a,d,n[d])})),i=hb(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],Array.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&\"expand\"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=kb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=ab||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(i||h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:ab||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);f<g;f++)if(d=kb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,hb,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j}r.Animation=r.extend(kb,{tweeners:{\"*\":[function(a,b){var c=this.createTween(a,b);return fa(c.elem,a,ba.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=[\"*\"]):a=a.match(L);for(var c,d=0,e=a.length;d<e;d++)c=a[d],kb.tweeners[c]=kb.tweeners[c]||[],kb.tweeners[c].unshift(b)},prefilters:[ib],prefilter:function(a,b){b?kb.prefilters.unshift(a):kb.prefilters.push(a)}}),r.speed=function(a,b,c){var d=a&&\"object\"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off?d.duration=0:\"number\"!=typeof d.duration&&(d.duration in r.fx.speeds?d.duration=r.fx.speeds[d.duration]:d.duration=r.fx.speeds._default),null!=d.queue&&d.queue!==!0||(d.queue=\"fx\"),d.old=d.complete,d.complete=function(){r.isFunction(d.old)&&d.old.call(this),d.queue&&r.dequeue(this,d.queue)},d},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(da).css(\"opacity\",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=kb(this,r.extend({},a),f);(e||W.get(this,\"finish\"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return\"string\"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||\"fx\",[]),this.each(function(){var b=!0,e=null!=a&&a+\"queueHooks\",f=r.timers,g=W.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&db.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||\"fx\"),this.each(function(){var b,c=W.get(this),d=c[a+\"queue\"],e=c[a+\"queueHooks\"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each([\"toggle\",\"show\",\"hide\"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||\"boolean\"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),r.each({slideDown:gb(\"show\"),slideUp:gb(\"hide\"),slideToggle:gb(\"toggle\"),fadeIn:{opacity:\"show\"},fadeOut:{opacity:\"hide\"},fadeToggle:{opacity:\"toggle\"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(ab=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),ab=void 0},r.fx.timer=function(a){r.timers.push(a),r.fx.start()},r.fx.interval=13,r.fx.start=function(){bb||(bb=!0,eb())},r.fx.stop=function(){bb=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||\"fx\",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement(\"input\"),b=d.createElement(\"select\"),c=b.appendChild(d.createElement(\"option\"));a.type=\"checkbox\",o.checkOn=\"\"!==a.value,o.optSelected=c.selected,a=d.createElement(\"input\"),a.value=\"t\",a.type=\"radio\",o.radioValue=\"t\"===a.value}();var lb,mb=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return T(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return\"undefined\"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?lb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&\"set\"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+\"\"),c):e&&\"get\"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),\nnull==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&\"radio\"===b&&B(a,\"input\")){var c=a.value;return a.setAttribute(\"type\",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(L);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),lb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\\w+/g),function(a,b){var c=mb[b]||r.find.attr;mb[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=mb[g],mb[g]=e,e=null!=c(a,b,d)?g:null,mb[g]=f),e}});var nb=/^(?:input|select|textarea|button)$/i,ob=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return T(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&\"set\"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&\"get\"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,\"tabindex\");return b?parseInt(b,10):nb.test(a.nodeName)||ob.test(a.nodeName)&&a.href?0:-1}}},propFix:{\"for\":\"htmlFor\",\"class\":\"className\"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each([\"tabIndex\",\"readOnly\",\"maxLength\",\"cellSpacing\",\"cellPadding\",\"rowSpan\",\"colSpan\",\"useMap\",\"frameBorder\",\"contentEditable\"],function(){r.propFix[this.toLowerCase()]=this});function pb(a){var b=a.match(L)||[];return b.join(\" \")}function qb(a){return a.getAttribute&&a.getAttribute(\"class\")||\"\"}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,qb(this)))});if(\"string\"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&\" \"+pb(e)+\" \"){g=0;while(f=b[g++])d.indexOf(\" \"+f+\" \")<0&&(d+=f+\" \");h=pb(d),e!==h&&c.setAttribute(\"class\",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,qb(this)))});if(!arguments.length)return this.attr(\"class\",\"\");if(\"string\"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&\" \"+pb(e)+\" \"){g=0;while(f=b[g++])while(d.indexOf(\" \"+f+\" \")>-1)d=d.replace(\" \"+f+\" \",\" \");h=pb(d),e!==h&&c.setAttribute(\"class\",h)}}return this},toggleClass:function(a,b){var c=typeof a;return\"boolean\"==typeof b&&\"string\"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,qb(this),b),b)}):this.each(function(){var b,d,e,f;if(\"string\"===c){d=0,e=r(this),f=a.match(L)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&\"boolean\"!==c||(b=qb(this),b&&W.set(this,\"__className__\",b),this.setAttribute&&this.setAttribute(\"class\",b||a===!1?\"\":W.get(this,\"__className__\")||\"\"))})},hasClass:function(a){var b,c,d=0;b=\" \"+a+\" \";while(c=this[d++])if(1===c.nodeType&&(\" \"+pb(qb(c))+\" \").indexOf(b)>-1)return!0;return!1}});var rb=/\\r/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e=\"\":\"number\"==typeof e?e+=\"\":Array.isArray(e)&&(e=r.map(e,function(a){return null==a?\"\":a+\"\"})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&\"set\"in b&&void 0!==b.set(this,e,\"value\")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&\"get\"in b&&void 0!==(c=b.get(e,\"value\"))?c:(c=e.value,\"string\"==typeof c?c.replace(rb,\"\"):null==c?\"\":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,\"value\");return null!=b?b:pb(r.text(a))}},select:{get:function(a){var b,c,d,e=a.options,f=a.selectedIndex,g=\"select-one\"===a.type,h=g?null:[],i=g?f+1:e.length;for(d=f<0?i:g?f:0;d<i;d++)if(c=e[d],(c.selected||d===f)&&!c.disabled&&(!c.parentNode.disabled||!B(c.parentNode,\"optgroup\"))){if(b=r(c).val(),g)return b;h.push(b)}return h},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each([\"radio\",\"checkbox\"],function(){r.valHooks[this]={set:function(a,b){if(Array.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute(\"value\")?\"on\":a.value})});var sb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,\"type\")?b.type:b,q=l.call(b,\"namespace\")?b.namespace.split(\".\"):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!sb.test(p+r.event.triggered)&&(p.indexOf(\".\")>-1&&(q=p.split(\".\"),p=q.shift(),q.sort()),k=p.indexOf(\":\")<0&&\"on\"+p,b=b[r.expando]?b:new r.Event(p,\"object\"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join(\".\"),b.rnamespace=b.namespace?new RegExp(\"(^|\\\\.)\"+q.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,sb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(W.get(h,\"events\")||{})[b.type]&&W.get(h,\"handle\"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&U(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!U(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each(\"blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu\".split(\" \"),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin=\"onfocusin\"in a,o.focusin||r.each({focus:\"focusin\",blur:\"focusout\"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=W.access(d,b);e||d.addEventListener(a,c,!0),W.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=W.access(d,b)-1;e?W.access(d,b,e):(d.removeEventListener(a,c,!0),W.remove(d,b))}}});var tb=a.location,ub=r.now(),vb=/\\?/;r.parseXML=function(b){var c;if(!b||\"string\"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,\"text/xml\")}catch(d){c=void 0}return c&&!c.getElementsByTagName(\"parsererror\").length||r.error(\"Invalid XML: \"+b),c};var wb=/\\[\\]$/,xb=/\\r?\\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(Array.isArray(b))r.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+\"[\"+(\"object\"==typeof e&&null!=e?b:\"\")+\"]\",e,c,d)});else if(c||\"object\"!==r.type(b))d(a,b);else for(e in b)Ab(a+\"[\"+e+\"]\",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+\"=\"+encodeURIComponent(null==c?\"\":c)};if(Array.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join(\"&\")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,\"elements\");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(\":disabled\")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!ja.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:Array.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(xb,\"\\r\\n\")}}):{name:b.name,value:c.replace(xb,\"\\r\\n\")}}).get()}});var Bb=/%20/g,Cb=/#.*$/,Db=/([?&])_=[^&]*/,Eb=/^(.*?):[ \\t]*([^\\r\\n]*)$/gm,Fb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Gb=/^(?:GET|HEAD)$/,Hb=/^\\/\\//,Ib={},Jb={},Kb=\"*/\".concat(\"*\"),Lb=d.createElement(\"a\");Lb.href=tb.href;function Mb(a){return function(b,c){\"string\"!=typeof b&&(c=b,b=\"*\");var d,e=0,f=b.toLowerCase().match(L)||[];if(r.isFunction(c))while(d=f[e++])\"+\"===d[0]?(d=d.slice(1)||\"*\",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Nb(a,b,c,d){var e={},f=a===Jb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return\"string\"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e[\"*\"]&&g(\"*\")}function Ob(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Pb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while(\"*\"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader(\"Content-Type\"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+\" \"+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Qb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if(\"*\"===f)f=i;else if(\"*\"!==i&&i!==f){if(g=j[i+\" \"+f]||j[\"* \"+f],!g)for(e in j)if(h=e.split(\" \"),h[1]===f&&(g=j[i+\" \"+h[0]]||j[\"* \"+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a[\"throws\"])b=g(b);else try{b=g(b)}catch(l){return{state:\"parsererror\",error:g?l:\"No conversion from \"+i+\" to \"+f}}}return{state:\"success\",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:tb.href,type:\"GET\",isLocal:Fb.test(tb.protocol),global:!0,processData:!0,async:!0,contentType:\"application/x-www-form-urlencoded; charset=UTF-8\",accepts:{\"*\":Kb,text:\"text/plain\",html:\"text/html\",xml:\"application/xml, text/xml\",json:\"application/json, text/javascript\"},contents:{xml:/\\bxml\\b/,html:/\\bhtml/,json:/\\bjson\\b/},responseFields:{xml:\"responseXML\",text:\"responseText\",json:\"responseJSON\"},converters:{\"* text\":String,\"text html\":!0,\"text json\":JSON.parse,\"text xml\":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Ob(Ob(a,r.ajaxSettings),b):Ob(r.ajaxSettings,a)},ajaxPrefilter:Mb(Ib),ajaxTransport:Mb(Jb),ajax:function(b,c){\"object\"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks(\"once memory\"),u=o.statusCode||{},v={},w={},x=\"canceled\",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Eb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||tb.href)+\"\").replace(Hb,tb.protocol+\"//\"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||\"*\").toLowerCase().match(L)||[\"\"],null==o.crossDomain){j=d.createElement(\"a\");try{j.href=o.url,j.href=j.href,o.crossDomain=Lb.protocol+\"//\"+Lb.host!=j.protocol+\"//\"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&\"string\"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Nb(Ib,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger(\"ajaxStart\"),o.type=o.type.toUpperCase(),o.hasContent=!Gb.test(o.type),f=o.url.replace(Cb,\"\"),o.hasContent?o.data&&o.processData&&0===(o.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&(o.data=o.data.replace(Bb,\"+\")):(n=o.url.slice(f.length),o.data&&(f+=(vb.test(f)?\"&\":\"?\")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Db,\"$1\"),n=(vb.test(f)?\"&\":\"?\")+\"_=\"+ub++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader(\"If-Modified-Since\",r.lastModified[f]),r.etag[f]&&y.setRequestHeader(\"If-None-Match\",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader(\"Content-Type\",o.contentType),y.setRequestHeader(\"Accept\",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+(\"*\"!==o.dataTypes[0]?\", \"+Kb+\"; q=0.01\":\"\"):o.accepts[\"*\"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x=\"abort\",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Nb(Jb,o,c,y)){if(y.readyState=1,l&&q.trigger(\"ajaxSend\",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort(\"timeout\")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,\"No Transport\");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||\"\",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Pb(o,y,d)),v=Qb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader(\"Last-Modified\"),w&&(r.lastModified[f]=w),w=y.getResponseHeader(\"etag\"),w&&(r.etag[f]=w)),204===b||\"HEAD\"===o.type?x=\"nocontent\":304===b?x=\"notmodified\":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x=\"error\",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+\"\",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?\"ajaxSuccess\":\"ajaxError\",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger(\"ajaxComplete\",[y,o]),--r.active||r.event.trigger(\"ajaxStop\")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,\"json\")},getScript:function(a,b){return r.get(a,void 0,b,\"script\")}}),r.each([\"get\",\"post\"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:\"GET\",dataType:\"script\",cache:!0,async:!1,global:!1,\"throws\":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not(\"body\").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Rb={0:200,1223:204},Sb=r.ajaxSettings.xhr();o.cors=!!Sb&&\"withCredentials\"in Sb,o.ajax=Sb=!!Sb,r.ajaxTransport(function(b){var c,d;if(o.cors||Sb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e[\"X-Requested-With\"]||(e[\"X-Requested-With\"]=\"XMLHttpRequest\");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,\"abort\"===a?h.abort():\"error\"===a?\"number\"!=typeof h.status?f(0,\"error\"):f(h.status,h.statusText):f(Rb[h.status]||h.status,h.statusText,\"text\"!==(h.responseType||\"text\")||\"string\"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c(\"error\"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c(\"abort\");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:\"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript\"},contents:{script:/\\b(?:java|ecma)script\\b/},converters:{\"text script\":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter(\"script\",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type=\"GET\")}),r.ajaxTransport(\"script\",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r(\"<script>\").prop({charset:a.scriptCharset,src:a.url}).on(\"load error\",c=function(a){b.remove(),c=null,a&&f(\"error\"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Tb=[],Ub=/(=)\\?(?=&|$)|\\?\\?/;r.ajaxSetup({jsonp:\"callback\",jsonpCallback:function(){var a=Tb.pop()||r.expando+\"_\"+ub++;return this[a]=!0,a}}),r.ajaxPrefilter(\"json jsonp\",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Ub.test(b.url)?\"url\":\"string\"==typeof b.data&&0===(b.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&Ub.test(b.data)&&\"data\");if(h||\"jsonp\"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Ub,\"$1\"+e):b.jsonp!==!1&&(b.url+=(vb.test(b.url)?\"&\":\"?\")+b.jsonp+\"=\"+e),b.converters[\"script json\"]=function(){return g||r.error(e+\" was not called\"),g[0]},b.dataTypes[0]=\"json\",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Tb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),\"script\"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument(\"\").body;return a.innerHTML=\"<form></form><form></form>\",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if(\"string\"!=typeof a)return[];\"boolean\"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(\"\"),e=b.createElement(\"base\"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=C.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=qa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(\" \");return h>-1&&(d=pb(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&\"object\"==typeof b&&(e=\"POST\"),g.length>0&&r.ajax({url:a,type:e||\"GET\",dataType:\"html\",data:b}).done(function(a){f=arguments,g.html(d?r(\"<div>\").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each([\"ajaxStart\",\"ajaxStop\",\"ajaxComplete\",\"ajaxError\",\"ajaxSuccess\",\"ajaxSend\"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length},r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,\"position\"),l=r(a),m={};\"static\"===k&&(a.style.position=\"relative\"),h=l.offset(),f=r.css(a,\"top\"),i=r.css(a,\"left\"),j=(\"absolute\"===k||\"fixed\"===k)&&(f+i).indexOf(\"auto\")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),\"using\"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),b=f.ownerDocument,c=b.documentElement,e=b.defaultView,{top:d.top+e.pageYOffset-c.clientTop,left:d.left+e.pageXOffset-c.clientLeft}):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return\"fixed\"===r.css(c,\"position\")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),B(a[0],\"html\")||(d=a.offset()),d={top:d.top+r.css(a[0],\"borderTopWidth\",!0),left:d.left+r.css(a[0],\"borderLeftWidth\",!0)}),{top:b.top-d.top-r.css(c,\"marginTop\",!0),left:b.left-d.left-r.css(c,\"marginLeft\",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&\"static\"===r.css(a,\"position\"))a=a.offsetParent;return a||ra})}}),r.each({scrollLeft:\"pageXOffset\",scrollTop:\"pageYOffset\"},function(a,b){var c=\"pageYOffset\"===b;r.fn[a]=function(d){return T(this,function(a,d,e){var f;return r.isWindow(a)?f=a:9===a.nodeType&&(f=a.defaultView),void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each([\"top\",\"left\"],function(a,b){r.cssHooks[b]=Pa(o.pixelPosition,function(a,c){if(c)return c=Oa(a,b),Ma.test(c)?r(a).position()[b]+\"px\":c})}),r.each({Height:\"height\",Width:\"width\"},function(a,b){r.each({padding:\"inner\"+a,content:b,\"\":\"outer\"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||\"boolean\"!=typeof e),h=c||(e===!0||f===!0?\"margin\":\"border\");return T(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf(\"outer\")?b[\"inner\"+a]:b.document.documentElement[\"client\"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body[\"scroll\"+a],f[\"scroll\"+a],b.body[\"offset\"+a],f[\"offset\"+a],f[\"client\"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,\"**\"):this.off(b,a||\"**\",c)}}),r.holdReady=function(a){a?r.readyWait++:r.ready(!0)},r.isArray=Array.isArray,r.parseJSON=JSON.parse,r.nodeName=B,\"function\"==typeof define&&define.amd&&define(\"jquery\",[],function(){return r});var Vb=a.jQuery,Wb=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Wb),b&&a.jQuery===r&&(a.jQuery=Vb),r},b||(a.jQuery=a.$=r),r});\n"

/***/ },

/***/ "3CJN":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },

/***/ "tkWw":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },

/***/ "j8cJ":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },

/***/ "wPpW":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },

/***/ "dURR":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },

/***/ "7OnE":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },

/***/ "BEem":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },

/***/ "3MVc":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },

/***/ "eHwN":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },

/***/ "3hfc":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },

/***/ "lOED":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },

/***/ "aM0x":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },

/***/ "w2Hs":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },

/***/ "OSsP":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },

/***/ "aqvp":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },

/***/ "wIgY":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },

/***/ "ssxj":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },

/***/ "N3vo":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },

/***/ "ZFGz":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },

/***/ "YBA/":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },

/***/ "8v14":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },

/***/ "Frex":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },

/***/ "DOkx":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },

/***/ "rIuo":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },

/***/ "CFqe":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },

/***/ "Sjoy":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },

/***/ "Tqun":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },

/***/ "hPuz":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },

/***/ "ALEw":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },

/***/ "dyB6":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },

/***/ "Nd3h":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },

/***/ "7MHZ":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },

/***/ "LT9G":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },

/***/ "XlWM":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },

/***/ "sqLM":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },

/***/ "2pmY":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },

/***/ "nS2h":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },

/***/ "OVPi":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },

/***/ "bXQP":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },

/***/ "VK9h":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },

/***/ "tzHd":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },

/***/ "g7KF":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },

/***/ "nLOz":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },

/***/ "FuaP":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },

/***/ "+27R":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },

/***/ "Nzt2":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },

/***/ "ETHv":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },

/***/ "V4qH":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },

/***/ "xne+":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },

/***/ "GrS7":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },

/***/ "yRTJ":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },

/***/ "upln":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },

/***/ "FKXc":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },

/***/ "ORgI":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },

/***/ "JwiF":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },

/***/ "RnJI":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },

/***/ "j+vx":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },

/***/ "5j66":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },

/***/ "gEQe":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },

/***/ "eBB/":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },

/***/ "6cf8":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },

/***/ "z3hR":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },

/***/ "nE8X":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },

/***/ "/6P1":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },

/***/ "jxEH":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },

/***/ "svD2":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },

/***/ "gEU3":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },

/***/ "Ab7C":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },

/***/ "oo1B":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },

/***/ "5vPg":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },

/***/ "G++c":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },

/***/ "ooba":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },

/***/ "F+2e":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },

/***/ "FlzV":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },

/***/ "/mhn":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },

/***/ "Bp2f":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },

/***/ "3K28":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },

/***/ "C7av":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },

/***/ "pfs9":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },

/***/ "7LV+":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },

/***/ "AoDM":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },

/***/ "ZoSI":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },

/***/ "wT5f":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },

/***/ "ulq9":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },

/***/ "fW1y":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },

/***/ "5Omq":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },

/***/ "Lgqo":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },

/***/ "OUMt":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },

/***/ "2s1U":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },

/***/ "V0td":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },

/***/ "c1x4":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },

/***/ "f4W3":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },

/***/ "7Q8x":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },

/***/ "Fpqq":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },

/***/ "DSXN":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },

/***/ "+7/x":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },

/***/ "Nlnz":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },

/***/ "gUgh":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },

/***/ "XzD+":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },

/***/ "3LKG":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },

/***/ "m7yE":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },

/***/ "k+5o":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },

/***/ "iNtv":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },

/***/ "krPU":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },

/***/ "FRPF":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },

/***/ "ntHu":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },

/***/ "uSe8":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },

/***/ "/bsm":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },

/***/ "XU1s":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },

/***/ "0X8Q":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },

/***/ "e/KL":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },

/***/ "YXlc":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },

/***/ "Vz2w":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },

/***/ "ZUyn":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },

/***/ "BbgG":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("PJh5")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },

/***/ "PJh5":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(1)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ },

/***/ "T1vd":
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "eMzG":
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ "jQ0k":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__("T1vd");
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },

/***/ "cOyx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__("jQ0k");
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },

/***/ "b8QK":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__("jQ0k");
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },

/***/ "mZ56":
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },

/***/ "+prg":
/***/ function(module, exports, __webpack_require__) {

	// Ensure polyfill compatibility between create-react-app and zero-config nwb apps.
	// This is from https://github.com/facebookincubator/create-react-app/blob/master/config/polyfills.js
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behaviour.
	  __webpack_require__("b8QK").enable()
	  window.Promise = __webpack_require__("cOyx")
	}
	
	// fetch() polyfill for making API calls
	__webpack_require__("mZ56")
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__("eMzG")


/***/ },

/***/ "O27J":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__("yote");


/***/ },

/***/ "5XOy":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },

/***/ "plzC":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__("if0G");
	
	var focusNode = __webpack_require__("6k5Q");
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },

/***/ "d+JT":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__("Kt1l");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var FallbackCompositionState = __webpack_require__("Jk1L");
	var SyntheticCompositionEvent = __webpack_require__("wedt");
	var SyntheticInputEvent = __webpack_require__("IM0q");
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },

/***/ "+ktn":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },

/***/ "RVQV":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__("+ktn");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var ReactInstrumentation = __webpack_require__("Veu9");
	
	var camelizeStyleName = __webpack_require__("tk+g");
	var dangerousStyleValue = __webpack_require__("n7kv");
	var hyphenateStyleName = __webpack_require__("mkxw");
	var memoizeStringOnly = __webpack_require__("njI0");
	var warning = __webpack_require__("EO1N");
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },

/***/ "er+d":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__("IjcK");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },

/***/ "Fd0m":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__("PESh");
	var EventPropagators = __webpack_require__("Kt1l");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactUpdates = __webpack_require__("vg0m");
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	var inputValueTracking = __webpack_require__("A+Ti");
	var getEventTarget = __webpack_require__("4hnb");
	var isEventSupported = __webpack_require__("44cQ");
	var isTextInputElement = __webpack_require__("aVE4");
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },

/***/ "rbSI":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__("hMln");
	var Danger = __webpack_require__("YJUA");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactInstrumentation = __webpack_require__("Veu9");
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__("SbeA");
	var setInnerHTML = __webpack_require__("Li0w");
	var setTextContent = __webpack_require__("/bNP");
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },

/***/ "hMln":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__("PCSp");
	var setInnerHTML = __webpack_require__("Li0w");
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__("SbeA");
	var setTextContent = __webpack_require__("/bNP");
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },

/***/ "PCSp":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },

/***/ "y2pp":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },

/***/ "zt3U":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__("y2pp");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactInstrumentation = __webpack_require__("Veu9");
	
	var quoteAttributeValueForBrowser = __webpack_require__("G524");
	var warning = __webpack_require__("EO1N");
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },

/***/ "YJUA":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var DOMLazyTree = __webpack_require__("hMln");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var createNodesFromMarkup = __webpack_require__("sy4b");
	var emptyFunction = __webpack_require__("Ygvj");
	var invariant = __webpack_require__("KRWL");
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },

/***/ "Jcur":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },

/***/ "thcD":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__("Kt1l");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var SyntheticMouseEvent = __webpack_require__("MygW");
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },

/***/ "PESh":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var EventPluginRegistry = __webpack_require__("inoO");
	var EventPluginUtils = __webpack_require__("VoX8");
	var ReactErrorUtils = __webpack_require__("iHWm");
	
	var accumulateInto = __webpack_require__("+VAZ");
	var forEachAccumulated = __webpack_require__("KFm+");
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },

/***/ "inoO":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },

/***/ "VoX8":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactErrorUtils = __webpack_require__("iHWm");
	
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },

/***/ "Kt1l":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__("PESh");
	var EventPluginUtils = __webpack_require__("VoX8");
	
	var accumulateInto = __webpack_require__("+VAZ");
	var forEachAccumulated = __webpack_require__("KFm+");
	var warning = __webpack_require__("EO1N");
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },

/***/ "Jk1L":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var PooledClass = __webpack_require__("IjcK");
	
	var getTextContentAccessor = __webpack_require__("0AML");
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },

/***/ "csjt":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__("y2pp");
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },

/***/ "pv5m":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },

/***/ "Zzr+":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactPropTypesSecret = __webpack_require__("yfjF");
	var propTypesFactory = __webpack_require__("gQOh");
	
	var React = __webpack_require__("G1ow");
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },

/***/ "IjcK":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },

/***/ "AU5s":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var EventPluginRegistry = __webpack_require__("inoO");
	var ReactEventEmitterMixin = __webpack_require__("mHDS");
	var ViewportMetrics = __webpack_require__("pwFr");
	
	var getVendorPrefixedEventName = __webpack_require__("+KdC");
	var isEventSupported = __webpack_require__("44cQ");
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },

/***/ "yGo3":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__("xWyi");
	
	var instantiateReactComponent = __webpack_require__("5nY2");
	var KeyEscapeUtils = __webpack_require__("pv5m");
	var shouldUpdateReactComponent = __webpack_require__("MWDd");
	var traverseAllChildren = __webpack_require__("Xt9f");
	var warning = __webpack_require__("EO1N");
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__("5LTE");
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;

/***/ },

/***/ "EHDa":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__("rbSI");
	var ReactDOMIDOperations = __webpack_require__("LNJV");
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },

/***/ "QVRU":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },

/***/ "Bj+8":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var React = __webpack_require__("G1ow");
	var ReactComponentEnvironment = __webpack_require__("QVRU");
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var ReactErrorUtils = __webpack_require__("iHWm");
	var ReactInstanceMap = __webpack_require__("yeCS");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var ReactNodeTypes = __webpack_require__("/762");
	var ReactReconciler = __webpack_require__("xWyi");
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__("quIK");
	var invariant = __webpack_require__("KRWL");
	var shallowEqual = __webpack_require__("InQU");
	var shouldUpdateReactComponent = __webpack_require__("MWDd");
	var warning = __webpack_require__("EO1N");
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },

/***/ "yote":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactDefaultInjection = __webpack_require__("ag9w");
	var ReactMount = __webpack_require__("DMKF");
	var ReactReconciler = __webpack_require__("xWyi");
	var ReactUpdates = __webpack_require__("vg0m");
	var ReactVersion = __webpack_require__("Ars9");
	
	var findDOMNode = __webpack_require__("9ahc");
	var getHostComponentFromComposite = __webpack_require__("dKDt");
	var renderSubtreeIntoContainer = __webpack_require__("W5vF");
	var warning = __webpack_require__("EO1N");
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },

/***/ "kio1":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var AutoFocusUtils = __webpack_require__("plzC");
	var CSSPropertyOperations = __webpack_require__("RVQV");
	var DOMLazyTree = __webpack_require__("hMln");
	var DOMNamespaces = __webpack_require__("PCSp");
	var DOMProperty = __webpack_require__("y2pp");
	var DOMPropertyOperations = __webpack_require__("zt3U");
	var EventPluginHub = __webpack_require__("PESh");
	var EventPluginRegistry = __webpack_require__("inoO");
	var ReactBrowserEventEmitter = __webpack_require__("AU5s");
	var ReactDOMComponentFlags = __webpack_require__("51en");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactDOMInput = __webpack_require__("1WsN");
	var ReactDOMOption = __webpack_require__("FQvv");
	var ReactDOMSelect = __webpack_require__("ShAC");
	var ReactDOMTextarea = __webpack_require__("c1IZ");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var ReactMultiChild = __webpack_require__("4fju");
	var ReactServerRenderingTransaction = __webpack_require__("P4HO");
	
	var emptyFunction = __webpack_require__("Ygvj");
	var escapeTextContentForBrowser = __webpack_require__("2HUo");
	var invariant = __webpack_require__("KRWL");
	var isEventSupported = __webpack_require__("44cQ");
	var shallowEqual = __webpack_require__("InQU");
	var inputValueTracking = __webpack_require__("A+Ti");
	var validateDOMNesting = __webpack_require__("SBlo");
	var warning = __webpack_require__("EO1N");
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },

/***/ "51en":
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },

/***/ "if0G":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var DOMProperty = __webpack_require__("y2pp");
	var ReactDOMComponentFlags = __webpack_require__("51en");
	
	var invariant = __webpack_require__("KRWL");
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },

/***/ "H24R":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__("SBlo");
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },

/***/ "wFuS":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var DOMLazyTree = __webpack_require__("hMln");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },

/***/ "sUfN":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },

/***/ "LNJV":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__("rbSI");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },

/***/ "1WsN":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var DOMPropertyOperations = __webpack_require__("zt3U");
	var LinkedValueUtils = __webpack_require__("Zzr+");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },

/***/ "FQvv":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var React = __webpack_require__("G1ow");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactDOMSelect = __webpack_require__("ShAC");
	
	var warning = __webpack_require__("EO1N");
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },

/***/ "ShAC":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var LinkedValueUtils = __webpack_require__("Zzr+");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var warning = __webpack_require__("EO1N");
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },

/***/ "ehig":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var getNodeForCharacterOffset = __webpack_require__("Nk+5");
	var getTextContentAccessor = __webpack_require__("0AML");
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },

/***/ "LR//":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var DOMChildrenOperations = __webpack_require__("rbSI");
	var DOMLazyTree = __webpack_require__("hMln");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	
	var escapeTextContentForBrowser = __webpack_require__("2HUo");
	var invariant = __webpack_require__("KRWL");
	var validateDOMNesting = __webpack_require__("SBlo");
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },

/***/ "c1IZ":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var LinkedValueUtils = __webpack_require__("Zzr+");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },

/***/ "cUIy":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },

/***/ "vdcO":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var ReactUpdates = __webpack_require__("vg0m");
	var Transaction = __webpack_require__("kbwd");
	
	var emptyFunction = __webpack_require__("Ygvj");
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },

/***/ "ag9w":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__("5XOy");
	var BeforeInputEventPlugin = __webpack_require__("d+JT");
	var ChangeEventPlugin = __webpack_require__("Fd0m");
	var DefaultEventPluginOrder = __webpack_require__("Jcur");
	var EnterLeaveEventPlugin = __webpack_require__("thcD");
	var HTMLDOMPropertyConfig = __webpack_require__("csjt");
	var ReactComponentBrowserEnvironment = __webpack_require__("EHDa");
	var ReactDOMComponent = __webpack_require__("kio1");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactDOMEmptyComponent = __webpack_require__("wFuS");
	var ReactDOMTreeTraversal = __webpack_require__("cUIy");
	var ReactDOMTextComponent = __webpack_require__("LR//");
	var ReactDefaultBatchingStrategy = __webpack_require__("vdcO");
	var ReactEventListener = __webpack_require__("5KoS");
	var ReactInjection = __webpack_require__("HKgI");
	var ReactReconcileTransaction = __webpack_require__("LTYS");
	var SVGDOMPropertyConfig = __webpack_require__("EP9N");
	var SelectEventPlugin = __webpack_require__("yy33");
	var SimpleEventPlugin = __webpack_require__("Nc5M");
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },

/***/ "8ZYT":
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },

/***/ "fPVY":
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },

/***/ "iHWm":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },

/***/ "mHDS":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__("PESh");
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },

/***/ "5KoS":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var EventListener = __webpack_require__("l0UM");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var PooledClass = __webpack_require__("IjcK");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var getEventTarget = __webpack_require__("4hnb");
	var getUnboundedScrollPosition = __webpack_require__("YHgc");
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },

/***/ "TWT6":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },

/***/ "4HPq":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },

/***/ "HKgI":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__("y2pp");
	var EventPluginHub = __webpack_require__("PESh");
	var EventPluginUtils = __webpack_require__("VoX8");
	var ReactComponentEnvironment = __webpack_require__("QVRU");
	var ReactEmptyComponent = __webpack_require__("fPVY");
	var ReactBrowserEventEmitter = __webpack_require__("AU5s");
	var ReactHostComponent = __webpack_require__("4HPq");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },

/***/ "mZQ9":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__("ehig");
	
	var containsNode = __webpack_require__("+323");
	var focusNode = __webpack_require__("6k5Q");
	var getActiveElement = __webpack_require__("bf9L");
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },

/***/ "yeCS":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },

/***/ "Veu9":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },

/***/ "SzO/":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__("iYQ6");
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },

/***/ "DMKF":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var DOMLazyTree = __webpack_require__("hMln");
	var DOMProperty = __webpack_require__("y2pp");
	var React = __webpack_require__("G1ow");
	var ReactBrowserEventEmitter = __webpack_require__("AU5s");
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactDOMContainerInfo = __webpack_require__("H24R");
	var ReactDOMFeatureFlags = __webpack_require__("sUfN");
	var ReactFeatureFlags = __webpack_require__("TWT6");
	var ReactInstanceMap = __webpack_require__("yeCS");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var ReactMarkupChecksum = __webpack_require__("SzO/");
	var ReactReconciler = __webpack_require__("xWyi");
	var ReactUpdateQueue = __webpack_require__("lZ3b");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var emptyObject = __webpack_require__("quIK");
	var instantiateReactComponent = __webpack_require__("5nY2");
	var invariant = __webpack_require__("KRWL");
	var setInnerHTML = __webpack_require__("Li0w");
	var shouldUpdateReactComponent = __webpack_require__("MWDd");
	var warning = __webpack_require__("EO1N");
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },

/***/ "4fju":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactComponentEnvironment = __webpack_require__("QVRU");
	var ReactInstanceMap = __webpack_require__("yeCS");
	var ReactInstrumentation = __webpack_require__("Veu9");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var ReactReconciler = __webpack_require__("xWyi");
	var ReactChildReconciler = __webpack_require__("yGo3");
	
	var emptyFunction = __webpack_require__("Ygvj");
	var flattenChildren = __webpack_require__("f6Df");
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },

/***/ "/762":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var React = __webpack_require__("G1ow");
	
	var invariant = __webpack_require__("KRWL");
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },

/***/ "S4Fj":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },

/***/ "yfjF":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },

/***/ "LTYS":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var CallbackQueue = __webpack_require__("er+d");
	var PooledClass = __webpack_require__("IjcK");
	var ReactBrowserEventEmitter = __webpack_require__("AU5s");
	var ReactInputSelection = __webpack_require__("mZQ9");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var Transaction = __webpack_require__("kbwd");
	var ReactUpdateQueue = __webpack_require__("lZ3b");
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },

/***/ "xWyi":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__("Q15r");
	var ReactInstrumentation = __webpack_require__("Veu9");
	
	var warning = __webpack_require__("EO1N");
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },

/***/ "Q15r":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__("S4Fj");
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },

/***/ "P4HO":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var PooledClass = __webpack_require__("IjcK");
	var Transaction = __webpack_require__("kbwd");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var ReactServerUpdateQueue = __webpack_require__("O15z");
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },

/***/ "O15z":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__("lZ3b");
	
	var warning = __webpack_require__("EO1N");
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },

/***/ "lZ3b":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var ReactInstanceMap = __webpack_require__("yeCS");
	var ReactInstrumentation = __webpack_require__("Veu9");
	var ReactUpdates = __webpack_require__("vg0m");
	
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },

/***/ "vg0m":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var CallbackQueue = __webpack_require__("er+d");
	var PooledClass = __webpack_require__("IjcK");
	var ReactFeatureFlags = __webpack_require__("TWT6");
	var ReactReconciler = __webpack_require__("xWyi");
	var Transaction = __webpack_require__("kbwd");
	
	var invariant = __webpack_require__("KRWL");
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },

/***/ "Ars9":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },

/***/ "EP9N":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },

/***/ "yy33":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__("Kt1l");
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactInputSelection = __webpack_require__("mZQ9");
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	var getActiveElement = __webpack_require__("bf9L");
	var isTextInputElement = __webpack_require__("aVE4");
	var shallowEqual = __webpack_require__("InQU");
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },

/***/ "Nc5M":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var EventListener = __webpack_require__("l0UM");
	var EventPropagators = __webpack_require__("Kt1l");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var SyntheticAnimationEvent = __webpack_require__("wbUH");
	var SyntheticClipboardEvent = __webpack_require__("U5Eh");
	var SyntheticEvent = __webpack_require__("ZhCu");
	var SyntheticFocusEvent = __webpack_require__("MIAc");
	var SyntheticKeyboardEvent = __webpack_require__("zQ3w");
	var SyntheticMouseEvent = __webpack_require__("MygW");
	var SyntheticDragEvent = __webpack_require__("1f0M");
	var SyntheticTouchEvent = __webpack_require__("kE2j");
	var SyntheticTransitionEvent = __webpack_require__("lmOh");
	var SyntheticUIEvent = __webpack_require__("Ch7n");
	var SyntheticWheelEvent = __webpack_require__("Pi3e");
	
	var emptyFunction = __webpack_require__("Ygvj");
	var getEventCharCode = __webpack_require__("+cCx");
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },

/***/ "wbUH":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },

/***/ "U5Eh":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },

/***/ "wedt":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },

/***/ "1f0M":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__("MygW");
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },

/***/ "ZhCu":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var PooledClass = __webpack_require__("IjcK");
	
	var emptyFunction = __webpack_require__("Ygvj");
	var warning = __webpack_require__("EO1N");
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },

/***/ "MIAc":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__("Ch7n");
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },

/***/ "IM0q":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },

/***/ "zQ3w":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__("Ch7n");
	
	var getEventCharCode = __webpack_require__("+cCx");
	var getEventKey = __webpack_require__("3oi4");
	var getEventModifierState = __webpack_require__("FdT2");
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },

/***/ "MygW":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__("Ch7n");
	var ViewportMetrics = __webpack_require__("pwFr");
	
	var getEventModifierState = __webpack_require__("FdT2");
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },

/***/ "kE2j":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__("Ch7n");
	
	var getEventModifierState = __webpack_require__("FdT2");
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },

/***/ "lmOh":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },

/***/ "Ch7n":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__("ZhCu");
	
	var getEventTarget = __webpack_require__("4hnb");
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },

/***/ "Pi3e":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__("MygW");
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },

/***/ "kbwd":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },

/***/ "pwFr":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },

/***/ "+VAZ":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },

/***/ "iYQ6":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },

/***/ "SbeA":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },

/***/ "n7kv":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__("+ktn");
	var warning = __webpack_require__("EO1N");
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },

/***/ "2HUo":
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },

/***/ "9ahc":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var ReactDOMComponentTree = __webpack_require__("if0G");
	var ReactInstanceMap = __webpack_require__("yeCS");
	
	var getHostComponentFromComposite = __webpack_require__("dKDt");
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },

/***/ "f6Df":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__("pv5m");
	var traverseAllChildren = __webpack_require__("Xt9f");
	var warning = __webpack_require__("EO1N");
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__("5LTE");
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },

/***/ "KFm+":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },

/***/ "+cCx":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },

/***/ "3oi4":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__("+cCx");
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },

/***/ "FdT2":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },

/***/ "4hnb":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },

/***/ "dKDt":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__("/762");
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },

/***/ "w/Zh":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },

/***/ "Nk+5":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },

/***/ "0AML":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },

/***/ "+KdC":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },

/***/ "A+Ti":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__("if0G");
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },

/***/ "5nY2":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI"),
	    _assign = __webpack_require__("oNTU");
	
	var ReactCompositeComponent = __webpack_require__("Bj+8");
	var ReactEmptyComponent = __webpack_require__("fPVY");
	var ReactHostComponent = __webpack_require__("4HPq");
	
	var getNextDebugID = __webpack_require__("gnAk");
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },

/***/ "44cQ":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },

/***/ "aVE4":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },

/***/ "G524":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__("2HUo");
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },

/***/ "gIDI":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },

/***/ "W5vF":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__("DMKF");
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },

/***/ "Li0w":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var DOMNamespaces = __webpack_require__("PCSp");
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__("SbeA");
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },

/***/ "/bNP":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	var escapeTextContentForBrowser = __webpack_require__("2HUo");
	var setInnerHTML = __webpack_require__("Li0w");
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },

/***/ "MWDd":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },

/***/ "Xt9f":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("gIDI");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var REACT_ELEMENT_TYPE = __webpack_require__("8ZYT");
	
	var getIteratorFn = __webpack_require__("w/Zh");
	var invariant = __webpack_require__("KRWL");
	var KeyEscapeUtils = __webpack_require__("pv5m");
	var warning = __webpack_require__("EO1N");
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },

/***/ "SBlo":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("oNTU");
	
	var emptyFunction = __webpack_require__("Ygvj");
	var warning = __webpack_require__("EO1N");
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },

/***/ "l0UM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__("Ygvj");
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },

/***/ "Jfgh":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },

/***/ "RZH4":
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },

/***/ "tk+g":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__("RZH4");
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },

/***/ "+323":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__("oth9");
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },

/***/ "2mpY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },

/***/ "sy4b":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var createArrayFromMixed = __webpack_require__("2mpY");
	var getMarkupWrap = __webpack_require__("KGqj");
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },

/***/ "Ygvj":
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },

/***/ "quIK":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },

/***/ "6k5Q":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },

/***/ "bf9L":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },

/***/ "KGqj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__("Jfgh");
	
	var invariant = __webpack_require__("KRWL");
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },

/***/ "YHgc":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },

/***/ "F+9a":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },

/***/ "mkxw":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__("F+9a");
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },

/***/ "KRWL":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },

/***/ "i6tz":
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },

/***/ "oth9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__("i6tz");
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },

/***/ "njI0":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },

/***/ "InQU":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },

/***/ "EO1N":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("Ygvj");
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },

/***/ "oNTU":
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ "qDnm":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },

/***/ "gQOh":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__("Am0P");
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },

/***/ "Am0P":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("Ygvj");
	var invariant = __webpack_require__("KRWL");
	var warning = __webpack_require__("EO1N");
	
	var ReactPropTypesSecret = __webpack_require__("QvUw");
	var checkPropTypes = __webpack_require__("qDnm");
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },

/***/ "QvUw":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },

/***/ "FQLQ":
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__("U7vG")):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-fileupload"]=t(require("react")):e["react-fileupload"]=t(e.React)}(this,function(__WEBPACK_EXTERNAL_MODULE_1__){return function(e){function t(i){if(o[i])return o[i].exports;var a=o[i]={exports:{},id:i,loaded:!1};return e[i].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(module,exports,__webpack_require__){"use strict";var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)Object.prototype.hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol?"symbol":typeof e},React=__webpack_require__(1),emptyFunction=function(){},currentIEID=0,IEFormGroup=[!0],xhrList=[],currentXHRID=0,PT=React.PropTypes,FileUpload=React.createClass({displayName:"FileUpload",propTypes:{options:PT.shape({baseUrl:PT.string.isRequired,param:PT.oneOfType([PT.object,PT.func]),dataType:PT.string,chooseAndUpload:PT.bool,paramAddToField:PT.oneOfType([PT.object,PT.func]),wrapperDisplay:PT.string,timeout:PT.number,accept:PT.string,multiple:PT.bool,numberLimit:PT.oneOfType([PT.number,PT.func]),fileFieldName:PT.oneOfType([PT.string,PT.func]),withCredentials:PT.bool,requestHeaders:PT.object,tag:PT.string,userAgent:PT.string,disabledIEChoose:PT.oneOfType([PT.bool,PT.func]),_withoutFileUpload:PT.bool,filesToUpload:PT.arrayOf(PT.object),textBeforeFiles:PT.bool,beforeChoose:PT.func,chooseFile:PT.func,beforeUpload:PT.func,doUpload:PT.func,uploading:PT.func,uploadSuccess:PT.func,uploadError:PT.func,uploadFail:PT.func,onabort:PT.func}).isRequired,style:PT.object,className:PT.string},_updateProps:function(e){var t=this;this.isIE=!(this.checkIE()<0||this.checkIE()>=10);var o=e.options;this.baseUrl=o.baseUrl,this.param=o.param,this.chooseAndUpload=o.chooseAndUpload||!1,this.paramAddToField=o.paramAddToField||void 0,this.dataType="json",o.dataType&&"text"==o.dataType.toLowerCase()&&(this.dataType="text"),this.wrapperDisplay=o.wrapperDisplay||"inline-block",this.timeout="number"==typeof o.timeout&&o.timeout>0?o.timeout:0,this.accept=o.accept||"",this.multiple=o.multiple||!1,this.numberLimit=o.numberLimit||!1,this.fileFieldName=o.fileFieldName||!1,this.withCredentials=o.withCredentials||!1,this.requestHeaders=o.requestHeaders||!1,this.beforeChoose=o.beforeChoose||emptyFunction,this.chooseFile=o.chooseFile||emptyFunction,this.beforeUpload=o.beforeUpload||emptyFunction,this.doUpload=o.doUpload||emptyFunction,this.uploading=o.uploading||emptyFunction,this.uploadSuccess=o.uploadSuccess||emptyFunction,this.uploadError=o.uploadError||emptyFunction,this.uploadFail=o.uploadFail||emptyFunction,this.onabort=o.onabort||emptyFunction,this.files=o.files||this.files||!1,this.disabledIEChoose=o.disabledIEChoose||!1,this._withoutFileUpload=o._withoutFileUpload||!1,this.filesToUpload=o.filesToUpload||[],this.textBeforeFiles=o.textBeforeFiles||!1,this.filesToUpload.length&&!this.isIE&&this.filesToUpload.forEach(function(e){t.files=[e],t.commonUpload()});var i=void 0,a=void 0,s=0,r=[],n=[],l=[];this.chooseAndUpload?React.Children.forEach(e.children,function(e){e&&"chooseAndUpload"==e.ref?(i=e,s++):0==s?r.push(e):1==s?n.push(e):""}):React.Children.forEach(e.children,function(e){e&&"chooseBtn"==e.ref?(i=e,s++):e&&"uploadBtn"==e.ref?(a=e,s++):0==s?r.push(e):1==s?n.push(e):l.push(e)}),this.setState({chooseBtn:i,uploadBtn:a,before:r,middle:n,after:l})},commonChooseFile:function(){var e=this.beforeChoose();1!=e&&void 0!=e||this.refs.ajax_upload_file_input.click()},commonChange:function(e){var t=void 0;e.dataTransfer?t=e.dataTransfer.files:e.target?t=e.target.files:"";var o="function"==typeof this.numberLimit?this.numberLimit():this.numberLimit;if(this.multiple&&o&&t.length>o){for(var i={},a=0;a<o;a++)i[a]=t[a];i.length=o,t=i}this.files=t,this.chooseFile(t),this.chooseAndUpload&&this.commonUpload()},commonUpload:function(){var e=this,t=this.files.length&&this.files[0].mill||(new Date).getTime(),o=this.beforeUpload(this.files,t);if(1!=o&&void 0!=o&&"object"!=("undefined"==typeof o?"undefined":_typeof(o)))return void(this.refs.ajax_upload_file_input.value="");if(this.files){if(!this.baseUrl)throw new Error("baseUrl missing in options");var i={},a=new FormData;this.textBeforeFiles&&(a=this.appendFieldsToFormData(a)),this._withoutFileUpload||!function(){var t=_typeof(e.fileFieldName);Object.keys(e.files).forEach(function(o){if("length"!=o)if("function"==t){var i=e.files[o],s=e.fileFieldName(i);a.append(s,i)}else if("string"==t){var r=e.files[o];a.append(e.fileFieldName,r)}else{var n=e.files[o];a.append(n.name,n)}})}(),this.textBeforeFiles||(a=this.appendFieldsToFormData(a));var s=this.baseUrl,r="function"==typeof this.param?this.param(this.files):this.param,n="";r&&!function(){var e=[];r._=t,Object.keys(r).forEach(function(t){return e.push(t+"="+r[t])}),n="?"+e.join("&")}();var l=s+n,p=new XMLHttpRequest;p.open("POST",l,!0),p.withCredentials=this.withCredentials;var d=this.requestHeaders;d&&Object.keys(d).forEach(function(e){return p.setRequestHeader(e,d[e])}),this.timeout&&(p.timeout=this.timeout,p.ontimeout=function(){e.uploadError({type:"TIMEOUTERROR",message:"timeout"}),i.isTimeout=!1},i.isTimeout=!1,setTimeout(function(){i.isTimeout=!0},this.timeout)),p.onreadystatechange=function(){try{if(4==p.readyState&&p.status>=200&&p.status<400){var t="json"==e.dataType?JSON.parse(p.responseText):p.responseText;e.uploadSuccess(t)}else if(4==p.readyState){var o="json"==e.dataType?JSON.parse(p.responseText):p.responseText;e.uploadFail(o)}}catch(a){!i.isTimeout&&e.uploadError({type:"FINISHERROR",message:a.message})}},p.onerror=function(){try{var t="json"==e.dataType?JSON.parse(p.responseText):p.responseText;e.uploadError({type:"XHRERROR",message:t})}catch(o){e.uploadError({type:"XHRERROR",message:o.message})}},p.onprogress=p.upload.onprogress=function(o){e.uploading(o,t)},this._withoutFileUpload?p.send(null):p.send(a),xhrList.push(p);var u=xhrList.length-1;currentXHRID=u,p.onabort=function(){return e.onabort(t,u)},this.doUpload(this.files,t,currentXHRID),this.refs.ajax_upload_file_input.value=""}},appendFieldsToFormData:function(e){var t="function"==typeof this.paramAddToField?this.paramAddToField():this.paramAddToField;return t&&Object.keys(t).map(function(o){return e.append(o,t[o])}),e},IEBeforeChoose:function(e){var t=this.beforeChoose();1!=t&&void 0!=t&&e.preventDefault()},IEChooseFile:function(e){this.fileName=e.target.value.substring(e.target.value.lastIndexOf("\\")+1),this.chooseFile(this.fileName),this.chooseAndUpload&&this.IEUpload()!==!1&&document.getElementById("ajax_upload_file_form_"+this.IETag+currentIEID).submit(),e.target.blur()},IEUpload:function(e){function t(){clearInterval(m);try{s.uploadSuccess(s.IECallback(s.dataType,_))}catch(e){s.uploadError(e)}finally{var t=document.getElementById("ajax_upload_hidden_input_"+s.IETag+_);t.outerHTML=t.outerHTML}}var o=this,i=(new Date).getTime(),a=this.beforeUpload(this.fileName,i);if(!this.fileName||1!=a&&void 0!=a)return e&&e.preventDefault(),!1;var s=this,r=this.baseUrl,n="function"==typeof this.param?this.param(this.fileName):this.param,l="";if(n){var p=[];n._=i,void 0===n.ie&&(n.ie="true");for(var d in n)void 0!=n[d]&&p.push(d+"="+n[d]);l="?"+p.join("&")}var u=r+l;document.getElementById("ajax_upload_file_form_"+this.IETag+currentIEID).setAttribute("action",u);var c=this.fakeProgress(),h=0,f=0,m=setInterval(function(){h=c(h),o.uploading({loaded:h,total:100},i),++f>=150&&clearInterval(m)},200),_=currentIEID;window.attachEvent?document.getElementById("ajax_upload_file_frame_"+this.IETag+_).attachEvent("onload",t):document.getElementById("ajax_upload_file_frame_"+this.IETag+_).addEventListener("load",t),this.doUpload(this.fileName,i),IEFormGroup[currentIEID]=!1},IECallback:function IECallback(dataType,frameId){IEFormGroup[frameId]=!0;var frame=document.getElementById("ajax_upload_file_frame_"+this.IETag+frameId),resp={},content=frame.contentWindow?frame.contentWindow.document.body:frame.contentDocument.document.body;if(!content)throw new Error("Your browser does not support async upload");try{resp.responseText=content.innerHTML||"null innerHTML",resp.json=JSON?JSON.parse(resp.responseText):eval("("+resp.responseText+")")}catch(e){if(e.message&&e.message.indexOf("Unexpected token")>=0){if(resp.responseText.indexOf("{")>=0){var msg=resp.responseText.substring(resp.responseText.indexOf("{"),resp.responseText.lastIndexOf("}")+1);return JSON?JSON.parse(msg):eval("("+msg+")")}return{type:"FINISHERROR",message:e.message}}throw e}return"json"==dataType?resp.json:resp.responseText},forwardChoose:function(){return!this.isIE&&void this.commonChooseFile()},fowardRemoveFile:function(e){this.files=e(this.files)},filesToUpload:function(e){this.isIE||(this.files=e,this.commonUpload())},abort:function(e){void 0===e?xhrList[currentXHRID].abort():xhrList[e].abort()},checkIE:function(){var e=this.userAgent,t=e.indexOf("MSIE");return t<0?-1:parseFloat(e.substring(t+5,e.indexOf(";",t)))},fakeProgress:function(){var e=6,t=.3,o=98,i=.2;return function(a){var s=a;return s>=o?s:(s+=e,e-=t,e<i&&(e=i),s)}},getUserAgent:function(){var e=this.props.options.userAgent,t="undefined"!=typeof navigator;if(!t&&!e)throw new Error("`options.userAgent` must be set rendering react-fileuploader in situations when `navigator` is not defined in the global namespace. (on the server, for example)");return t?navigator.userAgent:e},getInitialState:function(){return{chooseBtn:{},uploadBtn:{},before:[],middle:[],after:[]}},componentWillMount:function(){this.userAgent=this.getUserAgent(),this.isIE=!(this.checkIE()<0||this.checkIE()>=10);var e=this.props.options&&this.props.options.tag;this.IETag=e?e+"_":"",this._updateProps(this.props)},componentDidMount:function(){},componentWillReceiveProps:function(e){this._updateProps(e)},render:function(){return this._packRender()},_packRender:function(){var e="";if(this.isIE)e=this._multiIEForm();else{var t={accept:this.accept,multiple:this.multiple};e=React.createElement("div",{className:this.props.className,style:this.props.style},this.state.before,React.createElement("div",{onClick:this.commonChooseFile,style:{overflow:"hidden",postion:"relative",display:this.wrapperDisplay}},this.state.chooseBtn),this.state.middle,React.createElement("div",{onClick:this.commonUpload,style:{overflow:"hidden",postion:"relative",display:this.chooseAndUpload?"none":this.wrapperDisplay}},this.state.uploadBtn),this.state.after,React.createElement("input",_extends({type:"file",name:"ajax_upload_file_input",ref:"ajax_upload_file_input",style:{display:"none"},onChange:this.commonChange},t)))}return e},_multiIEForm:function(){function e(e,t){if(!IEFormGroup[t]||!o){var a=IEFormGroup[t],s={position:"absolute",left:"-30px",top:0,zIndex:"50",fontSize:"80px",width:"200px",opacity:0,filter:"alpha(opacity=0)"},r={accept:this.accept,disabled:i},n=React.createElement("input",_extends({type:"file",name:"ajax_upload_hidden_input_"+t,id:"ajax_upload_hidden_input_"+t,ref:"ajax_upload_hidden_input_"+t,onChange:this.IEChooseFile,onClick:this.IEBeforeChoose,style:s},r));t=""+this.IETag+t,e.push(React.createElement("form",{id:"ajax_upload_file_form_"+t,method:"post",target:"ajax_upload_file_frame_"+t,key:"ajax_upload_file_form_"+t,encType:"multipart/form-data",ref:"form_"+t,onSubmit:this.IEUpload,style:{display:a?"block":"none"}},this.state.before,React.createElement("div",{style:{overflow:"hidden",position:"relative",display:"inline-block"}},this.state.chooseBtn,n),this.state.middle,React.createElement("div",{style:{overflow:"hidden",position:"relative",display:this.chooseAndUpload?"none":this.wrapperDisplay}},this.state.uploadBtn,React.createElement("input",{type:"submit",style:{position:"absolute",left:0,top:0,fontSize:"50px",width:"200px",opacity:0}})),this.state.after)),e.push(React.createElement("iframe",{id:"ajax_upload_file_frame_"+t,name:"ajax_upload_file_frame_"+t,key:"ajax_upload_file_frame_"+t,className:"ajax_upload_file_frame",style:{display:"none",width:0,height:0,margin:0,border:0}}))}}for(var t=[],o=!1,i="function"==typeof this.disabledIEChoose?this.disabledIEChoose():this.disabledIEChoose,a=0;a<IEFormGroup.length;a++)e.call(this,t,a),IEFormGroup[a]&&!o&&(o=!0,currentIEID=a),a==IEFormGroup.length-1&&!o&&IEFormGroup.push(!0);return React.createElement("div",{className:this.props.className,style:this.props.style,id:"react-file-uploader"},t)}});module.exports=FileUpload},function(e,t){e.exports=__WEBPACK_EXTERNAL_MODULE_1__}])});

/***/ },

/***/ "J6Y4":
/***/ function(module, exports, __webpack_require__) {

	!function(t,r){ true?module.exports=r(__webpack_require__("U7vG"),__webpack_require__("504h")):"function"==typeof define&&define.amd?define(["react","highcharts"],r):"object"==typeof exports?exports.ReactHighcharts=r(require("react"),require("highcharts")):t.ReactHighcharts=r(t.React,t.Highcharts)}(this,function(t,r){return function(t){function r(o){if(e[o])return e[o].exports;var n=e[o]={exports:{},id:o,loaded:!1};return t[o].call(n.exports,n,n.exports,r),n.loaded=!0,n.exports}var e={};return r.m=t,r.c=e,r.p="",r(0)}([function(t,r,e){t.exports=e(3)},function(r,e){r.exports=t},function(t,r,e){(function(r){"use strict";var o=Object.assign||function(t){for(var r=1;r<arguments.length;r++){var e=arguments[r];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t},n=e(1),i="undefined"==typeof r?window:r;t.exports=function(r,e){var c="Highcharts"+r,s=n.createClass({displayName:c,propTypes:{config:n.PropTypes.object.isRequired,isPureConfig:n.PropTypes.bool,neverReflow:n.PropTypes.bool,callback:n.PropTypes.func,domProps:n.PropTypes.object},defaultProps:{callback:function(){},domProps:{}},renderChart:function(t){var n=this;if(!t)throw new Error("Config must be specified for the "+c+" component");var s=t.chart;this.chart=new e[r](o({},t,{chart:o({},s,{renderTo:this.refs.chart})}),this.props.callback),this.props.neverReflow||i&&i.requestAnimationFrame&&requestAnimationFrame(function(){n.chart&&n.chart.options&&n.chart.reflow()})},shouldComponentUpdate:function(t){return!!(t.neverReflow||t.isPureConfig&&this.props.config===t.config)||(this.renderChart(t.config),!1)},getChart:function(){if(!this.chart)throw new Error("getChart() should not be called before the component is mounted");return this.chart},componentDidMount:function(){this.renderChart(this.props.config)},componentWillUnmount:function(){this.chart.destroy()},render:function(){return n.createElement("div",o({ref:"chart"},this.props.domProps))}});return s.Highcharts=e,s.withHighcharts=function(e){return t.exports(r,e)},s}}).call(r,function(){return this}())},function(t,r,e){"use strict";t.exports=e(2)("Chart",e(4))},function(t,e){t.exports=r}])});

/***/ },

/***/ "p7hS":
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__("U7vG");
	var ReactDOM = __webpack_require__("O27J");
	var DOMFactories = __webpack_require__("5lT/");
	var PropTypes = __webpack_require__("5sUy");
	var ExecutionEnvironment = __webpack_require__("tNAm");
	var ModalPortal = React.createFactory(__webpack_require__("F/Ev"));
	var ariaAppHider = __webpack_require__("1wHk");
	var refCount = __webpack_require__("KJCY");
	var elementClass = __webpack_require__("leg3");
	var renderSubtreeIntoContainer = __webpack_require__("O27J").unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__("df3L");
	var createReactClass = __webpack_require__("V3S2");
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = createReactClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: PropTypes.bool.isRequired,
	    style: PropTypes.shape({
	      content: PropTypes.object,
	      overlay: PropTypes.object
	    }),
	    portalClassName: PropTypes.string,
	    bodyOpenClassName: PropTypes.string,
	    appElement: PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: PropTypes.func,
	    onRequestClose: PropTypes.func,
	    closeTimeoutMS: PropTypes.number,
	    ariaHideApp: PropTypes.bool,
	    shouldCloseOnOverlayClick: PropTypes.bool,
	    parentSelector: PropTypes.func,
	    role: PropTypes.string,
	    contentLabel: PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      bodyOpenClassName: 'ReactModal__Body--open',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    if (this.props.isOpen) refCount.add(this);
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillUpdate: function(newProps) {
	    if(newProps.portalClassName !== this.props.portalClassName) {
	      this.node.className = newProps.portalClassName;
	    }
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    if (newProps.isOpen) refCount.add(this);
	    if (!newProps.isOpen) refCount.remove(this);
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (!this.node) return;
	
	    refCount.remove(this);
	
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    var state = this.portal.state;
	    var now = Date.now();
	    var closesAt = state.isOpen && this.props.closeTimeoutMS
	      && (state.closesAt
	        || now + this.props.closeTimeoutMS);
	
	    if (closesAt) {
	      if (!state.beforeClose) {
	        this.portal.closeWithTimeout();
	      }
	
	      var that = this;
	      setTimeout(function() { that.removePortal(); }, closesAt - now);
	    } else {
	      this.removePortal();
	    }
	  },
	
	  removePortal: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	
	    if (refCount.count() === 0) {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen || refCount.count() > 0) {
	      elementClass(document.body).add(this.props.bodyOpenClassName);
	    } else {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return DOMFactories.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },

/***/ "F/Ev":
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__("U7vG");
	var DOMFactories = __webpack_require__("5lT/");
	var focusManager = __webpack_require__("nnEy");
	var scopeTab = __webpack_require__("eLVa");
	var Assign = __webpack_require__("df3L");
	var createReactClass = __webpack_require__("V3S2");
	
	var div = DOMFactories.div;
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var ModalPortal = module.exports = createReactClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  afterClose: function () {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  open: function () {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    var closesAt = Date.now() + this.props.closeTimeoutMS;
	    this.setState({beforeClose: true, closesAt: closesAt}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	      closesAt: null
	    }, this.afterClose);
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayOnClick: function (event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentOnClick: function () {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.state.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var classNames = (typeof additional === 'object') ? additional : {
	      base: CLASS_NAMES[which],
	      afterOpen: CLASS_NAMES[which] + "--after-open",
	      beforeClose: CLASS_NAMES[which] + "--before-close"
	    };
	    var className = classNames.base;
	    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
	    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
	    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayOnClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onClick: this.handleContentOnClick,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },

/***/ "1wHk":
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },

/***/ "nnEy":
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__("BwbV");
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElements.push(document.activeElement);
	};
	
	exports.returnFocus = function() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
	  }
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};


/***/ },

/***/ "KJCY":
/***/ function(module, exports) {

	var modals = [];
	
	module.exports = {
	  add: function (element) {
	    if (modals.indexOf(element) === -1) {
	      modals.push(element);
	    }
	  },
	  remove: function (element) {
	    var index = modals.indexOf(element);
	    if (index === -1) {
	      return;
	    }
	    modals.splice(index, 1);
	  },
	  count: function () {
	    return modals.length;
	  }
	};


/***/ },

/***/ "eLVa":
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__("BwbV");
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },

/***/ "BwbV":
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },

/***/ "sW0/":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("p7hS");
	


/***/ },

/***/ "jZSE":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("iMmd");
	
	var emptyObject = __webpack_require__("4d78");
	var _invariant = __webpack_require__("bd0f");
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },

/***/ "V3S2":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__("U7vG");
	var factory = __webpack_require__("jZSE");
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },

/***/ "leg3":
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },

/***/ "tNAm":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },

/***/ "9KX8":
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },

/***/ "4d78":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },

/***/ "bd0f":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },

/***/ "df3L":
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ },

/***/ "iMmd":
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ "Nd80":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("9KX8");
	var invariant = __webpack_require__("bd0f");
	var ReactPropTypesSecret = __webpack_require__("O7At");
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },

/***/ "5sUy":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__("Nd80")();
	}


/***/ },

/***/ "O7At":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },

/***/ "5lT/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__("U7vG"));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },

/***/ "oFSt":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },

/***/ "xFEJ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__("UGef");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },

/***/ "rc2I":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__("azq/");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },

/***/ "Uach":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__("Q4Q0");
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__("zxdO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },

/***/ "Raii":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	var _InternalPropTypes = __webpack_require__("zxdO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },

/***/ "zxdO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__("UGef");
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },

/***/ "azq/":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__("8xmk");
	
	var _ContextUtils = __webpack_require__("xFEJ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },

/***/ "XGmX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },

/***/ "JbeC":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },

/***/ "8xmk":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__("UGef");
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },

/***/ "Q4Q0":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	var _InternalPropTypes = __webpack_require__("zxdO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },

/***/ "a8tM":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	var _InternalPropTypes = __webpack_require__("zxdO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },

/***/ "0VuO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },

/***/ "+2z7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _createTransitionManager2 = __webpack_require__("RnJi");
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__("zxdO");
	
	var _RouterContext = __webpack_require__("H+xT");
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	var _RouterUtils = __webpack_require__("wgN/");
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },

/***/ "H+xT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__("UGef");
	
	var _getRouteParams = __webpack_require__("4N/R");
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__("xFEJ");
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },

/***/ "wgN/":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },

/***/ "fZNG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__("oFSt");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "bWYT":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__("H+xT");
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },

/***/ "clLG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__("1Kzh");
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__("NCNO");
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },

/***/ "o8EF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },

/***/ "vagL":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__("teWx");
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__("SOiI");
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__("Mmla");
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },

/***/ "NCNO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__("lOld");
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },

/***/ "RnJi":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__("o8EF");
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__("fZNG");
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__("29Iq");
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__("5g7L");
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__("FHgH");
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "5g7L":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__("oFSt");
	
	var _PromiseUtils = __webpack_require__("JbeC");
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },

/***/ "4N/R":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },

/***/ "Qi5m":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__("CK0t");
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__("NCNO");
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },

/***/ "Zfgq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__("8xmk");
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__("+2z7");
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__("azq/");
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__("rc2I");
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__("XL6o");
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__("Uach");
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__("Raii");
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__("Q4Q0");
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__("a8tM");
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__("H+xT");
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__("1Gip");
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__("lOld");
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__("bWYT");
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__("clLG");
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__("Qi5m");
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__("vagL");
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },

/***/ "29Iq":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },

/***/ "1Gip":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__("Y4sZ");
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__("vagL");
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__("RnJi");
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	var _RouterUtils = __webpack_require__("wgN/");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },

/***/ "FHgH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__("oFSt");
	
	var _PromiseUtils = __webpack_require__("JbeC");
	
	var _PatternUtils = __webpack_require__("XGmX");
	
	var _routerWarning = __webpack_require__("2GWW");
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__("0VuO");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },

/***/ "2GWW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },

/***/ "lOld":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__("teWx");
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__("SOiI");
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ "XL6o":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__("sRmE");
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__("T+2Y");
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__("xFEJ");
	
	var _PropTypes = __webpack_require__("8xmk");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },

/***/ "eF/p":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("szMX");
	
	var emptyObject = __webpack_require__("S2dV");
	var _invariant = __webpack_require__("tcPb");
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },

/***/ "sRmE":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__("U7vG");
	var factory = __webpack_require__("eF/p");
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },

/***/ "IoEN":
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },

/***/ "S2dV":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },

/***/ "tcPb":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },

/***/ "Y4sZ":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },

/***/ "rMmN":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },

/***/ "8hnC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	var _DOMUtils = __webpack_require__("2inJ");
	
	var _DOMStateStorage = __webpack_require__("t+J7");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	var _ExecutionEnvironment = __webpack_require__("3qHv");
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },

/***/ "t+J7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },

/***/ "2inJ":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },

/***/ "3qHv":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },

/***/ "ip+G":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__("8hnC");
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	var _DOMUtils = __webpack_require__("2inJ");
	
	var _DOMStateStorage = __webpack_require__("t+J7");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },

/***/ "a2BU":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__("lFM1");
	
	var _Actions = __webpack_require__("Y4sZ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },

/***/ "lFM1":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },

/***/ "NSk9":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__("8hnC");
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },

/***/ "1Kzh":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__("3qHv");
	
	var _BrowserProtocol = __webpack_require__("8hnC");
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__("NSk9");
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__("2inJ");
	
	var _createHistory = __webpack_require__("6kDn");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },

/***/ "CK0t":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__("3qHv");
	
	var _DOMUtils = __webpack_require__("2inJ");
	
	var _HashProtocol = __webpack_require__("ip+G");
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__("6kDn");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },

/***/ "6kDn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__("rMmN");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	var _runTransitionHook = __webpack_require__("Kwm3");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__("Y4sZ");
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },

/***/ "Mmla":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__("K/Fm");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	var _createHistory = __webpack_require__("6kDn");
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__("Y4sZ");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },

/***/ "Kwm3":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__("WuRR");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },

/***/ "SOiI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__("Kwm3");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__("lFM1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },

/***/ "teWx":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__("GD6N");
	
	var _runTransitionHook = __webpack_require__("Kwm3");
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__("a2BU");
	
	var _PathUtils = __webpack_require__("lFM1");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },

/***/ "T+2Y":
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },

/***/ "K/Fm":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },

/***/ "szMX":
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ "t5Lr":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("IoEN");
	var invariant = __webpack_require__("tcPb");
	var ReactPropTypesSecret = __webpack_require__("g9S7");
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },

/***/ "UGef":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__("t5Lr")();
	}


/***/ },

/***/ "g9S7":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },

/***/ "GD6N":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__("KxbG");
	var objectAssign = __webpack_require__("szMX");
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },

/***/ "KxbG":
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },

/***/ "WuRR":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },

/***/ "rAAB":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "vFCP":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqualFuzzy = __webpack_require__("i32V");
	
	var _shallowEqualFuzzy2 = _interopRequireDefault(_shallowEqualFuzzy);
	
	var _jquery = __webpack_require__("7t+N");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("X4M9");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var namespace = 'react-select2-wrapper';
	
	var Select2 = function (_Component) {
	  _inherits(Select2, _Component);
	
	  function Select2(props) {
	    _classCallCheck(this, Select2);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Select2).call(this, props));
	
	    _this.el = null;
	    return _this;
	  }
	
	  _createClass(Select2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initSelect2();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.el) {
	        this.setValue(this.prepareValue(nextProps.value, this.props.defaultValue));
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (!(0, _shallowEqualFuzzy2.default)(prevProps.data, this.props.data)) {
	        this.destroySelect2(false);
	        this.initSelect2(false);
	      } else {
	        var options = this.props.options;
	
	        if (!(0, _shallowEqualFuzzy2.default)(prevProps.options, options)) {
	          this.el.select2(this.prepareOptions(options));
	        }
	      }
	
	      var handlerChanged = function handlerChanged(e) {
	        return prevProps[e[1]] !== _this2.props[e[1]];
	      };
	
	      if (this.props.events.some(handlerChanged)) {
	        this.detachEventHandlers();
	        this.attachEventHandlers();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroySelect2();
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      var elVal = this.props.multiple ? this.el.val() || [] : this.el.val();
	      if (!(0, _shallowEqualFuzzy2.default)(elVal, value)) {
	        this.el.val(value).trigger('change');
	      }
	    }
	  }, {
	    key: 'prepareValue',
	    value: function prepareValue(value, defaultValue) {
	      var issetValue = typeof value !== 'undefined' && value !== null;
	      var issetDefaultValue = typeof defaultValue !== 'undefined';
	
	      if (!issetValue && issetDefaultValue) {
	        return defaultValue;
	      }
	      return value;
	    }
	  }, {
	    key: 'prepareOptions',
	    value: function prepareOptions(options) {
	      var opt = options;
	      if (typeof opt.dropdownParent === 'string') {
	        opt.dropdownParent = (0, _jquery2.default)(opt.dropdownParent);
	      }
	      return opt;
	    }
	  }, {
	    key: 'initSelect2',
	    value: function initSelect2() {
	      var withCallbacks = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (this.el) {
	        return;
	      }
	      var _props = this.props;
	      var defaultValue = _props.defaultValue;
	      var value = _props.value;
	      var options = _props.options;
	
	
	      this.el = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
	      this.el.select2(this.prepareOptions(options));
	
	      if (withCallbacks) {
	        this.attachEventHandlers();
	      }
	
	      if (typeof defaultValue === 'undefined' && typeof value !== 'undefined') {
	        this.setValue(value);
	      }
	    }
	  }, {
	    key: 'destroySelect2',
	    value: function destroySelect2() {
	      var withCallbacks = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (!this.el) {
	        return;
	      }
	
	      if (withCallbacks) {
	        this.detachEventHandlers();
	      }
	
	      this.el.select2('destroy');
	      this.el = null;
	    }
	  }, {
	    key: 'attachEventHandlers',
	    value: function attachEventHandlers() {
	      var _this3 = this;
	
	      this.props.events.forEach(function (event) {
	        if (typeof _this3.props[event[1]] !== 'undefined') {
	          _this3.el.on(event[0], _this3.props[event[1]]);
	        }
	      });
	    }
	  }, {
	    key: 'detachEventHandlers',
	    value: function detachEventHandlers() {
	      var _this4 = this;
	
	      this.props.events.forEach(function (event) {
	        if (typeof _this4.props[event[1]] !== 'undefined') {
	          _this4.el.off(event[0]);
	        }
	      });
	    }
	  }, {
	    key: 'isObject',
	    value: function isObject(value) {
	      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	      return type === 'function' || value && type === 'object' || false;
	    }
	  }, {
	    key: 'makeOption',
	    value: function makeOption(item) {
	      if (this.isObject(item)) {
	        var id = item.id;
	        var text = item.text;
	
	        var itemParams = _objectWithoutProperties(item, ['id', 'text']);
	
	        return _react2.default.createElement(
	          'option',
	          _extends({ key: 'option-' + id, value: id }, itemParams),
	          text
	        );
	      }
	
	      return _react2.default.createElement(
	        'option',
	        { key: 'option-' + item, value: item },
	        item
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props;
	      var data = _props2.data;
	      var value = _props2.value;
	
	      var props = _objectWithoutProperties(_props2, ['data', 'value']);
	
	      delete props.options;
	      delete props.events;
	      delete props.onOpen;
	      delete props.onClose;
	      delete props.onSelect;
	      delete props.onChange;
	      delete props.onUnselect;
	
	      return _react2.default.createElement(
	        'select',
	        props,
	        data.map(function (item, k) {
	          if (_this5.isObject(item) && _this5.isObject(item.children)) {
	            var children = item.children;
	            var text = item.text;
	
	            var itemParams = _objectWithoutProperties(item, ['children', 'text']);
	
	            return _react2.default.createElement(
	              'optgroup',
	              _extends({ key: 'optgroup-' + k, label: text }, itemParams),
	              children.map(function (child) {
	                return _this5.makeOption(child);
	              })
	            );
	          }
	          return _this5.makeOption(item);
	        })
	      );
	    }
	  }]);
	
	  return Select2;
	}(_react.Component);
	
	Select2.propTypes = {
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array, _react.PropTypes.string]),
	  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array, _react.PropTypes.string]),
	  data: _react.PropTypes.array,
	  events: _react.PropTypes.array,
	  options: _react.PropTypes.object,
	  multiple: _react.PropTypes.bool,
	  onOpen: _react.PropTypes.func,
	  onClose: _react.PropTypes.func,
	  onSelect: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onUnselect: _react.PropTypes.func
	};
	Select2.defaultProps = {
	  data: [],
	  events: [['change.' + namespace, 'onChange'], ['select2:open.' + namespace, 'onOpen'], ['select2:close.' + namespace, 'onClose'], ['select2:select.' + namespace, 'onSelect'], ['select2:unselect.' + namespace, 'onUnselect']],
	  options: {},
	  multiple: false
	};
	exports.default = Select2;
	module.exports = exports['default'];

/***/ },

/***/ "X4M9":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
	 * Select2 4.0.3
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("7t+N")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node/CommonJS
	    factory(require('jquery'));
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	}(function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 =
	(function () {
	  // Restore the Select2 AMD loader so it can be used
	  // Needed mostly in the language files, where the loader is not inserted
	  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	    var S2 = jQuery.fn.select2.amd;
	  }
	var S2;(function () { if (!S2 || !S2.requirejs) {
	if (!S2) { S2 = {}; } else { require = S2; }
	/**
	 * @license almond 0.3.1 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
	 * Available via the MIT or new BSD license.
	 * see: http://github.com/jrburke/almond for details
	 */
	//Going sloppy to avoid 'use strict' string cost, but strict practices should
	//be followed.
	/*jslint sloppy: true */
	/*global setTimeout: false */
	
	var requirejs, require, define;
	(function (undef) {
	    var main, req, makeMap, handlers,
	        defined = {},
	        waiting = {},
	        config = {},
	        defining = {},
	        hasOwn = Object.prototype.hasOwnProperty,
	        aps = [].slice,
	        jsSuffixRegExp = /\.js$/;
	
	    function hasProp(obj, prop) {
	        return hasOwn.call(obj, prop);
	    }
	
	    /**
	     * Given a relative module name, like ./something, normalize it to
	     * a real name that can be mapped to a path.
	     * @param {String} name the relative name
	     * @param {String} baseName a real name that the name arg is relative
	     * to.
	     * @returns {String} normalized name
	     */
	    function normalize(name, baseName) {
	        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
	            foundI, foundStarMap, starI, i, j, part,
	            baseParts = baseName && baseName.split("/"),
	            map = config.map,
	            starMap = (map && map['*']) || {};
	
	        //Adjust any relative paths.
	        if (name && name.charAt(0) === ".") {
	            //If have a base name, try to normalize against it,
	            //otherwise, assume it is a top-level require that will
	            //be relative to baseUrl in the end.
	            if (baseName) {
	                name = name.split('/');
	                lastIndex = name.length - 1;
	
	                // Node .js allowance:
	                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	                }
	
	                //Lop off the last part of baseParts, so that . matches the
	                //"directory" and not name of the baseName's module. For instance,
	                //baseName of "one/two/three", maps to "one/two/three.js", but we
	                //want the directory, "one/two" for this normalization.
	                name = baseParts.slice(0, baseParts.length - 1).concat(name);
	
	                //start trimDots
	                for (i = 0; i < name.length; i += 1) {
	                    part = name[i];
	                    if (part === ".") {
	                        name.splice(i, 1);
	                        i -= 1;
	                    } else if (part === "..") {
	                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
	                            //End of the line. Keep at least one non-dot
	                            //path segment at the front so it can be mapped
	                            //correctly to disk. Otherwise, there is likely
	                            //no path mapping for a path starting with '..'.
	                            //This can still fail, but catches the most reasonable
	                            //uses of ..
	                            break;
	                        } else if (i > 0) {
	                            name.splice(i - 1, 2);
	                            i -= 2;
	                        }
	                    }
	                }
	                //end trimDots
	
	                name = name.join("/");
	            } else if (name.indexOf('./') === 0) {
	                // No baseName, so this is ID is resolved relative
	                // to baseUrl, pull off the leading dot.
	                name = name.substring(2);
	            }
	        }
	
	        //Apply map config if available.
	        if ((baseParts || starMap) && map) {
	            nameParts = name.split('/');
	
	            for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                    //Find the longest baseName segment match in the config.
	                    //So, do joins on the biggest to smallest lengths of baseParts.
	                    for (j = baseParts.length; j > 0; j -= 1) {
	                        mapValue = map[baseParts.slice(0, j).join('/')];
	
	                        //baseName segment has  config, find if it has one for
	                        //this name.
	                        if (mapValue) {
	                            mapValue = mapValue[nameSegment];
	                            if (mapValue) {
	                                //Match, update name to the new value.
	                                foundMap = mapValue;
	                                foundI = i;
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (foundMap) {
	                    break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                    foundStarMap = starMap[nameSegment];
	                    starI = i;
	                }
	            }
	
	            if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	            }
	
	            if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	            }
	        }
	
	        return name;
	    }
	
	    function makeRequire(relName, forceSync) {
	        return function () {
	            //A version of a require function that passes a moduleName
	            //value for items that may need to
	            //look up paths relative to the moduleName
	            var args = aps.call(arguments, 0);
	
	            //If first arg is not require('string'), and there is only
	            //one arg, it is the array form without a callback. Insert
	            //a null so that the following concat is correct.
	            if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	            }
	            return req.apply(undef, args.concat([relName, forceSync]));
	        };
	    }
	
	    function makeNormalize(relName) {
	        return function (name) {
	            return normalize(name, relName);
	        };
	    }
	
	    function makeLoad(depName) {
	        return function (value) {
	            defined[depName] = value;
	        };
	    }
	
	    function callDep(name) {
	        if (hasProp(waiting, name)) {
	            var args = waiting[name];
	            delete waiting[name];
	            defining[name] = true;
	            main.apply(undef, args);
	        }
	
	        if (!hasProp(defined, name) && !hasProp(defining, name)) {
	            throw new Error('No ' + name);
	        }
	        return defined[name];
	    }
	
	    //Turns a plugin!resource to [plugin, resource]
	    //with the plugin being undefined if the name
	    //did not have a plugin prefix.
	    function splitPrefix(name) {
	        var prefix,
	            index = name ? name.indexOf('!') : -1;
	        if (index > -1) {
	            prefix = name.substring(0, index);
	            name = name.substring(index + 1, name.length);
	        }
	        return [prefix, name];
	    }
	
	    /**
	     * Makes a name map, normalizing the name, and using a plugin
	     * for normalization if necessary. Grabs a ref to plugin
	     * too, as an optimization.
	     */
	    makeMap = function (name, relName) {
	        var plugin,
	            parts = splitPrefix(name),
	            prefix = parts[0];
	
	        name = parts[1];
	
	        if (prefix) {
	            prefix = normalize(prefix, relName);
	            plugin = callDep(prefix);
	        }
	
	        //Normalize according
	        if (prefix) {
	            if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relName));
	            } else {
	                name = normalize(name, relName);
	            }
	        } else {
	            name = normalize(name, relName);
	            parts = splitPrefix(name);
	            prefix = parts[0];
	            name = parts[1];
	            if (prefix) {
	                plugin = callDep(prefix);
	            }
	        }
	
	        //Using ridiculous property names for space reasons
	        return {
	            f: prefix ? prefix + '!' + name : name, //fullName
	            n: name,
	            pr: prefix,
	            p: plugin
	        };
	    };
	
	    function makeConfig(name) {
	        return function () {
	            return (config && config.config && config.config[name]) || {};
	        };
	    }
	
	    handlers = {
	        require: function (name) {
	            return makeRequire(name);
	        },
	        exports: function (name) {
	            var e = defined[name];
	            if (typeof e !== 'undefined') {
	                return e;
	            } else {
	                return (defined[name] = {});
	            }
	        },
	        module: function (name) {
	            return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	            };
	        }
	    };
	
	    main = function (name, deps, callback, relName) {
	        var cjsModule, depName, ret, map, i,
	            args = [],
	            callbackType = typeof callback,
	            usingExports;
	
	        //Use name if no relName
	        relName = relName || name;
	
	        //Call the callback to define the module, if necessary.
	        if (callbackType === 'undefined' || callbackType === 'function') {
	            //Pull out the defined dependencies and pass the ordered
	            //values to the callback.
	            //Default to [require, exports, module] if no deps
	            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	            for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relName);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                    args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                    //CommonJS module spec 1.1
	                    args[i] = handlers.exports(name);
	                    usingExports = true;
	                } else if (depName === "module") {
	                    //CommonJS module spec 1.1
	                    cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) ||
	                           hasProp(waiting, depName) ||
	                           hasProp(defining, depName)) {
	                    args[i] = callDep(depName);
	                } else if (map.p) {
	                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                    args[i] = defined[depName];
	                } else {
	                    throw new Error(name + ' missing ' + depName);
	                }
	            }
	
	            ret = callback ? callback.apply(defined[name], args) : undefined;
	
	            if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef &&
	                        cjsModule.exports !== defined[name]) {
	                    defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                    //Use the return value from the function.
	                    defined[name] = ret;
	                }
	            }
	        } else if (name) {
	            //May just be an object definition for the module. Only
	            //worry about defining if have a module name.
	            defined[name] = callback;
	        }
	    };
	
	    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
	        if (typeof deps === "string") {
	            if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	            }
	            //Just return the module wanted. In this scenario, the
	            //deps arg is the module name, and second arg (if passed)
	            //is just the relName.
	            //Normalize module name, if it contains . or ..
	            return callDep(makeMap(deps, callback).f);
	        } else if (!deps.splice) {
	            //deps is a config object, not an array.
	            config = deps;
	            if (config.deps) {
	                req(config.deps, config.callback);
	            }
	            if (!callback) {
	                return;
	            }
	
	            if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	            } else {
	                deps = undef;
	            }
	        }
	
	        //Support require(['a'])
	        callback = callback || function () {};
	
	        //If relName is a function, it is an errback handler,
	        //so remove it.
	        if (typeof relName === 'function') {
	            relName = forceSync;
	            forceSync = alt;
	        }
	
	        //Simulate async callback;
	        if (forceSync) {
	            main(undef, deps, callback, relName);
	        } else {
	            //Using a non-zero value because of concern for what old browsers
	            //do, and latest browsers "upgrade" to 4 if lower value is used:
	            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	            //If want a value immediately, use require('id') instead -- something
	            //that works in almond on the global level, but not guaranteed and
	            //unlikely to work in other AMD implementations.
	            setTimeout(function () {
	                main(undef, deps, callback, relName);
	            }, 4);
	        }
	
	        return req;
	    };
	
	    /**
	     * Just drops the config on the floor, but returns req in case
	     * the config return value is used.
	     */
	    req.config = function (cfg) {
	        return req(cfg);
	    };
	
	    /**
	     * Expose module registry for debugging and tooling
	     */
	    requirejs._defined = defined;
	
	    define = function (name, deps, callback) {
	        if (typeof name !== 'string') {
	            throw new Error('See almond README: incorrect module build, no module name');
	        }
	
	        //This module may not have dependencies
	        if (!deps.splice) {
	            //deps is not an array, so probably means
	            //an object literal or factory function for
	            //the value. Adjust args.
	            callback = deps;
	            deps = [];
	        }
	
	        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	            waiting[name] = [name, deps, callback];
	        }
	    };
	
	    define.amd = {
	        jQuery: true
	    };
	}());
	
	S2.requirejs = requirejs;S2.require = require;S2.define = define;
	}
	}());
	S2.define("almond", function(){});
	
	/* global jQuery:false, $:false */
	S2.define('jquery',[],function () {
	  var _$ = jQuery || $;
	
	  if (_$ == null && console && console.error) {
	    console.error(
	      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
	      'found. Make sure that you are including jQuery before Select2 on your ' +
	      'web page.'
	    );
	  }
	
	  return _$;
	});
	
	S2.define('select2/utils',[
	  'jquery'
	], function ($) {
	  var Utils = {};
	
	  Utils.Extend = function (ChildClass, SuperClass) {
	    var __hasProp = {}.hasOwnProperty;
	
	    function BaseConstructor () {
	      this.constructor = ChildClass;
	    }
	
	    for (var key in SuperClass) {
	      if (__hasProp.call(SuperClass, key)) {
	        ChildClass[key] = SuperClass[key];
	      }
	    }
	
	    BaseConstructor.prototype = SuperClass.prototype;
	    ChildClass.prototype = new BaseConstructor();
	    ChildClass.__super__ = SuperClass.prototype;
	
	    return ChildClass;
	  };
	
	  function getMethods (theClass) {
	    var proto = theClass.prototype;
	
	    var methods = [];
	
	    for (var methodName in proto) {
	      var m = proto[methodName];
	
	      if (typeof m !== 'function') {
	        continue;
	      }
	
	      if (methodName === 'constructor') {
	        continue;
	      }
	
	      methods.push(methodName);
	    }
	
	    return methods;
	  }
	
	  Utils.Decorate = function (SuperClass, DecoratorClass) {
	    var decoratedMethods = getMethods(DecoratorClass);
	    var superMethods = getMethods(SuperClass);
	
	    function DecoratedClass () {
	      var unshift = Array.prototype.unshift;
	
	      var argCount = DecoratorClass.prototype.constructor.length;
	
	      var calledConstructor = SuperClass.prototype.constructor;
	
	      if (argCount > 0) {
	        unshift.call(arguments, SuperClass.prototype.constructor);
	
	        calledConstructor = DecoratorClass.prototype.constructor;
	      }
	
	      calledConstructor.apply(this, arguments);
	    }
	
	    DecoratorClass.displayName = SuperClass.displayName;
	
	    function ctr () {
	      this.constructor = DecoratedClass;
	    }
	
	    DecoratedClass.prototype = new ctr();
	
	    for (var m = 0; m < superMethods.length; m++) {
	        var superMethod = superMethods[m];
	
	        DecoratedClass.prototype[superMethod] =
	          SuperClass.prototype[superMethod];
	    }
	
	    var calledMethod = function (methodName) {
	      // Stub out the original method if it's not decorating an actual method
	      var originalMethod = function () {};
	
	      if (methodName in DecoratedClass.prototype) {
	        originalMethod = DecoratedClass.prototype[methodName];
	      }
	
	      var decoratedMethod = DecoratorClass.prototype[methodName];
	
	      return function () {
	        var unshift = Array.prototype.unshift;
	
	        unshift.call(arguments, originalMethod);
	
	        return decoratedMethod.apply(this, arguments);
	      };
	    };
	
	    for (var d = 0; d < decoratedMethods.length; d++) {
	      var decoratedMethod = decoratedMethods[d];
	
	      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	    }
	
	    return DecoratedClass;
	  };
	
	  var Observable = function () {
	    this.listeners = {};
	  };
	
	  Observable.prototype.on = function (event, callback) {
	    this.listeners = this.listeners || {};
	
	    if (event in this.listeners) {
	      this.listeners[event].push(callback);
	    } else {
	      this.listeners[event] = [callback];
	    }
	  };
	
	  Observable.prototype.trigger = function (event) {
	    var slice = Array.prototype.slice;
	    var params = slice.call(arguments, 1);
	
	    this.listeners = this.listeners || {};
	
	    // Params should always come in as an array
	    if (params == null) {
	      params = [];
	    }
	
	    // If there are no arguments to the event, use a temporary object
	    if (params.length === 0) {
	      params.push({});
	    }
	
	    // Set the `_type` of the first object to the event
	    params[0]._type = event;
	
	    if (event in this.listeners) {
	      this.invoke(this.listeners[event], slice.call(arguments, 1));
	    }
	
	    if ('*' in this.listeners) {
	      this.invoke(this.listeners['*'], arguments);
	    }
	  };
	
	  Observable.prototype.invoke = function (listeners, params) {
	    for (var i = 0, len = listeners.length; i < len; i++) {
	      listeners[i].apply(this, params);
	    }
	  };
	
	  Utils.Observable = Observable;
	
	  Utils.generateChars = function (length) {
	    var chars = '';
	
	    for (var i = 0; i < length; i++) {
	      var randomChar = Math.floor(Math.random() * 36);
	      chars += randomChar.toString(36);
	    }
	
	    return chars;
	  };
	
	  Utils.bind = function (func, context) {
	    return function () {
	      func.apply(context, arguments);
	    };
	  };
	
	  Utils._convertData = function (data) {
	    for (var originalKey in data) {
	      var keys = originalKey.split('-');
	
	      var dataLevel = data;
	
	      if (keys.length === 1) {
	        continue;
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];
	
	        // Lowercase the first letter
	        // By default, dash-separated becomes camelCase
	        key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	        if (!(key in dataLevel)) {
	          dataLevel[key] = {};
	        }
	
	        if (k == keys.length - 1) {
	          dataLevel[key] = data[originalKey];
	        }
	
	        dataLevel = dataLevel[key];
	      }
	
	      delete data[originalKey];
	    }
	
	    return data;
	  };
	
	  Utils.hasScroll = function (index, el) {
	    // Adapted from the function created by @ShadowScripter
	    // and adapted by @BillBarry on the Stack Exchange Code Review website.
	    // The original code can be found at
	    // http://codereview.stackexchange.com/q/13338
	    // and was designed to be used with the Sizzle selector engine.
	
	    var $el = $(el);
	    var overflowX = el.style.overflowX;
	    var overflowY = el.style.overflowY;
	
	    //Check both x and y declarations
	    if (overflowX === overflowY &&
	        (overflowY === 'hidden' || overflowY === 'visible')) {
	      return false;
	    }
	
	    if (overflowX === 'scroll' || overflowY === 'scroll') {
	      return true;
	    }
	
	    return ($el.innerHeight() < el.scrollHeight ||
	      $el.innerWidth() < el.scrollWidth);
	  };
	
	  Utils.escapeMarkup = function (markup) {
	    var replaceMap = {
	      '\\': '&#92;',
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      '\'': '&#39;',
	      '/': '&#47;'
	    };
	
	    // Do not try to escape the markup if it's not a string
	    if (typeof markup !== 'string') {
	      return markup;
	    }
	
	    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	      return replaceMap[match];
	    });
	  };
	
	  // Append an array of jQuery nodes to a given element.
	  Utils.appendMany = function ($element, $nodes) {
	    // jQuery 1.7.x does not support $.fn.append() with an array
	    // Fall back to a jQuery object collection using $.fn.add()
	    if ($.fn.jquery.substr(0, 3) === '1.7') {
	      var $jqNodes = $();
	
	      $.map($nodes, function (node) {
	        $jqNodes = $jqNodes.add(node);
	      });
	
	      $nodes = $jqNodes;
	    }
	
	    $element.append($nodes);
	  };
	
	  return Utils;
	});
	
	S2.define('select2/results',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Results ($element, options, dataAdapter) {
	    this.$element = $element;
	    this.data = dataAdapter;
	    this.options = options;
	
	    Results.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Results, Utils.Observable);
	
	  Results.prototype.render = function () {
	    var $results = $(
	      '<ul class="select2-results__options" role="tree"></ul>'
	    );
	
	    if (this.options.get('multiple')) {
	      $results.attr('aria-multiselectable', 'true');
	    }
	
	    this.$results = $results;
	
	    return $results;
	  };
	
	  Results.prototype.clear = function () {
	    this.$results.empty();
	  };
	
	  Results.prototype.displayMessage = function (params) {
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    this.clear();
	    this.hideLoading();
	
	    var $message = $(
	      '<li role="treeitem" aria-live="assertive"' +
	      ' class="select2-results__option"></li>'
	    );
	
	    var message = this.options.get('translations').get(params.message);
	
	    $message.append(
	      escapeMarkup(
	        message(params.args)
	      )
	    );
	
	    $message[0].className += ' select2-results__message';
	
	    this.$results.append($message);
	  };
	
	  Results.prototype.hideMessages = function () {
	    this.$results.find('.select2-results__message').remove();
	  };
	
	  Results.prototype.append = function (data) {
	    this.hideLoading();
	
	    var $options = [];
	
	    if (data.results == null || data.results.length === 0) {
	      if (this.$results.children().length === 0) {
	        this.trigger('results:message', {
	          message: 'noResults'
	        });
	      }
	
	      return;
	    }
	
	    data.results = this.sort(data.results);
	
	    for (var d = 0; d < data.results.length; d++) {
	      var item = data.results[d];
	
	      var $option = this.option(item);
	
	      $options.push($option);
	    }
	
	    this.$results.append($options);
	  };
	
	  Results.prototype.position = function ($results, $dropdown) {
	    var $resultsContainer = $dropdown.find('.select2-results');
	    $resultsContainer.append($results);
	  };
	
	  Results.prototype.sort = function (data) {
	    var sorter = this.options.get('sorter');
	
	    return sorter(data);
	  };
	
	  Results.prototype.highlightFirstItem = function () {
	    var $options = this.$results
	      .find('.select2-results__option[aria-selected]');
	
	    var $selected = $options.filter('[aria-selected=true]');
	
	    // Check if there are any selected options
	    if ($selected.length > 0) {
	      // If there are selected options, highlight the first
	      $selected.first().trigger('mouseenter');
	    } else {
	      // If there are no selected options, highlight the first option
	      // in the dropdown
	      $options.first().trigger('mouseenter');
	    }
	
	    this.ensureHighlightVisible();
	  };
	
	  Results.prototype.setClasses = function () {
	    var self = this;
	
	    this.data.current(function (selected) {
	      var selectedIds = $.map(selected, function (s) {
	        return s.id.toString();
	      });
	
	      var $options = self.$results
	        .find('.select2-results__option[aria-selected]');
	
	      $options.each(function () {
	        var $option = $(this);
	
	        var item = $.data(this, 'data');
	
	        // id needs to be converted to a string when comparing
	        var id = '' + item.id;
	
	        if ((item.element != null && item.element.selected) ||
	            (item.element == null && $.inArray(id, selectedIds) > -1)) {
	          $option.attr('aria-selected', 'true');
	        } else {
	          $option.attr('aria-selected', 'false');
	        }
	      });
	
	    });
	  };
	
	  Results.prototype.showLoading = function (params) {
	    this.hideLoading();
	
	    var loadingMore = this.options.get('translations').get('searching');
	
	    var loading = {
	      disabled: true,
	      loading: true,
	      text: loadingMore(params)
	    };
	    var $loading = this.option(loading);
	    $loading.className += ' loading-results';
	
	    this.$results.prepend($loading);
	  };
	
	  Results.prototype.hideLoading = function () {
	    this.$results.find('.loading-results').remove();
	  };
	
	  Results.prototype.option = function (data) {
	    var option = document.createElement('li');
	    option.className = 'select2-results__option';
	
	    var attrs = {
	      'role': 'treeitem',
	      'aria-selected': 'false'
	    };
	
	    if (data.disabled) {
	      delete attrs['aria-selected'];
	      attrs['aria-disabled'] = 'true';
	    }
	
	    if (data.id == null) {
	      delete attrs['aria-selected'];
	    }
	
	    if (data._resultId != null) {
	      option.id = data._resultId;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    if (data.children) {
	      attrs.role = 'group';
	      attrs['aria-label'] = data.text;
	      delete attrs['aria-selected'];
	    }
	
	    for (var attr in attrs) {
	      var val = attrs[attr];
	
	      option.setAttribute(attr, val);
	    }
	
	    if (data.children) {
	      var $option = $(option);
	
	      var label = document.createElement('strong');
	      label.className = 'select2-results__group';
	
	      var $label = $(label);
	      this.template(data, label);
	
	      var $children = [];
	
	      for (var c = 0; c < data.children.length; c++) {
	        var child = data.children[c];
	
	        var $child = this.option(child);
	
	        $children.push($child);
	      }
	
	      var $childrenContainer = $('<ul></ul>', {
	        'class': 'select2-results__options select2-results__options--nested'
	      });
	
	      $childrenContainer.append($children);
	
	      $option.append(label);
	      $option.append($childrenContainer);
	    } else {
	      this.template(data, option);
	    }
	
	    $.data(option, 'data', data);
	
	    return option;
	  };
	
	  Results.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-results';
	
	    this.$results.attr('id', id);
	
	    container.on('results:all', function (params) {
	      self.clear();
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('results:append', function (params) {
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	      }
	    });
	
	    container.on('query', function (params) {
	      self.hideMessages();
	      self.showLoading(params);
	    });
	
	    container.on('select', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	      self.highlightFirstItem();
	    });
	
	    container.on('unselect', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	      self.highlightFirstItem();
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expended="true"
	      self.$results.attr('aria-expanded', 'true');
	      self.$results.attr('aria-hidden', 'false');
	
	      self.setClasses();
	      self.ensureHighlightVisible();
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expended="false"
	      self.$results.attr('aria-expanded', 'false');
	      self.$results.attr('aria-hidden', 'true');
	      self.$results.removeAttr('aria-activedescendant');
	    });
	
	    container.on('results:toggle', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      $highlighted.trigger('mouseup');
	    });
	
	    container.on('results:select', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      var data = $highlighted.data('data');
	
	      if ($highlighted.attr('aria-selected') == 'true') {
	        self.trigger('close', {});
	      } else {
	        self.trigger('select', {
	          data: data
	        });
	      }
	    });
	
	    container.on('results:previous', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      // If we are already at te top, don't move further
	      if (currentIndex === 0) {
	        return;
	      }
	
	      var nextIndex = currentIndex - 1;
	
	      // If none are highlighted, highlight the first
	      if ($highlighted.length === 0) {
	        nextIndex = 0;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top;
	      var nextTop = $next.offset().top;
	      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextTop - currentOffset < 0) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:next', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      var nextIndex = currentIndex + 1;
	
	      // If we are at the last option, stay there
	      if (nextIndex >= $options.length) {
	        return;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var nextBottom = $next.offset().top + $next.outerHeight(false);
	      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextBottom > currentOffset) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      params.element.addClass('select2-results__option--highlighted');
	    });
	
	    container.on('results:message', function (params) {
	      self.displayMessage(params);
	    });
	
	    if ($.fn.mousewheel) {
	      this.$results.on('mousewheel', function (e) {
	        var top = self.$results.scrollTop();
	
	        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	        if (isAtTop) {
	          self.$results.scrollTop(0);
	
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (isAtBottom) {
	          self.$results.scrollTop(
	            self.$results.get(0).scrollHeight - self.$results.height()
	          );
	
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      });
	    }
	
	    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var $this = $(this);
	
	      var data = $this.data('data');
	
	      if ($this.attr('aria-selected') === 'true') {
	        if (self.options.get('multiple')) {
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        } else {
	          self.trigger('close', {});
	        }
	
	        return;
	      }
	
	      self.trigger('select', {
	        originalEvent: evt,
	        data: data
	      });
	    });
	
	    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var data = $(this).data('data');
	
	      self.getHighlightedResults()
	          .removeClass('select2-results__option--highlighted');
	
	      self.trigger('results:focus', {
	        data: data,
	        element: $(this)
	      });
	    });
	  };
	
	  Results.prototype.getHighlightedResults = function () {
	    var $highlighted = this.$results
	    .find('.select2-results__option--highlighted');
	
	    return $highlighted;
	  };
	
	  Results.prototype.destroy = function () {
	    this.$results.remove();
	  };
	
	  Results.prototype.ensureHighlightVisible = function () {
	    var $highlighted = this.getHighlightedResults();
	
	    if ($highlighted.length === 0) {
	      return;
	    }
	
	    var $options = this.$results.find('[aria-selected]');
	
	    var currentIndex = $options.index($highlighted);
	
	    var currentOffset = this.$results.offset().top;
	    var nextTop = $highlighted.offset().top;
	    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	    var offsetDelta = nextTop - currentOffset;
	    nextOffset -= $highlighted.outerHeight(false) * 2;
	
	    if (currentIndex <= 2) {
	      this.$results.scrollTop(0);
	    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	      this.$results.scrollTop(nextOffset);
	    }
	  };
	
	  Results.prototype.template = function (result, container) {
	    var template = this.options.get('templateResult');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    var content = template(result, container);
	
	    if (content == null) {
	      container.style.display = 'none';
	    } else if (typeof content === 'string') {
	      container.innerHTML = escapeMarkup(content);
	    } else {
	      $(container).append(content);
	    }
	  };
	
	  return Results;
	});
	
	S2.define('select2/keys',[
	
	], function () {
	  var KEYS = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    ESC: 27,
	    SPACE: 32,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  };
	
	  return KEYS;
	});
	
	S2.define('select2/selection/base',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function BaseSelection ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    BaseSelection.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseSelection, Utils.Observable);
	
	  BaseSelection.prototype.render = function () {
	    var $selection = $(
	      '<span class="select2-selection" role="combobox" ' +
	      ' aria-haspopup="true" aria-expanded="false">' +
	      '</span>'
	    );
	
	    this._tabindex = 0;
	
	    if (this.$element.data('old-tabindex') != null) {
	      this._tabindex = this.$element.data('old-tabindex');
	    } else if (this.$element.attr('tabindex') != null) {
	      this._tabindex = this.$element.attr('tabindex');
	    }
	
	    $selection.attr('title', this.$element.attr('title'));
	    $selection.attr('tabindex', this._tabindex);
	
	    this.$selection = $selection;
	
	    return $selection;
	  };
	
	  BaseSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-container';
	    var resultsId = container.id + '-results';
	
	    this.container = container;
	
	    this.$selection.on('focus', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('blur', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      if (evt.which === KEYS.SPACE) {
	        evt.preventDefault();
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      self.$selection.attr('aria-activedescendant', params.data._resultId);
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expanded="true"
	      self.$selection.attr('aria-expanded', 'true');
	      self.$selection.attr('aria-owns', resultsId);
	
	      self._attachCloseHandler(container);
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expanded="false"
	      self.$selection.attr('aria-expanded', 'false');
	      self.$selection.removeAttr('aria-activedescendant');
	      self.$selection.removeAttr('aria-owns');
	
	      self.$selection.focus();
	
	      self._detachCloseHandler(container);
	    });
	
	    container.on('enable', function () {
	      self.$selection.attr('tabindex', self._tabindex);
	    });
	
	    container.on('disable', function () {
	      self.$selection.attr('tabindex', '-1');
	    });
	  };
	
	  BaseSelection.prototype._handleBlur = function (evt) {
	    var self = this;
	
	    // This needs to be delayed as the active element is the body when the tab
	    // key is pressed, possibly along with others.
	    window.setTimeout(function () {
	      // Don't trigger `blur` if the focus is still in the selection
	      if (
	        (document.activeElement == self.$selection[0]) ||
	        ($.contains(self.$selection[0], document.activeElement))
	      ) {
	        return;
	      }
	
	      self.trigger('blur', evt);
	    }, 1);
	  };
	
	  BaseSelection.prototype._attachCloseHandler = function (container) {
	    var self = this;
	
	    $(document.body).on('mousedown.select2.' + container.id, function (e) {
	      var $target = $(e.target);
	
	      var $select = $target.closest('.select2');
	
	      var $all = $('.select2.select2-container--open');
	
	      $all.each(function () {
	        var $this = $(this);
	
	        if (this == $select[0]) {
	          return;
	        }
	
	        var $element = $this.data('element');
	
	        $element.select2('close');
	      });
	    });
	  };
	
	  BaseSelection.prototype._detachCloseHandler = function (container) {
	    $(document.body).off('mousedown.select2.' + container.id);
	  };
	
	  BaseSelection.prototype.position = function ($selection, $container) {
	    var $selectionContainer = $container.find('.selection');
	    $selectionContainer.append($selection);
	  };
	
	  BaseSelection.prototype.destroy = function () {
	    this._detachCloseHandler(this.container);
	  };
	
	  BaseSelection.prototype.update = function (data) {
	    throw new Error('The `update` method must be defined in child classes.');
	  };
	
	  return BaseSelection;
	});
	
	S2.define('select2/selection/single',[
	  'jquery',
	  './base',
	  '../utils',
	  '../keys'
	], function ($, BaseSelection, Utils, KEYS) {
	  function SingleSelection () {
	    SingleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(SingleSelection, BaseSelection);
	
	  SingleSelection.prototype.render = function () {
	    var $selection = SingleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--single');
	
	    $selection.html(
	      '<span class="select2-selection__rendered"></span>' +
	      '<span class="select2-selection__arrow" role="presentation">' +
	        '<b role="presentation"></b>' +
	      '</span>'
	    );
	
	    return $selection;
	  };
	
	  SingleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    SingleSelection.__super__.bind.apply(this, arguments);
	
	    var id = container.id + '-container';
	
	    this.$selection.find('.select2-selection__rendered').attr('id', id);
	    this.$selection.attr('aria-labelledby', id);
	
	    this.$selection.on('mousedown', function (evt) {
	      // Only respond to left clicks
	      if (evt.which !== 1) {
	        return;
	      }
	
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on('focus', function (evt) {
	      // User focuses on the container
	    });
	
	    this.$selection.on('blur', function (evt) {
	      // User exits the container
	    });
	
	    container.on('focus', function (evt) {
	      if (!container.isOpen()) {
	        self.$selection.focus();
	      }
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	  };
	
	  SingleSelection.prototype.clear = function () {
	    this.$selection.find('.select2-selection__rendered').empty();
	  };
	
	  SingleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  SingleSelection.prototype.selectionContainer = function () {
	    return $('<span></span>');
	  };
	
	  SingleSelection.prototype.update = function (data) {
	    if (data.length === 0) {
	      this.clear();
	      return;
	    }
	
	    var selection = data[0];
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    var formatted = this.display(selection, $rendered);
	
	    $rendered.empty().append(formatted);
	    $rendered.prop('title', selection.title || selection.text);
	  };
	
	  return SingleSelection;
	});
	
	S2.define('select2/selection/multiple',[
	  'jquery',
	  './base',
	  '../utils'
	], function ($, BaseSelection, Utils) {
	  function MultipleSelection ($element, options) {
	    MultipleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(MultipleSelection, BaseSelection);
	
	  MultipleSelection.prototype.render = function () {
	    var $selection = MultipleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--multiple');
	
	    $selection.html(
	      '<ul class="select2-selection__rendered"></ul>'
	    );
	
	    return $selection;
	  };
	
	  MultipleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    MultipleSelection.__super__.bind.apply(this, arguments);
	
	    this.$selection.on('click', function (evt) {
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on(
	      'click',
	      '.select2-selection__choice__remove',
	      function (evt) {
	        // Ignore the event if it is disabled
	        if (self.options.get('disabled')) {
	          return;
	        }
	
	        var $remove = $(this);
	        var $selection = $remove.parent();
	
	        var data = $selection.data('data');
	
	        self.trigger('unselect', {
	          originalEvent: evt,
	          data: data
	        });
	      }
	    );
	  };
	
	  MultipleSelection.prototype.clear = function () {
	    this.$selection.find('.select2-selection__rendered').empty();
	  };
	
	  MultipleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  MultipleSelection.prototype.selectionContainer = function () {
	    var $container = $(
	      '<li class="select2-selection__choice">' +
	        '<span class="select2-selection__choice__remove" role="presentation">' +
	          '&times;' +
	        '</span>' +
	      '</li>'
	    );
	
	    return $container;
	  };
	
	  MultipleSelection.prototype.update = function (data) {
	    this.clear();
	
	    if (data.length === 0) {
	      return;
	    }
	
	    var $selections = [];
	
	    for (var d = 0; d < data.length; d++) {
	      var selection = data[d];
	
	      var $selection = this.selectionContainer();
	      var formatted = this.display(selection, $selection);
	
	      $selection.append(formatted);
	      $selection.prop('title', selection.title || selection.text);
	
	      $selection.data('data', selection);
	
	      $selections.push($selection);
	    }
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	
	    Utils.appendMany($rendered, $selections);
	  };
	
	  return MultipleSelection;
	});
	
	S2.define('select2/selection/placeholder',[
	  '../utils'
	], function (Utils) {
	  function Placeholder (decorated, $element, options) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options);
	  }
	
	  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	    var $placeholder = this.selectionContainer();
	
	    $placeholder.html(this.display(placeholder));
	    $placeholder.addClass('select2-selection__placeholder')
	                .removeClass('select2-selection__choice');
	
	    return $placeholder;
	  };
	
	  Placeholder.prototype.update = function (decorated, data) {
	    var singlePlaceholder = (
	      data.length == 1 && data[0].id != this.placeholder.id
	    );
	    var multipleSelections = data.length > 1;
	
	    if (multipleSelections || singlePlaceholder) {
	      return decorated.call(this, data);
	    }
	
	    this.clear();
	
	    var $placeholder = this.createPlaceholder(this.placeholder);
	
	    this.$selection.find('.select2-selection__rendered').append($placeholder);
	  };
	
	  return Placeholder;
	});
	
	S2.define('select2/selection/allowClear',[
	  'jquery',
	  '../keys'
	], function ($, KEYS) {
	  function AllowClear () { }
	
	  AllowClear.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    if (this.placeholder == null) {
	      if (this.options.get('debug') && window.console && console.error) {
	        console.error(
	          'Select2: The `allowClear` option should be used in combination ' +
	          'with the `placeholder` option.'
	        );
	      }
	    }
	
	    this.$selection.on('mousedown', '.select2-selection__clear',
	      function (evt) {
	        self._handleClear(evt);
	    });
	
	    container.on('keypress', function (evt) {
	      self._handleKeyboardClear(evt, container);
	    });
	  };
	
	  AllowClear.prototype._handleClear = function (_, evt) {
	    // Ignore the event if it is disabled
	    if (this.options.get('disabled')) {
	      return;
	    }
	
	    var $clear = this.$selection.find('.select2-selection__clear');
	
	    // Ignore the event if nothing has been selected
	    if ($clear.length === 0) {
	      return;
	    }
	
	    evt.stopPropagation();
	
	    var data = $clear.data('data');
	
	    for (var d = 0; d < data.length; d++) {
	      var unselectData = {
	        data: data[d]
	      };
	
	      // Trigger the `unselect` event, so people can prevent it from being
	      // cleared.
	      this.trigger('unselect', unselectData);
	
	      // If the event was prevented, don't clear it out.
	      if (unselectData.prevented) {
	        return;
	      }
	    }
	
	    this.$element.val(this.placeholder.id).trigger('change');
	
	    this.trigger('toggle', {});
	  };
	
	  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	    if (container.isOpen()) {
	      return;
	    }
	
	    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	      this._handleClear(evt);
	    }
	  };
	
	  AllowClear.prototype.update = function (decorated, data) {
	    decorated.call(this, data);
	
	    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
	        data.length === 0) {
	      return;
	    }
	
	    var $remove = $(
	      '<span class="select2-selection__clear">' +
	        '&times;' +
	      '</span>'
	    );
	    $remove.data('data', data);
	
	    this.$selection.find('.select2-selection__rendered').prepend($remove);
	  };
	
	  return AllowClear;
	});
	
	S2.define('select2/selection/search',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function Search (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  Search.prototype.render = function (decorated) {
	    var $search = $(
	      '<li class="select2-search select2-search--inline">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
	        ' spellcheck="false" role="textbox" aria-autocomplete="list" />' +
	      '</li>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    var $rendered = decorated.call(this);
	
	    this._transferTabIndex();
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self.$search.trigger('focus');
	    });
	
	    container.on('close', function () {
	      self.$search.val('');
	      self.$search.removeAttr('aria-activedescendant');
	      self.$search.trigger('focus');
	    });
	
	    container.on('enable', function () {
	      self.$search.prop('disabled', false);
	
	      self._transferTabIndex();
	    });
	
	    container.on('disable', function () {
	      self.$search.prop('disabled', true);
	    });
	
	    container.on('focus', function (evt) {
	      self.$search.trigger('focus');
	    });
	
	    container.on('results:focus', function (params) {
	      self.$search.attr('aria-activedescendant', params.id);
	    });
	
	    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	      evt.stopPropagation();
	
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	
	      var key = evt.which;
	
	      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	        var $previousChoice = self.$searchContainer
	          .prev('.select2-selection__choice');
	
	        if ($previousChoice.length > 0) {
	          var item = $previousChoice.data('data');
	
	          self.searchRemoveChoice(item);
	
	          evt.preventDefault();
	        }
	      }
	    });
	
	    // Try to detect the IE version should the `documentMode` property that
	    // is stored on the document. This is only implemented in IE and is
	    // slightly cleaner than doing a user agent check.
	    // This property is not available in Edge, but Edge also doesn't have
	    // this bug.
	    var msie = document.documentMode;
	    var disableInputEvents = msie && msie <= 11;
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$selection.on(
	      'input.searchcheck',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents) {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        // Unbind the duplicated `keyup` event
	        self.$selection.off('keyup.search');
	      }
	    );
	
	    this.$selection.on(
	      'keyup.search input.search',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents && evt.type === 'input') {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        var key = evt.which;
	
	        // We can freely ignore events from modifier keys
	        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	          return;
	        }
	
	        // Tabbing will be handled during the `keydown` phase
	        if (key == KEYS.TAB) {
	          return;
	        }
	
	        self.handleSearch(evt);
	      }
	    );
	  };
	
	  /**
	   * This method will transfer the tabindex attribute from the rendered
	   * selection to the search box. This allows for the search box to be used as
	   * the primary focus instead of the selection container.
	   *
	   * @private
	   */
	  Search.prototype._transferTabIndex = function (decorated) {
	    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	    this.$selection.attr('tabindex', '-1');
	  };
	
	  Search.prototype.createPlaceholder = function (decorated, placeholder) {
	    this.$search.attr('placeholder', placeholder.text);
	  };
	
	  Search.prototype.update = function (decorated, data) {
	    var searchHadFocus = this.$search[0] == document.activeElement;
	
	    this.$search.attr('placeholder', '');
	
	    decorated.call(this, data);
	
	    this.$selection.find('.select2-selection__rendered')
	                   .append(this.$searchContainer);
	
	    this.resizeSearch();
	    if (searchHadFocus) {
	      this.$search.focus();
	    }
	  };
	
	  Search.prototype.handleSearch = function () {
	    this.resizeSearch();
	
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.searchRemoveChoice = function (decorated, item) {
	    this.trigger('unselect', {
	      data: item
	    });
	
	    this.$search.val(item.text);
	    this.handleSearch();
	  };
	
	  Search.prototype.resizeSearch = function () {
	    this.$search.css('width', '25px');
	
	    var width = '';
	
	    if (this.$search.attr('placeholder') !== '') {
	      width = this.$selection.find('.select2-selection__rendered').innerWidth();
	    } else {
	      var minimumWidth = this.$search.val().length + 1;
	
	      width = (minimumWidth * 0.75) + 'em';
	    }
	
	    this.$search.css('width', width);
	  };
	
	  return Search;
	});
	
	S2.define('select2/selection/eventRelay',[
	  'jquery'
	], function ($) {
	  function EventRelay () { }
	
	  EventRelay.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	    var relayEvents = [
	      'open', 'opening',
	      'close', 'closing',
	      'select', 'selecting',
	      'unselect', 'unselecting'
	    ];
	
	    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];
	
	    decorated.call(this, container, $container);
	
	    container.on('*', function (name, params) {
	      // Ignore events that should not be relayed
	      if ($.inArray(name, relayEvents) === -1) {
	        return;
	      }
	
	      // The parameters should always be an object
	      params = params || {};
	
	      // Generate the jQuery event for the Select2 event
	      var evt = $.Event('select2:' + name, {
	        params: params
	      });
	
	      self.$element.trigger(evt);
	
	      // Only handle preventable events if it was one
	      if ($.inArray(name, preventableEvents) === -1) {
	        return;
	      }
	
	      params.prevented = evt.isDefaultPrevented();
	    });
	  };
	
	  return EventRelay;
	});
	
	S2.define('select2/translation',[
	  'jquery',
	  'require'
	], function ($, require) {
	  function Translation (dict) {
	    this.dict = dict || {};
	  }
	
	  Translation.prototype.all = function () {
	    return this.dict;
	  };
	
	  Translation.prototype.get = function (key) {
	    return this.dict[key];
	  };
	
	  Translation.prototype.extend = function (translation) {
	    this.dict = $.extend({}, translation.all(), this.dict);
	  };
	
	  // Static functions
	
	  Translation._cache = {};
	
	  Translation.loadPath = function (path) {
	    if (!(path in Translation._cache)) {
	      var translations = require(path);
	
	      Translation._cache[path] = translations;
	    }
	
	    return new Translation(Translation._cache[path]);
	  };
	
	  return Translation;
	});
	
	S2.define('select2/diacritics',[
	
	], function () {
	  var diacritics = {
	    '\u24B6': 'A',
	    '\uFF21': 'A',
	    '\u00C0': 'A',
	    '\u00C1': 'A',
	    '\u00C2': 'A',
	    '\u1EA6': 'A',
	    '\u1EA4': 'A',
	    '\u1EAA': 'A',
	    '\u1EA8': 'A',
	    '\u00C3': 'A',
	    '\u0100': 'A',
	    '\u0102': 'A',
	    '\u1EB0': 'A',
	    '\u1EAE': 'A',
	    '\u1EB4': 'A',
	    '\u1EB2': 'A',
	    '\u0226': 'A',
	    '\u01E0': 'A',
	    '\u00C4': 'A',
	    '\u01DE': 'A',
	    '\u1EA2': 'A',
	    '\u00C5': 'A',
	    '\u01FA': 'A',
	    '\u01CD': 'A',
	    '\u0200': 'A',
	    '\u0202': 'A',
	    '\u1EA0': 'A',
	    '\u1EAC': 'A',
	    '\u1EB6': 'A',
	    '\u1E00': 'A',
	    '\u0104': 'A',
	    '\u023A': 'A',
	    '\u2C6F': 'A',
	    '\uA732': 'AA',
	    '\u00C6': 'AE',
	    '\u01FC': 'AE',
	    '\u01E2': 'AE',
	    '\uA734': 'AO',
	    '\uA736': 'AU',
	    '\uA738': 'AV',
	    '\uA73A': 'AV',
	    '\uA73C': 'AY',
	    '\u24B7': 'B',
	    '\uFF22': 'B',
	    '\u1E02': 'B',
	    '\u1E04': 'B',
	    '\u1E06': 'B',
	    '\u0243': 'B',
	    '\u0182': 'B',
	    '\u0181': 'B',
	    '\u24B8': 'C',
	    '\uFF23': 'C',
	    '\u0106': 'C',
	    '\u0108': 'C',
	    '\u010A': 'C',
	    '\u010C': 'C',
	    '\u00C7': 'C',
	    '\u1E08': 'C',
	    '\u0187': 'C',
	    '\u023B': 'C',
	    '\uA73E': 'C',
	    '\u24B9': 'D',
	    '\uFF24': 'D',
	    '\u1E0A': 'D',
	    '\u010E': 'D',
	    '\u1E0C': 'D',
	    '\u1E10': 'D',
	    '\u1E12': 'D',
	    '\u1E0E': 'D',
	    '\u0110': 'D',
	    '\u018B': 'D',
	    '\u018A': 'D',
	    '\u0189': 'D',
	    '\uA779': 'D',
	    '\u01F1': 'DZ',
	    '\u01C4': 'DZ',
	    '\u01F2': 'Dz',
	    '\u01C5': 'Dz',
	    '\u24BA': 'E',
	    '\uFF25': 'E',
	    '\u00C8': 'E',
	    '\u00C9': 'E',
	    '\u00CA': 'E',
	    '\u1EC0': 'E',
	    '\u1EBE': 'E',
	    '\u1EC4': 'E',
	    '\u1EC2': 'E',
	    '\u1EBC': 'E',
	    '\u0112': 'E',
	    '\u1E14': 'E',
	    '\u1E16': 'E',
	    '\u0114': 'E',
	    '\u0116': 'E',
	    '\u00CB': 'E',
	    '\u1EBA': 'E',
	    '\u011A': 'E',
	    '\u0204': 'E',
	    '\u0206': 'E',
	    '\u1EB8': 'E',
	    '\u1EC6': 'E',
	    '\u0228': 'E',
	    '\u1E1C': 'E',
	    '\u0118': 'E',
	    '\u1E18': 'E',
	    '\u1E1A': 'E',
	    '\u0190': 'E',
	    '\u018E': 'E',
	    '\u24BB': 'F',
	    '\uFF26': 'F',
	    '\u1E1E': 'F',
	    '\u0191': 'F',
	    '\uA77B': 'F',
	    '\u24BC': 'G',
	    '\uFF27': 'G',
	    '\u01F4': 'G',
	    '\u011C': 'G',
	    '\u1E20': 'G',
	    '\u011E': 'G',
	    '\u0120': 'G',
	    '\u01E6': 'G',
	    '\u0122': 'G',
	    '\u01E4': 'G',
	    '\u0193': 'G',
	    '\uA7A0': 'G',
	    '\uA77D': 'G',
	    '\uA77E': 'G',
	    '\u24BD': 'H',
	    '\uFF28': 'H',
	    '\u0124': 'H',
	    '\u1E22': 'H',
	    '\u1E26': 'H',
	    '\u021E': 'H',
	    '\u1E24': 'H',
	    '\u1E28': 'H',
	    '\u1E2A': 'H',
	    '\u0126': 'H',
	    '\u2C67': 'H',
	    '\u2C75': 'H',
	    '\uA78D': 'H',
	    '\u24BE': 'I',
	    '\uFF29': 'I',
	    '\u00CC': 'I',
	    '\u00CD': 'I',
	    '\u00CE': 'I',
	    '\u0128': 'I',
	    '\u012A': 'I',
	    '\u012C': 'I',
	    '\u0130': 'I',
	    '\u00CF': 'I',
	    '\u1E2E': 'I',
	    '\u1EC8': 'I',
	    '\u01CF': 'I',
	    '\u0208': 'I',
	    '\u020A': 'I',
	    '\u1ECA': 'I',
	    '\u012E': 'I',
	    '\u1E2C': 'I',
	    '\u0197': 'I',
	    '\u24BF': 'J',
	    '\uFF2A': 'J',
	    '\u0134': 'J',
	    '\u0248': 'J',
	    '\u24C0': 'K',
	    '\uFF2B': 'K',
	    '\u1E30': 'K',
	    '\u01E8': 'K',
	    '\u1E32': 'K',
	    '\u0136': 'K',
	    '\u1E34': 'K',
	    '\u0198': 'K',
	    '\u2C69': 'K',
	    '\uA740': 'K',
	    '\uA742': 'K',
	    '\uA744': 'K',
	    '\uA7A2': 'K',
	    '\u24C1': 'L',
	    '\uFF2C': 'L',
	    '\u013F': 'L',
	    '\u0139': 'L',
	    '\u013D': 'L',
	    '\u1E36': 'L',
	    '\u1E38': 'L',
	    '\u013B': 'L',
	    '\u1E3C': 'L',
	    '\u1E3A': 'L',
	    '\u0141': 'L',
	    '\u023D': 'L',
	    '\u2C62': 'L',
	    '\u2C60': 'L',
	    '\uA748': 'L',
	    '\uA746': 'L',
	    '\uA780': 'L',
	    '\u01C7': 'LJ',
	    '\u01C8': 'Lj',
	    '\u24C2': 'M',
	    '\uFF2D': 'M',
	    '\u1E3E': 'M',
	    '\u1E40': 'M',
	    '\u1E42': 'M',
	    '\u2C6E': 'M',
	    '\u019C': 'M',
	    '\u24C3': 'N',
	    '\uFF2E': 'N',
	    '\u01F8': 'N',
	    '\u0143': 'N',
	    '\u00D1': 'N',
	    '\u1E44': 'N',
	    '\u0147': 'N',
	    '\u1E46': 'N',
	    '\u0145': 'N',
	    '\u1E4A': 'N',
	    '\u1E48': 'N',
	    '\u0220': 'N',
	    '\u019D': 'N',
	    '\uA790': 'N',
	    '\uA7A4': 'N',
	    '\u01CA': 'NJ',
	    '\u01CB': 'Nj',
	    '\u24C4': 'O',
	    '\uFF2F': 'O',
	    '\u00D2': 'O',
	    '\u00D3': 'O',
	    '\u00D4': 'O',
	    '\u1ED2': 'O',
	    '\u1ED0': 'O',
	    '\u1ED6': 'O',
	    '\u1ED4': 'O',
	    '\u00D5': 'O',
	    '\u1E4C': 'O',
	    '\u022C': 'O',
	    '\u1E4E': 'O',
	    '\u014C': 'O',
	    '\u1E50': 'O',
	    '\u1E52': 'O',
	    '\u014E': 'O',
	    '\u022E': 'O',
	    '\u0230': 'O',
	    '\u00D6': 'O',
	    '\u022A': 'O',
	    '\u1ECE': 'O',
	    '\u0150': 'O',
	    '\u01D1': 'O',
	    '\u020C': 'O',
	    '\u020E': 'O',
	    '\u01A0': 'O',
	    '\u1EDC': 'O',
	    '\u1EDA': 'O',
	    '\u1EE0': 'O',
	    '\u1EDE': 'O',
	    '\u1EE2': 'O',
	    '\u1ECC': 'O',
	    '\u1ED8': 'O',
	    '\u01EA': 'O',
	    '\u01EC': 'O',
	    '\u00D8': 'O',
	    '\u01FE': 'O',
	    '\u0186': 'O',
	    '\u019F': 'O',
	    '\uA74A': 'O',
	    '\uA74C': 'O',
	    '\u01A2': 'OI',
	    '\uA74E': 'OO',
	    '\u0222': 'OU',
	    '\u24C5': 'P',
	    '\uFF30': 'P',
	    '\u1E54': 'P',
	    '\u1E56': 'P',
	    '\u01A4': 'P',
	    '\u2C63': 'P',
	    '\uA750': 'P',
	    '\uA752': 'P',
	    '\uA754': 'P',
	    '\u24C6': 'Q',
	    '\uFF31': 'Q',
	    '\uA756': 'Q',
	    '\uA758': 'Q',
	    '\u024A': 'Q',
	    '\u24C7': 'R',
	    '\uFF32': 'R',
	    '\u0154': 'R',
	    '\u1E58': 'R',
	    '\u0158': 'R',
	    '\u0210': 'R',
	    '\u0212': 'R',
	    '\u1E5A': 'R',
	    '\u1E5C': 'R',
	    '\u0156': 'R',
	    '\u1E5E': 'R',
	    '\u024C': 'R',
	    '\u2C64': 'R',
	    '\uA75A': 'R',
	    '\uA7A6': 'R',
	    '\uA782': 'R',
	    '\u24C8': 'S',
	    '\uFF33': 'S',
	    '\u1E9E': 'S',
	    '\u015A': 'S',
	    '\u1E64': 'S',
	    '\u015C': 'S',
	    '\u1E60': 'S',
	    '\u0160': 'S',
	    '\u1E66': 'S',
	    '\u1E62': 'S',
	    '\u1E68': 'S',
	    '\u0218': 'S',
	    '\u015E': 'S',
	    '\u2C7E': 'S',
	    '\uA7A8': 'S',
	    '\uA784': 'S',
	    '\u24C9': 'T',
	    '\uFF34': 'T',
	    '\u1E6A': 'T',
	    '\u0164': 'T',
	    '\u1E6C': 'T',
	    '\u021A': 'T',
	    '\u0162': 'T',
	    '\u1E70': 'T',
	    '\u1E6E': 'T',
	    '\u0166': 'T',
	    '\u01AC': 'T',
	    '\u01AE': 'T',
	    '\u023E': 'T',
	    '\uA786': 'T',
	    '\uA728': 'TZ',
	    '\u24CA': 'U',
	    '\uFF35': 'U',
	    '\u00D9': 'U',
	    '\u00DA': 'U',
	    '\u00DB': 'U',
	    '\u0168': 'U',
	    '\u1E78': 'U',
	    '\u016A': 'U',
	    '\u1E7A': 'U',
	    '\u016C': 'U',
	    '\u00DC': 'U',
	    '\u01DB': 'U',
	    '\u01D7': 'U',
	    '\u01D5': 'U',
	    '\u01D9': 'U',
	    '\u1EE6': 'U',
	    '\u016E': 'U',
	    '\u0170': 'U',
	    '\u01D3': 'U',
	    '\u0214': 'U',
	    '\u0216': 'U',
	    '\u01AF': 'U',
	    '\u1EEA': 'U',
	    '\u1EE8': 'U',
	    '\u1EEE': 'U',
	    '\u1EEC': 'U',
	    '\u1EF0': 'U',
	    '\u1EE4': 'U',
	    '\u1E72': 'U',
	    '\u0172': 'U',
	    '\u1E76': 'U',
	    '\u1E74': 'U',
	    '\u0244': 'U',
	    '\u24CB': 'V',
	    '\uFF36': 'V',
	    '\u1E7C': 'V',
	    '\u1E7E': 'V',
	    '\u01B2': 'V',
	    '\uA75E': 'V',
	    '\u0245': 'V',
	    '\uA760': 'VY',
	    '\u24CC': 'W',
	    '\uFF37': 'W',
	    '\u1E80': 'W',
	    '\u1E82': 'W',
	    '\u0174': 'W',
	    '\u1E86': 'W',
	    '\u1E84': 'W',
	    '\u1E88': 'W',
	    '\u2C72': 'W',
	    '\u24CD': 'X',
	    '\uFF38': 'X',
	    '\u1E8A': 'X',
	    '\u1E8C': 'X',
	    '\u24CE': 'Y',
	    '\uFF39': 'Y',
	    '\u1EF2': 'Y',
	    '\u00DD': 'Y',
	    '\u0176': 'Y',
	    '\u1EF8': 'Y',
	    '\u0232': 'Y',
	    '\u1E8E': 'Y',
	    '\u0178': 'Y',
	    '\u1EF6': 'Y',
	    '\u1EF4': 'Y',
	    '\u01B3': 'Y',
	    '\u024E': 'Y',
	    '\u1EFE': 'Y',
	    '\u24CF': 'Z',
	    '\uFF3A': 'Z',
	    '\u0179': 'Z',
	    '\u1E90': 'Z',
	    '\u017B': 'Z',
	    '\u017D': 'Z',
	    '\u1E92': 'Z',
	    '\u1E94': 'Z',
	    '\u01B5': 'Z',
	    '\u0224': 'Z',
	    '\u2C7F': 'Z',
	    '\u2C6B': 'Z',
	    '\uA762': 'Z',
	    '\u24D0': 'a',
	    '\uFF41': 'a',
	    '\u1E9A': 'a',
	    '\u00E0': 'a',
	    '\u00E1': 'a',
	    '\u00E2': 'a',
	    '\u1EA7': 'a',
	    '\u1EA5': 'a',
	    '\u1EAB': 'a',
	    '\u1EA9': 'a',
	    '\u00E3': 'a',
	    '\u0101': 'a',
	    '\u0103': 'a',
	    '\u1EB1': 'a',
	    '\u1EAF': 'a',
	    '\u1EB5': 'a',
	    '\u1EB3': 'a',
	    '\u0227': 'a',
	    '\u01E1': 'a',
	    '\u00E4': 'a',
	    '\u01DF': 'a',
	    '\u1EA3': 'a',
	    '\u00E5': 'a',
	    '\u01FB': 'a',
	    '\u01CE': 'a',
	    '\u0201': 'a',
	    '\u0203': 'a',
	    '\u1EA1': 'a',
	    '\u1EAD': 'a',
	    '\u1EB7': 'a',
	    '\u1E01': 'a',
	    '\u0105': 'a',
	    '\u2C65': 'a',
	    '\u0250': 'a',
	    '\uA733': 'aa',
	    '\u00E6': 'ae',
	    '\u01FD': 'ae',
	    '\u01E3': 'ae',
	    '\uA735': 'ao',
	    '\uA737': 'au',
	    '\uA739': 'av',
	    '\uA73B': 'av',
	    '\uA73D': 'ay',
	    '\u24D1': 'b',
	    '\uFF42': 'b',
	    '\u1E03': 'b',
	    '\u1E05': 'b',
	    '\u1E07': 'b',
	    '\u0180': 'b',
	    '\u0183': 'b',
	    '\u0253': 'b',
	    '\u24D2': 'c',
	    '\uFF43': 'c',
	    '\u0107': 'c',
	    '\u0109': 'c',
	    '\u010B': 'c',
	    '\u010D': 'c',
	    '\u00E7': 'c',
	    '\u1E09': 'c',
	    '\u0188': 'c',
	    '\u023C': 'c',
	    '\uA73F': 'c',
	    '\u2184': 'c',
	    '\u24D3': 'd',
	    '\uFF44': 'd',
	    '\u1E0B': 'd',
	    '\u010F': 'd',
	    '\u1E0D': 'd',
	    '\u1E11': 'd',
	    '\u1E13': 'd',
	    '\u1E0F': 'd',
	    '\u0111': 'd',
	    '\u018C': 'd',
	    '\u0256': 'd',
	    '\u0257': 'd',
	    '\uA77A': 'd',
	    '\u01F3': 'dz',
	    '\u01C6': 'dz',
	    '\u24D4': 'e',
	    '\uFF45': 'e',
	    '\u00E8': 'e',
	    '\u00E9': 'e',
	    '\u00EA': 'e',
	    '\u1EC1': 'e',
	    '\u1EBF': 'e',
	    '\u1EC5': 'e',
	    '\u1EC3': 'e',
	    '\u1EBD': 'e',
	    '\u0113': 'e',
	    '\u1E15': 'e',
	    '\u1E17': 'e',
	    '\u0115': 'e',
	    '\u0117': 'e',
	    '\u00EB': 'e',
	    '\u1EBB': 'e',
	    '\u011B': 'e',
	    '\u0205': 'e',
	    '\u0207': 'e',
	    '\u1EB9': 'e',
	    '\u1EC7': 'e',
	    '\u0229': 'e',
	    '\u1E1D': 'e',
	    '\u0119': 'e',
	    '\u1E19': 'e',
	    '\u1E1B': 'e',
	    '\u0247': 'e',
	    '\u025B': 'e',
	    '\u01DD': 'e',
	    '\u24D5': 'f',
	    '\uFF46': 'f',
	    '\u1E1F': 'f',
	    '\u0192': 'f',
	    '\uA77C': 'f',
	    '\u24D6': 'g',
	    '\uFF47': 'g',
	    '\u01F5': 'g',
	    '\u011D': 'g',
	    '\u1E21': 'g',
	    '\u011F': 'g',
	    '\u0121': 'g',
	    '\u01E7': 'g',
	    '\u0123': 'g',
	    '\u01E5': 'g',
	    '\u0260': 'g',
	    '\uA7A1': 'g',
	    '\u1D79': 'g',
	    '\uA77F': 'g',
	    '\u24D7': 'h',
	    '\uFF48': 'h',
	    '\u0125': 'h',
	    '\u1E23': 'h',
	    '\u1E27': 'h',
	    '\u021F': 'h',
	    '\u1E25': 'h',
	    '\u1E29': 'h',
	    '\u1E2B': 'h',
	    '\u1E96': 'h',
	    '\u0127': 'h',
	    '\u2C68': 'h',
	    '\u2C76': 'h',
	    '\u0265': 'h',
	    '\u0195': 'hv',
	    '\u24D8': 'i',
	    '\uFF49': 'i',
	    '\u00EC': 'i',
	    '\u00ED': 'i',
	    '\u00EE': 'i',
	    '\u0129': 'i',
	    '\u012B': 'i',
	    '\u012D': 'i',
	    '\u00EF': 'i',
	    '\u1E2F': 'i',
	    '\u1EC9': 'i',
	    '\u01D0': 'i',
	    '\u0209': 'i',
	    '\u020B': 'i',
	    '\u1ECB': 'i',
	    '\u012F': 'i',
	    '\u1E2D': 'i',
	    '\u0268': 'i',
	    '\u0131': 'i',
	    '\u24D9': 'j',
	    '\uFF4A': 'j',
	    '\u0135': 'j',
	    '\u01F0': 'j',
	    '\u0249': 'j',
	    '\u24DA': 'k',
	    '\uFF4B': 'k',
	    '\u1E31': 'k',
	    '\u01E9': 'k',
	    '\u1E33': 'k',
	    '\u0137': 'k',
	    '\u1E35': 'k',
	    '\u0199': 'k',
	    '\u2C6A': 'k',
	    '\uA741': 'k',
	    '\uA743': 'k',
	    '\uA745': 'k',
	    '\uA7A3': 'k',
	    '\u24DB': 'l',
	    '\uFF4C': 'l',
	    '\u0140': 'l',
	    '\u013A': 'l',
	    '\u013E': 'l',
	    '\u1E37': 'l',
	    '\u1E39': 'l',
	    '\u013C': 'l',
	    '\u1E3D': 'l',
	    '\u1E3B': 'l',
	    '\u017F': 'l',
	    '\u0142': 'l',
	    '\u019A': 'l',
	    '\u026B': 'l',
	    '\u2C61': 'l',
	    '\uA749': 'l',
	    '\uA781': 'l',
	    '\uA747': 'l',
	    '\u01C9': 'lj',
	    '\u24DC': 'm',
	    '\uFF4D': 'm',
	    '\u1E3F': 'm',
	    '\u1E41': 'm',
	    '\u1E43': 'm',
	    '\u0271': 'm',
	    '\u026F': 'm',
	    '\u24DD': 'n',
	    '\uFF4E': 'n',
	    '\u01F9': 'n',
	    '\u0144': 'n',
	    '\u00F1': 'n',
	    '\u1E45': 'n',
	    '\u0148': 'n',
	    '\u1E47': 'n',
	    '\u0146': 'n',
	    '\u1E4B': 'n',
	    '\u1E49': 'n',
	    '\u019E': 'n',
	    '\u0272': 'n',
	    '\u0149': 'n',
	    '\uA791': 'n',
	    '\uA7A5': 'n',
	    '\u01CC': 'nj',
	    '\u24DE': 'o',
	    '\uFF4F': 'o',
	    '\u00F2': 'o',
	    '\u00F3': 'o',
	    '\u00F4': 'o',
	    '\u1ED3': 'o',
	    '\u1ED1': 'o',
	    '\u1ED7': 'o',
	    '\u1ED5': 'o',
	    '\u00F5': 'o',
	    '\u1E4D': 'o',
	    '\u022D': 'o',
	    '\u1E4F': 'o',
	    '\u014D': 'o',
	    '\u1E51': 'o',
	    '\u1E53': 'o',
	    '\u014F': 'o',
	    '\u022F': 'o',
	    '\u0231': 'o',
	    '\u00F6': 'o',
	    '\u022B': 'o',
	    '\u1ECF': 'o',
	    '\u0151': 'o',
	    '\u01D2': 'o',
	    '\u020D': 'o',
	    '\u020F': 'o',
	    '\u01A1': 'o',
	    '\u1EDD': 'o',
	    '\u1EDB': 'o',
	    '\u1EE1': 'o',
	    '\u1EDF': 'o',
	    '\u1EE3': 'o',
	    '\u1ECD': 'o',
	    '\u1ED9': 'o',
	    '\u01EB': 'o',
	    '\u01ED': 'o',
	    '\u00F8': 'o',
	    '\u01FF': 'o',
	    '\u0254': 'o',
	    '\uA74B': 'o',
	    '\uA74D': 'o',
	    '\u0275': 'o',
	    '\u01A3': 'oi',
	    '\u0223': 'ou',
	    '\uA74F': 'oo',
	    '\u24DF': 'p',
	    '\uFF50': 'p',
	    '\u1E55': 'p',
	    '\u1E57': 'p',
	    '\u01A5': 'p',
	    '\u1D7D': 'p',
	    '\uA751': 'p',
	    '\uA753': 'p',
	    '\uA755': 'p',
	    '\u24E0': 'q',
	    '\uFF51': 'q',
	    '\u024B': 'q',
	    '\uA757': 'q',
	    '\uA759': 'q',
	    '\u24E1': 'r',
	    '\uFF52': 'r',
	    '\u0155': 'r',
	    '\u1E59': 'r',
	    '\u0159': 'r',
	    '\u0211': 'r',
	    '\u0213': 'r',
	    '\u1E5B': 'r',
	    '\u1E5D': 'r',
	    '\u0157': 'r',
	    '\u1E5F': 'r',
	    '\u024D': 'r',
	    '\u027D': 'r',
	    '\uA75B': 'r',
	    '\uA7A7': 'r',
	    '\uA783': 'r',
	    '\u24E2': 's',
	    '\uFF53': 's',
	    '\u00DF': 's',
	    '\u015B': 's',
	    '\u1E65': 's',
	    '\u015D': 's',
	    '\u1E61': 's',
	    '\u0161': 's',
	    '\u1E67': 's',
	    '\u1E63': 's',
	    '\u1E69': 's',
	    '\u0219': 's',
	    '\u015F': 's',
	    '\u023F': 's',
	    '\uA7A9': 's',
	    '\uA785': 's',
	    '\u1E9B': 's',
	    '\u24E3': 't',
	    '\uFF54': 't',
	    '\u1E6B': 't',
	    '\u1E97': 't',
	    '\u0165': 't',
	    '\u1E6D': 't',
	    '\u021B': 't',
	    '\u0163': 't',
	    '\u1E71': 't',
	    '\u1E6F': 't',
	    '\u0167': 't',
	    '\u01AD': 't',
	    '\u0288': 't',
	    '\u2C66': 't',
	    '\uA787': 't',
	    '\uA729': 'tz',
	    '\u24E4': 'u',
	    '\uFF55': 'u',
	    '\u00F9': 'u',
	    '\u00FA': 'u',
	    '\u00FB': 'u',
	    '\u0169': 'u',
	    '\u1E79': 'u',
	    '\u016B': 'u',
	    '\u1E7B': 'u',
	    '\u016D': 'u',
	    '\u00FC': 'u',
	    '\u01DC': 'u',
	    '\u01D8': 'u',
	    '\u01D6': 'u',
	    '\u01DA': 'u',
	    '\u1EE7': 'u',
	    '\u016F': 'u',
	    '\u0171': 'u',
	    '\u01D4': 'u',
	    '\u0215': 'u',
	    '\u0217': 'u',
	    '\u01B0': 'u',
	    '\u1EEB': 'u',
	    '\u1EE9': 'u',
	    '\u1EEF': 'u',
	    '\u1EED': 'u',
	    '\u1EF1': 'u',
	    '\u1EE5': 'u',
	    '\u1E73': 'u',
	    '\u0173': 'u',
	    '\u1E77': 'u',
	    '\u1E75': 'u',
	    '\u0289': 'u',
	    '\u24E5': 'v',
	    '\uFF56': 'v',
	    '\u1E7D': 'v',
	    '\u1E7F': 'v',
	    '\u028B': 'v',
	    '\uA75F': 'v',
	    '\u028C': 'v',
	    '\uA761': 'vy',
	    '\u24E6': 'w',
	    '\uFF57': 'w',
	    '\u1E81': 'w',
	    '\u1E83': 'w',
	    '\u0175': 'w',
	    '\u1E87': 'w',
	    '\u1E85': 'w',
	    '\u1E98': 'w',
	    '\u1E89': 'w',
	    '\u2C73': 'w',
	    '\u24E7': 'x',
	    '\uFF58': 'x',
	    '\u1E8B': 'x',
	    '\u1E8D': 'x',
	    '\u24E8': 'y',
	    '\uFF59': 'y',
	    '\u1EF3': 'y',
	    '\u00FD': 'y',
	    '\u0177': 'y',
	    '\u1EF9': 'y',
	    '\u0233': 'y',
	    '\u1E8F': 'y',
	    '\u00FF': 'y',
	    '\u1EF7': 'y',
	    '\u1E99': 'y',
	    '\u1EF5': 'y',
	    '\u01B4': 'y',
	    '\u024F': 'y',
	    '\u1EFF': 'y',
	    '\u24E9': 'z',
	    '\uFF5A': 'z',
	    '\u017A': 'z',
	    '\u1E91': 'z',
	    '\u017C': 'z',
	    '\u017E': 'z',
	    '\u1E93': 'z',
	    '\u1E95': 'z',
	    '\u01B6': 'z',
	    '\u0225': 'z',
	    '\u0240': 'z',
	    '\u2C6C': 'z',
	    '\uA763': 'z',
	    '\u0386': '\u0391',
	    '\u0388': '\u0395',
	    '\u0389': '\u0397',
	    '\u038A': '\u0399',
	    '\u03AA': '\u0399',
	    '\u038C': '\u039F',
	    '\u038E': '\u03A5',
	    '\u03AB': '\u03A5',
	    '\u038F': '\u03A9',
	    '\u03AC': '\u03B1',
	    '\u03AD': '\u03B5',
	    '\u03AE': '\u03B7',
	    '\u03AF': '\u03B9',
	    '\u03CA': '\u03B9',
	    '\u0390': '\u03B9',
	    '\u03CC': '\u03BF',
	    '\u03CD': '\u03C5',
	    '\u03CB': '\u03C5',
	    '\u03B0': '\u03C5',
	    '\u03C9': '\u03C9',
	    '\u03C2': '\u03C3'
	  };
	
	  return diacritics;
	});
	
	S2.define('select2/data/base',[
	  '../utils'
	], function (Utils) {
	  function BaseAdapter ($element, options) {
	    BaseAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseAdapter, Utils.Observable);
	
	  BaseAdapter.prototype.current = function (callback) {
	    throw new Error('The `current` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.query = function (params, callback) {
	    throw new Error('The `query` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.bind = function (container, $container) {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.destroy = function () {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.generateResultId = function (container, data) {
	    var id = container.id + '-result-';
	
	    id += Utils.generateChars(4);
	
	    if (data.id != null) {
	      id += '-' + data.id.toString();
	    } else {
	      id += '-' + Utils.generateChars(4);
	    }
	    return id;
	  };
	
	  return BaseAdapter;
	});
	
	S2.define('select2/data/select',[
	  './base',
	  '../utils',
	  'jquery'
	], function (BaseAdapter, Utils, $) {
	  function SelectAdapter ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    SelectAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(SelectAdapter, BaseAdapter);
	
	  SelectAdapter.prototype.current = function (callback) {
	    var data = [];
	    var self = this;
	
	    this.$element.find(':selected').each(function () {
	      var $option = $(this);
	
	      var option = self.item($option);
	
	      data.push(option);
	    });
	
	    callback(data);
	  };
	
	  SelectAdapter.prototype.select = function (data) {
	    var self = this;
	
	    data.selected = true;
	
	    // If data.element is a DOM node, use it instead
	    if ($(data.element).is('option')) {
	      data.element.selected = true;
	
	      this.$element.trigger('change');
	
	      return;
	    }
	
	    if (this.$element.prop('multiple')) {
	      this.current(function (currentData) {
	        var val = [];
	
	        data = [data];
	        data.push.apply(data, currentData);
	
	        for (var d = 0; d < data.length; d++) {
	          var id = data[d].id;
	
	          if ($.inArray(id, val) === -1) {
	            val.push(id);
	          }
	        }
	
	        self.$element.val(val);
	        self.$element.trigger('change');
	      });
	    } else {
	      var val = data.id;
	
	      this.$element.val(val);
	      this.$element.trigger('change');
	    }
	  };
	
	  SelectAdapter.prototype.unselect = function (data) {
	    var self = this;
	
	    if (!this.$element.prop('multiple')) {
	      return;
	    }
	
	    data.selected = false;
	
	    if ($(data.element).is('option')) {
	      data.element.selected = false;
	
	      this.$element.trigger('change');
	
	      return;
	    }
	
	    this.current(function (currentData) {
	      var val = [];
	
	      for (var d = 0; d < currentData.length; d++) {
	        var id = currentData[d].id;
	
	        if (id !== data.id && $.inArray(id, val) === -1) {
	          val.push(id);
	        }
	      }
	
	      self.$element.val(val);
	
	      self.$element.trigger('change');
	    });
	  };
	
	  SelectAdapter.prototype.bind = function (container, $container) {
	    var self = this;
	
	    this.container = container;
	
	    container.on('select', function (params) {
	      self.select(params.data);
	    });
	
	    container.on('unselect', function (params) {
	      self.unselect(params.data);
	    });
	  };
	
	  SelectAdapter.prototype.destroy = function () {
	    // Remove anything added to child elements
	    this.$element.find('*').each(function () {
	      // Remove any custom data set by Select2
	      $.removeData(this, 'data');
	    });
	  };
	
	  SelectAdapter.prototype.query = function (params, callback) {
	    var data = [];
	    var self = this;
	
	    var $options = this.$element.children();
	
	    $options.each(function () {
	      var $option = $(this);
	
	      if (!$option.is('option') && !$option.is('optgroup')) {
	        return;
	      }
	
	      var option = self.item($option);
	
	      var matches = self.matches(params, option);
	
	      if (matches !== null) {
	        data.push(matches);
	      }
	    });
	
	    callback({
	      results: data
	    });
	  };
	
	  SelectAdapter.prototype.addOptions = function ($options) {
	    Utils.appendMany(this.$element, $options);
	  };
	
	  SelectAdapter.prototype.option = function (data) {
	    var option;
	
	    if (data.children) {
	      option = document.createElement('optgroup');
	      option.label = data.text;
	    } else {
	      option = document.createElement('option');
	
	      if (option.textContent !== undefined) {
	        option.textContent = data.text;
	      } else {
	        option.innerText = data.text;
	      }
	    }
	
	    if (data.id) {
	      option.value = data.id;
	    }
	
	    if (data.disabled) {
	      option.disabled = true;
	    }
	
	    if (data.selected) {
	      option.selected = true;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    var $option = $(option);
	
	    var normalizedData = this._normalizeItem(data);
	    normalizedData.element = option;
	
	    // Override the option's data with the combined data
	    $.data(option, 'data', normalizedData);
	
	    return $option;
	  };
	
	  SelectAdapter.prototype.item = function ($option) {
	    var data = {};
	
	    data = $.data($option[0], 'data');
	
	    if (data != null) {
	      return data;
	    }
	
	    if ($option.is('option')) {
	      data = {
	        id: $option.val(),
	        text: $option.text(),
	        disabled: $option.prop('disabled'),
	        selected: $option.prop('selected'),
	        title: $option.prop('title')
	      };
	    } else if ($option.is('optgroup')) {
	      data = {
	        text: $option.prop('label'),
	        children: [],
	        title: $option.prop('title')
	      };
	
	      var $children = $option.children('option');
	      var children = [];
	
	      for (var c = 0; c < $children.length; c++) {
	        var $child = $($children[c]);
	
	        var child = this.item($child);
	
	        children.push(child);
	      }
	
	      data.children = children;
	    }
	
	    data = this._normalizeItem(data);
	    data.element = $option[0];
	
	    $.data($option[0], 'data', data);
	
	    return data;
	  };
	
	  SelectAdapter.prototype._normalizeItem = function (item) {
	    if (!$.isPlainObject(item)) {
	      item = {
	        id: item,
	        text: item
	      };
	    }
	
	    item = $.extend({}, {
	      text: ''
	    }, item);
	
	    var defaults = {
	      selected: false,
	      disabled: false
	    };
	
	    if (item.id != null) {
	      item.id = item.id.toString();
	    }
	
	    if (item.text != null) {
	      item.text = item.text.toString();
	    }
	
	    if (item._resultId == null && item.id && this.container != null) {
	      item._resultId = this.generateResultId(this.container, item);
	    }
	
	    return $.extend({}, defaults, item);
	  };
	
	  SelectAdapter.prototype.matches = function (params, data) {
	    var matcher = this.options.get('matcher');
	
	    return matcher(params, data);
	  };
	
	  return SelectAdapter;
	});
	
	S2.define('select2/data/array',[
	  './select',
	  '../utils',
	  'jquery'
	], function (SelectAdapter, Utils, $) {
	  function ArrayAdapter ($element, options) {
	    var data = options.get('data') || [];
	
	    ArrayAdapter.__super__.constructor.call(this, $element, options);
	
	    this.addOptions(this.convertToOptions(data));
	  }
	
	  Utils.Extend(ArrayAdapter, SelectAdapter);
	
	  ArrayAdapter.prototype.select = function (data) {
	    var $option = this.$element.find('option').filter(function (i, elm) {
	      return elm.value == data.id.toString();
	    });
	
	    if ($option.length === 0) {
	      $option = this.option(data);
	
	      this.addOptions($option);
	    }
	
	    ArrayAdapter.__super__.select.call(this, data);
	  };
	
	  ArrayAdapter.prototype.convertToOptions = function (data) {
	    var self = this;
	
	    var $existing = this.$element.find('option');
	    var existingIds = $existing.map(function () {
	      return self.item($(this)).id;
	    }).get();
	
	    var $options = [];
	
	    // Filter out all items except for the one passed in the argument
	    function onlyItem (item) {
	      return function () {
	        return $(this).val() == item.id;
	      };
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      var item = this._normalizeItem(data[d]);
	
	      // Skip items which were pre-loaded, only merge the data
	      if ($.inArray(item.id, existingIds) >= 0) {
	        var $existingOption = $existing.filter(onlyItem(item));
	
	        var existingData = this.item($existingOption);
	        var newData = $.extend(true, {}, item, existingData);
	
	        var $newOption = this.option(newData);
	
	        $existingOption.replaceWith($newOption);
	
	        continue;
	      }
	
	      var $option = this.option(item);
	
	      if (item.children) {
	        var $children = this.convertToOptions(item.children);
	
	        Utils.appendMany($option, $children);
	      }
	
	      $options.push($option);
	    }
	
	    return $options;
	  };
	
	  return ArrayAdapter;
	});
	
	S2.define('select2/data/ajax',[
	  './array',
	  '../utils',
	  'jquery'
	], function (ArrayAdapter, Utils, $) {
	  function AjaxAdapter ($element, options) {
	    this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	    if (this.ajaxOptions.processResults != null) {
	      this.processResults = this.ajaxOptions.processResults;
	    }
	
	    AjaxAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	  AjaxAdapter.prototype._applyDefaults = function (options) {
	    var defaults = {
	      data: function (params) {
	        return $.extend({}, params, {
	          q: params.term
	        });
	      },
	      transport: function (params, success, failure) {
	        var $request = $.ajax(params);
	
	        $request.then(success);
	        $request.fail(failure);
	
	        return $request;
	      }
	    };
	
	    return $.extend({}, defaults, options, true);
	  };
	
	  AjaxAdapter.prototype.processResults = function (results) {
	    return results;
	  };
	
	  AjaxAdapter.prototype.query = function (params, callback) {
	    var matches = [];
	    var self = this;
	
	    if (this._request != null) {
	      // JSONP requests cannot always be aborted
	      if ($.isFunction(this._request.abort)) {
	        this._request.abort();
	      }
	
	      this._request = null;
	    }
	
	    var options = $.extend({
	      type: 'GET'
	    }, this.ajaxOptions);
	
	    if (typeof options.url === 'function') {
	      options.url = options.url.call(this.$element, params);
	    }
	
	    if (typeof options.data === 'function') {
	      options.data = options.data.call(this.$element, params);
	    }
	
	    function request () {
	      var $request = options.transport(options, function (data) {
	        var results = self.processResults(data, params);
	
	        if (self.options.get('debug') && window.console && console.error) {
	          // Check to make sure that the response included a `results` key.
	          if (!results || !results.results || !$.isArray(results.results)) {
	            console.error(
	              'Select2: The AJAX results did not return an array in the ' +
	              '`results` key of the response.'
	            );
	          }
	        }
	
	        callback(results);
	      }, function () {
	        // Attempt to detect if a request was aborted
	        // Only works if the transport exposes a status property
	        if ($request.status && $request.status === '0') {
	          return;
	        }
	
	        self.trigger('results:message', {
	          message: 'errorLoading'
	        });
	      });
	
	      self._request = $request;
	    }
	
	    if (this.ajaxOptions.delay && params.term != null) {
	      if (this._queryTimeout) {
	        window.clearTimeout(this._queryTimeout);
	      }
	
	      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	    } else {
	      request();
	    }
	  };
	
	  return AjaxAdapter;
	});
	
	S2.define('select2/data/tags',[
	  'jquery'
	], function ($) {
	  function Tags (decorated, $element, options) {
	    var tags = options.get('tags');
	
	    var createTag = options.get('createTag');
	
	    if (createTag !== undefined) {
	      this.createTag = createTag;
	    }
	
	    var insertTag = options.get('insertTag');
	
	    if (insertTag !== undefined) {
	        this.insertTag = insertTag;
	    }
	
	    decorated.call(this, $element, options);
	
	    if ($.isArray(tags)) {
	      for (var t = 0; t < tags.length; t++) {
	        var tag = tags[t];
	        var item = this._normalizeItem(tag);
	
	        var $option = this.option(item);
	
	        this.$element.append($option);
	      }
	    }
	  }
	
	  Tags.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    this._removeOldTags();
	
	    if (params.term == null || params.page != null) {
	      decorated.call(this, params, callback);
	      return;
	    }
	
	    function wrapper (obj, child) {
	      var data = obj.results;
	
	      for (var i = 0; i < data.length; i++) {
	        var option = data[i];
	
	        var checkChildren = (
	          option.children != null &&
	          !wrapper({
	            results: option.children
	          }, true)
	        );
	
	        var checkText = option.text === params.term;
	
	        if (checkText || checkChildren) {
	          if (child) {
	            return false;
	          }
	
	          obj.data = data;
	          callback(obj);
	
	          return;
	        }
	      }
	
	      if (child) {
	        return true;
	      }
	
	      var tag = self.createTag(params);
	
	      if (tag != null) {
	        var $option = self.option(tag);
	        $option.attr('data-select2-tag', true);
	
	        self.addOptions([$option]);
	
	        self.insertTag(data, tag);
	      }
	
	      obj.results = data;
	
	      callback(obj);
	    }
	
	    decorated.call(this, params, wrapper);
	  };
	
	  Tags.prototype.createTag = function (decorated, params) {
	    var term = $.trim(params.term);
	
	    if (term === '') {
	      return null;
	    }
	
	    return {
	      id: term,
	      text: term
	    };
	  };
	
	  Tags.prototype.insertTag = function (_, data, tag) {
	    data.unshift(tag);
	  };
	
	  Tags.prototype._removeOldTags = function (_) {
	    var tag = this._lastTag;
	
	    var $options = this.$element.find('option[data-select2-tag]');
	
	    $options.each(function () {
	      if (this.selected) {
	        return;
	      }
	
	      $(this).remove();
	    });
	  };
	
	  return Tags;
	});
	
	S2.define('select2/data/tokenizer',[
	  'jquery'
	], function ($) {
	  function Tokenizer (decorated, $element, options) {
	    var tokenizer = options.get('tokenizer');
	
	    if (tokenizer !== undefined) {
	      this.tokenizer = tokenizer;
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Tokenizer.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    this.$search =  container.dropdown.$search || container.selection.$search ||
	      $container.find('.select2-search__field');
	  };
	
	  Tokenizer.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    function createAndSelect (data) {
	      // Normalize the data object so we can use it for checks
	      var item = self._normalizeItem(data);
	
	      // Check if the data object already exists as a tag
	      // Select it if it doesn't
	      var $existingOptions = self.$element.find('option').filter(function () {
	        return $(this).val() === item.id;
	      });
	
	      // If an existing option wasn't found for it, create the option
	      if (!$existingOptions.length) {
	        var $option = self.option(item);
	        $option.attr('data-select2-tag', true);
	
	        self._removeOldTags();
	        self.addOptions([$option]);
	      }
	
	      // Select the item, now that we know there is an option for it
	      select(item);
	    }
	
	    function select (data) {
	      self.trigger('select', {
	        data: data
	      });
	    }
	
	    params.term = params.term || '';
	
	    var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	    if (tokenData.term !== params.term) {
	      // Replace the search term if we have the search box
	      if (this.$search.length) {
	        this.$search.val(tokenData.term);
	        this.$search.focus();
	      }
	
	      params.term = tokenData.term;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	    var separators = options.get('tokenSeparators') || [];
	    var term = params.term;
	    var i = 0;
	
	    var createTag = this.createTag || function (params) {
	      return {
	        id: params.term,
	        text: params.term
	      };
	    };
	
	    while (i < term.length) {
	      var termChar = term[i];
	
	      if ($.inArray(termChar, separators) === -1) {
	        i++;
	
	        continue;
	      }
	
	      var part = term.substr(0, i);
	      var partParams = $.extend({}, params, {
	        term: part
	      });
	
	      var data = createTag(partParams);
	
	      if (data == null) {
	        i++;
	        continue;
	      }
	
	      callback(data);
	
	      // Reset the term to not include the tokenized portion
	      term = term.substr(i + 1) || '';
	      i = 0;
	    }
	
	    return {
	      term: term
	    };
	  };
	
	  return Tokenizer;
	});
	
	S2.define('select2/data/minimumInputLength',[
	
	], function () {
	  function MinimumInputLength (decorated, $e, options) {
	    this.minimumInputLength = options.get('minimumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MinimumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (params.term.length < this.minimumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooShort',
	        args: {
	          minimum: this.minimumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MinimumInputLength;
	});
	
	S2.define('select2/data/maximumInputLength',[
	
	], function () {
	  function MaximumInputLength (decorated, $e, options) {
	    this.maximumInputLength = options.get('maximumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (this.maximumInputLength > 0 &&
	        params.term.length > this.maximumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooLong',
	        args: {
	          maximum: this.maximumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MaximumInputLength;
	});
	
	S2.define('select2/data/maximumSelectionLength',[
	
	], function (){
	  function MaximumSelectionLength (decorated, $e, options) {
	    this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumSelectionLength.prototype.query =
	    function (decorated, params, callback) {
	      var self = this;
	
	      this.current(function (currentData) {
	        var count = currentData != null ? currentData.length : 0;
	        if (self.maximumSelectionLength > 0 &&
	          count >= self.maximumSelectionLength) {
	          self.trigger('results:message', {
	            message: 'maximumSelected',
	            args: {
	              maximum: self.maximumSelectionLength
	            }
	          });
	          return;
	        }
	        decorated.call(self, params, callback);
	      });
	  };
	
	  return MaximumSelectionLength;
	});
	
	S2.define('select2/dropdown',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Dropdown ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    Dropdown.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Dropdown, Utils.Observable);
	
	  Dropdown.prototype.render = function () {
	    var $dropdown = $(
	      '<span class="select2-dropdown">' +
	        '<span class="select2-results"></span>' +
	      '</span>'
	    );
	
	    $dropdown.attr('dir', this.options.get('dir'));
	
	    this.$dropdown = $dropdown;
	
	    return $dropdown;
	  };
	
	  Dropdown.prototype.bind = function () {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.position = function ($dropdown, $container) {
	    // Should be implmented in subclasses
	  };
	
	  Dropdown.prototype.destroy = function () {
	    // Remove the dropdown from the DOM
	    this.$dropdown.remove();
	  };
	
	  return Dropdown;
	});
	
	S2.define('select2/dropdown/search',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function Search () { }
	
	  Search.prototype.render = function (decorated) {
	    var $rendered = decorated.call(this);
	
	    var $search = $(
	      '<span class="select2-search select2-search--dropdown">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
	        ' spellcheck="false" role="textbox" />' +
	      '</span>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    $rendered.prepend($search);
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    this.$search.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	    });
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$search.on('input', function (evt) {
	      // Unbind the duplicated `keyup` event
	      $(this).off('keyup');
	    });
	
	    this.$search.on('keyup input', function (evt) {
	      self.handleSearch(evt);
	    });
	
	    container.on('open', function () {
	      self.$search.attr('tabindex', 0);
	
	      self.$search.focus();
	
	      window.setTimeout(function () {
	        self.$search.focus();
	      }, 0);
	    });
	
	    container.on('close', function () {
	      self.$search.attr('tabindex', -1);
	
	      self.$search.val('');
	    });
	
	    container.on('focus', function () {
	      if (container.isOpen()) {
	        self.$search.focus();
	      }
	    });
	
	    container.on('results:all', function (params) {
	      if (params.query.term == null || params.query.term === '') {
	        var showSearch = self.showSearch(params);
	
	        if (showSearch) {
	          self.$searchContainer.removeClass('select2-search--hide');
	        } else {
	          self.$searchContainer.addClass('select2-search--hide');
	        }
	      }
	    });
	  };
	
	  Search.prototype.handleSearch = function (evt) {
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.showSearch = function (_, params) {
	    return true;
	  };
	
	  return Search;
	});
	
	S2.define('select2/dropdown/hidePlaceholder',[
	
	], function () {
	  function HidePlaceholder (decorated, $element, options, dataAdapter) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  HidePlaceholder.prototype.append = function (decorated, data) {
	    data.results = this.removePlaceholder(data.results);
	
	    decorated.call(this, data);
	  };
	
	  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	    var modifiedData = data.slice(0);
	
	    for (var d = data.length - 1; d >= 0; d--) {
	      var item = data[d];
	
	      if (this.placeholder.id === item.id) {
	        modifiedData.splice(d, 1);
	      }
	    }
	
	    return modifiedData;
	  };
	
	  return HidePlaceholder;
	});
	
	S2.define('select2/dropdown/infiniteScroll',[
	  'jquery'
	], function ($) {
	  function InfiniteScroll (decorated, $element, options, dataAdapter) {
	    this.lastParams = {};
	
	    decorated.call(this, $element, options, dataAdapter);
	
	    this.$loadingMore = this.createLoadingMore();
	    this.loading = false;
	  }
	
	  InfiniteScroll.prototype.append = function (decorated, data) {
	    this.$loadingMore.remove();
	    this.loading = false;
	
	    decorated.call(this, data);
	
	    if (this.showLoadingMore(data)) {
	      this.$results.append(this.$loadingMore);
	    }
	  };
	
	  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('query', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    container.on('query:append', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    this.$results.on('scroll', function () {
	      var isLoadMoreVisible = $.contains(
	        document.documentElement,
	        self.$loadingMore[0]
	      );
	
	      if (self.loading || !isLoadMoreVisible) {
	        return;
	      }
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var loadingMoreOffset = self.$loadingMore.offset().top +
	        self.$loadingMore.outerHeight(false);
	
	      if (currentOffset + 50 >= loadingMoreOffset) {
	        self.loadMore();
	      }
	    });
	  };
	
	  InfiniteScroll.prototype.loadMore = function () {
	    this.loading = true;
	
	    var params = $.extend({}, {page: 1}, this.lastParams);
	
	    params.page++;
	
	    this.trigger('query:append', params);
	  };
	
	  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	    return data.pagination && data.pagination.more;
	  };
	
	  InfiniteScroll.prototype.createLoadingMore = function () {
	    var $option = $(
	      '<li ' +
	      'class="select2-results__option select2-results__option--load-more"' +
	      'role="treeitem" aria-disabled="true"></li>'
	    );
	
	    var message = this.options.get('translations').get('loadingMore');
	
	    $option.html(message(this.lastParams));
	
	    return $option;
	  };
	
	  return InfiniteScroll;
	});
	
	S2.define('select2/dropdown/attachBody',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function AttachBody (decorated, $element, options) {
	    this.$dropdownParent = options.get('dropdownParent') || $(document.body);
	
	    decorated.call(this, $element, options);
	  }
	
	  AttachBody.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var setupResultsEvents = false;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self._showDropdown();
	      self._attachPositioningHandler(container);
	
	      if (!setupResultsEvents) {
	        setupResultsEvents = true;
	
	        container.on('results:all', function () {
	          self._positionDropdown();
	          self._resizeDropdown();
	        });
	
	        container.on('results:append', function () {
	          self._positionDropdown();
	          self._resizeDropdown();
	        });
	      }
	    });
	
	    container.on('close', function () {
	      self._hideDropdown();
	      self._detachPositioningHandler(container);
	    });
	
	    this.$dropdownContainer.on('mousedown', function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  AttachBody.prototype.destroy = function (decorated) {
	    decorated.call(this);
	
	    this.$dropdownContainer.remove();
	  };
	
	  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	    // Clone all of the container classes
	    $dropdown.attr('class', $container.attr('class'));
	
	    $dropdown.removeClass('select2');
	    $dropdown.addClass('select2-container--open');
	
	    $dropdown.css({
	      position: 'absolute',
	      top: -999999
	    });
	
	    this.$container = $container;
	  };
	
	  AttachBody.prototype.render = function (decorated) {
	    var $container = $('<span></span>');
	
	    var $dropdown = decorated.call(this);
	    $container.append($dropdown);
	
	    this.$dropdownContainer = $container;
	
	    return $container;
	  };
	
	  AttachBody.prototype._hideDropdown = function (decorated) {
	    this.$dropdownContainer.detach();
	  };
	
	  AttachBody.prototype._attachPositioningHandler =
	      function (decorated, container) {
	    var self = this;
	
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.each(function () {
	      $(this).data('select2-scroll-position', {
	        x: $(this).scrollLeft(),
	        y: $(this).scrollTop()
	      });
	    });
	
	    $watchers.on(scrollEvent, function (ev) {
	      var position = $(this).data('select2-scroll-position');
	      $(this).scrollTop(position.y);
	    });
	
	    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
	      function (e) {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	  };
	
	  AttachBody.prototype._detachPositioningHandler =
	      function (decorated, container) {
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.off(scrollEvent);
	
	    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	  };
	
	  AttachBody.prototype._positionDropdown = function () {
	    var $window = $(window);
	
	    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	    var newDirection = null;
	
	    var offset = this.$container.offset();
	
	    offset.bottom = offset.top + this.$container.outerHeight(false);
	
	    var container = {
	      height: this.$container.outerHeight(false)
	    };
	
	    container.top = offset.top;
	    container.bottom = offset.top + container.height;
	
	    var dropdown = {
	      height: this.$dropdown.outerHeight(false)
	    };
	
	    var viewport = {
	      top: $window.scrollTop(),
	      bottom: $window.scrollTop() + $window.height()
	    };
	
	    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
	    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	
	    var css = {
	      left: offset.left,
	      top: container.bottom
	    };
	
	    // Determine what the parent element is to use for calciulating the offset
	    var $offsetParent = this.$dropdownParent;
	
	    // For statically positoned elements, we need to get the element
	    // that is determining the offset
	    if ($offsetParent.css('position') === 'static') {
	      $offsetParent = $offsetParent.offsetParent();
	    }
	
	    var parentOffset = $offsetParent.offset();
	
	    css.top -= parentOffset.top;
	    css.left -= parentOffset.left;
	
	    if (!isCurrentlyAbove && !isCurrentlyBelow) {
	      newDirection = 'below';
	    }
	
	    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	      newDirection = 'above';
	    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	      newDirection = 'below';
	    }
	
	    if (newDirection == 'above' ||
	      (isCurrentlyAbove && newDirection !== 'below')) {
	      css.top = container.top - parentOffset.top - dropdown.height;
	    }
	
	    if (newDirection != null) {
	      this.$dropdown
	        .removeClass('select2-dropdown--below select2-dropdown--above')
	        .addClass('select2-dropdown--' + newDirection);
	      this.$container
	        .removeClass('select2-container--below select2-container--above')
	        .addClass('select2-container--' + newDirection);
	    }
	
	    this.$dropdownContainer.css(css);
	  };
	
	  AttachBody.prototype._resizeDropdown = function () {
	    var css = {
	      width: this.$container.outerWidth(false) + 'px'
	    };
	
	    if (this.options.get('dropdownAutoWidth')) {
	      css.minWidth = css.width;
	      css.position = 'relative';
	      css.width = 'auto';
	    }
	
	    this.$dropdown.css(css);
	  };
	
	  AttachBody.prototype._showDropdown = function (decorated) {
	    this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	    this._positionDropdown();
	    this._resizeDropdown();
	  };
	
	  return AttachBody;
	});
	
	S2.define('select2/dropdown/minimumResultsForSearch',[
	
	], function () {
	  function countResults (data) {
	    var count = 0;
	
	    for (var d = 0; d < data.length; d++) {
	      var item = data[d];
	
	      if (item.children) {
	        count += countResults(item.children);
	      } else {
	        count++;
	      }
	    }
	
	    return count;
	  }
	
	  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
	    this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	    if (this.minimumResultsForSearch < 0) {
	      this.minimumResultsForSearch = Infinity;
	    }
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	    if (countResults(params.data.results) < this.minimumResultsForSearch) {
	      return false;
	    }
	
	    return decorated.call(this, params);
	  };
	
	  return MinimumResultsForSearch;
	});
	
	S2.define('select2/dropdown/selectOnClose',[
	
	], function () {
	  function SelectOnClose () { }
	
	  SelectOnClose.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('close', function (params) {
	      self._handleSelectOnClose(params);
	    });
	  };
	
	  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	    if (params && params.originalSelect2Event != null) {
	      var event = params.originalSelect2Event;
	
	      // Don't select an item if the close event was triggered from a select or
	      // unselect event
	      if (event._type === 'select' || event._type === 'unselect') {
	        return;
	      }
	    }
	
	    var $highlightedResults = this.getHighlightedResults();
	
	    // Only select highlighted results
	    if ($highlightedResults.length < 1) {
	      return;
	    }
	
	    var data = $highlightedResults.data('data');
	
	    // Don't re-select already selected resulte
	    if (
	      (data.element != null && data.element.selected) ||
	      (data.element == null && data.selected)
	    ) {
	      return;
	    }
	
	    this.trigger('select', {
	        data: data
	    });
	  };
	
	  return SelectOnClose;
	});
	
	S2.define('select2/dropdown/closeOnSelect',[
	
	], function () {
	  function CloseOnSelect () { }
	
	  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('select', function (evt) {
	      self._selectTriggered(evt);
	    });
	
	    container.on('unselect', function (evt) {
	      self._selectTriggered(evt);
	    });
	  };
	
	  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	    var originalEvent = evt.originalEvent;
	
	    // Don't close if the control key is being held
	    if (originalEvent && originalEvent.ctrlKey) {
	      return;
	    }
	
	    this.trigger('close', {
	      originalEvent: originalEvent,
	      originalSelect2Event: evt
	    });
	  };
	
	  return CloseOnSelect;
	});
	
	S2.define('select2/i18n/en',[],function () {
	  // English
	  return {
	    errorLoading: function () {
	      return 'The results could not be loaded.';
	    },
	    inputTooLong: function (args) {
	      var overChars = args.input.length - args.maximum;
	
	      var message = 'Please delete ' + overChars + ' character';
	
	      if (overChars != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    inputTooShort: function (args) {
	      var remainingChars = args.minimum - args.input.length;
	
	      var message = 'Please enter ' + remainingChars + ' or more characters';
	
	      return message;
	    },
	    loadingMore: function () {
	      return 'Loading more results…';
	    },
	    maximumSelected: function (args) {
	      var message = 'You can only select ' + args.maximum + ' item';
	
	      if (args.maximum != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    noResults: function () {
	      return 'No results found';
	    },
	    searching: function () {
	      return 'Searching…';
	    }
	  };
	});
	
	S2.define('select2/defaults',[
	  'jquery',
	  'require',
	
	  './results',
	
	  './selection/single',
	  './selection/multiple',
	  './selection/placeholder',
	  './selection/allowClear',
	  './selection/search',
	  './selection/eventRelay',
	
	  './utils',
	  './translation',
	  './diacritics',
	
	  './data/select',
	  './data/array',
	  './data/ajax',
	  './data/tags',
	  './data/tokenizer',
	  './data/minimumInputLength',
	  './data/maximumInputLength',
	  './data/maximumSelectionLength',
	
	  './dropdown',
	  './dropdown/search',
	  './dropdown/hidePlaceholder',
	  './dropdown/infiniteScroll',
	  './dropdown/attachBody',
	  './dropdown/minimumResultsForSearch',
	  './dropdown/selectOnClose',
	  './dropdown/closeOnSelect',
	
	  './i18n/en'
	], function ($, require,
	
	             ResultsList,
	
	             SingleSelection, MultipleSelection, Placeholder, AllowClear,
	             SelectionSearch, EventRelay,
	
	             Utils, Translation, DIACRITICS,
	
	             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
	             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,
	
	             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
	             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
	
	             EnglishTranslation) {
	  function Defaults () {
	    this.reset();
	  }
	
	  Defaults.prototype.apply = function (options) {
	    options = $.extend(true, {}, this.defaults, options);
	
	    if (options.dataAdapter == null) {
	      if (options.ajax != null) {
	        options.dataAdapter = AjaxData;
	      } else if (options.data != null) {
	        options.dataAdapter = ArrayData;
	      } else {
	        options.dataAdapter = SelectData;
	      }
	
	      if (options.minimumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MinimumInputLength
	        );
	      }
	
	      if (options.maximumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumInputLength
	        );
	      }
	
	      if (options.maximumSelectionLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumSelectionLength
	        );
	      }
	
	      if (options.tags) {
	        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	      }
	
	      if (options.tokenSeparators != null || options.tokenizer != null) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Tokenizer
	        );
	      }
	
	      if (options.query != null) {
	        var Query = require(options.amdBase + 'compat/query');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Query
	        );
	      }
	
	      if (options.initSelection != null) {
	        var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          InitSelection
	        );
	      }
	    }
	
	    if (options.resultsAdapter == null) {
	      options.resultsAdapter = ResultsList;
	
	      if (options.ajax != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          InfiniteScroll
	        );
	      }
	
	      if (options.placeholder != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          HidePlaceholder
	        );
	      }
	
	      if (options.selectOnClose) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          SelectOnClose
	        );
	      }
	    }
	
	    if (options.dropdownAdapter == null) {
	      if (options.multiple) {
	        options.dropdownAdapter = Dropdown;
	      } else {
	        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	        options.dropdownAdapter = SearchableDropdown;
	      }
	
	      if (options.minimumResultsForSearch !== 0) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          MinimumResultsForSearch
	        );
	      }
	
	      if (options.closeOnSelect) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          CloseOnSelect
	        );
	      }
	
	      if (
	        options.dropdownCssClass != null ||
	        options.dropdownCss != null ||
	        options.adaptDropdownCssClass != null
	      ) {
	        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          DropdownCSS
	        );
	      }
	
	      options.dropdownAdapter = Utils.Decorate(
	        options.dropdownAdapter,
	        AttachBody
	      );
	    }
	
	    if (options.selectionAdapter == null) {
	      if (options.multiple) {
	        options.selectionAdapter = MultipleSelection;
	      } else {
	        options.selectionAdapter = SingleSelection;
	      }
	
	      // Add the placeholder mixin if a placeholder was specified
	      if (options.placeholder != null) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          Placeholder
	        );
	      }
	
	      if (options.allowClear) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          AllowClear
	        );
	      }
	
	      if (options.multiple) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          SelectionSearch
	        );
	      }
	
	      if (
	        options.containerCssClass != null ||
	        options.containerCss != null ||
	        options.adaptContainerCssClass != null
	      ) {
	        var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          ContainerCSS
	        );
	      }
	
	      options.selectionAdapter = Utils.Decorate(
	        options.selectionAdapter,
	        EventRelay
	      );
	    }
	
	    if (typeof options.language === 'string') {
	      // Check if the language is specified with a region
	      if (options.language.indexOf('-') > 0) {
	        // Extract the region information if it is included
	        var languageParts = options.language.split('-');
	        var baseLanguage = languageParts[0];
	
	        options.language = [options.language, baseLanguage];
	      } else {
	        options.language = [options.language];
	      }
	    }
	
	    if ($.isArray(options.language)) {
	      var languages = new Translation();
	      options.language.push('en');
	
	      var languageNames = options.language;
	
	      for (var l = 0; l < languageNames.length; l++) {
	        var name = languageNames[l];
	        var language = {};
	
	        try {
	          // Try to load it with the original name
	          language = Translation.loadPath(name);
	        } catch (e) {
	          try {
	            // If we couldn't load it, check if it wasn't the full path
	            name = this.defaults.amdLanguageBase + name;
	            language = Translation.loadPath(name);
	          } catch (ex) {
	            // The translation could not be loaded at all. Sometimes this is
	            // because of a configuration problem, other times this can be
	            // because of how Select2 helps load all possible translation files.
	            if (options.debug && window.console && console.warn) {
	              console.warn(
	                'Select2: The language file for "' + name + '" could not be ' +
	                'automatically loaded. A fallback will be used instead.'
	              );
	            }
	
	            continue;
	          }
	        }
	
	        languages.extend(language);
	      }
	
	      options.translations = languages;
	    } else {
	      var baseTranslation = Translation.loadPath(
	        this.defaults.amdLanguageBase + 'en'
	      );
	      var customTranslation = new Translation(options.language);
	
	      customTranslation.extend(baseTranslation);
	
	      options.translations = customTranslation;
	    }
	
	    return options;
	  };
	
	  Defaults.prototype.reset = function () {
	    function stripDiacritics (text) {
	      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	      function match(a) {
	        return DIACRITICS[a] || a;
	      }
	
	      return text.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function matcher (params, data) {
	      // Always return the object if there is nothing to compare
	      if ($.trim(params.term) === '') {
	        return data;
	      }
	
	      // Do a recursive check for options with children
	      if (data.children && data.children.length > 0) {
	        // Clone the data object if there are children
	        // This is required as we modify the object to remove any non-matches
	        var match = $.extend(true, {}, data);
	
	        // Check each child of the option
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          var matches = matcher(params, child);
	
	          // If there wasn't a match, remove the object in the array
	          if (matches == null) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        // If any children matched, return the new object
	        if (match.children.length > 0) {
	          return match;
	        }
	
	        // If there were no matching children, check just the plain object
	        return matcher(params, match);
	      }
	
	      var original = stripDiacritics(data.text).toUpperCase();
	      var term = stripDiacritics(params.term).toUpperCase();
	
	      // Check if the text contains the term
	      if (original.indexOf(term) > -1) {
	        return data;
	      }
	
	      // If it doesn't contain the term, don't return anything
	      return null;
	    }
	
	    this.defaults = {
	      amdBase: './',
	      amdLanguageBase: './i18n/',
	      closeOnSelect: true,
	      debug: false,
	      dropdownAutoWidth: false,
	      escapeMarkup: Utils.escapeMarkup,
	      language: EnglishTranslation,
	      matcher: matcher,
	      minimumInputLength: 0,
	      maximumInputLength: 0,
	      maximumSelectionLength: 0,
	      minimumResultsForSearch: 0,
	      selectOnClose: false,
	      sorter: function (data) {
	        return data;
	      },
	      templateResult: function (result) {
	        return result.text;
	      },
	      templateSelection: function (selection) {
	        return selection.text;
	      },
	      theme: 'default',
	      width: 'resolve'
	    };
	  };
	
	  Defaults.prototype.set = function (key, value) {
	    var camelKey = $.camelCase(key);
	
	    var data = {};
	    data[camelKey] = value;
	
	    var convertedData = Utils._convertData(data);
	
	    $.extend(this.defaults, convertedData);
	  };
	
	  var defaults = new Defaults();
	
	  return defaults;
	});
	
	S2.define('select2/options',[
	  'require',
	  'jquery',
	  './defaults',
	  './utils'
	], function (require, $, Defaults, Utils) {
	  function Options (options, $element) {
	    this.options = options;
	
	    if ($element != null) {
	      this.fromElement($element);
	    }
	
	    this.options = Defaults.apply(this.options);
	
	    if ($element && $element.is('input')) {
	      var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	      this.options.dataAdapter = Utils.Decorate(
	        this.options.dataAdapter,
	        InputCompat
	      );
	    }
	  }
	
	  Options.prototype.fromElement = function ($e) {
	    var excludedData = ['select2'];
	
	    if (this.options.multiple == null) {
	      this.options.multiple = $e.prop('multiple');
	    }
	
	    if (this.options.disabled == null) {
	      this.options.disabled = $e.prop('disabled');
	    }
	
	    if (this.options.language == null) {
	      if ($e.prop('lang')) {
	        this.options.language = $e.prop('lang').toLowerCase();
	      } else if ($e.closest('[lang]').prop('lang')) {
	        this.options.language = $e.closest('[lang]').prop('lang');
	      }
	    }
	
	    if (this.options.dir == null) {
	      if ($e.prop('dir')) {
	        this.options.dir = $e.prop('dir');
	      } else if ($e.closest('[dir]').prop('dir')) {
	        this.options.dir = $e.closest('[dir]').prop('dir');
	      } else {
	        this.options.dir = 'ltr';
	      }
	    }
	
	    $e.prop('disabled', this.options.disabled);
	    $e.prop('multiple', this.options.multiple);
	
	    if ($e.data('select2Tags')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-select2-tags` attribute has been changed to ' +
	          'use the `data-data` and `data-tags="true"` attributes and will be ' +
	          'removed in future versions of Select2.'
	        );
	      }
	
	      $e.data('data', $e.data('select2Tags'));
	      $e.data('tags', true);
	    }
	
	    if ($e.data('ajaxUrl')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-ajax-url` attribute has been changed to ' +
	          '`data-ajax--url` and support for the old attribute will be removed' +
	          ' in future versions of Select2.'
	        );
	      }
	
	      $e.attr('ajax--url', $e.data('ajaxUrl'));
	      $e.data('ajax--url', $e.data('ajaxUrl'));
	    }
	
	    var dataset = {};
	
	    // Prefer the element's `dataset` attribute if it exists
	    // jQuery 1.x does not correctly handle data attributes with multiple dashes
	    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
	    } else {
	      dataset = $e.data();
	    }
	
	    var data = $.extend(true, {}, dataset);
	
	    data = Utils._convertData(data);
	
	    for (var key in data) {
	      if ($.inArray(key, excludedData) > -1) {
	        continue;
	      }
	
	      if ($.isPlainObject(this.options[key])) {
	        $.extend(this.options[key], data[key]);
	      } else {
	        this.options[key] = data[key];
	      }
	    }
	
	    return this;
	  };
	
	  Options.prototype.get = function (key) {
	    return this.options[key];
	  };
	
	  Options.prototype.set = function (key, val) {
	    this.options[key] = val;
	  };
	
	  return Options;
	});
	
	S2.define('select2/core',[
	  'jquery',
	  './options',
	  './utils',
	  './keys'
	], function ($, Options, Utils, KEYS) {
	  var Select2 = function ($element, options) {
	    if ($element.data('select2') != null) {
	      $element.data('select2').destroy();
	    }
	
	    this.$element = $element;
	
	    this.id = this._generateId($element);
	
	    options = options || {};
	
	    this.options = new Options(options, $element);
	
	    Select2.__super__.constructor.call(this);
	
	    // Set up the tabindex
	
	    var tabindex = $element.attr('tabindex') || 0;
	    $element.data('old-tabindex', tabindex);
	    $element.attr('tabindex', '-1');
	
	    // Set up containers and adapters
	
	    var DataAdapter = this.options.get('dataAdapter');
	    this.dataAdapter = new DataAdapter($element, this.options);
	
	    var $container = this.render();
	
	    this._placeContainer($container);
	
	    var SelectionAdapter = this.options.get('selectionAdapter');
	    this.selection = new SelectionAdapter($element, this.options);
	    this.$selection = this.selection.render();
	
	    this.selection.position(this.$selection, $container);
	
	    var DropdownAdapter = this.options.get('dropdownAdapter');
	    this.dropdown = new DropdownAdapter($element, this.options);
	    this.$dropdown = this.dropdown.render();
	
	    this.dropdown.position(this.$dropdown, $container);
	
	    var ResultsAdapter = this.options.get('resultsAdapter');
	    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	    this.$results = this.results.render();
	
	    this.results.position(this.$results, this.$dropdown);
	
	    // Bind events
	
	    var self = this;
	
	    // Bind the container to all of the adapters
	    this._bindAdapters();
	
	    // Register any DOM event handlers
	    this._registerDomEvents();
	
	    // Register any internal event handlers
	    this._registerDataEvents();
	    this._registerSelectionEvents();
	    this._registerDropdownEvents();
	    this._registerResultsEvents();
	    this._registerEvents();
	
	    // Set the initial state
	    this.dataAdapter.current(function (initialData) {
	      self.trigger('selection:update', {
	        data: initialData
	      });
	    });
	
	    // Hide the original select
	    $element.addClass('select2-hidden-accessible');
	    $element.attr('aria-hidden', 'true');
	
	    // Synchronize any monitored attributes
	    this._syncAttributes();
	
	    $element.data('select2', this);
	  };
	
	  Utils.Extend(Select2, Utils.Observable);
	
	  Select2.prototype._generateId = function ($element) {
	    var id = '';
	
	    if ($element.attr('id') != null) {
	      id = $element.attr('id');
	    } else if ($element.attr('name') != null) {
	      id = $element.attr('name') + '-' + Utils.generateChars(2);
	    } else {
	      id = Utils.generateChars(4);
	    }
	
	    id = id.replace(/(:|\.|\[|\]|,)/g, '');
	    id = 'select2-' + id;
	
	    return id;
	  };
	
	  Select2.prototype._placeContainer = function ($container) {
	    $container.insertAfter(this.$element);
	
	    var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	    if (width != null) {
	      $container.css('width', width);
	    }
	  };
	
	  Select2.prototype._resolveWidth = function ($element, method) {
	    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	    if (method == 'resolve') {
	      var styleWidth = this._resolveWidth($element, 'style');
	
	      if (styleWidth != null) {
	        return styleWidth;
	      }
	
	      return this._resolveWidth($element, 'element');
	    }
	
	    if (method == 'element') {
	      var elementWidth = $element.outerWidth(false);
	
	      if (elementWidth <= 0) {
	        return 'auto';
	      }
	
	      return elementWidth + 'px';
	    }
	
	    if (method == 'style') {
	      var style = $element.attr('style');
	
	      if (typeof(style) !== 'string') {
	        return null;
	      }
	
	      var attrs = style.split(';');
	
	      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	        var attr = attrs[i].replace(/\s/g, '');
	        var matches = attr.match(WIDTH);
	
	        if (matches !== null && matches.length >= 1) {
	          return matches[1];
	        }
	      }
	
	      return null;
	    }
	
	    return method;
	  };
	
	  Select2.prototype._bindAdapters = function () {
	    this.dataAdapter.bind(this, this.$container);
	    this.selection.bind(this, this.$container);
	
	    this.dropdown.bind(this, this.$container);
	    this.results.bind(this, this.$container);
	  };
	
	  Select2.prototype._registerDomEvents = function () {
	    var self = this;
	
	    this.$element.on('change.select2', function () {
	      self.dataAdapter.current(function (data) {
	        self.trigger('selection:update', {
	          data: data
	        });
	      });
	    });
	
	    this.$element.on('focus.select2', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this._syncA = Utils.bind(this._syncAttributes, this);
	    this._syncS = Utils.bind(this._syncSubtree, this);
	
	    if (this.$element[0].attachEvent) {
	      this.$element[0].attachEvent('onpropertychange', this._syncA);
	    }
	
	    var observer = window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    ;
	
	    if (observer != null) {
	      this._observer = new observer(function (mutations) {
	        $.each(mutations, self._syncA);
	        $.each(mutations, self._syncS);
	      });
	      this._observer.observe(this.$element[0], {
	        attributes: true,
	        childList: true,
	        subtree: false
	      });
	    } else if (this.$element[0].addEventListener) {
	      this.$element[0].addEventListener(
	        'DOMAttrModified',
	        self._syncA,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeInserted',
	        self._syncS,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeRemoved',
	        self._syncS,
	        false
	      );
	    }
	  };
	
	  Select2.prototype._registerDataEvents = function () {
	    var self = this;
	
	    this.dataAdapter.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerSelectionEvents = function () {
	    var self = this;
	    var nonRelayEvents = ['toggle', 'focus'];
	
	    this.selection.on('toggle', function () {
	      self.toggleDropdown();
	    });
	
	    this.selection.on('focus', function (params) {
	      self.focus(params);
	    });
	
	    this.selection.on('*', function (name, params) {
	      if ($.inArray(name, nonRelayEvents) !== -1) {
	        return;
	      }
	
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerDropdownEvents = function () {
	    var self = this;
	
	    this.dropdown.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerResultsEvents = function () {
	    var self = this;
	
	    this.results.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerEvents = function () {
	    var self = this;
	
	    this.on('open', function () {
	      self.$container.addClass('select2-container--open');
	    });
	
	    this.on('close', function () {
	      self.$container.removeClass('select2-container--open');
	    });
	
	    this.on('enable', function () {
	      self.$container.removeClass('select2-container--disabled');
	    });
	
	    this.on('disable', function () {
	      self.$container.addClass('select2-container--disabled');
	    });
	
	    this.on('blur', function () {
	      self.$container.removeClass('select2-container--focus');
	    });
	
	    this.on('query', function (params) {
	      if (!self.isOpen()) {
	        self.trigger('open', {});
	      }
	
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:all', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('query:append', function (params) {
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:append', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('keypress', function (evt) {
	      var key = evt.which;
	
	      if (self.isOpen()) {
	        if (key === KEYS.ESC || key === KEYS.TAB ||
	            (key === KEYS.UP && evt.altKey)) {
	          self.close();
	
	          evt.preventDefault();
	        } else if (key === KEYS.ENTER) {
	          self.trigger('results:select', {});
	
	          evt.preventDefault();
	        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
	          self.trigger('results:toggle', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.UP) {
	          self.trigger('results:previous', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.DOWN) {
	          self.trigger('results:next', {});
	
	          evt.preventDefault();
	        }
	      } else {
	        if (key === KEYS.ENTER || key === KEYS.SPACE ||
	            (key === KEYS.DOWN && evt.altKey)) {
	          self.open();
	
	          evt.preventDefault();
	        }
	      }
	    });
	  };
	
	  Select2.prototype._syncAttributes = function () {
	    this.options.set('disabled', this.$element.prop('disabled'));
	
	    if (this.options.get('disabled')) {
	      if (this.isOpen()) {
	        this.close();
	      }
	
	      this.trigger('disable', {});
	    } else {
	      this.trigger('enable', {});
	    }
	  };
	
	  Select2.prototype._syncSubtree = function (evt, mutations) {
	    var changed = false;
	    var self = this;
	
	    // Ignore any mutation events raised for elements that aren't options or
	    // optgroups. This handles the case when the select element is destroyed
	    if (
	      evt && evt.target && (
	        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
	      )
	    ) {
	      return;
	    }
	
	    if (!mutations) {
	      // If mutation events aren't supported, then we can only assume that the
	      // change affected the selections
	      changed = true;
	    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	      for (var n = 0; n < mutations.addedNodes.length; n++) {
	        var node = mutations.addedNodes[n];
	
	        if (node.selected) {
	          changed = true;
	        }
	      }
	    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	      changed = true;
	    }
	
	    // Only re-pull the data if we think there is a change
	    if (changed) {
	      this.dataAdapter.current(function (currentData) {
	        self.trigger('selection:update', {
	          data: currentData
	        });
	      });
	    }
	  };
	
	  /**
	   * Override the trigger method to automatically trigger pre-events when
	   * there are events that can be prevented.
	   */
	  Select2.prototype.trigger = function (name, args) {
	    var actualTrigger = Select2.__super__.trigger;
	    var preTriggerMap = {
	      'open': 'opening',
	      'close': 'closing',
	      'select': 'selecting',
	      'unselect': 'unselecting'
	    };
	
	    if (args === undefined) {
	      args = {};
	    }
	
	    if (name in preTriggerMap) {
	      var preTriggerName = preTriggerMap[name];
	      var preTriggerArgs = {
	        prevented: false,
	        name: name,
	        args: args
	      };
	
	      actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	      if (preTriggerArgs.prevented) {
	        args.prevented = true;
	
	        return;
	      }
	    }
	
	    actualTrigger.call(this, name, args);
	  };
	
	  Select2.prototype.toggleDropdown = function () {
	    if (this.options.get('disabled')) {
	      return;
	    }
	
	    if (this.isOpen()) {
	      this.close();
	    } else {
	      this.open();
	    }
	  };
	
	  Select2.prototype.open = function () {
	    if (this.isOpen()) {
	      return;
	    }
	
	    this.trigger('query', {});
	  };
	
	  Select2.prototype.close = function () {
	    if (!this.isOpen()) {
	      return;
	    }
	
	    this.trigger('close', {});
	  };
	
	  Select2.prototype.isOpen = function () {
	    return this.$container.hasClass('select2-container--open');
	  };
	
	  Select2.prototype.hasFocus = function () {
	    return this.$container.hasClass('select2-container--focus');
	  };
	
	  Select2.prototype.focus = function (data) {
	    // No need to re-trigger focus events if we are already focused
	    if (this.hasFocus()) {
	      return;
	    }
	
	    this.$container.addClass('select2-container--focus');
	    this.trigger('focus', {});
	  };
	
	  Select2.prototype.enable = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("enable")` method has been deprecated and will' +
	        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
	        ' instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      args = [true];
	    }
	
	    var disabled = !args[0];
	
	    this.$element.prop('disabled', disabled);
	  };
	
	  Select2.prototype.data = function () {
	    if (this.options.get('debug') &&
	        arguments.length > 0 && window.console && console.warn) {
	      console.warn(
	        'Select2: Data can no longer be set using `select2("data")`. You ' +
	        'should consider setting the value instead using `$element.val()`.'
	      );
	    }
	
	    var data = [];
	
	    this.dataAdapter.current(function (currentData) {
	      data = currentData;
	    });
	
	    return data;
	  };
	
	  Select2.prototype.val = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("val")` method has been deprecated and will be' +
	        ' removed in later Select2 versions. Use $element.val() instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      return this.$element.val();
	    }
	
	    var newVal = args[0];
	
	    if ($.isArray(newVal)) {
	      newVal = $.map(newVal, function (obj) {
	        return obj.toString();
	      });
	    }
	
	    this.$element.val(newVal).trigger('change');
	  };
	
	  Select2.prototype.destroy = function () {
	    this.$container.remove();
	
	    if (this.$element[0].detachEvent) {
	      this.$element[0].detachEvent('onpropertychange', this._syncA);
	    }
	
	    if (this._observer != null) {
	      this._observer.disconnect();
	      this._observer = null;
	    } else if (this.$element[0].removeEventListener) {
	      this.$element[0]
	        .removeEventListener('DOMAttrModified', this._syncA, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeInserted', this._syncS, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeRemoved', this._syncS, false);
	    }
	
	    this._syncA = null;
	    this._syncS = null;
	
	    this.$element.off('.select2');
	    this.$element.attr('tabindex', this.$element.data('old-tabindex'));
	
	    this.$element.removeClass('select2-hidden-accessible');
	    this.$element.attr('aria-hidden', 'false');
	    this.$element.removeData('select2');
	
	    this.dataAdapter.destroy();
	    this.selection.destroy();
	    this.dropdown.destroy();
	    this.results.destroy();
	
	    this.dataAdapter = null;
	    this.selection = null;
	    this.dropdown = null;
	    this.results = null;
	  };
	
	  Select2.prototype.render = function () {
	    var $container = $(
	      '<span class="select2 select2-container">' +
	        '<span class="selection"></span>' +
	        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
	      '</span>'
	    );
	
	    $container.attr('dir', this.options.get('dir'));
	
	    this.$container = $container;
	
	    this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	    $container.data('element', this.$element);
	
	    return $container;
	  };
	
	  return Select2;
	});
	
	S2.define('jquery-mousewheel',[
	  'jquery'
	], function ($) {
	  // Used to shim jQuery.mousewheel for non-full builds.
	  return $;
	});
	
	S2.define('jquery.select2',[
	  'jquery',
	  'jquery-mousewheel',
	
	  './select2/core',
	  './select2/defaults'
	], function ($, _, Select2, Defaults) {
	  if ($.fn.select2 == null) {
	    // All methods that should return the element
	    var thisMethods = ['open', 'close', 'destroy'];
	
	    $.fn.select2 = function (options) {
	      options = options || {};
	
	      if (typeof options === 'object') {
	        this.each(function () {
	          var instanceOptions = $.extend(true, {}, options);
	
	          var instance = new Select2($(this), instanceOptions);
	        });
	
	        return this;
	      } else if (typeof options === 'string') {
	        var ret;
	        var args = Array.prototype.slice.call(arguments, 1);
	
	        this.each(function () {
	          var instance = $(this).data('select2');
	
	          if (instance == null && window.console && console.error) {
	            console.error(
	              'The select2(\'' + options + '\') method was called on an ' +
	              'element that is not using Select2.'
	            );
	          }
	
	          ret = instance[options].apply(instance, args);
	        });
	
	        // Check if we should be returning `this`
	        if ($.inArray(options, thisMethods) > -1) {
	          return this;
	        }
	
	        return ret;
	      } else {
	        throw new Error('Invalid arguments for Select2: ' + options);
	      }
	    };
	  }
	
	  if ($.fn.select2.defaults == null) {
	    $.fn.select2.defaults = Defaults;
	  }
	
	  return Select2;
	});
	
	  // Return the AMD loader configuration so it can be used outside of this file
	  return {
	    define: S2.define,
	    require: S2.require
	  };
	}());
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	}));


/***/ },

/***/ "i32V":
/***/ function(module, exports) {

	// inlined http://underscorejs.org/ realization isString, isNumber
	var toString = Object.prototype.toString;
	
	function isString(obj) {
	  return toString.call(obj) === "[object String]";
	}
	
	function isNumber(obj) {
	  return toString.call(obj) === "[object Number]";
	}
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    /* eslint no-self-compare: 0 */
	    return x !== x && y !== y;
	  }
	}
	
	function isFuzzy(x, y) {
	  /* eslint eqeqeq: 0 */
	  if (x == y) {
	    if ((isString(x) || isNumber(x)) && (isString(y) || isNumber(y))) {
	      return true;
	    }
	  }
	  return is(x, y);
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// custom algoritm from https://github.com/facebook/fbjs
	// fbjs/lib/shallowEqual
	function shallowEqualFuzzy(objA, objB) {
	  if (isFuzzy(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
	    return false;
	  }
	
	  if (objA instanceof Array && objB instanceof Array) {
	    if (objA.length !== objB.length) {
	      return false;
	    }
	    // greed search
	    var valA, iLen = objA.length;
	    var equalityMap = new Array(iLen);
	    for (var i = 0; i < iLen; i++) {
	      valA = objA[i];
	      if (shallowEqualFuzzy(valA, objB[i])) {
	        // elements in array in normal order
	        equalityMap[i] = true;
	        continue;
	      }
	
	      // elements in array have different order
	      var isEqual = false;
	      for (var k = 0, kLen = objB.length; k < kLen; k++) {
	        if (equalityMap[k]) {
	          continue;
	        }
	        if (shallowEqualFuzzy(valA, objB[k])) {
	          equalityMap[k] = true;
	          isEqual = true;
	          break;
	        }
	      }
	      if (!isEqual) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  for (var j = 0; j < keysA.length; j++) {
	    if (!hasOwnProperty.call(objB, keysA[j]) ||
	      !shallowEqualFuzzy(objA[keysA[j]], objB[keysA[j]])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqualFuzzy;


/***/ },

/***/ "pV5o":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },

/***/ "9SWq":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("ar93");
	
	var invariant = __webpack_require__("n3uw");
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },

/***/ "G1ow":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("tXBS");
	
	var ReactBaseClasses = __webpack_require__("O6dE");
	var ReactChildren = __webpack_require__("LTDs");
	var ReactDOMFactories = __webpack_require__("vUzd");
	var ReactElement = __webpack_require__("W2D2");
	var ReactPropTypes = __webpack_require__("S+kE");
	var ReactVersion = __webpack_require__("GjCS");
	
	var createReactClass = __webpack_require__("JYGa");
	var onlyChild = __webpack_require__("5WN7");
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },

/***/ "O6dE":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("ar93"),
	    _assign = __webpack_require__("tXBS");
	
	var ReactNoopUpdateQueue = __webpack_require__("CO2B");
	
	var canDefineProperty = __webpack_require__("RFlT");
	var emptyObject = __webpack_require__("Ds8Q");
	var invariant = __webpack_require__("n3uw");
	var lowPriorityWarning = __webpack_require__("bVsJ");
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },

/***/ "LTDs":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__("9SWq");
	var ReactElement = __webpack_require__("W2D2");
	
	var emptyFunction = __webpack_require__("VMDK");
	var traverseAllChildren = __webpack_require__("MryT");
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },

/***/ "5LTE":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("ar93");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	
	var invariant = __webpack_require__("n3uw");
	var warning = __webpack_require__("37gl");
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },

/***/ "kvXm":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },

/***/ "vUzd":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__("W2D2");
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },

/***/ "W2D2":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("tXBS");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	
	var warning = __webpack_require__("37gl");
	var canDefineProperty = __webpack_require__("RFlT");
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__("KKHy");
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },

/***/ "KKHy":
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },

/***/ "CO2B":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__("37gl");
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },

/***/ "S+kE":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__("W2D2"),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__("hQeK");
	
	module.exports = factory(isValidElement);

/***/ },

/***/ "GjCS":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },

/***/ "RFlT":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },

/***/ "JYGa":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__("O6dE"),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__("W2D2"),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__("CO2B");
	var factory = __webpack_require__("kRwY");
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },

/***/ "8iJM":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },

/***/ "gnAk":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },

/***/ "bVsJ":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },

/***/ "5WN7":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__("ar93");
	
	var ReactElement = __webpack_require__("W2D2");
	
	var invariant = __webpack_require__("n3uw");
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },

/***/ "ar93":
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },

/***/ "MryT":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__("ar93");
	
	var ReactCurrentOwner = __webpack_require__("kvXm");
	var REACT_ELEMENT_TYPE = __webpack_require__("KKHy");
	
	var getIteratorFn = __webpack_require__("8iJM");
	var invariant = __webpack_require__("n3uw");
	var KeyEscapeUtils = __webpack_require__("pV5o");
	var warning = __webpack_require__("37gl");
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },

/***/ "kRwY":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("tXBS");
	
	var emptyObject = __webpack_require__("Ds8Q");
	var _invariant = __webpack_require__("n3uw");
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },

/***/ "VMDK":
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },

/***/ "Ds8Q":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },

/***/ "n3uw":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },

/***/ "37gl":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("VMDK");
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },

/***/ "tXBS":
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ "EstR":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },

/***/ "hQeK":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__("HaW6");
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },

/***/ "HaW6":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__("VMDK");
	var invariant = __webpack_require__("n3uw");
	var warning = __webpack_require__("37gl");
	
	var ReactPropTypesSecret = __webpack_require__("rWnz");
	var checkPropTypes = __webpack_require__("EstR");
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },

/***/ "rWnz":
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },

/***/ "U7vG":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__("G1ow");


/***/ },

/***/ "P+fo":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		try {
			if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else if (typeof execScript !== "undefined") {
				execScript(src);
			} else {
				console.error("[Script Loader] EvalError: No eval function available");
			}
		} catch (error) {
			console.error("[Script Loader] ", error.message);
		}
	}


/***/ },

/***/ "3IRH":
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }

});


// WEBPACK FOOTER //
// vendor.2082954e.js